(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7meeL", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $55b5a1b0c0eb630f$export$6503ec6e8aabbaf; }, function (v) { return $55b5a1b0c0eb630f$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $55b5a1b0c0eb630f$export$f7ad0328861e2f03; }, function (v) { return $55b5a1b0c0eb630f$export$f7ad0328861e2f03 = v; });
var $55b5a1b0c0eb630f$export$6503ec6e8aabbaf;
var $55b5a1b0c0eb630f$export$f7ad0328861e2f03;
"use strict";
var $55b5a1b0c0eb630f$var$mapping = new Map();
function $55b5a1b0c0eb630f$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$55b5a1b0c0eb630f$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $55b5a1b0c0eb630f$var$resolve(id) {
    var resolved = $55b5a1b0c0eb630f$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$55b5a1b0c0eb630f$export$6503ec6e8aabbaf = $55b5a1b0c0eb630f$var$register;
$55b5a1b0c0eb630f$export$f7ad0328861e2f03 = $55b5a1b0c0eb630f$var$resolve;

});

parcelRegister("c6lZy", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $8cf71ab048827416$export$bdfd709ae4826697; }, function (v) { return $8cf71ab048827416$export$bdfd709ae4826697 = v; });
var $8cf71ab048827416$export$bdfd709ae4826697;
var $8cf71ab048827416$export$c9e73fbda7da57b6;
var $8cf71ab048827416$export$5a759dc7a1cfb72a;
"use strict";
var $8cf71ab048827416$var$bundleURL = {};
function $8cf71ab048827416$var$getBundleURLCached(id) {
    var value = $8cf71ab048827416$var$bundleURL[id];
    if (!value) {
        value = $8cf71ab048827416$var$getBundleURL();
        $8cf71ab048827416$var$bundleURL[id] = value;
    }
    return value;
}
function $8cf71ab048827416$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $8cf71ab048827416$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $8cf71ab048827416$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $8cf71ab048827416$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$8cf71ab048827416$export$bdfd709ae4826697 = $8cf71ab048827416$var$getBundleURLCached;
$8cf71ab048827416$export$c9e73fbda7da57b6 = $8cf71ab048827416$var$getBaseURL;
$8cf71ab048827416$export$5a759dc7a1cfb72a = $8cf71ab048827416$var$getOrigin;

});

parcelRegister("Xfpqh", function(module, exports) {

var $qb7pP = parcelRequire("qb7pP");

var $ffICS = parcelRequire("ffICS");

var $dSRbH = parcelRequire("dSRbH");
var $0b2176b8027683cc$require$Buffer = $dSRbH.Buffer;

var $iczbQ = parcelRequire("iczbQ");

var $82idC = parcelRequire("82idC");

var $8bvFt = parcelRequire("8bvFt");

var $koGNw = parcelRequire("koGNw");

var $10PIf = parcelRequire("10PIf");
var $0b2176b8027683cc$var$version = $10PIf.version;
var $0b2176b8027683cc$var$LINE = /(?:^|^)\s*(?:export\s+)?([\w.-]+)(?:\s*=\s*?|:\s+?)(\s*'(?:\\'|[^'])*'|\s*"(?:\\"|[^"])*"|\s*`(?:\\`|[^`])*`|[^#\r\n]+)?\s*(?:#.*)?(?:$|$)/mg;
// Parse src into an Object
function $0b2176b8027683cc$var$parse(src) {
    var obj = {};
    // Convert buffer to string
    var lines = src.toString();
    // Convert line breaks to same format
    lines = lines.replace(/\r\n?/mg, '\n');
    var match;
    while((match = $0b2176b8027683cc$var$LINE.exec(lines)) != null){
        var key = match[1];
        // Default undefined or null to empty string
        var value = match[2] || '';
        // Remove whitespace
        value = value.trim();
        // Check if double quoted
        var maybeQuote = value[0];
        // Remove surrounding quotes
        value = value.replace(/^(['"`])([\s\S]*)\1$/mg, '$2');
        // Expand newlines if double quoted
        if (maybeQuote === '"') {
            value = value.replace(/\\n/g, '\n');
            value = value.replace(/\\r/g, '\r');
        }
        // Add to object
        obj[key] = value;
    }
    return obj;
}
function $0b2176b8027683cc$var$_parseVault(options) {
    var vaultPath = $0b2176b8027683cc$var$_vaultPath(options);
    // Parse .env.vault
    var result = $0b2176b8027683cc$var$DotenvModule.configDotenv({
        path: vaultPath
    });
    if (!result.parsed) {
        var err = new Error("MISSING_DATA: Cannot parse ".concat(vaultPath, " for an unknown reason"));
        err.code = 'MISSING_DATA';
        throw err;
    }
    // handle scenario for comma separated keys - for use with key rotation
    // example: DOTENV_KEY="dotenv://:key_1234@dotenvx.com/vault/.env.vault?environment=prod,dotenv://:key_7890@dotenvx.com/vault/.env.vault?environment=prod"
    var keys = $0b2176b8027683cc$var$_dotenvKey(options).split(',');
    var length = keys.length;
    var decrypted;
    for(var i = 0; i < length; i++)try {
        // Get full key
        var key = keys[i].trim();
        // Get instructions for decrypt
        var attrs = $0b2176b8027683cc$var$_instructions(result, key);
        // Decrypt
        decrypted = $0b2176b8027683cc$var$DotenvModule.decrypt(attrs.ciphertext, attrs.key);
        break;
    } catch (error) {
        // last key
        if (i + 1 >= length) throw error;
    // try next key
    }
    // Parse decrypted .env string
    return $0b2176b8027683cc$var$DotenvModule.parse(decrypted);
}
function $0b2176b8027683cc$var$_log(message) {
    console.log("[dotenv@".concat($0b2176b8027683cc$var$version, "][INFO] ").concat(message));
}
function $0b2176b8027683cc$var$_warn(message) {
    console.log("[dotenv@".concat($0b2176b8027683cc$var$version, "][WARN] ").concat(message));
}
function $0b2176b8027683cc$var$_debug(message) {
    console.log("[dotenv@".concat($0b2176b8027683cc$var$version, "][DEBUG] ").concat(message));
}
function $0b2176b8027683cc$var$_dotenvKey(options) {
    // prioritize developer directly setting options.DOTENV_KEY
    if (options && options.DOTENV_KEY && options.DOTENV_KEY.length > 0) return options.DOTENV_KEY;
    // fallback to empty string
    return '';
}
function $0b2176b8027683cc$var$_instructions(result, dotenvKey) {
    // Parse DOTENV_KEY. Format is a URI
    var uri;
    try {
        uri = new URL(dotenvKey);
    } catch (error) {
        if (error.code === 'ERR_INVALID_URL') {
            var err = new Error('INVALID_DOTENV_KEY: Wrong format. Must be in valid uri format like dotenv://:key_1234@dotenvx.com/vault/.env.vault?environment=development');
            err.code = 'INVALID_DOTENV_KEY';
            throw err;
        }
        throw error;
    }
    // Get decrypt key
    var key = uri.password;
    if (!key) {
        var err1 = new Error('INVALID_DOTENV_KEY: Missing key part');
        err1.code = 'INVALID_DOTENV_KEY';
        throw err1;
    }
    // Get environment
    var environment = uri.searchParams.get('environment');
    if (!environment) {
        var err2 = new Error('INVALID_DOTENV_KEY: Missing environment part');
        err2.code = 'INVALID_DOTENV_KEY';
        throw err2;
    }
    // Get ciphertext payload
    var environmentKey = "DOTENV_VAULT_".concat(environment.toUpperCase());
    var ciphertext = result.parsed[environmentKey] // DOTENV_VAULT_PRODUCTION
    ;
    if (!ciphertext) {
        var err3 = new Error("NOT_FOUND_DOTENV_ENVIRONMENT: Cannot locate environment ".concat(environmentKey, " in your .env.vault file."));
        err3.code = 'NOT_FOUND_DOTENV_ENVIRONMENT';
        throw err3;
    }
    return {
        ciphertext: ciphertext,
        key: key
    };
}
function $0b2176b8027683cc$var$_vaultPath(options) {
    var possibleVaultPath = null;
    if (options && options.path && options.path.length > 0) {
        if (Array.isArray(options.path)) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = options.path[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var filepath = _step.value;
                    if ($iczbQ.existsSync(filepath)) possibleVaultPath = filepath.endsWith('.vault') ? filepath : "".concat(filepath, ".vault");
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        } else possibleVaultPath = options.path.endsWith('.vault') ? options.path : "".concat(options.path, ".vault");
    } else possibleVaultPath = $82idC.resolve($ffICS.cwd(), '.env.vault');
    if ($iczbQ.existsSync(possibleVaultPath)) return possibleVaultPath;
    return null;
}
function $0b2176b8027683cc$var$_resolveHome(envPath) {
    return envPath[0] === '~' ? $82idC.join($8bvFt.homedir(), envPath.slice(1)) : envPath;
}
function $0b2176b8027683cc$var$_configVault(options) {
    $0b2176b8027683cc$var$_log('Loading env from encrypted .env.vault');
    var parsed = $0b2176b8027683cc$var$DotenvModule._parseVault(options);
    var processEnv = {};
    if (options && options.processEnv != null) processEnv = options.processEnv;
    $0b2176b8027683cc$var$DotenvModule.populate(processEnv, parsed, options);
    return {
        parsed: parsed
    };
}
function $0b2176b8027683cc$var$configDotenv(options) {
    var dotenvPath = $82idC.resolve($ffICS.cwd(), '.env');
    var encoding = 'utf8';
    var debug = Boolean(options && options.debug);
    if (options && options.encoding) encoding = options.encoding;
    else if (debug) $0b2176b8027683cc$var$_debug('No encoding is specified. UTF-8 is used by default');
    var optionPaths = [
        dotenvPath
    ] // default, look for .env
    ;
    if (options && options.path) {
        if (!Array.isArray(options.path)) optionPaths = [
            $0b2176b8027683cc$var$_resolveHome(options.path)
        ];
        else {
            optionPaths = [] // reset default
            ;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = options.path[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var filepath = _step.value;
                    optionPaths.push($0b2176b8027683cc$var$_resolveHome(filepath));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
    // Build the parsed data in a temporary object (because we need to return it).  Once we have the final
    // parsed data, we will combine it with process.env (or options.processEnv if provided).
    var lastError;
    var parsedAll = {};
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = optionPaths[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var path1 = _step1.value;
            try {
                // Specifying an encoding returns a string instead of a buffer
                var parsed = $0b2176b8027683cc$var$DotenvModule.parse($iczbQ.readFileSync(path1, {
                    encoding: encoding
                }));
                $0b2176b8027683cc$var$DotenvModule.populate(parsedAll, parsed, options);
            } catch (e) {
                if (debug) $0b2176b8027683cc$var$_debug("Failed to load ".concat(path1, " ").concat(e.message));
                lastError = e;
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                _iterator1["return"]();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    var processEnv = {};
    if (options && options.processEnv != null) processEnv = options.processEnv;
    $0b2176b8027683cc$var$DotenvModule.populate(processEnv, parsedAll, options);
    if (lastError) return {
        parsed: parsedAll,
        error: lastError
    };
    else return {
        parsed: parsedAll
    };
}
// Populates process.env from .env file
function $0b2176b8027683cc$var$config(options) {
    // fallback to original dotenv if DOTENV_KEY is not set
    if ($0b2176b8027683cc$var$_dotenvKey(options).length === 0) return $0b2176b8027683cc$var$DotenvModule.configDotenv(options);
    var vaultPath = $0b2176b8027683cc$var$_vaultPath(options);
    // dotenvKey exists but .env.vault file does not exist
    if (!vaultPath) {
        $0b2176b8027683cc$var$_warn("You set DOTENV_KEY but you are missing a .env.vault file at ".concat(vaultPath, ". Did you forget to build it?"));
        return $0b2176b8027683cc$var$DotenvModule.configDotenv(options);
    }
    return $0b2176b8027683cc$var$DotenvModule._configVault(options);
}
function $0b2176b8027683cc$var$decrypt(encrypted, keyStr) {
    var key = $0b2176b8027683cc$require$Buffer.from(keyStr.slice(-64), 'hex');
    var ciphertext = $0b2176b8027683cc$require$Buffer.from(encrypted, 'base64');
    var nonce = ciphertext.subarray(0, 12);
    var authTag = ciphertext.subarray(-16);
    ciphertext = ciphertext.subarray(12, -16);
    try {
        var aesgcm = $koGNw.createDecipheriv('aes-256-gcm', key, nonce);
        aesgcm.setAuthTag(authTag);
        return "".concat(aesgcm.update(ciphertext)).concat(aesgcm["final"]());
    } catch (error) {
        var isRange = error instanceof RangeError;
        var invalidKeyLength = error.message === 'Invalid key length';
        var decryptionFailed = error.message === 'Unsupported state or unable to authenticate data';
        if (isRange || invalidKeyLength) {
            var err = new Error('INVALID_DOTENV_KEY: It must be 64 characters long (or more)');
            err.code = 'INVALID_DOTENV_KEY';
            throw err;
        } else if (decryptionFailed) {
            var err1 = new Error('DECRYPTION_FAILED: Please check your DOTENV_KEY');
            err1.code = 'DECRYPTION_FAILED';
            throw err1;
        } else throw error;
    }
}
// Populate process.env with parsed values
function $0b2176b8027683cc$var$populate(processEnv, parsed) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var debug = Boolean(options && options.debug);
    var override = Boolean(options && options.override);
    if ((typeof parsed === "undefined" ? "undefined" : (0, $qb7pP._)(parsed)) !== 'object') {
        var _$err = new Error('OBJECT_REQUIRED: Please check the processEnv argument being passed to populate');
        _$err.code = 'OBJECT_REQUIRED';
        throw _$err;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Set process.env
        for(var _iterator = Object.keys(parsed)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (Object.prototype.hasOwnProperty.call(processEnv, key)) {
                if (override === true) processEnv[key] = parsed[key];
                if (debug) {
                    if (override === true) $0b2176b8027683cc$var$_debug('"'.concat(key, '" is already defined and WAS overwritten'));
                    else $0b2176b8027683cc$var$_debug('"'.concat(key, '" is already defined and was NOT overwritten'));
                }
            } else processEnv[key] = parsed[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
var $0b2176b8027683cc$var$DotenvModule = {
    configDotenv: $0b2176b8027683cc$var$configDotenv,
    _configVault: $0b2176b8027683cc$var$_configVault,
    _parseVault: $0b2176b8027683cc$var$_parseVault,
    config: $0b2176b8027683cc$var$config,
    decrypt: $0b2176b8027683cc$var$decrypt,
    parse: $0b2176b8027683cc$var$parse,
    populate: $0b2176b8027683cc$var$populate
};
module.exports.configDotenv = $0b2176b8027683cc$var$DotenvModule.configDotenv;
module.exports._configVault = $0b2176b8027683cc$var$DotenvModule._configVault;
module.exports._parseVault = $0b2176b8027683cc$var$DotenvModule._parseVault;
module.exports.config = $0b2176b8027683cc$var$DotenvModule.config;
module.exports.decrypt = $0b2176b8027683cc$var$DotenvModule.decrypt;
module.exports.parse = $0b2176b8027683cc$var$DotenvModule.parse;
module.exports.populate = $0b2176b8027683cc$var$DotenvModule.populate;
module.exports = $0b2176b8027683cc$var$DotenvModule;

});
parcelRegister("qb7pP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $04eb0dbf26262756$export$71511d61b312f219; });
function $04eb0dbf26262756$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

parcelRegister("ffICS", function(module, exports) {
// shim for using process in browser
var $b1aadf8304182be4$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $b1aadf8304182be4$var$cachedSetTimeout;
var $b1aadf8304182be4$var$cachedClearTimeout;
function $b1aadf8304182be4$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $b1aadf8304182be4$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $b1aadf8304182be4$var$cachedSetTimeout = setTimeout;
        else $b1aadf8304182be4$var$cachedSetTimeout = $b1aadf8304182be4$var$defaultSetTimout;
    } catch (e) {
        $b1aadf8304182be4$var$cachedSetTimeout = $b1aadf8304182be4$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $b1aadf8304182be4$var$cachedClearTimeout = clearTimeout;
        else $b1aadf8304182be4$var$cachedClearTimeout = $b1aadf8304182be4$var$defaultClearTimeout;
    } catch (e) {
        $b1aadf8304182be4$var$cachedClearTimeout = $b1aadf8304182be4$var$defaultClearTimeout;
    }
})();
function $b1aadf8304182be4$var$runTimeout(fun) {
    if ($b1aadf8304182be4$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($b1aadf8304182be4$var$cachedSetTimeout === $b1aadf8304182be4$var$defaultSetTimout || !$b1aadf8304182be4$var$cachedSetTimeout) && setTimeout) {
        $b1aadf8304182be4$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $b1aadf8304182be4$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $b1aadf8304182be4$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $b1aadf8304182be4$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $b1aadf8304182be4$var$runClearTimeout(marker) {
    if ($b1aadf8304182be4$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($b1aadf8304182be4$var$cachedClearTimeout === $b1aadf8304182be4$var$defaultClearTimeout || !$b1aadf8304182be4$var$cachedClearTimeout) && clearTimeout) {
        $b1aadf8304182be4$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $b1aadf8304182be4$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $b1aadf8304182be4$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $b1aadf8304182be4$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $b1aadf8304182be4$var$queue = [];
var $b1aadf8304182be4$var$draining = false;
var $b1aadf8304182be4$var$currentQueue;
var $b1aadf8304182be4$var$queueIndex = -1;
function $b1aadf8304182be4$var$cleanUpNextTick() {
    if (!$b1aadf8304182be4$var$draining || !$b1aadf8304182be4$var$currentQueue) return;
    $b1aadf8304182be4$var$draining = false;
    if ($b1aadf8304182be4$var$currentQueue.length) $b1aadf8304182be4$var$queue = $b1aadf8304182be4$var$currentQueue.concat($b1aadf8304182be4$var$queue);
    else $b1aadf8304182be4$var$queueIndex = -1;
    if ($b1aadf8304182be4$var$queue.length) $b1aadf8304182be4$var$drainQueue();
}
function $b1aadf8304182be4$var$drainQueue() {
    if ($b1aadf8304182be4$var$draining) return;
    var timeout = $b1aadf8304182be4$var$runTimeout($b1aadf8304182be4$var$cleanUpNextTick);
    $b1aadf8304182be4$var$draining = true;
    var len = $b1aadf8304182be4$var$queue.length;
    while(len){
        $b1aadf8304182be4$var$currentQueue = $b1aadf8304182be4$var$queue;
        $b1aadf8304182be4$var$queue = [];
        while(++$b1aadf8304182be4$var$queueIndex < len)if ($b1aadf8304182be4$var$currentQueue) $b1aadf8304182be4$var$currentQueue[$b1aadf8304182be4$var$queueIndex].run();
        $b1aadf8304182be4$var$queueIndex = -1;
        len = $b1aadf8304182be4$var$queue.length;
    }
    $b1aadf8304182be4$var$currentQueue = null;
    $b1aadf8304182be4$var$draining = false;
    $b1aadf8304182be4$var$runClearTimeout(timeout);
}
$b1aadf8304182be4$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $b1aadf8304182be4$var$queue.push(new $b1aadf8304182be4$var$Item(fun, args));
    if ($b1aadf8304182be4$var$queue.length === 1 && !$b1aadf8304182be4$var$draining) $b1aadf8304182be4$var$runTimeout($b1aadf8304182be4$var$drainQueue);
};
// v8 likes predictible objects
function $b1aadf8304182be4$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$b1aadf8304182be4$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$b1aadf8304182be4$var$process.title = 'browser';
$b1aadf8304182be4$var$process.browser = true;
$b1aadf8304182be4$var$process.env = {};
$b1aadf8304182be4$var$process.argv = [];
$b1aadf8304182be4$var$process.version = ''; // empty string to avoid regexp issues
$b1aadf8304182be4$var$process.versions = {};
function $b1aadf8304182be4$var$noop() {}
$b1aadf8304182be4$var$process.on = $b1aadf8304182be4$var$noop;
$b1aadf8304182be4$var$process.addListener = $b1aadf8304182be4$var$noop;
$b1aadf8304182be4$var$process.once = $b1aadf8304182be4$var$noop;
$b1aadf8304182be4$var$process.off = $b1aadf8304182be4$var$noop;
$b1aadf8304182be4$var$process.removeListener = $b1aadf8304182be4$var$noop;
$b1aadf8304182be4$var$process.removeAllListeners = $b1aadf8304182be4$var$noop;
$b1aadf8304182be4$var$process.emit = $b1aadf8304182be4$var$noop;
$b1aadf8304182be4$var$process.prependListener = $b1aadf8304182be4$var$noop;
$b1aadf8304182be4$var$process.prependOnceListener = $b1aadf8304182be4$var$noop;
$b1aadf8304182be4$var$process.listeners = function(name) {
    return [];
};
$b1aadf8304182be4$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$b1aadf8304182be4$var$process.cwd = function() {
    return '/';
};
$b1aadf8304182be4$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$b1aadf8304182be4$var$process.umask = function() {
    return 0;
};

});

parcelRegister("dSRbH", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $a1b9937f1d1ceb9c$export$a143d493d941bafc; }, function (v) { return $a1b9937f1d1ceb9c$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $a1b9937f1d1ceb9c$export$e4cf37d7f6fb9e0a; }, function (v) { return $a1b9937f1d1ceb9c$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $a1b9937f1d1ceb9c$export$f99ded8fe4b79145; }, function (v) { return $a1b9937f1d1ceb9c$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $a1b9937f1d1ceb9c$export$599f31c3813fae4d; }, function (v) { return $a1b9937f1d1ceb9c$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $huFCX = parcelRequire("huFCX");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $1atwj = parcelRequire("1atwj");

var $qb7pP = parcelRequire("qb7pP");
var $a1b9937f1d1ceb9c$export$a143d493d941bafc;
var $a1b9937f1d1ceb9c$export$e4cf37d7f6fb9e0a;
var $a1b9937f1d1ceb9c$export$f99ded8fe4b79145;
var $a1b9937f1d1ceb9c$export$599f31c3813fae4d;
'use strict';

var $4zPGf = parcelRequire("4zPGf");

var $8JATf = parcelRequire("8JATf");
var $a1b9937f1d1ceb9c$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$a1b9937f1d1ceb9c$export$a143d493d941bafc = $a1b9937f1d1ceb9c$var$Buffer;
$a1b9937f1d1ceb9c$export$e4cf37d7f6fb9e0a = $a1b9937f1d1ceb9c$var$SlowBuffer;
$a1b9937f1d1ceb9c$export$f99ded8fe4b79145 = 50;
var $a1b9937f1d1ceb9c$var$K_MAX_LENGTH = 0x7fffffff;
$a1b9937f1d1ceb9c$export$599f31c3813fae4d = $a1b9937f1d1ceb9c$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $a1b9937f1d1ceb9c$var$Buffer.TYPED_ARRAY_SUPPORT = $a1b9937f1d1ceb9c$var$typedArraySupport();
if (!$a1b9937f1d1ceb9c$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $a1b9937f1d1ceb9c$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($a1b9937f1d1ceb9c$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$a1b9937f1d1ceb9c$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($a1b9937f1d1ceb9c$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$a1b9937f1d1ceb9c$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $a1b9937f1d1ceb9c$var$createBuffer(length) {
    if (length > $a1b9937f1d1ceb9c$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $a1b9937f1d1ceb9c$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $a1b9937f1d1ceb9c$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $a1b9937f1d1ceb9c$var$allocUnsafe(arg);
    }
    return $a1b9937f1d1ceb9c$var$from(arg, encodingOrOffset, length);
}
$a1b9937f1d1ceb9c$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $a1b9937f1d1ceb9c$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $a1b9937f1d1ceb9c$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $a1b9937f1d1ceb9c$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $qb7pP._)(value)));
    if ($a1b9937f1d1ceb9c$var$isInstance(value, ArrayBuffer) || value && $a1b9937f1d1ceb9c$var$isInstance(value.buffer, ArrayBuffer)) return $a1b9937f1d1ceb9c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($a1b9937f1d1ceb9c$var$isInstance(value, SharedArrayBuffer) || value && $a1b9937f1d1ceb9c$var$isInstance(value.buffer, SharedArrayBuffer))) return $a1b9937f1d1ceb9c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $a1b9937f1d1ceb9c$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $a1b9937f1d1ceb9c$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $a1b9937f1d1ceb9c$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $qb7pP._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $a1b9937f1d1ceb9c$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $a1b9937f1d1ceb9c$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($a1b9937f1d1ceb9c$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($a1b9937f1d1ceb9c$var$Buffer, Uint8Array);
function $a1b9937f1d1ceb9c$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $a1b9937f1d1ceb9c$var$alloc(size, fill, encoding) {
    $a1b9937f1d1ceb9c$var$assertSize(size);
    if (size <= 0) return $a1b9937f1d1ceb9c$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $a1b9937f1d1ceb9c$var$createBuffer(size).fill(fill, encoding) : $a1b9937f1d1ceb9c$var$createBuffer(size).fill(fill);
    return $a1b9937f1d1ceb9c$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $a1b9937f1d1ceb9c$var$Buffer.alloc = function(size, fill, encoding) {
    return $a1b9937f1d1ceb9c$var$alloc(size, fill, encoding);
};
function $a1b9937f1d1ceb9c$var$allocUnsafe(size) {
    $a1b9937f1d1ceb9c$var$assertSize(size);
    return $a1b9937f1d1ceb9c$var$createBuffer(size < 0 ? 0 : $a1b9937f1d1ceb9c$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $a1b9937f1d1ceb9c$var$Buffer.allocUnsafe = function(size) {
    return $a1b9937f1d1ceb9c$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $a1b9937f1d1ceb9c$var$Buffer.allocUnsafeSlow = function(size) {
    return $a1b9937f1d1ceb9c$var$allocUnsafe(size);
};
function $a1b9937f1d1ceb9c$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$a1b9937f1d1ceb9c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $a1b9937f1d1ceb9c$var$byteLength(string, encoding) | 0;
    var buf = $a1b9937f1d1ceb9c$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $a1b9937f1d1ceb9c$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $a1b9937f1d1ceb9c$var$checked(array.length) | 0;
    var buf = $a1b9937f1d1ceb9c$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $a1b9937f1d1ceb9c$var$fromArrayView(arrayView) {
    if ($a1b9937f1d1ceb9c$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $a1b9937f1d1ceb9c$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $a1b9937f1d1ceb9c$var$fromArrayLike(arrayView);
}
function $a1b9937f1d1ceb9c$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $a1b9937f1d1ceb9c$var$Buffer.prototype);
    return buf;
}
function $a1b9937f1d1ceb9c$var$fromObject(obj) {
    if ($a1b9937f1d1ceb9c$var$Buffer.isBuffer(obj)) {
        var len = $a1b9937f1d1ceb9c$var$checked(obj.length) | 0;
        var buf = $a1b9937f1d1ceb9c$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $a1b9937f1d1ceb9c$var$numberIsNaN(obj.length)) return $a1b9937f1d1ceb9c$var$createBuffer(0);
        return $a1b9937f1d1ceb9c$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $a1b9937f1d1ceb9c$var$fromArrayLike(obj.data);
}
function $a1b9937f1d1ceb9c$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $a1b9937f1d1ceb9c$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $a1b9937f1d1ceb9c$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $a1b9937f1d1ceb9c$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $a1b9937f1d1ceb9c$var$Buffer.alloc(+length);
}
$a1b9937f1d1ceb9c$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $a1b9937f1d1ceb9c$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$a1b9937f1d1ceb9c$var$Buffer.compare = function compare(a, b) {
    if ($a1b9937f1d1ceb9c$var$isInstance(a, Uint8Array)) a = $a1b9937f1d1ceb9c$var$Buffer.from(a, a.offset, a.byteLength);
    if ($a1b9937f1d1ceb9c$var$isInstance(b, Uint8Array)) b = $a1b9937f1d1ceb9c$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$a1b9937f1d1ceb9c$var$Buffer.isBuffer(a) || !$a1b9937f1d1ceb9c$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$a1b9937f1d1ceb9c$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$a1b9937f1d1ceb9c$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $a1b9937f1d1ceb9c$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $a1b9937f1d1ceb9c$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($a1b9937f1d1ceb9c$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$a1b9937f1d1ceb9c$var$Buffer.isBuffer(buf)) buf = $a1b9937f1d1ceb9c$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$a1b9937f1d1ceb9c$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $a1b9937f1d1ceb9c$var$byteLength(string, encoding) {
    if ($a1b9937f1d1ceb9c$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $a1b9937f1d1ceb9c$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $qb7pP._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $a1b9937f1d1ceb9c$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $a1b9937f1d1ceb9c$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $a1b9937f1d1ceb9c$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$a1b9937f1d1ceb9c$var$Buffer.byteLength = $a1b9937f1d1ceb9c$var$byteLength;
function $a1b9937f1d1ceb9c$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $a1b9937f1d1ceb9c$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $a1b9937f1d1ceb9c$var$utf8Slice(this, start, end);
        case 'ascii':
            return $a1b9937f1d1ceb9c$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $a1b9937f1d1ceb9c$var$latin1Slice(this, start, end);
        case 'base64':
            return $a1b9937f1d1ceb9c$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $a1b9937f1d1ceb9c$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$a1b9937f1d1ceb9c$var$Buffer.prototype._isBuffer = true;
function $a1b9937f1d1ceb9c$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$a1b9937f1d1ceb9c$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$a1b9937f1d1ceb9c$var$swap(this, i, i + 1);
    return this;
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $a1b9937f1d1ceb9c$var$swap(this, i, i + 3);
        $a1b9937f1d1ceb9c$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $a1b9937f1d1ceb9c$var$swap(this, i, i + 7);
        $a1b9937f1d1ceb9c$var$swap(this, i + 1, i + 6);
        $a1b9937f1d1ceb9c$var$swap(this, i + 2, i + 5);
        $a1b9937f1d1ceb9c$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $a1b9937f1d1ceb9c$var$utf8Slice(this, 0, length);
    return $a1b9937f1d1ceb9c$var$slowToString.apply(this, arguments);
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.toLocaleString = $a1b9937f1d1ceb9c$var$Buffer.prototype.toString;
$a1b9937f1d1ceb9c$var$Buffer.prototype.equals = function equals(b) {
    if (!$a1b9937f1d1ceb9c$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $a1b9937f1d1ceb9c$var$Buffer.compare(this, b) === 0;
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $a1b9937f1d1ceb9c$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($a1b9937f1d1ceb9c$var$customInspectSymbol) $a1b9937f1d1ceb9c$var$Buffer.prototype[$a1b9937f1d1ceb9c$var$customInspectSymbol] = $a1b9937f1d1ceb9c$var$Buffer.prototype.inspect;
$a1b9937f1d1ceb9c$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($a1b9937f1d1ceb9c$var$isInstance(target, Uint8Array)) target = $a1b9937f1d1ceb9c$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$a1b9937f1d1ceb9c$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $qb7pP._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $a1b9937f1d1ceb9c$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($a1b9937f1d1ceb9c$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $a1b9937f1d1ceb9c$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($a1b9937f1d1ceb9c$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $a1b9937f1d1ceb9c$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $a1b9937f1d1ceb9c$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $a1b9937f1d1ceb9c$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$a1b9937f1d1ceb9c$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $a1b9937f1d1ceb9c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $a1b9937f1d1ceb9c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $a1b9937f1d1ceb9c$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($a1b9937f1d1ceb9c$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $a1b9937f1d1ceb9c$var$utf8Write(buf, string, offset, length) {
    return $a1b9937f1d1ceb9c$var$blitBuffer($a1b9937f1d1ceb9c$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $a1b9937f1d1ceb9c$var$asciiWrite(buf, string, offset, length) {
    return $a1b9937f1d1ceb9c$var$blitBuffer($a1b9937f1d1ceb9c$var$asciiToBytes(string), buf, offset, length);
}
function $a1b9937f1d1ceb9c$var$base64Write(buf, string, offset, length) {
    return $a1b9937f1d1ceb9c$var$blitBuffer($a1b9937f1d1ceb9c$var$base64ToBytes(string), buf, offset, length);
}
function $a1b9937f1d1ceb9c$var$ucs2Write(buf, string, offset, length) {
    return $a1b9937f1d1ceb9c$var$blitBuffer($a1b9937f1d1ceb9c$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$a1b9937f1d1ceb9c$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $a1b9937f1d1ceb9c$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $a1b9937f1d1ceb9c$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $a1b9937f1d1ceb9c$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $a1b9937f1d1ceb9c$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $a1b9937f1d1ceb9c$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $a1b9937f1d1ceb9c$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $4zPGf.fromByteArray(buf);
    else return $4zPGf.fromByteArray(buf.slice(start, end));
}
function $a1b9937f1d1ceb9c$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $a1b9937f1d1ceb9c$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $a1b9937f1d1ceb9c$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $a1b9937f1d1ceb9c$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $a1b9937f1d1ceb9c$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $a1b9937f1d1ceb9c$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $a1b9937f1d1ceb9c$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $a1b9937f1d1ceb9c$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $a1b9937f1d1ceb9c$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $a1b9937f1d1ceb9c$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $a1b9937f1d1ceb9c$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$a1b9937f1d1ceb9c$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $a1b9937f1d1ceb9c$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $a1b9937f1d1ceb9c$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$a1b9937f1d1ceb9c$var$Buffer.prototype.readUintLE = $a1b9937f1d1ceb9c$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.readUintBE = $a1b9937f1d1ceb9c$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.readUint8 = $a1b9937f1d1ceb9c$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.readUint16LE = $a1b9937f1d1ceb9c$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.readUint16BE = $a1b9937f1d1ceb9c$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.readUint32LE = $a1b9937f1d1ceb9c$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.readUint32BE = $a1b9937f1d1ceb9c$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.readBigUInt64LE = $a1b9937f1d1ceb9c$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $a1b9937f1d1ceb9c$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $a1b9937f1d1ceb9c$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$a1b9937f1d1ceb9c$var$Buffer.prototype.readBigUInt64BE = $a1b9937f1d1ceb9c$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $a1b9937f1d1ceb9c$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $a1b9937f1d1ceb9c$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$a1b9937f1d1ceb9c$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.readBigInt64LE = $a1b9937f1d1ceb9c$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $a1b9937f1d1ceb9c$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $a1b9937f1d1ceb9c$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$a1b9937f1d1ceb9c$var$Buffer.prototype.readBigInt64BE = $a1b9937f1d1ceb9c$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $a1b9937f1d1ceb9c$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $a1b9937f1d1ceb9c$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$a1b9937f1d1ceb9c$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkOffset(offset, 4, this.length);
    return $8JATf.read(this, offset, true, 23, 4);
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkOffset(offset, 4, this.length);
    return $8JATf.read(this, offset, false, 23, 4);
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkOffset(offset, 8, this.length);
    return $8JATf.read(this, offset, true, 52, 8);
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkOffset(offset, 8, this.length);
    return $8JATf.read(this, offset, false, 52, 8);
};
function $a1b9937f1d1ceb9c$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$a1b9937f1d1ceb9c$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$a1b9937f1d1ceb9c$var$Buffer.prototype.writeUintLE = $a1b9937f1d1ceb9c$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $a1b9937f1d1ceb9c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.writeUintBE = $a1b9937f1d1ceb9c$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $a1b9937f1d1ceb9c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.writeUint8 = $a1b9937f1d1ceb9c$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.writeUint16LE = $a1b9937f1d1ceb9c$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.writeUint16BE = $a1b9937f1d1ceb9c$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.writeUint32LE = $a1b9937f1d1ceb9c$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.writeUint32BE = $a1b9937f1d1ceb9c$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $a1b9937f1d1ceb9c$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $a1b9937f1d1ceb9c$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $a1b9937f1d1ceb9c$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $a1b9937f1d1ceb9c$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$a1b9937f1d1ceb9c$var$Buffer.prototype.writeBigUInt64LE = $a1b9937f1d1ceb9c$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $a1b9937f1d1ceb9c$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$a1b9937f1d1ceb9c$var$Buffer.prototype.writeBigUInt64BE = $a1b9937f1d1ceb9c$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $a1b9937f1d1ceb9c$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$a1b9937f1d1ceb9c$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $a1b9937f1d1ceb9c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $a1b9937f1d1ceb9c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.writeBigInt64LE = $a1b9937f1d1ceb9c$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $a1b9937f1d1ceb9c$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$a1b9937f1d1ceb9c$var$Buffer.prototype.writeBigInt64BE = $a1b9937f1d1ceb9c$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $a1b9937f1d1ceb9c$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $a1b9937f1d1ceb9c$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $a1b9937f1d1ceb9c$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8JATf.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$a1b9937f1d1ceb9c$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $a1b9937f1d1ceb9c$var$writeFloat(this, value, offset, true, noAssert);
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $a1b9937f1d1ceb9c$var$writeFloat(this, value, offset, false, noAssert);
};
function $a1b9937f1d1ceb9c$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a1b9937f1d1ceb9c$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8JATf.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$a1b9937f1d1ceb9c$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $a1b9937f1d1ceb9c$var$writeDouble(this, value, offset, true, noAssert);
};
$a1b9937f1d1ceb9c$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $a1b9937f1d1ceb9c$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$a1b9937f1d1ceb9c$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$a1b9937f1d1ceb9c$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$a1b9937f1d1ceb9c$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$a1b9937f1d1ceb9c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $a1b9937f1d1ceb9c$var$Buffer.isBuffer(val) ? val : $a1b9937f1d1ceb9c$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $a1b9937f1d1ceb9c$var$errors = {};
function $a1b9937f1d1ceb9c$var$E(sym, getMessage, Base) {
    $a1b9937f1d1ceb9c$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $1atwj._)(NodeError, Base);
        function NodeError() {
            (0, $50OuQ._)(this, NodeError);
            var _this;
            _this = (0, $huFCX._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $fGdZr._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$a1b9937f1d1ceb9c$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$a1b9937f1d1ceb9c$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $qb7pP._)(actual));
}, TypeError);
$a1b9937f1d1ceb9c$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $a1b9937f1d1ceb9c$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $qb7pP._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $a1b9937f1d1ceb9c$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $a1b9937f1d1ceb9c$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $a1b9937f1d1ceb9c$var$checkBounds(buf, offset, byteLength) {
    $a1b9937f1d1ceb9c$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $a1b9937f1d1ceb9c$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $a1b9937f1d1ceb9c$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $qb7pP._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $a1b9937f1d1ceb9c$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $a1b9937f1d1ceb9c$var$checkBounds(buf, offset, byteLength);
}
function $a1b9937f1d1ceb9c$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $a1b9937f1d1ceb9c$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $a1b9937f1d1ceb9c$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $a1b9937f1d1ceb9c$var$validateNumber(value, type);
        throw new $a1b9937f1d1ceb9c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $a1b9937f1d1ceb9c$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $a1b9937f1d1ceb9c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $a1b9937f1d1ceb9c$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $a1b9937f1d1ceb9c$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($a1b9937f1d1ceb9c$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $a1b9937f1d1ceb9c$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $a1b9937f1d1ceb9c$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $a1b9937f1d1ceb9c$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $a1b9937f1d1ceb9c$var$base64ToBytes(str) {
    return $4zPGf.toByteArray($a1b9937f1d1ceb9c$var$base64clean(str));
}
function $a1b9937f1d1ceb9c$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $a1b9937f1d1ceb9c$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $a1b9937f1d1ceb9c$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $a1b9937f1d1ceb9c$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $a1b9937f1d1ceb9c$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $a1b9937f1d1ceb9c$var$BufferBigIntNotDefined : fn;
}
function $a1b9937f1d1ceb9c$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("huFCX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cbc5874f1b613ac9$export$71511d61b312f219; });

var $bykok = parcelRequire("bykok");

var $kW87r = parcelRequire("kW87r");

var $9FVhl = parcelRequire("9FVhl");
function $cbc5874f1b613ac9$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $bykok._)(derived);
    return (0, $9FVhl._)(_this, (0, $kW87r._)() ? Reflect.construct(derived, args || [], (0, $bykok._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("bykok", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8692aff7579d247b$export$71511d61b312f219; });
function $8692aff7579d247b$export$71511d61b312f219(o) {
    $8692aff7579d247b$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8692aff7579d247b$export$71511d61b312f219(o);
}

});

parcelRegister("kW87r", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f3df85b7abd0198b$export$71511d61b312f219; });
function $f3df85b7abd0198b$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($f3df85b7abd0198b$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("9FVhl", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $70b45fc14ae715f9$export$71511d61b312f219; });

var $dMjkN = parcelRequire("dMjkN");

var $qb7pP = parcelRequire("qb7pP");
function $70b45fc14ae715f9$export$71511d61b312f219(self, call) {
    if (call && ((0, $qb7pP._)(call) === "object" || typeof call === "function")) return call;
    return (0, $dMjkN._)(self);
}

});
parcelRegister("dMjkN", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a07ec17282910409$export$71511d61b312f219; });
function $a07ec17282910409$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("50OuQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3a641f6367a2e6bd$export$71511d61b312f219; });
function $3a641f6367a2e6bd$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("fGdZr", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b6a5a160ea364895$export$71511d61b312f219; });
function $b6a5a160ea364895$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b6a5a160ea364895$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $b6a5a160ea364895$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b6a5a160ea364895$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("1atwj", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0d9d9fb902e40dd3$export$71511d61b312f219; });

var $4USSx = parcelRequire("4USSx");
function $0d9d9fb902e40dd3$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $4USSx._)(subClass, superClass);
}

});
parcelRegister("4USSx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3946f6227d05c830$export$71511d61b312f219; });
function $3946f6227d05c830$export$71511d61b312f219(o, p) {
    $3946f6227d05c830$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3946f6227d05c830$export$71511d61b312f219(o, p);
}

});


parcelRegister("4zPGf", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $355284faf3ffad06$export$d622b2ad8d90c771; }, function (v) { return $355284faf3ffad06$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $355284faf3ffad06$export$6100ba28696e12de; }, function (v) { return $355284faf3ffad06$export$6100ba28696e12de = v; });
var $355284faf3ffad06$export$a48f0734ac7c2329;
var $355284faf3ffad06$export$d622b2ad8d90c771;
var $355284faf3ffad06$export$6100ba28696e12de;
'use strict';
$355284faf3ffad06$export$a48f0734ac7c2329 = $355284faf3ffad06$var$byteLength;
$355284faf3ffad06$export$d622b2ad8d90c771 = $355284faf3ffad06$var$toByteArray;
$355284faf3ffad06$export$6100ba28696e12de = $355284faf3ffad06$var$fromByteArray;
var $355284faf3ffad06$var$lookup = [];
var $355284faf3ffad06$var$revLookup = [];
var $355284faf3ffad06$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $355284faf3ffad06$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $355284faf3ffad06$var$i = 0, $355284faf3ffad06$var$len = $355284faf3ffad06$var$code.length; $355284faf3ffad06$var$i < $355284faf3ffad06$var$len; ++$355284faf3ffad06$var$i){
    $355284faf3ffad06$var$lookup[$355284faf3ffad06$var$i] = $355284faf3ffad06$var$code[$355284faf3ffad06$var$i];
    $355284faf3ffad06$var$revLookup[$355284faf3ffad06$var$code.charCodeAt($355284faf3ffad06$var$i)] = $355284faf3ffad06$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$355284faf3ffad06$var$revLookup['-'.charCodeAt(0)] = 62;
$355284faf3ffad06$var$revLookup['_'.charCodeAt(0)] = 63;
function $355284faf3ffad06$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $355284faf3ffad06$var$byteLength(b64) {
    var lens = $355284faf3ffad06$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $355284faf3ffad06$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $355284faf3ffad06$var$toByteArray(b64) {
    var tmp;
    var lens = $355284faf3ffad06$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $355284faf3ffad06$var$Arr($355284faf3ffad06$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $355284faf3ffad06$var$revLookup[b64.charCodeAt(i)] << 18 | $355284faf3ffad06$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $355284faf3ffad06$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $355284faf3ffad06$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $355284faf3ffad06$var$revLookup[b64.charCodeAt(i)] << 2 | $355284faf3ffad06$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $355284faf3ffad06$var$revLookup[b64.charCodeAt(i)] << 10 | $355284faf3ffad06$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $355284faf3ffad06$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $355284faf3ffad06$var$tripletToBase64(num) {
    return $355284faf3ffad06$var$lookup[num >> 18 & 0x3F] + $355284faf3ffad06$var$lookup[num >> 12 & 0x3F] + $355284faf3ffad06$var$lookup[num >> 6 & 0x3F] + $355284faf3ffad06$var$lookup[num & 0x3F];
}
function $355284faf3ffad06$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($355284faf3ffad06$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $355284faf3ffad06$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($355284faf3ffad06$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($355284faf3ffad06$var$lookup[tmp >> 2] + $355284faf3ffad06$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($355284faf3ffad06$var$lookup[tmp >> 10] + $355284faf3ffad06$var$lookup[tmp >> 4 & 0x3F] + $355284faf3ffad06$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("8JATf", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $65bf244fb8961772$export$aafa59e2e03f2942; }, function (v) { return $65bf244fb8961772$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $65bf244fb8961772$export$68d8715fc104d294; }, function (v) { return $65bf244fb8961772$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $65bf244fb8961772$export$aafa59e2e03f2942;
var $65bf244fb8961772$export$68d8715fc104d294;
$65bf244fb8961772$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$65bf244fb8961772$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("iczbQ", function(module, exports) {
"use strict";

});

parcelRegister("82idC", function(module, exports) {
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $qb7pP = parcelRequire("qb7pP");

var $ffICS = parcelRequire("ffICS");
'use strict';
function $5d9ca47efb9a6769$var$assertPath(path) {
    if (typeof path !== 'string') throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $5d9ca47efb9a6769$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = '';
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf('/');
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = '';
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf('/');
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = '';
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += '/..';
                    else res = '..';
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += '/' + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $5d9ca47efb9a6769$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || '') + (pathObject.ext || '');
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $5d9ca47efb9a6769$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = '';
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $ffICS.cwd();
                path = cwd;
            }
            $5d9ca47efb9a6769$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + '/' + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $5d9ca47efb9a6769$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return '/' + resolvedPath;
            else return '/';
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return '.';
    },
    normalize: function normalize(path) {
        $5d9ca47efb9a6769$var$assertPath(path);
        if (path.length === 0) return '.';
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $5d9ca47efb9a6769$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = '.';
        if (path.length > 0 && trailingSeparator) path += '/';
        if (isAbsolute) return '/' + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $5d9ca47efb9a6769$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return '.';
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $5d9ca47efb9a6769$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += '/' + arg;
            }
        }
        if (joined === undefined) return '.';
        return $5d9ca47efb9a6769$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $5d9ca47efb9a6769$var$assertPath(from);
        $5d9ca47efb9a6769$var$assertPath(to);
        if (from === to) return '';
        from = $5d9ca47efb9a6769$var$posix.resolve(from);
        to = $5d9ca47efb9a6769$var$posix.resolve(to);
        if (from === to) return '';
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = '';
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += '..';
            else out += '/..';
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $5d9ca47efb9a6769$var$assertPath(path);
        if (path.length === 0) return '.';
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? '/' : '.';
        if (hasRoot && end === 1) return '//';
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
        $5d9ca47efb9a6769$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return '';
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return '';
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $5d9ca47efb9a6769$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return '';
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || (typeof pathObject === "undefined" ? "undefined" : (0, $qb7pP._)(pathObject)) !== 'object') throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + (typeof pathObject === "undefined" ? "undefined" : (0, $qb7pP._)(pathObject)));
        return $5d9ca47efb9a6769$var$_format('/', pathObject);
    },
    parse: function parse(path) {
        $5d9ca47efb9a6769$var$assertPath(path);
        var ret = {
            root: '',
            dir: '',
            base: '',
            ext: '',
            name: ''
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = '/';
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = '/';
        return ret;
    },
    sep: '/',
    delimiter: ':',
    win32: null,
    posix: null
};
$5d9ca47efb9a6769$var$posix.posix = $5d9ca47efb9a6769$var$posix;
module.exports = $5d9ca47efb9a6769$var$posix;

});

parcelRegister("8bvFt", function(module, exports) {

$parcel$export(module.exports, "homedir", function () { return $5f57ea63c28abdea$export$c1d46b5ea6262c0b; }, function (v) { return $5f57ea63c28abdea$export$c1d46b5ea6262c0b = v; });
var $5f57ea63c28abdea$export$edf525f30916fbb8;
var $5f57ea63c28abdea$export$640106f6dc7d2706;
var $5f57ea63c28abdea$export$3ea386628068cf62;
var $5f57ea63c28abdea$export$749d472264fad440;
var $5f57ea63c28abdea$export$8b931a48d9488767;
var $5f57ea63c28abdea$export$9123f37609399513;
var $5f57ea63c28abdea$export$9b60beb643db4d69;
var $5f57ea63c28abdea$export$bf9fb029d174d554;
var $5f57ea63c28abdea$export$23d3fad09dc44362;
var $5f57ea63c28abdea$export$d2f3c2f7e0c7dcf5;
var $5f57ea63c28abdea$export$3bf7c33313eba0fe;
var $5f57ea63c28abdea$export$7925d89f138dad5b;
var $5f57ea63c28abdea$export$722a64dea1b767dc;
var $5f57ea63c28abdea$export$9e6c06a7d47f9af7;
var $5f57ea63c28abdea$export$6b76988456c0292f;
var $5f57ea63c28abdea$export$266d3b9babd1fc45;
var $5f57ea63c28abdea$export$c1d46b5ea6262c0b;
$5f57ea63c28abdea$export$edf525f30916fbb8 = function() {
    return 'LE';
};
$5f57ea63c28abdea$export$640106f6dc7d2706 = function() {
    if (typeof location !== 'undefined') return location.hostname;
    else return '';
};
$5f57ea63c28abdea$export$3ea386628068cf62 = function() {
    return [];
};
$5f57ea63c28abdea$export$749d472264fad440 = function() {
    return 0;
};
$5f57ea63c28abdea$export$8b931a48d9488767 = function() {
    return Number.MAX_VALUE;
};
$5f57ea63c28abdea$export$9123f37609399513 = function() {
    return Number.MAX_VALUE;
};
$5f57ea63c28abdea$export$9b60beb643db4d69 = function() {
    return [];
};
$5f57ea63c28abdea$export$bf9fb029d174d554 = function() {
    return 'Browser';
};
$5f57ea63c28abdea$export$23d3fad09dc44362 = function() {
    if (typeof navigator !== 'undefined') return navigator.appVersion;
    return '';
};
$5f57ea63c28abdea$export$d2f3c2f7e0c7dcf5 = $5f57ea63c28abdea$export$3bf7c33313eba0fe = function() {
    return {};
};
$5f57ea63c28abdea$export$7925d89f138dad5b = function() {
    return 'javascript';
};
$5f57ea63c28abdea$export$722a64dea1b767dc = function() {
    return 'browser';
};
$5f57ea63c28abdea$export$9e6c06a7d47f9af7 = $5f57ea63c28abdea$export$6b76988456c0292f = function() {
    return '/tmp';
};
$5f57ea63c28abdea$export$266d3b9babd1fc45 = '\n';
$5f57ea63c28abdea$export$c1d46b5ea6262c0b = function() {
    return '/';
};

});

parcelRegister("koGNw", function(module, exports) {

$parcel$export(module.exports, "createDecipheriv", function () { return $ed973f46556386ca$export$36b6d6ef312eab39; }, function (v) { return $ed973f46556386ca$export$36b6d6ef312eab39 = v; });
// eslint-disable-next-line no-multi-assign
var $ed973f46556386ca$export$5f828d93ff035aa8;
var $ed973f46556386ca$export$cd94982b18c6332c;
var $ed973f46556386ca$export$1d518568e4f529b0;
var $ed973f46556386ca$export$5285b6d41c912b41;
// eslint-disable-next-line no-multi-assign
var $ed973f46556386ca$export$2fb37efbf6ae0c0e;
var $ed973f46556386ca$export$ab85ecd77ce6a5cd;
// eslint-disable-next-line no-multi-assign
var $ed973f46556386ca$export$da39cf97e1eb7c91;
var $ed973f46556386ca$export$52a9039d7177394f;
var $ed973f46556386ca$export$f7201db400317331;
var $ed973f46556386ca$export$448fa22aedc9dbca;
var $ed973f46556386ca$export$b80c7ba289c8fa56;
var $ed973f46556386ca$export$26e5786e8ac8e530;
var $ed973f46556386ca$export$bdd223f16383713e;
var $ed973f46556386ca$export$20533d26f07f1ee0;
var $ed973f46556386ca$export$2f64596b8cbf08b4;
var $ed973f46556386ca$export$2ce6d8d0e8b04e1a;
var $ed973f46556386ca$export$12ada9414fbc594c;
var $ed973f46556386ca$export$f5e7e39d57cd9700;
var $ed973f46556386ca$export$36b6d6ef312eab39;
var $ed973f46556386ca$export$58a258485f1e49f6;
var $ed973f46556386ca$export$dedd8dc3dc62b370;
var $ed973f46556386ca$export$971862a2fcb1bb40;
var $ed973f46556386ca$export$c6ff6a88acbeaf40;
var $ed973f46556386ca$export$fdc27893e98845cc;
var $ed973f46556386ca$export$6671fb9a1323bed;
var $ed973f46556386ca$export$d74daf141a551db;
var $ed973f46556386ca$export$45df7cae684751af;
var $ed973f46556386ca$export$1db683ad541682f6;
var $ed973f46556386ca$export$6f65485f87568e37;
var $ed973f46556386ca$export$91a8e56769aeb334;
var $ed973f46556386ca$export$2d4117e99c2179e4;
var $ed973f46556386ca$export$512823e338ddb1b7;
var $ed973f46556386ca$export$9d0e0c0c4a8d30f3;
var $ed973f46556386ca$export$b9d55ff329113abd;
var $ed973f46556386ca$export$7efb24e2fddf99b9;
var $ed973f46556386ca$export$bb1abf2ce84fc7e8;
var $ed973f46556386ca$export$2f7171e78e524d5e;
var $ed973f46556386ca$export$e1d879b482f37d98;
var $ed973f46556386ca$export$1a988e7317c65621;
'use strict';

$ed973f46556386ca$export$5f828d93ff035aa8 = $ed973f46556386ca$export$cd94982b18c6332c = $ed973f46556386ca$export$1d518568e4f529b0 = $ed973f46556386ca$export$5285b6d41c912b41 = (parcelRequire("cCNIN"));

$ed973f46556386ca$export$2fb37efbf6ae0c0e = $ed973f46556386ca$export$ab85ecd77ce6a5cd = (parcelRequire("hBj6e"));

$ed973f46556386ca$export$da39cf97e1eb7c91 = $ed973f46556386ca$export$52a9039d7177394f = (parcelRequire("4Ffzf"));

var $bm7Fu = parcelRequire("bm7Fu");
var $ed973f46556386ca$var$algoKeys = Object.keys($bm7Fu);
var $ed973f46556386ca$var$hashes = [
    'sha1',
    'sha224',
    'sha256',
    'sha384',
    'sha512',
    'md5',
    'rmd160'
].concat($ed973f46556386ca$var$algoKeys);
$ed973f46556386ca$export$f7201db400317331 = function() {
    return $ed973f46556386ca$var$hashes;
};

var $lRKNN = parcelRequire("lRKNN");
$ed973f46556386ca$export$448fa22aedc9dbca = $lRKNN.pbkdf2;
$ed973f46556386ca$export$b80c7ba289c8fa56 = $lRKNN.pbkdf2Sync;

var $dM8ww = parcelRequire("dM8ww");
$ed973f46556386ca$export$26e5786e8ac8e530 = $dM8ww.Cipher;
$ed973f46556386ca$export$bdd223f16383713e = $dM8ww.createCipher;
$ed973f46556386ca$export$20533d26f07f1ee0 = $dM8ww.Cipheriv;
$ed973f46556386ca$export$2f64596b8cbf08b4 = $dM8ww.createCipheriv;
$ed973f46556386ca$export$2ce6d8d0e8b04e1a = $dM8ww.Decipher;
$ed973f46556386ca$export$12ada9414fbc594c = $dM8ww.createDecipher;
$ed973f46556386ca$export$f5e7e39d57cd9700 = $dM8ww.Decipheriv;
$ed973f46556386ca$export$36b6d6ef312eab39 = $dM8ww.createDecipheriv;
$ed973f46556386ca$export$58a258485f1e49f6 = $dM8ww.getCiphers;
$ed973f46556386ca$export$dedd8dc3dc62b370 = $dM8ww.listCiphers;

var $eH94P = parcelRequire("eH94P");
$ed973f46556386ca$export$971862a2fcb1bb40 = $eH94P.DiffieHellmanGroup;
$ed973f46556386ca$export$c6ff6a88acbeaf40 = $eH94P.createDiffieHellmanGroup;
$ed973f46556386ca$export$fdc27893e98845cc = $eH94P.getDiffieHellman;
$ed973f46556386ca$export$6671fb9a1323bed = $eH94P.createDiffieHellman;
$ed973f46556386ca$export$d74daf141a551db = $eH94P.DiffieHellman;

var $6u9dE = parcelRequire("6u9dE");
$ed973f46556386ca$export$45df7cae684751af = $6u9dE.createSign;
$ed973f46556386ca$export$1db683ad541682f6 = $6u9dE.Sign;
$ed973f46556386ca$export$6f65485f87568e37 = $6u9dE.createVerify;
$ed973f46556386ca$export$91a8e56769aeb334 = $6u9dE.Verify;

$ed973f46556386ca$export$2d4117e99c2179e4 = (parcelRequire("flUnX"));

var $a0atk = parcelRequire("a0atk");
$ed973f46556386ca$export$512823e338ddb1b7 = $a0atk.publicEncrypt;
$ed973f46556386ca$export$9d0e0c0c4a8d30f3 = $a0atk.privateEncrypt;
$ed973f46556386ca$export$b9d55ff329113abd = $a0atk.publicDecrypt;
$ed973f46556386ca$export$7efb24e2fddf99b9 = $a0atk.privateDecrypt;

var $h4kk6 = parcelRequire("h4kk6");
$ed973f46556386ca$export$bb1abf2ce84fc7e8 = $h4kk6.randomFill;
$ed973f46556386ca$export$2f7171e78e524d5e = $h4kk6.randomFillSync;
$ed973f46556386ca$export$e1d879b482f37d98 = function() {
    throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
};
$ed973f46556386ca$export$1a988e7317c65621 = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
};

});
parcelRegister("cCNIN", function(module, exports) {

var $ffICS = parcelRequire("ffICS");
'use strict';
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $930f9a5221fde32d$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $930f9a5221fde32d$var$MAX_UINT32 = 4294967295;
function $930f9a5221fde32d$var$oldBrowser() {
    throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11');
}

var $5PcLP = parcelRequire("5PcLP");
var $930f9a5221fde32d$require$Buffer = $5PcLP.Buffer;
var $930f9a5221fde32d$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($930f9a5221fde32d$var$crypto && $930f9a5221fde32d$var$crypto.getRandomValues) module.exports = $930f9a5221fde32d$var$randomBytes;
else module.exports = $930f9a5221fde32d$var$oldBrowser;
function $930f9a5221fde32d$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $930f9a5221fde32d$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
    var bytes = $930f9a5221fde32d$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $930f9a5221fde32d$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $930f9a5221fde32d$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $930f9a5221fde32d$var$crypto.getRandomValues(bytes.slice(generated, generated + $930f9a5221fde32d$var$MAX_BYTES));
        else $930f9a5221fde32d$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === 'function') return $ffICS.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRegister("5PcLP", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $dSRbH = parcelRequire("dSRbH");
var $43db9f1f7e69361b$var$Buffer = $dSRbH.Buffer;
// alternative to using Object.keys for old browsers
function $43db9f1f7e69361b$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($43db9f1f7e69361b$var$Buffer.from && $43db9f1f7e69361b$var$Buffer.alloc && $43db9f1f7e69361b$var$Buffer.allocUnsafe && $43db9f1f7e69361b$var$Buffer.allocUnsafeSlow) module.exports = $dSRbH;
else {
    // Copy properties from require('buffer')
    $43db9f1f7e69361b$var$copyProps($dSRbH, module.exports);
    module.exports.Buffer = $43db9f1f7e69361b$var$SafeBuffer;
}
function $43db9f1f7e69361b$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $43db9f1f7e69361b$var$Buffer(arg, encodingOrOffset, length);
}
$43db9f1f7e69361b$var$SafeBuffer.prototype = Object.create($43db9f1f7e69361b$var$Buffer.prototype);
// Copy static methods from Buffer
$43db9f1f7e69361b$var$copyProps($43db9f1f7e69361b$var$Buffer, $43db9f1f7e69361b$var$SafeBuffer);
$43db9f1f7e69361b$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $43db9f1f7e69361b$var$Buffer(arg, encodingOrOffset, length);
};
$43db9f1f7e69361b$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $43db9f1f7e69361b$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$43db9f1f7e69361b$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $43db9f1f7e69361b$var$Buffer(size);
};
$43db9f1f7e69361b$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $dSRbH.SlowBuffer(size);
};

});


parcelRegister("hBj6e", function(module, exports) {
'use strict';

var $6LbC4 = parcelRequire("6LbC4");

var $dS5XU = parcelRequire("dS5XU");

var $abqEp = parcelRequire("abqEp");

var $5Yf9k = parcelRequire("5Yf9k");

var $db4vO = parcelRequire("db4vO");
function $cd04b51f4f2d0769$var$Hash(hash) {
    $db4vO.call(this, 'digest');
    this._hash = hash;
}
$6LbC4($cd04b51f4f2d0769$var$Hash, $db4vO);
$cd04b51f4f2d0769$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$cd04b51f4f2d0769$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new $dS5XU();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $abqEp();
    return new $cd04b51f4f2d0769$var$Hash($5Yf9k(alg));
};

});
parcelRegister("6LbC4", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("dS5XU", function(module, exports) {
'use strict';

var $6LbC4 = parcelRequire("6LbC4");

var $5szPq = parcelRequire("5szPq");

var $5PcLP = parcelRequire("5PcLP");
var $a194f218b3d0ac40$require$Buffer = $5PcLP.Buffer;
var $a194f218b3d0ac40$var$ARRAY16 = new Array(16);
function $a194f218b3d0ac40$var$MD5() {
    $5szPq.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$6LbC4($a194f218b3d0ac40$var$MD5, $5szPq);
$a194f218b3d0ac40$var$MD5.prototype._update = function() {
    var M = $a194f218b3d0ac40$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $a194f218b3d0ac40$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $a194f218b3d0ac40$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $a194f218b3d0ac40$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $a194f218b3d0ac40$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $a194f218b3d0ac40$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $a194f218b3d0ac40$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $a194f218b3d0ac40$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $a194f218b3d0ac40$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $a194f218b3d0ac40$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $a194f218b3d0ac40$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $a194f218b3d0ac40$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $a194f218b3d0ac40$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $a194f218b3d0ac40$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $a194f218b3d0ac40$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $a194f218b3d0ac40$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $a194f218b3d0ac40$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $a194f218b3d0ac40$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $a194f218b3d0ac40$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $a194f218b3d0ac40$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $a194f218b3d0ac40$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $a194f218b3d0ac40$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $a194f218b3d0ac40$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $a194f218b3d0ac40$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $a194f218b3d0ac40$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $a194f218b3d0ac40$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $a194f218b3d0ac40$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $a194f218b3d0ac40$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $a194f218b3d0ac40$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $a194f218b3d0ac40$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $a194f218b3d0ac40$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $a194f218b3d0ac40$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $a194f218b3d0ac40$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $a194f218b3d0ac40$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $a194f218b3d0ac40$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $a194f218b3d0ac40$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $a194f218b3d0ac40$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $a194f218b3d0ac40$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $a194f218b3d0ac40$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $a194f218b3d0ac40$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $a194f218b3d0ac40$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $a194f218b3d0ac40$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $a194f218b3d0ac40$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $a194f218b3d0ac40$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $a194f218b3d0ac40$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $a194f218b3d0ac40$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $a194f218b3d0ac40$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $a194f218b3d0ac40$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $a194f218b3d0ac40$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $a194f218b3d0ac40$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $a194f218b3d0ac40$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $a194f218b3d0ac40$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $a194f218b3d0ac40$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $a194f218b3d0ac40$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $a194f218b3d0ac40$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $a194f218b3d0ac40$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $a194f218b3d0ac40$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $a194f218b3d0ac40$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $a194f218b3d0ac40$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $a194f218b3d0ac40$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $a194f218b3d0ac40$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $a194f218b3d0ac40$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $a194f218b3d0ac40$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $a194f218b3d0ac40$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $a194f218b3d0ac40$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$a194f218b3d0ac40$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $a194f218b3d0ac40$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $a194f218b3d0ac40$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $a194f218b3d0ac40$var$fnF(a, b, c, d, m, k, s) {
    return $a194f218b3d0ac40$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $a194f218b3d0ac40$var$fnG(a, b, c, d, m, k, s) {
    return $a194f218b3d0ac40$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $a194f218b3d0ac40$var$fnH(a, b, c, d, m, k, s) {
    return $a194f218b3d0ac40$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $a194f218b3d0ac40$var$fnI(a, b, c, d, m, k, s) {
    return $a194f218b3d0ac40$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $a194f218b3d0ac40$var$MD5;

});
parcelRegister("5szPq", function(module, exports) {
'use strict';

var $5PcLP = parcelRequire("5PcLP");
var $3f9b5c0ce2a0f1e5$require$Buffer = $5PcLP.Buffer;

var $4Q7dm = parcelRequire("4Q7dm");
var $3f9b5c0ce2a0f1e5$require$Transform = $4Q7dm.Transform;

var $6LbC4 = parcelRequire("6LbC4");
function $3f9b5c0ce2a0f1e5$var$HashBase(blockSize) {
    $3f9b5c0ce2a0f1e5$require$Transform.call(this);
    this._block = $3f9b5c0ce2a0f1e5$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$6LbC4($3f9b5c0ce2a0f1e5$var$HashBase, $3f9b5c0ce2a0f1e5$require$Transform);
$3f9b5c0ce2a0f1e5$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$3f9b5c0ce2a0f1e5$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
var $3f9b5c0ce2a0f1e5$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $3f9b5c0ce2a0f1e5$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && ArrayBuffer.isView && ($3f9b5c0ce2a0f1e5$require$Buffer.prototype instanceof Uint8Array || $3f9b5c0ce2a0f1e5$require$Buffer.TYPED_ARRAY_SUPPORT);
function $3f9b5c0ce2a0f1e5$var$toBuffer(data, encoding) {
    // No need to do anything for exact instance
    // This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
    if (data instanceof $3f9b5c0ce2a0f1e5$require$Buffer) return data;
    // Convert strings to Buffer
    if (typeof data === 'string') return $3f9b5c0ce2a0f1e5$require$Buffer.from(data, encoding);
    /*
   * Wrap any TypedArray instances and DataViews
   * Makes sense only on engines with full TypedArray support -- let Buffer detect that
   */ if ($3f9b5c0ce2a0f1e5$var$useArrayBuffer && ArrayBuffer.isView(data)) {
        if (data.byteLength === 0) return $3f9b5c0ce2a0f1e5$require$Buffer.alloc(0) // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        ;
        var res = $3f9b5c0ce2a0f1e5$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
        // Recheck result size, as offset/length doesn't work on Node.js <5.10
        // We just go to Uint8Array case if this fails
        if (res.byteLength === data.byteLength) return res;
    }
    /*
   * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
   * Doesn't make sense with other TypedArray instances
   */ if ($3f9b5c0ce2a0f1e5$var$useUint8Array && data instanceof Uint8Array) return $3f9b5c0ce2a0f1e5$require$Buffer.from(data);
    /*
   * Old Buffer polyfill on an engine that doesn't have TypedArray support
   * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
   * Convert to our current Buffer implementation
   */ if ($3f9b5c0ce2a0f1e5$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $3f9b5c0ce2a0f1e5$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
}
$3f9b5c0ce2a0f1e5$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    data = $3f9b5c0ce2a0f1e5$var$toBuffer(data, encoding) // asserts correct input type
    ;
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$3f9b5c0ce2a0f1e5$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$3f9b5c0ce2a0f1e5$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$3f9b5c0ce2a0f1e5$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $3f9b5c0ce2a0f1e5$var$HashBase;

});
parcelRegister("4Q7dm", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $38619d6b05d281ff$var$Stream;

var $6zVuT = parcelRequire("6zVuT");
var $38619d6b05d281ff$require$EE = $6zVuT.EventEmitter;

var $6LbC4 = parcelRequire("6LbC4");
$6LbC4($38619d6b05d281ff$var$Stream, $38619d6b05d281ff$require$EE);

$38619d6b05d281ff$var$Stream.Readable = (parcelRequire("4oHTK"));

$38619d6b05d281ff$var$Stream.Writable = (parcelRequire("4pp7q"));

$38619d6b05d281ff$var$Stream.Duplex = (parcelRequire("iwYxg"));

$38619d6b05d281ff$var$Stream.Transform = (parcelRequire("d8q8o"));

$38619d6b05d281ff$var$Stream.PassThrough = (parcelRequire("4X0Sr"));

$38619d6b05d281ff$var$Stream.finished = (parcelRequire("8PyME"));

$38619d6b05d281ff$var$Stream.pipeline = (parcelRequire("9BRJW"));
// Backwards-compat with node 0.4.x
$38619d6b05d281ff$var$Stream.Stream = $38619d6b05d281ff$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $38619d6b05d281ff$var$Stream() {
    $38619d6b05d281ff$require$EE.call(this);
}
$38619d6b05d281ff$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($38619d6b05d281ff$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("6zVuT", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $qb7pP = parcelRequire("qb7pP");
'use strict';
var $4ca29cbb09c25fea$var$R = (typeof Reflect === "undefined" ? "undefined" : (0, $qb7pP._)(Reflect)) === 'object' ? Reflect : null;
var $4ca29cbb09c25fea$var$ReflectApply = $4ca29cbb09c25fea$var$R && typeof $4ca29cbb09c25fea$var$R.apply === 'function' ? $4ca29cbb09c25fea$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $4ca29cbb09c25fea$var$ReflectOwnKeys;
if ($4ca29cbb09c25fea$var$R && typeof $4ca29cbb09c25fea$var$R.ownKeys === 'function') $4ca29cbb09c25fea$var$ReflectOwnKeys = $4ca29cbb09c25fea$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $4ca29cbb09c25fea$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $4ca29cbb09c25fea$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $4ca29cbb09c25fea$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $4ca29cbb09c25fea$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $4ca29cbb09c25fea$var$EventEmitter() {
    $4ca29cbb09c25fea$var$EventEmitter.init.call(this);
}
module.exports = $4ca29cbb09c25fea$var$EventEmitter;
module.exports.once = $4ca29cbb09c25fea$var$once;
// Backwards-compat with node 0.10.x
$4ca29cbb09c25fea$var$EventEmitter.EventEmitter = $4ca29cbb09c25fea$var$EventEmitter;
$4ca29cbb09c25fea$var$EventEmitter.prototype._events = undefined;
$4ca29cbb09c25fea$var$EventEmitter.prototype._eventsCount = 0;
$4ca29cbb09c25fea$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $4ca29cbb09c25fea$var$defaultMaxListeners = 10;
function $4ca29cbb09c25fea$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + (typeof listener === "undefined" ? "undefined" : (0, $qb7pP._)(listener)));
}
Object.defineProperty($4ca29cbb09c25fea$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function get() {
        return $4ca29cbb09c25fea$var$defaultMaxListeners;
    },
    set: function set(arg) {
        if (typeof arg !== 'number' || arg < 0 || $4ca29cbb09c25fea$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $4ca29cbb09c25fea$var$defaultMaxListeners = arg;
    }
});
$4ca29cbb09c25fea$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$4ca29cbb09c25fea$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $4ca29cbb09c25fea$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $4ca29cbb09c25fea$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $4ca29cbb09c25fea$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$4ca29cbb09c25fea$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $4ca29cbb09c25fea$var$_getMaxListeners(this);
};
$4ca29cbb09c25fea$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $4ca29cbb09c25fea$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $4ca29cbb09c25fea$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$4ca29cbb09c25fea$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $4ca29cbb09c25fea$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $4ca29cbb09c25fea$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $4ca29cbb09c25fea$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $4ca29cbb09c25fea$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$4ca29cbb09c25fea$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $4ca29cbb09c25fea$var$_addListener(this, type, listener, false);
};
$4ca29cbb09c25fea$var$EventEmitter.prototype.on = $4ca29cbb09c25fea$var$EventEmitter.prototype.addListener;
$4ca29cbb09c25fea$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $4ca29cbb09c25fea$var$_addListener(this, type, listener, true);
};
function $4ca29cbb09c25fea$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $4ca29cbb09c25fea$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $4ca29cbb09c25fea$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$4ca29cbb09c25fea$var$EventEmitter.prototype.once = function once(type, listener) {
    $4ca29cbb09c25fea$var$checkListener(listener);
    this.on(type, $4ca29cbb09c25fea$var$_onceWrap(this, type, listener));
    return this;
};
$4ca29cbb09c25fea$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $4ca29cbb09c25fea$var$checkListener(listener);
    this.prependListener(type, $4ca29cbb09c25fea$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$4ca29cbb09c25fea$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $4ca29cbb09c25fea$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $4ca29cbb09c25fea$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$4ca29cbb09c25fea$var$EventEmitter.prototype.off = $4ca29cbb09c25fea$var$EventEmitter.prototype.removeListener;
$4ca29cbb09c25fea$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $4ca29cbb09c25fea$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $4ca29cbb09c25fea$var$unwrapListeners(evlistener) : $4ca29cbb09c25fea$var$arrayClone(evlistener, evlistener.length);
}
$4ca29cbb09c25fea$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $4ca29cbb09c25fea$var$_listeners(this, type, true);
};
$4ca29cbb09c25fea$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $4ca29cbb09c25fea$var$_listeners(this, type, false);
};
$4ca29cbb09c25fea$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $4ca29cbb09c25fea$var$listenerCount.call(emitter, type);
};
$4ca29cbb09c25fea$var$EventEmitter.prototype.listenerCount = $4ca29cbb09c25fea$var$listenerCount;
function $4ca29cbb09c25fea$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$4ca29cbb09c25fea$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $4ca29cbb09c25fea$var$ReflectOwnKeys(this._events) : [];
};
function $4ca29cbb09c25fea$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $4ca29cbb09c25fea$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $4ca29cbb09c25fea$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $4ca29cbb09c25fea$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $4ca29cbb09c25fea$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $4ca29cbb09c25fea$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $4ca29cbb09c25fea$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $4ca29cbb09c25fea$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $4ca29cbb09c25fea$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + (typeof emitter === "undefined" ? "undefined" : (0, $qb7pP._)(emitter)));
}

});

parcelRegister("4oHTK", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $ffICS = parcelRequire("ffICS");
'use strict';
module.exports = $333b748f825d0d88$var$Readable;
/*<replacement>*/ var $333b748f825d0d88$var$Duplex;
/*</replacement>*/ $333b748f825d0d88$var$Readable.ReadableState = $333b748f825d0d88$var$ReadableState;

var $6zVuT = parcelRequire("6zVuT");
var $333b748f825d0d88$require$EE = $6zVuT.EventEmitter;
var $333b748f825d0d88$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $bfPbq = parcelRequire("bfPbq");

var $dSRbH = parcelRequire("dSRbH");
var $333b748f825d0d88$require$Buffer = $dSRbH.Buffer;
var $333b748f825d0d88$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $333b748f825d0d88$var$_uint8ArrayToBuffer(chunk) {
    return $333b748f825d0d88$require$Buffer.from(chunk);
}
function $333b748f825d0d88$var$_isUint8Array(obj) {
    return $333b748f825d0d88$require$Buffer.isBuffer(obj) || obj instanceof $333b748f825d0d88$var$OurUint8Array;
}

var $iczbQ = parcelRequire("iczbQ");
var $333b748f825d0d88$var$debug;
if ($iczbQ && $iczbQ.debuglog) $333b748f825d0d88$var$debug = $iczbQ.debuglog('stream');
else $333b748f825d0d88$var$debug = function debug() {};

var $lGGgB = parcelRequire("lGGgB");

var $47S1R = parcelRequire("47S1R");

var $hYAwL = parcelRequire("hYAwL");
var $333b748f825d0d88$var$getHighWaterMark = $hYAwL.getHighWaterMark;

var $aFUoq = parcelRequire("aFUoq");
var $333b748f825d0d88$require$_require$codes = $aFUoq.codes;
var $333b748f825d0d88$var$ERR_INVALID_ARG_TYPE = $333b748f825d0d88$require$_require$codes.ERR_INVALID_ARG_TYPE, $333b748f825d0d88$var$ERR_STREAM_PUSH_AFTER_EOF = $333b748f825d0d88$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $333b748f825d0d88$var$ERR_METHOD_NOT_IMPLEMENTED = $333b748f825d0d88$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $333b748f825d0d88$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $333b748f825d0d88$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $333b748f825d0d88$var$StringDecoder;
var $333b748f825d0d88$var$createReadableStreamAsyncIterator;
var $333b748f825d0d88$var$from;

(parcelRequire("6LbC4"))($333b748f825d0d88$var$Readable, $bfPbq);
var $333b748f825d0d88$var$errorOrDestroy = $47S1R.errorOrDestroy;
var $333b748f825d0d88$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $333b748f825d0d88$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $333b748f825d0d88$var$ReadableState(options, stream, isDuplex) {
    $333b748f825d0d88$var$Duplex = $333b748f825d0d88$var$Duplex || (parcelRequire("iwYxg"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $333b748f825d0d88$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $333b748f825d0d88$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $lGGgB();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$333b748f825d0d88$var$StringDecoder) $333b748f825d0d88$var$StringDecoder = (parcelRequire("4Gydn")).StringDecoder;
        this.decoder = new $333b748f825d0d88$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $333b748f825d0d88$var$Readable(options) {
    $333b748f825d0d88$var$Duplex = $333b748f825d0d88$var$Duplex || (parcelRequire("iwYxg"));
    if (!(this instanceof $333b748f825d0d88$var$Readable)) return new $333b748f825d0d88$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $333b748f825d0d88$var$Duplex;
    this._readableState = new $333b748f825d0d88$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $bfPbq.call(this);
}
Object.defineProperty($333b748f825d0d88$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$333b748f825d0d88$var$Readable.prototype.destroy = $47S1R.destroy;
$333b748f825d0d88$var$Readable.prototype._undestroy = $47S1R.undestroy;
$333b748f825d0d88$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$333b748f825d0d88$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $333b748f825d0d88$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $333b748f825d0d88$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$333b748f825d0d88$var$Readable.prototype.unshift = function(chunk) {
    return $333b748f825d0d88$var$readableAddChunk(this, chunk, null, true, false);
};
function $333b748f825d0d88$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $333b748f825d0d88$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $333b748f825d0d88$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $333b748f825d0d88$var$chunkInvalid(state, chunk);
        if (er) $333b748f825d0d88$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $333b748f825d0d88$require$Buffer.prototype) chunk = $333b748f825d0d88$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $333b748f825d0d88$var$errorOrDestroy(stream, new $333b748f825d0d88$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $333b748f825d0d88$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $333b748f825d0d88$var$errorOrDestroy(stream, new $333b748f825d0d88$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $333b748f825d0d88$var$addChunk(stream, state, chunk, false);
                    else $333b748f825d0d88$var$maybeReadMore(stream, state);
                } else $333b748f825d0d88$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $333b748f825d0d88$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $333b748f825d0d88$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $333b748f825d0d88$var$emitReadable(stream);
    }
    $333b748f825d0d88$var$maybeReadMore(stream, state);
}
function $333b748f825d0d88$var$chunkInvalid(state, chunk) {
    var er;
    if (!$333b748f825d0d88$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $333b748f825d0d88$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$333b748f825d0d88$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$333b748f825d0d88$var$Readable.prototype.setEncoding = function(enc) {
    if (!$333b748f825d0d88$var$StringDecoder) $333b748f825d0d88$var$StringDecoder = (parcelRequire("4Gydn")).StringDecoder;
    var decoder = new $333b748f825d0d88$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $333b748f825d0d88$var$MAX_HWM = 0x40000000;
function $333b748f825d0d88$var$computeNewHighWaterMark(n) {
    if (n >= $333b748f825d0d88$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $333b748f825d0d88$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $333b748f825d0d88$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $333b748f825d0d88$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$333b748f825d0d88$var$Readable.prototype.read = function(n) {
    $333b748f825d0d88$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $333b748f825d0d88$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $333b748f825d0d88$var$endReadable(this);
        else $333b748f825d0d88$var$emitReadable(this);
        return null;
    }
    n = $333b748f825d0d88$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $333b748f825d0d88$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $333b748f825d0d88$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $333b748f825d0d88$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $333b748f825d0d88$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $333b748f825d0d88$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $333b748f825d0d88$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $333b748f825d0d88$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $333b748f825d0d88$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $333b748f825d0d88$var$onEofChunk(stream, state) {
    $333b748f825d0d88$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $333b748f825d0d88$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $333b748f825d0d88$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $333b748f825d0d88$var$emitReadable(stream) {
    var state = stream._readableState;
    $333b748f825d0d88$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $333b748f825d0d88$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $ffICS.nextTick($333b748f825d0d88$var$emitReadable_, stream);
    }
}
function $333b748f825d0d88$var$emitReadable_(stream) {
    var state = stream._readableState;
    $333b748f825d0d88$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $333b748f825d0d88$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $333b748f825d0d88$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $ffICS.nextTick($333b748f825d0d88$var$maybeReadMore_, stream, state);
    }
}
function $333b748f825d0d88$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $333b748f825d0d88$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$333b748f825d0d88$var$Readable.prototype._read = function(n) {
    $333b748f825d0d88$var$errorOrDestroy(this, new $333b748f825d0d88$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$333b748f825d0d88$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $333b748f825d0d88$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $ffICS.stdout && dest !== $ffICS.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $ffICS.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $333b748f825d0d88$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $333b748f825d0d88$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $333b748f825d0d88$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $333b748f825d0d88$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $333b748f825d0d88$var$debug('ondata');
        var ret = dest.write(chunk);
        $333b748f825d0d88$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $333b748f825d0d88$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $333b748f825d0d88$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $333b748f825d0d88$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($333b748f825d0d88$var$EElistenerCount(dest, 'error') === 0) $333b748f825d0d88$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $333b748f825d0d88$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $333b748f825d0d88$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $333b748f825d0d88$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $333b748f825d0d88$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $333b748f825d0d88$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $333b748f825d0d88$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $333b748f825d0d88$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $333b748f825d0d88$var$flow(src);
        }
    };
}
$333b748f825d0d88$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $333b748f825d0d88$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$333b748f825d0d88$var$Readable.prototype.on = function(ev, fn) {
    var res = $bfPbq.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $333b748f825d0d88$var$debug('on readable', state.length, state.reading);
            if (state.length) $333b748f825d0d88$var$emitReadable(this);
            else if (!state.reading) $ffICS.nextTick($333b748f825d0d88$var$nReadingNextTick, this);
        }
    }
    return res;
};
$333b748f825d0d88$var$Readable.prototype.addListener = $333b748f825d0d88$var$Readable.prototype.on;
$333b748f825d0d88$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $bfPbq.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $ffICS.nextTick($333b748f825d0d88$var$updateReadableListening, this);
    return res;
};
$333b748f825d0d88$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $bfPbq.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $ffICS.nextTick($333b748f825d0d88$var$updateReadableListening, this);
    return res;
};
function $333b748f825d0d88$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $333b748f825d0d88$var$nReadingNextTick(self1) {
    $333b748f825d0d88$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$333b748f825d0d88$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $333b748f825d0d88$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $333b748f825d0d88$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $333b748f825d0d88$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $ffICS.nextTick($333b748f825d0d88$var$resume_, stream, state);
    }
}
function $333b748f825d0d88$var$resume_(stream, state) {
    $333b748f825d0d88$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $333b748f825d0d88$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$333b748f825d0d88$var$Readable.prototype.pause = function() {
    $333b748f825d0d88$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $333b748f825d0d88$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $333b748f825d0d88$var$flow(stream) {
    var state = stream._readableState;
    $333b748f825d0d88$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$333b748f825d0d88$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $333b748f825d0d88$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $333b748f825d0d88$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $333b748f825d0d88$var$kProxyEvents.length; n++)stream.on($333b748f825d0d88$var$kProxyEvents[n], this.emit.bind(this, $333b748f825d0d88$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $333b748f825d0d88$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $333b748f825d0d88$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($333b748f825d0d88$var$createReadableStreamAsyncIterator === undefined) $333b748f825d0d88$var$createReadableStreamAsyncIterator = (parcelRequire("5BrKO"));
    return $333b748f825d0d88$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($333b748f825d0d88$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($333b748f825d0d88$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($333b748f825d0d88$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$333b748f825d0d88$var$Readable._fromList = $333b748f825d0d88$var$fromList;
Object.defineProperty($333b748f825d0d88$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $333b748f825d0d88$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $333b748f825d0d88$var$endReadable(stream) {
    var state = stream._readableState;
    $333b748f825d0d88$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $ffICS.nextTick($333b748f825d0d88$var$endReadableNT, state, stream);
    }
}
function $333b748f825d0d88$var$endReadableNT(state, stream) {
    $333b748f825d0d88$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $333b748f825d0d88$var$Readable.from = function(iterable, opts) {
    if ($333b748f825d0d88$var$from === undefined) $333b748f825d0d88$var$from = (parcelRequire("XVrbL"));
    return $333b748f825d0d88$var$from($333b748f825d0d88$var$Readable, iterable, opts);
};
function $333b748f825d0d88$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("bfPbq", function(module, exports) {

module.exports = (parcelRequire("6zVuT")).EventEmitter;

});

parcelRegister("lGGgB", function(module, exports) {

var $qb7pP = parcelRequire("qb7pP");
'use strict';
function $fc9e4e89870397fb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $fc9e4e89870397fb$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $fc9e4e89870397fb$var$ownKeys(Object(source), !0).forEach(function(key) {
            $fc9e4e89870397fb$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $fc9e4e89870397fb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $fc9e4e89870397fb$var$_defineProperty(obj, key, value) {
    key = $fc9e4e89870397fb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fc9e4e89870397fb$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fc9e4e89870397fb$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $fc9e4e89870397fb$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $fc9e4e89870397fb$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fc9e4e89870397fb$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fc9e4e89870397fb$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $fc9e4e89870397fb$var$_toPropertyKey(arg) {
    var key = $fc9e4e89870397fb$var$_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0, $qb7pP._)(key)) === "symbol" ? key : String(key);
}
function $fc9e4e89870397fb$var$_toPrimitive(input, hint) {
    if ((typeof input === "undefined" ? "undefined" : (0, $qb7pP._)(input)) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((typeof res === "undefined" ? "undefined" : (0, $qb7pP._)(res)) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $dSRbH = parcelRequire("dSRbH");
var $fc9e4e89870397fb$var$Buffer = $dSRbH.Buffer;

var $iczbQ = parcelRequire("iczbQ");
var $fc9e4e89870397fb$var$inspect = $iczbQ.inspect;
var $fc9e4e89870397fb$var$custom = $fc9e4e89870397fb$var$inspect && $fc9e4e89870397fb$var$inspect.custom || 'inspect';
function $fc9e4e89870397fb$var$copyBuffer(src, target, offset) {
    $fc9e4e89870397fb$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $fc9e4e89870397fb$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $fc9e4e89870397fb$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $fc9e4e89870397fb$var$Buffer.alloc(0);
                var ret = $fc9e4e89870397fb$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $fc9e4e89870397fb$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $fc9e4e89870397fb$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $fc9e4e89870397fb$var$custom,
            value: function value(_, options) {
                return $fc9e4e89870397fb$var$inspect(this, $fc9e4e89870397fb$var$_objectSpread($fc9e4e89870397fb$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("47S1R", function(module, exports) {

var $ffICS = parcelRequire("ffICS");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $3011b9e8d4dd1248$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $ffICS.nextTick($3011b9e8d4dd1248$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $ffICS.nextTick($3011b9e8d4dd1248$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $ffICS.nextTick($3011b9e8d4dd1248$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $ffICS.nextTick($3011b9e8d4dd1248$var$emitErrorAndCloseNT, _this, err);
            } else $ffICS.nextTick($3011b9e8d4dd1248$var$emitCloseNT, _this);
        } else if (cb) {
            $ffICS.nextTick($3011b9e8d4dd1248$var$emitCloseNT, _this);
            cb(err);
        } else $ffICS.nextTick($3011b9e8d4dd1248$var$emitCloseNT, _this);
    });
    return this;
}
function $3011b9e8d4dd1248$var$emitErrorAndCloseNT(self, err) {
    $3011b9e8d4dd1248$var$emitErrorNT(self, err);
    $3011b9e8d4dd1248$var$emitCloseNT(self);
}
function $3011b9e8d4dd1248$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $3011b9e8d4dd1248$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $3011b9e8d4dd1248$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $3011b9e8d4dd1248$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $3011b9e8d4dd1248$var$destroy,
    undestroy: $3011b9e8d4dd1248$var$undestroy,
    errorOrDestroy: $3011b9e8d4dd1248$var$errorOrDestroy
};

});

parcelRegister("hYAwL", function(module, exports) {
'use strict';

var $d1645fd49efd7533$var$ERR_INVALID_OPT_VALUE = (parcelRequire("aFUoq")).codes.ERR_INVALID_OPT_VALUE;
function $d1645fd49efd7533$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $d1645fd49efd7533$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $d1645fd49efd7533$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $d1645fd49efd7533$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $d1645fd49efd7533$var$getHighWaterMark
};

});
parcelRegister("aFUoq", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $7c597a30289431a3$export$e45cb6485273080e; }, function (v) { return $7c597a30289431a3$export$e45cb6485273080e = v; });

var $qb7pP = parcelRequire("qb7pP");
var $7c597a30289431a3$export$e45cb6485273080e;
'use strict';
function $7c597a30289431a3$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $7c597a30289431a3$var$codes = {};
function $7c597a30289431a3$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $7c597a30289431a3$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $7c597a30289431a3$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $7c597a30289431a3$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $7c597a30289431a3$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $7c597a30289431a3$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $7c597a30289431a3$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$7c597a30289431a3$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$7c597a30289431a3$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $7c597a30289431a3$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($7c597a30289431a3$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($7c597a30289431a3$var$oneOf(expected, 'type'));
    else {
        var type = $7c597a30289431a3$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($7c597a30289431a3$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual === "undefined" ? "undefined" : (0, $qb7pP._)(actual));
    return msg;
}, TypeError);
$7c597a30289431a3$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$7c597a30289431a3$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$7c597a30289431a3$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$7c597a30289431a3$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$7c597a30289431a3$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$7c597a30289431a3$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$7c597a30289431a3$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$7c597a30289431a3$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$7c597a30289431a3$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$7c597a30289431a3$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$7c597a30289431a3$export$e45cb6485273080e = $7c597a30289431a3$var$codes;

});


parcelRegister("iwYxg", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $ffICS = parcelRequire("ffICS");
'use strict';
/*<replacement>*/ var $d7da2c3c9fac60eb$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $d7da2c3c9fac60eb$var$Duplex;

var $4oHTK = parcelRequire("4oHTK");

var $4pp7q = parcelRequire("4pp7q");

(parcelRequire("6LbC4"))($d7da2c3c9fac60eb$var$Duplex, $4oHTK);
// Allow the keys array to be GC'ed.
var $d7da2c3c9fac60eb$var$keys = $d7da2c3c9fac60eb$var$objectKeys($4pp7q.prototype);
for(var $d7da2c3c9fac60eb$var$v = 0; $d7da2c3c9fac60eb$var$v < $d7da2c3c9fac60eb$var$keys.length; $d7da2c3c9fac60eb$var$v++){
    var $d7da2c3c9fac60eb$var$method = $d7da2c3c9fac60eb$var$keys[$d7da2c3c9fac60eb$var$v];
    if (!$d7da2c3c9fac60eb$var$Duplex.prototype[$d7da2c3c9fac60eb$var$method]) $d7da2c3c9fac60eb$var$Duplex.prototype[$d7da2c3c9fac60eb$var$method] = $4pp7q.prototype[$d7da2c3c9fac60eb$var$method];
}
function $d7da2c3c9fac60eb$var$Duplex(options) {
    if (!(this instanceof $d7da2c3c9fac60eb$var$Duplex)) return new $d7da2c3c9fac60eb$var$Duplex(options);
    $4oHTK.call(this, options);
    $4pp7q.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $d7da2c3c9fac60eb$var$onend);
        }
    }
}
Object.defineProperty($d7da2c3c9fac60eb$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($d7da2c3c9fac60eb$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($d7da2c3c9fac60eb$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $d7da2c3c9fac60eb$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $ffICS.nextTick($d7da2c3c9fac60eb$var$onEndNT, this);
}
function $d7da2c3c9fac60eb$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($d7da2c3c9fac60eb$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("4pp7q", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $ffICS = parcelRequire("ffICS");
'use strict';
module.exports = $335cfb4ecea7a484$var$Writable;
/* <replacement> */ function $335cfb4ecea7a484$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $335cfb4ecea7a484$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $335cfb4ecea7a484$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $335cfb4ecea7a484$var$Duplex;
/*</replacement>*/ $335cfb4ecea7a484$var$Writable.WritableState = $335cfb4ecea7a484$var$WritableState;

/*<replacement>*/ var $335cfb4ecea7a484$var$internalUtil = {
    deprecate: (parcelRequire("5VHHi"))
};

var $bfPbq = parcelRequire("bfPbq");

var $dSRbH = parcelRequire("dSRbH");
var $335cfb4ecea7a484$require$Buffer = $dSRbH.Buffer;
var $335cfb4ecea7a484$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $335cfb4ecea7a484$var$_uint8ArrayToBuffer(chunk) {
    return $335cfb4ecea7a484$require$Buffer.from(chunk);
}
function $335cfb4ecea7a484$var$_isUint8Array(obj) {
    return $335cfb4ecea7a484$require$Buffer.isBuffer(obj) || obj instanceof $335cfb4ecea7a484$var$OurUint8Array;
}

var $47S1R = parcelRequire("47S1R");

var $hYAwL = parcelRequire("hYAwL");
var $335cfb4ecea7a484$var$getHighWaterMark = $hYAwL.getHighWaterMark;

var $aFUoq = parcelRequire("aFUoq");
var $335cfb4ecea7a484$require$_require$codes = $aFUoq.codes;
var $335cfb4ecea7a484$var$ERR_INVALID_ARG_TYPE = $335cfb4ecea7a484$require$_require$codes.ERR_INVALID_ARG_TYPE, $335cfb4ecea7a484$var$ERR_METHOD_NOT_IMPLEMENTED = $335cfb4ecea7a484$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $335cfb4ecea7a484$var$ERR_MULTIPLE_CALLBACK = $335cfb4ecea7a484$require$_require$codes.ERR_MULTIPLE_CALLBACK, $335cfb4ecea7a484$var$ERR_STREAM_CANNOT_PIPE = $335cfb4ecea7a484$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $335cfb4ecea7a484$var$ERR_STREAM_DESTROYED = $335cfb4ecea7a484$require$_require$codes.ERR_STREAM_DESTROYED, $335cfb4ecea7a484$var$ERR_STREAM_NULL_VALUES = $335cfb4ecea7a484$require$_require$codes.ERR_STREAM_NULL_VALUES, $335cfb4ecea7a484$var$ERR_STREAM_WRITE_AFTER_END = $335cfb4ecea7a484$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $335cfb4ecea7a484$var$ERR_UNKNOWN_ENCODING = $335cfb4ecea7a484$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $335cfb4ecea7a484$var$errorOrDestroy = $47S1R.errorOrDestroy;

(parcelRequire("6LbC4"))($335cfb4ecea7a484$var$Writable, $bfPbq);
function $335cfb4ecea7a484$var$nop() {}

function $335cfb4ecea7a484$var$WritableState(options, stream, isDuplex) {
    $335cfb4ecea7a484$var$Duplex = $335cfb4ecea7a484$var$Duplex || (parcelRequire("iwYxg"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $335cfb4ecea7a484$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $335cfb4ecea7a484$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $335cfb4ecea7a484$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $335cfb4ecea7a484$var$CorkedRequest(this);
}
$335cfb4ecea7a484$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($335cfb4ecea7a484$var$WritableState.prototype, 'buffer', {
            get: $335cfb4ecea7a484$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $335cfb4ecea7a484$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $335cfb4ecea7a484$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($335cfb4ecea7a484$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($335cfb4ecea7a484$var$realHasInstance.call(this, object)) return true;
            if (this !== $335cfb4ecea7a484$var$Writable) return false;
            return object && object._writableState instanceof $335cfb4ecea7a484$var$WritableState;
        }
    });
} else $335cfb4ecea7a484$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $335cfb4ecea7a484$var$Writable(options) {
    $335cfb4ecea7a484$var$Duplex = $335cfb4ecea7a484$var$Duplex || (parcelRequire("iwYxg"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $335cfb4ecea7a484$var$Duplex;
    if (!isDuplex && !$335cfb4ecea7a484$var$realHasInstance.call($335cfb4ecea7a484$var$Writable, this)) return new $335cfb4ecea7a484$var$Writable(options);
    this._writableState = new $335cfb4ecea7a484$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
    }
    $bfPbq.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$335cfb4ecea7a484$var$Writable.prototype.pipe = function() {
    $335cfb4ecea7a484$var$errorOrDestroy(this, new $335cfb4ecea7a484$var$ERR_STREAM_CANNOT_PIPE());
};
function $335cfb4ecea7a484$var$writeAfterEnd(stream, cb) {
    var er = new $335cfb4ecea7a484$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $335cfb4ecea7a484$var$errorOrDestroy(stream, er);
    $ffICS.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $335cfb4ecea7a484$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $335cfb4ecea7a484$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $335cfb4ecea7a484$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $335cfb4ecea7a484$var$errorOrDestroy(stream, er);
        $ffICS.nextTick(cb, er);
        return false;
    }
    return true;
}
$335cfb4ecea7a484$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $335cfb4ecea7a484$var$_isUint8Array(chunk);
    if (isBuf && !$335cfb4ecea7a484$require$Buffer.isBuffer(chunk)) chunk = $335cfb4ecea7a484$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $335cfb4ecea7a484$var$nop;
    if (state.ending) $335cfb4ecea7a484$var$writeAfterEnd(this, cb);
    else if (isBuf || $335cfb4ecea7a484$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $335cfb4ecea7a484$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$335cfb4ecea7a484$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$335cfb4ecea7a484$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $335cfb4ecea7a484$var$clearBuffer(this, state);
    }
};
$335cfb4ecea7a484$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $335cfb4ecea7a484$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($335cfb4ecea7a484$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $335cfb4ecea7a484$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $335cfb4ecea7a484$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($335cfb4ecea7a484$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $335cfb4ecea7a484$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $335cfb4ecea7a484$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $335cfb4ecea7a484$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $335cfb4ecea7a484$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $335cfb4ecea7a484$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $335cfb4ecea7a484$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $ffICS.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $ffICS.nextTick($335cfb4ecea7a484$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $335cfb4ecea7a484$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $335cfb4ecea7a484$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $335cfb4ecea7a484$var$finishMaybe(stream, state);
    }
}
function $335cfb4ecea7a484$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $335cfb4ecea7a484$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $335cfb4ecea7a484$var$ERR_MULTIPLE_CALLBACK();
    $335cfb4ecea7a484$var$onwriteStateUpdate(state);
    if (er) $335cfb4ecea7a484$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $335cfb4ecea7a484$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $335cfb4ecea7a484$var$clearBuffer(stream, state);
        if (sync) $ffICS.nextTick($335cfb4ecea7a484$var$afterWrite, stream, state, finished, cb);
        else $335cfb4ecea7a484$var$afterWrite(stream, state, finished, cb);
    }
}
function $335cfb4ecea7a484$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $335cfb4ecea7a484$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $335cfb4ecea7a484$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $335cfb4ecea7a484$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $335cfb4ecea7a484$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $335cfb4ecea7a484$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $335cfb4ecea7a484$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $335cfb4ecea7a484$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$335cfb4ecea7a484$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $335cfb4ecea7a484$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$335cfb4ecea7a484$var$Writable.prototype._writev = null;
$335cfb4ecea7a484$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $335cfb4ecea7a484$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($335cfb4ecea7a484$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $335cfb4ecea7a484$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $335cfb4ecea7a484$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $335cfb4ecea7a484$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $335cfb4ecea7a484$var$finishMaybe(stream, state);
    });
}
function $335cfb4ecea7a484$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $ffICS.nextTick($335cfb4ecea7a484$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $335cfb4ecea7a484$var$finishMaybe(stream, state) {
    var need = $335cfb4ecea7a484$var$needFinish(state);
    if (need) {
        $335cfb4ecea7a484$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $335cfb4ecea7a484$var$endWritable(stream, state, cb) {
    state.ending = true;
    $335cfb4ecea7a484$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $ffICS.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $335cfb4ecea7a484$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($335cfb4ecea7a484$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$335cfb4ecea7a484$var$Writable.prototype.destroy = $47S1R.destroy;
$335cfb4ecea7a484$var$Writable.prototype._undestroy = $47S1R.undestroy;
$335cfb4ecea7a484$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("5VHHi", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $45142bfb533dcb4a$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $45142bfb533dcb4a$var$deprecate(fn, msg) {
    if ($45142bfb533dcb4a$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($45142bfb533dcb4a$var$config('throwDeprecation')) throw new Error(msg);
            else if ($45142bfb533dcb4a$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $45142bfb533dcb4a$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("4Gydn", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $3695a000fae847bd$export$63a7aa211a91ed69; }, function (v) { return $3695a000fae847bd$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $3695a000fae847bd$export$63a7aa211a91ed69;
'use strict';

var $5PcLP = parcelRequire("5PcLP");
var $3695a000fae847bd$require$Buffer = $5PcLP.Buffer;
/*</replacement>*/ var $3695a000fae847bd$var$isEncoding = $3695a000fae847bd$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $3695a000fae847bd$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $3695a000fae847bd$var$normalizeEncoding(enc) {
    var nenc = $3695a000fae847bd$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($3695a000fae847bd$require$Buffer.isEncoding === $3695a000fae847bd$var$isEncoding || !$3695a000fae847bd$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$3695a000fae847bd$export$63a7aa211a91ed69 = $3695a000fae847bd$var$StringDecoder;
function $3695a000fae847bd$var$StringDecoder(encoding) {
    this.encoding = $3695a000fae847bd$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $3695a000fae847bd$var$utf16Text;
            this.end = $3695a000fae847bd$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $3695a000fae847bd$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $3695a000fae847bd$var$base64Text;
            this.end = $3695a000fae847bd$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $3695a000fae847bd$var$simpleWrite;
            this.end = $3695a000fae847bd$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $3695a000fae847bd$require$Buffer.allocUnsafe(nb);
}
$3695a000fae847bd$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$3695a000fae847bd$var$StringDecoder.prototype.end = $3695a000fae847bd$var$utf8End;
// Returns only complete characters in a Buffer
$3695a000fae847bd$var$StringDecoder.prototype.text = $3695a000fae847bd$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$3695a000fae847bd$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $3695a000fae847bd$var$utf8CheckByte(_byte) {
    if (_byte <= 0x7F) return 0;
    else if (_byte >> 5 === 0x06) return 2;
    else if (_byte >> 4 === 0x0E) return 3;
    else if (_byte >> 3 === 0x1E) return 4;
    return _byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $3695a000fae847bd$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $3695a000fae847bd$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $3695a000fae847bd$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $3695a000fae847bd$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $3695a000fae847bd$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $3695a000fae847bd$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $3695a000fae847bd$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $3695a000fae847bd$var$utf8Text(buf, i) {
    var total = $3695a000fae847bd$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $3695a000fae847bd$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $3695a000fae847bd$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $3695a000fae847bd$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $3695a000fae847bd$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $3695a000fae847bd$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $3695a000fae847bd$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $3695a000fae847bd$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});

parcelRegister("5BrKO", function(module, exports) {

var $qb7pP = parcelRequire("qb7pP");

var $ffICS = parcelRequire("ffICS");
'use strict';
var $4145efd2ad56d362$var$_Object$setPrototypeO;
function $4145efd2ad56d362$var$_defineProperty(obj, key, value) {
    key = $4145efd2ad56d362$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4145efd2ad56d362$var$_toPropertyKey(arg) {
    var key = $4145efd2ad56d362$var$_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0, $qb7pP._)(key)) === "symbol" ? key : String(key);
}
function $4145efd2ad56d362$var$_toPrimitive(input, hint) {
    if ((typeof input === "undefined" ? "undefined" : (0, $qb7pP._)(input)) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((typeof res === "undefined" ? "undefined" : (0, $qb7pP._)(res)) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $8PyME = parcelRequire("8PyME");
var $4145efd2ad56d362$var$kLastResolve = Symbol('lastResolve');
var $4145efd2ad56d362$var$kLastReject = Symbol('lastReject');
var $4145efd2ad56d362$var$kError = Symbol('error');
var $4145efd2ad56d362$var$kEnded = Symbol('ended');
var $4145efd2ad56d362$var$kLastPromise = Symbol('lastPromise');
var $4145efd2ad56d362$var$kHandlePromise = Symbol('handlePromise');
var $4145efd2ad56d362$var$kStream = Symbol('stream');
function $4145efd2ad56d362$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $4145efd2ad56d362$var$readAndResolve(iter) {
    var resolve = iter[$4145efd2ad56d362$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$4145efd2ad56d362$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$4145efd2ad56d362$var$kLastPromise] = null;
            iter[$4145efd2ad56d362$var$kLastResolve] = null;
            iter[$4145efd2ad56d362$var$kLastReject] = null;
            resolve($4145efd2ad56d362$var$createIterResult(data, false));
        }
    }
}
function $4145efd2ad56d362$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $ffICS.nextTick($4145efd2ad56d362$var$readAndResolve, iter);
}
function $4145efd2ad56d362$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$4145efd2ad56d362$var$kEnded]) {
                resolve($4145efd2ad56d362$var$createIterResult(undefined, true));
                return;
            }
            iter[$4145efd2ad56d362$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $4145efd2ad56d362$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $4145efd2ad56d362$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($4145efd2ad56d362$var$_Object$setPrototypeO = {
    get stream () {
        return this[$4145efd2ad56d362$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$4145efd2ad56d362$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$4145efd2ad56d362$var$kEnded]) return Promise.resolve($4145efd2ad56d362$var$createIterResult(undefined, true));
        if (this[$4145efd2ad56d362$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $ffICS.nextTick(function() {
                if (_this[$4145efd2ad56d362$var$kError]) reject(_this[$4145efd2ad56d362$var$kError]);
                else resolve($4145efd2ad56d362$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$4145efd2ad56d362$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($4145efd2ad56d362$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$4145efd2ad56d362$var$kStream].read();
            if (data !== null) return Promise.resolve($4145efd2ad56d362$var$createIterResult(data, false));
            promise = new Promise(this[$4145efd2ad56d362$var$kHandlePromise]);
        }
        this[$4145efd2ad56d362$var$kLastPromise] = promise;
        return promise;
    }
}, $4145efd2ad56d362$var$_defineProperty($4145efd2ad56d362$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $4145efd2ad56d362$var$_defineProperty($4145efd2ad56d362$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$4145efd2ad56d362$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($4145efd2ad56d362$var$createIterResult(undefined, true));
        });
    });
}), $4145efd2ad56d362$var$_Object$setPrototypeO), $4145efd2ad56d362$var$AsyncIteratorPrototype);
var $4145efd2ad56d362$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($4145efd2ad56d362$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $4145efd2ad56d362$var$_defineProperty(_Object$create, $4145efd2ad56d362$var$kStream, {
        value: stream,
        writable: true
    }), $4145efd2ad56d362$var$_defineProperty(_Object$create, $4145efd2ad56d362$var$kLastResolve, {
        value: null,
        writable: true
    }), $4145efd2ad56d362$var$_defineProperty(_Object$create, $4145efd2ad56d362$var$kLastReject, {
        value: null,
        writable: true
    }), $4145efd2ad56d362$var$_defineProperty(_Object$create, $4145efd2ad56d362$var$kError, {
        value: null,
        writable: true
    }), $4145efd2ad56d362$var$_defineProperty(_Object$create, $4145efd2ad56d362$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $4145efd2ad56d362$var$_defineProperty(_Object$create, $4145efd2ad56d362$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$4145efd2ad56d362$var$kStream].read();
            if (data) {
                iterator[$4145efd2ad56d362$var$kLastPromise] = null;
                iterator[$4145efd2ad56d362$var$kLastResolve] = null;
                iterator[$4145efd2ad56d362$var$kLastReject] = null;
                resolve($4145efd2ad56d362$var$createIterResult(data, false));
            } else {
                iterator[$4145efd2ad56d362$var$kLastResolve] = resolve;
                iterator[$4145efd2ad56d362$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$4145efd2ad56d362$var$kLastPromise] = null;
    $8PyME(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$4145efd2ad56d362$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$4145efd2ad56d362$var$kLastPromise] = null;
                iterator[$4145efd2ad56d362$var$kLastResolve] = null;
                iterator[$4145efd2ad56d362$var$kLastReject] = null;
                reject(err);
            }
            iterator[$4145efd2ad56d362$var$kError] = err;
            return;
        }
        var resolve = iterator[$4145efd2ad56d362$var$kLastResolve];
        if (resolve !== null) {
            iterator[$4145efd2ad56d362$var$kLastPromise] = null;
            iterator[$4145efd2ad56d362$var$kLastResolve] = null;
            iterator[$4145efd2ad56d362$var$kLastReject] = null;
            resolve($4145efd2ad56d362$var$createIterResult(undefined, true));
        }
        iterator[$4145efd2ad56d362$var$kEnded] = true;
    });
    stream.on('readable', $4145efd2ad56d362$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $4145efd2ad56d362$var$createReadableStreamAsyncIterator;

});
parcelRegister("8PyME", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $66de11779d0cf89f$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("aFUoq")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $66de11779d0cf89f$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $66de11779d0cf89f$var$noop() {}
function $66de11779d0cf89f$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $66de11779d0cf89f$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $66de11779d0cf89f$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $66de11779d0cf89f$var$once(callback || $66de11779d0cf89f$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $66de11779d0cf89f$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $66de11779d0cf89f$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($66de11779d0cf89f$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $66de11779d0cf89f$var$eos;

});


parcelRegister("XVrbL", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("d8q8o", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $99004b73f6c2ecf5$var$Transform;

var $aFUoq = parcelRequire("aFUoq");
var $99004b73f6c2ecf5$require$_require$codes = $aFUoq.codes;
var $99004b73f6c2ecf5$var$ERR_METHOD_NOT_IMPLEMENTED = $99004b73f6c2ecf5$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $99004b73f6c2ecf5$var$ERR_MULTIPLE_CALLBACK = $99004b73f6c2ecf5$require$_require$codes.ERR_MULTIPLE_CALLBACK, $99004b73f6c2ecf5$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $99004b73f6c2ecf5$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $99004b73f6c2ecf5$var$ERR_TRANSFORM_WITH_LENGTH_0 = $99004b73f6c2ecf5$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $iwYxg = parcelRequire("iwYxg");

(parcelRequire("6LbC4"))($99004b73f6c2ecf5$var$Transform, $iwYxg);
function $99004b73f6c2ecf5$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $99004b73f6c2ecf5$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $99004b73f6c2ecf5$var$Transform(options) {
    if (!(this instanceof $99004b73f6c2ecf5$var$Transform)) return new $99004b73f6c2ecf5$var$Transform(options);
    $iwYxg.call(this, options);
    this._transformState = {
        afterTransform: $99004b73f6c2ecf5$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $99004b73f6c2ecf5$var$prefinish);
}
function $99004b73f6c2ecf5$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $99004b73f6c2ecf5$var$done(_this, er, data);
    });
    else $99004b73f6c2ecf5$var$done(this, null, null);
}
$99004b73f6c2ecf5$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $iwYxg.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$99004b73f6c2ecf5$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $99004b73f6c2ecf5$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$99004b73f6c2ecf5$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$99004b73f6c2ecf5$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$99004b73f6c2ecf5$var$Transform.prototype._destroy = function(err, cb) {
    $iwYxg.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $99004b73f6c2ecf5$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $99004b73f6c2ecf5$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $99004b73f6c2ecf5$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("4X0Sr", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $39ad5a48cc0101eb$var$PassThrough;

var $d8q8o = parcelRequire("d8q8o");

(parcelRequire("6LbC4"))($39ad5a48cc0101eb$var$PassThrough, $d8q8o);
function $39ad5a48cc0101eb$var$PassThrough(options) {
    if (!(this instanceof $39ad5a48cc0101eb$var$PassThrough)) return new $39ad5a48cc0101eb$var$PassThrough(options);
    $d8q8o.call(this, options);
}
$39ad5a48cc0101eb$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("9BRJW", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $6ff14167c25f3bd2$var$eos;
function $6ff14167c25f3bd2$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $aFUoq = parcelRequire("aFUoq");
var $6ff14167c25f3bd2$require$_require$codes = $aFUoq.codes;
var $6ff14167c25f3bd2$var$ERR_MISSING_ARGS = $6ff14167c25f3bd2$require$_require$codes.ERR_MISSING_ARGS, $6ff14167c25f3bd2$var$ERR_STREAM_DESTROYED = $6ff14167c25f3bd2$require$_require$codes.ERR_STREAM_DESTROYED;
function $6ff14167c25f3bd2$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $6ff14167c25f3bd2$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $6ff14167c25f3bd2$var$destroyer(stream, reading, writing, callback) {
    callback = $6ff14167c25f3bd2$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($6ff14167c25f3bd2$var$eos === undefined) $6ff14167c25f3bd2$var$eos = (parcelRequire("8PyME"));
    $6ff14167c25f3bd2$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($6ff14167c25f3bd2$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $6ff14167c25f3bd2$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $6ff14167c25f3bd2$var$call(fn) {
    fn();
}
function $6ff14167c25f3bd2$var$pipe(from, to) {
    return from.pipe(to);
}
function $6ff14167c25f3bd2$var$popCallback(streams) {
    if (!streams.length) return $6ff14167c25f3bd2$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $6ff14167c25f3bd2$var$noop;
    return streams.pop();
}
function $6ff14167c25f3bd2$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $6ff14167c25f3bd2$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $6ff14167c25f3bd2$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $6ff14167c25f3bd2$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($6ff14167c25f3bd2$var$call);
            if (reading) return;
            destroys.forEach($6ff14167c25f3bd2$var$call);
            callback(error);
        });
    });
    return streams.reduce($6ff14167c25f3bd2$var$pipe);
}
module.exports = $6ff14167c25f3bd2$var$pipeline;

});




parcelRegister("abqEp", function(module, exports) {
'use strict';

var $dSRbH = parcelRequire("dSRbH");
var $769f9ac1a6666684$require$Buffer = $dSRbH.Buffer;

var $6LbC4 = parcelRequire("6LbC4");

var $5szPq = parcelRequire("5szPq");
var $769f9ac1a6666684$var$ARRAY16 = new Array(16);
var $769f9ac1a6666684$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $769f9ac1a6666684$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $769f9ac1a6666684$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $769f9ac1a6666684$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $769f9ac1a6666684$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $769f9ac1a6666684$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $769f9ac1a6666684$var$RIPEMD160() {
    $5szPq.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$6LbC4($769f9ac1a6666684$var$RIPEMD160, $5szPq);
$769f9ac1a6666684$var$RIPEMD160.prototype._update = function() {
    var words = $769f9ac1a6666684$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $769f9ac1a6666684$var$fn1(al, bl, cl, dl, el, words[$769f9ac1a6666684$var$zl[i]], $769f9ac1a6666684$var$hl[0], $769f9ac1a6666684$var$sl[i]);
            tr = $769f9ac1a6666684$var$fn5(ar, br, cr, dr, er, words[$769f9ac1a6666684$var$zr[i]], $769f9ac1a6666684$var$hr[0], $769f9ac1a6666684$var$sr[i]);
        } else if (i < 32) {
            tl = $769f9ac1a6666684$var$fn2(al, bl, cl, dl, el, words[$769f9ac1a6666684$var$zl[i]], $769f9ac1a6666684$var$hl[1], $769f9ac1a6666684$var$sl[i]);
            tr = $769f9ac1a6666684$var$fn4(ar, br, cr, dr, er, words[$769f9ac1a6666684$var$zr[i]], $769f9ac1a6666684$var$hr[1], $769f9ac1a6666684$var$sr[i]);
        } else if (i < 48) {
            tl = $769f9ac1a6666684$var$fn3(al, bl, cl, dl, el, words[$769f9ac1a6666684$var$zl[i]], $769f9ac1a6666684$var$hl[2], $769f9ac1a6666684$var$sl[i]);
            tr = $769f9ac1a6666684$var$fn3(ar, br, cr, dr, er, words[$769f9ac1a6666684$var$zr[i]], $769f9ac1a6666684$var$hr[2], $769f9ac1a6666684$var$sr[i]);
        } else if (i < 64) {
            tl = $769f9ac1a6666684$var$fn4(al, bl, cl, dl, el, words[$769f9ac1a6666684$var$zl[i]], $769f9ac1a6666684$var$hl[3], $769f9ac1a6666684$var$sl[i]);
            tr = $769f9ac1a6666684$var$fn2(ar, br, cr, dr, er, words[$769f9ac1a6666684$var$zr[i]], $769f9ac1a6666684$var$hr[3], $769f9ac1a6666684$var$sr[i]);
        } else {
            tl = $769f9ac1a6666684$var$fn5(al, bl, cl, dl, el, words[$769f9ac1a6666684$var$zl[i]], $769f9ac1a6666684$var$hl[4], $769f9ac1a6666684$var$sl[i]);
            tr = $769f9ac1a6666684$var$fn1(ar, br, cr, dr, er, words[$769f9ac1a6666684$var$zr[i]], $769f9ac1a6666684$var$hr[4], $769f9ac1a6666684$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $769f9ac1a6666684$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $769f9ac1a6666684$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$769f9ac1a6666684$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $769f9ac1a6666684$require$Buffer.alloc ? $769f9ac1a6666684$require$Buffer.alloc(20) : new $769f9ac1a6666684$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $769f9ac1a6666684$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $769f9ac1a6666684$var$fn1(a, b, c, d, e, m, k, s) {
    return $769f9ac1a6666684$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $769f9ac1a6666684$var$fn2(a, b, c, d, e, m, k, s) {
    return $769f9ac1a6666684$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $769f9ac1a6666684$var$fn3(a, b, c, d, e, m, k, s) {
    return $769f9ac1a6666684$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $769f9ac1a6666684$var$fn4(a, b, c, d, e, m, k, s) {
    return $769f9ac1a6666684$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $769f9ac1a6666684$var$fn5(a, b, c, d, e, m, k, s) {
    return $769f9ac1a6666684$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $769f9ac1a6666684$var$RIPEMD160;

});

parcelRegister("5Yf9k", function(module, exports) {
var $458e4eb4934684a0$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $458e4eb4934684a0$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

$458e4eb4934684a0$var$exports.sha = (parcelRequire("24Gym"));

$458e4eb4934684a0$var$exports.sha1 = (parcelRequire("5ieJ8"));

$458e4eb4934684a0$var$exports.sha224 = (parcelRequire("dt8eT"));

$458e4eb4934684a0$var$exports.sha256 = (parcelRequire("6kOBm"));

$458e4eb4934684a0$var$exports.sha384 = (parcelRequire("fC5kw"));

$458e4eb4934684a0$var$exports.sha512 = (parcelRequire("faycu"));

});
parcelRegister("24Gym", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $6LbC4 = parcelRequire("6LbC4");

var $6ZzoL = parcelRequire("6ZzoL");

var $5PcLP = parcelRequire("5PcLP");
var $182cf6aee28d02f9$require$Buffer = $5PcLP.Buffer;
var $182cf6aee28d02f9$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $182cf6aee28d02f9$var$W = new Array(80);
function $182cf6aee28d02f9$var$Sha() {
    this.init();
    this._w = $182cf6aee28d02f9$var$W;
    $6ZzoL.call(this, 64, 56);
}
$6LbC4($182cf6aee28d02f9$var$Sha, $6ZzoL);
$182cf6aee28d02f9$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $182cf6aee28d02f9$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $182cf6aee28d02f9$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $182cf6aee28d02f9$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$182cf6aee28d02f9$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $182cf6aee28d02f9$var$rotl5(a) + $182cf6aee28d02f9$var$ft(s, b, c, d) + e + W[j] + $182cf6aee28d02f9$var$K[s] | 0;
        e = d;
        d = c;
        c = $182cf6aee28d02f9$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$182cf6aee28d02f9$var$Sha.prototype._hash = function() {
    var H = $182cf6aee28d02f9$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $182cf6aee28d02f9$var$Sha;

});
parcelRegister("6ZzoL", function(module, exports) {

var $5PcLP = parcelRequire("5PcLP");
var $5173e5f50bc980ea$require$Buffer = $5PcLP.Buffer;
// prototype class for hash functions
function $5173e5f50bc980ea$var$Hash(blockSize, finalSize) {
    this._block = $5173e5f50bc980ea$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$5173e5f50bc980ea$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === 'string') {
        enc = enc || 'utf8';
        data = $5173e5f50bc980ea$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$5173e5f50bc980ea$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$5173e5f50bc980ea$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $5173e5f50bc980ea$var$Hash;

});


parcelRegister("5ieJ8", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $6LbC4 = parcelRequire("6LbC4");

var $6ZzoL = parcelRequire("6ZzoL");

var $5PcLP = parcelRequire("5PcLP");
var $3daa0ea3c9bc8aa8$require$Buffer = $5PcLP.Buffer;
var $3daa0ea3c9bc8aa8$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $3daa0ea3c9bc8aa8$var$W = new Array(80);
function $3daa0ea3c9bc8aa8$var$Sha1() {
    this.init();
    this._w = $3daa0ea3c9bc8aa8$var$W;
    $6ZzoL.call(this, 64, 56);
}
$6LbC4($3daa0ea3c9bc8aa8$var$Sha1, $6ZzoL);
$3daa0ea3c9bc8aa8$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $3daa0ea3c9bc8aa8$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $3daa0ea3c9bc8aa8$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $3daa0ea3c9bc8aa8$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $3daa0ea3c9bc8aa8$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$3daa0ea3c9bc8aa8$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $3daa0ea3c9bc8aa8$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $3daa0ea3c9bc8aa8$var$rotl5(a) + $3daa0ea3c9bc8aa8$var$ft(s, b, c, d) + e + W[j] + $3daa0ea3c9bc8aa8$var$K[s] | 0;
        e = d;
        d = c;
        c = $3daa0ea3c9bc8aa8$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$3daa0ea3c9bc8aa8$var$Sha1.prototype._hash = function() {
    var H = $3daa0ea3c9bc8aa8$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $3daa0ea3c9bc8aa8$var$Sha1;

});

parcelRegister("dt8eT", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $6LbC4 = parcelRequire("6LbC4");

var $6kOBm = parcelRequire("6kOBm");

var $6ZzoL = parcelRequire("6ZzoL");

var $5PcLP = parcelRequire("5PcLP");
var $9ce45fe97bf882ce$require$Buffer = $5PcLP.Buffer;
var $9ce45fe97bf882ce$var$W = new Array(64);
function $9ce45fe97bf882ce$var$Sha224() {
    this.init();
    this._w = $9ce45fe97bf882ce$var$W // new Array(64)
    ;
    $6ZzoL.call(this, 64, 56);
}
$6LbC4($9ce45fe97bf882ce$var$Sha224, $6kOBm);
$9ce45fe97bf882ce$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$9ce45fe97bf882ce$var$Sha224.prototype._hash = function() {
    var H = $9ce45fe97bf882ce$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $9ce45fe97bf882ce$var$Sha224;

});
parcelRegister("6kOBm", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $6LbC4 = parcelRequire("6LbC4");

var $6ZzoL = parcelRequire("6ZzoL");

var $5PcLP = parcelRequire("5PcLP");
var $49cbdcbe5912d044$require$Buffer = $5PcLP.Buffer;
var $49cbdcbe5912d044$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $49cbdcbe5912d044$var$W = new Array(64);
function $49cbdcbe5912d044$var$Sha256() {
    this.init();
    this._w = $49cbdcbe5912d044$var$W // new Array(64)
    ;
    $6ZzoL.call(this, 64, 56);
}
$6LbC4($49cbdcbe5912d044$var$Sha256, $6ZzoL);
$49cbdcbe5912d044$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $49cbdcbe5912d044$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $49cbdcbe5912d044$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $49cbdcbe5912d044$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $49cbdcbe5912d044$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $49cbdcbe5912d044$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $49cbdcbe5912d044$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$49cbdcbe5912d044$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $49cbdcbe5912d044$var$gamma1(W[i - 2]) + W[i - 7] + $49cbdcbe5912d044$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $49cbdcbe5912d044$var$sigma1(e) + $49cbdcbe5912d044$var$ch(e, f, g) + $49cbdcbe5912d044$var$K[j] + W[j] | 0;
        var T2 = $49cbdcbe5912d044$var$sigma0(a) + $49cbdcbe5912d044$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$49cbdcbe5912d044$var$Sha256.prototype._hash = function() {
    var H = $49cbdcbe5912d044$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $49cbdcbe5912d044$var$Sha256;

});


parcelRegister("fC5kw", function(module, exports) {

var $6LbC4 = parcelRequire("6LbC4");

var $faycu = parcelRequire("faycu");

var $6ZzoL = parcelRequire("6ZzoL");

var $5PcLP = parcelRequire("5PcLP");
var $b5de8a0dca6931ef$require$Buffer = $5PcLP.Buffer;
var $b5de8a0dca6931ef$var$W = new Array(160);
function $b5de8a0dca6931ef$var$Sha384() {
    this.init();
    this._w = $b5de8a0dca6931ef$var$W;
    $6ZzoL.call(this, 128, 112);
}
$6LbC4($b5de8a0dca6931ef$var$Sha384, $faycu);
$b5de8a0dca6931ef$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$b5de8a0dca6931ef$var$Sha384.prototype._hash = function() {
    var H = $b5de8a0dca6931ef$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $b5de8a0dca6931ef$var$Sha384;

});
parcelRegister("faycu", function(module, exports) {

var $6LbC4 = parcelRequire("6LbC4");

var $6ZzoL = parcelRequire("6ZzoL");

var $5PcLP = parcelRequire("5PcLP");
var $b0b251ab75dc8166$require$Buffer = $5PcLP.Buffer;
var $b0b251ab75dc8166$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $b0b251ab75dc8166$var$W = new Array(160);
function $b0b251ab75dc8166$var$Sha512() {
    this.init();
    this._w = $b0b251ab75dc8166$var$W;
    $6ZzoL.call(this, 128, 112);
}
$6LbC4($b0b251ab75dc8166$var$Sha512, $6ZzoL);
$b0b251ab75dc8166$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $b0b251ab75dc8166$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $b0b251ab75dc8166$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $b0b251ab75dc8166$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $b0b251ab75dc8166$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $b0b251ab75dc8166$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $b0b251ab75dc8166$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $b0b251ab75dc8166$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $b0b251ab75dc8166$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $b0b251ab75dc8166$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$b0b251ab75dc8166$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $b0b251ab75dc8166$var$Gamma0(xh, xl);
        var gamma0l = $b0b251ab75dc8166$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $b0b251ab75dc8166$var$Gamma1(xh, xl);
        var gamma1l = $b0b251ab75dc8166$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $b0b251ab75dc8166$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $b0b251ab75dc8166$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $b0b251ab75dc8166$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $b0b251ab75dc8166$var$maj(ah, bh, ch);
        var majl = $b0b251ab75dc8166$var$maj(al, bl, cl);
        var sigma0h = $b0b251ab75dc8166$var$sigma0(ah, al);
        var sigma0l = $b0b251ab75dc8166$var$sigma0(al, ah);
        var sigma1h = $b0b251ab75dc8166$var$sigma1(eh, el);
        var sigma1l = $b0b251ab75dc8166$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $b0b251ab75dc8166$var$K[j];
        var Kil = $b0b251ab75dc8166$var$K[j + 1];
        var chh = $b0b251ab75dc8166$var$Ch(eh, fh, gh);
        var chl = $b0b251ab75dc8166$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $b0b251ab75dc8166$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $b0b251ab75dc8166$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $b0b251ab75dc8166$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $b0b251ab75dc8166$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $b0b251ab75dc8166$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $b0b251ab75dc8166$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $b0b251ab75dc8166$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $b0b251ab75dc8166$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $b0b251ab75dc8166$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $b0b251ab75dc8166$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $b0b251ab75dc8166$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $b0b251ab75dc8166$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $b0b251ab75dc8166$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $b0b251ab75dc8166$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $b0b251ab75dc8166$var$getCarry(this._hl, hl) | 0;
};
$b0b251ab75dc8166$var$Sha512.prototype._hash = function() {
    var H = $b0b251ab75dc8166$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $b0b251ab75dc8166$var$Sha512;

});



parcelRegister("db4vO", function(module, exports) {
'use strict';

var $5PcLP = parcelRequire("5PcLP");
var $997fcd761a55e0bd$require$Buffer = $5PcLP.Buffer;

var $4Q7dm = parcelRequire("4Q7dm");
var $997fcd761a55e0bd$require$Transform = $4Q7dm.Transform;

var $4Gydn = parcelRequire("4Gydn");
var $997fcd761a55e0bd$require$StringDecoder = $4Gydn.StringDecoder;

var $6LbC4 = parcelRequire("6LbC4");
function $997fcd761a55e0bd$var$CipherBase(hashMode) {
    $997fcd761a55e0bd$require$Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this['final'] = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$6LbC4($997fcd761a55e0bd$var$CipherBase, $997fcd761a55e0bd$require$Transform);
var $997fcd761a55e0bd$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $997fcd761a55e0bd$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && ArrayBuffer.isView && ($997fcd761a55e0bd$require$Buffer.prototype instanceof Uint8Array || $997fcd761a55e0bd$require$Buffer.TYPED_ARRAY_SUPPORT);
function $997fcd761a55e0bd$var$toBuffer(data, encoding) {
    /*
	 * No need to do anything for exact instance
	 * This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
	 */ if (data instanceof $997fcd761a55e0bd$require$Buffer) return data;
    // Convert strings to Buffer
    if (typeof data === 'string') return $997fcd761a55e0bd$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($997fcd761a55e0bd$var$useArrayBuffer && ArrayBuffer.isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $997fcd761a55e0bd$require$Buffer.alloc(0);
        var res = $997fcd761a55e0bd$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
        /*
		 * Recheck result size, as offset/length doesn't work on Node.js <5.10
		 * We just go to Uint8Array case if this fails
		 */ if (res.byteLength === data.byteLength) return res;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($997fcd761a55e0bd$var$useUint8Array && data instanceof Uint8Array) return $997fcd761a55e0bd$require$Buffer.from(data);
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if ($997fcd761a55e0bd$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $997fcd761a55e0bd$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
}
$997fcd761a55e0bd$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    var bufferData = $997fcd761a55e0bd$var$toBuffer(data, inputEnc); // asserts correct input type
    var outData = this._update(bufferData);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$997fcd761a55e0bd$var$CipherBase.prototype.setAutoPadding = function() {};
$997fcd761a55e0bd$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
$997fcd761a55e0bd$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
$997fcd761a55e0bd$var$CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
$997fcd761a55e0bd$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$997fcd761a55e0bd$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$997fcd761a55e0bd$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $997fcd761a55e0bd$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$997fcd761a55e0bd$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $997fcd761a55e0bd$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can\u2019t switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $997fcd761a55e0bd$var$CipherBase;

});


parcelRegister("4Ffzf", function(module, exports) {
'use strict';

var $6LbC4 = parcelRequire("6LbC4");

var $iVcLf = parcelRequire("iVcLf");

var $db4vO = parcelRequire("db4vO");

var $5PcLP = parcelRequire("5PcLP");
var $3657112214a3eb66$require$Buffer = $5PcLP.Buffer;

var $d7FoO = parcelRequire("d7FoO");

var $abqEp = parcelRequire("abqEp");

var $5Yf9k = parcelRequire("5Yf9k");
var $3657112214a3eb66$var$ZEROS = $3657112214a3eb66$require$Buffer.alloc(128);
function $3657112214a3eb66$var$Hmac(alg, key) {
    $db4vO.call(this, 'digest');
    if (typeof key === 'string') key = $3657112214a3eb66$require$Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new $abqEp() : $5Yf9k(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $3657112214a3eb66$require$Buffer.concat([
        key,
        $3657112214a3eb66$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $3657112214a3eb66$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $3657112214a3eb66$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new $abqEp() : $5Yf9k(alg);
    this._hash.update(ipad);
}
$6LbC4($3657112214a3eb66$var$Hmac, $db4vO);
$3657112214a3eb66$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$3657112214a3eb66$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new $abqEp() : $5Yf9k(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $3657112214a3eb66$var$Hmac('rmd160', key);
    if (alg === 'md5') return new $iVcLf($d7FoO, key);
    return new $3657112214a3eb66$var$Hmac(alg, key);
};

});
parcelRegister("iVcLf", function(module, exports) {
'use strict';

var $6LbC4 = parcelRequire("6LbC4");

var $5PcLP = parcelRequire("5PcLP");
var $dc6772f79da0e0a7$require$Buffer = $5PcLP.Buffer;

var $db4vO = parcelRequire("db4vO");
var $dc6772f79da0e0a7$var$ZEROS = $dc6772f79da0e0a7$require$Buffer.alloc(128);
var $dc6772f79da0e0a7$var$blocksize = 64;
function $dc6772f79da0e0a7$var$Hmac(alg, key) {
    $db4vO.call(this, 'digest');
    if (typeof key === 'string') key = $dc6772f79da0e0a7$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $dc6772f79da0e0a7$var$blocksize) key = alg(key);
    else if (key.length < $dc6772f79da0e0a7$var$blocksize) key = $dc6772f79da0e0a7$require$Buffer.concat([
        key,
        $dc6772f79da0e0a7$var$ZEROS
    ], $dc6772f79da0e0a7$var$blocksize);
    var ipad = this._ipad = $dc6772f79da0e0a7$require$Buffer.allocUnsafe($dc6772f79da0e0a7$var$blocksize);
    var opad = this._opad = $dc6772f79da0e0a7$require$Buffer.allocUnsafe($dc6772f79da0e0a7$var$blocksize);
    for(var i = 0; i < $dc6772f79da0e0a7$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$6LbC4($dc6772f79da0e0a7$var$Hmac, $db4vO);
$dc6772f79da0e0a7$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$dc6772f79da0e0a7$var$Hmac.prototype._final = function() {
    var h = this._alg($dc6772f79da0e0a7$require$Buffer.concat(this._hash));
    return this._alg($dc6772f79da0e0a7$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $dc6772f79da0e0a7$var$Hmac;

});

parcelRegister("d7FoO", function(module, exports) {

var $dS5XU = parcelRequire("dS5XU");
module.exports = function(buffer) {
    return new $dS5XU().update(buffer).digest();
};

});


parcelRegister("bm7Fu", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ahOFM"));

});
parcelRegister("ahOFM", function(module, exports) {
module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

});


parcelRegister("lRKNN", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", function () { return $feb2da26a085930d$export$448fa22aedc9dbca; }, function (v) { return $feb2da26a085930d$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $feb2da26a085930d$export$b80c7ba289c8fa56; }, function (v) { return $feb2da26a085930d$export$b80c7ba289c8fa56 = v; });
var $feb2da26a085930d$export$448fa22aedc9dbca;
var $feb2da26a085930d$export$b80c7ba289c8fa56;

$feb2da26a085930d$export$448fa22aedc9dbca = (parcelRequire("epp9K"));

$feb2da26a085930d$export$b80c7ba289c8fa56 = (parcelRequire("YNAdy"));

});
parcelRegister("epp9K", function(module, exports) {

var $5PcLP = parcelRequire("5PcLP");
var $a7d6e9f7289f895d$require$Buffer = $5PcLP.Buffer;

var $1L77y = parcelRequire("1L77y");

var $aR7of = parcelRequire("aR7of");

var $YNAdy = parcelRequire("YNAdy");

var $3xaxc = parcelRequire("3xaxc");
var $a7d6e9f7289f895d$var$ZERO_BUF;
var $a7d6e9f7289f895d$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $a7d6e9f7289f895d$var$toBrowser = {
    sha: 'SHA-1',
    'sha-1': 'SHA-1',
    sha1: 'SHA-1',
    sha256: 'SHA-256',
    'sha-256': 'SHA-256',
    sha384: 'SHA-384',
    'sha-384': 'SHA-384',
    'sha-512': 'SHA-512',
    sha512: 'SHA-512'
};
var $a7d6e9f7289f895d$var$checks = [];
function $a7d6e9f7289f895d$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$a7d6e9f7289f895d$var$subtle || !$a7d6e9f7289f895d$var$subtle.importKey || !$a7d6e9f7289f895d$var$subtle.deriveBits) return Promise.resolve(false);
    if ($a7d6e9f7289f895d$var$checks[algo] !== undefined) return $a7d6e9f7289f895d$var$checks[algo];
    $a7d6e9f7289f895d$var$ZERO_BUF = $a7d6e9f7289f895d$var$ZERO_BUF || $a7d6e9f7289f895d$require$Buffer.alloc(8);
    var prom = $a7d6e9f7289f895d$var$browserPbkdf2($a7d6e9f7289f895d$var$ZERO_BUF, $a7d6e9f7289f895d$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    })["catch"](function() {
        return false;
    });
    $a7d6e9f7289f895d$var$checks[algo] = prom;
    return prom;
}
var $a7d6e9f7289f895d$var$nextTick;
function $a7d6e9f7289f895d$var$getNextTick() {
    if ($a7d6e9f7289f895d$var$nextTick) return $a7d6e9f7289f895d$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $a7d6e9f7289f895d$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $a7d6e9f7289f895d$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $a7d6e9f7289f895d$var$nextTick = $parcel$global.setImmediate;
    else $a7d6e9f7289f895d$var$nextTick = $parcel$global.setTimeout;
    return $a7d6e9f7289f895d$var$nextTick;
}
function $a7d6e9f7289f895d$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $a7d6e9f7289f895d$var$subtle.importKey('raw', password, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]).then(function(key) {
        return $a7d6e9f7289f895d$var$subtle.deriveBits({
            name: 'PBKDF2',
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $a7d6e9f7289f895d$require$Buffer.from(res);
    });
}
function $a7d6e9f7289f895d$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $a7d6e9f7289f895d$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $a7d6e9f7289f895d$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
    }
    digest = digest || 'sha1';
    var algo = $a7d6e9f7289f895d$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== 'function') {
        $a7d6e9f7289f895d$var$getNextTick()(function() {
            var out;
            try {
                out = $YNAdy(password, salt, iterations, keylen, digest);
            } catch (e) {
                return callback(e);
            }
            callback(null, out);
        });
        return;
    }
    $1L77y(iterations, keylen);
    password = $3xaxc(password, $aR7of, 'Password');
    salt = $3xaxc(salt, $aR7of, 'Salt');
    if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
    $a7d6e9f7289f895d$var$resolvePromise($a7d6e9f7289f895d$var$checkNative(algo).then(function(resp) {
        if (resp) return $a7d6e9f7289f895d$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $YNAdy(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("1L77y", function(module, exports) {
var $147fb44c037ac8b1$var$MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
    if (iterations < 0) throw new TypeError('Bad iterations');
    if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
    if (keylen < 0 || keylen > $147fb44c037ac8b1$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
};

});

parcelRegister("aR7of", function(module, exports) {

var $ffICS = parcelRequire("ffICS");
var $7e749623736039bd$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $7e749623736039bd$var$defaultEncoding = 'utf-8';
else if ($parcel$global.process && $parcel$global.process.version) {
    var $7e749623736039bd$var$pVersionMajor = parseInt($ffICS.version.split('.')[0].slice(1), 10);
    $7e749623736039bd$var$defaultEncoding = $7e749623736039bd$var$pVersionMajor >= 6 ? 'utf-8' : 'binary';
} else $7e749623736039bd$var$defaultEncoding = 'utf-8';
module.exports = $7e749623736039bd$var$defaultEncoding;

});

parcelRegister("YNAdy", function(module, exports) {

var $d7FoO = parcelRequire("d7FoO");

var $abqEp = parcelRequire("abqEp");

var $5Yf9k = parcelRequire("5Yf9k");

var $5PcLP = parcelRequire("5PcLP");
var $0b6c10e49339a67a$require$Buffer = $5PcLP.Buffer;

var $1L77y = parcelRequire("1L77y");

var $aR7of = parcelRequire("aR7of");

var $3xaxc = parcelRequire("3xaxc");
var $0b6c10e49339a67a$var$ZEROS = $0b6c10e49339a67a$require$Buffer.alloc(128);
var $0b6c10e49339a67a$var$sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function $0b6c10e49339a67a$var$Hmac(alg, key, saltLen) {
    var hash = $0b6c10e49339a67a$var$getDigest(alg);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $0b6c10e49339a67a$require$Buffer.concat([
        key,
        $0b6c10e49339a67a$var$ZEROS
    ], blocksize);
    var ipad = $0b6c10e49339a67a$require$Buffer.allocUnsafe(blocksize + $0b6c10e49339a67a$var$sizes[alg]);
    var opad = $0b6c10e49339a67a$require$Buffer.allocUnsafe(blocksize + $0b6c10e49339a67a$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $0b6c10e49339a67a$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $0b6c10e49339a67a$var$sizes[alg];
}
$0b6c10e49339a67a$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $0b6c10e49339a67a$var$getDigest(alg) {
    function shaFunc(data) {
        return $5Yf9k(alg).update(data).digest();
    }
    function rmd160Func(data) {
        return new $abqEp().update(data).digest();
    }
    if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func;
    if (alg === 'md5') return $d7FoO;
    return shaFunc;
}
function $0b6c10e49339a67a$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $1L77y(iterations, keylen);
    password = $3xaxc(password, $aR7of, 'Password');
    salt = $3xaxc(salt, $aR7of, 'Salt');
    digest = digest || 'sha1';
    var hmac = new $0b6c10e49339a67a$var$Hmac(digest, password, salt.length);
    var DK = $0b6c10e49339a67a$require$Buffer.allocUnsafe(keylen);
    var block1 = $0b6c10e49339a67a$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = $0b6c10e49339a67a$var$sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $0b6c10e49339a67a$var$pbkdf2;

});
parcelRegister("3xaxc", function(module, exports) {

var $5PcLP = parcelRequire("5PcLP");
var $292ca012b245f1bc$require$Buffer = $5PcLP.Buffer;
module.exports = function(thing, encoding, name) {
    if ($292ca012b245f1bc$require$Buffer.isBuffer(thing)) return thing;
    else if (typeof thing === 'string') return $292ca012b245f1bc$require$Buffer.from(thing, encoding);
    else if (ArrayBuffer.isView(thing)) return $292ca012b245f1bc$require$Buffer.from(thing.buffer);
    else throw new TypeError(name + ' must be a string, a Buffer, a typed array or a DataView');
};

});




parcelRegister("dM8ww", function(module, exports) {

$parcel$export(module.exports, "createCipher", function () { return $a0765eadf1c87e45$export$bdd223f16383713e; }, function (v) { return $a0765eadf1c87e45$export$bdd223f16383713e = v; });
$parcel$export(module.exports, "Cipher", function () { return $a0765eadf1c87e45$export$26e5786e8ac8e530; }, function (v) { return $a0765eadf1c87e45$export$26e5786e8ac8e530 = v; });
$parcel$export(module.exports, "createCipheriv", function () { return $a0765eadf1c87e45$export$2f64596b8cbf08b4; }, function (v) { return $a0765eadf1c87e45$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "Cipheriv", function () { return $a0765eadf1c87e45$export$20533d26f07f1ee0; }, function (v) { return $a0765eadf1c87e45$export$20533d26f07f1ee0 = v; });
$parcel$export(module.exports, "createDecipher", function () { return $a0765eadf1c87e45$export$12ada9414fbc594c; }, function (v) { return $a0765eadf1c87e45$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "Decipher", function () { return $a0765eadf1c87e45$export$2ce6d8d0e8b04e1a; }, function (v) { return $a0765eadf1c87e45$export$2ce6d8d0e8b04e1a = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $a0765eadf1c87e45$export$36b6d6ef312eab39; }, function (v) { return $a0765eadf1c87e45$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "Decipheriv", function () { return $a0765eadf1c87e45$export$f5e7e39d57cd9700; }, function (v) { return $a0765eadf1c87e45$export$f5e7e39d57cd9700 = v; });
$parcel$export(module.exports, "listCiphers", function () { return $a0765eadf1c87e45$export$dedd8dc3dc62b370; }, function (v) { return $a0765eadf1c87e45$export$dedd8dc3dc62b370 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $a0765eadf1c87e45$export$58a258485f1e49f6; }, function (v) { return $a0765eadf1c87e45$export$58a258485f1e49f6 = v; });
var $a0765eadf1c87e45$export$bdd223f16383713e;
var $a0765eadf1c87e45$export$26e5786e8ac8e530;
var $a0765eadf1c87e45$export$2f64596b8cbf08b4;
var $a0765eadf1c87e45$export$20533d26f07f1ee0;
var $a0765eadf1c87e45$export$12ada9414fbc594c;
var $a0765eadf1c87e45$export$2ce6d8d0e8b04e1a;
var $a0765eadf1c87e45$export$36b6d6ef312eab39;
var $a0765eadf1c87e45$export$f5e7e39d57cd9700;
var $a0765eadf1c87e45$export$dedd8dc3dc62b370;
var $a0765eadf1c87e45$export$58a258485f1e49f6;

var $4xxvW = parcelRequire("4xxvW");

var $8rjBu = parcelRequire("8rjBu");

var $hfooU = parcelRequire("hfooU");

var $fFXoC = parcelRequire("fFXoC");

var $dMYKX = parcelRequire("dMYKX");
function $a0765eadf1c87e45$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($hfooU[suite]) {
        keyLen = $hfooU[suite].key;
        ivLen = $hfooU[suite].iv;
    } else if ($fFXoC[suite]) {
        keyLen = $fFXoC[suite].key * 8;
        ivLen = $fFXoC[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $dMYKX(password, false, keyLen, ivLen);
    return $a0765eadf1c87e45$var$createCipheriv(suite, keys.key, keys.iv);
}
function $a0765eadf1c87e45$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($hfooU[suite]) {
        keyLen = $hfooU[suite].key;
        ivLen = $hfooU[suite].iv;
    } else if ($fFXoC[suite]) {
        keyLen = $fFXoC[suite].key * 8;
        ivLen = $fFXoC[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $dMYKX(password, false, keyLen, ivLen);
    return $a0765eadf1c87e45$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $a0765eadf1c87e45$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($hfooU[suite]) return $8rjBu.createCipheriv(suite, key, iv);
    if ($fFXoC[suite]) return new $4xxvW({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError('invalid suite type');
}
function $a0765eadf1c87e45$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($hfooU[suite]) return $8rjBu.createDecipheriv(suite, key, iv);
    if ($fFXoC[suite]) return new $4xxvW({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError('invalid suite type');
}
function $a0765eadf1c87e45$var$getCiphers() {
    return Object.keys($fFXoC).concat($8rjBu.getCiphers());
}
$a0765eadf1c87e45$export$bdd223f16383713e = $a0765eadf1c87e45$export$26e5786e8ac8e530 = $a0765eadf1c87e45$var$createCipher;
$a0765eadf1c87e45$export$2f64596b8cbf08b4 = $a0765eadf1c87e45$export$20533d26f07f1ee0 = $a0765eadf1c87e45$var$createCipheriv;
$a0765eadf1c87e45$export$12ada9414fbc594c = $a0765eadf1c87e45$export$2ce6d8d0e8b04e1a = $a0765eadf1c87e45$var$createDecipher;
$a0765eadf1c87e45$export$36b6d6ef312eab39 = $a0765eadf1c87e45$export$f5e7e39d57cd9700 = $a0765eadf1c87e45$var$createDecipheriv;
$a0765eadf1c87e45$export$dedd8dc3dc62b370 = $a0765eadf1c87e45$export$58a258485f1e49f6 = $a0765eadf1c87e45$var$getCiphers;

});
parcelRegister("4xxvW", function(module, exports) {

var $db4vO = parcelRequire("db4vO");

var $L9lM1 = parcelRequire("L9lM1");

var $6LbC4 = parcelRequire("6LbC4");

var $5PcLP = parcelRequire("5PcLP");
var $34e43db311a7ad8c$require$Buffer = $5PcLP.Buffer;
var $34e43db311a7ad8c$var$modes = {
    'des-ede3-cbc': $L9lM1.CBC.instantiate($L9lM1.EDE),
    'des-ede3': $L9lM1.EDE,
    'des-ede-cbc': $L9lM1.CBC.instantiate($L9lM1.EDE),
    'des-ede': $L9lM1.EDE,
    'des-cbc': $L9lM1.CBC.instantiate($L9lM1.DES),
    'des-ecb': $L9lM1.DES
};
$34e43db311a7ad8c$var$modes.des = $34e43db311a7ad8c$var$modes['des-cbc'];
$34e43db311a7ad8c$var$modes.des3 = $34e43db311a7ad8c$var$modes['des-ede3-cbc'];
module.exports = $34e43db311a7ad8c$var$DES;
$6LbC4($34e43db311a7ad8c$var$DES, $db4vO);
function $34e43db311a7ad8c$var$DES(opts) {
    $db4vO.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $34e43db311a7ad8c$var$modes[modeName];
    var type;
    if (opts.decrypt) type = 'decrypt';
    else type = 'encrypt';
    var key = opts.key;
    if (!$34e43db311a7ad8c$require$Buffer.isBuffer(key)) key = $34e43db311a7ad8c$require$Buffer.from(key);
    if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $34e43db311a7ad8c$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$34e43db311a7ad8c$require$Buffer.isBuffer(iv)) iv = $34e43db311a7ad8c$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$34e43db311a7ad8c$var$DES.prototype._update = function(data) {
    return $34e43db311a7ad8c$require$Buffer.from(this._des.update(data));
};
$34e43db311a7ad8c$var$DES.prototype._final = function() {
    return $34e43db311a7ad8c$require$Buffer.from(this._des["final"]());
};

});
parcelRegister("L9lM1", function(module, exports) {

$parcel$export(module.exports, "DES", function () { return $08dba4a74bbedc70$export$cc8859615686b300; }, function (v) { return $08dba4a74bbedc70$export$cc8859615686b300 = v; });
$parcel$export(module.exports, "CBC", function () { return $08dba4a74bbedc70$export$8ad3f227af08fcc5; }, function (v) { return $08dba4a74bbedc70$export$8ad3f227af08fcc5 = v; });
$parcel$export(module.exports, "EDE", function () { return $08dba4a74bbedc70$export$947646e34766044f; }, function (v) { return $08dba4a74bbedc70$export$947646e34766044f = v; });
var $08dba4a74bbedc70$export$eab97d15b1788b8d;
var $08dba4a74bbedc70$export$26e5786e8ac8e530;
var $08dba4a74bbedc70$export$cc8859615686b300;
var $08dba4a74bbedc70$export$8ad3f227af08fcc5;
var $08dba4a74bbedc70$export$947646e34766044f;
'use strict';

$08dba4a74bbedc70$export$eab97d15b1788b8d = (parcelRequire("lPcr7"));

$08dba4a74bbedc70$export$26e5786e8ac8e530 = (parcelRequire("7jQ8q"));

$08dba4a74bbedc70$export$cc8859615686b300 = (parcelRequire("fjdmf"));

$08dba4a74bbedc70$export$8ad3f227af08fcc5 = (parcelRequire("5lvpb"));

$08dba4a74bbedc70$export$947646e34766044f = (parcelRequire("aPE6A"));

});
parcelRegister("lPcr7", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", function () { return $fe380206d8a9add6$export$cfaef8ed399428b0; }, function (v) { return $fe380206d8a9add6$export$cfaef8ed399428b0 = v; });
$parcel$export(module.exports, "writeUInt32BE", function () { return $fe380206d8a9add6$export$a80c7deaea7cbd80; }, function (v) { return $fe380206d8a9add6$export$a80c7deaea7cbd80 = v; });
$parcel$export(module.exports, "ip", function () { return $fe380206d8a9add6$export$ed7577ae6e1cd0ef; }, function (v) { return $fe380206d8a9add6$export$ed7577ae6e1cd0ef = v; });
$parcel$export(module.exports, "rip", function () { return $fe380206d8a9add6$export$5dcbef3aa594f567; }, function (v) { return $fe380206d8a9add6$export$5dcbef3aa594f567 = v; });
$parcel$export(module.exports, "pc1", function () { return $fe380206d8a9add6$export$5bc8001ca71ed9c5; }, function (v) { return $fe380206d8a9add6$export$5bc8001ca71ed9c5 = v; });
$parcel$export(module.exports, "r28shl", function () { return $fe380206d8a9add6$export$3e714e2c5d5d8cb2; }, function (v) { return $fe380206d8a9add6$export$3e714e2c5d5d8cb2 = v; });
$parcel$export(module.exports, "pc2", function () { return $fe380206d8a9add6$export$94c3e544fd062b7f; }, function (v) { return $fe380206d8a9add6$export$94c3e544fd062b7f = v; });
$parcel$export(module.exports, "expand", function () { return $fe380206d8a9add6$export$9f77e0932fb78f72; }, function (v) { return $fe380206d8a9add6$export$9f77e0932fb78f72 = v; });
$parcel$export(module.exports, "substitute", function () { return $fe380206d8a9add6$export$d865ce2836f5927f; }, function (v) { return $fe380206d8a9add6$export$d865ce2836f5927f = v; });
$parcel$export(module.exports, "permute", function () { return $fe380206d8a9add6$export$95e62ad65da8b7d2; }, function (v) { return $fe380206d8a9add6$export$95e62ad65da8b7d2 = v; });
$parcel$export(module.exports, "padSplit", function () { return $fe380206d8a9add6$export$209139ff098c441a; }, function (v) { return $fe380206d8a9add6$export$209139ff098c441a = v; });
var $fe380206d8a9add6$export$cfaef8ed399428b0;
var $fe380206d8a9add6$export$a80c7deaea7cbd80;
var $fe380206d8a9add6$export$ed7577ae6e1cd0ef;
var $fe380206d8a9add6$export$5dcbef3aa594f567;
var $fe380206d8a9add6$export$5bc8001ca71ed9c5;
var $fe380206d8a9add6$export$3e714e2c5d5d8cb2;
var $fe380206d8a9add6$export$94c3e544fd062b7f;
var $fe380206d8a9add6$export$9f77e0932fb78f72;
var $fe380206d8a9add6$export$d865ce2836f5927f;
var $fe380206d8a9add6$export$95e62ad65da8b7d2;
var $fe380206d8a9add6$export$209139ff098c441a;
'use strict';
$fe380206d8a9add6$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$fe380206d8a9add6$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$fe380206d8a9add6$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$fe380206d8a9add6$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$fe380206d8a9add6$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$fe380206d8a9add6$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $fe380206d8a9add6$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$fe380206d8a9add6$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $fe380206d8a9add6$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $fe380206d8a9add6$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $fe380206d8a9add6$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $fe380206d8a9add6$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$fe380206d8a9add6$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $fe380206d8a9add6$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$fe380206d8a9add6$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $fe380206d8a9add6$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $fe380206d8a9add6$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $fe380206d8a9add6$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$fe380206d8a9add6$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $fe380206d8a9add6$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $fe380206d8a9add6$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$fe380206d8a9add6$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = '0' + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(' ');
};

});

parcelRegister("7jQ8q", function(module, exports) {
'use strict';

var $3Pc6F = parcelRequire("3Pc6F");
function $5542bfadb8c15a31$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $5542bfadb8c15a31$var$Cipher;
$5542bfadb8c15a31$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$5542bfadb8c15a31$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === 'decrypt') return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$5542bfadb8c15a31$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$5542bfadb8c15a31$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$5542bfadb8c15a31$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$5542bfadb8c15a31$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$5542bfadb8c15a31$var$Cipher.prototype["final"] = function _final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === 'encrypt') last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$5542bfadb8c15a31$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$5542bfadb8c15a31$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$5542bfadb8c15a31$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$5542bfadb8c15a31$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $3Pc6F.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("3Pc6F", function(module, exports) {
module.exports = $2c8f86a5571d5b69$var$assert;
function $2c8f86a5571d5b69$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$2c8f86a5571d5b69$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});


parcelRegister("fjdmf", function(module, exports) {
'use strict';

var $3Pc6F = parcelRequire("3Pc6F");

var $6LbC4 = parcelRequire("6LbC4");

var $lPcr7 = parcelRequire("lPcr7");

var $7jQ8q = parcelRequire("7jQ8q");
function $b252fdf448fed7cf$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $b252fdf448fed7cf$var$DES(options) {
    $7jQ8q.call(this, options);
    var state = new $b252fdf448fed7cf$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$6LbC4($b252fdf448fed7cf$var$DES, $7jQ8q);
module.exports = $b252fdf448fed7cf$var$DES;
$b252fdf448fed7cf$var$DES.create = function create(options) {
    return new $b252fdf448fed7cf$var$DES(options);
};
var $b252fdf448fed7cf$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$b252fdf448fed7cf$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $3Pc6F.equal(key.length, this.blockSize, 'Invalid key length');
    var kL = $lPcr7.readUInt32BE(key, 0);
    var kR = $lPcr7.readUInt32BE(key, 4);
    $lPcr7.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $b252fdf448fed7cf$var$shiftTable[i >>> 1];
        kL = $lPcr7.r28shl(kL, shift);
        kR = $lPcr7.r28shl(kR, shift);
        $lPcr7.pc2(kL, kR, state.keys, i);
    }
};
$b252fdf448fed7cf$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $lPcr7.readUInt32BE(inp, inOff);
    var r = $lPcr7.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $lPcr7.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $lPcr7.writeUInt32BE(out, l, outOff);
    $lPcr7.writeUInt32BE(out, r, outOff + 4);
};
$b252fdf448fed7cf$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$b252fdf448fed7cf$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$3Pc6F.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$b252fdf448fed7cf$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $lPcr7.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $lPcr7.substitute(keyL, keyR);
        var f = $lPcr7.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $lPcr7.rip(r, l, out, off);
};
$b252fdf448fed7cf$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $lPcr7.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $lPcr7.substitute(keyL, keyR);
        var f = $lPcr7.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $lPcr7.rip(l, r, out, off);
};

});

parcelRegister("5lvpb", function(module, exports) {

$parcel$export(module.exports, "instantiate", function () { return $3e47465a6e7bec47$export$f9bb8d20ccc7477a; }, function (v) { return $3e47465a6e7bec47$export$f9bb8d20ccc7477a = v; });
var $3e47465a6e7bec47$export$f9bb8d20ccc7477a;
'use strict';

var $3Pc6F = parcelRequire("3Pc6F");

var $6LbC4 = parcelRequire("6LbC4");
var $3e47465a6e7bec47$var$proto = {};
function $3e47465a6e7bec47$var$CBCState(iv) {
    $3Pc6F.equal(iv.length, 8, 'Invalid IV length');
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $3e47465a6e7bec47$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $6LbC4(CBC, Base);
    var keys = Object.keys($3e47465a6e7bec47$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $3e47465a6e7bec47$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$3e47465a6e7bec47$export$f9bb8d20ccc7477a = $3e47465a6e7bec47$var$instantiate;
$3e47465a6e7bec47$var$proto._cbcInit = function _cbcInit() {
    var state = new $3e47465a6e7bec47$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$3e47465a6e7bec47$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === 'encrypt') {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("aPE6A", function(module, exports) {
'use strict';

var $3Pc6F = parcelRequire("3Pc6F");

var $6LbC4 = parcelRequire("6LbC4");

var $7jQ8q = parcelRequire("7jQ8q");

var $fjdmf = parcelRequire("fjdmf");
function $7e2dc6e3e6a02345$var$EDEState(type, key) {
    $3Pc6F.equal(key.length, 24, 'Invalid key length');
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === 'encrypt') this.ciphers = [
        $fjdmf.create({
            type: 'encrypt',
            key: k1
        }),
        $fjdmf.create({
            type: 'decrypt',
            key: k2
        }),
        $fjdmf.create({
            type: 'encrypt',
            key: k3
        })
    ];
    else this.ciphers = [
        $fjdmf.create({
            type: 'decrypt',
            key: k3
        }),
        $fjdmf.create({
            type: 'encrypt',
            key: k2
        }),
        $fjdmf.create({
            type: 'decrypt',
            key: k1
        })
    ];
}
function $7e2dc6e3e6a02345$var$EDE(options) {
    $7jQ8q.call(this, options);
    var state = new $7e2dc6e3e6a02345$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$6LbC4($7e2dc6e3e6a02345$var$EDE, $7jQ8q);
module.exports = $7e2dc6e3e6a02345$var$EDE;
$7e2dc6e3e6a02345$var$EDE.create = function create(options) {
    return new $7e2dc6e3e6a02345$var$EDE(options);
};
$7e2dc6e3e6a02345$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$7e2dc6e3e6a02345$var$EDE.prototype._pad = $fjdmf.prototype._pad;
$7e2dc6e3e6a02345$var$EDE.prototype._unpad = $fjdmf.prototype._unpad;

});



parcelRegister("8rjBu", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $62500d3bf72d1c96$export$2f64596b8cbf08b4; }, function (v) { return $62500d3bf72d1c96$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $62500d3bf72d1c96$export$36b6d6ef312eab39; }, function (v) { return $62500d3bf72d1c96$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $62500d3bf72d1c96$export$58a258485f1e49f6; }, function (v) { return $62500d3bf72d1c96$export$58a258485f1e49f6 = v; });
var $62500d3bf72d1c96$export$bdd223f16383713e;
var $62500d3bf72d1c96$export$26e5786e8ac8e530;
var $62500d3bf72d1c96$export$2f64596b8cbf08b4;
var $62500d3bf72d1c96$export$20533d26f07f1ee0;
var $62500d3bf72d1c96$export$12ada9414fbc594c;
var $62500d3bf72d1c96$export$2ce6d8d0e8b04e1a;
var $62500d3bf72d1c96$export$36b6d6ef312eab39;
var $62500d3bf72d1c96$export$f5e7e39d57cd9700;
var $62500d3bf72d1c96$export$dedd8dc3dc62b370;
var $62500d3bf72d1c96$export$58a258485f1e49f6;

var $fxFTI = parcelRequire("fxFTI");

var $72PQo = parcelRequire("72PQo");

var $lBaw5 = parcelRequire("lBaw5");
function $62500d3bf72d1c96$var$getCiphers() {
    return Object.keys($lBaw5);
}
$62500d3bf72d1c96$export$bdd223f16383713e = $62500d3bf72d1c96$export$26e5786e8ac8e530 = $fxFTI.createCipher;
$62500d3bf72d1c96$export$2f64596b8cbf08b4 = $62500d3bf72d1c96$export$20533d26f07f1ee0 = $fxFTI.createCipheriv;
$62500d3bf72d1c96$export$12ada9414fbc594c = $62500d3bf72d1c96$export$2ce6d8d0e8b04e1a = $72PQo.createDecipher;
$62500d3bf72d1c96$export$36b6d6ef312eab39 = $62500d3bf72d1c96$export$f5e7e39d57cd9700 = $72PQo.createDecipheriv;
$62500d3bf72d1c96$export$dedd8dc3dc62b370 = $62500d3bf72d1c96$export$58a258485f1e49f6 = $62500d3bf72d1c96$var$getCiphers;

});
parcelRegister("fxFTI", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $b50a701778434c0a$export$2f64596b8cbf08b4; }, function (v) { return $b50a701778434c0a$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createCipher", function () { return $b50a701778434c0a$export$bdd223f16383713e; }, function (v) { return $b50a701778434c0a$export$bdd223f16383713e = v; });
var $b50a701778434c0a$export$2f64596b8cbf08b4;
var $b50a701778434c0a$export$bdd223f16383713e;

var $hfooU = parcelRequire("hfooU");

var $WyLYE = parcelRequire("WyLYE");

var $5PcLP = parcelRequire("5PcLP");
var $b50a701778434c0a$require$Buffer = $5PcLP.Buffer;

var $59s8N = parcelRequire("59s8N");

var $db4vO = parcelRequire("db4vO");

var $8dORO = parcelRequire("8dORO");

var $dMYKX = parcelRequire("dMYKX");

var $6LbC4 = parcelRequire("6LbC4");
function $b50a701778434c0a$var$Cipher(mode, key, iv) {
    $db4vO.call(this);
    this._cache = new $b50a701778434c0a$var$Splitter();
    this._cipher = new $8dORO.AES(key);
    this._prev = $b50a701778434c0a$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$6LbC4($b50a701778434c0a$var$Cipher, $db4vO);
$b50a701778434c0a$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $b50a701778434c0a$require$Buffer.concat(out);
};
var $b50a701778434c0a$var$PADDING = $b50a701778434c0a$require$Buffer.alloc(16, 0x10);
$b50a701778434c0a$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($b50a701778434c0a$var$PADDING)) {
        this._cipher.scrub();
        throw new Error('data not multiple of block length');
    }
};
$b50a701778434c0a$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $b50a701778434c0a$var$Splitter() {
    this.cache = $b50a701778434c0a$require$Buffer.allocUnsafe(0);
}
$b50a701778434c0a$var$Splitter.prototype.add = function(data) {
    this.cache = $b50a701778434c0a$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$b50a701778434c0a$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$b50a701778434c0a$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $b50a701778434c0a$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $b50a701778434c0a$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $b50a701778434c0a$var$createCipheriv(suite, password, iv) {
    var config = $hfooU[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof password === 'string') password = $b50a701778434c0a$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (typeof iv === 'string') iv = $b50a701778434c0a$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (config.type === 'stream') return new $59s8N(config.module, password, iv);
    else if (config.type === 'auth') return new $WyLYE(config.module, password, iv);
    return new $b50a701778434c0a$var$Cipher(config.module, password, iv);
}
function $b50a701778434c0a$var$createCipher(suite, password) {
    var config = $hfooU[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $dMYKX(password, false, config.key, config.iv);
    return $b50a701778434c0a$var$createCipheriv(suite, keys.key, keys.iv);
}
$b50a701778434c0a$export$2f64596b8cbf08b4 = $b50a701778434c0a$var$createCipheriv;
$b50a701778434c0a$export$bdd223f16383713e = $b50a701778434c0a$var$createCipher;

});
parcelRegister("hfooU", function(module, exports) {








var $c8e6c3e1df54c9a8$var$modeModules = {
    ECB: (parcelRequire("5js33")),
    CBC: (parcelRequire("fIRnd")),
    CFB: (parcelRequire("gCLtc")),
    CFB8: (parcelRequire("l6baR")),
    CFB1: (parcelRequire("hiVBR")),
    OFB: (parcelRequire("6pmNF")),
    CTR: (parcelRequire("aBRn9")),
    GCM: (parcelRequire("aBRn9"))
};

var $lBaw5 = parcelRequire("lBaw5");
for(var $c8e6c3e1df54c9a8$var$key in $lBaw5)$lBaw5[$c8e6c3e1df54c9a8$var$key].module = $c8e6c3e1df54c9a8$var$modeModules[$lBaw5[$c8e6c3e1df54c9a8$var$key].mode];
module.exports = $lBaw5;

});
parcelRegister("5js33", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $3de47bea869dc66e$export$5b0f6292f11d1d18; }, function (v) { return $3de47bea869dc66e$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $3de47bea869dc66e$export$e85a0c9a1067c5d3; }, function (v) { return $3de47bea869dc66e$export$e85a0c9a1067c5d3 = v; });
var $3de47bea869dc66e$export$5b0f6292f11d1d18;
var $3de47bea869dc66e$export$e85a0c9a1067c5d3;
$3de47bea869dc66e$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$3de47bea869dc66e$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("fIRnd", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $b7245df363abcfec$export$5b0f6292f11d1d18; }, function (v) { return $b7245df363abcfec$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $b7245df363abcfec$export$e85a0c9a1067c5d3; }, function (v) { return $b7245df363abcfec$export$e85a0c9a1067c5d3 = v; });
var $b7245df363abcfec$export$5b0f6292f11d1d18;
var $b7245df363abcfec$export$e85a0c9a1067c5d3;

var $l0mG5 = parcelRequire("l0mG5");
$b7245df363abcfec$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $l0mG5(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$b7245df363abcfec$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $l0mG5(out, pad);
};

});
parcelRegister("l0mG5", function(module, exports) {

var $dSRbH = parcelRequire("dSRbH");
var $f4ab306bd5106f30$require$Buffer = $dSRbH.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $f4ab306bd5106f30$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("gCLtc", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $c1a5047d4729e991$export$5b0f6292f11d1d18; }, function (v) { return $c1a5047d4729e991$export$5b0f6292f11d1d18 = v; });
var $c1a5047d4729e991$export$5b0f6292f11d1d18;

var $5PcLP = parcelRequire("5PcLP");
var $c1a5047d4729e991$require$Buffer = $5PcLP.Buffer;

var $l0mG5 = parcelRequire("l0mG5");
function $c1a5047d4729e991$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $l0mG5(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $c1a5047d4729e991$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$c1a5047d4729e991$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $c1a5047d4729e991$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $c1a5047d4729e991$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $c1a5047d4729e991$require$Buffer.concat([
                out,
                $c1a5047d4729e991$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $c1a5047d4729e991$require$Buffer.concat([
                out,
                $c1a5047d4729e991$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("l6baR", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $f5c2d37df0252220$export$5b0f6292f11d1d18; }, function (v) { return $f5c2d37df0252220$export$5b0f6292f11d1d18 = v; });
var $f5c2d37df0252220$export$5b0f6292f11d1d18;

var $5PcLP = parcelRequire("5PcLP");
var $f5c2d37df0252220$require$Buffer = $5PcLP.Buffer;
function $f5c2d37df0252220$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $f5c2d37df0252220$require$Buffer.concat([
        self._prev.slice(1),
        $f5c2d37df0252220$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$f5c2d37df0252220$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $f5c2d37df0252220$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $f5c2d37df0252220$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("hiVBR", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $c990ce30769f773c$export$5b0f6292f11d1d18; }, function (v) { return $c990ce30769f773c$export$5b0f6292f11d1d18 = v; });
var $c990ce30769f773c$export$5b0f6292f11d1d18;

var $5PcLP = parcelRequire("5PcLP");
var $c990ce30769f773c$require$Buffer = $5PcLP.Buffer;
function $c990ce30769f773c$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $c990ce30769f773c$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $c990ce30769f773c$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $c990ce30769f773c$require$Buffer.allocUnsafe(buffer.length);
    buffer = $c990ce30769f773c$require$Buffer.concat([
        buffer,
        $c990ce30769f773c$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$c990ce30769f773c$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $c990ce30769f773c$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $c990ce30769f773c$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("6pmNF", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $4aa6c37ebcf5b252$export$5b0f6292f11d1d18; }, function (v) { return $4aa6c37ebcf5b252$export$5b0f6292f11d1d18 = v; });
var $4aa6c37ebcf5b252$export$5b0f6292f11d1d18;

var $dSRbH = parcelRequire("dSRbH");
var $4aa6c37ebcf5b252$require$Buffer = $dSRbH.Buffer;

var $l0mG5 = parcelRequire("l0mG5");
function $4aa6c37ebcf5b252$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$4aa6c37ebcf5b252$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $4aa6c37ebcf5b252$require$Buffer.concat([
        self._cache,
        $4aa6c37ebcf5b252$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $l0mG5(chunk, pad);
};

});

parcelRegister("aBRn9", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $7b96c2bb87920c5c$export$5b0f6292f11d1d18; }, function (v) { return $7b96c2bb87920c5c$export$5b0f6292f11d1d18 = v; });
var $7b96c2bb87920c5c$export$5b0f6292f11d1d18;

var $l0mG5 = parcelRequire("l0mG5");

var $5PcLP = parcelRequire("5PcLP");
var $7b96c2bb87920c5c$require$Buffer = $5PcLP.Buffer;

var $l0T4p = parcelRequire("l0T4p");
function $7b96c2bb87920c5c$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $l0T4p(self._prev);
    return out;
}
var $7b96c2bb87920c5c$var$blockSize = 16;
$7b96c2bb87920c5c$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $7b96c2bb87920c5c$var$blockSize);
    var start = self._cache.length;
    self._cache = $7b96c2bb87920c5c$require$Buffer.concat([
        self._cache,
        $7b96c2bb87920c5c$require$Buffer.allocUnsafe(chunkNum * $7b96c2bb87920c5c$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $7b96c2bb87920c5c$var$getBlock(self);
        var offset = start + i * $7b96c2bb87920c5c$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $l0mG5(chunk, pad);
};

});
parcelRegister("l0T4p", function(module, exports) {
function $f4c450da8cbce569$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $f4c450da8cbce569$var$incr32;

});


parcelRegister("lBaw5", function(module, exports) {
module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

});


parcelRegister("WyLYE", function(module, exports) {

var $8dORO = parcelRequire("8dORO");

var $5PcLP = parcelRequire("5PcLP");
var $0b00640dbd105773$require$Buffer = $5PcLP.Buffer;

var $db4vO = parcelRequire("db4vO");

var $6LbC4 = parcelRequire("6LbC4");

var $ePdwC = parcelRequire("ePdwC");

var $l0mG5 = parcelRequire("l0mG5");

var $l0T4p = parcelRequire("l0T4p");
function $0b00640dbd105773$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $0b00640dbd105773$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $0b00640dbd105773$require$Buffer.concat([
            iv,
            $0b00640dbd105773$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $0b00640dbd105773$require$Buffer.concat([
            iv,
            $0b00640dbd105773$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $ePdwC(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($0b00640dbd105773$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($0b00640dbd105773$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $0b00640dbd105773$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $0b00640dbd105773$require$Buffer.from(self._finID);
    $l0T4p(out);
    return out;
}
function $0b00640dbd105773$var$StreamCipher(mode, key, iv, decrypt) {
    $db4vO.call(this);
    var h = $0b00640dbd105773$require$Buffer.alloc(4, 0);
    this._cipher = new $8dORO.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $ePdwC(ck);
    iv = $0b00640dbd105773$var$calcIv(this, iv, ck);
    this._prev = $0b00640dbd105773$require$Buffer.from(iv);
    this._cache = $0b00640dbd105773$require$Buffer.allocUnsafe(0);
    this._secCache = $0b00640dbd105773$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$6LbC4($0b00640dbd105773$var$StreamCipher, $db4vO);
$0b00640dbd105773$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $0b00640dbd105773$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$0b00640dbd105773$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
    var tag = $l0mG5(this._ghash["final"](this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $0b00640dbd105773$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
    this._authTag = tag;
    this._cipher.scrub();
};
$0b00640dbd105773$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$0b00640dbd105773$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
    return this._authTag;
};
$0b00640dbd105773$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
    this._authTag = tag;
};
$0b00640dbd105773$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error('Attempting to set AAD in unsupported state');
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $0b00640dbd105773$var$StreamCipher;

});
parcelRegister("8dORO", function(module, exports) {

$parcel$export(module.exports, "AES", function () { return $5fc6febe232871d1$export$b80fbe1c3a2b92b5; }, function (v) { return $5fc6febe232871d1$export$b80fbe1c3a2b92b5 = v; });
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $5fc6febe232871d1$export$b80fbe1c3a2b92b5;

var $5PcLP = parcelRequire("5PcLP");
var $5fc6febe232871d1$require$Buffer = $5PcLP.Buffer;
function $5fc6febe232871d1$var$asUInt32Array(buf) {
    if (!$5fc6febe232871d1$require$Buffer.isBuffer(buf)) buf = $5fc6febe232871d1$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $5fc6febe232871d1$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $5fc6febe232871d1$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $5fc6febe232871d1$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $5fc6febe232871d1$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $5fc6febe232871d1$var$AES(key) {
    this._key = $5fc6febe232871d1$var$asUInt32Array(key);
    this._reset();
}
$5fc6febe232871d1$var$AES.blockSize = 16;
$5fc6febe232871d1$var$AES.keySize = 32;
$5fc6febe232871d1$var$AES.prototype.blockSize = $5fc6febe232871d1$var$AES.blockSize;
$5fc6febe232871d1$var$AES.prototype.keySize = $5fc6febe232871d1$var$AES.keySize;
$5fc6febe232871d1$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $5fc6febe232871d1$var$G.SBOX[t >>> 24] << 24 | $5fc6febe232871d1$var$G.SBOX[t >>> 16 & 0xff] << 16 | $5fc6febe232871d1$var$G.SBOX[t >>> 8 & 0xff] << 8 | $5fc6febe232871d1$var$G.SBOX[t & 0xff];
            t ^= $5fc6febe232871d1$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $5fc6febe232871d1$var$G.SBOX[t >>> 24] << 24 | $5fc6febe232871d1$var$G.SBOX[t >>> 16 & 0xff] << 16 | $5fc6febe232871d1$var$G.SBOX[t >>> 8 & 0xff] << 8 | $5fc6febe232871d1$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $5fc6febe232871d1$var$G.INV_SUB_MIX[0][$5fc6febe232871d1$var$G.SBOX[tt >>> 24]] ^ $5fc6febe232871d1$var$G.INV_SUB_MIX[1][$5fc6febe232871d1$var$G.SBOX[tt >>> 16 & 0xff]] ^ $5fc6febe232871d1$var$G.INV_SUB_MIX[2][$5fc6febe232871d1$var$G.SBOX[tt >>> 8 & 0xff]] ^ $5fc6febe232871d1$var$G.INV_SUB_MIX[3][$5fc6febe232871d1$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$5fc6febe232871d1$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $5fc6febe232871d1$var$asUInt32Array(M);
    return $5fc6febe232871d1$var$cryptBlock(M, this._keySchedule, $5fc6febe232871d1$var$G.SUB_MIX, $5fc6febe232871d1$var$G.SBOX, this._nRounds);
};
$5fc6febe232871d1$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $5fc6febe232871d1$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$5fc6febe232871d1$var$AES.prototype.decryptBlock = function(M) {
    M = $5fc6febe232871d1$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $5fc6febe232871d1$var$cryptBlock(M, this._invKeySchedule, $5fc6febe232871d1$var$G.INV_SUB_MIX, $5fc6febe232871d1$var$G.INV_SBOX, this._nRounds);
    var buf = $5fc6febe232871d1$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$5fc6febe232871d1$var$AES.prototype.scrub = function() {
    $5fc6febe232871d1$var$scrubVec(this._keySchedule);
    $5fc6febe232871d1$var$scrubVec(this._invKeySchedule);
    $5fc6febe232871d1$var$scrubVec(this._key);
};
$5fc6febe232871d1$export$b80fbe1c3a2b92b5 = $5fc6febe232871d1$var$AES;

});

parcelRegister("ePdwC", function(module, exports) {

var $5PcLP = parcelRequire("5PcLP");
var $acb051eff6200d71$require$Buffer = $5PcLP.Buffer;
var $acb051eff6200d71$var$ZEROES = $acb051eff6200d71$require$Buffer.alloc(16, 0);
function $acb051eff6200d71$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $acb051eff6200d71$var$fromArray(out) {
    var buf = $acb051eff6200d71$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $acb051eff6200d71$var$GHASH(key) {
    this.h = key;
    this.state = $acb051eff6200d71$require$Buffer.alloc(16, 0);
    this.cache = $acb051eff6200d71$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$acb051eff6200d71$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$acb051eff6200d71$var$GHASH.prototype._multiply = function() {
    var Vi = $acb051eff6200d71$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $acb051eff6200d71$var$fromArray(Zi);
};
$acb051eff6200d71$var$GHASH.prototype.update = function(buf) {
    this.cache = $acb051eff6200d71$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$acb051eff6200d71$var$GHASH.prototype["final"] = function(abl, bl) {
    if (this.cache.length) this.ghash($acb051eff6200d71$require$Buffer.concat([
        this.cache,
        $acb051eff6200d71$var$ZEROES
    ], 16));
    this.ghash($acb051eff6200d71$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $acb051eff6200d71$var$GHASH;

});


parcelRegister("59s8N", function(module, exports) {

var $8dORO = parcelRequire("8dORO");

var $5PcLP = parcelRequire("5PcLP");
var $3c039f35e39b2810$require$Buffer = $5PcLP.Buffer;

var $db4vO = parcelRequire("db4vO");

var $6LbC4 = parcelRequire("6LbC4");
function $3c039f35e39b2810$var$StreamCipher(mode, key, iv, decrypt) {
    $db4vO.call(this);
    this._cipher = new $8dORO.AES(key);
    this._prev = $3c039f35e39b2810$require$Buffer.from(iv);
    this._cache = $3c039f35e39b2810$require$Buffer.allocUnsafe(0);
    this._secCache = $3c039f35e39b2810$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$6LbC4($3c039f35e39b2810$var$StreamCipher, $db4vO);
$3c039f35e39b2810$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$3c039f35e39b2810$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $3c039f35e39b2810$var$StreamCipher;

});

parcelRegister("dMYKX", function(module, exports) {

var $5PcLP = parcelRequire("5PcLP");
var $a09ee30053727857$require$Buffer = $5PcLP.Buffer;

var $dS5XU = parcelRequire("dS5XU");
/* eslint-disable camelcase */ function $a09ee30053727857$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$a09ee30053727857$require$Buffer.isBuffer(password)) password = $a09ee30053727857$require$Buffer.from(password, 'binary');
    if (salt) {
        if (!$a09ee30053727857$require$Buffer.isBuffer(salt)) salt = $a09ee30053727857$require$Buffer.from(salt, 'binary');
        if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
    }
    var keyLen = keyBits / 8;
    var key = $a09ee30053727857$require$Buffer.alloc(keyLen);
    var iv = $a09ee30053727857$require$Buffer.alloc(ivLen || 0);
    var tmp = $a09ee30053727857$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $dS5XU();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $a09ee30053727857$var$EVP_BytesToKey;

});


parcelRegister("72PQo", function(module, exports) {

$parcel$export(module.exports, "createDecipher", function () { return $5210ef79ed15890a$export$12ada9414fbc594c; }, function (v) { return $5210ef79ed15890a$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $5210ef79ed15890a$export$36b6d6ef312eab39; }, function (v) { return $5210ef79ed15890a$export$36b6d6ef312eab39 = v; });
var $5210ef79ed15890a$export$12ada9414fbc594c;
var $5210ef79ed15890a$export$36b6d6ef312eab39;

var $WyLYE = parcelRequire("WyLYE");

var $5PcLP = parcelRequire("5PcLP");
var $5210ef79ed15890a$require$Buffer = $5PcLP.Buffer;

var $hfooU = parcelRequire("hfooU");

var $59s8N = parcelRequire("59s8N");

var $db4vO = parcelRequire("db4vO");

var $8dORO = parcelRequire("8dORO");

var $dMYKX = parcelRequire("dMYKX");

var $6LbC4 = parcelRequire("6LbC4");
function $5210ef79ed15890a$var$Decipher(mode, key, iv) {
    $db4vO.call(this);
    this._cache = new $5210ef79ed15890a$var$Splitter();
    this._last = void 0;
    this._cipher = new $8dORO.AES(key);
    this._prev = $5210ef79ed15890a$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$6LbC4($5210ef79ed15890a$var$Decipher, $db4vO);
$5210ef79ed15890a$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $5210ef79ed15890a$require$Buffer.concat(out);
};
$5210ef79ed15890a$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $5210ef79ed15890a$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error('data not multiple of block length');
};
$5210ef79ed15890a$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $5210ef79ed15890a$var$Splitter() {
    this.cache = $5210ef79ed15890a$require$Buffer.allocUnsafe(0);
}
$5210ef79ed15890a$var$Splitter.prototype.add = function(data) {
    this.cache = $5210ef79ed15890a$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$5210ef79ed15890a$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$5210ef79ed15890a$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $5210ef79ed15890a$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error('unable to decrypt data');
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $5210ef79ed15890a$var$createDecipheriv(suite, password, iv) {
    var config = $hfooU[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof iv === 'string') iv = $5210ef79ed15890a$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (typeof password === 'string') password = $5210ef79ed15890a$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (config.type === 'stream') return new $59s8N(config.module, password, iv, true);
    else if (config.type === 'auth') return new $WyLYE(config.module, password, iv, true);
    return new $5210ef79ed15890a$var$Decipher(config.module, password, iv);
}
function $5210ef79ed15890a$var$createDecipher(suite, password) {
    var config = $hfooU[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $dMYKX(password, false, config.key, config.iv);
    return $5210ef79ed15890a$var$createDecipheriv(suite, keys.key, keys.iv);
}
$5210ef79ed15890a$export$12ada9414fbc594c = $5210ef79ed15890a$var$createDecipher;
$5210ef79ed15890a$export$36b6d6ef312eab39 = $5210ef79ed15890a$var$createDecipheriv;

});


parcelRegister("fFXoC", function(module, exports) {

$parcel$export(module.exports, "des-ecb", function () { return $b698c227fae81e85$export$116f8a5cee447347; }, function (v) { return $b698c227fae81e85$export$116f8a5cee447347 = v; });
$parcel$export(module.exports, "des-cbc", function () { return $b698c227fae81e85$export$7483c4066bfb7ae9; }, function (v) { return $b698c227fae81e85$export$7483c4066bfb7ae9 = v; });
$parcel$export(module.exports, "des", function () { return $b698c227fae81e85$export$e7a565d2e588bb06; }, function (v) { return $b698c227fae81e85$export$e7a565d2e588bb06 = v; });
$parcel$export(module.exports, "des-ede3-cbc", function () { return $b698c227fae81e85$export$aaa2f54a426f3eb8; }, function (v) { return $b698c227fae81e85$export$aaa2f54a426f3eb8 = v; });
$parcel$export(module.exports, "des3", function () { return $b698c227fae81e85$export$eba20568dde4ada; }, function (v) { return $b698c227fae81e85$export$eba20568dde4ada = v; });
$parcel$export(module.exports, "des-ede3", function () { return $b698c227fae81e85$export$d3b5e5996938f5ae; }, function (v) { return $b698c227fae81e85$export$d3b5e5996938f5ae = v; });
$parcel$export(module.exports, "des-ede-cbc", function () { return $b698c227fae81e85$export$57c08356130bc99b; }, function (v) { return $b698c227fae81e85$export$57c08356130bc99b = v; });
$parcel$export(module.exports, "des-ede", function () { return $b698c227fae81e85$export$c7169791d5c1e65d; }, function (v) { return $b698c227fae81e85$export$c7169791d5c1e65d = v; });
var $b698c227fae81e85$export$116f8a5cee447347;
var $b698c227fae81e85$export$7483c4066bfb7ae9;
var $b698c227fae81e85$export$e7a565d2e588bb06;
var $b698c227fae81e85$export$aaa2f54a426f3eb8;
var $b698c227fae81e85$export$eba20568dde4ada;
var $b698c227fae81e85$export$d3b5e5996938f5ae;
var $b698c227fae81e85$export$57c08356130bc99b;
var $b698c227fae81e85$export$c7169791d5c1e65d;
$b698c227fae81e85$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$b698c227fae81e85$export$7483c4066bfb7ae9 = $b698c227fae81e85$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$b698c227fae81e85$export$aaa2f54a426f3eb8 = $b698c227fae81e85$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$b698c227fae81e85$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$b698c227fae81e85$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$b698c227fae81e85$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRegister("eH94P", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", function () { return $ab2c1f5363663169$export$971862a2fcb1bb40; }, function (v) { return $ab2c1f5363663169$export$971862a2fcb1bb40 = v; });
$parcel$export(module.exports, "createDiffieHellmanGroup", function () { return $ab2c1f5363663169$export$c6ff6a88acbeaf40; }, function (v) { return $ab2c1f5363663169$export$c6ff6a88acbeaf40 = v; });
$parcel$export(module.exports, "getDiffieHellman", function () { return $ab2c1f5363663169$export$fdc27893e98845cc; }, function (v) { return $ab2c1f5363663169$export$fdc27893e98845cc = v; });
$parcel$export(module.exports, "createDiffieHellman", function () { return $ab2c1f5363663169$export$6671fb9a1323bed; }, function (v) { return $ab2c1f5363663169$export$6671fb9a1323bed = v; });
$parcel$export(module.exports, "DiffieHellman", function () { return $ab2c1f5363663169$export$d74daf141a551db; }, function (v) { return $ab2c1f5363663169$export$d74daf141a551db = v; });
var $ab2c1f5363663169$export$971862a2fcb1bb40;
var $ab2c1f5363663169$export$c6ff6a88acbeaf40;
var $ab2c1f5363663169$export$fdc27893e98845cc;
var $ab2c1f5363663169$export$6671fb9a1323bed;
var $ab2c1f5363663169$export$d74daf141a551db;

var $dSRbH = parcelRequire("dSRbH");
var $ab2c1f5363663169$require$Buffer = $dSRbH.Buffer;

var $h18Wo = parcelRequire("h18Wo");

var $W8JuS = parcelRequire("W8JuS");

var $kQk30 = parcelRequire("kQk30");
function $ab2c1f5363663169$var$getDiffieHellman(mod) {
    var prime = new $ab2c1f5363663169$require$Buffer($W8JuS[mod].prime, 'hex');
    var gen = new $ab2c1f5363663169$require$Buffer($W8JuS[mod].gen, 'hex');
    return new $kQk30(prime, gen);
}
var $ab2c1f5363663169$var$ENCODINGS = {
    binary: true,
    hex: true,
    base64: true
};
function $ab2c1f5363663169$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($ab2c1f5363663169$require$Buffer.isBuffer(enc) || $ab2c1f5363663169$var$ENCODINGS[enc] === undefined) return $ab2c1f5363663169$var$createDiffieHellman(prime, 'binary', enc, generator);
    enc = enc || 'binary';
    genc = genc || 'binary';
    generator = generator || new $ab2c1f5363663169$require$Buffer([
        2
    ]);
    if (!$ab2c1f5363663169$require$Buffer.isBuffer(generator)) generator = new $ab2c1f5363663169$require$Buffer(generator, genc);
    if (typeof prime === 'number') return new $kQk30($h18Wo(prime, generator), generator, true);
    if (!$ab2c1f5363663169$require$Buffer.isBuffer(prime)) prime = new $ab2c1f5363663169$require$Buffer(prime, enc);
    return new $kQk30(prime, generator, true);
}
$ab2c1f5363663169$export$971862a2fcb1bb40 = $ab2c1f5363663169$export$c6ff6a88acbeaf40 = $ab2c1f5363663169$export$fdc27893e98845cc = $ab2c1f5363663169$var$getDiffieHellman;
$ab2c1f5363663169$export$6671fb9a1323bed = $ab2c1f5363663169$export$d74daf141a551db = $ab2c1f5363663169$var$createDiffieHellman;

});
parcelRegister("h18Wo", function(module, exports) {

var $cCNIN = parcelRequire("cCNIN");
module.exports = $c63977266799ed2e$var$findPrime;
$c63977266799ed2e$var$findPrime.simpleSieve = $c63977266799ed2e$var$simpleSieve;
$c63977266799ed2e$var$findPrime.fermatTest = $c63977266799ed2e$var$fermatTest;

var $jqr9W = parcelRequire("jqr9W");
var $c63977266799ed2e$var$TWENTYFOUR = new $jqr9W(24);

var $GvI16 = parcelRequire("GvI16");
var $c63977266799ed2e$var$millerRabin = new $GvI16();
var $c63977266799ed2e$var$ONE = new $jqr9W(1);
var $c63977266799ed2e$var$TWO = new $jqr9W(2);
var $c63977266799ed2e$var$FIVE = new $jqr9W(5);
var $c63977266799ed2e$var$SIXTEEN = new $jqr9W(16);
var $c63977266799ed2e$var$EIGHT = new $jqr9W(8);
var $c63977266799ed2e$var$TEN = new $jqr9W(10);
var $c63977266799ed2e$var$THREE = new $jqr9W(3);
var $c63977266799ed2e$var$SEVEN = new $jqr9W(7);
var $c63977266799ed2e$var$ELEVEN = new $jqr9W(11);
var $c63977266799ed2e$var$FOUR = new $jqr9W(4);
var $c63977266799ed2e$var$TWELVE = new $jqr9W(12);
var $c63977266799ed2e$var$primes = null;
function $c63977266799ed2e$var$_getPrimes() {
    if ($c63977266799ed2e$var$primes !== null) return $c63977266799ed2e$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $c63977266799ed2e$var$primes = res;
    return res;
}
function $c63977266799ed2e$var$simpleSieve(p) {
    var primes = $c63977266799ed2e$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $c63977266799ed2e$var$fermatTest(p) {
    var red = $jqr9W.mont(p);
    return $c63977266799ed2e$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $c63977266799ed2e$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $jqr9W([
            0x8c,
            0x7b
        ]);
        else return new $jqr9W([
            0x8c,
            0x27
        ]);
    }
    gen = new $jqr9W(gen);
    var num, n2;
    while(true){
        num = new $jqr9W($cCNIN(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($c63977266799ed2e$var$ONE);
        if (!num.testn(1)) num.iadd($c63977266799ed2e$var$TWO);
        if (!gen.cmp($c63977266799ed2e$var$TWO)) while(num.mod($c63977266799ed2e$var$TWENTYFOUR).cmp($c63977266799ed2e$var$ELEVEN))num.iadd($c63977266799ed2e$var$FOUR);
        else if (!gen.cmp($c63977266799ed2e$var$FIVE)) while(num.mod($c63977266799ed2e$var$TEN).cmp($c63977266799ed2e$var$THREE))num.iadd($c63977266799ed2e$var$FOUR);
        n2 = num.shrn(1);
        if ($c63977266799ed2e$var$simpleSieve(n2) && $c63977266799ed2e$var$simpleSieve(num) && $c63977266799ed2e$var$fermatTest(n2) && $c63977266799ed2e$var$fermatTest(num) && $c63977266799ed2e$var$millerRabin.test(n2) && $c63977266799ed2e$var$millerRabin.test(num)) return num;
    }
}

});
parcelRegister("jqr9W", function(module, exports) {

var $qb7pP = parcelRequire("qb7pP");

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if ((typeof module1 === "undefined" ? "undefined" : (0, $qb7pP._)(module1)) === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("iczbQ")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && (typeof num === "undefined" ? "undefined" : (0, $qb7pP._)(num)) === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if ((typeof number === "undefined" ? "undefined" : (0, $qb7pP._)(number)) === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, undefined);

});

parcelRegister("GvI16", function(module, exports) {

var $5WbdK = parcelRequire("5WbdK");

var $5oleY = parcelRequire("5oleY");
function $07fc85186c0490ca$var$MillerRabin(rand) {
    this.rand = rand || new $5oleY.Rand();
}
module.exports = $07fc85186c0490ca$var$MillerRabin;
$07fc85186c0490ca$var$MillerRabin.create = function create(rand) {
    return new $07fc85186c0490ca$var$MillerRabin(rand);
};
$07fc85186c0490ca$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $5WbdK(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$07fc85186c0490ca$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$07fc85186c0490ca$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $5WbdK.mont(n);
    var rone = new $5WbdK(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $5WbdK(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$07fc85186c0490ca$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $5WbdK.mont(n);
    var rone = new $5WbdK(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $5WbdK(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRegister("5WbdK", function(module, exports) {

var $qb7pP = parcelRequire("qb7pP");

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if ((typeof module1 === "undefined" ? "undefined" : (0, $qb7pP._)(module1)) === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("iczbQ")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && (typeof num === "undefined" ? "undefined" : (0, $qb7pP._)(num)) === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if ((typeof number === "undefined" ? "undefined" : (0, $qb7pP._)(number)) === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, undefined);

});

parcelRegister("5oleY", function(module, exports) {

var $qb7pP = parcelRequire("qb7pP");
var $3ecfab932233525f$var$r;
module.exports = function rand(len) {
    if (!$3ecfab932233525f$var$r) $3ecfab932233525f$var$r = new $3ecfab932233525f$var$Rand(null);
    return $3ecfab932233525f$var$r.generate(len);
};
function $3ecfab932233525f$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $3ecfab932233525f$var$Rand;
$3ecfab932233525f$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$3ecfab932233525f$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if ((typeof self === "undefined" ? "undefined" : (0, $qb7pP._)(self)) === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $3ecfab932233525f$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $3ecfab932233525f$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if ((typeof window === "undefined" ? "undefined" : (0, $qb7pP._)(window)) === 'object') // Old junk
    $3ecfab932233525f$var$Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var $3ecfab932233525f$var$crypto = (parcelRequire("iczbQ"));
    if (typeof $3ecfab932233525f$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
    $3ecfab932233525f$var$Rand.prototype._rand = function _rand(n) {
        return $3ecfab932233525f$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRegister("W8JuS", function(module, exports) {
module.exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");

});

parcelRegister("kQk30", function(module, exports) {

var $dSRbH = parcelRequire("dSRbH");
var $f2c836fd2ac916dd$require$Buffer = $dSRbH.Buffer;

var $jqr9W = parcelRequire("jqr9W");

var $GvI16 = parcelRequire("GvI16");
var $f2c836fd2ac916dd$var$millerRabin = new $GvI16();
var $f2c836fd2ac916dd$var$TWENTYFOUR = new $jqr9W(24);
var $f2c836fd2ac916dd$var$ELEVEN = new $jqr9W(11);
var $f2c836fd2ac916dd$var$TEN = new $jqr9W(10);
var $f2c836fd2ac916dd$var$THREE = new $jqr9W(3);
var $f2c836fd2ac916dd$var$SEVEN = new $jqr9W(7);

var $h18Wo = parcelRequire("h18Wo");

var $cCNIN = parcelRequire("cCNIN");
module.exports = $f2c836fd2ac916dd$var$DH;
function $f2c836fd2ac916dd$var$setPublicKey(pub, enc) {
    enc = enc || 'utf8';
    if (!$f2c836fd2ac916dd$require$Buffer.isBuffer(pub)) pub = new $f2c836fd2ac916dd$require$Buffer(pub, enc);
    this._pub = new $jqr9W(pub);
    return this;
}
function $f2c836fd2ac916dd$var$setPrivateKey(priv, enc) {
    enc = enc || 'utf8';
    if (!$f2c836fd2ac916dd$require$Buffer.isBuffer(priv)) priv = new $f2c836fd2ac916dd$require$Buffer(priv, enc);
    this._priv = new $jqr9W(priv);
    return this;
}
var $f2c836fd2ac916dd$var$primeCache = {};
function $f2c836fd2ac916dd$var$checkPrime(prime, generator) {
    var gen = generator.toString('hex');
    var hex = [
        gen,
        prime.toString(16)
    ].join('_');
    if (hex in $f2c836fd2ac916dd$var$primeCache) return $f2c836fd2ac916dd$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$h18Wo.simpleSieve || !$h18Wo.fermatTest(prime) || !$f2c836fd2ac916dd$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === '02' || gen === '05') // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $f2c836fd2ac916dd$var$primeCache[hex] = error;
        return error;
    }
    if (!$f2c836fd2ac916dd$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case '02':
            if (prime.mod($f2c836fd2ac916dd$var$TWENTYFOUR).cmp($f2c836fd2ac916dd$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case '05':
            rem = prime.mod($f2c836fd2ac916dd$var$TEN);
            if (rem.cmp($f2c836fd2ac916dd$var$THREE) && rem.cmp($f2c836fd2ac916dd$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $f2c836fd2ac916dd$var$primeCache[hex] = error;
    return error;
}
function $f2c836fd2ac916dd$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $jqr9W(prime);
    this._prime = $jqr9W.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $f2c836fd2ac916dd$var$setPublicKey;
        this.setPrivateKey = $f2c836fd2ac916dd$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($f2c836fd2ac916dd$var$DH.prototype, 'verifyError', {
    enumerable: true,
    get: function get() {
        if (typeof this._primeCode !== 'number') this._primeCode = $f2c836fd2ac916dd$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$f2c836fd2ac916dd$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $jqr9W($cCNIN(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$f2c836fd2ac916dd$var$DH.prototype.computeSecret = function(other) {
    other = new $jqr9W(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $f2c836fd2ac916dd$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $f2c836fd2ac916dd$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $f2c836fd2ac916dd$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$f2c836fd2ac916dd$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $f2c836fd2ac916dd$var$formatReturnValue(this._pub, enc);
};
$f2c836fd2ac916dd$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $f2c836fd2ac916dd$var$formatReturnValue(this._priv, enc);
};
$f2c836fd2ac916dd$var$DH.prototype.getPrime = function(enc) {
    return $f2c836fd2ac916dd$var$formatReturnValue(this.__prime, enc);
};
$f2c836fd2ac916dd$var$DH.prototype.getGenerator = function(enc) {
    return $f2c836fd2ac916dd$var$formatReturnValue(this._gen, enc);
};
$f2c836fd2ac916dd$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || 'utf8';
    if (!$f2c836fd2ac916dd$require$Buffer.isBuffer(gen)) gen = new $f2c836fd2ac916dd$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $jqr9W(gen);
    return this;
};
function $f2c836fd2ac916dd$var$formatReturnValue(bn, enc) {
    var buf = new $f2c836fd2ac916dd$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRegister("6u9dE", function(module, exports) {
'use strict';

var $5PcLP = parcelRequire("5PcLP");
var $4b8cb223716ca011$require$Buffer = $5PcLP.Buffer;

var $hBj6e = parcelRequire("hBj6e");

var $lgoYC = parcelRequire("lgoYC");

var $6LbC4 = parcelRequire("6LbC4");

var $6F8jU = parcelRequire("6F8jU");

var $jUSkB = parcelRequire("jUSkB");

var $ahOFM = parcelRequire("ahOFM");
Object.keys($ahOFM).forEach(function(key) {
    $ahOFM[key].id = $4b8cb223716ca011$require$Buffer.from($ahOFM[key].id, 'hex');
    $ahOFM[key.toLowerCase()] = $ahOFM[key];
});
function $4b8cb223716ca011$var$Sign(algorithm) {
    $lgoYC.Writable.call(this);
    var data = $ahOFM[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hashType = data.hash;
    this._hash = $hBj6e(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$6LbC4($4b8cb223716ca011$var$Sign, $lgoYC.Writable);
$4b8cb223716ca011$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$4b8cb223716ca011$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $4b8cb223716ca011$require$Buffer.from(data, enc) : data);
    return this;
};
$4b8cb223716ca011$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $6F8jU(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $4b8cb223716ca011$var$Verify(algorithm) {
    $lgoYC.Writable.call(this);
    var data = $ahOFM[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hash = $hBj6e(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$6LbC4($4b8cb223716ca011$var$Verify, $lgoYC.Writable);
$4b8cb223716ca011$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$4b8cb223716ca011$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $4b8cb223716ca011$require$Buffer.from(data, enc) : data);
    return this;
};
$4b8cb223716ca011$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === 'string' ? $4b8cb223716ca011$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $jUSkB(sigBuffer, hash, key, this._signType, this._tag);
};
function $4b8cb223716ca011$var$createSign(algorithm) {
    return new $4b8cb223716ca011$var$Sign(algorithm);
}
function $4b8cb223716ca011$var$createVerify(algorithm) {
    return new $4b8cb223716ca011$var$Verify(algorithm);
}
module.exports = {
    Sign: $4b8cb223716ca011$var$createSign,
    Verify: $4b8cb223716ca011$var$createVerify,
    createSign: $4b8cb223716ca011$var$createSign,
    createVerify: $4b8cb223716ca011$var$createVerify
};

});
parcelRegister("lgoYC", function(module, exports) {

exports = module.exports = (parcelRequire("dvwm4"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("hNefa"));

exports.Duplex = (parcelRequire("7NKt6"));

exports.Transform = (parcelRequire("2XUUu"));

exports.PassThrough = (parcelRequire("iQBai"));

});
parcelRegister("dvwm4", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $ffICS = parcelRequire("ffICS");
'use strict';

var $4e76d = parcelRequire("4e76d");
/*</replacement>*/ module.exports = $9d5744a040e6bf17$var$Readable;

var $4vdXq = parcelRequire("4vdXq");
/*</replacement>*/ /*<replacement>*/ var $9d5744a040e6bf17$var$Duplex;
/*</replacement>*/ $9d5744a040e6bf17$var$Readable.ReadableState = $9d5744a040e6bf17$var$ReadableState;

var $6zVuT = parcelRequire("6zVuT");
var $9d5744a040e6bf17$require$EE = $6zVuT.EventEmitter;
var $9d5744a040e6bf17$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $9PThW = parcelRequire("9PThW");

var $fRDMy = parcelRequire("fRDMy");
var $9d5744a040e6bf17$require$Buffer = $fRDMy.Buffer;
var $9d5744a040e6bf17$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $9d5744a040e6bf17$var$_uint8ArrayToBuffer(chunk) {
    return $9d5744a040e6bf17$require$Buffer.from(chunk);
}
function $9d5744a040e6bf17$var$_isUint8Array(obj) {
    return $9d5744a040e6bf17$require$Buffer.isBuffer(obj) || obj instanceof $9d5744a040e6bf17$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $9d5744a040e6bf17$var$util = Object.create((parcelRequire("crVmE")));

$9d5744a040e6bf17$var$util.inherits = (parcelRequire("6LbC4"));

var $iczbQ = parcelRequire("iczbQ");
var $9d5744a040e6bf17$var$debug = void 0;
if ($iczbQ && $iczbQ.debuglog) $9d5744a040e6bf17$var$debug = $iczbQ.debuglog('stream');
else $9d5744a040e6bf17$var$debug = function debug() {};

var $M01ev = parcelRequire("M01ev");

var $iox1P = parcelRequire("iox1P");
var $9d5744a040e6bf17$var$StringDecoder;
$9d5744a040e6bf17$var$util.inherits($9d5744a040e6bf17$var$Readable, $9PThW);
var $9d5744a040e6bf17$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $9d5744a040e6bf17$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($4vdXq(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $9d5744a040e6bf17$var$ReadableState(options, stream) {
    $9d5744a040e6bf17$var$Duplex = $9d5744a040e6bf17$var$Duplex || (parcelRequire("7NKt6"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $9d5744a040e6bf17$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $M01ev();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$9d5744a040e6bf17$var$StringDecoder) $9d5744a040e6bf17$var$StringDecoder = (parcelRequire("a26EP")).StringDecoder;
        this.decoder = new $9d5744a040e6bf17$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $9d5744a040e6bf17$var$Readable(options) {
    $9d5744a040e6bf17$var$Duplex = $9d5744a040e6bf17$var$Duplex || (parcelRequire("7NKt6"));
    if (!(this instanceof $9d5744a040e6bf17$var$Readable)) return new $9d5744a040e6bf17$var$Readable(options);
    this._readableState = new $9d5744a040e6bf17$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $9PThW.call(this);
}
Object.defineProperty($9d5744a040e6bf17$var$Readable.prototype, 'destroyed', {
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$9d5744a040e6bf17$var$Readable.prototype.destroy = $iox1P.destroy;
$9d5744a040e6bf17$var$Readable.prototype._undestroy = $iox1P.undestroy;
$9d5744a040e6bf17$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$9d5744a040e6bf17$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $9d5744a040e6bf17$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $9d5744a040e6bf17$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$9d5744a040e6bf17$var$Readable.prototype.unshift = function(chunk) {
    return $9d5744a040e6bf17$var$readableAddChunk(this, chunk, null, true, false);
};
function $9d5744a040e6bf17$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $9d5744a040e6bf17$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $9d5744a040e6bf17$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $9d5744a040e6bf17$require$Buffer.prototype) chunk = $9d5744a040e6bf17$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $9d5744a040e6bf17$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $9d5744a040e6bf17$var$addChunk(stream, state, chunk, false);
                    else $9d5744a040e6bf17$var$maybeReadMore(stream, state);
                } else $9d5744a040e6bf17$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $9d5744a040e6bf17$var$needMoreData(state);
}
function $9d5744a040e6bf17$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $9d5744a040e6bf17$var$emitReadable(stream);
    }
    $9d5744a040e6bf17$var$maybeReadMore(stream, state);
}
function $9d5744a040e6bf17$var$chunkInvalid(state, chunk) {
    var er;
    if (!$9d5744a040e6bf17$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $9d5744a040e6bf17$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$9d5744a040e6bf17$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$9d5744a040e6bf17$var$Readable.prototype.setEncoding = function(enc) {
    if (!$9d5744a040e6bf17$var$StringDecoder) $9d5744a040e6bf17$var$StringDecoder = (parcelRequire("a26EP")).StringDecoder;
    this._readableState.decoder = new $9d5744a040e6bf17$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $9d5744a040e6bf17$var$MAX_HWM = 0x800000;
function $9d5744a040e6bf17$var$computeNewHighWaterMark(n) {
    if (n >= $9d5744a040e6bf17$var$MAX_HWM) n = $9d5744a040e6bf17$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9d5744a040e6bf17$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $9d5744a040e6bf17$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$9d5744a040e6bf17$var$Readable.prototype.read = function(n) {
    $9d5744a040e6bf17$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $9d5744a040e6bf17$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $9d5744a040e6bf17$var$endReadable(this);
        else $9d5744a040e6bf17$var$emitReadable(this);
        return null;
    }
    n = $9d5744a040e6bf17$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $9d5744a040e6bf17$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $9d5744a040e6bf17$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $9d5744a040e6bf17$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $9d5744a040e6bf17$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $9d5744a040e6bf17$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $9d5744a040e6bf17$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $9d5744a040e6bf17$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $9d5744a040e6bf17$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $9d5744a040e6bf17$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $9d5744a040e6bf17$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $9d5744a040e6bf17$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $9d5744a040e6bf17$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $4e76d.nextTick($9d5744a040e6bf17$var$emitReadable_, stream);
        else $9d5744a040e6bf17$var$emitReadable_(stream);
    }
}
function $9d5744a040e6bf17$var$emitReadable_(stream) {
    $9d5744a040e6bf17$var$debug('emit readable');
    stream.emit('readable');
    $9d5744a040e6bf17$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $9d5744a040e6bf17$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $4e76d.nextTick($9d5744a040e6bf17$var$maybeReadMore_, stream, state);
    }
}
function $9d5744a040e6bf17$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $9d5744a040e6bf17$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$9d5744a040e6bf17$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$9d5744a040e6bf17$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $9d5744a040e6bf17$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $ffICS.stdout && dest !== $ffICS.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $4e76d.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $9d5744a040e6bf17$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $9d5744a040e6bf17$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $9d5744a040e6bf17$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $9d5744a040e6bf17$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $9d5744a040e6bf17$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $9d5744a040e6bf17$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $9d5744a040e6bf17$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $9d5744a040e6bf17$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($9d5744a040e6bf17$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $9d5744a040e6bf17$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $9d5744a040e6bf17$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $9d5744a040e6bf17$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $9d5744a040e6bf17$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $9d5744a040e6bf17$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $9d5744a040e6bf17$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $9d5744a040e6bf17$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $9d5744a040e6bf17$var$flow(src);
        }
    };
}
$9d5744a040e6bf17$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $9d5744a040e6bf17$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$9d5744a040e6bf17$var$Readable.prototype.on = function(ev, fn) {
    var res = $9PThW.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $4e76d.nextTick($9d5744a040e6bf17$var$nReadingNextTick, this);
            else if (state.length) $9d5744a040e6bf17$var$emitReadable(this);
        }
    }
    return res;
};
$9d5744a040e6bf17$var$Readable.prototype.addListener = $9d5744a040e6bf17$var$Readable.prototype.on;
function $9d5744a040e6bf17$var$nReadingNextTick(self1) {
    $9d5744a040e6bf17$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$9d5744a040e6bf17$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $9d5744a040e6bf17$var$debug('resume');
        state.flowing = true;
        $9d5744a040e6bf17$var$resume(this, state);
    }
    return this;
};
function $9d5744a040e6bf17$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $4e76d.nextTick($9d5744a040e6bf17$var$resume_, stream, state);
    }
}
function $9d5744a040e6bf17$var$resume_(stream, state) {
    if (!state.reading) {
        $9d5744a040e6bf17$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $9d5744a040e6bf17$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$9d5744a040e6bf17$var$Readable.prototype.pause = function() {
    $9d5744a040e6bf17$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $9d5744a040e6bf17$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $9d5744a040e6bf17$var$flow(stream) {
    var state = stream._readableState;
    $9d5744a040e6bf17$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$9d5744a040e6bf17$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $9d5744a040e6bf17$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $9d5744a040e6bf17$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $9d5744a040e6bf17$var$kProxyEvents.length; n++)stream.on($9d5744a040e6bf17$var$kProxyEvents[n], this.emit.bind(this, $9d5744a040e6bf17$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $9d5744a040e6bf17$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($9d5744a040e6bf17$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$9d5744a040e6bf17$var$Readable._fromList = $9d5744a040e6bf17$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9d5744a040e6bf17$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $9d5744a040e6bf17$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9d5744a040e6bf17$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $9d5744a040e6bf17$var$copyFromBufferString(n, list) : $9d5744a040e6bf17$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9d5744a040e6bf17$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9d5744a040e6bf17$var$copyFromBuffer(n, list) {
    var ret = $9d5744a040e6bf17$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $9d5744a040e6bf17$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $4e76d.nextTick($9d5744a040e6bf17$var$endReadableNT, state, stream);
    }
}
function $9d5744a040e6bf17$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $9d5744a040e6bf17$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("4e76d", function(module, exports) {

var $ffICS = parcelRequire("ffICS");
'use strict';
if (typeof $ffICS === 'undefined' || !$ffICS.version || $ffICS.version.indexOf('v0.') === 0 || $ffICS.version.indexOf('v1.') === 0 && $ffICS.version.indexOf('v1.8.') !== 0) module.exports = {
    nextTick: $313df9fe67b1fee1$var$nextTick
};
else module.exports = $ffICS;
function $313df9fe67b1fee1$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== 'function') throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $ffICS.nextTick(fn);
        case 2:
            return $ffICS.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $ffICS.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $ffICS.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $ffICS.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("4vdXq", function(module, exports) {
var $3474e25206816ba9$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $3474e25206816ba9$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("9PThW", function(module, exports) {

module.exports = (parcelRequire("6zVuT")).EventEmitter;

});

parcelRegister("fRDMy", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $dSRbH = parcelRequire("dSRbH");
var $b8caaa2bfdb325a7$var$Buffer = $dSRbH.Buffer;
// alternative to using Object.keys for old browsers
function $b8caaa2bfdb325a7$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($b8caaa2bfdb325a7$var$Buffer.from && $b8caaa2bfdb325a7$var$Buffer.alloc && $b8caaa2bfdb325a7$var$Buffer.allocUnsafe && $b8caaa2bfdb325a7$var$Buffer.allocUnsafeSlow) module.exports = $dSRbH;
else {
    // Copy properties from require('buffer')
    $b8caaa2bfdb325a7$var$copyProps($dSRbH, module.exports);
    module.exports.Buffer = $b8caaa2bfdb325a7$var$SafeBuffer;
}
function $b8caaa2bfdb325a7$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $b8caaa2bfdb325a7$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$b8caaa2bfdb325a7$var$copyProps($b8caaa2bfdb325a7$var$Buffer, $b8caaa2bfdb325a7$var$SafeBuffer);
$b8caaa2bfdb325a7$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $b8caaa2bfdb325a7$var$Buffer(arg, encodingOrOffset, length);
};
$b8caaa2bfdb325a7$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $b8caaa2bfdb325a7$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$b8caaa2bfdb325a7$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $b8caaa2bfdb325a7$var$Buffer(size);
};
$b8caaa2bfdb325a7$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $dSRbH.SlowBuffer(size);
};

});

parcelRegister("crVmE", function(module, exports) {

$parcel$export(module.exports, "isArray", function () { return $9104810625e66b44$export$43bee75e5e14138e; }, function (v) { return $9104810625e66b44$export$43bee75e5e14138e = v; });
$parcel$export(module.exports, "isBoolean", function () { return $9104810625e66b44$export$f9ce7b637dfbe238; }, function (v) { return $9104810625e66b44$export$f9ce7b637dfbe238 = v; });
$parcel$export(module.exports, "isNull", function () { return $9104810625e66b44$export$630801d484da15df; }, function (v) { return $9104810625e66b44$export$630801d484da15df = v; });
$parcel$export(module.exports, "isNullOrUndefined", function () { return $9104810625e66b44$export$bedb7023a7733221; }, function (v) { return $9104810625e66b44$export$bedb7023a7733221 = v; });
$parcel$export(module.exports, "isNumber", function () { return $9104810625e66b44$export$7e4aa119212bc614; }, function (v) { return $9104810625e66b44$export$7e4aa119212bc614 = v; });
$parcel$export(module.exports, "isString", function () { return $9104810625e66b44$export$844ec244b1367d54; }, function (v) { return $9104810625e66b44$export$844ec244b1367d54 = v; });
$parcel$export(module.exports, "isSymbol", function () { return $9104810625e66b44$export$a244864fd9645c7f; }, function (v) { return $9104810625e66b44$export$a244864fd9645c7f = v; });
$parcel$export(module.exports, "isUndefined", function () { return $9104810625e66b44$export$fce6876652108ab; }, function (v) { return $9104810625e66b44$export$fce6876652108ab = v; });
$parcel$export(module.exports, "isRegExp", function () { return $9104810625e66b44$export$49841c62b9eff15; }, function (v) { return $9104810625e66b44$export$49841c62b9eff15 = v; });
$parcel$export(module.exports, "isObject", function () { return $9104810625e66b44$export$a6cdc56e425d0d0a; }, function (v) { return $9104810625e66b44$export$a6cdc56e425d0d0a = v; });
$parcel$export(module.exports, "isDate", function () { return $9104810625e66b44$export$871608497c498473; }, function (v) { return $9104810625e66b44$export$871608497c498473 = v; });
$parcel$export(module.exports, "isError", function () { return $9104810625e66b44$export$e6127cc7fe7395c3; }, function (v) { return $9104810625e66b44$export$e6127cc7fe7395c3 = v; });
$parcel$export(module.exports, "isFunction", function () { return $9104810625e66b44$export$f6e2535fb5126e54; }, function (v) { return $9104810625e66b44$export$f6e2535fb5126e54 = v; });
$parcel$export(module.exports, "isPrimitive", function () { return $9104810625e66b44$export$c3825b437cbdea5c; }, function (v) { return $9104810625e66b44$export$c3825b437cbdea5c = v; });
$parcel$export(module.exports, "isBuffer", function () { return $9104810625e66b44$export$a7884ebc965f8f54; }, function (v) { return $9104810625e66b44$export$a7884ebc965f8f54 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

var $qb7pP = parcelRequire("qb7pP");
var $9104810625e66b44$export$43bee75e5e14138e;
var $9104810625e66b44$export$f9ce7b637dfbe238;
var $9104810625e66b44$export$630801d484da15df;
var $9104810625e66b44$export$bedb7023a7733221;
var $9104810625e66b44$export$7e4aa119212bc614;
var $9104810625e66b44$export$844ec244b1367d54;
var $9104810625e66b44$export$a244864fd9645c7f;
var $9104810625e66b44$export$fce6876652108ab;
var $9104810625e66b44$export$49841c62b9eff15;
var $9104810625e66b44$export$a6cdc56e425d0d0a;
var $9104810625e66b44$export$871608497c498473;
var $9104810625e66b44$export$e6127cc7fe7395c3;
var $9104810625e66b44$export$f6e2535fb5126e54;
var $9104810625e66b44$export$c3825b437cbdea5c;
var $9104810625e66b44$export$a7884ebc965f8f54;
function $9104810625e66b44$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $9104810625e66b44$var$objectToString(arg) === '[object Array]';
}
$9104810625e66b44$export$43bee75e5e14138e = $9104810625e66b44$var$isArray;
function $9104810625e66b44$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
$9104810625e66b44$export$f9ce7b637dfbe238 = $9104810625e66b44$var$isBoolean;
function $9104810625e66b44$var$isNull(arg) {
    return arg === null;
}
$9104810625e66b44$export$630801d484da15df = $9104810625e66b44$var$isNull;
function $9104810625e66b44$var$isNullOrUndefined(arg) {
    return arg == null;
}
$9104810625e66b44$export$bedb7023a7733221 = $9104810625e66b44$var$isNullOrUndefined;
function $9104810625e66b44$var$isNumber(arg) {
    return typeof arg === 'number';
}
$9104810625e66b44$export$7e4aa119212bc614 = $9104810625e66b44$var$isNumber;
function $9104810625e66b44$var$isString(arg) {
    return typeof arg === 'string';
}
$9104810625e66b44$export$844ec244b1367d54 = $9104810625e66b44$var$isString;
function $9104810625e66b44$var$isSymbol(arg) {
    return (typeof arg === "undefined" ? "undefined" : (0, $qb7pP._)(arg)) === 'symbol';
}
$9104810625e66b44$export$a244864fd9645c7f = $9104810625e66b44$var$isSymbol;
function $9104810625e66b44$var$isUndefined(arg) {
    return arg === void 0;
}
$9104810625e66b44$export$fce6876652108ab = $9104810625e66b44$var$isUndefined;
function $9104810625e66b44$var$isRegExp(re) {
    return $9104810625e66b44$var$objectToString(re) === '[object RegExp]';
}
$9104810625e66b44$export$49841c62b9eff15 = $9104810625e66b44$var$isRegExp;
function $9104810625e66b44$var$isObject(arg) {
    return (typeof arg === "undefined" ? "undefined" : (0, $qb7pP._)(arg)) === 'object' && arg !== null;
}
$9104810625e66b44$export$a6cdc56e425d0d0a = $9104810625e66b44$var$isObject;
function $9104810625e66b44$var$isDate(d) {
    return $9104810625e66b44$var$objectToString(d) === '[object Date]';
}
$9104810625e66b44$export$871608497c498473 = $9104810625e66b44$var$isDate;
function $9104810625e66b44$var$isError(e) {
    return $9104810625e66b44$var$objectToString(e) === '[object Error]' || e instanceof Error;
}
$9104810625e66b44$export$e6127cc7fe7395c3 = $9104810625e66b44$var$isError;
function $9104810625e66b44$var$isFunction(arg) {
    return typeof arg === 'function';
}
$9104810625e66b44$export$f6e2535fb5126e54 = $9104810625e66b44$var$isFunction;
function $9104810625e66b44$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || (typeof arg === "undefined" ? "undefined" : (0, $qb7pP._)(arg)) === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
$9104810625e66b44$export$c3825b437cbdea5c = $9104810625e66b44$var$isPrimitive;

$9104810625e66b44$export$a7884ebc965f8f54 = (parcelRequire("dSRbH")).Buffer.isBuffer;
function $9104810625e66b44$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("M01ev", function(module, exports) {
'use strict';
function $09047f8f43928fbe$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $fRDMy = parcelRequire("fRDMy");
var $09047f8f43928fbe$require$Buffer = $fRDMy.Buffer;

var $iczbQ = parcelRequire("iczbQ");
function $09047f8f43928fbe$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $09047f8f43928fbe$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $09047f8f43928fbe$require$Buffer.alloc(0);
        var ret = $09047f8f43928fbe$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $09047f8f43928fbe$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($iczbQ && $iczbQ.inspect && $iczbQ.inspect.custom) module.exports.prototype[$iczbQ.inspect.custom] = function() {
    var obj = $iczbQ.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("iox1P", function(module, exports) {
'use strict';

var $4e76d = parcelRequire("4e76d");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $d64416a78e66d21b$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $4e76d.nextTick($d64416a78e66d21b$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $4e76d.nextTick($d64416a78e66d21b$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $4e76d.nextTick($d64416a78e66d21b$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $4e76d.nextTick($d64416a78e66d21b$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $d64416a78e66d21b$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $d64416a78e66d21b$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $d64416a78e66d21b$var$destroy,
    undestroy: $d64416a78e66d21b$var$undestroy
};

});

parcelRegister("7NKt6", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $4e76d = parcelRequire("4e76d");
/*</replacement>*/ /*<replacement>*/ var $5ae127aae027a97c$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $5ae127aae027a97c$var$Duplex;

/*<replacement>*/ var $5ae127aae027a97c$var$util = Object.create((parcelRequire("crVmE")));

$5ae127aae027a97c$var$util.inherits = (parcelRequire("6LbC4"));

var $dvwm4 = parcelRequire("dvwm4");

var $hNefa = parcelRequire("hNefa");
$5ae127aae027a97c$var$util.inherits($5ae127aae027a97c$var$Duplex, $dvwm4);
// avoid scope creep, the keys array can then be collected
var $5ae127aae027a97c$var$keys = $5ae127aae027a97c$var$objectKeys($hNefa.prototype);
for(var $5ae127aae027a97c$var$v = 0; $5ae127aae027a97c$var$v < $5ae127aae027a97c$var$keys.length; $5ae127aae027a97c$var$v++){
    var $5ae127aae027a97c$var$method = $5ae127aae027a97c$var$keys[$5ae127aae027a97c$var$v];
    if (!$5ae127aae027a97c$var$Duplex.prototype[$5ae127aae027a97c$var$method]) $5ae127aae027a97c$var$Duplex.prototype[$5ae127aae027a97c$var$method] = $hNefa.prototype[$5ae127aae027a97c$var$method];
}
function $5ae127aae027a97c$var$Duplex(options) {
    if (!(this instanceof $5ae127aae027a97c$var$Duplex)) return new $5ae127aae027a97c$var$Duplex(options);
    $dvwm4.call(this, options);
    $hNefa.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $5ae127aae027a97c$var$onend);
}
Object.defineProperty($5ae127aae027a97c$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $5ae127aae027a97c$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $4e76d.nextTick($5ae127aae027a97c$var$onEndNT, this);
}
function $5ae127aae027a97c$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($5ae127aae027a97c$var$Duplex.prototype, 'destroyed', {
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$5ae127aae027a97c$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $4e76d.nextTick(cb, err);
};

});
parcelRegister("hNefa", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $4e76d = parcelRequire("4e76d");
/*</replacement>*/ module.exports = $cf420fbe17ef2097$var$Writable;
/* <replacement> */ function $cf420fbe17ef2097$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $cf420fbe17ef2097$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $cf420fbe17ef2097$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $cf420fbe17ef2097$var$asyncWrite = (0, $4e76d.nextTick);
/*</replacement>*/ /*<replacement>*/ var $cf420fbe17ef2097$var$Duplex;
/*</replacement>*/ $cf420fbe17ef2097$var$Writable.WritableState = $cf420fbe17ef2097$var$WritableState;

/*<replacement>*/ var $cf420fbe17ef2097$var$util = Object.create((parcelRequire("crVmE")));

$cf420fbe17ef2097$var$util.inherits = (parcelRequire("6LbC4"));

/*</replacement>*/ /*<replacement>*/ var $cf420fbe17ef2097$var$internalUtil = {
    deprecate: (parcelRequire("5VHHi"))
};

var $9PThW = parcelRequire("9PThW");

var $fRDMy = parcelRequire("fRDMy");
var $cf420fbe17ef2097$require$Buffer = $fRDMy.Buffer;
var $cf420fbe17ef2097$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $cf420fbe17ef2097$var$_uint8ArrayToBuffer(chunk) {
    return $cf420fbe17ef2097$require$Buffer.from(chunk);
}
function $cf420fbe17ef2097$var$_isUint8Array(obj) {
    return $cf420fbe17ef2097$require$Buffer.isBuffer(obj) || obj instanceof $cf420fbe17ef2097$var$OurUint8Array;
}

var $iox1P = parcelRequire("iox1P");
$cf420fbe17ef2097$var$util.inherits($cf420fbe17ef2097$var$Writable, $9PThW);
function $cf420fbe17ef2097$var$nop() {}

function $cf420fbe17ef2097$var$WritableState(options, stream) {
    $cf420fbe17ef2097$var$Duplex = $cf420fbe17ef2097$var$Duplex || (parcelRequire("7NKt6"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $cf420fbe17ef2097$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $cf420fbe17ef2097$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $cf420fbe17ef2097$var$CorkedRequest(this);
}
$cf420fbe17ef2097$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($cf420fbe17ef2097$var$WritableState.prototype, 'buffer', {
            get: $cf420fbe17ef2097$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $cf420fbe17ef2097$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $cf420fbe17ef2097$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($cf420fbe17ef2097$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($cf420fbe17ef2097$var$realHasInstance.call(this, object)) return true;
            if (this !== $cf420fbe17ef2097$var$Writable) return false;
            return object && object._writableState instanceof $cf420fbe17ef2097$var$WritableState;
        }
    });
} else $cf420fbe17ef2097$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $cf420fbe17ef2097$var$Writable(options) {
    $cf420fbe17ef2097$var$Duplex = $cf420fbe17ef2097$var$Duplex || (parcelRequire("7NKt6"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$cf420fbe17ef2097$var$realHasInstance.call($cf420fbe17ef2097$var$Writable, this) && !(this instanceof $cf420fbe17ef2097$var$Duplex)) return new $cf420fbe17ef2097$var$Writable(options);
    this._writableState = new $cf420fbe17ef2097$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options["final"] === 'function') this._final = options["final"];
    }
    $9PThW.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$cf420fbe17ef2097$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $cf420fbe17ef2097$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $4e76d.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $cf420fbe17ef2097$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $4e76d.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$cf420fbe17ef2097$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $cf420fbe17ef2097$var$_isUint8Array(chunk);
    if (isBuf && !$cf420fbe17ef2097$require$Buffer.isBuffer(chunk)) chunk = $cf420fbe17ef2097$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $cf420fbe17ef2097$var$nop;
    if (state.ended) $cf420fbe17ef2097$var$writeAfterEnd(this, cb);
    else if (isBuf || $cf420fbe17ef2097$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $cf420fbe17ef2097$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$cf420fbe17ef2097$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$cf420fbe17ef2097$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $cf420fbe17ef2097$var$clearBuffer(this, state);
    }
};
$cf420fbe17ef2097$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $cf420fbe17ef2097$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $cf420fbe17ef2097$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($cf420fbe17ef2097$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $cf420fbe17ef2097$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $cf420fbe17ef2097$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $cf420fbe17ef2097$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $cf420fbe17ef2097$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $cf420fbe17ef2097$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $4e76d.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $4e76d.nextTick($cf420fbe17ef2097$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $cf420fbe17ef2097$var$finishMaybe(stream, state);
    }
}
function $cf420fbe17ef2097$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $cf420fbe17ef2097$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $cf420fbe17ef2097$var$onwriteStateUpdate(state);
    if (er) $cf420fbe17ef2097$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $cf420fbe17ef2097$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $cf420fbe17ef2097$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $cf420fbe17ef2097$var$asyncWrite($cf420fbe17ef2097$var$afterWrite, stream, state, finished, cb);
        else $cf420fbe17ef2097$var$afterWrite(stream, state, finished, cb);
    }
}
function $cf420fbe17ef2097$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $cf420fbe17ef2097$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $cf420fbe17ef2097$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $cf420fbe17ef2097$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $cf420fbe17ef2097$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $cf420fbe17ef2097$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $cf420fbe17ef2097$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $cf420fbe17ef2097$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$cf420fbe17ef2097$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$cf420fbe17ef2097$var$Writable.prototype._writev = null;
$cf420fbe17ef2097$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $cf420fbe17ef2097$var$endWritable(this, state, cb);
};
function $cf420fbe17ef2097$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $cf420fbe17ef2097$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $cf420fbe17ef2097$var$finishMaybe(stream, state);
    });
}
function $cf420fbe17ef2097$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $4e76d.nextTick($cf420fbe17ef2097$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $cf420fbe17ef2097$var$finishMaybe(stream, state) {
    var need = $cf420fbe17ef2097$var$needFinish(state);
    if (need) {
        $cf420fbe17ef2097$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $cf420fbe17ef2097$var$endWritable(stream, state, cb) {
    state.ending = true;
    $cf420fbe17ef2097$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $4e76d.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $cf420fbe17ef2097$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($cf420fbe17ef2097$var$Writable.prototype, 'destroyed', {
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$cf420fbe17ef2097$var$Writable.prototype.destroy = $iox1P.destroy;
$cf420fbe17ef2097$var$Writable.prototype._undestroy = $iox1P.undestroy;
$cf420fbe17ef2097$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("a26EP", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $74df4155da33a2a9$export$63a7aa211a91ed69; }, function (v) { return $74df4155da33a2a9$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $74df4155da33a2a9$export$63a7aa211a91ed69;
'use strict';

var $fRDMy = parcelRequire("fRDMy");
var $74df4155da33a2a9$require$Buffer = $fRDMy.Buffer;
/*</replacement>*/ var $74df4155da33a2a9$var$isEncoding = $74df4155da33a2a9$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $74df4155da33a2a9$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $74df4155da33a2a9$var$normalizeEncoding(enc) {
    var nenc = $74df4155da33a2a9$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($74df4155da33a2a9$require$Buffer.isEncoding === $74df4155da33a2a9$var$isEncoding || !$74df4155da33a2a9$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$74df4155da33a2a9$export$63a7aa211a91ed69 = $74df4155da33a2a9$var$StringDecoder;
function $74df4155da33a2a9$var$StringDecoder(encoding) {
    this.encoding = $74df4155da33a2a9$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $74df4155da33a2a9$var$utf16Text;
            this.end = $74df4155da33a2a9$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $74df4155da33a2a9$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $74df4155da33a2a9$var$base64Text;
            this.end = $74df4155da33a2a9$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $74df4155da33a2a9$var$simpleWrite;
            this.end = $74df4155da33a2a9$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $74df4155da33a2a9$require$Buffer.allocUnsafe(nb);
}
$74df4155da33a2a9$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$74df4155da33a2a9$var$StringDecoder.prototype.end = $74df4155da33a2a9$var$utf8End;
// Returns only complete characters in a Buffer
$74df4155da33a2a9$var$StringDecoder.prototype.text = $74df4155da33a2a9$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$74df4155da33a2a9$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $74df4155da33a2a9$var$utf8CheckByte(_byte) {
    if (_byte <= 0x7F) return 0;
    else if (_byte >> 5 === 0x06) return 2;
    else if (_byte >> 4 === 0x0E) return 3;
    else if (_byte >> 3 === 0x1E) return 4;
    return _byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $74df4155da33a2a9$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $74df4155da33a2a9$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $74df4155da33a2a9$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $74df4155da33a2a9$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $74df4155da33a2a9$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $74df4155da33a2a9$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $74df4155da33a2a9$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $74df4155da33a2a9$var$utf8Text(buf, i) {
    var total = $74df4155da33a2a9$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $74df4155da33a2a9$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $74df4155da33a2a9$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $74df4155da33a2a9$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $74df4155da33a2a9$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $74df4155da33a2a9$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $74df4155da33a2a9$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $74df4155da33a2a9$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});


parcelRegister("2XUUu", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $228d3c9edb3ff689$var$Transform;

var $7NKt6 = parcelRequire("7NKt6");

/*<replacement>*/ var $228d3c9edb3ff689$var$util = Object.create((parcelRequire("crVmE")));

$228d3c9edb3ff689$var$util.inherits = (parcelRequire("6LbC4"));
/*</replacement>*/ $228d3c9edb3ff689$var$util.inherits($228d3c9edb3ff689$var$Transform, $7NKt6);
function $228d3c9edb3ff689$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $228d3c9edb3ff689$var$Transform(options) {
    if (!(this instanceof $228d3c9edb3ff689$var$Transform)) return new $228d3c9edb3ff689$var$Transform(options);
    $7NKt6.call(this, options);
    this._transformState = {
        afterTransform: $228d3c9edb3ff689$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $228d3c9edb3ff689$var$prefinish);
}
function $228d3c9edb3ff689$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $228d3c9edb3ff689$var$done(_this, er, data);
    });
    else $228d3c9edb3ff689$var$done(this, null, null);
}
$228d3c9edb3ff689$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $7NKt6.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$228d3c9edb3ff689$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$228d3c9edb3ff689$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$228d3c9edb3ff689$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$228d3c9edb3ff689$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $7NKt6.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $228d3c9edb3ff689$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("iQBai", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $db89e98d338c1aa7$var$PassThrough;

var $2XUUu = parcelRequire("2XUUu");

/*<replacement>*/ var $db89e98d338c1aa7$var$util = Object.create((parcelRequire("crVmE")));

$db89e98d338c1aa7$var$util.inherits = (parcelRequire("6LbC4"));
/*</replacement>*/ $db89e98d338c1aa7$var$util.inherits($db89e98d338c1aa7$var$PassThrough, $2XUUu);
function $db89e98d338c1aa7$var$PassThrough(options) {
    if (!(this instanceof $db89e98d338c1aa7$var$PassThrough)) return new $db89e98d338c1aa7$var$PassThrough(options);
    $2XUUu.call(this, options);
}
$db89e98d338c1aa7$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});


parcelRegister("6F8jU", function(module, exports) {
'use strict';

var $5PcLP = parcelRequire("5PcLP");
var $4d9d0698e1b72684$require$Buffer = $5PcLP.Buffer;

var $4Ffzf = parcelRequire("4Ffzf");

var $6t4wh = parcelRequire("6t4wh");

var $aKi6r = parcelRequire("aKi6r");
var $4d9d0698e1b72684$require$EC = $aKi6r.ec;

var $iKbS8 = parcelRequire("iKbS8");

var $4SshR = parcelRequire("4SshR");

var $coJWo = parcelRequire("coJWo");
var $4d9d0698e1b72684$var$RSA_PKCS1_PADDING = 1;
function $4d9d0698e1b72684$var$sign(hash, key, hashType, signType, tag) {
    var priv = $4SshR(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        return $4d9d0698e1b72684$var$ecSign(hash, priv);
    } else if (priv.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong private key type');
        return $4d9d0698e1b72684$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    if (key.padding !== undefined && key.padding !== $4d9d0698e1b72684$var$RSA_PKCS1_PADDING) throw new Error('illegal or unsupported padding mode');
    hash = $4d9d0698e1b72684$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $6t4wh(pad, priv);
    return out;
}
function $4d9d0698e1b72684$var$ecSign(hash, priv) {
    var curveId = $coJWo[priv.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
    var curve = new $4d9d0698e1b72684$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $4d9d0698e1b72684$require$Buffer.from(out.toDER());
}
function $4d9d0698e1b72684$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $iKbS8(0);
    var k;
    var H = $4d9d0698e1b72684$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $4d9d0698e1b72684$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $4d9d0698e1b72684$var$makeKey(q, kv, algo);
        r = $4d9d0698e1b72684$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $iKbS8(0);
        }
    }
    return $4d9d0698e1b72684$var$toDER(r, s);
}
function $4d9d0698e1b72684$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $4d9d0698e1b72684$require$Buffer.from(res);
}
function $4d9d0698e1b72684$var$getKey(x, q, hash, algo) {
    x = $4d9d0698e1b72684$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $4d9d0698e1b72684$require$Buffer.alloc(q.byteLength() - x.length);
        x = $4d9d0698e1b72684$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $4d9d0698e1b72684$var$bits2octets(hash, q);
    var v = $4d9d0698e1b72684$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $4d9d0698e1b72684$require$Buffer.alloc(hlen);
    k = $4Ffzf(algo, k).update(v).update($4d9d0698e1b72684$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $4Ffzf(algo, k).update(v).digest();
    k = $4Ffzf(algo, k).update(v).update($4d9d0698e1b72684$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $4Ffzf(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $4d9d0698e1b72684$var$bits2int(obits, q) {
    var bits = new $iKbS8(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $4d9d0698e1b72684$var$bits2octets(bits, q) {
    bits = $4d9d0698e1b72684$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $4d9d0698e1b72684$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $4d9d0698e1b72684$require$Buffer.alloc(q.byteLength() - out.length);
        out = $4d9d0698e1b72684$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $4d9d0698e1b72684$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $4d9d0698e1b72684$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $4Ffzf(algo, kv.k).update(kv.v).digest();
            t = $4d9d0698e1b72684$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $4d9d0698e1b72684$var$bits2int(t, q);
        kv.k = $4Ffzf(algo, kv.k).update(kv.v).update($4d9d0698e1b72684$require$Buffer.from([
            0
        ])).digest();
        kv.v = $4Ffzf(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $4d9d0698e1b72684$var$makeR(g, k, p, q) {
    return g.toRed($iKbS8.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $4d9d0698e1b72684$var$sign;
module.exports.getKey = $4d9d0698e1b72684$var$getKey;
module.exports.makeKey = $4d9d0698e1b72684$var$makeKey;

});
parcelRegister("6t4wh", function(module, exports) {
'use strict';

var $iKbS8 = parcelRequire("iKbS8");

var $cCNIN = parcelRequire("cCNIN");

var $5PcLP = parcelRequire("5PcLP");
var $4b58f503a0b1d166$require$Buffer = $5PcLP.Buffer;
function $4b58f503a0b1d166$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $iKbS8($cCNIN(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $4b58f503a0b1d166$var$blind(priv) {
    var r = $4b58f503a0b1d166$var$getr(priv);
    var blinder = r.toRed($iKbS8.mont(priv.modulus)).redPow(new $iKbS8(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $4b58f503a0b1d166$var$crt(msg, priv) {
    var blinds = $4b58f503a0b1d166$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $iKbS8(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($iKbS8.mont(priv.prime1));
    var c2 = blinded.toRed($iKbS8.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($4b58f503a0b1d166$require$Buffer, 'be', len);
}
$4b58f503a0b1d166$var$crt.getr = $4b58f503a0b1d166$var$getr;
module.exports = $4b58f503a0b1d166$var$crt;

});
parcelRegister("iKbS8", function(module, exports) {

var $qb7pP = parcelRequire("qb7pP");

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if ((typeof module1 === "undefined" ? "undefined" : (0, $qb7pP._)(module1)) === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("iczbQ")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && (typeof num === "undefined" ? "undefined" : (0, $qb7pP._)(num)) === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if ((typeof number === "undefined" ? "undefined" : (0, $qb7pP._)(number)) === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol["for"] === 'function') try {
        BN.prototype[Symbol["for"]('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, undefined);

});


parcelRegister("aKi6r", function(module, exports) {
'use strict';
var $7d2c3e17eff6de0f$var$elliptic = module.exports;

$7d2c3e17eff6de0f$var$elliptic.version = (parcelRequire("fxUFf")).version;

$7d2c3e17eff6de0f$var$elliptic.utils = (parcelRequire("8Wc9V"));

$7d2c3e17eff6de0f$var$elliptic.rand = (parcelRequire("5oleY"));

$7d2c3e17eff6de0f$var$elliptic.curve = (parcelRequire("HDQz6"));

$7d2c3e17eff6de0f$var$elliptic.curves = (parcelRequire("lQdx5"));

// Protocols
$7d2c3e17eff6de0f$var$elliptic.ec = (parcelRequire("a0TyH"));

$7d2c3e17eff6de0f$var$elliptic.eddsa = (parcelRequire("5eaPJ"));

});
parcelRegister("fxUFf", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.6.1\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");

});

parcelRegister("8Wc9V", function(module, exports) {
'use strict';
var $681d2c0760021863$var$utils = module.exports;

var $35J5F = parcelRequire("35J5F");

var $3Pc6F = parcelRequire("3Pc6F");

var $46wbx = parcelRequire("46wbx");
$681d2c0760021863$var$utils.assert = $3Pc6F;
$681d2c0760021863$var$utils.toArray = $46wbx.toArray;
$681d2c0760021863$var$utils.zero2 = $46wbx.zero2;
$681d2c0760021863$var$utils.toHex = $46wbx.toHex;
$681d2c0760021863$var$utils.encode = $46wbx.encode;
// Represent num in a w-NAF form
function $681d2c0760021863$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$681d2c0760021863$var$utils.getNAF = $681d2c0760021863$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $681d2c0760021863$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$681d2c0760021863$var$utils.getJSF = $681d2c0760021863$var$getJSF;
function $681d2c0760021863$var$cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$681d2c0760021863$var$utils.cachedProperty = $681d2c0760021863$var$cachedProperty;
function $681d2c0760021863$var$parseBytes(bytes) {
    return typeof bytes === 'string' ? $681d2c0760021863$var$utils.toArray(bytes, 'hex') : bytes;
}
$681d2c0760021863$var$utils.parseBytes = $681d2c0760021863$var$parseBytes;
function $681d2c0760021863$var$intFromLE(bytes) {
    return new $35J5F(bytes, 'hex', 'le');
}
$681d2c0760021863$var$utils.intFromLE = $681d2c0760021863$var$intFromLE;

});
parcelRegister("35J5F", function(module, exports) {

var $qb7pP = parcelRequire("qb7pP");

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if ((typeof module1 === "undefined" ? "undefined" : (0, $qb7pP._)(module1)) === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("iczbQ")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && (typeof num === "undefined" ? "undefined" : (0, $qb7pP._)(num)) === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if ((typeof number === "undefined" ? "undefined" : (0, $qb7pP._)(number)) === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, undefined);

});

parcelRegister("46wbx", function(module, exports) {
'use strict';
var $2fd0b04610187d02$var$utils = module.exports;
function $2fd0b04610187d02$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$2fd0b04610187d02$var$utils.toArray = $2fd0b04610187d02$var$toArray;
function $2fd0b04610187d02$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$2fd0b04610187d02$var$utils.zero2 = $2fd0b04610187d02$var$zero2;
function $2fd0b04610187d02$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $2fd0b04610187d02$var$zero2(msg[i].toString(16));
    return res;
}
$2fd0b04610187d02$var$utils.toHex = $2fd0b04610187d02$var$toHex;
$2fd0b04610187d02$var$utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return $2fd0b04610187d02$var$toHex(arr);
    else return arr;
};

});


parcelRegister("HDQz6", function(module, exports) {
'use strict';
var $0832ed0429a2b72f$var$curve = module.exports;

$0832ed0429a2b72f$var$curve.base = (parcelRequire("knKUY"));

$0832ed0429a2b72f$var$curve["short"] = (parcelRequire("fxUbP"));

$0832ed0429a2b72f$var$curve.mont = (parcelRequire("j7VZU"));

$0832ed0429a2b72f$var$curve.edwards = (parcelRequire("gHzoy"));

});
parcelRegister("knKUY", function(module, exports) {
'use strict';

var $35J5F = parcelRequire("35J5F");

var $8Wc9V = parcelRequire("8Wc9V");
var $ed6a599399724b19$var$getNAF = $8Wc9V.getNAF;
var $ed6a599399724b19$var$getJSF = $8Wc9V.getJSF;
var $ed6a599399724b19$var$assert = $8Wc9V.assert;
function $ed6a599399724b19$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $35J5F(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $35J5F.red(conf.prime) : $35J5F.mont(this.p);
    // Useful for many curves
    this.zero = new $35J5F(0).toRed(this.red);
    this.one = new $35J5F(1).toRed(this.red);
    this.two = new $35J5F(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $35J5F(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $ed6a599399724b19$var$BaseCurve;
$ed6a599399724b19$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$ed6a599399724b19$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$ed6a599399724b19$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $ed6a599399724b19$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $ed6a599399724b19$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$ed6a599399724b19$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $ed6a599399724b19$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $ed6a599399724b19$var$assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$ed6a599399724b19$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $ed6a599399724b19$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $ed6a599399724b19$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $ed6a599399724b19$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $ed6a599399724b19$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$ed6a599399724b19$var$BaseCurve.BasePoint = $ed6a599399724b19$var$BasePoint;
$ed6a599399724b19$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$ed6a599399724b19$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$ed6a599399724b19$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $8Wc9V.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $ed6a599399724b19$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $ed6a599399724b19$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$ed6a599399724b19$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$ed6a599399724b19$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$ed6a599399724b19$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $8Wc9V.encode(this._encode(compact), enc);
};
$ed6a599399724b19$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$ed6a599399724b19$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$ed6a599399724b19$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$ed6a599399724b19$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$ed6a599399724b19$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$ed6a599399724b19$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("fxUbP", function(module, exports) {
'use strict';

var $8Wc9V = parcelRequire("8Wc9V");

var $35J5F = parcelRequire("35J5F");

var $6LbC4 = parcelRequire("6LbC4");

var $knKUY = parcelRequire("knKUY");
var $b515862dc453dedd$var$assert = $8Wc9V.assert;
function $b515862dc453dedd$var$ShortCurve(conf) {
    $knKUY.call(this, 'short', conf);
    this.a = new $35J5F(conf.a, 16).toRed(this.red);
    this.b = new $35J5F(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$6LbC4($b515862dc453dedd$var$ShortCurve, $knKUY);
module.exports = $b515862dc453dedd$var$ShortCurve;
$b515862dc453dedd$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $35J5F(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $35J5F(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $b515862dc453dedd$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $35J5F(vec.a, 16),
            b: new $35J5F(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$b515862dc453dedd$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $35J5F.mont(num);
    var tinv = new $35J5F(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $35J5F(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$b515862dc453dedd$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $35J5F(1);
    var y1 = new $35J5F(0);
    var x2 = new $35J5F(0);
    var y2 = new $35J5F(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$b515862dc453dedd$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$b515862dc453dedd$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $35J5F(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$b515862dc453dedd$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$b515862dc453dedd$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $b515862dc453dedd$var$Point(curve, x, y, isRed) {
    $knKUY.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $35J5F(x, 16);
        this.y = new $35J5F(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$6LbC4($b515862dc453dedd$var$Point, $knKUY.BasePoint);
$b515862dc453dedd$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $b515862dc453dedd$var$Point(this, x, y, isRed);
};
$b515862dc453dedd$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $b515862dc453dedd$var$Point.fromJSON(this, obj, red);
};
$b515862dc453dedd$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function endoMul(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$b515862dc453dedd$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$b515862dc453dedd$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$b515862dc453dedd$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$b515862dc453dedd$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$b515862dc453dedd$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$b515862dc453dedd$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$b515862dc453dedd$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$b515862dc453dedd$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$b515862dc453dedd$var$Point.prototype.mul = function mul(k) {
    k = new $35J5F(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$b515862dc453dedd$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$b515862dc453dedd$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$b515862dc453dedd$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$b515862dc453dedd$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function negate(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$b515862dc453dedd$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $b515862dc453dedd$var$JPoint(curve, x, y, z) {
    $knKUY.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $35J5F(0);
    } else {
        this.x = new $35J5F(x, 16);
        this.y = new $35J5F(y, 16);
        this.z = new $35J5F(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$6LbC4($b515862dc453dedd$var$JPoint, $knKUY.BasePoint);
$b515862dc453dedd$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $b515862dc453dedd$var$JPoint(this, x, y, z);
};
$b515862dc453dedd$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$b515862dc453dedd$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$b515862dc453dedd$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$b515862dc453dedd$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$b515862dc453dedd$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$b515862dc453dedd$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$b515862dc453dedd$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$b515862dc453dedd$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$b515862dc453dedd$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$b515862dc453dedd$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$b515862dc453dedd$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $35J5F(k, kbase);
    return this.curve._wnafMul(this, k);
};
$b515862dc453dedd$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$b515862dc453dedd$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$b515862dc453dedd$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$b515862dc453dedd$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("j7VZU", function(module, exports) {
'use strict';

var $35J5F = parcelRequire("35J5F");

var $6LbC4 = parcelRequire("6LbC4");

var $knKUY = parcelRequire("knKUY");

var $8Wc9V = parcelRequire("8Wc9V");
function $decba8e2d7d62084$var$MontCurve(conf) {
    $knKUY.call(this, 'mont', conf);
    this.a = new $35J5F(conf.a, 16).toRed(this.red);
    this.b = new $35J5F(conf.b, 16).toRed(this.red);
    this.i4 = new $35J5F(4).toRed(this.red).redInvm();
    this.two = new $35J5F(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$6LbC4($decba8e2d7d62084$var$MontCurve, $knKUY);
module.exports = $decba8e2d7d62084$var$MontCurve;
$decba8e2d7d62084$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $decba8e2d7d62084$var$Point(curve, x, z) {
    $knKUY.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $35J5F(x, 16);
        this.z = new $35J5F(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$6LbC4($decba8e2d7d62084$var$Point, $knKUY.BasePoint);
$decba8e2d7d62084$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($8Wc9V.toArray(bytes, enc), 1);
};
$decba8e2d7d62084$var$MontCurve.prototype.point = function point(x, z) {
    return new $decba8e2d7d62084$var$Point(this, x, z);
};
$decba8e2d7d62084$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $decba8e2d7d62084$var$Point.fromJSON(this, obj);
};
$decba8e2d7d62084$var$Point.prototype.precompute = function precompute() {
// No-op
};
$decba8e2d7d62084$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
$decba8e2d7d62084$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $decba8e2d7d62084$var$Point(curve, obj[0], obj[1] || curve.one);
};
$decba8e2d7d62084$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$decba8e2d7d62084$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$decba8e2d7d62084$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$decba8e2d7d62084$var$Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
$decba8e2d7d62084$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$decba8e2d7d62084$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$decba8e2d7d62084$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$decba8e2d7d62084$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$decba8e2d7d62084$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$decba8e2d7d62084$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$decba8e2d7d62084$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("gHzoy", function(module, exports) {
'use strict';

var $8Wc9V = parcelRequire("8Wc9V");

var $35J5F = parcelRequire("35J5F");

var $6LbC4 = parcelRequire("6LbC4");

var $knKUY = parcelRequire("knKUY");
var $c28c1e2fc8f2716b$var$assert = $8Wc9V.assert;
function $c28c1e2fc8f2716b$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $knKUY.call(this, 'edwards', conf);
    this.a = new $35J5F(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $35J5F(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $35J5F(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $c28c1e2fc8f2716b$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$6LbC4($c28c1e2fc8f2716b$var$EdwardsCurve, $knKUY);
module.exports = $c28c1e2fc8f2716b$var$EdwardsCurve;
$c28c1e2fc8f2716b$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$c28c1e2fc8f2716b$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$c28c1e2fc8f2716b$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$c28c1e2fc8f2716b$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $35J5F(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$c28c1e2fc8f2716b$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $35J5F(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$c28c1e2fc8f2716b$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $c28c1e2fc8f2716b$var$Point(curve, x, y, z, t) {
    $knKUY.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $35J5F(x, 16);
        this.y = new $35J5F(y, 16);
        this.z = z ? new $35J5F(z, 16) : this.curve.one;
        this.t = t && new $35J5F(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$6LbC4($c28c1e2fc8f2716b$var$Point, $knKUY.BasePoint);
$c28c1e2fc8f2716b$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $c28c1e2fc8f2716b$var$Point.fromJSON(this, obj);
};
$c28c1e2fc8f2716b$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $c28c1e2fc8f2716b$var$Point(this, x, y, z, t);
};
$c28c1e2fc8f2716b$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $c28c1e2fc8f2716b$var$Point(curve, obj[0], obj[1], obj[2]);
};
$c28c1e2fc8f2716b$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$c28c1e2fc8f2716b$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$c28c1e2fc8f2716b$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$c28c1e2fc8f2716b$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$c28c1e2fc8f2716b$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$c28c1e2fc8f2716b$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$c28c1e2fc8f2716b$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$c28c1e2fc8f2716b$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$c28c1e2fc8f2716b$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$c28c1e2fc8f2716b$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$c28c1e2fc8f2716b$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$c28c1e2fc8f2716b$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$c28c1e2fc8f2716b$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$c28c1e2fc8f2716b$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$c28c1e2fc8f2716b$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$c28c1e2fc8f2716b$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$c28c1e2fc8f2716b$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$c28c1e2fc8f2716b$var$Point.prototype.toP = $c28c1e2fc8f2716b$var$Point.prototype.normalize;
$c28c1e2fc8f2716b$var$Point.prototype.mixedAdd = $c28c1e2fc8f2716b$var$Point.prototype.add;

});


parcelRegister("lQdx5", function(module, exports) {
'use strict';
var $fe68f395281f871e$var$curves = module.exports;

var $exuq2 = parcelRequire("exuq2");

var $HDQz6 = parcelRequire("HDQz6");

var $8Wc9V = parcelRequire("8Wc9V");
var $fe68f395281f871e$var$assert = $8Wc9V.assert;
function $fe68f395281f871e$var$PresetCurve(options) {
    if (options.type === 'short') this.curve = new $HDQz6.short(options);
    else if (options.type === 'edwards') this.curve = new $HDQz6.edwards(options);
    else this.curve = new $HDQz6.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $fe68f395281f871e$var$assert(this.g.validate(), 'Invalid curve');
    $fe68f395281f871e$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
$fe68f395281f871e$var$curves.PresetCurve = $fe68f395281f871e$var$PresetCurve;
function $fe68f395281f871e$var$defineCurve(name, options) {
    Object.defineProperty($fe68f395281f871e$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function get() {
            var curve = new $fe68f395281f871e$var$PresetCurve(options);
            Object.defineProperty($fe68f395281f871e$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$fe68f395281f871e$var$defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: $exuq2.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
$fe68f395281f871e$var$defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: $exuq2.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
$fe68f395281f871e$var$defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: $exuq2.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
$fe68f395281f871e$var$defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $exuq2.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$fe68f395281f871e$var$defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $exuq2.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$fe68f395281f871e$var$defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $exuq2.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
$fe68f395281f871e$var$defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $exuq2.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var $fe68f395281f871e$var$pre;

try {
    $fe68f395281f871e$var$pre = (parcelRequire("5pre2"));
} catch (e) {
    $fe68f395281f871e$var$pre = undefined;
}
$fe68f395281f871e$var$defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: $exuq2.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        $fe68f395281f871e$var$pre
    ]
});

});
parcelRegister("exuq2", function(module, exports) {
var $a95bbe4fb5de02af$var$hash = module.exports;

$a95bbe4fb5de02af$var$hash.utils = (parcelRequire("eBkPU"));

$a95bbe4fb5de02af$var$hash.common = (parcelRequire("lWU0e"));

$a95bbe4fb5de02af$var$hash.sha = (parcelRequire("lP7vE"));

$a95bbe4fb5de02af$var$hash.ripemd = (parcelRequire("bjXNk"));

$a95bbe4fb5de02af$var$hash.hmac = (parcelRequire("iZcAm"));
// Proxy hash functions to the main object
$a95bbe4fb5de02af$var$hash.sha1 = $a95bbe4fb5de02af$var$hash.sha.sha1;
$a95bbe4fb5de02af$var$hash.sha256 = $a95bbe4fb5de02af$var$hash.sha.sha256;
$a95bbe4fb5de02af$var$hash.sha224 = $a95bbe4fb5de02af$var$hash.sha.sha224;
$a95bbe4fb5de02af$var$hash.sha384 = $a95bbe4fb5de02af$var$hash.sha.sha384;
$a95bbe4fb5de02af$var$hash.sha512 = $a95bbe4fb5de02af$var$hash.sha.sha512;
$a95bbe4fb5de02af$var$hash.ripemd160 = $a95bbe4fb5de02af$var$hash.ripemd.ripemd160;

});
parcelRegister("eBkPU", function(module, exports) {

$parcel$export(module.exports, "inherits", function () { return $aa14af09c629bbe8$export$69f1b2dcda23c5f8; }, function (v) { return $aa14af09c629bbe8$export$69f1b2dcda23c5f8 = v; });
$parcel$export(module.exports, "toArray", function () { return $aa14af09c629bbe8$export$45b10814cc054894; }, function (v) { return $aa14af09c629bbe8$export$45b10814cc054894 = v; });
$parcel$export(module.exports, "toHex", function () { return $aa14af09c629bbe8$export$7ea66e3774a60b67; }, function (v) { return $aa14af09c629bbe8$export$7ea66e3774a60b67 = v; });
$parcel$export(module.exports, "htonl", function () { return $aa14af09c629bbe8$export$34a52f00f601f6f1; }, function (v) { return $aa14af09c629bbe8$export$34a52f00f601f6f1 = v; });
$parcel$export(module.exports, "toHex32", function () { return $aa14af09c629bbe8$export$812b0cbd5e8a72ab; }, function (v) { return $aa14af09c629bbe8$export$812b0cbd5e8a72ab = v; });
$parcel$export(module.exports, "zero2", function () { return $aa14af09c629bbe8$export$f24f9e11d63bb314; }, function (v) { return $aa14af09c629bbe8$export$f24f9e11d63bb314 = v; });
$parcel$export(module.exports, "zero8", function () { return $aa14af09c629bbe8$export$b71357c7e07ca1f1; }, function (v) { return $aa14af09c629bbe8$export$b71357c7e07ca1f1 = v; });
$parcel$export(module.exports, "join32", function () { return $aa14af09c629bbe8$export$2e58a4b541fdcbe8; }, function (v) { return $aa14af09c629bbe8$export$2e58a4b541fdcbe8 = v; });
$parcel$export(module.exports, "split32", function () { return $aa14af09c629bbe8$export$183b950bde9faab8; }, function (v) { return $aa14af09c629bbe8$export$183b950bde9faab8 = v; });
$parcel$export(module.exports, "rotr32", function () { return $aa14af09c629bbe8$export$4785c77169fea59e; }, function (v) { return $aa14af09c629bbe8$export$4785c77169fea59e = v; });
$parcel$export(module.exports, "rotl32", function () { return $aa14af09c629bbe8$export$242a185dfcffac5b; }, function (v) { return $aa14af09c629bbe8$export$242a185dfcffac5b = v; });
$parcel$export(module.exports, "sum32", function () { return $aa14af09c629bbe8$export$58c04ae0ae31877d; }, function (v) { return $aa14af09c629bbe8$export$58c04ae0ae31877d = v; });
$parcel$export(module.exports, "sum32_3", function () { return $aa14af09c629bbe8$export$d058ca695f8c6f11; }, function (v) { return $aa14af09c629bbe8$export$d058ca695f8c6f11 = v; });
$parcel$export(module.exports, "sum32_4", function () { return $aa14af09c629bbe8$export$a1efd7fc3e986367; }, function (v) { return $aa14af09c629bbe8$export$a1efd7fc3e986367 = v; });
$parcel$export(module.exports, "sum32_5", function () { return $aa14af09c629bbe8$export$bbfea4a2b5abaab4; }, function (v) { return $aa14af09c629bbe8$export$bbfea4a2b5abaab4 = v; });
$parcel$export(module.exports, "sum64", function () { return $aa14af09c629bbe8$export$97ad4afc7de86152; }, function (v) { return $aa14af09c629bbe8$export$97ad4afc7de86152 = v; });
$parcel$export(module.exports, "sum64_hi", function () { return $aa14af09c629bbe8$export$ce4673d9a79f6a4b; }, function (v) { return $aa14af09c629bbe8$export$ce4673d9a79f6a4b = v; });
$parcel$export(module.exports, "sum64_lo", function () { return $aa14af09c629bbe8$export$786cc99fc6eedc0b; }, function (v) { return $aa14af09c629bbe8$export$786cc99fc6eedc0b = v; });
$parcel$export(module.exports, "sum64_4_hi", function () { return $aa14af09c629bbe8$export$45c59b9a1848dd0; }, function (v) { return $aa14af09c629bbe8$export$45c59b9a1848dd0 = v; });
$parcel$export(module.exports, "sum64_4_lo", function () { return $aa14af09c629bbe8$export$50d8f613e76d3034; }, function (v) { return $aa14af09c629bbe8$export$50d8f613e76d3034 = v; });
$parcel$export(module.exports, "sum64_5_hi", function () { return $aa14af09c629bbe8$export$b8e83683c60ee162; }, function (v) { return $aa14af09c629bbe8$export$b8e83683c60ee162 = v; });
$parcel$export(module.exports, "sum64_5_lo", function () { return $aa14af09c629bbe8$export$aeeb51790d1bcc4a; }, function (v) { return $aa14af09c629bbe8$export$aeeb51790d1bcc4a = v; });
$parcel$export(module.exports, "rotr64_hi", function () { return $aa14af09c629bbe8$export$bb7c616f719ad9c; }, function (v) { return $aa14af09c629bbe8$export$bb7c616f719ad9c = v; });
$parcel$export(module.exports, "rotr64_lo", function () { return $aa14af09c629bbe8$export$4d63290824f9d7df; }, function (v) { return $aa14af09c629bbe8$export$4d63290824f9d7df = v; });
$parcel$export(module.exports, "shr64_hi", function () { return $aa14af09c629bbe8$export$2f64ceb90ef28ea1; }, function (v) { return $aa14af09c629bbe8$export$2f64ceb90ef28ea1 = v; });
$parcel$export(module.exports, "shr64_lo", function () { return $aa14af09c629bbe8$export$8d2089d465f6d10d; }, function (v) { return $aa14af09c629bbe8$export$8d2089d465f6d10d = v; });
var $aa14af09c629bbe8$export$69f1b2dcda23c5f8;
var $aa14af09c629bbe8$export$45b10814cc054894;
var $aa14af09c629bbe8$export$7ea66e3774a60b67;
var $aa14af09c629bbe8$export$34a52f00f601f6f1;
var $aa14af09c629bbe8$export$812b0cbd5e8a72ab;
var $aa14af09c629bbe8$export$f24f9e11d63bb314;
var $aa14af09c629bbe8$export$b71357c7e07ca1f1;
var $aa14af09c629bbe8$export$2e58a4b541fdcbe8;
var $aa14af09c629bbe8$export$183b950bde9faab8;
var $aa14af09c629bbe8$export$4785c77169fea59e;
var $aa14af09c629bbe8$export$242a185dfcffac5b;
var $aa14af09c629bbe8$export$58c04ae0ae31877d;
var $aa14af09c629bbe8$export$d058ca695f8c6f11;
var $aa14af09c629bbe8$export$a1efd7fc3e986367;
var $aa14af09c629bbe8$export$bbfea4a2b5abaab4;
var $aa14af09c629bbe8$export$97ad4afc7de86152;
var $aa14af09c629bbe8$export$ce4673d9a79f6a4b;
var $aa14af09c629bbe8$export$786cc99fc6eedc0b;
var $aa14af09c629bbe8$export$45c59b9a1848dd0;
var $aa14af09c629bbe8$export$50d8f613e76d3034;
var $aa14af09c629bbe8$export$b8e83683c60ee162;
var $aa14af09c629bbe8$export$aeeb51790d1bcc4a;
var $aa14af09c629bbe8$export$bb7c616f719ad9c;
var $aa14af09c629bbe8$export$4d63290824f9d7df;
var $aa14af09c629bbe8$export$2f64ceb90ef28ea1;
var $aa14af09c629bbe8$export$8d2089d465f6d10d;
'use strict';

var $3Pc6F = parcelRequire("3Pc6F");

var $6LbC4 = parcelRequire("6LbC4");
$aa14af09c629bbe8$export$69f1b2dcda23c5f8 = $6LbC4;
function $aa14af09c629bbe8$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $aa14af09c629bbe8$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($aa14af09c629bbe8$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$aa14af09c629bbe8$export$45b10814cc054894 = $aa14af09c629bbe8$var$toArray;
function $aa14af09c629bbe8$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $aa14af09c629bbe8$var$zero2(msg[i].toString(16));
    return res;
}
$aa14af09c629bbe8$export$7ea66e3774a60b67 = $aa14af09c629bbe8$var$toHex;
function $aa14af09c629bbe8$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$aa14af09c629bbe8$export$34a52f00f601f6f1 = $aa14af09c629bbe8$var$htonl;
function $aa14af09c629bbe8$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $aa14af09c629bbe8$var$htonl(w);
        res += $aa14af09c629bbe8$var$zero8(w.toString(16));
    }
    return res;
}
$aa14af09c629bbe8$export$812b0cbd5e8a72ab = $aa14af09c629bbe8$var$toHex32;
function $aa14af09c629bbe8$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$aa14af09c629bbe8$export$f24f9e11d63bb314 = $aa14af09c629bbe8$var$zero2;
function $aa14af09c629bbe8$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$aa14af09c629bbe8$export$b71357c7e07ca1f1 = $aa14af09c629bbe8$var$zero8;
function $aa14af09c629bbe8$var$join32(msg, start, end, endian) {
    var len = end - start;
    $3Pc6F(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$aa14af09c629bbe8$export$2e58a4b541fdcbe8 = $aa14af09c629bbe8$var$join32;
function $aa14af09c629bbe8$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$aa14af09c629bbe8$export$183b950bde9faab8 = $aa14af09c629bbe8$var$split32;
function $aa14af09c629bbe8$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$aa14af09c629bbe8$export$4785c77169fea59e = $aa14af09c629bbe8$var$rotr32;
function $aa14af09c629bbe8$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$aa14af09c629bbe8$export$242a185dfcffac5b = $aa14af09c629bbe8$var$rotl32;
function $aa14af09c629bbe8$var$sum32(a, b) {
    return a + b >>> 0;
}
$aa14af09c629bbe8$export$58c04ae0ae31877d = $aa14af09c629bbe8$var$sum32;
function $aa14af09c629bbe8$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$aa14af09c629bbe8$export$d058ca695f8c6f11 = $aa14af09c629bbe8$var$sum32_3;
function $aa14af09c629bbe8$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$aa14af09c629bbe8$export$a1efd7fc3e986367 = $aa14af09c629bbe8$var$sum32_4;
function $aa14af09c629bbe8$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$aa14af09c629bbe8$export$bbfea4a2b5abaab4 = $aa14af09c629bbe8$var$sum32_5;
function $aa14af09c629bbe8$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$aa14af09c629bbe8$export$97ad4afc7de86152 = $aa14af09c629bbe8$var$sum64;
function $aa14af09c629bbe8$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$aa14af09c629bbe8$export$ce4673d9a79f6a4b = $aa14af09c629bbe8$var$sum64_hi;
function $aa14af09c629bbe8$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$aa14af09c629bbe8$export$786cc99fc6eedc0b = $aa14af09c629bbe8$var$sum64_lo;
function $aa14af09c629bbe8$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$aa14af09c629bbe8$export$45c59b9a1848dd0 = $aa14af09c629bbe8$var$sum64_4_hi;
function $aa14af09c629bbe8$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$aa14af09c629bbe8$export$50d8f613e76d3034 = $aa14af09c629bbe8$var$sum64_4_lo;
function $aa14af09c629bbe8$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$aa14af09c629bbe8$export$b8e83683c60ee162 = $aa14af09c629bbe8$var$sum64_5_hi;
function $aa14af09c629bbe8$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$aa14af09c629bbe8$export$aeeb51790d1bcc4a = $aa14af09c629bbe8$var$sum64_5_lo;
function $aa14af09c629bbe8$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$aa14af09c629bbe8$export$bb7c616f719ad9c = $aa14af09c629bbe8$var$rotr64_hi;
function $aa14af09c629bbe8$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$aa14af09c629bbe8$export$4d63290824f9d7df = $aa14af09c629bbe8$var$rotr64_lo;
function $aa14af09c629bbe8$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$aa14af09c629bbe8$export$2f64ceb90ef28ea1 = $aa14af09c629bbe8$var$shr64_hi;
function $aa14af09c629bbe8$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$aa14af09c629bbe8$export$8d2089d465f6d10d = $aa14af09c629bbe8$var$shr64_lo;

});

parcelRegister("lWU0e", function(module, exports) {

$parcel$export(module.exports, "BlockHash", function () { return $ffaa74b5b7009fd9$export$8687658379b577e6; }, function (v) { return $ffaa74b5b7009fd9$export$8687658379b577e6 = v; });
var $ffaa74b5b7009fd9$export$8687658379b577e6;
'use strict';

var $eBkPU = parcelRequire("eBkPU");

var $3Pc6F = parcelRequire("3Pc6F");
function $ffaa74b5b7009fd9$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$ffaa74b5b7009fd9$export$8687658379b577e6 = $ffaa74b5b7009fd9$var$BlockHash;
$ffaa74b5b7009fd9$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $eBkPU.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $eBkPU.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$ffaa74b5b7009fd9$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $3Pc6F(this.pending === null);
    return this._digest(enc);
};
$ffaa74b5b7009fd9$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("lP7vE", function(module, exports) {

$parcel$export(module.exports, "sha1", function () { return $fe342fa6593b48cd$export$5091bdda49ba90f5; }, function (v) { return $fe342fa6593b48cd$export$5091bdda49ba90f5 = v; });
$parcel$export(module.exports, "sha224", function () { return $fe342fa6593b48cd$export$97b70509d4e397ea; }, function (v) { return $fe342fa6593b48cd$export$97b70509d4e397ea = v; });
$parcel$export(module.exports, "sha256", function () { return $fe342fa6593b48cd$export$bced8d2aada2d1c9; }, function (v) { return $fe342fa6593b48cd$export$bced8d2aada2d1c9 = v; });
$parcel$export(module.exports, "sha384", function () { return $fe342fa6593b48cd$export$612d47d55dedde45; }, function (v) { return $fe342fa6593b48cd$export$612d47d55dedde45 = v; });
$parcel$export(module.exports, "sha512", function () { return $fe342fa6593b48cd$export$a888d2532e6dc7bb; }, function (v) { return $fe342fa6593b48cd$export$a888d2532e6dc7bb = v; });
var $fe342fa6593b48cd$export$5091bdda49ba90f5;
var $fe342fa6593b48cd$export$97b70509d4e397ea;
var $fe342fa6593b48cd$export$bced8d2aada2d1c9;
var $fe342fa6593b48cd$export$612d47d55dedde45;
var $fe342fa6593b48cd$export$a888d2532e6dc7bb;
'use strict';

$fe342fa6593b48cd$export$5091bdda49ba90f5 = (parcelRequire("f7MYj"));

$fe342fa6593b48cd$export$97b70509d4e397ea = (parcelRequire("2qMnQ"));

$fe342fa6593b48cd$export$bced8d2aada2d1c9 = (parcelRequire("eujNI"));

$fe342fa6593b48cd$export$612d47d55dedde45 = (parcelRequire("f1Y5j"));

$fe342fa6593b48cd$export$a888d2532e6dc7bb = (parcelRequire("dqfZp"));

});
parcelRegister("f7MYj", function(module, exports) {
'use strict';

var $eBkPU = parcelRequire("eBkPU");

var $lWU0e = parcelRequire("lWU0e");

var $5ubuM = parcelRequire("5ubuM");
var $b02d7f3fc592a9ca$var$rotl32 = $eBkPU.rotl32;
var $b02d7f3fc592a9ca$var$sum32 = $eBkPU.sum32;
var $b02d7f3fc592a9ca$var$sum32_5 = $eBkPU.sum32_5;
var $b02d7f3fc592a9ca$var$ft_1 = $5ubuM.ft_1;
var $b02d7f3fc592a9ca$var$BlockHash = $lWU0e.BlockHash;
var $b02d7f3fc592a9ca$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $b02d7f3fc592a9ca$var$SHA1() {
    if (!(this instanceof $b02d7f3fc592a9ca$var$SHA1)) return new $b02d7f3fc592a9ca$var$SHA1();
    $b02d7f3fc592a9ca$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$eBkPU.inherits($b02d7f3fc592a9ca$var$SHA1, $b02d7f3fc592a9ca$var$BlockHash);
module.exports = $b02d7f3fc592a9ca$var$SHA1;
$b02d7f3fc592a9ca$var$SHA1.blockSize = 512;
$b02d7f3fc592a9ca$var$SHA1.outSize = 160;
$b02d7f3fc592a9ca$var$SHA1.hmacStrength = 80;
$b02d7f3fc592a9ca$var$SHA1.padLength = 64;
$b02d7f3fc592a9ca$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $b02d7f3fc592a9ca$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $b02d7f3fc592a9ca$var$sum32_5($b02d7f3fc592a9ca$var$rotl32(a, 5), $b02d7f3fc592a9ca$var$ft_1(s, b, c, d), e, W[i], $b02d7f3fc592a9ca$var$sha1_K[s]);
        e = d;
        d = c;
        c = $b02d7f3fc592a9ca$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $b02d7f3fc592a9ca$var$sum32(this.h[0], a);
    this.h[1] = $b02d7f3fc592a9ca$var$sum32(this.h[1], b);
    this.h[2] = $b02d7f3fc592a9ca$var$sum32(this.h[2], c);
    this.h[3] = $b02d7f3fc592a9ca$var$sum32(this.h[3], d);
    this.h[4] = $b02d7f3fc592a9ca$var$sum32(this.h[4], e);
};
$b02d7f3fc592a9ca$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $eBkPU.toHex32(this.h, 'big');
    else return $eBkPU.split32(this.h, 'big');
};

});
parcelRegister("5ubuM", function(module, exports) {

$parcel$export(module.exports, "ft_1", function () { return $3fe8abda3a94bef7$export$5a92649d7ddb9f63; }, function (v) { return $3fe8abda3a94bef7$export$5a92649d7ddb9f63 = v; });
$parcel$export(module.exports, "ch32", function () { return $3fe8abda3a94bef7$export$c6d0d020c3a6269; }, function (v) { return $3fe8abda3a94bef7$export$c6d0d020c3a6269 = v; });
$parcel$export(module.exports, "maj32", function () { return $3fe8abda3a94bef7$export$eb90c27fca05f956; }, function (v) { return $3fe8abda3a94bef7$export$eb90c27fca05f956 = v; });
$parcel$export(module.exports, "s0_256", function () { return $3fe8abda3a94bef7$export$14a4a98e063b1999; }, function (v) { return $3fe8abda3a94bef7$export$14a4a98e063b1999 = v; });
$parcel$export(module.exports, "s1_256", function () { return $3fe8abda3a94bef7$export$d20cecfa1564c686; }, function (v) { return $3fe8abda3a94bef7$export$d20cecfa1564c686 = v; });
$parcel$export(module.exports, "g0_256", function () { return $3fe8abda3a94bef7$export$44fd472a12fc6db; }, function (v) { return $3fe8abda3a94bef7$export$44fd472a12fc6db = v; });
$parcel$export(module.exports, "g1_256", function () { return $3fe8abda3a94bef7$export$1ed238bb6ea1dd47; }, function (v) { return $3fe8abda3a94bef7$export$1ed238bb6ea1dd47 = v; });
var $3fe8abda3a94bef7$export$5a92649d7ddb9f63;
var $3fe8abda3a94bef7$export$c6d0d020c3a6269;
var $3fe8abda3a94bef7$export$eb90c27fca05f956;
var $3fe8abda3a94bef7$export$cc992891a14496a1;
var $3fe8abda3a94bef7$export$14a4a98e063b1999;
var $3fe8abda3a94bef7$export$d20cecfa1564c686;
var $3fe8abda3a94bef7$export$44fd472a12fc6db;
var $3fe8abda3a94bef7$export$1ed238bb6ea1dd47;
'use strict';

var $eBkPU = parcelRequire("eBkPU");
var $3fe8abda3a94bef7$var$rotr32 = $eBkPU.rotr32;
function $3fe8abda3a94bef7$var$ft_1(s, x, y, z) {
    if (s === 0) return $3fe8abda3a94bef7$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $3fe8abda3a94bef7$var$p32(x, y, z);
    if (s === 2) return $3fe8abda3a94bef7$var$maj32(x, y, z);
}
$3fe8abda3a94bef7$export$5a92649d7ddb9f63 = $3fe8abda3a94bef7$var$ft_1;
function $3fe8abda3a94bef7$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$3fe8abda3a94bef7$export$c6d0d020c3a6269 = $3fe8abda3a94bef7$var$ch32;
function $3fe8abda3a94bef7$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$3fe8abda3a94bef7$export$eb90c27fca05f956 = $3fe8abda3a94bef7$var$maj32;
function $3fe8abda3a94bef7$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$3fe8abda3a94bef7$export$cc992891a14496a1 = $3fe8abda3a94bef7$var$p32;
function $3fe8abda3a94bef7$var$s0_256(x) {
    return $3fe8abda3a94bef7$var$rotr32(x, 2) ^ $3fe8abda3a94bef7$var$rotr32(x, 13) ^ $3fe8abda3a94bef7$var$rotr32(x, 22);
}
$3fe8abda3a94bef7$export$14a4a98e063b1999 = $3fe8abda3a94bef7$var$s0_256;
function $3fe8abda3a94bef7$var$s1_256(x) {
    return $3fe8abda3a94bef7$var$rotr32(x, 6) ^ $3fe8abda3a94bef7$var$rotr32(x, 11) ^ $3fe8abda3a94bef7$var$rotr32(x, 25);
}
$3fe8abda3a94bef7$export$d20cecfa1564c686 = $3fe8abda3a94bef7$var$s1_256;
function $3fe8abda3a94bef7$var$g0_256(x) {
    return $3fe8abda3a94bef7$var$rotr32(x, 7) ^ $3fe8abda3a94bef7$var$rotr32(x, 18) ^ x >>> 3;
}
$3fe8abda3a94bef7$export$44fd472a12fc6db = $3fe8abda3a94bef7$var$g0_256;
function $3fe8abda3a94bef7$var$g1_256(x) {
    return $3fe8abda3a94bef7$var$rotr32(x, 17) ^ $3fe8abda3a94bef7$var$rotr32(x, 19) ^ x >>> 10;
}
$3fe8abda3a94bef7$export$1ed238bb6ea1dd47 = $3fe8abda3a94bef7$var$g1_256;

});


parcelRegister("2qMnQ", function(module, exports) {
'use strict';

var $eBkPU = parcelRequire("eBkPU");

var $eujNI = parcelRequire("eujNI");
function $1c538a6d8622e899$var$SHA224() {
    if (!(this instanceof $1c538a6d8622e899$var$SHA224)) return new $1c538a6d8622e899$var$SHA224();
    $eujNI.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$eBkPU.inherits($1c538a6d8622e899$var$SHA224, $eujNI);
module.exports = $1c538a6d8622e899$var$SHA224;
$1c538a6d8622e899$var$SHA224.blockSize = 512;
$1c538a6d8622e899$var$SHA224.outSize = 224;
$1c538a6d8622e899$var$SHA224.hmacStrength = 192;
$1c538a6d8622e899$var$SHA224.padLength = 64;
$1c538a6d8622e899$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $eBkPU.toHex32(this.h.slice(0, 7), 'big');
    else return $eBkPU.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("eujNI", function(module, exports) {
'use strict';

var $eBkPU = parcelRequire("eBkPU");

var $lWU0e = parcelRequire("lWU0e");

var $5ubuM = parcelRequire("5ubuM");

var $3Pc6F = parcelRequire("3Pc6F");
var $a8c33a156df0afb3$var$sum32 = $eBkPU.sum32;
var $a8c33a156df0afb3$var$sum32_4 = $eBkPU.sum32_4;
var $a8c33a156df0afb3$var$sum32_5 = $eBkPU.sum32_5;
var $a8c33a156df0afb3$var$ch32 = $5ubuM.ch32;
var $a8c33a156df0afb3$var$maj32 = $5ubuM.maj32;
var $a8c33a156df0afb3$var$s0_256 = $5ubuM.s0_256;
var $a8c33a156df0afb3$var$s1_256 = $5ubuM.s1_256;
var $a8c33a156df0afb3$var$g0_256 = $5ubuM.g0_256;
var $a8c33a156df0afb3$var$g1_256 = $5ubuM.g1_256;
var $a8c33a156df0afb3$var$BlockHash = $lWU0e.BlockHash;
var $a8c33a156df0afb3$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $a8c33a156df0afb3$var$SHA256() {
    if (!(this instanceof $a8c33a156df0afb3$var$SHA256)) return new $a8c33a156df0afb3$var$SHA256();
    $a8c33a156df0afb3$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $a8c33a156df0afb3$var$sha256_K;
    this.W = new Array(64);
}
$eBkPU.inherits($a8c33a156df0afb3$var$SHA256, $a8c33a156df0afb3$var$BlockHash);
module.exports = $a8c33a156df0afb3$var$SHA256;
$a8c33a156df0afb3$var$SHA256.blockSize = 512;
$a8c33a156df0afb3$var$SHA256.outSize = 256;
$a8c33a156df0afb3$var$SHA256.hmacStrength = 192;
$a8c33a156df0afb3$var$SHA256.padLength = 64;
$a8c33a156df0afb3$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $a8c33a156df0afb3$var$sum32_4($a8c33a156df0afb3$var$g1_256(W[i - 2]), W[i - 7], $a8c33a156df0afb3$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $3Pc6F(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $a8c33a156df0afb3$var$sum32_5(h, $a8c33a156df0afb3$var$s1_256(e), $a8c33a156df0afb3$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $a8c33a156df0afb3$var$sum32($a8c33a156df0afb3$var$s0_256(a), $a8c33a156df0afb3$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $a8c33a156df0afb3$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $a8c33a156df0afb3$var$sum32(T1, T2);
    }
    this.h[0] = $a8c33a156df0afb3$var$sum32(this.h[0], a);
    this.h[1] = $a8c33a156df0afb3$var$sum32(this.h[1], b);
    this.h[2] = $a8c33a156df0afb3$var$sum32(this.h[2], c);
    this.h[3] = $a8c33a156df0afb3$var$sum32(this.h[3], d);
    this.h[4] = $a8c33a156df0afb3$var$sum32(this.h[4], e);
    this.h[5] = $a8c33a156df0afb3$var$sum32(this.h[5], f);
    this.h[6] = $a8c33a156df0afb3$var$sum32(this.h[6], g);
    this.h[7] = $a8c33a156df0afb3$var$sum32(this.h[7], h);
};
$a8c33a156df0afb3$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $eBkPU.toHex32(this.h, 'big');
    else return $eBkPU.split32(this.h, 'big');
};

});


parcelRegister("f1Y5j", function(module, exports) {
'use strict';

var $eBkPU = parcelRequire("eBkPU");

var $dqfZp = parcelRequire("dqfZp");
function $af158e9822786df5$var$SHA384() {
    if (!(this instanceof $af158e9822786df5$var$SHA384)) return new $af158e9822786df5$var$SHA384();
    $dqfZp.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$eBkPU.inherits($af158e9822786df5$var$SHA384, $dqfZp);
module.exports = $af158e9822786df5$var$SHA384;
$af158e9822786df5$var$SHA384.blockSize = 1024;
$af158e9822786df5$var$SHA384.outSize = 384;
$af158e9822786df5$var$SHA384.hmacStrength = 192;
$af158e9822786df5$var$SHA384.padLength = 128;
$af158e9822786df5$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $eBkPU.toHex32(this.h.slice(0, 12), 'big');
    else return $eBkPU.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("dqfZp", function(module, exports) {
'use strict';

var $eBkPU = parcelRequire("eBkPU");

var $lWU0e = parcelRequire("lWU0e");

var $3Pc6F = parcelRequire("3Pc6F");
var $9c5a1b3cc17c7d94$var$rotr64_hi = $eBkPU.rotr64_hi;
var $9c5a1b3cc17c7d94$var$rotr64_lo = $eBkPU.rotr64_lo;
var $9c5a1b3cc17c7d94$var$shr64_hi = $eBkPU.shr64_hi;
var $9c5a1b3cc17c7d94$var$shr64_lo = $eBkPU.shr64_lo;
var $9c5a1b3cc17c7d94$var$sum64 = $eBkPU.sum64;
var $9c5a1b3cc17c7d94$var$sum64_hi = $eBkPU.sum64_hi;
var $9c5a1b3cc17c7d94$var$sum64_lo = $eBkPU.sum64_lo;
var $9c5a1b3cc17c7d94$var$sum64_4_hi = $eBkPU.sum64_4_hi;
var $9c5a1b3cc17c7d94$var$sum64_4_lo = $eBkPU.sum64_4_lo;
var $9c5a1b3cc17c7d94$var$sum64_5_hi = $eBkPU.sum64_5_hi;
var $9c5a1b3cc17c7d94$var$sum64_5_lo = $eBkPU.sum64_5_lo;
var $9c5a1b3cc17c7d94$var$BlockHash = $lWU0e.BlockHash;
var $9c5a1b3cc17c7d94$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $9c5a1b3cc17c7d94$var$SHA512() {
    if (!(this instanceof $9c5a1b3cc17c7d94$var$SHA512)) return new $9c5a1b3cc17c7d94$var$SHA512();
    $9c5a1b3cc17c7d94$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $9c5a1b3cc17c7d94$var$sha512_K;
    this.W = new Array(160);
}
$eBkPU.inherits($9c5a1b3cc17c7d94$var$SHA512, $9c5a1b3cc17c7d94$var$BlockHash);
module.exports = $9c5a1b3cc17c7d94$var$SHA512;
$9c5a1b3cc17c7d94$var$SHA512.blockSize = 1024;
$9c5a1b3cc17c7d94$var$SHA512.outSize = 512;
$9c5a1b3cc17c7d94$var$SHA512.hmacStrength = 192;
$9c5a1b3cc17c7d94$var$SHA512.padLength = 128;
$9c5a1b3cc17c7d94$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $9c5a1b3cc17c7d94$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $9c5a1b3cc17c7d94$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $9c5a1b3cc17c7d94$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $9c5a1b3cc17c7d94$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $9c5a1b3cc17c7d94$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $9c5a1b3cc17c7d94$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$9c5a1b3cc17c7d94$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $3Pc6F(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $9c5a1b3cc17c7d94$var$s1_512_hi(eh, el);
        var c1_lo = $9c5a1b3cc17c7d94$var$s1_512_lo(eh, el);
        var c2_hi = $9c5a1b3cc17c7d94$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $9c5a1b3cc17c7d94$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $9c5a1b3cc17c7d94$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $9c5a1b3cc17c7d94$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $9c5a1b3cc17c7d94$var$s0_512_hi(ah, al);
        c0_lo = $9c5a1b3cc17c7d94$var$s0_512_lo(ah, al);
        c1_hi = $9c5a1b3cc17c7d94$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $9c5a1b3cc17c7d94$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $9c5a1b3cc17c7d94$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $9c5a1b3cc17c7d94$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $9c5a1b3cc17c7d94$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $9c5a1b3cc17c7d94$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $9c5a1b3cc17c7d94$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $9c5a1b3cc17c7d94$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $9c5a1b3cc17c7d94$var$sum64(this.h, 0, ah, al);
    $9c5a1b3cc17c7d94$var$sum64(this.h, 2, bh, bl);
    $9c5a1b3cc17c7d94$var$sum64(this.h, 4, ch, cl);
    $9c5a1b3cc17c7d94$var$sum64(this.h, 6, dh, dl);
    $9c5a1b3cc17c7d94$var$sum64(this.h, 8, eh, el);
    $9c5a1b3cc17c7d94$var$sum64(this.h, 10, fh, fl);
    $9c5a1b3cc17c7d94$var$sum64(this.h, 12, gh, gl);
    $9c5a1b3cc17c7d94$var$sum64(this.h, 14, hh, hl);
};
$9c5a1b3cc17c7d94$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $eBkPU.toHex32(this.h, 'big');
    else return $eBkPU.split32(this.h, 'big');
};
function $9c5a1b3cc17c7d94$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9c5a1b3cc17c7d94$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9c5a1b3cc17c7d94$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9c5a1b3cc17c7d94$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9c5a1b3cc17c7d94$var$s0_512_hi(xh, xl) {
    var c0_hi = $9c5a1b3cc17c7d94$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $9c5a1b3cc17c7d94$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $9c5a1b3cc17c7d94$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9c5a1b3cc17c7d94$var$s0_512_lo(xh, xl) {
    var c0_lo = $9c5a1b3cc17c7d94$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $9c5a1b3cc17c7d94$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $9c5a1b3cc17c7d94$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9c5a1b3cc17c7d94$var$s1_512_hi(xh, xl) {
    var c0_hi = $9c5a1b3cc17c7d94$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $9c5a1b3cc17c7d94$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $9c5a1b3cc17c7d94$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9c5a1b3cc17c7d94$var$s1_512_lo(xh, xl) {
    var c0_lo = $9c5a1b3cc17c7d94$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $9c5a1b3cc17c7d94$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $9c5a1b3cc17c7d94$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9c5a1b3cc17c7d94$var$g0_512_hi(xh, xl) {
    var c0_hi = $9c5a1b3cc17c7d94$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $9c5a1b3cc17c7d94$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $9c5a1b3cc17c7d94$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9c5a1b3cc17c7d94$var$g0_512_lo(xh, xl) {
    var c0_lo = $9c5a1b3cc17c7d94$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $9c5a1b3cc17c7d94$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $9c5a1b3cc17c7d94$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9c5a1b3cc17c7d94$var$g1_512_hi(xh, xl) {
    var c0_hi = $9c5a1b3cc17c7d94$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $9c5a1b3cc17c7d94$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $9c5a1b3cc17c7d94$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9c5a1b3cc17c7d94$var$g1_512_lo(xh, xl) {
    var c0_lo = $9c5a1b3cc17c7d94$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $9c5a1b3cc17c7d94$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $9c5a1b3cc17c7d94$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("bjXNk", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $83dfda0b85a3c989$export$d1cea0ee4e3f0d3e; }, function (v) { return $83dfda0b85a3c989$export$d1cea0ee4e3f0d3e = v; });
var $83dfda0b85a3c989$export$d1cea0ee4e3f0d3e;
'use strict';

var $eBkPU = parcelRequire("eBkPU");

var $lWU0e = parcelRequire("lWU0e");
var $83dfda0b85a3c989$var$rotl32 = $eBkPU.rotl32;
var $83dfda0b85a3c989$var$sum32 = $eBkPU.sum32;
var $83dfda0b85a3c989$var$sum32_3 = $eBkPU.sum32_3;
var $83dfda0b85a3c989$var$sum32_4 = $eBkPU.sum32_4;
var $83dfda0b85a3c989$var$BlockHash = $lWU0e.BlockHash;
function $83dfda0b85a3c989$var$RIPEMD160() {
    if (!(this instanceof $83dfda0b85a3c989$var$RIPEMD160)) return new $83dfda0b85a3c989$var$RIPEMD160();
    $83dfda0b85a3c989$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$eBkPU.inherits($83dfda0b85a3c989$var$RIPEMD160, $83dfda0b85a3c989$var$BlockHash);
$83dfda0b85a3c989$export$d1cea0ee4e3f0d3e = $83dfda0b85a3c989$var$RIPEMD160;
$83dfda0b85a3c989$var$RIPEMD160.blockSize = 512;
$83dfda0b85a3c989$var$RIPEMD160.outSize = 160;
$83dfda0b85a3c989$var$RIPEMD160.hmacStrength = 192;
$83dfda0b85a3c989$var$RIPEMD160.padLength = 64;
$83dfda0b85a3c989$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $83dfda0b85a3c989$var$sum32($83dfda0b85a3c989$var$rotl32($83dfda0b85a3c989$var$sum32_4(A, $83dfda0b85a3c989$var$f(j, B, C, D), msg[$83dfda0b85a3c989$var$r[j] + start], $83dfda0b85a3c989$var$K(j)), $83dfda0b85a3c989$var$s[j]), E);
        A = E;
        E = D;
        D = $83dfda0b85a3c989$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $83dfda0b85a3c989$var$sum32($83dfda0b85a3c989$var$rotl32($83dfda0b85a3c989$var$sum32_4(Ah, $83dfda0b85a3c989$var$f(79 - j, Bh, Ch, Dh), msg[$83dfda0b85a3c989$var$rh[j] + start], $83dfda0b85a3c989$var$Kh(j)), $83dfda0b85a3c989$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $83dfda0b85a3c989$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $83dfda0b85a3c989$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $83dfda0b85a3c989$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $83dfda0b85a3c989$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $83dfda0b85a3c989$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $83dfda0b85a3c989$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$83dfda0b85a3c989$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $eBkPU.toHex32(this.h, 'little');
    else return $eBkPU.split32(this.h, 'little');
};
function $83dfda0b85a3c989$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $83dfda0b85a3c989$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $83dfda0b85a3c989$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $83dfda0b85a3c989$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $83dfda0b85a3c989$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $83dfda0b85a3c989$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $83dfda0b85a3c989$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("iZcAm", function(module, exports) {
'use strict';

var $eBkPU = parcelRequire("eBkPU");

var $3Pc6F = parcelRequire("3Pc6F");
function $dd27afafe6a9df90$var$Hmac(hash, key, enc) {
    if (!(this instanceof $dd27afafe6a9df90$var$Hmac)) return new $dd27afafe6a9df90$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($eBkPU.toArray(key, enc));
}
module.exports = $dd27afafe6a9df90$var$Hmac;
$dd27afafe6a9df90$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $3Pc6F(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$dd27afafe6a9df90$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$dd27afafe6a9df90$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("5pre2", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

});


parcelRegister("a0TyH", function(module, exports) {

var $qb7pP = parcelRequire("qb7pP");
'use strict';

var $35J5F = parcelRequire("35J5F");

var $5Y7JE = parcelRequire("5Y7JE");

var $8Wc9V = parcelRequire("8Wc9V");

var $lQdx5 = parcelRequire("lQdx5");

var $5oleY = parcelRequire("5oleY");
var $74a5003e2707318f$var$assert = $8Wc9V.assert;

var $5hJr2 = parcelRequire("5hJr2");

var $4umzj = parcelRequire("4umzj");
function $74a5003e2707318f$var$EC(options) {
    if (!(this instanceof $74a5003e2707318f$var$EC)) return new $74a5003e2707318f$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $74a5003e2707318f$var$assert(Object.prototype.hasOwnProperty.call($lQdx5, options), 'Unknown curve ' + options);
        options = $lQdx5[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $lQdx5.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $74a5003e2707318f$var$EC;
$74a5003e2707318f$var$EC.prototype.keyPair = function keyPair(options) {
    return new $5hJr2(this, options);
};
$74a5003e2707318f$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $5hJr2.fromPrivate(this, priv, enc);
};
$74a5003e2707318f$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $5hJr2.fromPublic(this, pub, enc);
};
$74a5003e2707318f$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $5Y7JE({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $5oleY(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $35J5F(2));
    for(;;){
        var priv = new $35J5F(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$74a5003e2707318f$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
    var byteLength;
    if ($35J5F.isBN(msg) || typeof msg === 'number') {
        msg = new $35J5F(msg, 16);
        byteLength = msg.byteLength();
    } else if ((typeof msg === "undefined" ? "undefined" : (0, $qb7pP._)(msg)) === 'object') {
        // BN assumes an array-like input and asserts length
        byteLength = msg.length;
        msg = new $35J5F(msg, 16);
    } else {
        // BN converts the value to string
        var str = msg.toString();
        // HEX encoding
        byteLength = str.length + 1 >>> 1;
        msg = new $35J5F(str, 16);
    }
    // Allow overriding
    if (typeof bitLength !== 'number') bitLength = byteLength * 8;
    var delta = bitLength - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$74a5003e2707318f$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if ((typeof enc === "undefined" ? "undefined" : (0, $qb7pP._)(enc)) === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    if (typeof msg !== 'string' && typeof msg !== 'number' && !$35J5F.isBN(msg)) {
        $74a5003e2707318f$var$assert((typeof msg === "undefined" ? "undefined" : (0, $qb7pP._)(msg)) === 'object' && msg && typeof msg.length === 'number', 'Expected message to be an array-like, a hex string, or a BN instance');
        $74a5003e2707318f$var$assert(msg.length >>> 0 === msg.length); // non-negative 32-bit integer
        for(var i = 0; i < msg.length; i++)$74a5003e2707318f$var$assert((msg[i] & 255) === msg[i]);
    }
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(msg, false, options.msgBitLength);
    // Would fail further checks, but let's make the error message clear
    $74a5003e2707318f$var$assert(!msg.isNeg(), 'Can not sign a negative message');
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Recheck nonce to be bijective to msg
    $74a5003e2707318f$var$assert(new $35J5F(nonce).eq(msg), 'Can not sign message');
    // Instantiate Hmac_DRBG
    var drbg = new $5Y7JE({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $35J5F(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $35J5F(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $4umzj({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$74a5003e2707318f$var$EC.prototype.verify = function verify(msg, signature, key, enc, options) {
    if (!options) options = {};
    msg = this._truncateToN(msg, false, options.msgBitLength);
    key = this.keyFromPublic(key, enc);
    signature = new $4umzj(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$74a5003e2707318f$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $74a5003e2707318f$var$assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new $4umzj(signature, enc);
    var n = this.n;
    var e = new $35J5F(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$74a5003e2707318f$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $4umzj(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

});
parcelRegister("5Y7JE", function(module, exports) {
'use strict';

var $exuq2 = parcelRequire("exuq2");

var $46wbx = parcelRequire("46wbx");

var $3Pc6F = parcelRequire("3Pc6F");
function $45888e6f2bbc0f95$var$HmacDRBG(options) {
    if (!(this instanceof $45888e6f2bbc0f95$var$HmacDRBG)) return new $45888e6f2bbc0f95$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $46wbx.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $46wbx.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $46wbx.toArray(options.pers, options.persEnc || 'hex');
    $3Pc6F(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
module.exports = $45888e6f2bbc0f95$var$HmacDRBG;
$45888e6f2bbc0f95$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$45888e6f2bbc0f95$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $exuq2.hmac(this.hash, this.K);
};
$45888e6f2bbc0f95$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$45888e6f2bbc0f95$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $46wbx.toArray(entropy, entropyEnc);
    add = $46wbx.toArray(add, addEnc);
    $3Pc6F(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$45888e6f2bbc0f95$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $46wbx.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $46wbx.encode(res, enc);
};

});

parcelRegister("5hJr2", function(module, exports) {
'use strict';

var $35J5F = parcelRequire("35J5F");

var $8Wc9V = parcelRequire("8Wc9V");
var $3d91c8bc6576bb98$var$assert = $8Wc9V.assert;
function $3d91c8bc6576bb98$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $3d91c8bc6576bb98$var$KeyPair;
$3d91c8bc6576bb98$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $3d91c8bc6576bb98$var$KeyPair) return pub;
    return new $3d91c8bc6576bb98$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$3d91c8bc6576bb98$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $3d91c8bc6576bb98$var$KeyPair) return priv;
    return new $3d91c8bc6576bb98$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$3d91c8bc6576bb98$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$3d91c8bc6576bb98$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$3d91c8bc6576bb98$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$3d91c8bc6576bb98$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $35J5F(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$3d91c8bc6576bb98$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $3d91c8bc6576bb98$var$assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $3d91c8bc6576bb98$var$assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$3d91c8bc6576bb98$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $3d91c8bc6576bb98$var$assert(pub.validate(), 'public point not validated');
    return pub.mul(this.priv).getX();
};
// ECDSA
$3d91c8bc6576bb98$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$3d91c8bc6576bb98$var$KeyPair.prototype.verify = function verify(msg, signature, options) {
    return this.ec.verify(msg, signature, this, undefined, options);
};
$3d91c8bc6576bb98$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

});

parcelRegister("4umzj", function(module, exports) {
'use strict';

var $35J5F = parcelRequire("35J5F");

var $8Wc9V = parcelRequire("8Wc9V");
var $344b7869c26bb490$var$assert = $8Wc9V.assert;
function $344b7869c26bb490$var$Signature(options, enc) {
    if (options instanceof $344b7869c26bb490$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $344b7869c26bb490$var$assert(options.r && options.s, 'Signature without r or s');
    this.r = new $35J5F(options.r, 16);
    this.s = new $35J5F(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $344b7869c26bb490$var$Signature;
function $344b7869c26bb490$var$Position() {
    this.place = 0;
}
function $344b7869c26bb490$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $344b7869c26bb490$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$344b7869c26bb490$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $8Wc9V.toArray(data, enc);
    var p = new $344b7869c26bb490$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $344b7869c26bb490$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $344b7869c26bb490$var$getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $344b7869c26bb490$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $35J5F(r);
    this.s = new $35J5F(s);
    this.recoveryParam = null;
    return true;
};
function $344b7869c26bb490$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$344b7869c26bb490$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $344b7869c26bb490$var$rmPadding(r);
    s = $344b7869c26bb490$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $344b7869c26bb490$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $344b7869c26bb490$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $344b7869c26bb490$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $8Wc9V.encode(res, enc);
};

});


parcelRegister("5eaPJ", function(module, exports) {
'use strict';

var $exuq2 = parcelRequire("exuq2");

var $lQdx5 = parcelRequire("lQdx5");

var $8Wc9V = parcelRequire("8Wc9V");
var $3ce6a9d65147a195$var$assert = $8Wc9V.assert;
var $3ce6a9d65147a195$var$parseBytes = $8Wc9V.parseBytes;

var $bZVVn = parcelRequire("bZVVn");

var $eBHA7 = parcelRequire("eBHA7");
function $3ce6a9d65147a195$var$EDDSA(curve) {
    $3ce6a9d65147a195$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof $3ce6a9d65147a195$var$EDDSA)) return new $3ce6a9d65147a195$var$EDDSA(curve);
    curve = $lQdx5[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $exuq2.sha512;
}
module.exports = $3ce6a9d65147a195$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $3ce6a9d65147a195$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $3ce6a9d65147a195$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $3ce6a9d65147a195$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $3ce6a9d65147a195$var$parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$3ce6a9d65147a195$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $8Wc9V.intFromLE(hash.digest()).umod(this.curve.n);
};
$3ce6a9d65147a195$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $bZVVn.fromPublic(this, pub);
};
$3ce6a9d65147a195$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $bZVVn.fromSecret(this, secret);
};
$3ce6a9d65147a195$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $eBHA7) return sig;
    return new $eBHA7(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $3ce6a9d65147a195$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$3ce6a9d65147a195$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $8Wc9V.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $8Wc9V.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$3ce6a9d65147a195$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
$3ce6a9d65147a195$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $8Wc9V.intFromLE(bytes);
};
$3ce6a9d65147a195$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("bZVVn", function(module, exports) {
'use strict';

var $8Wc9V = parcelRequire("8Wc9V");
var $8bc252c787e30ff2$var$assert = $8Wc9V.assert;
var $8bc252c787e30ff2$var$parseBytes = $8Wc9V.parseBytes;
var $8bc252c787e30ff2$var$cachedProperty = $8Wc9V.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $8bc252c787e30ff2$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $8bc252c787e30ff2$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $8bc252c787e30ff2$var$parseBytes(params.pub);
}
$8bc252c787e30ff2$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $8bc252c787e30ff2$var$KeyPair) return pub;
    return new $8bc252c787e30ff2$var$KeyPair(eddsa, {
        pub: pub
    });
};
$8bc252c787e30ff2$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $8bc252c787e30ff2$var$KeyPair) return secret;
    return new $8bc252c787e30ff2$var$KeyPair(eddsa, {
        secret: secret
    });
};
$8bc252c787e30ff2$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$8bc252c787e30ff2$var$cachedProperty($8bc252c787e30ff2$var$KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$8bc252c787e30ff2$var$cachedProperty($8bc252c787e30ff2$var$KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$8bc252c787e30ff2$var$cachedProperty($8bc252c787e30ff2$var$KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$8bc252c787e30ff2$var$cachedProperty($8bc252c787e30ff2$var$KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$8bc252c787e30ff2$var$cachedProperty($8bc252c787e30ff2$var$KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$8bc252c787e30ff2$var$cachedProperty($8bc252c787e30ff2$var$KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$8bc252c787e30ff2$var$KeyPair.prototype.sign = function sign(message) {
    $8bc252c787e30ff2$var$assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
$8bc252c787e30ff2$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$8bc252c787e30ff2$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $8bc252c787e30ff2$var$assert(this._secret, 'KeyPair is public only');
    return $8Wc9V.encode(this.secret(), enc);
};
$8bc252c787e30ff2$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $8Wc9V.encode(this.pubBytes(), enc);
};
module.exports = $8bc252c787e30ff2$var$KeyPair;

});

parcelRegister("eBHA7", function(module, exports) {

var $qb7pP = parcelRequire("qb7pP");
'use strict';

var $35J5F = parcelRequire("35J5F");

var $8Wc9V = parcelRequire("8Wc9V");
var $aa2653ce4d2e06f7$var$assert = $8Wc9V.assert;
var $aa2653ce4d2e06f7$var$cachedProperty = $8Wc9V.cachedProperty;
var $aa2653ce4d2e06f7$var$parseBytes = $8Wc9V.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $aa2653ce4d2e06f7$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if ((typeof sig === "undefined" ? "undefined" : (0, $qb7pP._)(sig)) !== 'object') sig = $aa2653ce4d2e06f7$var$parseBytes(sig);
    if (Array.isArray(sig)) {
        $aa2653ce4d2e06f7$var$assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    $aa2653ce4d2e06f7$var$assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $35J5F) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$aa2653ce4d2e06f7$var$cachedProperty($aa2653ce4d2e06f7$var$Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$aa2653ce4d2e06f7$var$cachedProperty($aa2653ce4d2e06f7$var$Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$aa2653ce4d2e06f7$var$cachedProperty($aa2653ce4d2e06f7$var$Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$aa2653ce4d2e06f7$var$cachedProperty($aa2653ce4d2e06f7$var$Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$aa2653ce4d2e06f7$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$aa2653ce4d2e06f7$var$Signature.prototype.toHex = function toHex() {
    return $8Wc9V.encode(this.toBytes(), 'hex').toUpperCase();
};
module.exports = $aa2653ce4d2e06f7$var$Signature;

});



parcelRegister("4SshR", function(module, exports) {

var $qb7pP = parcelRequire("qb7pP");
'use strict';

var $cZiFg = parcelRequire("cZiFg");

var $jCdVD = parcelRequire("jCdVD");

var $fMMSA = parcelRequire("fMMSA");

var $8rjBu = parcelRequire("8rjBu");

var $lRKNN = parcelRequire("lRKNN");

var $5PcLP = parcelRequire("5PcLP");
var $38d225ce92b65c7c$require$Buffer = $5PcLP.Buffer;
function $38d225ce92b65c7c$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $jCdVD[data.algorithm.decrypt.cipher.algo.join('.')];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split('-')[1], 10) / 8;
    var key = $lRKNN.pbkdf2Sync(password, salt, iters, keylen, 'sha1');
    var cipher = $8rjBu.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher['final']());
    return $38d225ce92b65c7c$require$Buffer.concat(out);
}
function $38d225ce92b65c7c$var$parseKeys(buffer) {
    var password;
    if ((typeof buffer === "undefined" ? "undefined" : (0, $qb7pP._)(buffer)) === 'object' && !$38d225ce92b65c7c$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === 'string') buffer = $38d225ce92b65c7c$require$Buffer.from(buffer);
    var stripped = $fMMSA(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case 'CERTIFICATE':
            ndata = $cZiFg.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case 'PUBLIC KEY':
            if (!ndata) ndata = $cZiFg.PublicKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $cZiFg.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: 'ec',
                        data: ndata
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.pub_key = $cZiFg.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                    return {
                        type: 'dsa',
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'ENCRYPTED PRIVATE KEY':
            data = $cZiFg.EncryptedPrivateKey.decode(data, 'der');
            data = $38d225ce92b65c7c$var$decrypt(data, password);
        // falls through
        case 'PRIVATE KEY':
            ndata = $cZiFg.PrivateKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $cZiFg.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $cZiFg.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.priv_key = $cZiFg.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                    return {
                        type: 'dsa',
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'RSA PUBLIC KEY':
            return $cZiFg.RSAPublicKey.decode(data, 'der');
        case 'RSA PRIVATE KEY':
            return $cZiFg.RSAPrivateKey.decode(data, 'der');
        case 'DSA PRIVATE KEY':
            return {
                type: 'dsa',
                params: $cZiFg.DSAPrivateKey.decode(data, 'der')
            };
        case 'EC PRIVATE KEY':
            data = $cZiFg.ECPrivateKey.decode(data, 'der');
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error('unknown key type ' + type);
    }
}
$38d225ce92b65c7c$var$parseKeys.signature = $cZiFg.signature;
module.exports = $38d225ce92b65c7c$var$parseKeys;

});
parcelRegister("cZiFg", function(module, exports) {

$parcel$export(module.exports, "certificate", function () { return $9749a8efd863fd79$export$c98397a6eb8d0678; }, function (v) { return $9749a8efd863fd79$export$c98397a6eb8d0678 = v; });
$parcel$export(module.exports, "RSAPrivateKey", function () { return $9749a8efd863fd79$export$f4aab6816f64fa6b; }, function (v) { return $9749a8efd863fd79$export$f4aab6816f64fa6b = v; });
$parcel$export(module.exports, "RSAPublicKey", function () { return $9749a8efd863fd79$export$4471f5c65d097c11; }, function (v) { return $9749a8efd863fd79$export$4471f5c65d097c11 = v; });
$parcel$export(module.exports, "PublicKey", function () { return $9749a8efd863fd79$export$ca8b6604d6ce14de; }, function (v) { return $9749a8efd863fd79$export$ca8b6604d6ce14de = v; });
$parcel$export(module.exports, "PrivateKey", function () { return $9749a8efd863fd79$export$8f54525b330fd87b; }, function (v) { return $9749a8efd863fd79$export$8f54525b330fd87b = v; });
$parcel$export(module.exports, "EncryptedPrivateKey", function () { return $9749a8efd863fd79$export$23cd2842b44ca3e7; }, function (v) { return $9749a8efd863fd79$export$23cd2842b44ca3e7 = v; });
$parcel$export(module.exports, "DSAPrivateKey", function () { return $9749a8efd863fd79$export$245c9aaa9f5ce4ce; }, function (v) { return $9749a8efd863fd79$export$245c9aaa9f5ce4ce = v; });
$parcel$export(module.exports, "DSAparam", function () { return $9749a8efd863fd79$export$8ad762e3e6399afe; }, function (v) { return $9749a8efd863fd79$export$8ad762e3e6399afe = v; });
$parcel$export(module.exports, "ECPrivateKey", function () { return $9749a8efd863fd79$export$32ef6f92e22c6ab0; }, function (v) { return $9749a8efd863fd79$export$32ef6f92e22c6ab0 = v; });
$parcel$export(module.exports, "signature", function () { return $9749a8efd863fd79$export$c9cd164b539ebb63; }, function (v) { return $9749a8efd863fd79$export$c9cd164b539ebb63 = v; });
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $9749a8efd863fd79$export$c98397a6eb8d0678;
var $9749a8efd863fd79$export$f4aab6816f64fa6b;
var $9749a8efd863fd79$export$4471f5c65d097c11;
var $9749a8efd863fd79$export$ca8b6604d6ce14de;
var $9749a8efd863fd79$export$8f54525b330fd87b;
var $9749a8efd863fd79$export$23cd2842b44ca3e7;
var $9749a8efd863fd79$export$245c9aaa9f5ce4ce;
var $9749a8efd863fd79$export$8ad762e3e6399afe;
var $9749a8efd863fd79$export$32ef6f92e22c6ab0;
var $9749a8efd863fd79$export$c9cd164b539ebb63;
'use strict';

var $cGPrw = parcelRequire("cGPrw");

$9749a8efd863fd79$export$c98397a6eb8d0678 = (parcelRequire("9RdoG"));
var $9749a8efd863fd79$var$RSAPrivateKey = $cGPrw.define('RSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('modulus')['int'](), this.key('publicExponent')['int'](), this.key('privateExponent')['int'](), this.key('prime1')['int'](), this.key('prime2')['int'](), this.key('exponent1')['int'](), this.key('exponent2')['int'](), this.key('coefficient')['int']());
});
$9749a8efd863fd79$export$f4aab6816f64fa6b = $9749a8efd863fd79$var$RSAPrivateKey;
var $9749a8efd863fd79$var$RSAPublicKey = $cGPrw.define('RSAPublicKey', function() {
    this.seq().obj(this.key('modulus')['int'](), this.key('publicExponent')['int']());
});
$9749a8efd863fd79$export$4471f5c65d097c11 = $9749a8efd863fd79$var$RSAPublicKey;
var $9749a8efd863fd79$var$AlgorithmIdentifier = $cGPrw.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int']()).optional());
});
var $9749a8efd863fd79$var$PublicKey = $cGPrw.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($9749a8efd863fd79$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
$9749a8efd863fd79$export$ca8b6604d6ce14de = $9749a8efd863fd79$var$PublicKey;
var $9749a8efd863fd79$var$PrivateKeyInfo = $cGPrw.define('PrivateKeyInfo', function() {
    this.seq().obj(this.key('version')['int'](), this.key('algorithm').use($9749a8efd863fd79$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
$9749a8efd863fd79$export$8f54525b330fd87b = $9749a8efd863fd79$var$PrivateKeyInfo;
var $9749a8efd863fd79$var$EncryptedPrivateKeyInfo = $cGPrw.define('EncryptedPrivateKeyInfo', function() {
    this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters')['int']())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});
$9749a8efd863fd79$export$23cd2842b44ca3e7 = $9749a8efd863fd79$var$EncryptedPrivateKeyInfo;
var $9749a8efd863fd79$var$DSAPrivateKey = $cGPrw.define('DSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int'](), this.key('pub_key')['int'](), this.key('priv_key')['int']());
});
$9749a8efd863fd79$export$245c9aaa9f5ce4ce = $9749a8efd863fd79$var$DSAPrivateKey;
$9749a8efd863fd79$export$8ad762e3e6399afe = $cGPrw.define('DSAparam', function() {
    this['int']();
});
var $9749a8efd863fd79$var$ECParameters = $cGPrw.define('ECParameters', function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var $9749a8efd863fd79$var$ECPrivateKey = $cGPrw.define('ECPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($9749a8efd863fd79$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
$9749a8efd863fd79$export$32ef6f92e22c6ab0 = $9749a8efd863fd79$var$ECPrivateKey;
$9749a8efd863fd79$export$c9cd164b539ebb63 = $cGPrw.define('signature', function() {
    this.seq().obj(this.key('r')['int'](), this.key('s')['int']());
});

});
parcelRegister("cGPrw", function(module, exports) {
var $93d14fc1441a6b69$var$asn1 = module.exports;

$93d14fc1441a6b69$var$asn1.bignum = (parcelRequire("VT9aK"));

$93d14fc1441a6b69$var$asn1.define = (parcelRequire("HFCbG")).define;

$93d14fc1441a6b69$var$asn1.base = (parcelRequire("8FENA"));

$93d14fc1441a6b69$var$asn1.constants = (parcelRequire("fTk93"));

$93d14fc1441a6b69$var$asn1.decoders = (parcelRequire("2b29E"));

$93d14fc1441a6b69$var$asn1.encoders = (parcelRequire("hrmMG"));

});
parcelRegister("VT9aK", function(module, exports) {

var $qb7pP = parcelRequire("qb7pP");

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if ((typeof module1 === "undefined" ? "undefined" : (0, $qb7pP._)(module1)) === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("iczbQ")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && (typeof num === "undefined" ? "undefined" : (0, $qb7pP._)(num)) === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if ((typeof number === "undefined" ? "undefined" : (0, $qb7pP._)(number)) === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, undefined);

});

parcelRegister("HFCbG", function(module, exports) {

var $cGPrw = parcelRequire("cGPrw");

var $6LbC4 = parcelRequire("6LbC4");
var $08344c1fdd26a6c9$var$api = module.exports;
$08344c1fdd26a6c9$var$api.define = function define(name, body) {
    return new $08344c1fdd26a6c9$var$Entity(name, body);
};
function $08344c1fdd26a6c9$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$08344c1fdd26a6c9$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("cMSsk")).runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
    } catch (e) {
        named = function named(entity) {
            this._initNamed(entity);
        };
    }
    $6LbC4(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$08344c1fdd26a6c9$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || 'der';
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($cGPrw.decoders[enc]);
    return this.decoders[enc];
};
$08344c1fdd26a6c9$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$08344c1fdd26a6c9$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || 'der';
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($cGPrw.encoders[enc]);
    return this.encoders[enc];
};
$08344c1fdd26a6c9$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("cMSsk", function(module, exports) {

var $qb7pP = parcelRequire("qb7pP");
var indexOf = function indexOf(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function Object_keys(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function forEach(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    'Array',
    'Boolean',
    'Date',
    'Error',
    'EvalError',
    'Function',
    'Infinity',
    'JSON',
    'Math',
    'NaN',
    'Number',
    'Object',
    'RangeError',
    'ReferenceError',
    'RegExp',
    'String',
    'SyntaxError',
    'TypeError',
    'URIError',
    'decodeURI',
    'decodeURIComponent',
    'encodeURI',
    'encodeURIComponent',
    'escape',
    'eval',
    'isFinite',
    'isNaN',
    'parseFloat',
    'parseInt',
    'undefined',
    'unescape'
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win["eval"], wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win["eval"];
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if ((typeof context === "undefined" ? "undefined" : (0, $qb7pP._)(context)) === 'object') forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});


parcelRegister("8FENA", function(module, exports) {
var $6501ccd42c0bb47e$var$base = module.exports;

$6501ccd42c0bb47e$var$base.Reporter = (parcelRequire("iVQFD")).Reporter;

$6501ccd42c0bb47e$var$base.DecoderBuffer = (parcelRequire("d05va")).DecoderBuffer;

$6501ccd42c0bb47e$var$base.EncoderBuffer = (parcelRequire("d05va")).EncoderBuffer;

$6501ccd42c0bb47e$var$base.Node = (parcelRequire("4G4m3"));

});
parcelRegister("iVQFD", function(module, exports) {

$parcel$export(module.exports, "Reporter", function () { return $dc86681d0245e7e6$export$957313a2f485e5ed; }, function (v) { return $dc86681d0245e7e6$export$957313a2f485e5ed = v; });
var $dc86681d0245e7e6$export$957313a2f485e5ed;

var $6LbC4 = parcelRequire("6LbC4");
function $dc86681d0245e7e6$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$dc86681d0245e7e6$export$957313a2f485e5ed = $dc86681d0245e7e6$var$Reporter;
$dc86681d0245e7e6$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $dc86681d0245e7e6$var$ReporterError;
};
$dc86681d0245e7e6$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$dc86681d0245e7e6$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$dc86681d0245e7e6$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$dc86681d0245e7e6$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$dc86681d0245e7e6$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$dc86681d0245e7e6$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join('/');
};
$dc86681d0245e7e6$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$dc86681d0245e7e6$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$dc86681d0245e7e6$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $dc86681d0245e7e6$var$ReporterError;
    if (inherited) err = msg;
    else err = new $dc86681d0245e7e6$var$ReporterError(state.path.map(function(elem) {
        return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$dc86681d0245e7e6$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $dc86681d0245e7e6$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$6LbC4($dc86681d0245e7e6$var$ReporterError, Error);
$dc86681d0245e7e6$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + ' at: ' + (this.path || '(shallow)');
    if (Error.captureStackTrace) Error.captureStackTrace(this, $dc86681d0245e7e6$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("d05va", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", function () { return $976f8afaec9d1344$export$bf9f79cdc4a49163; }, function (v) { return $976f8afaec9d1344$export$bf9f79cdc4a49163 = v; });
$parcel$export(module.exports, "EncoderBuffer", function () { return $976f8afaec9d1344$export$8ff24f7760c7a78e; }, function (v) { return $976f8afaec9d1344$export$8ff24f7760c7a78e = v; });

var $qb7pP = parcelRequire("qb7pP");
var $976f8afaec9d1344$export$bf9f79cdc4a49163;
var $976f8afaec9d1344$export$8ff24f7760c7a78e;

var $6LbC4 = parcelRequire("6LbC4");

var $8FENA = parcelRequire("8FENA");
var $976f8afaec9d1344$require$Reporter = $8FENA.Reporter;

var $dSRbH = parcelRequire("dSRbH");
var $976f8afaec9d1344$require$Buffer = $dSRbH.Buffer;
function $976f8afaec9d1344$var$DecoderBuffer(base, options) {
    $976f8afaec9d1344$require$Reporter.call(this, options);
    if (!$976f8afaec9d1344$require$Buffer.isBuffer(base)) {
        this.error('Input not Buffer');
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$6LbC4($976f8afaec9d1344$var$DecoderBuffer, $976f8afaec9d1344$require$Reporter);
$976f8afaec9d1344$export$bf9f79cdc4a49163 = $976f8afaec9d1344$var$DecoderBuffer;
$976f8afaec9d1344$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $976f8afaec9d1344$require$Reporter.prototype.save.call(this)
    };
};
$976f8afaec9d1344$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $976f8afaec9d1344$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $976f8afaec9d1344$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$976f8afaec9d1344$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$976f8afaec9d1344$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || 'DecoderBuffer overrun');
};
$976f8afaec9d1344$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
    var res = new $976f8afaec9d1344$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$976f8afaec9d1344$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $976f8afaec9d1344$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $976f8afaec9d1344$var$EncoderBuffer)) item = new $976f8afaec9d1344$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === 'number') {
        if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
        this.value = value;
        this.length = 1;
    } else if (typeof value === 'string') {
        this.value = value;
        this.length = $976f8afaec9d1344$require$Buffer.byteLength(value);
    } else if ($976f8afaec9d1344$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error('Unsupported type: ' + (typeof value === "undefined" ? "undefined" : (0, $qb7pP._)(value)));
}
$976f8afaec9d1344$export$8ff24f7760c7a78e = $976f8afaec9d1344$var$EncoderBuffer;
$976f8afaec9d1344$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $976f8afaec9d1344$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === 'number') out[offset] = this.value;
        else if (typeof this.value === 'string') out.write(this.value, offset);
        else if ($976f8afaec9d1344$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("4G4m3", function(module, exports) {

var $qb7pP = parcelRequire("qb7pP");

var $8FENA = parcelRequire("8FENA");
var $367e766d4f185819$require$Reporter = $8FENA.Reporter;

var $8FENA = parcelRequire("8FENA");
var $367e766d4f185819$require$EncoderBuffer = $8FENA.EncoderBuffer;

var $8FENA = parcelRequire("8FENA");
var $367e766d4f185819$require$DecoderBuffer = $8FENA.DecoderBuffer;

var $3Pc6F = parcelRequire("3Pc6F");
// Supported tags
var $367e766d4f185819$var$tags = [
    'seq',
    'seqof',
    'set',
    'setof',
    'objid',
    'bool',
    'gentime',
    'utctime',
    'null_',
    'enum',
    'int',
    'objDesc',
    'bitstr',
    'bmpstr',
    'charstr',
    'genstr',
    'graphstr',
    'ia5str',
    'iso646str',
    'numstr',
    'octstr',
    'printstr',
    't61str',
    'unistr',
    'utf8str',
    'videostr'
];
// Public methods list
var $367e766d4f185819$var$methods = [
    'key',
    'obj',
    'use',
    'optional',
    'explicit',
    'implicit',
    'def',
    'choice',
    'any',
    'contains'
].concat($367e766d4f185819$var$tags);
// Overrided methods list
var $367e766d4f185819$var$overrided = [
    '_peekTag',
    '_decodeTag',
    '_use',
    '_decodeStr',
    '_decodeObjid',
    '_decodeTime',
    '_decodeNull',
    '_decodeInt',
    '_decodeBool',
    '_decodeList',
    '_encodeComposite',
    '_encodeStr',
    '_encodeObjid',
    '_encodeTime',
    '_encodeNull',
    '_encodeInt',
    '_encodeBool'
];
function $367e766d4f185819$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state['default'] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $367e766d4f185819$var$Node;
var $367e766d4f185819$var$stateProps = [
    'enc',
    'parent',
    'children',
    'tag',
    'args',
    'reverseArgs',
    'choice',
    'optional',
    'any',
    'obj',
    'use',
    'alteredUse',
    'key',
    'default',
    'explicit',
    'implicit',
    'contains'
];
$367e766d4f185819$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $367e766d4f185819$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$367e766d4f185819$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $367e766d4f185819$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$367e766d4f185819$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $3Pc6F(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $3Pc6F.equal(state.children.length, 1, 'Root node can have only one child');
};
$367e766d4f185819$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $3Pc6F(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $3Pc6F(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if ((typeof arg === "undefined" ? "undefined" : (0, $qb7pP._)(arg)) !== 'object' || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$367e766d4f185819$var$overrided.forEach(function(method) {
    $367e766d4f185819$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + ' not implemented for encoding: ' + state.enc);
    };
});
//
// Public methods
//
$367e766d4f185819$var$tags.forEach(function(tag) {
    $367e766d4f185819$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $3Pc6F(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$367e766d4f185819$var$Node.prototype.use = function use(item) {
    $3Pc6F(item);
    var state = this._baseState;
    $3Pc6F(state.use === null);
    state.use = item;
    return this;
};
$367e766d4f185819$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$367e766d4f185819$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $3Pc6F(state['default'] === null);
    state['default'] = val;
    state.optional = true;
    return this;
};
$367e766d4f185819$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $3Pc6F(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$367e766d4f185819$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $3Pc6F(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$367e766d4f185819$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$367e766d4f185819$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $3Pc6F(state.key === null);
    state.key = newKey;
    return this;
};
$367e766d4f185819$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$367e766d4f185819$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $3Pc6F(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$367e766d4f185819$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $3Pc6F(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$367e766d4f185819$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state['default'];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            var data = new $367e766d4f185819$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$367e766d4f185819$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === 'seq' || tag === 'set') return null;
    if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
    else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
    else if (tag === 'null_') return this._decodeNull(input, options);
    else if (tag === 'bool') return this._decodeBool(input, options);
    else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
    else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error('unknown tag: ' + tag);
};
$367e766d4f185819$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $3Pc6F(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$367e766d4f185819$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error('Choice not matched');
    return result;
};
//
// Encoding
//
$367e766d4f185819$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $367e766d4f185819$require$EncoderBuffer(data, this.reporter);
};
$367e766d4f185819$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state['default'] !== null && state['default'] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$367e766d4f185819$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $367e766d4f185819$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state['default'] !== null) data = state['default'];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error('Child should have a key');
            var prevKey = reporter.enterKey(child._baseState.key);
            if ((typeof data === "undefined" ? "undefined" : (0, $qb7pP._)(data)) !== 'object') return reporter.error('Child expected, but input is not object');
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
            if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? 'universal' : 'context';
        if (tag === null) {
            if (state.use === null) reporter.error('Tag could be omitted only for .use()');
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
    return result;
};
$367e766d4f185819$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $3Pc6F(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$367e766d4f185819$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === 'objid') return this._encodeObjid(data, null, null);
    else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
    else if (tag === 'null_') return this._encodeNull();
    else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === 'bool') return this._encodeBool(data);
    else if (tag === 'objDesc') return this._encodeStr(data, tag);
    else throw new Error('Unsupported tag: ' + tag);
};
$367e766d4f185819$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$367e766d4f185819$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("fTk93", function(module, exports) {
var $b91b9e704b34d618$var$constants = module.exports;
// Helper
$b91b9e704b34d618$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$b91b9e704b34d618$var$constants.der = (parcelRequire("cDNyt"));

});
parcelRegister("cDNyt", function(module, exports) {

$parcel$export(module.exports, "tagClass", function () { return $933f912190fb6dc6$export$3584c46ed60baee8; }, function (v) { return $933f912190fb6dc6$export$3584c46ed60baee8 = v; });
$parcel$export(module.exports, "tagClassByName", function () { return $933f912190fb6dc6$export$f18596ef8d632e49; }, function (v) { return $933f912190fb6dc6$export$f18596ef8d632e49 = v; });
$parcel$export(module.exports, "tag", function () { return $933f912190fb6dc6$export$2b067c6666111485; }, function (v) { return $933f912190fb6dc6$export$2b067c6666111485 = v; });
$parcel$export(module.exports, "tagByName", function () { return $933f912190fb6dc6$export$f17df38a421ab9e3; }, function (v) { return $933f912190fb6dc6$export$f17df38a421ab9e3 = v; });
var $933f912190fb6dc6$export$3584c46ed60baee8;
var $933f912190fb6dc6$export$f18596ef8d632e49;
var $933f912190fb6dc6$export$2b067c6666111485;
var $933f912190fb6dc6$export$f17df38a421ab9e3;

var $fTk93 = parcelRequire("fTk93");
$933f912190fb6dc6$export$3584c46ed60baee8 = {
    0: 'universal',
    1: 'application',
    2: 'context',
    3: 'private'
};
$933f912190fb6dc6$export$f18596ef8d632e49 = $fTk93._reverse($933f912190fb6dc6$export$3584c46ed60baee8);
$933f912190fb6dc6$export$2b067c6666111485 = {
    0x00: 'end',
    0x01: 'bool',
    0x02: 'int',
    0x03: 'bitstr',
    0x04: 'octstr',
    0x05: 'null_',
    0x06: 'objid',
    0x07: 'objDesc',
    0x08: 'external',
    0x09: 'real',
    0x0a: 'enum',
    0x0b: 'embed',
    0x0c: 'utf8str',
    0x0d: 'relativeOid',
    0x10: 'seq',
    0x11: 'set',
    0x12: 'numstr',
    0x13: 'printstr',
    0x14: 't61str',
    0x15: 'videostr',
    0x16: 'ia5str',
    0x17: 'utctime',
    0x18: 'gentime',
    0x19: 'graphstr',
    0x1a: 'iso646str',
    0x1b: 'genstr',
    0x1c: 'unistr',
    0x1d: 'charstr',
    0x1e: 'bmpstr'
};
$933f912190fb6dc6$export$f17df38a421ab9e3 = $fTk93._reverse($933f912190fb6dc6$export$2b067c6666111485);

});


parcelRegister("2b29E", function(module, exports) {
var $195e47bb342b85ea$var$decoders = module.exports;

$195e47bb342b85ea$var$decoders.der = (parcelRequire("fyzw3"));

$195e47bb342b85ea$var$decoders.pem = (parcelRequire("k5XHw"));

});
parcelRegister("fyzw3", function(module, exports) {

var $6LbC4 = parcelRequire("6LbC4");

var $cGPrw = parcelRequire("cGPrw");
var $b53594ba4cc3f4a4$var$base = $cGPrw.base;
var $b53594ba4cc3f4a4$var$bignum = $cGPrw.bignum;
// Import DER constants
var $b53594ba4cc3f4a4$var$der = $cGPrw.constants.der;
function $b53594ba4cc3f4a4$var$DERDecoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $b53594ba4cc3f4a4$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $b53594ba4cc3f4a4$var$DERDecoder;
$b53594ba4cc3f4a4$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $b53594ba4cc3f4a4$var$base.DecoderBuffer)) data = new $b53594ba4cc3f4a4$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $b53594ba4cc3f4a4$var$DERNode(parent) {
    $b53594ba4cc3f4a4$var$base.Node.call(this, 'der', parent);
}
$6LbC4($b53594ba4cc3f4a4$var$DERNode, $b53594ba4cc3f4a4$var$base.Node);
$b53594ba4cc3f4a4$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $b53594ba4cc3f4a4$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};
$b53594ba4cc3f4a4$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $b53594ba4cc3f4a4$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $b53594ba4cc3f4a4$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$b53594ba4cc3f4a4$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $b53594ba4cc3f4a4$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $b53594ba4cc3f4a4$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === 'end') break;
    }
};
$b53594ba4cc3f4a4$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, 'end');
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, 'der', options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$b53594ba4cc3f4a4$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === 'bitstr') {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === 'bmpstr') {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
        var str = '';
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === 'numstr') {
        var numstr = buffer.raw().toString('ascii');
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === 'octstr') return buffer.raw();
    else if (tag === 'objDesc') return buffer.raw();
    else if (tag === 'printstr') {
        var printstr = buffer.raw().toString('ascii');
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
};
$b53594ba4cc3f4a4$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(' ')];
        if (tmp === undefined) tmp = values[result.join('.')];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$b53594ba4cc3f4a4$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === 'gentime') {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === 'utctime') {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$b53594ba4cc3f4a4$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$b53594ba4cc3f4a4$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$b53594ba4cc3f4a4$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $b53594ba4cc3f4a4$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$b53594ba4cc3f4a4$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getDecoder('der').tree;
};
// Utility methods
function $b53594ba4cc3f4a4$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $b53594ba4cc3f4a4$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $b53594ba4cc3f4a4$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $b53594ba4cc3f4a4$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error('length octect is too long');
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("k5XHw", function(module, exports) {

var $6LbC4 = parcelRequire("6LbC4");

var $dSRbH = parcelRequire("dSRbH");
var $ea1295a7564eda4e$require$Buffer = $dSRbH.Buffer;

var $fyzw3 = parcelRequire("fyzw3");
function $ea1295a7564eda4e$var$PEMDecoder(entity) {
    $fyzw3.call(this, entity);
    this.enc = 'pem';
}
$6LbC4($ea1295a7564eda4e$var$PEMDecoder, $fyzw3);
module.exports = $ea1295a7564eda4e$var$PEMDecoder;
$ea1295a7564eda4e$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== 'BEGIN') break;
            start = i;
        } else {
            if (match[1] !== 'END') break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
    var base64 = lines.slice(start + 1, end).join('');
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, '');
    var input = new $ea1295a7564eda4e$require$Buffer(base64, 'base64');
    return $fyzw3.prototype.decode.call(this, input, options);
};

});


parcelRegister("hrmMG", function(module, exports) {
var $cb26a1bf38b5c5e5$var$encoders = module.exports;

$cb26a1bf38b5c5e5$var$encoders.der = (parcelRequire("Ja3Qy"));

$cb26a1bf38b5c5e5$var$encoders.pem = (parcelRequire("dfNeU"));

});
parcelRegister("Ja3Qy", function(module, exports) {

var $6LbC4 = parcelRequire("6LbC4");

var $dSRbH = parcelRequire("dSRbH");
var $087c01ff5beae34c$require$Buffer = $dSRbH.Buffer;

var $cGPrw = parcelRequire("cGPrw");
var $087c01ff5beae34c$var$base = $cGPrw.base;
// Import DER constants
var $087c01ff5beae34c$var$der = $cGPrw.constants.der;
function $087c01ff5beae34c$var$DEREncoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $087c01ff5beae34c$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $087c01ff5beae34c$var$DEREncoder;
$087c01ff5beae34c$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $087c01ff5beae34c$var$DERNode(parent) {
    $087c01ff5beae34c$var$base.Node.call(this, 'der', parent);
}
$6LbC4($087c01ff5beae34c$var$DERNode, $087c01ff5beae34c$var$base.Node);
$087c01ff5beae34c$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $087c01ff5beae34c$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $087c01ff5beae34c$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $087c01ff5beae34c$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$087c01ff5beae34c$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === 'bitstr') return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === 'bmpstr') {
        var buf = new $087c01ff5beae34c$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === 'numstr') {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === 'printstr') {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === 'objDesc') return this._createEncoderBuffer(str);
    else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
};
$087c01ff5beae34c$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === 'string') {
        if (!values) return this.reporter.error('string objid given, but no values map found');
        if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $087c01ff5beae34c$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $087c01ff5beae34c$var$two(num) {
    if (num < 10) return '0' + num;
    else return num;
}
$087c01ff5beae34c$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === 'gentime') str = [
        $087c01ff5beae34c$var$two(date.getFullYear()),
        $087c01ff5beae34c$var$two(date.getUTCMonth() + 1),
        $087c01ff5beae34c$var$two(date.getUTCDate()),
        $087c01ff5beae34c$var$two(date.getUTCHours()),
        $087c01ff5beae34c$var$two(date.getUTCMinutes()),
        $087c01ff5beae34c$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else if (tag === 'utctime') str = [
        $087c01ff5beae34c$var$two(date.getFullYear() % 100),
        $087c01ff5beae34c$var$two(date.getUTCMonth() + 1),
        $087c01ff5beae34c$var$two(date.getUTCDate()),
        $087c01ff5beae34c$var$two(date.getUTCHours()),
        $087c01ff5beae34c$var$two(date.getUTCMinutes()),
        $087c01ff5beae34c$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
    return this._encodeStr(str, 'octstr');
};
$087c01ff5beae34c$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer('');
};
$087c01ff5beae34c$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === 'string') {
        if (!values) return this.reporter.error('String int or enum given, but no values map');
        if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== 'number' && !$087c01ff5beae34c$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $087c01ff5beae34c$require$Buffer(numArray);
    }
    if ($087c01ff5beae34c$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $087c01ff5beae34c$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $087c01ff5beae34c$require$Buffer(out));
};
$087c01ff5beae34c$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$087c01ff5beae34c$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getEncoder('der').tree;
};
$087c01ff5beae34c$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state['default'] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $087c01ff5beae34c$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === 'seqof') tag = 'seq';
    else if (tag === 'setof') tag = 'set';
    if ($087c01ff5beae34c$var$der.tagByName.hasOwnProperty(tag)) res = $087c01ff5beae34c$var$der.tagByName[tag];
    else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
    else return reporter.error('Unknown tag: ' + tag);
    if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
    if (!primitive) res |= 0x20;
    res |= $087c01ff5beae34c$var$der.tagClassByName[cls || 'universal'] << 6;
    return res;
}

});

parcelRegister("dfNeU", function(module, exports) {

var $6LbC4 = parcelRequire("6LbC4");

var $Ja3Qy = parcelRequire("Ja3Qy");
function $9a62df02f311a781$var$PEMEncoder(entity) {
    $Ja3Qy.call(this, entity);
    this.enc = 'pem';
}
$6LbC4($9a62df02f311a781$var$PEMEncoder, $Ja3Qy);
module.exports = $9a62df02f311a781$var$PEMEncoder;
$9a62df02f311a781$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $Ja3Qy.prototype.encode.call(this, data);
    var p = buf.toString('base64');
    var out = [
        '-----BEGIN ' + options.label + '-----'
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push('-----END ' + options.label + '-----');
    return out.join('\n');
};

});



parcelRegister("9RdoG", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
'use strict';

var $cGPrw = parcelRequire("cGPrw");
var $72d374b31b225a5d$var$Time = $cGPrw.define('Time', function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $72d374b31b225a5d$var$AttributeTypeValue = $cGPrw.define('AttributeTypeValue', function() {
    this.seq().obj(this.key('type').objid(), this.key('value').any());
});
var $72d374b31b225a5d$var$AlgorithmIdentifier = $cGPrw.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional(), this.key('curve').objid().optional());
});
var $72d374b31b225a5d$var$SubjectPublicKeyInfo = $cGPrw.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($72d374b31b225a5d$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
var $72d374b31b225a5d$var$RelativeDistinguishedName = $cGPrw.define('RelativeDistinguishedName', function() {
    this.setof($72d374b31b225a5d$var$AttributeTypeValue);
});
var $72d374b31b225a5d$var$RDNSequence = $cGPrw.define('RDNSequence', function() {
    this.seqof($72d374b31b225a5d$var$RelativeDistinguishedName);
});
var $72d374b31b225a5d$var$Name = $cGPrw.define('Name', function() {
    this.choice({
        rdnSequence: this.use($72d374b31b225a5d$var$RDNSequence)
    });
});
var $72d374b31b225a5d$var$Validity = $cGPrw.define('Validity', function() {
    this.seq().obj(this.key('notBefore').use($72d374b31b225a5d$var$Time), this.key('notAfter').use($72d374b31b225a5d$var$Time));
});
var $72d374b31b225a5d$var$Extension = $cGPrw.define('Extension', function() {
    this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});
var $72d374b31b225a5d$var$TBSCertificate = $cGPrw.define('TBSCertificate', function() {
    this.seq().obj(this.key('version').explicit(0)['int']().optional(), this.key('serialNumber')['int'](), this.key('signature').use($72d374b31b225a5d$var$AlgorithmIdentifier), this.key('issuer').use($72d374b31b225a5d$var$Name), this.key('validity').use($72d374b31b225a5d$var$Validity), this.key('subject').use($72d374b31b225a5d$var$Name), this.key('subjectPublicKeyInfo').use($72d374b31b225a5d$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($72d374b31b225a5d$var$Extension).optional());
});
var $72d374b31b225a5d$var$X509Certificate = $cGPrw.define('X509Certificate', function() {
    this.seq().obj(this.key('tbsCertificate').use($72d374b31b225a5d$var$TBSCertificate), this.key('signatureAlgorithm').use($72d374b31b225a5d$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
});
module.exports = $72d374b31b225a5d$var$X509Certificate;

});


parcelRegister("jCdVD", function(module, exports) {
module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

});

parcelRegister("fMMSA", function(module, exports) {
'use strict';
// adapted from https://github.com/apatil/pemstrip
var $b7e141237b2492a9$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $b7e141237b2492a9$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $b7e141237b2492a9$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $dMYKX = parcelRequire("dMYKX");

var $8rjBu = parcelRequire("8rjBu");

var $5PcLP = parcelRequire("5PcLP");
var $b7e141237b2492a9$require$Buffer = $5PcLP.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($b7e141237b2492a9$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($b7e141237b2492a9$var$fullRegex);
        decrypted = $b7e141237b2492a9$require$Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
    } else {
        var suite = 'aes' + match[1];
        var iv = $b7e141237b2492a9$require$Buffer.from(match[2], 'hex');
        var cipherText = $b7e141237b2492a9$require$Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
        var cipherKey = $dMYKX(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $8rjBu.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher['final']());
        decrypted = $b7e141237b2492a9$require$Buffer.concat(out);
    }
    var tag = key.match($b7e141237b2492a9$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRegister("coJWo", function(module, exports) {
module.exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");

});


parcelRegister("jUSkB", function(module, exports) {
'use strict';

var $5PcLP = parcelRequire("5PcLP");
var $e7fd64591d8d1d54$require$Buffer = $5PcLP.Buffer;

var $iKbS8 = parcelRequire("iKbS8");

var $aKi6r = parcelRequire("aKi6r");
var $e7fd64591d8d1d54$require$EC = $aKi6r.ec;

var $4SshR = parcelRequire("4SshR");

var $coJWo = parcelRequire("coJWo");
function $e7fd64591d8d1d54$var$verify(sig, hash, key, signType, tag) {
    var pub = $4SshR(key);
    if (pub.type === 'ec') {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        return $e7fd64591d8d1d54$var$ecVerify(sig, hash, pub);
    } else if (pub.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong public key type');
        return $e7fd64591d8d1d54$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    hash = $e7fd64591d8d1d54$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $e7fd64591d8d1d54$require$Buffer.from(pad);
    var red = $iKbS8.mont(pub.modulus);
    sig = new $iKbS8(sig).toRed(red);
    sig = sig.redPow(new $iKbS8(pub.publicExponent));
    sig = $e7fd64591d8d1d54$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $e7fd64591d8d1d54$var$ecVerify(sig, hash, pub) {
    var curveId = $coJWo[pub.data.algorithm.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
    var curve = new $e7fd64591d8d1d54$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $e7fd64591d8d1d54$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $4SshR.signature.decode(sig, 'der');
    var s = unpacked.s;
    var r = unpacked.r;
    $e7fd64591d8d1d54$var$checkValue(s, q);
    $e7fd64591d8d1d54$var$checkValue(r, q);
    var montp = $iKbS8.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $iKbS8(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $e7fd64591d8d1d54$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error('invalid sig');
    if (b.cmp(q) >= 0) throw new Error('invalid sig');
}
module.exports = $e7fd64591d8d1d54$var$verify;

});


parcelRegister("flUnX", function(module, exports) {

var $dSRbH = parcelRequire("dSRbH");
var $b2d48e2681c47be9$require$Buffer = $dSRbH.Buffer;

var $aKi6r = parcelRequire("aKi6r");

var $HQ3jT = parcelRequire("HQ3jT");
module.exports = function createECDH(curve) {
    return new $b2d48e2681c47be9$var$ECDH(curve);
};
var $b2d48e2681c47be9$var$aliases = {
    secp256k1: {
        name: 'secp256k1',
        byteLength: 32
    },
    secp224r1: {
        name: 'p224',
        byteLength: 28
    },
    prime256v1: {
        name: 'p256',
        byteLength: 32
    },
    prime192v1: {
        name: 'p192',
        byteLength: 24
    },
    ed25519: {
        name: 'ed25519',
        byteLength: 32
    },
    secp384r1: {
        name: 'p384',
        byteLength: 48
    },
    secp521r1: {
        name: 'p521',
        byteLength: 66
    }
};
$b2d48e2681c47be9$var$aliases.p224 = $b2d48e2681c47be9$var$aliases.secp224r1;
$b2d48e2681c47be9$var$aliases.p256 = $b2d48e2681c47be9$var$aliases.secp256r1 = $b2d48e2681c47be9$var$aliases.prime256v1;
$b2d48e2681c47be9$var$aliases.p192 = $b2d48e2681c47be9$var$aliases.secp192r1 = $b2d48e2681c47be9$var$aliases.prime192v1;
$b2d48e2681c47be9$var$aliases.p384 = $b2d48e2681c47be9$var$aliases.secp384r1;
$b2d48e2681c47be9$var$aliases.p521 = $b2d48e2681c47be9$var$aliases.secp521r1;
function $b2d48e2681c47be9$var$ECDH(curve) {
    this.curveType = $b2d48e2681c47be9$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $aKi6r.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$b2d48e2681c47be9$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$b2d48e2681c47be9$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || 'utf8';
    if (!$b2d48e2681c47be9$require$Buffer.isBuffer(other)) other = new $b2d48e2681c47be9$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $b2d48e2681c47be9$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$b2d48e2681c47be9$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === 'compressed', true);
    if (format === 'hybrid') {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $b2d48e2681c47be9$var$formatReturnValue(key, enc);
};
$b2d48e2681c47be9$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $b2d48e2681c47be9$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$b2d48e2681c47be9$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || 'utf8';
    if (!$b2d48e2681c47be9$require$Buffer.isBuffer(pub)) pub = new $b2d48e2681c47be9$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$b2d48e2681c47be9$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || 'utf8';
    if (!$b2d48e2681c47be9$require$Buffer.isBuffer(priv)) priv = new $b2d48e2681c47be9$require$Buffer(priv, enc);
    var _priv = new $HQ3jT(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $b2d48e2681c47be9$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $b2d48e2681c47be9$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $b2d48e2681c47be9$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $b2d48e2681c47be9$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRegister("HQ3jT", function(module, exports) {

var $qb7pP = parcelRequire("qb7pP");

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if ((typeof module1 === "undefined" ? "undefined" : (0, $qb7pP._)(module1)) === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("iczbQ")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && (typeof num === "undefined" ? "undefined" : (0, $qb7pP._)(num)) === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if ((typeof number === "undefined" ? "undefined" : (0, $qb7pP._)(number)) === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, undefined);

});


parcelRegister("a0atk", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", function () { return $74820703f0d4dc31$export$512823e338ddb1b7; }, function (v) { return $74820703f0d4dc31$export$512823e338ddb1b7 = v; });
$parcel$export(module.exports, "privateDecrypt", function () { return $74820703f0d4dc31$export$7efb24e2fddf99b9; }, function (v) { return $74820703f0d4dc31$export$7efb24e2fddf99b9 = v; });
$parcel$export(module.exports, "privateEncrypt", function () { return $74820703f0d4dc31$export$9d0e0c0c4a8d30f3; }, function (v) { return $74820703f0d4dc31$export$9d0e0c0c4a8d30f3 = v; });
$parcel$export(module.exports, "publicDecrypt", function () { return $74820703f0d4dc31$export$b9d55ff329113abd; }, function (v) { return $74820703f0d4dc31$export$b9d55ff329113abd = v; });
var $74820703f0d4dc31$export$512823e338ddb1b7;
var $74820703f0d4dc31$export$7efb24e2fddf99b9;
var $74820703f0d4dc31$export$9d0e0c0c4a8d30f3;
var $74820703f0d4dc31$export$b9d55ff329113abd;

$74820703f0d4dc31$export$512823e338ddb1b7 = (parcelRequire("9uK2U"));

$74820703f0d4dc31$export$7efb24e2fddf99b9 = (parcelRequire("8lFGi"));
$74820703f0d4dc31$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $74820703f0d4dc31$export$512823e338ddb1b7(key, buf, true);
};
$74820703f0d4dc31$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $74820703f0d4dc31$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRegister("9uK2U", function(module, exports) {

var $4SshR = parcelRequire("4SshR");

var $cCNIN = parcelRequire("cCNIN");

var $hBj6e = parcelRequire("hBj6e");

var $a0uEJ = parcelRequire("a0uEJ");

var $15eL2 = parcelRequire("15eL2");

var $3oSvp = parcelRequire("3oSvp");

var $1wT5W = parcelRequire("1wT5W");

var $6t4wh = parcelRequire("6t4wh");

var $5PcLP = parcelRequire("5PcLP");
var $6e9aa22cb14a02d5$require$Buffer = $5PcLP.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $4SshR(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $6e9aa22cb14a02d5$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $6e9aa22cb14a02d5$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $3oSvp(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
    } else throw new Error('unknown padding');
    if (reverse) return $6t4wh(paddedMsg, key);
    else return $1wT5W(paddedMsg, key);
};
function $6e9aa22cb14a02d5$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $hBj6e('sha1').update($6e9aa22cb14a02d5$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error('message too long');
    var ps = $6e9aa22cb14a02d5$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $cCNIN(hLen);
    var maskedDb = $15eL2($6e9aa22cb14a02d5$require$Buffer.concat([
        iHash,
        ps,
        $6e9aa22cb14a02d5$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $a0uEJ(seed, dblen));
    var maskedSeed = $15eL2(seed, $a0uEJ(maskedDb, hLen));
    return new $3oSvp($6e9aa22cb14a02d5$require$Buffer.concat([
        $6e9aa22cb14a02d5$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $6e9aa22cb14a02d5$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error('message too long');
    var ps;
    if (reverse) ps = $6e9aa22cb14a02d5$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $6e9aa22cb14a02d5$var$nonZero(k - mLen - 3);
    return new $3oSvp($6e9aa22cb14a02d5$require$Buffer.concat([
        $6e9aa22cb14a02d5$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $6e9aa22cb14a02d5$require$Buffer.alloc(1),
        msg
    ], k));
}
function $6e9aa22cb14a02d5$var$nonZero(len) {
    var out = $6e9aa22cb14a02d5$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $cCNIN(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $cCNIN(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("a0uEJ", function(module, exports) {

var $hBj6e = parcelRequire("hBj6e");

var $5PcLP = parcelRequire("5PcLP");
var $7491af201db7258c$require$Buffer = $5PcLP.Buffer;
module.exports = function(seed, len) {
    var t = $7491af201db7258c$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $7491af201db7258c$var$i2ops(i++);
        t = $7491af201db7258c$require$Buffer.concat([
            t,
            $hBj6e('sha1').update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $7491af201db7258c$var$i2ops(c) {
    var out = $7491af201db7258c$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("15eL2", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("3oSvp", function(module, exports) {

var $qb7pP = parcelRequire("qb7pP");

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if ((typeof module1 === "undefined" ? "undefined" : (0, $qb7pP._)(module1)) === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("iczbQ")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && (typeof num === "undefined" ? "undefined" : (0, $qb7pP._)(num)) === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if ((typeof number === "undefined" ? "undefined" : (0, $qb7pP._)(number)) === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, undefined);

});

parcelRegister("1wT5W", function(module, exports) {

var $3oSvp = parcelRequire("3oSvp");

var $5PcLP = parcelRequire("5PcLP");
var $11d3844ff9c0aabf$require$Buffer = $5PcLP.Buffer;
function $11d3844ff9c0aabf$var$withPublic(paddedMsg, key) {
    return $11d3844ff9c0aabf$require$Buffer.from(paddedMsg.toRed($3oSvp.mont(key.modulus)).redPow(new $3oSvp(key.publicExponent)).fromRed().toArray());
}
module.exports = $11d3844ff9c0aabf$var$withPublic;

});


parcelRegister("8lFGi", function(module, exports) {

var $4SshR = parcelRequire("4SshR");

var $a0uEJ = parcelRequire("a0uEJ");

var $15eL2 = parcelRequire("15eL2");

var $3oSvp = parcelRequire("3oSvp");

var $6t4wh = parcelRequire("6t4wh");

var $hBj6e = parcelRequire("hBj6e");

var $1wT5W = parcelRequire("1wT5W");

var $5PcLP = parcelRequire("5PcLP");
var $61409def3f278f2f$require$Buffer = $5PcLP.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $4SshR(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $3oSvp(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
    var msg;
    if (reverse) msg = $1wT5W(new $3oSvp(enc), key);
    else msg = $6t4wh(enc, key);
    var zBuffer = $61409def3f278f2f$require$Buffer.alloc(k - msg.length);
    msg = $61409def3f278f2f$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $61409def3f278f2f$var$oaep(key, msg);
    else if (padding === 1) return $61409def3f278f2f$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error('unknown padding');
};
function $61409def3f278f2f$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $hBj6e('sha1').update($61409def3f278f2f$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error('decryption error');
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $15eL2(maskedSeed, $a0uEJ(maskedDb, hLen));
    var db = $15eL2(maskedDb, $a0uEJ(seed, k - hLen - 1));
    if ($61409def3f278f2f$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error('decryption error');
    return db.slice(i);
}
function $61409def3f278f2f$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error('decryption error');
    return msg.slice(i);
}
function $61409def3f278f2f$var$compare(a, b) {
    a = $61409def3f278f2f$require$Buffer.from(a);
    b = $61409def3f278f2f$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRegister("h4kk6", function(module, exports) {

$parcel$export(module.exports, "randomFill", function () { return $c6d2932a730e20ea$export$bb1abf2ce84fc7e8; }, function (v) { return $c6d2932a730e20ea$export$bb1abf2ce84fc7e8 = v; });
$parcel$export(module.exports, "randomFillSync", function () { return $c6d2932a730e20ea$export$2f7171e78e524d5e; }, function (v) { return $c6d2932a730e20ea$export$2f7171e78e524d5e = v; });
var $c6d2932a730e20ea$export$bb1abf2ce84fc7e8;
var $c6d2932a730e20ea$export$2f7171e78e524d5e;

var $ffICS = parcelRequire("ffICS");
'use strict';
function $c6d2932a730e20ea$var$oldBrowser() {
    throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}

var $5PcLP = parcelRequire("5PcLP");

var $cCNIN = parcelRequire("cCNIN");
var $c6d2932a730e20ea$var$Buffer = $5PcLP.Buffer;
var $c6d2932a730e20ea$var$kBufferMaxLength = $5PcLP.kMaxLength;
var $c6d2932a730e20ea$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $c6d2932a730e20ea$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $c6d2932a730e20ea$var$assertOffset(offset, length) {
    if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
    if (offset > $c6d2932a730e20ea$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
    if (offset > $c6d2932a730e20ea$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
}
function $c6d2932a730e20ea$var$assertSize(size, offset, length) {
    if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
    if (size > $c6d2932a730e20ea$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
    if (size + offset > length || size > $c6d2932a730e20ea$var$kBufferMaxLength) throw new RangeError('buffer too small');
}
if ($c6d2932a730e20ea$var$crypto && $c6d2932a730e20ea$var$crypto.getRandomValues || false) {
    $c6d2932a730e20ea$export$bb1abf2ce84fc7e8 = $c6d2932a730e20ea$var$randomFill;
    $c6d2932a730e20ea$export$2f7171e78e524d5e = $c6d2932a730e20ea$var$randomFillSync;
} else {
    $c6d2932a730e20ea$export$bb1abf2ce84fc7e8 = $c6d2932a730e20ea$var$oldBrowser;
    $c6d2932a730e20ea$export$2f7171e78e524d5e = $c6d2932a730e20ea$var$oldBrowser;
}
function $c6d2932a730e20ea$var$randomFill(buf, offset, size, cb) {
    if (!$c6d2932a730e20ea$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === 'function') {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === 'function') {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
    $c6d2932a730e20ea$var$assertOffset(offset, buf.length);
    $c6d2932a730e20ea$var$assertSize(size, offset, buf.length);
    return $c6d2932a730e20ea$var$actualFill(buf, offset, size, cb);
}
function $c6d2932a730e20ea$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $c6d2932a730e20ea$var$crypto.getRandomValues(uint);
    if (cb) {
        $ffICS.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $cCNIN(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $cCNIN(size);
    bytes.copy(buf, offset);
    return buf;
}
function $c6d2932a730e20ea$var$randomFillSync(buf, offset, size) {
    if (typeof offset === 'undefined') offset = 0;
    if (!$c6d2932a730e20ea$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $c6d2932a730e20ea$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $c6d2932a730e20ea$var$assertSize(size, offset, buf.length);
    return $c6d2932a730e20ea$var$actualFill(buf, offset, size);
}

});


parcelRegister("10PIf", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"dotenv\",\"version\":\"16.4.7\",\"description\":\"Loads environment variables from .env file\",\"main\":\"lib/main.js\",\"types\":\"lib/main.d.ts\",\"exports\":{\".\":{\"types\":\"./lib/main.d.ts\",\"require\":\"./lib/main.js\",\"default\":\"./lib/main.js\"},\"./config\":\"./config.js\",\"./config.js\":\"./config.js\",\"./lib/env-options\":\"./lib/env-options.js\",\"./lib/env-options.js\":\"./lib/env-options.js\",\"./lib/cli-options\":\"./lib/cli-options.js\",\"./lib/cli-options.js\":\"./lib/cli-options.js\",\"./package.json\":\"./package.json\"},\"scripts\":{\"dts-check\":\"tsc --project tests/types/tsconfig.json\",\"lint\":\"standard\",\"pretest\":\"npm run lint && npm run dts-check\",\"test\":\"tap run --allow-empty-coverage --disable-coverage --timeout=60000\",\"test:coverage\":\"tap run --show-full-coverage --timeout=60000 --coverage-report=lcov\",\"prerelease\":\"npm test\",\"release\":\"standard-version\"},\"repository\":{\"type\":\"git\",\"url\":\"git://github.com/motdotla/dotenv.git\"},\"funding\":\"https://dotenvx.com\",\"keywords\":[\"dotenv\",\"env\",\".env\",\"environment\",\"variables\",\"config\",\"settings\"],\"readmeFilename\":\"README.md\",\"license\":\"BSD-2-Clause\",\"devDependencies\":{\"@types/node\":\"^18.11.3\",\"decache\":\"^4.6.2\",\"sinon\":\"^14.0.1\",\"standard\":\"^17.0.0\",\"standard-version\":\"^9.5.0\",\"tap\":\"^19.2.0\",\"typescript\":\"^4.8.4\"},\"engines\":{\"node\":\">=12\"},\"browser\":{\"fs\":false}}");

});


parcelRegister("dEWAU", function(module, exports) {
// ../config.js accepts options via environment variables
var $9f1c766359aa41b2$var$options = {};
module.exports = $9f1c766359aa41b2$var$options;

});

parcelRegister("c0g4Z", function(module, exports) {
var $8bd1f52b1f2a99e1$var$re = /^dotenv_config_(encoding|path|debug|override|DOTENV_KEY)=(.+)$/;
module.exports = function optionMatcher(args) {
    return args.reduce(function(acc, cur) {
        var matches = cur.match($8bd1f52b1f2a99e1$var$re);
        if (matches) acc[matches[1]] = matches[2];
        return acc;
    }, {});
};

});

parcelRegister("gTcxm", function(module, exports) {

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $aSMts = parcelRequire("aSMts");
"use strict";
var $c4bb81fb7365349a$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $c4bb81fb7365349a$var$PostgrestQueryBuilder_1 = $c4bb81fb7365349a$var$__importDefault((parcelRequire("lHE4l")));

var $c4bb81fb7365349a$var$PostgrestFilterBuilder_1 = $c4bb81fb7365349a$var$__importDefault((parcelRequire("9HWpt")));

var $Lvz7W = parcelRequire("Lvz7W");
/**
 * PostgREST client.
 *
 * @typeParam Database - Types for the schema from the [type
 * generator](https://supabase.com/docs/reference/javascript/next/typescript-support)
 *
 * @typeParam SchemaName - Postgres schema to switch to. Must be a string
 * literal, the same one passed to the constructor. If the schema is not
 * `"public"`, this must be supplied manually.
 */ var $c4bb81fb7365349a$var$PostgrestClient = /*#__PURE__*/ function() {
    function PostgrestClient(url) {
        var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers, schema = _ref.schema, fetch = _ref.fetch;
        (0, $50OuQ._)(this, PostgrestClient);
        this.url = url;
        this.headers = Object.assign(Object.assign({}, $Lvz7W.DEFAULT_HEADERS), headers);
        this.schemaName = schema;
        this.fetch = fetch;
    }
    (0, $fGdZr._)(PostgrestClient, [
        {
            /**
     * Perform a query on a table or a view.
     *
     * @param relation - The table or view name to query
     */ key: "from",
            value: function from(relation) {
                var url = new URL("".concat(this.url, "/").concat(relation));
                return new $c4bb81fb7365349a$var$PostgrestQueryBuilder_1["default"](url, {
                    headers: Object.assign({}, this.headers),
                    schema: this.schemaName,
                    fetch: this.fetch
                });
            }
        },
        {
            /**
     * Select a schema to query or perform an function (rpc) call.
     *
     * The schema needs to be on the list of exposed schemas inside Supabase.
     *
     * @param schema - The schema to query
     */ key: "schema",
            value: function schema(_schema) {
                return new PostgrestClient(this.url, {
                    headers: this.headers,
                    schema: _schema,
                    fetch: this.fetch
                });
            }
        },
        {
            /**
     * Perform a function call.
     *
     * @param fn - The function name to call
     * @param args - The arguments to pass to the function call
     * @param options - Named parameters
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     * @param options.get - When set to `true`, the function will be called with
     * read-only access mode.
     * @param options.count - Count algorithm to use to count rows returned by the
     * function. Only applicable for [set-returning
     * functions](https://www.postgresql.org/docs/current/functions-srf.html).
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ key: "rpc",
            value: function rpc(fn) {
                var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_head = _ref.head, head = _ref_head === void 0 ? false : _ref_head, _ref_get = _ref.get, get = _ref_get === void 0 ? false : _ref_get, count = _ref.count;
                var method;
                var url = new URL("".concat(this.url, "/rpc/").concat(fn));
                var body;
                if (head || get) {
                    method = head ? 'HEAD' : 'GET';
                    Object.entries(args)// params with undefined value needs to be filtered out, otherwise it'll
                    // show up as `?param=undefined`
                    .filter(function(param) {
                        var _param = (0, $aSMts._)(param, 2), _ = _param[0], value = _param[1];
                        return value !== undefined;
                    })// array values need special syntax
                    .map(function(param) {
                        var _param = (0, $aSMts._)(param, 2), name = _param[0], value = _param[1];
                        return [
                            name,
                            Array.isArray(value) ? "{".concat(value.join(','), "}") : "".concat(value)
                        ];
                    }).forEach(function(param) {
                        var _param = (0, $aSMts._)(param, 2), name = _param[0], value = _param[1];
                        url.searchParams.append(name, value);
                    });
                } else {
                    method = 'POST';
                    body = args;
                }
                var headers = Object.assign({}, this.headers);
                if (count) headers['Prefer'] = "count=".concat(count);
                return new $c4bb81fb7365349a$var$PostgrestFilterBuilder_1["default"]({
                    method: method,
                    url: url,
                    headers: headers,
                    schema: this.schemaName,
                    body: body,
                    fetch: this.fetch,
                    allowEmpty: false
                });
            }
        }
    ]);
    return PostgrestClient;
}();
module.exports["default"] = $c4bb81fb7365349a$var$PostgrestClient;

});
parcelRegister("aSMts", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7ec48c7d8ea17758$export$71511d61b312f219; });

var $jG3FW = parcelRequire("jG3FW");

var $hpdLM = parcelRequire("hpdLM");

var $8V4Ru = parcelRequire("8V4Ru");

var $fXGmO = parcelRequire("fXGmO");
function $7ec48c7d8ea17758$export$71511d61b312f219(arr, i) {
    return (0, $jG3FW._)(arr) || (0, $hpdLM._)(arr, i) || (0, $fXGmO._)(arr, i) || (0, $8V4Ru._)();
}

});
parcelRegister("jG3FW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e534ca721748b0c3$export$71511d61b312f219; });
function $e534ca721748b0c3$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("hpdLM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cabf73d5763ce5a2$export$71511d61b312f219; });
function $cabf73d5763ce5a2$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("8V4Ru", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $67e76b0988166e1e$export$71511d61b312f219; });
function $67e76b0988166e1e$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("fXGmO", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b9ed3ae1694dd153$export$71511d61b312f219; });

var $5B3Hz = parcelRequire("5B3Hz");
function $b9ed3ae1694dd153$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $5B3Hz._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $5B3Hz._)(o, minLen);
}

});
parcelRegister("5B3Hz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4133478a60806ab4$export$71511d61b312f219; });
function $4133478a60806ab4$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("lHE4l", function(module, exports) {

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $dHvbf = parcelRequire("dHvbf");
"use strict";
var $fcccb206769e38dc$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fcccb206769e38dc$var$PostgrestFilterBuilder_1 = $fcccb206769e38dc$var$__importDefault((parcelRequire("9HWpt")));
var $fcccb206769e38dc$var$PostgrestQueryBuilder = /*#__PURE__*/ function() {
    function PostgrestQueryBuilder(url, param) {
        var _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, schema = param.schema, fetch = param.fetch;
        (0, $50OuQ._)(this, PostgrestQueryBuilder);
        this.url = url;
        this.headers = headers;
        this.schema = schema;
        this.fetch = fetch;
    }
    (0, $fGdZr._)(PostgrestQueryBuilder, [
        {
            /**
     * Perform a SELECT query on the table or view.
     *
     * @param columns - The columns to retrieve, separated by commas. Columns can be renamed when returned with `customName:columnName`
     *
     * @param options - Named parameters
     *
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     *
     * @param options.count - Count algorithm to use to count rows in the table or view.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ key: "select",
            value: function select(columns) {
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_head = _ref.head, head = _ref_head === void 0 ? false : _ref_head, count = _ref.count;
                var method = head ? 'HEAD' : 'GET';
                // Remove whitespaces except when quoted
                var quoted = false;
                var cleanedColumns = (columns !== null && columns !== void 0 ? columns : '*').split('').map(function(c) {
                    if (/\s/.test(c) && !quoted) return '';
                    if (c === '"') quoted = !quoted;
                    return c;
                }).join('');
                this.url.searchParams.set('select', cleanedColumns);
                if (count) this.headers['Prefer'] = "count=".concat(count);
                return new $fcccb206769e38dc$var$PostgrestFilterBuilder_1["default"]({
                    method: method,
                    url: this.url,
                    headers: this.headers,
                    schema: this.schema,
                    fetch: this.fetch,
                    allowEmpty: false
                });
            }
        },
        {
            /**
     * Perform an INSERT into the table or view.
     *
     * By default, inserted rows are not returned. To return it, chain the call
     * with `.select()`.
     *
     * @param values - The values to insert. Pass an object to insert a single row
     * or an array to insert multiple rows.
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count inserted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     *
     * @param options.defaultToNull - Make missing fields default to `null`.
     * Otherwise, use the default value for the column. Only applies for bulk
     * inserts.
     */ key: "insert",
            value: function insert(values) {
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, count = _ref.count, _ref_defaultToNull = _ref.defaultToNull, defaultToNull = _ref_defaultToNull === void 0 ? true : _ref_defaultToNull;
                var method = 'POST';
                var prefersHeaders = [];
                if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
                if (count) prefersHeaders.push("count=".concat(count));
                if (!defaultToNull) prefersHeaders.push('missing=default');
                this.headers['Prefer'] = prefersHeaders.join(',');
                if (Array.isArray(values)) {
                    var columns = values.reduce(function(acc, x) {
                        return acc.concat(Object.keys(x));
                    }, []);
                    if (columns.length > 0) {
                        var uniqueColumns = (0, $dHvbf._)(new Set(columns)).map(function(column) {
                            return '"'.concat(column, '"');
                        });
                        this.url.searchParams.set('columns', uniqueColumns.join(','));
                    }
                }
                return new $fcccb206769e38dc$var$PostgrestFilterBuilder_1["default"]({
                    method: method,
                    url: this.url,
                    headers: this.headers,
                    schema: this.schema,
                    body: values,
                    fetch: this.fetch,
                    allowEmpty: false
                });
            }
        },
        {
            /**
     * Perform an UPSERT on the table or view. Depending on the column(s) passed
     * to `onConflict`, `.upsert()` allows you to perform the equivalent of
     * `.insert()` if a row with the corresponding `onConflict` columns doesn't
     * exist, or if it does exist, perform an alternative action depending on
     * `ignoreDuplicates`.
     *
     * By default, upserted rows are not returned. To return it, chain the call
     * with `.select()`.
     *
     * @param values - The values to upsert with. Pass an object to upsert a
     * single row or an array to upsert multiple rows.
     *
     * @param options - Named parameters
     *
     * @param options.onConflict - Comma-separated UNIQUE column(s) to specify how
     * duplicate rows are determined. Two rows are duplicates if all the
     * `onConflict` columns are equal.
     *
     * @param options.ignoreDuplicates - If `true`, duplicate rows are ignored. If
     * `false`, duplicate rows are merged with existing rows.
     *
     * @param options.count - Count algorithm to use to count upserted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     *
     * @param options.defaultToNull - Make missing fields default to `null`.
     * Otherwise, use the default value for the column. This only applies when
     * inserting new rows, not when merging with existing rows under
     * `ignoreDuplicates: false`. This also only applies when doing bulk upserts.
     */ key: "upsert",
            value: function upsert(values) {
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, onConflict = _ref.onConflict, _ref_ignoreDuplicates = _ref.ignoreDuplicates, ignoreDuplicates = _ref_ignoreDuplicates === void 0 ? false : _ref_ignoreDuplicates, count = _ref.count, _ref_defaultToNull = _ref.defaultToNull, defaultToNull = _ref_defaultToNull === void 0 ? true : _ref_defaultToNull;
                var method = 'POST';
                var prefersHeaders = [
                    "resolution=".concat(ignoreDuplicates ? 'ignore' : 'merge', "-duplicates")
                ];
                if (onConflict !== undefined) this.url.searchParams.set('on_conflict', onConflict);
                if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
                if (count) prefersHeaders.push("count=".concat(count));
                if (!defaultToNull) prefersHeaders.push('missing=default');
                this.headers['Prefer'] = prefersHeaders.join(',');
                if (Array.isArray(values)) {
                    var columns = values.reduce(function(acc, x) {
                        return acc.concat(Object.keys(x));
                    }, []);
                    if (columns.length > 0) {
                        var uniqueColumns = (0, $dHvbf._)(new Set(columns)).map(function(column) {
                            return '"'.concat(column, '"');
                        });
                        this.url.searchParams.set('columns', uniqueColumns.join(','));
                    }
                }
                return new $fcccb206769e38dc$var$PostgrestFilterBuilder_1["default"]({
                    method: method,
                    url: this.url,
                    headers: this.headers,
                    schema: this.schema,
                    body: values,
                    fetch: this.fetch,
                    allowEmpty: false
                });
            }
        },
        {
            /**
     * Perform an UPDATE on the table or view.
     *
     * By default, updated rows are not returned. To return it, chain the call
     * with `.select()` after filters.
     *
     * @param values - The values to update with
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count updated rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ key: "update",
            value: function update(values) {
                var count = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).count;
                var method = 'PATCH';
                var prefersHeaders = [];
                if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
                if (count) prefersHeaders.push("count=".concat(count));
                this.headers['Prefer'] = prefersHeaders.join(',');
                return new $fcccb206769e38dc$var$PostgrestFilterBuilder_1["default"]({
                    method: method,
                    url: this.url,
                    headers: this.headers,
                    schema: this.schema,
                    body: values,
                    fetch: this.fetch,
                    allowEmpty: false
                });
            }
        },
        {
            /**
     * Perform a DELETE on the table or view.
     *
     * By default, deleted rows are not returned. To return it, chain the call
     * with `.select()` after filters.
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count deleted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ key: "delete",
            value: function _delete() {
                var count = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).count;
                var method = 'DELETE';
                var prefersHeaders = [];
                if (count) prefersHeaders.push("count=".concat(count));
                if (this.headers['Prefer']) prefersHeaders.unshift(this.headers['Prefer']);
                this.headers['Prefer'] = prefersHeaders.join(',');
                return new $fcccb206769e38dc$var$PostgrestFilterBuilder_1["default"]({
                    method: method,
                    url: this.url,
                    headers: this.headers,
                    schema: this.schema,
                    fetch: this.fetch,
                    allowEmpty: false
                });
            }
        }
    ]);
    return PostgrestQueryBuilder;
}();
module.exports["default"] = $fcccb206769e38dc$var$PostgrestQueryBuilder;

});
parcelRegister("dHvbf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9f977a4a91aacb97$export$71511d61b312f219; });

var $hKgIo = parcelRequire("hKgIo");

var $2j9E4 = parcelRequire("2j9E4");

var $55t4W = parcelRequire("55t4W");

var $fXGmO = parcelRequire("fXGmO");
function $9f977a4a91aacb97$export$71511d61b312f219(arr) {
    return (0, $hKgIo._)(arr) || (0, $2j9E4._)(arr) || (0, $fXGmO._)(arr) || (0, $55t4W._)();
}

});
parcelRegister("hKgIo", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ceb3b2d1d8d8e799$export$71511d61b312f219; });

var $5B3Hz = parcelRequire("5B3Hz");
function $ceb3b2d1d8d8e799$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $5B3Hz._)(arr);
}

});

parcelRegister("2j9E4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1ae4d67339a61e6c$export$71511d61b312f219; });
function $1ae4d67339a61e6c$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("55t4W", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3b43f9d018915a54$export$71511d61b312f219; });
function $3b43f9d018915a54$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("9HWpt", function(module, exports) {

var $huFCX = parcelRequire("huFCX");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $1atwj = parcelRequire("1atwj");

var $aSMts = parcelRequire("aSMts");
"use strict";
var $7115703569cd2495$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7115703569cd2495$var$PostgrestTransformBuilder_1 = $7115703569cd2495$var$__importDefault((parcelRequire("frmVa")));
var $7115703569cd2495$var$PostgrestFilterBuilder = /*#__PURE__*/ function(_PostgrestTransformBuilder_1_default) {
    (0, $1atwj._)(PostgrestFilterBuilder, _PostgrestTransformBuilder_1_default);
    function PostgrestFilterBuilder() {
        (0, $50OuQ._)(this, PostgrestFilterBuilder);
        return (0, $huFCX._)(this, PostgrestFilterBuilder, arguments);
    }
    (0, $fGdZr._)(PostgrestFilterBuilder, [
        {
            /**
     * Match only rows where `column` is equal to `value`.
     *
     * To check if the value of `column` is NULL, you should use `.is()` instead.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ key: "eq",
            value: function eq(column, value) {
                this.url.searchParams.append(column, "eq.".concat(value));
                return this;
            }
        },
        {
            /**
     * Match only rows where `column` is not equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ key: "neq",
            value: function neq(column, value) {
                this.url.searchParams.append(column, "neq.".concat(value));
                return this;
            }
        },
        {
            /**
     * Match only rows where `column` is greater than `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ key: "gt",
            value: function gt(column, value) {
                this.url.searchParams.append(column, "gt.".concat(value));
                return this;
            }
        },
        {
            /**
     * Match only rows where `column` is greater than or equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ key: "gte",
            value: function gte(column, value) {
                this.url.searchParams.append(column, "gte.".concat(value));
                return this;
            }
        },
        {
            /**
     * Match only rows where `column` is less than `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ key: "lt",
            value: function lt(column, value) {
                this.url.searchParams.append(column, "lt.".concat(value));
                return this;
            }
        },
        {
            /**
     * Match only rows where `column` is less than or equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ key: "lte",
            value: function lte(column, value) {
                this.url.searchParams.append(column, "lte.".concat(value));
                return this;
            }
        },
        {
            /**
     * Match only rows where `column` matches `pattern` case-sensitively.
     *
     * @param column - The column to filter on
     * @param pattern - The pattern to match with
     */ key: "like",
            value: function like(column, pattern) {
                this.url.searchParams.append(column, "like.".concat(pattern));
                return this;
            }
        },
        {
            /**
     * Match only rows where `column` matches all of `patterns` case-sensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ key: "likeAllOf",
            value: function likeAllOf(column, patterns) {
                this.url.searchParams.append(column, "like(all).{".concat(patterns.join(','), "}"));
                return this;
            }
        },
        {
            /**
     * Match only rows where `column` matches any of `patterns` case-sensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ key: "likeAnyOf",
            value: function likeAnyOf(column, patterns) {
                this.url.searchParams.append(column, "like(any).{".concat(patterns.join(','), "}"));
                return this;
            }
        },
        {
            /**
     * Match only rows where `column` matches `pattern` case-insensitively.
     *
     * @param column - The column to filter on
     * @param pattern - The pattern to match with
     */ key: "ilike",
            value: function ilike(column, pattern) {
                this.url.searchParams.append(column, "ilike.".concat(pattern));
                return this;
            }
        },
        {
            /**
     * Match only rows where `column` matches all of `patterns` case-insensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ key: "ilikeAllOf",
            value: function ilikeAllOf(column, patterns) {
                this.url.searchParams.append(column, "ilike(all).{".concat(patterns.join(','), "}"));
                return this;
            }
        },
        {
            /**
     * Match only rows where `column` matches any of `patterns` case-insensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ key: "ilikeAnyOf",
            value: function ilikeAnyOf(column, patterns) {
                this.url.searchParams.append(column, "ilike(any).{".concat(patterns.join(','), "}"));
                return this;
            }
        },
        {
            /**
     * Match only rows where `column` IS `value`.
     *
     * For non-boolean columns, this is only relevant for checking if the value of
     * `column` is NULL by setting `value` to `null`.
     *
     * For boolean columns, you can also set `value` to `true` or `false` and it
     * will behave the same way as `.eq()`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ key: "is",
            value: function is(column, value) {
                this.url.searchParams.append(column, "is.".concat(value));
                return this;
            }
        },
        {
            /**
     * Match only rows where `column` is included in the `values` array.
     *
     * @param column - The column to filter on
     * @param values - The values array to filter with
     */ key: "in",
            value: function _in(column, values) {
                var cleanedValues = Array.from(new Set(values)).map(function(s) {
                    // handle postgrest reserved characters
                    // https://postgrest.org/en/v7.0.0/api.html#reserved-characters
                    if (typeof s === 'string' && new RegExp('[,()]').test(s)) return '"'.concat(s, '"');
                    else return "".concat(s);
                }).join(',');
                this.url.searchParams.append(column, "in.(".concat(cleanedValues, ")"));
                return this;
            }
        },
        {
            /**
     * Only relevant for jsonb, array, and range columns. Match only rows where
     * `column` contains every element appearing in `value`.
     *
     * @param column - The jsonb, array, or range column to filter on
     * @param value - The jsonb, array, or range value to filter with
     */ key: "contains",
            value: function contains(column, value) {
                if (typeof value === 'string') // range types can be inclusive '[', ']' or exclusive '(', ')' so just
                // keep it simple and accept a string
                this.url.searchParams.append(column, "cs.".concat(value));
                else if (Array.isArray(value)) // array
                this.url.searchParams.append(column, "cs.{".concat(value.join(','), "}"));
                else // json
                this.url.searchParams.append(column, "cs.".concat(JSON.stringify(value)));
                return this;
            }
        },
        {
            /**
     * Only relevant for jsonb, array, and range columns. Match only rows where
     * every element appearing in `column` is contained by `value`.
     *
     * @param column - The jsonb, array, or range column to filter on
     * @param value - The jsonb, array, or range value to filter with
     */ key: "containedBy",
            value: function containedBy(column, value) {
                if (typeof value === 'string') // range
                this.url.searchParams.append(column, "cd.".concat(value));
                else if (Array.isArray(value)) // array
                this.url.searchParams.append(column, "cd.{".concat(value.join(','), "}"));
                else // json
                this.url.searchParams.append(column, "cd.".concat(JSON.stringify(value)));
                return this;
            }
        },
        {
            /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is greater than any element in `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ key: "rangeGt",
            value: function rangeGt(column, range) {
                this.url.searchParams.append(column, "sr.".concat(range));
                return this;
            }
        },
        {
            /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is either contained in `range` or greater than any element in
     * `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ key: "rangeGte",
            value: function rangeGte(column, range) {
                this.url.searchParams.append(column, "nxl.".concat(range));
                return this;
            }
        },
        {
            /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is less than any element in `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ key: "rangeLt",
            value: function rangeLt(column, range) {
                this.url.searchParams.append(column, "sl.".concat(range));
                return this;
            }
        },
        {
            /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is either contained in `range` or less than any element in
     * `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ key: "rangeLte",
            value: function rangeLte(column, range) {
                this.url.searchParams.append(column, "nxr.".concat(range));
                return this;
            }
        },
        {
            /**
     * Only relevant for range columns. Match only rows where `column` is
     * mutually exclusive to `range` and there can be no element between the two
     * ranges.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ key: "rangeAdjacent",
            value: function rangeAdjacent(column, range) {
                this.url.searchParams.append(column, "adj.".concat(range));
                return this;
            }
        },
        {
            /**
     * Only relevant for array and range columns. Match only rows where
     * `column` and `value` have an element in common.
     *
     * @param column - The array or range column to filter on
     * @param value - The array or range value to filter with
     */ key: "overlaps",
            value: function overlaps(column, value) {
                if (typeof value === 'string') // range
                this.url.searchParams.append(column, "ov.".concat(value));
                else // array
                this.url.searchParams.append(column, "ov.{".concat(value.join(','), "}"));
                return this;
            }
        },
        {
            /**
     * Only relevant for text and tsvector columns. Match only rows where
     * `column` matches the query string in `query`.
     *
     * @param column - The text or tsvector column to filter on
     * @param query - The query text to match with
     * @param options - Named parameters
     * @param options.config - The text search configuration to use
     * @param options.type - Change how the `query` text is interpreted
     */ key: "textSearch",
            value: function textSearch(column, query) {
                var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, config = _ref.config, type = _ref.type;
                var typePart = '';
                if (type === 'plain') typePart = 'pl';
                else if (type === 'phrase') typePart = 'ph';
                else if (type === 'websearch') typePart = 'w';
                var configPart = config === undefined ? '' : "(".concat(config, ")");
                this.url.searchParams.append(column, "".concat(typePart, "fts").concat(configPart, ".").concat(query));
                return this;
            }
        },
        {
            /**
     * Match only rows where each column in `query` keys is equal to its
     * associated value. Shorthand for multiple `.eq()`s.
     *
     * @param query - The object to filter with, with column names as keys mapped
     * to their filter values
     */ key: "match",
            value: function match(query) {
                var _this = this;
                Object.entries(query).forEach(function(param) {
                    var _param = (0, $aSMts._)(param, 2), column = _param[0], value = _param[1];
                    _this.url.searchParams.append(column, "eq.".concat(value));
                });
                return this;
            }
        },
        {
            /**
     * Match only rows which doesn't satisfy the filter.
     *
     * Unlike most filters, `opearator` and `value` are used as-is and need to
     * follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure they are properly sanitized.
     *
     * @param column - The column to filter on
     * @param operator - The operator to be negated to filter with, following
     * PostgREST syntax
     * @param value - The value to filter with, following PostgREST syntax
     */ key: "not",
            value: function not(column, operator, value) {
                this.url.searchParams.append(column, "not.".concat(operator, ".").concat(value));
                return this;
            }
        },
        {
            /**
     * Match only rows which satisfy at least one of the filters.
     *
     * Unlike most filters, `filters` is used as-is and needs to follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure it's properly sanitized.
     *
     * It's currently not possible to do an `.or()` filter across multiple tables.
     *
     * @param filters - The filters to use, following PostgREST syntax
     * @param options - Named parameters
     * @param options.referencedTable - Set this to filter on referenced tables
     * instead of the parent table
     * @param options.foreignTable - Deprecated, use `referencedTable` instead
     */ key: "or",
            value: function or(filters) {
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, foreignTable = _ref.foreignTable, _ref_referencedTable = _ref.referencedTable, referencedTable = _ref_referencedTable === void 0 ? foreignTable : _ref_referencedTable;
                var key = referencedTable ? "".concat(referencedTable, ".or") : 'or';
                this.url.searchParams.append(key, "(".concat(filters, ")"));
                return this;
            }
        },
        {
            /**
     * Match only rows which satisfy the filter. This is an escape hatch - you
     * should use the specific filter methods wherever possible.
     *
     * Unlike most filters, `opearator` and `value` are used as-is and need to
     * follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure they are properly sanitized.
     *
     * @param column - The column to filter on
     * @param operator - The operator to filter with, following PostgREST syntax
     * @param value - The value to filter with, following PostgREST syntax
     */ key: "filter",
            value: function filter(column, operator, value) {
                this.url.searchParams.append(column, "".concat(operator, ".").concat(value));
                return this;
            }
        }
    ]);
    return PostgrestFilterBuilder;
}($7115703569cd2495$var$PostgrestTransformBuilder_1["default"]);
module.exports["default"] = $7115703569cd2495$var$PostgrestFilterBuilder;

});
parcelRegister("frmVa", function(module, exports) {

var $huFCX = parcelRequire("huFCX");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $1atwj = parcelRequire("1atwj");
"use strict";
var $b3db284608244c1c$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $b3db284608244c1c$var$PostgrestBuilder_1 = $b3db284608244c1c$var$__importDefault((parcelRequire("bd5X5")));
var $b3db284608244c1c$var$PostgrestTransformBuilder = /*#__PURE__*/ function(_PostgrestBuilder_1_default) {
    (0, $1atwj._)(PostgrestTransformBuilder, _PostgrestBuilder_1_default);
    function PostgrestTransformBuilder() {
        (0, $50OuQ._)(this, PostgrestTransformBuilder);
        return (0, $huFCX._)(this, PostgrestTransformBuilder, arguments);
    }
    (0, $fGdZr._)(PostgrestTransformBuilder, [
        {
            /**
     * Perform a SELECT on the query result.
     *
     * By default, `.insert()`, `.update()`, `.upsert()`, and `.delete()` do not
     * return modified rows. By calling this method, modified rows are returned in
     * `data`.
     *
     * @param columns - The columns to retrieve, separated by commas
     */ key: "select",
            value: function select(columns) {
                // Remove whitespaces except when quoted
                var quoted = false;
                var cleanedColumns = (columns !== null && columns !== void 0 ? columns : '*').split('').map(function(c) {
                    if (/\s/.test(c) && !quoted) return '';
                    if (c === '"') quoted = !quoted;
                    return c;
                }).join('');
                this.url.searchParams.set('select', cleanedColumns);
                if (this.headers['Prefer']) this.headers['Prefer'] += ',';
                this.headers['Prefer'] += 'return=representation';
                return this;
            }
        },
        {
            /**
     * Order the query result by `column`.
     *
     * You can call this method multiple times to order by multiple columns.
     *
     * You can order referenced tables, but it only affects the ordering of the
     * parent table if you use `!inner` in the query.
     *
     * @param column - The column to order by
     * @param options - Named parameters
     * @param options.ascending - If `true`, the result will be in ascending order
     * @param options.nullsFirst - If `true`, `null`s appear first. If `false`,
     * `null`s appear last.
     * @param options.referencedTable - Set this to order a referenced table by
     * its columns
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ key: "order",
            value: function order(column) {
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_ascending = _ref.ascending, ascending = _ref_ascending === void 0 ? true : _ref_ascending, nullsFirst = _ref.nullsFirst, foreignTable = _ref.foreignTable, _ref_referencedTable = _ref.referencedTable, referencedTable = _ref_referencedTable === void 0 ? foreignTable : _ref_referencedTable;
                var key = referencedTable ? "".concat(referencedTable, ".order") : 'order';
                var existingOrder = this.url.searchParams.get(key);
                this.url.searchParams.set(key, "".concat(existingOrder ? "".concat(existingOrder, ",") : '').concat(column, ".").concat(ascending ? 'asc' : 'desc').concat(nullsFirst === undefined ? '' : nullsFirst ? '.nullsfirst' : '.nullslast'));
                return this;
            }
        },
        {
            /**
     * Limit the query result by `count`.
     *
     * @param count - The maximum number of rows to return
     * @param options - Named parameters
     * @param options.referencedTable - Set this to limit rows of referenced
     * tables instead of the parent table
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ key: "limit",
            value: function limit(count) {
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, foreignTable = _ref.foreignTable, _ref_referencedTable = _ref.referencedTable, referencedTable = _ref_referencedTable === void 0 ? foreignTable : _ref_referencedTable;
                var key = typeof referencedTable === 'undefined' ? 'limit' : "".concat(referencedTable, ".limit");
                this.url.searchParams.set(key, "".concat(count));
                return this;
            }
        },
        {
            /**
     * Limit the query result by starting at an offset `from` and ending at the offset `to`.
     * Only records within this range are returned.
     * This respects the query order and if there is no order clause the range could behave unexpectedly.
     * The `from` and `to` values are 0-based and inclusive: `range(1, 3)` will include the second, third
     * and fourth rows of the query.
     *
     * @param from - The starting index from which to limit the result
     * @param to - The last index to which to limit the result
     * @param options - Named parameters
     * @param options.referencedTable - Set this to limit rows of referenced
     * tables instead of the parent table
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ key: "range",
            value: function range(from, to) {
                var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, foreignTable = _ref.foreignTable, _ref_referencedTable = _ref.referencedTable, referencedTable = _ref_referencedTable === void 0 ? foreignTable : _ref_referencedTable;
                var keyOffset = typeof referencedTable === 'undefined' ? 'offset' : "".concat(referencedTable, ".offset");
                var keyLimit = typeof referencedTable === 'undefined' ? 'limit' : "".concat(referencedTable, ".limit");
                this.url.searchParams.set(keyOffset, "".concat(from));
                // Range is inclusive, so add 1
                this.url.searchParams.set(keyLimit, "".concat(to - from + 1));
                return this;
            }
        },
        {
            /**
     * Set the AbortSignal for the fetch request.
     *
     * @param signal - The AbortSignal to use for the fetch request
     */ key: "abortSignal",
            value: function abortSignal(signal) {
                this.signal = signal;
                return this;
            }
        },
        {
            /**
     * Return `data` as a single object instead of an array of objects.
     *
     * Query result must be one row (e.g. using `.limit(1)`), otherwise this
     * returns an error.
     */ key: "single",
            value: function single() {
                this.headers['Accept'] = 'application/vnd.pgrst.object+json';
                return this;
            }
        },
        {
            /**
     * Return `data` as a single object instead of an array of objects.
     *
     * Query result must be zero or one row (e.g. using `.limit(1)`), otherwise
     * this returns an error.
     */ key: "maybeSingle",
            value: function maybeSingle() {
                // Temporary partial fix for https://github.com/supabase/postgrest-js/issues/361
                // Issue persists e.g. for `.insert([...]).select().maybeSingle()`
                if (this.method === 'GET') this.headers['Accept'] = 'application/json';
                else this.headers['Accept'] = 'application/vnd.pgrst.object+json';
                this.isMaybeSingle = true;
                return this;
            }
        },
        {
            /**
     * Return `data` as a string in CSV format.
     */ key: "csv",
            value: function csv() {
                this.headers['Accept'] = 'text/csv';
                return this;
            }
        },
        {
            /**
     * Return `data` as an object in [GeoJSON](https://geojson.org) format.
     */ key: "geojson",
            value: function geojson() {
                this.headers['Accept'] = 'application/geo+json';
                return this;
            }
        },
        {
            /**
     * Return `data` as the EXPLAIN plan for the query.
     *
     * You need to enable the
     * [db_plan_enabled](https://supabase.com/docs/guides/database/debugging-performance#enabling-explain)
     * setting before using this method.
     *
     * @param options - Named parameters
     *
     * @param options.analyze - If `true`, the query will be executed and the
     * actual run time will be returned
     *
     * @param options.verbose - If `true`, the query identifier will be returned
     * and `data` will include the output columns of the query
     *
     * @param options.settings - If `true`, include information on configuration
     * parameters that affect query planning
     *
     * @param options.buffers - If `true`, include information on buffer usage
     *
     * @param options.wal - If `true`, include information on WAL record generation
     *
     * @param options.format - The format of the output, can be `"text"` (default)
     * or `"json"`
     */ key: "explain",
            value: function explain() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_analyze = _ref.analyze, analyze = _ref_analyze === void 0 ? false : _ref_analyze, _ref_verbose = _ref.verbose, verbose = _ref_verbose === void 0 ? false : _ref_verbose, _ref_settings = _ref.settings, settings = _ref_settings === void 0 ? false : _ref_settings, _ref_buffers = _ref.buffers, buffers = _ref_buffers === void 0 ? false : _ref_buffers, _ref_wal = _ref.wal, wal = _ref_wal === void 0 ? false : _ref_wal, _ref_format = _ref.format, format = _ref_format === void 0 ? 'text' : _ref_format;
                var _a;
                var options = [
                    analyze ? 'analyze' : null,
                    verbose ? 'verbose' : null,
                    settings ? 'settings' : null,
                    buffers ? 'buffers' : null,
                    wal ? 'wal' : null
                ].filter(Boolean).join('|');
                // An Accept header can carry multiple media types but postgrest-js always sends one
                var forMediatype = (_a = this.headers['Accept']) !== null && _a !== void 0 ? _a : 'application/json';
                this.headers['Accept'] = "application/vnd.pgrst.plan+".concat(format, '; for="').concat(forMediatype, '"; options=').concat(options, ";");
                if (format === 'json') return this;
                else return this;
            }
        },
        {
            /**
     * Rollback the query.
     *
     * `data` will still be returned, but the query is not committed.
     */ key: "rollback",
            value: function rollback() {
                var _a;
                if (((_a = this.headers['Prefer']) !== null && _a !== void 0 ? _a : '').trim().length > 0) this.headers['Prefer'] += ',tx=rollback';
                else this.headers['Prefer'] = 'tx=rollback';
                return this;
            }
        },
        {
            /**
     * Override the type of the returned `data`.
     *
     * @typeParam NewResult - The new result type to override with
     */ key: "returns",
            value: function returns() {
                return this;
            }
        }
    ]);
    return PostgrestTransformBuilder;
}($b3db284608244c1c$var$PostgrestBuilder_1["default"]);
module.exports["default"] = $b3db284608244c1c$var$PostgrestTransformBuilder;

});
parcelRegister("bd5X5", function(module, exports) {

var $5Pgs2 = parcelRequire("5Pgs2");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $1XfpH = parcelRequire("1XfpH");
"use strict";
var $82958688053228e6$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

// @ts-ignore
var $82958688053228e6$var$node_fetch_1 = $82958688053228e6$var$__importDefault((parcelRequire("TskBh")));

var $82958688053228e6$var$PostgrestError_1 = $82958688053228e6$var$__importDefault((parcelRequire("7hiup")));
var $82958688053228e6$var$PostgrestBuilder = /*#__PURE__*/ function() {
    function PostgrestBuilder(builder) {
        (0, $50OuQ._)(this, PostgrestBuilder);
        this.shouldThrowOnError = false;
        this.method = builder.method;
        this.url = builder.url;
        this.headers = builder.headers;
        this.schema = builder.schema;
        this.body = builder.body;
        this.shouldThrowOnError = builder.shouldThrowOnError;
        this.signal = builder.signal;
        this.isMaybeSingle = builder.isMaybeSingle;
        if (builder.fetch) this.fetch = builder.fetch;
        else if (typeof fetch === 'undefined') this.fetch = $82958688053228e6$var$node_fetch_1["default"];
        else this.fetch = fetch;
    }
    (0, $fGdZr._)(PostgrestBuilder, [
        {
            /**
     * If there's an error with the query, throwOnError will reject the promise by
     * throwing the error instead of returning it as part of a successful response.
     *
     * {@link https://github.com/supabase/supabase-js/issues/92}
     */ key: "throwOnError",
            value: function throwOnError() {
                this.shouldThrowOnError = true;
                return this;
            }
        },
        {
            /**
     * Set an HTTP header for the request.
     */ key: "setHeader",
            value: function setHeader(name, value) {
                this.headers = Object.assign({}, this.headers);
                this.headers[name] = value;
                return this;
            }
        },
        {
            key: "then",
            value: function then(onfulfilled, onrejected) {
                // https://postgrest.org/en/stable/api.html#switching-schemas
                if (this.schema === undefined) ;
                else if ([
                    'GET',
                    'HEAD'
                ].includes(this.method)) this.headers['Accept-Profile'] = this.schema;
                else this.headers['Content-Profile'] = this.schema;
                if (this.method !== 'GET' && this.method !== 'HEAD') this.headers['Content-Type'] = 'application/json';
                // NOTE: Invoke w/o `this` to avoid illegal invocation error.
                // https://github.com/supabase/postgrest-js/pull/247
                var _fetch = this.fetch;
                var _this = this;
                var res = _fetch(this.url.toString(), {
                    method: this.method,
                    headers: this.headers,
                    body: JSON.stringify(this.body),
                    signal: this.signal
                }).then(/*#__PURE__*/ function() {
                    var _ref = (0, $5Pgs2._)(function(res) {
                        var _a, _b, _c, error, data, count, status, statusText, body, countHeader, contentRange, body1, postgrestResponse;
                        return (0, $1XfpH.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    error = null;
                                    data = null;
                                    count = null;
                                    status = res.status;
                                    statusText = res.statusText;
                                    if (!res.ok) return [
                                        3,
                                        3
                                    ];
                                    if (!(_this.method !== 'HEAD')) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        res.text()
                                    ];
                                case 1:
                                    body = _state.sent();
                                    if (body === '') ;
                                    else if (_this.headers['Accept'] === 'text/csv') data = body;
                                    else if (_this.headers['Accept'] && _this.headers['Accept'].includes('application/vnd.pgrst.plan+text')) data = body;
                                    else data = JSON.parse(body);
                                    _state.label = 2;
                                case 2:
                                    countHeader = (_a = _this.headers['Prefer']) === null || _a === void 0 ? void 0 : _a.match(/count=(exact|planned|estimated)/);
                                    contentRange = (_b = res.headers.get('content-range')) === null || _b === void 0 ? void 0 : _b.split('/');
                                    if (countHeader && contentRange && contentRange.length > 1) count = parseInt(contentRange[1]);
                                    // Temporary partial fix for https://github.com/supabase/postgrest-js/issues/361
                                    // Issue persists e.g. for `.insert([...]).select().maybeSingle()`
                                    if (_this.isMaybeSingle && _this.method === 'GET' && Array.isArray(data)) {
                                        if (data.length > 1) {
                                            error = {
                                                // https://github.com/PostgREST/postgrest/blob/a867d79c42419af16c18c3fb019eba8df992626f/src/PostgREST/Error.hs#L553
                                                code: 'PGRST116',
                                                details: "Results contain ".concat(data.length, " rows, application/vnd.pgrst.object+json requires 1 row"),
                                                hint: null,
                                                message: 'JSON object requested, multiple (or no) rows returned'
                                            };
                                            data = null;
                                            count = null;
                                            status = 406;
                                            statusText = 'Not Acceptable';
                                        } else if (data.length === 1) data = data[0];
                                        else data = null;
                                    }
                                    return [
                                        3,
                                        5
                                    ];
                                case 3:
                                    return [
                                        4,
                                        res.text()
                                    ];
                                case 4:
                                    body1 = _state.sent();
                                    try {
                                        error = JSON.parse(body1);
                                        // Workaround for https://github.com/supabase/postgrest-js/issues/295
                                        if (Array.isArray(error) && res.status === 404) {
                                            data = [];
                                            error = null;
                                            status = 200;
                                            statusText = 'OK';
                                        }
                                    } catch (_d) {
                                        // Workaround for https://github.com/supabase/postgrest-js/issues/295
                                        if (res.status === 404 && body1 === '') {
                                            status = 204;
                                            statusText = 'No Content';
                                        } else error = {
                                            message: body1
                                        };
                                    }
                                    if (error && _this.isMaybeSingle && ((_c = error === null || error === void 0 ? void 0 : error.details) === null || _c === void 0 ? void 0 : _c.includes('0 rows'))) {
                                        error = null;
                                        status = 200;
                                        statusText = 'OK';
                                    }
                                    if (error && _this.shouldThrowOnError) throw new $82958688053228e6$var$PostgrestError_1["default"](error);
                                    _state.label = 5;
                                case 5:
                                    postgrestResponse = {
                                        error: error,
                                        data: data,
                                        count: count,
                                        status: status,
                                        statusText: statusText
                                    };
                                    return [
                                        2,
                                        postgrestResponse
                                    ];
                            }
                        });
                    });
                    return function(res) {
                        return _ref.apply(this, arguments);
                    };
                }());
                if (!this.shouldThrowOnError) res = res["catch"](function(fetchError) {
                    var _a, _b, _c;
                    return {
                        error: {
                            message: "".concat((_a = fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) !== null && _a !== void 0 ? _a : 'FetchError', ": ").concat(fetchError === null || fetchError === void 0 ? void 0 : fetchError.message),
                            details: "".concat((_b = fetchError === null || fetchError === void 0 ? void 0 : fetchError.stack) !== null && _b !== void 0 ? _b : ''),
                            hint: '',
                            code: "".concat((_c = fetchError === null || fetchError === void 0 ? void 0 : fetchError.code) !== null && _c !== void 0 ? _c : '')
                        },
                        data: null,
                        count: null,
                        status: 0,
                        statusText: ''
                    };
                });
                return res.then(onfulfilled, onrejected);
            }
        }
    ]);
    return PostgrestBuilder;
}();
module.exports["default"] = $82958688053228e6$var$PostgrestBuilder;

});
parcelRegister("5Pgs2", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $43de7a0b82198241$export$71511d61b312f219; });
function $43de7a0b82198241$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $43de7a0b82198241$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $43de7a0b82198241$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $43de7a0b82198241$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("1XfpH", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $16c741eabde15b91$export$67ebef60e6f28a6; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $qb7pP = parcelRequire("qb7pP");
var $16c741eabde15b91$var$extendStatics = function extendStatics1(d, b) {
    $16c741eabde15b91$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $16c741eabde15b91$var$extendStatics(d, b);
};
function $16c741eabde15b91$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $16c741eabde15b91$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $16c741eabde15b91$export$18ce0697a983be9b = function __assign1() {
    $16c741eabde15b91$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $16c741eabde15b91$export$18ce0697a983be9b.apply(this, arguments);
};
function $16c741eabde15b91$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $16c741eabde15b91$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $qb7pP._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $16c741eabde15b91$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $16c741eabde15b91$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $qb7pP._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $16c741eabde15b91$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $16c741eabde15b91$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $qb7pP._)(x)) === "symbol" ? x : "".concat(x);
}
function $16c741eabde15b91$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $qb7pP._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $16c741eabde15b91$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $qb7pP._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $16c741eabde15b91$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $16c741eabde15b91$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $16c741eabde15b91$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $16c741eabde15b91$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $16c741eabde15b91$export$45d3717a4c69092e(o, m, p);
}
function $16c741eabde15b91$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $16c741eabde15b91$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $16c741eabde15b91$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($16c741eabde15b91$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $16c741eabde15b91$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $16c741eabde15b91$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $16c741eabde15b91$export$10c90e4f7922046c(v) {
    return this instanceof $16c741eabde15b91$export$10c90e4f7922046c ? (this.v = v, this) : new $16c741eabde15b91$export$10c90e4f7922046c(v);
}
function $16c741eabde15b91$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $16c741eabde15b91$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $16c741eabde15b91$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $16c741eabde15b91$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $16c741eabde15b91$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $16c741eabde15b91$export$19a8beecd37a4c45 === "function" ? $16c741eabde15b91$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $16c741eabde15b91$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $16c741eabde15b91$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $16c741eabde15b91$var$ownKeys = function ownKeys1(o) {
    $16c741eabde15b91$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $16c741eabde15b91$var$ownKeys(o);
};
function $16c741eabde15b91$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $16c741eabde15b91$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $16c741eabde15b91$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $16c741eabde15b91$var$__setModuleDefault(result, mod);
    return result;
}
function $16c741eabde15b91$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
}
function $16c741eabde15b91$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $16c741eabde15b91$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $16c741eabde15b91$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $qb7pP._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $16c741eabde15b91$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $qb7pP._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $16c741eabde15b91$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $16c741eabde15b91$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $16c741eabde15b91$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $16c741eabde15b91$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $16c741eabde15b91$export$2e2bcd8739ae039 = {
    __extends: $16c741eabde15b91$export$a8ba968b8961cb8a,
    __assign: $16c741eabde15b91$export$18ce0697a983be9b,
    __rest: $16c741eabde15b91$export$3c9a16f847548506,
    __decorate: $16c741eabde15b91$export$29e00dfd3077644b,
    __param: $16c741eabde15b91$export$d5ad3fd78186038f,
    __esDecorate: $16c741eabde15b91$export$3a84e1ae4e97e9b0,
    __runInitializers: $16c741eabde15b91$export$d831c04e792af3d,
    __propKey: $16c741eabde15b91$export$6a2a36740a146cb8,
    __setFunctionName: $16c741eabde15b91$export$d1a06452d3489bc7,
    __metadata: $16c741eabde15b91$export$f1db080c865becb9,
    __awaiter: $16c741eabde15b91$export$1050f835b63b671e,
    __generator: $16c741eabde15b91$export$67ebef60e6f28a6,
    __createBinding: $16c741eabde15b91$export$45d3717a4c69092e,
    __exportStar: $16c741eabde15b91$export$f33643c0debef087,
    __values: $16c741eabde15b91$export$19a8beecd37a4c45,
    __read: $16c741eabde15b91$export$8d051b38c9118094,
    __spread: $16c741eabde15b91$export$afc72e2116322959,
    __spreadArrays: $16c741eabde15b91$export$6388937ca91ccae8,
    __spreadArray: $16c741eabde15b91$export$1216008129fb82ed,
    __await: $16c741eabde15b91$export$10c90e4f7922046c,
    __asyncGenerator: $16c741eabde15b91$export$e427f37a30a4de9b,
    __asyncDelegator: $16c741eabde15b91$export$bbd80228419bb833,
    __asyncValues: $16c741eabde15b91$export$e3b29a3d6162315f,
    __makeTemplateObject: $16c741eabde15b91$export$4fb47efe1390b86f,
    __importStar: $16c741eabde15b91$export$c21735bcef00d192,
    __importDefault: $16c741eabde15b91$export$da59b14a69baef04,
    __classPrivateFieldGet: $16c741eabde15b91$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $16c741eabde15b91$export$d40a35129aaff81f,
    __classPrivateFieldIn: $16c741eabde15b91$export$81fdc39f203e4e04,
    __addDisposableResource: $16c741eabde15b91$export$88ac25d8e944e405,
    __disposeResources: $16c741eabde15b91$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $16c741eabde15b91$export$889dfb5d17574b0b
};

});

parcelRegister("TskBh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "fetch", function () { return $0a6b1d2ad0fc65ba$export$e7aa7bc5c1b3cfb3; });
$parcel$export(module.exports, "default", function () { return $0a6b1d2ad0fc65ba$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Headers", function () { return $0a6b1d2ad0fc65ba$export$79b704688b15c0f4; });
$parcel$export(module.exports, "Request", function () { return $0a6b1d2ad0fc65ba$export$7fa6c5b6f8193917; });
$parcel$export(module.exports, "Response", function () { return $0a6b1d2ad0fc65ba$export$9f633d56d7ec90d3; });
"use strict";
// ref: https://github.com/tc39/proposal-global
var $0a6b1d2ad0fc65ba$var$getGlobal = function getGlobal() {
    // the only reliable means to get the global object is
    // `Function('return this')()`
    // However, this causes CSP violations in Chrome apps.
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('unable to locate global object');
};
var $0a6b1d2ad0fc65ba$var$globalObject = $0a6b1d2ad0fc65ba$var$getGlobal();
var $0a6b1d2ad0fc65ba$export$e7aa7bc5c1b3cfb3 = $0a6b1d2ad0fc65ba$var$globalObject.fetch;
var $0a6b1d2ad0fc65ba$export$2e2bcd8739ae039 = $0a6b1d2ad0fc65ba$var$globalObject.fetch.bind($0a6b1d2ad0fc65ba$var$globalObject);
var $0a6b1d2ad0fc65ba$export$79b704688b15c0f4 = $0a6b1d2ad0fc65ba$var$globalObject.Headers;
var $0a6b1d2ad0fc65ba$export$7fa6c5b6f8193917 = $0a6b1d2ad0fc65ba$var$globalObject.Request;
var $0a6b1d2ad0fc65ba$export$9f633d56d7ec90d3 = $0a6b1d2ad0fc65ba$var$globalObject.Response;

});

parcelRegister("7hiup", function(module, exports) {

var $huFCX = parcelRequire("huFCX");

var $50OuQ = parcelRequire("50OuQ");

var $1atwj = parcelRequire("1atwj");

var $jc6v0 = parcelRequire("jc6v0");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Error format
 *
 * {@link https://postgrest.org/en/stable/api.html?highlight=options#errors-and-http-status-codes}
 */ var $54c87692631fa8e0$var$PostgrestError = /*#__PURE__*/ function(Error1) {
    (0, $1atwj._)(PostgrestError, Error1);
    function PostgrestError(context) {
        (0, $50OuQ._)(this, PostgrestError);
        var _this;
        _this = (0, $huFCX._)(this, PostgrestError, [
            context.message
        ]);
        _this.name = 'PostgrestError';
        _this.details = context.details;
        _this.hint = context.hint;
        _this.code = context.code;
        return _this;
    }
    return PostgrestError;
}((0, $jc6v0._)(Error));
module.exports["default"] = $54c87692631fa8e0$var$PostgrestError;

});
parcelRegister("jc6v0", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $df942de5c60d7946$export$71511d61b312f219; });

var $kkvIW = parcelRequire("kkvIW");

var $bykok = parcelRequire("bykok");

var $lCPdn = parcelRequire("lCPdn");

var $4USSx = parcelRequire("4USSx");
function $df942de5c60d7946$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $df942de5c60d7946$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $lCPdn._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $kkvIW._)(Class, arguments, (0, $bykok._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $4USSx._)(Wrapper, Class);
    };
    return $df942de5c60d7946$export$71511d61b312f219(Class);
}

});
parcelRegister("kkvIW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ecce489e508aa395$export$71511d61b312f219; });

var $kW87r = parcelRequire("kW87r");

var $4USSx = parcelRequire("4USSx");
function $ecce489e508aa395$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $kW87r._)()) $ecce489e508aa395$export$71511d61b312f219 = Reflect.construct;
    else $ecce489e508aa395$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $4USSx._)(instance, Class.prototype);
        return instance;
    };
    return $ecce489e508aa395$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("lCPdn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fbe4dfc35693931c$export$71511d61b312f219; });
function $fbe4dfc35693931c$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});







parcelRegister("Lvz7W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_HEADERS = void 0;

var $hQdxQ = parcelRequire("hQdxQ");
module.exports.DEFAULT_HEADERS = {
    'X-Client-Info': "postgrest-js/".concat($hQdxQ.version)
};

});
parcelRegister("hQdxQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.version = void 0;
module.exports.version = '0.0.0-automated';

});



parcelRegister("67Sz8", function(module, exports) {


module.exports = (parcelRequire("iwOd7"))((parcelRequire("7meeL")).resolve("3aMbB")).then(function() {
    return parcelRequire('bhaAc');
});

});
parcelRegister("iwOd7", function(module, exports) {
"use strict";

var $axrlS = parcelRequire("axrlS");
module.exports = $axrlS(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("axrlS", function(module, exports) {
"use strict";
var $7ac233fabe109637$var$cachedBundles = {};
var $7ac233fabe109637$var$cachedPreloads = {};
var $7ac233fabe109637$var$cachedPrefetches = {};
function $7ac233fabe109637$var$getCache(type) {
    switch(type){
        case 'preload':
            return $7ac233fabe109637$var$cachedPreloads;
        case 'prefetch':
            return $7ac233fabe109637$var$cachedPrefetches;
        default:
            return $7ac233fabe109637$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $7ac233fabe109637$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments)["catch"](function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $ce3f4fd82ca9f3fd$exports = {};


(parcelRequire("7meeL")).register((parcelRequire("c6lZy")).getBundleURL('1mAAk'), JSON.parse("[\"1mAAk\",\"index.06c2a6e5.js\",\"1BQ3j\",\"cover-fallback.e125975b.webp\",\"7ZjgJ\",\"sprite.74c91b86.svg\",\"4KvtF\",\"error.49304dea.gif\",\"4JVxn\",\"poweredbygoogle.8a5e9e15.png\",\"jscZC\",\"home_create-plans.09f1a898.webp\",\"NPsib\",\"home_save-plans.d00dc7f1.webp\",\"gM4Ry\",\"home_share-plans.197cf6dd.webp\",\"dBjK8\",\"poweredbygoogle.8a5e9e15.png\",\"3aMbB\",\"browser.55645b99.js\"]"));


var $5Pgs2 = parcelRequire("5Pgs2");
function $1aca3bdf51b67d66$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $50aa2eeb65885e7e$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $1aca3bdf51b67d66$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}



var $1XfpH = parcelRequire("1XfpH");
'use strict';
'use strict';
var $500d5d8b5806b834$exports = {};

var $qb7pP = parcelRequire("qb7pP");
'use strict';
var $9be6fcc00ef60f58$exports = {};

var $qb7pP = parcelRequire("qb7pP");
'use strict';
var $9be6fcc00ef60f58$var$check = function check(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$9be6fcc00ef60f58$exports = // eslint-disable-next-line es/no-global-this -- safe
$9be6fcc00ef60f58$var$check((typeof globalThis === "undefined" ? "undefined" : (0, $qb7pP._)(globalThis)) == 'object' && globalThis) || $9be6fcc00ef60f58$var$check((typeof window === "undefined" ? "undefined" : (0, $qb7pP._)(window)) == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$9be6fcc00ef60f58$var$check((typeof self === "undefined" ? "undefined" : (0, $qb7pP._)(self)) == 'object' && self) || $9be6fcc00ef60f58$var$check((typeof $parcel$global === "undefined" ? "undefined" : (0, $qb7pP._)($parcel$global)) == 'object' && $parcel$global) || $9be6fcc00ef60f58$var$check((0, $qb7pP._)(undefined) == 'object' && undefined) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();


var $bb417845773708b5$exports = {};

$parcel$export($bb417845773708b5$exports, "f", function () { return $bb417845773708b5$export$2d1720544b23b823; }, function (v) { return $bb417845773708b5$export$2d1720544b23b823 = v; });
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $bb417845773708b5$export$2d1720544b23b823;
'use strict';
var $6ffb7908e83cf36c$exports = {};
'use strict';
var $06c7d56a730e31f1$exports = {};
'use strict';
$06c7d56a730e31f1$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$6ffb7908e83cf36c$exports = !$06c7d56a730e31f1$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function get() {
            return 7;
        }
    })[1] !== 7;
});


var $e3ebd8cb7f512f74$exports = {};
'use strict';
var $0945d194f6c2c4f6$exports = {};
'use strict';

$0945d194f6c2c4f6$exports = !$06c7d56a730e31f1$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});


var $e3ebd8cb7f512f74$var$call = Function.prototype.call;
$e3ebd8cb7f512f74$exports = $0945d194f6c2c4f6$exports ? $e3ebd8cb7f512f74$var$call.bind($e3ebd8cb7f512f74$var$call) : function() {
    return $e3ebd8cb7f512f74$var$call.apply($e3ebd8cb7f512f74$var$call, arguments);
};


var $7365bb173f3e63f5$exports = {};

$parcel$export($7365bb173f3e63f5$exports, "f", function () { return $7365bb173f3e63f5$export$2d1720544b23b823; }, function (v) { return $7365bb173f3e63f5$export$2d1720544b23b823 = v; });
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $7365bb173f3e63f5$export$2d1720544b23b823;
'use strict';
var $7365bb173f3e63f5$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $7365bb173f3e63f5$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $7365bb173f3e63f5$var$NASHORN_BUG = $7365bb173f3e63f5$var$getOwnPropertyDescriptor && !$7365bb173f3e63f5$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$7365bb173f3e63f5$export$2d1720544b23b823 = $7365bb173f3e63f5$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $7365bb173f3e63f5$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $7365bb173f3e63f5$var$$propertyIsEnumerable;


var $f89eb1caea2679b0$exports = {};
'use strict';
$f89eb1caea2679b0$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $e656dbd61e0a8253$exports = {};
'use strict';
var $a71603b0710a8479$exports = {};
'use strict';
var $1689570c06db508b$exports = {};
'use strict';

var $1689570c06db508b$var$FunctionPrototype = Function.prototype;
var $1689570c06db508b$var$call = $1689570c06db508b$var$FunctionPrototype.call;
var $1689570c06db508b$var$uncurryThisWithBind = $0945d194f6c2c4f6$exports && $1689570c06db508b$var$FunctionPrototype.bind.bind($1689570c06db508b$var$call, $1689570c06db508b$var$call);
$1689570c06db508b$exports = $0945d194f6c2c4f6$exports ? $1689570c06db508b$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $1689570c06db508b$var$call.apply(fn, arguments);
    };
};



var $9afeb253af368f01$exports = {};
'use strict';

var $9afeb253af368f01$var$toString = $1689570c06db508b$exports({}.toString);
var $9afeb253af368f01$var$stringSlice = $1689570c06db508b$exports(''.slice);
$9afeb253af368f01$exports = function(it) {
    return $9afeb253af368f01$var$stringSlice($9afeb253af368f01$var$toString(it), 8, -1);
};


var $a71603b0710a8479$var$$Object = Object;
var $a71603b0710a8479$var$split = $1689570c06db508b$exports(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$a71603b0710a8479$exports = $06c7d56a730e31f1$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$a71603b0710a8479$var$$Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $9afeb253af368f01$exports(it) === 'String' ? $a71603b0710a8479$var$split(it, '') : $a71603b0710a8479$var$$Object(it);
} : $a71603b0710a8479$var$$Object;


var $fdf84a64c2f63ac3$exports = {};
'use strict';
var $8d82b0b487ce9bb5$exports = {};
'use strict';
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$8d82b0b487ce9bb5$exports = function(it) {
    return it === null || it === undefined;
};


var $fdf84a64c2f63ac3$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$fdf84a64c2f63ac3$exports = function(it) {
    if ($8d82b0b487ce9bb5$exports(it)) throw new $fdf84a64c2f63ac3$var$$TypeError("Can't call method on " + it);
    return it;
};


$e656dbd61e0a8253$exports = function(it) {
    return $a71603b0710a8479$exports($fdf84a64c2f63ac3$exports(it));
};


var $282f32d47e9dd4f8$exports = {};
'use strict';
var $50b25b11d61908fe$exports = {};
'use strict';

var $d2d3162bdcc39b88$exports = {};

var $qb7pP = parcelRequire("qb7pP");
'use strict';
var $0a82f0a5368b6870$exports = {};

var $qb7pP = parcelRequire("qb7pP");
'use strict';
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $0a82f0a5368b6870$var$documentAll = (typeof document === "undefined" ? "undefined" : (0, $qb7pP._)(document)) == 'object' && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$0a82f0a5368b6870$exports = typeof $0a82f0a5368b6870$var$documentAll == 'undefined' && $0a82f0a5368b6870$var$documentAll !== undefined ? function(argument) {
    return typeof argument == 'function' || argument === $0a82f0a5368b6870$var$documentAll;
} : function(argument) {
    return typeof argument == 'function';
};


$d2d3162bdcc39b88$exports = function(it) {
    return (typeof it === "undefined" ? "undefined" : (0, $qb7pP._)(it)) == 'object' ? it !== null : $0a82f0a5368b6870$exports(it);
};


var $4cdbccb02aa7d286$exports = {};

var $qb7pP = parcelRequire("qb7pP");
'use strict';
var $36de342b7315604e$exports = {};
'use strict';


var $36de342b7315604e$var$aFunction = function aFunction(argument) {
    return $0a82f0a5368b6870$exports(argument) ? argument : undefined;
};
$36de342b7315604e$exports = function(namespace, method) {
    return arguments.length < 2 ? $36de342b7315604e$var$aFunction($9be6fcc00ef60f58$exports[namespace]) : $9be6fcc00ef60f58$exports[namespace] && $9be6fcc00ef60f58$exports[namespace][method];
};



var $bc714f4a9c09d4bd$exports = {};
'use strict';

$bc714f4a9c09d4bd$exports = $1689570c06db508b$exports({}.isPrototypeOf);


var $757c0802344784a9$exports = {};

var $qb7pP = parcelRequire("qb7pP");
'use strict';
var $3ccde59009348858$exports = {};
'use strict';
var $9d47635dcaf33179$exports = {};
'use strict';

var $57973a61a761d756$exports = {};
'use strict';

var $57973a61a761d756$var$navigator = $9be6fcc00ef60f58$exports.navigator;
var $57973a61a761d756$var$userAgent = $57973a61a761d756$var$navigator && $57973a61a761d756$var$navigator.userAgent;
$57973a61a761d756$exports = $57973a61a761d756$var$userAgent ? String($57973a61a761d756$var$userAgent) : '';


var $9d47635dcaf33179$var$process = $9be6fcc00ef60f58$exports.process;
var $9d47635dcaf33179$var$Deno = $9be6fcc00ef60f58$exports.Deno;
var $9d47635dcaf33179$var$versions = $9d47635dcaf33179$var$process && $9d47635dcaf33179$var$process.versions || $9d47635dcaf33179$var$Deno && $9d47635dcaf33179$var$Deno.version;
var $9d47635dcaf33179$var$v8 = $9d47635dcaf33179$var$versions && $9d47635dcaf33179$var$versions.v8;
var $9d47635dcaf33179$var$match, $9d47635dcaf33179$var$version;
if ($9d47635dcaf33179$var$v8) {
    $9d47635dcaf33179$var$match = $9d47635dcaf33179$var$v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $9d47635dcaf33179$var$version = $9d47635dcaf33179$var$match[0] > 0 && $9d47635dcaf33179$var$match[0] < 4 ? 1 : +($9d47635dcaf33179$var$match[0] + $9d47635dcaf33179$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$9d47635dcaf33179$var$version && $57973a61a761d756$exports) {
    $9d47635dcaf33179$var$match = $57973a61a761d756$exports.match(/Edge\/(\d+)/);
    if (!$9d47635dcaf33179$var$match || $9d47635dcaf33179$var$match[1] >= 74) {
        $9d47635dcaf33179$var$match = $57973a61a761d756$exports.match(/Chrome\/(\d+)/);
        if ($9d47635dcaf33179$var$match) $9d47635dcaf33179$var$version = +$9d47635dcaf33179$var$match[1];
    }
}
$9d47635dcaf33179$exports = $9d47635dcaf33179$var$version;




var $3ccde59009348858$var$$String = $9be6fcc00ef60f58$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$3ccde59009348858$exports = !!Object.getOwnPropertySymbols && !$06c7d56a730e31f1$exports(function() {
    var symbol = Symbol('symbol detection');
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$3ccde59009348858$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $9d47635dcaf33179$exports && $9d47635dcaf33179$exports < 41;
});


$757c0802344784a9$exports = $3ccde59009348858$exports && !Symbol.sham && (0, $qb7pP._)(Symbol.iterator) == 'symbol';


var $4cdbccb02aa7d286$var$$Object = Object;
$4cdbccb02aa7d286$exports = $757c0802344784a9$exports ? function(it) {
    return (typeof it === "undefined" ? "undefined" : (0, $qb7pP._)(it)) == 'symbol';
} : function(it) {
    var $Symbol = $36de342b7315604e$exports('Symbol');
    return $0a82f0a5368b6870$exports($Symbol) && $bc714f4a9c09d4bd$exports($Symbol.prototype, $4cdbccb02aa7d286$var$$Object(it));
};


var $430a0bdb40365e72$exports = {};
'use strict';
var $c976080d379e828f$exports = {};
'use strict';

var $53c3bf74c3e856bf$exports = {};
'use strict';
var $53c3bf74c3e856bf$var$$String = String;
$53c3bf74c3e856bf$exports = function(argument) {
    try {
        return $53c3bf74c3e856bf$var$$String(argument);
    } catch (error) {
        return 'Object';
    }
};


var $c976080d379e828f$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$c976080d379e828f$exports = function(argument) {
    if ($0a82f0a5368b6870$exports(argument)) return argument;
    throw new $c976080d379e828f$var$$TypeError($53c3bf74c3e856bf$exports(argument) + ' is not a function');
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$430a0bdb40365e72$exports = function(V, P) {
    var func = V[P];
    return $8d82b0b487ce9bb5$exports(func) ? undefined : $c976080d379e828f$exports(func);
};


var $3625f92b2265aab4$exports = {};
'use strict';



var $3625f92b2265aab4$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$3625f92b2265aab4$exports = function(input, pref) {
    var fn, val;
    if (pref === 'string' && $0a82f0a5368b6870$exports(fn = input.toString) && !$d2d3162bdcc39b88$exports(val = $e3ebd8cb7f512f74$exports(fn, input))) return val;
    if ($0a82f0a5368b6870$exports(fn = input.valueOf) && !$d2d3162bdcc39b88$exports(val = $e3ebd8cb7f512f74$exports(fn, input))) return val;
    if (pref !== 'string' && $0a82f0a5368b6870$exports(fn = input.toString) && !$d2d3162bdcc39b88$exports(val = $e3ebd8cb7f512f74$exports(fn, input))) return val;
    throw new $3625f92b2265aab4$var$$TypeError("Can't convert object to primitive value");
};


var $6268abd12745dd3b$exports = {};
'use strict';

var $cc5c269a44b6e335$exports = {};
'use strict';
var $72e9bcc33ae310b9$exports = {};
'use strict';
var $62bf9cf43d01f7ec$exports = {};
'use strict';
$62bf9cf43d01f7ec$exports = false;



var $f82bb239fcc043cf$exports = {};
'use strict';

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $f82bb239fcc043cf$var$defineProperty = Object.defineProperty;
$f82bb239fcc043cf$exports = function(key, value) {
    try {
        $f82bb239fcc043cf$var$defineProperty($9be6fcc00ef60f58$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $9be6fcc00ef60f58$exports[key] = value;
    }
    return value;
};


var $72e9bcc33ae310b9$var$SHARED = '__core-js_shared__';
var $72e9bcc33ae310b9$var$store = $72e9bcc33ae310b9$exports = $9be6fcc00ef60f58$exports[$72e9bcc33ae310b9$var$SHARED] || $f82bb239fcc043cf$exports($72e9bcc33ae310b9$var$SHARED, {});
($72e9bcc33ae310b9$var$store.versions || ($72e9bcc33ae310b9$var$store.versions = [])).push({
    version: '3.39.0',
    mode: $62bf9cf43d01f7ec$exports ? 'pure' : 'global',
    copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
    license: 'https://github.com/zloirock/core-js/blob/v3.39.0/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});


$cc5c269a44b6e335$exports = function(key, value) {
    return $72e9bcc33ae310b9$exports[key] || ($72e9bcc33ae310b9$exports[key] = value || {});
};


var $35cf4bf79fe152cc$exports = {};
'use strict';

var $ec839b558eb5dcf4$exports = {};
'use strict';

var $ec839b558eb5dcf4$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$ec839b558eb5dcf4$exports = function(argument) {
    return $ec839b558eb5dcf4$var$$Object($fdf84a64c2f63ac3$exports(argument));
};


var $35cf4bf79fe152cc$var$hasOwnProperty = $1689570c06db508b$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$35cf4bf79fe152cc$exports = Object.hasOwn || function hasOwn(it, key) {
    return $35cf4bf79fe152cc$var$hasOwnProperty($ec839b558eb5dcf4$exports(it), key);
};


var $a90ea85f631354d3$exports = {};
'use strict';

var $a90ea85f631354d3$var$id = 0;
var $a90ea85f631354d3$var$postfix = Math.random();
var $a90ea85f631354d3$var$toString = $1689570c06db508b$exports(1.0.toString);
$a90ea85f631354d3$exports = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + $a90ea85f631354d3$var$toString(++$a90ea85f631354d3$var$id + $a90ea85f631354d3$var$postfix, 36);
};




var $6268abd12745dd3b$var$Symbol = $9be6fcc00ef60f58$exports.Symbol;
var $6268abd12745dd3b$var$WellKnownSymbolsStore = $cc5c269a44b6e335$exports('wks');
var $6268abd12745dd3b$var$createWellKnownSymbol = $757c0802344784a9$exports ? $6268abd12745dd3b$var$Symbol['for'] || $6268abd12745dd3b$var$Symbol : $6268abd12745dd3b$var$Symbol && $6268abd12745dd3b$var$Symbol.withoutSetter || $a90ea85f631354d3$exports;
$6268abd12745dd3b$exports = function(name) {
    if (!$35cf4bf79fe152cc$exports($6268abd12745dd3b$var$WellKnownSymbolsStore, name)) $6268abd12745dd3b$var$WellKnownSymbolsStore[name] = $3ccde59009348858$exports && $35cf4bf79fe152cc$exports($6268abd12745dd3b$var$Symbol, name) ? $6268abd12745dd3b$var$Symbol[name] : $6268abd12745dd3b$var$createWellKnownSymbol('Symbol.' + name);
    return $6268abd12745dd3b$var$WellKnownSymbolsStore[name];
};


var $50b25b11d61908fe$var$$TypeError = TypeError;
var $50b25b11d61908fe$var$TO_PRIMITIVE = $6268abd12745dd3b$exports('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$50b25b11d61908fe$exports = function(input, pref) {
    if (!$d2d3162bdcc39b88$exports(input) || $4cdbccb02aa7d286$exports(input)) return input;
    var exoticToPrim = $430a0bdb40365e72$exports(input, $50b25b11d61908fe$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = $e3ebd8cb7f512f74$exports(exoticToPrim, input, pref);
        if (!$d2d3162bdcc39b88$exports(result) || $4cdbccb02aa7d286$exports(result)) return result;
        throw new $50b25b11d61908fe$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return $3625f92b2265aab4$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$282f32d47e9dd4f8$exports = function(argument) {
    var key = $50b25b11d61908fe$exports(argument, 'string');
    return $4cdbccb02aa7d286$exports(key) ? key : key + '';
};



var $7fa96d66dead4ceb$exports = {};
'use strict';


var $b4e20123d93a8378$exports = {};
'use strict';


var $b4e20123d93a8378$var$document = $9be6fcc00ef60f58$exports.document;
// typeof document.createElement is 'object' in old IE
var $b4e20123d93a8378$var$EXISTS = $d2d3162bdcc39b88$exports($b4e20123d93a8378$var$document) && $d2d3162bdcc39b88$exports($b4e20123d93a8378$var$document.createElement);
$b4e20123d93a8378$exports = function(it) {
    return $b4e20123d93a8378$var$EXISTS ? $b4e20123d93a8378$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$7fa96d66dead4ceb$exports = !$6ffb7908e83cf36c$exports && !$06c7d56a730e31f1$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($b4e20123d93a8378$exports('div'), 'a', {
        get: function get() {
            return 7;
        }
    }).a !== 7;
});


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $bb417845773708b5$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$bb417845773708b5$export$2d1720544b23b823 = $6ffb7908e83cf36c$exports ? $bb417845773708b5$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $e656dbd61e0a8253$exports(O);
    P = $282f32d47e9dd4f8$exports(P);
    if ($7fa96d66dead4ceb$exports) try {
        return $bb417845773708b5$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($35cf4bf79fe152cc$exports(O, P)) return $f89eb1caea2679b0$exports(!$e3ebd8cb7f512f74$exports($7365bb173f3e63f5$export$2d1720544b23b823, O, P), O[P]);
};


var $500d5d8b5806b834$require$getOwnPropertyDescriptor = $bb417845773708b5$export$2d1720544b23b823;
var $5b5bc07d688591ac$exports = {};
'use strict';

var $23cff59c96aeab90$exports = {};

$parcel$export($23cff59c96aeab90$exports, "f", function () { return $23cff59c96aeab90$export$2d1720544b23b823; }, function (v) { return $23cff59c96aeab90$export$2d1720544b23b823 = v; });
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $23cff59c96aeab90$export$2d1720544b23b823;
'use strict';


var $8bc29e9335787782$exports = {};
'use strict';


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$8bc29e9335787782$exports = $6ffb7908e83cf36c$exports && $06c7d56a730e31f1$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $05718fce3232bc84$exports = {};
'use strict';

var $05718fce3232bc84$var$$String = String;
var $05718fce3232bc84$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$05718fce3232bc84$exports = function(argument) {
    if ($d2d3162bdcc39b88$exports(argument)) return argument;
    throw new $05718fce3232bc84$var$$TypeError($05718fce3232bc84$var$$String(argument) + ' is not an object');
};



var $23cff59c96aeab90$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $23cff59c96aeab90$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $23cff59c96aeab90$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $23cff59c96aeab90$var$ENUMERABLE = 'enumerable';
var $23cff59c96aeab90$var$CONFIGURABLE = 'configurable';
var $23cff59c96aeab90$var$WRITABLE = 'writable';
$23cff59c96aeab90$export$2d1720544b23b823 = $6ffb7908e83cf36c$exports ? $8bc29e9335787782$exports ? function defineProperty(O, P, Attributes) {
    $05718fce3232bc84$exports(O);
    P = $282f32d47e9dd4f8$exports(P);
    $05718fce3232bc84$exports(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && $23cff59c96aeab90$var$WRITABLE in Attributes && !Attributes[$23cff59c96aeab90$var$WRITABLE]) {
        var current = $23cff59c96aeab90$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$23cff59c96aeab90$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $23cff59c96aeab90$var$CONFIGURABLE in Attributes ? Attributes[$23cff59c96aeab90$var$CONFIGURABLE] : current[$23cff59c96aeab90$var$CONFIGURABLE],
                enumerable: $23cff59c96aeab90$var$ENUMERABLE in Attributes ? Attributes[$23cff59c96aeab90$var$ENUMERABLE] : current[$23cff59c96aeab90$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $23cff59c96aeab90$var$$defineProperty(O, P, Attributes);
} : $23cff59c96aeab90$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $05718fce3232bc84$exports(O);
    P = $282f32d47e9dd4f8$exports(P);
    $05718fce3232bc84$exports(Attributes);
    if ($7fa96d66dead4ceb$exports) try {
        return $23cff59c96aeab90$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw new $23cff59c96aeab90$var$$TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};



$5b5bc07d688591ac$exports = $6ffb7908e83cf36c$exports ? function(object, key, value) {
    return $23cff59c96aeab90$export$2d1720544b23b823(object, key, $f89eb1caea2679b0$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


var $b817bfc251eac07c$exports = {};
'use strict';


var $6df183f9a20e2a35$exports = {};
'use strict';





var $61a1b81c88c8f190$exports = {};
'use strict';


var $61a1b81c88c8f190$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $61a1b81c88c8f190$var$getDescriptor = $6ffb7908e83cf36c$exports && Object.getOwnPropertyDescriptor;
var $61a1b81c88c8f190$var$EXISTS = $35cf4bf79fe152cc$exports($61a1b81c88c8f190$var$FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var $61a1b81c88c8f190$var$PROPER = $61a1b81c88c8f190$var$EXISTS && (function something() {}).name === 'something';
var $61a1b81c88c8f190$var$CONFIGURABLE = $61a1b81c88c8f190$var$EXISTS && (!$6ffb7908e83cf36c$exports || $6ffb7908e83cf36c$exports && $61a1b81c88c8f190$var$getDescriptor($61a1b81c88c8f190$var$FunctionPrototype, 'name').configurable);
$61a1b81c88c8f190$exports = {
    EXISTS: $61a1b81c88c8f190$var$EXISTS,
    PROPER: $61a1b81c88c8f190$var$PROPER,
    CONFIGURABLE: $61a1b81c88c8f190$var$CONFIGURABLE
};


var $6df183f9a20e2a35$require$CONFIGURABLE_FUNCTION_NAME = $61a1b81c88c8f190$exports.CONFIGURABLE;
var $9933f2479804f1dc$exports = {};
'use strict';



var $9933f2479804f1dc$var$functionToString = $1689570c06db508b$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$0a82f0a5368b6870$exports($72e9bcc33ae310b9$exports.inspectSource)) $72e9bcc33ae310b9$exports.inspectSource = function(it) {
    return $9933f2479804f1dc$var$functionToString(it);
};
$9933f2479804f1dc$exports = $72e9bcc33ae310b9$exports.inspectSource;


var $419c333d2a5dd5f4$exports = {};
'use strict';
var $4056705048f999f1$exports = {};
'use strict';


var $4056705048f999f1$var$WeakMap = $9be6fcc00ef60f58$exports.WeakMap;
$4056705048f999f1$exports = $0a82f0a5368b6870$exports($4056705048f999f1$var$WeakMap) && /native code/.test(String($4056705048f999f1$var$WeakMap));







var $53afc3c5338354ce$exports = {};
'use strict';


var $53afc3c5338354ce$var$keys = $cc5c269a44b6e335$exports('keys');
$53afc3c5338354ce$exports = function(key) {
    return $53afc3c5338354ce$var$keys[key] || ($53afc3c5338354ce$var$keys[key] = $a90ea85f631354d3$exports(key));
};


var $37c7d807d8aa31e8$exports = {};
'use strict';
$37c7d807d8aa31e8$exports = {};


var $419c333d2a5dd5f4$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $419c333d2a5dd5f4$var$TypeError = $9be6fcc00ef60f58$exports.TypeError;
var $419c333d2a5dd5f4$var$WeakMap = $9be6fcc00ef60f58$exports.WeakMap;
var $419c333d2a5dd5f4$var$set, $419c333d2a5dd5f4$var$get, $419c333d2a5dd5f4$var$has;
var $419c333d2a5dd5f4$var$enforce = function enforce(it) {
    return $419c333d2a5dd5f4$var$has(it) ? $419c333d2a5dd5f4$var$get(it) : $419c333d2a5dd5f4$var$set(it, {});
};
var $419c333d2a5dd5f4$var$getterFor = function getterFor(TYPE) {
    return function(it) {
        var state;
        if (!$d2d3162bdcc39b88$exports(it) || (state = $419c333d2a5dd5f4$var$get(it)).type !== TYPE) throw new $419c333d2a5dd5f4$var$TypeError('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($4056705048f999f1$exports || $72e9bcc33ae310b9$exports.state) {
    var $419c333d2a5dd5f4$var$store = $72e9bcc33ae310b9$exports.state || ($72e9bcc33ae310b9$exports.state = new $419c333d2a5dd5f4$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $419c333d2a5dd5f4$var$store.get = $419c333d2a5dd5f4$var$store.get;
    $419c333d2a5dd5f4$var$store.has = $419c333d2a5dd5f4$var$store.has;
    $419c333d2a5dd5f4$var$store.set = $419c333d2a5dd5f4$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $419c333d2a5dd5f4$var$set = function set(it, metadata) {
        if ($419c333d2a5dd5f4$var$store.has(it)) throw new $419c333d2a5dd5f4$var$TypeError($419c333d2a5dd5f4$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $419c333d2a5dd5f4$var$store.set(it, metadata);
        return metadata;
    };
    $419c333d2a5dd5f4$var$get = function get(it) {
        return $419c333d2a5dd5f4$var$store.get(it) || {};
    };
    $419c333d2a5dd5f4$var$has = function has(it) {
        return $419c333d2a5dd5f4$var$store.has(it);
    };
} else {
    var $419c333d2a5dd5f4$var$STATE = $53afc3c5338354ce$exports('state');
    $37c7d807d8aa31e8$exports[$419c333d2a5dd5f4$var$STATE] = true;
    $419c333d2a5dd5f4$var$set = function set(it, metadata) {
        if ($35cf4bf79fe152cc$exports(it, $419c333d2a5dd5f4$var$STATE)) throw new $419c333d2a5dd5f4$var$TypeError($419c333d2a5dd5f4$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $5b5bc07d688591ac$exports(it, $419c333d2a5dd5f4$var$STATE, metadata);
        return metadata;
    };
    $419c333d2a5dd5f4$var$get = function get(it) {
        return $35cf4bf79fe152cc$exports(it, $419c333d2a5dd5f4$var$STATE) ? it[$419c333d2a5dd5f4$var$STATE] : {};
    };
    $419c333d2a5dd5f4$var$has = function has(it) {
        return $35cf4bf79fe152cc$exports(it, $419c333d2a5dd5f4$var$STATE);
    };
}
$419c333d2a5dd5f4$exports = {
    set: $419c333d2a5dd5f4$var$set,
    get: $419c333d2a5dd5f4$var$get,
    has: $419c333d2a5dd5f4$var$has,
    enforce: $419c333d2a5dd5f4$var$enforce,
    getterFor: $419c333d2a5dd5f4$var$getterFor
};


var $6df183f9a20e2a35$var$enforceInternalState = $419c333d2a5dd5f4$exports.enforce;
var $6df183f9a20e2a35$var$getInternalState = $419c333d2a5dd5f4$exports.get;
var $6df183f9a20e2a35$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $6df183f9a20e2a35$var$defineProperty = Object.defineProperty;
var $6df183f9a20e2a35$var$stringSlice = $1689570c06db508b$exports(''.slice);
var $6df183f9a20e2a35$var$replace = $1689570c06db508b$exports(''.replace);
var $6df183f9a20e2a35$var$join = $1689570c06db508b$exports([].join);
var $6df183f9a20e2a35$var$CONFIGURABLE_LENGTH = $6ffb7908e83cf36c$exports && !$06c7d56a730e31f1$exports(function() {
    return $6df183f9a20e2a35$var$defineProperty(function() {}, 'length', {
        value: 8
    }).length !== 8;
});
var $6df183f9a20e2a35$var$TEMPLATE = String(String).split('String');
var $6df183f9a20e2a35$var$makeBuiltIn = $6df183f9a20e2a35$exports = function makeBuiltIn(value, name, options) {
    if ($6df183f9a20e2a35$var$stringSlice($6df183f9a20e2a35$var$$String(name), 0, 7) === 'Symbol(') name = '[' + $6df183f9a20e2a35$var$replace($6df183f9a20e2a35$var$$String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;
    if (!$35cf4bf79fe152cc$exports(value, 'name') || $6df183f9a20e2a35$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($6ffb7908e83cf36c$exports) $6df183f9a20e2a35$var$defineProperty(value, 'name', {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($6df183f9a20e2a35$var$CONFIGURABLE_LENGTH && options && $35cf4bf79fe152cc$exports(options, 'arity') && value.length !== options.arity) $6df183f9a20e2a35$var$defineProperty(value, 'length', {
        value: options.arity
    });
    try {
        if (options && $35cf4bf79fe152cc$exports(options, 'constructor') && options.constructor) {
            if ($6ffb7908e83cf36c$exports) $6df183f9a20e2a35$var$defineProperty(value, 'prototype', {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $6df183f9a20e2a35$var$enforceInternalState(value);
    if (!$35cf4bf79fe152cc$exports(state, 'source')) state.source = $6df183f9a20e2a35$var$join($6df183f9a20e2a35$var$TEMPLATE, typeof name == 'string' ? name : '');
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $6df183f9a20e2a35$var$makeBuiltIn(function toString() {
    return $0a82f0a5368b6870$exports(this) && $6df183f9a20e2a35$var$getInternalState(this).source || $9933f2479804f1dc$exports(this);
}, 'toString');



$b817bfc251eac07c$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($0a82f0a5368b6870$exports(value)) $6df183f9a20e2a35$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $f82bb239fcc043cf$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $23cff59c96aeab90$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $d41611a3c943a751$exports = {};
'use strict';

var $0610906adb160ba4$exports = {};
'use strict';


var $13520dff9cf61e9d$exports = {};

$parcel$export($13520dff9cf61e9d$exports, "f", function () { return $13520dff9cf61e9d$export$2d1720544b23b823; }, function (v) { return $13520dff9cf61e9d$export$2d1720544b23b823 = v; });
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $13520dff9cf61e9d$export$2d1720544b23b823;
'use strict';
var $b050ab095602f649$exports = {};
'use strict';



var $7e4669141832e27c$exports = {};
'use strict';

var $d78d48da15e9c8eb$exports = {};
'use strict';
var $4508997bd0ba9879$exports = {};
'use strict';
var $8ce23ed191976089$exports = {};
'use strict';
var $8ce23ed191976089$var$ceil = Math.ceil;
var $8ce23ed191976089$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$8ce23ed191976089$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $8ce23ed191976089$var$floor : $8ce23ed191976089$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$4508997bd0ba9879$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $8ce23ed191976089$exports(number);
};


var $d78d48da15e9c8eb$var$max = Math.max;
var $d78d48da15e9c8eb$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$d78d48da15e9c8eb$exports = function(index, length) {
    var integer = $4508997bd0ba9879$exports(index);
    return integer < 0 ? $d78d48da15e9c8eb$var$max(integer + length, 0) : $d78d48da15e9c8eb$var$min(integer, length);
};


var $f91b2cfe2e3f959b$exports = {};
'use strict';
var $d14e7a9632dda07a$exports = {};
'use strict';

var $d14e7a9632dda07a$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$d14e7a9632dda07a$exports = function(argument) {
    var len = $4508997bd0ba9879$exports(argument);
    return len > 0 ? $d14e7a9632dda07a$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$f91b2cfe2e3f959b$exports = function(obj) {
    return $d14e7a9632dda07a$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $7e4669141832e27c$var$createMethod = function createMethod(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $e656dbd61e0a8253$exports($this);
        var length = $f91b2cfe2e3f959b$exports(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $d78d48da15e9c8eb$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$7e4669141832e27c$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $7e4669141832e27c$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $7e4669141832e27c$var$createMethod(false)
};


var $b050ab095602f649$require$indexOf = $7e4669141832e27c$exports.indexOf;

var $b050ab095602f649$var$push = $1689570c06db508b$exports([].push);
$b050ab095602f649$exports = function(object, names) {
    var O = $e656dbd61e0a8253$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$35cf4bf79fe152cc$exports($37c7d807d8aa31e8$exports, key) && $35cf4bf79fe152cc$exports(O, key) && $b050ab095602f649$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($35cf4bf79fe152cc$exports(O, key = names[i++])) ~$b050ab095602f649$require$indexOf(result, key) || $b050ab095602f649$var$push(result, key);
    return result;
};


var $f550568f2c440ade$exports = {};
'use strict';
// IE8- don't enum bug keys
$f550568f2c440ade$exports = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];


var $13520dff9cf61e9d$var$hiddenKeys = $f550568f2c440ade$exports.concat('length', 'prototype');
$13520dff9cf61e9d$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $b050ab095602f649$exports(O, $13520dff9cf61e9d$var$hiddenKeys);
};


var $dcfc1c5672328394$exports = {};

$parcel$export($dcfc1c5672328394$exports, "f", function () { return $dcfc1c5672328394$export$2d1720544b23b823; }, function (v) { return $dcfc1c5672328394$export$2d1720544b23b823 = v; });
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $dcfc1c5672328394$export$2d1720544b23b823;
'use strict';
$dcfc1c5672328394$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $0610906adb160ba4$var$concat = $1689570c06db508b$exports([].concat);
// all object keys, includes non-enumerable and symbols
$0610906adb160ba4$exports = $36de342b7315604e$exports('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = $13520dff9cf61e9d$export$2d1720544b23b823($05718fce3232bc84$exports(it));
    var getOwnPropertySymbols = $dcfc1c5672328394$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $0610906adb160ba4$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$d41611a3c943a751$exports = function(target, source, exceptions) {
    var keys = $0610906adb160ba4$exports(source);
    var defineProperty = $23cff59c96aeab90$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $bb417845773708b5$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$35cf4bf79fe152cc$exports(target, key) && !(exceptions && $35cf4bf79fe152cc$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $1aa429f267e7bd69$exports = {};
'use strict';


var $1aa429f267e7bd69$var$replacement = /#|\.prototype\./;
var $1aa429f267e7bd69$var$isForced = function isForced(feature, detection) {
    var value = $1aa429f267e7bd69$var$data[$1aa429f267e7bd69$var$normalize(feature)];
    return value === $1aa429f267e7bd69$var$POLYFILL ? true : value === $1aa429f267e7bd69$var$NATIVE ? false : $0a82f0a5368b6870$exports(detection) ? $06c7d56a730e31f1$exports(detection) : !!detection;
};
var $1aa429f267e7bd69$var$normalize = $1aa429f267e7bd69$var$isForced.normalize = function normalize(string) {
    return String(string).replace($1aa429f267e7bd69$var$replacement, '.').toLowerCase();
};
var $1aa429f267e7bd69$var$data = $1aa429f267e7bd69$var$isForced.data = {};
var $1aa429f267e7bd69$var$NATIVE = $1aa429f267e7bd69$var$isForced.NATIVE = 'N';
var $1aa429f267e7bd69$var$POLYFILL = $1aa429f267e7bd69$var$isForced.POLYFILL = 'P';
$1aa429f267e7bd69$exports = $1aa429f267e7bd69$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $500d5d8b5806b834$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $9be6fcc00ef60f58$exports;
    else if (STATIC) target = $9be6fcc00ef60f58$exports[TARGET] || $f82bb239fcc043cf$exports(TARGET, {});
    else target = $9be6fcc00ef60f58$exports[TARGET] && $9be6fcc00ef60f58$exports[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $500d5d8b5806b834$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $1aa429f267e7bd69$exports(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if ((typeof sourceProperty === "undefined" ? "undefined" : (0, $qb7pP._)(sourceProperty)) == (typeof targetProperty === "undefined" ? "undefined" : (0, $qb7pP._)(targetProperty))) continue;
            $d41611a3c943a751$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $5b5bc07d688591ac$exports(sourceProperty, 'sham', true);
        $b817bfc251eac07c$exports(target, key, sourceProperty, options);
    }
};














var $f4fff477af530dca$exports = {};
'use strict';
var $4591439421551449$exports = {};
'use strict';
var $b5fabce5e8156a25$exports = {};
'use strict';

var $b5fabce5e8156a25$var$TO_STRING_TAG = $6268abd12745dd3b$exports('toStringTag');
var $b5fabce5e8156a25$var$test = {};
$b5fabce5e8156a25$var$test[$b5fabce5e8156a25$var$TO_STRING_TAG] = 'z';
$b5fabce5e8156a25$exports = String($b5fabce5e8156a25$var$test) === '[object z]';





var $4591439421551449$var$TO_STRING_TAG = $6268abd12745dd3b$exports('toStringTag');
var $4591439421551449$var$$Object = Object;
// ES3 wrong here
var $4591439421551449$var$CORRECT_ARGUMENTS = $9afeb253af368f01$exports(function() {
    return arguments;
}()) === 'Arguments';
// fallback for IE11 Script Access Denied error
var $4591439421551449$var$tryGet = function tryGet(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$4591439421551449$exports = $b5fabce5e8156a25$exports ? $9afeb253af368f01$exports : function(it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = $4591439421551449$var$tryGet(O = $4591439421551449$var$$Object(it), $4591439421551449$var$TO_STRING_TAG)) == 'string' ? tag : $4591439421551449$var$CORRECT_ARGUMENTS ? $9afeb253af368f01$exports(O) : (result = $9afeb253af368f01$exports(O)) === 'Object' && $0a82f0a5368b6870$exports(O.callee) ? 'Arguments' : result;
};


var $f4fff477af530dca$var$$String = String;
$f4fff477af530dca$exports = function(argument) {
    if ($4591439421551449$exports(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
    return $f4fff477af530dca$var$$String(argument);
};



var $c8a7d59657e3f14b$exports = {};
'use strict';

var $846c9cd8a2cecf69$exports = {};

$parcel$export($846c9cd8a2cecf69$exports, "f", function () { return $846c9cd8a2cecf69$export$2d1720544b23b823; }, function (v) { return $846c9cd8a2cecf69$export$2d1720544b23b823 = v; });
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $846c9cd8a2cecf69$export$2d1720544b23b823;
'use strict';





var $3e49974af21bc51b$exports = {};
'use strict';


// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
$3e49974af21bc51b$exports = Object.keys || function keys(O) {
    return $b050ab095602f649$exports(O, $f550568f2c440ade$exports);
};


$846c9cd8a2cecf69$export$2d1720544b23b823 = $6ffb7908e83cf36c$exports && !$8bc29e9335787782$exports ? Object.defineProperties : function defineProperties(O, Properties) {
    $05718fce3232bc84$exports(O);
    var props = $e656dbd61e0a8253$exports(Properties);
    var keys = $3e49974af21bc51b$exports(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$23cff59c96aeab90$export$2d1720544b23b823(O, key = keys[index++], props[key]);
    return O;
};




var $10389597269aae86$exports = {};
'use strict';

$10389597269aae86$exports = $36de342b7315604e$exports('document', 'documentElement');




var $c8a7d59657e3f14b$var$GT = '>';
var $c8a7d59657e3f14b$var$LT = '<';
var $c8a7d59657e3f14b$var$PROTOTYPE = 'prototype';
var $c8a7d59657e3f14b$var$SCRIPT = 'script';
var $c8a7d59657e3f14b$var$IE_PROTO = $53afc3c5338354ce$exports('IE_PROTO');
var $c8a7d59657e3f14b$var$EmptyConstructor = function EmptyConstructor() {};
var $c8a7d59657e3f14b$var$scriptTag = function scriptTag(content) {
    return $c8a7d59657e3f14b$var$LT + $c8a7d59657e3f14b$var$SCRIPT + $c8a7d59657e3f14b$var$GT + content + $c8a7d59657e3f14b$var$LT + '/' + $c8a7d59657e3f14b$var$SCRIPT + $c8a7d59657e3f14b$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $c8a7d59657e3f14b$var$NullProtoObjectViaActiveX = function NullProtoObjectViaActiveX(activeXDocument) {
    activeXDocument.write($c8a7d59657e3f14b$var$scriptTag(''));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    // eslint-disable-next-line no-useless-assignment -- avoid memory leak
    activeXDocument = null;
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $c8a7d59657e3f14b$var$NullProtoObjectViaIFrame = function NullProtoObjectViaIFrame() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $b4e20123d93a8378$exports('iframe');
    var JS = 'java' + $c8a7d59657e3f14b$var$SCRIPT + ':';
    var iframeDocument;
    iframe.style.display = 'none';
    $10389597269aae86$exports.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($c8a7d59657e3f14b$var$scriptTag('document.F=Object'));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $c8a7d59657e3f14b$var$activeXDocument;
var $c8a7d59657e3f14b$var$NullProtoObject = function NullProtoObject1() {
    try {
        $c8a7d59657e3f14b$var$activeXDocument = new ActiveXObject('htmlfile');
    } catch (error) {}
    $c8a7d59657e3f14b$var$NullProtoObject = typeof document != 'undefined' ? document.domain && $c8a7d59657e3f14b$var$activeXDocument ? $c8a7d59657e3f14b$var$NullProtoObjectViaActiveX($c8a7d59657e3f14b$var$activeXDocument) // old IE
     : $c8a7d59657e3f14b$var$NullProtoObjectViaIFrame() : $c8a7d59657e3f14b$var$NullProtoObjectViaActiveX($c8a7d59657e3f14b$var$activeXDocument); // WSH
    var length = $f550568f2c440ade$exports.length;
    while(length--)delete $c8a7d59657e3f14b$var$NullProtoObject[$c8a7d59657e3f14b$var$PROTOTYPE][$f550568f2c440ade$exports[length]];
    return $c8a7d59657e3f14b$var$NullProtoObject();
};
$37c7d807d8aa31e8$exports[$c8a7d59657e3f14b$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
$c8a7d59657e3f14b$exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $c8a7d59657e3f14b$var$EmptyConstructor[$c8a7d59657e3f14b$var$PROTOTYPE] = $05718fce3232bc84$exports(O);
        result = new $c8a7d59657e3f14b$var$EmptyConstructor();
        $c8a7d59657e3f14b$var$EmptyConstructor[$c8a7d59657e3f14b$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$c8a7d59657e3f14b$var$IE_PROTO] = O;
    } else result = $c8a7d59657e3f14b$var$NullProtoObject();
    return Properties === undefined ? result : $846c9cd8a2cecf69$export$2d1720544b23b823(result, Properties);
};




var $226371c2c18604cf$exports = {};

$parcel$export($226371c2c18604cf$exports, "f", function () { return $226371c2c18604cf$export$2d1720544b23b823; }, function (v) { return $226371c2c18604cf$export$2d1720544b23b823 = v; });

var $qb7pP = parcelRequire("qb7pP");
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $226371c2c18604cf$export$2d1720544b23b823;
'use strict';



var $226371c2c18604cf$require$$getOwnPropertyNames = $13520dff9cf61e9d$export$2d1720544b23b823;
var $65dcb7b8ed29ae22$exports = {};
'use strict';

$65dcb7b8ed29ae22$exports = $1689570c06db508b$exports([].slice);


var $226371c2c18604cf$var$windowNames = (typeof window === "undefined" ? "undefined" : (0, $qb7pP._)(window)) == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $226371c2c18604cf$var$getWindowNames = function getWindowNames(it) {
    try {
        return $226371c2c18604cf$require$$getOwnPropertyNames(it);
    } catch (error) {
        return $65dcb7b8ed29ae22$exports($226371c2c18604cf$var$windowNames);
    }
};
$226371c2c18604cf$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $226371c2c18604cf$var$windowNames && $9afeb253af368f01$exports(it) === 'Window' ? $226371c2c18604cf$var$getWindowNames(it) : $226371c2c18604cf$require$$getOwnPropertyNames($e656dbd61e0a8253$exports(it));
};








var $6de7996ceea81cf8$exports = {};
'use strict';


$6de7996ceea81cf8$exports = function(target, name, descriptor) {
    if (descriptor.get) $6df183f9a20e2a35$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $6df183f9a20e2a35$exports(descriptor.set, name, {
        setter: true
    });
    return $23cff59c96aeab90$export$2d1720544b23b823(target, name, descriptor);
};







var $e32dba60ca25df05$exports = {};

$parcel$export($e32dba60ca25df05$exports, "f", function () { return $e32dba60ca25df05$export$2d1720544b23b823; }, function (v) { return $e32dba60ca25df05$export$2d1720544b23b823 = v; });
var $e32dba60ca25df05$export$2d1720544b23b823;
'use strict';

$e32dba60ca25df05$export$2d1720544b23b823 = $6268abd12745dd3b$exports;


var $6a01c8a65bc6f97d$exports = {};
'use strict';
var $56e9e6ac1b0b6c62$exports = {};
'use strict';

$56e9e6ac1b0b6c62$exports = $9be6fcc00ef60f58$exports;





var $6a01c8a65bc6f97d$require$defineProperty = $23cff59c96aeab90$export$2d1720544b23b823;
$6a01c8a65bc6f97d$exports = function(NAME) {
    var Symbol = $56e9e6ac1b0b6c62$exports.Symbol || ($56e9e6ac1b0b6c62$exports.Symbol = {});
    if (!$35cf4bf79fe152cc$exports(Symbol, NAME)) $6a01c8a65bc6f97d$require$defineProperty(Symbol, NAME, {
        value: $e32dba60ca25df05$export$2d1720544b23b823(NAME)
    });
};


var $68c2ff0fb60c4814$exports = {};
'use strict';




$68c2ff0fb60c4814$exports = function() {
    var Symbol = $36de342b7315604e$exports('Symbol');
    var SymbolPrototype = Symbol && Symbol.prototype;
    var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
    var TO_PRIMITIVE = $6268abd12745dd3b$exports('toPrimitive');
    if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    $b817bfc251eac07c$exports(SymbolPrototype, TO_PRIMITIVE, function(hint) {
        return $e3ebd8cb7f512f74$exports(valueOf, this);
    }, {
        arity: 1
    });
};


var $be9d27c6f3178ed3$exports = {};
'use strict';

var $be9d27c6f3178ed3$require$defineProperty = $23cff59c96aeab90$export$2d1720544b23b823;


var $be9d27c6f3178ed3$var$TO_STRING_TAG = $6268abd12745dd3b$exports('toStringTag');
$be9d27c6f3178ed3$exports = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$35cf4bf79fe152cc$exports(target, $be9d27c6f3178ed3$var$TO_STRING_TAG)) $be9d27c6f3178ed3$require$defineProperty(target, $be9d27c6f3178ed3$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};



var $2f37be4e4d5b5ff0$exports = {};
'use strict';
var $847280b2cf36c2e0$exports = {};
'use strict';
var $010fa6fc9394de19$exports = {};
'use strict';


$010fa6fc9394de19$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($9afeb253af368f01$exports(fn) === 'Function') return $1689570c06db508b$exports(fn);
};




var $847280b2cf36c2e0$var$bind = $010fa6fc9394de19$exports($010fa6fc9394de19$exports.bind);
// optional / simple context binding
$847280b2cf36c2e0$exports = function(fn, that) {
    $c976080d379e828f$exports(fn);
    return that === undefined ? fn : $0945d194f6c2c4f6$exports ? $847280b2cf36c2e0$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};






var $9225d9f1ded8840d$exports = {};
'use strict';
var $462533265e4c60d2$exports = {};
'use strict';
var $61ddfef2bf8c280c$exports = {};
'use strict';

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
$61ddfef2bf8c280c$exports = Array.isArray || function isArray(argument) {
    return $9afeb253af368f01$exports(argument) === 'Array';
};


var $c14e5ce4ade3a35d$exports = {};
'use strict';






var $c14e5ce4ade3a35d$var$noop = function noop() {};
var $c14e5ce4ade3a35d$var$construct = $36de342b7315604e$exports('Reflect', 'construct');
var $c14e5ce4ade3a35d$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $c14e5ce4ade3a35d$var$exec = $1689570c06db508b$exports($c14e5ce4ade3a35d$var$constructorRegExp.exec);
var $c14e5ce4ade3a35d$var$INCORRECT_TO_STRING = !$c14e5ce4ade3a35d$var$constructorRegExp.test($c14e5ce4ade3a35d$var$noop);
var $c14e5ce4ade3a35d$var$isConstructorModern = function isConstructor(argument) {
    if (!$0a82f0a5368b6870$exports(argument)) return false;
    try {
        $c14e5ce4ade3a35d$var$construct($c14e5ce4ade3a35d$var$noop, [], argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $c14e5ce4ade3a35d$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$0a82f0a5368b6870$exports(argument)) return false;
    switch($4591439421551449$exports(argument)){
        case 'AsyncFunction':
        case 'GeneratorFunction':
        case 'AsyncGeneratorFunction':
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $c14e5ce4ade3a35d$var$INCORRECT_TO_STRING || !!$c14e5ce4ade3a35d$var$exec($c14e5ce4ade3a35d$var$constructorRegExp, $9933f2479804f1dc$exports(argument));
    } catch (error) {
        return true;
    }
};
$c14e5ce4ade3a35d$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
$c14e5ce4ade3a35d$exports = !$c14e5ce4ade3a35d$var$construct || $06c7d56a730e31f1$exports(function() {
    var called;
    return $c14e5ce4ade3a35d$var$isConstructorModern($c14e5ce4ade3a35d$var$isConstructorModern.call) || !$c14e5ce4ade3a35d$var$isConstructorModern(Object) || !$c14e5ce4ade3a35d$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $c14e5ce4ade3a35d$var$isConstructorLegacy : $c14e5ce4ade3a35d$var$isConstructorModern;




var $462533265e4c60d2$var$SPECIES = $6268abd12745dd3b$exports('species');
var $462533265e4c60d2$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$462533265e4c60d2$exports = function(originalArray) {
    var C;
    if ($61ddfef2bf8c280c$exports(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($c14e5ce4ade3a35d$exports(C) && (C === $462533265e4c60d2$var$$Array || $61ddfef2bf8c280c$exports(C.prototype))) C = undefined;
        else if ($d2d3162bdcc39b88$exports(C)) {
            C = C[$462533265e4c60d2$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $462533265e4c60d2$var$$Array : C;
};


// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$9225d9f1ded8840d$exports = function(originalArray, length) {
    return new ($462533265e4c60d2$exports(originalArray))(length === 0 ? 0 : length);
};


var $2f37be4e4d5b5ff0$var$push = $1689570c06db508b$exports([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $2f37be4e4d5b5ff0$var$createMethod = function createMethod(TYPE) {
    var IS_MAP = TYPE === 1;
    var IS_FILTER = TYPE === 2;
    var IS_SOME = TYPE === 3;
    var IS_EVERY = TYPE === 4;
    var IS_FIND_INDEX = TYPE === 6;
    var IS_FILTER_REJECT = TYPE === 7;
    var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $ec839b558eb5dcf4$exports($this);
        var self = $a71603b0710a8479$exports(O);
        var length = $f91b2cfe2e3f959b$exports(self);
        var boundFunction = $847280b2cf36c2e0$exports(callbackfn, that);
        var index = 0;
        var create = specificCreate || $9225d9f1ded8840d$exports;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $2f37be4e4d5b5ff0$var$push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $2f37be4e4d5b5ff0$var$push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
$2f37be4e4d5b5ff0$exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $2f37be4e4d5b5ff0$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $2f37be4e4d5b5ff0$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $2f37be4e4d5b5ff0$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $2f37be4e4d5b5ff0$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $2f37be4e4d5b5ff0$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $2f37be4e4d5b5ff0$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $2f37be4e4d5b5ff0$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $2f37be4e4d5b5ff0$var$createMethod(7)
};


var $34146b52d63c1b2e$require$$forEach = $2f37be4e4d5b5ff0$exports.forEach;
var $34146b52d63c1b2e$var$HIDDEN = $53afc3c5338354ce$exports('hidden');
var $34146b52d63c1b2e$var$SYMBOL = 'Symbol';
var $34146b52d63c1b2e$var$PROTOTYPE = 'prototype';
var $34146b52d63c1b2e$var$setInternalState = $419c333d2a5dd5f4$exports.set;
var $34146b52d63c1b2e$var$getInternalState = $419c333d2a5dd5f4$exports.getterFor($34146b52d63c1b2e$var$SYMBOL);
var $34146b52d63c1b2e$var$ObjectPrototype = Object[$34146b52d63c1b2e$var$PROTOTYPE];
var $34146b52d63c1b2e$var$$Symbol = $9be6fcc00ef60f58$exports.Symbol;
var $34146b52d63c1b2e$var$SymbolPrototype = $34146b52d63c1b2e$var$$Symbol && $34146b52d63c1b2e$var$$Symbol[$34146b52d63c1b2e$var$PROTOTYPE];
var $34146b52d63c1b2e$var$RangeError = $9be6fcc00ef60f58$exports.RangeError;
var $34146b52d63c1b2e$var$TypeError = $9be6fcc00ef60f58$exports.TypeError;
var $34146b52d63c1b2e$var$QObject = $9be6fcc00ef60f58$exports.QObject;
var $34146b52d63c1b2e$var$nativeGetOwnPropertyDescriptor = $bb417845773708b5$export$2d1720544b23b823;
var $34146b52d63c1b2e$var$nativeDefineProperty = $23cff59c96aeab90$export$2d1720544b23b823;
var $34146b52d63c1b2e$var$nativeGetOwnPropertyNames = $226371c2c18604cf$export$2d1720544b23b823;
var $34146b52d63c1b2e$var$nativePropertyIsEnumerable = $7365bb173f3e63f5$export$2d1720544b23b823;
var $34146b52d63c1b2e$var$push = $1689570c06db508b$exports([].push);
var $34146b52d63c1b2e$var$AllSymbols = $cc5c269a44b6e335$exports('symbols');
var $34146b52d63c1b2e$var$ObjectPrototypeSymbols = $cc5c269a44b6e335$exports('op-symbols');
var $34146b52d63c1b2e$var$WellKnownSymbolsStore = $cc5c269a44b6e335$exports('wks');
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $34146b52d63c1b2e$var$USE_SETTER = !$34146b52d63c1b2e$var$QObject || !$34146b52d63c1b2e$var$QObject[$34146b52d63c1b2e$var$PROTOTYPE] || !$34146b52d63c1b2e$var$QObject[$34146b52d63c1b2e$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $34146b52d63c1b2e$var$fallbackDefineProperty = function fallbackDefineProperty(O, P, Attributes) {
    var ObjectPrototypeDescriptor = $34146b52d63c1b2e$var$nativeGetOwnPropertyDescriptor($34146b52d63c1b2e$var$ObjectPrototype, P);
    if (ObjectPrototypeDescriptor) delete $34146b52d63c1b2e$var$ObjectPrototype[P];
    $34146b52d63c1b2e$var$nativeDefineProperty(O, P, Attributes);
    if (ObjectPrototypeDescriptor && O !== $34146b52d63c1b2e$var$ObjectPrototype) $34146b52d63c1b2e$var$nativeDefineProperty($34146b52d63c1b2e$var$ObjectPrototype, P, ObjectPrototypeDescriptor);
};
var $34146b52d63c1b2e$var$setSymbolDescriptor = $6ffb7908e83cf36c$exports && $06c7d56a730e31f1$exports(function() {
    return $c8a7d59657e3f14b$exports($34146b52d63c1b2e$var$nativeDefineProperty({}, 'a', {
        get: function get() {
            return $34146b52d63c1b2e$var$nativeDefineProperty(this, 'a', {
                value: 7
            }).a;
        }
    })).a !== 7;
}) ? $34146b52d63c1b2e$var$fallbackDefineProperty : $34146b52d63c1b2e$var$nativeDefineProperty;
var $34146b52d63c1b2e$var$wrap = function wrap(tag, description) {
    var symbol = $34146b52d63c1b2e$var$AllSymbols[tag] = $c8a7d59657e3f14b$exports($34146b52d63c1b2e$var$SymbolPrototype);
    $34146b52d63c1b2e$var$setInternalState(symbol, {
        type: $34146b52d63c1b2e$var$SYMBOL,
        tag: tag,
        description: description
    });
    if (!$6ffb7908e83cf36c$exports) symbol.description = description;
    return symbol;
};
var $34146b52d63c1b2e$var$$defineProperty = function defineProperty(O, P, Attributes) {
    if (O === $34146b52d63c1b2e$var$ObjectPrototype) $34146b52d63c1b2e$var$$defineProperty($34146b52d63c1b2e$var$ObjectPrototypeSymbols, P, Attributes);
    $05718fce3232bc84$exports(O);
    var key = $282f32d47e9dd4f8$exports(P);
    $05718fce3232bc84$exports(Attributes);
    if ($35cf4bf79fe152cc$exports($34146b52d63c1b2e$var$AllSymbols, key)) {
        if (!Attributes.enumerable) {
            if (!$35cf4bf79fe152cc$exports(O, $34146b52d63c1b2e$var$HIDDEN)) $34146b52d63c1b2e$var$nativeDefineProperty(O, $34146b52d63c1b2e$var$HIDDEN, $f89eb1caea2679b0$exports(1, $c8a7d59657e3f14b$exports(null)));
            O[$34146b52d63c1b2e$var$HIDDEN][key] = true;
        } else {
            if ($35cf4bf79fe152cc$exports(O, $34146b52d63c1b2e$var$HIDDEN) && O[$34146b52d63c1b2e$var$HIDDEN][key]) O[$34146b52d63c1b2e$var$HIDDEN][key] = false;
            Attributes = $c8a7d59657e3f14b$exports(Attributes, {
                enumerable: $f89eb1caea2679b0$exports(0, false)
            });
        }
        return $34146b52d63c1b2e$var$setSymbolDescriptor(O, key, Attributes);
    }
    return $34146b52d63c1b2e$var$nativeDefineProperty(O, key, Attributes);
};
var $34146b52d63c1b2e$var$$defineProperties = function defineProperties(O, Properties) {
    $05718fce3232bc84$exports(O);
    var properties = $e656dbd61e0a8253$exports(Properties);
    var keys = $3e49974af21bc51b$exports(properties).concat($34146b52d63c1b2e$var$$getOwnPropertySymbols(properties));
    $34146b52d63c1b2e$require$$forEach(keys, function(key) {
        if (!$6ffb7908e83cf36c$exports || $e3ebd8cb7f512f74$exports($34146b52d63c1b2e$var$$propertyIsEnumerable, properties, key)) $34146b52d63c1b2e$var$$defineProperty(O, key, properties[key]);
    });
    return O;
};
var $34146b52d63c1b2e$var$$create = function create(O, Properties) {
    return Properties === undefined ? $c8a7d59657e3f14b$exports(O) : $34146b52d63c1b2e$var$$defineProperties($c8a7d59657e3f14b$exports(O), Properties);
};
var $34146b52d63c1b2e$var$$propertyIsEnumerable = function propertyIsEnumerable(V) {
    var P = $282f32d47e9dd4f8$exports(V);
    var enumerable = $e3ebd8cb7f512f74$exports($34146b52d63c1b2e$var$nativePropertyIsEnumerable, this, P);
    if (this === $34146b52d63c1b2e$var$ObjectPrototype && $35cf4bf79fe152cc$exports($34146b52d63c1b2e$var$AllSymbols, P) && !$35cf4bf79fe152cc$exports($34146b52d63c1b2e$var$ObjectPrototypeSymbols, P)) return false;
    return enumerable || !$35cf4bf79fe152cc$exports(this, P) || !$35cf4bf79fe152cc$exports($34146b52d63c1b2e$var$AllSymbols, P) || $35cf4bf79fe152cc$exports(this, $34146b52d63c1b2e$var$HIDDEN) && this[$34146b52d63c1b2e$var$HIDDEN][P] ? enumerable : true;
};
var $34146b52d63c1b2e$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
    var it = $e656dbd61e0a8253$exports(O);
    var key = $282f32d47e9dd4f8$exports(P);
    if (it === $34146b52d63c1b2e$var$ObjectPrototype && $35cf4bf79fe152cc$exports($34146b52d63c1b2e$var$AllSymbols, key) && !$35cf4bf79fe152cc$exports($34146b52d63c1b2e$var$ObjectPrototypeSymbols, key)) return;
    var descriptor = $34146b52d63c1b2e$var$nativeGetOwnPropertyDescriptor(it, key);
    if (descriptor && $35cf4bf79fe152cc$exports($34146b52d63c1b2e$var$AllSymbols, key) && !($35cf4bf79fe152cc$exports(it, $34146b52d63c1b2e$var$HIDDEN) && it[$34146b52d63c1b2e$var$HIDDEN][key])) descriptor.enumerable = true;
    return descriptor;
};
var $34146b52d63c1b2e$var$$getOwnPropertyNames = function getOwnPropertyNames(O) {
    var names = $34146b52d63c1b2e$var$nativeGetOwnPropertyNames($e656dbd61e0a8253$exports(O));
    var result = [];
    $34146b52d63c1b2e$require$$forEach(names, function(key) {
        if (!$35cf4bf79fe152cc$exports($34146b52d63c1b2e$var$AllSymbols, key) && !$35cf4bf79fe152cc$exports($37c7d807d8aa31e8$exports, key)) $34146b52d63c1b2e$var$push(result, key);
    });
    return result;
};
var $34146b52d63c1b2e$var$$getOwnPropertySymbols = function $getOwnPropertySymbols(O) {
    var IS_OBJECT_PROTOTYPE = O === $34146b52d63c1b2e$var$ObjectPrototype;
    var names = $34146b52d63c1b2e$var$nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? $34146b52d63c1b2e$var$ObjectPrototypeSymbols : $e656dbd61e0a8253$exports(O));
    var result = [];
    $34146b52d63c1b2e$require$$forEach(names, function(key) {
        if ($35cf4bf79fe152cc$exports($34146b52d63c1b2e$var$AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || $35cf4bf79fe152cc$exports($34146b52d63c1b2e$var$ObjectPrototype, key))) $34146b52d63c1b2e$var$push(result, $34146b52d63c1b2e$var$AllSymbols[key]);
    });
    return result;
};
// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!$3ccde59009348858$exports) {
    $34146b52d63c1b2e$var$$Symbol = function Symbol() {
        if ($bc714f4a9c09d4bd$exports($34146b52d63c1b2e$var$SymbolPrototype, this)) throw new $34146b52d63c1b2e$var$TypeError('Symbol is not a constructor');
        var description = !arguments.length || arguments[0] === undefined ? undefined : $f4fff477af530dca$exports(arguments[0]);
        var tag = $a90ea85f631354d3$exports(description);
        var setter = function setter1(value) {
            var $this = this === undefined ? $9be6fcc00ef60f58$exports : this;
            if ($this === $34146b52d63c1b2e$var$ObjectPrototype) $e3ebd8cb7f512f74$exports(setter, $34146b52d63c1b2e$var$ObjectPrototypeSymbols, value);
            if ($35cf4bf79fe152cc$exports($this, $34146b52d63c1b2e$var$HIDDEN) && $35cf4bf79fe152cc$exports($this[$34146b52d63c1b2e$var$HIDDEN], tag)) $this[$34146b52d63c1b2e$var$HIDDEN][tag] = false;
            var descriptor = $f89eb1caea2679b0$exports(1, value);
            try {
                $34146b52d63c1b2e$var$setSymbolDescriptor($this, tag, descriptor);
            } catch (error) {
                if (!(error instanceof $34146b52d63c1b2e$var$RangeError)) throw error;
                $34146b52d63c1b2e$var$fallbackDefineProperty($this, tag, descriptor);
            }
        };
        if ($6ffb7908e83cf36c$exports && $34146b52d63c1b2e$var$USE_SETTER) $34146b52d63c1b2e$var$setSymbolDescriptor($34146b52d63c1b2e$var$ObjectPrototype, tag, {
            configurable: true,
            set: setter
        });
        return $34146b52d63c1b2e$var$wrap(tag, description);
    };
    $34146b52d63c1b2e$var$SymbolPrototype = $34146b52d63c1b2e$var$$Symbol[$34146b52d63c1b2e$var$PROTOTYPE];
    $b817bfc251eac07c$exports($34146b52d63c1b2e$var$SymbolPrototype, 'toString', function toString() {
        return $34146b52d63c1b2e$var$getInternalState(this).tag;
    });
    $b817bfc251eac07c$exports($34146b52d63c1b2e$var$$Symbol, 'withoutSetter', function(description) {
        return $34146b52d63c1b2e$var$wrap($a90ea85f631354d3$exports(description), description);
    });
    $7365bb173f3e63f5$exports.f = $34146b52d63c1b2e$var$$propertyIsEnumerable;
    $23cff59c96aeab90$exports.f = $34146b52d63c1b2e$var$$defineProperty;
    $846c9cd8a2cecf69$exports.f = $34146b52d63c1b2e$var$$defineProperties;
    $bb417845773708b5$exports.f = $34146b52d63c1b2e$var$$getOwnPropertyDescriptor;
    $13520dff9cf61e9d$exports.f = $226371c2c18604cf$exports.f = $34146b52d63c1b2e$var$$getOwnPropertyNames;
    $dcfc1c5672328394$exports.f = $34146b52d63c1b2e$var$$getOwnPropertySymbols;
    $e32dba60ca25df05$exports.f = function(name) {
        return $34146b52d63c1b2e$var$wrap($6268abd12745dd3b$exports(name), name);
    };
    if ($6ffb7908e83cf36c$exports) {
        // https://github.com/tc39/proposal-Symbol-description
        $6de7996ceea81cf8$exports($34146b52d63c1b2e$var$SymbolPrototype, 'description', {
            configurable: true,
            get: function description() {
                return $34146b52d63c1b2e$var$getInternalState(this).description;
            }
        });
        if (!$62bf9cf43d01f7ec$exports) $b817bfc251eac07c$exports($34146b52d63c1b2e$var$ObjectPrototype, 'propertyIsEnumerable', $34146b52d63c1b2e$var$$propertyIsEnumerable, {
            unsafe: true
        });
    }
}
$500d5d8b5806b834$exports({
    global: true,
    constructor: true,
    wrap: true,
    forced: !$3ccde59009348858$exports,
    sham: !$3ccde59009348858$exports
}, {
    Symbol: $34146b52d63c1b2e$var$$Symbol
});
$34146b52d63c1b2e$require$$forEach($3e49974af21bc51b$exports($34146b52d63c1b2e$var$WellKnownSymbolsStore), function(name) {
    $6a01c8a65bc6f97d$exports(name);
});
$500d5d8b5806b834$exports({
    target: $34146b52d63c1b2e$var$SYMBOL,
    stat: true,
    forced: !$3ccde59009348858$exports
}, {
    useSetter: function useSetter() {
        $34146b52d63c1b2e$var$USE_SETTER = true;
    },
    useSimple: function useSimple() {
        $34146b52d63c1b2e$var$USE_SETTER = false;
    }
});
$500d5d8b5806b834$exports({
    target: 'Object',
    stat: true,
    forced: !$3ccde59009348858$exports,
    sham: !$6ffb7908e83cf36c$exports
}, {
    // `Object.create` method
    // https://tc39.es/ecma262/#sec-object.create
    create: $34146b52d63c1b2e$var$$create,
    // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty
    defineProperty: $34146b52d63c1b2e$var$$defineProperty,
    // `Object.defineProperties` method
    // https://tc39.es/ecma262/#sec-object.defineproperties
    defineProperties: $34146b52d63c1b2e$var$$defineProperties,
    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
    getOwnPropertyDescriptor: $34146b52d63c1b2e$var$$getOwnPropertyDescriptor
});
$500d5d8b5806b834$exports({
    target: 'Object',
    stat: true,
    forced: !$3ccde59009348858$exports
}, {
    // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames
    getOwnPropertyNames: $34146b52d63c1b2e$var$$getOwnPropertyNames
});
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
$68c2ff0fb60c4814$exports();
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
$be9d27c6f3178ed3$exports($34146b52d63c1b2e$var$$Symbol, $34146b52d63c1b2e$var$SYMBOL);
$37c7d807d8aa31e8$exports[$34146b52d63c1b2e$var$HIDDEN] = true;


'use strict';





var $446a8148a6540910$exports = {};
'use strict';

/* eslint-disable es/no-symbol -- safe */ $446a8148a6540910$exports = $3ccde59009348858$exports && !!Symbol['for'] && !!Symbol.keyFor;


var $eaade174bd839792$var$StringToSymbolRegistry = $cc5c269a44b6e335$exports('string-to-symbol-registry');
var $eaade174bd839792$var$SymbolToStringRegistry = $cc5c269a44b6e335$exports('symbol-to-string-registry');
// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$500d5d8b5806b834$exports({
    target: 'Symbol',
    stat: true,
    forced: !$446a8148a6540910$exports
}, {
    'for': function(key) {
        var string = $f4fff477af530dca$exports(key);
        if ($35cf4bf79fe152cc$exports($eaade174bd839792$var$StringToSymbolRegistry, string)) return $eaade174bd839792$var$StringToSymbolRegistry[string];
        var symbol = $36de342b7315604e$exports('Symbol')(string);
        $eaade174bd839792$var$StringToSymbolRegistry[string] = symbol;
        $eaade174bd839792$var$SymbolToStringRegistry[symbol] = string;
        return symbol;
    }
});


'use strict';






var $82987e4fc3efd17d$var$SymbolToStringRegistry = $cc5c269a44b6e335$exports('symbol-to-string-registry');
// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$500d5d8b5806b834$exports({
    target: 'Symbol',
    stat: true,
    forced: !$446a8148a6540910$exports
}, {
    keyFor: function keyFor(sym) {
        if (!$4cdbccb02aa7d286$exports(sym)) throw new TypeError($53c3bf74c3e856bf$exports(sym) + ' is not a symbol');
        if ($35cf4bf79fe152cc$exports($82987e4fc3efd17d$var$SymbolToStringRegistry, sym)) return $82987e4fc3efd17d$var$SymbolToStringRegistry[sym];
    }
});


'use strict';


var $c126e09ab0f7e2a8$exports = {};

var $qb7pP = parcelRequire("qb7pP");
'use strict';

var $c126e09ab0f7e2a8$var$FunctionPrototype = Function.prototype;
var $c126e09ab0f7e2a8$var$apply = $c126e09ab0f7e2a8$var$FunctionPrototype.apply;
var $c126e09ab0f7e2a8$var$call = $c126e09ab0f7e2a8$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$c126e09ab0f7e2a8$exports = (typeof Reflect === "undefined" ? "undefined" : (0, $qb7pP._)(Reflect)) == 'object' && Reflect.apply || ($0945d194f6c2c4f6$exports ? $c126e09ab0f7e2a8$var$call.bind($c126e09ab0f7e2a8$var$apply) : function() {
    return $c126e09ab0f7e2a8$var$call.apply($c126e09ab0f7e2a8$var$apply, arguments);
});








var $a4fb0b2d66568fd2$exports = {};
'use strict';





var $a4fb0b2d66568fd2$var$push = $1689570c06db508b$exports([].push);
$a4fb0b2d66568fd2$exports = function(replacer) {
    if ($0a82f0a5368b6870$exports(replacer)) return replacer;
    if (!$61ddfef2bf8c280c$exports(replacer)) return;
    var rawLength = replacer.length;
    var keys = [];
    for(var i = 0; i < rawLength; i++){
        var element = replacer[i];
        if (typeof element == 'string') $a4fb0b2d66568fd2$var$push(keys, element);
        else if (typeof element == 'number' || $9afeb253af368f01$exports(element) === 'Number' || $9afeb253af368f01$exports(element) === 'String') $a4fb0b2d66568fd2$var$push(keys, $f4fff477af530dca$exports(element));
    }
    var keysLength = keys.length;
    var root = true;
    return function(key, value) {
        if (root) {
            root = false;
            return value;
        }
        if ($61ddfef2bf8c280c$exports(this)) return value;
        for(var j = 0; j < keysLength; j++)if (keys[j] === key) return value;
    };
};



var $a136c06cd403662a$var$$String = String;
var $a136c06cd403662a$var$$stringify = $36de342b7315604e$exports('JSON', 'stringify');
var $a136c06cd403662a$var$exec = $1689570c06db508b$exports(/./.exec);
var $a136c06cd403662a$var$charAt = $1689570c06db508b$exports(''.charAt);
var $a136c06cd403662a$var$charCodeAt = $1689570c06db508b$exports(''.charCodeAt);
var $a136c06cd403662a$var$replace = $1689570c06db508b$exports(''.replace);
var $a136c06cd403662a$var$numberToString = $1689570c06db508b$exports(1.0.toString);
var $a136c06cd403662a$var$tester = /[\uD800-\uDFFF]/g;
var $a136c06cd403662a$var$low = /^[\uD800-\uDBFF]$/;
var $a136c06cd403662a$var$hi = /^[\uDC00-\uDFFF]$/;
var $a136c06cd403662a$var$WRONG_SYMBOLS_CONVERSION = !$3ccde59009348858$exports || $06c7d56a730e31f1$exports(function() {
    var symbol = $36de342b7315604e$exports('Symbol')('stringify detection');
    // MS Edge converts symbol values to JSON as {}
    return $a136c06cd403662a$var$$stringify([
        symbol
    ]) !== '[null]' || $a136c06cd403662a$var$$stringify({
        a: symbol
    }) !== '{}' || $a136c06cd403662a$var$$stringify(Object(symbol)) !== '{}';
});
// https://github.com/tc39/proposal-well-formed-stringify
var $a136c06cd403662a$var$ILL_FORMED_UNICODE = $06c7d56a730e31f1$exports(function() {
    return $a136c06cd403662a$var$$stringify('\uDF06\uD834') !== '"\\udf06\\ud834"' || $a136c06cd403662a$var$$stringify('\uDEAD') !== '"\\udead"';
});
var $a136c06cd403662a$var$stringifyWithSymbolsFix = function stringifyWithSymbolsFix(it, replacer) {
    var args = $65dcb7b8ed29ae22$exports(arguments);
    var $replacer = $a4fb0b2d66568fd2$exports(replacer);
    if (!$0a82f0a5368b6870$exports($replacer) && (it === undefined || $4cdbccb02aa7d286$exports(it))) return; // IE8 returns string on undefined
    args[1] = function(key, value) {
        // some old implementations (like WebKit) could pass numbers as keys
        if ($0a82f0a5368b6870$exports($replacer)) value = $e3ebd8cb7f512f74$exports($replacer, this, $a136c06cd403662a$var$$String(key), value);
        if (!$4cdbccb02aa7d286$exports(value)) return value;
    };
    return $c126e09ab0f7e2a8$exports($a136c06cd403662a$var$$stringify, null, args);
};
var $a136c06cd403662a$var$fixIllFormed = function fixIllFormed(match, offset, string) {
    var prev = $a136c06cd403662a$var$charAt(string, offset - 1);
    var next = $a136c06cd403662a$var$charAt(string, offset + 1);
    if ($a136c06cd403662a$var$exec($a136c06cd403662a$var$low, match) && !$a136c06cd403662a$var$exec($a136c06cd403662a$var$hi, next) || $a136c06cd403662a$var$exec($a136c06cd403662a$var$hi, match) && !$a136c06cd403662a$var$exec($a136c06cd403662a$var$low, prev)) return '\\u' + $a136c06cd403662a$var$numberToString($a136c06cd403662a$var$charCodeAt(match, 0), 16);
    return match;
};
if ($a136c06cd403662a$var$$stringify) // `JSON.stringify` method
// https://tc39.es/ecma262/#sec-json.stringify
$500d5d8b5806b834$exports({
    target: 'JSON',
    stat: true,
    arity: 3,
    forced: $a136c06cd403662a$var$WRONG_SYMBOLS_CONVERSION || $a136c06cd403662a$var$ILL_FORMED_UNICODE
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
        var args = $65dcb7b8ed29ae22$exports(arguments);
        var result = $c126e09ab0f7e2a8$exports($a136c06cd403662a$var$WRONG_SYMBOLS_CONVERSION ? $a136c06cd403662a$var$stringifyWithSymbolsFix : $a136c06cd403662a$var$$stringify, null, args);
        return $a136c06cd403662a$var$ILL_FORMED_UNICODE && typeof result == 'string' ? $a136c06cd403662a$var$replace(result, $a136c06cd403662a$var$tester, $a136c06cd403662a$var$fixIllFormed) : result;
    }
});


'use strict';





// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $839d487ef7c58cd4$var$FORCED = !$3ccde59009348858$exports || $06c7d56a730e31f1$exports(function() {
    $dcfc1c5672328394$export$2d1720544b23b823(1);
});
// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$500d5d8b5806b834$exports({
    target: 'Object',
    stat: true,
    forced: $839d487ef7c58cd4$var$FORCED
}, {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        var $getOwnPropertySymbols = $dcfc1c5672328394$export$2d1720544b23b823;
        return $getOwnPropertySymbols ? $getOwnPropertySymbols($ec839b558eb5dcf4$exports(it)) : [];
    }
});




// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description
'use strict';










var $a2bd7f52ca1b7108$var$NativeSymbol = $9be6fcc00ef60f58$exports.Symbol;
var $a2bd7f52ca1b7108$var$SymbolPrototype = $a2bd7f52ca1b7108$var$NativeSymbol && $a2bd7f52ca1b7108$var$NativeSymbol.prototype;
if ($6ffb7908e83cf36c$exports && $0a82f0a5368b6870$exports($a2bd7f52ca1b7108$var$NativeSymbol) && (!('description' in $a2bd7f52ca1b7108$var$SymbolPrototype) || // Safari 12 bug
$a2bd7f52ca1b7108$var$NativeSymbol().description !== undefined)) {
    var $a2bd7f52ca1b7108$var$EmptyStringDescriptionStore = {};
    // wrap Symbol constructor for correct work with undefined description
    var $a2bd7f52ca1b7108$var$SymbolWrapper = function Symbol() {
        var description = arguments.length < 1 || arguments[0] === undefined ? undefined : $f4fff477af530dca$exports(arguments[0]);
        var result = $bc714f4a9c09d4bd$exports($a2bd7f52ca1b7108$var$SymbolPrototype, this) ? new $a2bd7f52ca1b7108$var$NativeSymbol(description) : description === undefined ? $a2bd7f52ca1b7108$var$NativeSymbol() : $a2bd7f52ca1b7108$var$NativeSymbol(description);
        if (description === '') $a2bd7f52ca1b7108$var$EmptyStringDescriptionStore[result] = true;
        return result;
    };
    $d41611a3c943a751$exports($a2bd7f52ca1b7108$var$SymbolWrapper, $a2bd7f52ca1b7108$var$NativeSymbol);
    $a2bd7f52ca1b7108$var$SymbolWrapper.prototype = $a2bd7f52ca1b7108$var$SymbolPrototype;
    $a2bd7f52ca1b7108$var$SymbolPrototype.constructor = $a2bd7f52ca1b7108$var$SymbolWrapper;
    var $a2bd7f52ca1b7108$var$NATIVE_SYMBOL = String($a2bd7f52ca1b7108$var$NativeSymbol('description detection')) === 'Symbol(description detection)';
    var $a2bd7f52ca1b7108$var$thisSymbolValue = $1689570c06db508b$exports($a2bd7f52ca1b7108$var$SymbolPrototype.valueOf);
    var $a2bd7f52ca1b7108$var$symbolDescriptiveString = $1689570c06db508b$exports($a2bd7f52ca1b7108$var$SymbolPrototype.toString);
    var $a2bd7f52ca1b7108$var$regexp = /^Symbol\((.*)\)[^)]+$/;
    var $a2bd7f52ca1b7108$var$replace = $1689570c06db508b$exports(''.replace);
    var $a2bd7f52ca1b7108$var$stringSlice = $1689570c06db508b$exports(''.slice);
    $6de7996ceea81cf8$exports($a2bd7f52ca1b7108$var$SymbolPrototype, 'description', {
        configurable: true,
        get: function description() {
            var symbol = $a2bd7f52ca1b7108$var$thisSymbolValue(this);
            if ($35cf4bf79fe152cc$exports($a2bd7f52ca1b7108$var$EmptyStringDescriptionStore, symbol)) return '';
            var string = $a2bd7f52ca1b7108$var$symbolDescriptiveString(symbol);
            var desc = $a2bd7f52ca1b7108$var$NATIVE_SYMBOL ? $a2bd7f52ca1b7108$var$stringSlice(string, 7, -1) : $a2bd7f52ca1b7108$var$replace(string, $a2bd7f52ca1b7108$var$regexp, '$1');
            return desc === '' ? undefined : desc;
        }
    });
    $500d5d8b5806b834$exports({
        global: true,
        constructor: true,
        forced: true
    }, {
        Symbol: $a2bd7f52ca1b7108$var$SymbolWrapper
    });
}


'use strict';

// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
$6a01c8a65bc6f97d$exports('asyncIterator');


'use strict';

// `Symbol.hasInstance` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.hasinstance
$6a01c8a65bc6f97d$exports('hasInstance');


'use strict';

// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
$6a01c8a65bc6f97d$exports('isConcatSpreadable');


'use strict';

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
$6a01c8a65bc6f97d$exports('iterator');


'use strict';

// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
$6a01c8a65bc6f97d$exports('match');


'use strict';

// `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace
$6a01c8a65bc6f97d$exports('replace');


'use strict';

// `Symbol.search` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.search
$6a01c8a65bc6f97d$exports('search');


'use strict';

// `Symbol.species` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.species
$6a01c8a65bc6f97d$exports('species');


'use strict';

// `Symbol.split` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.split
$6a01c8a65bc6f97d$exports('split');


'use strict';


// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
$6a01c8a65bc6f97d$exports('toPrimitive');
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
$68c2ff0fb60c4814$exports();


'use strict';



// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
$6a01c8a65bc6f97d$exports('toStringTag');
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
$be9d27c6f3178ed3$exports($36de342b7315604e$exports('Symbol'), 'Symbol');


'use strict';

// `Symbol.unscopables` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.unscopables
$6a01c8a65bc6f97d$exports('unscopables');


'use strict';






var $07fb3fe3651896a7$exports = {};
'use strict';
var $07fb3fe3651896a7$var$$TypeError = TypeError;
var $07fb3fe3651896a7$var$MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991
$07fb3fe3651896a7$exports = function(it) {
    if (it > $07fb3fe3651896a7$var$MAX_SAFE_INTEGER) throw $07fb3fe3651896a7$var$$TypeError('Maximum allowed index exceeded');
    return it;
};


var $aaa4fdf84fef0770$exports = {};
'use strict';



$aaa4fdf84fef0770$exports = function(object, key, value) {
    if ($6ffb7908e83cf36c$exports) $23cff59c96aeab90$export$2d1720544b23b823(object, key, $f89eb1caea2679b0$exports(0, value));
    else object[key] = value;
};



var $4623f4f05584ac92$exports = {};
'use strict';



var $4623f4f05584ac92$var$SPECIES = $6268abd12745dd3b$exports('species');
$4623f4f05584ac92$exports = function(METHOD_NAME) {
    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/677
    return $9d47635dcaf33179$exports >= 51 || !$06c7d56a730e31f1$exports(function() {
        var array = [];
        var constructor = array.constructor = {};
        constructor[$4623f4f05584ac92$var$SPECIES] = function() {
            return {
                foo: 1
            };
        };
        return array[METHOD_NAME](Boolean).foo !== 1;
    });
};




var $d92631240ae4cc98$var$IS_CONCAT_SPREADABLE = $6268abd12745dd3b$exports('isConcatSpreadable');
// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var $d92631240ae4cc98$var$IS_CONCAT_SPREADABLE_SUPPORT = $9d47635dcaf33179$exports >= 51 || !$06c7d56a730e31f1$exports(function() {
    var array = [];
    array[$d92631240ae4cc98$var$IS_CONCAT_SPREADABLE] = false;
    return array.concat()[0] !== array;
});
var $d92631240ae4cc98$var$isConcatSpreadable = function isConcatSpreadable(O) {
    if (!$d2d3162bdcc39b88$exports(O)) return false;
    var spreadable = O[$d92631240ae4cc98$var$IS_CONCAT_SPREADABLE];
    return spreadable !== undefined ? !!spreadable : $61ddfef2bf8c280c$exports(O);
};
var $d92631240ae4cc98$var$FORCED = !$d92631240ae4cc98$var$IS_CONCAT_SPREADABLE_SUPPORT || !$4623f4f05584ac92$exports('concat');
// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$500d5d8b5806b834$exports({
    target: 'Array',
    proto: true,
    arity: 1,
    forced: $d92631240ae4cc98$var$FORCED
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    concat: function concat(arg) {
        var O = $ec839b558eb5dcf4$exports(this);
        var A = $9225d9f1ded8840d$exports(O, 0);
        var n = 0;
        var i, k, length, len, E;
        for(i = -1, length = arguments.length; i < length; i++){
            E = i === -1 ? O : arguments[i];
            if ($d92631240ae4cc98$var$isConcatSpreadable(E)) {
                len = $f91b2cfe2e3f959b$exports(E);
                $07fb3fe3651896a7$exports(n + len);
                for(k = 0; k < len; k++, n++)if (k in E) $aaa4fdf84fef0770$exports(A, n, E[k]);
            } else {
                $07fb3fe3651896a7$exports(n + 1);
                $aaa4fdf84fef0770$exports(A, n++, E);
            }
        }
        A.length = n;
        return A;
    }
});


'use strict';

var $c48cb76116abd042$exports = {};
'use strict';



var $8a69be8224adb6ec$exports = {};
'use strict';

var $8a69be8224adb6ec$var$$TypeError = TypeError;
$8a69be8224adb6ec$exports = function(O, P) {
    if (!delete O[P]) throw new $8a69be8224adb6ec$var$$TypeError('Cannot delete property ' + $53c3bf74c3e856bf$exports(P) + ' of ' + $53c3bf74c3e856bf$exports(O));
};


var $c48cb76116abd042$var$min = Math.min;
// `Array.prototype.copyWithin` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
// eslint-disable-next-line es/no-array-prototype-copywithin -- safe
$c48cb76116abd042$exports = [].copyWithin || function copyWithin(target /* = 0 */ , start /* = 0, end = @length */ ) {
    var O = $ec839b558eb5dcf4$exports(this);
    var len = $f91b2cfe2e3f959b$exports(O);
    var to = $d78d48da15e9c8eb$exports(target, len);
    var from = $d78d48da15e9c8eb$exports(start, len);
    var end = arguments.length > 2 ? arguments[2] : undefined;
    var count = $c48cb76116abd042$var$min((end === undefined ? len : $d78d48da15e9c8eb$exports(end, len)) - from, len - to);
    var inc = 1;
    if (from < to && to < from + count) {
        inc = -1;
        from += count - 1;
        to += count - 1;
    }
    while(count-- > 0){
        if (from in O) O[to] = O[from];
        else $8a69be8224adb6ec$exports(O, to);
        to += inc;
        from += inc;
    }
    return O;
};


var $06761dfd2f968885$exports = {};
'use strict';



var $06761dfd2f968885$require$defineProperty = $23cff59c96aeab90$export$2d1720544b23b823;
var $06761dfd2f968885$var$UNSCOPABLES = $6268abd12745dd3b$exports('unscopables');
var $06761dfd2f968885$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($06761dfd2f968885$var$ArrayPrototype[$06761dfd2f968885$var$UNSCOPABLES] === undefined) $06761dfd2f968885$require$defineProperty($06761dfd2f968885$var$ArrayPrototype, $06761dfd2f968885$var$UNSCOPABLES, {
    configurable: true,
    value: $c8a7d59657e3f14b$exports(null)
});
// add a key to Array.prototype[@@unscopables]
$06761dfd2f968885$exports = function(key) {
    $06761dfd2f968885$var$ArrayPrototype[$06761dfd2f968885$var$UNSCOPABLES][key] = true;
};


// `Array.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
$500d5d8b5806b834$exports({
    target: 'Array',
    proto: true
}, {
    copyWithin: $c48cb76116abd042$exports
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$06761dfd2f968885$exports('copyWithin');


'use strict';


var $4c5992a4ca617faf$require$$every = $2f37be4e4d5b5ff0$exports.every;
var $f76c81c16f6c16d3$exports = {};
'use strict';

$f76c81c16f6c16d3$exports = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && $06c7d56a730e31f1$exports(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};


var $4c5992a4ca617faf$var$STRICT_METHOD = $f76c81c16f6c16d3$exports('every');
// `Array.prototype.every` method
// https://tc39.es/ecma262/#sec-array.prototype.every
$500d5d8b5806b834$exports({
    target: 'Array',
    proto: true,
    forced: !$4c5992a4ca617faf$var$STRICT_METHOD
}, {
    every: function every(callbackfn /* , thisArg */ ) {
        return $4c5992a4ca617faf$require$$every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});


'use strict';

var $0f35f07457e06688$exports = {};
'use strict';



// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
$0f35f07457e06688$exports = function fill(value /* , start = 0, end = @length */ ) {
    var O = $ec839b558eb5dcf4$exports(this);
    var length = $f91b2cfe2e3f959b$exports(O);
    var argumentsLength = arguments.length;
    var index = $d78d48da15e9c8eb$exports(argumentsLength > 1 ? arguments[1] : undefined, length);
    var end = argumentsLength > 2 ? arguments[2] : undefined;
    var endPos = end === undefined ? length : $d78d48da15e9c8eb$exports(end, length);
    while(endPos > index)O[index++] = value;
    return O;
};



// `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill
$500d5d8b5806b834$exports({
    target: 'Array',
    proto: true
}, {
    fill: $0f35f07457e06688$exports
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$06761dfd2f968885$exports('fill');


'use strict';


var $899ddb48cba0ecfb$require$$filter = $2f37be4e4d5b5ff0$exports.filter;

var $899ddb48cba0ecfb$var$HAS_SPECIES_SUPPORT = $4623f4f05584ac92$exports('filter');
// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$500d5d8b5806b834$exports({
    target: 'Array',
    proto: true,
    forced: !$899ddb48cba0ecfb$var$HAS_SPECIES_SUPPORT
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        return $899ddb48cba0ecfb$require$$filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});


'use strict';


var $00e6836c7f2b22dc$require$$find = $2f37be4e4d5b5ff0$exports.find;

var $00e6836c7f2b22dc$var$FIND = 'find';
var $00e6836c7f2b22dc$var$SKIPS_HOLES = true;
// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-find -- testing
if ($00e6836c7f2b22dc$var$FIND in []) Array(1)[$00e6836c7f2b22dc$var$FIND](function() {
    $00e6836c7f2b22dc$var$SKIPS_HOLES = false;
});
// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$500d5d8b5806b834$exports({
    target: 'Array',
    proto: true,
    forced: $00e6836c7f2b22dc$var$SKIPS_HOLES
}, {
    find: function find(callbackfn /* , that = undefined */ ) {
        return $00e6836c7f2b22dc$require$$find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$06761dfd2f968885$exports($00e6836c7f2b22dc$var$FIND);


'use strict';


var $c6e1583576aa191e$require$$findIndex = $2f37be4e4d5b5ff0$exports.findIndex;

var $c6e1583576aa191e$var$FIND_INDEX = 'findIndex';
var $c6e1583576aa191e$var$SKIPS_HOLES = true;
// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-findindex -- testing
if ($c6e1583576aa191e$var$FIND_INDEX in []) Array(1)[$c6e1583576aa191e$var$FIND_INDEX](function() {
    $c6e1583576aa191e$var$SKIPS_HOLES = false;
});
// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$500d5d8b5806b834$exports({
    target: 'Array',
    proto: true,
    forced: $c6e1583576aa191e$var$SKIPS_HOLES
}, {
    findIndex: function findIndex(callbackfn /* , that = undefined */ ) {
        return $c6e1583576aa191e$require$$findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$06761dfd2f968885$exports($c6e1583576aa191e$var$FIND_INDEX);


'use strict';

var $b612a97f89684b66$exports = {};
'use strict';




// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var $b612a97f89684b66$var$flattenIntoArray = function flattenIntoArray1(target, original, source, sourceLen, start, depth, mapper, thisArg) {
    var targetIndex = start;
    var sourceIndex = 0;
    var mapFn = mapper ? $847280b2cf36c2e0$exports(mapper, thisArg) : false;
    var element, elementLen;
    while(sourceIndex < sourceLen){
        if (sourceIndex in source) {
            element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
            if (depth > 0 && $61ddfef2bf8c280c$exports(element)) {
                elementLen = $f91b2cfe2e3f959b$exports(element);
                targetIndex = $b612a97f89684b66$var$flattenIntoArray(target, original, element, elementLen, targetIndex, depth - 1) - 1;
            } else {
                $07fb3fe3651896a7$exports(targetIndex + 1);
                target[targetIndex] = element;
            }
            targetIndex++;
        }
        sourceIndex++;
    }
    return targetIndex;
};
$b612a97f89684b66$exports = $b612a97f89684b66$var$flattenIntoArray;






// `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat
$500d5d8b5806b834$exports({
    target: 'Array',
    proto: true
}, {
    flat: function flat() {
        var depthArg = arguments.length ? arguments[0] : undefined;
        var O = $ec839b558eb5dcf4$exports(this);
        var sourceLen = $f91b2cfe2e3f959b$exports(O);
        var A = $9225d9f1ded8840d$exports(O, 0);
        A.length = $b612a97f89684b66$exports(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : $4508997bd0ba9879$exports(depthArg));
        return A;
    }
});


'use strict';






// `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap
$500d5d8b5806b834$exports({
    target: 'Array',
    proto: true
}, {
    flatMap: function flatMap(callbackfn /* , thisArg */ ) {
        var O = $ec839b558eb5dcf4$exports(this);
        var sourceLen = $f91b2cfe2e3f959b$exports(O);
        var A;
        $c976080d379e828f$exports(callbackfn);
        A = $9225d9f1ded8840d$exports(O, 0);
        A.length = $b612a97f89684b66$exports(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return A;
    }
});


'use strict';

var $cb440d227fb3a5c7$exports = {};
'use strict';

var $cb440d227fb3a5c7$require$$forEach = $2f37be4e4d5b5ff0$exports.forEach;

var $cb440d227fb3a5c7$var$STRICT_METHOD = $f76c81c16f6c16d3$exports('forEach');
// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
$cb440d227fb3a5c7$exports = !$cb440d227fb3a5c7$var$STRICT_METHOD ? function forEach(callbackfn /* , thisArg */ ) {
    return $cb440d227fb3a5c7$require$$forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
$500d5d8b5806b834$exports({
    target: 'Array',
    proto: true,
    forced: [].forEach !== $cb440d227fb3a5c7$exports
}, {
    forEach: $cb440d227fb3a5c7$exports
});


'use strict';

var $2210b738d2e5489c$exports = {};
'use strict';



var $5422cc6dbc889840$exports = {};
'use strict';

var $714e512e384bcced$exports = {};
'use strict';



$714e512e384bcced$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $05718fce3232bc84$exports(iterator);
    try {
        innerResult = $430a0bdb40365e72$exports(iterator, 'return');
        if (!innerResult) {
            if (kind === 'throw') throw value;
            return value;
        }
        innerResult = $e3ebd8cb7f512f74$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === 'throw') throw value;
    if (innerError) throw innerResult;
    $05718fce3232bc84$exports(innerResult);
    return value;
};


// call something on iterator step with safe closing on error
$5422cc6dbc889840$exports = function(iterator, fn, value, ENTRIES) {
    try {
        return ENTRIES ? fn($05718fce3232bc84$exports(value)[0], value[1]) : fn(value);
    } catch (error) {
        $714e512e384bcced$exports(iterator, 'throw', error);
    }
};


var $bac9daed9328b5c0$exports = {};
'use strict';

var $f0a0b0eacea46fff$exports = {};
'use strict';
$f0a0b0eacea46fff$exports = {};


var $bac9daed9328b5c0$var$ITERATOR = $6268abd12745dd3b$exports('iterator');
var $bac9daed9328b5c0$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$bac9daed9328b5c0$exports = function(it) {
    return it !== undefined && ($f0a0b0eacea46fff$exports.Array === it || $bac9daed9328b5c0$var$ArrayPrototype[$bac9daed9328b5c0$var$ITERATOR] === it);
};





var $e16d366978e3a98b$exports = {};
'use strict';




var $b7a9a1ef631e02cb$exports = {};
'use strict';





var $b7a9a1ef631e02cb$var$ITERATOR = $6268abd12745dd3b$exports('iterator');
$b7a9a1ef631e02cb$exports = function(it) {
    if (!$8d82b0b487ce9bb5$exports(it)) return $430a0bdb40365e72$exports(it, $b7a9a1ef631e02cb$var$ITERATOR) || $430a0bdb40365e72$exports(it, '@@iterator') || $f0a0b0eacea46fff$exports[$4591439421551449$exports(it)];
};


var $e16d366978e3a98b$var$$TypeError = TypeError;
$e16d366978e3a98b$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $b7a9a1ef631e02cb$exports(argument) : usingIterator;
    if ($c976080d379e828f$exports(iteratorMethod)) return $05718fce3232bc84$exports($e3ebd8cb7f512f74$exports(iteratorMethod, argument));
    throw new $e16d366978e3a98b$var$$TypeError($53c3bf74c3e856bf$exports(argument) + ' is not iterable');
};



var $2210b738d2e5489c$var$$Array = Array;
// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
$2210b738d2e5489c$exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
    var O = $ec839b558eb5dcf4$exports(arrayLike);
    var IS_CONSTRUCTOR = $c14e5ce4ade3a35d$exports(this);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    if (mapping) mapfn = $847280b2cf36c2e0$exports(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
    var iteratorMethod = $b7a9a1ef631e02cb$exports(O);
    var index = 0;
    var length, result, step, iterator, next, value;
    // if the target is not iterable or it's an array with the default iterator - use a simple case
    if (iteratorMethod && !(this === $2210b738d2e5489c$var$$Array && $bac9daed9328b5c0$exports(iteratorMethod))) {
        result = IS_CONSTRUCTOR ? new this() : [];
        iterator = $e16d366978e3a98b$exports(O, iteratorMethod);
        next = iterator.next;
        for(; !(step = $e3ebd8cb7f512f74$exports(next, iterator)).done; index++){
            value = mapping ? $5422cc6dbc889840$exports(iterator, mapfn, [
                step.value,
                index
            ], true) : step.value;
            $aaa4fdf84fef0770$exports(result, index, value);
        }
    } else {
        length = $f91b2cfe2e3f959b$exports(O);
        result = IS_CONSTRUCTOR ? new this(length) : $2210b738d2e5489c$var$$Array(length);
        for(; length > index; index++){
            value = mapping ? mapfn(O[index], index) : O[index];
            $aaa4fdf84fef0770$exports(result, index, value);
        }
    }
    result.length = index;
    return result;
};


var $02438b0b93cfa696$exports = {};
'use strict';

var $02438b0b93cfa696$var$ITERATOR = $6268abd12745dd3b$exports('iterator');
var $02438b0b93cfa696$var$SAFE_CLOSING = false;
try {
    var $02438b0b93cfa696$var$called = 0;
    var $02438b0b93cfa696$var$iteratorWithReturn = {
        next: function next() {
            return {
                done: !!$02438b0b93cfa696$var$called++
            };
        },
        'return': function() {
            $02438b0b93cfa696$var$SAFE_CLOSING = true;
        }
    };
    $02438b0b93cfa696$var$iteratorWithReturn[$02438b0b93cfa696$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($02438b0b93cfa696$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
$02438b0b93cfa696$exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$02438b0b93cfa696$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$02438b0b93cfa696$var$ITERATOR] = function() {
            return {
                next: function next() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};


var $015da59a682755e4$var$INCORRECT_ITERATION = !$02438b0b93cfa696$exports(function(iterable) {
    // eslint-disable-next-line es/no-array-from -- required for testing
    Array.from(iterable);
});
// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$500d5d8b5806b834$exports({
    target: 'Array',
    stat: true,
    forced: $015da59a682755e4$var$INCORRECT_ITERATION
}, {
    from: $2210b738d2e5489c$exports
});


'use strict';


var $f6722b5410f03e0d$require$$includes = $7e4669141832e27c$exports.includes;


// FF99+ bug
var $f6722b5410f03e0d$var$BROKEN_ON_SPARSE = $06c7d56a730e31f1$exports(function() {
    // eslint-disable-next-line es/no-array-prototype-includes -- detection
    return !Array(1).includes();
});
// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$500d5d8b5806b834$exports({
    target: 'Array',
    proto: true,
    forced: $f6722b5410f03e0d$var$BROKEN_ON_SPARSE
}, {
    includes: function includes(el /* , fromIndex = 0 */ ) {
        return $f6722b5410f03e0d$require$$includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$06761dfd2f968885$exports('includes');


'use strict';



var $87d2ce67a0cef2ea$require$$indexOf = $7e4669141832e27c$exports.indexOf;

var $87d2ce67a0cef2ea$var$nativeIndexOf = $010fa6fc9394de19$exports([].indexOf);
var $87d2ce67a0cef2ea$var$NEGATIVE_ZERO = !!$87d2ce67a0cef2ea$var$nativeIndexOf && 1 / $87d2ce67a0cef2ea$var$nativeIndexOf([
    1
], 1, -0) < 0;
var $87d2ce67a0cef2ea$var$FORCED = $87d2ce67a0cef2ea$var$NEGATIVE_ZERO || !$f76c81c16f6c16d3$exports('indexOf');
// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
$500d5d8b5806b834$exports({
    target: 'Array',
    proto: true,
    forced: $87d2ce67a0cef2ea$var$FORCED
}, {
    indexOf: function indexOf(searchElement /* , fromIndex = 0 */ ) {
        var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
        return $87d2ce67a0cef2ea$var$NEGATIVE_ZERO ? $87d2ce67a0cef2ea$var$nativeIndexOf(this, searchElement, fromIndex) || 0 : $87d2ce67a0cef2ea$require$$indexOf(this, searchElement, fromIndex);
    }
});


'use strict';


// `Array.isArray` method
// https://tc39.es/ecma262/#sec-array.isarray
$500d5d8b5806b834$exports({
    target: 'Array',
    stat: true
}, {
    isArray: $61ddfef2bf8c280c$exports
});


var $7d62cd3cf967f9c5$exports = {};
'use strict';





var $7d62cd3cf967f9c5$require$defineProperty = $23cff59c96aeab90$export$2d1720544b23b823;
var $29372d36a55fcc4a$exports = {};
'use strict';





var $ec365b22b9a10925$exports = {};
'use strict';
var $67719f618c16b9a1$exports = {};
'use strict';




var $a7c2d1ef948bc294$exports = {};
'use strict';




var $234c0f4f47710f9d$exports = {};
'use strict';

$234c0f4f47710f9d$exports = !$06c7d56a730e31f1$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $a7c2d1ef948bc294$var$IE_PROTO = $53afc3c5338354ce$exports('IE_PROTO');
var $a7c2d1ef948bc294$var$$Object = Object;
var $a7c2d1ef948bc294$var$ObjectPrototype = $a7c2d1ef948bc294$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$a7c2d1ef948bc294$exports = $234c0f4f47710f9d$exports ? $a7c2d1ef948bc294$var$$Object.getPrototypeOf : function(O) {
    var object = $ec839b558eb5dcf4$exports(O);
    if ($35cf4bf79fe152cc$exports(object, $a7c2d1ef948bc294$var$IE_PROTO)) return object[$a7c2d1ef948bc294$var$IE_PROTO];
    var constructor = object.constructor;
    if ($0a82f0a5368b6870$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $a7c2d1ef948bc294$var$$Object ? $a7c2d1ef948bc294$var$ObjectPrototype : null;
};





var $67719f618c16b9a1$var$ITERATOR = $6268abd12745dd3b$exports('iterator');
var $67719f618c16b9a1$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $67719f618c16b9a1$var$IteratorPrototype, $67719f618c16b9a1$var$PrototypeOfArrayIteratorPrototype, $67719f618c16b9a1$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $67719f618c16b9a1$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!('next' in $67719f618c16b9a1$var$arrayIterator)) $67719f618c16b9a1$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $67719f618c16b9a1$var$PrototypeOfArrayIteratorPrototype = $a7c2d1ef948bc294$exports($a7c2d1ef948bc294$exports($67719f618c16b9a1$var$arrayIterator));
        if ($67719f618c16b9a1$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $67719f618c16b9a1$var$IteratorPrototype = $67719f618c16b9a1$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $67719f618c16b9a1$var$NEW_ITERATOR_PROTOTYPE = !$d2d3162bdcc39b88$exports($67719f618c16b9a1$var$IteratorPrototype) || $06c7d56a730e31f1$exports(function() {
    var test = {};
    // FF44- legacy iterators case
    return $67719f618c16b9a1$var$IteratorPrototype[$67719f618c16b9a1$var$ITERATOR].call(test) !== test;
});
if ($67719f618c16b9a1$var$NEW_ITERATOR_PROTOTYPE) $67719f618c16b9a1$var$IteratorPrototype = {};
else if ($62bf9cf43d01f7ec$exports) $67719f618c16b9a1$var$IteratorPrototype = $c8a7d59657e3f14b$exports($67719f618c16b9a1$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$0a82f0a5368b6870$exports($67719f618c16b9a1$var$IteratorPrototype[$67719f618c16b9a1$var$ITERATOR])) $b817bfc251eac07c$exports($67719f618c16b9a1$var$IteratorPrototype, $67719f618c16b9a1$var$ITERATOR, function() {
    return this;
});
$67719f618c16b9a1$exports = {
    IteratorPrototype: $67719f618c16b9a1$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $67719f618c16b9a1$var$BUGGY_SAFARI_ITERATORS
};


var $ec365b22b9a10925$require$IteratorPrototype = $67719f618c16b9a1$exports.IteratorPrototype;




var $ec365b22b9a10925$var$returnThis = function returnThis() {
    return this;
};
$ec365b22b9a10925$exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + ' Iterator';
    IteratorConstructor.prototype = $c8a7d59657e3f14b$exports($ec365b22b9a10925$require$IteratorPrototype, {
        next: $f89eb1caea2679b0$exports(+!ENUMERABLE_NEXT, next)
    });
    $be9d27c6f3178ed3$exports(IteratorConstructor, TO_STRING_TAG, false, true);
    $f0a0b0eacea46fff$exports[TO_STRING_TAG] = $ec365b22b9a10925$var$returnThis;
    return IteratorConstructor;
};



var $6a2615bbdaa85242$exports = {};
'use strict';
var $f2dbbfa475288da4$exports = {};
'use strict';


$f2dbbfa475288da4$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $1689570c06db508b$exports($c976080d379e828f$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};




var $e097bf67d5d670de$exports = {};
'use strict';
var $027387732f963c1a$exports = {};
'use strict';

$027387732f963c1a$exports = function(argument) {
    return $d2d3162bdcc39b88$exports(argument) || argument === null;
};


var $e097bf67d5d670de$var$$String = String;
var $e097bf67d5d670de$var$$TypeError = TypeError;
$e097bf67d5d670de$exports = function(argument) {
    if ($027387732f963c1a$exports(argument)) return argument;
    throw new $e097bf67d5d670de$var$$TypeError("Can't set " + $e097bf67d5d670de$var$$String(argument) + ' as a prototype');
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$6a2615bbdaa85242$exports = Object.setPrototypeOf || ('__proto__' in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $f2dbbfa475288da4$exports(Object.prototype, '__proto__', 'set');
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $fdf84a64c2f63ac3$exports(O);
        $e097bf67d5d670de$exports(proto);
        if (!$d2d3162bdcc39b88$exports(O)) return O;
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);








var $29372d36a55fcc4a$var$PROPER_FUNCTION_NAME = $61a1b81c88c8f190$exports.PROPER;
var $29372d36a55fcc4a$var$CONFIGURABLE_FUNCTION_NAME = $61a1b81c88c8f190$exports.CONFIGURABLE;
var $29372d36a55fcc4a$var$IteratorPrototype = $67719f618c16b9a1$exports.IteratorPrototype;
var $29372d36a55fcc4a$var$BUGGY_SAFARI_ITERATORS = $67719f618c16b9a1$exports.BUGGY_SAFARI_ITERATORS;
var $29372d36a55fcc4a$var$ITERATOR = $6268abd12745dd3b$exports('iterator');
var $29372d36a55fcc4a$var$KEYS = 'keys';
var $29372d36a55fcc4a$var$VALUES = 'values';
var $29372d36a55fcc4a$var$ENTRIES = 'entries';
var $29372d36a55fcc4a$var$returnThis = function returnThis() {
    return this;
};
$29372d36a55fcc4a$exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $ec365b22b9a10925$exports(IteratorConstructor, NAME, next);
    var getIterationMethod = function getIterationMethod(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$29372d36a55fcc4a$var$BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $29372d36a55fcc4a$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $29372d36a55fcc4a$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $29372d36a55fcc4a$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + ' Iterator';
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$29372d36a55fcc4a$var$ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$29372d36a55fcc4a$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $a7c2d1ef948bc294$exports(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$62bf9cf43d01f7ec$exports && $a7c2d1ef948bc294$exports(CurrentIteratorPrototype) !== $29372d36a55fcc4a$var$IteratorPrototype) {
                if ($6a2615bbdaa85242$exports) $6a2615bbdaa85242$exports(CurrentIteratorPrototype, $29372d36a55fcc4a$var$IteratorPrototype);
                else if (!$0a82f0a5368b6870$exports(CurrentIteratorPrototype[$29372d36a55fcc4a$var$ITERATOR])) $b817bfc251eac07c$exports(CurrentIteratorPrototype, $29372d36a55fcc4a$var$ITERATOR, $29372d36a55fcc4a$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $be9d27c6f3178ed3$exports(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($62bf9cf43d01f7ec$exports) $f0a0b0eacea46fff$exports[TO_STRING_TAG] = $29372d36a55fcc4a$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($29372d36a55fcc4a$var$PROPER_FUNCTION_NAME && DEFAULT === $29372d36a55fcc4a$var$VALUES && nativeIterator && nativeIterator.name !== $29372d36a55fcc4a$var$VALUES) {
        if (!$62bf9cf43d01f7ec$exports && $29372d36a55fcc4a$var$CONFIGURABLE_FUNCTION_NAME) $5b5bc07d688591ac$exports(IterablePrototype, 'name', $29372d36a55fcc4a$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $e3ebd8cb7f512f74$exports(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($29372d36a55fcc4a$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($29372d36a55fcc4a$var$KEYS),
            entries: getIterationMethod($29372d36a55fcc4a$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($29372d36a55fcc4a$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $b817bfc251eac07c$exports(IterablePrototype, KEY, methods[KEY]);
        } else $500d5d8b5806b834$exports({
            target: NAME,
            proto: true,
            forced: $29372d36a55fcc4a$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$62bf9cf43d01f7ec$exports || FORCED) && IterablePrototype[$29372d36a55fcc4a$var$ITERATOR] !== defaultIterator) $b817bfc251eac07c$exports(IterablePrototype, $29372d36a55fcc4a$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $f0a0b0eacea46fff$exports[NAME] = defaultIterator;
    return methods;
};


var $e026e44558cad06d$exports = {};
'use strict';
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
$e026e44558cad06d$exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};




var $7d62cd3cf967f9c5$var$ARRAY_ITERATOR = 'Array Iterator';
var $7d62cd3cf967f9c5$var$setInternalState = $419c333d2a5dd5f4$exports.set;
var $7d62cd3cf967f9c5$var$getInternalState = $419c333d2a5dd5f4$exports.getterFor($7d62cd3cf967f9c5$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
$7d62cd3cf967f9c5$exports = $29372d36a55fcc4a$exports(Array, 'Array', function(iterated, kind) {
    $7d62cd3cf967f9c5$var$setInternalState(this, {
        type: $7d62cd3cf967f9c5$var$ARRAY_ITERATOR,
        target: $e656dbd61e0a8253$exports(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $7d62cd3cf967f9c5$var$getInternalState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = null;
        return $e026e44558cad06d$exports(undefined, true);
    }
    switch(state.kind){
        case 'keys':
            return $e026e44558cad06d$exports(index, false);
        case 'values':
            return $e026e44558cad06d$exports(target[index], false);
    }
    return $e026e44558cad06d$exports([
        index,
        target[index]
    ], false);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $7d62cd3cf967f9c5$var$values = $f0a0b0eacea46fff$exports.Arguments = $f0a0b0eacea46fff$exports.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$06761dfd2f968885$exports('keys');
$06761dfd2f968885$exports('values');
$06761dfd2f968885$exports('entries');
// V8 ~ Chrome 45- bug
if (!$62bf9cf43d01f7ec$exports && $6ffb7908e83cf36c$exports && $7d62cd3cf967f9c5$var$values.name !== 'values') try {
    $7d62cd3cf967f9c5$require$defineProperty($7d62cd3cf967f9c5$var$values, 'name', {
        value: 'values'
    });
} catch (error) {}


'use strict';





var $8cd675c4a515861e$var$nativeJoin = $1689570c06db508b$exports([].join);
var $8cd675c4a515861e$var$ES3_STRINGS = $a71603b0710a8479$exports !== Object;
var $8cd675c4a515861e$var$FORCED = $8cd675c4a515861e$var$ES3_STRINGS || !$f76c81c16f6c16d3$exports('join', ',');
// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$500d5d8b5806b834$exports({
    target: 'Array',
    proto: true,
    forced: $8cd675c4a515861e$var$FORCED
}, {
    join: function join(separator) {
        return $8cd675c4a515861e$var$nativeJoin($e656dbd61e0a8253$exports(this), separator === undefined ? ',' : separator);
    }
});


'use strict';

var $c49d8513c1da4ce4$exports = {};
'use strict';





var $c49d8513c1da4ce4$var$min = Math.min;
var $c49d8513c1da4ce4$var$$lastIndexOf = [].lastIndexOf;
var $c49d8513c1da4ce4$var$NEGATIVE_ZERO = !!$c49d8513c1da4ce4$var$$lastIndexOf && 1 / [
    1
].lastIndexOf(1, -0) < 0;
var $c49d8513c1da4ce4$var$STRICT_METHOD = $f76c81c16f6c16d3$exports('lastIndexOf');
var $c49d8513c1da4ce4$var$FORCED = $c49d8513c1da4ce4$var$NEGATIVE_ZERO || !$c49d8513c1da4ce4$var$STRICT_METHOD;
// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
$c49d8513c1da4ce4$exports = $c49d8513c1da4ce4$var$FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */ ) {
    // convert -0 to +0
    if ($c49d8513c1da4ce4$var$NEGATIVE_ZERO) return $c126e09ab0f7e2a8$exports($c49d8513c1da4ce4$var$$lastIndexOf, this, arguments) || 0;
    var O = $e656dbd61e0a8253$exports(this);
    var length = $f91b2cfe2e3f959b$exports(O);
    if (length === 0) return -1;
    var index = length - 1;
    if (arguments.length > 1) index = $c49d8513c1da4ce4$var$min(index, $4508997bd0ba9879$exports(arguments[1]));
    if (index < 0) index = length + index;
    for(; index >= 0; index--)if (index in O && O[index] === searchElement) return index || 0;
    return -1;
} : $c49d8513c1da4ce4$var$$lastIndexOf;


// `Array.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
// eslint-disable-next-line es/no-array-prototype-lastindexof -- required for testing
$500d5d8b5806b834$exports({
    target: 'Array',
    proto: true,
    forced: $c49d8513c1da4ce4$exports !== [].lastIndexOf
}, {
    lastIndexOf: $c49d8513c1da4ce4$exports
});


'use strict';


var $5150ed2cae9eb63f$require$$map = $2f37be4e4d5b5ff0$exports.map;

var $5150ed2cae9eb63f$var$HAS_SPECIES_SUPPORT = $4623f4f05584ac92$exports('map');
// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$500d5d8b5806b834$exports({
    target: 'Array',
    proto: true,
    forced: !$5150ed2cae9eb63f$var$HAS_SPECIES_SUPPORT
}, {
    map: function map(callbackfn /* , thisArg */ ) {
        return $5150ed2cae9eb63f$require$$map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});


'use strict';




var $3fa98f0df8c30751$var$$Array = Array;
var $3fa98f0df8c30751$var$ISNT_GENERIC = $06c7d56a730e31f1$exports(function() {
    function F() {}
    // eslint-disable-next-line es/no-array-of -- safe
    return !($3fa98f0df8c30751$var$$Array.of.call(F) instanceof F);
});
// `Array.of` method
// https://tc39.es/ecma262/#sec-array.of
// WebKit Array.of isn't generic
$500d5d8b5806b834$exports({
    target: 'Array',
    stat: true,
    forced: $3fa98f0df8c30751$var$ISNT_GENERIC
}, {
    of: function of() {
        var index = 0;
        var argumentsLength = arguments.length;
        var result = new ($c14e5ce4ade3a35d$exports(this) ? this : $3fa98f0df8c30751$var$$Array)(argumentsLength);
        while(argumentsLength > index)$aaa4fdf84fef0770$exports(result, index, arguments[index++]);
        result.length = argumentsLength;
        return result;
    }
});


'use strict';

var $6a315aad6740ea3d$exports = {};
'use strict';




var $6a315aad6740ea3d$var$$TypeError = TypeError;
var $6a315aad6740ea3d$var$REDUCE_EMPTY = 'Reduce of empty array with no initial value';
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var $6a315aad6740ea3d$var$createMethod = function createMethod(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        var O = $ec839b558eb5dcf4$exports(that);
        var self = $a71603b0710a8479$exports(O);
        var length = $f91b2cfe2e3f959b$exports(O);
        $c976080d379e828f$exports(callbackfn);
        if (length === 0 && argumentsLength < 2) throw new $6a315aad6740ea3d$var$$TypeError($6a315aad6740ea3d$var$REDUCE_EMPTY);
        var index = IS_RIGHT ? length - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in self) {
                memo = self[index];
                index += i;
                break;
            }
            index += i;
            if (IS_RIGHT ? index < 0 : length <= index) throw new $6a315aad6740ea3d$var$$TypeError($6a315aad6740ea3d$var$REDUCE_EMPTY);
        }
        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self) memo = callbackfn(memo, self[index], index, O);
        return memo;
    };
};
$6a315aad6740ea3d$exports = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: $6a315aad6740ea3d$var$createMethod(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: $6a315aad6740ea3d$var$createMethod(true)
};


var $9bcb8ec0c286b394$require$$reduce = $6a315aad6740ea3d$exports.left;


var $a97ab19b61c06eda$exports = {};
'use strict';
var $2e69a89a5051d832$exports = {};

var $qb7pP = parcelRequire("qb7pP");
'use strict';



var $2e69a89a5051d832$var$userAgentStartsWith = function userAgentStartsWith(string) {
    return $57973a61a761d756$exports.slice(0, string.length) === string;
};
$2e69a89a5051d832$exports = function() {
    if ($2e69a89a5051d832$var$userAgentStartsWith('Bun/')) return 'BUN';
    if ($2e69a89a5051d832$var$userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
    if ($2e69a89a5051d832$var$userAgentStartsWith('Deno/')) return 'DENO';
    if ($2e69a89a5051d832$var$userAgentStartsWith('Node.js/')) return 'NODE';
    if ($9be6fcc00ef60f58$exports.Bun && typeof Bun.version == 'string') return 'BUN';
    if ($9be6fcc00ef60f58$exports.Deno && (0, $qb7pP._)(Deno.version) == 'object') return 'DENO';
    if ($9afeb253af368f01$exports($9be6fcc00ef60f58$exports.process) === 'process') return 'NODE';
    if ($9be6fcc00ef60f58$exports.window && $9be6fcc00ef60f58$exports.document) return 'BROWSER';
    return 'REST';
}();


$a97ab19b61c06eda$exports = $2e69a89a5051d832$exports === 'NODE';


// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $9bcb8ec0c286b394$var$CHROME_BUG = !$a97ab19b61c06eda$exports && $9d47635dcaf33179$exports > 79 && $9d47635dcaf33179$exports < 83;
var $9bcb8ec0c286b394$var$FORCED = $9bcb8ec0c286b394$var$CHROME_BUG || !$f76c81c16f6c16d3$exports('reduce');
// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$500d5d8b5806b834$exports({
    target: 'Array',
    proto: true,
    forced: $9bcb8ec0c286b394$var$FORCED
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var length = arguments.length;
        return $9bcb8ec0c286b394$require$$reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
    }
});


'use strict';


var $31fa6d1199e98147$require$$reduceRight = $6a315aad6740ea3d$exports.right;



// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $31fa6d1199e98147$var$CHROME_BUG = !$a97ab19b61c06eda$exports && $9d47635dcaf33179$exports > 79 && $9d47635dcaf33179$exports < 83;
var $31fa6d1199e98147$var$FORCED = $31fa6d1199e98147$var$CHROME_BUG || !$f76c81c16f6c16d3$exports('reduceRight');
// `Array.prototype.reduceRight` method
// https://tc39.es/ecma262/#sec-array.prototype.reduceright
$500d5d8b5806b834$exports({
    target: 'Array',
    proto: true,
    forced: $31fa6d1199e98147$var$FORCED
}, {
    reduceRight: function reduceRight(callbackfn /* , initialValue */ ) {
        return $31fa6d1199e98147$require$$reduceRight(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
    }
});


'use strict';











var $7c775b460f3d2cca$var$HAS_SPECIES_SUPPORT = $4623f4f05584ac92$exports('slice');
var $7c775b460f3d2cca$var$SPECIES = $6268abd12745dd3b$exports('species');
var $7c775b460f3d2cca$var$$Array = Array;
var $7c775b460f3d2cca$var$max = Math.max;
// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$500d5d8b5806b834$exports({
    target: 'Array',
    proto: true,
    forced: !$7c775b460f3d2cca$var$HAS_SPECIES_SUPPORT
}, {
    slice: function slice(start, end) {
        var O = $e656dbd61e0a8253$exports(this);
        var length = $f91b2cfe2e3f959b$exports(O);
        var k = $d78d48da15e9c8eb$exports(start, length);
        var fin = $d78d48da15e9c8eb$exports(end === undefined ? length : end, length);
        // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
        var Constructor, result, n;
        if ($61ddfef2bf8c280c$exports(O)) {
            Constructor = O.constructor;
            // cross-realm fallback
            if ($c14e5ce4ade3a35d$exports(Constructor) && (Constructor === $7c775b460f3d2cca$var$$Array || $61ddfef2bf8c280c$exports(Constructor.prototype))) Constructor = undefined;
            else if ($d2d3162bdcc39b88$exports(Constructor)) {
                Constructor = Constructor[$7c775b460f3d2cca$var$SPECIES];
                if (Constructor === null) Constructor = undefined;
            }
            if (Constructor === $7c775b460f3d2cca$var$$Array || Constructor === undefined) return $65dcb7b8ed29ae22$exports(O, k, fin);
        }
        result = new (Constructor === undefined ? $7c775b460f3d2cca$var$$Array : Constructor)($7c775b460f3d2cca$var$max(fin - k, 0));
        for(n = 0; k < fin; k++, n++)if (k in O) $aaa4fdf84fef0770$exports(result, n, O[k]);
        result.length = n;
        return result;
    }
});


'use strict';


var $ba995be9f5a5ddfc$require$$some = $2f37be4e4d5b5ff0$exports.some;

var $ba995be9f5a5ddfc$var$STRICT_METHOD = $f76c81c16f6c16d3$exports('some');
// `Array.prototype.some` method
// https://tc39.es/ecma262/#sec-array.prototype.some
$500d5d8b5806b834$exports({
    target: 'Array',
    proto: true,
    forced: !$ba995be9f5a5ddfc$var$STRICT_METHOD
}, {
    some: function some(callbackfn /* , thisArg */ ) {
        return $ba995be9f5a5ddfc$require$$some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});


'use strict';








var $4ee33df2db620866$exports = {};
'use strict';

var $4ee33df2db620866$var$floor = Math.floor;
var $4ee33df2db620866$var$sort = function sort1(array, comparefn) {
    var length = array.length;
    if (length < 8) {
        // insertion sort
        var i = 1;
        var element, j;
        while(i < length){
            j = i;
            element = array[i];
            while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
            if (j !== i++) array[j] = element;
        }
    } else {
        // merge sort
        var middle = $4ee33df2db620866$var$floor(length / 2);
        var left = $4ee33df2db620866$var$sort($65dcb7b8ed29ae22$exports(array, 0, middle), comparefn);
        var right = $4ee33df2db620866$var$sort($65dcb7b8ed29ae22$exports(array, middle), comparefn);
        var llength = left.length;
        var rlength = right.length;
        var lindex = 0;
        var rindex = 0;
        while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
    }
    return array;
};
$4ee33df2db620866$exports = $4ee33df2db620866$var$sort;



var $799a167b76922fa4$exports = {};
'use strict';

var $799a167b76922fa4$var$firefox = $57973a61a761d756$exports.match(/firefox\/(\d+)/i);
$799a167b76922fa4$exports = !!$799a167b76922fa4$var$firefox && +$799a167b76922fa4$var$firefox[1];


var $608f2a809a1d0042$exports = {};
'use strict';

$608f2a809a1d0042$exports = /MSIE|Trident/.test($57973a61a761d756$exports);



var $a4a58fb9b1d3c6b9$exports = {};
'use strict';

var $a4a58fb9b1d3c6b9$var$webkit = $57973a61a761d756$exports.match(/AppleWebKit\/(\d+)\./);
$a4a58fb9b1d3c6b9$exports = !!$a4a58fb9b1d3c6b9$var$webkit && +$a4a58fb9b1d3c6b9$var$webkit[1];


var $ad7b14bbc1bb852d$var$test = [];
var $ad7b14bbc1bb852d$var$nativeSort = $1689570c06db508b$exports($ad7b14bbc1bb852d$var$test.sort);
var $ad7b14bbc1bb852d$var$push = $1689570c06db508b$exports($ad7b14bbc1bb852d$var$test.push);
// IE8-
var $ad7b14bbc1bb852d$var$FAILS_ON_UNDEFINED = $06c7d56a730e31f1$exports(function() {
    $ad7b14bbc1bb852d$var$test.sort(undefined);
});
// V8 bug
var $ad7b14bbc1bb852d$var$FAILS_ON_NULL = $06c7d56a730e31f1$exports(function() {
    $ad7b14bbc1bb852d$var$test.sort(null);
});
// Old WebKit
var $ad7b14bbc1bb852d$var$STRICT_METHOD = $f76c81c16f6c16d3$exports('sort');
var $ad7b14bbc1bb852d$var$STABLE_SORT = !$06c7d56a730e31f1$exports(function() {
    // feature detection can be too slow, so check engines versions
    if ($9d47635dcaf33179$exports) return $9d47635dcaf33179$exports < 70;
    if ($799a167b76922fa4$exports && $799a167b76922fa4$exports > 3) return;
    if ($608f2a809a1d0042$exports) return true;
    if ($a4a58fb9b1d3c6b9$exports) return $a4a58fb9b1d3c6b9$exports < 603;
    var result = '';
    var code, chr, value, index;
    // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
    for(code = 65; code < 76; code++){
        chr = String.fromCharCode(code);
        switch(code){
            case 66:
            case 69:
            case 70:
            case 72:
                value = 3;
                break;
            case 68:
            case 71:
                value = 4;
                break;
            default:
                value = 2;
        }
        for(index = 0; index < 47; index++)$ad7b14bbc1bb852d$var$test.push({
            k: chr + index,
            v: value
        });
    }
    $ad7b14bbc1bb852d$var$test.sort(function(a, b) {
        return b.v - a.v;
    });
    for(index = 0; index < $ad7b14bbc1bb852d$var$test.length; index++){
        chr = $ad7b14bbc1bb852d$var$test[index].k.charAt(0);
        if (result.charAt(result.length - 1) !== chr) result += chr;
    }
    return result !== 'DGBEFHACIJK';
});
var $ad7b14bbc1bb852d$var$FORCED = $ad7b14bbc1bb852d$var$FAILS_ON_UNDEFINED || !$ad7b14bbc1bb852d$var$FAILS_ON_NULL || !$ad7b14bbc1bb852d$var$STRICT_METHOD || !$ad7b14bbc1bb852d$var$STABLE_SORT;
var $ad7b14bbc1bb852d$var$getSortCompare = function getSortCompare(comparefn) {
    return function(x, y) {
        if (y === undefined) return -1;
        if (x === undefined) return 1;
        if (comparefn !== undefined) return +comparefn(x, y) || 0;
        return $f4fff477af530dca$exports(x) > $f4fff477af530dca$exports(y) ? 1 : -1;
    };
};
// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$500d5d8b5806b834$exports({
    target: 'Array',
    proto: true,
    forced: $ad7b14bbc1bb852d$var$FORCED
}, {
    sort: function sort(comparefn) {
        if (comparefn !== undefined) $c976080d379e828f$exports(comparefn);
        var array = $ec839b558eb5dcf4$exports(this);
        if ($ad7b14bbc1bb852d$var$STABLE_SORT) return comparefn === undefined ? $ad7b14bbc1bb852d$var$nativeSort(array) : $ad7b14bbc1bb852d$var$nativeSort(array, comparefn);
        var items = [];
        var arrayLength = $f91b2cfe2e3f959b$exports(array);
        var itemsLength, index;
        for(index = 0; index < arrayLength; index++)if (index in array) $ad7b14bbc1bb852d$var$push(items, array[index]);
        $4ee33df2db620866$exports(items, $ad7b14bbc1bb852d$var$getSortCompare(comparefn));
        itemsLength = $f91b2cfe2e3f959b$exports(items);
        index = 0;
        while(index < itemsLength)array[index] = items[index++];
        while(index < arrayLength)$8a69be8224adb6ec$exports(array, index++);
        return array;
    }
});


'use strict';
var $8db167be81e78b6c$exports = {};
'use strict';




var $8db167be81e78b6c$var$SPECIES = $6268abd12745dd3b$exports('species');
$8db167be81e78b6c$exports = function(CONSTRUCTOR_NAME) {
    var Constructor = $36de342b7315604e$exports(CONSTRUCTOR_NAME);
    if ($6ffb7908e83cf36c$exports && Constructor && !Constructor[$8db167be81e78b6c$var$SPECIES]) $6de7996ceea81cf8$exports(Constructor, $8db167be81e78b6c$var$SPECIES, {
        configurable: true,
        get: function get() {
            return this;
        }
    });
};


// `Array[@@species]` getter
// https://tc39.es/ecma262/#sec-get-array-@@species
$8db167be81e78b6c$exports('Array');


'use strict';





var $2d9a1743e19e7ba5$exports = {};
'use strict';


var $2d9a1743e19e7ba5$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $2d9a1743e19e7ba5$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Safari < 13 does not throw an error in this case
var $2d9a1743e19e7ba5$var$SILENT_ON_NON_WRITABLE_LENGTH_SET = $6ffb7908e83cf36c$exports && !function() {
    // makes no sense without proper strict mode support
    if (this !== undefined) return true;
    try {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty([], 'length', {
            writable: false
        }).length = 1;
    } catch (error) {
        return error instanceof TypeError;
    }
}();
$2d9a1743e19e7ba5$exports = $2d9a1743e19e7ba5$var$SILENT_ON_NON_WRITABLE_LENGTH_SET ? function(O, length) {
    if ($61ddfef2bf8c280c$exports(O) && !$2d9a1743e19e7ba5$var$getOwnPropertyDescriptor(O, 'length').writable) throw new $2d9a1743e19e7ba5$var$$TypeError('Cannot set read only .length');
    return O.length = length;
} : function(O, length) {
    return O.length = length;
};







var $ac9183aeba66c214$var$HAS_SPECIES_SUPPORT = $4623f4f05584ac92$exports('splice');
var $ac9183aeba66c214$var$max = Math.max;
var $ac9183aeba66c214$var$min = Math.min;
// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$500d5d8b5806b834$exports({
    target: 'Array',
    proto: true,
    forced: !$ac9183aeba66c214$var$HAS_SPECIES_SUPPORT
}, {
    splice: function splice(start, deleteCount /* , ...items */ ) {
        var O = $ec839b558eb5dcf4$exports(this);
        var len = $f91b2cfe2e3f959b$exports(O);
        var actualStart = $d78d48da15e9c8eb$exports(start, len);
        var argumentsLength = arguments.length;
        var insertCount, actualDeleteCount, A, k, from, to;
        if (argumentsLength === 0) insertCount = actualDeleteCount = 0;
        else if (argumentsLength === 1) {
            insertCount = 0;
            actualDeleteCount = len - actualStart;
        } else {
            insertCount = argumentsLength - 2;
            actualDeleteCount = $ac9183aeba66c214$var$min($ac9183aeba66c214$var$max($4508997bd0ba9879$exports(deleteCount), 0), len - actualStart);
        }
        $07fb3fe3651896a7$exports(len + insertCount - actualDeleteCount);
        A = $9225d9f1ded8840d$exports(O, actualDeleteCount);
        for(k = 0; k < actualDeleteCount; k++){
            from = actualStart + k;
            if (from in O) $aaa4fdf84fef0770$exports(A, k, O[from]);
        }
        A.length = actualDeleteCount;
        if (insertCount < actualDeleteCount) {
            for(k = actualStart; k < len - actualDeleteCount; k++){
                from = k + actualDeleteCount;
                to = k + insertCount;
                if (from in O) O[to] = O[from];
                else $8a69be8224adb6ec$exports(O, to);
            }
            for(k = len; k > len - actualDeleteCount + insertCount; k--)$8a69be8224adb6ec$exports(O, k - 1);
        } else if (insertCount > actualDeleteCount) for(k = len - actualDeleteCount; k > actualStart; k--){
            from = k + actualDeleteCount - 1;
            to = k + insertCount - 1;
            if (from in O) O[to] = O[from];
            else $8a69be8224adb6ec$exports(O, to);
        }
        for(k = 0; k < insertCount; k++)O[k + actualStart] = arguments[k + 2];
        $2d9a1743e19e7ba5$exports(O, len - actualDeleteCount + insertCount);
        return A;
    }
});


'use strict';

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$06761dfd2f968885$exports('flat');


'use strict';

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$06761dfd2f968885$exports('flatMap');


'use strict';


var $e070b599b2ed132d$exports = {};
'use strict';



var $3acc1db098119a6d$exports = {};
'use strict';
// eslint-disable-next-line es/no-typed-arrays -- safe
$3acc1db098119a6d$exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';





var $7ad1d749b941a26e$exports = {};
'use strict';

$7ad1d749b941a26e$exports = function(target, src, options) {
    for(var key in src)$b817bfc251eac07c$exports(target, key, src[key], options);
    return target;
};



var $65f23bed46afab45$exports = {};
'use strict';

var $65f23bed46afab45$var$$TypeError = TypeError;
$65f23bed46afab45$exports = function(it, Prototype) {
    if ($bc714f4a9c09d4bd$exports(Prototype, it)) return it;
    throw new $65f23bed46afab45$var$$TypeError('Incorrect invocation');
};




var $1616da479b63d514$exports = {};
'use strict';


var $1616da479b63d514$var$$RangeError = RangeError;
// `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex
$1616da479b63d514$exports = function(it) {
    if (it === undefined) return 0;
    var number = $4508997bd0ba9879$exports(it);
    var length = $d14e7a9632dda07a$exports(number);
    if (number !== length) throw new $1616da479b63d514$var$$RangeError('Wrong length or index');
    return length;
};


var $78b718bae1c89cef$exports = {};
'use strict';
var $77dd204631a66e19$exports = {};
'use strict';
var $25fe284f18cf8b30$exports = {};
'use strict';
// `Math.sign` method implementation
// https://tc39.es/ecma262/#sec-math.sign
// eslint-disable-next-line es/no-math-sign -- safe
$25fe284f18cf8b30$exports = Math.sign || function sign(x) {
    var n = +x;
    // eslint-disable-next-line no-self-compare -- NaN check
    return n === 0 || n !== n ? n : n < 0 ? -1 : 1;
};


var $77dd204631a66e19$var$abs = Math.abs;
var $77dd204631a66e19$var$EPSILON = 2.220446049250313e-16; // Number.EPSILON
var $77dd204631a66e19$var$INVERSE_EPSILON = 1 / $77dd204631a66e19$var$EPSILON;
var $77dd204631a66e19$var$roundTiesToEven = function roundTiesToEven(n) {
    return n + $77dd204631a66e19$var$INVERSE_EPSILON - $77dd204631a66e19$var$INVERSE_EPSILON;
};
$77dd204631a66e19$exports = function(x, FLOAT_EPSILON, FLOAT_MAX_VALUE, FLOAT_MIN_VALUE) {
    var n = +x;
    var absolute = $77dd204631a66e19$var$abs(n);
    var s = $25fe284f18cf8b30$exports(n);
    if (absolute < FLOAT_MIN_VALUE) return s * $77dd204631a66e19$var$roundTiesToEven(absolute / FLOAT_MIN_VALUE / FLOAT_EPSILON) * FLOAT_MIN_VALUE * FLOAT_EPSILON;
    var a = (1 + FLOAT_EPSILON / $77dd204631a66e19$var$EPSILON) * absolute;
    var result = a - (a - absolute);
    // eslint-disable-next-line no-self-compare -- NaN check
    if (result > FLOAT_MAX_VALUE || result !== result) return s * Infinity;
    return s * result;
};


var $78b718bae1c89cef$var$FLOAT32_EPSILON = 1.1920928955078125e-7; // 2 ** -23;
var $78b718bae1c89cef$var$FLOAT32_MAX_VALUE = 3.4028234663852886e+38; // 2 ** 128 - 2 ** 104
var $78b718bae1c89cef$var$FLOAT32_MIN_VALUE = 1.1754943508222875e-38; // 2 ** -126;
// `Math.fround` method implementation
// https://tc39.es/ecma262/#sec-math.fround
// eslint-disable-next-line es/no-math-fround -- safe
$78b718bae1c89cef$exports = Math.fround || function fround(x) {
    return $77dd204631a66e19$exports(x, $78b718bae1c89cef$var$FLOAT32_EPSILON, $78b718bae1c89cef$var$FLOAT32_MAX_VALUE, $78b718bae1c89cef$var$FLOAT32_MIN_VALUE);
};


var $a8a6ac5701fbe452$exports = {};
'use strict';
// IEEE754 conversions based on https://github.com/feross/ieee754
var $a8a6ac5701fbe452$var$$Array = Array;
var $a8a6ac5701fbe452$var$abs = Math.abs;
var $a8a6ac5701fbe452$var$pow = Math.pow;
var $a8a6ac5701fbe452$var$floor = Math.floor;
var $a8a6ac5701fbe452$var$log = Math.log;
var $a8a6ac5701fbe452$var$LN2 = Math.LN2;
var $a8a6ac5701fbe452$var$pack = function pack(number, mantissaLength, bytes) {
    var buffer = $a8a6ac5701fbe452$var$$Array(bytes);
    var exponentLength = bytes * 8 - mantissaLength - 1;
    var eMax = (1 << exponentLength) - 1;
    var eBias = eMax >> 1;
    var rt = mantissaLength === 23 ? $a8a6ac5701fbe452$var$pow(2, -24) - $a8a6ac5701fbe452$var$pow(2, -77) : 0;
    var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
    var index = 0;
    var exponent, mantissa, c;
    number = $a8a6ac5701fbe452$var$abs(number);
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number !== number || number === Infinity) {
        // eslint-disable-next-line no-self-compare -- NaN check
        mantissa = number !== number ? 1 : 0;
        exponent = eMax;
    } else {
        exponent = $a8a6ac5701fbe452$var$floor($a8a6ac5701fbe452$var$log(number) / $a8a6ac5701fbe452$var$LN2);
        c = $a8a6ac5701fbe452$var$pow(2, -exponent);
        if (number * c < 1) {
            exponent--;
            c *= 2;
        }
        if (exponent + eBias >= 1) number += rt / c;
        else number += rt * $a8a6ac5701fbe452$var$pow(2, 1 - eBias);
        if (number * c >= 2) {
            exponent++;
            c /= 2;
        }
        if (exponent + eBias >= eMax) {
            mantissa = 0;
            exponent = eMax;
        } else if (exponent + eBias >= 1) {
            mantissa = (number * c - 1) * $a8a6ac5701fbe452$var$pow(2, mantissaLength);
            exponent += eBias;
        } else {
            mantissa = number * $a8a6ac5701fbe452$var$pow(2, eBias - 1) * $a8a6ac5701fbe452$var$pow(2, mantissaLength);
            exponent = 0;
        }
    }
    while(mantissaLength >= 8){
        buffer[index++] = mantissa & 255;
        mantissa /= 256;
        mantissaLength -= 8;
    }
    exponent = exponent << mantissaLength | mantissa;
    exponentLength += mantissaLength;
    while(exponentLength > 0){
        buffer[index++] = exponent & 255;
        exponent /= 256;
        exponentLength -= 8;
    }
    buffer[index - 1] |= sign * 128;
    return buffer;
};
var $a8a6ac5701fbe452$var$unpack = function unpack(buffer, mantissaLength) {
    var bytes = buffer.length;
    var exponentLength = bytes * 8 - mantissaLength - 1;
    var eMax = (1 << exponentLength) - 1;
    var eBias = eMax >> 1;
    var nBits = exponentLength - 7;
    var index = bytes - 1;
    var sign = buffer[index--];
    var exponent = sign & 127;
    var mantissa;
    sign >>= 7;
    while(nBits > 0){
        exponent = exponent * 256 + buffer[index--];
        nBits -= 8;
    }
    mantissa = exponent & (1 << -nBits) - 1;
    exponent >>= -nBits;
    nBits += mantissaLength;
    while(nBits > 0){
        mantissa = mantissa * 256 + buffer[index--];
        nBits -= 8;
    }
    if (exponent === 0) exponent = 1 - eBias;
    else if (exponent === eMax) return mantissa ? NaN : sign ? -Infinity : Infinity;
    else {
        mantissa += $a8a6ac5701fbe452$var$pow(2, mantissaLength);
        exponent -= eBias;
    }
    return (sign ? -1 : 1) * mantissa * $a8a6ac5701fbe452$var$pow(2, exponent - mantissaLength);
};
$a8a6ac5701fbe452$exports = {
    pack: $a8a6ac5701fbe452$var$pack,
    unpack: $a8a6ac5701fbe452$var$unpack
};






var $8388ec23a46a9286$exports = {};
'use strict';



// makes subclassing work correct for wrapped built-ins
$8388ec23a46a9286$exports = function($this, dummy, Wrapper) {
    var NewTarget, NewTargetPrototype;
    if (// it can work only with native `setPrototypeOf`
    $6a2615bbdaa85242$exports && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    $0a82f0a5368b6870$exports(NewTarget = dummy.constructor) && NewTarget !== Wrapper && $d2d3162bdcc39b88$exports(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) $6a2615bbdaa85242$exports($this, NewTargetPrototype);
    return $this;
};





var $e070b599b2ed132d$var$PROPER_FUNCTION_NAME = $61a1b81c88c8f190$exports.PROPER;
var $e070b599b2ed132d$var$CONFIGURABLE_FUNCTION_NAME = $61a1b81c88c8f190$exports.CONFIGURABLE;
var $e070b599b2ed132d$var$ARRAY_BUFFER = 'ArrayBuffer';
var $e070b599b2ed132d$var$DATA_VIEW = 'DataView';
var $e070b599b2ed132d$var$PROTOTYPE = 'prototype';
var $e070b599b2ed132d$var$WRONG_LENGTH = 'Wrong length';
var $e070b599b2ed132d$var$WRONG_INDEX = 'Wrong index';
var $e070b599b2ed132d$var$getInternalArrayBufferState = $419c333d2a5dd5f4$exports.getterFor($e070b599b2ed132d$var$ARRAY_BUFFER);
var $e070b599b2ed132d$var$getInternalDataViewState = $419c333d2a5dd5f4$exports.getterFor($e070b599b2ed132d$var$DATA_VIEW);
var $e070b599b2ed132d$var$setInternalState = $419c333d2a5dd5f4$exports.set;
var $e070b599b2ed132d$var$NativeArrayBuffer = $9be6fcc00ef60f58$exports[$e070b599b2ed132d$var$ARRAY_BUFFER];
var $e070b599b2ed132d$var$$ArrayBuffer = $e070b599b2ed132d$var$NativeArrayBuffer;
var $e070b599b2ed132d$var$ArrayBufferPrototype = $e070b599b2ed132d$var$$ArrayBuffer && $e070b599b2ed132d$var$$ArrayBuffer[$e070b599b2ed132d$var$PROTOTYPE];
var $e070b599b2ed132d$var$$DataView = $9be6fcc00ef60f58$exports[$e070b599b2ed132d$var$DATA_VIEW];
var $e070b599b2ed132d$var$DataViewPrototype = $e070b599b2ed132d$var$$DataView && $e070b599b2ed132d$var$$DataView[$e070b599b2ed132d$var$PROTOTYPE];
var $e070b599b2ed132d$var$ObjectPrototype = Object.prototype;
var $e070b599b2ed132d$var$Array = $9be6fcc00ef60f58$exports.Array;
var $e070b599b2ed132d$var$RangeError = $9be6fcc00ef60f58$exports.RangeError;
var $e070b599b2ed132d$var$fill = $1689570c06db508b$exports($0f35f07457e06688$exports);
var $e070b599b2ed132d$var$reverse = $1689570c06db508b$exports([].reverse);
var $e070b599b2ed132d$var$packIEEE754 = $a8a6ac5701fbe452$exports.pack;
var $e070b599b2ed132d$var$unpackIEEE754 = $a8a6ac5701fbe452$exports.unpack;
var $e070b599b2ed132d$var$packInt8 = function packInt8(number) {
    return [
        number & 0xFF
    ];
};
var $e070b599b2ed132d$var$packInt16 = function packInt16(number) {
    return [
        number & 0xFF,
        number >> 8 & 0xFF
    ];
};
var $e070b599b2ed132d$var$packInt32 = function packInt32(number) {
    return [
        number & 0xFF,
        number >> 8 & 0xFF,
        number >> 16 & 0xFF,
        number >> 24 & 0xFF
    ];
};
var $e070b599b2ed132d$var$unpackInt32 = function unpackInt32(buffer) {
    return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};
var $e070b599b2ed132d$var$packFloat32 = function packFloat32(number) {
    return $e070b599b2ed132d$var$packIEEE754($78b718bae1c89cef$exports(number), 23, 4);
};
var $e070b599b2ed132d$var$packFloat64 = function packFloat64(number) {
    return $e070b599b2ed132d$var$packIEEE754(number, 52, 8);
};
var $e070b599b2ed132d$var$addGetter = function addGetter(Constructor, key, getInternalState) {
    $6de7996ceea81cf8$exports(Constructor[$e070b599b2ed132d$var$PROTOTYPE], key, {
        configurable: true,
        get: function get() {
            return getInternalState(this)[key];
        }
    });
};
var $e070b599b2ed132d$var$get = function get(view, count, index, isLittleEndian) {
    var store = $e070b599b2ed132d$var$getInternalDataViewState(view);
    var intIndex = $1616da479b63d514$exports(index);
    var boolIsLittleEndian = !!isLittleEndian;
    if (intIndex + count > store.byteLength) throw new $e070b599b2ed132d$var$RangeError($e070b599b2ed132d$var$WRONG_INDEX);
    var bytes = store.bytes;
    var start = intIndex + store.byteOffset;
    var pack = $65dcb7b8ed29ae22$exports(bytes, start, start + count);
    return boolIsLittleEndian ? pack : $e070b599b2ed132d$var$reverse(pack);
};
var $e070b599b2ed132d$var$set = function set(view, count, index, conversion, value, isLittleEndian) {
    var store = $e070b599b2ed132d$var$getInternalDataViewState(view);
    var intIndex = $1616da479b63d514$exports(index);
    var pack = conversion(+value);
    var boolIsLittleEndian = !!isLittleEndian;
    if (intIndex + count > store.byteLength) throw new $e070b599b2ed132d$var$RangeError($e070b599b2ed132d$var$WRONG_INDEX);
    var bytes = store.bytes;
    var start = intIndex + store.byteOffset;
    for(var i = 0; i < count; i++)bytes[start + i] = pack[boolIsLittleEndian ? i : count - i - 1];
};
if (!$3acc1db098119a6d$exports) {
    $e070b599b2ed132d$var$$ArrayBuffer = function ArrayBuffer(length) {
        $65f23bed46afab45$exports(this, $e070b599b2ed132d$var$ArrayBufferPrototype);
        var byteLength = $1616da479b63d514$exports(length);
        $e070b599b2ed132d$var$setInternalState(this, {
            type: $e070b599b2ed132d$var$ARRAY_BUFFER,
            bytes: $e070b599b2ed132d$var$fill($e070b599b2ed132d$var$Array(byteLength), 0),
            byteLength: byteLength
        });
        if (!$6ffb7908e83cf36c$exports) {
            this.byteLength = byteLength;
            this.detached = false;
        }
    };
    $e070b599b2ed132d$var$ArrayBufferPrototype = $e070b599b2ed132d$var$$ArrayBuffer[$e070b599b2ed132d$var$PROTOTYPE];
    $e070b599b2ed132d$var$$DataView = function DataView(buffer, byteOffset, byteLength) {
        $65f23bed46afab45$exports(this, $e070b599b2ed132d$var$DataViewPrototype);
        $65f23bed46afab45$exports(buffer, $e070b599b2ed132d$var$ArrayBufferPrototype);
        var bufferState = $e070b599b2ed132d$var$getInternalArrayBufferState(buffer);
        var bufferLength = bufferState.byteLength;
        var offset = $4508997bd0ba9879$exports(byteOffset);
        if (offset < 0 || offset > bufferLength) throw new $e070b599b2ed132d$var$RangeError('Wrong offset');
        byteLength = byteLength === undefined ? bufferLength - offset : $d14e7a9632dda07a$exports(byteLength);
        if (offset + byteLength > bufferLength) throw new $e070b599b2ed132d$var$RangeError($e070b599b2ed132d$var$WRONG_LENGTH);
        $e070b599b2ed132d$var$setInternalState(this, {
            type: $e070b599b2ed132d$var$DATA_VIEW,
            buffer: buffer,
            byteLength: byteLength,
            byteOffset: offset,
            bytes: bufferState.bytes
        });
        if (!$6ffb7908e83cf36c$exports) {
            this.buffer = buffer;
            this.byteLength = byteLength;
            this.byteOffset = offset;
        }
    };
    $e070b599b2ed132d$var$DataViewPrototype = $e070b599b2ed132d$var$$DataView[$e070b599b2ed132d$var$PROTOTYPE];
    if ($6ffb7908e83cf36c$exports) {
        $e070b599b2ed132d$var$addGetter($e070b599b2ed132d$var$$ArrayBuffer, 'byteLength', $e070b599b2ed132d$var$getInternalArrayBufferState);
        $e070b599b2ed132d$var$addGetter($e070b599b2ed132d$var$$DataView, 'buffer', $e070b599b2ed132d$var$getInternalDataViewState);
        $e070b599b2ed132d$var$addGetter($e070b599b2ed132d$var$$DataView, 'byteLength', $e070b599b2ed132d$var$getInternalDataViewState);
        $e070b599b2ed132d$var$addGetter($e070b599b2ed132d$var$$DataView, 'byteOffset', $e070b599b2ed132d$var$getInternalDataViewState);
    }
    $7ad1d749b941a26e$exports($e070b599b2ed132d$var$DataViewPrototype, {
        getInt8: function getInt8(byteOffset) {
            return $e070b599b2ed132d$var$get(this, 1, byteOffset)[0] << 24 >> 24;
        },
        getUint8: function getUint8(byteOffset) {
            return $e070b599b2ed132d$var$get(this, 1, byteOffset)[0];
        },
        getInt16: function getInt16(byteOffset /* , littleEndian */ ) {
            var bytes = $e070b599b2ed132d$var$get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
            return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
        },
        getUint16: function getUint16(byteOffset /* , littleEndian */ ) {
            var bytes = $e070b599b2ed132d$var$get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
            return bytes[1] << 8 | bytes[0];
        },
        getInt32: function getInt32(byteOffset /* , littleEndian */ ) {
            return $e070b599b2ed132d$var$unpackInt32($e070b599b2ed132d$var$get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false));
        },
        getUint32: function getUint32(byteOffset /* , littleEndian */ ) {
            return $e070b599b2ed132d$var$unpackInt32($e070b599b2ed132d$var$get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false)) >>> 0;
        },
        getFloat32: function getFloat32(byteOffset /* , littleEndian */ ) {
            return $e070b599b2ed132d$var$unpackIEEE754($e070b599b2ed132d$var$get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false), 23);
        },
        getFloat64: function getFloat64(byteOffset /* , littleEndian */ ) {
            return $e070b599b2ed132d$var$unpackIEEE754($e070b599b2ed132d$var$get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : false), 52);
        },
        setInt8: function setInt8(byteOffset, value) {
            $e070b599b2ed132d$var$set(this, 1, byteOffset, $e070b599b2ed132d$var$packInt8, value);
        },
        setUint8: function setUint8(byteOffset, value) {
            $e070b599b2ed132d$var$set(this, 1, byteOffset, $e070b599b2ed132d$var$packInt8, value);
        },
        setInt16: function setInt16(byteOffset, value /* , littleEndian */ ) {
            $e070b599b2ed132d$var$set(this, 2, byteOffset, $e070b599b2ed132d$var$packInt16, value, arguments.length > 2 ? arguments[2] : false);
        },
        setUint16: function setUint16(byteOffset, value /* , littleEndian */ ) {
            $e070b599b2ed132d$var$set(this, 2, byteOffset, $e070b599b2ed132d$var$packInt16, value, arguments.length > 2 ? arguments[2] : false);
        },
        setInt32: function setInt32(byteOffset, value /* , littleEndian */ ) {
            $e070b599b2ed132d$var$set(this, 4, byteOffset, $e070b599b2ed132d$var$packInt32, value, arguments.length > 2 ? arguments[2] : false);
        },
        setUint32: function setUint32(byteOffset, value /* , littleEndian */ ) {
            $e070b599b2ed132d$var$set(this, 4, byteOffset, $e070b599b2ed132d$var$packInt32, value, arguments.length > 2 ? arguments[2] : false);
        },
        setFloat32: function setFloat32(byteOffset, value /* , littleEndian */ ) {
            $e070b599b2ed132d$var$set(this, 4, byteOffset, $e070b599b2ed132d$var$packFloat32, value, arguments.length > 2 ? arguments[2] : false);
        },
        setFloat64: function setFloat64(byteOffset, value /* , littleEndian */ ) {
            $e070b599b2ed132d$var$set(this, 8, byteOffset, $e070b599b2ed132d$var$packFloat64, value, arguments.length > 2 ? arguments[2] : false);
        }
    });
} else {
    var $e070b599b2ed132d$var$INCORRECT_ARRAY_BUFFER_NAME = $e070b599b2ed132d$var$PROPER_FUNCTION_NAME && $e070b599b2ed132d$var$NativeArrayBuffer.name !== $e070b599b2ed132d$var$ARRAY_BUFFER;
    /* eslint-disable no-new, sonarjs/inconsistent-function-call -- required for testing */ if (!$06c7d56a730e31f1$exports(function() {
        $e070b599b2ed132d$var$NativeArrayBuffer(1);
    }) || !$06c7d56a730e31f1$exports(function() {
        new $e070b599b2ed132d$var$NativeArrayBuffer(-1);
    }) || $06c7d56a730e31f1$exports(function() {
        new $e070b599b2ed132d$var$NativeArrayBuffer();
        new $e070b599b2ed132d$var$NativeArrayBuffer(1.5);
        new $e070b599b2ed132d$var$NativeArrayBuffer(NaN);
        return $e070b599b2ed132d$var$NativeArrayBuffer.length !== 1 || $e070b599b2ed132d$var$INCORRECT_ARRAY_BUFFER_NAME && !$e070b599b2ed132d$var$CONFIGURABLE_FUNCTION_NAME;
    })) {
        /* eslint-enable no-new, sonarjs/inconsistent-function-call -- required for testing */ $e070b599b2ed132d$var$$ArrayBuffer = function ArrayBuffer(length) {
            $65f23bed46afab45$exports(this, $e070b599b2ed132d$var$ArrayBufferPrototype);
            return $8388ec23a46a9286$exports(new $e070b599b2ed132d$var$NativeArrayBuffer($1616da479b63d514$exports(length)), this, $e070b599b2ed132d$var$$ArrayBuffer);
        };
        $e070b599b2ed132d$var$$ArrayBuffer[$e070b599b2ed132d$var$PROTOTYPE] = $e070b599b2ed132d$var$ArrayBufferPrototype;
        $e070b599b2ed132d$var$ArrayBufferPrototype.constructor = $e070b599b2ed132d$var$$ArrayBuffer;
        $d41611a3c943a751$exports($e070b599b2ed132d$var$$ArrayBuffer, $e070b599b2ed132d$var$NativeArrayBuffer);
    } else if ($e070b599b2ed132d$var$INCORRECT_ARRAY_BUFFER_NAME && $e070b599b2ed132d$var$CONFIGURABLE_FUNCTION_NAME) $5b5bc07d688591ac$exports($e070b599b2ed132d$var$NativeArrayBuffer, 'name', $e070b599b2ed132d$var$ARRAY_BUFFER);
    // WebKit bug - the same parent prototype for typed arrays and data view
    if ($6a2615bbdaa85242$exports && $a7c2d1ef948bc294$exports($e070b599b2ed132d$var$DataViewPrototype) !== $e070b599b2ed132d$var$ObjectPrototype) $6a2615bbdaa85242$exports($e070b599b2ed132d$var$DataViewPrototype, $e070b599b2ed132d$var$ObjectPrototype);
    // iOS Safari 7.x bug
    var $e070b599b2ed132d$var$testView = new $e070b599b2ed132d$var$$DataView(new $e070b599b2ed132d$var$$ArrayBuffer(2));
    var $e070b599b2ed132d$var$$setInt8 = $1689570c06db508b$exports($e070b599b2ed132d$var$DataViewPrototype.setInt8);
    $e070b599b2ed132d$var$testView.setInt8(0, 2147483648);
    $e070b599b2ed132d$var$testView.setInt8(1, 2147483649);
    if ($e070b599b2ed132d$var$testView.getInt8(0) || !$e070b599b2ed132d$var$testView.getInt8(1)) $7ad1d749b941a26e$exports($e070b599b2ed132d$var$DataViewPrototype, {
        setInt8: function setInt8(byteOffset, value) {
            $e070b599b2ed132d$var$$setInt8(this, byteOffset, value << 24 >> 24);
        },
        setUint8: function setUint8(byteOffset, value) {
            $e070b599b2ed132d$var$$setInt8(this, byteOffset, value << 24 >> 24);
        }
    }, {
        unsafe: true
    });
}
$be9d27c6f3178ed3$exports($e070b599b2ed132d$var$$ArrayBuffer, $e070b599b2ed132d$var$ARRAY_BUFFER);
$be9d27c6f3178ed3$exports($e070b599b2ed132d$var$$DataView, $e070b599b2ed132d$var$DATA_VIEW);
$e070b599b2ed132d$exports = {
    ArrayBuffer: $e070b599b2ed132d$var$$ArrayBuffer,
    DataView: $e070b599b2ed132d$var$$DataView
};



var $25d22aa7e2f96a85$var$ARRAY_BUFFER = 'ArrayBuffer';
var $25d22aa7e2f96a85$var$ArrayBuffer = $e070b599b2ed132d$exports[$25d22aa7e2f96a85$var$ARRAY_BUFFER];
var $25d22aa7e2f96a85$var$NativeArrayBuffer = $9be6fcc00ef60f58$exports[$25d22aa7e2f96a85$var$ARRAY_BUFFER];
// `ArrayBuffer` constructor
// https://tc39.es/ecma262/#sec-arraybuffer-constructor
$500d5d8b5806b834$exports({
    global: true,
    constructor: true,
    forced: $25d22aa7e2f96a85$var$NativeArrayBuffer !== $25d22aa7e2f96a85$var$ArrayBuffer
}, {
    ArrayBuffer: $25d22aa7e2f96a85$var$ArrayBuffer
});
$8db167be81e78b6c$exports($25d22aa7e2f96a85$var$ARRAY_BUFFER);


'use strict';

var $14c7b05570ea7e40$exports = {};
'use strict';

















var $14c7b05570ea7e40$var$enforceInternalState = $419c333d2a5dd5f4$exports.enforce;
var $14c7b05570ea7e40$var$getInternalState = $419c333d2a5dd5f4$exports.get;
var $14c7b05570ea7e40$var$Int8Array = $9be6fcc00ef60f58$exports.Int8Array;
var $14c7b05570ea7e40$var$Int8ArrayPrototype = $14c7b05570ea7e40$var$Int8Array && $14c7b05570ea7e40$var$Int8Array.prototype;
var $14c7b05570ea7e40$var$Uint8ClampedArray = $9be6fcc00ef60f58$exports.Uint8ClampedArray;
var $14c7b05570ea7e40$var$Uint8ClampedArrayPrototype = $14c7b05570ea7e40$var$Uint8ClampedArray && $14c7b05570ea7e40$var$Uint8ClampedArray.prototype;
var $14c7b05570ea7e40$var$TypedArray = $14c7b05570ea7e40$var$Int8Array && $a7c2d1ef948bc294$exports($14c7b05570ea7e40$var$Int8Array);
var $14c7b05570ea7e40$var$TypedArrayPrototype = $14c7b05570ea7e40$var$Int8ArrayPrototype && $a7c2d1ef948bc294$exports($14c7b05570ea7e40$var$Int8ArrayPrototype);
var $14c7b05570ea7e40$var$ObjectPrototype = Object.prototype;
var $14c7b05570ea7e40$var$TypeError = $9be6fcc00ef60f58$exports.TypeError;
var $14c7b05570ea7e40$var$TO_STRING_TAG = $6268abd12745dd3b$exports('toStringTag');
var $14c7b05570ea7e40$var$TYPED_ARRAY_TAG = $a90ea85f631354d3$exports('TYPED_ARRAY_TAG');
var $14c7b05570ea7e40$var$TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor';
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var $14c7b05570ea7e40$var$NATIVE_ARRAY_BUFFER_VIEWS = $3acc1db098119a6d$exports && !!$6a2615bbdaa85242$exports && $4591439421551449$exports($9be6fcc00ef60f58$exports.opera) !== 'Opera';
var $14c7b05570ea7e40$var$TYPED_ARRAY_TAG_REQUIRED = false;
var $14c7b05570ea7e40$var$NAME, $14c7b05570ea7e40$var$Constructor, $14c7b05570ea7e40$var$Prototype;
var $14c7b05570ea7e40$var$TypedArrayConstructorsList = {
    Int8Array: 1,
    Uint8Array: 1,
    Uint8ClampedArray: 1,
    Int16Array: 2,
    Uint16Array: 2,
    Int32Array: 4,
    Uint32Array: 4,
    Float32Array: 4,
    Float64Array: 8
};
var $14c7b05570ea7e40$var$BigIntArrayConstructorsList = {
    BigInt64Array: 8,
    BigUint64Array: 8
};
var $14c7b05570ea7e40$var$isView = function isView(it) {
    if (!$d2d3162bdcc39b88$exports(it)) return false;
    var klass = $4591439421551449$exports(it);
    return klass === 'DataView' || $35cf4bf79fe152cc$exports($14c7b05570ea7e40$var$TypedArrayConstructorsList, klass) || $35cf4bf79fe152cc$exports($14c7b05570ea7e40$var$BigIntArrayConstructorsList, klass);
};
var $14c7b05570ea7e40$var$getTypedArrayConstructor = function getTypedArrayConstructor1(it) {
    var proto = $a7c2d1ef948bc294$exports(it);
    if (!$d2d3162bdcc39b88$exports(proto)) return;
    var state = $14c7b05570ea7e40$var$getInternalState(proto);
    return state && $35cf4bf79fe152cc$exports(state, $14c7b05570ea7e40$var$TYPED_ARRAY_CONSTRUCTOR) ? state[$14c7b05570ea7e40$var$TYPED_ARRAY_CONSTRUCTOR] : $14c7b05570ea7e40$var$getTypedArrayConstructor(proto);
};
var $14c7b05570ea7e40$var$isTypedArray = function isTypedArray(it) {
    if (!$d2d3162bdcc39b88$exports(it)) return false;
    var klass = $4591439421551449$exports(it);
    return $35cf4bf79fe152cc$exports($14c7b05570ea7e40$var$TypedArrayConstructorsList, klass) || $35cf4bf79fe152cc$exports($14c7b05570ea7e40$var$BigIntArrayConstructorsList, klass);
};
var $14c7b05570ea7e40$var$aTypedArray = function aTypedArray(it) {
    if ($14c7b05570ea7e40$var$isTypedArray(it)) return it;
    throw new $14c7b05570ea7e40$var$TypeError('Target is not a typed array');
};
var $14c7b05570ea7e40$var$aTypedArrayConstructor = function aTypedArrayConstructor(C) {
    if ($0a82f0a5368b6870$exports(C) && (!$6a2615bbdaa85242$exports || $bc714f4a9c09d4bd$exports($14c7b05570ea7e40$var$TypedArray, C))) return C;
    throw new $14c7b05570ea7e40$var$TypeError($53c3bf74c3e856bf$exports(C) + ' is not a typed array constructor');
};
var $14c7b05570ea7e40$var$exportTypedArrayMethod = function exportTypedArrayMethod(KEY, property, forced, options) {
    if (!$6ffb7908e83cf36c$exports) return;
    if (forced) for(var ARRAY in $14c7b05570ea7e40$var$TypedArrayConstructorsList){
        var TypedArrayConstructor = $9be6fcc00ef60f58$exports[ARRAY];
        if (TypedArrayConstructor && $35cf4bf79fe152cc$exports(TypedArrayConstructor.prototype, KEY)) try {
            delete TypedArrayConstructor.prototype[KEY];
        } catch (error) {
            // old WebKit bug - some methods are non-configurable
            try {
                TypedArrayConstructor.prototype[KEY] = property;
            } catch (error2) {}
        }
    }
    if (!$14c7b05570ea7e40$var$TypedArrayPrototype[KEY] || forced) $b817bfc251eac07c$exports($14c7b05570ea7e40$var$TypedArrayPrototype, KEY, forced ? property : $14c7b05570ea7e40$var$NATIVE_ARRAY_BUFFER_VIEWS && $14c7b05570ea7e40$var$Int8ArrayPrototype[KEY] || property, options);
};
var $14c7b05570ea7e40$var$exportTypedArrayStaticMethod = function exportTypedArrayStaticMethod(KEY, property, forced) {
    var ARRAY, TypedArrayConstructor;
    if (!$6ffb7908e83cf36c$exports) return;
    if ($6a2615bbdaa85242$exports) {
        if (forced) for(ARRAY in $14c7b05570ea7e40$var$TypedArrayConstructorsList){
            TypedArrayConstructor = $9be6fcc00ef60f58$exports[ARRAY];
            if (TypedArrayConstructor && $35cf4bf79fe152cc$exports(TypedArrayConstructor, KEY)) try {
                delete TypedArrayConstructor[KEY];
            } catch (error) {}
        }
        if (!$14c7b05570ea7e40$var$TypedArray[KEY] || forced) // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
        try {
            return $b817bfc251eac07c$exports($14c7b05570ea7e40$var$TypedArray, KEY, forced ? property : $14c7b05570ea7e40$var$NATIVE_ARRAY_BUFFER_VIEWS && $14c7b05570ea7e40$var$TypedArray[KEY] || property);
        } catch (error) {}
        else return;
    }
    for(ARRAY in $14c7b05570ea7e40$var$TypedArrayConstructorsList){
        TypedArrayConstructor = $9be6fcc00ef60f58$exports[ARRAY];
        if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) $b817bfc251eac07c$exports(TypedArrayConstructor, KEY, property);
    }
};
for($14c7b05570ea7e40$var$NAME in $14c7b05570ea7e40$var$TypedArrayConstructorsList){
    $14c7b05570ea7e40$var$Constructor = $9be6fcc00ef60f58$exports[$14c7b05570ea7e40$var$NAME];
    $14c7b05570ea7e40$var$Prototype = $14c7b05570ea7e40$var$Constructor && $14c7b05570ea7e40$var$Constructor.prototype;
    if ($14c7b05570ea7e40$var$Prototype) $14c7b05570ea7e40$var$enforceInternalState($14c7b05570ea7e40$var$Prototype)[$14c7b05570ea7e40$var$TYPED_ARRAY_CONSTRUCTOR] = $14c7b05570ea7e40$var$Constructor;
    else $14c7b05570ea7e40$var$NATIVE_ARRAY_BUFFER_VIEWS = false;
}
for($14c7b05570ea7e40$var$NAME in $14c7b05570ea7e40$var$BigIntArrayConstructorsList){
    $14c7b05570ea7e40$var$Constructor = $9be6fcc00ef60f58$exports[$14c7b05570ea7e40$var$NAME];
    $14c7b05570ea7e40$var$Prototype = $14c7b05570ea7e40$var$Constructor && $14c7b05570ea7e40$var$Constructor.prototype;
    if ($14c7b05570ea7e40$var$Prototype) $14c7b05570ea7e40$var$enforceInternalState($14c7b05570ea7e40$var$Prototype)[$14c7b05570ea7e40$var$TYPED_ARRAY_CONSTRUCTOR] = $14c7b05570ea7e40$var$Constructor;
}
// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!$14c7b05570ea7e40$var$NATIVE_ARRAY_BUFFER_VIEWS || !$0a82f0a5368b6870$exports($14c7b05570ea7e40$var$TypedArray) || $14c7b05570ea7e40$var$TypedArray === Function.prototype) {
    // eslint-disable-next-line no-shadow -- safe
    $14c7b05570ea7e40$var$TypedArray = function TypedArray() {
        throw new $14c7b05570ea7e40$var$TypeError('Incorrect invocation');
    };
    if ($14c7b05570ea7e40$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        for($14c7b05570ea7e40$var$NAME in $14c7b05570ea7e40$var$TypedArrayConstructorsList)if ($9be6fcc00ef60f58$exports[$14c7b05570ea7e40$var$NAME]) $6a2615bbdaa85242$exports($9be6fcc00ef60f58$exports[$14c7b05570ea7e40$var$NAME], $14c7b05570ea7e40$var$TypedArray);
    }
}
if (!$14c7b05570ea7e40$var$NATIVE_ARRAY_BUFFER_VIEWS || !$14c7b05570ea7e40$var$TypedArrayPrototype || $14c7b05570ea7e40$var$TypedArrayPrototype === $14c7b05570ea7e40$var$ObjectPrototype) {
    $14c7b05570ea7e40$var$TypedArrayPrototype = $14c7b05570ea7e40$var$TypedArray.prototype;
    if ($14c7b05570ea7e40$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        for($14c7b05570ea7e40$var$NAME in $14c7b05570ea7e40$var$TypedArrayConstructorsList)if ($9be6fcc00ef60f58$exports[$14c7b05570ea7e40$var$NAME]) $6a2615bbdaa85242$exports($9be6fcc00ef60f58$exports[$14c7b05570ea7e40$var$NAME].prototype, $14c7b05570ea7e40$var$TypedArrayPrototype);
    }
}
// WebKit bug - one more object in Uint8ClampedArray prototype chain
if ($14c7b05570ea7e40$var$NATIVE_ARRAY_BUFFER_VIEWS && $a7c2d1ef948bc294$exports($14c7b05570ea7e40$var$Uint8ClampedArrayPrototype) !== $14c7b05570ea7e40$var$TypedArrayPrototype) $6a2615bbdaa85242$exports($14c7b05570ea7e40$var$Uint8ClampedArrayPrototype, $14c7b05570ea7e40$var$TypedArrayPrototype);
if ($6ffb7908e83cf36c$exports && !$35cf4bf79fe152cc$exports($14c7b05570ea7e40$var$TypedArrayPrototype, $14c7b05570ea7e40$var$TO_STRING_TAG)) {
    $14c7b05570ea7e40$var$TYPED_ARRAY_TAG_REQUIRED = true;
    $6de7996ceea81cf8$exports($14c7b05570ea7e40$var$TypedArrayPrototype, $14c7b05570ea7e40$var$TO_STRING_TAG, {
        configurable: true,
        get: function get() {
            return $d2d3162bdcc39b88$exports(this) ? this[$14c7b05570ea7e40$var$TYPED_ARRAY_TAG] : undefined;
        }
    });
    for($14c7b05570ea7e40$var$NAME in $14c7b05570ea7e40$var$TypedArrayConstructorsList)if ($9be6fcc00ef60f58$exports[$14c7b05570ea7e40$var$NAME]) $5b5bc07d688591ac$exports($9be6fcc00ef60f58$exports[$14c7b05570ea7e40$var$NAME], $14c7b05570ea7e40$var$TYPED_ARRAY_TAG, $14c7b05570ea7e40$var$NAME);
}
$14c7b05570ea7e40$exports = {
    NATIVE_ARRAY_BUFFER_VIEWS: $14c7b05570ea7e40$var$NATIVE_ARRAY_BUFFER_VIEWS,
    TYPED_ARRAY_TAG: $14c7b05570ea7e40$var$TYPED_ARRAY_TAG_REQUIRED && $14c7b05570ea7e40$var$TYPED_ARRAY_TAG,
    aTypedArray: $14c7b05570ea7e40$var$aTypedArray,
    aTypedArrayConstructor: $14c7b05570ea7e40$var$aTypedArrayConstructor,
    exportTypedArrayMethod: $14c7b05570ea7e40$var$exportTypedArrayMethod,
    exportTypedArrayStaticMethod: $14c7b05570ea7e40$var$exportTypedArrayStaticMethod,
    getTypedArrayConstructor: $14c7b05570ea7e40$var$getTypedArrayConstructor,
    isView: $14c7b05570ea7e40$var$isView,
    isTypedArray: $14c7b05570ea7e40$var$isTypedArray,
    TypedArray: $14c7b05570ea7e40$var$TypedArray,
    TypedArrayPrototype: $14c7b05570ea7e40$var$TypedArrayPrototype
};


var $8d61581297158cad$var$NATIVE_ARRAY_BUFFER_VIEWS = $14c7b05570ea7e40$exports.NATIVE_ARRAY_BUFFER_VIEWS;
// `ArrayBuffer.isView` method
// https://tc39.es/ecma262/#sec-arraybuffer.isview
$500d5d8b5806b834$exports({
    target: 'ArrayBuffer',
    stat: true,
    forced: !$8d61581297158cad$var$NATIVE_ARRAY_BUFFER_VIEWS
}, {
    isView: $14c7b05570ea7e40$exports.isView
});


'use strict';







var $f6bdc82218f8f454$var$ArrayBuffer = $e070b599b2ed132d$exports.ArrayBuffer;
var $f6bdc82218f8f454$var$DataView = $e070b599b2ed132d$exports.DataView;
var $f6bdc82218f8f454$var$DataViewPrototype = $f6bdc82218f8f454$var$DataView.prototype;
var $f6bdc82218f8f454$var$nativeArrayBufferSlice = $010fa6fc9394de19$exports($f6bdc82218f8f454$var$ArrayBuffer.prototype.slice);
var $f6bdc82218f8f454$var$getUint8 = $010fa6fc9394de19$exports($f6bdc82218f8f454$var$DataViewPrototype.getUint8);
var $f6bdc82218f8f454$var$setUint8 = $010fa6fc9394de19$exports($f6bdc82218f8f454$var$DataViewPrototype.setUint8);
var $f6bdc82218f8f454$var$INCORRECT_SLICE = $06c7d56a730e31f1$exports(function() {
    return !new $f6bdc82218f8f454$var$ArrayBuffer(2).slice(1, undefined).byteLength;
});
// `ArrayBuffer.prototype.slice` method
// https://tc39.es/ecma262/#sec-arraybuffer.prototype.slice
$500d5d8b5806b834$exports({
    target: 'ArrayBuffer',
    proto: true,
    unsafe: true,
    forced: $f6bdc82218f8f454$var$INCORRECT_SLICE
}, {
    slice: function slice(start, end) {
        if ($f6bdc82218f8f454$var$nativeArrayBufferSlice && end === undefined) return $f6bdc82218f8f454$var$nativeArrayBufferSlice($05718fce3232bc84$exports(this), start); // FF fix
        var length = $05718fce3232bc84$exports(this).byteLength;
        var first = $d78d48da15e9c8eb$exports(start, length);
        var fin = $d78d48da15e9c8eb$exports(end === undefined ? length : end, length);
        var result = new $f6bdc82218f8f454$var$ArrayBuffer($d14e7a9632dda07a$exports(fin - first));
        var viewSource = new $f6bdc82218f8f454$var$DataView(this);
        var viewTarget = new $f6bdc82218f8f454$var$DataView(result);
        var index = 0;
        while(first < fin)$f6bdc82218f8f454$var$setUint8(viewTarget, index++, $f6bdc82218f8f454$var$getUint8(viewSource, first++));
        return result;
    }
});


'use strict';
'use strict';



// `DataView` constructor
// https://tc39.es/ecma262/#sec-dataview-constructor
$500d5d8b5806b834$exports({
    global: true,
    constructor: true,
    forced: !$3acc1db098119a6d$exports
}, {
    DataView: $e070b599b2ed132d$exports.DataView
});




'use strict';


var $a13b99f4484f0239$var$$Date = Date;
var $a13b99f4484f0239$var$thisTimeValue = $1689570c06db508b$exports($a13b99f4484f0239$var$$Date.prototype.getTime);
// `Date.now` method
// https://tc39.es/ecma262/#sec-date.now
$500d5d8b5806b834$exports({
    target: 'Date',
    stat: true
}, {
    now: function now() {
        return $a13b99f4484f0239$var$thisTimeValue(new $a13b99f4484f0239$var$$Date());
    }
});


'use strict';

var $88d2bbcc8aadb897$exports = {};
'use strict';


var $66aebd71bf9ba548$exports = {};
'use strict';



var $05ac5542bb716171$exports = {};
'use strict';



var $05ac5542bb716171$var$$RangeError = RangeError;
// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
$05ac5542bb716171$exports = function repeat(count) {
    var str = $f4fff477af530dca$exports($fdf84a64c2f63ac3$exports(this));
    var result = '';
    var n = $4508997bd0ba9879$exports(count);
    if (n < 0 || n === Infinity) throw new $05ac5542bb716171$var$$RangeError('Wrong number of repetitions');
    for(; n > 0; (n >>>= 1) && (str += str))if (n & 1) result += str;
    return result;
};



var $66aebd71bf9ba548$var$repeat = $1689570c06db508b$exports($05ac5542bb716171$exports);
var $66aebd71bf9ba548$var$stringSlice = $1689570c06db508b$exports(''.slice);
var $66aebd71bf9ba548$var$ceil = Math.ceil;
// `String.prototype.{ padStart, padEnd }` methods implementation
var $66aebd71bf9ba548$var$createMethod = function createMethod(IS_END) {
    return function($this, maxLength, fillString) {
        var S = $f4fff477af530dca$exports($fdf84a64c2f63ac3$exports($this));
        var intMaxLength = $d14e7a9632dda07a$exports(maxLength);
        var stringLength = S.length;
        var fillStr = fillString === undefined ? ' ' : $f4fff477af530dca$exports(fillString);
        var fillLen, stringFiller;
        if (intMaxLength <= stringLength || fillStr === '') return S;
        fillLen = intMaxLength - stringLength;
        stringFiller = $66aebd71bf9ba548$var$repeat(fillStr, $66aebd71bf9ba548$var$ceil(fillLen / fillStr.length));
        if (stringFiller.length > fillLen) stringFiller = $66aebd71bf9ba548$var$stringSlice(stringFiller, 0, fillLen);
        return IS_END ? S + stringFiller : stringFiller + S;
    };
};
$66aebd71bf9ba548$exports = {
    // `String.prototype.padStart` method
    // https://tc39.es/ecma262/#sec-string.prototype.padstart
    start: $66aebd71bf9ba548$var$createMethod(false),
    // `String.prototype.padEnd` method
    // https://tc39.es/ecma262/#sec-string.prototype.padend
    end: $66aebd71bf9ba548$var$createMethod(true)
};


var $88d2bbcc8aadb897$require$padStart = $66aebd71bf9ba548$exports.start;
var $88d2bbcc8aadb897$var$$RangeError = RangeError;
var $88d2bbcc8aadb897$var$$isFinite = isFinite;
var $88d2bbcc8aadb897$var$abs = Math.abs;
var $88d2bbcc8aadb897$var$DatePrototype = Date.prototype;
var $88d2bbcc8aadb897$var$nativeDateToISOString = $88d2bbcc8aadb897$var$DatePrototype.toISOString;
var $88d2bbcc8aadb897$var$thisTimeValue = $1689570c06db508b$exports($88d2bbcc8aadb897$var$DatePrototype.getTime);
var $88d2bbcc8aadb897$var$getUTCDate = $1689570c06db508b$exports($88d2bbcc8aadb897$var$DatePrototype.getUTCDate);
var $88d2bbcc8aadb897$var$getUTCFullYear = $1689570c06db508b$exports($88d2bbcc8aadb897$var$DatePrototype.getUTCFullYear);
var $88d2bbcc8aadb897$var$getUTCHours = $1689570c06db508b$exports($88d2bbcc8aadb897$var$DatePrototype.getUTCHours);
var $88d2bbcc8aadb897$var$getUTCMilliseconds = $1689570c06db508b$exports($88d2bbcc8aadb897$var$DatePrototype.getUTCMilliseconds);
var $88d2bbcc8aadb897$var$getUTCMinutes = $1689570c06db508b$exports($88d2bbcc8aadb897$var$DatePrototype.getUTCMinutes);
var $88d2bbcc8aadb897$var$getUTCMonth = $1689570c06db508b$exports($88d2bbcc8aadb897$var$DatePrototype.getUTCMonth);
var $88d2bbcc8aadb897$var$getUTCSeconds = $1689570c06db508b$exports($88d2bbcc8aadb897$var$DatePrototype.getUTCSeconds);
// `Date.prototype.toISOString` method implementation
// https://tc39.es/ecma262/#sec-date.prototype.toisostring
// PhantomJS / old WebKit fails here:
$88d2bbcc8aadb897$exports = $06c7d56a730e31f1$exports(function() {
    return $88d2bbcc8aadb897$var$nativeDateToISOString.call(new Date(-50000000000000 - 1)) !== '0385-07-25T07:06:39.999Z';
}) || !$06c7d56a730e31f1$exports(function() {
    $88d2bbcc8aadb897$var$nativeDateToISOString.call(new Date(NaN));
}) ? function toISOString() {
    if (!$88d2bbcc8aadb897$var$$isFinite($88d2bbcc8aadb897$var$thisTimeValue(this))) throw new $88d2bbcc8aadb897$var$$RangeError('Invalid time value');
    var date = this;
    var year = $88d2bbcc8aadb897$var$getUTCFullYear(date);
    var milliseconds = $88d2bbcc8aadb897$var$getUTCMilliseconds(date);
    var sign = year < 0 ? '-' : year > 9999 ? '+' : '';
    return sign + $88d2bbcc8aadb897$require$padStart($88d2bbcc8aadb897$var$abs(year), sign ? 6 : 4, 0) + '-' + $88d2bbcc8aadb897$require$padStart($88d2bbcc8aadb897$var$getUTCMonth(date) + 1, 2, 0) + '-' + $88d2bbcc8aadb897$require$padStart($88d2bbcc8aadb897$var$getUTCDate(date), 2, 0) + 'T' + $88d2bbcc8aadb897$require$padStart($88d2bbcc8aadb897$var$getUTCHours(date), 2, 0) + ':' + $88d2bbcc8aadb897$require$padStart($88d2bbcc8aadb897$var$getUTCMinutes(date), 2, 0) + ':' + $88d2bbcc8aadb897$require$padStart($88d2bbcc8aadb897$var$getUTCSeconds(date), 2, 0) + '.' + $88d2bbcc8aadb897$require$padStart(milliseconds, 3, 0) + 'Z';
} : $88d2bbcc8aadb897$var$nativeDateToISOString;


// `Date.prototype.toISOString` method
// https://tc39.es/ecma262/#sec-date.prototype.toisostring
// PhantomJS / old WebKit has a broken implementations
$500d5d8b5806b834$exports({
    target: 'Date',
    proto: true,
    forced: Date.prototype.toISOString !== $88d2bbcc8aadb897$exports
}, {
    toISOString: $88d2bbcc8aadb897$exports
});


'use strict';




var $29227ba6203c092f$var$FORCED = $06c7d56a730e31f1$exports(function() {
    return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({
        toISOString: function toISOString() {
            return 1;
        }
    }) !== 1;
});
// `Date.prototype.toJSON` method
// https://tc39.es/ecma262/#sec-date.prototype.tojson
$500d5d8b5806b834$exports({
    target: 'Date',
    proto: true,
    arity: 1,
    forced: $29227ba6203c092f$var$FORCED
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    toJSON: function toJSON(key) {
        var O = $ec839b558eb5dcf4$exports(this);
        var pv = $50b25b11d61908fe$exports(O, 'number');
        return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
    }
});


'use strict';


var $957a271dafdefb78$exports = {};
'use strict';


var $957a271dafdefb78$var$$TypeError = TypeError;
// `Date.prototype[@@toPrimitive](hint)` method implementation
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
$957a271dafdefb78$exports = function(hint) {
    $05718fce3232bc84$exports(this);
    if (hint === 'string' || hint === 'default') hint = 'string';
    else if (hint !== 'number') throw new $957a271dafdefb78$var$$TypeError('Incorrect hint');
    return $3625f92b2265aab4$exports(this, hint);
};



var $3282082f0aa795a2$var$TO_PRIMITIVE = $6268abd12745dd3b$exports('toPrimitive');
var $3282082f0aa795a2$var$DatePrototype = Date.prototype;
// `Date.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
if (!$35cf4bf79fe152cc$exports($3282082f0aa795a2$var$DatePrototype, $3282082f0aa795a2$var$TO_PRIMITIVE)) $b817bfc251eac07c$exports($3282082f0aa795a2$var$DatePrototype, $3282082f0aa795a2$var$TO_PRIMITIVE, $957a271dafdefb78$exports);


'use strict';


var $a9d8e4940158e42e$var$DatePrototype = Date.prototype;
var $a9d8e4940158e42e$var$INVALID_DATE = 'Invalid Date';
var $a9d8e4940158e42e$var$TO_STRING = 'toString';
var $a9d8e4940158e42e$var$nativeDateToString = $1689570c06db508b$exports($a9d8e4940158e42e$var$DatePrototype[$a9d8e4940158e42e$var$TO_STRING]);
var $a9d8e4940158e42e$var$thisTimeValue = $1689570c06db508b$exports($a9d8e4940158e42e$var$DatePrototype.getTime);
// `Date.prototype.toString` method
// https://tc39.es/ecma262/#sec-date.prototype.tostring
if (String(new Date(NaN)) !== $a9d8e4940158e42e$var$INVALID_DATE) $b817bfc251eac07c$exports($a9d8e4940158e42e$var$DatePrototype, $a9d8e4940158e42e$var$TO_STRING, function toString() {
    var value = $a9d8e4940158e42e$var$thisTimeValue(this);
    // eslint-disable-next-line no-self-compare -- NaN check
    return value === value ? $a9d8e4940158e42e$var$nativeDateToString(this) : $a9d8e4940158e42e$var$INVALID_DATE;
});


'use strict';

var $c0a1456e067c4c2e$exports = {};
'use strict';






var $c0a1456e067c4c2e$var$$Function = Function;
var $c0a1456e067c4c2e$var$concat = $1689570c06db508b$exports([].concat);
var $c0a1456e067c4c2e$var$join = $1689570c06db508b$exports([].join);
var $c0a1456e067c4c2e$var$factories = {};
var $c0a1456e067c4c2e$var$construct = function construct(C, argsLength, args) {
    if (!$35cf4bf79fe152cc$exports($c0a1456e067c4c2e$var$factories, argsLength)) {
        var list = [];
        var i = 0;
        for(; i < argsLength; i++)list[i] = 'a[' + i + ']';
        $c0a1456e067c4c2e$var$factories[argsLength] = $c0a1456e067c4c2e$var$$Function('C,a', 'return new C(' + $c0a1456e067c4c2e$var$join(list, ',') + ')');
    }
    return $c0a1456e067c4c2e$var$factories[argsLength](C, args);
};
// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
$c0a1456e067c4c2e$exports = $0945d194f6c2c4f6$exports ? $c0a1456e067c4c2e$var$$Function.bind : function bind(that /* , ...args */ ) {
    var F = $c976080d379e828f$exports(this);
    var Prototype = F.prototype;
    var partArgs = $65dcb7b8ed29ae22$exports(arguments, 1);
    var boundFunction = function bound() {
        var args = $c0a1456e067c4c2e$var$concat(partArgs, $65dcb7b8ed29ae22$exports(arguments));
        return this instanceof boundFunction ? $c0a1456e067c4c2e$var$construct(F, args.length, args) : F.apply(that, args);
    };
    if ($d2d3162bdcc39b88$exports(Prototype)) boundFunction.prototype = Prototype;
    return boundFunction;
};


// `Function.prototype.bind` method
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
$500d5d8b5806b834$exports({
    target: 'Function',
    proto: true,
    forced: Function.bind !== $c0a1456e067c4c2e$exports
}, {
    bind: $c0a1456e067c4c2e$exports
});


'use strict';






var $76e711cf267f372b$var$HAS_INSTANCE = $6268abd12745dd3b$exports('hasInstance');
var $76e711cf267f372b$var$FunctionPrototype = Function.prototype;
// `Function.prototype[@@hasInstance]` method
// https://tc39.es/ecma262/#sec-function.prototype-@@hasinstance
if (!($76e711cf267f372b$var$HAS_INSTANCE in $76e711cf267f372b$var$FunctionPrototype)) $23cff59c96aeab90$export$2d1720544b23b823($76e711cf267f372b$var$FunctionPrototype, $76e711cf267f372b$var$HAS_INSTANCE, {
    value: $6df183f9a20e2a35$exports(function(O) {
        if (!$0a82f0a5368b6870$exports(this) || !$d2d3162bdcc39b88$exports(O)) return false;
        var P = this.prototype;
        return $d2d3162bdcc39b88$exports(P) ? $bc714f4a9c09d4bd$exports(P, O) : O instanceof this;
    }, $76e711cf267f372b$var$HAS_INSTANCE)
});


'use strict';


var $474a73c2eea9e38c$require$FUNCTION_NAME_EXISTS = $61a1b81c88c8f190$exports.EXISTS;


var $474a73c2eea9e38c$var$FunctionPrototype = Function.prototype;
var $474a73c2eea9e38c$var$functionToString = $1689570c06db508b$exports($474a73c2eea9e38c$var$FunctionPrototype.toString);
var $474a73c2eea9e38c$var$nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var $474a73c2eea9e38c$var$regExpExec = $1689570c06db508b$exports($474a73c2eea9e38c$var$nameRE.exec);
var $474a73c2eea9e38c$var$NAME = 'name';
// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if ($6ffb7908e83cf36c$exports && !$474a73c2eea9e38c$require$FUNCTION_NAME_EXISTS) $6de7996ceea81cf8$exports($474a73c2eea9e38c$var$FunctionPrototype, $474a73c2eea9e38c$var$NAME, {
    configurable: true,
    get: function get() {
        try {
            return $474a73c2eea9e38c$var$regExpExec($474a73c2eea9e38c$var$nameRE, $474a73c2eea9e38c$var$functionToString(this))[1];
        } catch (error) {
            return '';
        }
    }
});


'use strict';


// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
$be9d27c6f3178ed3$exports($9be6fcc00ef60f58$exports.JSON, 'JSON', true);


'use strict';
'use strict';
var $a78fa382baf6bf1e$exports = {};
'use strict';





var $24ac99e13d26c138$exports = {};

var $qb7pP = parcelRequire("qb7pP");
'use strict';






var $24ac99e13d26c138$require$defineProperty = $23cff59c96aeab90$export$2d1720544b23b823;


var $57bd68525637913a$exports = {};
'use strict';



var $e8872ee40e374557$exports = {};
'use strict';

$e8872ee40e374557$exports = $06c7d56a730e31f1$exports(function() {
    if (typeof ArrayBuffer == 'function') {
        var buffer = new ArrayBuffer(8);
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
        if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', {
            value: 8
        });
    }
});


// eslint-disable-next-line es/no-object-isextensible -- safe
var $57bd68525637913a$var$$isExtensible = Object.isExtensible;
var $57bd68525637913a$var$FAILS_ON_PRIMITIVES = $06c7d56a730e31f1$exports(function() {
    $57bd68525637913a$var$$isExtensible(1);
});
// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
$57bd68525637913a$exports = $57bd68525637913a$var$FAILS_ON_PRIMITIVES || $e8872ee40e374557$exports ? function isExtensible(it) {
    if (!$d2d3162bdcc39b88$exports(it)) return false;
    if ($e8872ee40e374557$exports && $9afeb253af368f01$exports(it) === 'ArrayBuffer') return false;
    return $57bd68525637913a$var$$isExtensible ? $57bd68525637913a$var$$isExtensible(it) : true;
} : $57bd68525637913a$var$$isExtensible;



var $dd70d49b1cfa63a3$exports = {};
'use strict';

$dd70d49b1cfa63a3$exports = !$06c7d56a730e31f1$exports(function() {
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
    return Object.isExtensible(Object.preventExtensions({}));
});


var $24ac99e13d26c138$var$REQUIRED = false;
var $24ac99e13d26c138$var$METADATA = $a90ea85f631354d3$exports('meta');
var $24ac99e13d26c138$var$id = 0;
var $24ac99e13d26c138$var$setMetadata = function setMetadata(it) {
    $24ac99e13d26c138$require$defineProperty(it, $24ac99e13d26c138$var$METADATA, {
        value: {
            objectID: 'O' + $24ac99e13d26c138$var$id++,
            weakData: {} // weak collections IDs
        }
    });
};
var $24ac99e13d26c138$var$fastKey = function fastKey(it, create) {
    // return a primitive with prefix
    if (!$d2d3162bdcc39b88$exports(it)) return (typeof it === "undefined" ? "undefined" : (0, $qb7pP._)(it)) == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$35cf4bf79fe152cc$exports(it, $24ac99e13d26c138$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$57bd68525637913a$exports(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $24ac99e13d26c138$var$setMetadata(it);
    // return object ID
    }
    return it[$24ac99e13d26c138$var$METADATA].objectID;
};
var $24ac99e13d26c138$var$getWeakData = function getWeakData(it, create) {
    if (!$35cf4bf79fe152cc$exports(it, $24ac99e13d26c138$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$57bd68525637913a$exports(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $24ac99e13d26c138$var$setMetadata(it);
    // return the store of weak collections IDs
    }
    return it[$24ac99e13d26c138$var$METADATA].weakData;
};
// add metadata on freeze-family methods calling
var $24ac99e13d26c138$var$onFreeze = function onFreeze(it) {
    if ($dd70d49b1cfa63a3$exports && $24ac99e13d26c138$var$REQUIRED && $57bd68525637913a$exports(it) && !$35cf4bf79fe152cc$exports(it, $24ac99e13d26c138$var$METADATA)) $24ac99e13d26c138$var$setMetadata(it);
    return it;
};
var $24ac99e13d26c138$var$enable = function enable() {
    $24ac99e13d26c138$var$meta.enable = function() {};
    $24ac99e13d26c138$var$REQUIRED = true;
    var getOwnPropertyNames = $13520dff9cf61e9d$export$2d1720544b23b823;
    var splice = $1689570c06db508b$exports([].splice);
    var test = {};
    test[$24ac99e13d26c138$var$METADATA] = 1;
    // prevent exposing of metadata key
    if (getOwnPropertyNames(test).length) {
        $13520dff9cf61e9d$exports.f = function(it) {
            var result = getOwnPropertyNames(it);
            for(var i = 0, length = result.length; i < length; i++)if (result[i] === $24ac99e13d26c138$var$METADATA) {
                splice(result, i, 1);
                break;
            }
            return result;
        };
        $500d5d8b5806b834$exports({
            target: 'Object',
            stat: true,
            forced: true
        }, {
            getOwnPropertyNames: $226371c2c18604cf$export$2d1720544b23b823
        });
    }
};
var $24ac99e13d26c138$var$meta = $24ac99e13d26c138$exports = {
    enable: $24ac99e13d26c138$var$enable,
    fastKey: $24ac99e13d26c138$var$fastKey,
    getWeakData: $24ac99e13d26c138$var$getWeakData,
    onFreeze: $24ac99e13d26c138$var$onFreeze
};
$37c7d807d8aa31e8$exports[$24ac99e13d26c138$var$METADATA] = true;


var $6244c42639c04860$exports = {};

var $qb7pP = parcelRequire("qb7pP");
'use strict';










var $6244c42639c04860$var$$TypeError = TypeError;
var $6244c42639c04860$var$Result = function Result(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $6244c42639c04860$var$ResultPrototype = $6244c42639c04860$var$Result.prototype;
$6244c42639c04860$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $847280b2cf36c2e0$exports(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function stop(condition) {
        if (iterator) $714e512e384bcced$exports(iterator, 'normal', condition);
        return new $6244c42639c04860$var$Result(true, condition);
    };
    var callFn = function callFn(value) {
        if (AS_ENTRIES) {
            $05718fce3232bc84$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $b7a9a1ef631e02cb$exports(iterable);
        if (!iterFn) throw new $6244c42639c04860$var$$TypeError($53c3bf74c3e856bf$exports(iterable) + ' is not iterable');
        // optimisation for array iterators
        if ($bac9daed9328b5c0$exports(iterFn)) {
            for(index = 0, length = $f91b2cfe2e3f959b$exports(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $bc714f4a9c09d4bd$exports($6244c42639c04860$var$ResultPrototype, result)) return result;
            }
            return new $6244c42639c04860$var$Result(false);
        }
        iterator = $e16d366978e3a98b$exports(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $e3ebd8cb7f512f74$exports(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $714e512e384bcced$exports(iterator, 'throw', error);
        }
        if ((typeof result === "undefined" ? "undefined" : (0, $qb7pP._)(result)) == 'object' && result && $bc714f4a9c09d4bd$exports($6244c42639c04860$var$ResultPrototype, result)) return result;
    }
    return new $6244c42639c04860$var$Result(false);
};










$a78fa382baf6bf1e$exports = function(CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
    var ADDER = IS_MAP ? 'set' : 'add';
    var NativeConstructor = $9be6fcc00ef60f58$exports[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var Constructor = NativeConstructor;
    var exported = {};
    var fixMethod = function fixMethod(KEY) {
        var uncurriedNativeMethod = $1689570c06db508b$exports(NativePrototype[KEY]);
        $b817bfc251eac07c$exports(NativePrototype, KEY, KEY === 'add' ? function add(value) {
            uncurriedNativeMethod(this, value === 0 ? 0 : value);
            return this;
        } : KEY === 'delete' ? function(key) {
            return IS_WEAK && !$d2d3162bdcc39b88$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === 'get' ? function get(key) {
            return IS_WEAK && !$d2d3162bdcc39b88$exports(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === 'has' ? function has(key) {
            return IS_WEAK && !$d2d3162bdcc39b88$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : function set(key, value) {
            uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
            return this;
        });
    };
    var REPLACE = $1aa429f267e7bd69$exports(CONSTRUCTOR_NAME, !$0a82f0a5368b6870$exports(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !$06c7d56a730e31f1$exports(function() {
        new NativeConstructor().entries().next();
    })));
    if (REPLACE) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        $24ac99e13d26c138$exports.enable();
    } else if ($1aa429f267e7bd69$exports(CONSTRUCTOR_NAME, true)) {
        var instance = new Constructor();
        // early implementations not supports chaining
        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) !== instance;
        // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
        var THROWS_ON_PRIMITIVES = $06c7d56a730e31f1$exports(function() {
            instance.has(1);
        });
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        // eslint-disable-next-line no-new -- required for testing
        var ACCEPT_ITERABLES = $02438b0b93cfa696$exports(function(iterable) {
            new NativeConstructor(iterable);
        });
        // for early implementations -0 and +0 not the same
        var BUGGY_ZERO = !IS_WEAK && $06c7d56a730e31f1$exports(function() {
            // V8 ~ Chromium 42- fails only with 5+ elements
            var $instance = new NativeConstructor();
            var index = 5;
            while(index--)$instance[ADDER](index, index);
            return !$instance.has(-0);
        });
        if (!ACCEPT_ITERABLES) {
            Constructor = wrapper(function(dummy, iterable) {
                $65f23bed46afab45$exports(dummy, NativePrototype);
                var that = $8388ec23a46a9286$exports(new NativeConstructor(), dummy, Constructor);
                if (!$8d82b0b487ce9bb5$exports(iterable)) $6244c42639c04860$exports(iterable, that[ADDER], {
                    that: that,
                    AS_ENTRIES: IS_MAP
                });
                return that;
            });
            Constructor.prototype = NativePrototype;
            NativePrototype.constructor = Constructor;
        }
        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod('delete');
            fixMethod('has');
            IS_MAP && fixMethod('get');
        }
        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
        // weak collections should not contains .clear method
        if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
    }
    exported[CONSTRUCTOR_NAME] = Constructor;
    $500d5d8b5806b834$exports({
        global: true,
        constructor: true,
        forced: Constructor !== NativeConstructor
    }, exported);
    $be9d27c6f3178ed3$exports(Constructor, CONSTRUCTOR_NAME);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
};


var $1ab4cd3abd7ac36a$exports = {};
'use strict';












var $1ab4cd3abd7ac36a$require$fastKey = $24ac99e13d26c138$exports.fastKey;

var $1ab4cd3abd7ac36a$var$setInternalState = $419c333d2a5dd5f4$exports.set;
var $1ab4cd3abd7ac36a$var$internalStateGetterFor = $419c333d2a5dd5f4$exports.getterFor;
$1ab4cd3abd7ac36a$exports = {
    getConstructor: function getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $65f23bed46afab45$exports(that, Prototype);
            $1ab4cd3abd7ac36a$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                index: $c8a7d59657e3f14b$exports(null),
                first: null,
                last: null,
                size: 0
            });
            if (!$6ffb7908e83cf36c$exports) that.size = 0;
            if (!$8d82b0b487ce9bb5$exports(iterable)) $6244c42639c04860$exports(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $1ab4cd3abd7ac36a$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function define(that, key, value) {
            var state = getInternalState(that);
            var entry = getEntry(that, key);
            var previous, index;
            // change existing entry
            if (entry) entry.value = value;
            else {
                state.last = entry = {
                    index: index = $1ab4cd3abd7ac36a$require$fastKey(key, true),
                    key: key,
                    value: value,
                    previous: previous = state.last,
                    next: null,
                    removed: false
                };
                if (!state.first) state.first = entry;
                if (previous) previous.next = entry;
                if ($6ffb7908e83cf36c$exports) state.size++;
                else that.size++;
                // add to index
                if (index !== 'F') state.index[index] = entry;
            }
            return that;
        };
        var getEntry = function getEntry(that, key) {
            var state = getInternalState(that);
            // fast case
            var index = $1ab4cd3abd7ac36a$require$fastKey(key);
            var entry;
            if (index !== 'F') return state.index[index];
            // frozen object case
            for(entry = state.first; entry; entry = entry.next){
                if (entry.key === key) return entry;
            }
        };
        $7ad1d749b941a26e$exports(Prototype, {
            // `{ Map, Set }.prototype.clear()` methods
            // https://tc39.es/ecma262/#sec-map.prototype.clear
            // https://tc39.es/ecma262/#sec-set.prototype.clear
            clear: function clear() {
                var that = this;
                var state = getInternalState(that);
                var entry = state.first;
                while(entry){
                    entry.removed = true;
                    if (entry.previous) entry.previous = entry.previous.next = null;
                    entry = entry.next;
                }
                state.first = state.last = null;
                state.index = $c8a7d59657e3f14b$exports(null);
                if ($6ffb7908e83cf36c$exports) state.size = 0;
                else that.size = 0;
            },
            // `{ Map, Set }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.delete
            // https://tc39.es/ecma262/#sec-set.prototype.delete
            'delete': function(key) {
                var that = this;
                var state = getInternalState(that);
                var entry = getEntry(that, key);
                if (entry) {
                    var next = entry.next;
                    var prev = entry.previous;
                    delete state.index[entry.index];
                    entry.removed = true;
                    if (prev) prev.next = next;
                    if (next) next.previous = prev;
                    if (state.first === entry) state.first = next;
                    if (state.last === entry) state.last = prev;
                    if ($6ffb7908e83cf36c$exports) state.size--;
                    else that.size--;
                }
                return !!entry;
            },
            // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.foreach
            // https://tc39.es/ecma262/#sec-set.prototype.foreach
            forEach: function forEach(callbackfn /* , that = undefined */ ) {
                var state = getInternalState(this);
                var boundFunction = $847280b2cf36c2e0$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                var entry;
                while(entry = entry ? entry.next : state.first){
                    boundFunction(entry.value, entry.key, this);
                    // revert to the last existing entry
                    while(entry && entry.removed)entry = entry.previous;
                }
            },
            // `{ Map, Set}.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.has
            // https://tc39.es/ecma262/#sec-set.prototype.has
            has: function has(key) {
                return !!getEntry(this, key);
            }
        });
        $7ad1d749b941a26e$exports(Prototype, IS_MAP ? {
            // `Map.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-map.prototype.get
            get: function get(key) {
                var entry = getEntry(this, key);
                return entry && entry.value;
            },
            // `Map.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-map.prototype.set
            set: function set(key, value) {
                return define(this, key === 0 ? 0 : key, value);
            }
        } : {
            // `Set.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-set.prototype.add
            add: function add(value) {
                return define(this, value = value === 0 ? 0 : value, value);
            }
        });
        if ($6ffb7908e83cf36c$exports) $6de7996ceea81cf8$exports(Prototype, 'size', {
            configurable: true,
            get: function get() {
                return getInternalState(this).size;
            }
        });
        return Constructor;
    },
    setStrong: function setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP) {
        var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
        var getInternalCollectionState = $1ab4cd3abd7ac36a$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var getInternalIteratorState = $1ab4cd3abd7ac36a$var$internalStateGetterFor(ITERATOR_NAME);
        // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
        // https://tc39.es/ecma262/#sec-map.prototype.entries
        // https://tc39.es/ecma262/#sec-map.prototype.keys
        // https://tc39.es/ecma262/#sec-map.prototype.values
        // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
        // https://tc39.es/ecma262/#sec-set.prototype.entries
        // https://tc39.es/ecma262/#sec-set.prototype.keys
        // https://tc39.es/ecma262/#sec-set.prototype.values
        // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
        $29372d36a55fcc4a$exports(Constructor, CONSTRUCTOR_NAME, function(iterated, kind) {
            $1ab4cd3abd7ac36a$var$setInternalState(this, {
                type: ITERATOR_NAME,
                target: iterated,
                state: getInternalCollectionState(iterated),
                kind: kind,
                last: null
            });
        }, function() {
            var state = getInternalIteratorState(this);
            var kind = state.kind;
            var entry = state.last;
            // revert to the last existing entry
            while(entry && entry.removed)entry = entry.previous;
            // get next entry
            if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
                // or finish the iteration
                state.target = null;
                return $e026e44558cad06d$exports(undefined, true);
            }
            // return step by kind
            if (kind === 'keys') return $e026e44558cad06d$exports(entry.key, false);
            if (kind === 'values') return $e026e44558cad06d$exports(entry.value, false);
            return $e026e44558cad06d$exports([
                entry.key,
                entry.value
            ], false);
        }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
        // `{ Map, Set }.prototype[@@species]` accessors
        // https://tc39.es/ecma262/#sec-get-map-@@species
        // https://tc39.es/ecma262/#sec-get-set-@@species
        $8db167be81e78b6c$exports(CONSTRUCTOR_NAME);
    }
};


// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
$a78fa382baf6bf1e$exports('Map', function(init) {
    return function Map() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $1ab4cd3abd7ac36a$exports);




'use strict';

var $e822c6dcdaca97a4$exports = {};
'use strict';
var $e822c6dcdaca97a4$var$log = Math.log;
// `Math.log1p` method implementation
// https://tc39.es/ecma262/#sec-math.log1p
// eslint-disable-next-line es/no-math-log1p -- safe
$e822c6dcdaca97a4$exports = Math.log1p || function log1p(x) {
    var n = +x;
    return n > -0.00000001 && n < 1e-8 ? n - n * n / 2 : $e822c6dcdaca97a4$var$log(1 + n);
};


// eslint-disable-next-line es/no-math-acosh -- required for testing
var $51feea7bb09d61c3$var$$acosh = Math.acosh;
var $51feea7bb09d61c3$var$log = Math.log;
var $51feea7bb09d61c3$var$sqrt = Math.sqrt;
var $51feea7bb09d61c3$var$LN2 = Math.LN2;
var $51feea7bb09d61c3$var$FORCED = !$51feea7bb09d61c3$var$$acosh || Math.floor($51feea7bb09d61c3$var$$acosh(Number.MAX_VALUE)) !== 710 || $51feea7bb09d61c3$var$$acosh(Infinity) !== Infinity;
// `Math.acosh` method
// https://tc39.es/ecma262/#sec-math.acosh
$500d5d8b5806b834$exports({
    target: 'Math',
    stat: true,
    forced: $51feea7bb09d61c3$var$FORCED
}, {
    acosh: function acosh(x) {
        var n = +x;
        return n < 1 ? NaN : n > 94906265.62425156 ? $51feea7bb09d61c3$var$log(n) + $51feea7bb09d61c3$var$LN2 : $e822c6dcdaca97a4$exports(n - 1 + $51feea7bb09d61c3$var$sqrt(n - 1) * $51feea7bb09d61c3$var$sqrt(n + 1));
    }
});


'use strict';

// eslint-disable-next-line es/no-math-asinh -- required for testing
var $bcf50f382c4cefdd$var$$asinh = Math.asinh;
var $bcf50f382c4cefdd$var$log = Math.log;
var $bcf50f382c4cefdd$var$sqrt = Math.sqrt;
function $bcf50f382c4cefdd$var$asinh(x) {
    var n = +x;
    return !isFinite(n) || n === 0 ? n : n < 0 ? -$bcf50f382c4cefdd$var$asinh(-n) : $bcf50f382c4cefdd$var$log(n + $bcf50f382c4cefdd$var$sqrt(n * n + 1));
}
var $bcf50f382c4cefdd$var$FORCED = !($bcf50f382c4cefdd$var$$asinh && 1 / $bcf50f382c4cefdd$var$$asinh(0) > 0);
// `Math.asinh` method
// https://tc39.es/ecma262/#sec-math.asinh
// Tor Browser bug: Math.asinh(0) -> -0
$500d5d8b5806b834$exports({
    target: 'Math',
    stat: true,
    forced: $bcf50f382c4cefdd$var$FORCED
}, {
    asinh: $bcf50f382c4cefdd$var$asinh
});


'use strict';

// eslint-disable-next-line es/no-math-atanh -- required for testing
var $1bb826ff0be38ba8$var$$atanh = Math.atanh;
var $1bb826ff0be38ba8$var$log = Math.log;
var $1bb826ff0be38ba8$var$FORCED = !($1bb826ff0be38ba8$var$$atanh && 1 / $1bb826ff0be38ba8$var$$atanh(-0) < 0);
// `Math.atanh` method
// https://tc39.es/ecma262/#sec-math.atanh
// Tor Browser bug: Math.atanh(-0) -> 0
$500d5d8b5806b834$exports({
    target: 'Math',
    stat: true,
    forced: $1bb826ff0be38ba8$var$FORCED
}, {
    atanh: function atanh(x) {
        var n = +x;
        return n === 0 ? n : $1bb826ff0be38ba8$var$log((1 + n) / (1 - n)) / 2;
    }
});


'use strict';


var $7680afb54d0a6d6f$var$abs = Math.abs;
var $7680afb54d0a6d6f$var$pow = Math.pow;
// `Math.cbrt` method
// https://tc39.es/ecma262/#sec-math.cbrt
$500d5d8b5806b834$exports({
    target: 'Math',
    stat: true
}, {
    cbrt: function cbrt(x) {
        var n = +x;
        return $25fe284f18cf8b30$exports(n) * $7680afb54d0a6d6f$var$pow($7680afb54d0a6d6f$var$abs(n), 1 / 3);
    }
});


'use strict';

var $89148de13508ae3d$var$floor = Math.floor;
var $89148de13508ae3d$var$log = Math.log;
var $89148de13508ae3d$var$LOG2E = Math.LOG2E;
// `Math.clz32` method
// https://tc39.es/ecma262/#sec-math.clz32
$500d5d8b5806b834$exports({
    target: 'Math',
    stat: true
}, {
    clz32: function clz32(x) {
        var n = x >>> 0;
        return n ? 31 - $89148de13508ae3d$var$floor($89148de13508ae3d$var$log(n + 0.5) * $89148de13508ae3d$var$LOG2E) : 32;
    }
});


'use strict';

var $52e395d729448f0a$exports = {};
'use strict';
// eslint-disable-next-line es/no-math-expm1 -- safe
var $52e395d729448f0a$var$$expm1 = Math.expm1;
var $52e395d729448f0a$var$exp = Math.exp;
// `Math.expm1` method implementation
// https://tc39.es/ecma262/#sec-math.expm1
$52e395d729448f0a$exports = !$52e395d729448f0a$var$$expm1 || $52e395d729448f0a$var$$expm1(10) > 22025.465794806719 || $52e395d729448f0a$var$$expm1(10) < 22025.4657948067165168 || $52e395d729448f0a$var$$expm1(-0.00000000000000002) !== -0.00000000000000002 ? function expm1(x) {
    var n = +x;
    return n === 0 ? n : n > -0.000001 && n < 1e-6 ? n + n * n / 2 : $52e395d729448f0a$var$exp(n) - 1;
} : $52e395d729448f0a$var$$expm1;


// eslint-disable-next-line es/no-math-cosh -- required for testing
var $1c94140ce55968e7$var$$cosh = Math.cosh;
var $1c94140ce55968e7$var$abs = Math.abs;
var $1c94140ce55968e7$var$E = Math.E;
var $1c94140ce55968e7$var$FORCED = !$1c94140ce55968e7$var$$cosh || $1c94140ce55968e7$var$$cosh(710) === Infinity;
// `Math.cosh` method
// https://tc39.es/ecma262/#sec-math.cosh
$500d5d8b5806b834$exports({
    target: 'Math',
    stat: true,
    forced: $1c94140ce55968e7$var$FORCED
}, {
    cosh: function cosh(x) {
        var t = $52e395d729448f0a$exports($1c94140ce55968e7$var$abs(x) - 1) + 1;
        return (t + 1 / (t * $1c94140ce55968e7$var$E * $1c94140ce55968e7$var$E)) * ($1c94140ce55968e7$var$E / 2);
    }
});


'use strict';


// `Math.expm1` method
// https://tc39.es/ecma262/#sec-math.expm1
// eslint-disable-next-line es/no-math-expm1 -- required for testing
$500d5d8b5806b834$exports({
    target: 'Math',
    stat: true,
    forced: $52e395d729448f0a$exports !== Math.expm1
}, {
    expm1: $52e395d729448f0a$exports
});


'use strict';


// `Math.fround` method
// https://tc39.es/ecma262/#sec-math.fround
$500d5d8b5806b834$exports({
    target: 'Math',
    stat: true
}, {
    fround: $78b718bae1c89cef$exports
});


'use strict';

// eslint-disable-next-line es/no-math-hypot -- required for testing
var $db2d487361d74f26$var$$hypot = Math.hypot;
var $db2d487361d74f26$var$abs = Math.abs;
var $db2d487361d74f26$var$sqrt = Math.sqrt;
// Chrome 77 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=9546
var $db2d487361d74f26$var$FORCED = !!$db2d487361d74f26$var$$hypot && $db2d487361d74f26$var$$hypot(Infinity, NaN) !== Infinity;
// `Math.hypot` method
// https://tc39.es/ecma262/#sec-math.hypot
$500d5d8b5806b834$exports({
    target: 'Math',
    stat: true,
    arity: 2,
    forced: $db2d487361d74f26$var$FORCED
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    hypot: function hypot(value1, value2) {
        var sum = 0;
        var i = 0;
        var aLen = arguments.length;
        var larg = 0;
        var arg, div;
        while(i < aLen){
            arg = $db2d487361d74f26$var$abs(arguments[i++]);
            if (larg < arg) {
                div = larg / arg;
                sum = sum * div * div + 1;
                larg = arg;
            } else if (arg > 0) {
                div = arg / larg;
                sum += div * div;
            } else sum += arg;
        }
        return larg === Infinity ? Infinity : larg * $db2d487361d74f26$var$sqrt(sum);
    }
});


'use strict';


// eslint-disable-next-line es/no-math-imul -- required for testing
var $0d577de89c2d2c22$var$$imul = Math.imul;
var $0d577de89c2d2c22$var$FORCED = $06c7d56a730e31f1$exports(function() {
    return $0d577de89c2d2c22$var$$imul(0xFFFFFFFF, 5) !== -5 || $0d577de89c2d2c22$var$$imul.length !== 2;
});
// `Math.imul` method
// https://tc39.es/ecma262/#sec-math.imul
// some WebKit versions fails with big numbers, some has wrong arity
$500d5d8b5806b834$exports({
    target: 'Math',
    stat: true,
    forced: $0d577de89c2d2c22$var$FORCED
}, {
    imul: function imul(x, y) {
        var UINT16 = 0xFFFF;
        var xn = +x;
        var yn = +y;
        var xl = UINT16 & xn;
        var yl = UINT16 & yn;
        return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
    }
});


'use strict';

var $62824a740cb74624$exports = {};
'use strict';
var $62824a740cb74624$var$log = Math.log;
var $62824a740cb74624$var$LOG10E = Math.LOG10E;
// eslint-disable-next-line es/no-math-log10 -- safe
$62824a740cb74624$exports = Math.log10 || function log10(x) {
    return $62824a740cb74624$var$log(x) * $62824a740cb74624$var$LOG10E;
};


// `Math.log10` method
// https://tc39.es/ecma262/#sec-math.log10
$500d5d8b5806b834$exports({
    target: 'Math',
    stat: true
}, {
    log10: $62824a740cb74624$exports
});


'use strict';


// `Math.log1p` method
// https://tc39.es/ecma262/#sec-math.log1p
$500d5d8b5806b834$exports({
    target: 'Math',
    stat: true
}, {
    log1p: $e822c6dcdaca97a4$exports
});


'use strict';

var $3cda6b6812b30348$var$log = Math.log;
var $3cda6b6812b30348$var$LN2 = Math.LN2;
// `Math.log2` method
// https://tc39.es/ecma262/#sec-math.log2
$500d5d8b5806b834$exports({
    target: 'Math',
    stat: true
}, {
    log2: function log2(x) {
        return $3cda6b6812b30348$var$log(x) / $3cda6b6812b30348$var$LN2;
    }
});


'use strict';


// `Math.sign` method
// https://tc39.es/ecma262/#sec-math.sign
$500d5d8b5806b834$exports({
    target: 'Math',
    stat: true
}, {
    sign: $25fe284f18cf8b30$exports
});


'use strict';



var $dd8ddf516e3bd921$var$abs = Math.abs;
var $dd8ddf516e3bd921$var$exp = Math.exp;
var $dd8ddf516e3bd921$var$E = Math.E;
var $dd8ddf516e3bd921$var$FORCED = $06c7d56a730e31f1$exports(function() {
    // eslint-disable-next-line es/no-math-sinh -- required for testing
    return Math.sinh(-0.00000000000000002) !== -0.00000000000000002;
});
// `Math.sinh` method
// https://tc39.es/ecma262/#sec-math.sinh
// V8 near Chromium 38 has a problem with very small numbers
$500d5d8b5806b834$exports({
    target: 'Math',
    stat: true,
    forced: $dd8ddf516e3bd921$var$FORCED
}, {
    sinh: function sinh(x) {
        var n = +x;
        return $dd8ddf516e3bd921$var$abs(n) < 1 ? ($52e395d729448f0a$exports(n) - $52e395d729448f0a$exports(-n)) / 2 : ($dd8ddf516e3bd921$var$exp(n - 1) - $dd8ddf516e3bd921$var$exp(-n - 1)) * ($dd8ddf516e3bd921$var$E / 2);
    }
});


'use strict';


var $6955522ba553ec84$var$exp = Math.exp;
// `Math.tanh` method
// https://tc39.es/ecma262/#sec-math.tanh
$500d5d8b5806b834$exports({
    target: 'Math',
    stat: true
}, {
    tanh: function tanh(x) {
        var n = +x;
        var a = $52e395d729448f0a$exports(n);
        var b = $52e395d729448f0a$exports(-n);
        return a === Infinity ? 1 : b === Infinity ? -1 : (a - b) / ($6955522ba553ec84$var$exp(n) + $6955522ba553ec84$var$exp(-n));
    }
});


'use strict';

// Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag
$be9d27c6f3178ed3$exports(Math, 'Math', true);


'use strict';


// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
$500d5d8b5806b834$exports({
    target: 'Math',
    stat: true
}, {
    trunc: $8ce23ed191976089$exports
});



var $qb7pP = parcelRequire("qb7pP");
'use strict';














var $a60b76013c547fcc$require$getOwnPropertyNames = $13520dff9cf61e9d$export$2d1720544b23b823;

var $a60b76013c547fcc$require$getOwnPropertyDescriptor = $bb417845773708b5$export$2d1720544b23b823;

var $a60b76013c547fcc$require$defineProperty = $23cff59c96aeab90$export$2d1720544b23b823;
var $0246aadfb2e871e0$exports = {};
'use strict';

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
$0246aadfb2e871e0$exports = $1689570c06db508b$exports(1.0.valueOf);


var $1e0ce41924eafd61$exports = {};
'use strict';



var $e32455e9fd1e1d3c$exports = {};
'use strict';
// a string of all valid unicode whitespaces
$e32455e9fd1e1d3c$exports = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";


var $1e0ce41924eafd61$var$replace = $1689570c06db508b$exports(''.replace);
var $1e0ce41924eafd61$var$ltrim = RegExp('^[' + $e32455e9fd1e1d3c$exports + ']+');
var $1e0ce41924eafd61$var$rtrim = RegExp('(^|[^' + $e32455e9fd1e1d3c$exports + '])[' + $e32455e9fd1e1d3c$exports + ']+$');
// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var $1e0ce41924eafd61$var$createMethod = function createMethod(TYPE) {
    return function($this) {
        var string = $f4fff477af530dca$exports($fdf84a64c2f63ac3$exports($this));
        if (TYPE & 1) string = $1e0ce41924eafd61$var$replace(string, $1e0ce41924eafd61$var$ltrim, '');
        if (TYPE & 2) string = $1e0ce41924eafd61$var$replace(string, $1e0ce41924eafd61$var$rtrim, '$1');
        return string;
    };
};
$1e0ce41924eafd61$exports = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: $1e0ce41924eafd61$var$createMethod(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: $1e0ce41924eafd61$var$createMethod(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: $1e0ce41924eafd61$var$createMethod(3)
};


var $a60b76013c547fcc$require$trim = $1e0ce41924eafd61$exports.trim;
var $a60b76013c547fcc$var$NUMBER = 'Number';
var $a60b76013c547fcc$var$NativeNumber = $9be6fcc00ef60f58$exports[$a60b76013c547fcc$var$NUMBER];
var $a60b76013c547fcc$var$PureNumberNamespace = $56e9e6ac1b0b6c62$exports[$a60b76013c547fcc$var$NUMBER];
var $a60b76013c547fcc$var$NumberPrototype = $a60b76013c547fcc$var$NativeNumber.prototype;
var $a60b76013c547fcc$var$TypeError = $9be6fcc00ef60f58$exports.TypeError;
var $a60b76013c547fcc$var$stringSlice = $1689570c06db508b$exports(''.slice);
var $a60b76013c547fcc$var$charCodeAt = $1689570c06db508b$exports(''.charCodeAt);
// `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric
var $a60b76013c547fcc$var$toNumeric = function toNumeric(value) {
    var primValue = $50b25b11d61908fe$exports(value, 'number');
    return (typeof primValue === "undefined" ? "undefined" : (0, $qb7pP._)(primValue)) == 'bigint' ? primValue : $a60b76013c547fcc$var$toNumber(primValue);
};
// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var $a60b76013c547fcc$var$toNumber = function toNumber(argument) {
    var it = $50b25b11d61908fe$exports(argument, 'number');
    var first, third, radix, maxCode, digits, length, index, code;
    if ($4cdbccb02aa7d286$exports(it)) throw new $a60b76013c547fcc$var$TypeError('Cannot convert a Symbol value to a number');
    if (typeof it == 'string' && it.length > 2) {
        it = $a60b76013c547fcc$require$trim(it);
        first = $a60b76013c547fcc$var$charCodeAt(it, 0);
        if (first === 43 || first === 45) {
            third = $a60b76013c547fcc$var$charCodeAt(it, 2);
            if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
        } else if (first === 48) {
            switch($a60b76013c547fcc$var$charCodeAt(it, 1)){
                // fast equal of /^0b[01]+$/i
                case 66:
                case 98:
                    radix = 2;
                    maxCode = 49;
                    break;
                // fast equal of /^0o[0-7]+$/i
                case 79:
                case 111:
                    radix = 8;
                    maxCode = 55;
                    break;
                default:
                    return +it;
            }
            digits = $a60b76013c547fcc$var$stringSlice(it, 2);
            length = digits.length;
            for(index = 0; index < length; index++){
                code = $a60b76013c547fcc$var$charCodeAt(digits, index);
                // parseInt parses a string to a first unavailable symbol
                // but ToNumber should return NaN if a string contains unavailable symbols
                if (code < 48 || code > maxCode) return NaN;
            }
            return parseInt(digits, radix);
        }
    }
    return +it;
};
var $a60b76013c547fcc$var$FORCED = $1aa429f267e7bd69$exports($a60b76013c547fcc$var$NUMBER, !$a60b76013c547fcc$var$NativeNumber(' 0o1') || !$a60b76013c547fcc$var$NativeNumber('0b1') || $a60b76013c547fcc$var$NativeNumber('+0x1'));
var $a60b76013c547fcc$var$calledWithNew = function calledWithNew(dummy) {
    // includes check on 1..constructor(foo) case
    return $bc714f4a9c09d4bd$exports($a60b76013c547fcc$var$NumberPrototype, dummy) && $06c7d56a730e31f1$exports(function() {
        $0246aadfb2e871e0$exports(dummy);
    });
};
// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
var $a60b76013c547fcc$var$NumberWrapper = function Number(value) {
    var n = arguments.length < 1 ? 0 : $a60b76013c547fcc$var$NativeNumber($a60b76013c547fcc$var$toNumeric(value));
    return $a60b76013c547fcc$var$calledWithNew(this) ? $8388ec23a46a9286$exports(Object(n), this, $a60b76013c547fcc$var$NumberWrapper) : n;
};
$a60b76013c547fcc$var$NumberWrapper.prototype = $a60b76013c547fcc$var$NumberPrototype;
if ($a60b76013c547fcc$var$FORCED && !$62bf9cf43d01f7ec$exports) $a60b76013c547fcc$var$NumberPrototype.constructor = $a60b76013c547fcc$var$NumberWrapper;
$500d5d8b5806b834$exports({
    global: true,
    constructor: true,
    wrap: true,
    forced: $a60b76013c547fcc$var$FORCED
}, {
    Number: $a60b76013c547fcc$var$NumberWrapper
});
// Use `internal/copy-constructor-properties` helper in `core-js@4`
var $a60b76013c547fcc$var$copyConstructorProperties = function copyConstructorProperties(target, source) {
    for(var keys = $6ffb7908e83cf36c$exports ? $a60b76013c547fcc$require$getOwnPropertyNames(source) : // ES3:
    "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(','), j = 0, key; keys.length > j; j++)if ($35cf4bf79fe152cc$exports(source, key = keys[j]) && !$35cf4bf79fe152cc$exports(target, key)) $a60b76013c547fcc$require$defineProperty(target, key, $a60b76013c547fcc$require$getOwnPropertyDescriptor(source, key));
};
if ($62bf9cf43d01f7ec$exports && $a60b76013c547fcc$var$PureNumberNamespace) $a60b76013c547fcc$var$copyConstructorProperties($56e9e6ac1b0b6c62$exports[$a60b76013c547fcc$var$NUMBER], $a60b76013c547fcc$var$PureNumberNamespace);
if ($a60b76013c547fcc$var$FORCED || $62bf9cf43d01f7ec$exports) $a60b76013c547fcc$var$copyConstructorProperties($56e9e6ac1b0b6c62$exports[$a60b76013c547fcc$var$NUMBER], $a60b76013c547fcc$var$NativeNumber);


'use strict';

// `Number.EPSILON` constant
// https://tc39.es/ecma262/#sec-number.epsilon
$500d5d8b5806b834$exports({
    target: 'Number',
    stat: true,
    nonConfigurable: true,
    nonWritable: true
}, {
    EPSILON: Math.pow(2, -52)
});


'use strict';

var $27ea9e850f8b66d9$exports = {};
'use strict';

var $27ea9e850f8b66d9$var$globalIsFinite = $9be6fcc00ef60f58$exports.isFinite;
// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
// eslint-disable-next-line es/no-number-isfinite -- safe
$27ea9e850f8b66d9$exports = Number.isFinite || function isFinite(it) {
    return typeof it == 'number' && $27ea9e850f8b66d9$var$globalIsFinite(it);
};


// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
$500d5d8b5806b834$exports({
    target: 'Number',
    stat: true
}, {
    isFinite: $27ea9e850f8b66d9$exports
});


'use strict';

var $0b15627d3bc33b2f$exports = {};
'use strict';

var $0b15627d3bc33b2f$var$floor = Math.floor;
// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es/no-number-isinteger -- safe
$0b15627d3bc33b2f$exports = Number.isInteger || function isInteger(it) {
    return !$d2d3162bdcc39b88$exports(it) && isFinite(it) && $0b15627d3bc33b2f$var$floor(it) === it;
};


// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$500d5d8b5806b834$exports({
    target: 'Number',
    stat: true
}, {
    isInteger: $0b15627d3bc33b2f$exports
});


'use strict';

// `Number.isNaN` method
// https://tc39.es/ecma262/#sec-number.isnan
$500d5d8b5806b834$exports({
    target: 'Number',
    stat: true
}, {
    isNaN: function isNaN(number) {
        // eslint-disable-next-line no-self-compare -- NaN check
        return number !== number;
    }
});


'use strict';


var $69e34434c04f02ac$var$abs = Math.abs;
// `Number.isSafeInteger` method
// https://tc39.es/ecma262/#sec-number.issafeinteger
$500d5d8b5806b834$exports({
    target: 'Number',
    stat: true
}, {
    isSafeInteger: function isSafeInteger(number) {
        return $0b15627d3bc33b2f$exports(number) && $69e34434c04f02ac$var$abs(number) <= 0x1FFFFFFFFFFFFF;
    }
});


'use strict';

// `Number.MAX_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.max_safe_integer
$500d5d8b5806b834$exports({
    target: 'Number',
    stat: true,
    nonConfigurable: true,
    nonWritable: true
}, {
    MAX_SAFE_INTEGER: 0x1FFFFFFFFFFFFF
});


'use strict';

// `Number.MIN_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.min_safe_integer
$500d5d8b5806b834$exports({
    target: 'Number',
    stat: true,
    nonConfigurable: true,
    nonWritable: true
}, {
    MIN_SAFE_INTEGER: -9007199254740991
});


'use strict';

var $905267e47ab36ebf$exports = {};
'use strict';





var $905267e47ab36ebf$require$trim = $1e0ce41924eafd61$exports.trim;

var $905267e47ab36ebf$var$charAt = $1689570c06db508b$exports(''.charAt);
var $905267e47ab36ebf$var$$parseFloat = $9be6fcc00ef60f58$exports.parseFloat;
var $905267e47ab36ebf$var$Symbol = $9be6fcc00ef60f58$exports.Symbol;
var $905267e47ab36ebf$var$ITERATOR = $905267e47ab36ebf$var$Symbol && $905267e47ab36ebf$var$Symbol.iterator;
var $905267e47ab36ebf$var$FORCED = 1 / $905267e47ab36ebf$var$$parseFloat($e32455e9fd1e1d3c$exports + '-0') !== -Infinity || $905267e47ab36ebf$var$ITERATOR && !$06c7d56a730e31f1$exports(function() {
    $905267e47ab36ebf$var$$parseFloat(Object($905267e47ab36ebf$var$ITERATOR));
});
// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
$905267e47ab36ebf$exports = $905267e47ab36ebf$var$FORCED ? function parseFloat(string) {
    var trimmedString = $905267e47ab36ebf$require$trim($f4fff477af530dca$exports(string));
    var result = $905267e47ab36ebf$var$$parseFloat(trimmedString);
    return result === 0 && $905267e47ab36ebf$var$charAt(trimmedString, 0) === '-' ? -0 : result;
} : $905267e47ab36ebf$var$$parseFloat;


// `Number.parseFloat` method
// https://tc39.es/ecma262/#sec-number.parseFloat
// eslint-disable-next-line es/no-number-parsefloat -- required for testing
$500d5d8b5806b834$exports({
    target: 'Number',
    stat: true,
    forced: Number.parseFloat !== $905267e47ab36ebf$exports
}, {
    parseFloat: $905267e47ab36ebf$exports
});


'use strict';

var $9bffeb8de0eddd9d$exports = {};
'use strict';





var $9bffeb8de0eddd9d$require$trim = $1e0ce41924eafd61$exports.trim;

var $9bffeb8de0eddd9d$var$$parseInt = $9be6fcc00ef60f58$exports.parseInt;
var $9bffeb8de0eddd9d$var$Symbol = $9be6fcc00ef60f58$exports.Symbol;
var $9bffeb8de0eddd9d$var$ITERATOR = $9bffeb8de0eddd9d$var$Symbol && $9bffeb8de0eddd9d$var$Symbol.iterator;
var $9bffeb8de0eddd9d$var$hex = /^[+-]?0x/i;
var $9bffeb8de0eddd9d$var$exec = $1689570c06db508b$exports($9bffeb8de0eddd9d$var$hex.exec);
var $9bffeb8de0eddd9d$var$FORCED = $9bffeb8de0eddd9d$var$$parseInt($e32455e9fd1e1d3c$exports + '08') !== 8 || $9bffeb8de0eddd9d$var$$parseInt($e32455e9fd1e1d3c$exports + '0x16') !== 22 || $9bffeb8de0eddd9d$var$ITERATOR && !$06c7d56a730e31f1$exports(function() {
    $9bffeb8de0eddd9d$var$$parseInt(Object($9bffeb8de0eddd9d$var$ITERATOR));
});
// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$9bffeb8de0eddd9d$exports = $9bffeb8de0eddd9d$var$FORCED ? function parseInt(string, radix) {
    var S = $9bffeb8de0eddd9d$require$trim($f4fff477af530dca$exports(string));
    return $9bffeb8de0eddd9d$var$$parseInt(S, radix >>> 0 || ($9bffeb8de0eddd9d$var$exec($9bffeb8de0eddd9d$var$hex, S) ? 16 : 10));
} : $9bffeb8de0eddd9d$var$$parseInt;


// `Number.parseInt` method
// https://tc39.es/ecma262/#sec-number.parseint
// eslint-disable-next-line es/no-number-parseint -- required for testing
$500d5d8b5806b834$exports({
    target: 'Number',
    stat: true,
    forced: Number.parseInt !== $9bffeb8de0eddd9d$exports
}, {
    parseInt: $9bffeb8de0eddd9d$exports
});


'use strict';






var $3230aa32dc0d53c4$var$$RangeError = RangeError;
var $3230aa32dc0d53c4$var$$String = String;
var $3230aa32dc0d53c4$var$floor = Math.floor;
var $3230aa32dc0d53c4$var$repeat = $1689570c06db508b$exports($05ac5542bb716171$exports);
var $3230aa32dc0d53c4$var$stringSlice = $1689570c06db508b$exports(''.slice);
var $3230aa32dc0d53c4$var$nativeToFixed = $1689570c06db508b$exports(1.0.toFixed);
var $3230aa32dc0d53c4$var$pow = function pow1(x, n, acc) {
    return n === 0 ? acc : n % 2 === 1 ? $3230aa32dc0d53c4$var$pow(x, n - 1, acc * x) : $3230aa32dc0d53c4$var$pow(x * x, n / 2, acc);
};
var $3230aa32dc0d53c4$var$log = function log(x) {
    var n = 0;
    var x2 = x;
    while(x2 >= 4096){
        n += 12;
        x2 /= 4096;
    }
    while(x2 >= 2){
        n += 1;
        x2 /= 2;
    }
    return n;
};
var $3230aa32dc0d53c4$var$multiply = function multiply(data, n, c) {
    var index = -1;
    var c2 = c;
    while(++index < 6){
        c2 += n * data[index];
        data[index] = c2 % 1e7;
        c2 = $3230aa32dc0d53c4$var$floor(c2 / 1e7);
    }
};
var $3230aa32dc0d53c4$var$divide = function divide(data, n) {
    var index = 6;
    var c = 0;
    while(--index >= 0){
        c += data[index];
        data[index] = $3230aa32dc0d53c4$var$floor(c / n);
        c = c % n * 1e7;
    }
};
var $3230aa32dc0d53c4$var$dataToString = function dataToString(data) {
    var index = 6;
    var s = '';
    while(--index >= 0)if (s !== '' || index === 0 || data[index] !== 0) {
        var t = $3230aa32dc0d53c4$var$$String(data[index]);
        s = s === '' ? t : s + $3230aa32dc0d53c4$var$repeat('0', 7 - t.length) + t;
    }
    return s;
};
var $3230aa32dc0d53c4$var$FORCED = $06c7d56a730e31f1$exports(function() {
    return $3230aa32dc0d53c4$var$nativeToFixed(0.00008, 3) !== '0.000' || $3230aa32dc0d53c4$var$nativeToFixed(0.9, 0) !== '1' || $3230aa32dc0d53c4$var$nativeToFixed(1.255, 2) !== '1.25' || $3230aa32dc0d53c4$var$nativeToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
}) || !$06c7d56a730e31f1$exports(function() {
    // V8 ~ Android 4.3-
    $3230aa32dc0d53c4$var$nativeToFixed({});
});
// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$500d5d8b5806b834$exports({
    target: 'Number',
    proto: true,
    forced: $3230aa32dc0d53c4$var$FORCED
}, {
    toFixed: function toFixed(fractionDigits) {
        var number = $0246aadfb2e871e0$exports(this);
        var fractDigits = $4508997bd0ba9879$exports(fractionDigits);
        var data = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var sign = '';
        var result = '0';
        var e, z, j, k;
        // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
        if (fractDigits < 0 || fractDigits > 20) throw new $3230aa32dc0d53c4$var$$RangeError('Incorrect fraction digits');
        // eslint-disable-next-line no-self-compare -- NaN check
        if (number !== number) return 'NaN';
        if (number <= -1000000000000000000000 || number >= 1e21) return $3230aa32dc0d53c4$var$$String(number);
        if (number < 0) {
            sign = '-';
            number = -number;
        }
        if (number > 1e-21) {
            e = $3230aa32dc0d53c4$var$log(number * $3230aa32dc0d53c4$var$pow(2, 69, 1)) - 69;
            z = e < 0 ? number * $3230aa32dc0d53c4$var$pow(2, -e, 1) : number / $3230aa32dc0d53c4$var$pow(2, e, 1);
            z *= 0x10000000000000;
            e = 52 - e;
            if (e > 0) {
                $3230aa32dc0d53c4$var$multiply(data, 0, z);
                j = fractDigits;
                while(j >= 7){
                    $3230aa32dc0d53c4$var$multiply(data, 1e7, 0);
                    j -= 7;
                }
                $3230aa32dc0d53c4$var$multiply(data, $3230aa32dc0d53c4$var$pow(10, j, 1), 0);
                j = e - 1;
                while(j >= 23){
                    $3230aa32dc0d53c4$var$divide(data, 8388608);
                    j -= 23;
                }
                $3230aa32dc0d53c4$var$divide(data, 1 << j);
                $3230aa32dc0d53c4$var$multiply(data, 1, 1);
                $3230aa32dc0d53c4$var$divide(data, 2);
                result = $3230aa32dc0d53c4$var$dataToString(data);
            } else {
                $3230aa32dc0d53c4$var$multiply(data, 0, z);
                $3230aa32dc0d53c4$var$multiply(data, 1 << -e, 0);
                result = $3230aa32dc0d53c4$var$dataToString(data) + $3230aa32dc0d53c4$var$repeat('0', fractDigits);
            }
        }
        if (fractDigits > 0) {
            k = result.length;
            result = sign + (k <= fractDigits ? '0.' + $3230aa32dc0d53c4$var$repeat('0', fractDigits - k) + result : $3230aa32dc0d53c4$var$stringSlice(result, 0, k - fractDigits) + '.' + $3230aa32dc0d53c4$var$stringSlice(result, k - fractDigits));
        } else result = sign + result;
        return result;
    }
});


'use strict';




var $d2e87f2c6d64f8b4$var$nativeToPrecision = $1689570c06db508b$exports(1.0.toPrecision);
var $d2e87f2c6d64f8b4$var$FORCED = $06c7d56a730e31f1$exports(function() {
    // IE7-
    return $d2e87f2c6d64f8b4$var$nativeToPrecision(1, undefined) !== '1';
}) || !$06c7d56a730e31f1$exports(function() {
    // V8 ~ Android 4.3-
    $d2e87f2c6d64f8b4$var$nativeToPrecision({});
});
// `Number.prototype.toPrecision` method
// https://tc39.es/ecma262/#sec-number.prototype.toprecision
$500d5d8b5806b834$exports({
    target: 'Number',
    proto: true,
    forced: $d2e87f2c6d64f8b4$var$FORCED
}, {
    toPrecision: function toPrecision(precision) {
        return precision === undefined ? $d2e87f2c6d64f8b4$var$nativeToPrecision($0246aadfb2e871e0$exports(this)) : $d2e87f2c6d64f8b4$var$nativeToPrecision($0246aadfb2e871e0$exports(this), precision);
    }
});


'use strict';

var $12c15fcd9efee893$exports = {};
'use strict';









// eslint-disable-next-line es/no-object-assign -- safe
var $12c15fcd9efee893$var$$assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var $12c15fcd9efee893$var$defineProperty = Object.defineProperty;
var $12c15fcd9efee893$var$concat = $1689570c06db508b$exports([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
$12c15fcd9efee893$exports = !$12c15fcd9efee893$var$$assign || $06c7d56a730e31f1$exports(function() {
    // should have correct order of operations (Edge bug)
    if ($6ffb7908e83cf36c$exports && $12c15fcd9efee893$var$$assign({
        b: 1
    }, $12c15fcd9efee893$var$$assign($12c15fcd9efee893$var$defineProperty({}, 'a', {
        enumerable: true,
        get: function get() {
            $12c15fcd9efee893$var$defineProperty(this, 'b', {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es/no-symbol -- safe
    var symbol = Symbol('assign detection');
    var alphabet = 'abcdefghijklmnopqrst';
    A[symbol] = 7;
    alphabet.split('').forEach(function(chr) {
        B[chr] = chr;
    });
    return $12c15fcd9efee893$var$$assign({}, A)[symbol] !== 7 || $3e49974af21bc51b$exports($12c15fcd9efee893$var$$assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) {
    var T = $ec839b558eb5dcf4$exports(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $dcfc1c5672328394$export$2d1720544b23b823;
    var propertyIsEnumerable = $7365bb173f3e63f5$export$2d1720544b23b823;
    while(argumentsLength > index){
        var S = $a71603b0710a8479$exports(arguments[index++]);
        var keys = getOwnPropertySymbols ? $12c15fcd9efee893$var$concat($3e49974af21bc51b$exports(S), getOwnPropertySymbols(S)) : $3e49974af21bc51b$exports(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$6ffb7908e83cf36c$exports || $e3ebd8cb7f512f74$exports(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $12c15fcd9efee893$var$$assign;


// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$500d5d8b5806b834$exports({
    target: 'Object',
    stat: true,
    arity: 2,
    forced: Object.assign !== $12c15fcd9efee893$exports
}, {
    assign: $12c15fcd9efee893$exports
});


'use strict';



// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
$500d5d8b5806b834$exports({
    target: 'Object',
    stat: true,
    sham: !$6ffb7908e83cf36c$exports
}, {
    create: $c8a7d59657e3f14b$exports
});


'use strict';


var $4c08c73c747eb61d$exports = {};
'use strict';




// Forced replacement object prototype accessors methods
$4c08c73c747eb61d$exports = $62bf9cf43d01f7ec$exports || !$06c7d56a730e31f1$exports(function() {
    // This feature detection crashes old WebKit
    // https://github.com/zloirock/core-js/issues/232
    if ($a4a58fb9b1d3c6b9$exports && $a4a58fb9b1d3c6b9$exports < 535) return;
    var key = Math.random();
    // In FF throws only define methods
    __defineSetter__.call(null, key, function() {});
    delete $9be6fcc00ef60f58$exports[key];
});





// `Object.prototype.__defineGetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__defineGetter__
if ($6ffb7908e83cf36c$exports) $500d5d8b5806b834$exports({
    target: 'Object',
    proto: true,
    forced: $4c08c73c747eb61d$exports
}, {
    __defineGetter__: function __defineGetter__(P, getter) {
        $23cff59c96aeab90$export$2d1720544b23b823($ec839b558eb5dcf4$exports(this), P, {
            get: $c976080d379e828f$exports(getter),
            enumerable: true,
            configurable: true
        });
    }
});


'use strict';



var $b47ec04691a7cd00$require$defineProperties = $846c9cd8a2cecf69$export$2d1720544b23b823;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
$500d5d8b5806b834$exports({
    target: 'Object',
    stat: true,
    forced: Object.defineProperties !== $b47ec04691a7cd00$require$defineProperties,
    sham: !$6ffb7908e83cf36c$exports
}, {
    defineProperties: $b47ec04691a7cd00$require$defineProperties
});


'use strict';



var $b2e63ca05cdb9e8a$require$defineProperty = $23cff59c96aeab90$export$2d1720544b23b823;
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
// eslint-disable-next-line es/no-object-defineproperty -- safe
$500d5d8b5806b834$exports({
    target: 'Object',
    stat: true,
    forced: Object.defineProperty !== $b2e63ca05cdb9e8a$require$defineProperty,
    sham: !$6ffb7908e83cf36c$exports
}, {
    defineProperty: $b2e63ca05cdb9e8a$require$defineProperty
});


'use strict';






// `Object.prototype.__defineSetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__defineSetter__
if ($6ffb7908e83cf36c$exports) $500d5d8b5806b834$exports({
    target: 'Object',
    proto: true,
    forced: $4c08c73c747eb61d$exports
}, {
    __defineSetter__: function __defineSetter__(P, setter) {
        $23cff59c96aeab90$export$2d1720544b23b823($ec839b558eb5dcf4$exports(this), P, {
            set: $c976080d379e828f$exports(setter),
            enumerable: true,
            configurable: true
        });
    }
});


'use strict';

var $e31aa339df3142ce$exports = {};
'use strict';







var $e31aa339df3142ce$require$$propertyIsEnumerable = $7365bb173f3e63f5$export$2d1720544b23b823;
var $e31aa339df3142ce$var$propertyIsEnumerable = $1689570c06db508b$exports($e31aa339df3142ce$require$$propertyIsEnumerable);
var $e31aa339df3142ce$var$push = $1689570c06db508b$exports([].push);
// in some IE versions, `propertyIsEnumerable` returns incorrect result on integer keys
// of `null` prototype objects
var $e31aa339df3142ce$var$IE_BUG = $6ffb7908e83cf36c$exports && $06c7d56a730e31f1$exports(function() {
    // eslint-disable-next-line es/no-object-create -- safe
    var O = Object.create(null);
    O[2] = 2;
    return !$e31aa339df3142ce$var$propertyIsEnumerable(O, 2);
});
// `Object.{ entries, values }` methods implementation
var $e31aa339df3142ce$var$createMethod = function createMethod(TO_ENTRIES) {
    return function(it) {
        var O = $e656dbd61e0a8253$exports(it);
        var keys = $3e49974af21bc51b$exports(O);
        var IE_WORKAROUND = $e31aa339df3142ce$var$IE_BUG && $a7c2d1ef948bc294$exports(O) === null;
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while(length > i){
            key = keys[i++];
            if (!$6ffb7908e83cf36c$exports || (IE_WORKAROUND ? key in O : $e31aa339df3142ce$var$propertyIsEnumerable(O, key))) $e31aa339df3142ce$var$push(result, TO_ENTRIES ? [
                key,
                O[key]
            ] : O[key]);
        }
        return result;
    };
};
$e31aa339df3142ce$exports = {
    // `Object.entries` method
    // https://tc39.es/ecma262/#sec-object.entries
    entries: $e31aa339df3142ce$var$createMethod(true),
    // `Object.values` method
    // https://tc39.es/ecma262/#sec-object.values
    values: $e31aa339df3142ce$var$createMethod(false)
};


var $45dcb70e78611c9c$require$$entries = $e31aa339df3142ce$exports.entries;
// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$500d5d8b5806b834$exports({
    target: 'Object',
    stat: true
}, {
    entries: function entries(O) {
        return $45dcb70e78611c9c$require$$entries(O);
    }
});


'use strict';





var $6773707d6cec88c4$require$onFreeze = $24ac99e13d26c138$exports.onFreeze;
// eslint-disable-next-line es/no-object-freeze -- safe
var $6773707d6cec88c4$var$$freeze = Object.freeze;
var $6773707d6cec88c4$var$FAILS_ON_PRIMITIVES = $06c7d56a730e31f1$exports(function() {
    $6773707d6cec88c4$var$$freeze(1);
});
// `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze
$500d5d8b5806b834$exports({
    target: 'Object',
    stat: true,
    forced: $6773707d6cec88c4$var$FAILS_ON_PRIMITIVES,
    sham: !$dd70d49b1cfa63a3$exports
}, {
    freeze: function freeze(it) {
        return $6773707d6cec88c4$var$$freeze && $d2d3162bdcc39b88$exports(it) ? $6773707d6cec88c4$var$$freeze($6773707d6cec88c4$require$onFreeze(it)) : it;
    }
});


'use strict';



// `Object.fromEntries` method
// https://tc39.es/ecma262/#sec-object.fromentries
$500d5d8b5806b834$exports({
    target: 'Object',
    stat: true
}, {
    fromEntries: function fromEntries(iterable) {
        var obj = {};
        $6244c42639c04860$exports(iterable, function(k, v) {
            $aaa4fdf84fef0770$exports(obj, k, v);
        }, {
            AS_ENTRIES: true
        });
        return obj;
    }
});


'use strict';




var $b07973d6ba16875e$require$nativeGetOwnPropertyDescriptor = $bb417845773708b5$export$2d1720544b23b823;

var $b07973d6ba16875e$var$FORCED = !$6ffb7908e83cf36c$exports || $06c7d56a730e31f1$exports(function() {
    $b07973d6ba16875e$require$nativeGetOwnPropertyDescriptor(1);
});
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$500d5d8b5806b834$exports({
    target: 'Object',
    stat: true,
    forced: $b07973d6ba16875e$var$FORCED,
    sham: !$6ffb7908e83cf36c$exports
}, {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
        return $b07973d6ba16875e$require$nativeGetOwnPropertyDescriptor($e656dbd61e0a8253$exports(it), key);
    }
});


'use strict';






// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$500d5d8b5806b834$exports({
    target: 'Object',
    stat: true,
    sham: !$6ffb7908e83cf36c$exports
}, {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
        var O = $e656dbd61e0a8253$exports(object);
        var getOwnPropertyDescriptor = $bb417845773708b5$export$2d1720544b23b823;
        var keys = $0610906adb160ba4$exports(O);
        var result = {};
        var index = 0;
        var key, descriptor;
        while(keys.length > index){
            descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
            if (descriptor !== undefined) $aaa4fdf84fef0770$exports(result, key, descriptor);
        }
        return result;
    }
});


'use strict';



var $4bbd9116633d6c1a$require$getOwnPropertyNames = $226371c2c18604cf$export$2d1720544b23b823;
// eslint-disable-next-line es/no-object-getownpropertynames -- required for testing
var $4bbd9116633d6c1a$var$FAILS_ON_PRIMITIVES = $06c7d56a730e31f1$exports(function() {
    return !Object.getOwnPropertyNames(1);
});
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
$500d5d8b5806b834$exports({
    target: 'Object',
    stat: true,
    forced: $4bbd9116633d6c1a$var$FAILS_ON_PRIMITIVES
}, {
    getOwnPropertyNames: $4bbd9116633d6c1a$require$getOwnPropertyNames
});


'use strict';





var $a61fc6c5a2e4f664$var$FAILS_ON_PRIMITIVES = $06c7d56a730e31f1$exports(function() {
    $a7c2d1ef948bc294$exports(1);
});
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$500d5d8b5806b834$exports({
    target: 'Object',
    stat: true,
    forced: $a61fc6c5a2e4f664$var$FAILS_ON_PRIMITIVES,
    sham: !$234c0f4f47710f9d$exports
}, {
    getPrototypeOf: function getPrototypeOf(it) {
        return $a7c2d1ef948bc294$exports($ec839b558eb5dcf4$exports(it));
    }
});


'use strict';

var $d9de1e6a7d0028b5$exports = {};
'use strict';
// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
$d9de1e6a7d0028b5$exports = Object.is || function is(x, y) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return x === y ? x !== 0 || 1 / x === 1 / y : x !== x && y !== y;
};


// `Object.is` method
// https://tc39.es/ecma262/#sec-object.is
$500d5d8b5806b834$exports({
    target: 'Object',
    stat: true
}, {
    is: $d9de1e6a7d0028b5$exports
});


'use strict';


// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
// eslint-disable-next-line es/no-object-isextensible -- safe
$500d5d8b5806b834$exports({
    target: 'Object',
    stat: true,
    forced: Object.isExtensible !== $57bd68525637913a$exports
}, {
    isExtensible: $57bd68525637913a$exports
});


'use strict';





// eslint-disable-next-line es/no-object-isfrozen -- safe
var $7ffa03b4c40a8324$var$$isFrozen = Object.isFrozen;
var $7ffa03b4c40a8324$var$FORCED = $e8872ee40e374557$exports || $06c7d56a730e31f1$exports(function() {
    $7ffa03b4c40a8324$var$$isFrozen(1);
});
// `Object.isFrozen` method
// https://tc39.es/ecma262/#sec-object.isfrozen
$500d5d8b5806b834$exports({
    target: 'Object',
    stat: true,
    forced: $7ffa03b4c40a8324$var$FORCED
}, {
    isFrozen: function isFrozen(it) {
        if (!$d2d3162bdcc39b88$exports(it)) return true;
        if ($e8872ee40e374557$exports && $9afeb253af368f01$exports(it) === 'ArrayBuffer') return true;
        return $7ffa03b4c40a8324$var$$isFrozen ? $7ffa03b4c40a8324$var$$isFrozen(it) : false;
    }
});


'use strict';





// eslint-disable-next-line es/no-object-issealed -- safe
var $bbf4e22a5a77a68c$var$$isSealed = Object.isSealed;
var $bbf4e22a5a77a68c$var$FORCED = $e8872ee40e374557$exports || $06c7d56a730e31f1$exports(function() {
    $bbf4e22a5a77a68c$var$$isSealed(1);
});
// `Object.isSealed` method
// https://tc39.es/ecma262/#sec-object.issealed
$500d5d8b5806b834$exports({
    target: 'Object',
    stat: true,
    forced: $bbf4e22a5a77a68c$var$FORCED
}, {
    isSealed: function isSealed(it) {
        if (!$d2d3162bdcc39b88$exports(it)) return true;
        if ($e8872ee40e374557$exports && $9afeb253af368f01$exports(it) === 'ArrayBuffer') return true;
        return $bbf4e22a5a77a68c$var$$isSealed ? $bbf4e22a5a77a68c$var$$isSealed(it) : false;
    }
});


'use strict';




var $16006852ea98a27a$var$FAILS_ON_PRIMITIVES = $06c7d56a730e31f1$exports(function() {
    $3e49974af21bc51b$exports(1);
});
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$500d5d8b5806b834$exports({
    target: 'Object',
    stat: true,
    forced: $16006852ea98a27a$var$FAILS_ON_PRIMITIVES
}, {
    keys: function keys(it) {
        return $3e49974af21bc51b$exports($ec839b558eb5dcf4$exports(it));
    }
});


'use strict';







var $2bdcda829b129a20$require$getOwnPropertyDescriptor = $bb417845773708b5$export$2d1720544b23b823;
// `Object.prototype.__lookupGetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__lookupGetter__
if ($6ffb7908e83cf36c$exports) $500d5d8b5806b834$exports({
    target: 'Object',
    proto: true,
    forced: $4c08c73c747eb61d$exports
}, {
    __lookupGetter__: function __lookupGetter__(P) {
        var O = $ec839b558eb5dcf4$exports(this);
        var key = $282f32d47e9dd4f8$exports(P);
        var desc;
        do {
            if (desc = $2bdcda829b129a20$require$getOwnPropertyDescriptor(O, key)) return desc.get;
        }while (O = $a7c2d1ef948bc294$exports(O));
    }
});


'use strict';







var $c034dd1b6c010f93$require$getOwnPropertyDescriptor = $bb417845773708b5$export$2d1720544b23b823;
// `Object.prototype.__lookupSetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__lookupSetter__
if ($6ffb7908e83cf36c$exports) $500d5d8b5806b834$exports({
    target: 'Object',
    proto: true,
    forced: $4c08c73c747eb61d$exports
}, {
    __lookupSetter__: function __lookupSetter__(P) {
        var O = $ec839b558eb5dcf4$exports(this);
        var key = $282f32d47e9dd4f8$exports(P);
        var desc;
        do {
            if (desc = $c034dd1b6c010f93$require$getOwnPropertyDescriptor(O, key)) return desc.set;
        }while (O = $a7c2d1ef948bc294$exports(O));
    }
});


'use strict';



var $c75a6c4a949a0bae$require$onFreeze = $24ac99e13d26c138$exports.onFreeze;


// eslint-disable-next-line es/no-object-preventextensions -- safe
var $c75a6c4a949a0bae$var$$preventExtensions = Object.preventExtensions;
var $c75a6c4a949a0bae$var$FAILS_ON_PRIMITIVES = $06c7d56a730e31f1$exports(function() {
    $c75a6c4a949a0bae$var$$preventExtensions(1);
});
// `Object.preventExtensions` method
// https://tc39.es/ecma262/#sec-object.preventextensions
$500d5d8b5806b834$exports({
    target: 'Object',
    stat: true,
    forced: $c75a6c4a949a0bae$var$FAILS_ON_PRIMITIVES,
    sham: !$dd70d49b1cfa63a3$exports
}, {
    preventExtensions: function preventExtensions(it) {
        return $c75a6c4a949a0bae$var$$preventExtensions && $d2d3162bdcc39b88$exports(it) ? $c75a6c4a949a0bae$var$$preventExtensions($c75a6c4a949a0bae$require$onFreeze(it)) : it;
    }
});


'use strict';



var $7efe1693eb0c9b69$require$onFreeze = $24ac99e13d26c138$exports.onFreeze;


// eslint-disable-next-line es/no-object-seal -- safe
var $7efe1693eb0c9b69$var$$seal = Object.seal;
var $7efe1693eb0c9b69$var$FAILS_ON_PRIMITIVES = $06c7d56a730e31f1$exports(function() {
    $7efe1693eb0c9b69$var$$seal(1);
});
// `Object.seal` method
// https://tc39.es/ecma262/#sec-object.seal
$500d5d8b5806b834$exports({
    target: 'Object',
    stat: true,
    forced: $7efe1693eb0c9b69$var$FAILS_ON_PRIMITIVES,
    sham: !$dd70d49b1cfa63a3$exports
}, {
    seal: function seal(it) {
        return $7efe1693eb0c9b69$var$$seal && $d2d3162bdcc39b88$exports(it) ? $7efe1693eb0c9b69$var$$seal($7efe1693eb0c9b69$require$onFreeze(it)) : it;
    }
});


'use strict';


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$500d5d8b5806b834$exports({
    target: 'Object',
    stat: true
}, {
    setPrototypeOf: $6a2615bbdaa85242$exports
});


'use strict';


var $1e33a9e11d9545d5$exports = {};
'use strict';


// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
$1e33a9e11d9545d5$exports = $b5fabce5e8156a25$exports ? ({}).toString : function toString() {
    return '[object ' + $4591439421551449$exports(this) + ']';
};


// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!$b5fabce5e8156a25$exports) $b817bfc251eac07c$exports(Object.prototype, 'toString', $1e33a9e11d9545d5$exports, {
    unsafe: true
});


'use strict';


var $68020864a86a9713$require$$values = $e31aa339df3142ce$exports.values;
// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$500d5d8b5806b834$exports({
    target: 'Object',
    stat: true
}, {
    values: function values(O) {
        return $68020864a86a9713$require$$values(O);
    }
});


'use strict';


// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
$500d5d8b5806b834$exports({
    global: true,
    forced: parseFloat !== $905267e47ab36ebf$exports
}, {
    parseFloat: $905267e47ab36ebf$exports
});


'use strict';


// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$500d5d8b5806b834$exports({
    global: true,
    forced: parseInt !== $9bffeb8de0eddd9d$exports
}, {
    parseInt: $9bffeb8de0eddd9d$exports
});


'use strict';
'use strict';













var $ebf7e01de9701d7b$exports = {};
'use strict';

var $1272194ab2c74efa$exports = {};
'use strict';


var $1272194ab2c74efa$var$$TypeError = TypeError;
// `Assert: IsConstructor(argument) is true`
$1272194ab2c74efa$exports = function(argument) {
    if ($c14e5ce4ade3a35d$exports(argument)) return argument;
    throw new $1272194ab2c74efa$var$$TypeError($53c3bf74c3e856bf$exports(argument) + ' is not a constructor');
};




var $ebf7e01de9701d7b$var$SPECIES = $6268abd12745dd3b$exports('species');
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
$ebf7e01de9701d7b$exports = function(O, defaultConstructor) {
    var C = $05718fce3232bc84$exports(O).constructor;
    var S;
    return C === undefined || $8d82b0b487ce9bb5$exports(S = $05718fce3232bc84$exports(C)[$ebf7e01de9701d7b$var$SPECIES]) ? defaultConstructor : $1272194ab2c74efa$exports(S);
};


var $6ece68b922b42b4f$exports = {};
'use strict';









var $2e3ae4fb0da606c5$exports = {};
'use strict';
var $2e3ae4fb0da606c5$var$$TypeError = TypeError;
$2e3ae4fb0da606c5$exports = function(passed, required) {
    if (passed < required) throw new $2e3ae4fb0da606c5$var$$TypeError('Not enough arguments');
    return passed;
};


var $8a7f6334db38597b$exports = {};
'use strict';

// eslint-disable-next-line redos/no-vulnerable -- safe
$8a7f6334db38597b$exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($57973a61a761d756$exports);



var $6ece68b922b42b4f$var$set = $9be6fcc00ef60f58$exports.setImmediate;
var $6ece68b922b42b4f$var$clear = $9be6fcc00ef60f58$exports.clearImmediate;
var $6ece68b922b42b4f$var$process = $9be6fcc00ef60f58$exports.process;
var $6ece68b922b42b4f$var$Dispatch = $9be6fcc00ef60f58$exports.Dispatch;
var $6ece68b922b42b4f$var$Function = $9be6fcc00ef60f58$exports.Function;
var $6ece68b922b42b4f$var$MessageChannel = $9be6fcc00ef60f58$exports.MessageChannel;
var $6ece68b922b42b4f$var$String = $9be6fcc00ef60f58$exports.String;
var $6ece68b922b42b4f$var$counter = 0;
var $6ece68b922b42b4f$var$queue = {};
var $6ece68b922b42b4f$var$ONREADYSTATECHANGE = 'onreadystatechange';
var $6ece68b922b42b4f$var$$location, $6ece68b922b42b4f$var$defer, $6ece68b922b42b4f$var$channel, $6ece68b922b42b4f$var$port;
$06c7d56a730e31f1$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $6ece68b922b42b4f$var$$location = $9be6fcc00ef60f58$exports.location;
});
var $6ece68b922b42b4f$var$run = function run(id) {
    if ($35cf4bf79fe152cc$exports($6ece68b922b42b4f$var$queue, id)) {
        var fn = $6ece68b922b42b4f$var$queue[id];
        delete $6ece68b922b42b4f$var$queue[id];
        fn();
    }
};
var $6ece68b922b42b4f$var$runner = function runner(id) {
    return function() {
        $6ece68b922b42b4f$var$run(id);
    };
};
var $6ece68b922b42b4f$var$eventListener = function eventListener(event) {
    $6ece68b922b42b4f$var$run(event.data);
};
var $6ece68b922b42b4f$var$globalPostMessageDefer = function globalPostMessageDefer(id) {
    // old engines have not location.origin
    $9be6fcc00ef60f58$exports.postMessage($6ece68b922b42b4f$var$String(id), $6ece68b922b42b4f$var$$location.protocol + '//' + $6ece68b922b42b4f$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$6ece68b922b42b4f$var$set || !$6ece68b922b42b4f$var$clear) {
    $6ece68b922b42b4f$var$set = function setImmediate(handler) {
        $2e3ae4fb0da606c5$exports(arguments.length, 1);
        var fn = $0a82f0a5368b6870$exports(handler) ? handler : $6ece68b922b42b4f$var$Function(handler);
        var args = $65dcb7b8ed29ae22$exports(arguments, 1);
        $6ece68b922b42b4f$var$queue[++$6ece68b922b42b4f$var$counter] = function() {
            $c126e09ab0f7e2a8$exports(fn, undefined, args);
        };
        $6ece68b922b42b4f$var$defer($6ece68b922b42b4f$var$counter);
        return $6ece68b922b42b4f$var$counter;
    };
    $6ece68b922b42b4f$var$clear = function clearImmediate(id) {
        delete $6ece68b922b42b4f$var$queue[id];
    };
    // Node.js 0.8-
    if ($a97ab19b61c06eda$exports) $6ece68b922b42b4f$var$defer = function defer(id) {
        $6ece68b922b42b4f$var$process.nextTick($6ece68b922b42b4f$var$runner(id));
    };
    else if ($6ece68b922b42b4f$var$Dispatch && $6ece68b922b42b4f$var$Dispatch.now) $6ece68b922b42b4f$var$defer = function defer(id) {
        $6ece68b922b42b4f$var$Dispatch.now($6ece68b922b42b4f$var$runner(id));
    };
    else if ($6ece68b922b42b4f$var$MessageChannel && !$8a7f6334db38597b$exports) {
        $6ece68b922b42b4f$var$channel = new $6ece68b922b42b4f$var$MessageChannel();
        $6ece68b922b42b4f$var$port = $6ece68b922b42b4f$var$channel.port2;
        $6ece68b922b42b4f$var$channel.port1.onmessage = $6ece68b922b42b4f$var$eventListener;
        $6ece68b922b42b4f$var$defer = $847280b2cf36c2e0$exports($6ece68b922b42b4f$var$port.postMessage, $6ece68b922b42b4f$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($9be6fcc00ef60f58$exports.addEventListener && $0a82f0a5368b6870$exports($9be6fcc00ef60f58$exports.postMessage) && !$9be6fcc00ef60f58$exports.importScripts && $6ece68b922b42b4f$var$$location && $6ece68b922b42b4f$var$$location.protocol !== 'file:' && !$06c7d56a730e31f1$exports($6ece68b922b42b4f$var$globalPostMessageDefer)) {
        $6ece68b922b42b4f$var$defer = $6ece68b922b42b4f$var$globalPostMessageDefer;
        $9be6fcc00ef60f58$exports.addEventListener('message', $6ece68b922b42b4f$var$eventListener, false);
    // IE8-
    } else if ($6ece68b922b42b4f$var$ONREADYSTATECHANGE in $b4e20123d93a8378$exports('script')) $6ece68b922b42b4f$var$defer = function defer(id) {
        $10389597269aae86$exports.appendChild($b4e20123d93a8378$exports('script'))[$6ece68b922b42b4f$var$ONREADYSTATECHANGE] = function() {
            $10389597269aae86$exports.removeChild(this);
            $6ece68b922b42b4f$var$run(id);
        };
    };
    else $6ece68b922b42b4f$var$defer = function defer(id) {
        setTimeout($6ece68b922b42b4f$var$runner(id), 0);
    };
}
$6ece68b922b42b4f$exports = {
    set: $6ece68b922b42b4f$var$set,
    clear: $6ece68b922b42b4f$var$clear
};


var $9e1d5503eee3b3b2$require$task = $6ece68b922b42b4f$exports.set;
var $83551686af07bd37$exports = {};
'use strict';

var $5c5516287ef435b7$exports = {};
'use strict';


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $5c5516287ef435b7$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Avoid NodeJS experimental warning
$5c5516287ef435b7$exports = function(name) {
    if (!$6ffb7908e83cf36c$exports) return $9be6fcc00ef60f58$exports[name];
    var descriptor = $5c5516287ef435b7$var$getOwnPropertyDescriptor($9be6fcc00ef60f58$exports, name);
    return descriptor && descriptor.value;
};




var $83551686af07bd37$require$macrotask = $6ece68b922b42b4f$exports.set;
var $556c7ec49b6c6bb0$exports = {};
'use strict';
var $556c7ec49b6c6bb0$var$Queue = function Queue() {
    this.head = null;
    this.tail = null;
};
$556c7ec49b6c6bb0$var$Queue.prototype = {
    add: function add(item) {
        var entry = {
            item: item,
            next: null
        };
        var tail = this.tail;
        if (tail) tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function get() {
        var entry = this.head;
        if (entry) {
            var next = this.head = entry.next;
            if (next === null) this.tail = null;
            return entry.item;
        }
    }
};
$556c7ec49b6c6bb0$exports = $556c7ec49b6c6bb0$var$Queue;



var $6e24dc4a51a41a88$exports = {};
'use strict';

$6e24dc4a51a41a88$exports = /ipad|iphone|ipod/i.test($57973a61a761d756$exports) && typeof Pebble != 'undefined';


var $ccaa14c2afd66777$exports = {};
'use strict';

$ccaa14c2afd66777$exports = /web0s(?!.*chrome)/i.test($57973a61a761d756$exports);



var $83551686af07bd37$var$MutationObserver = $9be6fcc00ef60f58$exports.MutationObserver || $9be6fcc00ef60f58$exports.WebKitMutationObserver;
var $83551686af07bd37$var$document = $9be6fcc00ef60f58$exports.document;
var $83551686af07bd37$var$process = $9be6fcc00ef60f58$exports.process;
var $83551686af07bd37$var$Promise = $9be6fcc00ef60f58$exports.Promise;
var $83551686af07bd37$var$microtask = $5c5516287ef435b7$exports('queueMicrotask');
var $83551686af07bd37$var$notify, $83551686af07bd37$var$toggle, $83551686af07bd37$var$node, $83551686af07bd37$var$promise, $83551686af07bd37$var$then;
// modern engines have queueMicrotask method
if (!$83551686af07bd37$var$microtask) {
    var $83551686af07bd37$var$queue = new $556c7ec49b6c6bb0$exports();
    var $83551686af07bd37$var$flush = function flush() {
        var parent, fn;
        if ($a97ab19b61c06eda$exports && (parent = $83551686af07bd37$var$process.domain)) parent.exit();
        while(fn = $83551686af07bd37$var$queue.get())try {
            fn();
        } catch (error) {
            if ($83551686af07bd37$var$queue.head) $83551686af07bd37$var$notify();
            throw error;
        }
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$8a7f6334db38597b$exports && !$a97ab19b61c06eda$exports && !$ccaa14c2afd66777$exports && $83551686af07bd37$var$MutationObserver && $83551686af07bd37$var$document) {
        $83551686af07bd37$var$toggle = true;
        $83551686af07bd37$var$node = $83551686af07bd37$var$document.createTextNode('');
        new $83551686af07bd37$var$MutationObserver($83551686af07bd37$var$flush).observe($83551686af07bd37$var$node, {
            characterData: true
        });
        $83551686af07bd37$var$notify = function notify() {
            $83551686af07bd37$var$node.data = $83551686af07bd37$var$toggle = !$83551686af07bd37$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$6e24dc4a51a41a88$exports && $83551686af07bd37$var$Promise && $83551686af07bd37$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $83551686af07bd37$var$promise = $83551686af07bd37$var$Promise.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $83551686af07bd37$var$promise.constructor = $83551686af07bd37$var$Promise;
        $83551686af07bd37$var$then = $847280b2cf36c2e0$exports($83551686af07bd37$var$promise.then, $83551686af07bd37$var$promise);
        $83551686af07bd37$var$notify = function notify() {
            $83551686af07bd37$var$then($83551686af07bd37$var$flush);
        };
    // Node.js without promises
    } else if ($a97ab19b61c06eda$exports) $83551686af07bd37$var$notify = function notify() {
        $83551686af07bd37$var$process.nextTick($83551686af07bd37$var$flush);
    };
    else {
        // `webpack` dev server bug on IE global methods - use bind(fn, global)
        $83551686af07bd37$require$macrotask = $847280b2cf36c2e0$exports($83551686af07bd37$require$macrotask, $9be6fcc00ef60f58$exports);
        $83551686af07bd37$var$notify = function notify() {
            $83551686af07bd37$require$macrotask($83551686af07bd37$var$flush);
        };
    }
    $83551686af07bd37$var$microtask = function microtask(fn) {
        if (!$83551686af07bd37$var$queue.head) $83551686af07bd37$var$notify();
        $83551686af07bd37$var$queue.add(fn);
    };
}
$83551686af07bd37$exports = $83551686af07bd37$var$microtask;


var $4f6d618f177b8ed5$exports = {};
'use strict';
$4f6d618f177b8ed5$exports = function(a, b) {
    try {
        // eslint-disable-next-line no-console -- safe
        arguments.length === 1 ? console.error(a) : console.error(a, b);
    } catch (error) {}
};


var $6e13f6af83e98221$exports = {};
'use strict';
$6e13f6af83e98221$exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};




var $30aa1178bf4d8bd8$exports = {};
'use strict';

$30aa1178bf4d8bd8$exports = $9be6fcc00ef60f58$exports.Promise;


var $905d4be0bd1e4400$exports = {};
'use strict';









var $905d4be0bd1e4400$var$NativePromisePrototype = $30aa1178bf4d8bd8$exports && $30aa1178bf4d8bd8$exports.prototype;
var $905d4be0bd1e4400$var$SPECIES = $6268abd12745dd3b$exports('species');
var $905d4be0bd1e4400$var$SUBCLASSING = false;
var $905d4be0bd1e4400$var$NATIVE_PROMISE_REJECTION_EVENT = $0a82f0a5368b6870$exports($9be6fcc00ef60f58$exports.PromiseRejectionEvent);
var $905d4be0bd1e4400$var$FORCED_PROMISE_CONSTRUCTOR = $1aa429f267e7bd69$exports('Promise', function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $9933f2479804f1dc$exports($30aa1178bf4d8bd8$exports);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($30aa1178bf4d8bd8$exports);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $9d47635dcaf33179$exports === 66) return true;
    // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
    if ($62bf9cf43d01f7ec$exports && !($905d4be0bd1e4400$var$NativePromisePrototype['catch'] && $905d4be0bd1e4400$var$NativePromisePrototype['finally'])) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if (!$9d47635dcaf33179$exports || $9d47635dcaf33179$exports < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
        // Detect correctness of subclassing with @@species support
        var promise = new $30aa1178bf4d8bd8$exports(function(resolve) {
            resolve(1);
        });
        var FakePromise = function FakePromise(exec) {
            exec(function() {}, function() {});
        };
        var constructor = promise.constructor = {};
        constructor[$905d4be0bd1e4400$var$SPECIES] = FakePromise;
        $905d4be0bd1e4400$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
        if (!$905d4be0bd1e4400$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    }
    return !GLOBAL_CORE_JS_PROMISE && ($2e69a89a5051d832$exports === 'BROWSER' || $2e69a89a5051d832$exports === 'DENO') && !$905d4be0bd1e4400$var$NATIVE_PROMISE_REJECTION_EVENT;
});
$905d4be0bd1e4400$exports = {
    CONSTRUCTOR: $905d4be0bd1e4400$var$FORCED_PROMISE_CONSTRUCTOR,
    REJECTION_EVENT: $905d4be0bd1e4400$var$NATIVE_PROMISE_REJECTION_EVENT,
    SUBCLASSING: $905d4be0bd1e4400$var$SUBCLASSING
};


var $e16d1e3715cca0f1$exports = {};

$parcel$export($e16d1e3715cca0f1$exports, "f", function () { return $e16d1e3715cca0f1$export$2d1720544b23b823; }, function (v) { return $e16d1e3715cca0f1$export$2d1720544b23b823 = v; });
// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var $e16d1e3715cca0f1$export$2d1720544b23b823;
'use strict';

var $e16d1e3715cca0f1$var$$TypeError = TypeError;
var $e16d1e3715cca0f1$var$PromiseCapability = function PromiseCapability(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw new $e16d1e3715cca0f1$var$$TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $c976080d379e828f$exports(resolve);
    this.reject = $c976080d379e828f$exports(reject);
};
$e16d1e3715cca0f1$export$2d1720544b23b823 = function(C) {
    return new $e16d1e3715cca0f1$var$PromiseCapability(C);
};


var $9e1d5503eee3b3b2$var$PROMISE = 'Promise';
var $9e1d5503eee3b3b2$var$FORCED_PROMISE_CONSTRUCTOR = $905d4be0bd1e4400$exports.CONSTRUCTOR;
var $9e1d5503eee3b3b2$var$NATIVE_PROMISE_REJECTION_EVENT = $905d4be0bd1e4400$exports.REJECTION_EVENT;
var $9e1d5503eee3b3b2$var$NATIVE_PROMISE_SUBCLASSING = $905d4be0bd1e4400$exports.SUBCLASSING;
var $9e1d5503eee3b3b2$var$getInternalPromiseState = $419c333d2a5dd5f4$exports.getterFor($9e1d5503eee3b3b2$var$PROMISE);
var $9e1d5503eee3b3b2$var$setInternalState = $419c333d2a5dd5f4$exports.set;
var $9e1d5503eee3b3b2$var$NativePromisePrototype = $30aa1178bf4d8bd8$exports && $30aa1178bf4d8bd8$exports.prototype;
var $9e1d5503eee3b3b2$var$PromiseConstructor = $30aa1178bf4d8bd8$exports;
var $9e1d5503eee3b3b2$var$PromisePrototype = $9e1d5503eee3b3b2$var$NativePromisePrototype;
var $9e1d5503eee3b3b2$var$TypeError = $9be6fcc00ef60f58$exports.TypeError;
var $9e1d5503eee3b3b2$var$document = $9be6fcc00ef60f58$exports.document;
var $9e1d5503eee3b3b2$var$process = $9be6fcc00ef60f58$exports.process;
var $9e1d5503eee3b3b2$var$newPromiseCapability = $e16d1e3715cca0f1$export$2d1720544b23b823;
var $9e1d5503eee3b3b2$var$newGenericPromiseCapability = $9e1d5503eee3b3b2$var$newPromiseCapability;
var $9e1d5503eee3b3b2$var$DISPATCH_EVENT = !!($9e1d5503eee3b3b2$var$document && $9e1d5503eee3b3b2$var$document.createEvent && $9be6fcc00ef60f58$exports.dispatchEvent);
var $9e1d5503eee3b3b2$var$UNHANDLED_REJECTION = 'unhandledrejection';
var $9e1d5503eee3b3b2$var$REJECTION_HANDLED = 'rejectionhandled';
var $9e1d5503eee3b3b2$var$PENDING = 0;
var $9e1d5503eee3b3b2$var$FULFILLED = 1;
var $9e1d5503eee3b3b2$var$REJECTED = 2;
var $9e1d5503eee3b3b2$var$HANDLED = 1;
var $9e1d5503eee3b3b2$var$UNHANDLED = 2;
var $9e1d5503eee3b3b2$var$Internal, $9e1d5503eee3b3b2$var$OwnPromiseCapability, $9e1d5503eee3b3b2$var$PromiseWrapper, $9e1d5503eee3b3b2$var$nativeThen;
// helpers
var $9e1d5503eee3b3b2$var$isThenable = function isThenable(it) {
    var then;
    return $d2d3162bdcc39b88$exports(it) && $0a82f0a5368b6870$exports(then = it.then) ? then : false;
};
var $9e1d5503eee3b3b2$var$callReaction = function callReaction(reaction, state) {
    var value = state.value;
    var ok = state.state === $9e1d5503eee3b3b2$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $9e1d5503eee3b3b2$var$UNHANDLED) $9e1d5503eee3b3b2$var$onHandleUnhandled(state);
                state.rejection = $9e1d5503eee3b3b2$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject(new $9e1d5503eee3b3b2$var$TypeError('Promise-chain cycle'));
            else if (then = $9e1d5503eee3b3b2$var$isThenable(result)) $e3ebd8cb7f512f74$exports(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $9e1d5503eee3b3b2$var$notify = function notify(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $83551686af07bd37$exports(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$9e1d5503eee3b3b2$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $9e1d5503eee3b3b2$var$onUnhandled(state);
    });
};
var $9e1d5503eee3b3b2$var$dispatchEvent = function dispatchEvent(name, promise, reason) {
    var event, handler;
    if ($9e1d5503eee3b3b2$var$DISPATCH_EVENT) {
        event = $9e1d5503eee3b3b2$var$document.createEvent('Event');
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $9be6fcc00ef60f58$exports.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$9e1d5503eee3b3b2$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $9be6fcc00ef60f58$exports['on' + name])) handler(event);
    else if (name === $9e1d5503eee3b3b2$var$UNHANDLED_REJECTION) $4f6d618f177b8ed5$exports('Unhandled promise rejection', reason);
};
var $9e1d5503eee3b3b2$var$onUnhandled = function onUnhandled(state) {
    $e3ebd8cb7f512f74$exports($9e1d5503eee3b3b2$require$task, $9be6fcc00ef60f58$exports, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $9e1d5503eee3b3b2$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $6e13f6af83e98221$exports(function() {
                if ($a97ab19b61c06eda$exports) $9e1d5503eee3b3b2$var$process.emit('unhandledRejection', value, promise);
                else $9e1d5503eee3b3b2$var$dispatchEvent($9e1d5503eee3b3b2$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $a97ab19b61c06eda$exports || $9e1d5503eee3b3b2$var$isUnhandled(state) ? $9e1d5503eee3b3b2$var$UNHANDLED : $9e1d5503eee3b3b2$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $9e1d5503eee3b3b2$var$isUnhandled = function isUnhandled(state) {
    return state.rejection !== $9e1d5503eee3b3b2$var$HANDLED && !state.parent;
};
var $9e1d5503eee3b3b2$var$onHandleUnhandled = function onHandleUnhandled(state) {
    $e3ebd8cb7f512f74$exports($9e1d5503eee3b3b2$require$task, $9be6fcc00ef60f58$exports, function() {
        var promise = state.facade;
        if ($a97ab19b61c06eda$exports) $9e1d5503eee3b3b2$var$process.emit('rejectionHandled', promise);
        else $9e1d5503eee3b3b2$var$dispatchEvent($9e1d5503eee3b3b2$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $9e1d5503eee3b3b2$var$bind = function bind(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $9e1d5503eee3b3b2$var$internalReject = function internalReject(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $9e1d5503eee3b3b2$var$REJECTED;
    $9e1d5503eee3b3b2$var$notify(state, true);
};
var $9e1d5503eee3b3b2$var$internalResolve = function internalResolve1(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw new $9e1d5503eee3b3b2$var$TypeError("Promise can't be resolved itself");
        var then = $9e1d5503eee3b3b2$var$isThenable(value);
        if (then) $83551686af07bd37$exports(function() {
            var wrapper = {
                done: false
            };
            try {
                $e3ebd8cb7f512f74$exports(then, value, $9e1d5503eee3b3b2$var$bind($9e1d5503eee3b3b2$var$internalResolve, wrapper, state), $9e1d5503eee3b3b2$var$bind($9e1d5503eee3b3b2$var$internalReject, wrapper, state));
            } catch (error) {
                $9e1d5503eee3b3b2$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $9e1d5503eee3b3b2$var$FULFILLED;
            $9e1d5503eee3b3b2$var$notify(state, false);
        }
    } catch (error) {
        $9e1d5503eee3b3b2$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($9e1d5503eee3b3b2$var$FORCED_PROMISE_CONSTRUCTOR) {
    // 25.4.3.1 Promise(executor)
    $9e1d5503eee3b3b2$var$PromiseConstructor = function Promise(executor) {
        $65f23bed46afab45$exports(this, $9e1d5503eee3b3b2$var$PromisePrototype);
        $c976080d379e828f$exports(executor);
        $e3ebd8cb7f512f74$exports($9e1d5503eee3b3b2$var$Internal, this);
        var state = $9e1d5503eee3b3b2$var$getInternalPromiseState(this);
        try {
            executor($9e1d5503eee3b3b2$var$bind($9e1d5503eee3b3b2$var$internalResolve, state), $9e1d5503eee3b3b2$var$bind($9e1d5503eee3b3b2$var$internalReject, state));
        } catch (error) {
            $9e1d5503eee3b3b2$var$internalReject(state, error);
        }
    };
    $9e1d5503eee3b3b2$var$PromisePrototype = $9e1d5503eee3b3b2$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $9e1d5503eee3b3b2$var$Internal = function Promise(executor) {
        $9e1d5503eee3b3b2$var$setInternalState(this, {
            type: $9e1d5503eee3b3b2$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $556c7ec49b6c6bb0$exports(),
            rejection: false,
            state: $9e1d5503eee3b3b2$var$PENDING,
            value: null
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $9e1d5503eee3b3b2$var$Internal.prototype = $b817bfc251eac07c$exports($9e1d5503eee3b3b2$var$PromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var state = $9e1d5503eee3b3b2$var$getInternalPromiseState(this);
        var reaction = $9e1d5503eee3b3b2$var$newPromiseCapability($ebf7e01de9701d7b$exports(this, $9e1d5503eee3b3b2$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $0a82f0a5368b6870$exports(onFulfilled) ? onFulfilled : true;
        reaction.fail = $0a82f0a5368b6870$exports(onRejected) && onRejected;
        reaction.domain = $a97ab19b61c06eda$exports ? $9e1d5503eee3b3b2$var$process.domain : undefined;
        if (state.state === $9e1d5503eee3b3b2$var$PENDING) state.reactions.add(reaction);
        else $83551686af07bd37$exports(function() {
            $9e1d5503eee3b3b2$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $9e1d5503eee3b3b2$var$OwnPromiseCapability = function OwnPromiseCapability() {
        var promise = new $9e1d5503eee3b3b2$var$Internal();
        var state = $9e1d5503eee3b3b2$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $9e1d5503eee3b3b2$var$bind($9e1d5503eee3b3b2$var$internalResolve, state);
        this.reject = $9e1d5503eee3b3b2$var$bind($9e1d5503eee3b3b2$var$internalReject, state);
    };
    $e16d1e3715cca0f1$exports.f = $9e1d5503eee3b3b2$var$newPromiseCapability = function newPromiseCapability(C) {
        return C === $9e1d5503eee3b3b2$var$PromiseConstructor || C === $9e1d5503eee3b3b2$var$PromiseWrapper ? new $9e1d5503eee3b3b2$var$OwnPromiseCapability(C) : $9e1d5503eee3b3b2$var$newGenericPromiseCapability(C);
    };
    if (!$62bf9cf43d01f7ec$exports && $0a82f0a5368b6870$exports($30aa1178bf4d8bd8$exports) && $9e1d5503eee3b3b2$var$NativePromisePrototype !== Object.prototype) {
        $9e1d5503eee3b3b2$var$nativeThen = $9e1d5503eee3b3b2$var$NativePromisePrototype.then;
        if (!$9e1d5503eee3b3b2$var$NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        $b817bfc251eac07c$exports($9e1d5503eee3b3b2$var$NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
            var that = this;
            return new $9e1d5503eee3b3b2$var$PromiseConstructor(function(resolve, reject) {
                $e3ebd8cb7f512f74$exports($9e1d5503eee3b3b2$var$nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $9e1d5503eee3b3b2$var$NativePromisePrototype.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($6a2615bbdaa85242$exports) $6a2615bbdaa85242$exports($9e1d5503eee3b3b2$var$NativePromisePrototype, $9e1d5503eee3b3b2$var$PromisePrototype);
    }
}
// `Promise` constructor
// https://tc39.es/ecma262/#sec-promise-executor
$500d5d8b5806b834$exports({
    global: true,
    constructor: true,
    wrap: true,
    forced: $9e1d5503eee3b3b2$var$FORCED_PROMISE_CONSTRUCTOR
}, {
    Promise: $9e1d5503eee3b3b2$var$PromiseConstructor
});
$be9d27c6f3178ed3$exports($9e1d5503eee3b3b2$var$PromiseConstructor, $9e1d5503eee3b3b2$var$PROMISE, false, true);
$8db167be81e78b6c$exports($9e1d5503eee3b3b2$var$PROMISE);


'use strict';






var $def0526e3a06488e$exports = {};
'use strict';



var $def0526e3a06488e$require$FORCED_PROMISE_CONSTRUCTOR = $905d4be0bd1e4400$exports.CONSTRUCTOR;
$def0526e3a06488e$exports = $def0526e3a06488e$require$FORCED_PROMISE_CONSTRUCTOR || !$02438b0b93cfa696$exports(function(iterable) {
    $30aa1178bf4d8bd8$exports.all(iterable).then(undefined, function() {});
});


// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$500d5d8b5806b834$exports({
    target: 'Promise',
    stat: true,
    forced: $def0526e3a06488e$exports
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $e16d1e3715cca0f1$export$2d1720544b23b823(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $6e13f6af83e98221$exports(function() {
            var $promiseResolve = $c976080d379e828f$exports(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $6244c42639c04860$exports(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $e3ebd8cb7f512f74$exports($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});


'use strict';



var $c6a2a6df308e1f5b$require$FORCED_PROMISE_CONSTRUCTOR = $905d4be0bd1e4400$exports.CONSTRUCTOR;




var $c6a2a6df308e1f5b$var$NativePromisePrototype = $30aa1178bf4d8bd8$exports && $30aa1178bf4d8bd8$exports.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$500d5d8b5806b834$exports({
    target: 'Promise',
    proto: true,
    forced: $c6a2a6df308e1f5b$require$FORCED_PROMISE_CONSTRUCTOR,
    real: true
}, {
    'catch': function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!$62bf9cf43d01f7ec$exports && $0a82f0a5368b6870$exports($30aa1178bf4d8bd8$exports)) {
    var $c6a2a6df308e1f5b$var$method = $36de342b7315604e$exports('Promise').prototype['catch'];
    if ($c6a2a6df308e1f5b$var$NativePromisePrototype['catch'] !== $c6a2a6df308e1f5b$var$method) $b817bfc251eac07c$exports($c6a2a6df308e1f5b$var$NativePromisePrototype, 'catch', $c6a2a6df308e1f5b$var$method, {
        unsafe: true
    });
}


'use strict';







// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$500d5d8b5806b834$exports({
    target: 'Promise',
    stat: true,
    forced: $def0526e3a06488e$exports
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $e16d1e3715cca0f1$export$2d1720544b23b823(C);
        var reject = capability.reject;
        var result = $6e13f6af83e98221$exports(function() {
            var $promiseResolve = $c976080d379e828f$exports(C.resolve);
            $6244c42639c04860$exports(iterable, function(promise) {
                $e3ebd8cb7f512f74$exports($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});


'use strict';



var $bed80814bd454564$require$FORCED_PROMISE_CONSTRUCTOR = $905d4be0bd1e4400$exports.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$500d5d8b5806b834$exports({
    target: 'Promise',
    stat: true,
    forced: $bed80814bd454564$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    reject: function reject(r) {
        var capability = $e16d1e3715cca0f1$export$2d1720544b23b823(this);
        var capabilityReject = capability.reject;
        capabilityReject(r);
        return capability.promise;
    }
});


'use strict';





var $43333149f661241b$require$FORCED_PROMISE_CONSTRUCTOR = $905d4be0bd1e4400$exports.CONSTRUCTOR;
var $8c3c160abac35b0f$exports = {};
'use strict';



$8c3c160abac35b0f$exports = function(C, x) {
    $05718fce3232bc84$exports(C);
    if ($d2d3162bdcc39b88$exports(x) && x.constructor === C) return x;
    var promiseCapability = $e16d1e3715cca0f1$export$2d1720544b23b823(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};


var $43333149f661241b$var$PromiseConstructorWrapper = $36de342b7315604e$exports('Promise');
var $43333149f661241b$var$CHECK_WRAPPER = $62bf9cf43d01f7ec$exports && !$43333149f661241b$require$FORCED_PROMISE_CONSTRUCTOR;
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$500d5d8b5806b834$exports({
    target: 'Promise',
    stat: true,
    forced: $62bf9cf43d01f7ec$exports || $43333149f661241b$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return $8c3c160abac35b0f$exports($43333149f661241b$var$CHECK_WRAPPER && this === $43333149f661241b$var$PromiseConstructorWrapper ? $30aa1178bf4d8bd8$exports : this, x);
    }
});




'use strict';









var $8d086324e78da7c4$var$NativePromisePrototype = $30aa1178bf4d8bd8$exports && $30aa1178bf4d8bd8$exports.prototype;
// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var $8d086324e78da7c4$var$NON_GENERIC = !!$30aa1178bf4d8bd8$exports && $06c7d56a730e31f1$exports(function() {
    // eslint-disable-next-line unicorn/no-thenable -- required for testing
    $8d086324e78da7c4$var$NativePromisePrototype['finally'].call({
        then: function then() {}
    }, function() {});
});
// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$500d5d8b5806b834$exports({
    target: 'Promise',
    proto: true,
    real: true,
    forced: $8d086324e78da7c4$var$NON_GENERIC
}, {
    'finally': function(onFinally) {
        var C = $ebf7e01de9701d7b$exports(this, $36de342b7315604e$exports('Promise'));
        var isFunction = $0a82f0a5368b6870$exports(onFinally);
        return this.then(isFunction ? function(x) {
            return $8c3c160abac35b0f$exports(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return $8c3c160abac35b0f$exports(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});
// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!$62bf9cf43d01f7ec$exports && $0a82f0a5368b6870$exports($30aa1178bf4d8bd8$exports)) {
    var $8d086324e78da7c4$var$method = $36de342b7315604e$exports('Promise').prototype['finally'];
    if ($8d086324e78da7c4$var$NativePromisePrototype['finally'] !== $8d086324e78da7c4$var$method) $b817bfc251eac07c$exports($8d086324e78da7c4$var$NativePromisePrototype, 'finally', $8d086324e78da7c4$var$method, {
        unsafe: true
    });
}


'use strict';





// MS Edge argumentsList argument is optional
var $0950e77e010addb9$var$OPTIONAL_ARGUMENTS_LIST = !$06c7d56a730e31f1$exports(function() {
    // eslint-disable-next-line es/no-reflect -- required for testing
    Reflect.apply(function() {});
});
// `Reflect.apply` method
// https://tc39.es/ecma262/#sec-reflect.apply
$500d5d8b5806b834$exports({
    target: 'Reflect',
    stat: true,
    forced: $0950e77e010addb9$var$OPTIONAL_ARGUMENTS_LIST
}, {
    apply: function apply(target, thisArgument, argumentsList) {
        return $c126e09ab0f7e2a8$exports($c976080d379e828f$exports(target), thisArgument, $05718fce3232bc84$exports(argumentsList));
    }
});


'use strict';









var $42f36d7321a7da09$var$nativeConstruct = $36de342b7315604e$exports('Reflect', 'construct');
var $42f36d7321a7da09$var$ObjectPrototype = Object.prototype;
var $42f36d7321a7da09$var$push = [].push;
// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var $42f36d7321a7da09$var$NEW_TARGET_BUG = $06c7d56a730e31f1$exports(function() {
    function F() {}
    return !($42f36d7321a7da09$var$nativeConstruct(function() {}, [], F) instanceof F);
});
var $42f36d7321a7da09$var$ARGS_BUG = !$06c7d56a730e31f1$exports(function() {
    $42f36d7321a7da09$var$nativeConstruct(function() {});
});
var $42f36d7321a7da09$var$FORCED = $42f36d7321a7da09$var$NEW_TARGET_BUG || $42f36d7321a7da09$var$ARGS_BUG;
$500d5d8b5806b834$exports({
    target: 'Reflect',
    stat: true,
    forced: $42f36d7321a7da09$var$FORCED,
    sham: $42f36d7321a7da09$var$FORCED
}, {
    construct: function construct(Target, args /* , newTarget */ ) {
        $1272194ab2c74efa$exports(Target);
        $05718fce3232bc84$exports(args);
        var newTarget = arguments.length < 3 ? Target : $1272194ab2c74efa$exports(arguments[2]);
        if ($42f36d7321a7da09$var$ARGS_BUG && !$42f36d7321a7da09$var$NEW_TARGET_BUG) return $42f36d7321a7da09$var$nativeConstruct(Target, args, newTarget);
        if (Target === newTarget) {
            // w/o altered newTarget, optimization for 0-4 arguments
            switch(args.length){
                case 0:
                    return new Target();
                case 1:
                    return new Target(args[0]);
                case 2:
                    return new Target(args[0], args[1]);
                case 3:
                    return new Target(args[0], args[1], args[2]);
                case 4:
                    return new Target(args[0], args[1], args[2], args[3]);
            }
            // w/o altered newTarget, lot of arguments case
            var $args = [
                null
            ];
            $c126e09ab0f7e2a8$exports($42f36d7321a7da09$var$push, $args, args);
            return new ($c126e09ab0f7e2a8$exports($c0a1456e067c4c2e$exports, Target, $args))();
        }
        // with altered newTarget, not support built-in constructors
        var proto = newTarget.prototype;
        var instance = $c8a7d59657e3f14b$exports($d2d3162bdcc39b88$exports(proto) ? proto : $42f36d7321a7da09$var$ObjectPrototype);
        var result = $c126e09ab0f7e2a8$exports(Target, instance, args);
        return $d2d3162bdcc39b88$exports(result) ? result : instance;
    }
});


'use strict';






// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
var $f9857f70ee07878f$var$ERROR_INSTEAD_OF_FALSE = $06c7d56a730e31f1$exports(function() {
    // eslint-disable-next-line es/no-reflect -- required for testing
    Reflect.defineProperty($23cff59c96aeab90$export$2d1720544b23b823({}, 1, {
        value: 1
    }), 1, {
        value: 2
    });
});
// `Reflect.defineProperty` method
// https://tc39.es/ecma262/#sec-reflect.defineproperty
$500d5d8b5806b834$exports({
    target: 'Reflect',
    stat: true,
    forced: $f9857f70ee07878f$var$ERROR_INSTEAD_OF_FALSE,
    sham: !$6ffb7908e83cf36c$exports
}, {
    defineProperty: function defineProperty(target, propertyKey, attributes) {
        $05718fce3232bc84$exports(target);
        var key = $282f32d47e9dd4f8$exports(propertyKey);
        $05718fce3232bc84$exports(attributes);
        try {
            $23cff59c96aeab90$export$2d1720544b23b823(target, key, attributes);
            return true;
        } catch (error) {
            return false;
        }
    }
});


'use strict';



var $ecd00d4a028339cb$require$getOwnPropertyDescriptor = $bb417845773708b5$export$2d1720544b23b823;
// `Reflect.deleteProperty` method
// https://tc39.es/ecma262/#sec-reflect.deleteproperty
$500d5d8b5806b834$exports({
    target: 'Reflect',
    stat: true
}, {
    deleteProperty: function deleteProperty(target, propertyKey) {
        var descriptor = $ecd00d4a028339cb$require$getOwnPropertyDescriptor($05718fce3232bc84$exports(target), propertyKey);
        return descriptor && !descriptor.configurable ? false : delete target[propertyKey];
    }
});


'use strict';




var $fe3417c010b98566$exports = {};
'use strict';

$fe3417c010b98566$exports = function(descriptor) {
    return descriptor !== undefined && ($35cf4bf79fe152cc$exports(descriptor, 'value') || $35cf4bf79fe152cc$exports(descriptor, 'writable'));
};




// `Reflect.get` method
// https://tc39.es/ecma262/#sec-reflect.get
function $79d9378daa8eefe2$var$get(target, propertyKey /* , receiver */ ) {
    var receiver = arguments.length < 3 ? target : arguments[2];
    var descriptor, prototype;
    if ($05718fce3232bc84$exports(target) === receiver) return target[propertyKey];
    descriptor = $bb417845773708b5$export$2d1720544b23b823(target, propertyKey);
    if (descriptor) return $fe3417c010b98566$exports(descriptor) ? descriptor.value : descriptor.get === undefined ? undefined : $e3ebd8cb7f512f74$exports(descriptor.get, receiver);
    if ($d2d3162bdcc39b88$exports(prototype = $a7c2d1ef948bc294$exports(target))) return $79d9378daa8eefe2$var$get(prototype, propertyKey, receiver);
}
$500d5d8b5806b834$exports({
    target: 'Reflect',
    stat: true
}, {
    get: $79d9378daa8eefe2$var$get
});


'use strict';




// `Reflect.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-reflect.getownpropertydescriptor
$500d5d8b5806b834$exports({
    target: 'Reflect',
    stat: true,
    sham: !$6ffb7908e83cf36c$exports
}, {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
        return $bb417845773708b5$export$2d1720544b23b823($05718fce3232bc84$exports(target), propertyKey);
    }
});


'use strict';




// `Reflect.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-reflect.getprototypeof
$500d5d8b5806b834$exports({
    target: 'Reflect',
    stat: true,
    sham: !$234c0f4f47710f9d$exports
}, {
    getPrototypeOf: function getPrototypeOf(target) {
        return $a7c2d1ef948bc294$exports($05718fce3232bc84$exports(target));
    }
});


'use strict';

// `Reflect.has` method
// https://tc39.es/ecma262/#sec-reflect.has
$500d5d8b5806b834$exports({
    target: 'Reflect',
    stat: true
}, {
    has: function has(target, propertyKey) {
        return propertyKey in target;
    }
});


'use strict';



// `Reflect.isExtensible` method
// https://tc39.es/ecma262/#sec-reflect.isextensible
$500d5d8b5806b834$exports({
    target: 'Reflect',
    stat: true
}, {
    isExtensible: function isExtensible(target) {
        $05718fce3232bc84$exports(target);
        return $57bd68525637913a$exports(target);
    }
});


'use strict';


// `Reflect.ownKeys` method
// https://tc39.es/ecma262/#sec-reflect.ownkeys
$500d5d8b5806b834$exports({
    target: 'Reflect',
    stat: true
}, {
    ownKeys: $0610906adb160ba4$exports
});


'use strict';




// `Reflect.preventExtensions` method
// https://tc39.es/ecma262/#sec-reflect.preventextensions
$500d5d8b5806b834$exports({
    target: 'Reflect',
    stat: true,
    sham: !$dd70d49b1cfa63a3$exports
}, {
    preventExtensions: function preventExtensions(target) {
        $05718fce3232bc84$exports(target);
        try {
            var objectPreventExtensions = $36de342b7315604e$exports('Object', 'preventExtensions');
            if (objectPreventExtensions) objectPreventExtensions(target);
            return true;
        } catch (error) {
            return false;
        }
    }
});


'use strict';










// `Reflect.set` method
// https://tc39.es/ecma262/#sec-reflect.set
function $66c1f4553bdbc7b2$var$set(target, propertyKey, V /* , receiver */ ) {
    var receiver = arguments.length < 4 ? target : arguments[3];
    var ownDescriptor = $bb417845773708b5$export$2d1720544b23b823($05718fce3232bc84$exports(target), propertyKey);
    var existingDescriptor, prototype, setter;
    if (!ownDescriptor) {
        if ($d2d3162bdcc39b88$exports(prototype = $a7c2d1ef948bc294$exports(target))) return $66c1f4553bdbc7b2$var$set(prototype, propertyKey, V, receiver);
        ownDescriptor = $f89eb1caea2679b0$exports(0);
    }
    if ($fe3417c010b98566$exports(ownDescriptor)) {
        if (ownDescriptor.writable === false || !$d2d3162bdcc39b88$exports(receiver)) return false;
        if (existingDescriptor = $bb417845773708b5$export$2d1720544b23b823(receiver, propertyKey)) {
            if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
            existingDescriptor.value = V;
            $23cff59c96aeab90$export$2d1720544b23b823(receiver, propertyKey, existingDescriptor);
        } else $23cff59c96aeab90$export$2d1720544b23b823(receiver, propertyKey, $f89eb1caea2679b0$exports(0, V));
    } else {
        setter = ownDescriptor.set;
        if (setter === undefined) return false;
        $e3ebd8cb7f512f74$exports(setter, receiver, V);
    }
    return true;
}
// MS Edge 17-18 Reflect.set allows setting the property to object
// with non-writable property on the prototype
var $66c1f4553bdbc7b2$var$MS_EDGE_BUG = $06c7d56a730e31f1$exports(function() {
    var Constructor = function Constructor() {};
    var object = $23cff59c96aeab90$export$2d1720544b23b823(new Constructor(), 'a', {
        configurable: true
    });
    // eslint-disable-next-line es/no-reflect -- required for testing
    return Reflect.set(Constructor.prototype, 'a', 1, object) !== false;
});
$500d5d8b5806b834$exports({
    target: 'Reflect',
    stat: true,
    forced: $66c1f4553bdbc7b2$var$MS_EDGE_BUG
}, {
    set: $66c1f4553bdbc7b2$var$set
});


'use strict';




// `Reflect.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-reflect.setprototypeof
if ($6a2615bbdaa85242$exports) $500d5d8b5806b834$exports({
    target: 'Reflect',
    stat: true
}, {
    setPrototypeOf: function setPrototypeOf(target, proto) {
        $05718fce3232bc84$exports(target);
        $e097bf67d5d670de$exports(proto);
        try {
            $6a2615bbdaa85242$exports(target, proto);
            return true;
        } catch (error) {
            return false;
        }
    }
});


'use strict';








var $57cb5fa4cccf3fc2$require$getOwnPropertyNames = $13520dff9cf61e9d$export$2d1720544b23b823;

var $3f41fa99899046f0$exports = {};
'use strict';



var $3f41fa99899046f0$var$MATCH = $6268abd12745dd3b$exports('match');
// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
$3f41fa99899046f0$exports = function(it) {
    var isRegExp;
    return $d2d3162bdcc39b88$exports(it) && ((isRegExp = it[$3f41fa99899046f0$var$MATCH]) !== undefined ? !!isRegExp : $9afeb253af368f01$exports(it) === 'RegExp');
};



var $c7104e91dd64cf67$exports = {};
'use strict';



var $88dbfc720887d6c9$exports = {};
'use strict';

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
$88dbfc720887d6c9$exports = function() {
    var that = $05718fce3232bc84$exports(this);
    var result = '';
    if (that.hasIndices) result += 'd';
    if (that.global) result += 'g';
    if (that.ignoreCase) result += 'i';
    if (that.multiline) result += 'm';
    if (that.dotAll) result += 's';
    if (that.unicode) result += 'u';
    if (that.unicodeSets) result += 'v';
    if (that.sticky) result += 'y';
    return result;
};


var $c7104e91dd64cf67$var$RegExpPrototype = RegExp.prototype;
$c7104e91dd64cf67$exports = function(R) {
    var flags = R.flags;
    return flags === undefined && !('flags' in $c7104e91dd64cf67$var$RegExpPrototype) && !$35cf4bf79fe152cc$exports(R, 'flags') && $bc714f4a9c09d4bd$exports($c7104e91dd64cf67$var$RegExpPrototype, R) ? $e3ebd8cb7f512f74$exports($88dbfc720887d6c9$exports, R) : flags;
};


var $1bb0dd1568f5470b$exports = {};
'use strict';


// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $1bb0dd1568f5470b$var$$RegExp = $9be6fcc00ef60f58$exports.RegExp;
var $1bb0dd1568f5470b$var$UNSUPPORTED_Y = $06c7d56a730e31f1$exports(function() {
    var re = $1bb0dd1568f5470b$var$$RegExp('a', 'y');
    re.lastIndex = 2;
    return re.exec('abcd') !== null;
});
// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var $1bb0dd1568f5470b$var$MISSED_STICKY = $1bb0dd1568f5470b$var$UNSUPPORTED_Y || $06c7d56a730e31f1$exports(function() {
    return !$1bb0dd1568f5470b$var$$RegExp('a', 'y').sticky;
});
var $1bb0dd1568f5470b$var$BROKEN_CARET = $1bb0dd1568f5470b$var$UNSUPPORTED_Y || $06c7d56a730e31f1$exports(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $1bb0dd1568f5470b$var$$RegExp('^r', 'gy');
    re.lastIndex = 2;
    return re.exec('str') !== null;
});
$1bb0dd1568f5470b$exports = {
    BROKEN_CARET: $1bb0dd1568f5470b$var$BROKEN_CARET,
    MISSED_STICKY: $1bb0dd1568f5470b$var$MISSED_STICKY,
    UNSUPPORTED_Y: $1bb0dd1568f5470b$var$UNSUPPORTED_Y
};


var $30da2950feab59af$exports = {};
'use strict';

var $30da2950feab59af$require$defineProperty = $23cff59c96aeab90$export$2d1720544b23b823;
$30da2950feab59af$exports = function(Target, Source, key) {
    key in Target || $30da2950feab59af$require$defineProperty(Target, key, {
        configurable: true,
        get: function get() {
            return Source[key];
        },
        set: function set(it) {
            Source[key] = it;
        }
    });
};






var $57cb5fa4cccf3fc2$require$enforceInternalState = $419c333d2a5dd5f4$exports.enforce;


var $74d727e8e1d249a9$exports = {};
'use strict';


// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $74d727e8e1d249a9$var$$RegExp = $9be6fcc00ef60f58$exports.RegExp;
$74d727e8e1d249a9$exports = $06c7d56a730e31f1$exports(function() {
    var re = $74d727e8e1d249a9$var$$RegExp('.', 's');
    return !(re.dotAll && re.test('\n') && re.flags === 's');
});


var $04f7a103e1f839db$exports = {};
'use strict';


// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $04f7a103e1f839db$var$$RegExp = $9be6fcc00ef60f58$exports.RegExp;
$04f7a103e1f839db$exports = $06c7d56a730e31f1$exports(function() {
    var re = $04f7a103e1f839db$var$$RegExp('(?<a>b)', 'g');
    return re.exec('b').groups.a !== 'b' || 'b'.replace(re, '$<a>c') !== 'bc';
});


var $57cb5fa4cccf3fc2$var$MATCH = $6268abd12745dd3b$exports('match');
var $57cb5fa4cccf3fc2$var$NativeRegExp = $9be6fcc00ef60f58$exports.RegExp;
var $57cb5fa4cccf3fc2$var$RegExpPrototype = $57cb5fa4cccf3fc2$var$NativeRegExp.prototype;
var $57cb5fa4cccf3fc2$var$SyntaxError = $9be6fcc00ef60f58$exports.SyntaxError;
var $57cb5fa4cccf3fc2$var$exec = $1689570c06db508b$exports($57cb5fa4cccf3fc2$var$RegExpPrototype.exec);
var $57cb5fa4cccf3fc2$var$charAt = $1689570c06db508b$exports(''.charAt);
var $57cb5fa4cccf3fc2$var$replace = $1689570c06db508b$exports(''.replace);
var $57cb5fa4cccf3fc2$var$stringIndexOf = $1689570c06db508b$exports(''.indexOf);
var $57cb5fa4cccf3fc2$var$stringSlice = $1689570c06db508b$exports(''.slice);
// TODO: Use only proper RegExpIdentifierName
var $57cb5fa4cccf3fc2$var$IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var $57cb5fa4cccf3fc2$var$re1 = /a/g;
var $57cb5fa4cccf3fc2$var$re2 = /a/g;
// "new" should create a new object, old webkit bug
var $57cb5fa4cccf3fc2$var$CORRECT_NEW = new $57cb5fa4cccf3fc2$var$NativeRegExp($57cb5fa4cccf3fc2$var$re1) !== $57cb5fa4cccf3fc2$var$re1;
var $57cb5fa4cccf3fc2$var$MISSED_STICKY = $1bb0dd1568f5470b$exports.MISSED_STICKY;
var $57cb5fa4cccf3fc2$var$UNSUPPORTED_Y = $1bb0dd1568f5470b$exports.UNSUPPORTED_Y;
var $57cb5fa4cccf3fc2$var$BASE_FORCED = $6ffb7908e83cf36c$exports && (!$57cb5fa4cccf3fc2$var$CORRECT_NEW || $57cb5fa4cccf3fc2$var$MISSED_STICKY || $74d727e8e1d249a9$exports || $04f7a103e1f839db$exports || $06c7d56a730e31f1$exports(function() {
    $57cb5fa4cccf3fc2$var$re2[$57cb5fa4cccf3fc2$var$MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    // eslint-disable-next-line sonarjs/inconsistent-function-call -- required for testing
    return $57cb5fa4cccf3fc2$var$NativeRegExp($57cb5fa4cccf3fc2$var$re1) !== $57cb5fa4cccf3fc2$var$re1 || $57cb5fa4cccf3fc2$var$NativeRegExp($57cb5fa4cccf3fc2$var$re2) === $57cb5fa4cccf3fc2$var$re2 || String($57cb5fa4cccf3fc2$var$NativeRegExp($57cb5fa4cccf3fc2$var$re1, 'i')) !== '/a/i';
}));
var $57cb5fa4cccf3fc2$var$handleDotAll = function handleDotAll(string) {
    var length = string.length;
    var index = 0;
    var result = '';
    var brackets = false;
    var chr;
    for(; index <= length; index++){
        chr = $57cb5fa4cccf3fc2$var$charAt(string, index);
        if (chr === '\\') {
            result += chr + $57cb5fa4cccf3fc2$var$charAt(string, ++index);
            continue;
        }
        if (!brackets && chr === '.') result += '[\\s\\S]';
        else {
            if (chr === '[') brackets = true;
            else if (chr === ']') brackets = false;
            result += chr;
        }
    }
    return result;
};
var $57cb5fa4cccf3fc2$var$handleNCG = function handleNCG(string) {
    var length = string.length;
    var index = 0;
    var result = '';
    var named = [];
    var names = $c8a7d59657e3f14b$exports(null);
    var brackets = false;
    var ncg = false;
    var groupid = 0;
    var groupname = '';
    var chr;
    for(; index <= length; index++){
        chr = $57cb5fa4cccf3fc2$var$charAt(string, index);
        if (chr === '\\') chr += $57cb5fa4cccf3fc2$var$charAt(string, ++index);
        else if (chr === ']') brackets = false;
        else if (!brackets) switch(true){
            case chr === '[':
                brackets = true;
                break;
            case chr === '(':
                result += chr;
                // ignore non-capturing groups
                if ($57cb5fa4cccf3fc2$var$stringSlice(string, index + 1, index + 3) === '?:') continue;
                if ($57cb5fa4cccf3fc2$var$exec($57cb5fa4cccf3fc2$var$IS_NCG, $57cb5fa4cccf3fc2$var$stringSlice(string, index + 1))) {
                    index += 2;
                    ncg = true;
                }
                groupid++;
                continue;
            case chr === '>' && ncg:
                if (groupname === '' || $35cf4bf79fe152cc$exports(names, groupname)) throw new $57cb5fa4cccf3fc2$var$SyntaxError('Invalid capture group name');
                names[groupname] = true;
                named[named.length] = [
                    groupname,
                    groupid
                ];
                ncg = false;
                groupname = '';
                continue;
        }
        if (ncg) groupname += chr;
        else result += chr;
    }
    return [
        result,
        named
    ];
};
// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if ($1aa429f267e7bd69$exports('RegExp', $57cb5fa4cccf3fc2$var$BASE_FORCED)) {
    var $57cb5fa4cccf3fc2$var$RegExpWrapper = function RegExp(pattern, flags) {
        var thisIsRegExp = $bc714f4a9c09d4bd$exports($57cb5fa4cccf3fc2$var$RegExpPrototype, this);
        var patternIsRegExp = $3f41fa99899046f0$exports(pattern);
        var flagsAreUndefined = flags === undefined;
        var groups = [];
        var rawPattern = pattern;
        var rawFlags, dotAll, sticky, handled, result, state;
        if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === $57cb5fa4cccf3fc2$var$RegExpWrapper) return pattern;
        if (patternIsRegExp || $bc714f4a9c09d4bd$exports($57cb5fa4cccf3fc2$var$RegExpPrototype, pattern)) {
            pattern = pattern.source;
            if (flagsAreUndefined) flags = $c7104e91dd64cf67$exports(rawPattern);
        }
        pattern = pattern === undefined ? '' : $f4fff477af530dca$exports(pattern);
        flags = flags === undefined ? '' : $f4fff477af530dca$exports(flags);
        rawPattern = pattern;
        if ($74d727e8e1d249a9$exports && 'dotAll' in $57cb5fa4cccf3fc2$var$re1) {
            dotAll = !!flags && $57cb5fa4cccf3fc2$var$stringIndexOf(flags, 's') > -1;
            if (dotAll) flags = $57cb5fa4cccf3fc2$var$replace(flags, /s/g, '');
        }
        rawFlags = flags;
        if ($57cb5fa4cccf3fc2$var$MISSED_STICKY && 'sticky' in $57cb5fa4cccf3fc2$var$re1) {
            sticky = !!flags && $57cb5fa4cccf3fc2$var$stringIndexOf(flags, 'y') > -1;
            if (sticky && $57cb5fa4cccf3fc2$var$UNSUPPORTED_Y) flags = $57cb5fa4cccf3fc2$var$replace(flags, /y/g, '');
        }
        if ($04f7a103e1f839db$exports) {
            handled = $57cb5fa4cccf3fc2$var$handleNCG(pattern);
            pattern = handled[0];
            groups = handled[1];
        }
        result = $8388ec23a46a9286$exports($57cb5fa4cccf3fc2$var$NativeRegExp(pattern, flags), thisIsRegExp ? this : $57cb5fa4cccf3fc2$var$RegExpPrototype, $57cb5fa4cccf3fc2$var$RegExpWrapper);
        if (dotAll || sticky || groups.length) {
            state = $57cb5fa4cccf3fc2$require$enforceInternalState(result);
            if (dotAll) {
                state.dotAll = true;
                state.raw = $57cb5fa4cccf3fc2$var$RegExpWrapper($57cb5fa4cccf3fc2$var$handleDotAll(pattern), rawFlags);
            }
            if (sticky) state.sticky = true;
            if (groups.length) state.groups = groups;
        }
        if (pattern !== rawPattern) try {
            // fails in old engines, but we have no alternatives for unsupported regex syntax
            $5b5bc07d688591ac$exports(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
        } catch (error) {}
        return result;
    };
    for(var $57cb5fa4cccf3fc2$var$keys = $57cb5fa4cccf3fc2$require$getOwnPropertyNames($57cb5fa4cccf3fc2$var$NativeRegExp), $57cb5fa4cccf3fc2$var$index = 0; $57cb5fa4cccf3fc2$var$keys.length > $57cb5fa4cccf3fc2$var$index;)$30da2950feab59af$exports($57cb5fa4cccf3fc2$var$RegExpWrapper, $57cb5fa4cccf3fc2$var$NativeRegExp, $57cb5fa4cccf3fc2$var$keys[$57cb5fa4cccf3fc2$var$index++]);
    $57cb5fa4cccf3fc2$var$RegExpPrototype.constructor = $57cb5fa4cccf3fc2$var$RegExpWrapper;
    $57cb5fa4cccf3fc2$var$RegExpWrapper.prototype = $57cb5fa4cccf3fc2$var$RegExpPrototype;
    $b817bfc251eac07c$exports($9be6fcc00ef60f58$exports, 'RegExp', $57cb5fa4cccf3fc2$var$RegExpWrapper, {
        constructor: true
    });
}
// https://tc39.es/ecma262/#sec-get-regexp-@@species
$8db167be81e78b6c$exports('RegExp');


'use strict';

var $0a9a3c2c6a999f2d$exports = {};
'use strict';








var $0a9a3c2c6a999f2d$require$getInternalState = $419c333d2a5dd5f4$exports.get;


var $0a9a3c2c6a999f2d$var$nativeReplace = $cc5c269a44b6e335$exports('native-string-replace', String.prototype.replace);
var $0a9a3c2c6a999f2d$var$nativeExec = RegExp.prototype.exec;
var $0a9a3c2c6a999f2d$var$patchedExec = $0a9a3c2c6a999f2d$var$nativeExec;
var $0a9a3c2c6a999f2d$var$charAt = $1689570c06db508b$exports(''.charAt);
var $0a9a3c2c6a999f2d$var$indexOf = $1689570c06db508b$exports(''.indexOf);
var $0a9a3c2c6a999f2d$var$replace = $1689570c06db508b$exports(''.replace);
var $0a9a3c2c6a999f2d$var$stringSlice = $1689570c06db508b$exports(''.slice);
var $0a9a3c2c6a999f2d$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/;
    var re2 = /b*/g;
    $e3ebd8cb7f512f74$exports($0a9a3c2c6a999f2d$var$nativeExec, re1, 'a');
    $e3ebd8cb7f512f74$exports($0a9a3c2c6a999f2d$var$nativeExec, re2, 'a');
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var $0a9a3c2c6a999f2d$var$UNSUPPORTED_Y = $1bb0dd1568f5470b$exports.BROKEN_CARET;
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $0a9a3c2c6a999f2d$var$NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
var $0a9a3c2c6a999f2d$var$PATCH = $0a9a3c2c6a999f2d$var$UPDATES_LAST_INDEX_WRONG || $0a9a3c2c6a999f2d$var$NPCG_INCLUDED || $0a9a3c2c6a999f2d$var$UNSUPPORTED_Y || $74d727e8e1d249a9$exports || $04f7a103e1f839db$exports;
if ($0a9a3c2c6a999f2d$var$PATCH) $0a9a3c2c6a999f2d$var$patchedExec = function exec(string) {
    var re = this;
    var state = $0a9a3c2c6a999f2d$require$getInternalState(re);
    var str = $f4fff477af530dca$exports(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;
    if (raw) {
        raw.lastIndex = re.lastIndex;
        result = $e3ebd8cb7f512f74$exports($0a9a3c2c6a999f2d$var$patchedExec, raw, str);
        re.lastIndex = raw.lastIndex;
        return result;
    }
    var groups = state.groups;
    var sticky = $0a9a3c2c6a999f2d$var$UNSUPPORTED_Y && re.sticky;
    var flags = $e3ebd8cb7f512f74$exports($88dbfc720887d6c9$exports, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
        flags = $0a9a3c2c6a999f2d$var$replace(flags, 'y', '');
        if ($0a9a3c2c6a999f2d$var$indexOf(flags, 'g') === -1) flags += 'g';
        strCopy = $0a9a3c2c6a999f2d$var$stringSlice(str, re.lastIndex);
        // Support anchored sticky behavior.
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && $0a9a3c2c6a999f2d$var$charAt(str, re.lastIndex - 1) !== '\n')) {
            source = '(?: ' + source + ')';
            strCopy = ' ' + strCopy;
            charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp('^(?:' + source + ')', flags);
    }
    if ($0a9a3c2c6a999f2d$var$NPCG_INCLUDED) reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    if ($0a9a3c2c6a999f2d$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = $e3ebd8cb7f512f74$exports($0a9a3c2c6a999f2d$var$nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
        if (match) {
            match.input = $0a9a3c2c6a999f2d$var$stringSlice(match.input, charsAdded);
            match[0] = $0a9a3c2c6a999f2d$var$stringSlice(match[0], charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
    } else if ($0a9a3c2c6a999f2d$var$UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    if ($0a9a3c2c6a999f2d$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
    $e3ebd8cb7f512f74$exports($0a9a3c2c6a999f2d$var$nativeReplace, match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    if (match && groups) {
        match.groups = object = $c8a7d59657e3f14b$exports(null);
        for(i = 0; i < groups.length; i++){
            group = groups[i];
            object[group[0]] = match[group[1]];
        }
    }
    return match;
};
$0a9a3c2c6a999f2d$exports = $0a9a3c2c6a999f2d$var$patchedExec;


// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$500d5d8b5806b834$exports({
    target: 'RegExp',
    proto: true,
    forced: /./.exec !== $0a9a3c2c6a999f2d$exports
}, {
    exec: $0a9a3c2c6a999f2d$exports
});


'use strict';





// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var $0a71722f6db0dbf4$var$RegExp = $9be6fcc00ef60f58$exports.RegExp;
var $0a71722f6db0dbf4$var$RegExpPrototype = $0a71722f6db0dbf4$var$RegExp.prototype;
var $0a71722f6db0dbf4$var$FORCED = $6ffb7908e83cf36c$exports && $06c7d56a730e31f1$exports(function() {
    var INDICES_SUPPORT = true;
    try {
        $0a71722f6db0dbf4$var$RegExp('.', 'd');
    } catch (error) {
        INDICES_SUPPORT = false;
    }
    var O = {};
    // modern V8 bug
    var calls = '';
    var expected = INDICES_SUPPORT ? 'dgimsy' : 'gimsy';
    var addGetter = function addGetter(key, chr) {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty(O, key, {
            get: function get() {
                calls += chr;
                return true;
            }
        });
    };
    var pairs = {
        dotAll: 's',
        global: 'g',
        ignoreCase: 'i',
        multiline: 'm',
        sticky: 'y'
    };
    if (INDICES_SUPPORT) pairs.hasIndices = 'd';
    for(var key in pairs)addGetter(key, pairs[key]);
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var result = Object.getOwnPropertyDescriptor($0a71722f6db0dbf4$var$RegExpPrototype, 'flags').get.call(O);
    return result !== expected || calls !== expected;
});
// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if ($0a71722f6db0dbf4$var$FORCED) $6de7996ceea81cf8$exports($0a71722f6db0dbf4$var$RegExpPrototype, 'flags', {
    configurable: true,
    get: $88dbfc720887d6c9$exports
});


'use strict';

var $ec72f91873319d94$require$PROPER_FUNCTION_NAME = $61a1b81c88c8f190$exports.PROPER;





var $ec72f91873319d94$var$TO_STRING = 'toString';
var $ec72f91873319d94$var$RegExpPrototype = RegExp.prototype;
var $ec72f91873319d94$var$nativeToString = $ec72f91873319d94$var$RegExpPrototype[$ec72f91873319d94$var$TO_STRING];
var $ec72f91873319d94$var$NOT_GENERIC = $06c7d56a730e31f1$exports(function() {
    return $ec72f91873319d94$var$nativeToString.call({
        source: 'a',
        flags: 'b'
    }) !== '/a/b';
});
// FF44- RegExp#toString has a wrong name
var $ec72f91873319d94$var$INCORRECT_NAME = $ec72f91873319d94$require$PROPER_FUNCTION_NAME && $ec72f91873319d94$var$nativeToString.name !== $ec72f91873319d94$var$TO_STRING;
// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if ($ec72f91873319d94$var$NOT_GENERIC || $ec72f91873319d94$var$INCORRECT_NAME) $b817bfc251eac07c$exports($ec72f91873319d94$var$RegExpPrototype, $ec72f91873319d94$var$TO_STRING, function toString() {
    var R = $05718fce3232bc84$exports(this);
    var pattern = $f4fff477af530dca$exports(R.source);
    var flags = $f4fff477af530dca$exports($c7104e91dd64cf67$exports(R));
    return '/' + pattern + '/' + flags;
}, {
    unsafe: true
});


'use strict';
'use strict';


// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
$a78fa382baf6bf1e$exports('Set', function(init) {
    return function Set() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $1ab4cd3abd7ac36a$exports);




'use strict';

var $2a3378023c0e1c1b$exports = {};
'use strict';




var $2a3378023c0e1c1b$var$charAt = $1689570c06db508b$exports(''.charAt);
var $2a3378023c0e1c1b$var$charCodeAt = $1689570c06db508b$exports(''.charCodeAt);
var $2a3378023c0e1c1b$var$stringSlice = $1689570c06db508b$exports(''.slice);
var $2a3378023c0e1c1b$var$createMethod = function createMethod(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $f4fff477af530dca$exports($fdf84a64c2f63ac3$exports($this));
        var position = $4508997bd0ba9879$exports(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
        first = $2a3378023c0e1c1b$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $2a3378023c0e1c1b$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $2a3378023c0e1c1b$var$charAt(S, position) : first : CONVERT_TO_STRING ? $2a3378023c0e1c1b$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
$2a3378023c0e1c1b$exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $2a3378023c0e1c1b$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $2a3378023c0e1c1b$var$createMethod(true)
};


var $63ec93a9acc84963$require$codeAt = $2a3378023c0e1c1b$exports.codeAt;
// `String.prototype.codePointAt` method
// https://tc39.es/ecma262/#sec-string.prototype.codepointat
$500d5d8b5806b834$exports({
    target: 'String',
    proto: true
}, {
    codePointAt: function codePointAt(pos) {
        return $63ec93a9acc84963$require$codeAt(this, pos);
    }
});


'use strict';



var $cc9d25750827c97b$require$getOwnPropertyDescriptor = $bb417845773708b5$export$2d1720544b23b823;


var $410bedce13320863$exports = {};
'use strict';

var $410bedce13320863$var$$TypeError = TypeError;
$410bedce13320863$exports = function(it) {
    if ($3f41fa99899046f0$exports(it)) throw new $410bedce13320863$var$$TypeError("The method doesn't accept regular expressions");
    return it;
};



var $9579f20b415febbf$exports = {};
'use strict';

var $9579f20b415febbf$var$MATCH = $6268abd12745dd3b$exports('match');
$9579f20b415febbf$exports = function(METHOD_NAME) {
    var regexp = /./;
    try {
        '/./'[METHOD_NAME](regexp);
    } catch (error1) {
        try {
            regexp[$9579f20b415febbf$var$MATCH] = false;
            return '/./'[METHOD_NAME](regexp);
        } catch (error2) {}
    }
    return false;
};



var $cc9d25750827c97b$var$slice = $010fa6fc9394de19$exports(''.slice);
var $cc9d25750827c97b$var$min = Math.min;
var $cc9d25750827c97b$var$CORRECT_IS_REGEXP_LOGIC = $9579f20b415febbf$exports('endsWith');
// https://github.com/zloirock/core-js/pull/702
var $cc9d25750827c97b$var$MDN_POLYFILL_BUG = !$62bf9cf43d01f7ec$exports && !$cc9d25750827c97b$var$CORRECT_IS_REGEXP_LOGIC && !!function() {
    var descriptor = $cc9d25750827c97b$require$getOwnPropertyDescriptor(String.prototype, 'endsWith');
    return descriptor && !descriptor.writable;
}();
// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$500d5d8b5806b834$exports({
    target: 'String',
    proto: true,
    forced: !$cc9d25750827c97b$var$MDN_POLYFILL_BUG && !$cc9d25750827c97b$var$CORRECT_IS_REGEXP_LOGIC
}, {
    endsWith: function endsWith(searchString /* , endPosition = @length */ ) {
        var that = $f4fff477af530dca$exports($fdf84a64c2f63ac3$exports(this));
        $410bedce13320863$exports(searchString);
        var endPosition = arguments.length > 1 ? arguments[1] : undefined;
        var len = that.length;
        var end = endPosition === undefined ? len : $cc9d25750827c97b$var$min($d14e7a9632dda07a$exports(endPosition), len);
        var search = $f4fff477af530dca$exports(searchString);
        return $cc9d25750827c97b$var$slice(that, end - search.length, end) === search;
    }
});


'use strict';



var $80f3d279e61e254d$var$$RangeError = RangeError;
var $80f3d279e61e254d$var$fromCharCode = String.fromCharCode;
// eslint-disable-next-line es/no-string-fromcodepoint -- required for testing
var $80f3d279e61e254d$var$$fromCodePoint = String.fromCodePoint;
var $80f3d279e61e254d$var$join = $1689570c06db508b$exports([].join);
// length should be 1, old FF problem
var $80f3d279e61e254d$var$INCORRECT_LENGTH = !!$80f3d279e61e254d$var$$fromCodePoint && $80f3d279e61e254d$var$$fromCodePoint.length !== 1;
// `String.fromCodePoint` method
// https://tc39.es/ecma262/#sec-string.fromcodepoint
$500d5d8b5806b834$exports({
    target: 'String',
    stat: true,
    arity: 1,
    forced: $80f3d279e61e254d$var$INCORRECT_LENGTH
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    fromCodePoint: function fromCodePoint(x) {
        var elements = [];
        var length = arguments.length;
        var i = 0;
        var code;
        while(length > i){
            code = +arguments[i++];
            if ($d78d48da15e9c8eb$exports(code, 0x10FFFF) !== code) throw new $80f3d279e61e254d$var$$RangeError(code + ' is not a valid code point');
            elements[i] = code < 0x10000 ? $80f3d279e61e254d$var$fromCharCode(code) : $80f3d279e61e254d$var$fromCharCode(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00);
        }
        return $80f3d279e61e254d$var$join(elements, '');
    }
});


'use strict';






var $fab9fc2d35f3b8a7$var$stringIndexOf = $1689570c06db508b$exports(''.indexOf);
// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$500d5d8b5806b834$exports({
    target: 'String',
    proto: true,
    forced: !$9579f20b415febbf$exports('includes')
}, {
    includes: function includes(searchString /* , position = 0 */ ) {
        return !!~$fab9fc2d35f3b8a7$var$stringIndexOf($f4fff477af530dca$exports($fdf84a64c2f63ac3$exports(this)), $f4fff477af530dca$exports($410bedce13320863$exports(searchString)), arguments.length > 1 ? arguments[1] : undefined);
    }
});


'use strict';

var $5acf07ebe0f6acae$require$charAt = $2a3378023c0e1c1b$exports.charAt;




var $5acf07ebe0f6acae$var$STRING_ITERATOR = 'String Iterator';
var $5acf07ebe0f6acae$var$setInternalState = $419c333d2a5dd5f4$exports.set;
var $5acf07ebe0f6acae$var$getInternalState = $419c333d2a5dd5f4$exports.getterFor($5acf07ebe0f6acae$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$29372d36a55fcc4a$exports(String, 'String', function(iterated) {
    $5acf07ebe0f6acae$var$setInternalState(this, {
        type: $5acf07ebe0f6acae$var$STRING_ITERATOR,
        string: $f4fff477af530dca$exports(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $5acf07ebe0f6acae$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $e026e44558cad06d$exports(undefined, true);
    point = $5acf07ebe0f6acae$require$charAt(string, index);
    state.index += point.length;
    return $e026e44558cad06d$exports(point, false);
});


'use strict';

var $fb7b54d734af56c0$exports = {};
'use strict';







var $fb7b54d734af56c0$var$SPECIES = $6268abd12745dd3b$exports('species');
var $fb7b54d734af56c0$var$RegExpPrototype = RegExp.prototype;
$fb7b54d734af56c0$exports = function(KEY, exec, FORCED, SHAM) {
    var SYMBOL = $6268abd12745dd3b$exports(KEY);
    var DELEGATES_TO_SYMBOL = !$06c7d56a730e31f1$exports(function() {
        // String methods call symbol-named RegExp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ''[KEY](O) !== 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !$06c7d56a730e31f1$exports(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        if (KEY === 'split') {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            re = {};
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[$fb7b54d734af56c0$var$SPECIES] = function() {
                return re;
            };
            re.flags = '';
            re[SYMBOL] = /./[SYMBOL];
        }
        re.exec = function() {
            execCalled = true;
            return null;
        };
        re[SYMBOL]('');
        return !execCalled;
    });
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var nativeRegExpMethod = /./[SYMBOL];
        var methods = exec(SYMBOL, ''[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var $exec = regexp.exec;
            if ($exec === $0a9a3c2c6a999f2d$exports || $exec === $fb7b54d734af56c0$var$RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: $e3ebd8cb7f512f74$exports(nativeRegExpMethod, regexp, str, arg2)
                };
                return {
                    done: true,
                    value: $e3ebd8cb7f512f74$exports(nativeMethod, str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        $b817bfc251eac07c$exports(String.prototype, KEY, methods[0]);
        $b817bfc251eac07c$exports($fb7b54d734af56c0$var$RegExpPrototype, SYMBOL, methods[1]);
    }
    if (SHAM) $5b5bc07d688591ac$exports($fb7b54d734af56c0$var$RegExpPrototype[SYMBOL], 'sham', true);
};








var $d1b857de1504e16d$exports = {};
'use strict';

var $d1b857de1504e16d$require$charAt = $2a3378023c0e1c1b$exports.charAt;
// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
$d1b857de1504e16d$exports = function(S, index, unicode) {
    return index + (unicode ? $d1b857de1504e16d$require$charAt(S, index).length : 1);
};


var $2d607fc75c8bfba5$exports = {};
'use strict';





var $2d607fc75c8bfba5$var$$TypeError = TypeError;
// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
$2d607fc75c8bfba5$exports = function(R, S) {
    var exec = R.exec;
    if ($0a82f0a5368b6870$exports(exec)) {
        var result = $e3ebd8cb7f512f74$exports(exec, R, S);
        if (result !== null) $05718fce3232bc84$exports(result);
        return result;
    }
    if ($9afeb253af368f01$exports(R) === 'RegExp') return $e3ebd8cb7f512f74$exports($0a9a3c2c6a999f2d$exports, R, S);
    throw new $2d607fc75c8bfba5$var$$TypeError('RegExp#exec called on incompatible receiver');
};


// @@match logic
$fb7b54d734af56c0$exports('match', function(MATCH, nativeMatch, maybeCallNative) {
    return [
        // `String.prototype.match` method
        // https://tc39.es/ecma262/#sec-string.prototype.match
        function match(regexp) {
            var O = $fdf84a64c2f63ac3$exports(this);
            var matcher = $8d82b0b487ce9bb5$exports(regexp) ? undefined : $430a0bdb40365e72$exports(regexp, MATCH);
            return matcher ? $e3ebd8cb7f512f74$exports(matcher, regexp, O) : new RegExp(regexp)[MATCH]($f4fff477af530dca$exports(O));
        },
        // `RegExp.prototype[@@match]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
        function(string) {
            var rx = $05718fce3232bc84$exports(this);
            var S = $f4fff477af530dca$exports(string);
            var res = maybeCallNative(nativeMatch, rx, S);
            if (res.done) return res.value;
            if (!rx.global) return $2d607fc75c8bfba5$exports(rx, S);
            var fullUnicode = rx.unicode;
            rx.lastIndex = 0;
            var A = [];
            var n = 0;
            var result;
            while((result = $2d607fc75c8bfba5$exports(rx, S)) !== null){
                var matchStr = $f4fff477af530dca$exports(result[0]);
                A[n] = matchStr;
                if (matchStr === '') rx.lastIndex = $d1b857de1504e16d$exports(S, $d14e7a9632dda07a$exports(rx.lastIndex), fullUnicode);
                n++;
            }
            return n === 0 ? null : A;
        }
    ];
});


'use strict';


var $fb3726ebe9318b0a$require$$padEnd = $66aebd71bf9ba548$exports.end;
var $b34d0e2fe98a56d8$exports = {};
'use strict';

$b34d0e2fe98a56d8$exports = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test($57973a61a761d756$exports);


// `String.prototype.padEnd` method
// https://tc39.es/ecma262/#sec-string.prototype.padend
$500d5d8b5806b834$exports({
    target: 'String',
    proto: true,
    forced: $b34d0e2fe98a56d8$exports
}, {
    padEnd: function padEnd(maxLength /* , fillString = ' ' */ ) {
        return $fb3726ebe9318b0a$require$$padEnd(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
    }
});


'use strict';


var $1137b68fc0722a55$require$$padStart = $66aebd71bf9ba548$exports.start;

// `String.prototype.padStart` method
// https://tc39.es/ecma262/#sec-string.prototype.padstart
$500d5d8b5806b834$exports({
    target: 'String',
    proto: true,
    forced: $b34d0e2fe98a56d8$exports
}, {
    padStart: function padStart(maxLength /* , fillString = ' ' */ ) {
        return $1137b68fc0722a55$require$$padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
    }
});


'use strict';






var $928c8d6a3558fd98$var$push = $1689570c06db508b$exports([].push);
var $928c8d6a3558fd98$var$join = $1689570c06db508b$exports([].join);
// `String.raw` method
// https://tc39.es/ecma262/#sec-string.raw
$500d5d8b5806b834$exports({
    target: 'String',
    stat: true
}, {
    raw: function raw(template) {
        var rawTemplate = $e656dbd61e0a8253$exports($ec839b558eb5dcf4$exports(template).raw);
        var literalSegments = $f91b2cfe2e3f959b$exports(rawTemplate);
        if (!literalSegments) return '';
        var argumentsLength = arguments.length;
        var elements = [];
        var i = 0;
        while(true){
            $928c8d6a3558fd98$var$push(elements, $f4fff477af530dca$exports(rawTemplate[i++]));
            if (i === literalSegments) return $928c8d6a3558fd98$var$join(elements, '');
            if (i < argumentsLength) $928c8d6a3558fd98$var$push(elements, $f4fff477af530dca$exports(arguments[i]));
        }
    }
});


'use strict';


// `String.prototype.repeat` method
// https://tc39.es/ecma262/#sec-string.prototype.repeat
$500d5d8b5806b834$exports({
    target: 'String',
    proto: true
}, {
    repeat: $05ac5542bb716171$exports
});


'use strict';














var $63d0a6f441e67871$exports = {};
'use strict';


var $63d0a6f441e67871$var$floor = Math.floor;
var $63d0a6f441e67871$var$charAt = $1689570c06db508b$exports(''.charAt);
var $63d0a6f441e67871$var$replace = $1689570c06db508b$exports(''.replace);
var $63d0a6f441e67871$var$stringSlice = $1689570c06db508b$exports(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var $63d0a6f441e67871$var$SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var $63d0a6f441e67871$var$SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
$63d0a6f441e67871$exports = function(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = $63d0a6f441e67871$var$SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
        namedCaptures = $ec839b558eb5dcf4$exports(namedCaptures);
        symbols = $63d0a6f441e67871$var$SUBSTITUTION_SYMBOLS;
    }
    return $63d0a6f441e67871$var$replace(replacement, symbols, function(match, ch) {
        var capture;
        switch($63d0a6f441e67871$var$charAt(ch, 0)){
            case '$':
                return '$';
            case '&':
                return matched;
            case '`':
                return $63d0a6f441e67871$var$stringSlice(str, 0, position);
            case "'":
                return $63d0a6f441e67871$var$stringSlice(str, tailPos);
            case '<':
                capture = namedCaptures[$63d0a6f441e67871$var$stringSlice(ch, 1, -1)];
                break;
            default:
                var n = +ch;
                if (n === 0) return match;
                if (n > m) {
                    var f = $63d0a6f441e67871$var$floor(n / 10);
                    if (f === 0) return match;
                    if (f <= m) return captures[f - 1] === undefined ? $63d0a6f441e67871$var$charAt(ch, 1) : captures[f - 1] + $63d0a6f441e67871$var$charAt(ch, 1);
                    return match;
                }
                capture = captures[n - 1];
        }
        return capture === undefined ? '' : capture;
    });
};




var $ecb224c34cac5302$var$REPLACE = $6268abd12745dd3b$exports('replace');
var $ecb224c34cac5302$var$max = Math.max;
var $ecb224c34cac5302$var$min = Math.min;
var $ecb224c34cac5302$var$concat = $1689570c06db508b$exports([].concat);
var $ecb224c34cac5302$var$push = $1689570c06db508b$exports([].push);
var $ecb224c34cac5302$var$stringIndexOf = $1689570c06db508b$exports(''.indexOf);
var $ecb224c34cac5302$var$stringSlice = $1689570c06db508b$exports(''.slice);
var $ecb224c34cac5302$var$maybeToString = function maybeToString(it) {
    return it === undefined ? it : String(it);
};
// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var $ecb224c34cac5302$var$REPLACE_KEEPS_$0 = function() {
    // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
    return 'a'.replace(/./, '$0') === '$0';
}();
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var $ecb224c34cac5302$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
    if (/./[$ecb224c34cac5302$var$REPLACE]) return /./[$ecb224c34cac5302$var$REPLACE]('a', '$0') === '';
    return false;
}();
var $ecb224c34cac5302$var$REPLACE_SUPPORTS_NAMED_GROUPS = !$06c7d56a730e31f1$exports(function() {
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: '7'
        };
        return result;
    };
    // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
    return ''.replace(re, '$<a>') !== '7';
});
// @@replace logic
$fb7b54d734af56c0$exports('replace', function(_, nativeReplace, maybeCallNative) {
    var UNSAFE_SUBSTITUTE = $ecb224c34cac5302$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';
    return [
        // `String.prototype.replace` method
        // https://tc39.es/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = $fdf84a64c2f63ac3$exports(this);
            var replacer = $8d82b0b487ce9bb5$exports(searchValue) ? undefined : $430a0bdb40365e72$exports(searchValue, $ecb224c34cac5302$var$REPLACE);
            return replacer ? $e3ebd8cb7f512f74$exports(replacer, searchValue, O, replaceValue) : $e3ebd8cb7f512f74$exports(nativeReplace, $f4fff477af530dca$exports(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
        function(string, replaceValue) {
            var rx = $05718fce3232bc84$exports(this);
            var S = $f4fff477af530dca$exports(string);
            if (typeof replaceValue == 'string' && $ecb224c34cac5302$var$stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 && $ecb224c34cac5302$var$stringIndexOf(replaceValue, '$<') === -1) {
                var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                if (res.done) return res.value;
            }
            var functionalReplace = $0a82f0a5368b6870$exports(replaceValue);
            if (!functionalReplace) replaceValue = $f4fff477af530dca$exports(replaceValue);
            var global = rx.global;
            var fullUnicode;
            if (global) {
                fullUnicode = rx.unicode;
                rx.lastIndex = 0;
            }
            var results = [];
            var result;
            while(true){
                result = $2d607fc75c8bfba5$exports(rx, S);
                if (result === null) break;
                $ecb224c34cac5302$var$push(results, result);
                if (!global) break;
                var matchStr = $f4fff477af530dca$exports(result[0]);
                if (matchStr === '') rx.lastIndex = $d1b857de1504e16d$exports(S, $d14e7a9632dda07a$exports(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = '';
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = $f4fff477af530dca$exports(result[0]);
                var position = $ecb224c34cac5302$var$max($ecb224c34cac5302$var$min($4508997bd0ba9879$exports(result.index), S.length), 0);
                var captures = [];
                var replacement;
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)$ecb224c34cac5302$var$push(captures, $ecb224c34cac5302$var$maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = $ecb224c34cac5302$var$concat([
                        matched
                    ], captures, position, S);
                    if (namedCaptures !== undefined) $ecb224c34cac5302$var$push(replacerArgs, namedCaptures);
                    replacement = $f4fff477af530dca$exports($c126e09ab0f7e2a8$exports(replaceValue, undefined, replacerArgs));
                } else replacement = $63d0a6f441e67871$exports(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += $ecb224c34cac5302$var$stringSlice(S, nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + $ecb224c34cac5302$var$stringSlice(S, nextSourcePosition);
        }
    ];
}, !$ecb224c34cac5302$var$REPLACE_SUPPORTS_NAMED_GROUPS || !$ecb224c34cac5302$var$REPLACE_KEEPS_$0 || $ecb224c34cac5302$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


'use strict';









// @@search logic
$fb7b54d734af56c0$exports('search', function(SEARCH, nativeSearch, maybeCallNative) {
    return [
        // `String.prototype.search` method
        // https://tc39.es/ecma262/#sec-string.prototype.search
        function search(regexp) {
            var O = $fdf84a64c2f63ac3$exports(this);
            var searcher = $8d82b0b487ce9bb5$exports(regexp) ? undefined : $430a0bdb40365e72$exports(regexp, SEARCH);
            return searcher ? $e3ebd8cb7f512f74$exports(searcher, regexp, O) : new RegExp(regexp)[SEARCH]($f4fff477af530dca$exports(O));
        },
        // `RegExp.prototype[@@search]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
        function(string) {
            var rx = $05718fce3232bc84$exports(this);
            var S = $f4fff477af530dca$exports(string);
            var res = maybeCallNative(nativeSearch, rx, S);
            if (res.done) return res.value;
            var previousLastIndex = rx.lastIndex;
            if (!$d9de1e6a7d0028b5$exports(previousLastIndex, 0)) rx.lastIndex = 0;
            var result = $2d607fc75c8bfba5$exports(rx, S);
            if (!$d9de1e6a7d0028b5$exports(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
            return result === null ? -1 : result.index;
        }
    ];
});


'use strict';














var $b0f4228ff97151b6$var$UNSUPPORTED_Y = $1bb0dd1568f5470b$exports.UNSUPPORTED_Y;
var $b0f4228ff97151b6$var$MAX_UINT32 = 0xFFFFFFFF;
var $b0f4228ff97151b6$var$min = Math.min;
var $b0f4228ff97151b6$var$push = $1689570c06db508b$exports([].push);
var $b0f4228ff97151b6$var$stringSlice = $1689570c06db508b$exports(''.slice);
// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var $b0f4228ff97151b6$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !$06c7d56a730e31f1$exports(function() {
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    var re = /(?:)/;
    var originalExec = re.exec;
    re.exec = function() {
        return originalExec.apply(this, arguments);
    };
    var result = 'ab'.split(re);
    return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});
var $b0f4228ff97151b6$var$BUGGY = 'abbc'.split(/(b)*/)[1] === 'c' || // eslint-disable-next-line regexp/no-empty-group -- required for testing
'test'.split(/(?:)/, -1).length !== 4 || 'ab'.split(/(?:ab)*/).length !== 2 || '.'.split(/(.?)(.?)/).length !== 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
'.'.split(/()()/).length > 1 || ''.split(/.?/).length;
// @@split logic
$fb7b54d734af56c0$exports('split', function(SPLIT, nativeSplit, maybeCallNative) {
    var internalSplit = '0'.split(undefined, 0).length ? function internalSplit(separator, limit) {
        return separator === undefined && limit === 0 ? [] : $e3ebd8cb7f512f74$exports(nativeSplit, this, separator, limit);
    } : nativeSplit;
    return [
        // `String.prototype.split` method
        // https://tc39.es/ecma262/#sec-string.prototype.split
        function split(separator, limit) {
            var O = $fdf84a64c2f63ac3$exports(this);
            var splitter = $8d82b0b487ce9bb5$exports(separator) ? undefined : $430a0bdb40365e72$exports(separator, SPLIT);
            return splitter ? $e3ebd8cb7f512f74$exports(splitter, separator, O, limit) : $e3ebd8cb7f512f74$exports(internalSplit, $f4fff477af530dca$exports(O), separator, limit);
        },
        // `RegExp.prototype[@@split]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
        //
        // NOTE: This cannot be properly polyfilled in engines that don't support
        // the 'y' flag.
        function(string, limit) {
            var rx = $05718fce3232bc84$exports(this);
            var S = $f4fff477af530dca$exports(string);
            if (!$b0f4228ff97151b6$var$BUGGY) {
                var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
                if (res.done) return res.value;
            }
            var C = $ebf7e01de9701d7b$exports(rx, RegExp);
            var unicodeMatching = rx.unicode;
            var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + ($b0f4228ff97151b6$var$UNSUPPORTED_Y ? 'g' : 'y');
            // ^(? + rx + ) is needed, in combination with some S slicing, to
            // simulate the 'y' flag.
            var splitter = new C($b0f4228ff97151b6$var$UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
            var lim = limit === undefined ? $b0f4228ff97151b6$var$MAX_UINT32 : limit >>> 0;
            if (lim === 0) return [];
            if (S.length === 0) return $2d607fc75c8bfba5$exports(splitter, S) === null ? [
                S
            ] : [];
            var p = 0;
            var q = 0;
            var A = [];
            while(q < S.length){
                splitter.lastIndex = $b0f4228ff97151b6$var$UNSUPPORTED_Y ? 0 : q;
                var z = $2d607fc75c8bfba5$exports(splitter, $b0f4228ff97151b6$var$UNSUPPORTED_Y ? $b0f4228ff97151b6$var$stringSlice(S, q) : S);
                var e;
                if (z === null || (e = $b0f4228ff97151b6$var$min($d14e7a9632dda07a$exports(splitter.lastIndex + ($b0f4228ff97151b6$var$UNSUPPORTED_Y ? q : 0)), S.length)) === p) q = $d1b857de1504e16d$exports(S, q, unicodeMatching);
                else {
                    $b0f4228ff97151b6$var$push(A, $b0f4228ff97151b6$var$stringSlice(S, p, q));
                    if (A.length === lim) return A;
                    for(var i = 1; i <= z.length - 1; i++){
                        $b0f4228ff97151b6$var$push(A, z[i]);
                        if (A.length === lim) return A;
                    }
                    q = p = e;
                }
            }
            $b0f4228ff97151b6$var$push(A, $b0f4228ff97151b6$var$stringSlice(S, p));
            return A;
        }
    ];
}, $b0f4228ff97151b6$var$BUGGY || !$b0f4228ff97151b6$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, $b0f4228ff97151b6$var$UNSUPPORTED_Y);


'use strict';



var $8d7700bb7aa4fdde$require$getOwnPropertyDescriptor = $bb417845773708b5$export$2d1720544b23b823;






var $8d7700bb7aa4fdde$var$stringSlice = $010fa6fc9394de19$exports(''.slice);
var $8d7700bb7aa4fdde$var$min = Math.min;
var $8d7700bb7aa4fdde$var$CORRECT_IS_REGEXP_LOGIC = $9579f20b415febbf$exports('startsWith');
// https://github.com/zloirock/core-js/pull/702
var $8d7700bb7aa4fdde$var$MDN_POLYFILL_BUG = !$62bf9cf43d01f7ec$exports && !$8d7700bb7aa4fdde$var$CORRECT_IS_REGEXP_LOGIC && !!function() {
    var descriptor = $8d7700bb7aa4fdde$require$getOwnPropertyDescriptor(String.prototype, 'startsWith');
    return descriptor && !descriptor.writable;
}();
// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$500d5d8b5806b834$exports({
    target: 'String',
    proto: true,
    forced: !$8d7700bb7aa4fdde$var$MDN_POLYFILL_BUG && !$8d7700bb7aa4fdde$var$CORRECT_IS_REGEXP_LOGIC
}, {
    startsWith: function startsWith(searchString /* , position = 0 */ ) {
        var that = $f4fff477af530dca$exports($fdf84a64c2f63ac3$exports(this));
        $410bedce13320863$exports(searchString);
        var index = $d14e7a9632dda07a$exports($8d7700bb7aa4fdde$var$min(arguments.length > 1 ? arguments[1] : undefined, that.length));
        var search = $f4fff477af530dca$exports(searchString);
        return $8d7700bb7aa4fdde$var$stringSlice(that, index, index + search.length) === search;
    }
});


'use strict';


var $663b5e283f85e76c$require$$trim = $1e0ce41924eafd61$exports.trim;
var $e015cf1767b96634$exports = {};
'use strict';

var $e015cf1767b96634$require$PROPER_FUNCTION_NAME = $61a1b81c88c8f190$exports.PROPER;


var $e015cf1767b96634$var$non = '\u200B\u0085\u180E';
// check that a method works with the correct list
// of whitespaces and has a correct name
$e015cf1767b96634$exports = function(METHOD_NAME) {
    return $06c7d56a730e31f1$exports(function() {
        return !!$e32455e9fd1e1d3c$exports[METHOD_NAME]() || $e015cf1767b96634$var$non[METHOD_NAME]() !== $e015cf1767b96634$var$non || $e015cf1767b96634$require$PROPER_FUNCTION_NAME && $e32455e9fd1e1d3c$exports[METHOD_NAME].name !== METHOD_NAME;
    });
};


// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$500d5d8b5806b834$exports({
    target: 'String',
    proto: true,
    forced: $e015cf1767b96634$exports('trim')
}, {
    trim: function trim() {
        return $663b5e283f85e76c$require$$trim(this);
    }
});


'use strict';
'use strict';

var $936b82f24da52076$exports = {};
'use strict';

var $936b82f24da52076$require$$trimEnd = $1e0ce41924eafd61$exports.end;

// `String.prototype.{ trimEnd, trimRight }` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// https://tc39.es/ecma262/#String.prototype.trimright
$936b82f24da52076$exports = $e015cf1767b96634$exports('trimEnd') ? function trimEnd() {
    return $936b82f24da52076$require$$trimEnd(this);
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
} : ''.trimEnd;


// `String.prototype.trimRight` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// eslint-disable-next-line es/no-string-prototype-trimleft-trimright -- safe
$500d5d8b5806b834$exports({
    target: 'String',
    proto: true,
    name: 'trimEnd',
    forced: ''.trimRight !== $936b82f24da52076$exports
}, {
    trimRight: $936b82f24da52076$exports
});




// `String.prototype.trimEnd` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
$500d5d8b5806b834$exports({
    target: 'String',
    proto: true,
    name: 'trimEnd',
    forced: ''.trimEnd !== $936b82f24da52076$exports
}, {
    trimEnd: $936b82f24da52076$exports
});


'use strict';
'use strict';

var $66f38896c6cf4481$exports = {};
'use strict';

var $66f38896c6cf4481$require$$trimStart = $1e0ce41924eafd61$exports.start;

// `String.prototype.{ trimStart, trimLeft }` method
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// https://tc39.es/ecma262/#String.prototype.trimleft
$66f38896c6cf4481$exports = $e015cf1767b96634$exports('trimStart') ? function trimStart() {
    return $66f38896c6cf4481$require$$trimStart(this);
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
} : ''.trimStart;


// `String.prototype.trimLeft` method
// https://tc39.es/ecma262/#sec-string.prototype.trimleft
// eslint-disable-next-line es/no-string-prototype-trimleft-trimright -- safe
$500d5d8b5806b834$exports({
    target: 'String',
    proto: true,
    name: 'trimStart',
    forced: ''.trimLeft !== $66f38896c6cf4481$exports
}, {
    trimLeft: $66f38896c6cf4481$exports
});




// `String.prototype.trimStart` method
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
$500d5d8b5806b834$exports({
    target: 'String',
    proto: true,
    name: 'trimStart',
    forced: ''.trimStart !== $66f38896c6cf4481$exports
}, {
    trimStart: $66f38896c6cf4481$exports
});


'use strict';

var $92f31ed2357f577f$exports = {};
'use strict';



var $92f31ed2357f577f$var$quot = /"/g;
var $92f31ed2357f577f$var$replace = $1689570c06db508b$exports(''.replace);
// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
$92f31ed2357f577f$exports = function(string, tag, attribute, value) {
    var S = $f4fff477af530dca$exports($fdf84a64c2f63ac3$exports(string));
    var p1 = '<' + tag;
    if (attribute !== '') p1 += ' ' + attribute + '="' + $92f31ed2357f577f$var$replace($f4fff477af530dca$exports(value), $92f31ed2357f577f$var$quot, '&quot;') + '"';
    return p1 + '>' + S + '</' + tag + '>';
};


var $086e89c26b5a10d2$exports = {};
'use strict';

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
$086e89c26b5a10d2$exports = function(METHOD_NAME) {
    return $06c7d56a730e31f1$exports(function() {
        var test = ''[METHOD_NAME]('"');
        return test !== test.toLowerCase() || test.split('"').length > 3;
    });
};


// `String.prototype.anchor` method
// https://tc39.es/ecma262/#sec-string.prototype.anchor
$500d5d8b5806b834$exports({
    target: 'String',
    proto: true,
    forced: $086e89c26b5a10d2$exports('anchor')
}, {
    anchor: function anchor(name) {
        return $92f31ed2357f577f$exports(this, 'a', 'name', name);
    }
});


'use strict';



// `String.prototype.big` method
// https://tc39.es/ecma262/#sec-string.prototype.big
$500d5d8b5806b834$exports({
    target: 'String',
    proto: true,
    forced: $086e89c26b5a10d2$exports('big')
}, {
    big: function big() {
        return $92f31ed2357f577f$exports(this, 'big', '', '');
    }
});


'use strict';



// `String.prototype.blink` method
// https://tc39.es/ecma262/#sec-string.prototype.blink
$500d5d8b5806b834$exports({
    target: 'String',
    proto: true,
    forced: $086e89c26b5a10d2$exports('blink')
}, {
    blink: function blink() {
        return $92f31ed2357f577f$exports(this, 'blink', '', '');
    }
});


'use strict';



// `String.prototype.bold` method
// https://tc39.es/ecma262/#sec-string.prototype.bold
$500d5d8b5806b834$exports({
    target: 'String',
    proto: true,
    forced: $086e89c26b5a10d2$exports('bold')
}, {
    bold: function bold() {
        return $92f31ed2357f577f$exports(this, 'b', '', '');
    }
});


'use strict';



// `String.prototype.fixed` method
// https://tc39.es/ecma262/#sec-string.prototype.fixed
$500d5d8b5806b834$exports({
    target: 'String',
    proto: true,
    forced: $086e89c26b5a10d2$exports('fixed')
}, {
    fixed: function fixed() {
        return $92f31ed2357f577f$exports(this, 'tt', '', '');
    }
});


'use strict';



// `String.prototype.fontcolor` method
// https://tc39.es/ecma262/#sec-string.prototype.fontcolor
$500d5d8b5806b834$exports({
    target: 'String',
    proto: true,
    forced: $086e89c26b5a10d2$exports('fontcolor')
}, {
    fontcolor: function fontcolor(color) {
        return $92f31ed2357f577f$exports(this, 'font', 'color', color);
    }
});


'use strict';



// `String.prototype.fontsize` method
// https://tc39.es/ecma262/#sec-string.prototype.fontsize
$500d5d8b5806b834$exports({
    target: 'String',
    proto: true,
    forced: $086e89c26b5a10d2$exports('fontsize')
}, {
    fontsize: function fontsize(size) {
        return $92f31ed2357f577f$exports(this, 'font', 'size', size);
    }
});


'use strict';



// `String.prototype.italics` method
// https://tc39.es/ecma262/#sec-string.prototype.italics
$500d5d8b5806b834$exports({
    target: 'String',
    proto: true,
    forced: $086e89c26b5a10d2$exports('italics')
}, {
    italics: function italics() {
        return $92f31ed2357f577f$exports(this, 'i', '', '');
    }
});


'use strict';



// `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link
$500d5d8b5806b834$exports({
    target: 'String',
    proto: true,
    forced: $086e89c26b5a10d2$exports('link')
}, {
    link: function link(url) {
        return $92f31ed2357f577f$exports(this, 'a', 'href', url);
    }
});


'use strict';



// `String.prototype.small` method
// https://tc39.es/ecma262/#sec-string.prototype.small
$500d5d8b5806b834$exports({
    target: 'String',
    proto: true,
    forced: $086e89c26b5a10d2$exports('small')
}, {
    small: function small() {
        return $92f31ed2357f577f$exports(this, 'small', '', '');
    }
});


'use strict';



// `String.prototype.strike` method
// https://tc39.es/ecma262/#sec-string.prototype.strike
$500d5d8b5806b834$exports({
    target: 'String',
    proto: true,
    forced: $086e89c26b5a10d2$exports('strike')
}, {
    strike: function strike() {
        return $92f31ed2357f577f$exports(this, 'strike', '', '');
    }
});


'use strict';



// `String.prototype.sub` method
// https://tc39.es/ecma262/#sec-string.prototype.sub
$500d5d8b5806b834$exports({
    target: 'String',
    proto: true,
    forced: $086e89c26b5a10d2$exports('sub')
}, {
    sub: function sub() {
        return $92f31ed2357f577f$exports(this, 'sub', '', '');
    }
});


'use strict';



// `String.prototype.sup` method
// https://tc39.es/ecma262/#sec-string.prototype.sup
$500d5d8b5806b834$exports({
    target: 'String',
    proto: true,
    forced: $086e89c26b5a10d2$exports('sup')
}, {
    sup: function sup() {
        return $92f31ed2357f577f$exports(this, 'sup', '', '');
    }
});


'use strict';
var $e96cb64ebc7b7356$exports = {};
'use strict';




var $3951dd99bc53fcb4$exports = {};
'use strict';




var $3951dd99bc53fcb4$require$NATIVE_ARRAY_BUFFER_VIEWS = $14c7b05570ea7e40$exports.NATIVE_ARRAY_BUFFER_VIEWS;
var $3951dd99bc53fcb4$var$ArrayBuffer = $9be6fcc00ef60f58$exports.ArrayBuffer;
var $3951dd99bc53fcb4$var$Int8Array = $9be6fcc00ef60f58$exports.Int8Array;
$3951dd99bc53fcb4$exports = !$3951dd99bc53fcb4$require$NATIVE_ARRAY_BUFFER_VIEWS || !$06c7d56a730e31f1$exports(function() {
    $3951dd99bc53fcb4$var$Int8Array(1);
}) || !$06c7d56a730e31f1$exports(function() {
    new $3951dd99bc53fcb4$var$Int8Array(-1);
}) || !$02438b0b93cfa696$exports(function(iterable) {
    new $3951dd99bc53fcb4$var$Int8Array();
    new $3951dd99bc53fcb4$var$Int8Array(null);
    new $3951dd99bc53fcb4$var$Int8Array(1.5);
    new $3951dd99bc53fcb4$var$Int8Array(iterable);
}, true) || $06c7d56a730e31f1$exports(function() {
    // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
    return new $3951dd99bc53fcb4$var$Int8Array(new $3951dd99bc53fcb4$var$ArrayBuffer(2), 1, undefined).length !== 1;
});










var $f95f56f41e8f56d7$exports = {};
'use strict';
var $49d4d6a5ebcea767$exports = {};
'use strict';

var $49d4d6a5ebcea767$var$$RangeError = RangeError;
$49d4d6a5ebcea767$exports = function(it) {
    var result = $4508997bd0ba9879$exports(it);
    if (result < 0) throw new $49d4d6a5ebcea767$var$$RangeError("The argument can't be less than 0");
    return result;
};


var $f95f56f41e8f56d7$var$$RangeError = RangeError;
$f95f56f41e8f56d7$exports = function(it, BYTES) {
    var offset = $49d4d6a5ebcea767$exports(it);
    if (offset % BYTES) throw new $f95f56f41e8f56d7$var$$RangeError('Wrong offset');
    return offset;
};


var $3c2b56ace725c7fa$exports = {};
'use strict';
var $3c2b56ace725c7fa$var$round = Math.round;
$3c2b56ace725c7fa$exports = function(it) {
    var value = $3c2b56ace725c7fa$var$round(it);
    return value < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
};











var $e96cb64ebc7b7356$require$getOwnPropertyNames = $13520dff9cf61e9d$export$2d1720544b23b823;
var $548aa517a820f158$exports = {};
'use strict';








var $6d9f99a2de290560$exports = {};
'use strict';

$6d9f99a2de290560$exports = function(it) {
    var klass = $4591439421551449$exports(it);
    return klass === 'BigInt64Array' || klass === 'BigUint64Array';
};



var $548aa517a820f158$require$aTypedArrayConstructor = $14c7b05570ea7e40$exports.aTypedArrayConstructor;
var $885581d4c32962e9$exports = {};
'use strict';

var $885581d4c32962e9$var$$TypeError = TypeError;
// `ToBigInt` abstract operation
// https://tc39.es/ecma262/#sec-tobigint
$885581d4c32962e9$exports = function(argument) {
    var prim = $50b25b11d61908fe$exports(argument, 'number');
    if (typeof prim == 'number') throw new $885581d4c32962e9$var$$TypeError("Can't convert number to bigint");
    // eslint-disable-next-line es/no-bigint -- safe
    return BigInt(prim);
};


$548aa517a820f158$exports = function from(source /* , mapfn, thisArg */ ) {
    var C = $1272194ab2c74efa$exports(this);
    var O = $ec839b558eb5dcf4$exports(source);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iteratorMethod = $b7a9a1ef631e02cb$exports(O);
    var i, length, result, thisIsBigIntArray, value, step, iterator, next;
    if (iteratorMethod && !$bac9daed9328b5c0$exports(iteratorMethod)) {
        iterator = $e16d366978e3a98b$exports(O, iteratorMethod);
        next = iterator.next;
        O = [];
        while(!(step = $e3ebd8cb7f512f74$exports(next, iterator)).done)O.push(step.value);
    }
    if (mapping && argumentsLength > 2) mapfn = $847280b2cf36c2e0$exports(mapfn, arguments[2]);
    length = $f91b2cfe2e3f959b$exports(O);
    result = new ($548aa517a820f158$require$aTypedArrayConstructor(C))(length);
    thisIsBigIntArray = $6d9f99a2de290560$exports(result);
    for(i = 0; length > i; i++){
        value = mapping ? mapfn(O[i], i) : O[i];
        // FF30- typed arrays doesn't properly convert objects to typed array values
        result[i] = thisIsBigIntArray ? $885581d4c32962e9$exports(value) : +value;
    }
    return result;
};



var $e96cb64ebc7b7356$require$forEach = $2f37be4e4d5b5ff0$exports.forEach;




var $96a937848a27921c$exports = {};
'use strict';

$96a937848a27921c$exports = function(Constructor, list, $length) {
    var index = 0;
    var length = arguments.length > 2 ? $length : $f91b2cfe2e3f959b$exports(list);
    var result = new Constructor(length);
    while(length > index)result[index] = list[index++];
    return result;
};




var $e96cb64ebc7b7356$var$getInternalState = $419c333d2a5dd5f4$exports.get;
var $e96cb64ebc7b7356$var$setInternalState = $419c333d2a5dd5f4$exports.set;
var $e96cb64ebc7b7356$var$enforceInternalState = $419c333d2a5dd5f4$exports.enforce;
var $e96cb64ebc7b7356$var$nativeDefineProperty = $23cff59c96aeab90$export$2d1720544b23b823;
var $e96cb64ebc7b7356$var$nativeGetOwnPropertyDescriptor = $bb417845773708b5$export$2d1720544b23b823;
var $e96cb64ebc7b7356$var$RangeError = $9be6fcc00ef60f58$exports.RangeError;
var $e96cb64ebc7b7356$var$ArrayBuffer = $e070b599b2ed132d$exports.ArrayBuffer;
var $e96cb64ebc7b7356$var$ArrayBufferPrototype = $e96cb64ebc7b7356$var$ArrayBuffer.prototype;
var $e96cb64ebc7b7356$var$DataView = $e070b599b2ed132d$exports.DataView;
var $e96cb64ebc7b7356$var$NATIVE_ARRAY_BUFFER_VIEWS = $14c7b05570ea7e40$exports.NATIVE_ARRAY_BUFFER_VIEWS;
var $e96cb64ebc7b7356$var$TYPED_ARRAY_TAG = $14c7b05570ea7e40$exports.TYPED_ARRAY_TAG;
var $e96cb64ebc7b7356$var$TypedArray = $14c7b05570ea7e40$exports.TypedArray;
var $e96cb64ebc7b7356$var$TypedArrayPrototype = $14c7b05570ea7e40$exports.TypedArrayPrototype;
var $e96cb64ebc7b7356$var$isTypedArray = $14c7b05570ea7e40$exports.isTypedArray;
var $e96cb64ebc7b7356$var$BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
var $e96cb64ebc7b7356$var$WRONG_LENGTH = 'Wrong length';
var $e96cb64ebc7b7356$var$addGetter = function addGetter(it, key) {
    $6de7996ceea81cf8$exports(it, key, {
        configurable: true,
        get: function get() {
            return $e96cb64ebc7b7356$var$getInternalState(this)[key];
        }
    });
};
var $e96cb64ebc7b7356$var$isArrayBuffer = function isArrayBuffer(it) {
    var klass;
    return $bc714f4a9c09d4bd$exports($e96cb64ebc7b7356$var$ArrayBufferPrototype, it) || (klass = $4591439421551449$exports(it)) === 'ArrayBuffer' || klass === 'SharedArrayBuffer';
};
var $e96cb64ebc7b7356$var$isTypedArrayIndex = function isTypedArrayIndex(target, key) {
    return $e96cb64ebc7b7356$var$isTypedArray(target) && !$4cdbccb02aa7d286$exports(key) && key in target && $0b15627d3bc33b2f$exports(+key) && key >= 0;
};
var $e96cb64ebc7b7356$var$wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
    key = $282f32d47e9dd4f8$exports(key);
    return $e96cb64ebc7b7356$var$isTypedArrayIndex(target, key) ? $f89eb1caea2679b0$exports(2, target[key]) : $e96cb64ebc7b7356$var$nativeGetOwnPropertyDescriptor(target, key);
};
var $e96cb64ebc7b7356$var$wrappedDefineProperty = function defineProperty(target, key, descriptor) {
    key = $282f32d47e9dd4f8$exports(key);
    if ($e96cb64ebc7b7356$var$isTypedArrayIndex(target, key) && $d2d3162bdcc39b88$exports(descriptor) && $35cf4bf79fe152cc$exports(descriptor, 'value') && !$35cf4bf79fe152cc$exports(descriptor, 'get') && !$35cf4bf79fe152cc$exports(descriptor, 'set') && !descriptor.configurable && (!$35cf4bf79fe152cc$exports(descriptor, 'writable') || descriptor.writable) && (!$35cf4bf79fe152cc$exports(descriptor, 'enumerable') || descriptor.enumerable)) {
        target[key] = descriptor.value;
        return target;
    }
    return $e96cb64ebc7b7356$var$nativeDefineProperty(target, key, descriptor);
};
if ($6ffb7908e83cf36c$exports) {
    if (!$e96cb64ebc7b7356$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        $bb417845773708b5$exports.f = $e96cb64ebc7b7356$var$wrappedGetOwnPropertyDescriptor;
        $23cff59c96aeab90$exports.f = $e96cb64ebc7b7356$var$wrappedDefineProperty;
        $e96cb64ebc7b7356$var$addGetter($e96cb64ebc7b7356$var$TypedArrayPrototype, 'buffer');
        $e96cb64ebc7b7356$var$addGetter($e96cb64ebc7b7356$var$TypedArrayPrototype, 'byteOffset');
        $e96cb64ebc7b7356$var$addGetter($e96cb64ebc7b7356$var$TypedArrayPrototype, 'byteLength');
        $e96cb64ebc7b7356$var$addGetter($e96cb64ebc7b7356$var$TypedArrayPrototype, 'length');
    }
    $500d5d8b5806b834$exports({
        target: 'Object',
        stat: true,
        forced: !$e96cb64ebc7b7356$var$NATIVE_ARRAY_BUFFER_VIEWS
    }, {
        getOwnPropertyDescriptor: $e96cb64ebc7b7356$var$wrappedGetOwnPropertyDescriptor,
        defineProperty: $e96cb64ebc7b7356$var$wrappedDefineProperty
    });
    $e96cb64ebc7b7356$exports = function(TYPE, wrapper, CLAMPED) {
        var BYTES = TYPE.match(/\d+/)[0] / 8;
        var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? 'Clamped' : '') + 'Array';
        var GETTER = 'get' + TYPE;
        var SETTER = 'set' + TYPE;
        var NativeTypedArrayConstructor = $9be6fcc00ef60f58$exports[CONSTRUCTOR_NAME];
        var TypedArrayConstructor = NativeTypedArrayConstructor;
        var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
        var exported = {};
        var getter = function getter(that, index) {
            var data = $e96cb64ebc7b7356$var$getInternalState(that);
            return data.view[GETTER](index * BYTES + data.byteOffset, true);
        };
        var setter = function setter(that, index, value) {
            var data = $e96cb64ebc7b7356$var$getInternalState(that);
            data.view[SETTER](index * BYTES + data.byteOffset, CLAMPED ? $3c2b56ace725c7fa$exports(value) : value, true);
        };
        var addElement = function addElement(that, index) {
            $e96cb64ebc7b7356$var$nativeDefineProperty(that, index, {
                get: function get() {
                    return getter(this, index);
                },
                set: function set(value) {
                    return setter(this, index, value);
                },
                enumerable: true
            });
        };
        if (!$e96cb64ebc7b7356$var$NATIVE_ARRAY_BUFFER_VIEWS) {
            TypedArrayConstructor = wrapper(function(that, data, offset, $length) {
                $65f23bed46afab45$exports(that, TypedArrayConstructorPrototype);
                var index = 0;
                var byteOffset = 0;
                var buffer, byteLength, length;
                if (!$d2d3162bdcc39b88$exports(data)) {
                    length = $1616da479b63d514$exports(data);
                    byteLength = length * BYTES;
                    buffer = new $e96cb64ebc7b7356$var$ArrayBuffer(byteLength);
                } else if ($e96cb64ebc7b7356$var$isArrayBuffer(data)) {
                    buffer = data;
                    byteOffset = $f95f56f41e8f56d7$exports(offset, BYTES);
                    var $len = data.byteLength;
                    if ($length === undefined) {
                        if ($len % BYTES) throw new $e96cb64ebc7b7356$var$RangeError($e96cb64ebc7b7356$var$WRONG_LENGTH);
                        byteLength = $len - byteOffset;
                        if (byteLength < 0) throw new $e96cb64ebc7b7356$var$RangeError($e96cb64ebc7b7356$var$WRONG_LENGTH);
                    } else {
                        byteLength = $d14e7a9632dda07a$exports($length) * BYTES;
                        if (byteLength + byteOffset > $len) throw new $e96cb64ebc7b7356$var$RangeError($e96cb64ebc7b7356$var$WRONG_LENGTH);
                    }
                    length = byteLength / BYTES;
                } else if ($e96cb64ebc7b7356$var$isTypedArray(data)) return $96a937848a27921c$exports(TypedArrayConstructor, data);
                else return $e3ebd8cb7f512f74$exports($548aa517a820f158$exports, TypedArrayConstructor, data);
                $e96cb64ebc7b7356$var$setInternalState(that, {
                    buffer: buffer,
                    byteOffset: byteOffset,
                    byteLength: byteLength,
                    length: length,
                    view: new $e96cb64ebc7b7356$var$DataView(buffer)
                });
                while(index < length)addElement(that, index++);
            });
            if ($6a2615bbdaa85242$exports) $6a2615bbdaa85242$exports(TypedArrayConstructor, $e96cb64ebc7b7356$var$TypedArray);
            TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = $c8a7d59657e3f14b$exports($e96cb64ebc7b7356$var$TypedArrayPrototype);
        } else if ($3951dd99bc53fcb4$exports) {
            TypedArrayConstructor = wrapper(function(dummy, data, typedArrayOffset, $length) {
                $65f23bed46afab45$exports(dummy, TypedArrayConstructorPrototype);
                return $8388ec23a46a9286$exports(function() {
                    if (!$d2d3162bdcc39b88$exports(data)) return new NativeTypedArrayConstructor($1616da479b63d514$exports(data));
                    if ($e96cb64ebc7b7356$var$isArrayBuffer(data)) return $length !== undefined ? new NativeTypedArrayConstructor(data, $f95f56f41e8f56d7$exports(typedArrayOffset, BYTES), $length) : typedArrayOffset !== undefined ? new NativeTypedArrayConstructor(data, $f95f56f41e8f56d7$exports(typedArrayOffset, BYTES)) : new NativeTypedArrayConstructor(data);
                    if ($e96cb64ebc7b7356$var$isTypedArray(data)) return $96a937848a27921c$exports(TypedArrayConstructor, data);
                    return $e3ebd8cb7f512f74$exports($548aa517a820f158$exports, TypedArrayConstructor, data);
                }(), dummy, TypedArrayConstructor);
            });
            if ($6a2615bbdaa85242$exports) $6a2615bbdaa85242$exports(TypedArrayConstructor, $e96cb64ebc7b7356$var$TypedArray);
            $e96cb64ebc7b7356$require$forEach($e96cb64ebc7b7356$require$getOwnPropertyNames(NativeTypedArrayConstructor), function(key) {
                if (!(key in TypedArrayConstructor)) $5b5bc07d688591ac$exports(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
            });
            TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
        }
        if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) $5b5bc07d688591ac$exports(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
        $e96cb64ebc7b7356$var$enforceInternalState(TypedArrayConstructorPrototype).TypedArrayConstructor = TypedArrayConstructor;
        if ($e96cb64ebc7b7356$var$TYPED_ARRAY_TAG) $5b5bc07d688591ac$exports(TypedArrayConstructorPrototype, $e96cb64ebc7b7356$var$TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
        var FORCED = TypedArrayConstructor !== NativeTypedArrayConstructor;
        exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;
        $500d5d8b5806b834$exports({
            global: true,
            constructor: true,
            forced: FORCED,
            sham: !$e96cb64ebc7b7356$var$NATIVE_ARRAY_BUFFER_VIEWS
        }, exported);
        if (!($e96cb64ebc7b7356$var$BYTES_PER_ELEMENT in TypedArrayConstructor)) $5b5bc07d688591ac$exports(TypedArrayConstructor, $e96cb64ebc7b7356$var$BYTES_PER_ELEMENT, BYTES);
        if (!($e96cb64ebc7b7356$var$BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) $5b5bc07d688591ac$exports(TypedArrayConstructorPrototype, $e96cb64ebc7b7356$var$BYTES_PER_ELEMENT, BYTES);
        $8db167be81e78b6c$exports(CONSTRUCTOR_NAME);
    };
} else $e96cb64ebc7b7356$exports = function() {};


// `Float32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$e96cb64ebc7b7356$exports('Float32', function(init) {
    return function Float32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


'use strict';

// `Float64Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$e96cb64ebc7b7356$exports('Float64', function(init) {
    return function Float64Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


'use strict';

// `Int8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$e96cb64ebc7b7356$exports('Int8', function(init) {
    return function Int8Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


'use strict';

// `Int16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$e96cb64ebc7b7356$exports('Int16', function(init) {
    return function Int16Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


'use strict';

// `Int32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$e96cb64ebc7b7356$exports('Int32', function(init) {
    return function Int32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


'use strict';

// `Uint8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$e96cb64ebc7b7356$exports('Uint8', function(init) {
    return function Uint8Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


'use strict';

// `Uint8ClampedArray` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$e96cb64ebc7b7356$exports('Uint8', function(init) {
    return function Uint8ClampedArray(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
}, true);


'use strict';

// `Uint16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$e96cb64ebc7b7356$exports('Uint16', function(init) {
    return function Uint16Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


'use strict';

// `Uint32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$e96cb64ebc7b7356$exports('Uint32', function(init) {
    return function Uint32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


'use strict';



var $3317c61ad0386d9f$var$u$ArrayCopyWithin = $1689570c06db508b$exports($c48cb76116abd042$exports);
var $3317c61ad0386d9f$var$aTypedArray = $14c7b05570ea7e40$exports.aTypedArray;
var $3317c61ad0386d9f$var$exportTypedArrayMethod = $14c7b05570ea7e40$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.copywithin
$3317c61ad0386d9f$var$exportTypedArrayMethod('copyWithin', function copyWithin(target, start /* , end */ ) {
    return $3317c61ad0386d9f$var$u$ArrayCopyWithin($3317c61ad0386d9f$var$aTypedArray(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
});


'use strict';


var $08e58582bef4bf48$require$$every = $2f37be4e4d5b5ff0$exports.every;
var $08e58582bef4bf48$var$aTypedArray = $14c7b05570ea7e40$exports.aTypedArray;
var $08e58582bef4bf48$var$exportTypedArrayMethod = $14c7b05570ea7e40$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.every` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.every
$08e58582bef4bf48$var$exportTypedArrayMethod('every', function every(callbackfn /* , thisArg */ ) {
    return $08e58582bef4bf48$require$$every($08e58582bef4bf48$var$aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


'use strict';







var $4943a5ce6b9b61ef$var$aTypedArray = $14c7b05570ea7e40$exports.aTypedArray;
var $4943a5ce6b9b61ef$var$exportTypedArrayMethod = $14c7b05570ea7e40$exports.exportTypedArrayMethod;
var $4943a5ce6b9b61ef$var$slice = $1689570c06db508b$exports(''.slice);
// V8 ~ Chrome < 59, Safari < 14.1, FF < 55, Edge <=18
var $4943a5ce6b9b61ef$var$CONVERSION_BUG = $06c7d56a730e31f1$exports(function() {
    var count = 0;
    // eslint-disable-next-line es/no-typed-arrays -- safe
    new Int8Array(2).fill({
        valueOf: function valueOf() {
            return count++;
        }
    });
    return count !== 1;
});
// `%TypedArray%.prototype.fill` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
$4943a5ce6b9b61ef$var$exportTypedArrayMethod('fill', function fill(value /* , start, end */ ) {
    var length = arguments.length;
    $4943a5ce6b9b61ef$var$aTypedArray(this);
    var actualValue = $4943a5ce6b9b61ef$var$slice($4591439421551449$exports(this), 0, 3) === 'Big' ? $885581d4c32962e9$exports(value) : +value;
    return $e3ebd8cb7f512f74$exports($0f35f07457e06688$exports, this, actualValue, length > 1 ? arguments[1] : undefined, length > 2 ? arguments[2] : undefined);
}, $4943a5ce6b9b61ef$var$CONVERSION_BUG);


'use strict';


var $473c6c3884727e11$require$$filter = $2f37be4e4d5b5ff0$exports.filter;
var $ac7ec6825fa1db92$exports = {};
'use strict';


var $ac7ec6825fa1db92$require$getTypedArrayConstructor = $14c7b05570ea7e40$exports.getTypedArrayConstructor;
$ac7ec6825fa1db92$exports = function(instance, list) {
    return $96a937848a27921c$exports($ac7ec6825fa1db92$require$getTypedArrayConstructor(instance), list);
};


var $473c6c3884727e11$var$aTypedArray = $14c7b05570ea7e40$exports.aTypedArray;
var $473c6c3884727e11$var$exportTypedArrayMethod = $14c7b05570ea7e40$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.filter` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.filter
$473c6c3884727e11$var$exportTypedArrayMethod('filter', function filter(callbackfn /* , thisArg */ ) {
    var list = $473c6c3884727e11$require$$filter($473c6c3884727e11$var$aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return $ac7ec6825fa1db92$exports(this, list);
});


'use strict';


var $dd01ab41c7156d7f$require$$find = $2f37be4e4d5b5ff0$exports.find;
var $dd01ab41c7156d7f$var$aTypedArray = $14c7b05570ea7e40$exports.aTypedArray;
var $dd01ab41c7156d7f$var$exportTypedArrayMethod = $14c7b05570ea7e40$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.find` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.find
$dd01ab41c7156d7f$var$exportTypedArrayMethod('find', function find(predicate /* , thisArg */ ) {
    return $dd01ab41c7156d7f$require$$find($dd01ab41c7156d7f$var$aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


'use strict';


var $3a40c85876ba5d98$require$$findIndex = $2f37be4e4d5b5ff0$exports.findIndex;
var $3a40c85876ba5d98$var$aTypedArray = $14c7b05570ea7e40$exports.aTypedArray;
var $3a40c85876ba5d98$var$exportTypedArrayMethod = $14c7b05570ea7e40$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findindex
$3a40c85876ba5d98$var$exportTypedArrayMethod('findIndex', function findIndex(predicate /* , thisArg */ ) {
    return $3a40c85876ba5d98$require$$findIndex($3a40c85876ba5d98$var$aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


'use strict';


var $65227ac68aa9616e$require$$forEach = $2f37be4e4d5b5ff0$exports.forEach;
var $65227ac68aa9616e$var$aTypedArray = $14c7b05570ea7e40$exports.aTypedArray;
var $65227ac68aa9616e$var$exportTypedArrayMethod = $14c7b05570ea7e40$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.forEach` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.foreach
$65227ac68aa9616e$var$exportTypedArrayMethod('forEach', function forEach(callbackfn /* , thisArg */ ) {
    $65227ac68aa9616e$require$$forEach($65227ac68aa9616e$var$aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


'use strict';


var $1af26a2008185257$require$exportTypedArrayStaticMethod = $14c7b05570ea7e40$exports.exportTypedArrayStaticMethod;

// `%TypedArray%.from` method
// https://tc39.es/ecma262/#sec-%typedarray%.from
$1af26a2008185257$require$exportTypedArrayStaticMethod('from', $548aa517a820f158$exports, $3951dd99bc53fcb4$exports);


'use strict';


var $b6c93599c0b05484$require$$includes = $7e4669141832e27c$exports.includes;
var $b6c93599c0b05484$var$aTypedArray = $14c7b05570ea7e40$exports.aTypedArray;
var $b6c93599c0b05484$var$exportTypedArrayMethod = $14c7b05570ea7e40$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.includes` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.includes
$b6c93599c0b05484$var$exportTypedArrayMethod('includes', function includes(searchElement /* , fromIndex */ ) {
    return $b6c93599c0b05484$require$$includes($b6c93599c0b05484$var$aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});


'use strict';


var $d060ac9651f930b0$require$$indexOf = $7e4669141832e27c$exports.indexOf;
var $d060ac9651f930b0$var$aTypedArray = $14c7b05570ea7e40$exports.aTypedArray;
var $d060ac9651f930b0$var$exportTypedArrayMethod = $14c7b05570ea7e40$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.indexof
$d060ac9651f930b0$var$exportTypedArrayMethod('indexOf', function indexOf(searchElement /* , fromIndex */ ) {
    return $d060ac9651f930b0$require$$indexOf($d060ac9651f930b0$var$aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});


'use strict';






var $3f196b8d2a30e405$var$ITERATOR = $6268abd12745dd3b$exports('iterator');
var $3f196b8d2a30e405$var$Uint8Array = $9be6fcc00ef60f58$exports.Uint8Array;
var $3f196b8d2a30e405$var$arrayValues = $1689570c06db508b$exports($7d62cd3cf967f9c5$exports.values);
var $3f196b8d2a30e405$var$arrayKeys = $1689570c06db508b$exports($7d62cd3cf967f9c5$exports.keys);
var $3f196b8d2a30e405$var$arrayEntries = $1689570c06db508b$exports($7d62cd3cf967f9c5$exports.entries);
var $3f196b8d2a30e405$var$aTypedArray = $14c7b05570ea7e40$exports.aTypedArray;
var $3f196b8d2a30e405$var$exportTypedArrayMethod = $14c7b05570ea7e40$exports.exportTypedArrayMethod;
var $3f196b8d2a30e405$var$TypedArrayPrototype = $3f196b8d2a30e405$var$Uint8Array && $3f196b8d2a30e405$var$Uint8Array.prototype;
var $3f196b8d2a30e405$var$GENERIC = !$06c7d56a730e31f1$exports(function() {
    $3f196b8d2a30e405$var$TypedArrayPrototype[$3f196b8d2a30e405$var$ITERATOR].call([
        1
    ]);
});
var $3f196b8d2a30e405$var$ITERATOR_IS_VALUES = !!$3f196b8d2a30e405$var$TypedArrayPrototype && $3f196b8d2a30e405$var$TypedArrayPrototype.values && $3f196b8d2a30e405$var$TypedArrayPrototype[$3f196b8d2a30e405$var$ITERATOR] === $3f196b8d2a30e405$var$TypedArrayPrototype.values && $3f196b8d2a30e405$var$TypedArrayPrototype.values.name === 'values';
var $3f196b8d2a30e405$var$typedArrayValues = function values() {
    return $3f196b8d2a30e405$var$arrayValues($3f196b8d2a30e405$var$aTypedArray(this));
};
// `%TypedArray%.prototype.entries` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.entries
$3f196b8d2a30e405$var$exportTypedArrayMethod('entries', function entries() {
    return $3f196b8d2a30e405$var$arrayEntries($3f196b8d2a30e405$var$aTypedArray(this));
}, $3f196b8d2a30e405$var$GENERIC);
// `%TypedArray%.prototype.keys` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.keys
$3f196b8d2a30e405$var$exportTypedArrayMethod('keys', function keys() {
    return $3f196b8d2a30e405$var$arrayKeys($3f196b8d2a30e405$var$aTypedArray(this));
}, $3f196b8d2a30e405$var$GENERIC);
// `%TypedArray%.prototype.values` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.values
$3f196b8d2a30e405$var$exportTypedArrayMethod('values', $3f196b8d2a30e405$var$typedArrayValues, $3f196b8d2a30e405$var$GENERIC || !$3f196b8d2a30e405$var$ITERATOR_IS_VALUES, {
    name: 'values'
});
// `%TypedArray%.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype-@@iterator
$3f196b8d2a30e405$var$exportTypedArrayMethod($3f196b8d2a30e405$var$ITERATOR, $3f196b8d2a30e405$var$typedArrayValues, $3f196b8d2a30e405$var$GENERIC || !$3f196b8d2a30e405$var$ITERATOR_IS_VALUES, {
    name: 'values'
});


'use strict';


var $12224fc48263caf0$var$aTypedArray = $14c7b05570ea7e40$exports.aTypedArray;
var $12224fc48263caf0$var$exportTypedArrayMethod = $14c7b05570ea7e40$exports.exportTypedArrayMethod;
var $12224fc48263caf0$var$$join = $1689570c06db508b$exports([].join);
// `%TypedArray%.prototype.join` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.join
$12224fc48263caf0$var$exportTypedArrayMethod('join', function join(separator) {
    return $12224fc48263caf0$var$$join($12224fc48263caf0$var$aTypedArray(this), separator);
});


'use strict';



var $4d57b080b12e187a$var$aTypedArray = $14c7b05570ea7e40$exports.aTypedArray;
var $4d57b080b12e187a$var$exportTypedArrayMethod = $14c7b05570ea7e40$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.lastindexof
$4d57b080b12e187a$var$exportTypedArrayMethod('lastIndexOf', function lastIndexOf(searchElement /* , fromIndex */ ) {
    var length = arguments.length;
    return $c126e09ab0f7e2a8$exports($c49d8513c1da4ce4$exports, $4d57b080b12e187a$var$aTypedArray(this), length > 1 ? [
        searchElement,
        arguments[1]
    ] : [
        searchElement
    ]);
});


'use strict';


var $34f09cb25fd6580e$require$$map = $2f37be4e4d5b5ff0$exports.map;
var $34f09cb25fd6580e$var$aTypedArray = $14c7b05570ea7e40$exports.aTypedArray;
var $34f09cb25fd6580e$var$getTypedArrayConstructor = $14c7b05570ea7e40$exports.getTypedArrayConstructor;
var $34f09cb25fd6580e$var$exportTypedArrayMethod = $14c7b05570ea7e40$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.map` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.map
$34f09cb25fd6580e$var$exportTypedArrayMethod('map', function map(mapfn /* , thisArg */ ) {
    return $34f09cb25fd6580e$require$$map($34f09cb25fd6580e$var$aTypedArray(this), mapfn, arguments.length > 1 ? arguments[1] : undefined, function(O, length) {
        return new ($34f09cb25fd6580e$var$getTypedArrayConstructor(O))(length);
    });
});


'use strict';


var $e656823b6da58268$var$aTypedArrayConstructor = $14c7b05570ea7e40$exports.aTypedArrayConstructor;
var $e656823b6da58268$var$exportTypedArrayStaticMethod = $14c7b05570ea7e40$exports.exportTypedArrayStaticMethod;
// `%TypedArray%.of` method
// https://tc39.es/ecma262/#sec-%typedarray%.of
$e656823b6da58268$var$exportTypedArrayStaticMethod('of', function of() {
    var index = 0;
    var length = arguments.length;
    var result = new ($e656823b6da58268$var$aTypedArrayConstructor(this))(length);
    while(length > index)result[index] = arguments[index++];
    return result;
}, $3951dd99bc53fcb4$exports);


'use strict';


var $7093d76a680fe4c7$require$$reduce = $6a315aad6740ea3d$exports.left;
var $7093d76a680fe4c7$var$aTypedArray = $14c7b05570ea7e40$exports.aTypedArray;
var $7093d76a680fe4c7$var$exportTypedArrayMethod = $14c7b05570ea7e40$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.reduce` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduce
$7093d76a680fe4c7$var$exportTypedArrayMethod('reduce', function reduce(callbackfn /* , initialValue */ ) {
    var length = arguments.length;
    return $7093d76a680fe4c7$require$$reduce($7093d76a680fe4c7$var$aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});


'use strict';


var $27c35cb25b7837de$require$$reduceRight = $6a315aad6740ea3d$exports.right;
var $27c35cb25b7837de$var$aTypedArray = $14c7b05570ea7e40$exports.aTypedArray;
var $27c35cb25b7837de$var$exportTypedArrayMethod = $14c7b05570ea7e40$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.reduceRight` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduceright
$27c35cb25b7837de$var$exportTypedArrayMethod('reduceRight', function reduceRight(callbackfn /* , initialValue */ ) {
    var length = arguments.length;
    return $27c35cb25b7837de$require$$reduceRight($27c35cb25b7837de$var$aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});


'use strict';

var $eada8064399abf16$var$aTypedArray = $14c7b05570ea7e40$exports.aTypedArray;
var $eada8064399abf16$var$exportTypedArrayMethod = $14c7b05570ea7e40$exports.exportTypedArrayMethod;
var $eada8064399abf16$var$floor = Math.floor;
// `%TypedArray%.prototype.reverse` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reverse
$eada8064399abf16$var$exportTypedArrayMethod('reverse', function reverse() {
    var that = this;
    var length = $eada8064399abf16$var$aTypedArray(that).length;
    var middle = $eada8064399abf16$var$floor(length / 2);
    var index = 0;
    var value;
    while(index < middle){
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
    }
    return that;
});


'use strict';







var $0ef6b8222bbb4acf$var$RangeError = $9be6fcc00ef60f58$exports.RangeError;
var $0ef6b8222bbb4acf$var$Int8Array = $9be6fcc00ef60f58$exports.Int8Array;
var $0ef6b8222bbb4acf$var$Int8ArrayPrototype = $0ef6b8222bbb4acf$var$Int8Array && $0ef6b8222bbb4acf$var$Int8Array.prototype;
var $0ef6b8222bbb4acf$var$$set = $0ef6b8222bbb4acf$var$Int8ArrayPrototype && $0ef6b8222bbb4acf$var$Int8ArrayPrototype.set;
var $0ef6b8222bbb4acf$var$aTypedArray = $14c7b05570ea7e40$exports.aTypedArray;
var $0ef6b8222bbb4acf$var$exportTypedArrayMethod = $14c7b05570ea7e40$exports.exportTypedArrayMethod;
var $0ef6b8222bbb4acf$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !$06c7d56a730e31f1$exports(function() {
    // eslint-disable-next-line es/no-typed-arrays -- required for testing
    var array = new Uint8ClampedArray(2);
    $e3ebd8cb7f512f74$exports($0ef6b8222bbb4acf$var$$set, array, {
        length: 1,
        0: 3
    }, 1);
    return array[1] !== 3;
});
// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var $0ef6b8222bbb4acf$var$TO_OBJECT_BUG = $0ef6b8222bbb4acf$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && $14c7b05570ea7e40$exports.NATIVE_ARRAY_BUFFER_VIEWS && $06c7d56a730e31f1$exports(function() {
    var array = new $0ef6b8222bbb4acf$var$Int8Array(2);
    array.set(1);
    array.set('2', 1);
    return array[0] !== 0 || array[1] !== 2;
});
// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
$0ef6b8222bbb4acf$var$exportTypedArrayMethod('set', function set(arrayLike /* , offset */ ) {
    $0ef6b8222bbb4acf$var$aTypedArray(this);
    var offset = $f95f56f41e8f56d7$exports(arguments.length > 1 ? arguments[1] : undefined, 1);
    var src = $ec839b558eb5dcf4$exports(arrayLike);
    if ($0ef6b8222bbb4acf$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS) return $e3ebd8cb7f512f74$exports($0ef6b8222bbb4acf$var$$set, this, src, offset);
    var length = this.length;
    var len = $f91b2cfe2e3f959b$exports(src);
    var index = 0;
    if (len + offset > length) throw new $0ef6b8222bbb4acf$var$RangeError('Wrong length');
    while(index < len)this[offset + index] = src[index++];
}, !$0ef6b8222bbb4acf$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || $0ef6b8222bbb4acf$var$TO_OBJECT_BUG);


'use strict';



var $2a53e1ee218672b5$var$aTypedArray = $14c7b05570ea7e40$exports.aTypedArray;
var $2a53e1ee218672b5$var$getTypedArrayConstructor = $14c7b05570ea7e40$exports.getTypedArrayConstructor;
var $2a53e1ee218672b5$var$exportTypedArrayMethod = $14c7b05570ea7e40$exports.exportTypedArrayMethod;
var $2a53e1ee218672b5$var$FORCED = $06c7d56a730e31f1$exports(function() {
    // eslint-disable-next-line es/no-typed-arrays -- required for testing
    new Int8Array(1).slice();
});
// `%TypedArray%.prototype.slice` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.slice
$2a53e1ee218672b5$var$exportTypedArrayMethod('slice', function slice(start, end) {
    var list = $65dcb7b8ed29ae22$exports($2a53e1ee218672b5$var$aTypedArray(this), start, end);
    var C = $2a53e1ee218672b5$var$getTypedArrayConstructor(this);
    var index = 0;
    var length = list.length;
    var result = new C(length);
    while(length > index)result[index] = list[index++];
    return result;
}, $2a53e1ee218672b5$var$FORCED);


'use strict';


var $8bb0bbeddbecdb13$require$$some = $2f37be4e4d5b5ff0$exports.some;
var $8bb0bbeddbecdb13$var$aTypedArray = $14c7b05570ea7e40$exports.aTypedArray;
var $8bb0bbeddbecdb13$var$exportTypedArrayMethod = $14c7b05570ea7e40$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.some` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.some
$8bb0bbeddbecdb13$var$exportTypedArrayMethod('some', function some(callbackfn /* , thisArg */ ) {
    return $8bb0bbeddbecdb13$require$$some($8bb0bbeddbecdb13$var$aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


'use strict';










var $98aeef3a1c930036$var$aTypedArray = $14c7b05570ea7e40$exports.aTypedArray;
var $98aeef3a1c930036$var$exportTypedArrayMethod = $14c7b05570ea7e40$exports.exportTypedArrayMethod;
var $98aeef3a1c930036$var$Uint16Array = $9be6fcc00ef60f58$exports.Uint16Array;
var $98aeef3a1c930036$var$nativeSort = $98aeef3a1c930036$var$Uint16Array && $010fa6fc9394de19$exports($98aeef3a1c930036$var$Uint16Array.prototype.sort);
// WebKit
var $98aeef3a1c930036$var$ACCEPT_INCORRECT_ARGUMENTS = !!$98aeef3a1c930036$var$nativeSort && !($06c7d56a730e31f1$exports(function() {
    $98aeef3a1c930036$var$nativeSort(new $98aeef3a1c930036$var$Uint16Array(2), null);
}) && $06c7d56a730e31f1$exports(function() {
    $98aeef3a1c930036$var$nativeSort(new $98aeef3a1c930036$var$Uint16Array(2), {});
}));
var $98aeef3a1c930036$var$STABLE_SORT = !!$98aeef3a1c930036$var$nativeSort && !$06c7d56a730e31f1$exports(function() {
    // feature detection can be too slow, so check engines versions
    if ($9d47635dcaf33179$exports) return $9d47635dcaf33179$exports < 74;
    if ($799a167b76922fa4$exports) return $799a167b76922fa4$exports < 67;
    if ($608f2a809a1d0042$exports) return true;
    if ($a4a58fb9b1d3c6b9$exports) return $a4a58fb9b1d3c6b9$exports < 602;
    var array = new $98aeef3a1c930036$var$Uint16Array(516);
    var expected = Array(516);
    var index, mod;
    for(index = 0; index < 516; index++){
        mod = index % 4;
        array[index] = 515 - index;
        expected[index] = index - 2 * mod + 3;
    }
    $98aeef3a1c930036$var$nativeSort(array, function(a, b) {
        return (a / 4 | 0) - (b / 4 | 0);
    });
    for(index = 0; index < 516; index++){
        if (array[index] !== expected[index]) return true;
    }
});
var $98aeef3a1c930036$var$getSortCompare = function getSortCompare(comparefn) {
    return function(x, y) {
        if (comparefn !== undefined) return +comparefn(x, y) || 0;
        // eslint-disable-next-line no-self-compare -- NaN check
        if (y !== y) return -1;
        // eslint-disable-next-line no-self-compare -- NaN check
        if (x !== x) return 1;
        if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
        return x > y;
    };
};
// `%TypedArray%.prototype.sort` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
$98aeef3a1c930036$var$exportTypedArrayMethod('sort', function sort(comparefn) {
    if (comparefn !== undefined) $c976080d379e828f$exports(comparefn);
    if ($98aeef3a1c930036$var$STABLE_SORT) return $98aeef3a1c930036$var$nativeSort(this, comparefn);
    return $4ee33df2db620866$exports($98aeef3a1c930036$var$aTypedArray(this), $98aeef3a1c930036$var$getSortCompare(comparefn));
}, !$98aeef3a1c930036$var$STABLE_SORT || $98aeef3a1c930036$var$ACCEPT_INCORRECT_ARGUMENTS);


'use strict';



var $9829b4f7222e44d3$var$aTypedArray = $14c7b05570ea7e40$exports.aTypedArray;
var $9829b4f7222e44d3$var$getTypedArrayConstructor = $14c7b05570ea7e40$exports.getTypedArrayConstructor;
var $9829b4f7222e44d3$var$exportTypedArrayMethod = $14c7b05570ea7e40$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.subarray` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.subarray
$9829b4f7222e44d3$var$exportTypedArrayMethod('subarray', function subarray(begin, end) {
    var O = $9829b4f7222e44d3$var$aTypedArray(this);
    var length = O.length;
    var beginIndex = $d78d48da15e9c8eb$exports(begin, length);
    var C = $9829b4f7222e44d3$var$getTypedArrayConstructor(O);
    return new C(O.buffer, O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT, $d14e7a9632dda07a$exports((end === undefined ? length : $d78d48da15e9c8eb$exports(end, length)) - beginIndex));
});


'use strict';





var $959d7c9ed6c53451$var$Int8Array = $9be6fcc00ef60f58$exports.Int8Array;
var $959d7c9ed6c53451$var$aTypedArray = $14c7b05570ea7e40$exports.aTypedArray;
var $959d7c9ed6c53451$var$exportTypedArrayMethod = $14c7b05570ea7e40$exports.exportTypedArrayMethod;
var $959d7c9ed6c53451$var$$toLocaleString = [].toLocaleString;
// iOS Safari 6.x fails here
var $959d7c9ed6c53451$var$TO_LOCALE_STRING_BUG = !!$959d7c9ed6c53451$var$Int8Array && $06c7d56a730e31f1$exports(function() {
    $959d7c9ed6c53451$var$$toLocaleString.call(new $959d7c9ed6c53451$var$Int8Array(1));
});
var $959d7c9ed6c53451$var$FORCED = $06c7d56a730e31f1$exports(function() {
    return [
        1,
        2
    ].toLocaleString() !== new $959d7c9ed6c53451$var$Int8Array([
        1,
        2
    ]).toLocaleString();
}) || !$06c7d56a730e31f1$exports(function() {
    $959d7c9ed6c53451$var$Int8Array.prototype.toLocaleString.call([
        1,
        2
    ]);
});
// `%TypedArray%.prototype.toLocaleString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring
$959d7c9ed6c53451$var$exportTypedArrayMethod('toLocaleString', function toLocaleString() {
    return $c126e09ab0f7e2a8$exports($959d7c9ed6c53451$var$$toLocaleString, $959d7c9ed6c53451$var$TO_LOCALE_STRING_BUG ? $65dcb7b8ed29ae22$exports($959d7c9ed6c53451$var$aTypedArray(this)) : $959d7c9ed6c53451$var$aTypedArray(this), $65dcb7b8ed29ae22$exports(arguments));
}, $959d7c9ed6c53451$var$FORCED);


'use strict';

var $a1e3954f28ab0bc5$require$exportTypedArrayMethod = $14c7b05570ea7e40$exports.exportTypedArrayMethod;



var $a1e3954f28ab0bc5$var$Uint8Array = $9be6fcc00ef60f58$exports.Uint8Array;
var $a1e3954f28ab0bc5$var$Uint8ArrayPrototype = $a1e3954f28ab0bc5$var$Uint8Array && $a1e3954f28ab0bc5$var$Uint8Array.prototype || {};
var $a1e3954f28ab0bc5$var$arrayToString = [].toString;
var $a1e3954f28ab0bc5$var$join = $1689570c06db508b$exports([].join);
if ($06c7d56a730e31f1$exports(function() {
    $a1e3954f28ab0bc5$var$arrayToString.call({});
})) $a1e3954f28ab0bc5$var$arrayToString = function toString() {
    return $a1e3954f28ab0bc5$var$join(this);
};
var $a1e3954f28ab0bc5$var$IS_NOT_ARRAY_METHOD = $a1e3954f28ab0bc5$var$Uint8ArrayPrototype.toString !== $a1e3954f28ab0bc5$var$arrayToString;
// `%TypedArray%.prototype.toString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tostring
$a1e3954f28ab0bc5$require$exportTypedArrayMethod('toString', $a1e3954f28ab0bc5$var$arrayToString, $a1e3954f28ab0bc5$var$IS_NOT_ARRAY_METHOD);


'use strict';
'use strict';






var $e4859fd2e26a3f69$exports = {};
'use strict';



var $e4859fd2e26a3f69$require$getWeakData = $24ac99e13d26c138$exports.getWeakData;








var $e4859fd2e26a3f69$var$setInternalState = $419c333d2a5dd5f4$exports.set;
var $e4859fd2e26a3f69$var$internalStateGetterFor = $419c333d2a5dd5f4$exports.getterFor;
var $e4859fd2e26a3f69$var$find = $2f37be4e4d5b5ff0$exports.find;
var $e4859fd2e26a3f69$var$findIndex = $2f37be4e4d5b5ff0$exports.findIndex;
var $e4859fd2e26a3f69$var$splice = $1689570c06db508b$exports([].splice);
var $e4859fd2e26a3f69$var$id = 0;
// fallback for uncaught frozen keys
var $e4859fd2e26a3f69$var$uncaughtFrozenStore = function uncaughtFrozenStore(state) {
    return state.frozen || (state.frozen = new $e4859fd2e26a3f69$var$UncaughtFrozenStore());
};
var $e4859fd2e26a3f69$var$UncaughtFrozenStore = function UncaughtFrozenStore() {
    this.entries = [];
};
var $e4859fd2e26a3f69$var$findUncaughtFrozen = function findUncaughtFrozen(store, key) {
    return $e4859fd2e26a3f69$var$find(store.entries, function(it) {
        return it[0] === key;
    });
};
$e4859fd2e26a3f69$var$UncaughtFrozenStore.prototype = {
    get: function get(key) {
        var entry = $e4859fd2e26a3f69$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function has(key) {
        return !!$e4859fd2e26a3f69$var$findUncaughtFrozen(this, key);
    },
    set: function set(key, value) {
        var entry = $e4859fd2e26a3f69$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.entries.push([
            key,
            value
        ]);
    },
    'delete': function(key) {
        var index = $e4859fd2e26a3f69$var$findIndex(this.entries, function(it) {
            return it[0] === key;
        });
        if (~index) $e4859fd2e26a3f69$var$splice(this.entries, index, 1);
        return !!~index;
    }
};
$e4859fd2e26a3f69$exports = {
    getConstructor: function getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $65f23bed46afab45$exports(that, Prototype);
            $e4859fd2e26a3f69$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                id: $e4859fd2e26a3f69$var$id++,
                frozen: null
            });
            if (!$8d82b0b487ce9bb5$exports(iterable)) $6244c42639c04860$exports(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $e4859fd2e26a3f69$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function define(that, key, value) {
            var state = getInternalState(that);
            var data = $e4859fd2e26a3f69$require$getWeakData($05718fce3232bc84$exports(key), true);
            if (data === true) $e4859fd2e26a3f69$var$uncaughtFrozenStore(state).set(key, value);
            else data[state.id] = value;
            return that;
        };
        $7ad1d749b941a26e$exports(Prototype, {
            // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
            // https://tc39.es/ecma262/#sec-weakset.prototype.delete
            'delete': function(key) {
                var state = getInternalState(this);
                if (!$d2d3162bdcc39b88$exports(key)) return false;
                var data = $e4859fd2e26a3f69$require$getWeakData(key);
                if (data === true) return $e4859fd2e26a3f69$var$uncaughtFrozenStore(state)['delete'](key);
                return data && $35cf4bf79fe152cc$exports(data, state.id) && delete data[state.id];
            },
            // `{ WeakMap, WeakSet }.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.has
            // https://tc39.es/ecma262/#sec-weakset.prototype.has
            has: function has(key) {
                var state = getInternalState(this);
                if (!$d2d3162bdcc39b88$exports(key)) return false;
                var data = $e4859fd2e26a3f69$require$getWeakData(key);
                if (data === true) return $e4859fd2e26a3f69$var$uncaughtFrozenStore(state).has(key);
                return data && $35cf4bf79fe152cc$exports(data, state.id);
            }
        });
        $7ad1d749b941a26e$exports(Prototype, IS_MAP ? {
            // `WeakMap.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.get
            get: function get(key) {
                var state = getInternalState(this);
                if ($d2d3162bdcc39b88$exports(key)) {
                    var data = $e4859fd2e26a3f69$require$getWeakData(key);
                    if (data === true) return $e4859fd2e26a3f69$var$uncaughtFrozenStore(state).get(key);
                    if (data) return data[state.id];
                }
            },
            // `WeakMap.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.set
            set: function set(key, value) {
                return define(this, key, value);
            }
        } : {
            // `WeakSet.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-weakset.prototype.add
            add: function add(value) {
                return define(this, value, true);
            }
        });
        return Constructor;
    }
};




var $05ed4c47eea00777$require$enforceInternalState = $419c333d2a5dd5f4$exports.enforce;


var $05ed4c47eea00777$var$$Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var $05ed4c47eea00777$var$isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var $05ed4c47eea00777$var$isExtensible = $05ed4c47eea00777$var$$Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var $05ed4c47eea00777$var$isFrozen = $05ed4c47eea00777$var$$Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var $05ed4c47eea00777$var$isSealed = $05ed4c47eea00777$var$$Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var $05ed4c47eea00777$var$freeze = $05ed4c47eea00777$var$$Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var $05ed4c47eea00777$var$seal = $05ed4c47eea00777$var$$Object.seal;
var $05ed4c47eea00777$var$IS_IE11 = !$9be6fcc00ef60f58$exports.ActiveXObject && 'ActiveXObject' in $9be6fcc00ef60f58$exports;
var $05ed4c47eea00777$var$InternalWeakMap;
var $05ed4c47eea00777$var$wrapper = function wrapper(init) {
    return function WeakMap() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
};
// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $05ed4c47eea00777$var$$WeakMap = $a78fa382baf6bf1e$exports('WeakMap', $05ed4c47eea00777$var$wrapper, $e4859fd2e26a3f69$exports);
var $05ed4c47eea00777$var$WeakMapPrototype = $05ed4c47eea00777$var$$WeakMap.prototype;
var $05ed4c47eea00777$var$nativeSet = $1689570c06db508b$exports($05ed4c47eea00777$var$WeakMapPrototype.set);
// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var $05ed4c47eea00777$var$hasMSEdgeFreezingBug = function hasMSEdgeFreezingBug() {
    return $dd70d49b1cfa63a3$exports && $06c7d56a730e31f1$exports(function() {
        var frozenArray = $05ed4c47eea00777$var$freeze([]);
        $05ed4c47eea00777$var$nativeSet(new $05ed4c47eea00777$var$$WeakMap(), frozenArray, 1);
        return !$05ed4c47eea00777$var$isFrozen(frozenArray);
    });
};
// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if ($4056705048f999f1$exports) {
    if ($05ed4c47eea00777$var$IS_IE11) {
        $05ed4c47eea00777$var$InternalWeakMap = $e4859fd2e26a3f69$exports.getConstructor($05ed4c47eea00777$var$wrapper, 'WeakMap', true);
        $24ac99e13d26c138$exports.enable();
        var $05ed4c47eea00777$var$nativeDelete = $1689570c06db508b$exports($05ed4c47eea00777$var$WeakMapPrototype['delete']);
        var $05ed4c47eea00777$var$nativeHas = $1689570c06db508b$exports($05ed4c47eea00777$var$WeakMapPrototype.has);
        var $05ed4c47eea00777$var$nativeGet = $1689570c06db508b$exports($05ed4c47eea00777$var$WeakMapPrototype.get);
        $7ad1d749b941a26e$exports($05ed4c47eea00777$var$WeakMapPrototype, {
            'delete': function(key) {
                if ($d2d3162bdcc39b88$exports(key) && !$05ed4c47eea00777$var$isExtensible(key)) {
                    var state = $05ed4c47eea00777$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $05ed4c47eea00777$var$InternalWeakMap();
                    return $05ed4c47eea00777$var$nativeDelete(this, key) || state.frozen['delete'](key);
                }
                return $05ed4c47eea00777$var$nativeDelete(this, key);
            },
            has: function has(key) {
                if ($d2d3162bdcc39b88$exports(key) && !$05ed4c47eea00777$var$isExtensible(key)) {
                    var state = $05ed4c47eea00777$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $05ed4c47eea00777$var$InternalWeakMap();
                    return $05ed4c47eea00777$var$nativeHas(this, key) || state.frozen.has(key);
                }
                return $05ed4c47eea00777$var$nativeHas(this, key);
            },
            get: function get(key) {
                if ($d2d3162bdcc39b88$exports(key) && !$05ed4c47eea00777$var$isExtensible(key)) {
                    var state = $05ed4c47eea00777$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $05ed4c47eea00777$var$InternalWeakMap();
                    return $05ed4c47eea00777$var$nativeHas(this, key) ? $05ed4c47eea00777$var$nativeGet(this, key) : state.frozen.get(key);
                }
                return $05ed4c47eea00777$var$nativeGet(this, key);
            },
            set: function set(key, value) {
                if ($d2d3162bdcc39b88$exports(key) && !$05ed4c47eea00777$var$isExtensible(key)) {
                    var state = $05ed4c47eea00777$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $05ed4c47eea00777$var$InternalWeakMap();
                    $05ed4c47eea00777$var$nativeHas(this, key) ? $05ed4c47eea00777$var$nativeSet(this, key, value) : state.frozen.set(key, value);
                } else $05ed4c47eea00777$var$nativeSet(this, key, value);
                return this;
            }
        });
    // Chakra Edge frozen keys fix
    } else if ($05ed4c47eea00777$var$hasMSEdgeFreezingBug()) $7ad1d749b941a26e$exports($05ed4c47eea00777$var$WeakMapPrototype, {
        set: function set(key, value) {
            var arrayIntegrityLevel;
            if ($05ed4c47eea00777$var$isArray(key)) {
                if ($05ed4c47eea00777$var$isFrozen(key)) arrayIntegrityLevel = $05ed4c47eea00777$var$freeze;
                else if ($05ed4c47eea00777$var$isSealed(key)) arrayIntegrityLevel = $05ed4c47eea00777$var$seal;
            }
            $05ed4c47eea00777$var$nativeSet(this, key, value);
            if (arrayIntegrityLevel) arrayIntegrityLevel(key);
            return this;
        }
    });
}




'use strict';
'use strict';


// `WeakSet` constructor
// https://tc39.es/ecma262/#sec-weakset-constructor
$a78fa382baf6bf1e$exports('WeakSet', function(init) {
    return function WeakSet() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $e4859fd2e26a3f69$exports);




'use strict';

var $5e122a8970b1f9c7$exports = {};
'use strict';
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
$5e122a8970b1f9c7$exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};


var $dc3bfcd2b9b5a93c$exports = {};
'use strict';

var $dc3bfcd2b9b5a93c$var$classList = $b4e20123d93a8378$exports('span').classList;
var $dc3bfcd2b9b5a93c$var$DOMTokenListPrototype = $dc3bfcd2b9b5a93c$var$classList && $dc3bfcd2b9b5a93c$var$classList.constructor && $dc3bfcd2b9b5a93c$var$classList.constructor.prototype;
$dc3bfcd2b9b5a93c$exports = $dc3bfcd2b9b5a93c$var$DOMTokenListPrototype === Object.prototype ? undefined : $dc3bfcd2b9b5a93c$var$DOMTokenListPrototype;




var $495d00b5b14ae121$var$handlePrototype = function handlePrototype(CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype && CollectionPrototype.forEach !== $cb440d227fb3a5c7$exports) try {
        $5b5bc07d688591ac$exports(CollectionPrototype, 'forEach', $cb440d227fb3a5c7$exports);
    } catch (error) {
        CollectionPrototype.forEach = $cb440d227fb3a5c7$exports;
    }
};
for(var $495d00b5b14ae121$var$COLLECTION_NAME in $5e122a8970b1f9c7$exports)if ($5e122a8970b1f9c7$exports[$495d00b5b14ae121$var$COLLECTION_NAME]) $495d00b5b14ae121$var$handlePrototype($9be6fcc00ef60f58$exports[$495d00b5b14ae121$var$COLLECTION_NAME] && $9be6fcc00ef60f58$exports[$495d00b5b14ae121$var$COLLECTION_NAME].prototype);
$495d00b5b14ae121$var$handlePrototype($dc3bfcd2b9b5a93c$exports);


'use strict';







var $9c4d030cc9d01635$var$ITERATOR = $6268abd12745dd3b$exports('iterator');
var $9c4d030cc9d01635$var$ArrayValues = $7d62cd3cf967f9c5$exports.values;
var $9c4d030cc9d01635$var$handlePrototype = function handlePrototype(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$9c4d030cc9d01635$var$ITERATOR] !== $9c4d030cc9d01635$var$ArrayValues) try {
            $5b5bc07d688591ac$exports(CollectionPrototype, $9c4d030cc9d01635$var$ITERATOR, $9c4d030cc9d01635$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$9c4d030cc9d01635$var$ITERATOR] = $9c4d030cc9d01635$var$ArrayValues;
        }
        $be9d27c6f3178ed3$exports(CollectionPrototype, COLLECTION_NAME, true);
        if ($5e122a8970b1f9c7$exports[COLLECTION_NAME]) for(var METHOD_NAME in $7d62cd3cf967f9c5$exports){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $7d62cd3cf967f9c5$exports[METHOD_NAME]) try {
                $5b5bc07d688591ac$exports(CollectionPrototype, METHOD_NAME, $7d62cd3cf967f9c5$exports[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $7d62cd3cf967f9c5$exports[METHOD_NAME];
            }
        }
    }
};
for(var $9c4d030cc9d01635$var$COLLECTION_NAME in $5e122a8970b1f9c7$exports)$9c4d030cc9d01635$var$handlePrototype($9be6fcc00ef60f58$exports[$9c4d030cc9d01635$var$COLLECTION_NAME] && $9be6fcc00ef60f58$exports[$9c4d030cc9d01635$var$COLLECTION_NAME].prototype, $9c4d030cc9d01635$var$COLLECTION_NAME);
$9c4d030cc9d01635$var$handlePrototype($dc3bfcd2b9b5a93c$exports, 'DOMTokenList');


'use strict';
'use strict';



var $3921ba81af7445f4$require$clearImmediate = $6ece68b922b42b4f$exports.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$500d5d8b5806b834$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $9be6fcc00ef60f58$exports.clearImmediate !== $3921ba81af7445f4$require$clearImmediate
}, {
    clearImmediate: $3921ba81af7445f4$require$clearImmediate
});


'use strict';



var $92ca9f71f57e527a$require$setTask = $6ece68b922b42b4f$exports.set;
var $071600b7dd16ba77$exports = {};
'use strict';







var $071600b7dd16ba77$var$Function = $9be6fcc00ef60f58$exports.Function;
// dirty IE9- and Bun 0.3.0- checks
var $071600b7dd16ba77$var$WRAP = /MSIE .\./.test($57973a61a761d756$exports) || $2e69a89a5051d832$exports === 'BUN' && function() {
    var version = $9be6fcc00ef60f58$exports.Bun.version.split('.');
    return version.length < 3 || version[0] === '0' && (version[1] < 3 || version[1] === '3' && version[2] === '0');
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
$071600b7dd16ba77$exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $071600b7dd16ba77$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $2e3ae4fb0da606c5$exports(arguments.length, 1) > firstParamIndex;
        var fn = $0a82f0a5368b6870$exports(handler) ? handler : $071600b7dd16ba77$var$Function(handler);
        var params = boundArgs ? $65dcb7b8ed29ae22$exports(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function callback() {
            $c126e09ab0f7e2a8$exports(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};


// https://github.com/oven-sh/bun/issues/1633
var $92ca9f71f57e527a$var$setImmediate = $9be6fcc00ef60f58$exports.setImmediate ? $071600b7dd16ba77$exports($92ca9f71f57e527a$require$setTask, false) : $92ca9f71f57e527a$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$500d5d8b5806b834$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $9be6fcc00ef60f58$exports.setImmediate !== $92ca9f71f57e527a$var$setImmediate
}, {
    setImmediate: $92ca9f71f57e527a$var$setImmediate
});




'use strict';







// Bun ~ 1.0.30 bug
// https://github.com/oven-sh/bun/issues/9249
var $20337fbf916bdcd7$var$WRONG_ARITY = $06c7d56a730e31f1$exports(function() {
    // getOwnPropertyDescriptor for prevent experimental warning in Node 11
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return $6ffb7908e83cf36c$exports && Object.getOwnPropertyDescriptor($9be6fcc00ef60f58$exports, 'queueMicrotask').value.length !== 1;
});
// `queueMicrotask` method
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-queuemicrotask
$500d5d8b5806b834$exports({
    global: true,
    enumerable: true,
    dontCallGetSet: true,
    forced: $20337fbf916bdcd7$var$WRONG_ARITY
}, {
    queueMicrotask: function queueMicrotask(fn) {
        $2e3ae4fb0da606c5$exports(arguments.length, 1);
        $83551686af07bd37$exports($c976080d379e828f$exports(fn));
    }
});


'use strict';
'use strict';



var $718f952a0f04183c$var$setInterval = $071600b7dd16ba77$exports($9be6fcc00ef60f58$exports.setInterval, true);
// Bun / IE9- setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
$500d5d8b5806b834$exports({
    global: true,
    bind: true,
    forced: $9be6fcc00ef60f58$exports.setInterval !== $718f952a0f04183c$var$setInterval
}, {
    setInterval: $718f952a0f04183c$var$setInterval
});


'use strict';



var $655b2b1321fbed8a$var$setTimeout = $071600b7dd16ba77$exports($9be6fcc00ef60f58$exports.setTimeout, true);
// Bun / IE9- setTimeout additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
$500d5d8b5806b834$exports({
    global: true,
    bind: true,
    forced: $9be6fcc00ef60f58$exports.setTimeout !== $655b2b1321fbed8a$var$setTimeout
}, {
    setTimeout: $655b2b1321fbed8a$var$setTimeout
});




'use strict';

var $qb7pP = parcelRequire("qb7pP");
'use strict';



var $5aba2174b85280b7$exports = {};
'use strict';




var $5aba2174b85280b7$var$ITERATOR = $6268abd12745dd3b$exports('iterator');
$5aba2174b85280b7$exports = !$06c7d56a730e31f1$exports(function() {
    // eslint-disable-next-line unicorn/relative-url-style -- required for testing
    var url = new URL('b?a=1&b=2&c=3', 'https://a');
    var params = url.searchParams;
    var params2 = new URLSearchParams('a=1&a=2&b=3');
    var result = '';
    url.pathname = 'c%20d';
    params.forEach(function(value, key) {
        params['delete']('b');
        result += key + value;
    });
    params2['delete']('a', 2);
    // `undefined` case is a Chromium 117 bug
    // https://bugs.chromium.org/p/v8/issues/detail?id=14222
    params2['delete']('b', undefined);
    return $62bf9cf43d01f7ec$exports && (!url.toJSON || !params2.has('a', 1) || params2.has('a', 2) || !params2.has('a', undefined) || params2.has('b')) || !params.size && ($62bf9cf43d01f7ec$exports || !$6ffb7908e83cf36c$exports) || !params.sort || url.href !== 'https://a/c%20d?a=1&c=3' || params.get('c') !== '3' || String(new URLSearchParams('?a=1')) !== 'a=1' || !params[$5aba2174b85280b7$var$ITERATOR] || new URL('https://a@b').username !== 'a' || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b' || new URL("https://\u0442\u0435\u0441\u0442").host !== 'xn--e1aybc' || new URL("https://a#\u0431").hash !== '#%D0%B1' || result !== 'a1c3' || new URL('https://x', undefined).host !== 'x';
});













var $00aa40cdf9bc358f$require$codeAt = $2a3378023c0e1c1b$exports.codeAt;
var $179c3c97e0ee4daa$exports = {};
'use strict';

var $179c3c97e0ee4daa$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var $179c3c97e0ee4daa$var$base = 36;
var $179c3c97e0ee4daa$var$tMin = 1;
var $179c3c97e0ee4daa$var$tMax = 26;
var $179c3c97e0ee4daa$var$skew = 38;
var $179c3c97e0ee4daa$var$damp = 700;
var $179c3c97e0ee4daa$var$initialBias = 72;
var $179c3c97e0ee4daa$var$initialN = 128; // 0x80
var $179c3c97e0ee4daa$var$delimiter = '-'; // '\x2D'
var $179c3c97e0ee4daa$var$regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var $179c3c97e0ee4daa$var$regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var $179c3c97e0ee4daa$var$OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var $179c3c97e0ee4daa$var$baseMinusTMin = $179c3c97e0ee4daa$var$base - $179c3c97e0ee4daa$var$tMin;
var $179c3c97e0ee4daa$var$$RangeError = RangeError;
var $179c3c97e0ee4daa$var$exec = $1689570c06db508b$exports($179c3c97e0ee4daa$var$regexSeparators.exec);
var $179c3c97e0ee4daa$var$floor = Math.floor;
var $179c3c97e0ee4daa$var$fromCharCode = String.fromCharCode;
var $179c3c97e0ee4daa$var$charCodeAt = $1689570c06db508b$exports(''.charCodeAt);
var $179c3c97e0ee4daa$var$join = $1689570c06db508b$exports([].join);
var $179c3c97e0ee4daa$var$push = $1689570c06db508b$exports([].push);
var $179c3c97e0ee4daa$var$replace = $1689570c06db508b$exports(''.replace);
var $179c3c97e0ee4daa$var$split = $1689570c06db508b$exports(''.split);
var $179c3c97e0ee4daa$var$toLowerCase = $1689570c06db508b$exports(''.toLowerCase);
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */ var $179c3c97e0ee4daa$var$ucs2decode = function ucs2decode(string) {
    var output = [];
    var counter = 0;
    var length = string.length;
    while(counter < length){
        var value = $179c3c97e0ee4daa$var$charCodeAt(string, counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            var extra = $179c3c97e0ee4daa$var$charCodeAt(string, counter++);
            if ((extra & 0xFC00) === 0xDC00) $179c3c97e0ee4daa$var$push(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                $179c3c97e0ee4daa$var$push(output, value);
                counter--;
            }
        } else $179c3c97e0ee4daa$var$push(output, value);
    }
    return output;
};
/**
 * Converts a digit/integer into a basic code point.
 */ var $179c3c97e0ee4daa$var$digitToBasic = function digitToBasic(digit) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */ var $179c3c97e0ee4daa$var$adapt = function adapt(delta, numPoints, firstTime) {
    var k = 0;
    delta = firstTime ? $179c3c97e0ee4daa$var$floor(delta / $179c3c97e0ee4daa$var$damp) : delta >> 1;
    delta += $179c3c97e0ee4daa$var$floor(delta / numPoints);
    while(delta > $179c3c97e0ee4daa$var$baseMinusTMin * $179c3c97e0ee4daa$var$tMax >> 1){
        delta = $179c3c97e0ee4daa$var$floor(delta / $179c3c97e0ee4daa$var$baseMinusTMin);
        k += $179c3c97e0ee4daa$var$base;
    }
    return $179c3c97e0ee4daa$var$floor(k + ($179c3c97e0ee4daa$var$baseMinusTMin + 1) * delta / (delta + $179c3c97e0ee4daa$var$skew));
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */ var $179c3c97e0ee4daa$var$encode = function encode(input) {
    var output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $179c3c97e0ee4daa$var$ucs2decode(input);
    // Cache the length.
    var inputLength = input.length;
    // Initialize the state.
    var n = $179c3c97e0ee4daa$var$initialN;
    var delta = 0;
    var bias = $179c3c97e0ee4daa$var$initialBias;
    var i, currentValue;
    // Handle the basic code points.
    for(i = 0; i < input.length; i++){
        currentValue = input[i];
        if (currentValue < 0x80) $179c3c97e0ee4daa$var$push(output, $179c3c97e0ee4daa$var$fromCharCode(currentValue));
    }
    var basicLength = output.length; // number of basic code points.
    var handledCPCount = basicLength; // number of code points that have been handled;
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) $179c3c97e0ee4daa$var$push(output, $179c3c97e0ee4daa$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next larger one:
        var m = $179c3c97e0ee4daa$var$maxInt;
        for(i = 0; i < input.length; i++){
            currentValue = input[i];
            if (currentValue >= n && currentValue < m) m = currentValue;
        }
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
        var handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $179c3c97e0ee4daa$var$floor(($179c3c97e0ee4daa$var$maxInt - delta) / handledCPCountPlusOne)) throw new $179c3c97e0ee4daa$var$$RangeError($179c3c97e0ee4daa$var$OVERFLOW_ERROR);
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for(i = 0; i < input.length; i++){
            currentValue = input[i];
            if (currentValue < n && ++delta > $179c3c97e0ee4daa$var$maxInt) throw new $179c3c97e0ee4daa$var$$RangeError($179c3c97e0ee4daa$var$OVERFLOW_ERROR);
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                var q = delta;
                var k = $179c3c97e0ee4daa$var$base;
                while(true){
                    var t = k <= bias ? $179c3c97e0ee4daa$var$tMin : k >= bias + $179c3c97e0ee4daa$var$tMax ? $179c3c97e0ee4daa$var$tMax : k - bias;
                    if (q < t) break;
                    var qMinusT = q - t;
                    var baseMinusT = $179c3c97e0ee4daa$var$base - t;
                    $179c3c97e0ee4daa$var$push(output, $179c3c97e0ee4daa$var$fromCharCode($179c3c97e0ee4daa$var$digitToBasic(t + qMinusT % baseMinusT)));
                    q = $179c3c97e0ee4daa$var$floor(qMinusT / baseMinusT);
                    k += $179c3c97e0ee4daa$var$base;
                }
                $179c3c97e0ee4daa$var$push(output, $179c3c97e0ee4daa$var$fromCharCode($179c3c97e0ee4daa$var$digitToBasic(q)));
                bias = $179c3c97e0ee4daa$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                handledCPCount++;
            }
        }
        delta++;
        n++;
    }
    return $179c3c97e0ee4daa$var$join(output, '');
};
$179c3c97e0ee4daa$exports = function(input) {
    var encoded = [];
    var labels = $179c3c97e0ee4daa$var$split($179c3c97e0ee4daa$var$replace($179c3c97e0ee4daa$var$toLowerCase(input), $179c3c97e0ee4daa$var$regexSeparators, '\u002E'), '.');
    var i, label;
    for(i = 0; i < labels.length; i++){
        label = labels[i];
        $179c3c97e0ee4daa$var$push(encoded, $179c3c97e0ee4daa$var$exec($179c3c97e0ee4daa$var$regexNonASCII, label) ? 'xn--' + $179c3c97e0ee4daa$var$encode(label) : label);
    }
    return $179c3c97e0ee4daa$var$join(encoded, '.');
};





var $642cfdd25f8077cc$exports = {};
'use strict';
































var $642cfdd25f8077cc$var$ITERATOR = $6268abd12745dd3b$exports('iterator');
var $642cfdd25f8077cc$var$URL_SEARCH_PARAMS = 'URLSearchParams';
var $642cfdd25f8077cc$var$URL_SEARCH_PARAMS_ITERATOR = $642cfdd25f8077cc$var$URL_SEARCH_PARAMS + 'Iterator';
var $642cfdd25f8077cc$var$setInternalState = $419c333d2a5dd5f4$exports.set;
var $642cfdd25f8077cc$var$getInternalParamsState = $419c333d2a5dd5f4$exports.getterFor($642cfdd25f8077cc$var$URL_SEARCH_PARAMS);
var $642cfdd25f8077cc$var$getInternalIteratorState = $419c333d2a5dd5f4$exports.getterFor($642cfdd25f8077cc$var$URL_SEARCH_PARAMS_ITERATOR);
var $642cfdd25f8077cc$var$nativeFetch = $5c5516287ef435b7$exports('fetch');
var $642cfdd25f8077cc$var$NativeRequest = $5c5516287ef435b7$exports('Request');
var $642cfdd25f8077cc$var$Headers = $5c5516287ef435b7$exports('Headers');
var $642cfdd25f8077cc$var$RequestPrototype = $642cfdd25f8077cc$var$NativeRequest && $642cfdd25f8077cc$var$NativeRequest.prototype;
var $642cfdd25f8077cc$var$HeadersPrototype = $642cfdd25f8077cc$var$Headers && $642cfdd25f8077cc$var$Headers.prototype;
var $642cfdd25f8077cc$var$TypeError = $9be6fcc00ef60f58$exports.TypeError;
var $642cfdd25f8077cc$var$encodeURIComponent = $9be6fcc00ef60f58$exports.encodeURIComponent;
var $642cfdd25f8077cc$var$fromCharCode = String.fromCharCode;
var $642cfdd25f8077cc$var$fromCodePoint = $36de342b7315604e$exports('String', 'fromCodePoint');
var $642cfdd25f8077cc$var$$parseInt = parseInt;
var $642cfdd25f8077cc$var$charAt = $1689570c06db508b$exports(''.charAt);
var $642cfdd25f8077cc$var$join = $1689570c06db508b$exports([].join);
var $642cfdd25f8077cc$var$push = $1689570c06db508b$exports([].push);
var $642cfdd25f8077cc$var$replace = $1689570c06db508b$exports(''.replace);
var $642cfdd25f8077cc$var$shift = $1689570c06db508b$exports([].shift);
var $642cfdd25f8077cc$var$splice = $1689570c06db508b$exports([].splice);
var $642cfdd25f8077cc$var$split = $1689570c06db508b$exports(''.split);
var $642cfdd25f8077cc$var$stringSlice = $1689570c06db508b$exports(''.slice);
var $642cfdd25f8077cc$var$exec = $1689570c06db508b$exports(/./.exec);
var $642cfdd25f8077cc$var$plus = /\+/g;
var $642cfdd25f8077cc$var$FALLBACK_REPLACER = '\uFFFD';
var $642cfdd25f8077cc$var$VALID_HEX = /^[0-9a-f]+$/i;
var $642cfdd25f8077cc$var$parseHexOctet = function parseHexOctet(string, start) {
    var substr = $642cfdd25f8077cc$var$stringSlice(string, start, start + 2);
    if (!$642cfdd25f8077cc$var$exec($642cfdd25f8077cc$var$VALID_HEX, substr)) return NaN;
    return $642cfdd25f8077cc$var$$parseInt(substr, 16);
};
var $642cfdd25f8077cc$var$getLeadingOnes = function getLeadingOnes(octet) {
    var count = 0;
    for(var mask = 0x80; mask > 0 && (octet & mask) !== 0; mask >>= 1)count++;
    return count;
};
var $642cfdd25f8077cc$var$utf8Decode = function utf8Decode(octets) {
    var codePoint = null;
    switch(octets.length){
        case 1:
            codePoint = octets[0];
            break;
        case 2:
            codePoint = (octets[0] & 0x1F) << 6 | octets[1] & 0x3F;
            break;
        case 3:
            codePoint = (octets[0] & 0x0F) << 12 | (octets[1] & 0x3F) << 6 | octets[2] & 0x3F;
            break;
        case 4:
            codePoint = (octets[0] & 0x07) << 18 | (octets[1] & 0x3F) << 12 | (octets[2] & 0x3F) << 6 | octets[3] & 0x3F;
            break;
    }
    return codePoint > 0x10FFFF ? null : codePoint;
};
var $642cfdd25f8077cc$var$decode = function decode(input) {
    input = $642cfdd25f8077cc$var$replace(input, $642cfdd25f8077cc$var$plus, ' ');
    var length = input.length;
    var result = '';
    var i = 0;
    while(i < length){
        var decodedChar = $642cfdd25f8077cc$var$charAt(input, i);
        if (decodedChar === '%') {
            if ($642cfdd25f8077cc$var$charAt(input, i + 1) === '%' || i + 3 > length) {
                result += '%';
                i++;
                continue;
            }
            var octet = $642cfdd25f8077cc$var$parseHexOctet(input, i + 1);
            // eslint-disable-next-line no-self-compare -- NaN check
            if (octet !== octet) {
                result += decodedChar;
                i++;
                continue;
            }
            i += 2;
            var byteSequenceLength = $642cfdd25f8077cc$var$getLeadingOnes(octet);
            if (byteSequenceLength === 0) decodedChar = $642cfdd25f8077cc$var$fromCharCode(octet);
            else {
                if (byteSequenceLength === 1 || byteSequenceLength > 4) {
                    result += $642cfdd25f8077cc$var$FALLBACK_REPLACER;
                    i++;
                    continue;
                }
                var octets = [
                    octet
                ];
                var sequenceIndex = 1;
                while(sequenceIndex < byteSequenceLength){
                    i++;
                    if (i + 3 > length || $642cfdd25f8077cc$var$charAt(input, i) !== '%') break;
                    var nextByte = $642cfdd25f8077cc$var$parseHexOctet(input, i + 1);
                    // eslint-disable-next-line no-self-compare -- NaN check
                    if (nextByte !== nextByte) {
                        i += 3;
                        break;
                    }
                    if (nextByte > 191 || nextByte < 128) break;
                    $642cfdd25f8077cc$var$push(octets, nextByte);
                    i += 2;
                    sequenceIndex++;
                }
                if (octets.length !== byteSequenceLength) {
                    result += $642cfdd25f8077cc$var$FALLBACK_REPLACER;
                    continue;
                }
                var codePoint = $642cfdd25f8077cc$var$utf8Decode(octets);
                if (codePoint === null) result += $642cfdd25f8077cc$var$FALLBACK_REPLACER;
                else decodedChar = $642cfdd25f8077cc$var$fromCodePoint(codePoint);
            }
        }
        result += decodedChar;
        i++;
    }
    return result;
};
var $642cfdd25f8077cc$var$find = /[!'()~]|%20/g;
var $642cfdd25f8077cc$var$replacements = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+'
};
var $642cfdd25f8077cc$var$replacer = function replacer(match) {
    return $642cfdd25f8077cc$var$replacements[match];
};
var $642cfdd25f8077cc$var$serialize = function serialize(it) {
    return $642cfdd25f8077cc$var$replace($642cfdd25f8077cc$var$encodeURIComponent(it), $642cfdd25f8077cc$var$find, $642cfdd25f8077cc$var$replacer);
};
var $642cfdd25f8077cc$var$URLSearchParamsIterator = $ec365b22b9a10925$exports(function Iterator(params, kind) {
    $642cfdd25f8077cc$var$setInternalState(this, {
        type: $642cfdd25f8077cc$var$URL_SEARCH_PARAMS_ITERATOR,
        target: $642cfdd25f8077cc$var$getInternalParamsState(params).entries,
        index: 0,
        kind: kind
    });
}, $642cfdd25f8077cc$var$URL_SEARCH_PARAMS, function next() {
    var state = $642cfdd25f8077cc$var$getInternalIteratorState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = null;
        return $e026e44558cad06d$exports(undefined, true);
    }
    var entry = target[index];
    switch(state.kind){
        case 'keys':
            return $e026e44558cad06d$exports(entry.key, false);
        case 'values':
            return $e026e44558cad06d$exports(entry.value, false);
    }
    return $e026e44558cad06d$exports([
        entry.key,
        entry.value
    ], false);
}, true);
var $642cfdd25f8077cc$var$URLSearchParamsState = function URLSearchParamsState(init) {
    this.entries = [];
    this.url = null;
    if (init !== undefined) {
        if ($d2d3162bdcc39b88$exports(init)) this.parseObject(init);
        else this.parseQuery(typeof init == 'string' ? $642cfdd25f8077cc$var$charAt(init, 0) === '?' ? $642cfdd25f8077cc$var$stringSlice(init, 1) : init : $f4fff477af530dca$exports(init));
    }
};
$642cfdd25f8077cc$var$URLSearchParamsState.prototype = {
    type: $642cfdd25f8077cc$var$URL_SEARCH_PARAMS,
    bindURL: function bindURL(url) {
        this.url = url;
        this.update();
    },
    parseObject: function parseObject(object) {
        var entries = this.entries;
        var iteratorMethod = $b7a9a1ef631e02cb$exports(object);
        var iterator, next, step, entryIterator, entryNext, first, second;
        if (iteratorMethod) {
            iterator = $e16d366978e3a98b$exports(object, iteratorMethod);
            next = iterator.next;
            while(!(step = $e3ebd8cb7f512f74$exports(next, iterator)).done){
                entryIterator = $e16d366978e3a98b$exports($05718fce3232bc84$exports(step.value));
                entryNext = entryIterator.next;
                if ((first = $e3ebd8cb7f512f74$exports(entryNext, entryIterator)).done || (second = $e3ebd8cb7f512f74$exports(entryNext, entryIterator)).done || !$e3ebd8cb7f512f74$exports(entryNext, entryIterator).done) throw new $642cfdd25f8077cc$var$TypeError('Expected sequence with length 2');
                $642cfdd25f8077cc$var$push(entries, {
                    key: $f4fff477af530dca$exports(first.value),
                    value: $f4fff477af530dca$exports(second.value)
                });
            }
        } else for(var key in object)if ($35cf4bf79fe152cc$exports(object, key)) $642cfdd25f8077cc$var$push(entries, {
            key: key,
            value: $f4fff477af530dca$exports(object[key])
        });
    },
    parseQuery: function parseQuery(query) {
        if (query) {
            var entries = this.entries;
            var attributes = $642cfdd25f8077cc$var$split(query, '&');
            var index = 0;
            var attribute, entry;
            while(index < attributes.length){
                attribute = attributes[index++];
                if (attribute.length) {
                    entry = $642cfdd25f8077cc$var$split(attribute, '=');
                    $642cfdd25f8077cc$var$push(entries, {
                        key: $642cfdd25f8077cc$var$decode($642cfdd25f8077cc$var$shift(entry)),
                        value: $642cfdd25f8077cc$var$decode($642cfdd25f8077cc$var$join(entry, '='))
                    });
                }
            }
        }
    },
    serialize: function serialize1() {
        var entries = this.entries;
        var result = [];
        var index = 0;
        var entry;
        while(index < entries.length){
            entry = entries[index++];
            $642cfdd25f8077cc$var$push(result, $642cfdd25f8077cc$var$serialize(entry.key) + '=' + $642cfdd25f8077cc$var$serialize(entry.value));
        }
        return $642cfdd25f8077cc$var$join(result, '&');
    },
    update: function update() {
        this.entries.length = 0;
        this.parseQuery(this.url.query);
    },
    updateURL: function updateURL() {
        if (this.url) this.url.update();
    }
};
// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var $642cfdd25f8077cc$var$URLSearchParamsConstructor = function URLSearchParams() {
    $65f23bed46afab45$exports(this, $642cfdd25f8077cc$var$URLSearchParamsPrototype);
    var init = arguments.length > 0 ? arguments[0] : undefined;
    var state = $642cfdd25f8077cc$var$setInternalState(this, new $642cfdd25f8077cc$var$URLSearchParamsState(init));
    if (!$6ffb7908e83cf36c$exports) this.size = state.entries.length;
};
var $642cfdd25f8077cc$var$URLSearchParamsPrototype = $642cfdd25f8077cc$var$URLSearchParamsConstructor.prototype;
$7ad1d749b941a26e$exports($642cfdd25f8077cc$var$URLSearchParamsPrototype, {
    // `URLSearchParams.prototype.append` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-append
    append: function append(name, value) {
        var state = $642cfdd25f8077cc$var$getInternalParamsState(this);
        $2e3ae4fb0da606c5$exports(arguments.length, 2);
        $642cfdd25f8077cc$var$push(state.entries, {
            key: $f4fff477af530dca$exports(name),
            value: $f4fff477af530dca$exports(value)
        });
        if (!$6ffb7908e83cf36c$exports) this.length++;
        state.updateURL();
    },
    // `URLSearchParams.prototype.delete` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
    'delete': function(name /* , value */ ) {
        var state = $642cfdd25f8077cc$var$getInternalParamsState(this);
        var length = $2e3ae4fb0da606c5$exports(arguments.length, 1);
        var entries = state.entries;
        var key = $f4fff477af530dca$exports(name);
        var $value = length < 2 ? undefined : arguments[1];
        var value = $value === undefined ? $value : $f4fff477af530dca$exports($value);
        var index = 0;
        while(index < entries.length){
            var entry = entries[index];
            if (entry.key === key && (value === undefined || entry.value === value)) {
                $642cfdd25f8077cc$var$splice(entries, index, 1);
                if (value !== undefined) break;
            } else index++;
        }
        if (!$6ffb7908e83cf36c$exports) this.size = entries.length;
        state.updateURL();
    },
    // `URLSearchParams.prototype.get` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-get
    get: function get(name) {
        var entries = $642cfdd25f8077cc$var$getInternalParamsState(this).entries;
        $2e3ae4fb0da606c5$exports(arguments.length, 1);
        var key = $f4fff477af530dca$exports(name);
        var index = 0;
        for(; index < entries.length; index++){
            if (entries[index].key === key) return entries[index].value;
        }
        return null;
    },
    // `URLSearchParams.prototype.getAll` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
    getAll: function getAll(name) {
        var entries = $642cfdd25f8077cc$var$getInternalParamsState(this).entries;
        $2e3ae4fb0da606c5$exports(arguments.length, 1);
        var key = $f4fff477af530dca$exports(name);
        var result = [];
        var index = 0;
        for(; index < entries.length; index++)if (entries[index].key === key) $642cfdd25f8077cc$var$push(result, entries[index].value);
        return result;
    },
    // `URLSearchParams.prototype.has` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-has
    has: function has(name /* , value */ ) {
        var entries = $642cfdd25f8077cc$var$getInternalParamsState(this).entries;
        var length = $2e3ae4fb0da606c5$exports(arguments.length, 1);
        var key = $f4fff477af530dca$exports(name);
        var $value = length < 2 ? undefined : arguments[1];
        var value = $value === undefined ? $value : $f4fff477af530dca$exports($value);
        var index = 0;
        while(index < entries.length){
            var entry = entries[index++];
            if (entry.key === key && (value === undefined || entry.value === value)) return true;
        }
        return false;
    },
    // `URLSearchParams.prototype.set` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-set
    set: function set(name, value) {
        var state = $642cfdd25f8077cc$var$getInternalParamsState(this);
        $2e3ae4fb0da606c5$exports(arguments.length, 1);
        var entries = state.entries;
        var found = false;
        var key = $f4fff477af530dca$exports(name);
        var val = $f4fff477af530dca$exports(value);
        var index = 0;
        var entry;
        for(; index < entries.length; index++){
            entry = entries[index];
            if (entry.key === key) {
                if (found) $642cfdd25f8077cc$var$splice(entries, index--, 1);
                else {
                    found = true;
                    entry.value = val;
                }
            }
        }
        if (!found) $642cfdd25f8077cc$var$push(entries, {
            key: key,
            value: val
        });
        if (!$6ffb7908e83cf36c$exports) this.size = entries.length;
        state.updateURL();
    },
    // `URLSearchParams.prototype.sort` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
    sort: function sort() {
        var state = $642cfdd25f8077cc$var$getInternalParamsState(this);
        $4ee33df2db620866$exports(state.entries, function(a, b) {
            return a.key > b.key ? 1 : -1;
        });
        state.updateURL();
    },
    // `URLSearchParams.prototype.forEach` method
    forEach: function forEach(callback /* , thisArg */ ) {
        var entries = $642cfdd25f8077cc$var$getInternalParamsState(this).entries;
        var boundFunction = $847280b2cf36c2e0$exports(callback, arguments.length > 1 ? arguments[1] : undefined);
        var index = 0;
        var entry;
        while(index < entries.length){
            entry = entries[index++];
            boundFunction(entry.value, entry.key, this);
        }
    },
    // `URLSearchParams.prototype.keys` method
    keys: function keys() {
        return new $642cfdd25f8077cc$var$URLSearchParamsIterator(this, 'keys');
    },
    // `URLSearchParams.prototype.values` method
    values: function values() {
        return new $642cfdd25f8077cc$var$URLSearchParamsIterator(this, 'values');
    },
    // `URLSearchParams.prototype.entries` method
    entries: function entries() {
        return new $642cfdd25f8077cc$var$URLSearchParamsIterator(this, 'entries');
    }
}, {
    enumerable: true
});
// `URLSearchParams.prototype[@@iterator]` method
$b817bfc251eac07c$exports($642cfdd25f8077cc$var$URLSearchParamsPrototype, $642cfdd25f8077cc$var$ITERATOR, $642cfdd25f8077cc$var$URLSearchParamsPrototype.entries, {
    name: 'entries'
});
// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
$b817bfc251eac07c$exports($642cfdd25f8077cc$var$URLSearchParamsPrototype, 'toString', function toString() {
    return $642cfdd25f8077cc$var$getInternalParamsState(this).serialize();
}, {
    enumerable: true
});
// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if ($6ffb7908e83cf36c$exports) $6de7996ceea81cf8$exports($642cfdd25f8077cc$var$URLSearchParamsPrototype, 'size', {
    get: function size() {
        return $642cfdd25f8077cc$var$getInternalParamsState(this).entries.length;
    },
    configurable: true,
    enumerable: true
});
$be9d27c6f3178ed3$exports($642cfdd25f8077cc$var$URLSearchParamsConstructor, $642cfdd25f8077cc$var$URL_SEARCH_PARAMS);
$500d5d8b5806b834$exports({
    global: true,
    constructor: true,
    forced: !$5aba2174b85280b7$exports
}, {
    URLSearchParams: $642cfdd25f8077cc$var$URLSearchParamsConstructor
});
// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!$5aba2174b85280b7$exports && $0a82f0a5368b6870$exports($642cfdd25f8077cc$var$Headers)) {
    var $642cfdd25f8077cc$var$headersHas = $1689570c06db508b$exports($642cfdd25f8077cc$var$HeadersPrototype.has);
    var $642cfdd25f8077cc$var$headersSet = $1689570c06db508b$exports($642cfdd25f8077cc$var$HeadersPrototype.set);
    var $642cfdd25f8077cc$var$wrapRequestOptions = function wrapRequestOptions(init) {
        if ($d2d3162bdcc39b88$exports(init)) {
            var body = init.body;
            var headers;
            if ($4591439421551449$exports(body) === $642cfdd25f8077cc$var$URL_SEARCH_PARAMS) {
                headers = init.headers ? new $642cfdd25f8077cc$var$Headers(init.headers) : new $642cfdd25f8077cc$var$Headers();
                if (!$642cfdd25f8077cc$var$headersHas(headers, 'content-type')) $642cfdd25f8077cc$var$headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                return $c8a7d59657e3f14b$exports(init, {
                    body: $f89eb1caea2679b0$exports(0, $f4fff477af530dca$exports(body)),
                    headers: $f89eb1caea2679b0$exports(0, headers)
                });
            }
        }
        return init;
    };
    if ($0a82f0a5368b6870$exports($642cfdd25f8077cc$var$nativeFetch)) $500d5d8b5806b834$exports({
        global: true,
        enumerable: true,
        dontCallGetSet: true,
        forced: true
    }, {
        fetch: function fetch(input /* , init */ ) {
            return $642cfdd25f8077cc$var$nativeFetch(input, arguments.length > 1 ? $642cfdd25f8077cc$var$wrapRequestOptions(arguments[1]) : {});
        }
    });
    if ($0a82f0a5368b6870$exports($642cfdd25f8077cc$var$NativeRequest)) {
        var $642cfdd25f8077cc$var$RequestConstructor = function Request(input /* , init */ ) {
            $65f23bed46afab45$exports(this, $642cfdd25f8077cc$var$RequestPrototype);
            return new $642cfdd25f8077cc$var$NativeRequest(input, arguments.length > 1 ? $642cfdd25f8077cc$var$wrapRequestOptions(arguments[1]) : {});
        };
        $642cfdd25f8077cc$var$RequestPrototype.constructor = $642cfdd25f8077cc$var$RequestConstructor;
        $642cfdd25f8077cc$var$RequestConstructor.prototype = $642cfdd25f8077cc$var$RequestPrototype;
        $500d5d8b5806b834$exports({
            global: true,
            constructor: true,
            dontCallGetSet: true,
            forced: true
        }, {
            Request: $642cfdd25f8077cc$var$RequestConstructor
        });
    }
}
$642cfdd25f8077cc$exports = {
    URLSearchParams: $642cfdd25f8077cc$var$URLSearchParamsConstructor,
    getState: $642cfdd25f8077cc$var$getInternalParamsState
};



var $00aa40cdf9bc358f$var$setInternalState = $419c333d2a5dd5f4$exports.set;
var $00aa40cdf9bc358f$var$getInternalURLState = $419c333d2a5dd5f4$exports.getterFor('URL');
var $00aa40cdf9bc358f$var$URLSearchParams = $642cfdd25f8077cc$exports.URLSearchParams;
var $00aa40cdf9bc358f$var$getInternalSearchParamsState = $642cfdd25f8077cc$exports.getState;
var $00aa40cdf9bc358f$var$NativeURL = $9be6fcc00ef60f58$exports.URL;
var $00aa40cdf9bc358f$var$TypeError = $9be6fcc00ef60f58$exports.TypeError;
var $00aa40cdf9bc358f$var$parseInt = $9be6fcc00ef60f58$exports.parseInt;
var $00aa40cdf9bc358f$var$floor = Math.floor;
var $00aa40cdf9bc358f$var$pow = Math.pow;
var $00aa40cdf9bc358f$var$charAt = $1689570c06db508b$exports(''.charAt);
var $00aa40cdf9bc358f$var$exec = $1689570c06db508b$exports(/./.exec);
var $00aa40cdf9bc358f$var$join = $1689570c06db508b$exports([].join);
var $00aa40cdf9bc358f$var$numberToString = $1689570c06db508b$exports(1.0.toString);
var $00aa40cdf9bc358f$var$pop = $1689570c06db508b$exports([].pop);
var $00aa40cdf9bc358f$var$push = $1689570c06db508b$exports([].push);
var $00aa40cdf9bc358f$var$replace = $1689570c06db508b$exports(''.replace);
var $00aa40cdf9bc358f$var$shift = $1689570c06db508b$exports([].shift);
var $00aa40cdf9bc358f$var$split = $1689570c06db508b$exports(''.split);
var $00aa40cdf9bc358f$var$stringSlice = $1689570c06db508b$exports(''.slice);
var $00aa40cdf9bc358f$var$toLowerCase = $1689570c06db508b$exports(''.toLowerCase);
var $00aa40cdf9bc358f$var$unshift = $1689570c06db508b$exports([].unshift);
var $00aa40cdf9bc358f$var$INVALID_AUTHORITY = 'Invalid authority';
var $00aa40cdf9bc358f$var$INVALID_SCHEME = 'Invalid scheme';
var $00aa40cdf9bc358f$var$INVALID_HOST = 'Invalid host';
var $00aa40cdf9bc358f$var$INVALID_PORT = 'Invalid port';
var $00aa40cdf9bc358f$var$ALPHA = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var $00aa40cdf9bc358f$var$ALPHANUMERIC = /[\d+-.a-z]/i;
var $00aa40cdf9bc358f$var$DIGIT = /\d/;
var $00aa40cdf9bc358f$var$HEX_START = /^0x/i;
var $00aa40cdf9bc358f$var$OCT = /^[0-7]+$/;
var $00aa40cdf9bc358f$var$DEC = /^\d+$/;
var $00aa40cdf9bc358f$var$HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */ var $00aa40cdf9bc358f$var$FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var $00aa40cdf9bc358f$var$FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var $00aa40cdf9bc358f$var$LEADING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+/;
var $00aa40cdf9bc358f$var$TRAILING_C0_CONTROL_OR_SPACE = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/;
var $00aa40cdf9bc358f$var$TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */ var $00aa40cdf9bc358f$var$EOF;
// https://url.spec.whatwg.org/#ipv4-number-parser
var $00aa40cdf9bc358f$var$parseIPv4 = function parseIPv4(input) {
    var parts = $00aa40cdf9bc358f$var$split(input, '.');
    var partsLength, numbers, index, part, radix, number, ipv4;
    if (parts.length && parts[parts.length - 1] === '') parts.length--;
    partsLength = parts.length;
    if (partsLength > 4) return input;
    numbers = [];
    for(index = 0; index < partsLength; index++){
        part = parts[index];
        if (part === '') return input;
        radix = 10;
        if (part.length > 1 && $00aa40cdf9bc358f$var$charAt(part, 0) === '0') {
            radix = $00aa40cdf9bc358f$var$exec($00aa40cdf9bc358f$var$HEX_START, part) ? 16 : 8;
            part = $00aa40cdf9bc358f$var$stringSlice(part, radix === 8 ? 1 : 2);
        }
        if (part === '') number = 0;
        else {
            if (!$00aa40cdf9bc358f$var$exec(radix === 10 ? $00aa40cdf9bc358f$var$DEC : radix === 8 ? $00aa40cdf9bc358f$var$OCT : $00aa40cdf9bc358f$var$HEX, part)) return input;
            number = $00aa40cdf9bc358f$var$parseInt(part, radix);
        }
        $00aa40cdf9bc358f$var$push(numbers, number);
    }
    for(index = 0; index < partsLength; index++){
        number = numbers[index];
        if (index === partsLength - 1) {
            if (number >= $00aa40cdf9bc358f$var$pow(256, 5 - partsLength)) return null;
        } else if (number > 255) return null;
    }
    ipv4 = $00aa40cdf9bc358f$var$pop(numbers);
    for(index = 0; index < numbers.length; index++)ipv4 += numbers[index] * $00aa40cdf9bc358f$var$pow(256, 3 - index);
    return ipv4;
};
// https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO
var $00aa40cdf9bc358f$var$parseIPv6 = function parseIPv6(input) {
    var address = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    var pieceIndex = 0;
    var compress = null;
    var pointer = 0;
    var value, length, numbersSeen, ipv4Piece, number, swaps, swap;
    var chr = function chr() {
        return $00aa40cdf9bc358f$var$charAt(input, pointer);
    };
    if (chr() === ':') {
        if ($00aa40cdf9bc358f$var$charAt(input, 1) !== ':') return;
        pointer += 2;
        pieceIndex++;
        compress = pieceIndex;
    }
    while(chr()){
        if (pieceIndex === 8) return;
        if (chr() === ':') {
            if (compress !== null) return;
            pointer++;
            pieceIndex++;
            compress = pieceIndex;
            continue;
        }
        value = length = 0;
        while(length < 4 && $00aa40cdf9bc358f$var$exec($00aa40cdf9bc358f$var$HEX, chr())){
            value = value * 16 + $00aa40cdf9bc358f$var$parseInt(chr(), 16);
            pointer++;
            length++;
        }
        if (chr() === '.') {
            if (length === 0) return;
            pointer -= length;
            if (pieceIndex > 6) return;
            numbersSeen = 0;
            while(chr()){
                ipv4Piece = null;
                if (numbersSeen > 0) {
                    if (chr() === '.' && numbersSeen < 4) pointer++;
                    else return;
                }
                if (!$00aa40cdf9bc358f$var$exec($00aa40cdf9bc358f$var$DIGIT, chr())) return;
                while($00aa40cdf9bc358f$var$exec($00aa40cdf9bc358f$var$DIGIT, chr())){
                    number = $00aa40cdf9bc358f$var$parseInt(chr(), 10);
                    if (ipv4Piece === null) ipv4Piece = number;
                    else if (ipv4Piece === 0) return;
                    else ipv4Piece = ipv4Piece * 10 + number;
                    if (ipv4Piece > 255) return;
                    pointer++;
                }
                address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
                numbersSeen++;
                if (numbersSeen === 2 || numbersSeen === 4) pieceIndex++;
            }
            if (numbersSeen !== 4) return;
            break;
        } else if (chr() === ':') {
            pointer++;
            if (!chr()) return;
        } else if (chr()) return;
        address[pieceIndex++] = value;
    }
    if (compress !== null) {
        swaps = pieceIndex - compress;
        pieceIndex = 7;
        while(pieceIndex !== 0 && swaps > 0){
            swap = address[pieceIndex];
            address[pieceIndex--] = address[compress + swaps - 1];
            address[compress + --swaps] = swap;
        }
    } else if (pieceIndex !== 8) return;
    return address;
};
var $00aa40cdf9bc358f$var$findLongestZeroSequence = function findLongestZeroSequence(ipv6) {
    var maxIndex = null;
    var maxLength = 1;
    var currStart = null;
    var currLength = 0;
    var index = 0;
    for(; index < 8; index++)if (ipv6[index] !== 0) {
        if (currLength > maxLength) {
            maxIndex = currStart;
            maxLength = currLength;
        }
        currStart = null;
        currLength = 0;
    } else {
        if (currStart === null) currStart = index;
        ++currLength;
    }
    return currLength > maxLength ? currStart : maxIndex;
};
// https://url.spec.whatwg.org/#host-serializing
var $00aa40cdf9bc358f$var$serializeHost = function serializeHost(host) {
    var result, index, compress, ignore0;
    // ipv4
    if (typeof host == 'number') {
        result = [];
        for(index = 0; index < 4; index++){
            $00aa40cdf9bc358f$var$unshift(result, host % 256);
            host = $00aa40cdf9bc358f$var$floor(host / 256);
        }
        return $00aa40cdf9bc358f$var$join(result, '.');
    }
    // ipv6
    if ((typeof host === "undefined" ? "undefined" : (0, $qb7pP._)(host)) == 'object') {
        result = '';
        compress = $00aa40cdf9bc358f$var$findLongestZeroSequence(host);
        for(index = 0; index < 8; index++){
            if (ignore0 && host[index] === 0) continue;
            if (ignore0) ignore0 = false;
            if (compress === index) {
                result += index ? ':' : '::';
                ignore0 = true;
            } else {
                result += $00aa40cdf9bc358f$var$numberToString(host[index], 16);
                if (index < 7) result += ':';
            }
        }
        return '[' + result + ']';
    }
    return host;
};
var $00aa40cdf9bc358f$var$C0ControlPercentEncodeSet = {};
var $00aa40cdf9bc358f$var$fragmentPercentEncodeSet = $12c15fcd9efee893$exports({}, $00aa40cdf9bc358f$var$C0ControlPercentEncodeSet, {
    ' ': 1,
    '"': 1,
    '<': 1,
    '>': 1,
    '`': 1
});
var $00aa40cdf9bc358f$var$pathPercentEncodeSet = $12c15fcd9efee893$exports({}, $00aa40cdf9bc358f$var$fragmentPercentEncodeSet, {
    '#': 1,
    '?': 1,
    '{': 1,
    '}': 1
});
var $00aa40cdf9bc358f$var$userinfoPercentEncodeSet = $12c15fcd9efee893$exports({}, $00aa40cdf9bc358f$var$pathPercentEncodeSet, {
    '/': 1,
    ':': 1,
    ';': 1,
    '=': 1,
    '@': 1,
    '[': 1,
    '\\': 1,
    ']': 1,
    '^': 1,
    '|': 1
});
var $00aa40cdf9bc358f$var$percentEncode = function percentEncode(chr, set) {
    var code = $00aa40cdf9bc358f$require$codeAt(chr, 0);
    return code > 0x20 && code < 0x7F && !$35cf4bf79fe152cc$exports(set, chr) ? chr : encodeURIComponent(chr);
};
// https://url.spec.whatwg.org/#special-scheme
var $00aa40cdf9bc358f$var$specialSchemes = {
    ftp: 21,
    file: null,
    http: 80,
    https: 443,
    ws: 80,
    wss: 443
};
// https://url.spec.whatwg.org/#windows-drive-letter
var $00aa40cdf9bc358f$var$isWindowsDriveLetter = function isWindowsDriveLetter(string, normalized) {
    var second;
    return string.length === 2 && $00aa40cdf9bc358f$var$exec($00aa40cdf9bc358f$var$ALPHA, $00aa40cdf9bc358f$var$charAt(string, 0)) && ((second = $00aa40cdf9bc358f$var$charAt(string, 1)) === ':' || !normalized && second === '|');
};
// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
var $00aa40cdf9bc358f$var$startsWithWindowsDriveLetter = function startsWithWindowsDriveLetter(string) {
    var third;
    return string.length > 1 && $00aa40cdf9bc358f$var$isWindowsDriveLetter($00aa40cdf9bc358f$var$stringSlice(string, 0, 2)) && (string.length === 2 || (third = $00aa40cdf9bc358f$var$charAt(string, 2)) === '/' || third === '\\' || third === '?' || third === '#');
};
// https://url.spec.whatwg.org/#single-dot-path-segment
var $00aa40cdf9bc358f$var$isSingleDot = function isSingleDot(segment) {
    return segment === '.' || $00aa40cdf9bc358f$var$toLowerCase(segment) === '%2e';
};
// https://url.spec.whatwg.org/#double-dot-path-segment
var $00aa40cdf9bc358f$var$isDoubleDot = function isDoubleDot(segment) {
    segment = $00aa40cdf9bc358f$var$toLowerCase(segment);
    return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};
// States:
var $00aa40cdf9bc358f$var$SCHEME_START = {};
var $00aa40cdf9bc358f$var$SCHEME = {};
var $00aa40cdf9bc358f$var$NO_SCHEME = {};
var $00aa40cdf9bc358f$var$SPECIAL_RELATIVE_OR_AUTHORITY = {};
var $00aa40cdf9bc358f$var$PATH_OR_AUTHORITY = {};
var $00aa40cdf9bc358f$var$RELATIVE = {};
var $00aa40cdf9bc358f$var$RELATIVE_SLASH = {};
var $00aa40cdf9bc358f$var$SPECIAL_AUTHORITY_SLASHES = {};
var $00aa40cdf9bc358f$var$SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var $00aa40cdf9bc358f$var$AUTHORITY = {};
var $00aa40cdf9bc358f$var$HOST = {};
var $00aa40cdf9bc358f$var$HOSTNAME = {};
var $00aa40cdf9bc358f$var$PORT = {};
var $00aa40cdf9bc358f$var$FILE = {};
var $00aa40cdf9bc358f$var$FILE_SLASH = {};
var $00aa40cdf9bc358f$var$FILE_HOST = {};
var $00aa40cdf9bc358f$var$PATH_START = {};
var $00aa40cdf9bc358f$var$PATH = {};
var $00aa40cdf9bc358f$var$CANNOT_BE_A_BASE_URL_PATH = {};
var $00aa40cdf9bc358f$var$QUERY = {};
var $00aa40cdf9bc358f$var$FRAGMENT = {};
var $00aa40cdf9bc358f$var$URLState = function URLState1(url, isBase, base) {
    var urlString = $f4fff477af530dca$exports(url);
    var baseState, failure, searchParams;
    if (isBase) {
        failure = this.parse(urlString);
        if (failure) throw new $00aa40cdf9bc358f$var$TypeError(failure);
        this.searchParams = null;
    } else {
        if (base !== undefined) baseState = new $00aa40cdf9bc358f$var$URLState(base, true);
        failure = this.parse(urlString, null, baseState);
        if (failure) throw new $00aa40cdf9bc358f$var$TypeError(failure);
        searchParams = $00aa40cdf9bc358f$var$getInternalSearchParamsState(new $00aa40cdf9bc358f$var$URLSearchParams());
        searchParams.bindURL(this);
        this.searchParams = searchParams;
    }
};
$00aa40cdf9bc358f$var$URLState.prototype = {
    type: 'URL',
    // https://url.spec.whatwg.org/#url-parsing
    // eslint-disable-next-line max-statements -- TODO
    parse: function parse(input, stateOverride, base) {
        var url = this;
        var state = stateOverride || $00aa40cdf9bc358f$var$SCHEME_START;
        var pointer = 0;
        var buffer = '';
        var seenAt = false;
        var seenBracket = false;
        var seenPasswordToken = false;
        var codePoints, chr, bufferCodePoints, failure;
        input = $f4fff477af530dca$exports(input);
        if (!stateOverride) {
            url.scheme = '';
            url.username = '';
            url.password = '';
            url.host = null;
            url.port = null;
            url.path = [];
            url.query = null;
            url.fragment = null;
            url.cannotBeABaseURL = false;
            input = $00aa40cdf9bc358f$var$replace(input, $00aa40cdf9bc358f$var$LEADING_C0_CONTROL_OR_SPACE, '');
            input = $00aa40cdf9bc358f$var$replace(input, $00aa40cdf9bc358f$var$TRAILING_C0_CONTROL_OR_SPACE, '$1');
        }
        input = $00aa40cdf9bc358f$var$replace(input, $00aa40cdf9bc358f$var$TAB_AND_NEW_LINE, '');
        codePoints = $2210b738d2e5489c$exports(input);
        while(pointer <= codePoints.length){
            chr = codePoints[pointer];
            switch(state){
                case $00aa40cdf9bc358f$var$SCHEME_START:
                    if (chr && $00aa40cdf9bc358f$var$exec($00aa40cdf9bc358f$var$ALPHA, chr)) {
                        buffer += $00aa40cdf9bc358f$var$toLowerCase(chr);
                        state = $00aa40cdf9bc358f$var$SCHEME;
                    } else if (!stateOverride) {
                        state = $00aa40cdf9bc358f$var$NO_SCHEME;
                        continue;
                    } else return $00aa40cdf9bc358f$var$INVALID_SCHEME;
                    break;
                case $00aa40cdf9bc358f$var$SCHEME:
                    if (chr && ($00aa40cdf9bc358f$var$exec($00aa40cdf9bc358f$var$ALPHANUMERIC, chr) || chr === '+' || chr === '-' || chr === '.')) buffer += $00aa40cdf9bc358f$var$toLowerCase(chr);
                    else if (chr === ':') {
                        if (stateOverride && (url.isSpecial() !== $35cf4bf79fe152cc$exports($00aa40cdf9bc358f$var$specialSchemes, buffer) || buffer === 'file' && (url.includesCredentials() || url.port !== null) || url.scheme === 'file' && !url.host)) return;
                        url.scheme = buffer;
                        if (stateOverride) {
                            if (url.isSpecial() && $00aa40cdf9bc358f$var$specialSchemes[url.scheme] === url.port) url.port = null;
                            return;
                        }
                        buffer = '';
                        if (url.scheme === 'file') state = $00aa40cdf9bc358f$var$FILE;
                        else if (url.isSpecial() && base && base.scheme === url.scheme) state = $00aa40cdf9bc358f$var$SPECIAL_RELATIVE_OR_AUTHORITY;
                        else if (url.isSpecial()) state = $00aa40cdf9bc358f$var$SPECIAL_AUTHORITY_SLASHES;
                        else if (codePoints[pointer + 1] === '/') {
                            state = $00aa40cdf9bc358f$var$PATH_OR_AUTHORITY;
                            pointer++;
                        } else {
                            url.cannotBeABaseURL = true;
                            $00aa40cdf9bc358f$var$push(url.path, '');
                            state = $00aa40cdf9bc358f$var$CANNOT_BE_A_BASE_URL_PATH;
                        }
                    } else if (!stateOverride) {
                        buffer = '';
                        state = $00aa40cdf9bc358f$var$NO_SCHEME;
                        pointer = 0;
                        continue;
                    } else return $00aa40cdf9bc358f$var$INVALID_SCHEME;
                    break;
                case $00aa40cdf9bc358f$var$NO_SCHEME:
                    if (!base || base.cannotBeABaseURL && chr !== '#') return $00aa40cdf9bc358f$var$INVALID_SCHEME;
                    if (base.cannotBeABaseURL && chr === '#') {
                        url.scheme = base.scheme;
                        url.path = $65dcb7b8ed29ae22$exports(base.path);
                        url.query = base.query;
                        url.fragment = '';
                        url.cannotBeABaseURL = true;
                        state = $00aa40cdf9bc358f$var$FRAGMENT;
                        break;
                    }
                    state = base.scheme === 'file' ? $00aa40cdf9bc358f$var$FILE : $00aa40cdf9bc358f$var$RELATIVE;
                    continue;
                case $00aa40cdf9bc358f$var$SPECIAL_RELATIVE_OR_AUTHORITY:
                    if (chr === '/' && codePoints[pointer + 1] === '/') {
                        state = $00aa40cdf9bc358f$var$SPECIAL_AUTHORITY_IGNORE_SLASHES;
                        pointer++;
                    } else {
                        state = $00aa40cdf9bc358f$var$RELATIVE;
                        continue;
                    }
                    break;
                case $00aa40cdf9bc358f$var$PATH_OR_AUTHORITY:
                    if (chr === '/') {
                        state = $00aa40cdf9bc358f$var$AUTHORITY;
                        break;
                    } else {
                        state = $00aa40cdf9bc358f$var$PATH;
                        continue;
                    }
                case $00aa40cdf9bc358f$var$RELATIVE:
                    url.scheme = base.scheme;
                    if (chr === $00aa40cdf9bc358f$var$EOF) {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $65dcb7b8ed29ae22$exports(base.path);
                        url.query = base.query;
                    } else if (chr === '/' || chr === '\\' && url.isSpecial()) state = $00aa40cdf9bc358f$var$RELATIVE_SLASH;
                    else if (chr === '?') {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $65dcb7b8ed29ae22$exports(base.path);
                        url.query = '';
                        state = $00aa40cdf9bc358f$var$QUERY;
                    } else if (chr === '#') {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $65dcb7b8ed29ae22$exports(base.path);
                        url.query = base.query;
                        url.fragment = '';
                        state = $00aa40cdf9bc358f$var$FRAGMENT;
                    } else {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $65dcb7b8ed29ae22$exports(base.path);
                        url.path.length--;
                        state = $00aa40cdf9bc358f$var$PATH;
                        continue;
                    }
                    break;
                case $00aa40cdf9bc358f$var$RELATIVE_SLASH:
                    if (url.isSpecial() && (chr === '/' || chr === '\\')) state = $00aa40cdf9bc358f$var$SPECIAL_AUTHORITY_IGNORE_SLASHES;
                    else if (chr === '/') state = $00aa40cdf9bc358f$var$AUTHORITY;
                    else {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        state = $00aa40cdf9bc358f$var$PATH;
                        continue;
                    }
                    break;
                case $00aa40cdf9bc358f$var$SPECIAL_AUTHORITY_SLASHES:
                    state = $00aa40cdf9bc358f$var$SPECIAL_AUTHORITY_IGNORE_SLASHES;
                    if (chr !== '/' || $00aa40cdf9bc358f$var$charAt(buffer, pointer + 1) !== '/') continue;
                    pointer++;
                    break;
                case $00aa40cdf9bc358f$var$SPECIAL_AUTHORITY_IGNORE_SLASHES:
                    if (chr !== '/' && chr !== '\\') {
                        state = $00aa40cdf9bc358f$var$AUTHORITY;
                        continue;
                    }
                    break;
                case $00aa40cdf9bc358f$var$AUTHORITY:
                    if (chr === '@') {
                        if (seenAt) buffer = '%40' + buffer;
                        seenAt = true;
                        bufferCodePoints = $2210b738d2e5489c$exports(buffer);
                        for(var i = 0; i < bufferCodePoints.length; i++){
                            var codePoint = bufferCodePoints[i];
                            if (codePoint === ':' && !seenPasswordToken) {
                                seenPasswordToken = true;
                                continue;
                            }
                            var encodedCodePoints = $00aa40cdf9bc358f$var$percentEncode(codePoint, $00aa40cdf9bc358f$var$userinfoPercentEncodeSet);
                            if (seenPasswordToken) url.password += encodedCodePoints;
                            else url.username += encodedCodePoints;
                        }
                        buffer = '';
                    } else if (chr === $00aa40cdf9bc358f$var$EOF || chr === '/' || chr === '?' || chr === '#' || chr === '\\' && url.isSpecial()) {
                        if (seenAt && buffer === '') return $00aa40cdf9bc358f$var$INVALID_AUTHORITY;
                        pointer -= $2210b738d2e5489c$exports(buffer).length + 1;
                        buffer = '';
                        state = $00aa40cdf9bc358f$var$HOST;
                    } else buffer += chr;
                    break;
                case $00aa40cdf9bc358f$var$HOST:
                case $00aa40cdf9bc358f$var$HOSTNAME:
                    if (stateOverride && url.scheme === 'file') {
                        state = $00aa40cdf9bc358f$var$FILE_HOST;
                        continue;
                    } else if (chr === ':' && !seenBracket) {
                        if (buffer === '') return $00aa40cdf9bc358f$var$INVALID_HOST;
                        failure = url.parseHost(buffer);
                        if (failure) return failure;
                        buffer = '';
                        state = $00aa40cdf9bc358f$var$PORT;
                        if (stateOverride === $00aa40cdf9bc358f$var$HOSTNAME) return;
                    } else if (chr === $00aa40cdf9bc358f$var$EOF || chr === '/' || chr === '?' || chr === '#' || chr === '\\' && url.isSpecial()) {
                        if (url.isSpecial() && buffer === '') return $00aa40cdf9bc358f$var$INVALID_HOST;
                        if (stateOverride && buffer === '' && (url.includesCredentials() || url.port !== null)) return;
                        failure = url.parseHost(buffer);
                        if (failure) return failure;
                        buffer = '';
                        state = $00aa40cdf9bc358f$var$PATH_START;
                        if (stateOverride) return;
                        continue;
                    } else {
                        if (chr === '[') seenBracket = true;
                        else if (chr === ']') seenBracket = false;
                        buffer += chr;
                    }
                    break;
                case $00aa40cdf9bc358f$var$PORT:
                    if ($00aa40cdf9bc358f$var$exec($00aa40cdf9bc358f$var$DIGIT, chr)) buffer += chr;
                    else if (chr === $00aa40cdf9bc358f$var$EOF || chr === '/' || chr === '?' || chr === '#' || chr === '\\' && url.isSpecial() || stateOverride) {
                        if (buffer !== '') {
                            var port = $00aa40cdf9bc358f$var$parseInt(buffer, 10);
                            if (port > 0xFFFF) return $00aa40cdf9bc358f$var$INVALID_PORT;
                            url.port = url.isSpecial() && port === $00aa40cdf9bc358f$var$specialSchemes[url.scheme] ? null : port;
                            buffer = '';
                        }
                        if (stateOverride) return;
                        state = $00aa40cdf9bc358f$var$PATH_START;
                        continue;
                    } else return $00aa40cdf9bc358f$var$INVALID_PORT;
                    break;
                case $00aa40cdf9bc358f$var$FILE:
                    url.scheme = 'file';
                    if (chr === '/' || chr === '\\') state = $00aa40cdf9bc358f$var$FILE_SLASH;
                    else if (base && base.scheme === 'file') switch(chr){
                        case $00aa40cdf9bc358f$var$EOF:
                            url.host = base.host;
                            url.path = $65dcb7b8ed29ae22$exports(base.path);
                            url.query = base.query;
                            break;
                        case '?':
                            url.host = base.host;
                            url.path = $65dcb7b8ed29ae22$exports(base.path);
                            url.query = '';
                            state = $00aa40cdf9bc358f$var$QUERY;
                            break;
                        case '#':
                            url.host = base.host;
                            url.path = $65dcb7b8ed29ae22$exports(base.path);
                            url.query = base.query;
                            url.fragment = '';
                            state = $00aa40cdf9bc358f$var$FRAGMENT;
                            break;
                        default:
                            if (!$00aa40cdf9bc358f$var$startsWithWindowsDriveLetter($00aa40cdf9bc358f$var$join($65dcb7b8ed29ae22$exports(codePoints, pointer), ''))) {
                                url.host = base.host;
                                url.path = $65dcb7b8ed29ae22$exports(base.path);
                                url.shortenPath();
                            }
                            state = $00aa40cdf9bc358f$var$PATH;
                            continue;
                    }
                    else {
                        state = $00aa40cdf9bc358f$var$PATH;
                        continue;
                    }
                    break;
                case $00aa40cdf9bc358f$var$FILE_SLASH:
                    if (chr === '/' || chr === '\\') {
                        state = $00aa40cdf9bc358f$var$FILE_HOST;
                        break;
                    }
                    if (base && base.scheme === 'file' && !$00aa40cdf9bc358f$var$startsWithWindowsDriveLetter($00aa40cdf9bc358f$var$join($65dcb7b8ed29ae22$exports(codePoints, pointer), ''))) {
                        if ($00aa40cdf9bc358f$var$isWindowsDriveLetter(base.path[0], true)) $00aa40cdf9bc358f$var$push(url.path, base.path[0]);
                        else url.host = base.host;
                    }
                    state = $00aa40cdf9bc358f$var$PATH;
                    continue;
                case $00aa40cdf9bc358f$var$FILE_HOST:
                    if (chr === $00aa40cdf9bc358f$var$EOF || chr === '/' || chr === '\\' || chr === '?' || chr === '#') {
                        if (!stateOverride && $00aa40cdf9bc358f$var$isWindowsDriveLetter(buffer)) state = $00aa40cdf9bc358f$var$PATH;
                        else if (buffer === '') {
                            url.host = '';
                            if (stateOverride) return;
                            state = $00aa40cdf9bc358f$var$PATH_START;
                        } else {
                            failure = url.parseHost(buffer);
                            if (failure) return failure;
                            if (url.host === 'localhost') url.host = '';
                            if (stateOverride) return;
                            buffer = '';
                            state = $00aa40cdf9bc358f$var$PATH_START;
                        }
                        continue;
                    } else buffer += chr;
                    break;
                case $00aa40cdf9bc358f$var$PATH_START:
                    if (url.isSpecial()) {
                        state = $00aa40cdf9bc358f$var$PATH;
                        if (chr !== '/' && chr !== '\\') continue;
                    } else if (!stateOverride && chr === '?') {
                        url.query = '';
                        state = $00aa40cdf9bc358f$var$QUERY;
                    } else if (!stateOverride && chr === '#') {
                        url.fragment = '';
                        state = $00aa40cdf9bc358f$var$FRAGMENT;
                    } else if (chr !== $00aa40cdf9bc358f$var$EOF) {
                        state = $00aa40cdf9bc358f$var$PATH;
                        if (chr !== '/') continue;
                    }
                    break;
                case $00aa40cdf9bc358f$var$PATH:
                    if (chr === $00aa40cdf9bc358f$var$EOF || chr === '/' || chr === '\\' && url.isSpecial() || !stateOverride && (chr === '?' || chr === '#')) {
                        if ($00aa40cdf9bc358f$var$isDoubleDot(buffer)) {
                            url.shortenPath();
                            if (chr !== '/' && !(chr === '\\' && url.isSpecial())) $00aa40cdf9bc358f$var$push(url.path, '');
                        } else if ($00aa40cdf9bc358f$var$isSingleDot(buffer)) {
                            if (chr !== '/' && !(chr === '\\' && url.isSpecial())) $00aa40cdf9bc358f$var$push(url.path, '');
                        } else {
                            if (url.scheme === 'file' && !url.path.length && $00aa40cdf9bc358f$var$isWindowsDriveLetter(buffer)) {
                                if (url.host) url.host = '';
                                buffer = $00aa40cdf9bc358f$var$charAt(buffer, 0) + ':'; // normalize windows drive letter
                            }
                            $00aa40cdf9bc358f$var$push(url.path, buffer);
                        }
                        buffer = '';
                        if (url.scheme === 'file' && (chr === $00aa40cdf9bc358f$var$EOF || chr === '?' || chr === '#')) while(url.path.length > 1 && url.path[0] === '')$00aa40cdf9bc358f$var$shift(url.path);
                        if (chr === '?') {
                            url.query = '';
                            state = $00aa40cdf9bc358f$var$QUERY;
                        } else if (chr === '#') {
                            url.fragment = '';
                            state = $00aa40cdf9bc358f$var$FRAGMENT;
                        }
                    } else buffer += $00aa40cdf9bc358f$var$percentEncode(chr, $00aa40cdf9bc358f$var$pathPercentEncodeSet);
                    break;
                case $00aa40cdf9bc358f$var$CANNOT_BE_A_BASE_URL_PATH:
                    if (chr === '?') {
                        url.query = '';
                        state = $00aa40cdf9bc358f$var$QUERY;
                    } else if (chr === '#') {
                        url.fragment = '';
                        state = $00aa40cdf9bc358f$var$FRAGMENT;
                    } else if (chr !== $00aa40cdf9bc358f$var$EOF) url.path[0] += $00aa40cdf9bc358f$var$percentEncode(chr, $00aa40cdf9bc358f$var$C0ControlPercentEncodeSet);
                    break;
                case $00aa40cdf9bc358f$var$QUERY:
                    if (!stateOverride && chr === '#') {
                        url.fragment = '';
                        state = $00aa40cdf9bc358f$var$FRAGMENT;
                    } else if (chr !== $00aa40cdf9bc358f$var$EOF) {
                        if (chr === "'" && url.isSpecial()) url.query += '%27';
                        else if (chr === '#') url.query += '%23';
                        else url.query += $00aa40cdf9bc358f$var$percentEncode(chr, $00aa40cdf9bc358f$var$C0ControlPercentEncodeSet);
                    }
                    break;
                case $00aa40cdf9bc358f$var$FRAGMENT:
                    if (chr !== $00aa40cdf9bc358f$var$EOF) url.fragment += $00aa40cdf9bc358f$var$percentEncode(chr, $00aa40cdf9bc358f$var$fragmentPercentEncodeSet);
                    break;
            }
            pointer++;
        }
    },
    // https://url.spec.whatwg.org/#host-parsing
    parseHost: function parseHost(input) {
        var result, codePoints, index;
        if ($00aa40cdf9bc358f$var$charAt(input, 0) === '[') {
            if ($00aa40cdf9bc358f$var$charAt(input, input.length - 1) !== ']') return $00aa40cdf9bc358f$var$INVALID_HOST;
            result = $00aa40cdf9bc358f$var$parseIPv6($00aa40cdf9bc358f$var$stringSlice(input, 1, -1));
            if (!result) return $00aa40cdf9bc358f$var$INVALID_HOST;
            this.host = result;
        // opaque host
        } else if (!this.isSpecial()) {
            if ($00aa40cdf9bc358f$var$exec($00aa40cdf9bc358f$var$FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return $00aa40cdf9bc358f$var$INVALID_HOST;
            result = '';
            codePoints = $2210b738d2e5489c$exports(input);
            for(index = 0; index < codePoints.length; index++)result += $00aa40cdf9bc358f$var$percentEncode(codePoints[index], $00aa40cdf9bc358f$var$C0ControlPercentEncodeSet);
            this.host = result;
        } else {
            input = $179c3c97e0ee4daa$exports(input);
            if ($00aa40cdf9bc358f$var$exec($00aa40cdf9bc358f$var$FORBIDDEN_HOST_CODE_POINT, input)) return $00aa40cdf9bc358f$var$INVALID_HOST;
            result = $00aa40cdf9bc358f$var$parseIPv4(input);
            if (result === null) return $00aa40cdf9bc358f$var$INVALID_HOST;
            this.host = result;
        }
    },
    // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
    cannotHaveUsernamePasswordPort: function cannotHaveUsernamePasswordPort() {
        return !this.host || this.cannotBeABaseURL || this.scheme === 'file';
    },
    // https://url.spec.whatwg.org/#include-credentials
    includesCredentials: function includesCredentials() {
        return this.username !== '' || this.password !== '';
    },
    // https://url.spec.whatwg.org/#is-special
    isSpecial: function isSpecial() {
        return $35cf4bf79fe152cc$exports($00aa40cdf9bc358f$var$specialSchemes, this.scheme);
    },
    // https://url.spec.whatwg.org/#shorten-a-urls-path
    shortenPath: function shortenPath() {
        var path = this.path;
        var pathSize = path.length;
        if (pathSize && (this.scheme !== 'file' || pathSize !== 1 || !$00aa40cdf9bc358f$var$isWindowsDriveLetter(path[0], true))) path.length--;
    },
    // https://url.spec.whatwg.org/#concept-url-serializer
    serialize: function serialize() {
        var url = this;
        var scheme = url.scheme;
        var username = url.username;
        var password = url.password;
        var host = url.host;
        var port = url.port;
        var path = url.path;
        var query = url.query;
        var fragment = url.fragment;
        var output = scheme + ':';
        if (host !== null) {
            output += '//';
            if (url.includesCredentials()) output += username + (password ? ':' + password : '') + '@';
            output += $00aa40cdf9bc358f$var$serializeHost(host);
            if (port !== null) output += ':' + port;
        } else if (scheme === 'file') output += '//';
        output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + $00aa40cdf9bc358f$var$join(path, '/') : '';
        if (query !== null) output += '?' + query;
        if (fragment !== null) output += '#' + fragment;
        return output;
    },
    // https://url.spec.whatwg.org/#dom-url-href
    setHref: function setHref(href) {
        var failure = this.parse(href);
        if (failure) throw new $00aa40cdf9bc358f$var$TypeError(failure);
        this.searchParams.update();
    },
    // https://url.spec.whatwg.org/#dom-url-origin
    getOrigin: function getOrigin() {
        var scheme = this.scheme;
        var port = this.port;
        if (scheme === 'blob') try {
            return new $00aa40cdf9bc358f$var$URLConstructor(scheme.path[0]).origin;
        } catch (error) {
            return 'null';
        }
        if (scheme === 'file' || !this.isSpecial()) return 'null';
        return scheme + '://' + $00aa40cdf9bc358f$var$serializeHost(this.host) + (port !== null ? ':' + port : '');
    },
    // https://url.spec.whatwg.org/#dom-url-protocol
    getProtocol: function getProtocol() {
        return this.scheme + ':';
    },
    setProtocol: function setProtocol(protocol) {
        this.parse($f4fff477af530dca$exports(protocol) + ':', $00aa40cdf9bc358f$var$SCHEME_START);
    },
    // https://url.spec.whatwg.org/#dom-url-username
    getUsername: function getUsername() {
        return this.username;
    },
    setUsername: function setUsername(username) {
        var codePoints = $2210b738d2e5489c$exports($f4fff477af530dca$exports(username));
        if (this.cannotHaveUsernamePasswordPort()) return;
        this.username = '';
        for(var i = 0; i < codePoints.length; i++)this.username += $00aa40cdf9bc358f$var$percentEncode(codePoints[i], $00aa40cdf9bc358f$var$userinfoPercentEncodeSet);
    },
    // https://url.spec.whatwg.org/#dom-url-password
    getPassword: function getPassword() {
        return this.password;
    },
    setPassword: function setPassword(password) {
        var codePoints = $2210b738d2e5489c$exports($f4fff477af530dca$exports(password));
        if (this.cannotHaveUsernamePasswordPort()) return;
        this.password = '';
        for(var i = 0; i < codePoints.length; i++)this.password += $00aa40cdf9bc358f$var$percentEncode(codePoints[i], $00aa40cdf9bc358f$var$userinfoPercentEncodeSet);
    },
    // https://url.spec.whatwg.org/#dom-url-host
    getHost: function getHost() {
        var host = this.host;
        var port = this.port;
        return host === null ? '' : port === null ? $00aa40cdf9bc358f$var$serializeHost(host) : $00aa40cdf9bc358f$var$serializeHost(host) + ':' + port;
    },
    setHost: function setHost(host) {
        if (this.cannotBeABaseURL) return;
        this.parse(host, $00aa40cdf9bc358f$var$HOST);
    },
    // https://url.spec.whatwg.org/#dom-url-hostname
    getHostname: function getHostname() {
        var host = this.host;
        return host === null ? '' : $00aa40cdf9bc358f$var$serializeHost(host);
    },
    setHostname: function setHostname(hostname) {
        if (this.cannotBeABaseURL) return;
        this.parse(hostname, $00aa40cdf9bc358f$var$HOSTNAME);
    },
    // https://url.spec.whatwg.org/#dom-url-port
    getPort: function getPort() {
        var port = this.port;
        return port === null ? '' : $f4fff477af530dca$exports(port);
    },
    setPort: function setPort(port) {
        if (this.cannotHaveUsernamePasswordPort()) return;
        port = $f4fff477af530dca$exports(port);
        if (port === '') this.port = null;
        else this.parse(port, $00aa40cdf9bc358f$var$PORT);
    },
    // https://url.spec.whatwg.org/#dom-url-pathname
    getPathname: function getPathname() {
        var path = this.path;
        return this.cannotBeABaseURL ? path[0] : path.length ? '/' + $00aa40cdf9bc358f$var$join(path, '/') : '';
    },
    setPathname: function setPathname(pathname) {
        if (this.cannotBeABaseURL) return;
        this.path = [];
        this.parse(pathname, $00aa40cdf9bc358f$var$PATH_START);
    },
    // https://url.spec.whatwg.org/#dom-url-search
    getSearch: function getSearch() {
        var query = this.query;
        return query ? '?' + query : '';
    },
    setSearch: function setSearch(search) {
        search = $f4fff477af530dca$exports(search);
        if (search === '') this.query = null;
        else {
            if ($00aa40cdf9bc358f$var$charAt(search, 0) === '?') search = $00aa40cdf9bc358f$var$stringSlice(search, 1);
            this.query = '';
            this.parse(search, $00aa40cdf9bc358f$var$QUERY);
        }
        this.searchParams.update();
    },
    // https://url.spec.whatwg.org/#dom-url-searchparams
    getSearchParams: function getSearchParams() {
        return this.searchParams.facade;
    },
    // https://url.spec.whatwg.org/#dom-url-hash
    getHash: function getHash() {
        var fragment = this.fragment;
        return fragment ? '#' + fragment : '';
    },
    setHash: function setHash(hash) {
        hash = $f4fff477af530dca$exports(hash);
        if (hash === '') {
            this.fragment = null;
            return;
        }
        if ($00aa40cdf9bc358f$var$charAt(hash, 0) === '#') hash = $00aa40cdf9bc358f$var$stringSlice(hash, 1);
        this.fragment = '';
        this.parse(hash, $00aa40cdf9bc358f$var$FRAGMENT);
    },
    update: function update() {
        this.query = this.searchParams.serialize() || null;
    }
};
// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var $00aa40cdf9bc358f$var$URLConstructor = function URL(url /* , base */ ) {
    var that = $65f23bed46afab45$exports(this, $00aa40cdf9bc358f$var$URLPrototype);
    var base = $2e3ae4fb0da606c5$exports(arguments.length, 1) > 1 ? arguments[1] : undefined;
    var state = $00aa40cdf9bc358f$var$setInternalState(that, new $00aa40cdf9bc358f$var$URLState(url, false, base));
    if (!$6ffb7908e83cf36c$exports) {
        that.href = state.serialize();
        that.origin = state.getOrigin();
        that.protocol = state.getProtocol();
        that.username = state.getUsername();
        that.password = state.getPassword();
        that.host = state.getHost();
        that.hostname = state.getHostname();
        that.port = state.getPort();
        that.pathname = state.getPathname();
        that.search = state.getSearch();
        that.searchParams = state.getSearchParams();
        that.hash = state.getHash();
    }
};
var $00aa40cdf9bc358f$var$URLPrototype = $00aa40cdf9bc358f$var$URLConstructor.prototype;
var $00aa40cdf9bc358f$var$accessorDescriptor = function accessorDescriptor(getter, setter) {
    return {
        get: function get() {
            return $00aa40cdf9bc358f$var$getInternalURLState(this)[getter]();
        },
        set: setter && function(value) {
            return $00aa40cdf9bc358f$var$getInternalURLState(this)[setter](value);
        },
        configurable: true,
        enumerable: true
    };
};
if ($6ffb7908e83cf36c$exports) {
    // `URL.prototype.href` accessors pair
    // https://url.spec.whatwg.org/#dom-url-href
    $6de7996ceea81cf8$exports($00aa40cdf9bc358f$var$URLPrototype, 'href', $00aa40cdf9bc358f$var$accessorDescriptor('serialize', 'setHref'));
    // `URL.prototype.origin` getter
    // https://url.spec.whatwg.org/#dom-url-origin
    $6de7996ceea81cf8$exports($00aa40cdf9bc358f$var$URLPrototype, 'origin', $00aa40cdf9bc358f$var$accessorDescriptor('getOrigin'));
    // `URL.prototype.protocol` accessors pair
    // https://url.spec.whatwg.org/#dom-url-protocol
    $6de7996ceea81cf8$exports($00aa40cdf9bc358f$var$URLPrototype, 'protocol', $00aa40cdf9bc358f$var$accessorDescriptor('getProtocol', 'setProtocol'));
    // `URL.prototype.username` accessors pair
    // https://url.spec.whatwg.org/#dom-url-username
    $6de7996ceea81cf8$exports($00aa40cdf9bc358f$var$URLPrototype, 'username', $00aa40cdf9bc358f$var$accessorDescriptor('getUsername', 'setUsername'));
    // `URL.prototype.password` accessors pair
    // https://url.spec.whatwg.org/#dom-url-password
    $6de7996ceea81cf8$exports($00aa40cdf9bc358f$var$URLPrototype, 'password', $00aa40cdf9bc358f$var$accessorDescriptor('getPassword', 'setPassword'));
    // `URL.prototype.host` accessors pair
    // https://url.spec.whatwg.org/#dom-url-host
    $6de7996ceea81cf8$exports($00aa40cdf9bc358f$var$URLPrototype, 'host', $00aa40cdf9bc358f$var$accessorDescriptor('getHost', 'setHost'));
    // `URL.prototype.hostname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hostname
    $6de7996ceea81cf8$exports($00aa40cdf9bc358f$var$URLPrototype, 'hostname', $00aa40cdf9bc358f$var$accessorDescriptor('getHostname', 'setHostname'));
    // `URL.prototype.port` accessors pair
    // https://url.spec.whatwg.org/#dom-url-port
    $6de7996ceea81cf8$exports($00aa40cdf9bc358f$var$URLPrototype, 'port', $00aa40cdf9bc358f$var$accessorDescriptor('getPort', 'setPort'));
    // `URL.prototype.pathname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-pathname
    $6de7996ceea81cf8$exports($00aa40cdf9bc358f$var$URLPrototype, 'pathname', $00aa40cdf9bc358f$var$accessorDescriptor('getPathname', 'setPathname'));
    // `URL.prototype.search` accessors pair
    // https://url.spec.whatwg.org/#dom-url-search
    $6de7996ceea81cf8$exports($00aa40cdf9bc358f$var$URLPrototype, 'search', $00aa40cdf9bc358f$var$accessorDescriptor('getSearch', 'setSearch'));
    // `URL.prototype.searchParams` getter
    // https://url.spec.whatwg.org/#dom-url-searchparams
    $6de7996ceea81cf8$exports($00aa40cdf9bc358f$var$URLPrototype, 'searchParams', $00aa40cdf9bc358f$var$accessorDescriptor('getSearchParams'));
    // `URL.prototype.hash` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hash
    $6de7996ceea81cf8$exports($00aa40cdf9bc358f$var$URLPrototype, 'hash', $00aa40cdf9bc358f$var$accessorDescriptor('getHash', 'setHash'));
}
// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$b817bfc251eac07c$exports($00aa40cdf9bc358f$var$URLPrototype, 'toJSON', function toJSON() {
    return $00aa40cdf9bc358f$var$getInternalURLState(this).serialize();
}, {
    enumerable: true
});
// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
$b817bfc251eac07c$exports($00aa40cdf9bc358f$var$URLPrototype, 'toString', function toString() {
    return $00aa40cdf9bc358f$var$getInternalURLState(this).serialize();
}, {
    enumerable: true
});
if ($00aa40cdf9bc358f$var$NativeURL) {
    var $00aa40cdf9bc358f$var$nativeCreateObjectURL = $00aa40cdf9bc358f$var$NativeURL.createObjectURL;
    var $00aa40cdf9bc358f$var$nativeRevokeObjectURL = $00aa40cdf9bc358f$var$NativeURL.revokeObjectURL;
    // `URL.createObjectURL` method
    // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
    if ($00aa40cdf9bc358f$var$nativeCreateObjectURL) $b817bfc251eac07c$exports($00aa40cdf9bc358f$var$URLConstructor, 'createObjectURL', $847280b2cf36c2e0$exports($00aa40cdf9bc358f$var$nativeCreateObjectURL, $00aa40cdf9bc358f$var$NativeURL));
    // `URL.revokeObjectURL` method
    // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
    if ($00aa40cdf9bc358f$var$nativeRevokeObjectURL) $b817bfc251eac07c$exports($00aa40cdf9bc358f$var$URLConstructor, 'revokeObjectURL', $847280b2cf36c2e0$exports($00aa40cdf9bc358f$var$nativeRevokeObjectURL, $00aa40cdf9bc358f$var$NativeURL));
}
$be9d27c6f3178ed3$exports($00aa40cdf9bc358f$var$URLConstructor, 'URL');
$500d5d8b5806b834$exports({
    global: true,
    constructor: true,
    forced: !$5aba2174b85280b7$exports,
    sham: !$6ffb7908e83cf36c$exports
}, {
    URL: $00aa40cdf9bc358f$var$URLConstructor
});




'use strict';


// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$500d5d8b5806b834$exports({
    target: 'URL',
    proto: true,
    enumerable: true
}, {
    toJSON: function toJSON() {
        return $e3ebd8cb7f512f74$exports(URL.prototype.toString, this);
    }
});


'use strict';




var $5Pgs2 = parcelRequire("5Pgs2");

var $dHvbf = parcelRequire("dHvbf");

var $1XfpH = parcelRequire("1XfpH");

var $5Pgs2 = parcelRequire("5Pgs2");

var $aSMts = parcelRequire("aSMts");

var $dHvbf = parcelRequire("dHvbf");

var $1XfpH = parcelRequire("1XfpH");

var $ffICS = parcelRequire("ffICS");



(function() {
    (parcelRequire("Xfpqh")).config(Object.assign({}, (parcelRequire("dEWAU")), (parcelRequire("c0g4Z"))($ffICS.argv)));
})();


var $0d51ec966e2c6e90$export$923ea8233b386e99 = 'https://www.googleapis.com/books/v1/volumes';
var $0d51ec966e2c6e90$export$a9861bd62f48e142 = "AIzaSyDyH0_nD3BFmPon40PMKx4iuDS6L2sF03U";
var $0d51ec966e2c6e90$export$c016e91678be354b = "0bad90a36e89ab813f9fd1703894a627";
var $0d51ec966e2c6e90$export$c0b592c68ac1c625 = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml4c2RqYW56ZnhreXZ5bWV5cnBiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzYzNDM3MDYsImV4cCI6MjA1MTkxOTcwNn0.ksr0JZXTbGl8DDwPtHKwG7ATbR4n8CaggB_gRTGyD48";
var $0d51ec966e2c6e90$export$721045acb0bbe132 = "https://ixsdjanzfxkyvymeyrpb.supabase.co";
var $0d51ec966e2c6e90$export$196440f71ed9f601 = 10;
var $0d51ec966e2c6e90$export$79f902c668fe8d1f = {
    CLICKED_SHARE: 'Clicked Share',
    CLICKED_SEARCH: 'Clicked Search',
    CLICKED_BOOKMARK: 'Clicked Bookmark',
    CLICKED_SEARCH_FILTER: 'Clicked Search Filter',
    CREATED_COLLECTION: 'Created Collection',
    VIEWED_HOME_PAGE: 'Viewed Home Page',
    VIEWED_FIND_BOOKS_PAGE: 'Viewed Find Books Page',
    VIEWED_CREATE_COLLECTIONS_PAGE: 'Viewed Create Collections Page',
    VIEWED_SHELF: 'Viewed Shelf',
    VIEWED_COLLECTION: 'Viewed Collection',
    VIEWED_BOOK: 'Viewed Book'
};



var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $aSMts = parcelRequire("aSMts");

var $dHvbf = parcelRequire("dHvbf");

var $qb7pP = parcelRequire("qb7pP");

var $1XfpH = parcelRequire("1XfpH");
var $6c21bacc9274e141$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($6c21bacc9274e141$var$NodeType || ($6c21bacc9274e141$var$NodeType = {}));
function $6c21bacc9274e141$var$isElement(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $6c21bacc9274e141$var$isShadowRoot(n) {
    var host = n === null || n === void 0 ? void 0 : n.host;
    return Boolean((host === null || host === void 0 ? void 0 : host.shadowRoot) === n);
}
function $6c21bacc9274e141$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === '[object ShadowRoot]';
}
function $6c21bacc9274e141$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(' background-clip: text;') && !cssText.includes(' -webkit-background-clip: text;')) cssText = cssText.replace(' background-clip: text;', ' -webkit-background-clip: text; background-clip: text;');
    return cssText;
}
function $6c21bacc9274e141$var$escapeImportStatement(rule) {
    var cssText = rule.cssText;
    if (cssText.split('"').length < 3) return cssText;
    var statement = [
        '@import',
        "url(".concat(JSON.stringify(rule.href), ")")
    ];
    if (rule.layerName === '') statement.push("layer");
    else if (rule.layerName) statement.push("layer(".concat(rule.layerName, ")"));
    if (rule.supportsText) statement.push("supports(".concat(rule.supportsText, ")"));
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(' ') + ';';
}
function $6c21bacc9274e141$var$stringifyStylesheet(s) {
    try {
        var rules = s.rules || s.cssRules;
        return rules ? $6c21bacc9274e141$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules, $6c21bacc9274e141$var$stringifyRule).join('')) : null;
    } catch (error) {
        return null;
    }
}
function $6c21bacc9274e141$var$stringifyRule(rule) {
    var importStringified;
    if ($6c21bacc9274e141$var$isCSSImportRule(rule)) try {
        importStringified = $6c21bacc9274e141$var$stringifyStylesheet(rule.styleSheet) || $6c21bacc9274e141$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($6c21bacc9274e141$var$isCSSStyleRule(rule) && rule.selectorText.includes(':')) return $6c21bacc9274e141$var$fixSafariColons(rule.cssText);
    return importStringified || rule.cssText;
}
function $6c21bacc9274e141$var$fixSafariColons(cssStringified) {
    var regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, '$1\\$2');
}
function $6c21bacc9274e141$var$isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
function $6c21bacc9274e141$var$isCSSStyleRule(rule) {
    return 'selectorText' in rule;
}
var $6c21bacc9274e141$var$Mirror = /*#__PURE__*/ function() {
    "use strict";
    function Mirror() {
        (0, $50OuQ._)(this, Mirror);
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
    (0, $fGdZr._)(Mirror, [
        {
            key: "getId",
            value: function getId(n) {
                var _a;
                if (!n) return -1;
                var id = (_a = this.getMeta(n)) === null || _a === void 0 ? void 0 : _a.id;
                return id !== null && id !== void 0 ? id : -1;
            }
        },
        {
            key: "getNode",
            value: function getNode(id) {
                return this.idNodeMap.get(id) || null;
            }
        },
        {
            key: "getIds",
            value: function getIds() {
                return Array.from(this.idNodeMap.keys());
            }
        },
        {
            key: "getMeta",
            value: function getMeta(n) {
                return this.nodeMetaMap.get(n) || null;
            }
        },
        {
            key: "removeNodeFromMap",
            value: function removeNodeFromMap(n) {
                var _this = this;
                var id = this.getId(n);
                this.idNodeMap["delete"](id);
                if (n.childNodes) n.childNodes.forEach(function(childNode) {
                    return _this.removeNodeFromMap(childNode);
                });
            }
        },
        {
            key: "has",
            value: function has(id) {
                return this.idNodeMap.has(id);
            }
        },
        {
            key: "hasNode",
            value: function hasNode(node) {
                return this.nodeMetaMap.has(node);
            }
        },
        {
            key: "add",
            value: function add(n, meta) {
                var id = meta.id;
                this.idNodeMap.set(id, n);
                this.nodeMetaMap.set(n, meta);
            }
        },
        {
            key: "replace",
            value: function replace(id, n) {
                var oldNode = this.getNode(id);
                if (oldNode) {
                    var meta = this.nodeMetaMap.get(oldNode);
                    if (meta) this.nodeMetaMap.set(n, meta);
                }
                this.idNodeMap.set(id, n);
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.idNodeMap = new Map();
                this.nodeMetaMap = new WeakMap();
            }
        }
    ]);
    return Mirror;
}();
function $6c21bacc9274e141$var$createMirror() {
    return new $6c21bacc9274e141$var$Mirror();
}
function $6c21bacc9274e141$var$maskInputValue(param) {
    var element = param.element, maskInputOptions = param.maskInputOptions, tagName = param.tagName, type = param.type, value = param.value, maskInputFn = param.maskInputFn;
    var text = value || '';
    var actualType = type && $6c21bacc9274e141$var$toLowerCase(type);
    if (maskInputOptions[tagName.toLowerCase()] || actualType && maskInputOptions[actualType]) {
        if (maskInputFn) text = maskInputFn(text, element);
        else text = '*'.repeat(text.length);
    }
    return text;
}
function $6c21bacc9274e141$var$toLowerCase(str) {
    return str.toLowerCase();
}
var $6c21bacc9274e141$var$ORIGINAL_ATTRIBUTE_NAME = '__rrweb_original__';
function $6c21bacc9274e141$var$is2DCanvasBlank(canvas) {
    var ctx = canvas.getContext('2d');
    if (!ctx) return true;
    var chunkSize = 50;
    for(var x = 0; x < canvas.width; x += chunkSize)for(var y = 0; y < canvas.height; y += chunkSize){
        var getImageData = ctx.getImageData;
        var originalGetImageData = $6c21bacc9274e141$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$6c21bacc9274e141$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        var pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some(function(pixel) {
            return pixel !== 0;
        })) return false;
    }
    return true;
}
function $6c21bacc9274e141$var$getInputType(element) {
    var type = element.type;
    return element.hasAttribute('data-rr-is-password') ? 'password' : type ? $6c21bacc9274e141$var$toLowerCase(type) : null;
}
function $6c21bacc9274e141$var$extractFileExtension(path, baseURL) {
    var _a;
    var url;
    try {
        url = new URL(path, baseURL !== null && baseURL !== void 0 ? baseURL : window.location.href);
    } catch (err) {
        return null;
    }
    var regex = /\.([0-9a-z]+)(?:$)/i;
    var match = url.pathname.match(regex);
    return (_a = match === null || match === void 0 ? void 0 : match[1]) !== null && _a !== void 0 ? _a : null;
}
var $6c21bacc9274e141$var$_id = 1;
var $6c21bacc9274e141$var$tagNameRegex = new RegExp('[^a-z0-9-_:]');
var $6c21bacc9274e141$var$IGNORED_NODE = -2;
function $6c21bacc9274e141$var$genId() {
    return $6c21bacc9274e141$var$_id++;
}
function $6c21bacc9274e141$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return 'form';
    var processedTagName = $6c21bacc9274e141$var$toLowerCase(element.tagName);
    if ($6c21bacc9274e141$var$tagNameRegex.test(processedTagName)) return 'div';
    return processedTagName;
}
function $6c21bacc9274e141$var$extractOrigin(url) {
    var origin = '';
    if (url.indexOf('//') > -1) origin = url.split('/').slice(0, 3).join('/');
    else origin = url.split('/')[0];
    origin = origin.split('?')[0];
    return origin;
}
var $6c21bacc9274e141$var$canvasService;
var $6c21bacc9274e141$var$canvasCtx;
var $6c21bacc9274e141$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
var $6c21bacc9274e141$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
var $6c21bacc9274e141$var$URL_WWW_MATCH = /^www\..*/i;
var $6c21bacc9274e141$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $6c21bacc9274e141$var$absoluteToStylesheet(cssText, href) {
    return (cssText || '').replace($6c21bacc9274e141$var$URL_IN_CSS_REF, function(origin, quote1, path1, quote2, path2, path3) {
        var filePath = path1 || path2 || path3;
        var maybeQuote = quote1 || quote2 || '';
        if (!filePath) return origin;
        if ($6c21bacc9274e141$var$URL_PROTOCOL_MATCH.test(filePath) || $6c21bacc9274e141$var$URL_WWW_MATCH.test(filePath)) return "url(".concat(maybeQuote).concat(filePath).concat(maybeQuote, ")");
        if ($6c21bacc9274e141$var$DATA_URI.test(filePath)) return "url(".concat(maybeQuote).concat(filePath).concat(maybeQuote, ")");
        if (filePath[0] === '/') return "url(".concat(maybeQuote).concat($6c21bacc9274e141$var$extractOrigin(href) + filePath).concat(maybeQuote, ")");
        var stack = href.split('/');
        var parts = filePath.split('/');
        stack.pop();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var part = _step.value;
                if (part === '.') continue;
                else if (part === '..') stack.pop();
                else stack.push(part);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return "url(".concat(maybeQuote).concat(stack.join('/')).concat(maybeQuote, ")");
    });
}
var $6c21bacc9274e141$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
var $6c21bacc9274e141$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $6c21bacc9274e141$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === '') return attributeValue;
    var pos = 0;
    function collectCharacters(regEx) {
        var chars;
        var match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return '';
    }
    var output = [];
    while(true){
        collectCharacters($6c21bacc9274e141$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        var url = collectCharacters($6c21bacc9274e141$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ',') {
            url = $6c21bacc9274e141$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            var descriptorsStr = '';
            url = $6c21bacc9274e141$var$absoluteToDoc(doc, url);
            var inParens = false;
            while(true){
                var c = attributeValue.charAt(pos);
                if (c === '') {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ',') {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === '(') inParens = true;
                } else if (c === ')') inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(', ');
}
function $6c21bacc9274e141$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === '') return attributeValue;
    var a = doc.createElement('a');
    a.href = attributeValue;
    return a.href;
}
function $6c21bacc9274e141$var$isSVGElement(el) {
    return Boolean(el.tagName === 'svg' || el.ownerSVGElement);
}
function $6c21bacc9274e141$var$getHref() {
    var a = document.createElement('a');
    a.href = '';
    return a.href;
}
function $6c21bacc9274e141$var$transformAttribute(doc, tagName, name, value) {
    if (!value) return value;
    if (name === 'src' || name === 'href' && !(tagName === 'use' && value[0] === '#')) return $6c21bacc9274e141$var$absoluteToDoc(doc, value);
    else if (name === 'xlink:href' && value[0] !== '#') return $6c21bacc9274e141$var$absoluteToDoc(doc, value);
    else if (name === 'background' && (tagName === 'table' || tagName === 'td' || tagName === 'th')) return $6c21bacc9274e141$var$absoluteToDoc(doc, value);
    else if (name === 'srcset') return $6c21bacc9274e141$var$getAbsoluteSrcsetString(doc, value);
    else if (name === 'style') return $6c21bacc9274e141$var$absoluteToStylesheet(value, $6c21bacc9274e141$var$getHref());
    else if (tagName === 'object' && name === 'data') return $6c21bacc9274e141$var$absoluteToDoc(doc, value);
    return value;
}
function $6c21bacc9274e141$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === 'video' || tagName === 'audio') && name === 'autoplay';
}
function $6c21bacc9274e141$var$_isBlockedElement(element, blockClass, blockSelector) {
    try {
        if (typeof blockClass === 'string') {
            if (element.classList.contains(blockClass)) return true;
        } else for(var eIndex = element.classList.length; eIndex--;){
            var className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function $6c21bacc9274e141$var$classMatchesRegex(node, regex, checkAncestors) {
    if (!node) return false;
    if (node.nodeType !== node.ELEMENT_NODE) {
        if (!checkAncestors) return false;
        return $6c21bacc9274e141$var$classMatchesRegex(node.parentNode, regex, checkAncestors);
    }
    for(var eIndex = node.classList.length; eIndex--;){
        var className = node.classList[eIndex];
        if (regex.test(className)) return true;
    }
    if (!checkAncestors) return false;
    return $6c21bacc9274e141$var$classMatchesRegex(node.parentNode, regex, checkAncestors);
}
function $6c21bacc9274e141$var$needMaskingText(node, maskTextClass, maskTextSelector, checkAncestors) {
    try {
        var el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (typeof maskTextClass === 'string') {
            if (checkAncestors) {
                if (el.closest(".".concat(maskTextClass))) return true;
            } else {
                if (el.classList.contains(maskTextClass)) return true;
            }
        } else {
            if ($6c21bacc9274e141$var$classMatchesRegex(el, maskTextClass, checkAncestors)) return true;
        }
        if (maskTextSelector) {
            if (checkAncestors) {
                if (el.closest(maskTextSelector)) return true;
            } else {
                if (el.matches(maskTextSelector)) return true;
            }
        }
    } catch (e) {}
    return false;
}
function $6c21bacc9274e141$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    var win = iframeEl.contentWindow;
    if (!win) return;
    var fired = false;
    var readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== 'complete') {
        var timer = setTimeout(function() {
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener('load', function() {
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    var blankUrl = 'about:blank';
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === '') {
        setTimeout(listener, 0);
        return iframeEl.addEventListener('load', listener);
    }
    iframeEl.addEventListener('load', listener);
}
function $6c21bacc9274e141$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    var fired = false;
    var styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    var timer = setTimeout(function() {
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener('load', function() {
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function $6c21bacc9274e141$var$serializeNode(n, options) {
    var doc = options.doc, mirror = options.mirror, blockClass = options.blockClass, blockSelector = options.blockSelector, needsMask = options.needsMask, inlineStylesheet = options.inlineStylesheet, _options_maskInputOptions = options.maskInputOptions, maskInputOptions = _options_maskInputOptions === void 0 ? {} : _options_maskInputOptions, maskTextFn = options.maskTextFn, maskInputFn = options.maskInputFn, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, inlineImages = options.inlineImages, recordCanvas = options.recordCanvas, keepIframeSrcFn = options.keepIframeSrcFn, _options_newlyAddedElement = options.newlyAddedElement, newlyAddedElement = _options_newlyAddedElement === void 0 ? false : _options_newlyAddedElement;
    var rootId = $6c21bacc9274e141$var$getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== 'CSS1Compat') return {
                type: $6c21bacc9274e141$var$NodeType.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: $6c21bacc9274e141$var$NodeType.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $6c21bacc9274e141$var$NodeType.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            return $6c21bacc9274e141$var$serializeElementNode(n, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId
            });
        case n.TEXT_NODE:
            return $6c21bacc9274e141$var$serializeTextNode(n, {
                needsMask: needsMask,
                maskTextFn: maskTextFn,
                rootId: rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: $6c21bacc9274e141$var$NodeType.CDATA,
                textContent: '',
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $6c21bacc9274e141$var$NodeType.Comment,
                textContent: n.textContent || '',
                rootId: rootId
            };
        default:
            return false;
    }
}
function $6c21bacc9274e141$var$getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return undefined;
    var docId = mirror.getId(doc);
    return docId === 1 ? undefined : docId;
}
function $6c21bacc9274e141$var$serializeTextNode(n, options) {
    var _a;
    var needsMask = options.needsMask, maskTextFn = options.maskTextFn, rootId = options.rootId;
    var parentTagName = n.parentNode && n.parentNode.tagName;
    var textContent = n.textContent;
    var isStyle = parentTagName === 'STYLE' ? true : undefined;
    var isScript = parentTagName === 'SCRIPT' ? true : undefined;
    if (isStyle && textContent) {
        try {
            if (n.nextSibling || n.previousSibling) ;
            else if ((_a = n.parentNode.sheet) === null || _a === void 0 ? void 0 : _a.cssRules) textContent = $6c21bacc9274e141$var$stringifyStylesheet(n.parentNode.sheet);
        } catch (err) {
            console.warn("Cannot get CSS styles from text's parentNode. Error: ".concat(err), n);
        }
        textContent = $6c21bacc9274e141$var$absoluteToStylesheet(textContent, $6c21bacc9274e141$var$getHref());
    }
    if (isScript) textContent = 'SCRIPT_PLACEHOLDER';
    if (!isStyle && !isScript && textContent && needsMask) textContent = maskTextFn ? maskTextFn(textContent, n.parentElement) : textContent.replace(/[\S]/g, '*');
    return {
        type: $6c21bacc9274e141$var$NodeType.Text,
        textContent: textContent || '',
        isStyle: isStyle,
        rootId: rootId
    };
}
function $6c21bacc9274e141$var$serializeElementNode(n, options) {
    var doc = options.doc, blockClass = options.blockClass, blockSelector = options.blockSelector, inlineStylesheet = options.inlineStylesheet, _options_maskInputOptions = options.maskInputOptions, maskInputOptions = _options_maskInputOptions === void 0 ? {} : _options_maskInputOptions, maskInputFn = options.maskInputFn, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, inlineImages = options.inlineImages, recordCanvas = options.recordCanvas, keepIframeSrcFn = options.keepIframeSrcFn, _options_newlyAddedElement = options.newlyAddedElement, newlyAddedElement = _options_newlyAddedElement === void 0 ? false : _options_newlyAddedElement, rootId = options.rootId;
    var needBlock = $6c21bacc9274e141$var$_isBlockedElement(n, blockClass, blockSelector);
    var tagName = $6c21bacc9274e141$var$getValidTagName(n);
    var attributes = {};
    var len = n.attributes.length;
    for(var i = 0; i < len; i++){
        var attr = n.attributes[i];
        if (!$6c21bacc9274e141$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = $6c21bacc9274e141$var$transformAttribute(doc, tagName, $6c21bacc9274e141$var$toLowerCase(attr.name), attr.value);
    }
    if (tagName === 'link' && inlineStylesheet) {
        var stylesheet = Array.from(doc.styleSheets).find(function(s) {
            return s.href === n.href;
        });
        var cssText = null;
        if (stylesheet) cssText = $6c21bacc9274e141$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = $6c21bacc9274e141$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === 'style' && n.sheet && !(n.innerText || n.textContent || '').trim().length) {
        var cssText1 = $6c21bacc9274e141$var$stringifyStylesheet(n.sheet);
        if (cssText1) attributes._cssText = $6c21bacc9274e141$var$absoluteToStylesheet(cssText1, $6c21bacc9274e141$var$getHref());
    }
    if (tagName === 'input' || tagName === 'textarea' || tagName === 'select') {
        var value = n.value;
        var checked = n.checked;
        if (attributes.type !== 'radio' && attributes.type !== 'checkbox' && attributes.type !== 'submit' && attributes.type !== 'button' && value) attributes.value = $6c21bacc9274e141$var$maskInputValue({
            element: n,
            type: $6c21bacc9274e141$var$getInputType(n),
            tagName: tagName,
            value: value,
            maskInputOptions: maskInputOptions,
            maskInputFn: maskInputFn
        });
        else if (checked) attributes.checked = checked;
    }
    if (tagName === 'option') {
        if (n.selected && !maskInputOptions['select']) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === 'canvas' && recordCanvas) {
        if (n.__context === '2d') {
            if (!$6c21bacc9274e141$var$is2DCanvasBlank(n)) attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!('__context' in n)) {
            var canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            var blankCanvas = document.createElement('canvas');
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            var blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === 'img' && inlineImages) {
        if (!$6c21bacc9274e141$var$canvasService) {
            $6c21bacc9274e141$var$canvasService = doc.createElement('canvas');
            $6c21bacc9274e141$var$canvasCtx = $6c21bacc9274e141$var$canvasService.getContext('2d');
        }
        var image = n;
        var oldValue = image.crossOrigin;
        image.crossOrigin = 'anonymous';
        var recordInlineImage = function() {
            image.removeEventListener('load', recordInlineImage);
            try {
                $6c21bacc9274e141$var$canvasService.width = image.naturalWidth;
                $6c21bacc9274e141$var$canvasService.height = image.naturalHeight;
                $6c21bacc9274e141$var$canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = $6c21bacc9274e141$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                console.warn("Cannot inline img src=".concat(image.currentSrc, "! Error: ").concat(err));
            }
            oldValue ? attributes.crossOrigin = oldValue : image.removeAttribute('crossorigin');
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener('load', recordInlineImage);
    }
    if (tagName === 'audio' || tagName === 'video') {
        var mediaAttributes = attributes;
        mediaAttributes.rr_mediaState = n.paused ? 'paused' : 'played';
        mediaAttributes.rr_mediaCurrentTime = n.currentTime;
        mediaAttributes.rr_mediaPlaybackRate = n.playbackRate;
        mediaAttributes.rr_mediaMuted = n.muted;
        mediaAttributes.rr_mediaLoop = n.loop;
        mediaAttributes.rr_mediaVolume = n.volume;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        var _n_getBoundingClientRect = n.getBoundingClientRect(), width = _n_getBoundingClientRect.width, height = _n_getBoundingClientRect.height;
        attributes = {
            "class": attributes["class"],
            rr_width: "".concat(width, "px"),
            rr_height: "".concat(height, "px")
        };
    }
    if (tagName === 'iframe' && !keepIframeSrcFn(attributes.src)) {
        if (!n.contentDocument) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    var isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: $6c21bacc9274e141$var$NodeType.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: $6c21bacc9274e141$var$isSVGElement(n) || undefined,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $6c21bacc9274e141$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) return '';
    else return maybeAttr.toLowerCase();
}
function $6c21bacc9274e141$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $6c21bacc9274e141$var$NodeType.Comment) return true;
    else if (sn.type === $6c21bacc9274e141$var$NodeType.Element) {
        if (slimDOMOptions.script && (sn.tagName === 'script' || sn.tagName === 'link' && (sn.attributes.rel === 'preload' || sn.attributes.rel === 'modulepreload') && sn.attributes.as === 'script' || sn.tagName === 'link' && sn.attributes.rel === 'prefetch' && typeof sn.attributes.href === 'string' && $6c21bacc9274e141$var$extractFileExtension(sn.attributes.href) === 'js')) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === 'link' && sn.attributes.rel === 'shortcut icon' || sn.tagName === 'meta' && ($6c21bacc9274e141$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $6c21bacc9274e141$var$lowerIfExists(sn.attributes.name) === 'application-name' || $6c21bacc9274e141$var$lowerIfExists(sn.attributes.rel) === 'icon' || $6c21bacc9274e141$var$lowerIfExists(sn.attributes.rel) === 'apple-touch-icon' || $6c21bacc9274e141$var$lowerIfExists(sn.attributes.rel) === 'shortcut icon'))) return true;
        else if (sn.tagName === 'meta') {
            if (slimDOMOptions.headMetaDescKeywords && $6c21bacc9274e141$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($6c21bacc9274e141$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || $6c21bacc9274e141$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $6c21bacc9274e141$var$lowerIfExists(sn.attributes.name) === 'pinterest')) return true;
            else if (slimDOMOptions.headMetaRobots && ($6c21bacc9274e141$var$lowerIfExists(sn.attributes.name) === 'robots' || $6c21bacc9274e141$var$lowerIfExists(sn.attributes.name) === 'googlebot' || $6c21bacc9274e141$var$lowerIfExists(sn.attributes.name) === 'bingbot')) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes['http-equiv'] !== undefined) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($6c21bacc9274e141$var$lowerIfExists(sn.attributes.name) === 'author' || $6c21bacc9274e141$var$lowerIfExists(sn.attributes.name) === 'generator' || $6c21bacc9274e141$var$lowerIfExists(sn.attributes.name) === 'framework' || $6c21bacc9274e141$var$lowerIfExists(sn.attributes.name) === 'publisher' || $6c21bacc9274e141$var$lowerIfExists(sn.attributes.name) === 'progid' || $6c21bacc9274e141$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $6c21bacc9274e141$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($6c21bacc9274e141$var$lowerIfExists(sn.attributes.name) === 'google-site-verification' || $6c21bacc9274e141$var$lowerIfExists(sn.attributes.name) === 'yandex-verification' || $6c21bacc9274e141$var$lowerIfExists(sn.attributes.name) === 'csrf-token' || $6c21bacc9274e141$var$lowerIfExists(sn.attributes.name) === 'p:domain_verify' || $6c21bacc9274e141$var$lowerIfExists(sn.attributes.name) === 'verify-v1' || $6c21bacc9274e141$var$lowerIfExists(sn.attributes.name) === 'verification' || $6c21bacc9274e141$var$lowerIfExists(sn.attributes.name) === 'shopify-checkout-api-token')) return true;
        }
    }
    return false;
}
function $6c21bacc9274e141$var$serializeNodeWithId(n, options) {
    var doc = options.doc, mirror = options.mirror, blockClass = options.blockClass, blockSelector = options.blockSelector, maskTextClass = options.maskTextClass, maskTextSelector = options.maskTextSelector, _options_skipChild = options.skipChild, skipChild = _options_skipChild === void 0 ? false : _options_skipChild, _options_inlineStylesheet = options.inlineStylesheet, inlineStylesheet = _options_inlineStylesheet === void 0 ? true : _options_inlineStylesheet, _options_maskInputOptions = options.maskInputOptions, maskInputOptions = _options_maskInputOptions === void 0 ? {} : _options_maskInputOptions, maskTextFn = options.maskTextFn, maskInputFn = options.maskInputFn, slimDOMOptions = options.slimDOMOptions, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, _options_inlineImages = options.inlineImages, inlineImages = _options_inlineImages === void 0 ? false : _options_inlineImages, _options_recordCanvas = options.recordCanvas, recordCanvas = _options_recordCanvas === void 0 ? false : _options_recordCanvas, onSerialize = options.onSerialize, onIframeLoad = options.onIframeLoad, _options_iframeLoadTimeout = options.iframeLoadTimeout, iframeLoadTimeout = _options_iframeLoadTimeout === void 0 ? 5000 : _options_iframeLoadTimeout, onStylesheetLoad = options.onStylesheetLoad, _options_stylesheetLoadTimeout = options.stylesheetLoadTimeout, stylesheetLoadTimeout = _options_stylesheetLoadTimeout === void 0 ? 5000 : _options_stylesheetLoadTimeout, _options_keepIframeSrcFn = options.keepIframeSrcFn, keepIframeSrcFn = _options_keepIframeSrcFn === void 0 ? function() {
        return false;
    } : _options_keepIframeSrcFn, _options_newlyAddedElement = options.newlyAddedElement, newlyAddedElement = _options_newlyAddedElement === void 0 ? false : _options_newlyAddedElement;
    var needsMask = options.needsMask;
    var _options_preserveWhiteSpace = options.preserveWhiteSpace, preserveWhiteSpace = _options_preserveWhiteSpace === void 0 ? true : _options_preserveWhiteSpace;
    if (!needsMask && n.childNodes) {
        var checkAncestors = needsMask === undefined;
        needsMask = $6c21bacc9274e141$var$needMaskingText(n, maskTextClass, maskTextSelector, checkAncestors);
    }
    var _serializedNode = $6c21bacc9274e141$var$serializeNode(n, {
        doc: doc,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        needsMask: needsMask,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement
    });
    if (!_serializedNode) {
        console.warn(n, 'not serialized');
        return null;
    }
    var id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if ($6c21bacc9274e141$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $6c21bacc9274e141$var$NodeType.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, '').length) id = $6c21bacc9274e141$var$IGNORED_NODE;
    else id = $6c21bacc9274e141$var$genId();
    var serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror.add(n, serializedNode);
    if (id === $6c21bacc9274e141$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n);
    var recordChild = !skipChild;
    if (serializedNode.type === $6c21bacc9274e141$var$NodeType.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        var shadowRoot = n.shadowRoot;
        if (shadowRoot && $6c21bacc9274e141$var$isNativeShadowDom(shadowRoot)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $6c21bacc9274e141$var$NodeType.Document || serializedNode.type === $6c21bacc9274e141$var$NodeType.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === $6c21bacc9274e141$var$NodeType.Element && serializedNode.tagName === 'head') preserveWhiteSpace = false;
        var bypassOptions = {
            doc: doc,
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            needsMask: needsMask,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (serializedNode.type === $6c21bacc9274e141$var$NodeType.Element && serializedNode.tagName === 'textarea' && serializedNode.attributes.value !== undefined) ;
        else try {
            for(var _iterator = Array.from(n.childNodes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var childN = _step.value;
                var serializedChildNode = $6c21bacc9274e141$var$serializeNodeWithId(childN, bypassOptions);
                if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        if ($6c21bacc9274e141$var$isElement(n) && n.shadowRoot) try {
            for(var _iterator1 = Array.from(n.shadowRoot.childNodes)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var childN1 = _step1.value;
                var serializedChildNode1 = $6c21bacc9274e141$var$serializeNodeWithId(childN1, bypassOptions);
                if (serializedChildNode1) {
                    $6c21bacc9274e141$var$isNativeShadowDom(n.shadowRoot) && (serializedChildNode1.isShadow = true);
                    serializedNode.childNodes.push(serializedChildNode1);
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                    _iterator1["return"]();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    if (n.parentNode && $6c21bacc9274e141$var$isShadowRoot(n.parentNode) && $6c21bacc9274e141$var$isNativeShadowDom(n.parentNode)) serializedNode.isShadow = true;
    if (serializedNode.type === $6c21bacc9274e141$var$NodeType.Element && serializedNode.tagName === 'iframe') $6c21bacc9274e141$var$onceIframeLoaded(n, function() {
        var iframeDoc = n.contentDocument;
        if (iframeDoc && onIframeLoad) {
            var serializedIframeNode = $6c21bacc9274e141$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                needsMask: needsMask,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === $6c21bacc9274e141$var$NodeType.Element && serializedNode.tagName === 'link' && typeof serializedNode.attributes.rel === 'string' && (serializedNode.attributes.rel === 'stylesheet' || serializedNode.attributes.rel === 'preload' && typeof serializedNode.attributes.href === 'string' && $6c21bacc9274e141$var$extractFileExtension(serializedNode.attributes.href) === 'css')) $6c21bacc9274e141$var$onceStylesheetLoaded(n, function() {
        if (onStylesheetLoad) {
            var serializedLinkNode = $6c21bacc9274e141$var$serializeNodeWithId(n, {
                doc: doc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                needsMask: needsMask,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function $6c21bacc9274e141$var$snapshot(n, options) {
    var _ref = options || {}, _ref_mirror = _ref.mirror, mirror = _ref_mirror === void 0 ? new $6c21bacc9274e141$var$Mirror() : _ref_mirror, _ref_blockClass = _ref.blockClass, blockClass = _ref_blockClass === void 0 ? 'rr-block' : _ref_blockClass, _ref_blockSelector = _ref.blockSelector, blockSelector = _ref_blockSelector === void 0 ? null : _ref_blockSelector, _ref_maskTextClass = _ref.maskTextClass, maskTextClass = _ref_maskTextClass === void 0 ? 'rr-mask' : _ref_maskTextClass, _ref_maskTextSelector = _ref.maskTextSelector, maskTextSelector = _ref_maskTextSelector === void 0 ? null : _ref_maskTextSelector, _ref_inlineStylesheet = _ref.inlineStylesheet, inlineStylesheet = _ref_inlineStylesheet === void 0 ? true : _ref_inlineStylesheet, _ref_inlineImages = _ref.inlineImages, inlineImages = _ref_inlineImages === void 0 ? false : _ref_inlineImages, _ref_recordCanvas = _ref.recordCanvas, recordCanvas = _ref_recordCanvas === void 0 ? false : _ref_recordCanvas, _ref_maskAllInputs = _ref.maskAllInputs, maskAllInputs = _ref_maskAllInputs === void 0 ? false : _ref_maskAllInputs, maskTextFn = _ref.maskTextFn, maskInputFn = _ref.maskInputFn, _ref_slimDOM = _ref.slimDOM, slimDOM = _ref_slimDOM === void 0 ? false : _ref_slimDOM, dataURLOptions = _ref.dataURLOptions, preserveWhiteSpace = _ref.preserveWhiteSpace, onSerialize = _ref.onSerialize, onIframeLoad = _ref.onIframeLoad, iframeLoadTimeout = _ref.iframeLoadTimeout, onStylesheetLoad = _ref.onStylesheetLoad, stylesheetLoadTimeout = _ref.stylesheetLoadTimeout, _ref_keepIframeSrcFn = _ref.keepIframeSrcFn, keepIframeSrcFn = _ref_keepIframeSrcFn === void 0 ? function() {
        return false;
    } : _ref_keepIframeSrcFn;
    var maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        password: true
    } : maskAllInputs === false ? {
        password: true
    } : maskAllInputs;
    var slimDOMOptions = slimDOM === true || slimDOM === 'all' ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === 'all',
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $6c21bacc9274e141$var$serializeNodeWithId(n, {
        doc: n,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskTextClass: maskTextClass,
        maskTextSelector: maskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $6c21bacc9274e141$var$on(type, fn) {
    var target = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : document;
    var options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return function() {
        return target.removeEventListener(type, fn, options);
    };
}
var $6c21bacc9274e141$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
var $6c21bacc9274e141$var$_mirror = {
    map: {},
    getId: function() {
        console.error($6c21bacc9274e141$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode: function() {
        console.error($6c21bacc9274e141$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap: function() {
        console.error($6c21bacc9274e141$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has: function() {
        console.error($6c21bacc9274e141$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset: function() {
        console.error($6c21bacc9274e141$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== 'undefined' && window.Proxy && window.Reflect) $6c21bacc9274e141$var$_mirror = new Proxy($6c21bacc9274e141$var$_mirror, {
    get: function(target, prop, receiver) {
        if (prop === 'map') console.error($6c21bacc9274e141$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $6c21bacc9274e141$var$throttle(func, wait) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var timeout = null;
    var previous = 0;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var now = Date.now();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        var context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(function() {
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $6c21bacc9274e141$var$hookSetter(target, key, d, isRevoked) {
    var win = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : window;
    var original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set: function(value) {
            var _this = this;
            setTimeout(function() {
                d.set.call(_this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return function() {
        return $6c21bacc9274e141$var$hookSetter(target, key, original || {}, true);
    };
}
function $6c21bacc9274e141$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return function() {};
        var original = source[name];
        var wrapped = replacement(original);
        if (typeof wrapped === 'function') {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return function() {
            source[name] = original;
        };
    } catch (_a) {
        return function() {};
    }
}
var $6c21bacc9274e141$var$nowTimestamp = Date.now;
if (!/[1-9][0-9]{12}/.test(Date.now().toString())) $6c21bacc9274e141$var$nowTimestamp = function() {
    return new Date().getTime();
};
function $6c21bacc9274e141$var$getWindowScroll(win) {
    var _a, _b, _c, _d, _e, _f;
    var doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== undefined ? win.pageXOffset : (doc === null || doc === void 0 ? void 0 : doc.documentElement.scrollLeft) || ((_b = (_a = doc === null || doc === void 0 ? void 0 : doc.body) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.scrollLeft) || ((_c = doc === null || doc === void 0 ? void 0 : doc.body) === null || _c === void 0 ? void 0 : _c.scrollLeft) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== undefined ? win.pageYOffset : (doc === null || doc === void 0 ? void 0 : doc.documentElement.scrollTop) || ((_e = (_d = doc === null || doc === void 0 ? void 0 : doc.body) === null || _d === void 0 ? void 0 : _d.parentElement) === null || _e === void 0 ? void 0 : _e.scrollTop) || ((_f = doc === null || doc === void 0 ? void 0 : doc.body) === null || _f === void 0 ? void 0 : _f.scrollTop) || 0
    };
}
function $6c21bacc9274e141$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $6c21bacc9274e141$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $6c21bacc9274e141$var$closestElementOfNode(node) {
    if (!node) return null;
    var el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    return el;
}
function $6c21bacc9274e141$var$isBlocked(node, blockClass, blockSelector, checkAncestors) {
    if (!node) return false;
    var el = $6c21bacc9274e141$var$closestElementOfNode(node);
    if (!el) return false;
    try {
        if (typeof blockClass === 'string') {
            if (el.classList.contains(blockClass)) return true;
            if (checkAncestors && el.closest('.' + blockClass) !== null) return true;
        } else {
            if ($6c21bacc9274e141$var$classMatchesRegex(el, blockClass, checkAncestors)) return true;
        }
    } catch (e) {}
    if (blockSelector) {
        if (el.matches(blockSelector)) return true;
        if (checkAncestors && el.closest(blockSelector) !== null) return true;
    }
    return false;
}
function $6c21bacc9274e141$var$isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function $6c21bacc9274e141$var$isIgnored(n, mirror) {
    return mirror.getId(n) === $6c21bacc9274e141$var$IGNORED_NODE;
}
function $6c21bacc9274e141$var$isAncestorRemoved(target, mirror) {
    if ($6c21bacc9274e141$var$isShadowRoot(target)) return false;
    var id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $6c21bacc9274e141$var$isAncestorRemoved(target.parentNode, mirror);
}
function $6c21bacc9274e141$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $6c21bacc9274e141$var$polyfill() {
    var win = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window;
    var _this = this;
    if ('NodeList' in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ('DOMTokenList' in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var node = args[0];
        if (!(0 in args)) throw new TypeError('1 argument is required');
        do {
            if (_this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $6c21bacc9274e141$var$isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === 'IFRAME' && mirror.getMeta(n));
}
function $6c21bacc9274e141$var$isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === 'LINK' && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute('rel') === 'stylesheet' && mirror.getMeta(n));
}
function $6c21bacc9274e141$var$hasShadowRoot(n) {
    return Boolean(n === null || n === void 0 ? void 0 : n.shadowRoot);
}
var $6c21bacc9274e141$var$StyleSheetMirror = /*#__PURE__*/ function() {
    "use strict";
    function StyleSheetMirror() {
        (0, $50OuQ._)(this, StyleSheetMirror);
        this.id = 1;
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
    }
    (0, $fGdZr._)(StyleSheetMirror, [
        {
            key: "getId",
            value: function getId(stylesheet) {
                var _a;
                return (_a = this.styleIDMap.get(stylesheet)) !== null && _a !== void 0 ? _a : -1;
            }
        },
        {
            key: "has",
            value: function has(stylesheet) {
                return this.styleIDMap.has(stylesheet);
            }
        },
        {
            key: "add",
            value: function add(stylesheet, id) {
                if (this.has(stylesheet)) return this.getId(stylesheet);
                var newId;
                if (id === undefined) newId = this.id++;
                else newId = id;
                this.styleIDMap.set(stylesheet, newId);
                this.idStyleMap.set(newId, stylesheet);
                return newId;
            }
        },
        {
            key: "getStyle",
            value: function getStyle(id) {
                return this.idStyleMap.get(id) || null;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.styleIDMap = new WeakMap();
                this.idStyleMap = new Map();
                this.id = 1;
            }
        },
        {
            key: "generateId",
            value: function generateId() {
                return this.id++;
            }
        }
    ]);
    return StyleSheetMirror;
}();
function $6c21bacc9274e141$var$getShadowHost(n) {
    var _a, _b;
    var shadowHost = null;
    if (((_b = (_a = n.getRootNode) === null || _a === void 0 ? void 0 : _a.call(n)) === null || _b === void 0 ? void 0 : _b.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
    return shadowHost;
}
function $6c21bacc9274e141$var$getRootShadowHost(n) {
    var rootShadowHost = n;
    var shadowHost;
    while(shadowHost = $6c21bacc9274e141$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $6c21bacc9274e141$var$shadowHostInDom(n) {
    var doc = n.ownerDocument;
    if (!doc) return false;
    var shadowHost = $6c21bacc9274e141$var$getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function $6c21bacc9274e141$var$inDom(n) {
    var doc = n.ownerDocument;
    if (!doc) return false;
    return doc.contains(n) || $6c21bacc9274e141$var$shadowHostInDom(n);
}
var $6c21bacc9274e141$var$EventType$1 = /* @__PURE__ */ function(EventType2) {
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
}($6c21bacc9274e141$var$EventType$1 || {});
var $6c21bacc9274e141$var$IncrementalSource$1 = /* @__PURE__ */ function(IncrementalSource2) {
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
}($6c21bacc9274e141$var$IncrementalSource$1 || {});
var $6c21bacc9274e141$var$MouseInteractions = /* @__PURE__ */ function(MouseInteractions2) {
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
}($6c21bacc9274e141$var$MouseInteractions || {});
var $6c21bacc9274e141$var$PointerTypes = /* @__PURE__ */ function(PointerTypes2) {
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
}($6c21bacc9274e141$var$PointerTypes || {});
var $6c21bacc9274e141$var$CanvasContext = /* @__PURE__ */ function(CanvasContext2) {
    CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
    CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
    CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
    return CanvasContext2;
}($6c21bacc9274e141$var$CanvasContext || {});
function $6c21bacc9274e141$var$isNodeInLinkedList(n) {
    return '__ln' in n;
}
var $6c21bacc9274e141$var$DoubleLinkedList = /*#__PURE__*/ function() {
    "use strict";
    function DoubleLinkedList() {
        (0, $50OuQ._)(this, DoubleLinkedList);
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    (0, $fGdZr._)(DoubleLinkedList, [
        {
            key: "get",
            value: function get(position) {
                if (position >= this.length) throw new Error('Position outside of list range');
                var current = this.head;
                for(var index = 0; index < position; index++)current = (current === null || current === void 0 ? void 0 : current.next) || null;
                return current;
            }
        },
        {
            key: "addNode",
            value: function addNode(n) {
                var node = {
                    value: n,
                    previous: null,
                    next: null
                };
                n.__ln = node;
                if (n.previousSibling && $6c21bacc9274e141$var$isNodeInLinkedList(n.previousSibling)) {
                    var current = n.previousSibling.__ln.next;
                    node.next = current;
                    node.previous = n.previousSibling.__ln;
                    n.previousSibling.__ln.next = node;
                    if (current) current.previous = node;
                } else if (n.nextSibling && $6c21bacc9274e141$var$isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
                    var current1 = n.nextSibling.__ln.previous;
                    node.previous = current1;
                    node.next = n.nextSibling.__ln;
                    n.nextSibling.__ln.previous = node;
                    if (current1) current1.next = node;
                } else {
                    if (this.head) this.head.previous = node;
                    node.next = this.head;
                    this.head = node;
                }
                if (node.next === null) this.tail = node;
                this.length++;
            }
        },
        {
            key: "removeNode",
            value: function removeNode(n) {
                var current = n.__ln;
                if (!this.head) return;
                if (!current.previous) {
                    this.head = current.next;
                    if (this.head) this.head.previous = null;
                    else this.tail = null;
                } else {
                    current.previous.next = current.next;
                    if (current.next) current.next.previous = current.previous;
                    else this.tail = current.previous;
                }
                if (n.__ln) delete n.__ln;
                this.length--;
            }
        }
    ]);
    return DoubleLinkedList;
}();
var $6c21bacc9274e141$var$moveKey = function(id, parentId) {
    return "".concat(id, "@").concat(parentId);
};
var $6c21bacc9274e141$var$MutationBuffer = /*#__PURE__*/ function() {
    "use strict";
    function MutationBuffer() {
        var _this = this;
        (0, $50OuQ._)(this, MutationBuffer);
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = function(mutations) {
            mutations.forEach(_this.processMutation);
            _this.emit();
        };
        this.emit = function() {
            if (_this.frozen || _this.locked) return;
            var adds = [];
            var addedIds = new Set();
            var addList = new $6c21bacc9274e141$var$DoubleLinkedList();
            var getNextId = function(n) {
                var ns = n;
                var nextId = $6c21bacc9274e141$var$IGNORED_NODE;
                while(nextId === $6c21bacc9274e141$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && _this.mirror.getId(ns);
                }
                return nextId;
            };
            var pushAdd = function(n) {
                if (!n.parentNode || !$6c21bacc9274e141$var$inDom(n) || n.parentNode.tagName === 'TEXTAREA') return;
                var parentId = $6c21bacc9274e141$var$isShadowRoot(n.parentNode) ? _this.mirror.getId($6c21bacc9274e141$var$getShadowHost(n)) : _this.mirror.getId(n.parentNode);
                var nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) return addList.addNode(n);
                var sn = $6c21bacc9274e141$var$serializeNodeWithId(n, {
                    doc: _this.doc,
                    mirror: _this.mirror,
                    blockClass: _this.blockClass,
                    blockSelector: _this.blockSelector,
                    maskTextClass: _this.maskTextClass,
                    maskTextSelector: _this.maskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: _this.inlineStylesheet,
                    maskInputOptions: _this.maskInputOptions,
                    maskTextFn: _this.maskTextFn,
                    maskInputFn: _this.maskInputFn,
                    slimDOMOptions: _this.slimDOMOptions,
                    dataURLOptions: _this.dataURLOptions,
                    recordCanvas: _this.recordCanvas,
                    inlineImages: _this.inlineImages,
                    onSerialize: function(currentN) {
                        if ($6c21bacc9274e141$var$isSerializedIframe(currentN, _this.mirror)) _this.iframeManager.addIframe(currentN);
                        if ($6c21bacc9274e141$var$isSerializedStylesheet(currentN, _this.mirror)) _this.stylesheetManager.trackLinkElement(currentN);
                        if ($6c21bacc9274e141$var$hasShadowRoot(n)) _this.shadowDomManager.addShadowRoot(n.shadowRoot, _this.doc);
                    },
                    onIframeLoad: function(iframe, childSn) {
                        _this.iframeManager.attachIframe(iframe, childSn);
                        _this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: function(link, childSn) {
                        _this.stylesheetManager.attachLinkElement(link, childSn);
                    }
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(_this.mapRemoves.length)_this.mirror.removeNodeFromMap(_this.mapRemoves.shift());
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = _this.movedSet[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var n = _step.value;
                    if ($6c21bacc9274e141$var$isParentRemoved(_this.removes, n, _this.mirror) && !_this.movedSet.has(n.parentNode)) continue;
                    pushAdd(n);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = _this.addedSet[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var n1 = _step1.value;
                    if (!$6c21bacc9274e141$var$isAncestorInSet(_this.droppedSet, n1) && !$6c21bacc9274e141$var$isParentRemoved(_this.removes, n1, _this.mirror)) pushAdd(n1);
                    else if ($6c21bacc9274e141$var$isAncestorInSet(_this.movedSet, n1)) pushAdd(n1);
                    else _this.droppedSet.add(n1);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                        _iterator1["return"]();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            var candidate = null;
            while(addList.length){
                var node = null;
                if (candidate) {
                    var parentId = _this.mirror.getId(candidate.value.parentNode);
                    var nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    var tailNode = addList.tail;
                    while(tailNode){
                        var _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            var parentId1 = _this.mirror.getId(_node.value.parentNode);
                            var nextId1 = getNextId(_node.value);
                            if (nextId1 === -1) continue;
                            else if (parentId1 !== -1) {
                                node = _node;
                                break;
                            } else {
                                var unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    var shadowHost = unhandledNode.parentNode.host;
                                    var parentId2 = _this.mirror.getId(shadowHost);
                                    if (parentId2 !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            var payload = {
                texts: _this.texts.map(function(text) {
                    var n = text.node;
                    if (n.parentNode && n.parentNode.tagName === 'TEXTAREA') _this.genTextAreaValueMutation(n.parentNode);
                    return {
                        id: _this.mirror.getId(n),
                        value: text.value
                    };
                }).filter(function(text) {
                    return !addedIds.has(text.id);
                }).filter(function(text) {
                    return _this.mirror.has(text.id);
                }),
                attributes: _this.attributes.map(function(attribute) {
                    var attributes = attribute.attributes;
                    if (typeof attributes.style === 'string') {
                        var diffAsStr = JSON.stringify(attribute.styleDiff);
                        var unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split('var(').length === attributes.style.split('var(').length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: _this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter(function(attribute) {
                    return !addedIds.has(attribute.id);
                }).filter(function(attribute) {
                    return _this.mirror.has(attribute.id);
                }),
                removes: _this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            _this.texts = [];
            _this.attributes = [];
            _this.attributeMap = new WeakMap();
            _this.removes = [];
            _this.addedSet = new Set();
            _this.movedSet = new Set();
            _this.droppedSet = new Set();
            _this.movedMap = {};
            _this.mutationCb(payload);
        };
        this.genTextAreaValueMutation = function(textarea) {
            var item = _this.attributeMap.get(textarea);
            if (!item) {
                item = {
                    node: textarea,
                    attributes: {},
                    styleDiff: {},
                    _unchangedStyles: {}
                };
                _this.attributes.push(item);
                _this.attributeMap.set(textarea, item);
            }
            item.attributes.value = Array.from(textarea.childNodes, function(cn) {
                return cn.textContent || '';
            }).join('');
        };
        this.processMutation = function(m) {
            if ($6c21bacc9274e141$var$isIgnored(m.target, _this.mirror)) return;
            switch(m.type){
                case 'characterData':
                    {
                        var value = m.target.textContent;
                        if (!$6c21bacc9274e141$var$isBlocked(m.target, _this.blockClass, _this.blockSelector, false) && value !== m.oldValue) _this.texts.push({
                            value: $6c21bacc9274e141$var$needMaskingText(m.target, _this.maskTextClass, _this.maskTextSelector, true) && value ? _this.maskTextFn ? _this.maskTextFn(value, $6c21bacc9274e141$var$closestElementOfNode(m.target)) : value.replace(/[\S]/g, '*') : value,
                            node: m.target
                        });
                        break;
                    }
                case 'attributes':
                    {
                        var target = m.target;
                        var attributeName = m.attributeName;
                        var value1 = m.target.getAttribute(attributeName);
                        if (attributeName === 'value') {
                            var type = $6c21bacc9274e141$var$getInputType(target);
                            value1 = $6c21bacc9274e141$var$maskInputValue({
                                element: target,
                                maskInputOptions: _this.maskInputOptions,
                                tagName: target.tagName,
                                type: type,
                                value: value1,
                                maskInputFn: _this.maskInputFn
                            });
                        }
                        if ($6c21bacc9274e141$var$isBlocked(m.target, _this.blockClass, _this.blockSelector, false) || value1 === m.oldValue) return;
                        var item = _this.attributeMap.get(m.target);
                        if (target.tagName === 'IFRAME' && attributeName === 'src' && !_this.keepIframeSrcFn(value1)) {
                            if (!target.contentDocument) attributeName = 'rr_src';
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            _this.attributes.push(item);
                            _this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === 'type' && target.tagName === 'INPUT' && (m.oldValue || '').toLowerCase() === 'password') target.setAttribute('data-rr-is-password', 'true');
                        if (!$6c21bacc9274e141$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $6c21bacc9274e141$var$transformAttribute(_this.doc, $6c21bacc9274e141$var$toLowerCase(target.tagName), $6c21bacc9274e141$var$toLowerCase(attributeName), value1);
                            if (attributeName === 'style') {
                                if (!_this.unattachedDoc) try {
                                    _this.unattachedDoc = document.implementation.createHTMLDocument();
                                } catch (e) {
                                    _this.unattachedDoc = _this.doc;
                                }
                                var old = _this.unattachedDoc.createElement('span');
                                if (m.oldValue) old.setAttribute('style', m.oldValue);
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = Array.from(target.style)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var pname = _step.value;
                                        var newValue = target.style.getPropertyValue(pname);
                                        var newPriority = target.style.getPropertyPriority(pname);
                                        if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                            if (newPriority === '') item.styleDiff[pname] = newValue;
                                            else item.styleDiff[pname] = [
                                                newValue,
                                                newPriority
                                            ];
                                        } else item._unchangedStyles[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                            _iterator["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(var _iterator1 = Array.from(old.style)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        var pname1 = _step1.value;
                                        if (target.style.getPropertyValue(pname1) === '') item.styleDiff[pname1] = false;
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                            _iterator1["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                            }
                        }
                        break;
                    }
                case 'childList':
                    if ($6c21bacc9274e141$var$isBlocked(m.target, _this.blockClass, _this.blockSelector, true)) return;
                    if (m.target.tagName === 'TEXTAREA') {
                        _this.genTextAreaValueMutation(m.target);
                        return;
                    }
                    m.addedNodes.forEach(function(n) {
                        return _this.genAdds(n, m.target);
                    });
                    m.removedNodes.forEach(function(n) {
                        var nodeId = _this.mirror.getId(n);
                        var parentId = $6c21bacc9274e141$var$isShadowRoot(m.target) ? _this.mirror.getId(m.target.host) : _this.mirror.getId(m.target);
                        if ($6c21bacc9274e141$var$isBlocked(m.target, _this.blockClass, _this.blockSelector, false) || $6c21bacc9274e141$var$isIgnored(n, _this.mirror) || !$6c21bacc9274e141$var$isSerialized(n, _this.mirror)) return;
                        if (_this.addedSet.has(n)) {
                            $6c21bacc9274e141$var$deepDelete(_this.addedSet, n);
                            _this.droppedSet.add(n);
                        } else if (_this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($6c21bacc9274e141$var$isAncestorRemoved(m.target, _this.mirror)) ;
                        else if (_this.movedSet.has(n) && _this.movedMap[$6c21bacc9274e141$var$moveKey(nodeId, parentId)]) $6c21bacc9274e141$var$deepDelete(_this.movedSet, n);
                        else _this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $6c21bacc9274e141$var$isShadowRoot(m.target) && $6c21bacc9274e141$var$isNativeShadowDom(m.target) ? true : undefined
                        });
                        _this.mapRemoves.push(n);
                    });
                    break;
            }
        };
        this.genAdds = function(n, target) {
            if (_this.processedNodeManager.inOtherBuffer(n, _this)) return;
            if (_this.addedSet.has(n) || _this.movedSet.has(n)) return;
            if (_this.mirror.hasNode(n)) {
                if ($6c21bacc9274e141$var$isIgnored(n, _this.mirror)) return;
                _this.movedSet.add(n);
                var targetId = null;
                if (target && _this.mirror.hasNode(target)) targetId = _this.mirror.getId(target);
                if (targetId && targetId !== -1) _this.movedMap[$6c21bacc9274e141$var$moveKey(_this.mirror.getId(n), targetId)] = true;
            } else {
                _this.addedSet.add(n);
                _this.droppedSet["delete"](n);
            }
            if (!$6c21bacc9274e141$var$isBlocked(n, _this.blockClass, _this.blockSelector, false)) {
                n.childNodes.forEach(function(childN) {
                    return _this.genAdds(childN);
                });
                if ($6c21bacc9274e141$var$hasShadowRoot(n)) n.shadowRoot.childNodes.forEach(function(childN) {
                    _this.processedNodeManager.add(childN, _this);
                    _this.genAdds(childN, n);
                });
            }
        };
    }
    (0, $fGdZr._)(MutationBuffer, [
        {
            key: "init",
            value: function init(options) {
                var _this = this;
                [
                    'mutationCb',
                    'blockClass',
                    'blockSelector',
                    'maskTextClass',
                    'maskTextSelector',
                    'inlineStylesheet',
                    'maskInputOptions',
                    'maskTextFn',
                    'maskInputFn',
                    'keepIframeSrcFn',
                    'recordCanvas',
                    'inlineImages',
                    'slimDOMOptions',
                    'dataURLOptions',
                    'doc',
                    'mirror',
                    'iframeManager',
                    'stylesheetManager',
                    'shadowDomManager',
                    'canvasManager',
                    'processedNodeManager'
                ].forEach(function(key) {
                    _this[key] = options[key];
                });
            }
        },
        {
            key: "freeze",
            value: function freeze() {
                this.frozen = true;
                this.canvasManager.freeze();
            }
        },
        {
            key: "unfreeze",
            value: function unfreeze() {
                this.frozen = false;
                this.canvasManager.unfreeze();
                this.emit();
            }
        },
        {
            key: "isFrozen",
            value: function isFrozen() {
                return this.frozen;
            }
        },
        {
            key: "lock",
            value: function lock() {
                this.locked = true;
                this.canvasManager.lock();
            }
        },
        {
            key: "unlock",
            value: function unlock() {
                this.locked = false;
                this.canvasManager.unlock();
                this.emit();
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.shadowDomManager.reset();
                this.canvasManager.reset();
            }
        }
    ]);
    return MutationBuffer;
}();
function $6c21bacc9274e141$var$deepDelete(addsSet, n) {
    addsSet["delete"](n);
    n.childNodes.forEach(function(childN) {
        return $6c21bacc9274e141$var$deepDelete(addsSet, childN);
    });
}
function $6c21bacc9274e141$var$isParentRemoved(removes, n, mirror) {
    if (removes.length === 0) return false;
    return $6c21bacc9274e141$var$_isParentRemoved(removes, n, mirror);
}
function $6c21bacc9274e141$var$_isParentRemoved(removes, n, mirror) {
    var parentNode = n.parentNode;
    if (!parentNode) return false;
    var parentId = mirror.getId(parentNode);
    if (removes.some(function(r) {
        return r.id === parentId;
    })) return true;
    return $6c21bacc9274e141$var$_isParentRemoved(removes, parentNode, mirror);
}
function $6c21bacc9274e141$var$isAncestorInSet(set, n) {
    if (set.size === 0) return false;
    return $6c21bacc9274e141$var$_isAncestorInSet(set, n);
}
function $6c21bacc9274e141$var$_isAncestorInSet(set, n) {
    var parentNode = n.parentNode;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $6c21bacc9274e141$var$_isAncestorInSet(set, parentNode);
}
var $6c21bacc9274e141$var$errorHandler;
function $6c21bacc9274e141$var$registerErrorHandler(handler) {
    $6c21bacc9274e141$var$errorHandler = handler;
}
function $6c21bacc9274e141$var$unregisterErrorHandler() {
    $6c21bacc9274e141$var$errorHandler = undefined;
}
var $6c21bacc9274e141$var$callbackWrapper = function(cb) {
    if (!$6c21bacc9274e141$var$errorHandler) return cb;
    var rrwebWrapped = function() {
        for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
            rest[_key] = arguments[_key];
        }
        try {
            return cb.apply(void 0, (0, $dHvbf._)(rest));
        } catch (error) {
            if ($6c21bacc9274e141$var$errorHandler && $6c21bacc9274e141$var$errorHandler(error) === true) return;
            throw error;
        }
    };
    return rrwebWrapped;
};
var $6c21bacc9274e141$var$mutationBuffers = [];
function $6c21bacc9274e141$var$getEventTarget(event) {
    try {
        if ('composedPath' in event) {
            var path = event.composedPath();
            if (path.length) return path[0];
        } else if ('path' in event && event.path.length) return event.path[0];
    } catch (_a) {}
    return event && event.target;
}
function $6c21bacc9274e141$var$initMutationObserver(options, rootEl) {
    var _a, _b;
    var mutationBuffer = new $6c21bacc9274e141$var$MutationBuffer();
    $6c21bacc9274e141$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    var mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
    var angularZoneSymbol = (_b = (_a = window === null || window === void 0 ? void 0 : window.Zone) === null || _a === void 0 ? void 0 : _a.__symbol__) === null || _b === void 0 ? void 0 : _b.call(_a, 'MutationObserver');
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    var observer = new mutationObserverCtor($6c21bacc9274e141$var$callbackWrapper(mutationBuffer.processMutations.bind(mutationBuffer)));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $6c21bacc9274e141$var$initMoveObserver(param) {
    var mousemoveCb = param.mousemoveCb, sampling = param.sampling, doc = param.doc, mirror = param.mirror;
    if (sampling.mousemove === false) return function() {};
    var threshold = typeof sampling.mousemove === 'number' ? sampling.mousemove : 50;
    var callbackThreshold = typeof sampling.mousemoveCallback === 'number' ? sampling.mousemoveCallback : 500;
    var positions = [];
    var timeBaseline;
    var wrappedCb = $6c21bacc9274e141$var$throttle($6c21bacc9274e141$var$callbackWrapper(function(source) {
        var totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map(function(p) {
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    var updatePosition = $6c21bacc9274e141$var$callbackWrapper($6c21bacc9274e141$var$throttle($6c21bacc9274e141$var$callbackWrapper(function(evt) {
        var target = $6c21bacc9274e141$var$getEventTarget(evt);
        var _ref = $6c21bacc9274e141$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt, clientX = _ref.clientX, clientY = _ref.clientY;
        if (!timeBaseline) timeBaseline = $6c21bacc9274e141$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: $6c21bacc9274e141$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== 'undefined' && evt instanceof DragEvent ? $6c21bacc9274e141$var$IncrementalSource$1.Drag : evt instanceof MouseEvent ? $6c21bacc9274e141$var$IncrementalSource$1.MouseMove : $6c21bacc9274e141$var$IncrementalSource$1.TouchMove);
    }), threshold, {
        trailing: false
    }));
    var handlers = [
        $6c21bacc9274e141$var$on('mousemove', updatePosition, doc),
        $6c21bacc9274e141$var$on('touchmove', updatePosition, doc),
        $6c21bacc9274e141$var$on('drag', updatePosition, doc)
    ];
    return $6c21bacc9274e141$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $6c21bacc9274e141$var$initMouseInteractionObserver(param) {
    var mouseInteractionCb = param.mouseInteractionCb, doc = param.doc, mirror = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, sampling = param.sampling;
    if (sampling.mouseInteraction === false) return function() {};
    var disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
    var handlers = [];
    var currentPointerType = null;
    var getHandler = function(eventKey) {
        return function(event) {
            var target = $6c21bacc9274e141$var$getEventTarget(event);
            if ($6c21bacc9274e141$var$isBlocked(target, blockClass, blockSelector, true)) return;
            var pointerType = null;
            var thisEventKey = eventKey;
            if ('pointerType' in event) {
                switch(event.pointerType){
                    case 'mouse':
                        pointerType = $6c21bacc9274e141$var$PointerTypes.Mouse;
                        break;
                    case 'touch':
                        pointerType = $6c21bacc9274e141$var$PointerTypes.Touch;
                        break;
                    case 'pen':
                        pointerType = $6c21bacc9274e141$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $6c21bacc9274e141$var$PointerTypes.Touch) {
                    if ($6c21bacc9274e141$var$MouseInteractions[eventKey] === $6c21bacc9274e141$var$MouseInteractions.MouseDown) thisEventKey = 'TouchStart';
                    else if ($6c21bacc9274e141$var$MouseInteractions[eventKey] === $6c21bacc9274e141$var$MouseInteractions.MouseUp) thisEventKey = 'TouchEnd';
                } else $6c21bacc9274e141$var$PointerTypes.Pen;
            } else if ($6c21bacc9274e141$var$legacy_isTouchEvent(event)) pointerType = $6c21bacc9274e141$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith('Touch') && pointerType === $6c21bacc9274e141$var$PointerTypes.Touch || thisEventKey.startsWith('Mouse') && pointerType === $6c21bacc9274e141$var$PointerTypes.Mouse) pointerType = null;
            } else if ($6c21bacc9274e141$var$MouseInteractions[eventKey] === $6c21bacc9274e141$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            var e = $6c21bacc9274e141$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) return;
            var id = mirror.getId(target);
            var clientX = e.clientX, clientY = e.clientY;
            $6c21bacc9274e141$var$callbackWrapper(mouseInteractionCb)(Object.assign({
                type: $6c21bacc9274e141$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY
            }, pointerType !== null && {
                pointerType: pointerType
            }));
        };
    };
    Object.keys($6c21bacc9274e141$var$MouseInteractions).filter(function(key) {
        return Number.isNaN(Number(key)) && !key.endsWith('_Departed') && disableMap[key] !== false;
    }).forEach(function(eventKey) {
        var eventName = $6c21bacc9274e141$var$toLowerCase(eventKey);
        var handler = getHandler(eventKey);
        if (window.PointerEvent) switch($6c21bacc9274e141$var$MouseInteractions[eventKey]){
            case $6c21bacc9274e141$var$MouseInteractions.MouseDown:
            case $6c21bacc9274e141$var$MouseInteractions.MouseUp:
                eventName = eventName.replace('mouse', 'pointer');
                break;
            case $6c21bacc9274e141$var$MouseInteractions.TouchStart:
            case $6c21bacc9274e141$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($6c21bacc9274e141$var$on(eventName, handler, doc));
    });
    return $6c21bacc9274e141$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $6c21bacc9274e141$var$initScrollObserver(param) {
    var scrollCb = param.scrollCb, doc = param.doc, mirror = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, sampling = param.sampling;
    var updatePosition = $6c21bacc9274e141$var$callbackWrapper($6c21bacc9274e141$var$throttle($6c21bacc9274e141$var$callbackWrapper(function(evt) {
        var target = $6c21bacc9274e141$var$getEventTarget(evt);
        if (!target || $6c21bacc9274e141$var$isBlocked(target, blockClass, blockSelector, true)) return;
        var id = mirror.getId(target);
        if (target === doc && doc.defaultView) {
            var scrollLeftTop = $6c21bacc9274e141$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $6c21bacc9274e141$var$on('scroll', updatePosition, doc);
}
function $6c21bacc9274e141$var$initViewportResizeObserver(param, param1) {
    var viewportResizeCb = param.viewportResizeCb, win = param1.win;
    var lastH = -1;
    var lastW = -1;
    var updateDimension = $6c21bacc9274e141$var$callbackWrapper($6c21bacc9274e141$var$throttle($6c21bacc9274e141$var$callbackWrapper(function() {
        var height = $6c21bacc9274e141$var$getWindowHeight();
        var width = $6c21bacc9274e141$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $6c21bacc9274e141$var$on('resize', updateDimension, win);
}
var $6c21bacc9274e141$var$INPUT_TAGS = [
    'INPUT',
    'TEXTAREA',
    'SELECT'
];
var $6c21bacc9274e141$var$lastInputValueMap = new WeakMap();
function $6c21bacc9274e141$var$initInputObserver(param) {
    var inputCb = param.inputCb, doc = param.doc, mirror = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, ignoreClass = param.ignoreClass, ignoreSelector = param.ignoreSelector, maskInputOptions = param.maskInputOptions, maskInputFn = param.maskInputFn, sampling = param.sampling, userTriggeredOnInput = param.userTriggeredOnInput;
    var _handlers;
    function eventHandler(event) {
        var target = $6c21bacc9274e141$var$getEventTarget(event);
        var userTriggered = event.isTrusted;
        var tagName = target && target.tagName;
        if (target && tagName === 'OPTION') target = target.parentElement;
        if (!target || !tagName || $6c21bacc9274e141$var$INPUT_TAGS.indexOf(tagName) < 0 || $6c21bacc9274e141$var$isBlocked(target, blockClass, blockSelector, true)) return;
        if (target.classList.contains(ignoreClass) || ignoreSelector && target.matches(ignoreSelector)) return;
        var text = target.value;
        var isChecked = false;
        var type = $6c21bacc9274e141$var$getInputType(target) || '';
        if (type === 'radio' || type === 'checkbox') isChecked = target.checked;
        else if (maskInputOptions[tagName.toLowerCase()] || maskInputOptions[type]) text = $6c21bacc9274e141$var$maskInputValue({
            element: target,
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        var name = target.name;
        if (type === 'radio' && name && isChecked) doc.querySelectorAll('input[type="radio"][name="'.concat(name, '"]')).forEach(function(el) {
            if (el !== target) {
                var text = el.value;
                cbWithDedup(el, userTriggeredOnInput ? {
                    text: text,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v) {
        var lastInputValue = $6c21bacc9274e141$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
            $6c21bacc9274e141$var$lastInputValueMap.set(target, v);
            var id = mirror.getId(target);
            $6c21bacc9274e141$var$callbackWrapper(inputCb)(Object.assign(Object.assign({}, v), {
                id: id
            }));
        }
    }
    var events = sampling.input === 'last' ? [
        'change'
    ] : [
        'input',
        'change'
    ];
    var handlers = events.map(function(eventName) {
        return $6c21bacc9274e141$var$on(eventName, $6c21bacc9274e141$var$callbackWrapper(eventHandler), doc);
    });
    var currentWindow = doc.defaultView;
    if (!currentWindow) return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
    var propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, 'value');
    var hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            'value'
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            'checked'
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            'value'
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            'value'
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            'selectedIndex'
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            'selected'
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) (_handlers = handlers).push.apply(_handlers, (0, $dHvbf._)(hookProperties.map(function(p) {
        return $6c21bacc9274e141$var$hookSetter(p[0], p[1], {
            set: function() {
                $6c21bacc9274e141$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow);
    })));
    return $6c21bacc9274e141$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $6c21bacc9274e141$var$getNestedCSSRulePositions(rule) {
    var positions = [];
    function recurse(childRule, pos) {
        if ($6c21bacc9274e141$var$hasNestedCSSRule('CSSGroupingRule') && childRule.parentRule instanceof CSSGroupingRule || $6c21bacc9274e141$var$hasNestedCSSRule('CSSMediaRule') && childRule.parentRule instanceof CSSMediaRule || $6c21bacc9274e141$var$hasNestedCSSRule('CSSSupportsRule') && childRule.parentRule instanceof CSSSupportsRule || $6c21bacc9274e141$var$hasNestedCSSRule('CSSConditionRule') && childRule.parentRule instanceof CSSConditionRule) {
            var rules = Array.from(childRule.parentRule.cssRules);
            var index = rules.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            var rules1 = Array.from(childRule.parentStyleSheet.cssRules);
            var index1 = rules1.indexOf(childRule);
            pos.unshift(index1);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $6c21bacc9274e141$var$getIdAndStyleId(sheet, mirror, styleMirror) {
    var id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $6c21bacc9274e141$var$initStyleSheetObserver(param, param1) {
    var styleSheetRuleCb = param.styleSheetRuleCb, mirror = param.mirror, stylesheetManager = param.stylesheetManager, win = param1.win;
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return function() {};
    var insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $6c21bacc9274e141$var$callbackWrapper(function(target, thisArg, argumentsList) {
            var _argumentsList = (0, $aSMts._)(argumentsList, 2), rule = _argumentsList[0], index = _argumentsList[1];
            var _getIdAndStyleId = $6c21bacc9274e141$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    var deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $6c21bacc9274e141$var$callbackWrapper(function(target, thisArg, argumentsList) {
            var _argumentsList = (0, $aSMts._)(argumentsList, 1), index = _argumentsList[0];
            var _getIdAndStyleId = $6c21bacc9274e141$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    var replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $6c21bacc9274e141$var$callbackWrapper(function(target, thisArg, argumentsList) {
                var _argumentsList = (0, $aSMts._)(argumentsList, 1), text = _argumentsList[0];
                var _getIdAndStyleId = $6c21bacc9274e141$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    var replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $6c21bacc9274e141$var$callbackWrapper(function(target, thisArg, argumentsList) {
                var _argumentsList = (0, $aSMts._)(argumentsList, 1), text = _argumentsList[0];
                var _getIdAndStyleId = $6c21bacc9274e141$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    var supportedNestedCSSRuleTypes = {};
    if ($6c21bacc9274e141$var$canMonkeyPatchNestedCSSRule('CSSGroupingRule')) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($6c21bacc9274e141$var$canMonkeyPatchNestedCSSRule('CSSMediaRule')) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($6c21bacc9274e141$var$canMonkeyPatchNestedCSSRule('CSSConditionRule')) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($6c21bacc9274e141$var$canMonkeyPatchNestedCSSRule('CSSSupportsRule')) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    var unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(function(param) {
        var _param = (0, $aSMts._)(param, 2), typeKey = _param[0], type = _param[1];
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $6c21bacc9274e141$var$callbackWrapper(function(target, thisArg, argumentsList) {
                var _argumentsList = (0, $aSMts._)(argumentsList, 2), rule = _argumentsList[0], index = _argumentsList[1];
                var _getIdAndStyleId = $6c21bacc9274e141$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: (0, $dHvbf._)($6c21bacc9274e141$var$getNestedCSSRulePositions(thisArg)).concat([
                                index || 0
                            ])
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $6c21bacc9274e141$var$callbackWrapper(function(target, thisArg, argumentsList) {
                var _argumentsList = (0, $aSMts._)(argumentsList, 1), index = _argumentsList[0];
                var _getIdAndStyleId = $6c21bacc9274e141$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: (0, $dHvbf._)($6c21bacc9274e141$var$getNestedCSSRulePositions(thisArg)).concat([
                                index
                            ])
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $6c21bacc9274e141$var$callbackWrapper(function() {
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(function(param) {
            var _param = (0, $aSMts._)(param, 2), typeKey = _param[0], type = _param[1];
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $6c21bacc9274e141$var$initAdoptedStyleSheetObserver(param, host) {
    var mirror = param.mirror, stylesheetManager = param.stylesheetManager;
    var _a, _b, _c;
    var hostId = null;
    if (host.nodeName === '#document') hostId = mirror.getId(host);
    else hostId = mirror.getId(host.host);
    var patchTarget = host.nodeName === '#document' ? (_a = host.defaultView) === null || _a === void 0 ? void 0 : _a.Document : (_c = (_b = host.ownerDocument) === null || _b === void 0 ? void 0 : _b.defaultView) === null || _c === void 0 ? void 0 : _c.ShadowRoot;
    var originalPropertyDescriptor = (patchTarget === null || patchTarget === void 0 ? void 0 : patchTarget.prototype) ? Object.getOwnPropertyDescriptor(patchTarget === null || patchTarget === void 0 ? void 0 : patchTarget.prototype, 'adoptedStyleSheets') : undefined;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return function() {};
    Object.defineProperty(host, 'adoptedStyleSheets', {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get: function() {
            var _a;
            return (_a = originalPropertyDescriptor.get) === null || _a === void 0 ? void 0 : _a.call(this);
        },
        set: function(sheets) {
            var _a;
            var result = (_a = originalPropertyDescriptor.set) === null || _a === void 0 ? void 0 : _a.call(this, sheets);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e) {}
            return result;
        }
    });
    return $6c21bacc9274e141$var$callbackWrapper(function() {
        Object.defineProperty(host, 'adoptedStyleSheets', {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            get: originalPropertyDescriptor.get,
            set: originalPropertyDescriptor.set
        });
    });
}
function $6c21bacc9274e141$var$initStyleDeclarationObserver(param, param1) {
    var styleDeclarationCb = param.styleDeclarationCb, mirror = param.mirror, ignoreCSSAttributes = param.ignoreCSSAttributes, stylesheetManager = param.stylesheetManager, win = param1.win;
    var setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $6c21bacc9274e141$var$callbackWrapper(function(target, thisArg, argumentsList) {
            var _a;
            var _argumentsList = (0, $aSMts._)(argumentsList, 3), property = _argumentsList[0], value = _argumentsList[1], priority = _argumentsList[2];
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            var _getIdAndStyleId = $6c21bacc9274e141$var$getIdAndStyleId((_a = thisArg.parentRule) === null || _a === void 0 ? void 0 : _a.parentStyleSheet, mirror, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                index: $6c21bacc9274e141$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    var removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $6c21bacc9274e141$var$callbackWrapper(function(target, thisArg, argumentsList) {
            var _a;
            var _argumentsList = (0, $aSMts._)(argumentsList, 1), property = _argumentsList[0];
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            var _getIdAndStyleId = $6c21bacc9274e141$var$getIdAndStyleId((_a = thisArg.parentRule) === null || _a === void 0 ? void 0 : _a.parentStyleSheet, mirror, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                index: $6c21bacc9274e141$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $6c21bacc9274e141$var$callbackWrapper(function() {
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $6c21bacc9274e141$var$initMediaInteractionObserver(param) {
    var mediaInteractionCb = param.mediaInteractionCb, blockClass = param.blockClass, blockSelector = param.blockSelector, mirror = param.mirror, sampling = param.sampling, doc = param.doc;
    var handler = $6c21bacc9274e141$var$callbackWrapper(function(type) {
        return $6c21bacc9274e141$var$throttle($6c21bacc9274e141$var$callbackWrapper(function(event) {
            var target = $6c21bacc9274e141$var$getEventTarget(event);
            if (!target || $6c21bacc9274e141$var$isBlocked(target, blockClass, blockSelector, true)) return;
            var currentTime = target.currentTime, volume = target.volume, muted = target.muted, playbackRate = target.playbackRate, loop = target.loop;
            mediaInteractionCb({
                type: type,
                id: mirror.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate,
                loop: loop
            });
        }), sampling.media || 500);
    });
    var handlers = [
        $6c21bacc9274e141$var$on('play', handler(0), doc),
        $6c21bacc9274e141$var$on('pause', handler(1), doc),
        $6c21bacc9274e141$var$on('seeked', handler(2), doc),
        $6c21bacc9274e141$var$on('volumechange', handler(3), doc),
        $6c21bacc9274e141$var$on('ratechange', handler(4), doc)
    ];
    return $6c21bacc9274e141$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $6c21bacc9274e141$var$initFontObserver(param) {
    var fontCb = param.fontCb, doc = param.doc;
    var win = doc.defaultView;
    if (!win) return function() {};
    var handlers = [];
    var fontMap = new WeakMap();
    var originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        var fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== 'string',
            descriptors: descriptors,
            fontSource: typeof source === 'string' ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    var restoreHandler = $6c21bacc9274e141$var$patch(doc.fonts, 'add', function(original) {
        return function(fontFace) {
            setTimeout($6c21bacc9274e141$var$callbackWrapper(function() {
                var p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap["delete"](fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(function() {
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $6c21bacc9274e141$var$callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function $6c21bacc9274e141$var$initSelectionObserver(param) {
    var doc = param.doc, mirror = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, selectionCb = param.selectionCb;
    var collapsed = true;
    var updateSelection = $6c21bacc9274e141$var$callbackWrapper(function() {
        var selection = doc.getSelection();
        if (!selection || collapsed && (selection === null || selection === void 0 ? void 0 : selection.isCollapsed)) return;
        collapsed = selection.isCollapsed || false;
        var ranges = [];
        var count = selection.rangeCount || 0;
        for(var i = 0; i < count; i++){
            var range = selection.getRangeAt(i);
            var startContainer = range.startContainer, startOffset = range.startOffset, endContainer = range.endContainer, endOffset = range.endOffset;
            var blocked = $6c21bacc9274e141$var$isBlocked(startContainer, blockClass, blockSelector, true) || $6c21bacc9274e141$var$isBlocked(endContainer, blockClass, blockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror.getId(startContainer),
                startOffset: startOffset,
                end: mirror.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $6c21bacc9274e141$var$on('selectionchange', updateSelection);
}
function $6c21bacc9274e141$var$initCustomElementObserver(param) {
    var doc = param.doc, customElementCb = param.customElementCb;
    var win = doc.defaultView;
    if (!win || !win.customElements) return function() {};
    var restoreHandler = $6c21bacc9274e141$var$patch(win.customElements, 'define', function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e) {
                console.warn("Custom element callback failed for ".concat(name));
            }
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $6c21bacc9274e141$var$mergeHooks(o, hooks) {
    var mutationCb = o.mutationCb, mousemoveCb = o.mousemoveCb, mouseInteractionCb = o.mouseInteractionCb, scrollCb = o.scrollCb, viewportResizeCb = o.viewportResizeCb, inputCb = o.inputCb, mediaInteractionCb = o.mediaInteractionCb, styleSheetRuleCb = o.styleSheetRuleCb, styleDeclarationCb = o.styleDeclarationCb, canvasMutationCb = o.canvasMutationCb, fontCb = o.fontCb, selectionCb = o.selectionCb, customElementCb = o.customElementCb;
    o.mutationCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++){
            p[_key] = arguments[_key];
        }
        var _hooks;
        if (hooks.mutation) (_hooks = hooks).mutation.apply(_hooks, (0, $dHvbf._)(p));
        mutationCb.apply(void 0, (0, $dHvbf._)(p));
    };
    o.mousemoveCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++){
            p[_key] = arguments[_key];
        }
        var _hooks;
        if (hooks.mousemove) (_hooks = hooks).mousemove.apply(_hooks, (0, $dHvbf._)(p));
        mousemoveCb.apply(void 0, (0, $dHvbf._)(p));
    };
    o.mouseInteractionCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++){
            p[_key] = arguments[_key];
        }
        var _hooks;
        if (hooks.mouseInteraction) (_hooks = hooks).mouseInteraction.apply(_hooks, (0, $dHvbf._)(p));
        mouseInteractionCb.apply(void 0, (0, $dHvbf._)(p));
    };
    o.scrollCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++){
            p[_key] = arguments[_key];
        }
        var _hooks;
        if (hooks.scroll) (_hooks = hooks).scroll.apply(_hooks, (0, $dHvbf._)(p));
        scrollCb.apply(void 0, (0, $dHvbf._)(p));
    };
    o.viewportResizeCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++){
            p[_key] = arguments[_key];
        }
        var _hooks;
        if (hooks.viewportResize) (_hooks = hooks).viewportResize.apply(_hooks, (0, $dHvbf._)(p));
        viewportResizeCb.apply(void 0, (0, $dHvbf._)(p));
    };
    o.inputCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++){
            p[_key] = arguments[_key];
        }
        var _hooks;
        if (hooks.input) (_hooks = hooks).input.apply(_hooks, (0, $dHvbf._)(p));
        inputCb.apply(void 0, (0, $dHvbf._)(p));
    };
    o.mediaInteractionCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++){
            p[_key] = arguments[_key];
        }
        var _hooks;
        if (hooks.mediaInteaction) (_hooks = hooks).mediaInteaction.apply(_hooks, (0, $dHvbf._)(p));
        mediaInteractionCb.apply(void 0, (0, $dHvbf._)(p));
    };
    o.styleSheetRuleCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++){
            p[_key] = arguments[_key];
        }
        var _hooks;
        if (hooks.styleSheetRule) (_hooks = hooks).styleSheetRule.apply(_hooks, (0, $dHvbf._)(p));
        styleSheetRuleCb.apply(void 0, (0, $dHvbf._)(p));
    };
    o.styleDeclarationCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++){
            p[_key] = arguments[_key];
        }
        var _hooks;
        if (hooks.styleDeclaration) (_hooks = hooks).styleDeclaration.apply(_hooks, (0, $dHvbf._)(p));
        styleDeclarationCb.apply(void 0, (0, $dHvbf._)(p));
    };
    o.canvasMutationCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++){
            p[_key] = arguments[_key];
        }
        var _hooks;
        if (hooks.canvasMutation) (_hooks = hooks).canvasMutation.apply(_hooks, (0, $dHvbf._)(p));
        canvasMutationCb.apply(void 0, (0, $dHvbf._)(p));
    };
    o.fontCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++){
            p[_key] = arguments[_key];
        }
        var _hooks;
        if (hooks.font) (_hooks = hooks).font.apply(_hooks, (0, $dHvbf._)(p));
        fontCb.apply(void 0, (0, $dHvbf._)(p));
    };
    o.selectionCb = function() {
        for(var _len = arguments.length, p = new Array(_len), _key = 0; _key < _len; _key++){
            p[_key] = arguments[_key];
        }
        var _hooks;
        if (hooks.selection) (_hooks = hooks).selection.apply(_hooks, (0, $dHvbf._)(p));
        selectionCb.apply(void 0, (0, $dHvbf._)(p));
    };
    o.customElementCb = function() {
        for(var _len = arguments.length, c = new Array(_len), _key = 0; _key < _len; _key++){
            c[_key] = arguments[_key];
        }
        var _hooks;
        if (hooks.customElement) (_hooks = hooks).customElement.apply(_hooks, (0, $dHvbf._)(c));
        customElementCb.apply(void 0, (0, $dHvbf._)(c));
    };
}
function $6c21bacc9274e141$var$initObservers(o) {
    var hooks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var currentWindow = o.doc.defaultView;
    if (!currentWindow) return function() {};
    $6c21bacc9274e141$var$mergeHooks(o, hooks);
    var mutationObserver;
    if (o.recordDOM) mutationObserver = $6c21bacc9274e141$var$initMutationObserver(o, o.doc);
    var mousemoveHandler = $6c21bacc9274e141$var$initMoveObserver(o);
    var mouseInteractionHandler = $6c21bacc9274e141$var$initMouseInteractionObserver(o);
    var scrollHandler = $6c21bacc9274e141$var$initScrollObserver(o);
    var viewportResizeHandler = $6c21bacc9274e141$var$initViewportResizeObserver(o, {
        win: currentWindow
    });
    var inputHandler = $6c21bacc9274e141$var$initInputObserver(o);
    var mediaInteractionHandler = $6c21bacc9274e141$var$initMediaInteractionObserver(o);
    var styleSheetObserver = function() {};
    var adoptedStyleSheetObserver = function() {};
    var styleDeclarationObserver = function() {};
    var fontObserver = function() {};
    if (o.recordDOM) {
        styleSheetObserver = $6c21bacc9274e141$var$initStyleSheetObserver(o, {
            win: currentWindow
        });
        adoptedStyleSheetObserver = $6c21bacc9274e141$var$initAdoptedStyleSheetObserver(o, o.doc);
        styleDeclarationObserver = $6c21bacc9274e141$var$initStyleDeclarationObserver(o, {
            win: currentWindow
        });
        if (o.collectFonts) fontObserver = $6c21bacc9274e141$var$initFontObserver(o);
    }
    var selectionObserver = $6c21bacc9274e141$var$initSelectionObserver(o);
    var customElementObserver = $6c21bacc9274e141$var$initCustomElementObserver(o);
    var pluginHandlers = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = o.plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var plugin = _step.value;
            pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return $6c21bacc9274e141$var$callbackWrapper(function() {
        $6c21bacc9274e141$var$mutationBuffers.forEach(function(b) {
            return b.reset();
        });
        mutationObserver === null || mutationObserver === void 0 || mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach(function(h) {
            return h();
        });
    });
}
function $6c21bacc9274e141$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== 'undefined';
}
function $6c21bacc9274e141$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== 'undefined' && window[prop].prototype && 'insertRule' in window[prop].prototype && 'deleteRule' in window[prop].prototype);
}
var $6c21bacc9274e141$var$CrossOriginIframeMirror = /*#__PURE__*/ function() {
    "use strict";
    function CrossOriginIframeMirror(generateIdFn) {
        (0, $50OuQ._)(this, CrossOriginIframeMirror);
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = new WeakMap();
        this.iframeRemoteIdToIdMap = new WeakMap();
    }
    (0, $fGdZr._)(CrossOriginIframeMirror, [
        {
            key: "getId",
            value: function getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
                var idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
                var remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
                var id = idToRemoteIdMap.get(remoteId);
                if (!id) {
                    id = this.generateIdFn();
                    idToRemoteIdMap.set(remoteId, id);
                    remoteIdToIdMap.set(id, remoteId);
                }
                return id;
            }
        },
        {
            key: "getIds",
            value: function getIds(iframe, remoteId) {
                var _this = this;
                var idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
                var remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
                return remoteId.map(function(id) {
                    return _this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap);
                });
            }
        },
        {
            key: "getRemoteId",
            value: function getRemoteId(iframe, id, map) {
                var remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
                if (typeof id !== 'number') return id;
                var remoteId = remoteIdToIdMap.get(id);
                if (!remoteId) return -1;
                return remoteId;
            }
        },
        {
            key: "getRemoteIds",
            value: function getRemoteIds(iframe, ids) {
                var _this = this;
                var remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
                return ids.map(function(id) {
                    return _this.getRemoteId(iframe, id, remoteIdToIdMap);
                });
            }
        },
        {
            key: "reset",
            value: function reset(iframe) {
                if (!iframe) {
                    this.iframeIdToRemoteIdMap = new WeakMap();
                    this.iframeRemoteIdToIdMap = new WeakMap();
                    return;
                }
                this.iframeIdToRemoteIdMap["delete"](iframe);
                this.iframeRemoteIdToIdMap["delete"](iframe);
            }
        },
        {
            key: "getIdToRemoteIdMap",
            value: function getIdToRemoteIdMap(iframe) {
                var idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
                if (!idToRemoteIdMap) {
                    idToRemoteIdMap = new Map();
                    this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
                }
                return idToRemoteIdMap;
            }
        },
        {
            key: "getRemoteIdToIdMap",
            value: function getRemoteIdToIdMap(iframe) {
                var remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
                if (!remoteIdToIdMap) {
                    remoteIdToIdMap = new Map();
                    this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
                }
                return remoteIdToIdMap;
            }
        }
    ]);
    return CrossOriginIframeMirror;
}();
var $6c21bacc9274e141$var$IframeManager = /*#__PURE__*/ function() {
    "use strict";
    function IframeManager(options) {
        (0, $50OuQ._)(this, IframeManager);
        this.iframes = new WeakMap();
        this.crossOriginIframeMap = new WeakMap();
        this.crossOriginIframeMirror = new $6c21bacc9274e141$var$CrossOriginIframeMirror($6c21bacc9274e141$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $6c21bacc9274e141$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener('message', this.handleMessage.bind(this));
    }
    (0, $fGdZr._)(IframeManager, [
        {
            key: "addIframe",
            value: function addIframe(iframeEl) {
                this.iframes.set(iframeEl, true);
                if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
            }
        },
        {
            key: "addLoadListener",
            value: function addLoadListener(cb) {
                this.loadListener = cb;
            }
        },
        {
            key: "attachIframe",
            value: function attachIframe(iframeEl, childSn) {
                var _a;
                this.mutationCb({
                    adds: [
                        {
                            parentId: this.mirror.getId(iframeEl),
                            nextId: null,
                            node: childSn
                        }
                    ],
                    removes: [],
                    texts: [],
                    attributes: [],
                    isAttachIframe: true
                });
                (_a = this.loadListener) === null || _a === void 0 || _a.call(this, iframeEl);
                if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
            }
        },
        {
            key: "handleMessage",
            value: function handleMessage(message) {
                var crossOriginMessageEvent = message;
                if (crossOriginMessageEvent.data.type !== 'rrweb' || crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
                var iframeSourceWindow = message.source;
                if (!iframeSourceWindow) return;
                var iframeEl = this.crossOriginIframeMap.get(message.source);
                if (!iframeEl) return;
                var transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
                if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
            }
        },
        {
            key: "transformCrossOriginEvent",
            value: function transformCrossOriginEvent(iframeEl, e) {
                var _this = this;
                var _a;
                switch(e.type){
                    case $6c21bacc9274e141$var$EventType$1.FullSnapshot:
                        {
                            this.crossOriginIframeMirror.reset(iframeEl);
                            this.crossOriginIframeStyleMirror.reset(iframeEl);
                            this.replaceIdOnNode(e.data.node, iframeEl);
                            var rootId = e.data.node.id;
                            this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                            this.patchRootIdOnNode(e.data.node, rootId);
                            return {
                                timestamp: e.timestamp,
                                type: $6c21bacc9274e141$var$EventType$1.IncrementalSnapshot,
                                data: {
                                    source: $6c21bacc9274e141$var$IncrementalSource$1.Mutation,
                                    adds: [
                                        {
                                            parentId: this.mirror.getId(iframeEl),
                                            nextId: null,
                                            node: e.data.node
                                        }
                                    ],
                                    removes: [],
                                    texts: [],
                                    attributes: [],
                                    isAttachIframe: true
                                }
                            };
                        }
                    case $6c21bacc9274e141$var$EventType$1.Meta:
                    case $6c21bacc9274e141$var$EventType$1.Load:
                    case $6c21bacc9274e141$var$EventType$1.DomContentLoaded:
                        return false;
                    case $6c21bacc9274e141$var$EventType$1.Plugin:
                        return e;
                    case $6c21bacc9274e141$var$EventType$1.Custom:
                        this.replaceIds(e.data.payload, iframeEl, [
                            'id',
                            'parentId',
                            'previousId',
                            'nextId'
                        ]);
                        return e;
                    case $6c21bacc9274e141$var$EventType$1.IncrementalSnapshot:
                        switch(e.data.source){
                            case $6c21bacc9274e141$var$IncrementalSource$1.Mutation:
                                e.data.adds.forEach(function(n) {
                                    _this.replaceIds(n, iframeEl, [
                                        'parentId',
                                        'nextId',
                                        'previousId'
                                    ]);
                                    _this.replaceIdOnNode(n.node, iframeEl);
                                    var rootId = _this.crossOriginIframeRootIdMap.get(iframeEl);
                                    rootId && _this.patchRootIdOnNode(n.node, rootId);
                                });
                                e.data.removes.forEach(function(n) {
                                    _this.replaceIds(n, iframeEl, [
                                        'parentId',
                                        'id'
                                    ]);
                                });
                                e.data.attributes.forEach(function(n) {
                                    _this.replaceIds(n, iframeEl, [
                                        'id'
                                    ]);
                                });
                                e.data.texts.forEach(function(n) {
                                    _this.replaceIds(n, iframeEl, [
                                        'id'
                                    ]);
                                });
                                return e;
                            case $6c21bacc9274e141$var$IncrementalSource$1.Drag:
                            case $6c21bacc9274e141$var$IncrementalSource$1.TouchMove:
                            case $6c21bacc9274e141$var$IncrementalSource$1.MouseMove:
                                e.data.positions.forEach(function(p) {
                                    _this.replaceIds(p, iframeEl, [
                                        'id'
                                    ]);
                                });
                                return e;
                            case $6c21bacc9274e141$var$IncrementalSource$1.ViewportResize:
                                return false;
                            case $6c21bacc9274e141$var$IncrementalSource$1.MediaInteraction:
                            case $6c21bacc9274e141$var$IncrementalSource$1.MouseInteraction:
                            case $6c21bacc9274e141$var$IncrementalSource$1.Scroll:
                            case $6c21bacc9274e141$var$IncrementalSource$1.CanvasMutation:
                            case $6c21bacc9274e141$var$IncrementalSource$1.Input:
                                this.replaceIds(e.data, iframeEl, [
                                    'id'
                                ]);
                                return e;
                            case $6c21bacc9274e141$var$IncrementalSource$1.StyleSheetRule:
                            case $6c21bacc9274e141$var$IncrementalSource$1.StyleDeclaration:
                                this.replaceIds(e.data, iframeEl, [
                                    'id'
                                ]);
                                this.replaceStyleIds(e.data, iframeEl, [
                                    'styleId'
                                ]);
                                return e;
                            case $6c21bacc9274e141$var$IncrementalSource$1.Font:
                                return e;
                            case $6c21bacc9274e141$var$IncrementalSource$1.Selection:
                                e.data.ranges.forEach(function(range) {
                                    _this.replaceIds(range, iframeEl, [
                                        'start',
                                        'end'
                                    ]);
                                });
                                return e;
                            case $6c21bacc9274e141$var$IncrementalSource$1.AdoptedStyleSheet:
                                this.replaceIds(e.data, iframeEl, [
                                    'id'
                                ]);
                                this.replaceStyleIds(e.data, iframeEl, [
                                    'styleIds'
                                ]);
                                (_a = e.data.styles) === null || _a === void 0 || _a.forEach(function(style) {
                                    _this.replaceStyleIds(style, iframeEl, [
                                        'styleId'
                                    ]);
                                });
                                return e;
                        }
                }
                return false;
            }
        },
        {
            key: "replace",
            value: function replace(iframeMirror, obj, iframeEl, keys) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (!Array.isArray(obj[key]) && typeof obj[key] !== 'number') continue;
                        if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
                        else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return obj;
            }
        },
        {
            key: "replaceIds",
            value: function replaceIds(obj, iframeEl, keys) {
                return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
            }
        },
        {
            key: "replaceStyleIds",
            value: function replaceStyleIds(obj, iframeEl, keys) {
                return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
            }
        },
        {
            key: "replaceIdOnNode",
            value: function replaceIdOnNode(node, iframeEl) {
                var _this = this;
                this.replaceIds(node, iframeEl, [
                    'id',
                    'rootId'
                ]);
                if ('childNodes' in node) node.childNodes.forEach(function(child) {
                    _this.replaceIdOnNode(child, iframeEl);
                });
            }
        },
        {
            key: "patchRootIdOnNode",
            value: function patchRootIdOnNode(node, rootId) {
                var _this = this;
                if (node.type !== $6c21bacc9274e141$var$NodeType.Document && !node.rootId) node.rootId = rootId;
                if ('childNodes' in node) node.childNodes.forEach(function(child) {
                    _this.patchRootIdOnNode(child, rootId);
                });
            }
        }
    ]);
    return IframeManager;
}();
var $6c21bacc9274e141$var$ShadowDomManager = /*#__PURE__*/ function() {
    "use strict";
    function ShadowDomManager(options) {
        (0, $50OuQ._)(this, ShadowDomManager);
        this.shadowDoms = new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    (0, $fGdZr._)(ShadowDomManager, [
        {
            key: "init",
            value: function init() {
                this.reset();
                this.patchAttachShadow(Element, document);
            }
        },
        {
            key: "addShadowRoot",
            value: function addShadowRoot(shadowRoot, doc) {
                var _this = this;
                if (!$6c21bacc9274e141$var$isNativeShadowDom(shadowRoot)) return;
                if (this.shadowDoms.has(shadowRoot)) return;
                this.shadowDoms.add(shadowRoot);
                var observer = $6c21bacc9274e141$var$initMutationObserver(Object.assign(Object.assign({}, this.bypassOptions), {
                    doc: doc,
                    mutationCb: this.mutationCb,
                    mirror: this.mirror,
                    shadowDomManager: this
                }), shadowRoot);
                this.restoreHandlers.push(function() {
                    return observer.disconnect();
                });
                this.restoreHandlers.push($6c21bacc9274e141$var$initScrollObserver(Object.assign(Object.assign({}, this.bypassOptions), {
                    scrollCb: this.scrollCb,
                    doc: shadowRoot,
                    mirror: this.mirror
                })));
                setTimeout(function() {
                    if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) _this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, _this.mirror.getId(shadowRoot.host));
                    _this.restoreHandlers.push($6c21bacc9274e141$var$initAdoptedStyleSheetObserver({
                        mirror: _this.mirror,
                        stylesheetManager: _this.bypassOptions.stylesheetManager
                    }, shadowRoot));
                }, 0);
            }
        },
        {
            key: "observeAttachShadow",
            value: function observeAttachShadow(iframeElement) {
                if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
                this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
            }
        },
        {
            key: "patchAttachShadow",
            value: function patchAttachShadow(element, doc) {
                var manager = this;
                this.restoreHandlers.push($6c21bacc9274e141$var$patch(element.prototype, 'attachShadow', function(original) {
                    return function(option) {
                        var shadowRoot = original.call(this, option);
                        if (this.shadowRoot && $6c21bacc9274e141$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                        return shadowRoot;
                    };
                }));
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.restoreHandlers.forEach(function(handler) {
                    try {
                        handler();
                    } catch (e) {}
                });
                this.restoreHandlers = [];
                this.shadowDoms = new WeakSet();
            }
        }
    ]);
    return ShadowDomManager;
}();
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $6c21bacc9274e141$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $6c21bacc9274e141$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
/*
 * base64-arraybuffer 1.0.1 <https://github.com/niklasvh/base64-arraybuffer>
 * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ var $6c21bacc9274e141$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var $6c21bacc9274e141$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(var $6c21bacc9274e141$var$i = 0; $6c21bacc9274e141$var$i < $6c21bacc9274e141$var$chars.length; $6c21bacc9274e141$var$i++)$6c21bacc9274e141$var$lookup[$6c21bacc9274e141$var$chars.charCodeAt($6c21bacc9274e141$var$i)] = $6c21bacc9274e141$var$i;
var $6c21bacc9274e141$var$encode = function encode(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += $6c21bacc9274e141$var$chars[bytes[i] >> 2];
        base64 += $6c21bacc9274e141$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $6c21bacc9274e141$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $6c21bacc9274e141$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
var $6c21bacc9274e141$var$canvasVarMap = new Map();
function $6c21bacc9274e141$var$variableListFor(ctx, ctor) {
    var contextMap = $6c21bacc9274e141$var$canvasVarMap.get(ctx);
    if (!contextMap) {
        contextMap = new Map();
        $6c21bacc9274e141$var$canvasVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) contextMap.set(ctor, []);
    return contextMap.get(ctor);
}
var $6c21bacc9274e141$var$saveWebGLVar = function(value, win, ctx) {
    if (!value || !($6c21bacc9274e141$var$isInstanceOfWebGLObject(value, win) || (typeof value === "undefined" ? "undefined" : (0, $qb7pP._)(value)) === 'object')) return;
    var name = value.constructor.name;
    var list = $6c21bacc9274e141$var$variableListFor(ctx, name);
    var index = list.indexOf(value);
    if (index === -1) {
        index = list.length;
        list.push(value);
    }
    return index;
};
function $6c21bacc9274e141$var$serializeArg(value, win, ctx) {
    if (value instanceof Array) return value.map(function(arg) {
        return $6c21bacc9274e141$var$serializeArg(arg, win, ctx);
    });
    else if (value === null) return value;
    else if (value instanceof Float32Array || value instanceof Float64Array || value instanceof Int32Array || value instanceof Uint32Array || value instanceof Uint8Array || value instanceof Uint16Array || value instanceof Int16Array || value instanceof Int8Array || value instanceof Uint8ClampedArray) {
        var name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                Object.values(value)
            ]
        };
    } else if (value instanceof ArrayBuffer) {
        var name1 = value.constructor.name;
        var base64 = $6c21bacc9274e141$var$encode(value);
        return {
            rr_type: name1,
            base64: base64
        };
    } else if (value instanceof DataView) {
        var name2 = value.constructor.name;
        return {
            rr_type: name2,
            args: [
                $6c21bacc9274e141$var$serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength
            ]
        };
    } else if (value instanceof HTMLImageElement) {
        var name3 = value.constructor.name;
        var src = value.src;
        return {
            rr_type: name3,
            src: src
        };
    } else if (value instanceof HTMLCanvasElement) {
        var name4 = 'HTMLImageElement';
        var src1 = value.toDataURL();
        return {
            rr_type: name4,
            src: src1
        };
    } else if (value instanceof ImageData) {
        var name5 = value.constructor.name;
        return {
            rr_type: name5,
            args: [
                $6c21bacc9274e141$var$serializeArg(value.data, win, ctx),
                value.width,
                value.height
            ]
        };
    } else if ($6c21bacc9274e141$var$isInstanceOfWebGLObject(value, win) || (typeof value === "undefined" ? "undefined" : (0, $qb7pP._)(value)) === 'object') {
        var name6 = value.constructor.name;
        var index = $6c21bacc9274e141$var$saveWebGLVar(value, win, ctx);
        return {
            rr_type: name6,
            index: index
        };
    }
    return value;
}
var $6c21bacc9274e141$var$serializeArgs = function(args, win, ctx) {
    return args.map(function(arg) {
        return $6c21bacc9274e141$var$serializeArg(arg, win, ctx);
    });
};
var $6c21bacc9274e141$var$isInstanceOfWebGLObject = function(value, win) {
    var webGLConstructorNames = [
        'WebGLActiveInfo',
        'WebGLBuffer',
        'WebGLFramebuffer',
        'WebGLProgram',
        'WebGLRenderbuffer',
        'WebGLShader',
        'WebGLShaderPrecisionFormat',
        'WebGLTexture',
        'WebGLUniformLocation',
        'WebGLVertexArrayObject',
        'WebGLVertexArrayObjectOES'
    ];
    var supportedWebGLConstructorNames = webGLConstructorNames.filter(function(name) {
        return typeof win[name] === 'function';
    });
    return Boolean(supportedWebGLConstructorNames.find(function(name) {
        return value instanceof win[name];
    }));
};
function $6c21bacc9274e141$var$initCanvas2DMutationObserver(cb, win, blockClass, blockSelector) {
    var handlers = [];
    var props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var prop = _step.value;
            try {
                if (typeof win.CanvasRenderingContext2D.prototype[prop] !== 'function') return "continue";
                var restoreHandler = $6c21bacc9274e141$var$patch(win.CanvasRenderingContext2D.prototype, prop, function(original) {
                    return function() {
                        var _this = this;
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        if (!$6c21bacc9274e141$var$isBlocked(this.canvas, blockClass, blockSelector, true)) setTimeout(function() {
                            var recordArgs = $6c21bacc9274e141$var$serializeArgs(args, win, _this);
                            cb(_this.canvas, {
                                type: $6c21bacc9274e141$var$CanvasContext['2D'],
                                property: prop,
                                args: recordArgs
                            });
                        }, 0);
                        return original.apply(this, args);
                    };
                });
                handlers.push(restoreHandler);
            } catch (_a) {
                var hookHandler = $6c21bacc9274e141$var$hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
                    set: function(v) {
                        cb(this.canvas, {
                            type: $6c21bacc9274e141$var$CanvasContext['2D'],
                            property: prop,
                            args: [
                                v
                            ],
                            setter: true
                        });
                    }
                });
                handlers.push(hookHandler);
            }
        };
        for(var _iterator = props2D[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
function $6c21bacc9274e141$var$getNormalizedContextName(contextType) {
    return contextType === 'experimental-webgl' ? 'webgl' : contextType;
}
function $6c21bacc9274e141$var$initCanvasContextObserver(win, blockClass, blockSelector, setPreserveDrawingBufferToTrue) {
    var handlers = [];
    try {
        var restoreHandler = $6c21bacc9274e141$var$patch(win.HTMLCanvasElement.prototype, 'getContext', function(original) {
            return function(contextType) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (!$6c21bacc9274e141$var$isBlocked(this, blockClass, blockSelector, true)) {
                    var ctxName = $6c21bacc9274e141$var$getNormalizedContextName(contextType);
                    if (!('__context' in this)) this.__context = ctxName;
                    if (setPreserveDrawingBufferToTrue && [
                        'webgl',
                        'webgl2'
                    ].includes(ctxName)) {
                        if (args[0] && (0, $qb7pP._)(args[0]) === 'object') {
                            var contextAttributes = args[0];
                            if (!contextAttributes.preserveDrawingBuffer) contextAttributes.preserveDrawingBuffer = true;
                        } else args.splice(0, 1, {
                            preserveDrawingBuffer: true
                        });
                    }
                }
                return original.apply(this, [
                    contextType
                ].concat((0, $dHvbf._)(args)));
            };
        });
        handlers.push(restoreHandler);
    } catch (_a) {
        console.error('failed to patch HTMLCanvasElement.prototype.getContext');
    }
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
function $6c21bacc9274e141$var$patchGLPrototype(prototype, type, cb, blockClass, blockSelector, mirror, win) {
    var handlers = [];
    var props = Object.getOwnPropertyNames(prototype);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var prop = _step.value;
            if ([
                'isContextLost',
                'canvas',
                'drawingBufferWidth',
                'drawingBufferHeight'
            ].includes(prop)) return "continue";
            try {
                if (typeof prototype[prop] !== 'function') return "continue";
                var restoreHandler = $6c21bacc9274e141$var$patch(prototype, prop, function(original) {
                    return function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        var result = original.apply(this, args);
                        $6c21bacc9274e141$var$saveWebGLVar(result, win, this);
                        if ('tagName' in this.canvas && !$6c21bacc9274e141$var$isBlocked(this.canvas, blockClass, blockSelector, true)) {
                            var recordArgs = $6c21bacc9274e141$var$serializeArgs(args, win, this);
                            var mutation = {
                                type: type,
                                property: prop,
                                args: recordArgs
                            };
                            cb(this.canvas, mutation);
                        }
                        return result;
                    };
                });
                handlers.push(restoreHandler);
            } catch (_a) {
                var hookHandler = $6c21bacc9274e141$var$hookSetter(prototype, prop, {
                    set: function(v) {
                        cb(this.canvas, {
                            type: type,
                            property: prop,
                            args: [
                                v
                            ],
                            setter: true
                        });
                    }
                });
                handlers.push(hookHandler);
            }
        };
        for(var _iterator = props[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return handlers;
}
function $6c21bacc9274e141$var$initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector, mirror) {
    var _handlers, _handlers1;
    var handlers = [];
    (_handlers = handlers).push.apply(_handlers, (0, $dHvbf._)($6c21bacc9274e141$var$patchGLPrototype(win.WebGLRenderingContext.prototype, $6c21bacc9274e141$var$CanvasContext.WebGL, cb, blockClass, blockSelector, mirror, win)));
    if (typeof win.WebGL2RenderingContext !== 'undefined') (_handlers1 = handlers).push.apply(_handlers1, (0, $dHvbf._)($6c21bacc9274e141$var$patchGLPrototype(win.WebGL2RenderingContext.prototype, $6c21bacc9274e141$var$CanvasContext.WebGL2, cb, blockClass, blockSelector, mirror, win)));
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
function $6c21bacc9274e141$var$funcToSource(fn, sourcemapArg) {
    var sourcemap = sourcemapArg === undefined ? null : sourcemapArg;
    var source = fn.toString();
    var lines = source.split('\n');
    lines.pop();
    lines.shift();
    var blankPrefixLength = lines[0].search(/\S/);
    var regex = /(['"])__worker_loader_strict__(['"])/g;
    for(var i = 0, n = lines.length; i < n; ++i)lines[i] = lines[i].substring(blankPrefixLength).replace(regex, '$1use strict$2') + '\n';
    if (sourcemap) lines.push('\/\/# sourceMappingURL=' + sourcemap + '\n');
    return lines;
}
function $6c21bacc9274e141$var$createURL(fn, sourcemapArg) {
    var lines = $6c21bacc9274e141$var$funcToSource(fn, sourcemapArg);
    var blob = new Blob(lines, {
        type: 'application/javascript'
    });
    return URL.createObjectURL(blob);
}
function $6c21bacc9274e141$var$createInlineWorkerFactory(fn, sourcemapArg) {
    var url;
    return function WorkerFactory(options) {
        url = url || $6c21bacc9274e141$var$createURL(fn, sourcemapArg);
        return new Worker(url, options);
    };
}
var $6c21bacc9274e141$var$WorkerFactory = $6c21bacc9274e141$var$createInlineWorkerFactory(/* rollup-plugin-web-worker-loader */ function() {
    (function() {
        '__worker_loader_strict__';
        /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ function __awaiter(thisArg, _arguments, P, generator) {
            function adopt(value) {
                return value instanceof P ? value : new P(function(resolve) {
                    resolve(value);
                });
            }
            return new (P || (P = Promise))(function(resolve, reject) {
                function fulfilled(value) {
                    try {
                        step(generator.next(value));
                    } catch (e) {
                        reject(e);
                    }
                }
                function rejected(value) {
                    try {
                        step(generator["throw"](value));
                    } catch (e) {
                        reject(e);
                    }
                }
                function step(result) {
                    result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                }
                step((generator = generator.apply(thisArg, _arguments || [])).next());
            });
        }
        /*
     * base64-arraybuffer 1.0.1 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
        // Use a lookup table to find the index.
        var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
        for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
        var encode = function encode(arraybuffer) {
            var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
            for(i = 0; i < len; i += 3){
                base64 += chars[bytes[i] >> 2];
                base64 += chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
                base64 += chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
                base64 += chars[bytes[i + 2] & 63];
            }
            if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
            else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
            return base64;
        };
        var lastBlobMap = new Map();
        var transparentBlobMap = new Map();
        function getTransparentBlobFor(width, height, dataURLOptions) {
            return __awaiter(this, void 0, void 0, function() {
                var id, offscreen, blob, arrayBuffer, base64;
                return (0, $1XfpH.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            id = "".concat(width, "-").concat(height);
                            if (!('OffscreenCanvas' in globalThis)) return [
                                3,
                                3
                            ];
                            if (transparentBlobMap.has(id)) return [
                                2,
                                transparentBlobMap.get(id)
                            ];
                            offscreen = new OffscreenCanvas(width, height);
                            offscreen.getContext('2d');
                            return [
                                4,
                                offscreen.convertToBlob(dataURLOptions)
                            ];
                        case 1:
                            blob = _state.sent();
                            return [
                                4,
                                blob.arrayBuffer()
                            ];
                        case 2:
                            arrayBuffer = _state.sent();
                            base64 = encode(arrayBuffer);
                            transparentBlobMap.set(id, base64);
                            return [
                                2,
                                base64
                            ];
                        case 3:
                            return [
                                2,
                                ''
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
        }
        var worker = self;
        worker.onmessage = function(e) {
            return __awaiter(this, void 0, void 0, function() {
                var _e_data, id, bitmap, width, height, dataURLOptions, transparentBase64, offscreen, ctx, blob, type, arrayBuffer, base64, _tmp;
                return (0, $1XfpH.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!('OffscreenCanvas' in globalThis)) return [
                                3,
                                5
                            ];
                            _e_data = e.data, id = _e_data.id, bitmap = _e_data.bitmap, width = _e_data.width, height = _e_data.height, dataURLOptions = _e_data.dataURLOptions;
                            transparentBase64 = getTransparentBlobFor(width, height, dataURLOptions);
                            offscreen = new OffscreenCanvas(width, height);
                            ctx = offscreen.getContext('2d');
                            ctx.drawImage(bitmap, 0, 0);
                            bitmap.close();
                            return [
                                4,
                                offscreen.convertToBlob(dataURLOptions)
                            ];
                        case 1:
                            blob = _state.sent();
                            type = blob.type;
                            return [
                                4,
                                blob.arrayBuffer()
                            ];
                        case 2:
                            arrayBuffer = _state.sent();
                            base64 = encode(arrayBuffer);
                            _tmp = !lastBlobMap.has(id);
                            if (!_tmp) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                transparentBase64
                            ];
                        case 3:
                            _tmp = _state.sent() === base64;
                            _state.label = 4;
                        case 4:
                            if (_tmp) {
                                lastBlobMap.set(id, base64);
                                return [
                                    2,
                                    worker.postMessage({
                                        id: id
                                    })
                                ];
                            }
                            if (lastBlobMap.get(id) === base64) return [
                                2,
                                worker.postMessage({
                                    id: id
                                })
                            ];
                            worker.postMessage({
                                id: id,
                                type: type,
                                base64: base64,
                                width: width,
                                height: height
                            });
                            lastBlobMap.set(id, base64);
                            return [
                                3,
                                6
                            ];
                        case 5:
                            return [
                                2,
                                worker.postMessage({
                                    id: e.data.id
                                })
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
        };
    })();
}, null);
var $6c21bacc9274e141$var$CanvasManager = /*#__PURE__*/ function() {
    "use strict";
    function CanvasManager(options) {
        var _this = this;
        (0, $50OuQ._)(this, CanvasManager);
        this.pendingCanvasMutations = new Map();
        this.rafStamps = {
            latestId: 0,
            invokeId: null
        };
        this.frozen = false;
        this.locked = false;
        this.processMutation = function(target, mutation) {
            var newFrame = _this.rafStamps.invokeId && _this.rafStamps.latestId !== _this.rafStamps.invokeId;
            if (newFrame || !_this.rafStamps.invokeId) _this.rafStamps.invokeId = _this.rafStamps.latestId;
            if (!_this.pendingCanvasMutations.has(target)) _this.pendingCanvasMutations.set(target, []);
            _this.pendingCanvasMutations.get(target).push(mutation);
        };
        var _options_sampling = options.sampling, sampling = _options_sampling === void 0 ? 'all' : _options_sampling, win = options.win, blockClass = options.blockClass, blockSelector = options.blockSelector, recordCanvas = options.recordCanvas, dataURLOptions = options.dataURLOptions;
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        if (recordCanvas && sampling === 'all') this.initCanvasMutationObserver(win, blockClass, blockSelector);
        if (recordCanvas && typeof sampling === 'number') this.initCanvasFPSObserver(sampling, win, blockClass, blockSelector, {
            dataURLOptions: dataURLOptions
        });
    }
    (0, $fGdZr._)(CanvasManager, [
        {
            key: "reset",
            value: function reset() {
                this.pendingCanvasMutations.clear();
                this.resetObservers && this.resetObservers();
            }
        },
        {
            key: "freeze",
            value: function freeze() {
                this.frozen = true;
            }
        },
        {
            key: "unfreeze",
            value: function unfreeze() {
                this.frozen = false;
            }
        },
        {
            key: "lock",
            value: function lock() {
                this.locked = true;
            }
        },
        {
            key: "unlock",
            value: function unlock() {
                this.locked = false;
            }
        },
        {
            key: "initCanvasFPSObserver",
            value: function initCanvasFPSObserver(fps, win, blockClass, blockSelector, options) {
                var _this = this;
                var canvasContextReset = $6c21bacc9274e141$var$initCanvasContextObserver(win, blockClass, blockSelector, true);
                var snapshotInProgressMap = new Map();
                var worker = new $6c21bacc9274e141$var$WorkerFactory();
                worker.onmessage = function(e) {
                    var id = e.data.id;
                    snapshotInProgressMap.set(id, false);
                    if (!('base64' in e.data)) return;
                    var _e_data = e.data, base64 = _e_data.base64, type = _e_data.type, width = _e_data.width, height = _e_data.height;
                    _this.mutationCb({
                        id: id,
                        type: $6c21bacc9274e141$var$CanvasContext['2D'],
                        commands: [
                            {
                                property: 'clearRect',
                                args: [
                                    0,
                                    0,
                                    width,
                                    height
                                ]
                            },
                            {
                                property: 'drawImage',
                                args: [
                                    {
                                        rr_type: 'ImageBitmap',
                                        args: [
                                            {
                                                rr_type: 'Blob',
                                                data: [
                                                    {
                                                        rr_type: 'ArrayBuffer',
                                                        base64: base64
                                                    }
                                                ],
                                                type: type
                                            }
                                        ]
                                    },
                                    0,
                                    0
                                ]
                            }
                        ]
                    });
                };
                var timeBetweenSnapshots = 1000 / fps;
                var lastSnapshotTime = 0;
                var rafId;
                var getCanvas = function() {
                    var matchedCanvas = [];
                    win.document.querySelectorAll('canvas').forEach(function(canvas) {
                        if (!$6c21bacc9274e141$var$isBlocked(canvas, blockClass, blockSelector, true)) matchedCanvas.push(canvas);
                    });
                    return matchedCanvas;
                };
                var takeCanvasSnapshots = function(timestamp) {
                    if (lastSnapshotTime && timestamp - lastSnapshotTime < timeBetweenSnapshots) {
                        rafId = requestAnimationFrame(takeCanvasSnapshots);
                        return;
                    }
                    lastSnapshotTime = timestamp;
                    getCanvas().forEach(function(canvas) {
                        return $6c21bacc9274e141$var$__awaiter(_this, void 0, void 0, function() {
                            var _a, id, context, bitmap;
                            return (0, $1XfpH.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        id = this.mirror.getId(canvas);
                                        if (snapshotInProgressMap.get(id)) return [
                                            2
                                        ];
                                        if (canvas.width === 0 || canvas.height === 0) return [
                                            2
                                        ];
                                        snapshotInProgressMap.set(id, true);
                                        if ([
                                            'webgl',
                                            'webgl2'
                                        ].includes(canvas.__context)) {
                                            context = canvas.getContext(canvas.__context);
                                            if (((_a = context === null || context === void 0 ? void 0 : context.getContextAttributes()) === null || _a === void 0 ? void 0 : _a.preserveDrawingBuffer) === false) context.clear(context.COLOR_BUFFER_BIT);
                                        }
                                        return [
                                            4,
                                            createImageBitmap(canvas)
                                        ];
                                    case 1:
                                        bitmap = _state.sent();
                                        worker.postMessage({
                                            id: id,
                                            bitmap: bitmap,
                                            width: canvas.width,
                                            height: canvas.height,
                                            dataURLOptions: options.dataURLOptions
                                        }, [
                                            bitmap
                                        ]);
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    });
                    rafId = requestAnimationFrame(takeCanvasSnapshots);
                };
                rafId = requestAnimationFrame(takeCanvasSnapshots);
                this.resetObservers = function() {
                    canvasContextReset();
                    cancelAnimationFrame(rafId);
                };
            }
        },
        {
            key: "initCanvasMutationObserver",
            value: function initCanvasMutationObserver(win, blockClass, blockSelector) {
                this.startRAFTimestamping();
                this.startPendingCanvasMutationFlusher();
                var canvasContextReset = $6c21bacc9274e141$var$initCanvasContextObserver(win, blockClass, blockSelector, false);
                var canvas2DReset = $6c21bacc9274e141$var$initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector);
                var canvasWebGL1and2Reset = $6c21bacc9274e141$var$initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, this.mirror);
                this.resetObservers = function() {
                    canvasContextReset();
                    canvas2DReset();
                    canvasWebGL1and2Reset();
                };
            }
        },
        {
            key: "startPendingCanvasMutationFlusher",
            value: function startPendingCanvasMutationFlusher() {
                var _this = this;
                requestAnimationFrame(function() {
                    return _this.flushPendingCanvasMutations();
                });
            }
        },
        {
            key: "startRAFTimestamping",
            value: function startRAFTimestamping() {
                var _this = this;
                var setLatestRAFTimestamp = function(timestamp) {
                    _this.rafStamps.latestId = timestamp;
                    requestAnimationFrame(setLatestRAFTimestamp);
                };
                requestAnimationFrame(setLatestRAFTimestamp);
            }
        },
        {
            key: "flushPendingCanvasMutations",
            value: function flushPendingCanvasMutations() {
                var _this = this;
                this.pendingCanvasMutations.forEach(function(values, canvas) {
                    var id = _this.mirror.getId(canvas);
                    _this.flushPendingCanvasMutationFor(canvas, id);
                });
                requestAnimationFrame(function() {
                    return _this.flushPendingCanvasMutations();
                });
            }
        },
        {
            key: "flushPendingCanvasMutationFor",
            value: function flushPendingCanvasMutationFor(canvas, id) {
                if (this.frozen || this.locked) return;
                var valuesWithType = this.pendingCanvasMutations.get(canvas);
                if (!valuesWithType || id === -1) return;
                var values = valuesWithType.map(function(value) {
                    var rest = $6c21bacc9274e141$var$__rest(value, [
                        "type"
                    ]);
                    return rest;
                });
                var type = valuesWithType[0].type;
                this.mutationCb({
                    id: id,
                    type: type,
                    commands: values
                });
                this.pendingCanvasMutations["delete"](canvas);
            }
        }
    ]);
    return CanvasManager;
}();
var $6c21bacc9274e141$var$StylesheetManager = /*#__PURE__*/ function() {
    "use strict";
    function StylesheetManager(options) {
        (0, $50OuQ._)(this, StylesheetManager);
        this.trackedLinkElements = new WeakSet();
        this.styleMirror = new $6c21bacc9274e141$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    (0, $fGdZr._)(StylesheetManager, [
        {
            key: "attachLinkElement",
            value: function attachLinkElement(linkEl, childSn) {
                if ('_cssText' in childSn.attributes) this.mutationCb({
                    adds: [],
                    removes: [],
                    texts: [],
                    attributes: [
                        {
                            id: childSn.id,
                            attributes: childSn.attributes
                        }
                    ]
                });
                this.trackLinkElement(linkEl);
            }
        },
        {
            key: "trackLinkElement",
            value: function trackLinkElement(linkEl) {
                if (this.trackedLinkElements.has(linkEl)) return;
                this.trackedLinkElements.add(linkEl);
                this.trackStylesheetInLinkElement(linkEl);
            }
        },
        {
            key: "adoptStyleSheets",
            value: function adoptStyleSheets(sheets, hostId) {
                if (sheets.length === 0) return;
                var adoptedStyleSheetData = {
                    id: hostId,
                    styleIds: []
                };
                var styles = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = sheets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sheet = _step.value;
                        var styleId = void 0;
                        if (!this.styleMirror.has(sheet)) {
                            styleId = this.styleMirror.add(sheet);
                            styles.push({
                                styleId: styleId,
                                rules: Array.from(sheet.rules || CSSRule, function(r, index) {
                                    return {
                                        rule: $6c21bacc9274e141$var$stringifyRule(r),
                                        index: index
                                    };
                                })
                            });
                        } else styleId = this.styleMirror.getId(sheet);
                        adoptedStyleSheetData.styleIds.push(styleId);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (styles.length > 0) adoptedStyleSheetData.styles = styles;
                this.adoptedStyleSheetCb(adoptedStyleSheetData);
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.styleMirror.reset();
                this.trackedLinkElements = new WeakSet();
            }
        },
        {
            key: "trackStylesheetInLinkElement",
            value: function trackStylesheetInLinkElement(linkEl) {}
        }
    ]);
    return StylesheetManager;
}();
var $6c21bacc9274e141$var$ProcessedNodeManager = /*#__PURE__*/ function() {
    "use strict";
    function ProcessedNodeManager() {
        (0, $50OuQ._)(this, ProcessedNodeManager);
        this.nodeMap = new WeakMap();
        this.loop = true;
        this.periodicallyClear();
    }
    (0, $fGdZr._)(ProcessedNodeManager, [
        {
            key: "periodicallyClear",
            value: function periodicallyClear() {
                var _this = this;
                requestAnimationFrame(function() {
                    _this.clear();
                    if (_this.loop) _this.periodicallyClear();
                });
            }
        },
        {
            key: "inOtherBuffer",
            value: function inOtherBuffer(node, thisBuffer) {
                var buffers = this.nodeMap.get(node);
                return buffers && Array.from(buffers).some(function(buffer) {
                    return buffer !== thisBuffer;
                });
            }
        },
        {
            key: "add",
            value: function add(node, buffer) {
                this.nodeMap.set(node, (this.nodeMap.get(node) || new Set()).add(buffer));
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.nodeMap = new WeakMap();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.loop = false;
            }
        }
    ]);
    return ProcessedNodeManager;
}();
function $6c21bacc9274e141$var$wrapEvent(e) {
    return Object.assign(Object.assign({}, e), {
        timestamp: $6c21bacc9274e141$var$nowTimestamp()
    });
}
var $6c21bacc9274e141$var$wrappedEmit;
var $6c21bacc9274e141$var$takeFullSnapshot;
var $6c21bacc9274e141$var$canvasManager;
var $6c21bacc9274e141$var$recording = false;
var $6c21bacc9274e141$var$mirror = $6c21bacc9274e141$var$createMirror();
function $6c21bacc9274e141$var$record() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var emit = options.emit, checkoutEveryNms = options.checkoutEveryNms, checkoutEveryNth = options.checkoutEveryNth, _options_blockClass = options.blockClass, blockClass = _options_blockClass === void 0 ? 'rr-block' : _options_blockClass, _options_blockSelector = options.blockSelector, blockSelector = _options_blockSelector === void 0 ? null : _options_blockSelector, _options_ignoreClass = options.ignoreClass, ignoreClass = _options_ignoreClass === void 0 ? 'rr-ignore' : _options_ignoreClass, _options_ignoreSelector = options.ignoreSelector, ignoreSelector = _options_ignoreSelector === void 0 ? null : _options_ignoreSelector, _options_maskTextClass = options.maskTextClass, maskTextClass = _options_maskTextClass === void 0 ? 'rr-mask' : _options_maskTextClass, _options_maskTextSelector = options.maskTextSelector, maskTextSelector = _options_maskTextSelector === void 0 ? null : _options_maskTextSelector, _options_inlineStylesheet = options.inlineStylesheet, inlineStylesheet = _options_inlineStylesheet === void 0 ? true : _options_inlineStylesheet, maskAllInputs = options.maskAllInputs, _maskInputOptions = options.maskInputOptions, _slimDOMOptions = options.slimDOMOptions, maskInputFn = options.maskInputFn, maskTextFn = options.maskTextFn, hooks = options.hooks, packFn = options.packFn, _options_sampling = options.sampling, sampling = _options_sampling === void 0 ? {} : _options_sampling, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, mousemoveWait = options.mousemoveWait, _options_recordDOM = options.recordDOM, recordDOM = _options_recordDOM === void 0 ? true : _options_recordDOM, _options_recordCanvas = options.recordCanvas, recordCanvas = _options_recordCanvas === void 0 ? false : _options_recordCanvas, _options_recordCrossOriginIframes = options.recordCrossOriginIframes, recordCrossOriginIframes = _options_recordCrossOriginIframes === void 0 ? false : _options_recordCrossOriginIframes, _options_recordAfter = options.recordAfter, recordAfter = _options_recordAfter === void 0 ? options.recordAfter === 'DOMContentLoaded' ? options.recordAfter : 'load' : _options_recordAfter, _options_userTriggeredOnInput = options.userTriggeredOnInput, userTriggeredOnInput = _options_userTriggeredOnInput === void 0 ? false : _options_userTriggeredOnInput, _options_collectFonts = options.collectFonts, collectFonts = _options_collectFonts === void 0 ? false : _options_collectFonts, _options_inlineImages = options.inlineImages, inlineImages = _options_inlineImages === void 0 ? false : _options_inlineImages, plugins = options.plugins, _options_keepIframeSrcFn = options.keepIframeSrcFn, keepIframeSrcFn = _options_keepIframeSrcFn === void 0 ? function() {
        return false;
    } : _options_keepIframeSrcFn, _options_ignoreCSSAttributes = options.ignoreCSSAttributes, ignoreCSSAttributes = _options_ignoreCSSAttributes === void 0 ? new Set([]) : _options_ignoreCSSAttributes, errorHandler = options.errorHandler;
    $6c21bacc9274e141$var$registerErrorHandler(errorHandler);
    var inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    var passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error('emit function is required');
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) sampling.mousemove = mousemoveWait;
    $6c21bacc9274e141$var$mirror.reset();
    var maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        password: true
    } : _maskInputOptions !== undefined ? _maskInputOptions : {
        password: true
    };
    var slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === 'all' ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        headMetaAuthorship: _slimDOMOptions === 'all',
        headMetaDescKeywords: _slimDOMOptions === 'all'
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $6c21bacc9274e141$var$polyfill();
    var lastFullSnapshotEvent;
    var incrementalSnapshotCount = 0;
    var eventProcessor = function(e) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = (plugins || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var plugin = _step.value;
                if (plugin.eventProcessor) e = plugin.eventProcessor(e);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (packFn && !passEmitsToParent) e = packFn(e);
        return e;
    };
    $6c21bacc9274e141$var$wrappedEmit = function(e, isCheckout) {
        var _a;
        if (((_a = $6c21bacc9274e141$var$mutationBuffers[0]) === null || _a === void 0 ? void 0 : _a.isFrozen()) && e.type !== $6c21bacc9274e141$var$EventType$1.FullSnapshot && !(e.type === $6c21bacc9274e141$var$EventType$1.IncrementalSnapshot && e.data.source === $6c21bacc9274e141$var$IncrementalSource$1.Mutation)) $6c21bacc9274e141$var$mutationBuffers.forEach(function(buf) {
            return buf.unfreeze();
        });
        if (inEmittingFrame) emit === null || emit === void 0 || emit(eventProcessor(e), isCheckout);
        else if (passEmitsToParent) {
            var message = {
                type: 'rrweb',
                event: eventProcessor(e),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, '*');
        }
        if (e.type === $6c21bacc9274e141$var$EventType$1.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        } else if (e.type === $6c21bacc9274e141$var$EventType$1.IncrementalSnapshot) {
            if (e.data.source === $6c21bacc9274e141$var$IncrementalSource$1.Mutation && e.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            var exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            var exceedTime = checkoutEveryNms && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) $6c21bacc9274e141$var$takeFullSnapshot(true);
        }
    };
    var wrappedMutationEmit = function(m) {
        $6c21bacc9274e141$var$wrappedEmit($6c21bacc9274e141$var$wrapEvent({
            type: $6c21bacc9274e141$var$EventType$1.IncrementalSnapshot,
            data: Object.assign({
                source: $6c21bacc9274e141$var$IncrementalSource$1.Mutation
            }, m)
        }));
    };
    var wrappedScrollEmit = function(p) {
        return $6c21bacc9274e141$var$wrappedEmit($6c21bacc9274e141$var$wrapEvent({
            type: $6c21bacc9274e141$var$EventType$1.IncrementalSnapshot,
            data: Object.assign({
                source: $6c21bacc9274e141$var$IncrementalSource$1.Scroll
            }, p)
        }));
    };
    var wrappedCanvasMutationEmit = function(p) {
        return $6c21bacc9274e141$var$wrappedEmit($6c21bacc9274e141$var$wrapEvent({
            type: $6c21bacc9274e141$var$EventType$1.IncrementalSnapshot,
            data: Object.assign({
                source: $6c21bacc9274e141$var$IncrementalSource$1.CanvasMutation
            }, p)
        }));
    };
    var wrappedAdoptedStyleSheetEmit = function(a) {
        return $6c21bacc9274e141$var$wrappedEmit($6c21bacc9274e141$var$wrapEvent({
            type: $6c21bacc9274e141$var$EventType$1.IncrementalSnapshot,
            data: Object.assign({
                source: $6c21bacc9274e141$var$IncrementalSource$1.AdoptedStyleSheet
            }, a)
        }));
    };
    var stylesheetManager = new $6c21bacc9274e141$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    var iframeManager = new $6c21bacc9274e141$var$IframeManager({
        mirror: $6c21bacc9274e141$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $6c21bacc9274e141$var$wrappedEmit
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (plugins || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var plugin = _step.value;
            if (plugin.getMirror) plugin.getMirror({
                nodeMirror: $6c21bacc9274e141$var$mirror,
                crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
                crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var processedNodeManager = new $6c21bacc9274e141$var$ProcessedNodeManager();
    $6c21bacc9274e141$var$canvasManager = new $6c21bacc9274e141$var$CanvasManager({
        recordCanvas: recordCanvas,
        mutationCb: wrappedCanvasMutationEmit,
        win: window,
        blockClass: blockClass,
        blockSelector: blockSelector,
        mirror: $6c21bacc9274e141$var$mirror,
        sampling: sampling.canvas,
        dataURLOptions: dataURLOptions
    });
    var shadowDomManager = new $6c21bacc9274e141$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: $6c21bacc9274e141$var$canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $6c21bacc9274e141$var$mirror
    });
    $6c21bacc9274e141$var$takeFullSnapshot = function() {
        var isCheckout = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        if (!recordDOM) return;
        $6c21bacc9274e141$var$wrappedEmit($6c21bacc9274e141$var$wrapEvent({
            type: $6c21bacc9274e141$var$EventType$1.Meta,
            data: {
                href: window.location.href,
                width: $6c21bacc9274e141$var$getWindowWidth(),
                height: $6c21bacc9274e141$var$getWindowHeight()
            }
        }), isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $6c21bacc9274e141$var$mutationBuffers.forEach(function(buf) {
            return buf.lock();
        });
        var node = $6c21bacc9274e141$var$snapshot(document, {
            mirror: $6c21bacc9274e141$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: function(n) {
                if ($6c21bacc9274e141$var$isSerializedIframe(n, $6c21bacc9274e141$var$mirror)) iframeManager.addIframe(n);
                if ($6c21bacc9274e141$var$isSerializedStylesheet(n, $6c21bacc9274e141$var$mirror)) stylesheetManager.trackLinkElement(n);
                if ($6c21bacc9274e141$var$hasShadowRoot(n)) shadowDomManager.addShadowRoot(n.shadowRoot, document);
            },
            onIframeLoad: function(iframe, childSn) {
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: function(linkEl, childSn) {
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node) return console.warn('Failed to snapshot the document');
        $6c21bacc9274e141$var$wrappedEmit($6c21bacc9274e141$var$wrapEvent({
            type: $6c21bacc9274e141$var$EventType$1.FullSnapshot,
            data: {
                node: node,
                initialOffset: $6c21bacc9274e141$var$getWindowScroll(window)
            }
        }), isCheckout);
        $6c21bacc9274e141$var$mutationBuffers.forEach(function(buf) {
            return buf.unlock();
        });
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $6c21bacc9274e141$var$mirror.getId(document));
    };
    try {
        var handlers = [];
        var observe = function(doc) {
            var _a;
            return $6c21bacc9274e141$var$callbackWrapper($6c21bacc9274e141$var$initObservers)({
                mutationCb: wrappedMutationEmit,
                mousemoveCb: function(positions, source) {
                    return $6c21bacc9274e141$var$wrappedEmit($6c21bacc9274e141$var$wrapEvent({
                        type: $6c21bacc9274e141$var$EventType$1.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    }));
                },
                mouseInteractionCb: function(d) {
                    return $6c21bacc9274e141$var$wrappedEmit($6c21bacc9274e141$var$wrapEvent({
                        type: $6c21bacc9274e141$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $6c21bacc9274e141$var$IncrementalSource$1.MouseInteraction
                        }, d)
                    }));
                },
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: function(d) {
                    return $6c21bacc9274e141$var$wrappedEmit($6c21bacc9274e141$var$wrapEvent({
                        type: $6c21bacc9274e141$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $6c21bacc9274e141$var$IncrementalSource$1.ViewportResize
                        }, d)
                    }));
                },
                inputCb: function(v) {
                    return $6c21bacc9274e141$var$wrappedEmit($6c21bacc9274e141$var$wrapEvent({
                        type: $6c21bacc9274e141$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $6c21bacc9274e141$var$IncrementalSource$1.Input
                        }, v)
                    }));
                },
                mediaInteractionCb: function(p) {
                    return $6c21bacc9274e141$var$wrappedEmit($6c21bacc9274e141$var$wrapEvent({
                        type: $6c21bacc9274e141$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $6c21bacc9274e141$var$IncrementalSource$1.MediaInteraction
                        }, p)
                    }));
                },
                styleSheetRuleCb: function(r) {
                    return $6c21bacc9274e141$var$wrappedEmit($6c21bacc9274e141$var$wrapEvent({
                        type: $6c21bacc9274e141$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $6c21bacc9274e141$var$IncrementalSource$1.StyleSheetRule
                        }, r)
                    }));
                },
                styleDeclarationCb: function(r) {
                    return $6c21bacc9274e141$var$wrappedEmit($6c21bacc9274e141$var$wrapEvent({
                        type: $6c21bacc9274e141$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $6c21bacc9274e141$var$IncrementalSource$1.StyleDeclaration
                        }, r)
                    }));
                },
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: function(p) {
                    return $6c21bacc9274e141$var$wrappedEmit($6c21bacc9274e141$var$wrapEvent({
                        type: $6c21bacc9274e141$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $6c21bacc9274e141$var$IncrementalSource$1.Font
                        }, p)
                    }));
                },
                selectionCb: function(p) {
                    $6c21bacc9274e141$var$wrappedEmit($6c21bacc9274e141$var$wrapEvent({
                        type: $6c21bacc9274e141$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $6c21bacc9274e141$var$IncrementalSource$1.Selection
                        }, p)
                    }));
                },
                customElementCb: function(c) {
                    $6c21bacc9274e141$var$wrappedEmit($6c21bacc9274e141$var$wrapEvent({
                        type: $6c21bacc9274e141$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $6c21bacc9274e141$var$IncrementalSource$1.CustomElement
                        }, c)
                    }));
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordDOM: recordDOM,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $6c21bacc9274e141$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: $6c21bacc9274e141$var$canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: ((_a = plugins === null || plugins === void 0 ? void 0 : plugins.filter(function(p) {
                    return p.observer;
                })) === null || _a === void 0 ? void 0 : _a.map(function(p) {
                    return {
                        observer: p.observer,
                        options: p.options,
                        callback: function(payload) {
                            return $6c21bacc9274e141$var$wrappedEmit($6c21bacc9274e141$var$wrapEvent({
                                type: $6c21bacc9274e141$var$EventType$1.Plugin,
                                data: {
                                    plugin: p.name,
                                    payload: payload
                                }
                            }));
                        }
                    };
                })) || []
            }, hooks);
        };
        iframeManager.addLoadListener(function(iframeEl) {
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        var init = function() {
            $6c21bacc9274e141$var$takeFullSnapshot();
            handlers.push(observe(document));
            $6c21bacc9274e141$var$recording = true;
        };
        if (document.readyState === 'interactive' || document.readyState === 'complete') init();
        else {
            handlers.push($6c21bacc9274e141$var$on('DOMContentLoaded', function() {
                $6c21bacc9274e141$var$wrappedEmit($6c21bacc9274e141$var$wrapEvent({
                    type: $6c21bacc9274e141$var$EventType$1.DomContentLoaded,
                    data: {}
                }));
                if (recordAfter === 'DOMContentLoaded') init();
            }));
            handlers.push($6c21bacc9274e141$var$on('load', function() {
                $6c21bacc9274e141$var$wrappedEmit($6c21bacc9274e141$var$wrapEvent({
                    type: $6c21bacc9274e141$var$EventType$1.Load,
                    data: {}
                }));
                if (recordAfter === 'load') init();
            }, window));
        }
        return function() {
            handlers.forEach(function(h) {
                return h();
            });
            processedNodeManager.destroy();
            $6c21bacc9274e141$var$recording = false;
            $6c21bacc9274e141$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
$6c21bacc9274e141$var$record.addCustomEvent = function(tag, payload) {
    if (!$6c21bacc9274e141$var$recording) throw new Error('please add custom event after start recording');
    $6c21bacc9274e141$var$wrappedEmit($6c21bacc9274e141$var$wrapEvent({
        type: $6c21bacc9274e141$var$EventType$1.Custom,
        data: {
            tag: tag,
            payload: payload
        }
    }));
};
$6c21bacc9274e141$var$record.freezePage = function() {
    $6c21bacc9274e141$var$mutationBuffers.forEach(function(buf) {
        return buf.freeze();
    });
};
$6c21bacc9274e141$var$record.takeFullSnapshot = function(isCheckout) {
    if (!$6c21bacc9274e141$var$recording) throw new Error('please take full snapshot after start recording');
    $6c21bacc9274e141$var$takeFullSnapshot(isCheckout);
};
$6c21bacc9274e141$var$record.mirror = $6c21bacc9274e141$var$mirror;
var $6c21bacc9274e141$var$EventType = /* @__PURE__ */ function(EventType2) {
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
}($6c21bacc9274e141$var$EventType || {});
var $6c21bacc9274e141$var$IncrementalSource = /* @__PURE__ */ function(IncrementalSource2) {
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
}($6c21bacc9274e141$var$IncrementalSource || {});
var $6c21bacc9274e141$var$Config = {
    DEBUG: false,
    LIB_VERSION: '2.58.0'
};
// since es6 imports are static and we run unit tests from the console, window won't be defined when importing this file
var $6c21bacc9274e141$var$win;
if (typeof window === 'undefined') {
    var $6c21bacc9274e141$var$loc = {
        hostname: ''
    };
    $6c21bacc9274e141$var$win = {
        navigator: {
            userAgent: '',
            onLine: true
        },
        document: {
            location: $6c21bacc9274e141$var$loc,
            referrer: ''
        },
        screen: {
            width: 0,
            height: 0
        },
        location: $6c21bacc9274e141$var$loc
    };
} else $6c21bacc9274e141$var$win = window;
var $6c21bacc9274e141$var$setImmediate = $6c21bacc9274e141$var$win['setImmediate'];
var $6c21bacc9274e141$var$builtInProp, $6c21bacc9274e141$var$cycle, $6c21bacc9274e141$var$schedulingQueue, $6c21bacc9274e141$var$ToString = Object.prototype.toString, $6c21bacc9274e141$var$timer = typeof $6c21bacc9274e141$var$setImmediate !== 'undefined' ? function timer(fn) {
    return $6c21bacc9274e141$var$setImmediate(fn);
} : setTimeout;
// dammit, IE8.
try {
    Object.defineProperty({}, 'x', {});
    $6c21bacc9274e141$var$builtInProp = function builtInProp(obj, name, val, config) {
        return Object.defineProperty(obj, name, {
            value: val,
            writable: true,
            configurable: config !== false
        });
    };
} catch (err) {
    $6c21bacc9274e141$var$builtInProp = function builtInProp(obj, name, val) {
        obj[name] = val;
        return obj;
    };
}
// Note: using a queue instead of array for efficiency
$6c21bacc9274e141$var$schedulingQueue = function Queue() {
    var first, last, item;
    function Item(fn, self1) {
        this.fn = fn;
        this.self = self1;
        this.next = void 0;
    }
    return {
        add: function add(fn, self1) {
            item = new Item(fn, self1);
            if (last) last.next = item;
            else first = item;
            last = item;
            item = void 0;
        },
        drain: function drain() {
            var f = first;
            first = last = $6c21bacc9274e141$var$cycle = void 0;
            while(f){
                f.fn.call(f.self);
                f = f.next;
            }
        }
    };
}();
function $6c21bacc9274e141$var$schedule(fn, self1) {
    $6c21bacc9274e141$var$schedulingQueue.add(fn, self1);
    if (!$6c21bacc9274e141$var$cycle) $6c21bacc9274e141$var$cycle = $6c21bacc9274e141$var$timer($6c21bacc9274e141$var$schedulingQueue.drain);
}
// promise duck typing
function $6c21bacc9274e141$var$isThenable(o) {
    var _then, oType = typeof o === "undefined" ? "undefined" : (0, $qb7pP._)(o);
    if (o !== null && (oType === 'object' || oType === 'function')) _then = o.then;
    return typeof _then === 'function' ? _then : false;
}
function $6c21bacc9274e141$var$notify() {
    for(var i = 0; i < this.chain.length; i++)$6c21bacc9274e141$var$notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
    this.chain.length = 0;
}
// NOTE: This is a separate function to isolate
// the `try..catch` so that other code can be
// optimized better
function $6c21bacc9274e141$var$notifyIsolated(self1, cb, chain) {
    var ret, _then;
    try {
        if (cb === false) chain.reject(self1.msg);
        else {
            if (cb === true) ret = self1.msg;
            else ret = cb.call(void 0, self1.msg);
            if (ret === chain.promise) chain.reject(TypeError('Promise-chain cycle'));
            else if (_then = $6c21bacc9274e141$var$isThenable(ret)) _then.call(ret, chain.resolve, chain.reject);
            else chain.resolve(ret);
        }
    } catch (err) {
        chain.reject(err);
    }
}
function $6c21bacc9274e141$var$resolve(msg) {
    var _then, self1 = this;
    // already triggered?
    if (self1.triggered) return;
    self1.triggered = true;
    // unwrap
    if (self1.def) self1 = self1.def;
    try {
        // eslint-disable-next-line no-cond-assign
        if (_then = $6c21bacc9274e141$var$isThenable(msg)) $6c21bacc9274e141$var$schedule(function() {
            var defWrapper = new $6c21bacc9274e141$var$MakeDefWrapper(self1);
            try {
                _then.call(msg, function $resolve$() {
                    $6c21bacc9274e141$var$resolve.apply(defWrapper, arguments);
                }, function $reject$() {
                    $6c21bacc9274e141$var$reject.apply(defWrapper, arguments);
                });
            } catch (err) {
                $6c21bacc9274e141$var$reject.call(defWrapper, err);
            }
        });
        else {
            self1.msg = msg;
            self1.state = 1;
            if (self1.chain.length > 0) $6c21bacc9274e141$var$schedule($6c21bacc9274e141$var$notify, self1);
        }
    } catch (err) {
        $6c21bacc9274e141$var$reject.call(new $6c21bacc9274e141$var$MakeDefWrapper(self1), err);
    }
}
function $6c21bacc9274e141$var$reject(msg) {
    var self1 = this;
    // already triggered?
    if (self1.triggered) return;
    self1.triggered = true;
    // unwrap
    if (self1.def) self1 = self1.def;
    self1.msg = msg;
    self1.state = 2;
    if (self1.chain.length > 0) $6c21bacc9274e141$var$schedule($6c21bacc9274e141$var$notify, self1);
}
function $6c21bacc9274e141$var$iteratePromises(Constructor, arr, resolver, rejecter) {
    for(var idx = 0; idx < arr.length; idx++)(function IIFE(idx) {
        Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
            resolver(idx, msg);
        }, rejecter);
    })(idx);
}
function $6c21bacc9274e141$var$MakeDefWrapper(self1) {
    this.def = self1;
    this.triggered = false;
}
function $6c21bacc9274e141$var$MakeDef(self1) {
    this.promise = self1;
    this.state = 0;
    this.triggered = false;
    this.chain = [];
    this.msg = void 0;
}
function $6c21bacc9274e141$var$NpoPromise(executor) {
    if (typeof executor !== 'function') throw TypeError('Not a function');
    if (this['__NPO__'] !== 0) throw TypeError('Not a promise');
    // instance shadowing the inherited "brand"
    // to signal an already "initialized" promise
    this['__NPO__'] = 1;
    var def = new $6c21bacc9274e141$var$MakeDef(this);
    this['then'] = function then(success, failure) {
        var o = {
            success: typeof success === 'function' ? success : true,
            failure: typeof failure === 'function' ? failure : false
        };
        // Note: `then(..)` itself can be borrowed to be used against
        // a different promise constructor for making the chained promise,
        // by substituting a different `this` binding.
        o.promise = new this.constructor(function extractChain(resolve, reject) {
            if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
            o.resolve = resolve;
            o.reject = reject;
        });
        def.chain.push(o);
        if (def.state !== 0) $6c21bacc9274e141$var$schedule($6c21bacc9274e141$var$notify, def);
        return o.promise;
    };
    this['catch'] = function $catch$(failure) {
        return this.then(void 0, failure);
    };
    try {
        executor.call(void 0, function publicResolve(msg) {
            $6c21bacc9274e141$var$resolve.call(def, msg);
        }, function publicReject(msg) {
            $6c21bacc9274e141$var$reject.call(def, msg);
        });
    } catch (err) {
        $6c21bacc9274e141$var$reject.call(def, err);
    }
}
var $6c21bacc9274e141$var$PromisePrototype = $6c21bacc9274e141$var$builtInProp({}, 'constructor', $6c21bacc9274e141$var$NpoPromise, /*configurable=*/ false);
// Note: Android 4 cannot use `Object.defineProperty(..)` here
$6c21bacc9274e141$var$NpoPromise.prototype = $6c21bacc9274e141$var$PromisePrototype;
// built-in "brand" to signal an "uninitialized" promise
$6c21bacc9274e141$var$builtInProp($6c21bacc9274e141$var$PromisePrototype, '__NPO__', 0, /*configurable=*/ false);
$6c21bacc9274e141$var$builtInProp($6c21bacc9274e141$var$NpoPromise, 'resolve', function Promise$resolve(msg) {
    var Constructor = this;
    // spec mandated checks
    // note: best "isPromise" check that's practical for now
    if (msg && (typeof msg === "undefined" ? "undefined" : (0, $qb7pP._)(msg)) === 'object' && msg['__NPO__'] === 1) return msg;
    return new Constructor(function executor(resolve, reject) {
        if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
        resolve(msg);
    });
});
$6c21bacc9274e141$var$builtInProp($6c21bacc9274e141$var$NpoPromise, 'reject', function Promise$reject(msg) {
    return new this(function executor(resolve, reject) {
        if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
        reject(msg);
    });
});
$6c21bacc9274e141$var$builtInProp($6c21bacc9274e141$var$NpoPromise, 'all', function Promise$all(arr) {
    var Constructor = this;
    // spec mandated checks
    if ($6c21bacc9274e141$var$ToString.call(arr) !== '[object Array]') return Constructor.reject(TypeError('Not an array'));
    if (arr.length === 0) return Constructor.resolve([]);
    return new Constructor(function executor(resolve, reject) {
        if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
        var len = arr.length, msgs = Array(len), count = 0;
        $6c21bacc9274e141$var$iteratePromises(Constructor, arr, function resolver(idx, msg) {
            msgs[idx] = msg;
            if (++count === len) resolve(msgs);
        }, reject);
    });
});
$6c21bacc9274e141$var$builtInProp($6c21bacc9274e141$var$NpoPromise, 'race', function Promise$race(arr) {
    var Constructor = this;
    // spec mandated checks
    if ($6c21bacc9274e141$var$ToString.call(arr) !== '[object Array]') return Constructor.reject(TypeError('Not an array'));
    return new Constructor(function executor(resolve, reject) {
        if (typeof resolve !== 'function' || typeof reject !== 'function') throw TypeError('Not a function');
        $6c21bacc9274e141$var$iteratePromises(Constructor, arr, function resolver(idx, msg) {
            resolve(msg);
        }, reject);
    });
});
var $6c21bacc9274e141$var$PromisePolyfill;
if (typeof Promise !== 'undefined' && Promise.toString().indexOf('[native code]') !== -1) $6c21bacc9274e141$var$PromisePolyfill = Promise;
else $6c21bacc9274e141$var$PromisePolyfill = $6c21bacc9274e141$var$NpoPromise;
/* eslint camelcase: "off", eqeqeq: "off" */ // Maximum allowed session recording length
var $6c21bacc9274e141$var$MAX_RECORDING_MS = 86400000; // 24 hours
// Maximum allowed value for minimum session recording length
var $6c21bacc9274e141$var$MAX_VALUE_FOR_MIN_RECORDING_MS = 8000; // 8 seconds
/*
 * Saved references to long variable names, so that closure compiler can
 * minimize file size.
 */ var $6c21bacc9274e141$var$ArrayProto = Array.prototype, $6c21bacc9274e141$var$FuncProto = Function.prototype, $6c21bacc9274e141$var$ObjProto = Object.prototype, $6c21bacc9274e141$var$slice = $6c21bacc9274e141$var$ArrayProto.slice, $6c21bacc9274e141$var$toString = $6c21bacc9274e141$var$ObjProto.toString, $6c21bacc9274e141$var$hasOwnProperty = $6c21bacc9274e141$var$ObjProto.hasOwnProperty, $6c21bacc9274e141$var$windowConsole = $6c21bacc9274e141$var$win.console, $6c21bacc9274e141$var$navigator = $6c21bacc9274e141$var$win.navigator, $6c21bacc9274e141$var$document$1 = $6c21bacc9274e141$var$win.document, $6c21bacc9274e141$var$windowOpera = $6c21bacc9274e141$var$win.opera, $6c21bacc9274e141$var$screen = $6c21bacc9274e141$var$win.screen, $6c21bacc9274e141$var$userAgent = $6c21bacc9274e141$var$navigator.userAgent;
var $6c21bacc9274e141$var$nativeBind = $6c21bacc9274e141$var$FuncProto.bind, $6c21bacc9274e141$var$nativeForEach = $6c21bacc9274e141$var$ArrayProto.forEach, $6c21bacc9274e141$var$nativeIndexOf = $6c21bacc9274e141$var$ArrayProto.indexOf, $6c21bacc9274e141$var$nativeMap = $6c21bacc9274e141$var$ArrayProto.map, $6c21bacc9274e141$var$nativeIsArray = Array.isArray, $6c21bacc9274e141$var$breaker = {};
var $6c21bacc9274e141$var$_ = {
    trim: function trim(str) {
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    }
};
// Console override
var $6c21bacc9274e141$var$console$1 = {
    /** @type {function(...*)} */ log: function log() {
        if ($6c21bacc9274e141$var$Config.DEBUG && !$6c21bacc9274e141$var$_.isUndefined($6c21bacc9274e141$var$windowConsole) && $6c21bacc9274e141$var$windowConsole) try {
            $6c21bacc9274e141$var$windowConsole.log.apply($6c21bacc9274e141$var$windowConsole, arguments);
        } catch (err) {
            $6c21bacc9274e141$var$_.each(arguments, function(arg) {
                $6c21bacc9274e141$var$windowConsole.log(arg);
            });
        }
    },
    /** @type {function(...*)} */ warn: function warn() {
        if ($6c21bacc9274e141$var$Config.DEBUG && !$6c21bacc9274e141$var$_.isUndefined($6c21bacc9274e141$var$windowConsole) && $6c21bacc9274e141$var$windowConsole) {
            var args = [
                'Mixpanel warning:'
            ].concat($6c21bacc9274e141$var$_.toArray(arguments));
            try {
                $6c21bacc9274e141$var$windowConsole.warn.apply($6c21bacc9274e141$var$windowConsole, args);
            } catch (err) {
                $6c21bacc9274e141$var$_.each(args, function(arg) {
                    $6c21bacc9274e141$var$windowConsole.warn(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */ error: function error() {
        if ($6c21bacc9274e141$var$Config.DEBUG && !$6c21bacc9274e141$var$_.isUndefined($6c21bacc9274e141$var$windowConsole) && $6c21bacc9274e141$var$windowConsole) {
            var args = [
                'Mixpanel error:'
            ].concat($6c21bacc9274e141$var$_.toArray(arguments));
            try {
                $6c21bacc9274e141$var$windowConsole.error.apply($6c21bacc9274e141$var$windowConsole, args);
            } catch (err) {
                $6c21bacc9274e141$var$_.each(args, function(arg) {
                    $6c21bacc9274e141$var$windowConsole.error(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */ critical: function critical() {
        if (!$6c21bacc9274e141$var$_.isUndefined($6c21bacc9274e141$var$windowConsole) && $6c21bacc9274e141$var$windowConsole) {
            var args = [
                'Mixpanel error:'
            ].concat($6c21bacc9274e141$var$_.toArray(arguments));
            try {
                $6c21bacc9274e141$var$windowConsole.error.apply($6c21bacc9274e141$var$windowConsole, args);
            } catch (err) {
                $6c21bacc9274e141$var$_.each(args, function(arg) {
                    $6c21bacc9274e141$var$windowConsole.error(arg);
                });
            }
        }
    }
};
var $6c21bacc9274e141$var$log_func_with_prefix = function log_func_with_prefix(func, prefix) {
    return function() {
        arguments[0] = '[' + prefix + '] ' + arguments[0];
        return func.apply($6c21bacc9274e141$var$console$1, arguments);
    };
};
var $6c21bacc9274e141$var$console_with_prefix = function console_with_prefix(prefix) {
    return {
        log: $6c21bacc9274e141$var$log_func_with_prefix($6c21bacc9274e141$var$console$1.log, prefix),
        error: $6c21bacc9274e141$var$log_func_with_prefix($6c21bacc9274e141$var$console$1.error, prefix),
        critical: $6c21bacc9274e141$var$log_func_with_prefix($6c21bacc9274e141$var$console$1.critical, prefix)
    };
};
// UNDERSCORE
// Embed part of the Underscore Library
$6c21bacc9274e141$var$_.bind = function(func, context) {
    var args, bound;
    if ($6c21bacc9274e141$var$nativeBind && func.bind === $6c21bacc9274e141$var$nativeBind) return $6c21bacc9274e141$var$nativeBind.apply(func, $6c21bacc9274e141$var$slice.call(arguments, 1));
    if (!$6c21bacc9274e141$var$_.isFunction(func)) throw new TypeError();
    args = $6c21bacc9274e141$var$slice.call(arguments, 2);
    bound = function() {
        if (!(this instanceof bound)) return func.apply(context, args.concat($6c21bacc9274e141$var$slice.call(arguments)));
        var ctor = {};
        ctor.prototype = func.prototype;
        var self1 = new ctor();
        ctor.prototype = null;
        var result = func.apply(self1, args.concat($6c21bacc9274e141$var$slice.call(arguments)));
        if (Object(result) === result) return result;
        return self1;
    };
    return bound;
};
/**
 * @param {*=} obj
 * @param {function(...*)=} iterator
 * @param {Object=} context
 */ $6c21bacc9274e141$var$_.each = function(obj, iterator, context) {
    if (obj === null || obj === undefined) return;
    if ($6c21bacc9274e141$var$nativeForEach && obj.forEach === $6c21bacc9274e141$var$nativeForEach) obj.forEach(iterator, context);
    else if (obj.length === +obj.length) for(var i = 0, l = obj.length; i < l; i++){
        if (i in obj && iterator.call(context, obj[i], i, obj) === $6c21bacc9274e141$var$breaker) return;
    }
    else {
        for(var key in obj)if ($6c21bacc9274e141$var$hasOwnProperty.call(obj, key)) {
            if (iterator.call(context, obj[key], key, obj) === $6c21bacc9274e141$var$breaker) return;
        }
    }
};
$6c21bacc9274e141$var$_.extend = function(obj) {
    $6c21bacc9274e141$var$_.each($6c21bacc9274e141$var$slice.call(arguments, 1), function(source) {
        for(var prop in source)if (source[prop] !== void 0) obj[prop] = source[prop];
    });
    return obj;
};
$6c21bacc9274e141$var$_.isArray = $6c21bacc9274e141$var$nativeIsArray || function(obj) {
    return $6c21bacc9274e141$var$toString.call(obj) === '[object Array]';
};
// from a comment on http://dbj.org/dbj/?p=286
// fails on only one very rare and deliberate custom object:
// var bomb = { toString : undefined, valueOf: function(o) { return "function BOMBA!"; }};
$6c21bacc9274e141$var$_.isFunction = function(f) {
    try {
        return /^\s*\bfunction\b/.test(f);
    } catch (x) {
        return false;
    }
};
$6c21bacc9274e141$var$_.isArguments = function(obj) {
    return !!(obj && $6c21bacc9274e141$var$hasOwnProperty.call(obj, 'callee'));
};
$6c21bacc9274e141$var$_.toArray = function(iterable) {
    if (!iterable) return [];
    if (iterable.toArray) return iterable.toArray();
    if ($6c21bacc9274e141$var$_.isArray(iterable)) return $6c21bacc9274e141$var$slice.call(iterable);
    if ($6c21bacc9274e141$var$_.isArguments(iterable)) return $6c21bacc9274e141$var$slice.call(iterable);
    return $6c21bacc9274e141$var$_.values(iterable);
};
$6c21bacc9274e141$var$_.map = function(arr, callback, context) {
    if ($6c21bacc9274e141$var$nativeMap && arr.map === $6c21bacc9274e141$var$nativeMap) return arr.map(callback, context);
    else {
        var results = [];
        $6c21bacc9274e141$var$_.each(arr, function(item) {
            results.push(callback.call(context, item));
        });
        return results;
    }
};
$6c21bacc9274e141$var$_.keys = function(obj) {
    var results = [];
    if (obj === null) return results;
    $6c21bacc9274e141$var$_.each(obj, function(value, key) {
        results[results.length] = key;
    });
    return results;
};
$6c21bacc9274e141$var$_.values = function(obj) {
    var results = [];
    if (obj === null) return results;
    $6c21bacc9274e141$var$_.each(obj, function(value) {
        results[results.length] = value;
    });
    return results;
};
$6c21bacc9274e141$var$_.include = function(obj, target) {
    var found = false;
    if (obj === null) return found;
    if ($6c21bacc9274e141$var$nativeIndexOf && obj.indexOf === $6c21bacc9274e141$var$nativeIndexOf) return obj.indexOf(target) != -1;
    $6c21bacc9274e141$var$_.each(obj, function(value) {
        if (found || (found = value === target)) return $6c21bacc9274e141$var$breaker;
    });
    return found;
};
$6c21bacc9274e141$var$_.includes = function(str, needle) {
    return str.indexOf(needle) !== -1;
};
// Underscore Addons
$6c21bacc9274e141$var$_.inherit = function(subclass, superclass) {
    subclass.prototype = new superclass();
    subclass.prototype.constructor = subclass;
    subclass.superclass = superclass.prototype;
    return subclass;
};
$6c21bacc9274e141$var$_.isObject = function(obj) {
    return obj === Object(obj) && !$6c21bacc9274e141$var$_.isArray(obj);
};
$6c21bacc9274e141$var$_.isEmptyObject = function(obj) {
    if ($6c21bacc9274e141$var$_.isObject(obj)) {
        for(var key in obj){
            if ($6c21bacc9274e141$var$hasOwnProperty.call(obj, key)) return false;
        }
        return true;
    }
    return false;
};
$6c21bacc9274e141$var$_.isUndefined = function(obj) {
    return obj === void 0;
};
$6c21bacc9274e141$var$_.isString = function(obj) {
    return $6c21bacc9274e141$var$toString.call(obj) == '[object String]';
};
$6c21bacc9274e141$var$_.isDate = function(obj) {
    return $6c21bacc9274e141$var$toString.call(obj) == '[object Date]';
};
$6c21bacc9274e141$var$_.isNumber = function(obj) {
    return $6c21bacc9274e141$var$toString.call(obj) == '[object Number]';
};
$6c21bacc9274e141$var$_.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
};
$6c21bacc9274e141$var$_.encodeDates = function(obj) {
    $6c21bacc9274e141$var$_.each(obj, function(v, k) {
        if ($6c21bacc9274e141$var$_.isDate(v)) obj[k] = $6c21bacc9274e141$var$_.formatDate(v);
        else if ($6c21bacc9274e141$var$_.isObject(v)) obj[k] = $6c21bacc9274e141$var$_.encodeDates(v); // recurse
    });
    return obj;
};
$6c21bacc9274e141$var$_.timestamp = function() {
    Date.now = Date.now || function() {
        return +new Date;
    };
    return Date.now();
};
$6c21bacc9274e141$var$_.formatDate = function(d) {
    // YYYY-MM-DDTHH:MM:SS in UTC
    function pad(n) {
        return n < 10 ? '0' + n : n;
    }
    return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()) + 'T' + pad(d.getUTCHours()) + ':' + pad(d.getUTCMinutes()) + ':' + pad(d.getUTCSeconds());
};
$6c21bacc9274e141$var$_.strip_empty_properties = function(p) {
    var ret = {};
    $6c21bacc9274e141$var$_.each(p, function(v, k) {
        if ($6c21bacc9274e141$var$_.isString(v) && v.length > 0) ret[k] = v;
    });
    return ret;
};
/*
 * this function returns a copy of object after truncating it.  If
 * passed an Array or Object it will iterate through obj and
 * truncate all the values recursively.
 */ $6c21bacc9274e141$var$_.truncate = function(obj, length) {
    var ret;
    if (typeof obj === 'string') ret = obj.slice(0, length);
    else if ($6c21bacc9274e141$var$_.isArray(obj)) {
        ret = [];
        $6c21bacc9274e141$var$_.each(obj, function(val) {
            ret.push($6c21bacc9274e141$var$_.truncate(val, length));
        });
    } else if ($6c21bacc9274e141$var$_.isObject(obj)) {
        ret = {};
        $6c21bacc9274e141$var$_.each(obj, function(val, key) {
            ret[key] = $6c21bacc9274e141$var$_.truncate(val, length);
        });
    } else ret = obj;
    return ret;
};
$6c21bacc9274e141$var$_.JSONEncode = function() {
    return function(mixed_val) {
        var value = mixed_val;
        var quote = function quote(string) {
            var escapable = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g; // eslint-disable-line no-control-regex
            var meta = {
                '\b': '\\b',
                '\t': '\\t',
                '\n': '\\n',
                '\f': '\\f',
                '\r': '\\r',
                '"': '\\"',
                '\\': '\\\\'
            };
            escapable.lastIndex = 0;
            return escapable.test(string) ? '"' + string.replace(escapable, function(a) {
                var c = meta[a];
                return typeof c === 'string' ? c : '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
            }) + '"' : '"' + string + '"';
        };
        var str = function str1(key, holder) {
            var gap = '';
            var indent = '    ';
            var i = 0; // The loop counter.
            var k = ''; // The member key.
            var v = ''; // The member value.
            var length = 0;
            var mind = gap;
            var partial = [];
            var value = holder[key];
            // If the value has a toJSON method, call it to obtain a replacement value.
            if (value && (typeof value === "undefined" ? "undefined" : (0, $qb7pP._)(value)) === 'object' && typeof value.toJSON === 'function') value = value.toJSON(key);
            // What happens next depends on the value's type.
            switch(typeof value === "undefined" ? "undefined" : (0, $qb7pP._)(value)){
                case 'string':
                    return quote(value);
                case 'number':
                    // JSON numbers must be finite. Encode non-finite numbers as null.
                    return isFinite(value) ? String(value) : 'null';
                case 'boolean':
                case 'null':
                    // If the value is a boolean or null, convert it to a string. Note:
                    // typeof null does not produce 'null'. The case is included here in
                    // the remote chance that this gets fixed someday.
                    return String(value);
                case 'object':
                    // If the type is 'object', we might be dealing with an object or an array or
                    // null.
                    // Due to a specification blunder in ECMAScript, typeof null is 'object',
                    // so watch out for that case.
                    if (!value) return 'null';
                    // Make an array to hold the partial results of stringifying this object value.
                    gap += indent;
                    partial = [];
                    // Is the value an array?
                    if ($6c21bacc9274e141$var$toString.apply(value) === '[object Array]') {
                        // The value is an array. Stringify every element. Use null as a placeholder
                        // for non-JSON values.
                        length = value.length;
                        for(i = 0; i < length; i += 1)partial[i] = str(i, value) || 'null';
                        // Join all of the elements together, separated with commas, and wrap them in
                        // brackets.
                        v = partial.length === 0 ? '[]' : gap ? '[\n' + gap + partial.join(',\n' + gap) + '\n' + mind + ']' : '[' + partial.join(',') + ']';
                        gap = mind;
                        return v;
                    }
                    // Iterate through all of the keys in the object.
                    for(k in value)if ($6c21bacc9274e141$var$hasOwnProperty.call(value, k)) {
                        v = str(k, value);
                        if (v) partial.push(quote(k) + (gap ? ': ' : ':') + v);
                    }
                    // Join all of the member texts together, separated with commas,
                    // and wrap them in braces.
                    v = partial.length === 0 ? '{}' : gap ? '{' + partial.join(',') + '' + mind + '}' : '{' + partial.join(',') + '}';
                    gap = mind;
                    return v;
            }
        };
        // Make a fake root object containing our value under the key of ''.
        // Return the result of stringifying the value.
        return str('', {
            '': value
        });
    };
}();
/**
 * From https://github.com/douglascrockford/JSON-js/blob/master/json_parse.js
 * Slightly modified to throw a real Error rather than a POJO
 */ $6c21bacc9274e141$var$_.JSONDecode = function() {
    var at, ch, escapee = {
        '"': '"',
        '\\': '\\',
        '/': '/',
        b: '\b',
        f: '\f',
        n: '\n',
        r: '\r',
        t: '\t'
    }, text, error = function error(m) {
        var e = new SyntaxError(m);
        e.at = at;
        e.text = text;
        throw e;
    }, next = function next(c) {
        // If a c parameter is provided, verify that it matches the current character.
        if (c && c !== ch) error('Expected \'' + c + '\' instead of \'' + ch + '\'');
        // Get the next character. When there are no more characters,
        // return the empty string.
        ch = text.charAt(at);
        at += 1;
        return ch;
    }, number = function number() {
        // Parse a number value.
        var number, string = '';
        if (ch === '-') {
            string = '-';
            next('-');
        }
        while(ch >= '0' && ch <= '9'){
            string += ch;
            next();
        }
        if (ch === '.') {
            string += '.';
            while(next() && ch >= '0' && ch <= '9')string += ch;
        }
        if (ch === 'e' || ch === 'E') {
            string += ch;
            next();
            if (ch === '-' || ch === '+') {
                string += ch;
                next();
            }
            while(ch >= '0' && ch <= '9'){
                string += ch;
                next();
            }
        }
        number = +string;
        if (!isFinite(number)) error('Bad number');
        else return number;
    }, string = function string() {
        // Parse a string value.
        var hex, i, string = '', uffff;
        // When parsing for string values, we must look for " and \ characters.
        if (ch === '"') while(next()){
            if (ch === '"') {
                next();
                return string;
            }
            if (ch === '\\') {
                next();
                if (ch === 'u') {
                    uffff = 0;
                    for(i = 0; i < 4; i += 1){
                        hex = parseInt(next(), 16);
                        if (!isFinite(hex)) break;
                        uffff = uffff * 16 + hex;
                    }
                    string += String.fromCharCode(uffff);
                } else if (typeof escapee[ch] === 'string') string += escapee[ch];
                else break;
            } else string += ch;
        }
        error('Bad string');
    }, white = function white() {
        // Skip whitespace.
        while(ch && ch <= ' ')next();
    }, word = function word() {
        // true, false, or null.
        switch(ch){
            case 't':
                next('t');
                next('r');
                next('u');
                next('e');
                return true;
            case 'f':
                next('f');
                next('a');
                next('l');
                next('s');
                next('e');
                return false;
            case 'n':
                next('n');
                next('u');
                next('l');
                next('l');
                return null;
        }
        error('Unexpected "' + ch + '"');
    }, value, array = function array() {
        // Parse an array value.
        var array = [];
        if (ch === '[') {
            next('[');
            white();
            if (ch === ']') {
                next(']');
                return array; // empty array
            }
            while(ch){
                array.push(value());
                white();
                if (ch === ']') {
                    next(']');
                    return array;
                }
                next(',');
                white();
            }
        }
        error('Bad array');
    }, object = function object() {
        // Parse an object value.
        var key, object = {};
        if (ch === '{') {
            next('{');
            white();
            if (ch === '}') {
                next('}');
                return object; // empty object
            }
            while(ch){
                key = string();
                white();
                next(':');
                if (Object.hasOwnProperty.call(object, key)) error('Duplicate key "' + key + '"');
                object[key] = value();
                white();
                if (ch === '}') {
                    next('}');
                    return object;
                }
                next(',');
                white();
            }
        }
        error('Bad object');
    };
    value = function value() {
        // Parse a JSON value. It could be an object, an array, a string,
        // a number, or a word.
        white();
        switch(ch){
            case '{':
                return object();
            case '[':
                return array();
            case '"':
                return string();
            case '-':
                return number();
            default:
                return ch >= '0' && ch <= '9' ? number() : word();
        }
    };
    // Return the json_parse function. It will have access to all of the
    // above functions and variables.
    return function(source) {
        var result;
        text = source;
        at = 0;
        ch = ' ';
        result = value();
        white();
        if (ch) error('Syntax error');
        return result;
    };
}();
$6c21bacc9274e141$var$_.base64Encode = function(data) {
    var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, enc = '', tmp_arr = [];
    if (!data) return data;
    data = $6c21bacc9274e141$var$_.utf8Encode(data);
    do {
        o1 = data.charCodeAt(i++);
        o2 = data.charCodeAt(i++);
        o3 = data.charCodeAt(i++);
        bits = o1 << 16 | o2 << 8 | o3;
        h1 = bits >> 18 & 0x3f;
        h2 = bits >> 12 & 0x3f;
        h3 = bits >> 6 & 0x3f;
        h4 = bits & 0x3f;
        // use hexets to index into b64, and append result to encoded string
        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
    }while (i < data.length);
    enc = tmp_arr.join('');
    switch(data.length % 3){
        case 1:
            enc = enc.slice(0, -2) + '==';
            break;
        case 2:
            enc = enc.slice(0, -1) + '=';
            break;
    }
    return enc;
};
$6c21bacc9274e141$var$_.utf8Encode = function(string) {
    string = (string + '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');
    var utftext = '', start, end;
    var stringl = 0, n;
    start = end = 0;
    stringl = string.length;
    for(n = 0; n < stringl; n++){
        var c1 = string.charCodeAt(n);
        var enc = null;
        if (c1 < 128) end++;
        else if (c1 > 127 && c1 < 2048) enc = String.fromCharCode(c1 >> 6 | 192, c1 & 63 | 128);
        else enc = String.fromCharCode(c1 >> 12 | 224, c1 >> 6 & 63 | 128, c1 & 63 | 128);
        if (enc !== null) {
            if (end > start) utftext += string.substring(start, end);
            utftext += enc;
            start = end = n + 1;
        }
    }
    if (end > start) utftext += string.substring(start, string.length);
    return utftext;
};
$6c21bacc9274e141$var$_.UUID = function() {
    // Time-based entropy
    var T = function T() {
        var time = 1 * new Date(); // cross-browser version of Date.now()
        var ticks;
        if ($6c21bacc9274e141$var$win.performance && $6c21bacc9274e141$var$win.performance.now) ticks = $6c21bacc9274e141$var$win.performance.now();
        else {
            // fall back to busy loop
            ticks = 0;
            // this while loop figures how many browser ticks go by
            // before 1*new Date() returns a new number, ie the amount
            // of ticks that go by per millisecond
            while(time == 1 * new Date())ticks++;
        }
        return time.toString(16) + Math.floor(ticks).toString(16);
    };
    // Math.Random entropy
    var R = function R() {
        return Math.random().toString(16).replace('.', '');
    };
    // User agent entropy
    // This function takes the user agent string, and then xors
    // together each sequence of 8 bytes.  This produces a final
    // sequence of 8 bytes which it returns as hex.
    var UA = function UA() {
        var ua = $6c21bacc9274e141$var$userAgent, i, ch, buffer = [], ret = 0;
        function xor(result, byte_array) {
            var j, tmp = 0;
            for(j = 0; j < byte_array.length; j++)tmp |= buffer[j] << j * 8;
            return result ^ tmp;
        }
        for(i = 0; i < ua.length; i++){
            ch = ua.charCodeAt(i);
            buffer.unshift(ch & 0xFF);
            if (buffer.length >= 4) {
                ret = xor(ret, buffer);
                buffer = [];
            }
        }
        if (buffer.length > 0) ret = xor(ret, buffer);
        return ret.toString(16);
    };
    return function() {
        var se = ($6c21bacc9274e141$var$screen.height * $6c21bacc9274e141$var$screen.width).toString(16);
        return T() + '-' + R() + '-' + UA() + '-' + se + '-' + T();
    };
}();
// _.isBlockedUA()
// This is to block various web spiders from executing our JS and
// sending false tracking data
var $6c21bacc9274e141$var$BLOCKED_UA_STRS = [
    'ahrefsbot',
    'ahrefssiteaudit',
    'baiduspider',
    'bingbot',
    'bingpreview',
    'chrome-lighthouse',
    'facebookexternal',
    'petalbot',
    'pinterest',
    'screaming frog',
    'yahoo! slurp',
    'yandexbot',
    // a whole bunch of goog-specific crawlers
    // https://developers.google.com/search/docs/advanced/crawling/overview-google-crawlers
    'adsbot-google',
    'apis-google',
    'duplexweb-google',
    'feedfetcher-google',
    'google favicon',
    'google web preview',
    'google-read-aloud',
    'googlebot',
    'googleweblight',
    'mediapartners-google',
    'storebot-google'
];
$6c21bacc9274e141$var$_.isBlockedUA = function(ua) {
    var i;
    ua = ua.toLowerCase();
    for(i = 0; i < $6c21bacc9274e141$var$BLOCKED_UA_STRS.length; i++){
        if (ua.indexOf($6c21bacc9274e141$var$BLOCKED_UA_STRS[i]) !== -1) return true;
    }
    return false;
};
/**
 * @param {Object=} formdata
 * @param {string=} arg_separator
 */ $6c21bacc9274e141$var$_.HTTPBuildQuery = function(formdata, arg_separator) {
    var use_val, use_key, tmp_arr = [];
    if ($6c21bacc9274e141$var$_.isUndefined(arg_separator)) arg_separator = '&';
    $6c21bacc9274e141$var$_.each(formdata, function(val, key) {
        use_val = encodeURIComponent(val.toString());
        use_key = encodeURIComponent(key);
        tmp_arr[tmp_arr.length] = use_key + '=' + use_val;
    });
    return tmp_arr.join(arg_separator);
};
$6c21bacc9274e141$var$_.getQueryParam = function(url, param) {
    // Expects a raw URL
    param = param.replace(/[[]/g, '\\[').replace(/[\]]/g, '\\]');
    var regexS = '[\\?&]' + param + '=([^&#]*)', regex = new RegExp(regexS), results = regex.exec(url);
    if (results === null || results && typeof results[1] !== 'string' && results[1].length) return '';
    else {
        var result = results[1];
        try {
            result = decodeURIComponent(result);
        } catch (err) {
            $6c21bacc9274e141$var$console$1.error('Skipping decoding for malformed query param: ' + result);
        }
        return result.replace(/\+/g, ' ');
    }
};
// _.cookie
// Methods partially borrowed from quirksmode.org/js/cookies.html
$6c21bacc9274e141$var$_.cookie = {
    get: function get(name) {
        var nameEQ = name + '=';
        var ca = $6c21bacc9274e141$var$document$1.cookie.split(';');
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) == ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    },
    parse: function parse(name) {
        var cookie;
        try {
            cookie = $6c21bacc9274e141$var$_.JSONDecode($6c21bacc9274e141$var$_.cookie.get(name)) || {};
        } catch (err) {
        // noop
        }
        return cookie;
    },
    set_seconds: function set_seconds(name, value, seconds, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = '', expires = '', secure = '';
        if (domain_override) cdomain = '; domain=' + domain_override;
        else if (is_cross_subdomain) {
            var domain = $6c21bacc9274e141$var$extract_domain($6c21bacc9274e141$var$document$1.location.hostname);
            cdomain = domain ? '; domain=.' + domain : '';
        }
        if (seconds) {
            var date = new Date();
            date.setTime(date.getTime() + seconds * 1000);
            expires = '; expires=' + date.toGMTString();
        }
        if (is_cross_site) {
            is_secure = true;
            secure = '; SameSite=None';
        }
        if (is_secure) secure += '; secure';
        $6c21bacc9274e141$var$document$1.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
    },
    set: function set(name, value, days, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = '', expires = '', secure = '';
        if (domain_override) cdomain = '; domain=' + domain_override;
        else if (is_cross_subdomain) {
            var domain = $6c21bacc9274e141$var$extract_domain($6c21bacc9274e141$var$document$1.location.hostname);
            cdomain = domain ? '; domain=.' + domain : '';
        }
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 86400000);
            expires = '; expires=' + date.toGMTString();
        }
        if (is_cross_site) {
            is_secure = true;
            secure = '; SameSite=None';
        }
        if (is_secure) secure += '; secure';
        var new_cookie_val = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
        $6c21bacc9274e141$var$document$1.cookie = new_cookie_val;
        return new_cookie_val;
    },
    remove: function remove(name, is_cross_subdomain, domain_override) {
        $6c21bacc9274e141$var$_.cookie.set(name, '', -1, is_cross_subdomain, false, false, domain_override);
    }
};
var $6c21bacc9274e141$var$_localStorageSupported = null;
var $6c21bacc9274e141$var$localStorageSupported = function localStorageSupported(storage, forceCheck) {
    if ($6c21bacc9274e141$var$_localStorageSupported !== null && !forceCheck) return $6c21bacc9274e141$var$_localStorageSupported;
    var supported = true;
    try {
        storage = storage || $6c21bacc9274e141$var$win.localStorage;
        var key = '__mplss_' + $6c21bacc9274e141$var$cheap_guid(8), val = 'xyz';
        storage.setItem(key, val);
        if (storage.getItem(key) !== val) supported = false;
        storage.removeItem(key);
    } catch (err) {
        supported = false;
    }
    $6c21bacc9274e141$var$_localStorageSupported = supported;
    return supported;
};
// _.localStorage
$6c21bacc9274e141$var$_.localStorage = {
    is_supported: function is_supported(force_check) {
        var supported = $6c21bacc9274e141$var$localStorageSupported(null, force_check);
        if (!supported) $6c21bacc9274e141$var$console$1.error('localStorage unsupported; falling back to cookie store');
        return supported;
    },
    error: function error(msg) {
        $6c21bacc9274e141$var$console$1.error('localStorage error: ' + msg);
    },
    get: function get(name) {
        try {
            return $6c21bacc9274e141$var$win.localStorage.getItem(name);
        } catch (err) {
            $6c21bacc9274e141$var$_.localStorage.error(err);
        }
        return null;
    },
    parse: function parse(name) {
        try {
            return $6c21bacc9274e141$var$_.JSONDecode($6c21bacc9274e141$var$_.localStorage.get(name)) || {};
        } catch (err) {
        // noop
        }
        return null;
    },
    set: function set(name, value) {
        try {
            $6c21bacc9274e141$var$win.localStorage.setItem(name, value);
        } catch (err) {
            $6c21bacc9274e141$var$_.localStorage.error(err);
        }
    },
    remove: function remove(name) {
        try {
            $6c21bacc9274e141$var$win.localStorage.removeItem(name);
        } catch (err) {
            $6c21bacc9274e141$var$_.localStorage.error(err);
        }
    }
};
$6c21bacc9274e141$var$_.register_event = function() {
    // written by Dean Edwards, 2005
    // with input from Tino Zijdel - crisp@xs4all.nl
    // with input from Carl Sverre - mail@carlsverre.com
    // with input from Mixpanel
    // http://dean.edwards.name/weblog/2005/10/add-event/
    // https://gist.github.com/1930440
    /**
     * @param {Object} element
     * @param {string} type
     * @param {function(...*)} handler
     * @param {boolean=} oldSchool
     * @param {boolean=} useCapture
     */ var register_event = function register_event(element, type, handler, oldSchool, useCapture) {
        if (!element) {
            $6c21bacc9274e141$var$console$1.error('No valid element provided to register_event');
            return;
        }
        if (element.addEventListener && !oldSchool) element.addEventListener(type, handler, !!useCapture);
        else {
            var ontype = 'on' + type;
            var old_handler = element[ontype]; // can be undefined
            element[ontype] = makeHandler(element, handler, old_handler);
        }
    };
    function makeHandler(element, new_handler, old_handlers) {
        var handler = function handler(event) {
            event = event || fixEvent($6c21bacc9274e141$var$win.event);
            // this basically happens in firefox whenever another script
            // overwrites the onload callback and doesn't pass the event
            // object to previously defined callbacks.  All the browsers
            // that don't define window.event implement addEventListener
            // so the dom_loaded handler will still be fired as usual.
            if (!event) return undefined;
            var ret = true;
            var old_result, new_result;
            if ($6c21bacc9274e141$var$_.isFunction(old_handlers)) old_result = old_handlers(event);
            new_result = new_handler.call(element, event);
            if (false === old_result || false === new_result) ret = false;
            return ret;
        };
        return handler;
    }
    function fixEvent(event) {
        if (event) {
            event.preventDefault = fixEvent.preventDefault;
            event.stopPropagation = fixEvent.stopPropagation;
        }
        return event;
    }
    fixEvent.preventDefault = function() {
        this.returnValue = false;
    };
    fixEvent.stopPropagation = function() {
        this.cancelBubble = true;
    };
    return register_event;
}();
var $6c21bacc9274e141$var$TOKEN_MATCH_REGEX = new RegExp('^(\\w*)\\[(\\w+)([=~\\|\\^\\$\\*]?)=?"?([^\\]"]*)"?\\]$');
$6c21bacc9274e141$var$_.dom_query = function() {
    /* document.getElementsBySelector(selector)
    - returns an array of element objects from the current document
    matching the CSS selector. Selectors can contain element names,
    class names and ids and can be nested. For example:

    elements = document.getElementsBySelector('div#main p a.external')

    Will return an array of all 'a' elements with 'external' in their
    class attribute that are contained inside 'p' elements that are
    contained inside the 'div' element which has id="main"

    New in version 0.4: Support for CSS2 and CSS3 attribute selectors:
    See http://www.w3.org/TR/css3-selectors/#attribute-selectors

    Version 0.4 - Simon Willison, March 25th 2003
    -- Works in Phoenix 0.5, Mozilla 1.3, Opera 7, Internet Explorer 6, Internet Explorer 5 on Windows
    -- Opera 7 fails

    Version 0.5 - Carl Sverre, Jan 7th 2013
    -- Now uses jQuery-esque `hasClass` for testing class name
    equality.  This fixes a bug related to '-' characters being
    considered not part of a 'word' in regex.
    */ function getAllChildren(e) {
        // Returns all children of element. Workaround required for IE5/Windows. Ugh.
        return e.all ? e.all : e.getElementsByTagName('*');
    }
    var bad_whitespace = /[\t\r\n]/g;
    function hasClass(elem, selector) {
        var className = ' ' + selector + ' ';
        return (' ' + elem.className + ' ').replace(bad_whitespace, ' ').indexOf(className) >= 0;
    }
    function getElementsBySelector(selector) {
        // Attempt to fail gracefully in lesser browsers
        if (!$6c21bacc9274e141$var$document$1.getElementsByTagName) return [];
        // Split selector in to tokens
        var tokens = selector.split(' ');
        var token, bits, tagName, found, foundCount, i, j, k, elements, currentContextIndex;
        var currentContext = [
            $6c21bacc9274e141$var$document$1
        ];
        for(i = 0; i < tokens.length; i++){
            token = tokens[i].replace(/^\s+/, '').replace(/\s+$/, '');
            if (token.indexOf('#') > -1) {
                // Token is an ID selector
                bits = token.split('#');
                tagName = bits[0];
                var id = bits[1];
                var element = $6c21bacc9274e141$var$document$1.getElementById(id);
                if (!element || tagName && element.nodeName.toLowerCase() != tagName) // element not found or tag with that ID not found, return false
                return [];
                // Set currentContext to contain just this element
                currentContext = [
                    element
                ];
                continue; // Skip to next token
            }
            if (token.indexOf('.') > -1) {
                // Token contains a class selector
                bits = token.split('.');
                tagName = bits[0];
                var className = bits[1];
                if (!tagName) tagName = '*';
                // Get elements matching tag, filter them for class selector
                found = [];
                foundCount = 0;
                for(j = 0; j < currentContext.length; j++){
                    if (tagName == '*') elements = getAllChildren(currentContext[j]);
                    else elements = currentContext[j].getElementsByTagName(tagName);
                    for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
                }
                currentContext = [];
                currentContextIndex = 0;
                for(j = 0; j < found.length; j++)if (found[j].className && $6c21bacc9274e141$var$_.isString(found[j].className) && // some SVG elements have classNames which are not strings
                hasClass(found[j], className)) currentContext[currentContextIndex++] = found[j];
                continue; // Skip to next token
            }
            // Code to deal with attribute selectors
            var token_match = token.match($6c21bacc9274e141$var$TOKEN_MATCH_REGEX);
            if (token_match) {
                tagName = token_match[1];
                var attrName = token_match[2];
                var attrOperator = token_match[3];
                var attrValue = token_match[4];
                if (!tagName) tagName = '*';
                // Grab all of the tagName elements within current context
                found = [];
                foundCount = 0;
                for(j = 0; j < currentContext.length; j++){
                    if (tagName == '*') elements = getAllChildren(currentContext[j]);
                    else elements = currentContext[j].getElementsByTagName(tagName);
                    for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
                }
                currentContext = [];
                currentContextIndex = 0;
                var checkFunction; // This function will be used to filter the elements
                switch(attrOperator){
                    case '=':
                        checkFunction = function checkFunction(e) {
                            return e.getAttribute(attrName) == attrValue;
                        };
                        break;
                    case '~':
                        checkFunction = function checkFunction(e) {
                            return e.getAttribute(attrName).match(new RegExp('\\b' + attrValue + '\\b'));
                        };
                        break;
                    case '|':
                        checkFunction = function checkFunction(e) {
                            return e.getAttribute(attrName).match(new RegExp('^' + attrValue + '-?'));
                        };
                        break;
                    case '^':
                        checkFunction = function checkFunction(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) === 0;
                        };
                        break;
                    case '$':
                        checkFunction = function checkFunction(e) {
                            return e.getAttribute(attrName).lastIndexOf(attrValue) == e.getAttribute(attrName).length - attrValue.length;
                        };
                        break;
                    case '*':
                        checkFunction = function checkFunction(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) > -1;
                        };
                        break;
                    default:
                        // Just test for existence of attribute
                        checkFunction = function checkFunction(e) {
                            return e.getAttribute(attrName);
                        };
                }
                currentContext = [];
                currentContextIndex = 0;
                for(j = 0; j < found.length; j++)if (checkFunction(found[j])) currentContext[currentContextIndex++] = found[j];
                continue; // Skip to next token
            }
            // If we get here, token is JUST an element (not a class or ID selector)
            tagName = token;
            found = [];
            foundCount = 0;
            for(j = 0; j < currentContext.length; j++){
                elements = currentContext[j].getElementsByTagName(tagName);
                for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
            }
            currentContext = found;
        }
        return currentContext;
    }
    return function(query) {
        if ($6c21bacc9274e141$var$_.isElement(query)) return [
            query
        ];
        else if ($6c21bacc9274e141$var$_.isObject(query) && !$6c21bacc9274e141$var$_.isUndefined(query.length)) return query;
        else return getElementsBySelector.call(this, query);
    };
}();
var $6c21bacc9274e141$var$CAMPAIGN_KEYWORDS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_id',
    'utm_source_platform',
    'utm_campaign_id',
    'utm_creative_format',
    'utm_marketing_tactic'
];
var $6c21bacc9274e141$var$CLICK_IDS = [
    'dclid',
    'fbclid',
    'gclid',
    'ko_click_id',
    'li_fat_id',
    'msclkid',
    'sccid',
    'ttclid',
    'twclid',
    'wbraid'
];
$6c21bacc9274e141$var$_.info = {
    campaignParams: function campaignParams(default_value) {
        var kw = '', params = {};
        $6c21bacc9274e141$var$_.each($6c21bacc9274e141$var$CAMPAIGN_KEYWORDS, function(kwkey) {
            kw = $6c21bacc9274e141$var$_.getQueryParam($6c21bacc9274e141$var$document$1.URL, kwkey);
            if (kw.length) params[kwkey] = kw;
            else if (default_value !== undefined) params[kwkey] = default_value;
        });
        return params;
    },
    clickParams: function clickParams() {
        var id = '', params = {};
        $6c21bacc9274e141$var$_.each($6c21bacc9274e141$var$CLICK_IDS, function(idkey) {
            id = $6c21bacc9274e141$var$_.getQueryParam($6c21bacc9274e141$var$document$1.URL, idkey);
            if (id.length) params[idkey] = id;
        });
        return params;
    },
    marketingParams: function marketingParams() {
        return $6c21bacc9274e141$var$_.extend($6c21bacc9274e141$var$_.info.campaignParams(), $6c21bacc9274e141$var$_.info.clickParams());
    },
    searchEngine: function searchEngine(referrer) {
        if (referrer.search('https?://(.*)google.([^/?]*)') === 0) return 'google';
        else if (referrer.search('https?://(.*)bing.com') === 0) return 'bing';
        else if (referrer.search('https?://(.*)yahoo.com') === 0) return 'yahoo';
        else if (referrer.search('https?://(.*)duckduckgo.com') === 0) return 'duckduckgo';
        else return null;
    },
    searchInfo: function searchInfo(referrer) {
        var search = $6c21bacc9274e141$var$_.info.searchEngine(referrer), param = search != 'yahoo' ? 'q' : 'p', ret = {};
        if (search !== null) {
            ret['$search_engine'] = search;
            var keyword = $6c21bacc9274e141$var$_.getQueryParam(referrer, param);
            if (keyword.length) ret['mp_keyword'] = keyword;
        }
        return ret;
    },
    /**
     * This function detects which browser is running this script.
     * The order of the checks are important since many user agents
     * include key words used in later checks.
     */ browser: function browser(user_agent, vendor, opera) {
        vendor = vendor || ''; // vendor is undefined for at least IE9
        if (opera || $6c21bacc9274e141$var$_.includes(user_agent, ' OPR/')) {
            if ($6c21bacc9274e141$var$_.includes(user_agent, 'Mini')) return 'Opera Mini';
            return 'Opera';
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return 'BlackBerry';
        else if ($6c21bacc9274e141$var$_.includes(user_agent, 'IEMobile') || $6c21bacc9274e141$var$_.includes(user_agent, 'WPDesktop')) return 'Internet Explorer Mobile';
        else if ($6c21bacc9274e141$var$_.includes(user_agent, 'SamsungBrowser/')) // https://developer.samsung.com/internet/user-agent-string-format
        return 'Samsung Internet';
        else if ($6c21bacc9274e141$var$_.includes(user_agent, 'Edge') || $6c21bacc9274e141$var$_.includes(user_agent, 'Edg/')) return 'Microsoft Edge';
        else if ($6c21bacc9274e141$var$_.includes(user_agent, 'FBIOS')) return 'Facebook Mobile';
        else if ($6c21bacc9274e141$var$_.includes(user_agent, 'Chrome')) return 'Chrome';
        else if ($6c21bacc9274e141$var$_.includes(user_agent, 'CriOS')) return 'Chrome iOS';
        else if ($6c21bacc9274e141$var$_.includes(user_agent, 'UCWEB') || $6c21bacc9274e141$var$_.includes(user_agent, 'UCBrowser')) return 'UC Browser';
        else if ($6c21bacc9274e141$var$_.includes(user_agent, 'FxiOS')) return 'Firefox iOS';
        else if ($6c21bacc9274e141$var$_.includes(vendor, 'Apple')) {
            if ($6c21bacc9274e141$var$_.includes(user_agent, 'Mobile')) return 'Mobile Safari';
            return 'Safari';
        } else if ($6c21bacc9274e141$var$_.includes(user_agent, 'Android')) return 'Android Mobile';
        else if ($6c21bacc9274e141$var$_.includes(user_agent, 'Konqueror')) return 'Konqueror';
        else if ($6c21bacc9274e141$var$_.includes(user_agent, 'Firefox')) return 'Firefox';
        else if ($6c21bacc9274e141$var$_.includes(user_agent, 'MSIE') || $6c21bacc9274e141$var$_.includes(user_agent, 'Trident/')) return 'Internet Explorer';
        else if ($6c21bacc9274e141$var$_.includes(user_agent, 'Gecko')) return 'Mozilla';
        else return '';
    },
    /**
     * This function detects which browser version is running this script,
     * parsing major and minor version (e.g., 42.1). User agent strings from:
     * http://www.useragentstring.com/pages/useragentstring.php
     */ browserVersion: function browserVersion(userAgent, vendor, opera) {
        var browser = $6c21bacc9274e141$var$_.info.browser(userAgent, vendor, opera);
        var versionRegexs = {
            'Internet Explorer Mobile': /rv:(\d+(\.\d+)?)/,
            'Microsoft Edge': /Edge?\/(\d+(\.\d+)?)/,
            Chrome: /Chrome\/(\d+(\.\d+)?)/,
            'Chrome iOS': /CriOS\/(\d+(\.\d+)?)/,
            'UC Browser': /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
            Safari: /Version\/(\d+(\.\d+)?)/,
            'Mobile Safari': /Version\/(\d+(\.\d+)?)/,
            Opera: /(Opera|OPR)\/(\d+(\.\d+)?)/,
            Firefox: /Firefox\/(\d+(\.\d+)?)/,
            'Firefox iOS': /FxiOS\/(\d+(\.\d+)?)/,
            Konqueror: /Konqueror:(\d+(\.\d+)?)/,
            BlackBerry: /BlackBerry (\d+(\.\d+)?)/,
            'Android Mobile': /android\s(\d+(\.\d+)?)/,
            'Samsung Internet': /SamsungBrowser\/(\d+(\.\d+)?)/,
            'Internet Explorer': /(rv:|MSIE )(\d+(\.\d+)?)/,
            Mozilla: /rv:(\d+(\.\d+)?)/
        };
        var regex = versionRegexs[browser];
        if (regex === undefined) return null;
        var matches = userAgent.match(regex);
        if (!matches) return null;
        return parseFloat(matches[matches.length - 2]);
    },
    os: function os() {
        var a = $6c21bacc9274e141$var$userAgent;
        if (/Windows/i.test(a)) {
            if (/Phone/.test(a) || /WPDesktop/.test(a)) return 'Windows Phone';
            return 'Windows';
        } else if (/(iPhone|iPad|iPod)/.test(a)) return 'iOS';
        else if (/Android/.test(a)) return 'Android';
        else if (/(BlackBerry|PlayBook|BB10)/i.test(a)) return 'BlackBerry';
        else if (/Mac/i.test(a)) return 'Mac OS X';
        else if (/Linux/.test(a)) return 'Linux';
        else if (/CrOS/.test(a)) return 'Chrome OS';
        else return '';
    },
    device: function device(user_agent) {
        if (/Windows Phone/i.test(user_agent) || /WPDesktop/.test(user_agent)) return 'Windows Phone';
        else if (/iPad/.test(user_agent)) return 'iPad';
        else if (/iPod/.test(user_agent)) return 'iPod Touch';
        else if (/iPhone/.test(user_agent)) return 'iPhone';
        else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return 'BlackBerry';
        else if (/Android/.test(user_agent)) return 'Android';
        else return '';
    },
    referringDomain: function referringDomain(referrer) {
        var split = referrer.split('/');
        if (split.length >= 3) return split[2];
        return '';
    },
    currentUrl: function currentUrl() {
        return $6c21bacc9274e141$var$win.location.href;
    },
    properties: function properties(extra_props) {
        if ((typeof extra_props === "undefined" ? "undefined" : (0, $qb7pP._)(extra_props)) !== 'object') extra_props = {};
        return $6c21bacc9274e141$var$_.extend($6c21bacc9274e141$var$_.strip_empty_properties({
            $os: $6c21bacc9274e141$var$_.info.os(),
            $browser: $6c21bacc9274e141$var$_.info.browser($6c21bacc9274e141$var$userAgent, $6c21bacc9274e141$var$navigator.vendor, $6c21bacc9274e141$var$windowOpera),
            $referrer: $6c21bacc9274e141$var$document$1.referrer,
            $referring_domain: $6c21bacc9274e141$var$_.info.referringDomain($6c21bacc9274e141$var$document$1.referrer),
            $device: $6c21bacc9274e141$var$_.info.device($6c21bacc9274e141$var$userAgent)
        }), {
            $current_url: $6c21bacc9274e141$var$_.info.currentUrl(),
            $browser_version: $6c21bacc9274e141$var$_.info.browserVersion($6c21bacc9274e141$var$userAgent, $6c21bacc9274e141$var$navigator.vendor, $6c21bacc9274e141$var$windowOpera),
            $screen_height: $6c21bacc9274e141$var$screen.height,
            $screen_width: $6c21bacc9274e141$var$screen.width,
            mp_lib: 'web',
            $lib_version: $6c21bacc9274e141$var$Config.LIB_VERSION,
            $insert_id: $6c21bacc9274e141$var$cheap_guid(),
            time: $6c21bacc9274e141$var$_.timestamp() / 1000 // epoch time in seconds
        }, $6c21bacc9274e141$var$_.strip_empty_properties(extra_props));
    },
    people_properties: function people_properties() {
        return $6c21bacc9274e141$var$_.extend($6c21bacc9274e141$var$_.strip_empty_properties({
            $os: $6c21bacc9274e141$var$_.info.os(),
            $browser: $6c21bacc9274e141$var$_.info.browser($6c21bacc9274e141$var$userAgent, $6c21bacc9274e141$var$navigator.vendor, $6c21bacc9274e141$var$windowOpera)
        }), {
            $browser_version: $6c21bacc9274e141$var$_.info.browserVersion($6c21bacc9274e141$var$userAgent, $6c21bacc9274e141$var$navigator.vendor, $6c21bacc9274e141$var$windowOpera)
        });
    },
    mpPageViewProperties: function mpPageViewProperties() {
        return $6c21bacc9274e141$var$_.strip_empty_properties({
            current_page_title: $6c21bacc9274e141$var$document$1.title,
            current_domain: $6c21bacc9274e141$var$win.location.hostname,
            current_url_path: $6c21bacc9274e141$var$win.location.pathname,
            current_url_protocol: $6c21bacc9274e141$var$win.location.protocol,
            current_url_search: $6c21bacc9274e141$var$win.location.search
        });
    }
};
var $6c21bacc9274e141$var$cheap_guid = function cheap_guid(maxlen) {
    var guid = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
    return maxlen ? guid.substring(0, maxlen) : guid;
};
// naive way to extract domain name (example.com) from full hostname (my.sub.example.com)
var $6c21bacc9274e141$var$SIMPLE_DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i;
// this next one attempts to account for some ccSLDs, e.g. extracting oxford.ac.uk from www.oxford.ac.uk
var $6c21bacc9274e141$var$DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i;
/**
 * Attempts to extract main domain name from full hostname, using a few blunt heuristics. For
 * common TLDs like .com/.org that always have a simple SLD.TLD structure (example.com), we
 * simply extract the last two .-separated parts of the hostname (SIMPLE_DOMAIN_MATCH_REGEX).
 * For others, we attempt to account for short ccSLD+TLD combos (.ac.uk) with the legacy
 * DOMAIN_MATCH_REGEX (kept to maintain backwards compatibility with existing Mixpanel
 * integrations). The only _reliable_ way to extract domain from hostname is with an up-to-date
 * list like at https://publicsuffix.org/ so for cases that this helper fails at, the SDK
 * offers the 'cookie_domain' config option to set it explicitly.
 * @example
 * extract_domain('my.sub.example.com')
 * // 'example.com'
 */ var $6c21bacc9274e141$var$extract_domain = function extract_domain(hostname) {
    var domain_regex = $6c21bacc9274e141$var$DOMAIN_MATCH_REGEX;
    var parts = hostname.split('.');
    var tld = parts[parts.length - 1];
    if (tld.length > 4 || tld === 'com' || tld === 'org') domain_regex = $6c21bacc9274e141$var$SIMPLE_DOMAIN_MATCH_REGEX;
    var matches = hostname.match(domain_regex);
    return matches ? matches[0] : '';
};
/**
 * Check whether we have network connection. default to true for browsers that don't support navigator.onLine (IE)
 * @returns {boolean}
 */ var $6c21bacc9274e141$var$isOnline = function isOnline() {
    var onLine = $6c21bacc9274e141$var$win.navigator['onLine'];
    return $6c21bacc9274e141$var$_.isUndefined(onLine) || onLine;
};
var $6c21bacc9274e141$var$JSONStringify = null, $6c21bacc9274e141$var$JSONParse = null;
if (typeof JSON !== 'undefined') {
    $6c21bacc9274e141$var$JSONStringify = JSON.stringify;
    $6c21bacc9274e141$var$JSONParse = JSON.parse;
}
$6c21bacc9274e141$var$JSONStringify = $6c21bacc9274e141$var$JSONStringify || $6c21bacc9274e141$var$_.JSONEncode;
$6c21bacc9274e141$var$JSONParse = $6c21bacc9274e141$var$JSONParse || $6c21bacc9274e141$var$_.JSONDecode;
// EXPORTS (for closure compiler)
$6c21bacc9274e141$var$_['toArray'] = $6c21bacc9274e141$var$_.toArray;
$6c21bacc9274e141$var$_['isObject'] = $6c21bacc9274e141$var$_.isObject;
$6c21bacc9274e141$var$_['JSONEncode'] = $6c21bacc9274e141$var$_.JSONEncode;
$6c21bacc9274e141$var$_['JSONDecode'] = $6c21bacc9274e141$var$_.JSONDecode;
$6c21bacc9274e141$var$_['isBlockedUA'] = $6c21bacc9274e141$var$_.isBlockedUA;
$6c21bacc9274e141$var$_['isEmptyObject'] = $6c21bacc9274e141$var$_.isEmptyObject;
$6c21bacc9274e141$var$_['info'] = $6c21bacc9274e141$var$_.info;
$6c21bacc9274e141$var$_['info']['device'] = $6c21bacc9274e141$var$_.info.device;
$6c21bacc9274e141$var$_['info']['browser'] = $6c21bacc9274e141$var$_.info.browser;
$6c21bacc9274e141$var$_['info']['browserVersion'] = $6c21bacc9274e141$var$_.info.browserVersion;
$6c21bacc9274e141$var$_['info']['properties'] = $6c21bacc9274e141$var$_.info.properties;
$6c21bacc9274e141$var$_['NPO'] = $6c21bacc9274e141$var$NpoPromise;
/**
 * GDPR utils
 *
 * The General Data Protection Regulation (GDPR) is a regulation in EU law on data protection
 * and privacy for all individuals within the European Union. It addresses the export of personal
 * data outside the EU. The GDPR aims primarily to give control back to citizens and residents
 * over their personal data and to simplify the regulatory environment for international business
 * by unifying the regulation within the EU.
 *
 * This set of utilities is intended to enable opt in/out functionality in the Mixpanel JS SDK.
 * These functions are used internally by the SDK and are not intended to be publicly exposed.
 */ /**
 * A function used to track a Mixpanel event (e.g. MixpanelLib.track)
 * @callback trackFunction
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 */ /** Public **/ var $6c21bacc9274e141$var$GDPR_DEFAULT_PERSISTENCE_PREFIX = '__mp_opt_in_out_';
/**
 * Opt the user in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $6c21bacc9274e141$var$optIn(token, options) {
    $6c21bacc9274e141$var$_optInOut(true, token, options);
}
/**
 * Opt the user out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-out cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-out cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-out cookie is set as secure or not
 */ function $6c21bacc9274e141$var$optOut(token, options) {
    $6c21bacc9274e141$var$_optInOut(false, token, options);
}
/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} whether the user has opted in to the given opt type
 */ function $6c21bacc9274e141$var$hasOptedIn(token, options) {
    return $6c21bacc9274e141$var$_getStorageValue(token, options) === '1';
}
/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the user has opted out of the given opt type
 */ function $6c21bacc9274e141$var$hasOptedOut(token, options) {
    if ($6c21bacc9274e141$var$_hasDoNotTrackFlagOn(options)) {
        $6c21bacc9274e141$var$console$1.warn('This browser has "Do Not Track" enabled. This will prevent the Mixpanel SDK from sending any data. To ignore the "Do Not Track" browser setting, initialize the Mixpanel instance with the config "ignore_dnt: true"');
        return true;
    }
    var optedOut = $6c21bacc9274e141$var$_getStorageValue(token, options) === '0';
    if (optedOut) $6c21bacc9274e141$var$console$1.warn('You are opted out of Mixpanel tracking. This will prevent the Mixpanel SDK from sending any data.');
    return optedOut;
}
/**
 * Wrap a MixpanelLib method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $6c21bacc9274e141$var$addOptOutCheckMixpanelLib(method) {
    return $6c21bacc9274e141$var$_addOptOutCheck(method, function(name) {
        return this.get_config(name);
    });
}
/**
 * Wrap a MixpanelPeople method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $6c21bacc9274e141$var$addOptOutCheckMixpanelPeople(method) {
    return $6c21bacc9274e141$var$_addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}
/**
 * Wrap a MixpanelGroup method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $6c21bacc9274e141$var$addOptOutCheckMixpanelGroup(method) {
    return $6c21bacc9274e141$var$_addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}
/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $6c21bacc9274e141$var$clearOptInOut(token, options) {
    options = options || {};
    $6c21bacc9274e141$var$_getStorage(options).remove($6c21bacc9274e141$var$_getStorageKey(token, options), !!options.crossSubdomainCookie, options.cookieDomain);
}
/** Private **/ /**
 * Get storage util
 * @param {Object} [options]
 * @param {string} [options.persistenceType]
 * @returns {object} either _.cookie or _.localstorage
 */ function $6c21bacc9274e141$var$_getStorage(options) {
    options = options || {};
    return options.persistenceType === 'localStorage' ? $6c21bacc9274e141$var$_.localStorage : $6c21bacc9274e141$var$_.cookie;
}
/**
 * Get the name of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the name of the cookie for the given opt type
 */ function $6c21bacc9274e141$var$_getStorageKey(token, options) {
    options = options || {};
    return (options.persistencePrefix || $6c21bacc9274e141$var$GDPR_DEFAULT_PERSISTENCE_PREFIX) + token;
}
/**
 * Get the value of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the value of the cookie for the given opt type
 */ function $6c21bacc9274e141$var$_getStorageValue(token, options) {
    return $6c21bacc9274e141$var$_getStorage(options).get($6c21bacc9274e141$var$_getStorageKey(token, options));
}
/**
 * Check whether the user has set the DNT/doNotTrack setting to true in their browser
 * @param {Object} [options]
 * @param {string} [options.window] - alternate window object to check; used to force various DNT settings in browser tests
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the DNT setting is true
 */ function $6c21bacc9274e141$var$_hasDoNotTrackFlagOn(options) {
    if (options && options.ignoreDnt) return false;
    var win$1 = options && options.window || $6c21bacc9274e141$var$win;
    var nav = win$1['navigator'] || {};
    var hasDntOn = false;
    $6c21bacc9274e141$var$_.each([
        nav['doNotTrack'],
        nav['msDoNotTrack'],
        win$1['doNotTrack']
    ], function(dntValue) {
        if ($6c21bacc9274e141$var$_.includes([
            true,
            1,
            '1',
            'yes'
        ], dntValue)) hasDntOn = true;
    });
    return hasDntOn;
}
/**
 * Set cookie/localstorage for the user indicating that they are opted in or out for the given opt type
 * @param {boolean} optValue - whether to opt the user in or out for the given opt type
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $6c21bacc9274e141$var$_optInOut(optValue, token, options) {
    if (!$6c21bacc9274e141$var$_.isString(token) || !token.length) {
        $6c21bacc9274e141$var$console$1.error('gdpr.' + (optValue ? 'optIn' : 'optOut') + ' called with an invalid token');
        return;
    }
    options = options || {};
    $6c21bacc9274e141$var$_getStorage(options).set($6c21bacc9274e141$var$_getStorageKey(token, options), optValue ? 1 : 0, $6c21bacc9274e141$var$_.isNumber(options.cookieExpiration) ? options.cookieExpiration : null, !!options.crossSubdomainCookie, !!options.secureCookie, !!options.crossSiteCookie, options.cookieDomain);
    if (options.track && optValue) options.track(options.trackEventName || '$opt_in', options.trackProperties, {
        send_immediately: true
    });
}
/**
 * Wrap a method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @param {function} getConfigValue - getter function for the Mixpanel API token and other options to be used with opt-out check
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $6c21bacc9274e141$var$_addOptOutCheck(method, getConfigValue) {
    return function() {
        var optedOut = false;
        try {
            var token = getConfigValue.call(this, 'token');
            var ignoreDnt = getConfigValue.call(this, 'ignore_dnt');
            var persistenceType = getConfigValue.call(this, 'opt_out_tracking_persistence_type');
            var persistencePrefix = getConfigValue.call(this, 'opt_out_tracking_cookie_prefix');
            var win = getConfigValue.call(this, 'window'); // used to override window during browser tests
            if (token) optedOut = $6c21bacc9274e141$var$hasOptedOut(token, {
                ignoreDnt: ignoreDnt,
                persistenceType: persistenceType,
                persistencePrefix: persistencePrefix,
                window: win
            });
        } catch (err) {
            $6c21bacc9274e141$var$console$1.error('Unexpected error when checking tracking opt-out status: ' + err);
        }
        if (!optedOut) return method.apply(this, arguments);
        var callback = arguments[arguments.length - 1];
        if (typeof callback === 'function') callback(0);
        return;
    };
}
var $6c21bacc9274e141$var$logger$4 = $6c21bacc9274e141$var$console_with_prefix('lock');
/**
 * SharedLock: a mutex built on HTML5 localStorage, to ensure that only one browser
 * window/tab at a time will be able to access shared resources.
 *
 * Based on the Alur and Taubenfeld fast lock
 * (http://www.cs.rochester.edu/research/synchronization/pseudocode/fastlock.html)
 * with an added timeout to ensure there will be eventual progress in the event
 * that a window is closed in the middle of the callback.
 *
 * Implementation based on the original version by David Wolever (https://github.com/wolever)
 * at https://gist.github.com/wolever/5fd7573d1ef6166e8f8c4af286a69432.
 *
 * @example
 * const myLock = new SharedLock('some-key');
 * myLock.withLock(function() {
 *   console.log('I hold the mutex!');
 * });
 *
 * @constructor
 */ var $6c21bacc9274e141$var$SharedLock = function SharedLock(key, options) {
    options = options || {};
    this.storageKey = key;
    this.storage = options.storage || window.localStorage;
    this.pollIntervalMS = options.pollIntervalMS || 100;
    this.timeoutMS = options.timeoutMS || 2000;
    // dependency-inject promise implementation for testing purposes
    this.promiseImpl = options.promiseImpl || $6c21bacc9274e141$var$PromisePolyfill;
};
// pass in a specific pid to test contention scenarios; otherwise
// it is chosen randomly for each acquisition attempt
$6c21bacc9274e141$var$SharedLock.prototype.withLock = function(lockedCB, pid) {
    var _$Promise = this.promiseImpl;
    return new _$Promise($6c21bacc9274e141$var$_.bind(function(resolve, reject) {
        var i = pid || new Date().getTime() + '|' + Math.random();
        var startTime = new Date().getTime();
        var key = this.storageKey;
        var pollIntervalMS = this.pollIntervalMS;
        var timeoutMS = this.timeoutMS;
        var storage = this.storage;
        var keyX = key + ':X';
        var keyY = key + ':Y';
        var keyZ = key + ':Z';
        var delay = function delay(cb) {
            if (new Date().getTime() - startTime > timeoutMS) {
                $6c21bacc9274e141$var$logger$4.error('Timeout waiting for mutex on ' + key + '; clearing lock. [' + i + ']');
                storage.removeItem(keyZ);
                storage.removeItem(keyY);
                loop();
                return;
            }
            setTimeout(function() {
                try {
                    cb();
                } catch (err) {
                    reject(err);
                }
            }, pollIntervalMS * (Math.random() + 0.1));
        };
        var waitFor = function waitFor1(predicate, cb) {
            if (predicate()) cb();
            else delay(function() {
                waitFor(predicate, cb);
            });
        };
        var getSetY = function getSetY() {
            var valY = storage.getItem(keyY);
            if (valY && valY !== i) return false;
            else {
                storage.setItem(keyY, i);
                if (storage.getItem(keyY) === i) return true;
                else {
                    if (!$6c21bacc9274e141$var$localStorageSupported(storage, true)) reject(new Error('localStorage support dropped while acquiring lock'));
                    return false;
                }
            }
        };
        var loop = function loop1() {
            storage.setItem(keyX, i);
            waitFor(getSetY, function() {
                if (storage.getItem(keyX) === i) {
                    criticalSection();
                    return;
                }
                delay(function() {
                    if (storage.getItem(keyY) !== i) {
                        loop();
                        return;
                    }
                    waitFor(function() {
                        return !storage.getItem(keyZ);
                    }, criticalSection);
                });
            });
        };
        var criticalSection = function criticalSection() {
            storage.setItem(keyZ, '1');
            var removeLock = function removeLock() {
                storage.removeItem(keyZ);
                if (storage.getItem(keyY) === i) storage.removeItem(keyY);
                if (storage.getItem(keyX) === i) storage.removeItem(keyX);
            };
            lockedCB().then(function(ret) {
                removeLock();
                resolve(ret);
            })["catch"](function(err) {
                removeLock();
                reject(err);
            });
        };
        try {
            if ($6c21bacc9274e141$var$localStorageSupported(storage, true)) loop();
            else throw new Error('localStorage support check failed');
        } catch (err) {
            reject(err);
        }
    }, this));
};
/**
 * @typedef {import('./wrapper').StorageWrapper}
 */ /**
 * @type {StorageWrapper}
 */ var $6c21bacc9274e141$var$LocalStorageWrapper = function LocalStorageWrapper(storageOverride) {
    this.storage = storageOverride || localStorage;
};
$6c21bacc9274e141$var$LocalStorageWrapper.prototype.init = function() {
    return $6c21bacc9274e141$var$PromisePolyfill.resolve();
};
$6c21bacc9274e141$var$LocalStorageWrapper.prototype.setItem = function(key, value) {
    return new $6c21bacc9274e141$var$PromisePolyfill($6c21bacc9274e141$var$_.bind(function(resolve, reject) {
        try {
            this.storage.setItem(key, value);
        } catch (e) {
            reject(e);
        }
        resolve();
    }, this));
};
$6c21bacc9274e141$var$LocalStorageWrapper.prototype.getItem = function(key) {
    return new $6c21bacc9274e141$var$PromisePolyfill($6c21bacc9274e141$var$_.bind(function(resolve, reject) {
        var item;
        try {
            item = this.storage.getItem(key);
        } catch (e) {
            reject(e);
        }
        resolve(item);
    }, this));
};
$6c21bacc9274e141$var$LocalStorageWrapper.prototype.removeItem = function(key) {
    return new $6c21bacc9274e141$var$PromisePolyfill($6c21bacc9274e141$var$_.bind(function(resolve, reject) {
        try {
            this.storage.removeItem(key);
        } catch (e) {
            reject(e);
        }
        resolve();
    }, this));
};
var $6c21bacc9274e141$var$logger$3 = $6c21bacc9274e141$var$console_with_prefix('batch');
/**
 * RequestQueue: queue for batching API requests with localStorage backup for retries.
 * Maintains an in-memory queue which represents the source of truth for the current
 * page, but also writes all items out to a copy in the browser's localStorage, which
 * can be read on subsequent pageloads and retried. For batchability, all the request
 * items in the queue should be of the same type (events, people updates, group updates)
 * so they can be sent in a single request to the same API endpoint.
 *
 * LocalStorage keying and locking: In order for reloads and subsequent pageloads of
 * the same site to access the same persisted data, they must share the same localStorage
 * key (for instance based on project token and queue type). Therefore access to the
 * localStorage entry is guarded by an asynchronous mutex (SharedLock) to prevent
 * simultaneously open windows/tabs from overwriting each other's data (which would lead
 * to data loss in some situations).
 * @constructor
 */ var $6c21bacc9274e141$var$RequestQueue = function RequestQueue(storageKey, options) {
    options = options || {};
    this.storageKey = storageKey;
    this.usePersistence = options.usePersistence;
    if (this.usePersistence) {
        this.queueStorage = options.queueStorage || new $6c21bacc9274e141$var$LocalStorageWrapper();
        this.lock = new $6c21bacc9274e141$var$SharedLock(storageKey, {
            storage: options.sharedLockStorage || window.localStorage
        });
        this.queueStorage.init();
    }
    this.reportError = options.errorReporter || $6c21bacc9274e141$var$_.bind($6c21bacc9274e141$var$logger$3.error, $6c21bacc9274e141$var$logger$3);
    this.pid = options.pid || null; // pass pid to test out storage lock contention scenarios
    this.memQueue = [];
    this.initialized = false;
};
$6c21bacc9274e141$var$RequestQueue.prototype.ensureInit = function() {
    if (this.initialized) return $6c21bacc9274e141$var$PromisePolyfill.resolve();
    return this.queueStorage.init().then($6c21bacc9274e141$var$_.bind(function() {
        this.initialized = true;
    }, this))["catch"]($6c21bacc9274e141$var$_.bind(function(err) {
        this.reportError('Error initializing queue persistence. Disabling persistence', err);
        this.initialized = true;
        this.usePersistence = false;
    }, this));
};
/**
 * Add one item to queues (memory and localStorage). The queued entry includes
 * the given item along with an auto-generated ID and a "flush-after" timestamp.
 * It is expected that the item will be sent over the network and dequeued
 * before the flush-after time; if this doesn't happen it is considered orphaned
 * (e.g., the original tab where it was enqueued got closed before it could be
 * sent) and the item can be sent by any tab that finds it in localStorage.
 *
 * The final callback param is called with a param indicating success or
 * failure of the enqueue operation; it is asynchronous because the localStorage
 * lock is asynchronous.
 */ $6c21bacc9274e141$var$RequestQueue.prototype.enqueue = function(item, flushInterval) {
    var queueEntry = {
        id: $6c21bacc9274e141$var$cheap_guid(),
        flushAfter: new Date().getTime() + flushInterval * 2,
        payload: item
    };
    if (!this.usePersistence) {
        this.memQueue.push(queueEntry);
        return $6c21bacc9274e141$var$PromisePolyfill.resolve(true);
    } else {
        var enqueueItem = $6c21bacc9274e141$var$_.bind(function() {
            return this.ensureInit().then($6c21bacc9274e141$var$_.bind(function() {
                return this.readFromStorage();
            }, this)).then($6c21bacc9274e141$var$_.bind(function(storedQueue) {
                storedQueue.push(queueEntry);
                return this.saveToStorage(storedQueue);
            }, this)).then($6c21bacc9274e141$var$_.bind(function(succeeded) {
                // only add to in-memory queue when storage succeeds
                if (succeeded) this.memQueue.push(queueEntry);
                return succeeded;
            }, this))["catch"]($6c21bacc9274e141$var$_.bind(function(err) {
                this.reportError('Error enqueueing item', err, item);
                return false;
            }, this));
        }, this);
        return this.lock.withLock(enqueueItem, this.pid)["catch"]($6c21bacc9274e141$var$_.bind(function(err) {
            this.reportError('Error acquiring storage lock', err);
            return false;
        }, this));
    }
};
/**
 * Read out the given number of queue entries. If this.memQueue
 * has fewer than batchSize items, then look for "orphaned" items
 * in the persisted queue (items where the 'flushAfter' time has
 * already passed).
 */ $6c21bacc9274e141$var$RequestQueue.prototype.fillBatch = function(batchSize) {
    var batch = this.memQueue.slice(0, batchSize);
    if (this.usePersistence && batch.length < batchSize) // don't need lock just to read events; localStorage is thread-safe
    // and the worst that could happen is a duplicate send of some
    // orphaned events, which will be deduplicated on the server side
    return this.ensureInit().then($6c21bacc9274e141$var$_.bind(function() {
        return this.readFromStorage();
    }, this)).then($6c21bacc9274e141$var$_.bind(function(storedQueue) {
        if (storedQueue.length) {
            // item IDs already in batch; don't duplicate out of storage
            var idsInBatch = {}; // poor man's Set
            $6c21bacc9274e141$var$_.each(batch, function(item) {
                idsInBatch[item['id']] = true;
            });
            for(var i = 0; i < storedQueue.length; i++){
                var item = storedQueue[i];
                if (new Date().getTime() > item['flushAfter'] && !idsInBatch[item['id']]) {
                    item.orphaned = true;
                    batch.push(item);
                    if (batch.length >= batchSize) break;
                }
            }
        }
        return batch;
    }, this));
    else return $6c21bacc9274e141$var$PromisePolyfill.resolve(batch);
};
/**
 * Remove items with matching 'id' from array (immutably)
 * also remove any item without a valid id (e.g., malformed
 * storage entries).
 */ var $6c21bacc9274e141$var$filterOutIDsAndInvalid = function filterOutIDsAndInvalid(items, idSet) {
    var filteredItems = [];
    $6c21bacc9274e141$var$_.each(items, function(item) {
        if (item['id'] && !idSet[item['id']]) filteredItems.push(item);
    });
    return filteredItems;
};
/**
 * Remove items with matching IDs from both in-memory queue
 * and persisted queue
 */ $6c21bacc9274e141$var$RequestQueue.prototype.removeItemsByID = function(ids) {
    var idSet = {}; // poor man's Set
    $6c21bacc9274e141$var$_.each(ids, function(id) {
        idSet[id] = true;
    });
    this.memQueue = $6c21bacc9274e141$var$filterOutIDsAndInvalid(this.memQueue, idSet);
    if (!this.usePersistence) return $6c21bacc9274e141$var$PromisePolyfill.resolve(true);
    else {
        var removeFromStorage = $6c21bacc9274e141$var$_.bind(function() {
            return this.ensureInit().then($6c21bacc9274e141$var$_.bind(function() {
                return this.readFromStorage();
            }, this)).then($6c21bacc9274e141$var$_.bind(function(storedQueue) {
                storedQueue = $6c21bacc9274e141$var$filterOutIDsAndInvalid(storedQueue, idSet);
                return this.saveToStorage(storedQueue);
            }, this)).then($6c21bacc9274e141$var$_.bind(function() {
                return this.readFromStorage();
            }, this)).then($6c21bacc9274e141$var$_.bind(function(storedQueue) {
                // an extra check: did storage report success but somehow
                // the items are still there?
                for(var i = 0; i < storedQueue.length; i++){
                    var item = storedQueue[i];
                    if (item['id'] && !!idSet[item['id']]) throw new Error('Item not removed from storage');
                }
                return true;
            }, this))["catch"]($6c21bacc9274e141$var$_.bind(function(err) {
                this.reportError('Error removing items', err, ids);
                return false;
            }, this));
        }, this);
        return this.lock.withLock(removeFromStorage, this.pid)["catch"]($6c21bacc9274e141$var$_.bind(function(err) {
            this.reportError('Error acquiring storage lock', err);
            if (!$6c21bacc9274e141$var$localStorageSupported(this.queueStorage.storage, true)) // Looks like localStorage writes have stopped working sometime after
            // initialization (probably full), and so nobody can acquire locks
            // anymore. Consider it temporarily safe to remove items without the
            // lock, since nobody's writing successfully anyway.
            return removeFromStorage().then($6c21bacc9274e141$var$_.bind(function(success) {
                if (!success) // OK, we couldn't even write out the smaller queue. Try clearing it
                // entirely.
                return this.queueStorage.removeItem(this.storageKey).then(function() {
                    return success;
                });
                return success;
            }, this))["catch"]($6c21bacc9274e141$var$_.bind(function(err) {
                this.reportError('Error clearing queue', err);
                return false;
            }, this));
            else return false;
        }, this));
    }
};
// internal helper for RequestQueue.updatePayloads
var $6c21bacc9274e141$var$updatePayloads = function updatePayloads(existingItems, itemsToUpdate) {
    var newItems = [];
    $6c21bacc9274e141$var$_.each(existingItems, function(item) {
        var id = item['id'];
        if (id in itemsToUpdate) {
            var newPayload = itemsToUpdate[id];
            if (newPayload !== null) {
                item['payload'] = newPayload;
                newItems.push(item);
            }
        } else // no update
        newItems.push(item);
    });
    return newItems;
};
/**
 * Update payloads of given items in both in-memory queue and
 * persisted queue. Items set to null are removed from queues.
 */ $6c21bacc9274e141$var$RequestQueue.prototype.updatePayloads = function(itemsToUpdate) {
    this.memQueue = $6c21bacc9274e141$var$updatePayloads(this.memQueue, itemsToUpdate);
    if (!this.usePersistence) return $6c21bacc9274e141$var$PromisePolyfill.resolve(true);
    else return this.lock.withLock($6c21bacc9274e141$var$_.bind(function lockAcquired() {
        return this.ensureInit().then($6c21bacc9274e141$var$_.bind(function() {
            return this.readFromStorage();
        }, this)).then($6c21bacc9274e141$var$_.bind(function(storedQueue) {
            storedQueue = $6c21bacc9274e141$var$updatePayloads(storedQueue, itemsToUpdate);
            return this.saveToStorage(storedQueue);
        }, this))["catch"]($6c21bacc9274e141$var$_.bind(function(err) {
            this.reportError('Error updating items', itemsToUpdate, err);
            return false;
        }, this));
    }, this), this.pid)["catch"]($6c21bacc9274e141$var$_.bind(function(err) {
        this.reportError('Error acquiring storage lock', err);
        return false;
    }, this));
};
/**
 * Read and parse items array from localStorage entry, handling
 * malformed/missing data if necessary.
 */ $6c21bacc9274e141$var$RequestQueue.prototype.readFromStorage = function() {
    return this.ensureInit().then($6c21bacc9274e141$var$_.bind(function() {
        return this.queueStorage.getItem(this.storageKey);
    }, this)).then($6c21bacc9274e141$var$_.bind(function(storageEntry) {
        if (storageEntry) {
            storageEntry = $6c21bacc9274e141$var$JSONParse(storageEntry);
            if (!$6c21bacc9274e141$var$_.isArray(storageEntry)) {
                this.reportError('Invalid storage entry:', storageEntry);
                storageEntry = null;
            }
        }
        return storageEntry || [];
    }, this))["catch"]($6c21bacc9274e141$var$_.bind(function(err) {
        this.reportError('Error retrieving queue', err);
        return [];
    }, this));
};
/**
 * Serialize the given items array to localStorage.
 */ $6c21bacc9274e141$var$RequestQueue.prototype.saveToStorage = function(queue) {
    try {
        var serialized = $6c21bacc9274e141$var$JSONStringify(queue);
    } catch (err) {
        this.reportError('Error serializing queue', err);
        return $6c21bacc9274e141$var$PromisePolyfill.resolve(false);
    }
    return this.ensureInit().then($6c21bacc9274e141$var$_.bind(function() {
        return this.queueStorage.setItem(this.storageKey, serialized);
    }, this)).then(function() {
        return true;
    })["catch"]($6c21bacc9274e141$var$_.bind(function(err) {
        this.reportError('Error saving queue', err);
        return false;
    }, this));
};
/**
 * Clear out queues (memory and localStorage).
 */ $6c21bacc9274e141$var$RequestQueue.prototype.clear = function() {
    this.memQueue = [];
    if (this.usePersistence) return this.ensureInit().then($6c21bacc9274e141$var$_.bind(function() {
        return this.queueStorage.removeItem(this.storageKey);
    }, this));
    else return $6c21bacc9274e141$var$PromisePolyfill.resolve();
};
// maximum interval between request retries after exponential backoff
var $6c21bacc9274e141$var$MAX_RETRY_INTERVAL_MS = 600000; // 10 minutes
var $6c21bacc9274e141$var$logger$2 = $6c21bacc9274e141$var$console_with_prefix('batch');
/**
 * RequestBatcher: manages the queueing, flushing, retry etc of requests of one
 * type (events, people, groups).
 * Uses RequestQueue to manage the backing store.
 * @constructor
 */ var $6c21bacc9274e141$var$RequestBatcher = function RequestBatcher(storageKey, options) {
    this.errorReporter = options.errorReporter;
    this.queue = new $6c21bacc9274e141$var$RequestQueue(storageKey, {
        errorReporter: $6c21bacc9274e141$var$_.bind(this.reportError, this),
        queueStorage: options.queueStorage,
        sharedLockStorage: options.sharedLockStorage,
        usePersistence: options.usePersistence
    });
    this.libConfig = options.libConfig;
    this.sendRequest = options.sendRequestFunc;
    this.beforeSendHook = options.beforeSendHook;
    this.stopAllBatching = options.stopAllBatchingFunc;
    // seed variable batch size + flush interval with configured values
    this.batchSize = this.libConfig['batch_size'];
    this.flushInterval = this.libConfig['batch_flush_interval_ms'];
    this.stopped = !this.libConfig['batch_autostart'];
    this.consecutiveRemovalFailures = 0;
    // extra client-side dedupe
    this.itemIdsSentSuccessfully = {};
    // Make the flush occur at the interval specified by flushIntervalMs, default behavior will attempt consecutive flushes
    // as long as the queue is not empty. This is useful for high-frequency events like Session Replay where we might end up
    // in a request loop and get ratelimited by the server.
    this.flushOnlyOnInterval = options.flushOnlyOnInterval || false;
};
/**
 * Add one item to queue.
 */ $6c21bacc9274e141$var$RequestBatcher.prototype.enqueue = function(item) {
    return this.queue.enqueue(item, this.flushInterval);
};
/**
 * Start flushing batches at the configured time interval. Must call
 * this method upon SDK init in order to send anything over the network.
 */ $6c21bacc9274e141$var$RequestBatcher.prototype.start = function() {
    this.stopped = false;
    this.consecutiveRemovalFailures = 0;
    return this.flush();
};
/**
 * Stop flushing batches. Can be restarted by calling start().
 */ $6c21bacc9274e141$var$RequestBatcher.prototype.stop = function() {
    this.stopped = true;
    if (this.timeoutID) {
        clearTimeout(this.timeoutID);
        this.timeoutID = null;
    }
};
/**
 * Clear out queue.
 */ $6c21bacc9274e141$var$RequestBatcher.prototype.clear = function() {
    return this.queue.clear();
};
/**
 * Restore batch size configuration to whatever is set in the main SDK.
 */ $6c21bacc9274e141$var$RequestBatcher.prototype.resetBatchSize = function() {
    this.batchSize = this.libConfig['batch_size'];
};
/**
 * Restore flush interval time configuration to whatever is set in the main SDK.
 */ $6c21bacc9274e141$var$RequestBatcher.prototype.resetFlush = function() {
    this.scheduleFlush(this.libConfig['batch_flush_interval_ms']);
};
/**
 * Schedule the next flush in the given number of milliseconds.
 */ $6c21bacc9274e141$var$RequestBatcher.prototype.scheduleFlush = function(flushMS) {
    this.flushInterval = flushMS;
    if (!this.stopped) this.timeoutID = setTimeout($6c21bacc9274e141$var$_.bind(function() {
        if (!this.stopped) this.flush();
    }, this), this.flushInterval);
};
/**
 * Send a request using the sendRequest callback, but promisified.
 * TODO: sendRequest should be promisified in the first place.
 */ $6c21bacc9274e141$var$RequestBatcher.prototype.sendRequestPromise = function(data, options) {
    return new $6c21bacc9274e141$var$PromisePolyfill($6c21bacc9274e141$var$_.bind(function(resolve) {
        this.sendRequest(data, options, resolve);
    }, this));
};
/**
 * Flush one batch to network. Depending on success/failure modes, it will either
 * remove the batch from the queue or leave it in for retry, and schedule the next
 * flush. In cases of most network or API failures, it will back off exponentially
 * when retrying.
 * @param {Object} [options]
 * @param {boolean} [options.sendBeacon] - whether to send batch with
 * navigator.sendBeacon (only useful for sending batches before page unloads, as
 * sendBeacon offers no callbacks or status indications)
 */ $6c21bacc9274e141$var$RequestBatcher.prototype.flush = function(options) {
    if (this.requestInProgress) {
        $6c21bacc9274e141$var$logger$2.log('Flush: Request already in progress');
        return $6c21bacc9274e141$var$PromisePolyfill.resolve();
    }
    this.requestInProgress = true;
    options = options || {};
    var timeoutMS = this.libConfig['batch_request_timeout_ms'];
    var startTime = new Date().getTime();
    var currentBatchSize = this.batchSize;
    return this.queue.fillBatch(currentBatchSize).then($6c21bacc9274e141$var$_.bind(function(batch) {
        // if there's more items in the queue than the batch size, attempt
        // to flush again after the current batch is done.
        var attemptSecondaryFlush = batch.length === currentBatchSize;
        var dataForRequest = [];
        var transformedItems = {};
        $6c21bacc9274e141$var$_.each(batch, function(item) {
            var payload = item['payload'];
            if (this.beforeSendHook && !item.orphaned) payload = this.beforeSendHook(payload);
            if (payload) {
                // mp_sent_by_lib_version prop captures which lib version actually
                // sends each event (regardless of which version originally queued
                // it for sending)
                if (payload['event'] && payload['properties']) payload['properties'] = $6c21bacc9274e141$var$_.extend({}, payload['properties'], {
                    mp_sent_by_lib_version: $6c21bacc9274e141$var$Config.LIB_VERSION
                });
                var addPayload = true;
                var itemId = item['id'];
                if (itemId) {
                    if ((this.itemIdsSentSuccessfully[itemId] || 0) > 5) {
                        this.reportError('[dupe] item ID sent too many times, not sending', {
                            item: item,
                            batchSize: batch.length,
                            timesSent: this.itemIdsSentSuccessfully[itemId]
                        });
                        addPayload = false;
                    }
                } else this.reportError('[dupe] found item with no ID', {
                    item: item
                });
                if (addPayload) dataForRequest.push(payload);
            }
            transformedItems[item['id']] = payload;
        }, this);
        if (dataForRequest.length < 1) {
            this.requestInProgress = false;
            this.resetFlush();
            return $6c21bacc9274e141$var$PromisePolyfill.resolve(); // nothing to do
        }
        var removeItemsFromQueue = $6c21bacc9274e141$var$_.bind(function() {
            return this.queue.removeItemsByID($6c21bacc9274e141$var$_.map(batch, function(item) {
                return item['id'];
            })).then($6c21bacc9274e141$var$_.bind(function(succeeded) {
                // client-side dedupe
                $6c21bacc9274e141$var$_.each(batch, $6c21bacc9274e141$var$_.bind(function(item) {
                    var itemId = item['id'];
                    if (itemId) {
                        this.itemIdsSentSuccessfully[itemId] = this.itemIdsSentSuccessfully[itemId] || 0;
                        this.itemIdsSentSuccessfully[itemId]++;
                        if (this.itemIdsSentSuccessfully[itemId] > 5) this.reportError('[dupe] item ID sent too many times', {
                            item: item,
                            batchSize: batch.length,
                            timesSent: this.itemIdsSentSuccessfully[itemId]
                        });
                    } else this.reportError('[dupe] found item with no ID while removing', {
                        item: item
                    });
                }, this));
                if (succeeded) {
                    this.consecutiveRemovalFailures = 0;
                    if (this.flushOnlyOnInterval && !attemptSecondaryFlush) {
                        this.resetFlush(); // schedule next batch with a delay
                        return $6c21bacc9274e141$var$PromisePolyfill.resolve();
                    } else return this.flush(); // handle next batch if the queue isn't empty
                } else {
                    if (++this.consecutiveRemovalFailures > 5) {
                        this.reportError('Too many queue failures; disabling batching system.');
                        this.stopAllBatching();
                    } else this.resetFlush();
                    return $6c21bacc9274e141$var$PromisePolyfill.resolve();
                }
            }, this));
        }, this);
        var batchSendCallback = $6c21bacc9274e141$var$_.bind(function(res) {
            this.requestInProgress = false;
            try {
                // handle API response in a try-catch to make sure we can reset the
                // flush operation if something goes wrong
                if (options.unloading) // update persisted data to include hook transformations
                return this.queue.updatePayloads(transformedItems);
                else if ($6c21bacc9274e141$var$_.isObject(res) && res.error === 'timeout' && new Date().getTime() - startTime >= timeoutMS) {
                    this.reportError('Network timeout; retrying');
                    return this.flush();
                } else if ($6c21bacc9274e141$var$_.isObject(res) && (res.httpStatusCode >= 500 || res.httpStatusCode === 429 || res.httpStatusCode <= 0 && !$6c21bacc9274e141$var$isOnline() || res.error === 'timeout')) {
                    // network or API error, or 429 Too Many Requests, retry
                    var retryMS = this.flushInterval * 2;
                    if (res.retryAfter) retryMS = parseInt(res.retryAfter, 10) * 1000 || retryMS;
                    retryMS = Math.min($6c21bacc9274e141$var$MAX_RETRY_INTERVAL_MS, retryMS);
                    this.reportError('Error; retry in ' + retryMS + ' ms');
                    this.scheduleFlush(retryMS);
                    return $6c21bacc9274e141$var$PromisePolyfill.resolve();
                } else if ($6c21bacc9274e141$var$_.isObject(res) && res.httpStatusCode === 413) {
                    // 413 Payload Too Large
                    if (batch.length > 1) {
                        var halvedBatchSize = Math.max(1, Math.floor(currentBatchSize / 2));
                        this.batchSize = Math.min(this.batchSize, halvedBatchSize, batch.length - 1);
                        this.reportError('413 response; reducing batch size to ' + this.batchSize);
                        this.resetFlush();
                        return $6c21bacc9274e141$var$PromisePolyfill.resolve();
                    } else {
                        this.reportError('Single-event request too large; dropping', batch);
                        this.resetBatchSize();
                        return removeItemsFromQueue();
                    }
                } else // successful network request+response; remove each item in batch from queue
                // (even if it was e.g. a 400, in which case retrying won't help)
                return removeItemsFromQueue();
            } catch (err) {
                this.reportError('Error handling API response', err);
                this.resetFlush();
            }
        }, this);
        var requestOptions = {
            method: 'POST',
            verbose: true,
            ignore_json_errors: true,
            timeout_ms: timeoutMS // eslint-disable-line camelcase
        };
        if (options.unloading) requestOptions.transport = 'sendBeacon';
        $6c21bacc9274e141$var$logger$2.log('MIXPANEL REQUEST:', dataForRequest);
        return this.sendRequestPromise(dataForRequest, requestOptions).then(batchSendCallback);
    }, this))["catch"]($6c21bacc9274e141$var$_.bind(function(err) {
        this.reportError('Error flushing request queue', err);
        this.resetFlush();
    }, this));
};
/**
 * Log error to global logger and optional user-defined logger.
 */ $6c21bacc9274e141$var$RequestBatcher.prototype.reportError = function(msg, err) {
    $6c21bacc9274e141$var$logger$2.error.apply($6c21bacc9274e141$var$logger$2.error, arguments);
    if (this.errorReporter) try {
        if (!(err instanceof Error)) err = new Error(msg);
        this.errorReporter(msg, err);
    } catch (err) {
        $6c21bacc9274e141$var$logger$2.error(err);
    }
};
var $6c21bacc9274e141$var$logger$1 = $6c21bacc9274e141$var$console_with_prefix('recorder');
var $6c21bacc9274e141$var$CompressionStream = $6c21bacc9274e141$var$win['CompressionStream'];
var $6c21bacc9274e141$var$RECORDER_BATCHER_LIB_CONFIG = {
    batch_size: 1000,
    batch_flush_interval_ms: 10000,
    batch_request_timeout_ms: 90000,
    batch_autostart: true
};
var $6c21bacc9274e141$var$ACTIVE_SOURCES = new Set([
    $6c21bacc9274e141$var$IncrementalSource.MouseMove,
    $6c21bacc9274e141$var$IncrementalSource.MouseInteraction,
    $6c21bacc9274e141$var$IncrementalSource.Scroll,
    $6c21bacc9274e141$var$IncrementalSource.ViewportResize,
    $6c21bacc9274e141$var$IncrementalSource.Input,
    $6c21bacc9274e141$var$IncrementalSource.TouchMove,
    $6c21bacc9274e141$var$IncrementalSource.MediaInteraction,
    $6c21bacc9274e141$var$IncrementalSource.Drag,
    $6c21bacc9274e141$var$IncrementalSource.Selection
]);
function $6c21bacc9274e141$var$isUserEvent(ev) {
    return ev.type === $6c21bacc9274e141$var$EventType.IncrementalSnapshot && $6c21bacc9274e141$var$ACTIVE_SOURCES.has(ev.data.source);
}
/**
 * This class encapsulates a single session recording and its lifecycle.
 * @param {Object} [options.mixpanelInstance] - reference to the core MixpanelLib
 * @param {String} [options.replayId] - unique uuid for a single replay
 * @param {Function} [options.onIdleTimeout] - callback when a recording reaches idle timeout
 * @param {Function} [options.onMaxLengthReached] - callback when a recording reaches its maximum length
 * @param {Function} [options.rrwebRecord] - rrweb's `record` function
 */ var $6c21bacc9274e141$var$SessionRecording = function SessionRecording(options) {
    this._mixpanel = options.mixpanelInstance;
    this._onIdleTimeout = options.onIdleTimeout;
    this._onMaxLengthReached = options.onMaxLengthReached;
    this._rrwebRecord = options.rrwebRecord;
    this.replayId = options.replayId;
    // internal rrweb stopRecording function
    this._stopRecording = null;
    this.seqNo = 0;
    this.replayStartTime = null;
    this.replayStartUrl = null;
    this.batchStartUrl = null;
    this.idleTimeoutId = null;
    this.maxTimeoutId = null;
    this.recordMaxMs = $6c21bacc9274e141$var$MAX_RECORDING_MS;
    this.recordMinMs = 0;
    // each replay has its own batcher key to avoid conflicts between rrweb events of different recordings
    // this will be important when persistence is introduced
    var batcherKey = '__mprec_' + this.getConfig('token') + '_' + this.replayId;
    this.batcher = new $6c21bacc9274e141$var$RequestBatcher(batcherKey, {
        errorReporter: $6c21bacc9274e141$var$_.bind(this.reportError, this),
        flushOnlyOnInterval: true,
        libConfig: $6c21bacc9274e141$var$RECORDER_BATCHER_LIB_CONFIG,
        sendRequestFunc: $6c21bacc9274e141$var$_.bind(this.flushEventsWithOptOut, this),
        usePersistence: false
    });
};
$6c21bacc9274e141$var$SessionRecording.prototype.getConfig = function(configVar) {
    return this._mixpanel.get_config(configVar);
};
// Alias for getConfig, used by the common addOptOutCheckMixpanelLib function which
// reaches into this class instance and expects the snake case version of the function.
// eslint-disable-next-line camelcase
$6c21bacc9274e141$var$SessionRecording.prototype.get_config = function(configVar) {
    return this.getConfig(configVar);
};
$6c21bacc9274e141$var$SessionRecording.prototype.startRecording = function(shouldStopBatcher) {
    if (this._stopRecording !== null) {
        $6c21bacc9274e141$var$logger$1.log('Recording already in progress, skipping startRecording.');
        return;
    }
    this.recordMaxMs = this.getConfig('record_max_ms');
    if (this.recordMaxMs > $6c21bacc9274e141$var$MAX_RECORDING_MS) {
        this.recordMaxMs = $6c21bacc9274e141$var$MAX_RECORDING_MS;
        $6c21bacc9274e141$var$logger$1.critical('record_max_ms cannot be greater than ' + $6c21bacc9274e141$var$MAX_RECORDING_MS + 'ms. Capping value.');
    }
    this.recordMinMs = this.getConfig('record_min_ms');
    if (this.recordMinMs > $6c21bacc9274e141$var$MAX_VALUE_FOR_MIN_RECORDING_MS) {
        this.recordMinMs = $6c21bacc9274e141$var$MAX_VALUE_FOR_MIN_RECORDING_MS;
        $6c21bacc9274e141$var$logger$1.critical('record_min_ms cannot be greater than ' + $6c21bacc9274e141$var$MAX_VALUE_FOR_MIN_RECORDING_MS + 'ms. Capping value.');
    }
    this.replayStartTime = new Date().getTime();
    this.batchStartUrl = $6c21bacc9274e141$var$_.info.currentUrl();
    this.replayStartUrl = $6c21bacc9274e141$var$_.info.currentUrl();
    if (shouldStopBatcher || this.recordMinMs > 0) // the primary case for shouldStopBatcher is when we're starting recording after a reset
    // and don't want to send anything over the network until there's
    // actual user activity
    // this also applies if the minimum recording length has not been hit yet
    // so that we don't send data until we know the recording will be long enough
    this.batcher.stop();
    else this.batcher.start();
    var resetIdleTimeout = $6c21bacc9274e141$var$_.bind(function() {
        clearTimeout(this.idleTimeoutId);
        this.idleTimeoutId = setTimeout(this._onIdleTimeout, this.getConfig('record_idle_timeout_ms'));
    }, this);
    var blockSelector = this.getConfig('record_block_selector');
    if (blockSelector === '' || blockSelector === null) blockSelector = undefined;
    this._stopRecording = this._rrwebRecord({
        emit: $6c21bacc9274e141$var$_.bind(function(ev) {
            this.batcher.enqueue(ev);
            if ($6c21bacc9274e141$var$isUserEvent(ev)) {
                if (this.batcher.stopped && new Date().getTime() - this.replayStartTime >= this.recordMinMs) // start flushing again after user activity
                this.batcher.start();
                resetIdleTimeout();
            }
        }, this),
        blockClass: this.getConfig('record_block_class'),
        blockSelector: blockSelector,
        collectFonts: this.getConfig('record_collect_fonts'),
        dataURLOptions: {
            type: 'image/webp',
            quality: 0.6
        },
        maskAllInputs: true,
        maskTextClass: this.getConfig('record_mask_text_class'),
        maskTextSelector: this.getConfig('record_mask_text_selector'),
        recordCanvas: this.getConfig('record_canvas'),
        sampling: {
            canvas: 15
        }
    });
    if (typeof this._stopRecording !== 'function') {
        this.reportError('rrweb failed to start, skipping this recording.');
        this._stopRecording = null;
        this.stopRecording(); // stop batcher looping and any timeouts
        return;
    }
    resetIdleTimeout();
    this.maxTimeoutId = setTimeout($6c21bacc9274e141$var$_.bind(this._onMaxLengthReached, this), this.recordMaxMs);
};
$6c21bacc9274e141$var$SessionRecording.prototype.stopRecording = function() {
    if (!this.isRrwebStopped()) {
        try {
            this._stopRecording();
        } catch (err) {
            this.reportError('Error with rrweb stopRecording', err);
        }
        this._stopRecording = null;
    }
    if (this.batcher.stopped) // never got user activity to flush after reset, so just clear the batcher
    this.batcher.clear();
    else {
        // flush any remaining events from running batcher
        this.batcher.flush();
        this.batcher.stop();
    }
    clearTimeout(this.idleTimeoutId);
    clearTimeout(this.maxTimeoutId);
};
$6c21bacc9274e141$var$SessionRecording.prototype.isRrwebStopped = function() {
    return this._stopRecording === null;
};
/**
 * Flushes the current batch of events to the server, but passes an opt-out callback to make sure
 * we stop recording and dump any queued events if the user has opted out.
 */ $6c21bacc9274e141$var$SessionRecording.prototype.flushEventsWithOptOut = function(data, options, cb) {
    this._flushEvents(data, options, cb, $6c21bacc9274e141$var$_.bind(this._onOptOut, this));
};
$6c21bacc9274e141$var$SessionRecording.prototype._onOptOut = function(code) {
    // addOptOutCheckMixpanelLib invokes this function with code=0 when the user has opted out
    if (code === 0) this.stopRecording();
};
$6c21bacc9274e141$var$SessionRecording.prototype._sendRequest = function(currentReplayId, reqParams, reqBody, callback) {
    var onSuccess = $6c21bacc9274e141$var$_.bind(function(response, responseBody) {
        // Update batch specific props only if the request was successful to guarantee ordering.
        // RequestBatcher will always flush the next batch after the previous one succeeds.
        // extra check to see if the replay ID has changed so that we don't increment the seqNo on the wrong replay
        if (response.status === 200 && this.replayId === currentReplayId) {
            this.seqNo++;
            this.batchStartUrl = $6c21bacc9274e141$var$_.info.currentUrl();
        }
        callback({
            status: 0,
            httpStatusCode: response.status,
            responseBody: responseBody,
            retryAfter: response.headers.get('Retry-After')
        });
    }, this);
    $6c21bacc9274e141$var$win['fetch'](this.getConfig('api_host') + '/' + this.getConfig('api_routes')['record'] + '?' + new URLSearchParams(reqParams), {
        method: 'POST',
        headers: {
            Authorization: 'Basic ' + btoa(this.getConfig('token') + ':'),
            'Content-Type': 'application/octet-stream'
        },
        body: reqBody
    }).then(function(response) {
        response.json().then(function(responseBody) {
            onSuccess(response, responseBody);
        })["catch"](function(error) {
            callback({
                error: error
            });
        });
    })["catch"](function(error) {
        callback({
            error: error,
            httpStatusCode: 0
        });
    });
};
$6c21bacc9274e141$var$SessionRecording.prototype._flushEvents = $6c21bacc9274e141$var$addOptOutCheckMixpanelLib(function(data, options, callback) {
    var numEvents = data.length;
    if (numEvents > 0) {
        var replayId = this.replayId;
        // each rrweb event has a timestamp - leverage those to get time properties
        var batchStartTime = data[0].timestamp;
        if (this.seqNo === 0 || !this.replayStartTime) {
            // extra safety net so that we don't send a null replay start time
            if (this.seqNo !== 0) this.reportError('Replay start time not set but seqNo is not 0. Using current batch start time as a fallback.');
            this.replayStartTime = batchStartTime;
        }
        var replayLengthMs = data[numEvents - 1].timestamp - this.replayStartTime;
        var reqParams = {
            $current_url: this.batchStartUrl,
            $lib_version: $6c21bacc9274e141$var$Config.LIB_VERSION,
            batch_start_time: batchStartTime / 1000,
            distinct_id: String(this._mixpanel.get_distinct_id()),
            mp_lib: 'web',
            replay_id: replayId,
            replay_length_ms: replayLengthMs,
            replay_start_time: this.replayStartTime / 1000,
            replay_start_url: this.replayStartUrl,
            seq: this.seqNo
        };
        var eventsJson = $6c21bacc9274e141$var$_.JSONEncode(data);
        // send ID management props if they exist
        var deviceId = this._mixpanel.get_property('$device_id');
        if (deviceId) reqParams['$device_id'] = deviceId;
        var userId = this._mixpanel.get_property('$user_id');
        if (userId) reqParams['$user_id'] = userId;
        if ($6c21bacc9274e141$var$CompressionStream) {
            var jsonStream = new Blob([
                eventsJson
            ], {
                type: 'application/json'
            }).stream();
            var gzipStream = jsonStream.pipeThrough(new $6c21bacc9274e141$var$CompressionStream('gzip'));
            new Response(gzipStream).blob().then($6c21bacc9274e141$var$_.bind(function(compressedBlob) {
                reqParams['format'] = 'gzip';
                this._sendRequest(replayId, reqParams, compressedBlob, callback);
            }, this));
        } else {
            reqParams['format'] = 'body';
            this._sendRequest(replayId, reqParams, eventsJson, callback);
        }
    }
});
$6c21bacc9274e141$var$SessionRecording.prototype.reportError = function(msg, err) {
    $6c21bacc9274e141$var$logger$1.error.apply($6c21bacc9274e141$var$logger$1.error, arguments);
    try {
        if (!err && !(msg instanceof Error)) msg = new Error(msg);
        this.getConfig('error_reporter')(msg, err);
    } catch (err) {
        $6c21bacc9274e141$var$logger$1.error(err);
    }
};
var $6c21bacc9274e141$var$logger = $6c21bacc9274e141$var$console_with_prefix('recorder');
/**
 * Recorder API: manages recordings and exposes methods public to the core Mixpanel library.
 * @param {Object} [options.mixpanelInstance] - reference to the core MixpanelLib
 */ var $6c21bacc9274e141$var$MixpanelRecorder = function MixpanelRecorder(mixpanelInstance) {
    this._mixpanel = mixpanelInstance;
    this.activeRecording = null;
};
$6c21bacc9274e141$var$MixpanelRecorder.prototype.startRecording = function(shouldStopBatcher) {
    if (this.activeRecording && !this.activeRecording.isRrwebStopped()) {
        $6c21bacc9274e141$var$logger.log('Recording already in progress, skipping startRecording.');
        return;
    }
    var onIdleTimeout = $6c21bacc9274e141$var$_.bind(function() {
        $6c21bacc9274e141$var$logger.log('Idle timeout reached, restarting recording.');
        this.resetRecording();
    }, this);
    var onMaxLengthReached = $6c21bacc9274e141$var$_.bind(function() {
        $6c21bacc9274e141$var$logger.log('Max recording length reached, stopping recording.');
        this.resetRecording();
    }, this);
    this.activeRecording = new $6c21bacc9274e141$var$SessionRecording({
        mixpanelInstance: this._mixpanel,
        onIdleTimeout: onIdleTimeout,
        onMaxLengthReached: onMaxLengthReached,
        replayId: $6c21bacc9274e141$var$_.UUID(),
        rrwebRecord: $6c21bacc9274e141$var$record
    });
    this.activeRecording.startRecording(shouldStopBatcher);
};
$6c21bacc9274e141$var$MixpanelRecorder.prototype.stopRecording = function() {
    if (this.activeRecording) {
        this.activeRecording.stopRecording();
        this.activeRecording = null;
    }
};
$6c21bacc9274e141$var$MixpanelRecorder.prototype.resetRecording = function() {
    this.stopRecording();
    this.startRecording(true);
};
$6c21bacc9274e141$var$MixpanelRecorder.prototype.getActiveReplayId = function() {
    if (this.activeRecording && !this.activeRecording.isRrwebStopped()) return this.activeRecording.replayId;
    else return null;
};
// getter so that older mixpanel-core versions can still retrieve the replay ID
// when pulling the latest recorder bundle from the CDN
Object.defineProperty($6c21bacc9274e141$var$MixpanelRecorder.prototype, 'replayId', {
    get: function get() {
        return this.getActiveReplayId();
    }
});
$6c21bacc9274e141$var$win['__mp_recorder'] = $6c21bacc9274e141$var$MixpanelRecorder;
/* eslint camelcase: "off" */ /**
 * DomTracker Object
 * @constructor
 */ var $6c21bacc9274e141$var$DomTracker = function DomTracker() {};
// interface
$6c21bacc9274e141$var$DomTracker.prototype.create_properties = function() {};
$6c21bacc9274e141$var$DomTracker.prototype.event_handler = function() {};
$6c21bacc9274e141$var$DomTracker.prototype.after_track_handler = function() {};
$6c21bacc9274e141$var$DomTracker.prototype.init = function(mixpanel_instance) {
    this.mp = mixpanel_instance;
    return this;
};
/**
 * @param {Object|string} query
 * @param {string} event_name
 * @param {Object=} properties
 * @param {function=} user_callback
 */ $6c21bacc9274e141$var$DomTracker.prototype.track = function(query, event_name, properties, user_callback) {
    var that = this;
    var elements = $6c21bacc9274e141$var$_.dom_query(query);
    if (elements.length === 0) {
        $6c21bacc9274e141$var$console$1.error('The DOM query (' + query + ') returned 0 elements');
        return;
    }
    $6c21bacc9274e141$var$_.each(elements, function(element) {
        $6c21bacc9274e141$var$_.register_event(element, this.override_event, function(e) {
            var options = {};
            var props = that.create_properties(properties, this);
            var timeout = that.mp.get_config('track_links_timeout');
            that.event_handler(e, this, options);
            // in case the mixpanel servers don't get back to us in time
            window.setTimeout(that.track_callback(user_callback, props, options, true), timeout);
            // fire the tracking event
            that.mp.track(event_name, props, that.track_callback(user_callback, props, options));
        });
    }, this);
    return true;
};
/**
 * @param {function} user_callback
 * @param {Object} props
 * @param {boolean=} timeout_occured
 */ $6c21bacc9274e141$var$DomTracker.prototype.track_callback = function(user_callback, props, options, timeout_occured) {
    timeout_occured = timeout_occured || false;
    var that = this;
    return function() {
        // options is referenced from both callbacks, so we can have
        // a 'lock' of sorts to ensure only one fires
        if (options.callback_fired) return;
        options.callback_fired = true;
        if (user_callback && user_callback(timeout_occured, props) === false) // user can prevent the default functionality by
        // returning false from their callback
        return;
        that.after_track_handler(props, options, timeout_occured);
    };
};
$6c21bacc9274e141$var$DomTracker.prototype.create_properties = function(properties, element) {
    var props;
    if (typeof properties === 'function') props = properties(element);
    else props = $6c21bacc9274e141$var$_.extend({}, properties);
    return props;
};
/**
 * LinkTracker Object
 * @constructor
 * @extends DomTracker
 */ var $6c21bacc9274e141$var$LinkTracker = function LinkTracker() {
    this.override_event = 'click';
};
$6c21bacc9274e141$var$_.inherit($6c21bacc9274e141$var$LinkTracker, $6c21bacc9274e141$var$DomTracker);
$6c21bacc9274e141$var$LinkTracker.prototype.create_properties = function(properties, element) {
    var props = $6c21bacc9274e141$var$LinkTracker.superclass.create_properties.apply(this, arguments);
    if (element.href) props['url'] = element.href;
    return props;
};
$6c21bacc9274e141$var$LinkTracker.prototype.event_handler = function(evt, element, options) {
    options.new_tab = evt.which === 2 || evt.metaKey || evt.ctrlKey || element.target === '_blank';
    options.href = element.href;
    if (!options.new_tab) evt.preventDefault();
};
$6c21bacc9274e141$var$LinkTracker.prototype.after_track_handler = function(props, options) {
    if (options.new_tab) return;
    setTimeout(function() {
        window.location = options.href;
    }, 0);
};
/**
 * FormTracker Object
 * @constructor
 * @extends DomTracker
 */ var $6c21bacc9274e141$var$FormTracker = function FormTracker() {
    this.override_event = 'submit';
};
$6c21bacc9274e141$var$_.inherit($6c21bacc9274e141$var$FormTracker, $6c21bacc9274e141$var$DomTracker);
$6c21bacc9274e141$var$FormTracker.prototype.event_handler = function(evt, element, options) {
    options.element = element;
    evt.preventDefault();
};
$6c21bacc9274e141$var$FormTracker.prototype.after_track_handler = function(props, options) {
    setTimeout(function() {
        options.element.submit();
    }, 0);
};
/* eslint camelcase: "off" */ /** @const */ var $6c21bacc9274e141$var$SET_ACTION = '$set';
/** @const */ var $6c21bacc9274e141$var$SET_ONCE_ACTION = '$set_once';
/** @const */ var $6c21bacc9274e141$var$UNSET_ACTION = '$unset';
/** @const */ var $6c21bacc9274e141$var$ADD_ACTION = '$add';
/** @const */ var $6c21bacc9274e141$var$APPEND_ACTION = '$append';
/** @const */ var $6c21bacc9274e141$var$UNION_ACTION = '$union';
/** @const */ var $6c21bacc9274e141$var$REMOVE_ACTION = '$remove';
/** @const */ var $6c21bacc9274e141$var$DELETE_ACTION = '$delete';
// Common internal methods for mixpanel.people and mixpanel.group APIs.
// These methods shouldn't involve network I/O.
var $6c21bacc9274e141$var$apiActions = {
    set_action: function set_action(prop, to) {
        var data = {};
        var $set = {};
        if ($6c21bacc9274e141$var$_.isObject(prop)) $6c21bacc9274e141$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) $set[k] = v;
        }, this);
        else $set[prop] = to;
        data[$6c21bacc9274e141$var$SET_ACTION] = $set;
        return data;
    },
    unset_action: function unset_action(prop) {
        var data = {};
        var $unset = [];
        if (!$6c21bacc9274e141$var$_.isArray(prop)) prop = [
            prop
        ];
        $6c21bacc9274e141$var$_.each(prop, function(k) {
            if (!this._is_reserved_property(k)) $unset.push(k);
        }, this);
        data[$6c21bacc9274e141$var$UNSET_ACTION] = $unset;
        return data;
    },
    set_once_action: function set_once_action(prop, to) {
        var data = {};
        var $set_once = {};
        if ($6c21bacc9274e141$var$_.isObject(prop)) $6c21bacc9274e141$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) $set_once[k] = v;
        }, this);
        else $set_once[prop] = to;
        data[$6c21bacc9274e141$var$SET_ONCE_ACTION] = $set_once;
        return data;
    },
    union_action: function union_action(list_name, values) {
        var data = {};
        var $union = {};
        if ($6c21bacc9274e141$var$_.isObject(list_name)) $6c21bacc9274e141$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $union[k] = $6c21bacc9274e141$var$_.isArray(v) ? v : [
                v
            ];
        }, this);
        else $union[list_name] = $6c21bacc9274e141$var$_.isArray(values) ? values : [
            values
        ];
        data[$6c21bacc9274e141$var$UNION_ACTION] = $union;
        return data;
    },
    append_action: function append_action(list_name, value) {
        var data = {};
        var $append = {};
        if ($6c21bacc9274e141$var$_.isObject(list_name)) $6c21bacc9274e141$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $append[k] = v;
        }, this);
        else $append[list_name] = value;
        data[$6c21bacc9274e141$var$APPEND_ACTION] = $append;
        return data;
    },
    remove_action: function remove_action(list_name, value) {
        var data = {};
        var $remove = {};
        if ($6c21bacc9274e141$var$_.isObject(list_name)) $6c21bacc9274e141$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $remove[k] = v;
        }, this);
        else $remove[list_name] = value;
        data[$6c21bacc9274e141$var$REMOVE_ACTION] = $remove;
        return data;
    },
    delete_action: function delete_action() {
        var data = {};
        data[$6c21bacc9274e141$var$DELETE_ACTION] = '';
        return data;
    }
};
/* eslint camelcase: "off" */ /**
 * Mixpanel Group Object
 * @constructor
 */ var $6c21bacc9274e141$var$MixpanelGroup = function MixpanelGroup() {};
$6c21bacc9274e141$var$_.extend($6c21bacc9274e141$var$MixpanelGroup.prototype, $6c21bacc9274e141$var$apiActions);
$6c21bacc9274e141$var$MixpanelGroup.prototype._init = function(mixpanel_instance, group_key, group_id) {
    this._mixpanel = mixpanel_instance;
    this._group_key = group_key;
    this._group_id = group_id;
};
/**
 * Set properties on a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, dates, or lists
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $6c21bacc9274e141$var$MixpanelGroup.prototype.set = $6c21bacc9274e141$var$addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if ($6c21bacc9274e141$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/**
 * Set properties on a group, only if they do not yet exist.
 * This will not overwrite previous group property values, unlike
 * group.set().
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set_once('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set_once({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, lists or dates
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $6c21bacc9274e141$var$MixpanelGroup.prototype.set_once = $6c21bacc9274e141$var$addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if ($6c21bacc9274e141$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/**
 * Unset properties on a group permanently.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').unset('Founded');
 *
 * @param {String} prop The name of the property.
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $6c21bacc9274e141$var$MixpanelGroup.prototype.unset = $6c21bacc9274e141$var$addOptOutCheckMixpanelGroup(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});
/**
 * Merge a given list with a list-valued group property, excluding duplicate values.
 *
 * ### Usage:
 *
 *     // merge a value to a list, creating it if needed
 *     mixpanel.get_group('company', 'mixpanel').union('Location', ['San Francisco', 'London']);
 *
 * @param {String} list_name Name of the property.
 * @param {Array} values Values to merge with the given property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $6c21bacc9274e141$var$MixpanelGroup.prototype.union = $6c21bacc9274e141$var$addOptOutCheckMixpanelGroup(function(list_name, values, callback) {
    if ($6c21bacc9274e141$var$_.isObject(list_name)) callback = values;
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});
/**
 * Permanently delete a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').delete();
 *
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $6c21bacc9274e141$var$MixpanelGroup.prototype['delete'] = $6c21bacc9274e141$var$addOptOutCheckMixpanelGroup(function(callback) {
    // bracket notation above prevents a minification error related to reserved words
    var data = this.delete_action();
    return this._send_request(data, callback);
});
/**
 * Remove a property from a group. The value will be ignored if doesn't exist.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').remove('Location', 'London');
 *
 * @param {String} list_name Name of the property.
 * @param {Object} value Value to remove from the given group property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $6c21bacc9274e141$var$MixpanelGroup.prototype.remove = $6c21bacc9274e141$var$addOptOutCheckMixpanelGroup(function(list_name, value, callback) {
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});
$6c21bacc9274e141$var$MixpanelGroup.prototype._send_request = function(data, callback) {
    data['$group_key'] = this._group_key;
    data['$group_id'] = this._group_id;
    data['$token'] = this._get_config('token');
    var date_encoded_data = $6c21bacc9274e141$var$_.encodeDates(data);
    return this._mixpanel._track_or_batch({
        type: 'groups',
        data: date_encoded_data,
        endpoint: this._get_config('api_host') + '/' + this._get_config('api_routes')['groups'],
        batcher: this._mixpanel.request_batchers.groups
    }, callback);
};
$6c21bacc9274e141$var$MixpanelGroup.prototype._is_reserved_property = function(prop) {
    return prop === '$group_key' || prop === '$group_id';
};
$6c21bacc9274e141$var$MixpanelGroup.prototype._get_config = function(conf) {
    return this._mixpanel.get_config(conf);
};
$6c21bacc9274e141$var$MixpanelGroup.prototype.toString = function() {
    return this._mixpanel.toString() + '.group.' + this._group_key + '.' + this._group_id;
};
// MixpanelGroup Exports
$6c21bacc9274e141$var$MixpanelGroup.prototype['remove'] = $6c21bacc9274e141$var$MixpanelGroup.prototype.remove;
$6c21bacc9274e141$var$MixpanelGroup.prototype['set'] = $6c21bacc9274e141$var$MixpanelGroup.prototype.set;
$6c21bacc9274e141$var$MixpanelGroup.prototype['set_once'] = $6c21bacc9274e141$var$MixpanelGroup.prototype.set_once;
$6c21bacc9274e141$var$MixpanelGroup.prototype['union'] = $6c21bacc9274e141$var$MixpanelGroup.prototype.union;
$6c21bacc9274e141$var$MixpanelGroup.prototype['unset'] = $6c21bacc9274e141$var$MixpanelGroup.prototype.unset;
$6c21bacc9274e141$var$MixpanelGroup.prototype['toString'] = $6c21bacc9274e141$var$MixpanelGroup.prototype.toString;
/* eslint camelcase: "off" */ /**
 * Mixpanel People Object
 * @constructor
 */ var $6c21bacc9274e141$var$MixpanelPeople = function MixpanelPeople() {};
$6c21bacc9274e141$var$_.extend($6c21bacc9274e141$var$MixpanelPeople.prototype, $6c21bacc9274e141$var$apiActions);
$6c21bacc9274e141$var$MixpanelPeople.prototype._init = function(mixpanel_instance) {
    this._mixpanel = mixpanel_instance;
};
/*
* Set properties on a user record.
*
* ### Usage:
*
*     mixpanel.people.set('gender', 'm');
*
*     // or set multiple properties at once
*     mixpanel.people.set({
*         'Company': 'Acme',
*         'Plan': 'Premium',
*         'Upgrade date': new Date()
*     });
*     // properties can be strings, integers, dates, or lists
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $6c21bacc9274e141$var$MixpanelPeople.prototype.set = $6c21bacc9274e141$var$addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if ($6c21bacc9274e141$var$_.isObject(prop)) callback = to;
    // make sure that the referrer info has been updated and saved
    if (this._get_config('save_referrer')) this._mixpanel['persistence'].update_referrer_info(document.referrer);
    // update $set object with default people properties
    data[$6c21bacc9274e141$var$SET_ACTION] = $6c21bacc9274e141$var$_.extend({}, $6c21bacc9274e141$var$_.info.people_properties(), data[$6c21bacc9274e141$var$SET_ACTION]);
    return this._send_request(data, callback);
});
/*
* Set properties on a user record, only if they do not yet exist.
* This will not overwrite previous people property values, unlike
* people.set().
*
* ### Usage:
*
*     mixpanel.people.set_once('First Login Date', new Date());
*
*     // or set multiple properties at once
*     mixpanel.people.set_once({
*         'First Login Date': new Date(),
*         'Starting Plan': 'Premium'
*     });
*
*     // properties can be strings, integers or dates
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $6c21bacc9274e141$var$MixpanelPeople.prototype.set_once = $6c21bacc9274e141$var$addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if ($6c21bacc9274e141$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/*
* Unset properties on a user record (permanently removes the properties and their values from a profile).
*
* ### Usage:
*
*     mixpanel.people.unset('gender');
*
*     // or unset multiple properties at once
*     mixpanel.people.unset(['gender', 'Company']);
*
* @param {Array|String} prop If a string, this is the name of the property. If an array, this is a list of property names.
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $6c21bacc9274e141$var$MixpanelPeople.prototype.unset = $6c21bacc9274e141$var$addOptOutCheckMixpanelPeople(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});
/*
* Increment/decrement numeric people analytics properties.
*
* ### Usage:
*
*     mixpanel.people.increment('page_views', 1);
*
*     // or, for convenience, if you're just incrementing a counter by
*     // 1, you can simply do
*     mixpanel.people.increment('page_views');
*
*     // to decrement a counter, pass a negative number
*     mixpanel.people.increment('credits_left', -1);
*
*     // like mixpanel.people.set(), you can increment multiple
*     // properties at once:
*     mixpanel.people.increment({
*         counter1: 1,
*         counter2: 6
*     });
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and numeric values.
* @param {Number} [by] An amount to increment the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $6c21bacc9274e141$var$MixpanelPeople.prototype.increment = $6c21bacc9274e141$var$addOptOutCheckMixpanelPeople(function(prop, by, callback) {
    var data = {};
    var $add = {};
    if ($6c21bacc9274e141$var$_.isObject(prop)) {
        $6c21bacc9274e141$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) {
                if (isNaN(parseFloat(v))) {
                    $6c21bacc9274e141$var$console$1.error('Invalid increment value passed to mixpanel.people.increment - must be a number');
                    return;
                } else $add[k] = v;
            }
        }, this);
        callback = by;
    } else {
        // convenience: mixpanel.people.increment('property'); will
        // increment 'property' by 1
        if ($6c21bacc9274e141$var$_.isUndefined(by)) by = 1;
        $add[prop] = by;
    }
    data[$6c21bacc9274e141$var$ADD_ACTION] = $add;
    return this._send_request(data, callback);
});
/*
* Append a value to a list-valued people analytics property.
*
* ### Usage:
*
*     // append a value to a list, creating it if needed
*     mixpanel.people.append('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.append({
*         list1: 'bob',
*         list2: 123
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value An item to append to the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $6c21bacc9274e141$var$MixpanelPeople.prototype.append = $6c21bacc9274e141$var$addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if ($6c21bacc9274e141$var$_.isObject(list_name)) callback = value;
    var data = this.append_action(list_name, value);
    return this._send_request(data, callback);
});
/*
* Remove a value from a list-valued people analytics property.
*
* ### Usage:
*
*     mixpanel.people.remove('School', 'UCB');
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value Item to remove from the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $6c21bacc9274e141$var$MixpanelPeople.prototype.remove = $6c21bacc9274e141$var$addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if ($6c21bacc9274e141$var$_.isObject(list_name)) callback = value;
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});
/*
* Merge a given list with a list-valued people analytics property,
* excluding duplicate values.
*
* ### Usage:
*
*     // merge a value to a list, creating it if needed
*     mixpanel.people.union('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.union({
*         list1: 'bob',
*         list2: 123
*     });
*
*     // like mixpanel.people.append(), you can append multiple
*     // values to the same list:
*     mixpanel.people.union({
*         list1: ['bob', 'billy']
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] Value / values to merge with the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $6c21bacc9274e141$var$MixpanelPeople.prototype.union = $6c21bacc9274e141$var$addOptOutCheckMixpanelPeople(function(list_name, values, callback) {
    if ($6c21bacc9274e141$var$_.isObject(list_name)) callback = values;
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});
/*
 * Record that you have charged the current user a certain amount
 * of money. Charges recorded with track_charge() will appear in the
 * Mixpanel revenue report.
 *
 * ### Usage:
 *
 *     // charge a user $50
 *     mixpanel.people.track_charge(50);
 *
 *     // charge a user $30.50 on the 2nd of january
 *     mixpanel.people.track_charge(30.50, {
 *         '$time': new Date('jan 1 2012')
 *     });
 *
 * @param {Number} amount The amount of money charged to the current user
 * @param {Object} [properties] An associative array of properties associated with the charge
 * @param {Function} [callback] If provided, the callback will be called when the server responds
 * @deprecated
 */ $6c21bacc9274e141$var$MixpanelPeople.prototype.track_charge = $6c21bacc9274e141$var$addOptOutCheckMixpanelPeople(function(amount, properties, callback) {
    if (!$6c21bacc9274e141$var$_.isNumber(amount)) {
        amount = parseFloat(amount);
        if (isNaN(amount)) {
            $6c21bacc9274e141$var$console$1.error('Invalid value passed to mixpanel.people.track_charge - must be a number');
            return;
        }
    }
    return this.append('$transactions', $6c21bacc9274e141$var$_.extend({
        $amount: amount
    }, properties), callback);
});
/*
 * Permanently clear all revenue report transactions from the
 * current user's people analytics profile.
 *
 * ### Usage:
 *
 *     mixpanel.people.clear_charges();
 *
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 * @deprecated
 */ $6c21bacc9274e141$var$MixpanelPeople.prototype.clear_charges = function(callback) {
    return this.set('$transactions', [], callback);
};
/*
* Permanently deletes the current people analytics profile from
* Mixpanel (using the current distinct_id).
*
* ### Usage:
*
*     // remove the all data you have stored about the current user
*     mixpanel.people.delete_user();
*
*/ $6c21bacc9274e141$var$MixpanelPeople.prototype.delete_user = function() {
    if (!this._identify_called()) {
        $6c21bacc9274e141$var$console$1.error('mixpanel.people.delete_user() requires you to call identify() first');
        return;
    }
    var data = {
        $delete: this._mixpanel.get_distinct_id()
    };
    return this._send_request(data);
};
$6c21bacc9274e141$var$MixpanelPeople.prototype.toString = function() {
    return this._mixpanel.toString() + '.people';
};
$6c21bacc9274e141$var$MixpanelPeople.prototype._send_request = function(data, callback) {
    data['$token'] = this._get_config('token');
    data['$distinct_id'] = this._mixpanel.get_distinct_id();
    var device_id = this._mixpanel.get_property('$device_id');
    var user_id = this._mixpanel.get_property('$user_id');
    var had_persisted_distinct_id = this._mixpanel.get_property('$had_persisted_distinct_id');
    if (device_id) data['$device_id'] = device_id;
    if (user_id) data['$user_id'] = user_id;
    if (had_persisted_distinct_id) data['$had_persisted_distinct_id'] = had_persisted_distinct_id;
    var date_encoded_data = $6c21bacc9274e141$var$_.encodeDates(data);
    if (!this._identify_called()) {
        this._enqueue(data);
        if (!$6c21bacc9274e141$var$_.isUndefined(callback)) {
            if (this._get_config('verbose')) callback({
                status: -1,
                error: null
            });
            else callback(-1);
        }
        return $6c21bacc9274e141$var$_.truncate(date_encoded_data, 255);
    }
    return this._mixpanel._track_or_batch({
        type: 'people',
        data: date_encoded_data,
        endpoint: this._get_config('api_host') + '/' + this._get_config('api_routes')['engage'],
        batcher: this._mixpanel.request_batchers.people
    }, callback);
};
$6c21bacc9274e141$var$MixpanelPeople.prototype._get_config = function(conf_var) {
    return this._mixpanel.get_config(conf_var);
};
$6c21bacc9274e141$var$MixpanelPeople.prototype._identify_called = function() {
    return this._mixpanel._flags.identify_called === true;
};
// Queue up engage operations if identify hasn't been called yet.
$6c21bacc9274e141$var$MixpanelPeople.prototype._enqueue = function(data) {
    if ($6c21bacc9274e141$var$SET_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($6c21bacc9274e141$var$SET_ACTION, data);
    else if ($6c21bacc9274e141$var$SET_ONCE_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($6c21bacc9274e141$var$SET_ONCE_ACTION, data);
    else if ($6c21bacc9274e141$var$UNSET_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($6c21bacc9274e141$var$UNSET_ACTION, data);
    else if ($6c21bacc9274e141$var$ADD_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($6c21bacc9274e141$var$ADD_ACTION, data);
    else if ($6c21bacc9274e141$var$APPEND_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($6c21bacc9274e141$var$APPEND_ACTION, data);
    else if ($6c21bacc9274e141$var$REMOVE_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($6c21bacc9274e141$var$REMOVE_ACTION, data);
    else if ($6c21bacc9274e141$var$UNION_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($6c21bacc9274e141$var$UNION_ACTION, data);
    else $6c21bacc9274e141$var$console$1.error('Invalid call to _enqueue():', data);
};
$6c21bacc9274e141$var$MixpanelPeople.prototype._flush_one_queue = function(action, action_method, callback, queue_to_params_fn) {
    var _this = this;
    var queued_data = $6c21bacc9274e141$var$_.extend({}, this._mixpanel['persistence'].load_queue(action));
    var action_params = queued_data;
    if (!$6c21bacc9274e141$var$_.isUndefined(queued_data) && $6c21bacc9274e141$var$_.isObject(queued_data) && !$6c21bacc9274e141$var$_.isEmptyObject(queued_data)) {
        _this._mixpanel['persistence']._pop_from_people_queue(action, queued_data);
        _this._mixpanel['persistence'].save();
        if (queue_to_params_fn) action_params = queue_to_params_fn(queued_data);
        action_method.call(_this, action_params, function(response, data) {
            // on bad response, we want to add it back to the queue
            if (response === 0) _this._mixpanel['persistence']._add_to_people_queue(action, queued_data);
            if (!$6c21bacc9274e141$var$_.isUndefined(callback)) callback(response, data);
        });
    }
};
// Flush queued engage operations - order does not matter,
// and there are network level race conditions anyway
$6c21bacc9274e141$var$MixpanelPeople.prototype._flush = function(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback) {
    var _this = this;
    this._flush_one_queue($6c21bacc9274e141$var$SET_ACTION, this.set, _set_callback);
    this._flush_one_queue($6c21bacc9274e141$var$SET_ONCE_ACTION, this.set_once, _set_once_callback);
    this._flush_one_queue($6c21bacc9274e141$var$UNSET_ACTION, this.unset, _unset_callback, function(queue) {
        return $6c21bacc9274e141$var$_.keys(queue);
    });
    this._flush_one_queue($6c21bacc9274e141$var$ADD_ACTION, this.increment, _add_callback);
    this._flush_one_queue($6c21bacc9274e141$var$UNION_ACTION, this.union, _union_callback);
    // we have to fire off each $append individually since there is
    // no concat method server side
    var $append_queue = this._mixpanel['persistence'].load_queue($6c21bacc9274e141$var$APPEND_ACTION);
    if (!$6c21bacc9274e141$var$_.isUndefined($append_queue) && $6c21bacc9274e141$var$_.isArray($append_queue) && $append_queue.length) {
        var $append_item;
        var append_callback = function append_callback(response, data) {
            if (response === 0) _this._mixpanel['persistence']._add_to_people_queue($6c21bacc9274e141$var$APPEND_ACTION, $append_item);
            if (!$6c21bacc9274e141$var$_.isUndefined(_append_callback)) _append_callback(response, data);
        };
        for(var i = $append_queue.length - 1; i >= 0; i--){
            $append_queue = this._mixpanel['persistence'].load_queue($6c21bacc9274e141$var$APPEND_ACTION);
            $append_item = $append_queue.pop();
            _this._mixpanel['persistence'].save();
            if (!$6c21bacc9274e141$var$_.isEmptyObject($append_item)) _this.append($append_item, append_callback);
        }
    }
    // same for $remove
    var $remove_queue = this._mixpanel['persistence'].load_queue($6c21bacc9274e141$var$REMOVE_ACTION);
    if (!$6c21bacc9274e141$var$_.isUndefined($remove_queue) && $6c21bacc9274e141$var$_.isArray($remove_queue) && $remove_queue.length) {
        var $remove_item;
        var remove_callback = function remove_callback(response, data) {
            if (response === 0) _this._mixpanel['persistence']._add_to_people_queue($6c21bacc9274e141$var$REMOVE_ACTION, $remove_item);
            if (!$6c21bacc9274e141$var$_.isUndefined(_remove_callback)) _remove_callback(response, data);
        };
        for(var j = $remove_queue.length - 1; j >= 0; j--){
            $remove_queue = this._mixpanel['persistence'].load_queue($6c21bacc9274e141$var$REMOVE_ACTION);
            $remove_item = $remove_queue.pop();
            _this._mixpanel['persistence'].save();
            if (!$6c21bacc9274e141$var$_.isEmptyObject($remove_item)) _this.remove($remove_item, remove_callback);
        }
    }
};
$6c21bacc9274e141$var$MixpanelPeople.prototype._is_reserved_property = function(prop) {
    return prop === '$distinct_id' || prop === '$token' || prop === '$device_id' || prop === '$user_id' || prop === '$had_persisted_distinct_id';
};
// MixpanelPeople Exports
$6c21bacc9274e141$var$MixpanelPeople.prototype['set'] = $6c21bacc9274e141$var$MixpanelPeople.prototype.set;
$6c21bacc9274e141$var$MixpanelPeople.prototype['set_once'] = $6c21bacc9274e141$var$MixpanelPeople.prototype.set_once;
$6c21bacc9274e141$var$MixpanelPeople.prototype['unset'] = $6c21bacc9274e141$var$MixpanelPeople.prototype.unset;
$6c21bacc9274e141$var$MixpanelPeople.prototype['increment'] = $6c21bacc9274e141$var$MixpanelPeople.prototype.increment;
$6c21bacc9274e141$var$MixpanelPeople.prototype['append'] = $6c21bacc9274e141$var$MixpanelPeople.prototype.append;
$6c21bacc9274e141$var$MixpanelPeople.prototype['remove'] = $6c21bacc9274e141$var$MixpanelPeople.prototype.remove;
$6c21bacc9274e141$var$MixpanelPeople.prototype['union'] = $6c21bacc9274e141$var$MixpanelPeople.prototype.union;
$6c21bacc9274e141$var$MixpanelPeople.prototype['track_charge'] = $6c21bacc9274e141$var$MixpanelPeople.prototype.track_charge;
$6c21bacc9274e141$var$MixpanelPeople.prototype['clear_charges'] = $6c21bacc9274e141$var$MixpanelPeople.prototype.clear_charges;
$6c21bacc9274e141$var$MixpanelPeople.prototype['delete_user'] = $6c21bacc9274e141$var$MixpanelPeople.prototype.delete_user;
$6c21bacc9274e141$var$MixpanelPeople.prototype['toString'] = $6c21bacc9274e141$var$MixpanelPeople.prototype.toString;
/* eslint camelcase: "off" */ /*
 * Constants
 */ /** @const */ var $6c21bacc9274e141$var$SET_QUEUE_KEY = '__mps';
/** @const */ var $6c21bacc9274e141$var$SET_ONCE_QUEUE_KEY = '__mpso';
/** @const */ var $6c21bacc9274e141$var$UNSET_QUEUE_KEY = '__mpus';
/** @const */ var $6c21bacc9274e141$var$ADD_QUEUE_KEY = '__mpa';
/** @const */ var $6c21bacc9274e141$var$APPEND_QUEUE_KEY = '__mpap';
/** @const */ var $6c21bacc9274e141$var$REMOVE_QUEUE_KEY = '__mpr';
/** @const */ var $6c21bacc9274e141$var$UNION_QUEUE_KEY = '__mpu';
// This key is deprecated, but we want to check for it to see whether aliasing is allowed.
/** @const */ var $6c21bacc9274e141$var$PEOPLE_DISTINCT_ID_KEY = '$people_distinct_id';
/** @const */ var $6c21bacc9274e141$var$ALIAS_ID_KEY = '__alias';
/** @const */ var $6c21bacc9274e141$var$EVENT_TIMERS_KEY = '__timers';
/** @const */ var $6c21bacc9274e141$var$RESERVED_PROPERTIES = [
    $6c21bacc9274e141$var$SET_QUEUE_KEY,
    $6c21bacc9274e141$var$SET_ONCE_QUEUE_KEY,
    $6c21bacc9274e141$var$UNSET_QUEUE_KEY,
    $6c21bacc9274e141$var$ADD_QUEUE_KEY,
    $6c21bacc9274e141$var$APPEND_QUEUE_KEY,
    $6c21bacc9274e141$var$REMOVE_QUEUE_KEY,
    $6c21bacc9274e141$var$UNION_QUEUE_KEY,
    $6c21bacc9274e141$var$PEOPLE_DISTINCT_ID_KEY,
    $6c21bacc9274e141$var$ALIAS_ID_KEY,
    $6c21bacc9274e141$var$EVENT_TIMERS_KEY
];
/**
 * Mixpanel Persistence Object
 * @constructor
 */ var $6c21bacc9274e141$var$MixpanelPersistence = function MixpanelPersistence(config) {
    this['props'] = {};
    this.campaign_params_saved = false;
    if (config['persistence_name']) this.name = 'mp_' + config['persistence_name'];
    else this.name = 'mp_' + config['token'] + '_mixpanel';
    var storage_type = config['persistence'];
    if (storage_type !== 'cookie' && storage_type !== 'localStorage') {
        $6c21bacc9274e141$var$console$1.critical('Unknown persistence type ' + storage_type + '; falling back to cookie');
        storage_type = config['persistence'] = 'cookie';
    }
    if (storage_type === 'localStorage' && $6c21bacc9274e141$var$_.localStorage.is_supported()) this.storage = $6c21bacc9274e141$var$_.localStorage;
    else this.storage = $6c21bacc9274e141$var$_.cookie;
    this.load();
    this.update_config(config);
    this.upgrade();
    this.save();
};
$6c21bacc9274e141$var$MixpanelPersistence.prototype.properties = function() {
    var p = {};
    this.load();
    // Filter out reserved properties
    $6c21bacc9274e141$var$_.each(this['props'], function(v, k) {
        if (!$6c21bacc9274e141$var$_.include($6c21bacc9274e141$var$RESERVED_PROPERTIES, k)) p[k] = v;
    });
    return p;
};
$6c21bacc9274e141$var$MixpanelPersistence.prototype.load = function() {
    if (this.disabled) return;
    var entry = this.storage.parse(this.name);
    if (entry) this['props'] = $6c21bacc9274e141$var$_.extend({}, entry);
};
$6c21bacc9274e141$var$MixpanelPersistence.prototype.upgrade = function() {
    var old_cookie, old_localstorage;
    // if transferring from cookie to localStorage or vice-versa, copy existing
    // super properties over to new storage mode
    if (this.storage === $6c21bacc9274e141$var$_.localStorage) {
        old_cookie = $6c21bacc9274e141$var$_.cookie.parse(this.name);
        $6c21bacc9274e141$var$_.cookie.remove(this.name);
        $6c21bacc9274e141$var$_.cookie.remove(this.name, true);
        if (old_cookie) this.register_once(old_cookie);
    } else if (this.storage === $6c21bacc9274e141$var$_.cookie) {
        old_localstorage = $6c21bacc9274e141$var$_.localStorage.parse(this.name);
        $6c21bacc9274e141$var$_.localStorage.remove(this.name);
        if (old_localstorage) this.register_once(old_localstorage);
    }
};
$6c21bacc9274e141$var$MixpanelPersistence.prototype.save = function() {
    if (this.disabled) return;
    this.storage.set(this.name, $6c21bacc9274e141$var$_.JSONEncode(this['props']), this.expire_days, this.cross_subdomain, this.secure, this.cross_site, this.cookie_domain);
};
$6c21bacc9274e141$var$MixpanelPersistence.prototype.load_prop = function(key) {
    this.load();
    return this['props'][key];
};
$6c21bacc9274e141$var$MixpanelPersistence.prototype.remove = function() {
    // remove both domain and subdomain cookies
    this.storage.remove(this.name, false, this.cookie_domain);
    this.storage.remove(this.name, true, this.cookie_domain);
};
// removes the storage entry and deletes all loaded data
// forced name for tests
$6c21bacc9274e141$var$MixpanelPersistence.prototype.clear = function() {
    this.remove();
    this['props'] = {};
};
/**
* @param {Object} props
* @param {*=} default_value
* @param {number=} days
*/ $6c21bacc9274e141$var$MixpanelPersistence.prototype.register_once = function(props, default_value, days) {
    if ($6c21bacc9274e141$var$_.isObject(props)) {
        if (typeof default_value === 'undefined') default_value = 'None';
        this.expire_days = typeof days === 'undefined' ? this.default_expiry : days;
        this.load();
        $6c21bacc9274e141$var$_.each(props, function(val, prop) {
            if (!this['props'].hasOwnProperty(prop) || this['props'][prop] === default_value) this['props'][prop] = val;
        }, this);
        this.save();
        return true;
    }
    return false;
};
/**
* @param {Object} props
* @param {number=} days
*/ $6c21bacc9274e141$var$MixpanelPersistence.prototype.register = function(props, days) {
    if ($6c21bacc9274e141$var$_.isObject(props)) {
        this.expire_days = typeof days === 'undefined' ? this.default_expiry : days;
        this.load();
        $6c21bacc9274e141$var$_.extend(this['props'], props);
        this.save();
        return true;
    }
    return false;
};
$6c21bacc9274e141$var$MixpanelPersistence.prototype.unregister = function(prop) {
    this.load();
    if (prop in this['props']) {
        delete this['props'][prop];
        this.save();
    }
};
$6c21bacc9274e141$var$MixpanelPersistence.prototype.update_search_keyword = function(referrer) {
    this.register($6c21bacc9274e141$var$_.info.searchInfo(referrer));
};
// EXPORTED METHOD, we test this directly.
$6c21bacc9274e141$var$MixpanelPersistence.prototype.update_referrer_info = function(referrer) {
    // If referrer doesn't exist, we want to note the fact that it was type-in traffic.
    this.register_once({
        $initial_referrer: referrer || '$direct',
        $initial_referring_domain: $6c21bacc9274e141$var$_.info.referringDomain(referrer) || '$direct'
    }, '');
};
$6c21bacc9274e141$var$MixpanelPersistence.prototype.get_referrer_info = function() {
    return $6c21bacc9274e141$var$_.strip_empty_properties({
        $initial_referrer: this['props']['$initial_referrer'],
        $initial_referring_domain: this['props']['$initial_referring_domain']
    });
};
$6c21bacc9274e141$var$MixpanelPersistence.prototype.update_config = function(config) {
    this.default_expiry = this.expire_days = config['cookie_expiration'];
    this.set_disabled(config['disable_persistence']);
    this.set_cookie_domain(config['cookie_domain']);
    this.set_cross_site(config['cross_site_cookie']);
    this.set_cross_subdomain(config['cross_subdomain_cookie']);
    this.set_secure(config['secure_cookie']);
};
$6c21bacc9274e141$var$MixpanelPersistence.prototype.set_disabled = function(disabled) {
    this.disabled = disabled;
    if (this.disabled) this.remove();
    else this.save();
};
$6c21bacc9274e141$var$MixpanelPersistence.prototype.set_cookie_domain = function(cookie_domain) {
    if (cookie_domain !== this.cookie_domain) {
        this.remove();
        this.cookie_domain = cookie_domain;
        this.save();
    }
};
$6c21bacc9274e141$var$MixpanelPersistence.prototype.set_cross_site = function(cross_site) {
    if (cross_site !== this.cross_site) {
        this.cross_site = cross_site;
        this.remove();
        this.save();
    }
};
$6c21bacc9274e141$var$MixpanelPersistence.prototype.set_cross_subdomain = function(cross_subdomain) {
    if (cross_subdomain !== this.cross_subdomain) {
        this.cross_subdomain = cross_subdomain;
        this.remove();
        this.save();
    }
};
$6c21bacc9274e141$var$MixpanelPersistence.prototype.get_cross_subdomain = function() {
    return this.cross_subdomain;
};
$6c21bacc9274e141$var$MixpanelPersistence.prototype.set_secure = function(secure) {
    if (secure !== this.secure) {
        this.secure = secure ? true : false;
        this.remove();
        this.save();
    }
};
$6c21bacc9274e141$var$MixpanelPersistence.prototype._add_to_people_queue = function(queue, data) {
    var q_key = this._get_queue_key(queue), q_data = data[queue], set_q = this._get_or_create_queue($6c21bacc9274e141$var$SET_ACTION), set_once_q = this._get_or_create_queue($6c21bacc9274e141$var$SET_ONCE_ACTION), unset_q = this._get_or_create_queue($6c21bacc9274e141$var$UNSET_ACTION), add_q = this._get_or_create_queue($6c21bacc9274e141$var$ADD_ACTION), union_q = this._get_or_create_queue($6c21bacc9274e141$var$UNION_ACTION), remove_q = this._get_or_create_queue($6c21bacc9274e141$var$REMOVE_ACTION, []), append_q = this._get_or_create_queue($6c21bacc9274e141$var$APPEND_ACTION, []);
    if (q_key === $6c21bacc9274e141$var$SET_QUEUE_KEY) {
        // Update the set queue - we can override any existing values
        $6c21bacc9274e141$var$_.extend(set_q, q_data);
        // if there was a pending increment, override it
        // with the set.
        this._pop_from_people_queue($6c21bacc9274e141$var$ADD_ACTION, q_data);
        // if there was a pending union, override it
        // with the set.
        this._pop_from_people_queue($6c21bacc9274e141$var$UNION_ACTION, q_data);
        this._pop_from_people_queue($6c21bacc9274e141$var$UNSET_ACTION, q_data);
    } else if (q_key === $6c21bacc9274e141$var$SET_ONCE_QUEUE_KEY) {
        // only queue the data if there is not already a set_once call for it.
        $6c21bacc9274e141$var$_.each(q_data, function(v, k) {
            if (!(k in set_once_q)) set_once_q[k] = v;
        });
        this._pop_from_people_queue($6c21bacc9274e141$var$UNSET_ACTION, q_data);
    } else if (q_key === $6c21bacc9274e141$var$UNSET_QUEUE_KEY) $6c21bacc9274e141$var$_.each(q_data, function(prop) {
        // undo previously-queued actions on this key
        $6c21bacc9274e141$var$_.each([
            set_q,
            set_once_q,
            add_q,
            union_q
        ], function(enqueued_obj) {
            if (prop in enqueued_obj) delete enqueued_obj[prop];
        });
        $6c21bacc9274e141$var$_.each(append_q, function(append_obj) {
            if (prop in append_obj) delete append_obj[prop];
        });
        unset_q[prop] = true;
    });
    else if (q_key === $6c21bacc9274e141$var$ADD_QUEUE_KEY) {
        $6c21bacc9274e141$var$_.each(q_data, function(v, k) {
            // If it exists in the set queue, increment
            // the value
            if (k in set_q) set_q[k] += v;
            else {
                // If it doesn't exist, update the add
                // queue
                if (!(k in add_q)) add_q[k] = 0;
                add_q[k] += v;
            }
        }, this);
        this._pop_from_people_queue($6c21bacc9274e141$var$UNSET_ACTION, q_data);
    } else if (q_key === $6c21bacc9274e141$var$UNION_QUEUE_KEY) {
        $6c21bacc9274e141$var$_.each(q_data, function(v, k) {
            if ($6c21bacc9274e141$var$_.isArray(v)) {
                if (!(k in union_q)) union_q[k] = [];
                // We may send duplicates, the server will dedup them.
                union_q[k] = union_q[k].concat(v);
            }
        });
        this._pop_from_people_queue($6c21bacc9274e141$var$UNSET_ACTION, q_data);
    } else if (q_key === $6c21bacc9274e141$var$REMOVE_QUEUE_KEY) {
        remove_q.push(q_data);
        this._pop_from_people_queue($6c21bacc9274e141$var$APPEND_ACTION, q_data);
    } else if (q_key === $6c21bacc9274e141$var$APPEND_QUEUE_KEY) {
        append_q.push(q_data);
        this._pop_from_people_queue($6c21bacc9274e141$var$UNSET_ACTION, q_data);
    }
    $6c21bacc9274e141$var$console$1.log('MIXPANEL PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):');
    $6c21bacc9274e141$var$console$1.log(data);
    this.save();
};
$6c21bacc9274e141$var$MixpanelPersistence.prototype._pop_from_people_queue = function(queue, data) {
    var q = this['props'][this._get_queue_key(queue)];
    if (!$6c21bacc9274e141$var$_.isUndefined(q)) $6c21bacc9274e141$var$_.each(data, function(v, k) {
        if (queue === $6c21bacc9274e141$var$APPEND_ACTION || queue === $6c21bacc9274e141$var$REMOVE_ACTION) // list actions: only remove if both k+v match
        // e.g. remove should not override append in a case like
        // append({foo: 'bar'}); remove({foo: 'qux'})
        $6c21bacc9274e141$var$_.each(q, function(queued_action) {
            if (queued_action[k] === v) delete queued_action[k];
        });
        else delete q[k];
    }, this);
};
$6c21bacc9274e141$var$MixpanelPersistence.prototype.load_queue = function(queue) {
    return this.load_prop(this._get_queue_key(queue));
};
$6c21bacc9274e141$var$MixpanelPersistence.prototype._get_queue_key = function(queue) {
    if (queue === $6c21bacc9274e141$var$SET_ACTION) return $6c21bacc9274e141$var$SET_QUEUE_KEY;
    else if (queue === $6c21bacc9274e141$var$SET_ONCE_ACTION) return $6c21bacc9274e141$var$SET_ONCE_QUEUE_KEY;
    else if (queue === $6c21bacc9274e141$var$UNSET_ACTION) return $6c21bacc9274e141$var$UNSET_QUEUE_KEY;
    else if (queue === $6c21bacc9274e141$var$ADD_ACTION) return $6c21bacc9274e141$var$ADD_QUEUE_KEY;
    else if (queue === $6c21bacc9274e141$var$APPEND_ACTION) return $6c21bacc9274e141$var$APPEND_QUEUE_KEY;
    else if (queue === $6c21bacc9274e141$var$REMOVE_ACTION) return $6c21bacc9274e141$var$REMOVE_QUEUE_KEY;
    else if (queue === $6c21bacc9274e141$var$UNION_ACTION) return $6c21bacc9274e141$var$UNION_QUEUE_KEY;
    else $6c21bacc9274e141$var$console$1.error('Invalid queue:', queue);
};
$6c21bacc9274e141$var$MixpanelPersistence.prototype._get_or_create_queue = function(queue, default_val) {
    var key = this._get_queue_key(queue);
    default_val = $6c21bacc9274e141$var$_.isUndefined(default_val) ? {} : default_val;
    return this['props'][key] || (this['props'][key] = default_val);
};
$6c21bacc9274e141$var$MixpanelPersistence.prototype.set_event_timer = function(event_name, timestamp) {
    var timers = this.load_prop($6c21bacc9274e141$var$EVENT_TIMERS_KEY) || {};
    timers[event_name] = timestamp;
    this['props'][$6c21bacc9274e141$var$EVENT_TIMERS_KEY] = timers;
    this.save();
};
$6c21bacc9274e141$var$MixpanelPersistence.prototype.remove_event_timer = function(event_name) {
    var timers = this.load_prop($6c21bacc9274e141$var$EVENT_TIMERS_KEY) || {};
    var timestamp = timers[event_name];
    if (!$6c21bacc9274e141$var$_.isUndefined(timestamp)) {
        delete this['props'][$6c21bacc9274e141$var$EVENT_TIMERS_KEY][event_name];
        this.save();
    }
    return timestamp;
};
/* eslint camelcase: "off" */ /*
 * Mixpanel JS Library
 *
 * Copyright 2012, Mixpanel, Inc. All Rights Reserved
 * http://mixpanel.com/
 *
 * Includes portions of Underscore.js
 * http://documentcloud.github.com/underscore/
 * (c) 2011 Jeremy Ashkenas, DocumentCloud Inc.
 * Released under the MIT License.
 */ // ==ClosureCompiler==
// @compilation_level ADVANCED_OPTIMIZATIONS
// @output_file_name mixpanel-2.8.min.js
// ==/ClosureCompiler==
/*
SIMPLE STYLE GUIDE:

this.x === public function
this._x === internal - only use within this file
this.__x === private - only use within the class

Globals should be all caps
*/ var $6c21bacc9274e141$var$init_type; // MODULE or SNIPPET loader
// allow bundlers to specify how extra code (recorder bundle) should be loaded
// eslint-disable-next-line no-unused-vars
var $6c21bacc9274e141$var$load_extra_bundle = function load_extra_bundle(src, _onload) {
    throw new Error(src + ' not available in this build.');
};
var $6c21bacc9274e141$var$mixpanel_master; // main mixpanel instance / object
var $6c21bacc9274e141$var$INIT_MODULE = 0;
var $6c21bacc9274e141$var$INIT_SNIPPET = 1;
var $6c21bacc9274e141$var$IDENTITY_FUNC = function IDENTITY_FUNC(x) {
    return x;
};
var $6c21bacc9274e141$var$NOOP_FUNC = function NOOP_FUNC() {};
/** @const */ var $6c21bacc9274e141$var$PRIMARY_INSTANCE_NAME = 'mixpanel';
/** @const */ var $6c21bacc9274e141$var$PAYLOAD_TYPE_BASE64 = 'base64';
/** @const */ var $6c21bacc9274e141$var$PAYLOAD_TYPE_JSON = 'json';
/** @const */ var $6c21bacc9274e141$var$DEVICE_ID_PREFIX = '$device:';
/*
 * Dynamic... constants? Is that an oxymoron?
 */ // http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/
// https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#withCredentials
var $6c21bacc9274e141$var$USE_XHR = $6c21bacc9274e141$var$win.XMLHttpRequest && 'withCredentials' in new XMLHttpRequest();
// IE<10 does not support cross-origin XHR's but script tags
// with defer won't block window.onload; ENQUEUE_REQUESTS
// should only be true for Opera<12
var $6c21bacc9274e141$var$ENQUEUE_REQUESTS = !$6c21bacc9274e141$var$USE_XHR && $6c21bacc9274e141$var$userAgent.indexOf('MSIE') === -1 && $6c21bacc9274e141$var$userAgent.indexOf('Mozilla') === -1;
// save reference to navigator.sendBeacon so it can be minified
var $6c21bacc9274e141$var$sendBeacon = null;
if ($6c21bacc9274e141$var$navigator['sendBeacon']) $6c21bacc9274e141$var$sendBeacon = function sendBeacon() {
    // late reference to navigator.sendBeacon to allow patching/spying
    return $6c21bacc9274e141$var$navigator['sendBeacon'].apply($6c21bacc9274e141$var$navigator, arguments);
};
var $6c21bacc9274e141$var$DEFAULT_API_ROUTES = {
    track: 'track/',
    engage: 'engage/',
    groups: 'groups/',
    record: 'record/'
};
/*
 * Module-level globals
 */ var $6c21bacc9274e141$var$DEFAULT_CONFIG = {
    api_host: 'https://api-js.mixpanel.com',
    api_routes: $6c21bacc9274e141$var$DEFAULT_API_ROUTES,
    api_method: 'POST',
    api_transport: 'XHR',
    api_payload_format: $6c21bacc9274e141$var$PAYLOAD_TYPE_BASE64,
    app_host: 'https://mixpanel.com',
    cdn: 'https://cdn.mxpnl.com',
    cross_site_cookie: false,
    cross_subdomain_cookie: true,
    error_reporter: $6c21bacc9274e141$var$NOOP_FUNC,
    persistence: 'cookie',
    persistence_name: '',
    cookie_domain: '',
    cookie_name: '',
    loaded: $6c21bacc9274e141$var$NOOP_FUNC,
    mp_loader: null,
    track_marketing: true,
    track_pageview: false,
    skip_first_touch_marketing: false,
    store_google: true,
    stop_utm_persistence: false,
    save_referrer: true,
    test: false,
    verbose: false,
    img: false,
    debug: false,
    track_links_timeout: 300,
    cookie_expiration: 365,
    upgrade: false,
    disable_persistence: false,
    disable_cookie: false,
    secure_cookie: false,
    ip: true,
    opt_out_tracking_by_default: false,
    opt_out_persistence_by_default: false,
    opt_out_tracking_persistence_type: 'localStorage',
    opt_out_tracking_cookie_prefix: null,
    property_blacklist: [],
    xhr_headers: {},
    ignore_dnt: false,
    batch_requests: true,
    batch_size: 50,
    batch_flush_interval_ms: 5000,
    batch_request_timeout_ms: 90000,
    batch_autostart: true,
    hooks: {},
    record_block_class: new RegExp('^(mp-block|fs-exclude|amp-block|rr-block|ph-no-capture)$'),
    record_block_selector: 'img, video',
    record_canvas: false,
    record_collect_fonts: false,
    record_idle_timeout_ms: 1800000,
    record_mask_text_class: new RegExp('^(mp-mask|fs-mask|amp-mask|rr-mask|ph-mask)$'),
    record_mask_text_selector: '*',
    record_max_ms: $6c21bacc9274e141$var$MAX_RECORDING_MS,
    record_min_ms: 0,
    record_sessions_percent: 0,
    recorder_src: 'https://cdn.mxpnl.com/libs/mixpanel-recorder.min.js'
};
var $6c21bacc9274e141$var$DOM_LOADED = false;
/**
 * Mixpanel Library Object
 * @constructor
 */ var $6c21bacc9274e141$var$MixpanelLib = function MixpanelLib() {};
/**
 * create_mplib(token:string, config:object, name:string)
 *
 * This function is used by the init method of MixpanelLib objects
 * as well as the main initializer at the end of the JSLib (that
 * initializes document.mixpanel as well as any additional instances
 * declared before this file has loaded).
 */ var $6c21bacc9274e141$var$create_mplib = function create_mplib(token, config, name) {
    var instance, target = name === $6c21bacc9274e141$var$PRIMARY_INSTANCE_NAME ? $6c21bacc9274e141$var$mixpanel_master : $6c21bacc9274e141$var$mixpanel_master[name];
    if (target && $6c21bacc9274e141$var$init_type === $6c21bacc9274e141$var$INIT_MODULE) instance = target;
    else {
        if (target && !$6c21bacc9274e141$var$_.isArray(target)) {
            $6c21bacc9274e141$var$console$1.error('You have already initialized ' + name);
            return;
        }
        instance = new $6c21bacc9274e141$var$MixpanelLib();
    }
    instance._cached_groups = {}; // cache groups in a pool
    instance._init(token, config, name);
    instance['people'] = new $6c21bacc9274e141$var$MixpanelPeople();
    instance['people']._init(instance);
    if (!instance.get_config('skip_first_touch_marketing')) {
        // We need null UTM params in the object because
        // UTM parameters act as a tuple. If any UTM param
        // is present, then we set all UTM params including
        // empty ones together
        var utm_params = $6c21bacc9274e141$var$_.info.campaignParams(null);
        var initial_utm_params = {};
        var has_utm = false;
        $6c21bacc9274e141$var$_.each(utm_params, function(utm_value, utm_key) {
            initial_utm_params['initial_' + utm_key] = utm_value;
            if (utm_value) has_utm = true;
        });
        if (has_utm) instance['people'].set_once(initial_utm_params);
    }
    // if any instance on the page has debug = true, we set the
    // global debug to be true
    $6c21bacc9274e141$var$Config.DEBUG = $6c21bacc9274e141$var$Config.DEBUG || instance.get_config('debug');
    // if target is not defined, we called init after the lib already
    // loaded, so there won't be an array of things to execute
    if (!$6c21bacc9274e141$var$_.isUndefined(target) && $6c21bacc9274e141$var$_.isArray(target)) {
        // Crunch through the people queue first - we queue this data up &
        // flush on identify, so it's better to do all these operations first
        instance._execute_array.call(instance['people'], target['people']);
        instance._execute_array(target);
    }
    return instance;
};
// Initialization methods
/**
 * This function initializes a new instance of the Mixpanel tracking object.
 * All new instances are added to the main mixpanel object as sub properties (such as
 * mixpanel.library_name) and also returned by this function. To define a
 * second instance on the page, you would call:
 *
 *     mixpanel.init('new token', { your: 'config' }, 'library_name');
 *
 * and use it like so:
 *
 *     mixpanel.library_name.track(...);
 *
 * @param {String} token   Your Mixpanel API token
 * @param {Object} [config]  A dictionary of config options to override. <a href="https://github.com/mixpanel/mixpanel-js/blob/v2.46.0/src/mixpanel-core.js#L88-L127">See a list of default config options</a>.
 * @param {String} [name]    The name for the new mixpanel instance that you want created
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.init = function(token, config, name) {
    if ($6c21bacc9274e141$var$_.isUndefined(name)) {
        this.report_error('You must name your new library: init(token, config, name)');
        return;
    }
    if (name === $6c21bacc9274e141$var$PRIMARY_INSTANCE_NAME) {
        this.report_error('You must initialize the main mixpanel object right after you include the Mixpanel js snippet');
        return;
    }
    var instance = $6c21bacc9274e141$var$create_mplib(token, config, name);
    $6c21bacc9274e141$var$mixpanel_master[name] = instance;
    instance._loaded();
    return instance;
};
// mixpanel._init(token:string, config:object, name:string)
//
// This function sets up the current instance of the mixpanel
// library.  The difference between this method and the init(...)
// method is this one initializes the actual instance, whereas the
// init(...) method sets up a new library and calls _init on it.
//
$6c21bacc9274e141$var$MixpanelLib.prototype._init = function(token, config, name) {
    config = config || {};
    this['__loaded'] = true;
    this['config'] = {};
    var variable_features = {};
    // default to JSON payload for standard mixpanel.com API hosts
    if (!('api_payload_format' in config)) {
        var api_host = config['api_host'] || $6c21bacc9274e141$var$DEFAULT_CONFIG['api_host'];
        if (api_host.match(/\.mixpanel\.com/)) variable_features['api_payload_format'] = $6c21bacc9274e141$var$PAYLOAD_TYPE_JSON;
    }
    this.set_config($6c21bacc9274e141$var$_.extend({}, $6c21bacc9274e141$var$DEFAULT_CONFIG, variable_features, config, {
        name: name,
        token: token,
        callback_fn: (name === $6c21bacc9274e141$var$PRIMARY_INSTANCE_NAME ? name : $6c21bacc9274e141$var$PRIMARY_INSTANCE_NAME + '.' + name) + '._jsc'
    }));
    this['_jsc'] = $6c21bacc9274e141$var$NOOP_FUNC;
    this.__dom_loaded_queue = [];
    this.__request_queue = [];
    this.__disabled_events = [];
    this._flags = {
        disable_all_events: false,
        identify_called: false
    };
    // set up request queueing/batching
    this.request_batchers = {};
    this._batch_requests = this.get_config('batch_requests');
    if (this._batch_requests) {
        if (!$6c21bacc9274e141$var$_.localStorage.is_supported(true) || !$6c21bacc9274e141$var$USE_XHR) {
            this._batch_requests = false;
            $6c21bacc9274e141$var$console$1.log('Turning off Mixpanel request-queueing; needs XHR and localStorage support');
            $6c21bacc9274e141$var$_.each(this.get_batcher_configs(), function(batcher_config) {
                $6c21bacc9274e141$var$console$1.log('Clearing batch queue ' + batcher_config.queue_key);
                $6c21bacc9274e141$var$_.localStorage.remove(batcher_config.queue_key);
            });
        } else {
            this.init_batchers();
            if ($6c21bacc9274e141$var$sendBeacon && $6c21bacc9274e141$var$win.addEventListener) {
                // Before page closes or hides (user tabs away etc), attempt to flush any events
                // queued up via navigator.sendBeacon. Since sendBeacon doesn't report success/failure,
                // events will not be removed from the persistent store; if the site is loaded again,
                // the events will be flushed again on startup and deduplicated on the Mixpanel server
                // side.
                // There is no reliable way to capture only page close events, so we lean on the
                // visibilitychange and pagehide events as recommended at
                // https://developer.mozilla.org/en-US/docs/Web/API/Window/unload_event#usage_notes.
                // These events fire when the user clicks away from the current page/tab, so will occur
                // more frequently than page unload, but are the only mechanism currently for capturing
                // this scenario somewhat reliably.
                var flush_on_unload = $6c21bacc9274e141$var$_.bind(function() {
                    if (!this.request_batchers.events.stopped) this.request_batchers.events.flush({
                        unloading: true
                    });
                }, this);
                $6c21bacc9274e141$var$win.addEventListener('pagehide', function(ev) {
                    if (ev['persisted']) flush_on_unload();
                });
                $6c21bacc9274e141$var$win.addEventListener('visibilitychange', function() {
                    if ($6c21bacc9274e141$var$document$1['visibilityState'] === 'hidden') flush_on_unload();
                });
            }
        }
    }
    this['persistence'] = this['cookie'] = new $6c21bacc9274e141$var$MixpanelPersistence(this['config']);
    this.unpersisted_superprops = {};
    this._gdpr_init();
    var uuid = $6c21bacc9274e141$var$_.UUID();
    if (!this.get_distinct_id()) // There is no need to set the distinct id
    // or the device id if something was already stored
    // in the persitence
    this.register_once({
        distinct_id: $6c21bacc9274e141$var$DEVICE_ID_PREFIX + uuid,
        $device_id: uuid
    }, '');
    var track_pageview_option = this.get_config('track_pageview');
    if (track_pageview_option) this._init_url_change_tracking(track_pageview_option);
    if (this.get_config('record_sessions_percent') > 0 && Math.random() * 100 <= this.get_config('record_sessions_percent')) this.start_session_recording();
};
$6c21bacc9274e141$var$MixpanelLib.prototype.start_session_recording = $6c21bacc9274e141$var$addOptOutCheckMixpanelLib(function() {
    if (!$6c21bacc9274e141$var$win['MutationObserver']) {
        $6c21bacc9274e141$var$console$1.critical('Browser does not support MutationObserver; skipping session recording');
        return;
    }
    var handleLoadedRecorder = $6c21bacc9274e141$var$_.bind(function() {
        this._recorder = this._recorder || new $6c21bacc9274e141$var$win['__mp_recorder'](this);
        this._recorder['startRecording']();
    }, this);
    if ($6c21bacc9274e141$var$_.isUndefined($6c21bacc9274e141$var$win['__mp_recorder'])) $6c21bacc9274e141$var$load_extra_bundle(this.get_config('recorder_src'), handleLoadedRecorder);
    else handleLoadedRecorder();
});
$6c21bacc9274e141$var$MixpanelLib.prototype.stop_session_recording = function() {
    if (this._recorder) this._recorder['stopRecording']();
    else $6c21bacc9274e141$var$console$1.critical('Session recorder module not loaded');
};
$6c21bacc9274e141$var$MixpanelLib.prototype.get_session_recording_properties = function() {
    var props = {};
    var replay_id = this._get_session_replay_id();
    if (replay_id) props['$mp_replay_id'] = replay_id;
    return props;
};
$6c21bacc9274e141$var$MixpanelLib.prototype.get_session_replay_url = function() {
    var replay_url = null;
    var replay_id = this._get_session_replay_id();
    if (replay_id) {
        var query_params = $6c21bacc9274e141$var$_.HTTPBuildQuery({
            replay_id: replay_id,
            distinct_id: this.get_distinct_id(),
            token: this.get_config('token')
        });
        replay_url = 'https://mixpanel.com/projects/replay-redirect?' + query_params;
    }
    return replay_url;
};
$6c21bacc9274e141$var$MixpanelLib.prototype._get_session_replay_id = function() {
    var replay_id = null;
    if (this._recorder) replay_id = this._recorder['replayId'];
    return replay_id || null;
};
// Private methods
$6c21bacc9274e141$var$MixpanelLib.prototype._loaded = function() {
    this.get_config('loaded')(this);
    this._set_default_superprops();
    this['people'].set_once(this['persistence'].get_referrer_info());
    // `store_google` is now deprecated and previously stored UTM parameters are cleared
    // from persistence by default.
    if (this.get_config('store_google') && this.get_config('stop_utm_persistence')) {
        var utm_params = $6c21bacc9274e141$var$_.info.campaignParams(null);
        $6c21bacc9274e141$var$_.each(utm_params, (function(_utm_value, utm_key) {
            // We need to unregister persisted UTM parameters so old values
            // are not mixed with the new UTM parameters
            this.unregister(utm_key);
        }).bind(this));
    }
};
// update persistence with info on referrer, UTM params, etc
$6c21bacc9274e141$var$MixpanelLib.prototype._set_default_superprops = function() {
    this['persistence'].update_search_keyword($6c21bacc9274e141$var$document$1.referrer);
    // Registering super properties for UTM persistence by 'store_google' is deprecated.
    if (this.get_config('store_google') && !this.get_config('stop_utm_persistence')) this.register($6c21bacc9274e141$var$_.info.campaignParams());
    if (this.get_config('save_referrer')) this['persistence'].update_referrer_info($6c21bacc9274e141$var$document$1.referrer);
};
$6c21bacc9274e141$var$MixpanelLib.prototype._dom_loaded = function() {
    $6c21bacc9274e141$var$_.each(this.__dom_loaded_queue, function(item) {
        this._track_dom.apply(this, item);
    }, this);
    if (!this.has_opted_out_tracking()) $6c21bacc9274e141$var$_.each(this.__request_queue, function(item) {
        this._send_request.apply(this, item);
    }, this);
    delete this.__dom_loaded_queue;
    delete this.__request_queue;
};
$6c21bacc9274e141$var$MixpanelLib.prototype._track_dom = function(DomClass, args) {
    if (this.get_config('img')) {
        this.report_error('You can\'t use DOM tracking functions with img = true.');
        return false;
    }
    if (!$6c21bacc9274e141$var$DOM_LOADED) {
        this.__dom_loaded_queue.push([
            DomClass,
            args
        ]);
        return false;
    }
    var dt = new DomClass().init(this);
    return dt.track.apply(dt, args);
};
$6c21bacc9274e141$var$MixpanelLib.prototype._init_url_change_tracking = function(track_pageview_option) {
    var previous_tracked_url = '';
    var tracked = this.track_pageview();
    if (tracked) previous_tracked_url = $6c21bacc9274e141$var$_.info.currentUrl();
    if ($6c21bacc9274e141$var$_.include([
        'full-url',
        'url-with-path-and-query-string',
        'url-with-path'
    ], track_pageview_option)) {
        $6c21bacc9274e141$var$win.addEventListener('popstate', function() {
            $6c21bacc9274e141$var$win.dispatchEvent(new Event('mp_locationchange'));
        });
        $6c21bacc9274e141$var$win.addEventListener('hashchange', function() {
            $6c21bacc9274e141$var$win.dispatchEvent(new Event('mp_locationchange'));
        });
        var nativePushState = $6c21bacc9274e141$var$win.history.pushState;
        if (typeof nativePushState === 'function') $6c21bacc9274e141$var$win.history.pushState = function(state, unused, url) {
            nativePushState.call($6c21bacc9274e141$var$win.history, state, unused, url);
            $6c21bacc9274e141$var$win.dispatchEvent(new Event('mp_locationchange'));
        };
        var nativeReplaceState = $6c21bacc9274e141$var$win.history.replaceState;
        if (typeof nativeReplaceState === 'function') $6c21bacc9274e141$var$win.history.replaceState = function(state, unused, url) {
            nativeReplaceState.call($6c21bacc9274e141$var$win.history, state, unused, url);
            $6c21bacc9274e141$var$win.dispatchEvent(new Event('mp_locationchange'));
        };
        $6c21bacc9274e141$var$win.addEventListener('mp_locationchange', (function() {
            var current_url = $6c21bacc9274e141$var$_.info.currentUrl();
            var should_track = false;
            if (track_pageview_option === 'full-url') should_track = current_url !== previous_tracked_url;
            else if (track_pageview_option === 'url-with-path-and-query-string') should_track = current_url.split('#')[0] !== previous_tracked_url.split('#')[0];
            else if (track_pageview_option === 'url-with-path') should_track = current_url.split('#')[0].split('?')[0] !== previous_tracked_url.split('#')[0].split('?')[0];
            if (should_track) {
                var tracked = this.track_pageview();
                if (tracked) previous_tracked_url = current_url;
            }
        }).bind(this));
    }
};
/**
 * _prepare_callback() should be called by callers of _send_request for use
 * as the callback argument.
 *
 * If there is no callback, this returns null.
 * If we are going to make XHR/XDR requests, this returns a function.
 * If we are going to use script tags, this returns a string to use as the
 * callback GET param.
 */ $6c21bacc9274e141$var$MixpanelLib.prototype._prepare_callback = function(callback, data) {
    if ($6c21bacc9274e141$var$_.isUndefined(callback)) return null;
    if ($6c21bacc9274e141$var$USE_XHR) {
        var callback_function = function callback_function(response) {
            callback(response, data);
        };
        return callback_function;
    } else {
        // if the user gives us a callback, we store as a random
        // property on this instances jsc function and update our
        // callback string to reflect that.
        var jsc = this['_jsc'];
        var randomized_cb = '' + Math.floor(Math.random() * 100000000);
        var callback_string = this.get_config('callback_fn') + '[' + randomized_cb + ']';
        jsc[randomized_cb] = function(response) {
            delete jsc[randomized_cb];
            callback(response, data);
        };
        return callback_string;
    }
};
$6c21bacc9274e141$var$MixpanelLib.prototype._send_request = function(url, data, options, callback) {
    var succeeded = true;
    if ($6c21bacc9274e141$var$ENQUEUE_REQUESTS) {
        this.__request_queue.push(arguments);
        return succeeded;
    }
    var DEFAULT_OPTIONS = {
        method: this.get_config('api_method'),
        transport: this.get_config('api_transport'),
        verbose: this.get_config('verbose')
    };
    var body_data = null;
    if (!callback && ($6c21bacc9274e141$var$_.isFunction(options) || typeof options === 'string')) {
        callback = options;
        options = null;
    }
    options = $6c21bacc9274e141$var$_.extend(DEFAULT_OPTIONS, options || {});
    if (!$6c21bacc9274e141$var$USE_XHR) options.method = 'GET';
    var use_post = options.method === 'POST';
    var use_sendBeacon = $6c21bacc9274e141$var$sendBeacon && use_post && options.transport.toLowerCase() === 'sendbeacon';
    // needed to correctly format responses
    var verbose_mode = options.verbose;
    if (data['verbose']) verbose_mode = true;
    if (this.get_config('test')) data['test'] = 1;
    if (verbose_mode) data['verbose'] = 1;
    if (this.get_config('img')) data['img'] = 1;
    if (!$6c21bacc9274e141$var$USE_XHR) {
        if (callback) data['callback'] = callback;
        else if (verbose_mode || this.get_config('test')) // Verbose output (from verbose mode, or an error in test mode) is a json blob,
        // which by itself is not valid javascript. Without a callback, this verbose output will
        // cause an error when returned via jsonp, so we force a no-op callback param.
        // See the ECMA script spec: http://www.ecma-international.org/ecma-262/5.1/#sec-12.4
        data['callback'] = '(function(){})';
    }
    data['ip'] = this.get_config('ip') ? 1 : 0;
    data['_'] = new Date().getTime().toString();
    if (use_post) {
        body_data = 'data=' + encodeURIComponent(data['data']);
        delete data['data'];
    }
    url += '?' + $6c21bacc9274e141$var$_.HTTPBuildQuery(data);
    var lib = this;
    if ('img' in data) {
        var img = $6c21bacc9274e141$var$document$1.createElement('img');
        img.src = url;
        $6c21bacc9274e141$var$document$1.body.appendChild(img);
    } else if (use_sendBeacon) {
        try {
            succeeded = $6c21bacc9274e141$var$sendBeacon(url, body_data);
        } catch (e) {
            lib.report_error(e);
            succeeded = false;
        }
        try {
            if (callback) callback(succeeded ? 1 : 0);
        } catch (e) {
            lib.report_error(e);
        }
    } else if ($6c21bacc9274e141$var$USE_XHR) try {
        var req = new XMLHttpRequest();
        req.open(options.method, url, true);
        var headers = this.get_config('xhr_headers');
        if (use_post) headers['Content-Type'] = 'application/x-www-form-urlencoded';
        $6c21bacc9274e141$var$_.each(headers, function(headerValue, headerName) {
            req.setRequestHeader(headerName, headerValue);
        });
        if (options.timeout_ms && typeof req.timeout !== 'undefined') {
            req.timeout = options.timeout_ms;
            var start_time = new Date().getTime();
        }
        // send the mp_optout cookie
        // withCredentials cannot be modified until after calling .open on Android and Mobile Safari
        req.withCredentials = true;
        req.onreadystatechange = function() {
            if (req.readyState === 4) {
                if (req.status === 200) {
                    if (callback) {
                        if (verbose_mode) {
                            var response;
                            try {
                                response = $6c21bacc9274e141$var$_.JSONDecode(req.responseText);
                            } catch (e) {
                                lib.report_error(e);
                                if (options.ignore_json_errors) response = req.responseText;
                                else return;
                            }
                            callback(response);
                        } else callback(Number(req.responseText));
                    }
                } else {
                    var error;
                    if (req.timeout && !req.status && new Date().getTime() - start_time >= req.timeout) error = 'timeout';
                    else error = 'Bad HTTP status: ' + req.status + ' ' + req.statusText;
                    lib.report_error(error);
                    if (callback) {
                        if (verbose_mode) {
                            var response_headers = req['responseHeaders'] || {};
                            callback({
                                status: 0,
                                httpStatusCode: req['status'],
                                error: error,
                                retryAfter: response_headers['Retry-After']
                            });
                        } else callback(0);
                    }
                }
            }
        };
        req.send(body_data);
    } catch (e) {
        lib.report_error(e);
        succeeded = false;
    }
    else {
        var script = $6c21bacc9274e141$var$document$1.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;
        script.src = url;
        var s = $6c21bacc9274e141$var$document$1.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(script, s);
    }
    return succeeded;
};
/**
 * _execute_array() deals with processing any mixpanel function
 * calls that were called before the Mixpanel library were loaded
 * (and are thus stored in an array so they can be called later)
 *
 * Note: we fire off all the mixpanel function calls && user defined
 * functions BEFORE we fire off mixpanel tracking calls. This is so
 * identify/register/set_config calls can properly modify early
 * tracking calls.
 *
 * @param {Array} array
 */ $6c21bacc9274e141$var$MixpanelLib.prototype._execute_array = function(array) {
    var fn_name, alias_calls = [], other_calls = [], tracking_calls = [];
    $6c21bacc9274e141$var$_.each(array, function(item) {
        if (item) {
            fn_name = item[0];
            if ($6c21bacc9274e141$var$_.isArray(fn_name)) tracking_calls.push(item); // chained call e.g. mixpanel.get_group().set()
            else if (typeof item === 'function') item.call(this);
            else if ($6c21bacc9274e141$var$_.isArray(item) && fn_name === 'alias') alias_calls.push(item);
            else if ($6c21bacc9274e141$var$_.isArray(item) && fn_name.indexOf('track') !== -1 && typeof this[fn_name] === 'function') tracking_calls.push(item);
            else other_calls.push(item);
        }
    }, this);
    var execute = function execute(calls, context) {
        $6c21bacc9274e141$var$_.each(calls, function(item) {
            if ($6c21bacc9274e141$var$_.isArray(item[0])) {
                // chained call
                var caller = context;
                $6c21bacc9274e141$var$_.each(item, function(call) {
                    caller = caller[call[0]].apply(caller, call.slice(1));
                });
            } else this[item[0]].apply(this, item.slice(1));
        }, context);
    };
    execute(alias_calls, this);
    execute(other_calls, this);
    execute(tracking_calls, this);
};
// request queueing utils
$6c21bacc9274e141$var$MixpanelLib.prototype.are_batchers_initialized = function() {
    return !!this.request_batchers.events;
};
$6c21bacc9274e141$var$MixpanelLib.prototype.get_batcher_configs = function() {
    var queue_prefix = '__mpq_' + this.get_config('token');
    var api_routes = this.get_config('api_routes');
    this._batcher_configs = this._batcher_configs || {
        events: {
            type: 'events',
            endpoint: '/' + api_routes['track'],
            queue_key: queue_prefix + '_ev'
        },
        people: {
            type: 'people',
            endpoint: '/' + api_routes['engage'],
            queue_key: queue_prefix + '_pp'
        },
        groups: {
            type: 'groups',
            endpoint: '/' + api_routes['groups'],
            queue_key: queue_prefix + '_gr'
        }
    };
    return this._batcher_configs;
};
$6c21bacc9274e141$var$MixpanelLib.prototype.init_batchers = function() {
    if (!this.are_batchers_initialized()) {
        var batcher_for = $6c21bacc9274e141$var$_.bind(function(attrs) {
            return new $6c21bacc9274e141$var$RequestBatcher(attrs.queue_key, {
                libConfig: this['config'],
                errorReporter: this.get_config('error_reporter'),
                sendRequestFunc: $6c21bacc9274e141$var$_.bind(function(data, options, cb) {
                    this._send_request(this.get_config('api_host') + attrs.endpoint, this._encode_data_for_request(data), options, this._prepare_callback(cb, data));
                }, this),
                beforeSendHook: $6c21bacc9274e141$var$_.bind(function(item) {
                    return this._run_hook('before_send_' + attrs.type, item);
                }, this),
                stopAllBatchingFunc: $6c21bacc9274e141$var$_.bind(this.stop_batch_senders, this),
                usePersistence: true
            });
        }, this);
        var batcher_configs = this.get_batcher_configs();
        this.request_batchers = {
            events: batcher_for(batcher_configs.events),
            people: batcher_for(batcher_configs.people),
            groups: batcher_for(batcher_configs.groups)
        };
    }
    if (this.get_config('batch_autostart')) this.start_batch_senders();
};
$6c21bacc9274e141$var$MixpanelLib.prototype.start_batch_senders = function() {
    this._batchers_were_started = true;
    if (this.are_batchers_initialized()) {
        this._batch_requests = true;
        $6c21bacc9274e141$var$_.each(this.request_batchers, function(batcher) {
            batcher.start();
        });
    }
};
$6c21bacc9274e141$var$MixpanelLib.prototype.stop_batch_senders = function() {
    this._batch_requests = false;
    $6c21bacc9274e141$var$_.each(this.request_batchers, function(batcher) {
        batcher.stop();
        batcher.clear();
    });
};
/**
 * push() keeps the standard async-array-push
 * behavior around after the lib is loaded.
 * This is only useful for external integrations that
 * do not wish to rely on our convenience methods
 * (created in the snippet).
 *
 * ### Usage:
 *     mixpanel.push(['register', { a: 'b' }]);
 *
 * @param {Array} item A [function_name, args...] array to be executed
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.push = function(item) {
    this._execute_array([
        item
    ]);
};
/**
 * Disable events on the Mixpanel object. If passed no arguments,
 * this function disables tracking of any event. If passed an
 * array of event names, those events will be disabled, but other
 * events will continue to be tracked.
 *
 * Note: this function does not stop other mixpanel functions from
 * firing, such as register() or people.set().
 *
 * @param {Array} [events] An array of event names to disable
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.disable = function(events) {
    if (typeof events === 'undefined') this._flags.disable_all_events = true;
    else this.__disabled_events = this.__disabled_events.concat(events);
};
$6c21bacc9274e141$var$MixpanelLib.prototype._encode_data_for_request = function(data) {
    var encoded_data = $6c21bacc9274e141$var$_.JSONEncode(data);
    if (this.get_config('api_payload_format') === $6c21bacc9274e141$var$PAYLOAD_TYPE_BASE64) encoded_data = $6c21bacc9274e141$var$_.base64Encode(encoded_data);
    return {
        data: encoded_data
    };
};
// internal method for handling track vs batch-enqueue logic
$6c21bacc9274e141$var$MixpanelLib.prototype._track_or_batch = function(options, callback) {
    var truncated_data = $6c21bacc9274e141$var$_.truncate(options.data, 255);
    var endpoint = options.endpoint;
    var batcher = options.batcher;
    var should_send_immediately = options.should_send_immediately;
    var send_request_options = options.send_request_options || {};
    callback = callback || $6c21bacc9274e141$var$NOOP_FUNC;
    var request_enqueued_or_initiated = true;
    var send_request_immediately = $6c21bacc9274e141$var$_.bind(function() {
        if (!send_request_options.skip_hooks) truncated_data = this._run_hook('before_send_' + options.type, truncated_data);
        if (truncated_data) {
            $6c21bacc9274e141$var$console$1.log('MIXPANEL REQUEST:');
            $6c21bacc9274e141$var$console$1.log(truncated_data);
            return this._send_request(endpoint, this._encode_data_for_request(truncated_data), send_request_options, this._prepare_callback(callback, truncated_data));
        } else return null;
    }, this);
    if (this._batch_requests && !should_send_immediately) batcher.enqueue(truncated_data).then(function(succeeded) {
        if (succeeded) callback(1, truncated_data);
        else send_request_immediately();
    });
    else request_enqueued_or_initiated = send_request_immediately();
    return request_enqueued_or_initiated && truncated_data;
};
/**
 * Track an event. This is the most important and
 * frequently used Mixpanel function.
 *
 * ### Usage:
 *
 *     // track an event named 'Registered'
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 *     // track an event using navigator.sendBeacon
 *     mixpanel.track('Left page', {'duration_seconds': 35}, {transport: 'sendBeacon'});
 *
 * To track link clicks or form submissions, see track_links() or track_forms().
 *
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Object} [options] Optional configuration for this track request.
 * @param {String} [options.transport] Transport method for network request ('xhr' or 'sendBeacon').
 * @param {Boolean} [options.send_immediately] Whether to bypass batching/queueing and send track request immediately.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.track = $6c21bacc9274e141$var$addOptOutCheckMixpanelLib(function(event_name, properties, options, callback) {
    if (!callback && typeof options === 'function') {
        callback = options;
        options = null;
    }
    options = options || {};
    var transport = options['transport']; // external API, don't minify 'transport' prop
    if (transport) options.transport = transport; // 'transport' prop name can be minified internally
    var should_send_immediately = options['send_immediately'];
    if (typeof callback !== 'function') callback = $6c21bacc9274e141$var$NOOP_FUNC;
    if ($6c21bacc9274e141$var$_.isUndefined(event_name)) {
        this.report_error('No event name provided to mixpanel.track');
        return;
    }
    if (this._event_is_disabled(event_name)) {
        callback(0);
        return;
    }
    // set defaults
    properties = $6c21bacc9274e141$var$_.extend({}, properties);
    properties['token'] = this.get_config('token');
    // set $duration if time_event was previously called for this event
    var start_timestamp = this['persistence'].remove_event_timer(event_name);
    if (!$6c21bacc9274e141$var$_.isUndefined(start_timestamp)) {
        var duration_in_ms = new Date().getTime() - start_timestamp;
        properties['$duration'] = parseFloat((duration_in_ms / 1000).toFixed(3));
    }
    this._set_default_superprops();
    var marketing_properties = this.get_config('track_marketing') ? $6c21bacc9274e141$var$_.info.marketingParams() : {};
    // note: extend writes to the first object, so lets make sure we
    // don't write to the persistence properties object and info
    // properties object by passing in a new object
    // update properties with pageview info and super-properties
    properties = $6c21bacc9274e141$var$_.extend({}, $6c21bacc9274e141$var$_.info.properties({
        mp_loader: this.get_config('mp_loader')
    }), marketing_properties, this['persistence'].properties(), this.unpersisted_superprops, this.get_session_recording_properties(), properties);
    var property_blacklist = this.get_config('property_blacklist');
    if ($6c21bacc9274e141$var$_.isArray(property_blacklist)) $6c21bacc9274e141$var$_.each(property_blacklist, function(blacklisted_prop) {
        delete properties[blacklisted_prop];
    });
    else this.report_error('Invalid value for property_blacklist config: ' + property_blacklist);
    var data = {
        event: event_name,
        properties: properties
    };
    var ret = this._track_or_batch({
        type: 'events',
        data: data,
        endpoint: this.get_config('api_host') + '/' + this.get_config('api_routes')['track'],
        batcher: this.request_batchers.events,
        should_send_immediately: should_send_immediately,
        send_request_options: options
    }, callback);
    return ret;
});
/**
 * Register the current user into one/many groups.
 *
 * ### Usage:
 *
 *      mixpanel.set_group('company', ['mixpanel', 'google']) // an array of IDs
 *      mixpanel.set_group('company', 'mixpanel')
 *      mixpanel.set_group('company', 128746312)
 *
 * @param {String} group_key Group key
 * @param {Array|String|Number} group_ids An array of group IDs, or a singular group ID
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 *
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.set_group = $6c21bacc9274e141$var$addOptOutCheckMixpanelLib(function(group_key, group_ids, callback) {
    if (!$6c21bacc9274e141$var$_.isArray(group_ids)) group_ids = [
        group_ids
    ];
    var prop = {};
    prop[group_key] = group_ids;
    this.register(prop);
    return this['people'].set(group_key, group_ids, callback);
});
/**
 * Add a new group for this user.
 *
 * ### Usage:
 *
 *      mixpanel.add_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.add_group = $6c21bacc9274e141$var$addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_values = this.get_property(group_key);
    var prop = {};
    if (old_values === undefined) {
        prop[group_key] = [
            group_id
        ];
        this.register(prop);
    } else if (old_values.indexOf(group_id) === -1) {
        old_values.push(group_id);
        prop[group_key] = old_values;
        this.register(prop);
    }
    return this['people'].union(group_key, group_id, callback);
});
/**
 * Remove a group from this user.
 *
 * ### Usage:
 *
 *      mixpanel.remove_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.remove_group = $6c21bacc9274e141$var$addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_value = this.get_property(group_key);
    // if the value doesn't exist, the persistent store is unchanged
    if (old_value !== undefined) {
        var idx = old_value.indexOf(group_id);
        if (idx > -1) {
            old_value.splice(idx, 1);
            this.register({
                group_key: old_value
            });
        }
        if (old_value.length === 0) this.unregister(group_key);
    }
    return this['people'].remove(group_key, group_id, callback);
});
/**
 * Track an event with specific groups.
 *
 * ### Usage:
 *
 *      mixpanel.track_with_groups('purchase', {'product': 'iphone'}, {'University': ['UCB', 'UCLA']})
 *
 * @param {String} event_name The name of the event (see `mixpanel.track()`)
 * @param {Object=} properties A set of properties to include with the event you're sending (see `mixpanel.track()`)
 * @param {Object=} groups An object mapping group name keys to one or more values
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.track_with_groups = $6c21bacc9274e141$var$addOptOutCheckMixpanelLib(function(event_name, properties, groups, callback) {
    var tracking_props = $6c21bacc9274e141$var$_.extend({}, properties || {});
    $6c21bacc9274e141$var$_.each(groups, function(v, k) {
        if (v !== null && v !== undefined) tracking_props[k] = v;
    });
    return this.track(event_name, tracking_props, callback);
});
$6c21bacc9274e141$var$MixpanelLib.prototype._create_map_key = function(group_key, group_id) {
    return group_key + '_' + JSON.stringify(group_id);
};
$6c21bacc9274e141$var$MixpanelLib.prototype._remove_group_from_cache = function(group_key, group_id) {
    delete this._cached_groups[this._create_map_key(group_key, group_id)];
};
/**
 * Look up reference to a Mixpanel group
 *
 * ### Usage:
 *
 *       mixpanel.get_group(group_key, group_id)
 *
 * @param {String} group_key Group key
 * @param {Object} group_id A valid Mixpanel property type
 * @returns {Object} A MixpanelGroup identifier
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.get_group = function(group_key, group_id) {
    var map_key = this._create_map_key(group_key, group_id);
    var group = this._cached_groups[map_key];
    if (group === undefined || group._group_key !== group_key || group._group_id !== group_id) {
        group = new $6c21bacc9274e141$var$MixpanelGroup();
        group._init(this, group_key, group_id);
        this._cached_groups[map_key] = group;
    }
    return group;
};
/**
 * Track a default Mixpanel page view event, which includes extra default event properties to
 * improve page view data.
 *
 * ### Usage:
 *
 *     // track a default $mp_web_page_view event
 *     mixpanel.track_pageview();
 *
 *     // track a page view event with additional event properties
 *     mixpanel.track_pageview({'ab_test_variant': 'card-layout-b'});
 *
 *     // example approach to track page views on different page types as event properties
 *     mixpanel.track_pageview({'page': 'pricing'});
 *     mixpanel.track_pageview({'page': 'homepage'});
 *
 *     // UNCOMMON: Tracking a page view event with a custom event_name option. NOT expected to be used for
 *     // individual pages on the same site or product. Use cases for custom event_name may be page
 *     // views on different products or internal applications that are considered completely separate
 *     mixpanel.track_pageview({'page': 'customer-search'}, {'event_name': '[internal] Admin Page View'});
 *
 * ### Notes:
 *
 * The `config.track_pageview` option for <a href="#mixpanelinit">mixpanel.init()</a>
 * may be turned on for tracking page loads automatically.
 *
 *     // track only page loads
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: true});
 *
 *     // track when the URL changes in any manner
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'full-url'});
 *
 *     // track when the URL changes, ignoring any changes in the hash part
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'url-with-path-and-query-string'});
 *
 *     // track when the path changes, ignoring any query parameter or hash changes
 *     mixpanel.init(PROJECT_TOKEN, {track_pageview: 'url-with-path'});
 *
 * @param {Object} [properties] An optional set of additional properties to send with the page view event
 * @param {Object} [options] Page view tracking options
 * @param {String} [options.event_name] - Alternate name for the tracking event
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.track_pageview = $6c21bacc9274e141$var$addOptOutCheckMixpanelLib(function(properties, options) {
    if ((typeof properties === "undefined" ? "undefined" : (0, $qb7pP._)(properties)) !== 'object') properties = {};
    options = options || {};
    var event_name = options['event_name'] || '$mp_web_page_view';
    var default_page_properties = $6c21bacc9274e141$var$_.extend($6c21bacc9274e141$var$_.info.mpPageViewProperties(), $6c21bacc9274e141$var$_.info.campaignParams(), $6c21bacc9274e141$var$_.info.clickParams());
    var event_properties = $6c21bacc9274e141$var$_.extend({}, default_page_properties, properties);
    return this.track(event_name, event_properties);
});
/**
 * Track clicks on a set of document elements. Selector must be a
 * valid query. Elements must exist on the page at the time track_links is called.
 *
 * ### Usage:
 *
 *     // track click for link id #nav
 *     mixpanel.track_links('#nav', 'Clicked Nav Link');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the Mixpanel
 * servers to respond. If they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] A properties object or function that returns a dictionary of properties when passed a DOMElement
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.track_links = function() {
    return this._track_dom.call(this, $6c21bacc9274e141$var$LinkTracker, arguments);
};
/**
 * Track form submissions. Selector must be a valid query.
 *
 * ### Usage:
 *
 *     // track submission for form id 'register'
 *     mixpanel.track_forms('#register', 'Created Account');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the mixpanel
 * servers to respond, if they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] This can be a set of properties, or a function that returns a set of properties after being passed a DOMElement
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.track_forms = function() {
    return this._track_dom.call(this, $6c21bacc9274e141$var$FormTracker, arguments);
};
/**
 * Time an event by including the time between this call and a
 * later 'track' call for the same event in the properties sent
 * with the event.
 *
 * ### Usage:
 *
 *     // time an event named 'Registered'
 *     mixpanel.time_event('Registered');
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 * When called for a particular event name, the next track call for that event
 * name will include the elapsed time between the 'time_event' and 'track'
 * calls. This value is stored as seconds in the '$duration' property.
 *
 * @param {String} event_name The name of the event.
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.time_event = function(event_name) {
    if ($6c21bacc9274e141$var$_.isUndefined(event_name)) {
        this.report_error('No event name provided to mixpanel.time_event');
        return;
    }
    if (this._event_is_disabled(event_name)) return;
    this['persistence'].set_event_timer(event_name, new Date().getTime());
};
var $6c21bacc9274e141$var$REGISTER_DEFAULTS = {
    persistent: true
};
/**
 * Helper to parse options param for register methods, maintaining
 * legacy support for plain "days" param instead of options object
 * @param {Number|Object} [days_or_options] 'days' option (Number), or Options object for register methods
 * @returns {Object} options object
 */ var $6c21bacc9274e141$var$options_for_register = function options_for_register(days_or_options) {
    var options;
    if ($6c21bacc9274e141$var$_.isObject(days_or_options)) options = days_or_options;
    else if (!$6c21bacc9274e141$var$_.isUndefined(days_or_options)) options = {
        days: days_or_options
    };
    else options = {};
    return $6c21bacc9274e141$var$_.extend({}, $6c21bacc9274e141$var$REGISTER_DEFAULTS, options);
};
/**
 * Register a set of super properties, which are included with all
 * events. This will overwrite previous super property values.
 *
 * ### Usage:
 *
 *     // register 'Gender' as a super property
 *     mixpanel.register({'Gender': 'Female'});
 *
 *     // register several super properties when a user signs up
 *     mixpanel.register({
 *         'Email': 'jdoe@example.com',
 *         'Account Type': 'Free'
 *     });
 *
 *     // register only for the current pageload
 *     mixpanel.register({'Name': 'Pat'}, {persistent: false});
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.register = function(props, days_or_options) {
    var options = $6c21bacc9274e141$var$options_for_register(days_or_options);
    if (options['persistent']) this['persistence'].register(props, options['days']);
    else $6c21bacc9274e141$var$_.extend(this.unpersisted_superprops, props);
};
/**
 * Register a set of super properties only once. This will not
 * overwrite previous super property values, unlike register().
 *
 * ### Usage:
 *
 *     // register a super property for the first time only
 *     mixpanel.register_once({
 *         'First Login Date': new Date().toISOString()
 *     });
 *
 *     // register once, only for the current pageload
 *     mixpanel.register_once({
 *         'First interaction time': new Date().toISOString()
 *     }, 'None', {persistent: false});
 *
 * ### Notes:
 *
 * If default_value is specified, current super properties
 * with that value will be overwritten.
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {*} [default_value] Value to override if already set in super properties (ex: 'False') Default: 'None'
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.register_once = function(props, default_value, days_or_options) {
    var options = $6c21bacc9274e141$var$options_for_register(days_or_options);
    if (options['persistent']) this['persistence'].register_once(props, default_value, options['days']);
    else {
        if (typeof default_value === 'undefined') default_value = 'None';
        $6c21bacc9274e141$var$_.each(props, function(val, prop) {
            if (!this.unpersisted_superprops.hasOwnProperty(prop) || this.unpersisted_superprops[prop] === default_value) this.unpersisted_superprops[prop] = val;
        }, this);
    }
};
/**
 * Delete a super property stored with the current user.
 *
 * @param {String} property The name of the super property to remove
 * @param {Object} [options]
 * @param {boolean} [options.persistent=true] - whether to look in persistent storage (cookie/localStorage)
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.unregister = function(property, options) {
    options = $6c21bacc9274e141$var$options_for_register(options);
    if (options['persistent']) this['persistence'].unregister(property);
    else delete this.unpersisted_superprops[property];
};
$6c21bacc9274e141$var$MixpanelLib.prototype._register_single = function(prop, value) {
    var props = {};
    props[prop] = value;
    this.register(props);
};
/**
 * Identify a user with a unique ID to track user activity across
 * devices, tie a user to their events, and create a user profile.
 * If you never call this method, unique visitors are tracked using
 * a UUID generated the first time they visit the site.
 *
 * Call identify when you know the identity of the current user,
 * typically after login or signup. We recommend against using
 * identify for anonymous visitors to your site.
 *
 * ### Notes:
 * If your project has
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the identify method will connect pre- and
 * post-authentication events when appropriate.
 *
 * If your project does not have ID Merge enabled, identify will
 * change the user's local distinct_id to the unique ID you pass.
 * Events tracked prior to authentication will not be connected
 * to the same user identity. If ID Merge is disabled, alias can
 * be used to connect pre- and post-registration events.
 *
 * @param {String} [unique_id] A string that uniquely identifies a user. If not provided, the distinct_id currently in the persistent store (cookie or localStorage) will be used.
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.identify = function(new_distinct_id, _set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback) {
    // Optional Parameters
    //  _set_callback:function  A callback to be run if and when the People set queue is flushed
    //  _add_callback:function  A callback to be run if and when the People add queue is flushed
    //  _append_callback:function  A callback to be run if and when the People append queue is flushed
    //  _set_once_callback:function  A callback to be run if and when the People set_once queue is flushed
    //  _union_callback:function  A callback to be run if and when the People union queue is flushed
    //  _unset_callback:function  A callback to be run if and when the People unset queue is flushed
    var previous_distinct_id = this.get_distinct_id();
    if (new_distinct_id && previous_distinct_id !== new_distinct_id) {
        // we allow the following condition if previous distinct_id is same as new_distinct_id
        // so that you can force flush people updates for anonymous profiles.
        if (typeof new_distinct_id === 'string' && new_distinct_id.indexOf($6c21bacc9274e141$var$DEVICE_ID_PREFIX) === 0) {
            this.report_error('distinct_id cannot have $device: prefix');
            return -1;
        }
        this.register({
            $user_id: new_distinct_id
        });
    }
    if (!this.get_property('$device_id')) {
        // The persisted distinct id might not actually be a device id at all
        // it might be a distinct id of the user from before
        var device_id = previous_distinct_id;
        this.register_once({
            $had_persisted_distinct_id: true,
            $device_id: device_id
        }, '');
    }
    // identify only changes the distinct id if it doesn't match either the existing or the alias;
    // if it's new, blow away the alias as well.
    if (new_distinct_id !== previous_distinct_id && new_distinct_id !== this.get_property($6c21bacc9274e141$var$ALIAS_ID_KEY)) {
        this.unregister($6c21bacc9274e141$var$ALIAS_ID_KEY);
        this.register({
            distinct_id: new_distinct_id
        });
    }
    this._flags.identify_called = true;
    // Flush any queued up people requests
    this['people']._flush(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback);
    // send an $identify event any time the distinct_id is changing - logic on the server
    // will determine whether or not to do anything with it.
    if (new_distinct_id !== previous_distinct_id) this.track('$identify', {
        distinct_id: new_distinct_id,
        $anon_distinct_id: previous_distinct_id
    }, {
        skip_hooks: true
    });
};
/**
 * Clears super properties and generates a new random distinct_id for this instance.
 * Useful for clearing data when a user logs out.
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.reset = function() {
    this['persistence'].clear();
    this._flags.identify_called = false;
    var uuid = $6c21bacc9274e141$var$_.UUID();
    this.register_once({
        distinct_id: $6c21bacc9274e141$var$DEVICE_ID_PREFIX + uuid,
        $device_id: uuid
    }, '');
};
/**
 * Returns the current distinct id of the user. This is either the id automatically
 * generated by the library or the id that has been passed by a call to identify().
 *
 * ### Notes:
 *
 * get_distinct_id() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // set distinct_id after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             distinct_id = mixpanel.get_distinct_id();
 *         }
 *     });
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.get_distinct_id = function() {
    return this.get_property('distinct_id');
};
/**
 * The alias method creates an alias which Mixpanel will use to
 * remap one id to another. Multiple aliases can point to the
 * same identifier.
 *
 * The following is a valid use of alias:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // You can add multiple id aliases to the existing ID
 *     mixpanel.alias('newer_id', 'existing_id');
 *
 * Aliases can also be chained - the following is a valid example:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // chain newer_id - new_id - existing_id
 *     mixpanel.alias('newer_id', 'new_id');
 *
 * Aliases cannot point to multiple identifiers - the following
 * example will not work:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // this is invalid as 'new_id' already points to 'existing_id'
 *     mixpanel.alias('new_id', 'newer_id');
 *
 * ### Notes:
 *
 * If your project does not have
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the best practice is to call alias once when a unique
 * ID is first created for a user (e.g., when a user first registers
 * for an account). Do not use alias multiple times for a single
 * user without ID Merge enabled.
 *
 * @param {String} alias A unique identifier that you want to use for this user in the future.
 * @param {String} [original] The current identifier being used for this user.
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.alias = function(alias, original) {
    // If the $people_distinct_id key exists in persistence, there has been a previous
    // mixpanel.people.identify() call made for this user. It is VERY BAD to make an alias with
    // this ID, as it will duplicate users.
    if (alias === this.get_property($6c21bacc9274e141$var$PEOPLE_DISTINCT_ID_KEY)) {
        this.report_error('Attempting to create alias for existing People user - aborting.');
        return -2;
    }
    var _this = this;
    if ($6c21bacc9274e141$var$_.isUndefined(original)) original = this.get_distinct_id();
    if (alias !== original) {
        this._register_single($6c21bacc9274e141$var$ALIAS_ID_KEY, alias);
        return this.track('$create_alias', {
            alias: alias,
            distinct_id: original
        }, {
            skip_hooks: true
        }, function() {
            // Flush the people queue
            _this.identify(alias);
        });
    } else {
        this.report_error('alias matches current distinct_id - skipping api call.');
        this.identify(alias);
        return -1;
    }
};
/**
 * Provide a string to recognize the user by. The string passed to
 * this method will appear in the Mixpanel Streams product rather
 * than an automatically generated name. Name tags do not have to
 * be unique.
 *
 * This value will only be included in Streams data.
 *
 * @param {String} name_tag A human readable name for the user
 * @deprecated
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.name_tag = function(name_tag) {
    this._register_single('mp_name_tag', name_tag);
};
/**
 * Update the configuration of a mixpanel library instance.
 *
 * The default config is:
 *
 *     {
 *       // host for requests (customizable for e.g. a local proxy)
 *       api_host: 'https://api-js.mixpanel.com',
 *
 *       // endpoints for different types of requests
 *       api_routes: {
 *         track: 'track/',
 *         engage: 'engage/',
 *         groups: 'groups/',
 *       }
 *
 *       // HTTP method for tracking requests
 *       api_method: 'POST'
 *
 *       // transport for sending requests ('XHR' or 'sendBeacon')
 *       // NB: sendBeacon should only be used for scenarios such as
 *       // page unload where a "best-effort" attempt to send is
 *       // acceptable; the sendBeacon API does not support callbacks
 *       // or any way to know the result of the request. Mixpanel
 *       // tracking via sendBeacon will not support any event-
 *       // batching or retry mechanisms.
 *       api_transport: 'XHR'
 *
 *       // request-batching/queueing/retry
 *       batch_requests: true,
 *
 *       // maximum number of events/updates to send in a single
 *       // network request
 *       batch_size: 50,
 *
 *       // milliseconds to wait between sending batch requests
 *       batch_flush_interval_ms: 5000,
 *
 *       // milliseconds to wait for network responses to batch requests
 *       // before they are considered timed-out and retried
 *       batch_request_timeout_ms: 90000,
 *
 *       // override value for cookie domain, only useful for ensuring
 *       // correct cross-subdomain cookies on unusual domains like
 *       // subdomain.mainsite.avocat.fr; NB this cannot be used to
 *       // set cookies on a different domain than the current origin
 *       cookie_domain: ''
 *
 *       // super properties cookie expiration (in days)
 *       cookie_expiration: 365
 *
 *       // if true, cookie will be set with SameSite=None; Secure
 *       // this is only useful in special situations, like embedded
 *       // 3rd-party iframes that set up a Mixpanel instance
 *       cross_site_cookie: false
 *
 *       // super properties span subdomains
 *       cross_subdomain_cookie: true
 *
 *       // debug mode
 *       debug: false
 *
 *       // if this is true, the mixpanel cookie or localStorage entry
 *       // will be deleted, and no user persistence will take place
 *       disable_persistence: false
 *
 *       // if this is true, Mixpanel will automatically determine
 *       // City, Region and Country data using the IP address of
 *       //the client
 *       ip: true
 *
 *       // opt users out of tracking by this Mixpanel instance by default
 *       opt_out_tracking_by_default: false
 *
 *       // opt users out of browser data storage by this Mixpanel instance by default
 *       opt_out_persistence_by_default: false
 *
 *       // persistence mechanism used by opt-in/opt-out methods - cookie
 *       // or localStorage - falls back to cookie if localStorage is unavailable
 *       opt_out_tracking_persistence_type: 'localStorage'
 *
 *       // customize the name of cookie/localStorage set by opt-in/opt-out methods
 *       opt_out_tracking_cookie_prefix: null
 *
 *       // type of persistent store for super properties (cookie/
 *       // localStorage) if set to 'localStorage', any existing
 *       // mixpanel cookie value with the same persistence_name
 *       // will be transferred to localStorage and deleted
 *       persistence: 'cookie'
 *
 *       // name for super properties persistent store
 *       persistence_name: ''
 *
 *       // names of properties/superproperties which should never
 *       // be sent with track() calls
 *       property_blacklist: []
 *
 *       // if this is true, mixpanel cookies will be marked as
 *       // secure, meaning they will only be transmitted over https
 *       secure_cookie: false
 *
 *       // disables enriching user profiles with first touch marketing data
 *       skip_first_touch_marketing: false
 *
 *       // the amount of time track_links will
 *       // wait for Mixpanel's servers to respond
 *       track_links_timeout: 300
 *
 *       // adds any UTM parameters and click IDs present on the page to any events fired
 *       track_marketing: true
 *
 *       // enables automatic page view tracking using default page view events through
 *       // the track_pageview() method
 *       track_pageview: false
 *
 *       // if you set upgrade to be true, the library will check for
 *       // a cookie from our old js library and import super
 *       // properties from it, then the old cookie is deleted
 *       // The upgrade config option only works in the initialization,
 *       // so make sure you set it when you create the library.
 *       upgrade: false
 *
 *       // extra HTTP request headers to set for each API request, in
 *       // the format {'Header-Name': value}
 *       xhr_headers: {}
 *
 *       // whether to ignore or respect the web browser's Do Not Track setting
 *       ignore_dnt: false
 *     }
 *
 *
 * @param {Object} config A dictionary of new configuration values to update
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.set_config = function(config) {
    if ($6c21bacc9274e141$var$_.isObject(config)) {
        $6c21bacc9274e141$var$_.extend(this['config'], config);
        var new_batch_size = config['batch_size'];
        if (new_batch_size) $6c21bacc9274e141$var$_.each(this.request_batchers, function(batcher) {
            batcher.resetBatchSize();
        });
        if (!this.get_config('persistence_name')) this['config']['persistence_name'] = this['config']['cookie_name'];
        if (!this.get_config('disable_persistence')) this['config']['disable_persistence'] = this['config']['disable_cookie'];
        if (this['persistence']) this['persistence'].update_config(this['config']);
        $6c21bacc9274e141$var$Config.DEBUG = $6c21bacc9274e141$var$Config.DEBUG || this.get_config('debug');
    }
};
/**
 * returns the current config object for the library.
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.get_config = function(prop_name) {
    return this['config'][prop_name];
};
/**
 * Fetch a hook function from config, with safe default, and run it
 * against the given arguments
 * @param {string} hook_name which hook to retrieve
 * @returns {any|null} return value of user-provided hook, or null if nothing was returned
 */ $6c21bacc9274e141$var$MixpanelLib.prototype._run_hook = function(hook_name) {
    var ret = (this['config']['hooks'][hook_name] || $6c21bacc9274e141$var$IDENTITY_FUNC).apply(this, $6c21bacc9274e141$var$slice.call(arguments, 1));
    if (typeof ret === 'undefined') {
        this.report_error(hook_name + ' hook did not return a value');
        ret = null;
    }
    return ret;
};
/**
 * Returns the value of the super property named property_name. If no such
 * property is set, get_property() will return the undefined value.
 *
 * ### Notes:
 *
 * get_property() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // grab value for 'user_id' after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             user_id = mixpanel.get_property('user_id');
 *         }
 *     });
 *
 * @param {String} property_name The name of the super property you want to retrieve
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.get_property = function(property_name) {
    return this['persistence'].load_prop([
        property_name
    ]);
};
$6c21bacc9274e141$var$MixpanelLib.prototype.toString = function() {
    var name = this.get_config('name');
    if (name !== $6c21bacc9274e141$var$PRIMARY_INSTANCE_NAME) name = $6c21bacc9274e141$var$PRIMARY_INSTANCE_NAME + '.' + name;
    return name;
};
$6c21bacc9274e141$var$MixpanelLib.prototype._event_is_disabled = function(event_name) {
    return $6c21bacc9274e141$var$_.isBlockedUA($6c21bacc9274e141$var$userAgent) || this._flags.disable_all_events || $6c21bacc9274e141$var$_.include(this.__disabled_events, event_name);
};
// perform some housekeeping around GDPR opt-in/out state
$6c21bacc9274e141$var$MixpanelLib.prototype._gdpr_init = function() {
    var is_localStorage_requested = this.get_config('opt_out_tracking_persistence_type') === 'localStorage';
    // try to convert opt-in/out cookies to localStorage if possible
    if (is_localStorage_requested && $6c21bacc9274e141$var$_.localStorage.is_supported()) {
        if (!this.has_opted_in_tracking() && this.has_opted_in_tracking({
            persistence_type: 'cookie'
        })) this.opt_in_tracking({
            enable_persistence: false
        });
        if (!this.has_opted_out_tracking() && this.has_opted_out_tracking({
            persistence_type: 'cookie'
        })) this.opt_out_tracking({
            clear_persistence: false
        });
        this.clear_opt_in_out_tracking({
            persistence_type: 'cookie',
            enable_persistence: false
        });
    }
    // check whether the user has already opted out - if so, clear & disable persistence
    if (this.has_opted_out_tracking()) this._gdpr_update_persistence({
        clear_persistence: true
    });
    else if (!this.has_opted_in_tracking() && (this.get_config('opt_out_tracking_by_default') || $6c21bacc9274e141$var$_.cookie.get('mp_optout'))) {
        $6c21bacc9274e141$var$_.cookie.remove('mp_optout');
        this.opt_out_tracking({
            clear_persistence: this.get_config('opt_out_persistence_by_default')
        });
    }
};
/**
 * Enable or disable persistence based on options
 * only enable/disable if persistence is not already in this state
 * @param {boolean} [options.clear_persistence] If true, will delete all data stored by the sdk in persistence and disable it
 * @param {boolean} [options.enable_persistence] If true, will re-enable sdk persistence
 */ $6c21bacc9274e141$var$MixpanelLib.prototype._gdpr_update_persistence = function(options) {
    var disabled;
    if (options && options['clear_persistence']) disabled = true;
    else if (options && options['enable_persistence']) disabled = false;
    else return;
    if (!this.get_config('disable_persistence') && this['persistence'].disabled !== disabled) this['persistence'].set_disabled(disabled);
    if (disabled) this.stop_batch_senders();
    else // only start batchers after opt-in if they have previously been started
    // in order to avoid unintentionally starting up batching for the first time
    if (this._batchers_were_started) this.start_batch_senders();
};
// call a base gdpr function after constructing the appropriate token and options args
$6c21bacc9274e141$var$MixpanelLib.prototype._gdpr_call_func = function(func, options) {
    options = $6c21bacc9274e141$var$_.extend({
        track: $6c21bacc9274e141$var$_.bind(this.track, this),
        persistence_type: this.get_config('opt_out_tracking_persistence_type'),
        cookie_prefix: this.get_config('opt_out_tracking_cookie_prefix'),
        cookie_expiration: this.get_config('cookie_expiration'),
        cross_site_cookie: this.get_config('cross_site_cookie'),
        cross_subdomain_cookie: this.get_config('cross_subdomain_cookie'),
        cookie_domain: this.get_config('cookie_domain'),
        secure_cookie: this.get_config('secure_cookie'),
        ignore_dnt: this.get_config('ignore_dnt')
    }, options);
    // check if localStorage can be used for recording opt out status, fall back to cookie if not
    if (!$6c21bacc9274e141$var$_.localStorage.is_supported()) options['persistence_type'] = 'cookie';
    return func(this.get_config('token'), {
        track: options['track'],
        trackEventName: options['track_event_name'],
        trackProperties: options['track_properties'],
        persistenceType: options['persistence_type'],
        persistencePrefix: options['cookie_prefix'],
        cookieDomain: options['cookie_domain'],
        cookieExpiration: options['cookie_expiration'],
        crossSiteCookie: options['cross_site_cookie'],
        crossSubdomainCookie: options['cross_subdomain_cookie'],
        secureCookie: options['secure_cookie'],
        ignoreDnt: options['ignore_dnt']
    });
};
/**
 * Opt the user in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // opt user in
 *     mixpanel.opt_in_tracking();
 *
 *     // opt user in with specific event name, properties, cookie configuration
 *     mixpanel.opt_in_tracking({
 *         track_event_name: 'User opted in',
 *         track_event_properties: {
 *             'Email': 'jdoe@example.com'
 *         },
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {function} [options.track] Function used for tracking a Mixpanel event to record the opt-in action (default is this Mixpanel instance's track method)
 * @param {string} [options.track_event_name=$opt_in] Event name to be used for tracking the opt-in action
 * @param {Object} [options.track_properties] Set of properties to be tracked along with the opt-in action
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.opt_in_tracking = function(options) {
    options = $6c21bacc9274e141$var$_.extend({
        enable_persistence: true
    }, options);
    this._gdpr_call_func($6c21bacc9274e141$var$optIn, options);
    this._gdpr_update_persistence(options);
};
/**
 * Opt the user out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // opt user out
 *     mixpanel.opt_out_tracking();
 *
 *     // opt user out with different cookie configuration from Mixpanel instance
 *     mixpanel.opt_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.delete_user=true] If true, will delete the currently identified user's profile and clear all charges after opting the user out
 * @param {boolean} [options.clear_persistence=true] If true, will delete all data stored by the sdk in persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.opt_out_tracking = function(options) {
    options = $6c21bacc9274e141$var$_.extend({
        clear_persistence: true,
        delete_user: true
    }, options);
    // delete user and clear charges since these methods may be disabled by opt-out
    if (options['delete_user'] && this['people'] && this['people']._identify_called()) {
        this['people'].delete_user();
        this['people'].clear_charges();
    }
    this._gdpr_call_func($6c21bacc9274e141$var$optOut, options);
    this._gdpr_update_persistence(options);
};
/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     var has_opted_in = mixpanel.has_opted_in_tracking();
 *     // use has_opted_in value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-in status
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.has_opted_in_tracking = function(options) {
    return this._gdpr_call_func($6c21bacc9274e141$var$hasOptedIn, options);
};
/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     var has_opted_out = mixpanel.has_opted_out_tracking();
 *     // use has_opted_out value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-out status
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.has_opted_out_tracking = function(options) {
    return this._gdpr_call_func($6c21bacc9274e141$var$hasOptedOut, options);
};
/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage:
 *
 *     // clear user's opt-in/out status
 *     mixpanel.clear_opt_in_out_tracking();
 *
 *     // clear user's opt-in/out status with specific cookie configuration - should match
 *     // configuration used when opt_in_tracking/opt_out_tracking methods were called.
 *     mixpanel.clear_opt_in_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $6c21bacc9274e141$var$MixpanelLib.prototype.clear_opt_in_out_tracking = function(options) {
    options = $6c21bacc9274e141$var$_.extend({
        enable_persistence: true
    }, options);
    this._gdpr_call_func($6c21bacc9274e141$var$clearOptInOut, options);
    this._gdpr_update_persistence(options);
};
$6c21bacc9274e141$var$MixpanelLib.prototype.report_error = function(msg, err) {
    $6c21bacc9274e141$var$console$1.error.apply($6c21bacc9274e141$var$console$1.error, arguments);
    try {
        if (!err && !(msg instanceof Error)) msg = new Error(msg);
        this.get_config('error_reporter')(msg, err);
    } catch (err) {
        $6c21bacc9274e141$var$console$1.error(err);
    }
};
// EXPORTS (for closure compiler)
// MixpanelLib Exports
$6c21bacc9274e141$var$MixpanelLib.prototype['init'] = $6c21bacc9274e141$var$MixpanelLib.prototype.init;
$6c21bacc9274e141$var$MixpanelLib.prototype['reset'] = $6c21bacc9274e141$var$MixpanelLib.prototype.reset;
$6c21bacc9274e141$var$MixpanelLib.prototype['disable'] = $6c21bacc9274e141$var$MixpanelLib.prototype.disable;
$6c21bacc9274e141$var$MixpanelLib.prototype['time_event'] = $6c21bacc9274e141$var$MixpanelLib.prototype.time_event;
$6c21bacc9274e141$var$MixpanelLib.prototype['track'] = $6c21bacc9274e141$var$MixpanelLib.prototype.track;
$6c21bacc9274e141$var$MixpanelLib.prototype['track_links'] = $6c21bacc9274e141$var$MixpanelLib.prototype.track_links;
$6c21bacc9274e141$var$MixpanelLib.prototype['track_forms'] = $6c21bacc9274e141$var$MixpanelLib.prototype.track_forms;
$6c21bacc9274e141$var$MixpanelLib.prototype['track_pageview'] = $6c21bacc9274e141$var$MixpanelLib.prototype.track_pageview;
$6c21bacc9274e141$var$MixpanelLib.prototype['register'] = $6c21bacc9274e141$var$MixpanelLib.prototype.register;
$6c21bacc9274e141$var$MixpanelLib.prototype['register_once'] = $6c21bacc9274e141$var$MixpanelLib.prototype.register_once;
$6c21bacc9274e141$var$MixpanelLib.prototype['unregister'] = $6c21bacc9274e141$var$MixpanelLib.prototype.unregister;
$6c21bacc9274e141$var$MixpanelLib.prototype['identify'] = $6c21bacc9274e141$var$MixpanelLib.prototype.identify;
$6c21bacc9274e141$var$MixpanelLib.prototype['alias'] = $6c21bacc9274e141$var$MixpanelLib.prototype.alias;
$6c21bacc9274e141$var$MixpanelLib.prototype['name_tag'] = $6c21bacc9274e141$var$MixpanelLib.prototype.name_tag;
$6c21bacc9274e141$var$MixpanelLib.prototype['set_config'] = $6c21bacc9274e141$var$MixpanelLib.prototype.set_config;
$6c21bacc9274e141$var$MixpanelLib.prototype['get_config'] = $6c21bacc9274e141$var$MixpanelLib.prototype.get_config;
$6c21bacc9274e141$var$MixpanelLib.prototype['get_property'] = $6c21bacc9274e141$var$MixpanelLib.prototype.get_property;
$6c21bacc9274e141$var$MixpanelLib.prototype['get_distinct_id'] = $6c21bacc9274e141$var$MixpanelLib.prototype.get_distinct_id;
$6c21bacc9274e141$var$MixpanelLib.prototype['toString'] = $6c21bacc9274e141$var$MixpanelLib.prototype.toString;
$6c21bacc9274e141$var$MixpanelLib.prototype['opt_out_tracking'] = $6c21bacc9274e141$var$MixpanelLib.prototype.opt_out_tracking;
$6c21bacc9274e141$var$MixpanelLib.prototype['opt_in_tracking'] = $6c21bacc9274e141$var$MixpanelLib.prototype.opt_in_tracking;
$6c21bacc9274e141$var$MixpanelLib.prototype['has_opted_out_tracking'] = $6c21bacc9274e141$var$MixpanelLib.prototype.has_opted_out_tracking;
$6c21bacc9274e141$var$MixpanelLib.prototype['has_opted_in_tracking'] = $6c21bacc9274e141$var$MixpanelLib.prototype.has_opted_in_tracking;
$6c21bacc9274e141$var$MixpanelLib.prototype['clear_opt_in_out_tracking'] = $6c21bacc9274e141$var$MixpanelLib.prototype.clear_opt_in_out_tracking;
$6c21bacc9274e141$var$MixpanelLib.prototype['get_group'] = $6c21bacc9274e141$var$MixpanelLib.prototype.get_group;
$6c21bacc9274e141$var$MixpanelLib.prototype['set_group'] = $6c21bacc9274e141$var$MixpanelLib.prototype.set_group;
$6c21bacc9274e141$var$MixpanelLib.prototype['add_group'] = $6c21bacc9274e141$var$MixpanelLib.prototype.add_group;
$6c21bacc9274e141$var$MixpanelLib.prototype['remove_group'] = $6c21bacc9274e141$var$MixpanelLib.prototype.remove_group;
$6c21bacc9274e141$var$MixpanelLib.prototype['track_with_groups'] = $6c21bacc9274e141$var$MixpanelLib.prototype.track_with_groups;
$6c21bacc9274e141$var$MixpanelLib.prototype['start_batch_senders'] = $6c21bacc9274e141$var$MixpanelLib.prototype.start_batch_senders;
$6c21bacc9274e141$var$MixpanelLib.prototype['stop_batch_senders'] = $6c21bacc9274e141$var$MixpanelLib.prototype.stop_batch_senders;
$6c21bacc9274e141$var$MixpanelLib.prototype['start_session_recording'] = $6c21bacc9274e141$var$MixpanelLib.prototype.start_session_recording;
$6c21bacc9274e141$var$MixpanelLib.prototype['stop_session_recording'] = $6c21bacc9274e141$var$MixpanelLib.prototype.stop_session_recording;
$6c21bacc9274e141$var$MixpanelLib.prototype['get_session_recording_properties'] = $6c21bacc9274e141$var$MixpanelLib.prototype.get_session_recording_properties;
$6c21bacc9274e141$var$MixpanelLib.prototype['get_session_replay_url'] = $6c21bacc9274e141$var$MixpanelLib.prototype.get_session_replay_url;
$6c21bacc9274e141$var$MixpanelLib.prototype['DEFAULT_API_ROUTES'] = $6c21bacc9274e141$var$DEFAULT_API_ROUTES;
// MixpanelPersistence Exports
$6c21bacc9274e141$var$MixpanelPersistence.prototype['properties'] = $6c21bacc9274e141$var$MixpanelPersistence.prototype.properties;
$6c21bacc9274e141$var$MixpanelPersistence.prototype['update_search_keyword'] = $6c21bacc9274e141$var$MixpanelPersistence.prototype.update_search_keyword;
$6c21bacc9274e141$var$MixpanelPersistence.prototype['update_referrer_info'] = $6c21bacc9274e141$var$MixpanelPersistence.prototype.update_referrer_info;
$6c21bacc9274e141$var$MixpanelPersistence.prototype['get_cross_subdomain'] = $6c21bacc9274e141$var$MixpanelPersistence.prototype.get_cross_subdomain;
$6c21bacc9274e141$var$MixpanelPersistence.prototype['clear'] = $6c21bacc9274e141$var$MixpanelPersistence.prototype.clear;
var $6c21bacc9274e141$var$instances = {};
var $6c21bacc9274e141$var$extend_mp = function extend_mp() {
    // add all the sub mixpanel instances
    $6c21bacc9274e141$var$_.each($6c21bacc9274e141$var$instances, function(instance, name) {
        if (name !== $6c21bacc9274e141$var$PRIMARY_INSTANCE_NAME) $6c21bacc9274e141$var$mixpanel_master[name] = instance;
    });
    // add private functions as _
    $6c21bacc9274e141$var$mixpanel_master['_'] = $6c21bacc9274e141$var$_;
};
var $6c21bacc9274e141$var$override_mp_init_func = function override_mp_init_func() {
    // we override the snippets init function to handle the case where a
    // user initializes the mixpanel library after the script loads & runs
    $6c21bacc9274e141$var$mixpanel_master['init'] = function(token, config, name) {
        if (name) {
            // initialize a sub library
            if (!$6c21bacc9274e141$var$mixpanel_master[name]) {
                $6c21bacc9274e141$var$mixpanel_master[name] = $6c21bacc9274e141$var$instances[name] = $6c21bacc9274e141$var$create_mplib(token, config, name);
                $6c21bacc9274e141$var$mixpanel_master[name]._loaded();
            }
            return $6c21bacc9274e141$var$mixpanel_master[name];
        } else {
            var instance = $6c21bacc9274e141$var$mixpanel_master;
            if ($6c21bacc9274e141$var$instances[$6c21bacc9274e141$var$PRIMARY_INSTANCE_NAME]) // main mixpanel lib already initialized
            instance = $6c21bacc9274e141$var$instances[$6c21bacc9274e141$var$PRIMARY_INSTANCE_NAME];
            else if (token) {
                // intialize the main mixpanel lib
                instance = $6c21bacc9274e141$var$create_mplib(token, config, $6c21bacc9274e141$var$PRIMARY_INSTANCE_NAME);
                instance._loaded();
                $6c21bacc9274e141$var$instances[$6c21bacc9274e141$var$PRIMARY_INSTANCE_NAME] = instance;
            }
            $6c21bacc9274e141$var$mixpanel_master = instance;
            if ($6c21bacc9274e141$var$init_type === $6c21bacc9274e141$var$INIT_SNIPPET) $6c21bacc9274e141$var$win[$6c21bacc9274e141$var$PRIMARY_INSTANCE_NAME] = $6c21bacc9274e141$var$mixpanel_master;
            $6c21bacc9274e141$var$extend_mp();
        }
    };
};
var $6c21bacc9274e141$var$add_dom_loaded_handler = function add_dom_loaded_handler() {
    // Cross browser DOM Loaded support
    function dom_loaded_handler() {
        // function flag since we only want to execute this once
        if (dom_loaded_handler.done) return;
        dom_loaded_handler.done = true;
        $6c21bacc9274e141$var$DOM_LOADED = true;
        $6c21bacc9274e141$var$ENQUEUE_REQUESTS = false;
        $6c21bacc9274e141$var$_.each($6c21bacc9274e141$var$instances, function(inst) {
            inst._dom_loaded();
        });
    }
    function do_scroll_check() {
        try {
            $6c21bacc9274e141$var$document$1.documentElement.doScroll('left');
        } catch (e) {
            setTimeout(do_scroll_check, 1);
            return;
        }
        dom_loaded_handler();
    }
    if ($6c21bacc9274e141$var$document$1.addEventListener) {
        if ($6c21bacc9274e141$var$document$1.readyState === 'complete') // safari 4 can fire the DOMContentLoaded event before loading all
        // external JS (including this file). you will see some copypasta
        // on the internet that checks for 'complete' and 'loaded', but
        // 'loaded' is an IE thing
        dom_loaded_handler();
        else $6c21bacc9274e141$var$document$1.addEventListener('DOMContentLoaded', dom_loaded_handler, false);
    } else if ($6c21bacc9274e141$var$document$1.attachEvent) {
        // IE
        $6c21bacc9274e141$var$document$1.attachEvent('onreadystatechange', dom_loaded_handler);
        // check to make sure we arn't in a frame
        var toplevel = false;
        try {
            toplevel = $6c21bacc9274e141$var$win.frameElement === null;
        } catch (e) {
        // noop
        }
        if ($6c21bacc9274e141$var$document$1.documentElement.doScroll && toplevel) do_scroll_check();
    }
    // fallback handler, always will work
    $6c21bacc9274e141$var$_.register_event($6c21bacc9274e141$var$win, 'load', dom_loaded_handler, true);
};
function $6c21bacc9274e141$var$init_as_module(bundle_loader) {
    $6c21bacc9274e141$var$load_extra_bundle = bundle_loader;
    $6c21bacc9274e141$var$init_type = $6c21bacc9274e141$var$INIT_MODULE;
    $6c21bacc9274e141$var$mixpanel_master = new $6c21bacc9274e141$var$MixpanelLib();
    $6c21bacc9274e141$var$override_mp_init_func();
    $6c21bacc9274e141$var$mixpanel_master['init']();
    $6c21bacc9274e141$var$add_dom_loaded_handler();
    return $6c21bacc9274e141$var$mixpanel_master;
}
// For loading separate bundles asynchronously via script tag
// For builds that have everything in one bundle, no extra work.
function $6c21bacc9274e141$var$loadNoop(_src, onload) {
    onload();
}
/* eslint camelcase: "off" */ var $6c21bacc9274e141$export$2e2bcd8739ae039 = $6c21bacc9274e141$var$init_as_module($6c21bacc9274e141$var$loadNoop);


var $fc18c856e77e0624$var$timeout = function(s) {
    return new Promise(function(_, reject) {
        setTimeout(function() {
            reject(new Error("Request took too long! Timeout after ".concat(s, " seconds")));
        }, s * 1000);
    });
};
var $fc18c856e77e0624$export$d047a7c56db64af4 = /*#__PURE__*/ function() {
    var _ref = (0, $5Pgs2._)(function(url) {
        var res, data, err;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        Promise.race([
                            fetch(url),
                            $fc18c856e77e0624$var$timeout((0, $0d51ec966e2c6e90$export$196440f71ed9f601))
                        ])
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        4,
                        res.json()
                    ];
                case 2:
                    data = _state.sent();
                    if (!res.ok) throw new Error("".concat(data.message, " (").concat(res.status, ")"));
                    return [
                        2,
                        data
                    ];
                case 3:
                    err = _state.sent();
                    console.error(err);
                    throw err;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getJSON(url) {
        return _ref.apply(this, arguments);
    };
}();
var $fc18c856e77e0624$export$4a0bf7d3e8ab0007 = /*#__PURE__*/ function() {
    var _ref = (0, $5Pgs2._)(function(link, name) {
        var collection, text, url, err, err1, err2;
        var _arguments = arguments;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    collection = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    text = collection ? "Check out my collection ".concat(name, " on shelf share. ") : "Check out the book ".concat(name, " on shelf share. ");
                    url = link.trim();
                    if (!navigator.share) return [
                        3,
                        9
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        8
                    ]);
                    return [
                        4,
                        navigator.share({
                            title: "".concat(collection ? 'Collection' : 'Book', " Recommendation"),
                            text: text,
                            url: url
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        ""
                    ];
                case 3:
                    err = _state.sent();
                    console.error("Couldn't copy the URL via navigator.share, Error: ".concat(err));
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        6,
                        ,
                        7
                    ]);
                    return [
                        4,
                        navigator.clipboard.writeText(text + url)
                    ];
                case 5:
                    _state.sent();
                    return [
                        2,
                        "Url copied to clipboard"
                    ];
                case 6:
                    err1 = _state.sent();
                    console.error("Couldn't copy the URL via navigator.clipboard, Error: ".concat(err1));
                    throw new Error(err1);
                case 7:
                    return [
                        3,
                        8
                    ];
                case 8:
                    return [
                        3,
                        12
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        11,
                        ,
                        12
                    ]);
                    return [
                        4,
                        navigator.clipboard.writeText(text + url)
                    ];
                case 10:
                    _state.sent();
                    return [
                        2,
                        "Url copied to clipboard"
                    ];
                case 11:
                    err2 = _state.sent();
                    console.error("Couldn't copy the URL. Error: ".concat(err2));
                    throw new Error(err2);
                case 12:
                    return [
                        2
                    ];
            }
        });
    });
    return function helperShare(link, name) {
        return _ref.apply(this, arguments);
    };
}();
var $fc18c856e77e0624$export$61fc7d43ac8f84b0 = function(cb) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 300;
    var timeout;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            return cb.apply(void 0, (0, $dHvbf._)(args));
        }, delay);
    };
};
var $fc18c856e77e0624$export$de363e709c412c8a = function(cb) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200;
    var shouldWait = false;
    var waitingArgs;
    var timeoutFunc = function() {
        if (waitingArgs == null) shouldWait = false;
        else {
            cb.apply(void 0, (0, $dHvbf._)(waitingArgs));
            waitingArgs = null;
            setTimeout(timeoutFunc, delay);
        }
    };
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (shouldWait) {
            waitingArgs = args;
            return;
        }
        cb.apply(void 0, (0, $dHvbf._)(args));
        shouldWait = true;
        setTimeout(timeoutFunc, delay);
    };
};
var $fc18c856e77e0624$export$57a5f2d0e67d7713 = function getUrlData() {
    var keys = decodeURIComponent(window.location.search);
    var urlParams = new URLSearchParams(keys);
    var data = {};
    urlParams.forEach(function(val, key) {
        return data[key] = val;
    });
    return data;
};
var $fc18c856e77e0624$export$a853aba3035a900d = function setUrlData(path, data) {
    var set = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var urlObject = new URL(path, window.location.origin);
    Object.entries(data).forEach(function(param) {
        var _param = (0, $aSMts._)(param, 2), key = _param[0], val = _param[1];
        urlObject.searchParams.set(key, Array.isArray(val) ? encodeURIComponent(JSON.stringify(val)) : val);
    });
    var url = urlObject.pathname;
    var finalUrl = encodeURI("".concat(url, "?").concat(urlObject.searchParams));
    if (set) window.history.pushState('', '', finalUrl);
    return finalUrl;
};
var $fc18c856e77e0624$export$cfff717aa51d5799 = function mixPanelTrack(event) {
    var properties = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '';
    if (!(0, $0d51ec966e2c6e90$export$c016e91678be354b)) return;
    (0, $6c21bacc9274e141$export$2e2bcd8739ae039).track(event, properties);
};
var $fc18c856e77e0624$export$c338c72616630535 = function checkUtm() {
    var data = $fc18c856e77e0624$export$57a5f2d0e67d7713();
    var utm = {
        utm_source: data.utm_source,
        utm_content: data.utm_content
    };
    if (!utm.utm_source) utm.utm_source = null;
    if (!utm.utm_content) utm.utm_content = null;
    return utm;
};



var $c83d36ddae132bba$exports = {};

$c83d36ddae132bba$exports = (parcelRequire("c6lZy")).getBundleURL('1mAAk') + "cover-fallback.e125975b.webp";


var $9dcf34dc7ab40417$export$ca000e230c0caa3e = {
    book: {},
    search: {
        query: '',
        category: '',
        results: [],
        titles: []
    },
    bookmarks: [],
    collections: [],
    selectedBooks: []
};
var $9dcf34dc7ab40417$export$c394977f6d1b4b6c = /*#__PURE__*/ function() {
    var _ref = (0, $5Pgs2._)(function(id) {
        var _data_volumeInfo, _data_volumeInfo1, _data_volumeInfo2, _data_volumeInfo3, _data_volumeInfo4, _data_volumeInfo5, _data_volumeInfo6, _data_volumeInfo7, _data_volumeInfo8, _data_volumeInfo9, _data_volumeInfo_imageLinks, _data_volumeInfo10, _data_volumeInfo11, _data_accessInfo, data, err;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0, $fc18c856e77e0624$export$d047a7c56db64af4)("".concat((0, $0d51ec966e2c6e90$export$923ea8233b386e99), "/").concat(id, "?key=").concat((0, $0d51ec966e2c6e90$export$a9861bd62f48e142)))
                    ];
                case 1:
                    data = _state.sent();
                    $9dcf34dc7ab40417$export$ca000e230c0caa3e.book = {
                        id: data.id,
                        title: ((_data_volumeInfo = data.volumeInfo) === null || _data_volumeInfo === void 0 ? void 0 : _data_volumeInfo.title) || 'title not available',
                        authors: ((_data_volumeInfo1 = data.volumeInfo) === null || _data_volumeInfo1 === void 0 ? void 0 : _data_volumeInfo1.authors) || [
                            'author not available'
                        ],
                        publisher: ((_data_volumeInfo2 = data.volumeInfo) === null || _data_volumeInfo2 === void 0 ? void 0 : _data_volumeInfo2.publisher) || 'not available',
                        publishedDate: ((_data_volumeInfo3 = data.volumeInfo) === null || _data_volumeInfo3 === void 0 ? void 0 : _data_volumeInfo3.publishedDate) || 'not available',
                        description: ((_data_volumeInfo4 = data.volumeInfo) === null || _data_volumeInfo4 === void 0 ? void 0 : _data_volumeInfo4.description) || '',
                        isbn: ((_data_volumeInfo5 = data.volumeInfo) === null || _data_volumeInfo5 === void 0 ? void 0 : _data_volumeInfo5.industryIdentifiers) ? (_data_volumeInfo6 = data.volumeInfo) === null || _data_volumeInfo6 === void 0 ? void 0 : _data_volumeInfo6.industryIdentifiers[1].identifier : 'not available',
                        pageCount: ((_data_volumeInfo7 = data.volumeInfo) === null || _data_volumeInfo7 === void 0 ? void 0 : _data_volumeInfo7.pageCount) || 'not available',
                        categories: ((_data_volumeInfo8 = data.volumeInfo) === null || _data_volumeInfo8 === void 0 ? void 0 : _data_volumeInfo8.categories) || [
                            'others'
                        ],
                        rating: ((_data_volumeInfo9 = data.volumeInfo) === null || _data_volumeInfo9 === void 0 ? void 0 : _data_volumeInfo9.averageRating) || '',
                        image: ((_data_volumeInfo10 = data.volumeInfo) === null || _data_volumeInfo10 === void 0 ? void 0 : (_data_volumeInfo_imageLinks = _data_volumeInfo10.imageLinks) === null || _data_volumeInfo_imageLinks === void 0 ? void 0 : _data_volumeInfo_imageLinks.thumbnail) || (0, (/*@__PURE__*/$parcel$interopDefault($c83d36ddae132bba$exports))),
                        language: ((_data_volumeInfo11 = data.volumeInfo) === null || _data_volumeInfo11 === void 0 ? void 0 : _data_volumeInfo11.language) || 'not available',
                        previewLink: "https://www.google.co.in/books/edition/_/".concat(data.id, "?hl=en"),
                        embeddable: (_data_accessInfo = data.accessInfo) === null || _data_accessInfo === void 0 ? void 0 : _data_accessInfo.embeddable
                    };
                    if ($9dcf34dc7ab40417$export$ca000e230c0caa3e.bookmarks.some(function(bookmark) {
                        return bookmark.id === id;
                    })) $9dcf34dc7ab40417$export$ca000e230c0caa3e.book.bookmarked = true;
                    else $9dcf34dc7ab40417$export$ca000e230c0caa3e.book.bookmarked = false;
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    console.error(err);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function loadBook(id) {
        return _ref.apply(this, arguments);
    };
}();
var $9dcf34dc7ab40417$export$202b8e5cb363a0c4 = /*#__PURE__*/ function() {
    var _ref = (0, $5Pgs2._)(function(query, category) {
        var _data_items, url, data, err;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    $9dcf34dc7ab40417$export$ca000e230c0caa3e.search.query = query;
                    $9dcf34dc7ab40417$export$ca000e230c0caa3e.search.category = category;
                    url = "".concat((0, $0d51ec966e2c6e90$export$923ea8233b386e99), "?q=").concat(query && !category ? query : !query && category ? "''+subject:".concat(category) : query && category ? "".concat(query, "+subject:").concat(category) : "", "&maxResults=40&key=").concat((0, $0d51ec966e2c6e90$export$a9861bd62f48e142));
                    return [
                        4,
                        (0, $fc18c856e77e0624$export$d047a7c56db64af4)(url)
                    ];
                case 1:
                    data = _state.sent();
                    $9dcf34dc7ab40417$export$ca000e230c0caa3e.search.results = (_data_items = data.items) === null || _data_items === void 0 ? void 0 : _data_items.map(function(cur) {
                        var _cur_volumeInfo, _cur_volumeInfo_imageLinks, _cur_volumeInfo1, _cur_volumeInfo2, _cur_volumeInfo3;
                        return {
                            id: cur.id,
                            rating: ((_cur_volumeInfo = cur.volumeInfo) === null || _cur_volumeInfo === void 0 ? void 0 : _cur_volumeInfo.averageRating) || 0,
                            image: ((_cur_volumeInfo1 = cur.volumeInfo) === null || _cur_volumeInfo1 === void 0 ? void 0 : (_cur_volumeInfo_imageLinks = _cur_volumeInfo1.imageLinks) === null || _cur_volumeInfo_imageLinks === void 0 ? void 0 : _cur_volumeInfo_imageLinks.thumbnail) || (0, (/*@__PURE__*/$parcel$interopDefault($c83d36ddae132bba$exports))),
                            title: ((_cur_volumeInfo2 = cur.volumeInfo) === null || _cur_volumeInfo2 === void 0 ? void 0 : _cur_volumeInfo2.title) || 'title not available',
                            authors: ((_cur_volumeInfo3 = cur.volumeInfo) === null || _cur_volumeInfo3 === void 0 ? void 0 : _cur_volumeInfo3.authors) || [
                                'author not available'
                            ],
                            bookmarked: $9dcf34dc7ab40417$export$ca000e230c0caa3e.bookmarks.some(function(bookmark) {
                                return bookmark.id === cur.id;
                            }),
                            selected: $9dcf34dc7ab40417$export$ca000e230c0caa3e.selectedBooks.some(function(book) {
                                return book.id === cur.id;
                            })
                        };
                    });
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    console.error(err);
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function loadSearchResults(query, category) {
        return _ref.apply(this, arguments);
    };
}();
var $9dcf34dc7ab40417$export$f4814d7adfd1c109 = /*#__PURE__*/ function() {
    var _ref = (0, $5Pgs2._)(function(query) {
        var _data_items, url, data, err;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    url = "".concat((0, $0d51ec966e2c6e90$export$923ea8233b386e99), "?q=''+intitle:").concat(query, "&maxResults=40&key=").concat((0, $0d51ec966e2c6e90$export$a9861bd62f48e142));
                    return [
                        4,
                        (0, $fc18c856e77e0624$export$d047a7c56db64af4)(url)
                    ];
                case 1:
                    data = _state.sent();
                    $9dcf34dc7ab40417$export$ca000e230c0caa3e.search.titles = (_data_items = data.items) === null || _data_items === void 0 ? void 0 : _data_items.map(function(cur) {
                        var _cur_volumeInfo;
                        return (_cur_volumeInfo = cur.volumeInfo) === null || _cur_volumeInfo === void 0 ? void 0 : _cur_volumeInfo.title;
                    });
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    console.error(err);
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function loadSearchTitles(query) {
        return _ref.apply(this, arguments);
    };
}();
// Bookmarks
var $9dcf34dc7ab40417$var$persistBookmarks = function persistBookmarks() {
    localStorage.setItem('bookmarks', JSON.stringify($9dcf34dc7ab40417$export$ca000e230c0caa3e.bookmarks));
};
var $9dcf34dc7ab40417$export$72009cc673d27d80 = function(book) {
    $9dcf34dc7ab40417$export$ca000e230c0caa3e.bookmarks.push(book);
    if (book.id === $9dcf34dc7ab40417$export$ca000e230c0caa3e.book.id) $9dcf34dc7ab40417$export$ca000e230c0caa3e.book.bookmarked = true;
    $9dcf34dc7ab40417$var$persistBookmarks();
};
var $9dcf34dc7ab40417$export$136048bcb9946c75 = function(id) {
    var index = $9dcf34dc7ab40417$export$ca000e230c0caa3e.bookmarks.findIndex(function(book) {
        return book.id === id;
    });
    $9dcf34dc7ab40417$export$ca000e230c0caa3e.bookmarks.splice(index, 1);
    if (id === $9dcf34dc7ab40417$export$ca000e230c0caa3e.book.id) $9dcf34dc7ab40417$export$ca000e230c0caa3e.book.bookmarked = false;
    $9dcf34dc7ab40417$var$persistBookmarks();
};
var $9dcf34dc7ab40417$export$b5bf271fe430fb9f = function(book) {
    if (!$9dcf34dc7ab40417$export$ca000e230c0caa3e.selectedBooks.some(function(selectedBook) {
        return selectedBook.id === book.id;
    })) {
        $9dcf34dc7ab40417$export$ca000e230c0caa3e.selectedBooks.push(book);
        book.selected = true;
    }
};
var $9dcf34dc7ab40417$export$121c76e4246ff7ba = function(bookId) {
    $9dcf34dc7ab40417$export$ca000e230c0caa3e.selectedBooks = $9dcf34dc7ab40417$export$ca000e230c0caa3e.selectedBooks.filter(function(book) {
        return book.id !== bookId;
    });
    var book = $9dcf34dc7ab40417$export$ca000e230c0caa3e.search.results.find(function(book) {
        return book.id === bookId;
    });
    if (book) book.selected = false;
};
var $9dcf34dc7ab40417$export$2a0fdc24076a638a = function resetSelectedBooks() {
    $9dcf34dc7ab40417$export$ca000e230c0caa3e.selectedBooks = [];
    $9dcf34dc7ab40417$export$ca000e230c0caa3e.search.results.map(function(book) {
        return book.selected = false;
    });
};
var $9dcf34dc7ab40417$export$c74125a8e3af6bb2 = function(collectionName) {
    var newCollection = {
        collectionId: Date.now(),
        collectionName: collectionName,
        books: (0, $dHvbf._)($9dcf34dc7ab40417$export$ca000e230c0caa3e.selectedBooks)
    };
    $9dcf34dc7ab40417$export$ca000e230c0caa3e.collections.push(newCollection);
    $9dcf34dc7ab40417$export$ca000e230c0caa3e.selectedBooks.forEach(function(book) {
        book.selected = false;
    });
    $9dcf34dc7ab40417$export$ca000e230c0caa3e.selectedBooks = [];
    $9dcf34dc7ab40417$var$persistCollections();
};
var $9dcf34dc7ab40417$export$3d16e031f6551662 = function(collectionId) {
    var index = $9dcf34dc7ab40417$export$ca000e230c0caa3e.collections.findIndex(function(collection) {
        return collection.collectionId === Number(collectionId) || collection.id === Number(collectionId);
    });
    if (index === -1) return;
    $9dcf34dc7ab40417$export$ca000e230c0caa3e.collections.splice(index, 1);
    $9dcf34dc7ab40417$var$persistCollections();
};
var $9dcf34dc7ab40417$export$f61d2441fef94173 = function(bookId, collectionId) {
    $9dcf34dc7ab40417$export$ca000e230c0caa3e.collections.map(function(collection) {
        if (collection.collectionId === Number(collectionId)) {
            var bookIndex = collection.books.findIndex(function(book) {
                return book.id === bookId;
            });
            if (bookIndex === -1) return;
            collection.books.splice(bookIndex, 1);
            if (collection.books.length === 0) $9dcf34dc7ab40417$export$3d16e031f6551662(collectionId);
        }
    });
    $9dcf34dc7ab40417$var$persistCollections();
};
var $9dcf34dc7ab40417$var$persistCollections = function persistCollections() {
    localStorage.setItem('collections', JSON.stringify($9dcf34dc7ab40417$export$ca000e230c0caa3e.collections));
};
// Initialize
var $9dcf34dc7ab40417$var$init = function init() {
    var storageBookmarks = localStorage.getItem('bookmarks');
    var storageCollections = localStorage.getItem('collections');
    if (storageBookmarks) $9dcf34dc7ab40417$export$ca000e230c0caa3e.bookmarks = JSON.parse(storageBookmarks);
    if (storageCollections) $9dcf34dc7ab40417$export$ca000e230c0caa3e.collections = JSON.parse(storageCollections);
};
$9dcf34dc7ab40417$var$init(); // const clearBookmarks = function () {
 //   localStorage.clear('bookmarks');
 // };
 // const clearCollections = function () {
 //   localStorage.clear('collections');
 // };
 // clearBookmarks();
 // clearCollections();



var $huFCX = parcelRequire("huFCX");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");


var $1atwj = parcelRequire("1atwj");

var $dHvbf = parcelRequire("dHvbf");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");


var $ebf602e660545280$exports = {};

$ebf602e660545280$exports = (parcelRequire("c6lZy")).getBundleURL('1mAAk') + "sprite.74c91b86.svg";


var $6b415d5b56546b2c$exports = {};

$6b415d5b56546b2c$exports = (parcelRequire("c6lZy")).getBundleURL('1mAAk') + "error.49304dea.gif";


var $5965b2301664edc7$var$View = /*#__PURE__*/ function() {
    "use strict";
    function View() {
        var _this = this;
        (0, $50OuQ._)(this, View);
        (0, $1aca3bdf51b67d66$export$71511d61b312f219)(this, "_data", void 0);
        (0, $1aca3bdf51b67d66$export$71511d61b312f219)(this, "_currentFocus", -1);
        (0, $1aca3bdf51b67d66$export$71511d61b312f219)(this, "_handleSuggestionContainer", function(value) {
            var suggestionsContainer = _this._parentElement.querySelector(".suggestions");
            if (value) suggestionsContainer.classList.add("suggestions--active");
            else _this._closeSuggestions();
        });
        (0, $1aca3bdf51b67d66$export$71511d61b312f219)(this, "_handleCurrentSuggestion", function(e) {
            var suggestions = _this._parentElement.querySelectorAll(".suggestions__suggestion");
            var form = _this._parentElement.querySelector(".search-form");
            if (e.key === "ArrowDown") {
                e.preventDefault();
                _this._currentFocus = (_this._currentFocus + 1) % suggestions.length;
                _this._setActiveSuggestion(suggestions);
            } else if (e.key === "ArrowUp") {
                e.preventDefault();
                _this._currentFocus = (_this._currentFocus - 1 + suggestions.length) % suggestions.length;
                _this._setActiveSuggestion(suggestions);
            } else if (e.key === "Enter") {
                form.dispatchEvent(new Event('submit'));
                _this._closeSuggestions();
            }
        });
    }
    (0, $fGdZr._)(View, [
        {
            key: "_clear",
            value: function _clear() {
                this._parentElement.innerHTML = '';
            }
        },
        {
            key: "_clearAlert",
            value: function _clearAlert() {
                var modal = document.querySelector(".alert-modal");
                var loader = document.querySelector(".loader");
                var btn = document.querySelector(".alert-modal__content__btn");
                var otherModal = document.querySelector(".homepage__modal");
                var searchBar = document.querySelector(".search-bar");
                var closeModal = function() {
                    modal.remove();
                    if (loader) loader.remove();
                    if (otherModal) otherModal.classList.remove("homepage__modal--active");
                    if (searchBar) {
                        searchBar.value = '';
                        searchBar.removeAttribute('disabled');
                    }
                };
                modal.addEventListener('click', function(e) {
                    if (!e.target.closest('.alert-modal__content')) closeModal();
                });
                btn.addEventListener('click', closeModal);
            }
        },
        {
            key: "render",
            value: function render(data) {
                var render = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, markupClass = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : '';
                this._data = data;
                var markup = this._generateMarkup(markupClass);
                if (!render) return markup;
                this._clear();
                this._parentElement.insertAdjacentHTML('afterbegin', markup);
            }
        },
        {
            key: "renderMessage",
            value: function renderMessage() {
                var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._message;
                var markup = '\n      <div class="absolute-center message">\n        <p>'.concat(message, "</p>\n      </div>\n    ");
                this._clear();
                this._parentElement.insertAdjacentHTML('afterbegin', markup);
            }
        },
        {
            key: "renderAlert",
            value: function renderAlert() {
                var alert = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'Opps! Something went wrong. <p class="alert-modal__content__alert-message--sub paragraph">We are working on it, please check back later.</p>';
                var markup = '\n      <div class="alert-modal">\n        <div class="alert-modal__content">\n        <div class="alert-modal__content__gif-container">\n         <img class="alert-modal__content__gif-container__gif" src='.concat((0, (/*@__PURE__*/$parcel$interopDefault($6b415d5b56546b2c$exports))), ' alt="error"/>\n        </div>\n          <h4 class="heading-4 alert-modal__content__alert-message">').concat(alert, '</h4>\n          <p class=alert-modal__content__alert-message__contact paragraph>If required, please contact us on <a href="mailto: connectshelfshare@gmail.com" class="alert-modal__content__alert-message__contact--link">connectshelfshare@gmail.com</a></p>\n          <button class="alert-modal__content__btn btn-tertiary">Close</button>\n        </div>\n      </div>\n    ');
                var modal = document.querySelector('.alert-modal');
                var searchBar = document.querySelector(".search-bar");
                if (searchBar) searchBar.setAttribute('disabled', 'true');
                if (modal) modal.remove();
                this._parentElement.insertAdjacentHTML('afterbegin', markup);
                this._clearAlert();
            }
        },
        {
            key: "renderToast",
            value: function renderToast(message, error) {
                var alertBox = document.createElement('div');
                alertBox.className = error ? 'custom-alert-red' : 'custom-alert';
                alertBox.innerText = message;
                document.body.appendChild(alertBox);
                alertBox.classList.add('show-alert');
                setTimeout(function() {
                    return alertBox.classList.remove('show-alert');
                }, 2000);
                setTimeout(function() {
                    alertBox.remove();
                }, 3000);
            }
        },
        {
            key: "renderLoader",
            value: function renderLoader() {
                var markup = '\n      <div class="loader">\n        <svg class="loader__svg loader__svg--1">\n          <use xlink:href="'.concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), '#icon-loader-book-2"></use>\n        </svg>\n        <svg class="loader__svg loader__svg--2">\n          <use xlink:href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), '#icon-loader-book-4"></use>\n        </svg>        \n        <svg class="loader__svg loader__svg--3">\n          <use xlink:href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), '#icon-loader-book-3"></use>\n        </svg>       \n        <svg class="loader__svg loader__svg--4">\n          <use xlink:href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), '#icon-loader-book-1"></use>\n        </svg> \n      </div>\n    ');
                this._clear();
                this._parentElement.insertAdjacentHTML('afterbegin', markup);
            }
        },
        {
            key: "update",
            value: function update(data) {
                if (!data || Array.isArray(data) && data.length === 0) return 'error';
                try {
                    this._data = data;
                    var newMarkup = this._generateMarkup();
                    var newDOM = document.createRange().createContextualFragment(newMarkup);
                    var newElements = Array.from(newDOM.querySelectorAll('*'));
                    var curElements = Array.from(this._parentElement.querySelectorAll('*'));
                    newElements.forEach(function(newEl, i) {
                        var _newEl_firstChild;
                        var curEl = curElements[i];
                        if (!newEl.isEqualNode(curEl) && ((_newEl_firstChild = newEl.firstChild) === null || _newEl_firstChild === void 0 ? void 0 : _newEl_firstChild.nodeValue.trim()) !== '') curEl.textContent = newEl.textContent;
                        if (!newEl.isEqualNode(curEl)) Array.from(newEl.attributes).forEach(function(attr) {
                            return curEl.setAttribute(attr.name, attr.value);
                        });
                    });
                } catch (err) {
                    console.error(err);
                }
            }
        },
        {
            key: "addHandlerDebounce",
            value: function addHandlerDebounce(handler) {
                var _this = this;
                var searchBar = this._parentElement.querySelector('.search-bar');
                var suggestionsContainer = this._parentElement.querySelector('.suggestions');
                var form = this._parentElement.querySelector(".search-form");
                searchBar.addEventListener('input', function() {
                    var value = searchBar.value.trim();
                    if (!value || value.length < 3) {
                        _this._closeSuggestions();
                        return;
                    }
                    handler(value);
                    _this._handleSuggestionContainer(value);
                });
                searchBar.addEventListener('keydown', (0, $fc18c856e77e0624$export$de363e709c412c8a)(function(e) {
                    return _this._handleCurrentSuggestion(e);
                }));
                suggestionsContainer.addEventListener('click', function(e) {
                    var suggestion = e.target.closest(".suggestions__suggestion");
                    if (!suggestion) return;
                    searchBar.value = suggestion.textContent;
                    form.dispatchEvent(new Event('submit'));
                    _this._closeSuggestions();
                });
                this._parentElement.addEventListener('click', function(e) {
                    if (e.target.closest(".suggestions") || e.target.closest(".suggestion")) return;
                    _this._closeSuggestions();
                });
            }
        },
        {
            key: "_closeSuggestions",
            value: function _closeSuggestions() {
                var suggestionsContainer = this._parentElement.querySelector(".suggestions");
                if (!suggestionsContainer) return;
                suggestionsContainer.classList.remove("suggestions--active");
                this._data = '';
                this._currentFocus = -1;
                suggestionsContainer.innerHTML = '';
            }
        },
        {
            key: "_setActiveSuggestion",
            value: function _setActiveSuggestion(suggestions) {
                if (!suggestions || suggestions.length === 0) return;
                var searchBar = this._parentElement.querySelector(".search-bar");
                if (!suggestions) return;
                suggestions.forEach(function(suggestion) {
                    return suggestion.classList.remove('suggestions__suggestion--active');
                });
                var activeSuggestion = suggestions[this._currentFocus];
                activeSuggestion.classList.add("suggestions__suggestion--active");
                activeSuggestion.scrollIntoView({
                    behaviour: 'smooth',
                    block: 'nearest'
                });
                searchBar.value = suggestions[this._currentFocus].textContent;
            }
        },
        {
            key: "updateSuggestions",
            value: function updateSuggestions(data) {
                this._data = data;
                var suggestionsContainer = this._parentElement.querySelector('.suggestions');
                var searchBar = this._parentElement.querySelector('.search-bar');
                if (!suggestionsContainer) return;
                if (!searchBar.value.trim()) {
                    this._closeSuggestions();
                    return;
                }
                suggestionsContainer.innerHTML = '';
                this._currentFocus = -1;
                if (data && data.length > 0) {
                    var suggestionsMarkup = this._generateSuggestionsMarkup();
                    suggestionsContainer.insertAdjacentHTML('afterbegin', suggestionsMarkup);
                }
            }
        },
        {
            key: "_generateSuggestionsContainerMarkup",
            value: function _generateSuggestionsContainerMarkup() {
                return '\n    <ul class="suggestions">\n     '.concat(this._generateSuggestionsMarkup(), "\n    </ul>\n  ");
            }
        },
        {
            key: "_generateSuggestionsMarkup",
            value: function _generateSuggestionsMarkup() {
                return "".concat(this._data ? this._data.map(function(title, id) {
                    return "<li key=".concat(id, ' class="suggestions__suggestion">').concat(title, "</li>");
                }).join('') : "");
            }
        }
    ]);
    return View;
}();
var $5965b2301664edc7$export$2e2bcd8739ae039 = $5965b2301664edc7$var$View;



var $563536d85d91ca17$var$BookView = /*#__PURE__*/ function(View) {
    "use strict";
    (0, $1atwj._)(BookView, View);
    function BookView() {
        (0, $50OuQ._)(this, BookView);
        var _this;
        _this = (0, $huFCX._)(this, BookView, arguments), (0, $1aca3bdf51b67d66$export$71511d61b312f219)(_this, "_parentElement", document.querySelector(".container"));
        return _this;
    }
    (0, $fGdZr._)(BookView, [
        {
            key: "_generateDate",
            value: function _generateDate() {
                var date = new Date(this._data.publishedDate);
                var options = {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                };
                return date.toLocaleDateString('en-US', options);
            }
        },
        {
            key: "_generateLanguage",
            value: function _generateLanguage() {
                var language = new Intl.DisplayNames([
                    'en'
                ], {
                    type: 'language'
                });
                return language.of(this._data.language);
            }
        },
        {
            key: "_generateCategories",
            value: function _generateCategories() {
                var categories = this._data.categories;
                var uniqueCategories = (0, $dHvbf._)(new Set(categories.flatMap(function(category) {
                    return category.split('/').map(function(cur) {
                        return cur.trim();
                    });
                })));
                return uniqueCategories.slice(0, 8);
            }
        },
        {
            key: "addHandlerRender",
            value: function addHandlerRender(handler) {
                window.addEventListener('load', handler);
            }
        },
        {
            key: "addHandlerAddBookmark",
            value: function addHandlerAddBookmark(handler) {
                this._parentElement.addEventListener('click', function(e) {
                    e.stopImmediatePropagation();
                    var btn = e.target.closest('.btn--bookmark');
                    if (!btn) return;
                    handler();
                });
            }
        },
        {
            key: "addHandlerTabHandler",
            value: function addHandlerTabHandler() {
                var tabContainer = document.querySelector(".section-book-view__detail__tab-container");
                var tabs = document.querySelectorAll(".section-book-view__detail__tab-container__tab");
                var content = document.querySelectorAll(".section-book-view__detail__content");
                tabContainer.addEventListener('click', function(e) {
                    var tab = e.target.closest('.section-book-view__detail__tab-container__tab');
                    if (!tab) return;
                    tabs.forEach(function(tab) {
                        return tab.classList.remove('section-book-view__detail__tab-container__tab--active');
                    });
                    content.forEach(function(content) {
                        return content.classList.remove("section-book-view__detail__content--active", "section-book-view__detail__content--active-table");
                    });
                    tab.classList.add('section-book-view__detail__tab-container__tab--active');
                    if (tab.dataset.id == 2) document.querySelector(".section-book-view__detail__content--".concat(tab.dataset.id)).classList.add('section-book-view__detail__content--active-table');
                    else document.querySelector(".section-book-view__detail__content--".concat(tab.dataset.id)).classList.add('section-book-view__detail__content--active');
                });
            }
        },
        {
            key: "addHandlerShare",
            value: function addHandlerShare(handler) {
                var _this = this;
                var shareBtn = this._parentElement.querySelector(".btn--share");
                shareBtn.addEventListener('click', function() {
                    handler(_this._data.title ? _this._data.title : '');
                });
            }
        },
        {
            key: "addHandlerXShare",
            value: function addHandlerXShare(handler) {
                var _this = this;
                var btn = this._parentElement.querySelector(".link-x");
                if (!btn) return;
                btn.addEventListener('click', function(e) {
                    e.preventDefault();
                    var url = "".concat(window.location.href, "&utm_source=X");
                    handler(_this._data.title, url);
                });
            }
        },
        {
            key: "_generateMarkup",
            value: function _generateMarkup() {
                var _this__data_title, _this__data_title1, _this__data_authors, _this__data_authors1, _this__data_authors2, _this__generateCategories;
                var xShareText = "Check out the book ".concat(this._data.title, " on shelf share.");
                var xShareUrl = "".concat(window.location.href, "&utm_source=X");
                return '\n      <section class="section-book-view">\n      <div class="section-book-view__temp"></div>\n          <div class="section-book-view__main-info-container">\n            <figure class="section-book-view__main-info-container__img">\n              <img\n                src="'.concat(this._data.image, '" alt="').concat(this._data.title, '"\n              />\n            </figure>\n            <div class="section-book-view__main-info-container__text">\n              <div class="section-book-view__main-info-container__text--up">\n                <h2\n                  class="section-book-view__main-info-container__text--up__title heading-2"\n                >\n                  ').concat(((_this__data_title = this._data.title) === null || _this__data_title === void 0 ? void 0 : _this__data_title.length) <= 70 ? this._data.title : (_this__data_title1 = this._data.title) === null || _this__data_title1 === void 0 ? void 0 : _this__data_title1.substring(0, 70 + "..."), ' \n                </h2>\n                <h3\n                  class="section-book-view__main-info-container__text--up__author heading-3"\n                >\n                  ').concat(((_this__data_authors = this._data.authors) === null || _this__data_authors === void 0 ? void 0 : _this__data_authors.join(', ').length) <= 50 ? (_this__data_authors1 = this._data.authors) === null || _this__data_authors1 === void 0 ? void 0 : _this__data_authors1.join(', ') : ((_this__data_authors2 = this._data.authors) === null || _this__data_authors2 === void 0 ? void 0 : _this__data_authors2.join(', ').substring(0, 50)) + "...", ' \n                </h3>\n                <p\n                  class="section-book-view__main-info-container__text--up__rating paragraph--big"\n                >\n                  Rating: ').concat(this._data.rating ? "<span>".concat(this._data.rating, ' </span>\n                  <svg class="section-book-view__main-info-container__text--up__rating__svg">\n                    <use xlink:href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), '#icon-star"></use>\n                  </svg>\n                    ') : "Unavailable", ' \n                  \n                </p>\n              </div>\n              <div class="section-book-view__main-info-container__text--down">\n                <h4\n                  class="section-book-view__main-info-container__text--down__category-heding heading-4"\n                >\n                  Category\n                </h4>\n                ').concat((_this__generateCategories = this._generateCategories()) === null || _this__generateCategories === void 0 ? void 0 : _this__generateCategories.map(function(cur) {
                    return '                <p\n                  class="section-book-view__main-info-container__text--down__category-text paragraph"\n                >\n                  '.concat(cur, " \n                </p>");
                }).join(''), '\n              </div>\n            <div class="section-book-view__main-info-container__text--button-container">\n            <a\n                href="').concat(this._data.previewLink, '"\n                target="_blank"\n                class="section-book-view__main-info-container__text--button btn-secondary"\n              >\n                Open in Google Books\n              </a>\n              <button class="section-book-view__main-info-container__text--button-icon btn--bookmark">\n               <svg class="').concat(this._data.bookmarked ? 'svg-fill' : 'svg-empty', '">\n                  <use xlink:href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), '#icon-bookmark"></use>\n              </svg>\n              </button>\n              <button class="section-book-view__main-info-container__text--button-icon btn--share">\n               <svg class="svg-fill">\n                  <use xlink:href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), '#icon-share"></use>\n              </svg>\n              </button>\n              <a href="https://twitter.com/intent/tweet?text=').concat(xShareText, "&url=").concat(xShareUrl, '" target="_blank" class="link-x section-book-view__main-info-container__text--button-icon__link">\n                <button class="section-book-view__main-info-container__text--button-icon btn--x-share">\n                  <svg class="svg-fill">\n                    <use xlink:href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), '#icon-x"></use>\n                  </svg>\n              </button>\n              </a>\n            </div>\n            </div>\n          </div>\n        \n        <div class="section-book-view__detail">\n        \n          <div class="section-book-view__detail__tab-container">\n            <button class="section-book-view__detail__tab-container__tab section-book-view__detail__tab-container__tab--1 section-book-view__detail__tab-container__tab--active" data-id="1">\n                  Description\n            </button>\n            <button class="section-book-view__detail__tab-container__tab section-book-view__detail__tab-container__tab--2" data-id=2>\n                  Overview\n            </button>\n          </div>\n          <div class="section-book-view__detail__content section-book-view__detail__content--1 section-book-view__detail__content--active">\n          ').concat(this._data.description ? '\n            <p class="section-book-view__detail__content--1__text paragraph">\n               '.concat(this._data.description, "\n            </p>\n            ") : '\n            <p class="section-book-view__detail__content--1__text--unavailable paragraph--big">\n               Description Unavailable\n            </p>\n              ', '\n\n          </div>\n\n          <div class="section-book-view__detail__content section-book-view__detail__content--2">\n            <table class="section-book-view__detail__content--2__table">\n              <tbody>\n                <tr>\n                  <th>Publisher</th>\n                  <td>').concat(this._data.publisher, " </td>\n                </tr>\n                <tr>\n                  <th>Published</th>\n                  <td>").concat(this._generateDate(), " </td>\n                </tr>\n                <tr>\n                  <th>Pages</th>\n                  <td>").concat(this._data.pageCount, "</td>\n                </tr>\n                <tr>\n                  <th>Language</th>\n                  <td>").concat(this._generateLanguage(), "</td>\n                </tr>\n                <tr>\n                  <th>ISBN</th>\n                  <td>").concat(this._data.isbn, " </td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n        </div>\n      </section>\n        ");
            }
        }
    ]);
    return BookView;
}((0, $5965b2301664edc7$export$2e2bcd8739ae039));
var $563536d85d91ca17$export$2e2bcd8739ae039 = new $563536d85d91ca17$var$BookView();



var $huFCX = parcelRequire("huFCX");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");


var $1atwj = parcelRequire("1atwj");



var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $c4ab8714ef37556f$var$Router = /*#__PURE__*/ function() {
    "use strict";
    function Router() {
        (0, $50OuQ._)(this, Router);
        (0, $1aca3bdf51b67d66$export$71511d61b312f219)(this, "_activeNavigationLinkHandler", function(path) {
            var navBtns = document.querySelectorAll(".header__max-width-container__btn-container__btn-link");
            navBtns.forEach(function(btn) {
                return btn.classList.remove('header__max-width-container__btn-container__btn-link--active');
            });
            var activePath = path === '/' ? 'home' : path === '/collections' ? 'bookmarks' : path.split('/')[1].toLowerCase();
            navBtns.forEach(function(btn) {
                var curBtn = btn.dataset.route === '/' ? 'home' : btn.dataset.route.split('/')[1].toLowerCase();
                if (curBtn === activePath) btn.classList.add("header__max-width-container__btn-container__btn-link--active");
            });
        });
        this._routes = [];
    }
    (0, $fGdZr._)(Router, [
        {
            key: "routes",
            get: function get() {
                return this._routes;
            },
            set: function set(routes) {
                this._routes = routes;
                this._loadInitialRoute();
            }
        },
        {
            key: "_matchedURL",
            value: function _matchedURL(path) {
                return this.routes.find(function(route) {
                    return route.path === path;
                });
            }
        },
        {
            key: "_loadInitialRoute",
            value: function _loadInitialRoute() {
                var path = window.location.pathname;
                this._loadRoute(path);
            }
        },
        {
            key: "_loadRoute",
            value: function _loadRoute(path) {
                try {
                    var matchedRoute = this._matchedURL(path);
                    if (!matchedRoute) throw new Error('Route Not Found');
                    matchedRoute.callback();
                } catch (err) {
                    console.error(err);
                    this.navigateTo('/page-not-found');
                }
            }
        },
        {
            key: "navigateTo",
            value: function navigateTo(path) {
                window.history.pushState('', '', path);
                var splitPath = path.split('?');
                if (splitPath.length > 1) path = splitPath[0];
                this._loadRoute(path);
                window.scrollTo({
                    top: 0,
                    left: 0
                });
                this._activeNavigationLinkHandler(path);
            }
        },
        {
            key: "addHandlerRouter",
            value: function addHandlerRouter() {
                var _this = this;
                window.addEventListener('popstate', function() {
                    _this._loadInitialRoute();
                });
                var events = [
                    'popstate',
                    'load'
                ];
                events.forEach(function(event) {
                    return window.addEventListener(event, function() {
                        return _this._activeNavigationLinkHandler(window.location.pathname);
                    });
                });
            }
        }
    ]);
    return Router;
}();
var $c4ab8714ef37556f$export$2e2bcd8739ae039 = new $c4ab8714ef37556f$var$Router();


var $eb740981c00d9017$exports = {};

$eb740981c00d9017$exports = (parcelRequire("c6lZy")).getBundleURL('1mAAk') + "poweredbygoogle.8a5e9e15.png";


var $f1583b4246933fbc$var$SearchView = /*#__PURE__*/ function(View) {
    "use strict";
    (0, $1atwj._)(SearchView, View);
    function SearchView() {
        (0, $50OuQ._)(this, SearchView);
        var _this;
        _this = (0, $huFCX._)(this, SearchView, arguments), (0, $1aca3bdf51b67d66$export$71511d61b312f219)(_this, "_parentElement", document.querySelector('.container')), (0, $1aca3bdf51b67d66$export$71511d61b312f219)(_this, "_categorySearch", function(handler) {
            var btnContainer = document.querySelector(".section-search__user-options__max-width-container__categories");
            var btns = document.querySelectorAll(".section-search__user-options__max-width-container__categories__btn");
            btnContainer.addEventListener('click', function(e) {
                var btn = e.target.closest(".section-search__user-options__max-width-container__categories__btn");
                if (!btn) return;
                if (btn.classList.contains("section-search__user-options__max-width-container__categories__btn--active")) {
                    btn.classList.remove("section-search__user-options__max-width-container__categories__btn--active");
                    handler(_this._getQuery(), '');
                    return;
                }
                btns.forEach(function(btn) {
                    return btn.classList.remove("section-search__user-options__max-width-container__categories__btn--active");
                });
                btn.classList.add("section-search__user-options__max-width-container__categories__btn--active");
                var category = btn.textContent;
                handler(_this._getQuery(), category);
            });
        });
        return _this;
    }
    (0, $fGdZr._)(SearchView, [
        {
            key: "_getQuery",
            value: function _getQuery() {
                if (this._parentElement.querySelector('.search-bar')) return this._parentElement.querySelector('.search-bar').value;
            }
        },
        {
            key: "_getCategory",
            value: function _getCategory() {
                var category = '';
                var btns = document.querySelectorAll(".section-search__user-options__max-width-container__categories__btn");
                btns.forEach(function(btn) {
                    if (btn.classList.contains("section-search__user-options__max-width-container__categories__btn--active")) category = btn.textContent;
                });
                return category;
            }
        },
        {
            key: "addHandlerSearch",
            value: function addHandlerSearch(handler) {
                var _this = this;
                this._categorySearch(handler);
                var form = this._parentElement.querySelector(".search-form");
                var submitBtn = this._parentElement.querySelector(".submit-btn");
                var searchBar = this._parentElement.querySelector(".search-bar");
                var addFoucs = function() {
                    form.classList.add('focused');
                    searchBar.focus();
                };
                var removeFoucs = function() {
                    form.classList.remove('focused');
                    searchBar.blur();
                };
                searchBar.addEventListener('focus', addFoucs);
                searchBar.addEventListener('blur', removeFoucs);
                submitBtn.addEventListener('click', function() {
                    var query = _this._getQuery();
                    if (!query) addFoucs();
                });
                form.addEventListener('submit', function(e) {
                    e.preventDefault();
                    var category = _this._getCategory();
                    var query = _this._getQuery();
                    if (query) removeFoucs();
                    handler(query, category);
                    _this._closeSuggestions();
                });
            }
        },
        {
            key: "addHandlerBookRoutes",
            value: function addHandlerBookRoutes(handler) {
                var resultsContainer = this._parentElement.querySelector(".results-container");
                resultsContainer.addEventListener('click', function(e) {
                    var card = e.target.closest('.book-link');
                    if (!card) return;
                    e.preventDefault();
                    handler(card.dataset.route, card.dataset.id);
                });
            }
        },
        {
            key: "addHandlerCreateCollection",
            value: function addHandlerCreateCollection(handler) {
                var _this = this;
                var doneBtn = this._parentElement.querySelector('.section-search__results__collection-controller__btn-container__btn-done');
                if (!doneBtn) return;
                doneBtn.addEventListener('click', function() {
                    return _this._handlemodal(handler);
                });
            }
        },
        {
            key: "addHandlerResetSelections",
            value: function addHandlerResetSelections(handler) {
                var resetBtn = document.querySelector(".section-search__results__collection-controller__btn-container__btn-reset");
                resetBtn.addEventListener("click", handler);
            }
        },
        {
            key: "_handlemodal",
            value: function _handlemodal(handler) {
                var _this = this;
                var modal = this._parentElement.querySelector('.section-search__modal');
                var form = this._parentElement.querySelector('.modal-form');
                var msg = this._parentElement.querySelector('.modal-msg');
                var errMsg = this._parentElement.querySelector('.modal-err-msg');
                var input = this._parentElement.querySelector('#modal-input');
                var inputContainer = this._parentElement.querySelector(".section-search__modal__content__form__input-container");
                var closeBtn = this._parentElement.querySelector('.section-search__modal__content__close-btn');
                var submitBn = this._parentElement.querySelector(".section-search__modal__content__form__btn");
                var userChoice = this._parentElement.querySelector(".section-search__modal__content__choice-container");
                var createBtn = this._parentElement.querySelector(".btn-create");
                var viewBtn = this._parentElement.querySelector(".btn-view");
                var handleSubmit = function() {
                    submitBn.classList.add("section-search__modal__content__form__btn--hidden");
                    userChoice.classList.add("section-search__modal__content__choice-container--active");
                    input.setAttribute('disabled', 'true');
                    createBtn.addEventListener('click', closeModal);
                    viewBtn.addEventListener('click', function() {
                        closeModal();
                        (0, $c4ab8714ef37556f$export$2e2bcd8739ae039).navigateTo('/collections');
                    });
                };
                var addFoucs = function() {
                    inputContainer.classList.add('focused');
                    input.focus();
                };
                var removeFoucs = function() {
                    inputContainer.classList.remove('focused');
                    input.blur();
                };
                var openModal = function() {
                    modal.classList.add('section-search__modal--active');
                    submitBn.classList.remove("section-search__modal__content__form__btn--hidden");
                    input.removeAttribute("disabled");
                    setTimeout(addFoucs, 50);
                    document.addEventListener('keydown', handleEscape);
                };
                var handleEscape = function(e) {
                    if (e.key === 'Escape') closeModal();
                };
                var closeModal = function() {
                    modal.classList.remove('section-search__modal--active');
                    userChoice.classList.remove("section-search__modal__content__choice-container--active");
                    document.removeEventListener('keydown', handleEscape);
                    errMsg.textContent = '';
                    msg.textContent = '';
                    input.value = '';
                    removeFoucs();
                };
                openModal();
                input.addEventListener('focus', addFoucs);
                input.addEventListener('blur', removeFoucs);
                closeBtn.addEventListener('click', closeModal);
                input.addEventListener('input', function(e) {
                    var inputCounter = _this._parentElement.querySelector(".section-search__modal__content__form__input-container__input-count");
                    if (e.target.value.length > 50) {
                        errMsg.textContent = 'Name cannot be longer than 50 characters :(';
                        input.value = input.value.slice(0, 50);
                    } else {
                        errMsg.textContent = '';
                        inputCounter.textContent = "".concat(input.value.length, "/50");
                    }
                });
                form.addEventListener('submit', function(e) {
                    e.preventDefault();
                    var name = input.value;
                    var selectedCount = document.querySelector(".section-search__results__collection-controller__text-container__count-display--count").textContent;
                    if (!name.trim()) {
                        errMsg.textContent = 'Name cannot be empty :(';
                        input.value = '';
                        input.focus();
                        return;
                    }
                    errMsg.textContent = '';
                    msg.textContent = 'Collection Created Successfully.';
                    handler(name, selectedCount);
                    handleSubmit();
                });
            }
        },
        {
            key: "updateSelectedBooks",
            value: function updateSelectedBooks(selectedBooks) {
                var selectedCount = document.querySelector(".section-search__results__collection-controller__text-container__count-display--count");
                var doneBtn = this._parentElement.querySelector('.section-search__results__collection-controller__btn-container__btn-done');
                var resetBtn = this._parentElement.querySelector(".section-search__results__collection-controller__btn-container__btn-reset");
                if (doneBtn && resetBtn) {
                    if (selectedBooks.length === 0) {
                        doneBtn.setAttribute('disabled', 'true');
                        resetBtn.setAttribute('disabled', 'true');
                        doneBtn.classList.add('section-search__results__collection-controller__btn-container__btn-done--disabled');
                        resetBtn.classList.add('section-search__results__collection-controller__btn-container__btn-reset--disabled');
                    } else {
                        doneBtn.classList.remove('section-search__results__collection-controller__btn-container__btn-done--disabled');
                        resetBtn.classList.remove('section-search__results__collection-controller__btn-container__btn-reset--disabled');
                        doneBtn.removeAttribute('disabled');
                        resetBtn.removeAttribute('disabled');
                    }
                }
                selectedCount.textContent = selectedBooks.length;
            }
        },
        {
            key: "_generateMarkup",
            value: function _generateMarkup(markupClass) {
                var categories = [
                    'Humorous',
                    'Romance',
                    'Action',
                    'Drama',
                    'Thriller',
                    'Fiction',
                    'Mystery',
                    'Horror'
                ];
                return '\n      <section class="section-search">\n        <div class="section-search__user-options">\n        <div class="section-search__user-options__max-width-container">\n          <div class="section-search__user-options__max-width-container__search">\n            <form\n              class="section-search__user-options__max-width-container__search__search-bar-container search-form"\n            >\n              <button class="submit-btn" type="submit">\n               <svg>\n                <use xlink:href="'.concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), '#icon-magnifying-glass"></use>\n               </svg>\n              </button>\n              <input\n                type="text"\n                class="search-bar"\n                placeholder="Search Books"\n                autocomplete="off"\n              />\n            </form>\n           <a href="https://www.google.com" target="_blank" class="section-search__user-options__max-width-container__search__search-bar-container__powered-by">\n              <img class="section-search__user-options__max-width-container__search__search-bar-container__powered-by--img" src=').concat((0, (/*@__PURE__*/$parcel$interopDefault($eb740981c00d9017$exports))), ' />\n          </a>\n\n            <div class="section-search__user-options__max-width-container__search__suggestions">\n              ').concat(this._generateSuggestionsContainerMarkup(), ' \n            </div>\n          </div>\n          <div class="section-search__user-options__max-width-container__categories">\n           ').concat(categories.map(function(category, id) {
                    return "<button key=".concat(id, ' class="section-search__user-options__max-width-container__categories__btn">').concat(category, "</button>");
                }).join(''), '\n          </div>\n        </div>\n        </div>\n      \n        <div class="section-search__results">\n        <div class="').concat(markupClass ? "section-search__results__collection-controller" : "section-search__results__collection-controller--hidden", '">\n        <div class="section-search__results__collection-controller__text-container">\n          <p class="paragraph section-search__results__collection-controller__text-container__count-display">Selected Books: <span class="section-search__results__collection-controller__text-container__count-display--count">0</span></p>\n        </div>\n          <div class="section-search__results__collection-controller__btn-container">\n            <button class="btn-tertiary section-search__results__collection-controller__btn-container__btn-done">Done</button>\n            <button class="btn-tertiary section-search__results__collection-controller__btn-container__btn-reset">Reset</button>\n          </div>\n        </div>\n          <ul class="section-search__results__results-container results-container">\n            ').concat(" ".concat(markupClass ? '<p class="paragraph--big center-element">Search books and select them to create a collection ;)</p>' : '<p class="paragraph--big center-element">Explore books by searching above ;)</p>', "\n              "), '\n          </ul>\n        </div>\n\n        \n        <div class="section-search__modal">\n            <div class="section-search__modal__content">\n\n            <button class="section-search__modal__content__close-btn">\n              <svg class="section-search__modal__content__close-btn__svg">\n                <use xlink:href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), '#icon-cross"></use>\n              </svg>\n            </button>\n\n            <h3 class="heading-3 section-search__modal__content__heading">Create Collection</h3>\n                         \n              <form class="section-search__modal__content__form modal-form">\n              <div class="section-search__modal__content__form__input-container">\n                <input\n                  type="text"\n                  id="modal-input"\n                  class="section-search__modal__content__form__input-container__input"\n                  placeholder="collection name"\n                  autocomplete="off"\n                />\n                <span class="section-search__modal__content__form__input-container__input-count">0/50</span>\n              </div>\n\n                <button class="btn-tertiary section-search__modal__content__form__btn" type="submit">Create</button>\n              </form>\n            <p class="section-search__modal__content__msg modal-msg"></p>\n            <p class="section-search__modal__content__err-msg modal-err-msg"></p>\n            <div class="section-search__modal__content__choice-container">\n              <button class="section-search__modal__content__choice-container__btn section-search__modal__content__choice-container__btn--create-more btn-create btn-tertiary">Create More</button>\n              <button class="section-search__modal__content__choice-container__btn btn-view btn-tertiary">View Collections</button>\n            </div>\n            </div>\n        </div>\n      </section>\n  ');
            }
        }
    ]);
    return SearchView;
}((0, $5965b2301664edc7$export$2e2bcd8739ae039));
var $f1583b4246933fbc$export$2e2bcd8739ae039 = new $f1583b4246933fbc$var$SearchView();



var $huFCX = parcelRequire("huFCX");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $1atwj = parcelRequire("1atwj");


var $huFCX = parcelRequire("huFCX");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");


var $1atwj = parcelRequire("1atwj");


var $e072da173f625080$var$PreviewView = /*#__PURE__*/ function(View) {
    "use strict";
    (0, $1atwj._)(PreviewView, View);
    function PreviewView() {
        (0, $50OuQ._)(this, PreviewView);
        var _this;
        _this = (0, $huFCX._)(this, PreviewView, arguments), (0, $1aca3bdf51b67d66$export$71511d61b312f219)(_this, "_parentElement", '');
        return _this;
    }
    (0, $fGdZr._)(PreviewView, [
        {
            key: "_generateMarkup",
            value: function _generateMarkup(markupClass) {
                var _this__data_title, _this__data_title1, _this__data_authors, _this__data_authors1, _this__data_authors_join, _this__data_authors2;
                return '<li class="card card--1">\n              <a href="" data-route="/book" data-id="'.concat(this._data.id, '" class="card--1__link book-link">\n                <div class="card--1__link__img-container">\n                  <img\n                   src="').concat(this._data.image, '"\n                    alt="').concat(this._data.title, '"\n                    class="card--1__link__img-container__img"\n                  />\n                  <div class="card--1__link__img-container__shadow">\n                    <span>View Details</span>\n                  </div>\n                </div>\n            \n             \n              <div class="card--1__link__text-container">\n                <p\n                  class="paragraph--big card--1__link__text-container__title"\n                >\n                  ').concat(((_this__data_title = this._data.title) === null || _this__data_title === void 0 ? void 0 : _this__data_title.length) <= 12 ? this._data.title : ((_this__data_title1 = this._data.title) === null || _this__data_title1 === void 0 ? void 0 : _this__data_title1.substring(0, 12)) + '...', '\n                </p>\n                <p\n                  class="paragraph card--1__link__text-container__author"\n                >\n                  ').concat(((_this__data_authors = this._data.authors) === null || _this__data_authors === void 0 ? void 0 : _this__data_authors.join(', ').length) <= 20 ? (_this__data_authors1 = this._data.authors) === null || _this__data_authors1 === void 0 ? void 0 : _this__data_authors1.join(', ') : ((_this__data_authors2 = this._data.authors) === null || _this__data_authors2 === void 0 ? void 0 : (_this__data_authors_join = _this__data_authors2.join(', ')) === null || _this__data_authors_join === void 0 ? void 0 : _this__data_authors_join.substring(0, 20)) + '...', '\n                </p>\n                <p\n                  class="paragraph card--1__link__text-container__rating"\n                >\n                    ').concat(this._data.rating ? '<span class="card--1__link__text-container__rating__text">'.concat(this._data.rating, ' </span>\n                          <svg class="card--1__link__text-container__rating__svg">\n                            <use xlink:href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), '#icon-star"></use>\n                          </svg>\n                        ') : "", ' \n                </p>\n              </div>\n            </a>\n\n              <button class="card--1__btn ').concat(markupClass, '" data-book-id="').concat(this._data.id, '">\n                ').concat(markupClass === 'add-collection-btn' ? '<svg class="'.concat(this._data.selected ? 'svg-fill' : 'svg-gray', '">\n                    <use xlink:href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), "#icon-circle-with-").concat(this._data.selected ? 'minus' : 'plus', '"></use>\n                  </svg>\n                    ') : markupClass === 'remove-collection-btn' ? '<svg class="svg-fill">\n                    <use xlink:href="'.concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), '#icon-circle-with-minus"></use>\n                  </svg>') : markupClass === 'shared-view' ? '' : markupClass === 'no-button' ? "" : '<svg class="'.concat(this._data.bookmarked ? 'svg-fill' : 'svg-empty', '">\n                    <use xlink:href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), '#icon-bookmark"></use>\n                  </svg>'), "\n              </button>\n            </li>\n    ");
            }
        }
    ]);
    return PreviewView;
}((0, $5965b2301664edc7$export$2e2bcd8739ae039));
var $e072da173f625080$export$2e2bcd8739ae039 = new $e072da173f625080$var$PreviewView();


var $7d7339a8dc0dc616$var$FindBooksView = /*#__PURE__*/ function(View) {
    "use strict";
    (0, $1atwj._)(FindBooksView, View);
    function FindBooksView() {
        (0, $50OuQ._)(this, FindBooksView);
        return (0, $huFCX._)(this, FindBooksView, arguments);
    }
    (0, $fGdZr._)(FindBooksView, [
        {
            key: "_parentElement",
            get: function get() {
                return document.querySelector(".results-container");
            }
        },
        {
            key: "addHandlerBookmark",
            value: function addHandlerBookmark(handler) {
                this._parentElement.addEventListener('click', function(e) {
                    var btn = e.target.closest('.add-bookmark-btn');
                    if (!btn) return;
                    var bookId = btn.dataset.bookId;
                    if (!bookId) {
                        console.error('Book ID is missing from the bookmark button and card');
                        return;
                    }
                    handler(bookId);
                });
            }
        },
        {
            key: "_generateMarkup",
            value: function _generateMarkup() {
                var _this__data;
                var cards = (_this__data = this._data) === null || _this__data === void 0 ? void 0 : _this__data.map(function(result) {
                    return (0, $e072da173f625080$export$2e2bcd8739ae039).render(result, false, 'add-bookmark-btn');
                }).join('');
                if (!this._data) return "Sorry, No Results Match Your Search Query :(";
                return '\n        <div class="section-search__results__results-container__card-container">\n        <p class="section-search__results__results-container__card-container__text">Google Books search results: <span class="section-search__results__results-container__card-container__text--count"> '.concat(this._data.length, ' </span> books</p>\n        <div class="section-search__results__results-container__card-container__cards">\n          ').concat(cards, "\n        </div>\n        </div>\n        ");
            }
        }
    ]);
    return FindBooksView;
}((0, $5965b2301664edc7$export$2e2bcd8739ae039));
var $7d7339a8dc0dc616$export$2e2bcd8739ae039 = new $7d7339a8dc0dc616$var$FindBooksView();



var $huFCX = parcelRequire("huFCX");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $1atwj = parcelRequire("1atwj");


var $6316bd0acf1406ab$var$CreateCollectionsView = /*#__PURE__*/ function(View) {
    "use strict";
    (0, $1atwj._)(CreateCollectionsView, View);
    function CreateCollectionsView() {
        (0, $50OuQ._)(this, CreateCollectionsView);
        return (0, $huFCX._)(this, CreateCollectionsView, arguments);
    }
    (0, $fGdZr._)(CreateCollectionsView, [
        {
            key: "_parentElement",
            get: function get() {
                return document.querySelector(".results-container");
            }
        },
        {
            key: "addHandlerAddBook",
            value: function addHandlerAddBook(handler) {
                this._parentElement.addEventListener('click', function(e) {
                    var btn = e.target.closest('.add-collection-btn');
                    if (!btn) return;
                    var bookId = btn.dataset.bookId;
                    handler(bookId);
                });
            }
        },
        {
            key: "_generateMarkupCards",
            value: function _generateMarkupCards() {
                if (!this._data) return "Sorry, No Results Match Your Search Query :(";
                return this._data.map(function(result) {
                    return (0, $e072da173f625080$export$2e2bcd8739ae039).render(result, false, 'add-collection-btn');
                }).join('');
            }
        },
        {
            key: "_generateMarkup",
            value: function _generateMarkup() {
                var cards = this._generateMarkupCards();
                return '\n    <div class="section-search__results__results-container__card-container">\n      <p class="section-search__results__results-container__card-container__text">Google Books search results: <span class="section-search__results__results-container__card-container__text--count"> '.concat(this._data.length, ' </span> books</p>\n      <div class="collection-cards-container">\n          ').concat(cards, "\n      </div>\n    </div\n    ");
            }
        }
    ]);
    return CreateCollectionsView;
}((0, $5965b2301664edc7$export$2e2bcd8739ae039));
var $6316bd0acf1406ab$export$2e2bcd8739ae039 = new $6316bd0acf1406ab$var$CreateCollectionsView();



var $huFCX = parcelRequire("huFCX");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");


var $1atwj = parcelRequire("1atwj");



var $fc7bd4694965bc86$var$individualCollectionView = /*#__PURE__*/ function(View) {
    "use strict";
    (0, $1atwj._)(individualCollectionView, View);
    function individualCollectionView() {
        (0, $50OuQ._)(this, individualCollectionView);
        var _this;
        _this = (0, $huFCX._)(this, individualCollectionView, arguments), (0, $1aca3bdf51b67d66$export$71511d61b312f219)(_this, "_parentElement", document.querySelector(".container")), (0, $1aca3bdf51b67d66$export$71511d61b312f219)(_this, "_errorMessage", 'Collection is empty :('), (0, $1aca3bdf51b67d66$export$71511d61b312f219)(_this, "_message", '');
        return _this;
    }
    (0, $fGdZr._)(individualCollectionView, [
        {
            key: "id",
            get: function get() {
                return this._id;
            },
            set: function set(id) {
                this._id = id;
            }
        },
        {
            key: "addHandlerBookRoutes",
            value: function addHandlerBookRoutes(handler) {
                var resultsContainer = this._parentElement.querySelector(".section-collection__content");
                if (!resultsContainer) return;
                resultsContainer.addEventListener('click', function(e) {
                    var card = e.target.closest('.book-link');
                    if (!card) return;
                    e.preventDefault();
                    handler(card.dataset.route, card.dataset.id);
                });
            }
        },
        {
            key: "addHandlerRemoveBook",
            value: function addHandlerRemoveBook(handler) {
                var _this = this;
                this._parentElement.addEventListener('click', function(e) {
                    var btn = e.target.closest('.remove-collection-btn');
                    if (!btn) return;
                    var bookId = btn.dataset.bookId;
                    handler(bookId, _this.id);
                });
            }
        },
        {
            key: "addHandlerShare",
            value: function addHandlerShare(handler) {
                var _this = this;
                var btn = document.querySelector('.section-collection__content__share-btn');
                if (!btn) return;
                btn.addEventListener('click', function() {
                    handler(_this._data, true);
                });
            }
        },
        {
            key: "_generateMarkupCollectionCards",
            value: function _generateMarkupCollectionCards(markupClass) {
                var _this__data_books;
                return (_this__data_books = this._data.books) === null || _this__data_books === void 0 ? void 0 : _this__data_books.map(function(bookmark) {
                    return (0, $e072da173f625080$export$2e2bcd8739ae039).render(bookmark, false, markupClass);
                }).join('');
            }
        },
        {
            key: "_generateMarkup",
            value: function _generateMarkup(markupClass) {
                var collectionCards = this._generateMarkupCollectionCards(markupClass);
                this.id = this._data.collectionId;
                return this._data.books ? '\n      <section class="section-collection">\n        <h2 class="heading-3 section-collection__heading">'.concat(this._data.collectionName, '</h2>\n        <div\n          class="section-collection__content"\n        >\n        ').concat(markupClass === 'shared-view' ? '' : '\n        <button class="btn-tertiary section-collection__content__share-btn" data-collection-id="'.concat(this._data.collectionId, '">\n        <svg class="section-collection__content__share-btn__svg">\n          <use xlink:href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), '#icon-share"></use>\n        </svg>\n        </button>\n          '), "\n          ").concat(collectionCards, "\n        </div>\n    \n      </section>\n    ") : '<div class="center-element">This collection is empty :(</div>';
            }
        }
    ]);
    return individualCollectionView;
}((0, $5965b2301664edc7$export$2e2bcd8739ae039));
var $fc7bd4694965bc86$export$2e2bcd8739ae039 = new $fc7bd4694965bc86$var$individualCollectionView();



var $huFCX = parcelRequire("huFCX");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");


var $1atwj = parcelRequire("1atwj");



var $a9853349f6311190$var$BookmarksView = /*#__PURE__*/ function(View) {
    "use strict";
    (0, $1atwj._)(BookmarksView, View);
    function BookmarksView() {
        (0, $50OuQ._)(this, BookmarksView);
        var _this;
        _this = (0, $huFCX._)(this, BookmarksView, arguments), (0, $1aca3bdf51b67d66$export$71511d61b312f219)(_this, "_parentElement", document.querySelector(".container")), (0, $1aca3bdf51b67d66$export$71511d61b312f219)(_this, "_errorMessage", 'No bookmarks yet. Find a nice book and bookmark it ;)'), (0, $1aca3bdf51b67d66$export$71511d61b312f219)(_this, "_message", '');
        return _this;
    }
    (0, $fGdZr._)(BookmarksView, [
        {
            key: "addHandlerBookRoutes",
            value: function addHandlerBookRoutes(handler) {
                var resultsContainer = this._parentElement.querySelector(".section-bookmarks__content");
                resultsContainer.addEventListener('click', function(e) {
                    var card = e.target.closest('.book-link');
                    if (!card) return;
                    e.preventDefault();
                    handler(card.dataset.route, card.dataset.id);
                });
            }
        },
        {
            key: "addHandlerLinks",
            value: function addHandlerLinks() {
                var links = document.querySelectorAll('.section-bookmarks__tab-container__link');
                links.forEach(function(link) {
                    return link.addEventListener('click', function(e) {
                        e.preventDefault();
                        (0, $c4ab8714ef37556f$export$2e2bcd8739ae039).navigateTo(link.dataset.route);
                    });
                });
            }
        },
        {
            key: "addHandlerRemoveBookmark",
            value: function addHandlerRemoveBookmark(handler) {
                var container = document.querySelector('.section-bookmarks__content');
                container.addEventListener('click', function(e) {
                    var btn = e.target.closest('.remove-bookmark-btn');
                    if (!btn) return;
                    handler(btn.dataset.bookId);
                });
            }
        },
        {
            key: "_generateMarkupBookmarkCards",
            value: function _generateMarkupBookmarkCards() {
                return this._data.map(function(bookmark) {
                    return (0, $e072da173f625080$export$2e2bcd8739ae039).render(bookmark, false, 'remove-bookmark-btn');
                }).join('');
            }
        },
        {
            key: "_generateMarkup",
            value: function _generateMarkup() {
                var bookmarkCards = this._generateMarkupBookmarkCards();
                return '\n      <section class="section-bookmarks">\n      <div class="section-bookmarks__header-bg"></div>\n        <div class="section-bookmarks__tab-container">\n        <a class="router-link section-bookmarks__tab-container__link" href="/bookmarks" data-route="/bookmarks">\n                 <button\n            class="section-bookmarks__tab-container__tab section-bookmarks__tab-container__tab--1 section-bookmarks__tab-container__tab--active"\n            data-tab="1"\n          >\n            Books\n          </button>\n        </a>\n\n\n        <a class="router-link section-bookmarks__tab-container__link" href="/collections" data-route="/collections">\n          <button\n              class="section-bookmarks__tab-container__tab section-bookmarks__tab-container__tab--2"\n              data-tab="2"\n            >\n              Collections\n            </button>\n        </a>\n         \n          \n        </div>\n        <div class ="section-bookmarks__container">\n          <div\n              class="section-bookmarks__content section-bookmarks__content--active"\n            >\n              '.concat(bookmarkCards ? bookmarkCards : '<div class="center-element">You did not bookmark any books yet :(</div>', "\n          </div>\n        </div>\n      </section>\n    ");
            }
        }
    ]);
    return BookmarksView;
}((0, $5965b2301664edc7$export$2e2bcd8739ae039));
var $a9853349f6311190$export$2e2bcd8739ae039 = new $a9853349f6311190$var$BookmarksView();



var $huFCX = parcelRequire("huFCX");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");


var $1atwj = parcelRequire("1atwj");


var $91000ab0687e1a6f$var$CollectionsView = /*#__PURE__*/ function(View) {
    "use strict";
    (0, $1atwj._)(CollectionsView, View);
    function CollectionsView() {
        (0, $50OuQ._)(this, CollectionsView);
        var _this;
        _this = (0, $huFCX._)(this, CollectionsView, arguments), (0, $1aca3bdf51b67d66$export$71511d61b312f219)(_this, "_parentElement", document.querySelector('.container'));
        return _this;
    }
    (0, $fGdZr._)(CollectionsView, [
        {
            key: "addHandlerLinks",
            value: function addHandlerLinks() {
                var links = document.querySelectorAll('.section-bookmarks__tab-container__link');
                links.forEach(function(link) {
                    return link.addEventListener('click', function(e) {
                        e.preventDefault();
                        (0, $c4ab8714ef37556f$export$2e2bcd8739ae039).navigateTo(link.dataset.route);
                    });
                });
            }
        },
        {
            key: "addHandlerViewCollection",
            value: function addHandlerViewCollection(handler) {
                var container = document.querySelector('.section-bookmarks__content');
                container.addEventListener('click', function(e) {
                    var btn = e.target.closest('.card--2__text-container__btn--view');
                    if (!btn) return;
                    handler(btn.dataset.collectionId);
                });
            }
        },
        {
            key: "addHandlerDeleteCollection",
            value: function addHandlerDeleteCollection(handler) {
                var _this = this;
                var container = document.querySelector('.section-bookmarks__content');
                container.addEventListener('click', function(e) {
                    var btn = e.target.closest('.card--2__text-container__btn--delete');
                    if (!btn) return;
                    var collectionId = btn.dataset.collectionId;
                    _this._handleModal(handler, collectionId);
                });
            }
        },
        {
            key: "_handleModal",
            value: function _handleModal(handler, collectionId) {
                var modal = this._parentElement.querySelector('.section-bookmarks__modal');
                var btnContainer = this._parentElement.querySelector('.section-bookmarks__modal__content__btn-container');
                modal.classList.add('section-bookmarks__modal--active');
                var closeModal = function() {
                    document.removeEventListener('keydown', handleKeypress);
                    modal.classList.remove('section-bookmarks__modal--active');
                };
                btnContainer.addEventListener('click', function(e) {
                    var btn = e.target.closest('.section-bookmarks__modal__content__btn');
                    if (!btn) return;
                    var choice = btn.dataset.choice;
                    if (choice === 'yes') handler(collectionId);
                    closeModal();
                });
                var handleKeypress = function(e) {
                    e.preventDefault();
                    if (e.key === 'Escape') closeModal();
                };
                document.addEventListener('keydown', handleKeypress);
            }
        },
        {
            key: "_generateMarkupCollectionCards",
            value: function _generateMarkupCollectionCards() {
                return this._data.map(function(collection) {
                    if (collection.books.length === 0) return;
                    return '\n      <li class="card card--2">\n        <div class="card--2__img-container">\n          '.concat(collection.books.slice(0, 3).map(function(book, index) {
                        return '\n            <img\n              src="'.concat(book.image, '"\n              alt="').concat(book.title, '"\n              class="card--2__img-container__img card--2__img-container__img--').concat(index + 1, '"\n            />\n          ');
                    }).join(''), '\n        </div>\n        <div class="card--2__text-container">\n\n          <p class="paragraph--big card--2__text-container__title">').concat(collection.collectionName.length <= 15 ? collection.collectionName : collection.collectionName.slice(0, 15) + '...', '</p>\n\n          <p class="paragraph--big card--2__text-container__books">\n            Total Books: ').concat(collection.books.length, '\n          </p>\n \n          <button class="btn-tertiary card--2__text-container__btn card--2__text-container__btn--view" data-collection-id="').concat(collection.id ? collection.id : collection.collectionId, '">\n            View\n          </button>\n          <button class="btn-tertiary card--2__text-container__btn card--2__text-container__btn--delete" data-collection-id="').concat(collection.id ? collection.id : collection.collectionId, '">\n            Delete\n          </button>\n        </div>\n      </li>\n    ');
                }).join('');
            }
        },
        {
            key: "_generateMarkup",
            value: function _generateMarkup() {
                var collectionCards = this._generateMarkupCollectionCards();
                return '\n      <section class="section-bookmarks">\n      <div class="section-bookmarks__header-bg"></div>\n        <div class="section-bookmarks__tab-container">\n        <a class="section-bookmarks__tab-container__link router-link" href="/bookmarks" data-route="/bookmarks">\n                 <button\n            class="section-bookmarks__tab-container__tab section-bookmarks__tab-container__tab--1"\n            data-tab="1"\n          >\n            Books\n          </button>\n        </a>\n\n\n        <a class="section-bookmarks__tab-container__link router-link" href="/collections" data-route="/collections">\n          <button\n              class="section-bookmarks__tab-container__tab section-bookmarks__tab-container__tab--2 section-bookmarks__tab-container__tab--active"\n              data-tab="2"\n            >\n              Collections\n            </button>\n        </a>\n        </div>\n\n        <div class="section-bookmarks__container">\n          <div\n            class="section-bookmarks__content section-bookmarks__content--active"\n          >\n            '.concat(collectionCards ? collectionCards : '<div class="center-element">You did not create any collections yet :(</div>', '\n          </div>\n        </div>       \n  \n        <div class="section-bookmarks__modal">\n            <div class="section-bookmarks__modal__content">\n\n            <h3 class="heading-3 section-bookmarks__modal__content__heading">Delete Collection ?</h3>\n            <div class="section-bookmarks__modal__content__btn-container">\n              <button class="btn-secondary section-bookmarks__modal__content__btn section-bookmarks__modal__content__btn--yes" data-choice="yes">Yes</button>\n              <button class="btn-secondary section-bookmarks__modal__content__btn" data-choice="no">No</button>\n            </div>\n            </div>\n        </div>\n      </section>\n    ');
            }
        }
    ]);
    return CollectionsView;
}((0, $5965b2301664edc7$export$2e2bcd8739ae039));
var $91000ab0687e1a6f$export$2e2bcd8739ae039 = new $91000ab0687e1a6f$var$CollectionsView();




var $huFCX = parcelRequire("huFCX");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");


var $1atwj = parcelRequire("1atwj");

var $4c324c79385c5920$exports = {};

$4c324c79385c5920$exports = (parcelRequire("c6lZy")).getBundleURL('1mAAk') + "home_create-plans.09f1a898.webp";


var $60eb300bbd450cb2$exports = {};

$60eb300bbd450cb2$exports = (parcelRequire("c6lZy")).getBundleURL('1mAAk') + "home_save-plans.d00dc7f1.webp";


var $642a939fcc39a7f9$exports = {};

$642a939fcc39a7f9$exports = (parcelRequire("c6lZy")).getBundleURL('1mAAk') + "home_share-plans.197cf6dd.webp";



var $4483f69ad63031c9$exports = {};

$4483f69ad63031c9$exports = (parcelRequire("c6lZy")).getBundleURL('1mAAk') + "poweredbygoogle.8a5e9e15.png";


var $8b4adf54cc3b8756$var$HomeView = /*#__PURE__*/ function(View) {
    "use strict";
    (0, $1atwj._)(HomeView, View);
    function HomeView() {
        (0, $50OuQ._)(this, HomeView);
        var _this;
        _this = (0, $huFCX._)(this, HomeView, arguments), (0, $1aca3bdf51b67d66$export$71511d61b312f219)(_this, "_parentElement", document.querySelector('.container')), (0, $1aca3bdf51b67d66$export$71511d61b312f219)(_this, "_count", 1);
        return _this;
    }
    (0, $fGdZr._)(HomeView, [
        {
            key: "addHandlerCarousel",
            value: function addHandlerCarousel() {
                var carousel = this._parentElement.querySelector(".section-collection-info__max-width-container__content");
                var textCards = carousel.querySelectorAll(".section-collection-info__max-width-container__content__text__text-box");
                var imgCards = carousel.querySelectorAll(".section-collection-info__max-width-container__content__img-container__img-box");
                var slideCounter = this._parentElement.querySelector(".section-collection-info__max-width-container__progress__count__text");
                var counter = 0;
                var updateCarousel = function() {
                    textCards.forEach(function(card) {
                        return card.classList.remove('text-active');
                    });
                    imgCards.forEach(function(card, index) {
                        card.classList.remove('section-collection-info__max-width-container__content__img-container__img-box--front', 'section-collection-info__max-width-container__content__img-container__img-box--middle', 'section-collection-info__max-width-container__content__img-container__img-box--back');
                        if (index === counter) card.classList.add('section-collection-info__max-width-container__content__img-container__img-box--front');
                        else if (index === (counter + 1) % imgCards.length) card.classList.add('section-collection-info__max-width-container__content__img-container__img-box--back');
                        else if (index === (counter + 2) % imgCards.length) card.classList.add('section-collection-info__max-width-container__content__img-container__img-box--middle');
                    });
                    slideCounter.textContent = "".concat(counter + 1, " / 3");
                    textCards[counter].classList.add('text-active');
                    counter = (counter + 1) % imgCards.length;
                    if (counter > 3) counter = 0;
                };
                setInterval(updateCarousel, 6000);
                updateCarousel();
            }
        },
        {
            key: "addHandlerSearch",
            value: function addHandlerSearch(handler) {
                var _this = this;
                var searchBtn = this._parentElement.querySelector(".hero__max-width-container__text__center-container__search-btn");
                searchBtn.addEventListener("click", function() {
                    return _this._handleModal(handler);
                });
            }
        },
        {
            key: "_getQuery",
            value: function _getQuery() {
                var searchBar = this._parentElement.querySelector(".search-bar");
                if (!searchBar) return;
                return searchBar.value;
            }
        },
        {
            key: "_handleModal",
            value: function _handleModal(handler) {
                var _this = this;
                var modal = this._parentElement.querySelector(".homepage__modal");
                var searchBar = this._parentElement.querySelector(".search-bar");
                var form = this._parentElement.querySelector(".search-form");
                var closeModal = function() {
                    var modal = _this._parentElement.querySelector(".homepage__modal");
                    var searchBar = _this._parentElement.querySelector(".search-bar");
                    modal.classList.remove('homepage__modal--active');
                    searchBar.value = '';
                    _this._closeSuggestions();
                };
                modal.classList.add('homepage__modal--active');
                setTimeout(function() {
                    return searchBar.focus();
                }, 300);
                modal.addEventListener('click', function(e) {
                    if (e.target === modal) closeModal();
                });
                form.addEventListener('submit', function(e) {
                    e.preventDefault();
                    var query = _this._getQuery();
                    if (!query) return;
                    handler(query);
                });
                searchBar.addEventListener('keydown', function(e) {
                    if (!(e.key === 'Escape')) return;
                    closeModal();
                });
            }
        },
        {
            key: "_generateMarkup",
            value: function _generateMarkup() {
                var suggestionsContainer = this._generateSuggestionsContainerMarkup();
                return '\n      <div class="homepage">\n        <section class="hero mb-hg">\n          <div class="max-width-container hero__max-width-container">\n            <div class="hero__max-width-container__text">\n                <div class="hero__max-width-container__text__center-container">\n                  <div class="hero__max-width-container__text__center-container__heading">\n                      <div class="heading-1 hero__max-width-container__text__center-container__heading--main"><span class="hero__max-width-container__text__center-container__heading--main__top">explore books,</span><span class="hero__max-width-container__text__heading--main__top">plan your reading journey</span></div>\n                      <div class="heading-4 hero__max-width-container__text__heading--sub">discover, organize, and share a world of stories</div>\n                  </div>\n                  <button class="hero__max-width-container__text__center-container__search-btn">  \n                    \n                    <span class="hero__max-width-container__text__center-container__search-btn__text">Search Books</span>\n                    <svg class="hero__max-width-container__text__center-container__search-btn__svg">\n                        <use xlink:href="'.concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), '#icon-magnifying-glass"></use>\n                      </svg>\n                  </button>\n                </div>\n                </div>\n                <div class="hero__max-width-container__img">\n                  <svg\n                    class="hero__max-width-container__img__svg"\n                  >\n                    <use\n                      xlink:href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), '#icon-hero"\n                    ></use>\n                  </svg>\n                </div>\n            </div>\n        </section>\n\n            <section class="section-collection-info mb-hg">\n            <div class="section-collection-info__max-width-container">\n              <h2 class="heading-2 section-collection-info__max-width-container__heading">Create Collections</h2>\n              <div class="section-collection-info__max-width-container__content">\n                <div class="section-collection-info__max-width-container__content__text">\n                  <ul>\n                    <li class="section-collection-info__max-width-container__content__text__text-box text-active">\n                      <h4 class="heading-4 section-collection-info__max-width-container__content__text__text-box__heading">Create Your Own Collection</h4>\n                      <p class="paragraph--big section-collection-info__max-width-container__content__text__text-box__para">\n                        Browse through our vast collection of a variety of books and\n                        handpick them for your personalized collections.\n                      </p>\n                    </li>\n                    <li class="section-collection-info__max-width-container__content__text__text-box">\n                      <h4 class="heading-4 section-collection-info__max-width-container__content__text__text-box__heading">Save Your Collections</h4>\n                      <p class="paragraph--big section-collection-info__max-width-container__content__text__text-box__para">\n                        Bookmark your collections to access them in future.\n                        Once you bookmark a collection or a book, you can access them under the Book Shelf.\n                      </p>\n                    </li>\n                    <li class="section-collection-info__max-width-container__content__text__text-box">\n                      <h4 class="heading-4 section-collection-info__max-width-container__content__text__text-box__heading">Share With Your Friends</h4>\n                      <p class="paragraph--big section-collection-info__max-width-container__content__text__text-box__para">\n                        You can use the share feature to share your collections\n                        with your peers. You get a unique URL for each of your\n                        collection that you can share with anyone!\n                      </p>\n                    </li>\n                  </ul>\n                  <div class="section-collection-info__max-width-container__progress">\n                    <div class="section-collection-info__max-width-container__progress__count">\n                      <p class="paragraph section-collection-info__max-width-container__progress__count__text"></p>\n                    </div>\n                    <div class="section-collection-info__max-width-container__progress__bar">\n                      <span class="section-collection-info__max-width-container__progress__bar__fill"></span>\n                    </div>\n                  </div>\n                </div>\n                <ul class="section-collection-info__max-width-container__content__img-container">\n                    <li class="section-collection-info__max-width-container__content__img-container__img-box section-collection-info__max-width-container__content__img-container__img-box--front">\n                      <img class="section-collection-info__max-width-container__content__img-container__img-box__img" src="').concat((0, (/*@__PURE__*/$parcel$interopDefault($4c324c79385c5920$exports))), '"/>\n                    </li>\n                    <li class="section-collection-info__max-width-container__content__img-container__img-box section-collection-info__max-width-container__content__img-container__img-box--middle">\n                      <img class="section-collection-info__max-width-container__content__img-container__img-box__img" src="').concat((0, (/*@__PURE__*/$parcel$interopDefault($60eb300bbd450cb2$exports))), '"/>\n                    </li>\n                    <li class="section-collection-info__max-width-container__content__img-container__img-box section-collection-info__max-width-container__content__img-container__img-box--back">\n                      <img class="section-collection-info__max-width-container__content__img-container__img-box__img" src="').concat((0, (/*@__PURE__*/$parcel$interopDefault($642a939fcc39a7f9$exports))), '"/>\n                    </li>\n                </ul>\n              </div>\n            </div>\n            </section>\n\n            <section class="section-find-info">\n            <div class ="section-find-info__max-width-container">\n              <h2 class="heading-2 mb-lg section-find-info__max-width-container__heading">Find Books</h2>\n              \n              <div class="section-find-info__max-width-container__content">\n                <div class="section-find-info__max-width-container__content__info-box">\n                  <div class="section-find-info__max-width-container__content__info-box__text-box section-find-info__max-width-container__content__info-box__text-box--1">\n                    <svg class="section-find-info__max-width-container__content__info-box__text-box__svg">\n                      <use xlink:href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), '#icon-magnifying-glass"></use>\n                    </svg>\n                    <div class="section-find-info__max-width-container__content__info-box__text-box__text">search from a variety of books</div>\n                  </div>\n                  <div class="section-find-info__max-width-container__content__info-box__img-box">\n                     <svg class="section-find-info__max-width-container__content__info-box__img-box__svg section-find-info__max-width-container__content__info-box__img-box__svg--1">\n                        <use xlink:href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), '#icon-right-facing"></use>\n                    </svg>\n                  </div>\n                </div>\n                \n                <div class="section-find-info__max-width-container__content__info-box">\n                  <div class="section-find-info__max-width-container__content__info-box__text-box section-find-info__max-width-container__content__info-box__text-box--2">\n                   <svg class="section-find-info__max-width-container__content__info-box__text-box__svg">\n                      <use xlink:href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), '#icon-bookmark"></use>\n                    </svg>\n                    <div class="section-find-info__max-width-container__content__info-box__text-box__text">bookmark your favorite books</div>\n                  </div>\n                  <div class="section-find-info__max-width-container__content__info-box__img-box">\n                     <svg class="section-find-info__max-width-container__content__info-box__img-box__svg section-find-info__max-width-container__content__info-box__img-box__svg--2">\n                        <use xlink:href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), '#icon-center-facing"></use>\n                    </svg>\n                  </div>\n                </div>\n\n                <div class="section-find-info__max-width-container__content__info-box">\n                  <div class="section-find-info__max-width-container__content__info-box__text-box section-find-info__max-width-container__content__info-box__text-box--3">\n                    <svg class="section-find-info__max-width-container__content__info-box__text-box__svg">\n                      <use xlink:href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), '#icon-share"></use>\n                    </svg>\n                    <div class="section-find-info__max-width-container__content__info-box__text-box__text">share a book with your friends</div>\n                  </div>\n                  <div class="section-find-info__max-width-container__content__info-box__img-box">\n                     <svg class="section-find-info__max-width-container__content__info-box__img-box__svg section-find-info__max-width-container__content__info-box__img-box__svg--3">\n                        <use xlink:href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), '#icon-left-facing"></use>\n                    </svg>\n                  </div>\n                </div>\n\n              </div>\n            </div>\n            </section>\n            <div class="homepage__modal">\n            <div class="homepage__modal__wrapper">\n              <div class="homepage__modal__wrapper__content">\n                <form class="homepage__modal__wrapper__content__search-form search-form">\n                  <div class="homepage__modal__wrapper__content__search-form__search-bar-container">\n                    <input \n                    class="homepage__modal__wrapper__content__search-form__search-bar-container__search-bar search-bar"\n                    placeholder="Type 3 or more characters..."\n                    autocomplete="off"\n                    />\n                    <button class="homepage__modal__wrapper__content__search-form__search-bar-container__search-btn">\n                    <svg class="homepage__modal__wrapper__content__search-form__search-bar-container__search-btn__svg">\n                      <use xlink:href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), '#icon-magnifying-glass"></use>\n                    </svg>\n                    </button>\n                  </div>\n                </form>\n                <div class="homepage__modal__wrapper__content__suggestions">\n                  ').concat(suggestionsContainer, '\n                </div>\n              </div>\n              <a href="https://www.google.com" target="_blank" class="homepage__modal__wrapper__powered-by">\n                <img class="homepage__modal__wrapper__powered-by--img" src=').concat((0, (/*@__PURE__*/$parcel$interopDefault($4483f69ad63031c9$exports))), " />\n              </a>\n            </div>\n            </div>\n          </div>\n    ");
            }
        }
    ]);
    return HomeView;
}((0, $5965b2301664edc7$export$2e2bcd8739ae039));
var $8b4adf54cc3b8756$export$2e2bcd8739ae039 = new $8b4adf54cc3b8756$var$HomeView();



var $huFCX = parcelRequire("huFCX");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");


var $1atwj = parcelRequire("1atwj");

var $aSMts = parcelRequire("aSMts");



var $aafb1cd6a41c7c1b$var$HeaderView = /*#__PURE__*/ function(View) {
    "use strict";
    (0, $1atwj._)(HeaderView, View);
    function HeaderView() {
        (0, $50OuQ._)(this, HeaderView);
        var _this;
        _this = (0, $huFCX._)(this, HeaderView, arguments), (0, $1aca3bdf51b67d66$export$71511d61b312f219)(_this, "_parentElement", document.querySelector('.navigation'));
        return _this;
    }
    (0, $fGdZr._)(HeaderView, [
        {
            key: "addHandlerCloseMenu",
            value: function addHandlerCloseMenu() {
                var checkBtn = document.querySelector('.header__max-width-container__check');
                var container = document.querySelector(".container");
                container.addEventListener('click', function() {
                    return checkBtn.checked = false;
                });
                this._parentElement.addEventListener('click', function(e) {
                    var link = e.target.closest('.router-link');
                    if (!link) return;
                    e.preventDefault();
                    (0, $c4ab8714ef37556f$export$2e2bcd8739ae039).navigateTo(link.dataset.route);
                    checkBtn.checked = false;
                });
            }
        },
        {
            key: "addHandlerNavbarPosition",
            value: function addHandlerNavbarPosition() {
                var header = this._parentElement.querySelector(".header");
                var observer = new IntersectionObserver(function(param) {
                    var _param = (0, $aSMts._)(param, 1), entry = _param[0];
                    header.classList.toggle('header--scrolled', !entry.isIntersecting);
                }, {});
                observer.observe(this._parentElement);
            }
        },
        {
            key: "_generateMarkup",
            value: function _generateMarkup() {
                return '\n    <nav class="header">\n      <div class="header__max-width-container">\n        <div class="header__max-width-container__logo-container">\n          <a href="/" class="router-link header__max-width-container__logo-container__link" data-route="/">\n            <svg class="header__max-width-container__logo-container__link__logo">\n              <use xlink:href="'.concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), '#icon-logo"></use>\n            </svg>\n          </a>\n        </div>\n          \n          <input type="checkbox" class="header__max-width-container__check" id="header-check" />\n          <label for="header-check" class="header__max-width-container__hamburger-container">\n            <div class="header__max-width-container__hamburger-container__hamburger"></div>\n          </label>\n          <div class="header__max-width-container__btn-container">\n            <a href="/find-books" class="header__max-width-container__btn-container__btn-link router-link" data-route="/find-books">\n              <button class="header__max-width-container__btn-container__btn-link__btn">Find Books</button>\n            </a>\n            \n            <a href="/create-collections" class="header__max-width-container__btn-container__btn-link router-link" data-route="/create-collections">\n              <button class="header__max-width-container__btn-container__btn-link__btn">Create Collections</button>\n            </a>\n            \n            <a href="/" class="header__max-width-container__btn-container__btn-link router-link" data-route="/">\n              <button class="header__max-width-container__btn-container__btn-link__btn">Home</button>\n            </a>\n            \n            <a href="/bookmarks" class="header__max-width-container__btn-container__btn-link router-link" data-route="/bookmarks">\n              <button class="header__max-width-container__btn-container__btn-link__btn header__max-width-container__btn-container__btn-link__btn-bm">Book Shelf</button>\n            </a>\n          </div>\n      </div>\n    </nav>\n    ');
            }
        }
    ]);
    return HeaderView;
}((0, $5965b2301664edc7$export$2e2bcd8739ae039));
var $aafb1cd6a41c7c1b$export$2e2bcd8739ae039 = new $aafb1cd6a41c7c1b$var$HeaderView();



var $huFCX = parcelRequire("huFCX");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");


var $1atwj = parcelRequire("1atwj");


var $12f8f514a54c20f4$var$FooterView = /*#__PURE__*/ function(View) {
    "use strict";
    (0, $1atwj._)(FooterView, View);
    function FooterView() {
        (0, $50OuQ._)(this, FooterView);
        var _this;
        _this = (0, $huFCX._)(this, FooterView, arguments), (0, $1aca3bdf51b67d66$export$71511d61b312f219)(_this, "_parentElement", document.querySelector('.footer'));
        return _this;
    }
    (0, $fGdZr._)(FooterView, [
        {
            key: "_generateMarkup",
            value: function _generateMarkup() {
                return '\n   <footer class="footer">\n   <div class="footer__logo">\n    <svg class="footer__logo--book">\n      <use xlink:href="'.concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), '#icon-logo-book--white"></use>\n    </svg>\n     <svg class="footer__logo--text">\n      <use xlink:href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), '#icon-logo-text--white"></use>\n    </svg>\n   </div>\n\n   <p class="paragraph footer__sub-text">"Self Care with Shelf Share\n    <svg class="footer__sub-text__svg">\n      <use xlink:href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), '#icon-winking-face"></use>\n    </svg>"\n   </p>\n   \n    <a href="https://github.com/Pranav-Patani/Shelf-Share" target="_blank" class="footer__link">\n      <div class="footer__link__text-box">\n        <svg class="footer__link__text-box__svg">\n          <use xlink:href="').concat((0, (/*@__PURE__*/$parcel$interopDefault($ebf602e660545280$exports))), '#icon-github"></use>\n        </svg>\n        <p class="paragraph--big footer__link__text-box__text">\n          Pranav-Patani/Shelf-Share\n        </p>\n      </div>\n    </a>\n   </footer>\n    ');
            }
        }
    ]);
    return FooterView;
}((0, $5965b2301664edc7$export$2e2bcd8739ae039));
var $12f8f514a54c20f4$export$2e2bcd8739ae039 = new $12f8f514a54c20f4$var$FooterView();



var $huFCX = parcelRequire("huFCX");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");


var $1atwj = parcelRequire("1atwj");


var $902aac28f1dedc9b$var$ErrorView = /*#__PURE__*/ function(View) {
    "use strict";
    (0, $1atwj._)(ErrorView, View);
    function ErrorView() {
        (0, $50OuQ._)(this, ErrorView);
        var _this;
        _this = (0, $huFCX._)(this, ErrorView, arguments), (0, $1aca3bdf51b67d66$export$71511d61b312f219)(_this, "_parentElement", document.querySelector(".container"));
        return _this;
    }
    (0, $fGdZr._)(ErrorView, [
        {
            key: "_generateErrorMessage",
            value: function _generateErrorMessage() {
                return this._data === 'pageNotFound' ? "404 Page Not Found" : " Opps! Something went wrong.";
            }
        },
        {
            key: "_generateSubErrorMessage",
            value: function _generateSubErrorMessage() {
                return this._data === 'pageNotFound' ? "Seems like you are on a wrong path :/" : "We are working on it, please check back later.";
            }
        },
        {
            key: "_generateMarkup",
            value: function _generateMarkup() {
                return '\n        <section class="error-view">\n        <div class="error-view__content">\n        <div class="error-view__content__gif-container">\n            <img class="error-view__content__gif-container__gif" src='.concat((0, (/*@__PURE__*/$parcel$interopDefault($6b415d5b56546b2c$exports))), ' alt="error"/>\n        </div>\n            <h4 class="heading-4 error-view__content__alert-message">').concat(this._generateErrorMessage(), '\n             <p class="error-view__content__alert-message--sub">').concat(this._generateSubErrorMessage(), '</p>\n            </h4>\n\n            <p class=error-view__content__alert-message__contact>If required, please contact us on <a href="mailto: connectshelfshare@gmail.com" class="error-view__content__alert-message__contact--link">connectshelfshare@gmail.com</a></p>\n        </div>\n        </section>\n    ');
            }
        }
    ]);
    return ErrorView;
}((0, $5965b2301664edc7$export$2e2bcd8739ae039));
var $902aac28f1dedc9b$export$2e2bcd8739ae039 = new $902aac28f1dedc9b$var$ErrorView();



var $5Pgs2 = parcelRequire("5Pgs2");

var $1XfpH = parcelRequire("1XfpH");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $1XfpH = parcelRequire("1XfpH");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $1XfpH = parcelRequire("1XfpH");

var $dHvbf = parcelRequire("dHvbf");

var $60db40b289bb50e3$export$98d92b1aa79f8cc7 = function(customFetch) {
    var _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return Promise.resolve((parcelRequire("TskBh"))).then(function(param) {
            var _$fetch = param["default"];
            return _$fetch.apply(void 0, (0, $dHvbf._)(args));
        });
    };
    else _fetch = fetch;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return _fetch.apply(void 0, (0, $dHvbf._)(args));
    };
};



var $huFCX = parcelRequire("huFCX");

var $50OuQ = parcelRequire("50OuQ");

var $1atwj = parcelRequire("1atwj");

var $jc6v0 = parcelRequire("jc6v0");
var $7c3123f99bdc17b6$export$738689d52335bb3c = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $1atwj._)(FunctionsError, Error1);
    function FunctionsError(message) {
        var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'FunctionsError', context = arguments.length > 2 ? arguments[2] : void 0;
        (0, $50OuQ._)(this, FunctionsError);
        var _this;
        _this = (0, $huFCX._)(this, FunctionsError, [
            message
        ]);
        _this.name = name;
        _this.context = context;
        return _this;
    }
    return FunctionsError;
}((0, $jc6v0._)(Error));
var $7c3123f99bdc17b6$export$14f2b6540d498ce = /*#__PURE__*/ function(FunctionsError) {
    "use strict";
    (0, $1atwj._)(FunctionsFetchError, FunctionsError);
    function FunctionsFetchError(context) {
        (0, $50OuQ._)(this, FunctionsFetchError);
        return (0, $huFCX._)(this, FunctionsFetchError, [
            'Failed to send a request to the Edge Function',
            'FunctionsFetchError',
            context
        ]);
    }
    return FunctionsFetchError;
}($7c3123f99bdc17b6$export$738689d52335bb3c);
var $7c3123f99bdc17b6$export$d08a45df86040161 = /*#__PURE__*/ function(FunctionsError) {
    "use strict";
    (0, $1atwj._)(FunctionsRelayError, FunctionsError);
    function FunctionsRelayError(context) {
        (0, $50OuQ._)(this, FunctionsRelayError);
        return (0, $huFCX._)(this, FunctionsRelayError, [
            'Relay Error invoking the Edge Function',
            'FunctionsRelayError',
            context
        ]);
    }
    return FunctionsRelayError;
}($7c3123f99bdc17b6$export$738689d52335bb3c);
var $7c3123f99bdc17b6$export$761f8c0e0fa4624f = /*#__PURE__*/ function(FunctionsError) {
    "use strict";
    (0, $1atwj._)(FunctionsHttpError, FunctionsError);
    function FunctionsHttpError(context) {
        (0, $50OuQ._)(this, FunctionsHttpError);
        return (0, $huFCX._)(this, FunctionsHttpError, [
            'Edge Function returned a non-2xx status code',
            'FunctionsHttpError',
            context
        ]);
    }
    return FunctionsHttpError;
}($7c3123f99bdc17b6$export$738689d52335bb3c);
var $7c3123f99bdc17b6$export$9b19f1a5abf91e06;
(function(FunctionRegion) {
    FunctionRegion["Any"] = "any";
    FunctionRegion["ApNortheast1"] = "ap-northeast-1";
    FunctionRegion["ApNortheast2"] = "ap-northeast-2";
    FunctionRegion["ApSouth1"] = "ap-south-1";
    FunctionRegion["ApSoutheast1"] = "ap-southeast-1";
    FunctionRegion["ApSoutheast2"] = "ap-southeast-2";
    FunctionRegion["CaCentral1"] = "ca-central-1";
    FunctionRegion["EuCentral1"] = "eu-central-1";
    FunctionRegion["EuWest1"] = "eu-west-1";
    FunctionRegion["EuWest2"] = "eu-west-2";
    FunctionRegion["EuWest3"] = "eu-west-3";
    FunctionRegion["SaEast1"] = "sa-east-1";
    FunctionRegion["UsEast1"] = "us-east-1";
    FunctionRegion["UsWest1"] = "us-west-1";
    FunctionRegion["UsWest2"] = "us-west-2";
})($7c3123f99bdc17b6$export$9b19f1a5abf91e06 || ($7c3123f99bdc17b6$export$9b19f1a5abf91e06 = {}));


var $3ea221538d6cfdc0$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3ea221538d6cfdc0$export$1d0b400bf8a0fa55 = /*#__PURE__*/ function() {
    "use strict";
    function FunctionsClient(url) {
        var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_headers = _ref.headers, headers = _ref_headers === void 0 ? {} : _ref_headers, customFetch = _ref.customFetch, _ref_region = _ref.region, region = _ref_region === void 0 ? (0, $7c3123f99bdc17b6$export$9b19f1a5abf91e06).Any : _ref_region;
        (0, $50OuQ._)(this, FunctionsClient);
        this.url = url;
        this.headers = headers;
        this.region = region;
        this.fetch = (0, $60db40b289bb50e3$export$98d92b1aa79f8cc7)(customFetch);
    }
    (0, $fGdZr._)(FunctionsClient, [
        {
            /**
     * Updates the authorization header
     * @param token - the new jwt token sent in the authorisation header
     */ key: "setAuth",
            value: function setAuth(token) {
                this.headers.Authorization = "Bearer ".concat(token);
            }
        },
        {
            /**
     * Invokes a function
     * @param functionName - The name of the Function to invoke.
     * @param options - Options for invoking the Function.
     */ key: "invoke",
            value: function invoke(functionName) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _a;
                return $3ea221538d6cfdc0$var$__awaiter(this, void 0, void 0, function() {
                    var headers, method, functionArgs, _headers, region, body, response, isRelayError, responseType, data, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    11,
                                    ,
                                    12
                                ]);
                                headers = options.headers, method = options.method, functionArgs = options.body;
                                _headers = {};
                                region = options.region;
                                if (!region) region = this.region;
                                if (region && region !== 'any') _headers['x-region'] = region;
                                if (functionArgs && (headers && !Object.prototype.hasOwnProperty.call(headers, 'Content-Type') || !headers)) {
                                    if (typeof Blob !== 'undefined' && functionArgs instanceof Blob || functionArgs instanceof ArrayBuffer) {
                                        // will work for File as File inherits Blob
                                        // also works for ArrayBuffer as it is the same underlying structure as a Blob
                                        _headers['Content-Type'] = 'application/octet-stream';
                                        body = functionArgs;
                                    } else if (typeof functionArgs === 'string') {
                                        // plain string
                                        _headers['Content-Type'] = 'text/plain';
                                        body = functionArgs;
                                    } else if (typeof FormData !== 'undefined' && functionArgs instanceof FormData) // don't set content-type headers
                                    // Request will automatically add the right boundary value
                                    body = functionArgs;
                                    else {
                                        // default, assume this is JSON
                                        _headers['Content-Type'] = 'application/json';
                                        body = JSON.stringify(functionArgs);
                                    }
                                }
                                return [
                                    4,
                                    this.fetch("".concat(this.url, "/").concat(functionName), {
                                        method: method || 'POST',
                                        // headers priority is (high to low):
                                        // 1. invoke-level headers
                                        // 2. client-level headers
                                        // 3. default Content-Type header
                                        headers: Object.assign(Object.assign(Object.assign({}, _headers), this.headers), headers),
                                        body: body
                                    })["catch"](function(fetchError) {
                                        throw new (0, $7c3123f99bdc17b6$export$14f2b6540d498ce)(fetchError);
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                isRelayError = response.headers.get('x-relay-error');
                                if (isRelayError && isRelayError === 'true') throw new (0, $7c3123f99bdc17b6$export$d08a45df86040161)(response);
                                if (!response.ok) throw new (0, $7c3123f99bdc17b6$export$761f8c0e0fa4624f)(response);
                                responseType = ((_a = response.headers.get('Content-Type')) !== null && _a !== void 0 ? _a : 'text/plain').split(';')[0].trim();
                                if (!(responseType === 'application/json')) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                data = _state.sent();
                                return [
                                    3,
                                    10
                                ];
                            case 3:
                                if (!(responseType === 'application/octet-stream')) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    response.blob()
                                ];
                            case 4:
                                data = _state.sent();
                                return [
                                    3,
                                    10
                                ];
                            case 5:
                                if (!(responseType === 'text/event-stream')) return [
                                    3,
                                    6
                                ];
                                data = response;
                                return [
                                    3,
                                    10
                                ];
                            case 6:
                                if (!(responseType === 'multipart/form-data')) return [
                                    3,
                                    8
                                ];
                                return [
                                    4,
                                    response.formData()
                                ];
                            case 7:
                                data = _state.sent();
                                return [
                                    3,
                                    10
                                ];
                            case 8:
                                return [
                                    4,
                                    response.text()
                                ];
                            case 9:
                                // default to text
                                data = _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    2,
                                    {
                                        data: data,
                                        error: null
                                    }
                                ];
                            case 11:
                                error = _state.sent();
                                return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                            case 12:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return FunctionsClient;
}();


var $db4ed43959b51b86$exports = {};
"use strict";
var $db4ed43959b51b86$var$__importDefault = $db4ed43959b51b86$exports && $db4ed43959b51b86$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($db4ed43959b51b86$exports, "__esModule", {
    value: true
});
$db4ed43959b51b86$exports.PostgrestError = $db4ed43959b51b86$exports.PostgrestBuilder = $db4ed43959b51b86$exports.PostgrestTransformBuilder = $db4ed43959b51b86$exports.PostgrestFilterBuilder = $db4ed43959b51b86$exports.PostgrestQueryBuilder = $db4ed43959b51b86$exports.PostgrestClient = void 0;

// Always update wrapper.mjs when updating this file.
var $db4ed43959b51b86$var$PostgrestClient_1 = $db4ed43959b51b86$var$__importDefault((parcelRequire("gTcxm")));
$db4ed43959b51b86$exports.PostgrestClient = $db4ed43959b51b86$var$PostgrestClient_1["default"];

var $db4ed43959b51b86$var$PostgrestQueryBuilder_1 = $db4ed43959b51b86$var$__importDefault((parcelRequire("lHE4l")));
$db4ed43959b51b86$exports.PostgrestQueryBuilder = $db4ed43959b51b86$var$PostgrestQueryBuilder_1["default"];

var $db4ed43959b51b86$var$PostgrestFilterBuilder_1 = $db4ed43959b51b86$var$__importDefault((parcelRequire("9HWpt")));
$db4ed43959b51b86$exports.PostgrestFilterBuilder = $db4ed43959b51b86$var$PostgrestFilterBuilder_1["default"];

var $db4ed43959b51b86$var$PostgrestTransformBuilder_1 = $db4ed43959b51b86$var$__importDefault((parcelRequire("frmVa")));
$db4ed43959b51b86$exports.PostgrestTransformBuilder = $db4ed43959b51b86$var$PostgrestTransformBuilder_1["default"];

var $db4ed43959b51b86$var$PostgrestBuilder_1 = $db4ed43959b51b86$var$__importDefault((parcelRequire("bd5X5")));
$db4ed43959b51b86$exports.PostgrestBuilder = $db4ed43959b51b86$var$PostgrestBuilder_1["default"];

var $db4ed43959b51b86$var$PostgrestError_1 = $db4ed43959b51b86$var$__importDefault((parcelRequire("7hiup")));
$db4ed43959b51b86$exports.PostgrestError = $db4ed43959b51b86$var$PostgrestError_1["default"];
$db4ed43959b51b86$exports["default"] = {
    PostgrestClient: $db4ed43959b51b86$var$PostgrestClient_1["default"],
    PostgrestQueryBuilder: $db4ed43959b51b86$var$PostgrestQueryBuilder_1["default"],
    PostgrestFilterBuilder: $db4ed43959b51b86$var$PostgrestFilterBuilder_1["default"],
    PostgrestTransformBuilder: $db4ed43959b51b86$var$PostgrestTransformBuilder_1["default"],
    PostgrestBuilder: $db4ed43959b51b86$var$PostgrestBuilder_1["default"],
    PostgrestError: $db4ed43959b51b86$var$PostgrestError_1["default"]
};


var $f22638f4b54b5a77$export$796f32e2ee984aaa = (0, (/*@__PURE__*/$parcel$interopDefault($db4ed43959b51b86$exports))).PostgrestClient, $f22638f4b54b5a77$export$a81993b50ca081ad = (0, (/*@__PURE__*/$parcel$interopDefault($db4ed43959b51b86$exports))).PostgrestQueryBuilder, $f22638f4b54b5a77$export$3158317c13bdc93a = (0, (/*@__PURE__*/$parcel$interopDefault($db4ed43959b51b86$exports))).PostgrestFilterBuilder, $f22638f4b54b5a77$export$7b4361bb87e3030c = (0, (/*@__PURE__*/$parcel$interopDefault($db4ed43959b51b86$exports))).PostgrestTransformBuilder, $f22638f4b54b5a77$export$3106e21688a06353 = (0, (/*@__PURE__*/$parcel$interopDefault($db4ed43959b51b86$exports))).PostgrestBuilder, $f22638f4b54b5a77$export$445b7e3a323f992f = (0, (/*@__PURE__*/$parcel$interopDefault($db4ed43959b51b86$exports))).PostgrestError;
var // compatibility with CJS output
$f22638f4b54b5a77$export$2e2bcd8739ae039 = {
    PostgrestClient: $f22638f4b54b5a77$export$796f32e2ee984aaa,
    PostgrestQueryBuilder: $f22638f4b54b5a77$export$a81993b50ca081ad,
    PostgrestFilterBuilder: $f22638f4b54b5a77$export$3158317c13bdc93a,
    PostgrestTransformBuilder: $f22638f4b54b5a77$export$7b4361bb87e3030c,
    PostgrestBuilder: $f22638f4b54b5a77$export$3106e21688a06353,
    PostgrestError: $f22638f4b54b5a77$export$445b7e3a323f992f
};



var $5Pgs2 = parcelRequire("5Pgs2");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $dHvbf = parcelRequire("dHvbf");

var $1XfpH = parcelRequire("1XfpH");
var $f463e651bcd062d3$export$83d89fbfd8236492 = '2.11.2';


var $bc0d0f689a320ba6$export$88a84136db6a4b64 = {
    'X-Client-Info': "realtime-js/".concat((0, $f463e651bcd062d3$export$83d89fbfd8236492))
};
var $bc0d0f689a320ba6$export$df3f558bb9a9c991 = '1.0.0';
var $bc0d0f689a320ba6$export$7bd623b29ec8e1eb = 10000;
var $bc0d0f689a320ba6$export$5e80cf62e56a877b = 1000;
var $bc0d0f689a320ba6$export$a6d0320a1563d49e;
(function(SOCKET_STATES) {
    SOCKET_STATES[SOCKET_STATES["connecting"] = 0] = "connecting";
    SOCKET_STATES[SOCKET_STATES["open"] = 1] = "open";
    SOCKET_STATES[SOCKET_STATES["closing"] = 2] = "closing";
    SOCKET_STATES[SOCKET_STATES["closed"] = 3] = "closed";
})($bc0d0f689a320ba6$export$a6d0320a1563d49e || ($bc0d0f689a320ba6$export$a6d0320a1563d49e = {}));
var $bc0d0f689a320ba6$export$b83816118db74fe7;
(function(CHANNEL_STATES) {
    CHANNEL_STATES["closed"] = "closed";
    CHANNEL_STATES["errored"] = "errored";
    CHANNEL_STATES["joined"] = "joined";
    CHANNEL_STATES["joining"] = "joining";
    CHANNEL_STATES["leaving"] = "leaving";
})($bc0d0f689a320ba6$export$b83816118db74fe7 || ($bc0d0f689a320ba6$export$b83816118db74fe7 = {}));
var $bc0d0f689a320ba6$export$8db7548e65d6ea55;
(function(CHANNEL_EVENTS) {
    CHANNEL_EVENTS["close"] = "phx_close";
    CHANNEL_EVENTS["error"] = "phx_error";
    CHANNEL_EVENTS["join"] = "phx_join";
    CHANNEL_EVENTS["reply"] = "phx_reply";
    CHANNEL_EVENTS["leave"] = "phx_leave";
    CHANNEL_EVENTS["access_token"] = "access_token";
})($bc0d0f689a320ba6$export$8db7548e65d6ea55 || ($bc0d0f689a320ba6$export$8db7548e65d6ea55 = {}));
var $bc0d0f689a320ba6$export$b2688bfb999f5751;
(function(TRANSPORTS) {
    TRANSPORTS["websocket"] = "websocket";
})($bc0d0f689a320ba6$export$b2688bfb999f5751 || ($bc0d0f689a320ba6$export$b2688bfb999f5751 = {}));
var $bc0d0f689a320ba6$export$deda39003d27273;
(function(CONNECTION_STATE) {
    CONNECTION_STATE["Connecting"] = "connecting";
    CONNECTION_STATE["Open"] = "open";
    CONNECTION_STATE["Closing"] = "closing";
    CONNECTION_STATE["Closed"] = "closed";
})($bc0d0f689a320ba6$export$deda39003d27273 || ($bc0d0f689a320ba6$export$deda39003d27273 = {}));


// This file draws heavily from https://github.com/phoenixframework/phoenix/commit/cf098e9cf7a44ee6479d31d911a97d3c7430c6fe
// License: https://github.com/phoenixframework/phoenix/blob/master/LICENSE.md

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");
var $8ef4be980dd2d07e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Serializer() {
        (0, $50OuQ._)(this, Serializer);
        this.HEADER_LENGTH = 1;
    }
    (0, $fGdZr._)(Serializer, [
        {
            key: "decode",
            value: function decode(rawPayload, callback) {
                if (rawPayload.constructor === ArrayBuffer) return callback(this._binaryDecode(rawPayload));
                if (typeof rawPayload === 'string') return callback(JSON.parse(rawPayload));
                return callback({});
            }
        },
        {
            key: "_binaryDecode",
            value: function _binaryDecode(buffer) {
                var view = new DataView(buffer);
                var decoder = new TextDecoder();
                return this._decodeBroadcast(buffer, view, decoder);
            }
        },
        {
            key: "_decodeBroadcast",
            value: function _decodeBroadcast(buffer, view, decoder) {
                var topicSize = view.getUint8(1);
                var eventSize = view.getUint8(2);
                var offset = this.HEADER_LENGTH + 2;
                var topic = decoder.decode(buffer.slice(offset, offset + topicSize));
                offset = offset + topicSize;
                var event = decoder.decode(buffer.slice(offset, offset + eventSize));
                offset = offset + eventSize;
                var data = JSON.parse(decoder.decode(buffer.slice(offset, buffer.byteLength)));
                return {
                    ref: null,
                    topic: topic,
                    event: event,
                    payload: data
                };
            }
        }
    ]);
    return Serializer;
}();


/**
 * Creates a timer that accepts a `timerCalc` function to perform calculated timeout retries, such as exponential backoff.
 *
 * @example
 *    let reconnectTimer = new Timer(() => this.connect(), function(tries){
 *      return [1000, 5000, 10000][tries - 1] || 10000
 *    })
 *    reconnectTimer.scheduleTimeout() // fires after 1000
 *    reconnectTimer.scheduleTimeout() // fires after 5000
 *    reconnectTimer.reset()
 *    reconnectTimer.scheduleTimeout() // fires after 1000
 */ 
var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");
var $deb1520a2ba90aff$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Timer(callback, timerCalc) {
        (0, $50OuQ._)(this, Timer);
        this.callback = callback;
        this.timerCalc = timerCalc;
        this.timer = undefined;
        this.tries = 0;
        this.callback = callback;
        this.timerCalc = timerCalc;
    }
    (0, $fGdZr._)(Timer, [
        {
            key: "reset",
            value: function reset() {
                this.tries = 0;
                clearTimeout(this.timer);
            }
        },
        {
            // Cancels any previous scheduleTimeout and schedules callback
            key: "scheduleTimeout",
            value: function scheduleTimeout() {
                var _this = this;
                clearTimeout(this.timer);
                this.timer = setTimeout(function() {
                    _this.tries = _this.tries + 1;
                    _this.callback();
                }, this.timerCalc(this.tries + 1));
            }
        }
    ]);
    return Timer;
}();


/**
 * Helpers to convert the change Payload into native JS types.
 */ // Adapted from epgsql (src/epgsql_binary.erl), this module licensed under
// 3-clause BSD found here: https://raw.githubusercontent.com/epgsql/epgsql/devel/LICENSE
var $06884f93312edc07$export$4d213a7d364021dc;
(function(PostgresTypes) {
    PostgresTypes["abstime"] = "abstime";
    PostgresTypes["bool"] = "bool";
    PostgresTypes["date"] = "date";
    PostgresTypes["daterange"] = "daterange";
    PostgresTypes["float4"] = "float4";
    PostgresTypes["float8"] = "float8";
    PostgresTypes["int2"] = "int2";
    PostgresTypes["int4"] = "int4";
    PostgresTypes["int4range"] = "int4range";
    PostgresTypes["int8"] = "int8";
    PostgresTypes["int8range"] = "int8range";
    PostgresTypes["json"] = "json";
    PostgresTypes["jsonb"] = "jsonb";
    PostgresTypes["money"] = "money";
    PostgresTypes["numeric"] = "numeric";
    PostgresTypes["oid"] = "oid";
    PostgresTypes["reltime"] = "reltime";
    PostgresTypes["text"] = "text";
    PostgresTypes["time"] = "time";
    PostgresTypes["timestamp"] = "timestamp";
    PostgresTypes["timestamptz"] = "timestamptz";
    PostgresTypes["timetz"] = "timetz";
    PostgresTypes["tsrange"] = "tsrange";
    PostgresTypes["tstzrange"] = "tstzrange";
})($06884f93312edc07$export$4d213a7d364021dc || ($06884f93312edc07$export$4d213a7d364021dc = {}));
var $06884f93312edc07$export$20ce708a1f594c5e = function(columns, record) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _a;
    var skipTypes = (_a = options.skipTypes) !== null && _a !== void 0 ? _a : [];
    return Object.keys(record).reduce(function(acc, rec_key) {
        acc[rec_key] = $06884f93312edc07$export$c054edfec1afa88d(rec_key, columns, record, skipTypes);
        return acc;
    }, {});
};
var $06884f93312edc07$export$c054edfec1afa88d = function(columnName, columns, record, skipTypes) {
    var column = columns.find(function(x) {
        return x.name === columnName;
    });
    var colType = column === null || column === void 0 ? void 0 : column.type;
    var value = record[columnName];
    if (colType && !skipTypes.includes(colType)) return $06884f93312edc07$export$3df02a362b86a91(colType, value);
    return $06884f93312edc07$var$noop(value);
};
var $06884f93312edc07$export$3df02a362b86a91 = function(type, value) {
    // if data type is an array
    if (type.charAt(0) === '_') {
        var dataType = type.slice(1, type.length);
        return $06884f93312edc07$export$45b10814cc054894(value, dataType);
    }
    // If not null, convert to correct type.
    switch(type){
        case $06884f93312edc07$export$4d213a7d364021dc.bool:
            return $06884f93312edc07$export$3c2e6d1b7583eee6(value);
        case $06884f93312edc07$export$4d213a7d364021dc.float4:
        case $06884f93312edc07$export$4d213a7d364021dc.float8:
        case $06884f93312edc07$export$4d213a7d364021dc.int2:
        case $06884f93312edc07$export$4d213a7d364021dc.int4:
        case $06884f93312edc07$export$4d213a7d364021dc.int8:
        case $06884f93312edc07$export$4d213a7d364021dc.numeric:
        case $06884f93312edc07$export$4d213a7d364021dc.oid:
            return $06884f93312edc07$export$a0a81dc3380ce7d3(value);
        case $06884f93312edc07$export$4d213a7d364021dc.json:
        case $06884f93312edc07$export$4d213a7d364021dc.jsonb:
            return $06884f93312edc07$export$d5b7a8bf56ee1fe2(value);
        case $06884f93312edc07$export$4d213a7d364021dc.timestamp:
            return $06884f93312edc07$export$eccf8c5d91d19e3a(value); // Format to be consistent with PostgREST
        case $06884f93312edc07$export$4d213a7d364021dc.abstime:
        case $06884f93312edc07$export$4d213a7d364021dc.date:
        case $06884f93312edc07$export$4d213a7d364021dc.daterange:
        case $06884f93312edc07$export$4d213a7d364021dc.int4range:
        case $06884f93312edc07$export$4d213a7d364021dc.int8range:
        case $06884f93312edc07$export$4d213a7d364021dc.money:
        case $06884f93312edc07$export$4d213a7d364021dc.reltime:
        case $06884f93312edc07$export$4d213a7d364021dc.text:
        case $06884f93312edc07$export$4d213a7d364021dc.time:
        case $06884f93312edc07$export$4d213a7d364021dc.timestamptz:
        case $06884f93312edc07$export$4d213a7d364021dc.timetz:
        case $06884f93312edc07$export$4d213a7d364021dc.tsrange:
        case $06884f93312edc07$export$4d213a7d364021dc.tstzrange:
            return $06884f93312edc07$var$noop(value);
        default:
            // Return the value for remaining types
            return $06884f93312edc07$var$noop(value);
    }
};
var $06884f93312edc07$var$noop = function(value) {
    return value;
};
var $06884f93312edc07$export$3c2e6d1b7583eee6 = function(value) {
    switch(value){
        case 't':
            return true;
        case 'f':
            return false;
        default:
            return value;
    }
};
var $06884f93312edc07$export$a0a81dc3380ce7d3 = function(value) {
    if (typeof value === 'string') {
        var parsedValue = parseFloat(value);
        if (!Number.isNaN(parsedValue)) return parsedValue;
    }
    return value;
};
var $06884f93312edc07$export$d5b7a8bf56ee1fe2 = function(value) {
    if (typeof value === 'string') try {
        return JSON.parse(value);
    } catch (error) {
        console.log("JSON parse error: ".concat(error));
        return value;
    }
    return value;
};
var $06884f93312edc07$export$45b10814cc054894 = function(value, type) {
    if (typeof value !== 'string') return value;
    var lastIdx = value.length - 1;
    var closeBrace = value[lastIdx];
    var openBrace = value[0];
    // Confirm value is a Postgres array by checking curly brackets
    if (openBrace === '{' && closeBrace === '}') {
        var arr;
        var valTrim = value.slice(1, lastIdx);
        // TODO: find a better solution to separate Postgres array data
        try {
            arr = JSON.parse('[' + valTrim + ']');
        } catch (_) {
            // WARNING: splitting on comma does not cover all edge cases
            arr = valTrim ? valTrim.split(',') : [];
        }
        return arr.map(function(val) {
            return $06884f93312edc07$export$3df02a362b86a91(type, val);
        });
    }
    return value;
};
var $06884f93312edc07$export$eccf8c5d91d19e3a = function(value) {
    if (typeof value === 'string') return value.replace(' ', 'T');
    return value;
};
var $06884f93312edc07$export$976fda7151b30cae = function(socketUrl) {
    var url = socketUrl;
    url = url.replace(/^ws/i, 'http');
    url = url.replace(/(\/socket\/websocket|\/socket|\/websocket)\/?$/i, '');
    return url.replace(/\/+$/, '');
};



var $5Pgs2 = parcelRequire("5Pgs2");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $qb7pP = parcelRequire("qb7pP");

var $1XfpH = parcelRequire("1XfpH");


var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $c0b56065c990793a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Push(channel, event) {
        var payload = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, timeout = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : (0, $bc0d0f689a320ba6$export$7bd623b29ec8e1eb);
        (0, $50OuQ._)(this, Push);
        this.channel = channel;
        this.event = event;
        this.payload = payload;
        this.timeout = timeout;
        this.sent = false;
        this.timeoutTimer = undefined;
        this.ref = '';
        this.receivedResp = null;
        this.recHooks = [];
        this.refEvent = null;
    }
    (0, $fGdZr._)(Push, [
        {
            key: "resend",
            value: function resend(timeout) {
                this.timeout = timeout;
                this._cancelRefEvent();
                this.ref = '';
                this.refEvent = null;
                this.receivedResp = null;
                this.sent = false;
                this.send();
            }
        },
        {
            key: "send",
            value: function send() {
                if (this._hasReceived('timeout')) return;
                this.startTimeout();
                this.sent = true;
                this.channel.socket.push({
                    topic: this.channel.topic,
                    event: this.event,
                    payload: this.payload,
                    ref: this.ref,
                    join_ref: this.channel._joinRef()
                });
            }
        },
        {
            key: "updatePayload",
            value: function updatePayload(payload) {
                this.payload = Object.assign(Object.assign({}, this.payload), payload);
            }
        },
        {
            key: "receive",
            value: function receive(status, callback) {
                var _a;
                if (this._hasReceived(status)) callback((_a = this.receivedResp) === null || _a === void 0 ? void 0 : _a.response);
                this.recHooks.push({
                    status: status,
                    callback: callback
                });
                return this;
            }
        },
        {
            key: "startTimeout",
            value: function startTimeout() {
                var _this = this;
                if (this.timeoutTimer) return;
                this.ref = this.channel.socket._makeRef();
                this.refEvent = this.channel._replyEventName(this.ref);
                var callback = function(payload) {
                    _this._cancelRefEvent();
                    _this._cancelTimeout();
                    _this.receivedResp = payload;
                    _this._matchReceive(payload);
                };
                this.channel._on(this.refEvent, {}, callback);
                this.timeoutTimer = setTimeout(function() {
                    _this.trigger('timeout', {});
                }, this.timeout);
            }
        },
        {
            key: "trigger",
            value: function trigger(status, response) {
                if (this.refEvent) this.channel._trigger(this.refEvent, {
                    status: status,
                    response: response
                });
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this._cancelRefEvent();
                this._cancelTimeout();
            }
        },
        {
            key: "_cancelRefEvent",
            value: function _cancelRefEvent() {
                if (!this.refEvent) return;
                this.channel._off(this.refEvent, {});
            }
        },
        {
            key: "_cancelTimeout",
            value: function _cancelTimeout() {
                clearTimeout(this.timeoutTimer);
                this.timeoutTimer = undefined;
            }
        },
        {
            key: "_matchReceive",
            value: function _matchReceive(param) {
                var status = param.status, response = param.response;
                this.recHooks.filter(function(h) {
                    return h.status === status;
                }).forEach(function(h) {
                    return h.callback(response);
                });
            }
        },
        {
            key: "_hasReceived",
            value: function _hasReceived(status) {
                return this.receivedResp && this.receivedResp.status === status;
            }
        }
    ]);
    return Push;
}();



/*
  This file draws heavily from https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/assets/js/phoenix/presence.js
  License: https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/LICENSE.md
*/ 
var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $dHvbf = parcelRequire("dHvbf");
var $250594dc3ca0b0d0$export$f1ce049df2794fb4;
(function(REALTIME_PRESENCE_LISTEN_EVENTS) {
    REALTIME_PRESENCE_LISTEN_EVENTS["SYNC"] = "sync";
    REALTIME_PRESENCE_LISTEN_EVENTS["JOIN"] = "join";
    REALTIME_PRESENCE_LISTEN_EVENTS["LEAVE"] = "leave";
})($250594dc3ca0b0d0$export$f1ce049df2794fb4 || ($250594dc3ca0b0d0$export$f1ce049df2794fb4 = {}));
var $250594dc3ca0b0d0$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function RealtimePresence(channel, opts) {
        var _this = this;
        (0, $50OuQ._)(this, RealtimePresence);
        this.channel = channel;
        this.state = {};
        this.pendingDiffs = [];
        this.joinRef = null;
        this.caller = {
            onJoin: function() {},
            onLeave: function() {},
            onSync: function() {}
        };
        var events = (opts === null || opts === void 0 ? void 0 : opts.events) || {
            state: 'presence_state',
            diff: 'presence_diff'
        };
        this.channel._on(events.state, {}, function(newState) {
            var _this_caller = _this.caller, onJoin = _this_caller.onJoin, onLeave = _this_caller.onLeave, onSync = _this_caller.onSync;
            _this.joinRef = _this.channel._joinRef();
            _this.state = RealtimePresence.syncState(_this.state, newState, onJoin, onLeave);
            _this.pendingDiffs.forEach(function(diff) {
                _this.state = RealtimePresence.syncDiff(_this.state, diff, onJoin, onLeave);
            });
            _this.pendingDiffs = [];
            onSync();
        });
        this.channel._on(events.diff, {}, function(diff) {
            var _this_caller = _this.caller, onJoin = _this_caller.onJoin, onLeave = _this_caller.onLeave, onSync = _this_caller.onSync;
            if (_this.inPendingSyncState()) _this.pendingDiffs.push(diff);
            else {
                _this.state = RealtimePresence.syncDiff(_this.state, diff, onJoin, onLeave);
                onSync();
            }
        });
        this.onJoin(function(key, currentPresences, newPresences) {
            _this.channel._trigger('presence', {
                event: 'join',
                key: key,
                currentPresences: currentPresences,
                newPresences: newPresences
            });
        });
        this.onLeave(function(key, currentPresences, leftPresences) {
            _this.channel._trigger('presence', {
                event: 'leave',
                key: key,
                currentPresences: currentPresences,
                leftPresences: leftPresences
            });
        });
        this.onSync(function() {
            _this.channel._trigger('presence', {
                event: 'sync'
            });
        });
    }
    (0, $fGdZr._)(RealtimePresence, [
        {
            /** @internal */ key: "onJoin",
            value: function onJoin(callback) {
                this.caller.onJoin = callback;
            }
        },
        {
            /** @internal */ key: "onLeave",
            value: function onLeave(callback) {
                this.caller.onLeave = callback;
            }
        },
        {
            /** @internal */ key: "onSync",
            value: function onSync(callback) {
                this.caller.onSync = callback;
            }
        },
        {
            /** @internal */ key: "inPendingSyncState",
            value: function inPendingSyncState() {
                return !this.joinRef || this.joinRef !== this.channel._joinRef();
            }
        }
    ], [
        {
            key: "syncState",
            value: /**
     * Used to sync the list of presences on the server with the
     * client's state.
     *
     * An optional `onJoin` and `onLeave` callback can be provided to
     * react to changes in the client's local presences across
     * disconnects and reconnects with the server.
     *
     * @internal
     */ function syncState(currentState, newState, onJoin, onLeave) {
                var state = this.cloneDeep(currentState);
                var transformedState = this.transformState(newState);
                var joins = {};
                var leaves = {};
                this.map(state, function(key, presences) {
                    if (!transformedState[key]) leaves[key] = presences;
                });
                this.map(transformedState, function(key, newPresences) {
                    var currentPresences = state[key];
                    if (currentPresences) {
                        var newPresenceRefs = newPresences.map(function(m) {
                            return m.presence_ref;
                        });
                        var curPresenceRefs = currentPresences.map(function(m) {
                            return m.presence_ref;
                        });
                        var joinedPresences = newPresences.filter(function(m) {
                            return curPresenceRefs.indexOf(m.presence_ref) < 0;
                        });
                        var leftPresences = currentPresences.filter(function(m) {
                            return newPresenceRefs.indexOf(m.presence_ref) < 0;
                        });
                        if (joinedPresences.length > 0) joins[key] = joinedPresences;
                        if (leftPresences.length > 0) leaves[key] = leftPresences;
                    } else joins[key] = newPresences;
                });
                return this.syncDiff(state, {
                    joins: joins,
                    leaves: leaves
                }, onJoin, onLeave);
            }
        },
        {
            key: "syncDiff",
            value: /**
     * Used to sync a diff of presence join and leave events from the
     * server, as they happen.
     *
     * Like `syncState`, `syncDiff` accepts optional `onJoin` and
     * `onLeave` callbacks to react to a user joining or leaving from a
     * device.
     *
     * @internal
     */ function syncDiff(state, diff, onJoin, onLeave) {
                var _this = this;
                var _ref = {
                    joins: this.transformState(diff.joins),
                    leaves: this.transformState(diff.leaves)
                }, joins = _ref.joins, leaves = _ref.leaves;
                if (!onJoin) onJoin = function() {};
                if (!onLeave) onLeave = function() {};
                this.map(joins, function(key, newPresences) {
                    var _a;
                    var currentPresences = (_a = state[key]) !== null && _a !== void 0 ? _a : [];
                    state[key] = _this.cloneDeep(newPresences);
                    if (currentPresences.length > 0) {
                        var _state_key;
                        var joinedPresenceRefs = state[key].map(function(m) {
                            return m.presence_ref;
                        });
                        var curPresences = currentPresences.filter(function(m) {
                            return joinedPresenceRefs.indexOf(m.presence_ref) < 0;
                        });
                        (_state_key = state[key]).unshift.apply(_state_key, (0, $dHvbf._)(curPresences));
                    }
                    onJoin(key, currentPresences, newPresences);
                });
                this.map(leaves, function(key, leftPresences) {
                    var currentPresences = state[key];
                    if (!currentPresences) return;
                    var presenceRefsToRemove = leftPresences.map(function(m) {
                        return m.presence_ref;
                    });
                    currentPresences = currentPresences.filter(function(m) {
                        return presenceRefsToRemove.indexOf(m.presence_ref) < 0;
                    });
                    state[key] = currentPresences;
                    onLeave(key, currentPresences, leftPresences);
                    if (currentPresences.length === 0) delete state[key];
                });
                return state;
            }
        },
        {
            key: "map",
            value: /** @internal */ function map(obj, func) {
                return Object.getOwnPropertyNames(obj).map(function(key) {
                    return func(key, obj[key]);
                });
            }
        },
        {
            key: "transformState",
            value: /**
     * Remove 'metas' key
     * Change 'phx_ref' to 'presence_ref'
     * Remove 'phx_ref' and 'phx_ref_prev'
     *
     * @example
     * // returns {
     *  abc123: [
     *    { presence_ref: '2', user_id: 1 },
     *    { presence_ref: '3', user_id: 2 }
     *  ]
     * }
     * RealtimePresence.transformState({
     *  abc123: {
     *    metas: [
     *      { phx_ref: '2', phx_ref_prev: '1' user_id: 1 },
     *      { phx_ref: '3', user_id: 2 }
     *    ]
     *  }
     * })
     *
     * @internal
     */ function transformState(state) {
                state = this.cloneDeep(state);
                return Object.getOwnPropertyNames(state).reduce(function(newState, key) {
                    var presences = state[key];
                    if ('metas' in presences) newState[key] = presences.metas.map(function(presence) {
                        presence['presence_ref'] = presence['phx_ref'];
                        delete presence['phx_ref'];
                        delete presence['phx_ref_prev'];
                        return presence;
                    });
                    else newState[key] = presences;
                    return newState;
                }, {});
            }
        },
        {
            key: "cloneDeep",
            value: /** @internal */ function cloneDeep(obj) {
                return JSON.parse(JSON.stringify(obj));
            }
        }
    ]);
    return RealtimePresence;
}();



var $6a8abcf604bb0be1$export$bc171c571098b6c4;
(function(REALTIME_POSTGRES_CHANGES_LISTEN_EVENT) {
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["ALL"] = "*";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["INSERT"] = "INSERT";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["UPDATE"] = "UPDATE";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["DELETE"] = "DELETE";
})($6a8abcf604bb0be1$export$bc171c571098b6c4 || ($6a8abcf604bb0be1$export$bc171c571098b6c4 = {}));
var $6a8abcf604bb0be1$export$9e3fe8e487ef792e;
(function(REALTIME_LISTEN_TYPES) {
    REALTIME_LISTEN_TYPES["BROADCAST"] = "broadcast";
    REALTIME_LISTEN_TYPES["PRESENCE"] = "presence";
    REALTIME_LISTEN_TYPES["POSTGRES_CHANGES"] = "postgres_changes";
    REALTIME_LISTEN_TYPES["SYSTEM"] = "system";
})($6a8abcf604bb0be1$export$9e3fe8e487ef792e || ($6a8abcf604bb0be1$export$9e3fe8e487ef792e = {}));
var $6a8abcf604bb0be1$export$a6885b926af646a2;
(function(REALTIME_SUBSCRIBE_STATES) {
    REALTIME_SUBSCRIBE_STATES["SUBSCRIBED"] = "SUBSCRIBED";
    REALTIME_SUBSCRIBE_STATES["TIMED_OUT"] = "TIMED_OUT";
    REALTIME_SUBSCRIBE_STATES["CLOSED"] = "CLOSED";
    REALTIME_SUBSCRIBE_STATES["CHANNEL_ERROR"] = "CHANNEL_ERROR";
})($6a8abcf604bb0be1$export$a6885b926af646a2 || ($6a8abcf604bb0be1$export$a6885b926af646a2 = {}));
var $6a8abcf604bb0be1$export$154db638d9c0559e = (0, $bc0d0f689a320ba6$export$b83816118db74fe7);
var $6a8abcf604bb0be1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function RealtimeChannel(/** Topic name can be any string. */ topic) {
        var _this = this;
        var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
            config: {}
        }, socket = arguments.length > 2 ? arguments[2] : void 0;
        (0, $50OuQ._)(this, RealtimeChannel);
        this.topic = topic;
        this.params = params;
        this.socket = socket;
        this.bindings = {};
        this.state = (0, $bc0d0f689a320ba6$export$b83816118db74fe7).closed;
        this.joinedOnce = false;
        this.pushBuffer = [];
        this.subTopic = topic.replace(/^realtime:/i, '');
        this.params.config = Object.assign({
            broadcast: {
                ack: false,
                self: false
            },
            presence: {
                key: ''
            },
            private: false
        }, params.config);
        this.timeout = this.socket.timeout;
        this.joinPush = new (0, $c0b56065c990793a$export$2e2bcd8739ae039)(this, (0, $bc0d0f689a320ba6$export$8db7548e65d6ea55).join, this.params, this.timeout);
        this.rejoinTimer = new (0, $deb1520a2ba90aff$export$2e2bcd8739ae039)(function() {
            return _this._rejoinUntilConnected();
        }, this.socket.reconnectAfterMs);
        this.joinPush.receive('ok', function() {
            _this.state = (0, $bc0d0f689a320ba6$export$b83816118db74fe7).joined;
            _this.rejoinTimer.reset();
            _this.pushBuffer.forEach(function(pushEvent) {
                return pushEvent.send();
            });
            _this.pushBuffer = [];
        });
        this._onClose(function() {
            _this.rejoinTimer.reset();
            _this.socket.log('channel', "close ".concat(_this.topic, " ").concat(_this._joinRef()));
            _this.state = (0, $bc0d0f689a320ba6$export$b83816118db74fe7).closed;
            _this.socket._remove(_this);
        });
        this._onError(function(reason) {
            if (_this._isLeaving() || _this._isClosed()) return;
            _this.socket.log('channel', "error ".concat(_this.topic), reason);
            _this.state = (0, $bc0d0f689a320ba6$export$b83816118db74fe7).errored;
            _this.rejoinTimer.scheduleTimeout();
        });
        this.joinPush.receive('timeout', function() {
            if (!_this._isJoining()) return;
            _this.socket.log('channel', "timeout ".concat(_this.topic), _this.joinPush.timeout);
            _this.state = (0, $bc0d0f689a320ba6$export$b83816118db74fe7).errored;
            _this.rejoinTimer.scheduleTimeout();
        });
        this._on((0, $bc0d0f689a320ba6$export$8db7548e65d6ea55).reply, {}, function(payload, ref) {
            _this._trigger(_this._replyEventName(ref), payload);
        });
        this.presence = new (0, $250594dc3ca0b0d0$export$2e2bcd8739ae039)(this);
        this.broadcastEndpointURL = (0, $06884f93312edc07$export$976fda7151b30cae)(this.socket.endPoint) + '/api/broadcast';
        this["private"] = this.params.config["private"] || false;
    }
    (0, $fGdZr._)(RealtimeChannel, [
        {
            /** Subscribe registers your client with the server */ key: "subscribe",
            value: function subscribe(callback) {
                var timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.timeout;
                var _a, _b;
                if (!this.socket.isConnected()) this.socket.connect();
                if (this.joinedOnce) throw "tried to subscribe multiple times. 'subscribe' can only be called a single time per channel instance";
                else {
                    var _this_params = this.params, _this_params_config = _this_params.config, broadcast = _this_params_config.broadcast, presence = _this_params_config.presence, isPrivate = _this_params_config["private"];
                    this._onError(function(e) {
                        return callback === null || callback === void 0 ? void 0 : callback($6a8abcf604bb0be1$export$a6885b926af646a2.CHANNEL_ERROR, e);
                    });
                    this._onClose(function() {
                        return callback === null || callback === void 0 ? void 0 : callback($6a8abcf604bb0be1$export$a6885b926af646a2.CLOSED);
                    });
                    var accessTokenPayload = {};
                    var config = {
                        broadcast: broadcast,
                        presence: presence,
                        postgres_changes: (_b = (_a = this.bindings.postgres_changes) === null || _a === void 0 ? void 0 : _a.map(function(r) {
                            return r.filter;
                        })) !== null && _b !== void 0 ? _b : [],
                        private: isPrivate
                    };
                    if (this.socket.accessTokenValue) accessTokenPayload.access_token = this.socket.accessTokenValue;
                    this.updateJoinPayload(Object.assign({
                        config: config
                    }, accessTokenPayload));
                    this.joinedOnce = true;
                    this._rejoin(timeout);
                    var _this = this;
                    this.joinPush.receive('ok', /*#__PURE__*/ function() {
                        var _ref = (0, $5Pgs2._)(function(param) {
                            var postgres_changes, _a, clientPostgresBindings, bindingsLen, newPostgresBindings, i, clientPostgresBinding, _clientPostgresBinding_filter, event, schema, table, filter, serverPostgresFilter;
                            return (0, $1XfpH.__generator)(this, function(_state) {
                                postgres_changes = param.postgres_changes;
                                _this.socket.setAuth();
                                if (postgres_changes === undefined) {
                                    callback === null || callback === void 0 || callback($6a8abcf604bb0be1$export$a6885b926af646a2.SUBSCRIBED);
                                    return [
                                        2
                                    ];
                                } else {
                                    clientPostgresBindings = _this.bindings.postgres_changes;
                                    bindingsLen = (_a = clientPostgresBindings === null || clientPostgresBindings === void 0 ? void 0 : clientPostgresBindings.length) !== null && _a !== void 0 ? _a : 0;
                                    newPostgresBindings = [];
                                    for(i = 0; i < bindingsLen; i++){
                                        clientPostgresBinding = clientPostgresBindings[i];
                                        _clientPostgresBinding_filter = clientPostgresBinding.filter, event = _clientPostgresBinding_filter.event, schema = _clientPostgresBinding_filter.schema, table = _clientPostgresBinding_filter.table, filter = _clientPostgresBinding_filter.filter;
                                        serverPostgresFilter = postgres_changes && postgres_changes[i];
                                        if (serverPostgresFilter && serverPostgresFilter.event === event && serverPostgresFilter.schema === schema && serverPostgresFilter.table === table && serverPostgresFilter.filter === filter) newPostgresBindings.push(Object.assign(Object.assign({}, clientPostgresBinding), {
                                            id: serverPostgresFilter.id
                                        }));
                                        else {
                                            _this.unsubscribe();
                                            callback === null || callback === void 0 || callback($6a8abcf604bb0be1$export$a6885b926af646a2.CHANNEL_ERROR, new Error('mismatch between server and client bindings for postgres changes'));
                                            return [
                                                2
                                            ];
                                        }
                                    }
                                    _this.bindings.postgres_changes = newPostgresBindings;
                                    callback && callback($6a8abcf604bb0be1$export$a6885b926af646a2.SUBSCRIBED);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    2
                                ];
                            });
                        });
                        return function(_) {
                            return _ref.apply(this, arguments);
                        };
                    }()).receive('error', function(error) {
                        callback === null || callback === void 0 || callback($6a8abcf604bb0be1$export$a6885b926af646a2.CHANNEL_ERROR, new Error(JSON.stringify(Object.values(error).join(', ') || 'error')));
                        return;
                    }).receive('timeout', function() {
                        callback === null || callback === void 0 || callback($6a8abcf604bb0be1$export$a6885b926af646a2.TIMED_OUT);
                        return;
                    });
                }
                return this;
            }
        },
        {
            key: "presenceState",
            value: function presenceState() {
                return this.presence.state;
            }
        },
        {
            key: "track",
            value: function track(payload) {
                var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.send({
                                        type: 'presence',
                                        event: 'track',
                                        payload: payload
                                    }, opts.timeout || _this.timeout)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "untrack",
            value: function untrack() {
                var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.send({
                                        type: 'presence',
                                        event: 'untrack'
                                    }, opts)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "on",
            value: function on(type, filter, callback) {
                return this._on(type, filter, callback);
            }
        },
        {
            key: "send",
            value: /**
     * Sends a message into the channel.
     *
     * @param args Arguments to send to channel
     * @param args.type The type of event to send
     * @param args.event The name of the event being sent
     * @param args.payload Payload to be sent
     * @param opts Options to be used during the send process
     */ function send(args) {
                var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _a, _b, event, endpoint_payload, authorization, options, response, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(!_this._canPush() && args.type === 'broadcast')) return [
                                    3,
                                    6
                                ];
                                event = args.event, endpoint_payload = args.payload;
                                authorization = _this.socket.accessTokenValue ? "Bearer ".concat(_this.socket.accessTokenValue) : '';
                                options = {
                                    method: 'POST',
                                    headers: {
                                        Authorization: authorization,
                                        apikey: _this.socket.apiKey ? _this.socket.apiKey : '',
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify({
                                        messages: [
                                            {
                                                topic: _this.subTopic,
                                                event: event,
                                                payload: endpoint_payload,
                                                private: _this["private"]
                                            }
                                        ]
                                    })
                                };
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    _this._fetchWithTimeout(_this.broadcastEndpointURL, options, (_a = opts.timeout) !== null && _a !== void 0 ? _a : _this.timeout)
                                ];
                            case 2:
                                response = _state.sent();
                                return [
                                    4,
                                    (_b = response.body) === null || _b === void 0 ? void 0 : _b.cancel()
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2,
                                    response.ok ? 'ok' : 'error'
                                ];
                            case 4:
                                error = _state.sent();
                                if (error.name === 'AbortError') return [
                                    2,
                                    'timed out'
                                ];
                                else return [
                                    2,
                                    'error'
                                ];
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                return [
                                    2,
                                    new Promise(function(resolve) {
                                        var _a, _b, _c;
                                        var push = _this._push(args.type, args, opts.timeout || _this.timeout);
                                        if (args.type === 'broadcast' && !((_c = (_b = (_a = _this.params) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.broadcast) === null || _c === void 0 ? void 0 : _c.ack)) resolve('ok');
                                        push.receive('ok', function() {
                                            return resolve('ok');
                                        });
                                        push.receive('error', function() {
                                            return resolve('error');
                                        });
                                        push.receive('timeout', function() {
                                            return resolve('timed out');
                                        });
                                    })
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateJoinPayload",
            value: function updateJoinPayload(payload) {
                this.joinPush.updatePayload(payload);
            }
        },
        {
            /**
     * Leaves the channel.
     *
     * Unsubscribes from server events, and instructs channel to terminate on server.
     * Triggers onClose() hooks.
     *
     * To receive leave acknowledgements, use the a `receive` hook to bind to the server ack, ie:
     * channel.unsubscribe().receive("ok", () => alert("left!") )
     */ key: "unsubscribe",
            value: function unsubscribe() {
                var _this = this;
                var timeout = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.timeout;
                this.state = (0, $bc0d0f689a320ba6$export$b83816118db74fe7).leaving;
                var onClose = function() {
                    _this.socket.log('channel', "leave ".concat(_this.topic));
                    _this._trigger((0, $bc0d0f689a320ba6$export$8db7548e65d6ea55).close, 'leave', _this._joinRef());
                };
                this.rejoinTimer.reset();
                // Destroy joinPush to avoid connection timeouts during unscription phase
                this.joinPush.destroy();
                return new Promise(function(resolve) {
                    var leavePush = new (0, $c0b56065c990793a$export$2e2bcd8739ae039)(_this, (0, $bc0d0f689a320ba6$export$8db7548e65d6ea55).leave, {}, timeout);
                    leavePush.receive('ok', function() {
                        onClose();
                        resolve('ok');
                    }).receive('timeout', function() {
                        onClose();
                        resolve('timed out');
                    }).receive('error', function() {
                        resolve('error');
                    });
                    leavePush.send();
                    if (!_this._canPush()) leavePush.trigger('ok', {});
                });
            }
        },
        {
            key: "_fetchWithTimeout",
            value: /** @internal */ function _fetchWithTimeout(url, options, timeout) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var controller, id, response;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                controller = new AbortController();
                                id = setTimeout(function() {
                                    return controller.abort();
                                }, timeout);
                                return [
                                    4,
                                    _this.socket.fetch(url, Object.assign(Object.assign({}, options), {
                                        signal: controller.signal
                                    }))
                                ];
                            case 1:
                                response = _state.sent();
                                clearTimeout(id);
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                })();
            }
        },
        {
            /** @internal */ key: "_push",
            value: function _push(event, payload) {
                var timeout = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.timeout;
                if (!this.joinedOnce) throw "tried to push '".concat(event, "' to '").concat(this.topic, "' before joining. Use channel.subscribe() before pushing events");
                var pushEvent = new (0, $c0b56065c990793a$export$2e2bcd8739ae039)(this, event, payload, timeout);
                if (this._canPush()) pushEvent.send();
                else {
                    pushEvent.startTimeout();
                    this.pushBuffer.push(pushEvent);
                }
                return pushEvent;
            }
        },
        {
            /**
     * Overridable message hook
     *
     * Receives all events for specialized message handling before dispatching to the channel callbacks.
     * Must return the payload, modified or unmodified.
     *
     * @internal
     */ key: "_onMessage",
            value: function _onMessage(_event, payload, _ref) {
                return payload;
            }
        },
        {
            /** @internal */ key: "_isMember",
            value: function _isMember(topic) {
                return this.topic === topic;
            }
        },
        {
            /** @internal */ key: "_joinRef",
            value: function _joinRef() {
                return this.joinPush.ref;
            }
        },
        {
            /** @internal */ key: "_trigger",
            value: function _trigger(type, payload, ref) {
                var _this = this;
                var _a, _b;
                var typeLower = type.toLocaleLowerCase();
                var close = (0, $bc0d0f689a320ba6$export$8db7548e65d6ea55).close, error = (0, $bc0d0f689a320ba6$export$8db7548e65d6ea55).error, leave = (0, $bc0d0f689a320ba6$export$8db7548e65d6ea55).leave, join = (0, $bc0d0f689a320ba6$export$8db7548e65d6ea55).join;
                var events = [
                    close,
                    error,
                    leave,
                    join
                ];
                if (ref && events.indexOf(typeLower) >= 0 && ref !== this._joinRef()) return;
                var handledPayload = this._onMessage(typeLower, payload, ref);
                if (payload && !handledPayload) throw 'channel onMessage callbacks must return the payload, modified or unmodified';
                if ([
                    'insert',
                    'update',
                    'delete'
                ].includes(typeLower)) (_a = this.bindings.postgres_changes) === null || _a === void 0 || _a.filter(function(bind) {
                    var _a, _b, _c;
                    return ((_a = bind.filter) === null || _a === void 0 ? void 0 : _a.event) === '*' || ((_c = (_b = bind.filter) === null || _b === void 0 ? void 0 : _b.event) === null || _c === void 0 ? void 0 : _c.toLocaleLowerCase()) === typeLower;
                }).map(function(bind) {
                    return bind.callback(handledPayload, ref);
                });
                else (_b = this.bindings[typeLower]) === null || _b === void 0 || _b.filter(function(bind) {
                    var _a, _b, _c, _d, _e, _f;
                    if ([
                        'broadcast',
                        'presence',
                        'postgres_changes'
                    ].includes(typeLower)) {
                        if ('id' in bind) {
                            var bindId = bind.id;
                            var bindEvent = (_a = bind.filter) === null || _a === void 0 ? void 0 : _a.event;
                            return bindId && ((_b = payload.ids) === null || _b === void 0 ? void 0 : _b.includes(bindId)) && (bindEvent === '*' || (bindEvent === null || bindEvent === void 0 ? void 0 : bindEvent.toLocaleLowerCase()) === ((_c = payload.data) === null || _c === void 0 ? void 0 : _c.type.toLocaleLowerCase()));
                        } else {
                            var bindEvent1 = (_e = (_d = bind === null || bind === void 0 ? void 0 : bind.filter) === null || _d === void 0 ? void 0 : _d.event) === null || _e === void 0 ? void 0 : _e.toLocaleLowerCase();
                            return bindEvent1 === '*' || bindEvent1 === ((_f = payload === null || payload === void 0 ? void 0 : payload.event) === null || _f === void 0 ? void 0 : _f.toLocaleLowerCase());
                        }
                    } else return bind.type.toLocaleLowerCase() === typeLower;
                }).map(function(bind) {
                    if ((typeof handledPayload === "undefined" ? "undefined" : (0, $qb7pP._)(handledPayload)) === 'object' && 'ids' in handledPayload) {
                        var postgresChanges = handledPayload.data;
                        var schema = postgresChanges.schema, table = postgresChanges.table, commit_timestamp = postgresChanges.commit_timestamp, _$type = postgresChanges.type, errors = postgresChanges.errors;
                        var enrichedPayload = {
                            schema: schema,
                            table: table,
                            commit_timestamp: commit_timestamp,
                            eventType: _$type,
                            "new": {},
                            old: {},
                            errors: errors
                        };
                        handledPayload = Object.assign(Object.assign({}, enrichedPayload), _this._getPayloadRecords(postgresChanges));
                    }
                    bind.callback(handledPayload, ref);
                });
            }
        },
        {
            /** @internal */ key: "_isClosed",
            value: function _isClosed() {
                return this.state === (0, $bc0d0f689a320ba6$export$b83816118db74fe7).closed;
            }
        },
        {
            /** @internal */ key: "_isJoined",
            value: function _isJoined() {
                return this.state === (0, $bc0d0f689a320ba6$export$b83816118db74fe7).joined;
            }
        },
        {
            /** @internal */ key: "_isJoining",
            value: function _isJoining() {
                return this.state === (0, $bc0d0f689a320ba6$export$b83816118db74fe7).joining;
            }
        },
        {
            /** @internal */ key: "_isLeaving",
            value: function _isLeaving() {
                return this.state === (0, $bc0d0f689a320ba6$export$b83816118db74fe7).leaving;
            }
        },
        {
            /** @internal */ key: "_replyEventName",
            value: function _replyEventName(ref) {
                return "chan_reply_".concat(ref);
            }
        },
        {
            /** @internal */ key: "_on",
            value: function _on(type, filter, callback) {
                var typeLower = type.toLocaleLowerCase();
                var binding = {
                    type: typeLower,
                    filter: filter,
                    callback: callback
                };
                if (this.bindings[typeLower]) this.bindings[typeLower].push(binding);
                else this.bindings[typeLower] = [
                    binding
                ];
                return this;
            }
        },
        {
            /** @internal */ key: "_off",
            value: function _off(type, filter) {
                var typeLower = type.toLocaleLowerCase();
                this.bindings[typeLower] = this.bindings[typeLower].filter(function(bind) {
                    var _a;
                    return !(((_a = bind.type) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === typeLower && RealtimeChannel.isEqual(bind.filter, filter));
                });
                return this;
            }
        },
        {
            /** @internal */ key: "_rejoinUntilConnected",
            value: function _rejoinUntilConnected() {
                this.rejoinTimer.scheduleTimeout();
                if (this.socket.isConnected()) this._rejoin();
            }
        },
        {
            /**
     * Registers a callback that will be executed when the channel closes.
     *
     * @internal
     */ key: "_onClose",
            value: function _onClose(callback) {
                this._on((0, $bc0d0f689a320ba6$export$8db7548e65d6ea55).close, {}, callback);
            }
        },
        {
            /**
     * Registers a callback that will be executed when the channel encounteres an error.
     *
     * @internal
     */ key: "_onError",
            value: function _onError(callback) {
                this._on((0, $bc0d0f689a320ba6$export$8db7548e65d6ea55).error, {}, function(reason) {
                    return callback(reason);
                });
            }
        },
        {
            /**
     * Returns `true` if the socket is connected and the channel has been joined.
     *
     * @internal
     */ key: "_canPush",
            value: function _canPush() {
                return this.socket.isConnected() && this._isJoined();
            }
        },
        {
            /** @internal */ key: "_rejoin",
            value: function _rejoin() {
                var timeout = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.timeout;
                if (this._isLeaving()) return;
                this.socket._leaveOpenTopic(this.topic);
                this.state = (0, $bc0d0f689a320ba6$export$b83816118db74fe7).joining;
                this.joinPush.resend(timeout);
            }
        },
        {
            /** @internal */ key: "_getPayloadRecords",
            value: function _getPayloadRecords(payload) {
                var records = {
                    "new": {},
                    old: {}
                };
                if (payload.type === 'INSERT' || payload.type === 'UPDATE') records["new"] = $06884f93312edc07$export$20ce708a1f594c5e(payload.columns, payload.record);
                if (payload.type === 'UPDATE' || payload.type === 'DELETE') records.old = $06884f93312edc07$export$20ce708a1f594c5e(payload.columns, payload.old_record);
                return records;
            }
        }
    ], [
        {
            key: "isEqual",
            value: /** @internal */ function isEqual(obj1, obj2) {
                if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;
                for(var k in obj1){
                    if (obj1[k] !== obj2[k]) return false;
                }
                return true;
            }
        }
    ]);
    return RealtimeChannel;
}();


var $d3a19c16dd3933b4$var$noop = function() {};
var $d3a19c16dd3933b4$var$NATIVE_WEBSOCKET_AVAILABLE = typeof WebSocket !== 'undefined';
var $d3a19c16dd3933b4$var$WORKER_SCRIPT = '\n  addEventListener("message", (e) => {\n    if (e.data.event === "start") {\n      setInterval(() => postMessage({ event: "keepAlive" }), e.data.interval);\n    }\n  });';


var $d3a19c16dd3933b4$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function RealtimeClient(endPoint, options) {
        (0, $50OuQ._)(this, RealtimeClient);
        var _this = this;
        var _a;
        this.accessTokenValue = null;
        this.apiKey = null;
        this.channels = [];
        this.endPoint = '';
        this.httpEndpoint = '';
        this.headers = (0, $bc0d0f689a320ba6$export$88a84136db6a4b64);
        this.params = {};
        this.timeout = (0, $bc0d0f689a320ba6$export$7bd623b29ec8e1eb);
        this.heartbeatIntervalMs = 30000;
        this.heartbeatTimer = undefined;
        this.pendingHeartbeatRef = null;
        this.ref = 0;
        this.logger = $d3a19c16dd3933b4$var$noop;
        this.conn = null;
        this.sendBuffer = [];
        this.serializer = new (0, $8ef4be980dd2d07e$export$2e2bcd8739ae039)();
        this.stateChangeCallbacks = {
            open: [],
            close: [],
            error: [],
            message: []
        };
        this.accessToken = null;
        /**
         * Use either custom fetch, if provided, or default fetch to make HTTP requests
         *
         * @internal
         */ this._resolveFetch = function(customFetch) {
            var _fetch;
            if (customFetch) _fetch = customFetch;
            else if (typeof fetch === 'undefined') _fetch = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return Promise.resolve((parcelRequire("TskBh"))).then(function(param) {
                    var _$fetch = param["default"];
                    return _$fetch.apply(void 0, (0, $dHvbf._)(args));
                });
            };
            else _fetch = fetch;
            return function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return _fetch.apply(void 0, (0, $dHvbf._)(args));
            };
        };
        this.endPoint = "".concat(endPoint, "/").concat((0, $bc0d0f689a320ba6$export$b2688bfb999f5751).websocket);
        this.httpEndpoint = (0, $06884f93312edc07$export$976fda7151b30cae)(endPoint);
        if (options === null || options === void 0 ? void 0 : options.transport) this.transport = options.transport;
        else this.transport = null;
        if (options === null || options === void 0 ? void 0 : options.params) this.params = options.params;
        if (options === null || options === void 0 ? void 0 : options.headers) this.headers = Object.assign(Object.assign({}, this.headers), options.headers);
        if (options === null || options === void 0 ? void 0 : options.timeout) this.timeout = options.timeout;
        if (options === null || options === void 0 ? void 0 : options.logger) this.logger = options.logger;
        if (options === null || options === void 0 ? void 0 : options.heartbeatIntervalMs) this.heartbeatIntervalMs = options.heartbeatIntervalMs;
        var accessTokenValue = (_a = options === null || options === void 0 ? void 0 : options.params) === null || _a === void 0 ? void 0 : _a.apikey;
        if (accessTokenValue) {
            this.accessTokenValue = accessTokenValue;
            this.apiKey = accessTokenValue;
        }
        this.reconnectAfterMs = (options === null || options === void 0 ? void 0 : options.reconnectAfterMs) ? options.reconnectAfterMs : function(tries) {
            return [
                1000,
                2000,
                5000,
                10000
            ][tries - 1] || 10000;
        };
        this.encode = (options === null || options === void 0 ? void 0 : options.encode) ? options.encode : function(payload, callback) {
            return callback(JSON.stringify(payload));
        };
        this.decode = (options === null || options === void 0 ? void 0 : options.decode) ? options.decode : this.serializer.decode.bind(this.serializer);
        this.reconnectTimer = new (0, $deb1520a2ba90aff$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $5Pgs2._)(function() {
            return (0, $1XfpH.__generator)(this, function(_state) {
                _this.disconnect();
                _this.connect();
                return [
                    2
                ];
            });
        }), this.reconnectAfterMs);
        this.fetch = this._resolveFetch(options === null || options === void 0 ? void 0 : options.fetch);
        if (options === null || options === void 0 ? void 0 : options.worker) {
            if (typeof window !== 'undefined' && !window.Worker) throw new Error('Web Worker is not supported');
            this.worker = (options === null || options === void 0 ? void 0 : options.worker) || false;
            this.workerUrl = options === null || options === void 0 ? void 0 : options.workerUrl;
        }
        this.accessToken = (options === null || options === void 0 ? void 0 : options.accessToken) || null;
    }
    (0, $fGdZr._)(RealtimeClient, [
        {
            /**
     * Connects the socket, unless already connected.
     */ key: "connect",
            value: function connect() {
                var _this = this;
                if (this.conn) return;
                if (this.transport) {
                    this.conn = new this.transport(this.endpointURL(), undefined, {
                        headers: this.headers
                    });
                    return;
                }
                if ($d3a19c16dd3933b4$var$NATIVE_WEBSOCKET_AVAILABLE) {
                    this.conn = new WebSocket(this.endpointURL());
                    this.setupConnection();
                    return;
                }
                this.conn = new $d3a19c16dd3933b4$var$WSWebSocketDummy(this.endpointURL(), undefined, {
                    close: function() {
                        _this.conn = null;
                    }
                });
                (parcelRequire("67Sz8")).then(function(param) {
                    var WS = param["default"];
                    _this.conn = new WS(_this.endpointURL(), undefined, {
                        headers: _this.headers
                    });
                    _this.setupConnection();
                });
            }
        },
        {
            /**
     * Returns the URL of the websocket.
     * @returns string The URL of the websocket.
     */ key: "endpointURL",
            value: function endpointURL() {
                return this._appendParams(this.endPoint, Object.assign({}, this.params, {
                    vsn: (0, $bc0d0f689a320ba6$export$df3f558bb9a9c991)
                }));
            }
        },
        {
            /**
     * Disconnects the socket.
     *
     * @param code A numeric status code to send on disconnect.
     * @param reason A custom reason for the disconnect.
     */ key: "disconnect",
            value: function disconnect(code, reason) {
                if (this.conn) {
                    this.conn.onclose = function() {}; // noop
                    if (code) this.conn.close(code, reason !== null && reason !== void 0 ? reason : '');
                    else this.conn.close();
                    this.conn = null;
                    // remove open handles
                    this.heartbeatTimer && clearInterval(this.heartbeatTimer);
                    this.reconnectTimer.reset();
                }
            }
        },
        {
            /**
     * Returns all created channels
     */ key: "getChannels",
            value: function getChannels() {
                return this.channels;
            }
        },
        {
            key: "removeChannel",
            value: /**
     * Unsubscribes and removes a single channel
     * @param channel A RealtimeChannel instance
     */ function removeChannel(channel) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var status;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    channel.unsubscribe()
                                ];
                            case 1:
                                status = _state.sent();
                                if (_this.channels.length === 0) _this.disconnect();
                                return [
                                    2,
                                    status
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "removeAllChannels",
            value: /**
     * Unsubscribes and removes all channels
     */ function removeAllChannels() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var values_1;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all(_this.channels.map(function(channel) {
                                        return channel.unsubscribe();
                                    }))
                                ];
                            case 1:
                                values_1 = _state.sent();
                                _this.disconnect();
                                return [
                                    2,
                                    values_1
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Logs the message.
     *
     * For customized logging, `this.logger` can be overridden.
     */ key: "log",
            value: function log(kind, msg, data) {
                this.logger(kind, msg, data);
            }
        },
        {
            /**
     * Returns the current state of the socket.
     */ key: "connectionState",
            value: function connectionState() {
                switch(this.conn && this.conn.readyState){
                    case (0, $bc0d0f689a320ba6$export$a6d0320a1563d49e).connecting:
                        return (0, $bc0d0f689a320ba6$export$deda39003d27273).Connecting;
                    case (0, $bc0d0f689a320ba6$export$a6d0320a1563d49e).open:
                        return (0, $bc0d0f689a320ba6$export$deda39003d27273).Open;
                    case (0, $bc0d0f689a320ba6$export$a6d0320a1563d49e).closing:
                        return (0, $bc0d0f689a320ba6$export$deda39003d27273).Closing;
                    default:
                        return (0, $bc0d0f689a320ba6$export$deda39003d27273).Closed;
                }
            }
        },
        {
            /**
     * Returns `true` is the connection is open.
     */ key: "isConnected",
            value: function isConnected() {
                return this.connectionState() === (0, $bc0d0f689a320ba6$export$deda39003d27273).Open;
            }
        },
        {
            key: "channel",
            value: function channel(topic) {
                var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                    config: {}
                };
                var chan = new (0, $6a8abcf604bb0be1$export$2e2bcd8739ae039)("realtime:".concat(topic), params, this);
                this.channels.push(chan);
                return chan;
            }
        },
        {
            /**
     * Push out a message if the socket is connected.
     *
     * If the socket is not connected, the message gets enqueued within a local buffer, and sent out when a connection is next established.
     */ key: "push",
            value: function push(data) {
                var _this = this;
                var topic = data.topic, event = data.event, payload = data.payload, ref = data.ref;
                var callback = function() {
                    _this.encode(data, function(result) {
                        var _a;
                        (_a = _this.conn) === null || _a === void 0 || _a.send(result);
                    });
                };
                this.log('push', "".concat(topic, " ").concat(event, " (").concat(ref, ")"), payload);
                if (this.isConnected()) callback();
                else this.sendBuffer.push(callback);
            }
        },
        {
            key: "setAuth",
            value: /**
     * Sets the JWT access token used for channel subscription authorization and Realtime RLS.
     *
     * If param is null it will use the `accessToken` callback function or the token set on the client.
     *
     * On callback used, it will set the value of the token internal to the client.
     *
     * @param token A JWT string to override the token set on the client.
     */ function setAuth() {
                var token = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var tokenToSend, _tmp, _tmp1, parsed, now, valid;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = token;
                                if (_tmp) return [
                                    3,
                                    3
                                ];
                                _tmp1 = _this.accessToken;
                                if (!_tmp1) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.accessToken()
                                ];
                            case 1:
                                _tmp1 = _state.sent();
                                _state.label = 2;
                            case 2:
                                _tmp = _tmp1;
                                _state.label = 3;
                            case 3:
                                tokenToSend = _tmp || _this.accessTokenValue;
                                if (tokenToSend) {
                                    parsed = null;
                                    try {
                                        parsed = JSON.parse(atob(tokenToSend.split('.')[1]));
                                    } catch (_error) {}
                                    if (parsed && parsed.exp) {
                                        now = Math.floor(Date.now() / 1000);
                                        valid = now - parsed.exp < 0;
                                        if (!valid) {
                                            _this.log('auth', 'InvalidJWTToken: Invalid value for JWT claim "exp" with value '.concat(parsed.exp));
                                            return [
                                                2,
                                                Promise.reject('InvalidJWTToken: Invalid value for JWT claim "exp" with value '.concat(parsed.exp))
                                            ];
                                        }
                                    }
                                    _this.accessTokenValue = tokenToSend;
                                    _this.channels.forEach(function(channel) {
                                        tokenToSend && channel.updateJoinPayload({
                                            access_token: tokenToSend
                                        });
                                        if (channel.joinedOnce && channel._isJoined()) channel._push((0, $bc0d0f689a320ba6$export$8db7548e65d6ea55).access_token, {
                                            access_token: tokenToSend
                                        });
                                    });
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "sendHeartbeat",
            value: /**
     * Sends a heartbeat message if the socket is connected.
     */ function sendHeartbeat() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _a;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        if (!_this.isConnected()) return [
                            2
                        ];
                        if (_this.pendingHeartbeatRef) {
                            _this.pendingHeartbeatRef = null;
                            _this.log('transport', 'heartbeat timeout. Attempting to re-establish connection');
                            (_a = _this.conn) === null || _a === void 0 || _a.close((0, $bc0d0f689a320ba6$export$5e80cf62e56a877b), 'hearbeat timeout');
                            return [
                                2
                            ];
                        }
                        _this.pendingHeartbeatRef = _this._makeRef();
                        _this.push({
                            topic: 'phoenix',
                            event: 'heartbeat',
                            payload: {},
                            ref: _this.pendingHeartbeatRef
                        });
                        _this.setAuth();
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            /**
     * Flushes send buffer
     */ key: "flushSendBuffer",
            value: function flushSendBuffer() {
                if (this.isConnected() && this.sendBuffer.length > 0) {
                    this.sendBuffer.forEach(function(callback) {
                        return callback();
                    });
                    this.sendBuffer = [];
                }
            }
        },
        {
            /**
     * Return the next message ref, accounting for overflows
     *
     * @internal
     */ key: "_makeRef",
            value: function _makeRef() {
                var newRef = this.ref + 1;
                if (newRef === this.ref) this.ref = 0;
                else this.ref = newRef;
                return this.ref.toString();
            }
        },
        {
            /**
     * Unsubscribe from channels with the specified topic.
     *
     * @internal
     */ key: "_leaveOpenTopic",
            value: function _leaveOpenTopic(topic) {
                var dupChannel = this.channels.find(function(c) {
                    return c.topic === topic && (c._isJoined() || c._isJoining());
                });
                if (dupChannel) {
                    this.log('transport', 'leaving duplicate topic "'.concat(topic, '"'));
                    dupChannel.unsubscribe();
                }
            }
        },
        {
            /**
     * Removes a subscription from the socket.
     *
     * @param channel An open subscription.
     *
     * @internal
     */ key: "_remove",
            value: function _remove(channel) {
                this.channels = this.channels.filter(function(c) {
                    return c._joinRef() !== channel._joinRef();
                });
            }
        },
        {
            /**
     * Sets up connection handlers.
     *
     * @internal
     */ key: "setupConnection",
            value: function setupConnection() {
                var _this = this;
                if (this.conn) {
                    this.conn.binaryType = 'arraybuffer';
                    this.conn.onopen = function() {
                        return _this._onConnOpen();
                    };
                    this.conn.onerror = function(error) {
                        return _this._onConnError(error);
                    };
                    this.conn.onmessage = function(event) {
                        return _this._onConnMessage(event);
                    };
                    this.conn.onclose = function(event) {
                        return _this._onConnClose(event);
                    };
                }
            }
        },
        {
            /** @internal */ key: "_onConnMessage",
            value: function _onConnMessage(rawMessage) {
                var _this = this;
                this.decode(rawMessage.data, function(msg) {
                    var topic = msg.topic, event = msg.event, payload = msg.payload, ref = msg.ref;
                    if (ref && ref === _this.pendingHeartbeatRef) _this.pendingHeartbeatRef = null;
                    _this.log('receive', "".concat(payload.status || '', " ").concat(topic, " ").concat(event, " ").concat(ref && '(' + ref + ')' || ''), payload);
                    _this.channels.filter(function(channel) {
                        return channel._isMember(topic);
                    }).forEach(function(channel) {
                        return channel._trigger(event, payload, ref);
                    });
                    _this.stateChangeCallbacks.message.forEach(function(callback) {
                        return callback(msg);
                    });
                });
            }
        },
        {
            key: "_onConnOpen",
            value: /** @internal */ function _onConnOpen() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var objectUrl;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        _this.log('transport', "connected to ".concat(_this.endpointURL()));
                        _this.flushSendBuffer();
                        _this.reconnectTimer.reset();
                        if (!_this.worker) {
                            _this.heartbeatTimer && clearInterval(_this.heartbeatTimer);
                            _this.heartbeatTimer = setInterval(function() {
                                return _this.sendHeartbeat();
                            }, _this.heartbeatIntervalMs);
                        } else {
                            if (_this.workerUrl) _this.log('worker', "starting worker for from ".concat(_this.workerUrl));
                            else _this.log('worker', "starting default worker");
                            objectUrl = _this._workerObjectUrl(_this.workerUrl);
                            _this.workerRef = new Worker(objectUrl);
                            _this.workerRef.onerror = function(error) {
                                _this.log('worker', 'worker error', error.message);
                                _this.workerRef.terminate();
                            };
                            _this.workerRef.onmessage = function(event) {
                                if (event.data.event === 'keepAlive') _this.sendHeartbeat();
                            };
                            _this.workerRef.postMessage({
                                event: 'start',
                                interval: _this.heartbeatIntervalMs
                            });
                        }
                        _this.stateChangeCallbacks.open.forEach(function(callback) {
                            return callback();
                        });
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            /** @internal */ key: "_onConnClose",
            value: function _onConnClose(event) {
                this.log('transport', 'close', event);
                this._triggerChanError();
                this.heartbeatTimer && clearInterval(this.heartbeatTimer);
                this.reconnectTimer.scheduleTimeout();
                this.stateChangeCallbacks.close.forEach(function(callback) {
                    return callback(event);
                });
            }
        },
        {
            /** @internal */ key: "_onConnError",
            value: function _onConnError(error) {
                this.log('transport', error.message);
                this._triggerChanError();
                this.stateChangeCallbacks.error.forEach(function(callback) {
                    return callback(error);
                });
            }
        },
        {
            /** @internal */ key: "_triggerChanError",
            value: function _triggerChanError() {
                this.channels.forEach(function(channel) {
                    return channel._trigger((0, $bc0d0f689a320ba6$export$8db7548e65d6ea55).error);
                });
            }
        },
        {
            /** @internal */ key: "_appendParams",
            value: function _appendParams(url, params) {
                if (Object.keys(params).length === 0) return url;
                var prefix = url.match(/\?/) ? '&' : '?';
                var query = new URLSearchParams(params);
                return "".concat(url).concat(prefix).concat(query);
            }
        },
        {
            key: "_workerObjectUrl",
            value: function _workerObjectUrl(url) {
                var result_url;
                if (url) result_url = url;
                else {
                    var blob = new Blob([
                        $d3a19c16dd3933b4$var$WORKER_SCRIPT
                    ], {
                        type: 'application/javascript'
                    });
                    result_url = URL.createObjectURL(blob);
                }
                return result_url;
            }
        }
    ]);
    return RealtimeClient;
}();
var $d3a19c16dd3933b4$var$WSWebSocketDummy = function WSWebSocketDummy(address, _protocols, options) {
    "use strict";
    (0, $50OuQ._)(this, WSWebSocketDummy);
    this.binaryType = 'arraybuffer';
    this.onclose = function() {};
    this.onerror = function() {};
    this.onmessage = function() {};
    this.onopen = function() {};
    this.readyState = (0, $bc0d0f689a320ba6$export$a6d0320a1563d49e).connecting;
    this.send = function() {};
    this.url = null;
    this.url = address;
    this.close = options.close;
};







var $huFCX = parcelRequire("huFCX");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $1atwj = parcelRequire("1atwj");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $1XfpH = parcelRequire("1XfpH");

var $huFCX = parcelRequire("huFCX");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $1atwj = parcelRequire("1atwj");

var $qb7pP = parcelRequire("qb7pP");

var $jc6v0 = parcelRequire("jc6v0");
var $fba3590508ee8418$export$697502632950e9d3 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $1atwj._)(StorageError, Error1);
    function StorageError(message) {
        (0, $50OuQ._)(this, StorageError);
        var _this;
        _this = (0, $huFCX._)(this, StorageError, [
            message
        ]);
        _this.__isStorageError = true;
        _this.name = 'StorageError';
        return _this;
    }
    return StorageError;
}((0, $jc6v0._)(Error));
function $fba3590508ee8418$export$5a322e77e5eb0561(error) {
    return (typeof error === "undefined" ? "undefined" : (0, $qb7pP._)(error)) === 'object' && error !== null && '__isStorageError' in error;
}
var $fba3590508ee8418$export$ca9ecfd959b3871c = /*#__PURE__*/ function(StorageError) {
    "use strict";
    (0, $1atwj._)(StorageApiError, StorageError);
    function StorageApiError(message, status) {
        (0, $50OuQ._)(this, StorageApiError);
        var _this;
        _this = (0, $huFCX._)(this, StorageApiError, [
            message
        ]);
        _this.name = 'StorageApiError';
        _this.status = status;
        return _this;
    }
    (0, $fGdZr._)(StorageApiError, [
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    name: this.name,
                    message: this.message,
                    status: this.status
                };
            }
        }
    ]);
    return StorageApiError;
}($fba3590508ee8418$export$697502632950e9d3);
var $fba3590508ee8418$export$29127ca2e1a271d = /*#__PURE__*/ function(StorageError) {
    "use strict";
    (0, $1atwj._)(StorageUnknownError, StorageError);
    function StorageUnknownError(message, originalError) {
        (0, $50OuQ._)(this, StorageUnknownError);
        var _this;
        _this = (0, $huFCX._)(this, StorageUnknownError, [
            message
        ]);
        _this.name = 'StorageUnknownError';
        _this.originalError = originalError;
        return _this;
    }
    return StorageUnknownError;
}($fba3590508ee8418$export$697502632950e9d3);



var $1XfpH = parcelRequire("1XfpH");


var $aSMts = parcelRequire("aSMts");

var $dHvbf = parcelRequire("dHvbf");

var $1XfpH = parcelRequire("1XfpH");
var $e4f6ae0adce48a92$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

var $e4f6ae0adce48a92$export$98d92b1aa79f8cc7 = function(customFetch) {
    var _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return Promise.resolve((parcelRequire("TskBh"))).then(function(param) {
            var _$fetch = param["default"];
            return _$fetch.apply(void 0, (0, $dHvbf._)(args));
        });
    };
    else _fetch = fetch;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return _fetch.apply(void 0, (0, $dHvbf._)(args));
    };
};

var $e4f6ae0adce48a92$export$ace1d6afc438cf26 = function() {
    return $e4f6ae0adce48a92$var$__awaiter(void 0, void 0, void 0, function() {
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(typeof Response === 'undefined')) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        Promise.resolve((parcelRequire("TskBh")))
                    ];
                case 1:
                    // @ts-ignore
                    return [
                        2,
                        _state.sent().Response
                    ];
                case 2:
                    return [
                        2,
                        Response
                    ];
            }
        });
    });
};
var $e4f6ae0adce48a92$export$69d519e35e6fc3d4 = function(item) {
    if (Array.isArray(item)) return item.map(function(el) {
        return $e4f6ae0adce48a92$export$69d519e35e6fc3d4(el);
    });
    else if (typeof item === 'function' || item !== Object(item)) return item;
    var result = {};
    Object.entries(item).forEach(function(param) {
        var _param = (0, $aSMts._)(param, 2), key = _param[0], value = _param[1];
        var newKey = key.replace(/([-_][a-z])/gi, function(c) {
            return c.toUpperCase().replace(/[-_]/g, '');
        });
        result[newKey] = $e4f6ae0adce48a92$export$69d519e35e6fc3d4(value);
    });
    return result;
};


var $6be874a2ed33584f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6be874a2ed33584f$var$_getErrorMessage = function(err) {
    return err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
};
var $6be874a2ed33584f$var$handleError = function(error, reject, options) {
    return $6be874a2ed33584f$var$__awaiter(void 0, void 0, void 0, function() {
        var Res;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $e4f6ae0adce48a92$export$ace1d6afc438cf26)()
                    ];
                case 1:
                    Res = _state.sent();
                    if (error instanceof Res && !(options === null || options === void 0 ? void 0 : options.noResolveJson)) error.json().then(function(err) {
                        reject(new (0, $fba3590508ee8418$export$ca9ecfd959b3871c)($6be874a2ed33584f$var$_getErrorMessage(err), error.status || 500));
                    })["catch"](function(err) {
                        reject(new (0, $fba3590508ee8418$export$29127ca2e1a271d)($6be874a2ed33584f$var$_getErrorMessage(err), err));
                    });
                    else reject(new (0, $fba3590508ee8418$export$29127ca2e1a271d)($6be874a2ed33584f$var$_getErrorMessage(error), error));
                    return [
                        2
                    ];
            }
        });
    });
};
var $6be874a2ed33584f$var$_getRequestParams = function(method, options, parameters, body) {
    var params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === 'GET') return params;
    params.headers = Object.assign({
        'Content-Type': 'application/json'
    }, options === null || options === void 0 ? void 0 : options.headers);
    if (body) params.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params), parameters);
};
function $6be874a2ed33584f$var$_handleRequest(fetcher, method, url, options, parameters, body) {
    return $6be874a2ed33584f$var$__awaiter(this, void 0, void 0, function() {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve, reject) {
                    fetcher(url, $6be874a2ed33584f$var$_getRequestParams(method, options, parameters, body)).then(function(result) {
                        if (!result.ok) throw result;
                        if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
                        return result.json();
                    }).then(function(data) {
                        return resolve(data);
                    })["catch"](function(error) {
                        return $6be874a2ed33584f$var$handleError(error, reject, options);
                    });
                })
            ];
        });
    });
}
function $6be874a2ed33584f$export$3988ae62b71be9a3(fetcher, url, options, parameters) {
    return $6be874a2ed33584f$var$__awaiter(this, void 0, void 0, function() {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $6be874a2ed33584f$var$_handleRequest(fetcher, 'GET', url, options, parameters)
            ];
        });
    });
}
function $6be874a2ed33584f$export$299ba2dee77727e9(fetcher, url, body, options, parameters) {
    return $6be874a2ed33584f$var$__awaiter(this, void 0, void 0, function() {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $6be874a2ed33584f$var$_handleRequest(fetcher, 'POST', url, options, parameters, body)
            ];
        });
    });
}
function $6be874a2ed33584f$export$327f7b26ebf455db(fetcher, url, body, options, parameters) {
    return $6be874a2ed33584f$var$__awaiter(this, void 0, void 0, function() {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $6be874a2ed33584f$var$_handleRequest(fetcher, 'PUT', url, options, parameters, body)
            ];
        });
    });
}
function $6be874a2ed33584f$export$5fd5031fecdacec3(fetcher, url, options, parameters) {
    return $6be874a2ed33584f$var$__awaiter(this, void 0, void 0, function() {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $6be874a2ed33584f$var$_handleRequest(fetcher, 'HEAD', url, Object.assign(Object.assign({}, options), {
                    noResolveJson: true
                }), parameters)
            ];
        });
    });
}
function $6be874a2ed33584f$export$cd7f480d6b8286c3(fetcher, url, body, options, parameters) {
    return $6be874a2ed33584f$var$__awaiter(this, void 0, void 0, function() {
        return (0, $1XfpH.__generator)(this, function(_state) {
            return [
                2,
                $6be874a2ed33584f$var$_handleRequest(fetcher, 'DELETE', url, options, parameters, body)
            ];
        });
    });
}




var $dSRbH = parcelRequire("dSRbH");
var $08a18fd652a244ca$require$Buffer = $dSRbH.Buffer;
var $08a18fd652a244ca$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $08a18fd652a244ca$var$DEFAULT_SEARCH_OPTIONS = {
    limit: 100,
    offset: 0,
    sortBy: {
        column: 'name',
        order: 'asc'
    }
};
var $08a18fd652a244ca$var$DEFAULT_FILE_OPTIONS = {
    cacheControl: '3600',
    contentType: 'text/plain;charset=UTF-8',
    upsert: false
};
var $08a18fd652a244ca$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function StorageFileApi(url) {
        var headers = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, bucketId = arguments.length > 2 ? arguments[2] : void 0, fetch = arguments.length > 3 ? arguments[3] : void 0;
        (0, $50OuQ._)(this, StorageFileApi);
        this.url = url;
        this.headers = headers;
        this.bucketId = bucketId;
        this.fetch = (0, $e4f6ae0adce48a92$export$98d92b1aa79f8cc7)(fetch);
    }
    (0, $fGdZr._)(StorageFileApi, [
        {
            /**
     * Uploads a file to an existing bucket or replaces an existing file at the specified path with a new one.
     *
     * @param method HTTP method.
     * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param fileBody The body of the file to be stored in the bucket.
     */ key: "uploadOrUpdate",
            value: function uploadOrUpdate(method, path, fileBody, fileOptions) {
                return $08a18fd652a244ca$var$__awaiter(this, void 0, void 0, function() {
                    var body, options, headers, metadata, cleanPath, _path, res, data, _$error, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    3,
                                    ,
                                    4
                                ]);
                                options = Object.assign(Object.assign({}, $08a18fd652a244ca$var$DEFAULT_FILE_OPTIONS), fileOptions);
                                headers = Object.assign(Object.assign({}, this.headers), method === 'POST' && {
                                    'x-upsert': String(options.upsert)
                                });
                                metadata = options.metadata;
                                if (typeof Blob !== 'undefined' && fileBody instanceof Blob) {
                                    body = new FormData();
                                    body.append('cacheControl', options.cacheControl);
                                    if (metadata) body.append('metadata', this.encodeMetadata(metadata));
                                    body.append('', fileBody);
                                } else if (typeof FormData !== 'undefined' && fileBody instanceof FormData) {
                                    body = fileBody;
                                    body.append('cacheControl', options.cacheControl);
                                    if (metadata) body.append('metadata', this.encodeMetadata(metadata));
                                } else {
                                    body = fileBody;
                                    headers['cache-control'] = "max-age=".concat(options.cacheControl);
                                    headers['content-type'] = options.contentType;
                                    if (metadata) headers['x-metadata'] = this.toBase64(this.encodeMetadata(metadata));
                                }
                                if (fileOptions === null || fileOptions === void 0 ? void 0 : fileOptions.headers) headers = Object.assign(Object.assign({}, headers), fileOptions.headers);
                                cleanPath = this._removeEmptyFolders(path);
                                _path = this._getFinalPath(cleanPath);
                                return [
                                    4,
                                    this.fetch("".concat(this.url, "/object/").concat(_path), Object.assign({
                                        method: method,
                                        body: body,
                                        headers: headers
                                    }, (options === null || options === void 0 ? void 0 : options.duplex) ? {
                                        duplex: options.duplex
                                    } : {}))
                                ];
                            case 1:
                                res = _state.sent();
                                return [
                                    4,
                                    res.json()
                                ];
                            case 2:
                                data = _state.sent();
                                if (res.ok) return [
                                    2,
                                    {
                                        data: {
                                            path: cleanPath,
                                            id: data.Id,
                                            fullPath: data.Key
                                        },
                                        error: null
                                    }
                                ];
                                else {
                                    _$error = data;
                                    return [
                                        2,
                                        {
                                            data: null,
                                            error: _$error
                                        }
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                if ((0, $fba3590508ee8418$export$5a322e77e5eb0561)(error)) return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                                throw error;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Uploads a file to an existing bucket.
     *
     * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param fileBody The body of the file to be stored in the bucket.
     */ key: "upload",
            value: function upload(path, fileBody, fileOptions) {
                return $08a18fd652a244ca$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        return [
                            2,
                            this.uploadOrUpdate('POST', path, fileBody, fileOptions)
                        ];
                    });
                });
            }
        },
        {
            /**
     * Upload a file with a token generated from `createSignedUploadUrl`.
     * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param token The token generated from `createSignedUploadUrl`
     * @param fileBody The body of the file to be stored in the bucket.
     */ key: "uploadToSignedUrl",
            value: function uploadToSignedUrl(path, token, fileBody, fileOptions) {
                return $08a18fd652a244ca$var$__awaiter(this, void 0, void 0, function() {
                    var cleanPath, _path, url, body, options, headers, res, data, _$error, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                cleanPath = this._removeEmptyFolders(path);
                                _path = this._getFinalPath(cleanPath);
                                url = new URL(this.url + "/object/upload/sign/".concat(_path));
                                url.searchParams.set('token', token);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                options = Object.assign({
                                    upsert: $08a18fd652a244ca$var$DEFAULT_FILE_OPTIONS.upsert
                                }, fileOptions);
                                headers = Object.assign(Object.assign({}, this.headers), {
                                    'x-upsert': String(options.upsert)
                                });
                                if (typeof Blob !== 'undefined' && fileBody instanceof Blob) {
                                    body = new FormData();
                                    body.append('cacheControl', options.cacheControl);
                                    body.append('', fileBody);
                                } else if (typeof FormData !== 'undefined' && fileBody instanceof FormData) {
                                    body = fileBody;
                                    body.append('cacheControl', options.cacheControl);
                                } else {
                                    body = fileBody;
                                    headers['cache-control'] = "max-age=".concat(options.cacheControl);
                                    headers['content-type'] = options.contentType;
                                }
                                return [
                                    4,
                                    this.fetch(url.toString(), {
                                        method: 'PUT',
                                        body: body,
                                        headers: headers
                                    })
                                ];
                            case 2:
                                res = _state.sent();
                                return [
                                    4,
                                    res.json()
                                ];
                            case 3:
                                data = _state.sent();
                                if (res.ok) return [
                                    2,
                                    {
                                        data: {
                                            path: cleanPath,
                                            fullPath: data.Key
                                        },
                                        error: null
                                    }
                                ];
                                else {
                                    _$error = data;
                                    return [
                                        2,
                                        {
                                            data: null,
                                            error: _$error
                                        }
                                    ];
                                }
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                error = _state.sent();
                                if ((0, $fba3590508ee8418$export$5a322e77e5eb0561)(error)) return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                                throw error;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Creates a signed upload URL.
     * Signed upload URLs can be used to upload files to the bucket without further authentication.
     * They are valid for 2 hours.
     * @param path The file path, including the current file name. For example `folder/image.png`.
     * @param options.upsert If set to true, allows the file to be overwritten if it already exists.
     */ key: "createSignedUploadUrl",
            value: function createSignedUploadUrl(path, options) {
                return $08a18fd652a244ca$var$__awaiter(this, void 0, void 0, function() {
                    var _path, headers, data, url, token, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _path = this._getFinalPath(path);
                                headers = Object.assign({}, this.headers);
                                if (options === null || options === void 0 ? void 0 : options.upsert) headers['x-upsert'] = 'true';
                                return [
                                    4,
                                    (0, $6be874a2ed33584f$export$299ba2dee77727e9)(this.fetch, "".concat(this.url, "/object/upload/sign/").concat(_path), {}, {
                                        headers: headers
                                    })
                                ];
                            case 1:
                                data = _state.sent();
                                url = new URL(this.url + data.url);
                                token = url.searchParams.get('token');
                                if (!token) throw new (0, $fba3590508ee8418$export$697502632950e9d3)('No token returned by API');
                                return [
                                    2,
                                    {
                                        data: {
                                            signedUrl: url.toString(),
                                            path: path,
                                            token: token
                                        },
                                        error: null
                                    }
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $fba3590508ee8418$export$5a322e77e5eb0561)(error)) return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Replaces an existing file at the specified path with a new one.
     *
     * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to update.
     * @param fileBody The body of the file to be stored in the bucket.
     */ key: "update",
            value: function update(path, fileBody, fileOptions) {
                return $08a18fd652a244ca$var$__awaiter(this, void 0, void 0, function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        return [
                            2,
                            this.uploadOrUpdate('PUT', path, fileBody, fileOptions)
                        ];
                    });
                });
            }
        },
        {
            /**
     * Moves an existing file to a new path in the same bucket.
     *
     * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
     * @param toPath The new file path, including the new file name. For example `folder/image-new.png`.
     * @param options The destination options.
     */ key: "move",
            value: function move(fromPath, toPath, options) {
                return $08a18fd652a244ca$var$__awaiter(this, void 0, void 0, function() {
                    var data, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0, $6be874a2ed33584f$export$299ba2dee77727e9)(this.fetch, "".concat(this.url, "/object/move"), {
                                        bucketId: this.bucketId,
                                        sourceKey: fromPath,
                                        destinationKey: toPath,
                                        destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
                                    }, {
                                        headers: this.headers
                                    })
                                ];
                            case 1:
                                data = _state.sent();
                                return [
                                    2,
                                    {
                                        data: data,
                                        error: null
                                    }
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $fba3590508ee8418$export$5a322e77e5eb0561)(error)) return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Copies an existing file to a new path in the same bucket.
     *
     * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
     * @param toPath The new file path, including the new file name. For example `folder/image-copy.png`.
     * @param options The destination options.
     */ key: "copy",
            value: function copy(fromPath, toPath, options) {
                return $08a18fd652a244ca$var$__awaiter(this, void 0, void 0, function() {
                    var data, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0, $6be874a2ed33584f$export$299ba2dee77727e9)(this.fetch, "".concat(this.url, "/object/copy"), {
                                        bucketId: this.bucketId,
                                        sourceKey: fromPath,
                                        destinationKey: toPath,
                                        destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
                                    }, {
                                        headers: this.headers
                                    })
                                ];
                            case 1:
                                data = _state.sent();
                                return [
                                    2,
                                    {
                                        data: {
                                            path: data.Key
                                        },
                                        error: null
                                    }
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $fba3590508ee8418$export$5a322e77e5eb0561)(error)) return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Creates a signed URL. Use a signed URL to share a file for a fixed amount of time.
     *
     * @param path The file path, including the current file name. For example `folder/image.png`.
     * @param expiresIn The number of seconds until the signed URL expires. For example, `60` for a URL which is valid for one minute.
     * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     * @param options.transform Transform the asset before serving it to the client.
     */ key: "createSignedUrl",
            value: function createSignedUrl(path, expiresIn, options) {
                return $08a18fd652a244ca$var$__awaiter(this, void 0, void 0, function() {
                    var _path, data, downloadQueryParam, signedUrl, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _path = this._getFinalPath(path);
                                return [
                                    4,
                                    (0, $6be874a2ed33584f$export$299ba2dee77727e9)(this.fetch, "".concat(this.url, "/object/sign/").concat(_path), Object.assign({
                                        expiresIn: expiresIn
                                    }, (options === null || options === void 0 ? void 0 : options.transform) ? {
                                        transform: options.transform
                                    } : {}), {
                                        headers: this.headers
                                    })
                                ];
                            case 1:
                                data = _state.sent();
                                downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? "&download=".concat(options.download === true ? '' : options.download) : '';
                                signedUrl = encodeURI("".concat(this.url).concat(data.signedURL).concat(downloadQueryParam));
                                data = {
                                    signedUrl: signedUrl
                                };
                                return [
                                    2,
                                    {
                                        data: data,
                                        error: null
                                    }
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $fba3590508ee8418$export$5a322e77e5eb0561)(error)) return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Creates multiple signed URLs. Use a signed URL to share a file for a fixed amount of time.
     *
     * @param paths The file paths to be downloaded, including the current file names. For example `['folder/image.png', 'folder2/image2.png']`.
     * @param expiresIn The number of seconds until the signed URLs expire. For example, `60` for URLs which are valid for one minute.
     * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     */ key: "createSignedUrls",
            value: function createSignedUrls(paths, expiresIn, options) {
                return $08a18fd652a244ca$var$__awaiter(this, void 0, void 0, function() {
                    var _this, data, downloadQueryParam, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    (0, $6be874a2ed33584f$export$299ba2dee77727e9)(this.fetch, "".concat(this.url, "/object/sign/").concat(this.bucketId), {
                                        expiresIn: expiresIn,
                                        paths: paths
                                    }, {
                                        headers: this.headers
                                    })
                                ];
                            case 2:
                                data = _state.sent();
                                downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? "&download=".concat(options.download === true ? '' : options.download) : '';
                                return [
                                    2,
                                    {
                                        data: data.map(function(datum) {
                                            return Object.assign(Object.assign({}, datum), {
                                                signedUrl: datum.signedURL ? encodeURI("".concat(_this.url).concat(datum.signedURL).concat(downloadQueryParam)) : null
                                            });
                                        }),
                                        error: null
                                    }
                                ];
                            case 3:
                                error = _state.sent();
                                if ((0, $fba3590508ee8418$export$5a322e77e5eb0561)(error)) return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                                throw error;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Downloads a file from a private bucket. For public buckets, make a request to the URL returned from `getPublicUrl` instead.
     *
     * @param path The full path and file name of the file to be downloaded. For example `folder/image.png`.
     * @param options.transform Transform the asset before serving it to the client.
     */ key: "download",
            value: function download(path, options) {
                return $08a18fd652a244ca$var$__awaiter(this, void 0, void 0, function() {
                    var wantsTransformation, renderPath, transformationQuery, queryString, _path, res, data, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                wantsTransformation = typeof (options === null || options === void 0 ? void 0 : options.transform) !== 'undefined';
                                renderPath = wantsTransformation ? 'render/image/authenticated' : 'object';
                                transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
                                queryString = transformationQuery ? "?".concat(transformationQuery) : '';
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                _path = this._getFinalPath(path);
                                return [
                                    4,
                                    (0, $6be874a2ed33584f$export$3988ae62b71be9a3)(this.fetch, "".concat(this.url, "/").concat(renderPath, "/").concat(_path).concat(queryString), {
                                        headers: this.headers,
                                        noResolveJson: true
                                    })
                                ];
                            case 2:
                                res = _state.sent();
                                return [
                                    4,
                                    res.blob()
                                ];
                            case 3:
                                data = _state.sent();
                                return [
                                    2,
                                    {
                                        data: data,
                                        error: null
                                    }
                                ];
                            case 4:
                                error = _state.sent();
                                if ((0, $fba3590508ee8418$export$5a322e77e5eb0561)(error)) return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                                throw error;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Retrieves the details of an existing file.
     * @param path
     */ key: "info",
            value: function info(path) {
                return $08a18fd652a244ca$var$__awaiter(this, void 0, void 0, function() {
                    var _path, data, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _path = this._getFinalPath(path);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    (0, $6be874a2ed33584f$export$3988ae62b71be9a3)(this.fetch, "".concat(this.url, "/object/info/").concat(_path), {
                                        headers: this.headers
                                    })
                                ];
                            case 2:
                                data = _state.sent();
                                return [
                                    2,
                                    {
                                        data: (0, $e4f6ae0adce48a92$export$69d519e35e6fc3d4)(data),
                                        error: null
                                    }
                                ];
                            case 3:
                                error = _state.sent();
                                if ((0, $fba3590508ee8418$export$5a322e77e5eb0561)(error)) return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                                throw error;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Checks the existence of a file.
     * @param path
     */ key: "exists",
            value: function exists(path) {
                return $08a18fd652a244ca$var$__awaiter(this, void 0, void 0, function() {
                    var _path, error, originalError;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _path = this._getFinalPath(path);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    (0, $6be874a2ed33584f$export$5fd5031fecdacec3)(this.fetch, "".concat(this.url, "/object/").concat(_path), {
                                        headers: this.headers
                                    })
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2,
                                    {
                                        data: true,
                                        error: null
                                    }
                                ];
                            case 3:
                                error = _state.sent();
                                if ((0, $fba3590508ee8418$export$5a322e77e5eb0561)(error) && error instanceof (0, $fba3590508ee8418$export$29127ca2e1a271d)) {
                                    originalError = error.originalError;
                                    if ([
                                        400,
                                        404
                                    ].includes(originalError === null || originalError === void 0 ? void 0 : originalError.status)) return [
                                        2,
                                        {
                                            data: false,
                                            error: error
                                        }
                                    ];
                                }
                                throw error;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * A simple convenience function to get the URL for an asset in a public bucket. If you do not want to use this function, you can construct the public URL by concatenating the bucket URL with the path to the asset.
     * This function does not verify if the bucket is public. If a public URL is created for a bucket which is not public, you will not be able to download the asset.
     *
     * @param path The path and name of the file to generate the public URL for. For example `folder/image.png`.
     * @param options.download Triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     * @param options.transform Transform the asset before serving it to the client.
     */ key: "getPublicUrl",
            value: function getPublicUrl(path, options) {
                var _path = this._getFinalPath(path);
                var _queryString = [];
                var downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? "download=".concat(options.download === true ? '' : options.download) : '';
                if (downloadQueryParam !== '') _queryString.push(downloadQueryParam);
                var wantsTransformation = typeof (options === null || options === void 0 ? void 0 : options.transform) !== 'undefined';
                var renderPath = wantsTransformation ? 'render/image' : 'object';
                var transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
                if (transformationQuery !== '') _queryString.push(transformationQuery);
                var queryString = _queryString.join('&');
                if (queryString !== '') queryString = "?".concat(queryString);
                return {
                    data: {
                        publicUrl: encodeURI("".concat(this.url, "/").concat(renderPath, "/public/").concat(_path).concat(queryString))
                    }
                };
            }
        },
        {
            /**
     * Deletes files within the same bucket
     *
     * @param paths An array of files to delete, including the path and file name. For example [`'folder/image.png'`].
     */ key: "remove",
            value: function remove1(paths) {
                return $08a18fd652a244ca$var$__awaiter(this, void 0, void 0, function() {
                    var data, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0, $6be874a2ed33584f$export$cd7f480d6b8286c3)(this.fetch, "".concat(this.url, "/object/").concat(this.bucketId), {
                                        prefixes: paths
                                    }, {
                                        headers: this.headers
                                    })
                                ];
                            case 1:
                                data = _state.sent();
                                return [
                                    2,
                                    {
                                        data: data,
                                        error: null
                                    }
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $fba3590508ee8418$export$5a322e77e5eb0561)(error)) return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Get file metadata
     * @param id the file id to retrieve metadata
     */ // async getMetadata(
            //   id: string
            // ): Promise<
            //   | {
            //       data: Metadata
            //       error: null
            //     }
            //   | {
            //       data: null
            //       error: StorageError
            //     }
            // > {
            //   try {
            //     const data = await get(this.fetch, `${this.url}/metadata/${id}`, { headers: this.headers })
            //     return { data, error: null }
            //   } catch (error) {
            //     if (isStorageError(error)) {
            //       return { data: null, error }
            //     }
            //     throw error
            //   }
            // }
            /**
     * Update file metadata
     * @param id the file id to update metadata
     * @param meta the new file metadata
     */ // async updateMetadata(
            //   id: string,
            //   meta: Metadata
            // ): Promise<
            //   | {
            //       data: Metadata
            //       error: null
            //     }
            //   | {
            //       data: null
            //       error: StorageError
            //     }
            // > {
            //   try {
            //     const data = await post(
            //       this.fetch,
            //       `${this.url}/metadata/${id}`,
            //       { ...meta },
            //       { headers: this.headers }
            //     )
            //     return { data, error: null }
            //   } catch (error) {
            //     if (isStorageError(error)) {
            //       return { data: null, error }
            //     }
            //     throw error
            //   }
            // }
            /**
     * Lists all the files within a bucket.
     * @param path The folder path.
     */ key: "list",
            value: function list(path, options, parameters) {
                return $08a18fd652a244ca$var$__awaiter(this, void 0, void 0, function() {
                    var body, data, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                body = Object.assign(Object.assign(Object.assign({}, $08a18fd652a244ca$var$DEFAULT_SEARCH_OPTIONS), options), {
                                    prefix: path || ''
                                });
                                return [
                                    4,
                                    (0, $6be874a2ed33584f$export$299ba2dee77727e9)(this.fetch, "".concat(this.url, "/object/list/").concat(this.bucketId), body, {
                                        headers: this.headers
                                    }, parameters)
                                ];
                            case 1:
                                data = _state.sent();
                                return [
                                    2,
                                    {
                                        data: data,
                                        error: null
                                    }
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $fba3590508ee8418$export$5a322e77e5eb0561)(error)) return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "encodeMetadata",
            value: function encodeMetadata(metadata) {
                return JSON.stringify(metadata);
            }
        },
        {
            key: "toBase64",
            value: function toBase64(data) {
                if (typeof $08a18fd652a244ca$require$Buffer !== 'undefined') return $08a18fd652a244ca$require$Buffer.from(data).toString('base64');
                return btoa(data);
            }
        },
        {
            key: "_getFinalPath",
            value: function _getFinalPath(path) {
                return "".concat(this.bucketId, "/").concat(path);
            }
        },
        {
            key: "_removeEmptyFolders",
            value: function _removeEmptyFolders(path) {
                return path.replace(/^\/|\/$/g, '').replace(/\/+/g, '/');
            }
        },
        {
            key: "transformOptsToQueryString",
            value: function transformOptsToQueryString(transform) {
                var params = [];
                if (transform.width) params.push("width=".concat(transform.width));
                if (transform.height) params.push("height=".concat(transform.height));
                if (transform.resize) params.push("resize=".concat(transform.resize));
                if (transform.format) params.push("format=".concat(transform.format));
                if (transform.quality) params.push("quality=".concat(transform.quality));
                return params.join('&');
            }
        }
    ]);
    return StorageFileApi;
}();



var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $1XfpH = parcelRequire("1XfpH");
// generated by genversion
var $9fd71e672d139c8a$export$83d89fbfd8236492 = '2.7.1';


var $f4cb64f2563d6f57$export$88a84136db6a4b64 = {
    'X-Client-Info': "storage-js/".concat((0, $9fd71e672d139c8a$export$83d89fbfd8236492))
};





var $85a47a9dbcbbdd77$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $85a47a9dbcbbdd77$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function StorageBucketApi(url) {
        var headers = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, fetch = arguments.length > 2 ? arguments[2] : void 0;
        (0, $50OuQ._)(this, StorageBucketApi);
        this.url = url;
        this.headers = Object.assign(Object.assign({}, (0, $f4cb64f2563d6f57$export$88a84136db6a4b64)), headers);
        this.fetch = (0, $e4f6ae0adce48a92$export$98d92b1aa79f8cc7)(fetch);
    }
    (0, $fGdZr._)(StorageBucketApi, [
        {
            /**
     * Retrieves the details of all Storage buckets within an existing project.
     */ key: "listBuckets",
            value: function listBuckets() {
                return $85a47a9dbcbbdd77$var$__awaiter(this, void 0, void 0, function() {
                    var data, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0, $6be874a2ed33584f$export$3988ae62b71be9a3)(this.fetch, "".concat(this.url, "/bucket"), {
                                        headers: this.headers
                                    })
                                ];
                            case 1:
                                data = _state.sent();
                                return [
                                    2,
                                    {
                                        data: data,
                                        error: null
                                    }
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $fba3590508ee8418$export$5a322e77e5eb0561)(error)) return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Retrieves the details of an existing Storage bucket.
     *
     * @param id The unique identifier of the bucket you would like to retrieve.
     */ key: "getBucket",
            value: function getBucket(id) {
                return $85a47a9dbcbbdd77$var$__awaiter(this, void 0, void 0, function() {
                    var data, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0, $6be874a2ed33584f$export$3988ae62b71be9a3)(this.fetch, "".concat(this.url, "/bucket/").concat(id), {
                                        headers: this.headers
                                    })
                                ];
                            case 1:
                                data = _state.sent();
                                return [
                                    2,
                                    {
                                        data: data,
                                        error: null
                                    }
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $fba3590508ee8418$export$5a322e77e5eb0561)(error)) return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Creates a new Storage bucket
     *
     * @param id A unique identifier for the bucket you are creating.
     * @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations. By default, buckets are private.
     * @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
     * The global file size limit takes precedence over this value.
     * The default value is null, which doesn't set a per bucket file size limit.
     * @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
     * The default value is null, which allows files with all mime types to be uploaded.
     * Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
     * @returns newly created bucket id
     */ key: "createBucket",
            value: function createBucket(id) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                    public: false
                };
                return $85a47a9dbcbbdd77$var$__awaiter(this, void 0, void 0, function() {
                    var data, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0, $6be874a2ed33584f$export$299ba2dee77727e9)(this.fetch, "".concat(this.url, "/bucket"), {
                                        id: id,
                                        name: id,
                                        public: options["public"],
                                        file_size_limit: options.fileSizeLimit,
                                        allowed_mime_types: options.allowedMimeTypes
                                    }, {
                                        headers: this.headers
                                    })
                                ];
                            case 1:
                                data = _state.sent();
                                return [
                                    2,
                                    {
                                        data: data,
                                        error: null
                                    }
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $fba3590508ee8418$export$5a322e77e5eb0561)(error)) return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Updates a Storage bucket
     *
     * @param id A unique identifier for the bucket you are updating.
     * @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations.
     * @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
     * The global file size limit takes precedence over this value.
     * The default value is null, which doesn't set a per bucket file size limit.
     * @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
     * The default value is null, which allows files with all mime types to be uploaded.
     * Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
     */ key: "updateBucket",
            value: function updateBucket(id, options) {
                return $85a47a9dbcbbdd77$var$__awaiter(this, void 0, void 0, function() {
                    var data, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0, $6be874a2ed33584f$export$327f7b26ebf455db)(this.fetch, "".concat(this.url, "/bucket/").concat(id), {
                                        id: id,
                                        name: id,
                                        public: options["public"],
                                        file_size_limit: options.fileSizeLimit,
                                        allowed_mime_types: options.allowedMimeTypes
                                    }, {
                                        headers: this.headers
                                    })
                                ];
                            case 1:
                                data = _state.sent();
                                return [
                                    2,
                                    {
                                        data: data,
                                        error: null
                                    }
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $fba3590508ee8418$export$5a322e77e5eb0561)(error)) return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Removes all objects inside a single bucket.
     *
     * @param id The unique identifier of the bucket you would like to empty.
     */ key: "emptyBucket",
            value: function emptyBucket(id) {
                return $85a47a9dbcbbdd77$var$__awaiter(this, void 0, void 0, function() {
                    var data, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0, $6be874a2ed33584f$export$299ba2dee77727e9)(this.fetch, "".concat(this.url, "/bucket/").concat(id, "/empty"), {}, {
                                        headers: this.headers
                                    })
                                ];
                            case 1:
                                data = _state.sent();
                                return [
                                    2,
                                    {
                                        data: data,
                                        error: null
                                    }
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $fba3590508ee8418$export$5a322e77e5eb0561)(error)) return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            /**
     * Deletes an existing bucket. A bucket can't be deleted with existing objects inside it.
     * You must first `empty()` the bucket.
     *
     * @param id The unique identifier of the bucket you would like to delete.
     */ key: "deleteBucket",
            value: function deleteBucket(id) {
                return $85a47a9dbcbbdd77$var$__awaiter(this, void 0, void 0, function() {
                    var data, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0, $6be874a2ed33584f$export$cd7f480d6b8286c3)(this.fetch, "".concat(this.url, "/bucket/").concat(id), {}, {
                                        headers: this.headers
                                    })
                                ];
                            case 1:
                                data = _state.sent();
                                return [
                                    2,
                                    {
                                        data: data,
                                        error: null
                                    }
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $fba3590508ee8418$export$5a322e77e5eb0561)(error)) return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        }
    ]);
    return StorageBucketApi;
}();


var $4c574872bb39cb61$export$6c85f5032e75eff9 = /*#__PURE__*/ function(StorageBucketApi) {
    "use strict";
    (0, $1atwj._)(StorageClient, StorageBucketApi);
    function StorageClient(url) {
        var headers = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, fetch = arguments.length > 2 ? arguments[2] : void 0;
        (0, $50OuQ._)(this, StorageClient);
        return (0, $huFCX._)(this, StorageClient, [
            url,
            headers,
            fetch
        ]);
    }
    (0, $fGdZr._)(StorageClient, [
        {
            /**
     * Perform file operation in a bucket.
     *
     * @param id The bucket id to operate on.
     */ key: "from",
            value: function from(id) {
                return new (0, $08a18fd652a244ca$export$2e2bcd8739ae039)(this.url, this.headers, id, this.fetch);
            }
        }
    ]);
    return StorageClient;
}((0, $85a47a9dbcbbdd77$export$2e2bcd8739ae039));


var $a3428c68b05c861d$export$83d89fbfd8236492 = '2.47.12';


var $3b56cbd3e30ce46e$var$JS_ENV = '';
// @ts-ignore
if (typeof Deno !== 'undefined') $3b56cbd3e30ce46e$var$JS_ENV = 'deno';
else if (typeof document !== 'undefined') $3b56cbd3e30ce46e$var$JS_ENV = 'web';
else if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') $3b56cbd3e30ce46e$var$JS_ENV = 'react-native';
else $3b56cbd3e30ce46e$var$JS_ENV = 'node';
var $3b56cbd3e30ce46e$export$88a84136db6a4b64 = {
    'X-Client-Info': "supabase-js-".concat($3b56cbd3e30ce46e$var$JS_ENV, "/").concat((0, $a3428c68b05c861d$export$83d89fbfd8236492))
};
var $3b56cbd3e30ce46e$export$b63a5c3a2e5becd2 = {
    headers: $3b56cbd3e30ce46e$export$88a84136db6a4b64
};
var $3b56cbd3e30ce46e$export$b31378ae815bea6b = {
    schema: 'public'
};
var $3b56cbd3e30ce46e$export$af122550cc2345b3 = {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'implicit'
};
var $3b56cbd3e30ce46e$export$59685507ca0a3912 = {};



var $dHvbf = parcelRequire("dHvbf");

var $1XfpH = parcelRequire("1XfpH");

var $TskBh = parcelRequire("TskBh");
var $83d30eae6e87e98f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $83d30eae6e87e98f$export$98d92b1aa79f8cc7 = function(customFetch) {
    var _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (0, $TskBh.default);
    else _fetch = fetch;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return _fetch.apply(void 0, (0, $dHvbf._)(args));
    };
};
var $83d30eae6e87e98f$export$3d2cf54f85b7fc8a = function() {
    if (typeof Headers === 'undefined') return 0, $TskBh.Headers;
    return Headers;
};
var $83d30eae6e87e98f$export$651dd5aef824521f = function(supabaseKey, getAccessToken, customFetch) {
    var fetch1 = $83d30eae6e87e98f$export$98d92b1aa79f8cc7(customFetch);
    var HeadersConstructor = $83d30eae6e87e98f$export$3d2cf54f85b7fc8a();
    return function(input, init) {
        return $83d30eae6e87e98f$var$__awaiter(void 0, void 0, void 0, function() {
            var _a, accessToken, headers;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getAccessToken()
                        ];
                    case 1:
                        accessToken = (_a = _state.sent()) !== null && _a !== void 0 ? _a : supabaseKey;
                        headers = new HeadersConstructor(init === null || init === void 0 ? void 0 : init.headers);
                        if (!headers.has('apikey')) headers.set('apikey', supabaseKey);
                        if (!headers.has('Authorization')) headers.set('Authorization', "Bearer ".concat(accessToken));
                        return [
                            2,
                            fetch1(input, Object.assign(Object.assign({}, init), {
                                headers: headers
                            }))
                        ];
                }
            });
        });
    };
};



var $1XfpH = parcelRequire("1XfpH");
var $69cd3a7da24f8adb$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $69cd3a7da24f8adb$export$31b40729666a4ae0() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $69cd3a7da24f8adb$export$d95b4586d238a081(url) {
    return url.replace(/\/$/, '');
}
var $69cd3a7da24f8adb$export$4e09c449d6c407f7 = function() {
    return typeof window !== 'undefined';
};
function $69cd3a7da24f8adb$export$da186dc3f8eace71(options, defaults) {
    var _this = this;
    var dbOptions = options.db, authOptions = options.auth, realtimeOptions = options.realtime, globalOptions = options.global;
    var DEFAULT_DB_OPTIONS = defaults.db, DEFAULT_AUTH_OPTIONS = defaults.auth, DEFAULT_REALTIME_OPTIONS = defaults.realtime, DEFAULT_GLOBAL_OPTIONS = defaults.global;
    var result = {
        db: Object.assign(Object.assign({}, DEFAULT_DB_OPTIONS), dbOptions),
        auth: Object.assign(Object.assign({}, DEFAULT_AUTH_OPTIONS), authOptions),
        realtime: Object.assign(Object.assign({}, DEFAULT_REALTIME_OPTIONS), realtimeOptions),
        global: Object.assign(Object.assign({}, DEFAULT_GLOBAL_OPTIONS), globalOptions),
        accessToken: function() {
            return $69cd3a7da24f8adb$var$__awaiter(_this, void 0, void 0, function() {
                return (0, $1XfpH.__generator)(this, function(_state) {
                    return [
                        2,
                        ''
                    ];
                });
            });
        }
    };
    if (options.accessToken) result.accessToken = options.accessToken;
    else // hack around Required<>
    delete result.accessToken;
    return result;
}



var $huFCX = parcelRequire("huFCX");

var $50OuQ = parcelRequire("50OuQ");

var $1atwj = parcelRequire("1atwj");

var $5Pgs2 = parcelRequire("5Pgs2");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $1XfpH = parcelRequire("1XfpH");

var $5Pgs2 = parcelRequire("5Pgs2");

var $qb7pP = parcelRequire("qb7pP");

var $1XfpH = parcelRequire("1XfpH");
var $7e12a7bc19ec358b$export$83d89fbfd8236492 = '2.67.3';


var $b2aad0884e88cf33$export$7fedf552187f0c3d = 'http://localhost:9999';
var $b2aad0884e88cf33$export$86880b4b2e1a2384 = 'supabase.auth.token';
var $b2aad0884e88cf33$export$2f9161bad044dacb = '';
var $b2aad0884e88cf33$export$88a84136db6a4b64 = {
    'X-Client-Info': "gotrue-js/".concat((0, $7e12a7bc19ec358b$export$83d89fbfd8236492))
};
var $b2aad0884e88cf33$export$7d4b3a66850dd9bd = 10; // in seconds
var $b2aad0884e88cf33$export$5615c708618ee858 = {
    MAX_RETRIES: 10,
    RETRY_INTERVAL: 2
};
var $b2aad0884e88cf33$export$e4f5507f88977535 = 'X-Supabase-Api-Version';
var $b2aad0884e88cf33$export$1f9a66038489bdeb = {
    '2024-01-01': {
        timestamp: Date.parse('2024-01-01T00:00:00.0Z'),
        name: '2024-01-01'
    }
};



var $5Pgs2 = parcelRequire("5Pgs2");

var $50OuQ = parcelRequire("50OuQ");

var $dHvbf = parcelRequire("dHvbf");

var $qb7pP = parcelRequire("qb7pP");

var $1XfpH = parcelRequire("1XfpH");

function $e47a9df456bd0ac4$export$e02d0a488392f690(expiresIn) {
    var timeNow = Math.round(Date.now() / 1000);
    return timeNow + expiresIn;
}
function $e47a9df456bd0ac4$export$31b40729666a4ae0() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
var $e47a9df456bd0ac4$export$4e09c449d6c407f7 = function() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
};
var $e47a9df456bd0ac4$var$localStorageWriteTests = {
    tested: false,
    writable: false
};
var $e47a9df456bd0ac4$export$9ec034ee80211814 = function() {
    if (!$e47a9df456bd0ac4$export$4e09c449d6c407f7()) return false;
    try {
        if ((0, $qb7pP._)(globalThis.localStorage) !== 'object') return false;
    } catch (e) {
        // DOM exception when accessing `localStorage`
        return false;
    }
    if ($e47a9df456bd0ac4$var$localStorageWriteTests.tested) return $e47a9df456bd0ac4$var$localStorageWriteTests.writable;
    var randomKey = "lswt-".concat(Math.random()).concat(Math.random());
    try {
        globalThis.localStorage.setItem(randomKey, randomKey);
        globalThis.localStorage.removeItem(randomKey);
        $e47a9df456bd0ac4$var$localStorageWriteTests.tested = true;
        $e47a9df456bd0ac4$var$localStorageWriteTests.writable = true;
    } catch (e) {
        // localStorage can't be written to
        // https://www.chromium.org/for-testers/bug-reporting-guidelines/uncaught-securityerror-failed-to-read-the-localstorage-property-from-window-access-is-denied-for-this-document
        $e47a9df456bd0ac4$var$localStorageWriteTests.tested = true;
        $e47a9df456bd0ac4$var$localStorageWriteTests.writable = false;
    }
    return $e47a9df456bd0ac4$var$localStorageWriteTests.writable;
};
function $e47a9df456bd0ac4$export$7a29392fb778224c(href) {
    var result = {};
    var url = new URL(href);
    if (url.hash && url.hash[0] === '#') try {
        var hashSearchParams = new URLSearchParams(url.hash.substring(1));
        hashSearchParams.forEach(function(value, key) {
            result[key] = value;
        });
    } catch (e) {
    // hash is not a query string
    }
    // search parameters take precedence over hash parameters
    url.searchParams.forEach(function(value, key) {
        result[key] = value;
    });
    return result;
}

var $e47a9df456bd0ac4$export$98d92b1aa79f8cc7 = function(customFetch) {
    var _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return Promise.resolve((parcelRequire("TskBh"))).then(function(param) {
            var _$fetch = param["default"];
            return _$fetch.apply(void 0, (0, $dHvbf._)(args));
        });
    };
    else _fetch = fetch;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return _fetch.apply(void 0, (0, $dHvbf._)(args));
    };
};
var $e47a9df456bd0ac4$export$e8ad6599be1036a7 = function(maybeResponse) {
    return (typeof maybeResponse === "undefined" ? "undefined" : (0, $qb7pP._)(maybeResponse)) === 'object' && maybeResponse !== null && 'status' in maybeResponse && 'ok' in maybeResponse && 'json' in maybeResponse && typeof maybeResponse.json === 'function';
};
var $e47a9df456bd0ac4$export$e82c36d29078a87f = /*#__PURE__*/ function() {
    var _ref = (0, $5Pgs2._)(function(storage, key, data) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        storage.setItem(key, JSON.stringify(data))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function setItemAsync(storage, key, data) {
        return _ref.apply(this, arguments);
    };
}();
var $e47a9df456bd0ac4$export$ba6fcb7c333d32c0 = /*#__PURE__*/ function() {
    var _ref = (0, $5Pgs2._)(function(storage, key) {
        var value;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        storage.getItem(key)
                    ];
                case 1:
                    value = _state.sent();
                    if (!value) return [
                        2,
                        null
                    ];
                    try {
                        return [
                            2,
                            JSON.parse(value)
                        ];
                    } catch (_a) {
                        return [
                            2,
                            value
                        ];
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function getItemAsync(storage, key) {
        return _ref.apply(this, arguments);
    };
}();
var $e47a9df456bd0ac4$export$d35c645d585317ec = /*#__PURE__*/ function() {
    var _ref = (0, $5Pgs2._)(function(storage, key) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        storage.removeItem(key)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function removeItemAsync(storage, key) {
        return _ref.apply(this, arguments);
    };
}();
function $e47a9df456bd0ac4$export$f0d30a693d94f11c(value) {
    var key = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var base64 = '';
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0;
    value = value.replace('-', '+').replace('_', '/');
    while(i < value.length){
        enc1 = key.indexOf(value.charAt(i++));
        enc2 = key.indexOf(value.charAt(i++));
        enc3 = key.indexOf(value.charAt(i++));
        enc4 = key.indexOf(value.charAt(i++));
        chr1 = enc1 << 2 | enc2 >> 4;
        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
        chr3 = (enc3 & 3) << 6 | enc4;
        base64 = base64 + String.fromCharCode(chr1);
        if (enc3 != 64 && chr2 != 0) base64 = base64 + String.fromCharCode(chr2);
        if (enc4 != 64 && chr3 != 0) base64 = base64 + String.fromCharCode(chr3);
    }
    return base64;
}
var $e47a9df456bd0ac4$export$85f6557964517f1a = function Deferred() {
    "use strict";
    var _this = this;
    (0, $50OuQ._)(this, Deferred);
    this.promise = new Deferred.promiseConstructor(function(res, rej) {
        _this.resolve = res;
        _this.reject = rej;
    });
};
$e47a9df456bd0ac4$export$85f6557964517f1a.promiseConstructor = Promise;
function $e47a9df456bd0ac4$export$cc1c0b988f7b5577(token) {
    // Regex checks for base64url format
    var base64UrlRegex = /^([a-z0-9_-]{4})*($|[a-z0-9_-]{3}=?$|[a-z0-9_-]{2}(==)?$)$/i;
    var parts = token.split('.');
    if (parts.length !== 3) throw new Error('JWT is not valid: not a JWT structure');
    if (!base64UrlRegex.test(parts[1])) throw new Error('JWT is not valid: payload is not in base64url format');
    var base64Url = parts[1];
    return JSON.parse($e47a9df456bd0ac4$export$f0d30a693d94f11c(base64Url));
}
function $e47a9df456bd0ac4$export$e772c8ff12451969(time) {
    return $e47a9df456bd0ac4$var$_sleep.apply(this, arguments);
}
function $e47a9df456bd0ac4$var$_sleep() {
    $e47a9df456bd0ac4$var$_sleep = (0, $5Pgs2._)(function(time) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        new Promise(function(accept) {
                            setTimeout(function() {
                                return accept(null);
                            }, time);
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return $e47a9df456bd0ac4$var$_sleep.apply(this, arguments);
}
function $e47a9df456bd0ac4$export$9e1b8e833f44ff21(fn, isRetryable) {
    var promise = new Promise(function(accept, reject) {
        (0, $5Pgs2._)(function() {
            var attempt, result, e;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        attempt = 0;
                        _state.label = 1;
                    case 1:
                        if (!(attempt < Infinity)) return [
                            3,
                            6
                        ];
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            fn(attempt)
                        ];
                    case 3:
                        result = _state.sent();
                        if (!isRetryable(attempt, null, result)) {
                            accept(result);
                            return [
                                2
                            ];
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        e = _state.sent();
                        if (!isRetryable(attempt, e)) {
                            reject(e);
                            return [
                                2
                            ];
                        }
                        return [
                            3,
                            5
                        ];
                    case 5:
                        attempt++;
                        return [
                            3,
                            1
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    });
    return promise;
}
function $e47a9df456bd0ac4$var$dec2hex(dec) {
    return ('0' + dec.toString(16)).substr(-2);
}
function $e47a9df456bd0ac4$export$b6c3b8498f152f15() {
    var verifierLength = 56;
    var array = new Uint32Array(verifierLength);
    if (typeof crypto === 'undefined') {
        var charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
        var charSetLen = charSet.length;
        var verifier = '';
        for(var i = 0; i < verifierLength; i++)verifier += charSet.charAt(Math.floor(Math.random() * charSetLen));
        return verifier;
    }
    crypto.getRandomValues(array);
    return Array.from(array, $e47a9df456bd0ac4$var$dec2hex).join('');
}
function $e47a9df456bd0ac4$var$sha256(randomString) {
    return $e47a9df456bd0ac4$var$_sha256.apply(this, arguments);
}
function $e47a9df456bd0ac4$var$_sha256() {
    $e47a9df456bd0ac4$var$_sha256 = (0, $5Pgs2._)(function(randomString) {
        var encoder, encodedData, hash, bytes;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    encoder = new TextEncoder();
                    encodedData = encoder.encode(randomString);
                    return [
                        4,
                        crypto.subtle.digest('SHA-256', encodedData)
                    ];
                case 1:
                    hash = _state.sent();
                    bytes = new Uint8Array(hash);
                    return [
                        2,
                        Array.from(bytes).map(function(c) {
                            return String.fromCharCode(c);
                        }).join('')
                    ];
            }
        });
    });
    return $e47a9df456bd0ac4$var$_sha256.apply(this, arguments);
}
function $e47a9df456bd0ac4$var$base64urlencode(str) {
    return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function $e47a9df456bd0ac4$export$eb79e16bb8189148(verifier) {
    return $e47a9df456bd0ac4$var$_generatePKCEChallenge.apply(this, arguments);
}
function $e47a9df456bd0ac4$var$_generatePKCEChallenge() {
    $e47a9df456bd0ac4$var$_generatePKCEChallenge = (0, $5Pgs2._)(function(verifier) {
        var hasCryptoSupport, hashed;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    hasCryptoSupport = typeof crypto !== 'undefined' && typeof crypto.subtle !== 'undefined' && typeof TextEncoder !== 'undefined';
                    if (!hasCryptoSupport) {
                        console.warn('WebCrypto API is not supported. Code challenge method will default to use plain instead of sha256.');
                        return [
                            2,
                            verifier
                        ];
                    }
                    return [
                        4,
                        $e47a9df456bd0ac4$var$sha256(verifier)
                    ];
                case 1:
                    hashed = _state.sent();
                    return [
                        2,
                        $e47a9df456bd0ac4$var$base64urlencode(hashed)
                    ];
            }
        });
    });
    return $e47a9df456bd0ac4$var$_generatePKCEChallenge.apply(this, arguments);
}
function $e47a9df456bd0ac4$export$81b177cadfcf873c(storage, storageKey) {
    return $e47a9df456bd0ac4$var$_getCodeChallengeAndMethod.apply(this, arguments);
}
function $e47a9df456bd0ac4$var$_getCodeChallengeAndMethod() {
    $e47a9df456bd0ac4$var$_getCodeChallengeAndMethod = (0, $5Pgs2._)(function(storage, storageKey) {
        var isPasswordRecovery, codeVerifier, storedCodeVerifier, codeChallenge, codeChallengeMethod;
        var _arguments = arguments;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    isPasswordRecovery = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    codeVerifier = $e47a9df456bd0ac4$export$b6c3b8498f152f15();
                    storedCodeVerifier = codeVerifier;
                    if (isPasswordRecovery) storedCodeVerifier += '/PASSWORD_RECOVERY';
                    return [
                        4,
                        $e47a9df456bd0ac4$export$e82c36d29078a87f(storage, "".concat(storageKey, "-code-verifier"), storedCodeVerifier)
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        $e47a9df456bd0ac4$export$eb79e16bb8189148(codeVerifier)
                    ];
                case 2:
                    codeChallenge = _state.sent();
                    codeChallengeMethod = codeVerifier === codeChallenge ? 'plain' : 's256';
                    return [
                        2,
                        [
                            codeChallenge,
                            codeChallengeMethod
                        ]
                    ];
            }
        });
    });
    return $e47a9df456bd0ac4$var$_getCodeChallengeAndMethod.apply(this, arguments);
}
/** Parses the API version which is 2YYY-MM-DD. */ var $e47a9df456bd0ac4$var$API_VERSION_REGEX = /^2[0-9]{3}-(0[1-9]|1[0-2])-(0[1-9]|1[0-9]|2[0-9]|3[0-1])$/i;
function $e47a9df456bd0ac4$export$5f69ecf1c14d56fd(response) {
    var apiVersion = response.headers.get((0, $b2aad0884e88cf33$export$e4f5507f88977535));
    if (!apiVersion) return null;
    if (!apiVersion.match($e47a9df456bd0ac4$var$API_VERSION_REGEX)) return null;
    try {
        var date = new Date("".concat(apiVersion, "T00:00:00.0Z"));
        return date;
    } catch (e) {
        return null;
    }
}



var $huFCX = parcelRequire("huFCX");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $1atwj = parcelRequire("1atwj");

var $qb7pP = parcelRequire("qb7pP");

var $jc6v0 = parcelRequire("jc6v0");
var $73f5e58330057bc1$export$145273558d58e0ac = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $1atwj._)(AuthError, Error1);
    function AuthError(message, status, code) {
        (0, $50OuQ._)(this, AuthError);
        var _this;
        _this = (0, $huFCX._)(this, AuthError, [
            message
        ]);
        _this.__isAuthError = true;
        _this.name = 'AuthError';
        _this.status = status;
        _this.code = code;
        return _this;
    }
    return AuthError;
}((0, $jc6v0._)(Error));
function $73f5e58330057bc1$export$cde1786a482f9a1c(error) {
    return (typeof error === "undefined" ? "undefined" : (0, $qb7pP._)(error)) === 'object' && error !== null && '__isAuthError' in error;
}
var $73f5e58330057bc1$export$45fde0b55b14f37b = /*#__PURE__*/ function(AuthError) {
    "use strict";
    (0, $1atwj._)(AuthApiError, AuthError);
    function AuthApiError(message, status, code) {
        (0, $50OuQ._)(this, AuthApiError);
        var _this;
        _this = (0, $huFCX._)(this, AuthApiError, [
            message,
            status,
            code
        ]);
        _this.name = 'AuthApiError';
        _this.status = status;
        _this.code = code;
        return _this;
    }
    return AuthApiError;
}($73f5e58330057bc1$export$145273558d58e0ac);
function $73f5e58330057bc1$export$4fe744aeb810d543(error) {
    return $73f5e58330057bc1$export$cde1786a482f9a1c(error) && error.name === 'AuthApiError';
}
var $73f5e58330057bc1$export$f7559805d4a50078 = /*#__PURE__*/ function(AuthError) {
    "use strict";
    (0, $1atwj._)(AuthUnknownError, AuthError);
    function AuthUnknownError(message, originalError) {
        (0, $50OuQ._)(this, AuthUnknownError);
        var _this;
        _this = (0, $huFCX._)(this, AuthUnknownError, [
            message
        ]);
        _this.name = 'AuthUnknownError';
        _this.originalError = originalError;
        return _this;
    }
    return AuthUnknownError;
}($73f5e58330057bc1$export$145273558d58e0ac);
var $73f5e58330057bc1$export$823c745ae0673c5e = /*#__PURE__*/ function(AuthError) {
    "use strict";
    (0, $1atwj._)(CustomAuthError, AuthError);
    function CustomAuthError(message, name, status, code) {
        (0, $50OuQ._)(this, CustomAuthError);
        var _this;
        _this = (0, $huFCX._)(this, CustomAuthError, [
            message,
            status,
            code
        ]);
        _this.name = name;
        _this.status = status;
        return _this;
    }
    return CustomAuthError;
}($73f5e58330057bc1$export$145273558d58e0ac);
var $73f5e58330057bc1$export$403b3fc0d3ad5f0c = /*#__PURE__*/ function(CustomAuthError) {
    "use strict";
    (0, $1atwj._)(AuthSessionMissingError, CustomAuthError);
    function AuthSessionMissingError() {
        (0, $50OuQ._)(this, AuthSessionMissingError);
        return (0, $huFCX._)(this, AuthSessionMissingError, [
            'Auth session missing!',
            'AuthSessionMissingError',
            400,
            undefined
        ]);
    }
    return AuthSessionMissingError;
}($73f5e58330057bc1$export$823c745ae0673c5e);
function $73f5e58330057bc1$export$3e849aa4db565c1d(error) {
    return $73f5e58330057bc1$export$cde1786a482f9a1c(error) && error.name === 'AuthSessionMissingError';
}
var $73f5e58330057bc1$export$7e277b620449c1b4 = /*#__PURE__*/ function(CustomAuthError) {
    "use strict";
    (0, $1atwj._)(AuthInvalidTokenResponseError, CustomAuthError);
    function AuthInvalidTokenResponseError() {
        (0, $50OuQ._)(this, AuthInvalidTokenResponseError);
        return (0, $huFCX._)(this, AuthInvalidTokenResponseError, [
            'Auth session or user missing',
            'AuthInvalidTokenResponseError',
            500,
            undefined
        ]);
    }
    return AuthInvalidTokenResponseError;
}($73f5e58330057bc1$export$823c745ae0673c5e);
var $73f5e58330057bc1$export$9ef583f0381b4cc = /*#__PURE__*/ function(CustomAuthError) {
    "use strict";
    (0, $1atwj._)(AuthInvalidCredentialsError, CustomAuthError);
    function AuthInvalidCredentialsError(message) {
        (0, $50OuQ._)(this, AuthInvalidCredentialsError);
        return (0, $huFCX._)(this, AuthInvalidCredentialsError, [
            message,
            'AuthInvalidCredentialsError',
            400,
            undefined
        ]);
    }
    return AuthInvalidCredentialsError;
}($73f5e58330057bc1$export$823c745ae0673c5e);
var $73f5e58330057bc1$export$bf5df8e043856ef5 = /*#__PURE__*/ function(CustomAuthError) {
    "use strict";
    (0, $1atwj._)(AuthImplicitGrantRedirectError, CustomAuthError);
    function AuthImplicitGrantRedirectError(message) {
        var details = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        (0, $50OuQ._)(this, AuthImplicitGrantRedirectError);
        var _this;
        _this = (0, $huFCX._)(this, AuthImplicitGrantRedirectError, [
            message,
            'AuthImplicitGrantRedirectError',
            500,
            undefined
        ]);
        _this.details = null;
        _this.details = details;
        return _this;
    }
    (0, $fGdZr._)(AuthImplicitGrantRedirectError, [
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    name: this.name,
                    message: this.message,
                    status: this.status,
                    details: this.details
                };
            }
        }
    ]);
    return AuthImplicitGrantRedirectError;
}($73f5e58330057bc1$export$823c745ae0673c5e);
function $73f5e58330057bc1$export$45edea3999507afd(error) {
    return $73f5e58330057bc1$export$cde1786a482f9a1c(error) && error.name === 'AuthImplicitGrantRedirectError';
}
var $73f5e58330057bc1$export$39583657eb2a7027 = /*#__PURE__*/ function(CustomAuthError) {
    "use strict";
    (0, $1atwj._)(AuthPKCEGrantCodeExchangeError, CustomAuthError);
    function AuthPKCEGrantCodeExchangeError(message) {
        var details = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        (0, $50OuQ._)(this, AuthPKCEGrantCodeExchangeError);
        var _this;
        _this = (0, $huFCX._)(this, AuthPKCEGrantCodeExchangeError, [
            message,
            'AuthPKCEGrantCodeExchangeError',
            500,
            undefined
        ]);
        _this.details = null;
        _this.details = details;
        return _this;
    }
    (0, $fGdZr._)(AuthPKCEGrantCodeExchangeError, [
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    name: this.name,
                    message: this.message,
                    status: this.status,
                    details: this.details
                };
            }
        }
    ]);
    return AuthPKCEGrantCodeExchangeError;
}($73f5e58330057bc1$export$823c745ae0673c5e);
var $73f5e58330057bc1$export$2423b763f68be1b4 = /*#__PURE__*/ function(CustomAuthError) {
    "use strict";
    (0, $1atwj._)(AuthRetryableFetchError, CustomAuthError);
    function AuthRetryableFetchError(message, status) {
        (0, $50OuQ._)(this, AuthRetryableFetchError);
        return (0, $huFCX._)(this, AuthRetryableFetchError, [
            message,
            'AuthRetryableFetchError',
            status,
            undefined
        ]);
    }
    return AuthRetryableFetchError;
}($73f5e58330057bc1$export$823c745ae0673c5e);
function $73f5e58330057bc1$export$a77af358da5fb874(error) {
    return $73f5e58330057bc1$export$cde1786a482f9a1c(error) && error.name === 'AuthRetryableFetchError';
}
var $73f5e58330057bc1$export$b034076aa04913a6 = /*#__PURE__*/ function(CustomAuthError) {
    "use strict";
    (0, $1atwj._)(AuthWeakPasswordError, CustomAuthError);
    function AuthWeakPasswordError(message, status, reasons) {
        (0, $50OuQ._)(this, AuthWeakPasswordError);
        var _this;
        _this = (0, $huFCX._)(this, AuthWeakPasswordError, [
            message,
            'AuthWeakPasswordError',
            status,
            'weak_password'
        ]);
        _this.reasons = reasons;
        return _this;
    }
    return AuthWeakPasswordError;
}($73f5e58330057bc1$export$823c745ae0673c5e);
function $73f5e58330057bc1$export$dac36143fd8a46ef(error) {
    return $73f5e58330057bc1$export$cde1786a482f9a1c(error) && error.name === 'AuthWeakPasswordError';
}


var $cc4d33f36ba2dab3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $cc4d33f36ba2dab3$var$_getErrorMessage = function(err) {
    return err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
};
var $cc4d33f36ba2dab3$var$NETWORK_ERROR_CODES = [
    502,
    503,
    504
];
function $cc4d33f36ba2dab3$export$d3da1ecaf1206c58(error) {
    return $cc4d33f36ba2dab3$var$_handleError.apply(this, arguments);
}
function $cc4d33f36ba2dab3$var$_handleError() {
    $cc4d33f36ba2dab3$var$_handleError = (0, $5Pgs2._)(function(error) {
        var _a, data, e, errorCode, responseAPIVersion;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(0, $e47a9df456bd0ac4$export$e8ad6599be1036a7)(error)) throw new (0, $73f5e58330057bc1$export$2423b763f68be1b4)($cc4d33f36ba2dab3$var$_getErrorMessage(error), 0);
                    if ($cc4d33f36ba2dab3$var$NETWORK_ERROR_CODES.includes(error.status)) // status in 500...599 range - server had an error, request might be retryed.
                    throw new (0, $73f5e58330057bc1$export$2423b763f68be1b4)($cc4d33f36ba2dab3$var$_getErrorMessage(error), error.status);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        error.json()
                    ];
                case 2:
                    data = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    throw new (0, $73f5e58330057bc1$export$f7559805d4a50078)($cc4d33f36ba2dab3$var$_getErrorMessage(e), e);
                case 4:
                    errorCode = undefined;
                    responseAPIVersion = (0, $e47a9df456bd0ac4$export$5f69ecf1c14d56fd)(error);
                    if (responseAPIVersion && responseAPIVersion.getTime() >= (0, $b2aad0884e88cf33$export$1f9a66038489bdeb)['2024-01-01'].timestamp && (typeof data === "undefined" ? "undefined" : (0, $qb7pP._)(data)) === 'object' && data && typeof data.code === 'string') errorCode = data.code;
                    else if ((typeof data === "undefined" ? "undefined" : (0, $qb7pP._)(data)) === 'object' && data && typeof data.error_code === 'string') errorCode = data.error_code;
                    if (!errorCode) {
                        // Legacy support for weak password errors, when there were no error codes
                        if ((typeof data === "undefined" ? "undefined" : (0, $qb7pP._)(data)) === 'object' && data && (0, $qb7pP._)(data.weak_password) === 'object' && data.weak_password && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.reasons.reduce(function(a, i) {
                            return a && typeof i === 'string';
                        }, true)) throw new (0, $73f5e58330057bc1$export$b034076aa04913a6)($cc4d33f36ba2dab3$var$_getErrorMessage(data), error.status, data.weak_password.reasons);
                    } else if (errorCode === 'weak_password') throw new (0, $73f5e58330057bc1$export$b034076aa04913a6)($cc4d33f36ba2dab3$var$_getErrorMessage(data), error.status, ((_a = data.weak_password) === null || _a === void 0 ? void 0 : _a.reasons) || []);
                    else if (errorCode === 'session_not_found') // The `session_id` inside the JWT does not correspond to a row in the
                    // `sessions` table. This usually means the user has signed out, has been
                    // deleted, or their session has somehow been terminated.
                    throw new (0, $73f5e58330057bc1$export$403b3fc0d3ad5f0c)();
                    throw new (0, $73f5e58330057bc1$export$45fde0b55b14f37b)($cc4d33f36ba2dab3$var$_getErrorMessage(data), error.status || 500, errorCode);
            }
        });
    });
    return $cc4d33f36ba2dab3$var$_handleError.apply(this, arguments);
}
var $cc4d33f36ba2dab3$var$_getRequestParams = function(method, options, parameters, body) {
    var params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === 'GET') return params;
    params.headers = Object.assign({
        'Content-Type': 'application/json;charset=UTF-8'
    }, options === null || options === void 0 ? void 0 : options.headers);
    params.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params), parameters);
};
function $cc4d33f36ba2dab3$export$8969b3850ca2cdfd(fetcher, method, url, options) {
    return $cc4d33f36ba2dab3$var$__request.apply(this, arguments);
}
function $cc4d33f36ba2dab3$var$__request() {
    $cc4d33f36ba2dab3$var$__request = (0, $5Pgs2._)(function(fetcher, method, url, options) {
        var _a, headers, qs, queryString, data;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    headers = Object.assign({}, options === null || options === void 0 ? void 0 : options.headers);
                    if (!headers[0, $b2aad0884e88cf33$export$e4f5507f88977535]) headers[0, $b2aad0884e88cf33$export$e4f5507f88977535] = (0, $b2aad0884e88cf33$export$1f9a66038489bdeb)['2024-01-01'].name;
                    if (options === null || options === void 0 ? void 0 : options.jwt) headers['Authorization'] = "Bearer ".concat(options.jwt);
                    qs = (_a = options === null || options === void 0 ? void 0 : options.query) !== null && _a !== void 0 ? _a : {};
                    if (options === null || options === void 0 ? void 0 : options.redirectTo) qs['redirect_to'] = options.redirectTo;
                    queryString = Object.keys(qs).length ? '?' + new URLSearchParams(qs).toString() : '';
                    return [
                        4,
                        $cc4d33f36ba2dab3$var$_handleRequest(fetcher, method, url + queryString, {
                            headers: headers,
                            noResolveJson: options === null || options === void 0 ? void 0 : options.noResolveJson
                        }, {}, options === null || options === void 0 ? void 0 : options.body)
                    ];
                case 1:
                    data = _state.sent();
                    return [
                        2,
                        (options === null || options === void 0 ? void 0 : options.xform) ? options === null || options === void 0 ? void 0 : options.xform(data) : {
                            data: Object.assign({}, data),
                            error: null
                        }
                    ];
            }
        });
    });
    return $cc4d33f36ba2dab3$var$__request.apply(this, arguments);
}
function $cc4d33f36ba2dab3$var$_handleRequest(fetcher, method, url, options, parameters, body) {
    return $cc4d33f36ba2dab3$var$__handleRequest.apply(this, arguments);
}
function $cc4d33f36ba2dab3$var$__handleRequest() {
    $cc4d33f36ba2dab3$var$__handleRequest = (0, $5Pgs2._)(function(fetcher, method, url, options, parameters, body) {
        var requestParams, result, e, e1;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    requestParams = $cc4d33f36ba2dab3$var$_getRequestParams(method, options, parameters, body);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetcher(url, Object.assign({}, requestParams))
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    console.error(e);
                    // fetch failed, likely due to a network or CORS error
                    throw new (0, $73f5e58330057bc1$export$2423b763f68be1b4)($cc4d33f36ba2dab3$var$_getErrorMessage(e), 0);
                case 4:
                    if (!!result.ok) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        $cc4d33f36ba2dab3$export$d3da1ecaf1206c58(result)
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    if (options === null || options === void 0 ? void 0 : options.noResolveJson) return [
                        2,
                        result
                    ];
                    _state.label = 7;
                case 7:
                    _state.trys.push([
                        7,
                        9,
                        ,
                        11
                    ]);
                    return [
                        4,
                        result.json()
                    ];
                case 8:
                    return [
                        2,
                        _state.sent()
                    ];
                case 9:
                    e1 = _state.sent();
                    return [
                        4,
                        $cc4d33f36ba2dab3$export$d3da1ecaf1206c58(e1)
                    ];
                case 10:
                    _state.sent();
                    return [
                        3,
                        11
                    ];
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
    return $cc4d33f36ba2dab3$var$__handleRequest.apply(this, arguments);
}
function $cc4d33f36ba2dab3$export$273fe4673a018c2e(data) {
    var _a;
    var session = null;
    if ($cc4d33f36ba2dab3$var$hasSession(data)) {
        session = Object.assign({}, data);
        if (!data.expires_at) session.expires_at = (0, $e47a9df456bd0ac4$export$e02d0a488392f690)(data.expires_in);
    }
    var user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            session: session,
            user: user
        },
        error: null
    };
}
function $cc4d33f36ba2dab3$export$db83aade1c2922c7(data) {
    var response = $cc4d33f36ba2dab3$export$273fe4673a018c2e(data);
    if (!response.error && data.weak_password && (0, $qb7pP._)(data.weak_password) === 'object' && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.message && typeof data.weak_password.message === 'string' && data.weak_password.reasons.reduce(function(a, i) {
        return a && typeof i === 'string';
    }, true)) response.data.weak_password = data.weak_password;
    return response;
}
function $cc4d33f36ba2dab3$export$e20f488897843593(data) {
    var _a;
    var user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            user: user
        },
        error: null
    };
}
function $cc4d33f36ba2dab3$export$b04785c46dcd8f8b(data) {
    return {
        data: data,
        error: null
    };
}
function $cc4d33f36ba2dab3$export$f5eaa950605b2146(data) {
    var action_link = data.action_link, email_otp = data.email_otp, hashed_token = data.hashed_token, redirect_to = data.redirect_to, verification_type = data.verification_type, rest = $cc4d33f36ba2dab3$var$__rest(data, [
        "action_link",
        "email_otp",
        "hashed_token",
        "redirect_to",
        "verification_type"
    ]);
    var properties = {
        action_link: action_link,
        email_otp: email_otp,
        hashed_token: hashed_token,
        redirect_to: redirect_to,
        verification_type: verification_type
    };
    var user = Object.assign({}, rest);
    return {
        data: {
            properties: properties,
            user: user
        },
        error: null
    };
}
function $cc4d33f36ba2dab3$export$7aed01df6e045e31(data) {
    return data;
}
/**
 * hasSession checks if the response object contains a valid session
 * @param data A response object
 * @returns true if a session is in the response
 */ function $cc4d33f36ba2dab3$var$hasSession(data) {
    return data.access_token && data.refresh_token && data.expires_in;
}




var $edafeda94c9906ac$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $edafeda94c9906ac$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function GoTrueAdminApi(param) {
        var _param_url = param.url, url = _param_url === void 0 ? '' : _param_url, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, fetch = param.fetch;
        (0, $50OuQ._)(this, GoTrueAdminApi);
        this.url = url;
        this.headers = headers;
        this.fetch = (0, $e47a9df456bd0ac4$export$98d92b1aa79f8cc7)(fetch);
        this.mfa = {
            listFactors: this._listFactors.bind(this),
            deleteFactor: this._deleteFactor.bind(this)
        };
    }
    (0, $fGdZr._)(GoTrueAdminApi, [
        {
            key: "signOut",
            value: /**
     * Removes a logged-in session.
     * @param jwt A valid, logged-in JWT.
     * @param scope The logout sope.
     */ function signOut(jwt) {
                var scope = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'global';
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'POST', "".concat(_this.url, "/logout?scope=").concat(scope), {
                                        headers: _this.headers,
                                        jwt: jwt,
                                        noResolveJson: true
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    {
                                        data: null,
                                        error: null
                                    }
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "inviteUserByEmail",
            value: /**
     * Sends an invite link to an email address.
     * @param email The email address of the user.
     * @param options Additional options to be included when inviting.
     */ function inviteUserByEmail(email) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'POST', "".concat(_this.url, "/invite"), {
                                        body: {
                                            email: email,
                                            data: options.data
                                        },
                                        headers: _this.headers,
                                        redirectTo: options.redirectTo,
                                        xform: (0, $cc4d33f36ba2dab3$export$e20f488897843593)
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: {
                                            user: null
                                        },
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "generateLink",
            value: /**
     * Generates email links and OTPs to be sent via a custom email provider.
     * @param email The user's email.
     * @param options.password User password. For signup only.
     * @param options.data Optional user metadata. For signup only.
     * @param options.redirectTo The redirect url which should be appended to the generated link
     */ function generateLink(params) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var options, rest, body, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                options = params.options, rest = $edafeda94c9906ac$var$__rest(params, [
                                    "options"
                                ]);
                                body = Object.assign(Object.assign({}, rest), options);
                                if ('newEmail' in rest) {
                                    // replace newEmail with new_email in request body
                                    body.new_email = rest === null || rest === void 0 ? void 0 : rest.newEmail;
                                    delete body['newEmail'];
                                }
                                return [
                                    4,
                                    (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'POST', "".concat(_this.url, "/admin/generate_link"), {
                                        body: body,
                                        headers: _this.headers,
                                        xform: (0, $cc4d33f36ba2dab3$export$f5eaa950605b2146),
                                        redirectTo: options === null || options === void 0 ? void 0 : options.redirectTo
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: {
                                            properties: null,
                                            user: null
                                        },
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createUser",
            value: // User Admin API
            /**
     * Creates a new user.
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ function createUser(attributes) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'POST', "".concat(_this.url, "/admin/users"), {
                                        body: attributes,
                                        headers: _this.headers,
                                        xform: (0, $cc4d33f36ba2dab3$export$e20f488897843593)
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: {
                                            user: null
                                        },
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "listUsers",
            value: /**
     * Get a list of users.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     * @param params An object which supports `page` and `perPage` as numbers, to alter the paginated results.
     */ function listUsers(params) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _a, _b, _c, _d, _e, _f, _g, pagination, response, users, total, links, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    3,
                                    ,
                                    4
                                ]);
                                pagination = {
                                    nextPage: null,
                                    lastPage: 0,
                                    total: 0
                                };
                                return [
                                    4,
                                    (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'GET', "".concat(_this.url, "/admin/users"), {
                                        headers: _this.headers,
                                        noResolveJson: true,
                                        query: {
                                            page: (_b = (_a = params === null || params === void 0 ? void 0 : params.page) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '',
                                            per_page: (_d = (_c = params === null || params === void 0 ? void 0 : params.perPage) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : ''
                                        },
                                        xform: (0, $cc4d33f36ba2dab3$export$7aed01df6e045e31)
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                if (response.error) throw response.error;
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                users = _state.sent();
                                total = (_e = response.headers.get('x-total-count')) !== null && _e !== void 0 ? _e : 0;
                                links = (_g = (_f = response.headers.get('link')) === null || _f === void 0 ? void 0 : _f.split(',')) !== null && _g !== void 0 ? _g : [];
                                if (links.length > 0) {
                                    links.forEach(function(link) {
                                        var page = parseInt(link.split(';')[0].split('=')[1].substring(0, 1));
                                        var rel = JSON.parse(link.split(';')[1].split('=')[1]);
                                        pagination["".concat(rel, "Page")] = page;
                                    });
                                    pagination.total = parseInt(total);
                                }
                                return [
                                    2,
                                    {
                                        data: Object.assign(Object.assign({}, users), pagination),
                                        error: null
                                    }
                                ];
                            case 3:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: {
                                            users: []
                                        },
                                        error: error
                                    }
                                ];
                                throw error;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getUserById",
            value: /**
     * Get user by id.
     *
     * @param uid The user's unique identifier
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ function getUserById(uid) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'GET', "".concat(_this.url, "/admin/users/").concat(uid), {
                                        headers: _this.headers,
                                        xform: (0, $cc4d33f36ba2dab3$export$e20f488897843593)
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: {
                                            user: null
                                        },
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateUserById",
            value: /**
     * Updates the user data.
     *
     * @param attributes The data you want to update.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ function updateUserById(uid, attributes) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'PUT', "".concat(_this.url, "/admin/users/").concat(uid), {
                                        body: attributes,
                                        headers: _this.headers,
                                        xform: (0, $cc4d33f36ba2dab3$export$e20f488897843593)
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: {
                                            user: null
                                        },
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "deleteUser",
            value: /**
     * Delete a user. Requires a `service_role` key.
     *
     * @param id The user id you want to remove.
     * @param shouldSoftDelete If true, then the user will be soft-deleted from the auth schema. Soft deletion allows user identification from the hashed user ID but is not reversible.
     * Defaults to false for backward compatibility.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ function deleteUser(id) {
                var shouldSoftDelete = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'DELETE', "".concat(_this.url, "/admin/users/").concat(id), {
                                        headers: _this.headers,
                                        body: {
                                            should_soft_delete: shouldSoftDelete
                                        },
                                        xform: (0, $cc4d33f36ba2dab3$export$e20f488897843593)
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: {
                                            user: null
                                        },
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_listFactors",
            value: function _listFactors(params) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _ref, data, _$error, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'GET', "".concat(_this.url, "/admin/users/").concat(params.userId, "/factors"), {
                                        headers: _this.headers,
                                        xform: function(factors) {
                                            return {
                                                data: {
                                                    factors: factors
                                                },
                                                error: null
                                            };
                                        }
                                    })
                                ];
                            case 1:
                                _ref = _state.sent(), data = _ref.data, _$error = _ref.error;
                                return [
                                    2,
                                    {
                                        data: data,
                                        error: _$error
                                    }
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_deleteFactor",
            value: function _deleteFactor(params) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var data, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'DELETE', "".concat(_this.url, "/admin/users/").concat(params.userId, "/factors/").concat(params.id), {
                                        headers: _this.headers
                                    })
                                ];
                            case 1:
                                data = _state.sent();
                                return [
                                    2,
                                    {
                                        data: data,
                                        error: null
                                    }
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return GoTrueAdminApi;
}();



var $5Pgs2 = parcelRequire("5Pgs2");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $aSMts = parcelRequire("aSMts");

var $dHvbf = parcelRequire("dHvbf");

var $qb7pP = parcelRequire("qb7pP");

var $1XfpH = parcelRequire("1XfpH");






var $88a68460b4a3d13a$export$bba7b6c94612d04b = {
    getItem: function(key) {
        if (!(0, $e47a9df456bd0ac4$export$9ec034ee80211814)()) return null;
        return globalThis.localStorage.getItem(key);
    },
    setItem: function(key, value) {
        if (!(0, $e47a9df456bd0ac4$export$9ec034ee80211814)()) return;
        globalThis.localStorage.setItem(key, value);
    },
    removeItem: function(key) {
        if (!(0, $e47a9df456bd0ac4$export$9ec034ee80211814)()) return;
        globalThis.localStorage.removeItem(key);
    }
};
function $88a68460b4a3d13a$export$d791f66d7e5710cf() {
    var store = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return {
        getItem: function(key) {
            return store[key] || null;
        },
        setItem: function(key, value) {
            store[key] = value;
        },
        removeItem: function(key) {
            delete store[key];
        }
    };
}


/**
 * https://mathiasbynens.be/notes/globalthis
 */ 
var $qb7pP = parcelRequire("qb7pP");
function $caa01daf4b9ec736$export$ad067ce270531206() {
    if ((typeof globalThis === "undefined" ? "undefined" : (0, $qb7pP._)(globalThis)) === 'object') return;
    try {
        Object.defineProperty(Object.prototype, '__magic__', {
            get: function get() {
                return this;
            },
            configurable: true
        });
        // @ts-expect-error 'Allow access to magic'
        __magic__.globalThis = __magic__;
        // @ts-expect-error 'Allow access to magic'
        delete Object.prototype.__magic__;
    } catch (e) {
        if (typeof self !== 'undefined') // @ts-expect-error 'Allow access to globals'
        self.globalThis = self;
    }
}




var $5Pgs2 = parcelRequire("5Pgs2");

var $huFCX = parcelRequire("huFCX");

var $50OuQ = parcelRequire("50OuQ");

var $1atwj = parcelRequire("1atwj");

var $jc6v0 = parcelRequire("jc6v0");

var $1XfpH = parcelRequire("1XfpH");

var $82be7713279e39ac$export$e368aba7747330f2 = {
    /**
     * @experimental
     */ debug: !!(globalThis && (0, $e47a9df456bd0ac4$export$9ec034ee80211814)() && globalThis.localStorage && globalThis.localStorage.getItem('supabase.gotrue-js.locks.debug') === 'true')
};
var $82be7713279e39ac$export$23e9464cc010dff9 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $1atwj._)(LockAcquireTimeoutError, Error1);
    function LockAcquireTimeoutError(message) {
        (0, $50OuQ._)(this, LockAcquireTimeoutError);
        var _this;
        _this = (0, $huFCX._)(this, LockAcquireTimeoutError, [
            message
        ]);
        _this.isAcquireTimeout = true;
        return _this;
    }
    return LockAcquireTimeoutError;
}((0, $jc6v0._)(Error));
var $82be7713279e39ac$export$4aa56776043a4631 = /*#__PURE__*/ function(LockAcquireTimeoutError) {
    "use strict";
    (0, $1atwj._)(NavigatorLockAcquireTimeoutError, LockAcquireTimeoutError);
    function NavigatorLockAcquireTimeoutError() {
        (0, $50OuQ._)(this, NavigatorLockAcquireTimeoutError);
        return (0, $huFCX._)(this, NavigatorLockAcquireTimeoutError, arguments);
    }
    return NavigatorLockAcquireTimeoutError;
}($82be7713279e39ac$export$23e9464cc010dff9);
var $82be7713279e39ac$export$4b982ee840d3d915 = /*#__PURE__*/ function(LockAcquireTimeoutError) {
    "use strict";
    (0, $1atwj._)(ProcessLockAcquireTimeoutError, LockAcquireTimeoutError);
    function ProcessLockAcquireTimeoutError() {
        (0, $50OuQ._)(this, ProcessLockAcquireTimeoutError);
        return (0, $huFCX._)(this, ProcessLockAcquireTimeoutError, arguments);
    }
    return ProcessLockAcquireTimeoutError;
}($82be7713279e39ac$export$23e9464cc010dff9);
function $82be7713279e39ac$export$f4ff21938fb7af3c(name, acquireTimeout, fn) {
    return $82be7713279e39ac$var$_navigatorLock.apply(this, arguments);
}
function $82be7713279e39ac$var$_navigatorLock() {
    $82be7713279e39ac$var$_navigatorLock = (0, $5Pgs2._)(function(name, acquireTimeout, fn) {
        var abortController;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if ($82be7713279e39ac$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquire lock', name, acquireTimeout);
                    abortController = new globalThis.AbortController();
                    if (acquireTimeout > 0) setTimeout(function() {
                        abortController.abort();
                        if ($82be7713279e39ac$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock acquire timed out', name);
                    }, acquireTimeout);
                    return [
                        4,
                        Promise.resolve().then(function() {
                            return globalThis.navigator.locks.request(name, acquireTimeout === 0 ? {
                                mode: 'exclusive',
                                ifAvailable: true
                            } : {
                                mode: 'exclusive',
                                signal: abortController.signal
                            }, /*#__PURE__*/ function() {
                                var _ref = (0, $5Pgs2._)(function(lock) {
                                    var result, e;
                                    return (0, $1XfpH.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!lock) return [
                                                    3,
                                                    5
                                                ];
                                                if ($82be7713279e39ac$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: acquired', name, lock.name);
                                                _state.label = 1;
                                            case 1:
                                                _state.trys.push([
                                                    1,
                                                    ,
                                                    3,
                                                    4
                                                ]);
                                                return [
                                                    4,
                                                    fn()
                                                ];
                                            case 2:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                            case 3:
                                                if ($82be7713279e39ac$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: released', name, lock.name);
                                                return [
                                                    7
                                                ];
                                            case 4:
                                                return [
                                                    3,
                                                    12
                                                ];
                                            case 5:
                                                if (!(acquireTimeout === 0)) return [
                                                    3,
                                                    6
                                                ];
                                                if ($82be7713279e39ac$export$e368aba7747330f2.debug) console.log('@supabase/gotrue-js: navigatorLock: not immediately available', name);
                                                throw new $82be7713279e39ac$export$4aa56776043a4631('Acquiring an exclusive Navigator LockManager lock "'.concat(name, '" immediately failed'));
                                            case 6:
                                                if (!$82be7713279e39ac$export$e368aba7747330f2.debug) return [
                                                    3,
                                                    10
                                                ];
                                                _state.label = 7;
                                            case 7:
                                                _state.trys.push([
                                                    7,
                                                    9,
                                                    ,
                                                    10
                                                ]);
                                                return [
                                                    4,
                                                    globalThis.navigator.locks.query()
                                                ];
                                            case 8:
                                                result = _state.sent();
                                                console.log('@supabase/gotrue-js: Navigator LockManager state', JSON.stringify(result, null, '  '));
                                                return [
                                                    3,
                                                    10
                                                ];
                                            case 9:
                                                e = _state.sent();
                                                console.warn('@supabase/gotrue-js: Error when querying Navigator LockManager state', e);
                                                return [
                                                    3,
                                                    10
                                                ];
                                            case 10:
                                                // Browser is not following the Navigator LockManager spec, it
                                                // returned a null lock when we didn't use ifAvailable. So we can
                                                // pretend the lock is acquired in the name of backward compatibility
                                                // and user experience and just run the function.
                                                console.warn('@supabase/gotrue-js: Navigator LockManager returned a null lock when using #request without ifAvailable set to true, it appears this browser is not following the LockManager spec https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request');
                                                return [
                                                    4,
                                                    fn()
                                                ];
                                            case 11:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                            case 12:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(lock) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                        })
                    ];
                case 1:
                    // MDN article: https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request
                    // Wrapping navigator.locks.request() with a plain Promise is done as some
                    // libraries like zone.js patch the Promise object to track the execution
                    // context. However, it appears that most browsers use an internal promise
                    // implementation when using the navigator.locks.request() API causing them
                    // to lose context and emit confusing log messages or break certain features.
                    // This wrapping is believed to help zone.js track the execution context
                    // better.
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return $82be7713279e39ac$var$_navigatorLock.apply(this, arguments);
}
var $82be7713279e39ac$var$PROCESS_LOCKS = {};
function $82be7713279e39ac$export$b21ec9b2268372c7(name, acquireTimeout, fn) {
    return $82be7713279e39ac$var$_processLock.apply(this, arguments);
}
function $82be7713279e39ac$var$_processLock() {
    $82be7713279e39ac$var$_processLock = (0, $5Pgs2._)(function(name, acquireTimeout, fn) {
        var _a, previousOperation, currentOperation;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    previousOperation = (_a = $82be7713279e39ac$var$PROCESS_LOCKS[name]) !== null && _a !== void 0 ? _a : Promise.resolve();
                    currentOperation = Promise.race([
                        previousOperation["catch"](function() {
                            // ignore error of previous operation that we're waiting to finish
                            return null;
                        }),
                        acquireTimeout >= 0 ? new Promise(function(_, reject) {
                            setTimeout(function() {
                                reject(new $82be7713279e39ac$export$4b982ee840d3d915('Acquring process lock with name "'.concat(name, '" timed out')));
                            }, acquireTimeout);
                        }) : null
                    ].filter(function(x) {
                        return x;
                    }))["catch"](function(e) {
                        if (e && e.isAcquireTimeout) throw e;
                        return null;
                    }).then(/*#__PURE__*/ (0, $5Pgs2._)(function() {
                        return (0, $1XfpH.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        fn()
                                    ];
                                case 1:
                                    // previous operations finished and we didn't get a race on the acquire
                                    // timeout, so the current operation can finally start
                                    return [
                                        2,
                                        _state.sent()
                                    ];
                            }
                        });
                    }));
                    $82be7713279e39ac$var$PROCESS_LOCKS[name] = currentOperation["catch"](/*#__PURE__*/ function() {
                        var _ref = (0, $5Pgs2._)(function(e) {
                            return (0, $1XfpH.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!(e && e.isAcquireTimeout)) return [
                                            3,
                                            2
                                        ];
                                        // if the current operation timed out, it doesn't mean that the previous
                                        // operation finished, so we need contnue waiting for it to finish
                                        return [
                                            4,
                                            previousOperation
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2,
                                            null
                                        ];
                                    case 2:
                                        throw e;
                                }
                            });
                        });
                        return function(e) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    return [
                        4,
                        currentOperation
                    ];
                case 1:
                    // finally wait for the current operation to finish successfully, with an
                    // error or with an acquire timeout error
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return $82be7713279e39ac$var$_processLock.apply(this, arguments);
}


(0, $caa01daf4b9ec736$export$ad067ce270531206)(); // Make "globalThis" available
var $5134855c200492a8$var$DEFAULT_OPTIONS = {
    url: (0, $b2aad0884e88cf33$export$7fedf552187f0c3d),
    storageKey: (0, $b2aad0884e88cf33$export$86880b4b2e1a2384),
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    headers: (0, $b2aad0884e88cf33$export$88a84136db6a4b64),
    flowType: 'implicit',
    debug: false,
    hasCustomAuthorizationHeader: false
};
/** Current session will be checked for refresh at this interval. */ var $5134855c200492a8$var$AUTO_REFRESH_TICK_DURATION = 30000;
/**
 * A token refresh will be attempted this many ticks before the current session expires. */ var $5134855c200492a8$var$AUTO_REFRESH_TICK_THRESHOLD = 3;
function $5134855c200492a8$var$lockNoOp(name, acquireTimeout, fn) {
    return $5134855c200492a8$var$_lockNoOp.apply(this, arguments);
}
function $5134855c200492a8$var$_lockNoOp() {
    $5134855c200492a8$var$_lockNoOp = (0, $5Pgs2._)(function(name, acquireTimeout, fn) {
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fn()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return $5134855c200492a8$var$_lockNoOp.apply(this, arguments);
}
var $5134855c200492a8$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function GoTrueClient(options) {
        (0, $50OuQ._)(this, GoTrueClient);
        var _a, _b;
        this.memoryStorage = null;
        this.stateChangeEmitters = new Map();
        this.autoRefreshTicker = null;
        this.visibilityChangedCallback = null;
        this.refreshingDeferred = null;
        /**
         * Keeps track of the async client initialization.
         * When null or not yet resolved the auth state is `unknown`
         * Once resolved the the auth state is known and it's save to call any further client methods.
         * Keep extra care to never reject or throw uncaught errors
         */ this.initializePromise = null;
        this.detectSessionInUrl = true;
        this.hasCustomAuthorizationHeader = false;
        this.suppressGetSessionWarning = false;
        this.lockAcquired = false;
        this.pendingInLock = [];
        /**
         * Used to broadcast state change events to other tabs listening.
         */ this.broadcastChannel = null;
        this.logger = console.log;
        this.instanceID = GoTrueClient.nextInstanceID;
        GoTrueClient.nextInstanceID += 1;
        if (this.instanceID > 0 && (0, $e47a9df456bd0ac4$export$4e09c449d6c407f7)()) console.warn('Multiple GoTrueClient instances detected in the same browser context. It is not an error, but this should be avoided as it may produce undefined behavior when used concurrently under the same storage key.');
        var settings = Object.assign(Object.assign({}, $5134855c200492a8$var$DEFAULT_OPTIONS), options);
        this.logDebugMessages = !!settings.debug;
        if (typeof settings.debug === 'function') this.logger = settings.debug;
        this.persistSession = settings.persistSession;
        this.storageKey = settings.storageKey;
        this.autoRefreshToken = settings.autoRefreshToken;
        this.admin = new (0, $edafeda94c9906ac$export$2e2bcd8739ae039)({
            url: settings.url,
            headers: settings.headers,
            fetch: settings.fetch
        });
        this.url = settings.url;
        this.headers = settings.headers;
        this.fetch = (0, $e47a9df456bd0ac4$export$98d92b1aa79f8cc7)(settings.fetch);
        this.lock = settings.lock || $5134855c200492a8$var$lockNoOp;
        this.detectSessionInUrl = settings.detectSessionInUrl;
        this.flowType = settings.flowType;
        this.hasCustomAuthorizationHeader = settings.hasCustomAuthorizationHeader;
        if (settings.lock) this.lock = settings.lock;
        else if ((0, $e47a9df456bd0ac4$export$4e09c449d6c407f7)() && ((_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.navigator) === null || _a === void 0 ? void 0 : _a.locks)) this.lock = (0, $82be7713279e39ac$export$f4ff21938fb7af3c);
        else this.lock = $5134855c200492a8$var$lockNoOp;
        this.mfa = {
            verify: this._verify.bind(this),
            enroll: this._enroll.bind(this),
            unenroll: this._unenroll.bind(this),
            challenge: this._challenge.bind(this),
            listFactors: this._listFactors.bind(this),
            challengeAndVerify: this._challengeAndVerify.bind(this),
            getAuthenticatorAssuranceLevel: this._getAuthenticatorAssuranceLevel.bind(this)
        };
        if (this.persistSession) {
            if (settings.storage) this.storage = settings.storage;
            else if ((0, $e47a9df456bd0ac4$export$9ec034ee80211814)()) this.storage = (0, $88a68460b4a3d13a$export$bba7b6c94612d04b);
            else {
                this.memoryStorage = {};
                this.storage = (0, $88a68460b4a3d13a$export$d791f66d7e5710cf)(this.memoryStorage);
            }
        } else {
            this.memoryStorage = {};
            this.storage = (0, $88a68460b4a3d13a$export$d791f66d7e5710cf)(this.memoryStorage);
        }
        if ((0, $e47a9df456bd0ac4$export$4e09c449d6c407f7)() && globalThis.BroadcastChannel && this.persistSession && this.storageKey) {
            try {
                this.broadcastChannel = new globalThis.BroadcastChannel(this.storageKey);
            } catch (e) {
                console.error('Failed to create a new BroadcastChannel, multi-tab state changes will not be available', e);
            }
            var _this = this;
            (_b = this.broadcastChannel) === null || _b === void 0 || _b.addEventListener('message', /*#__PURE__*/ function() {
                var _ref = (0, $5Pgs2._)(function(event) {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this._debug('received broadcast notification from other tab or client', event);
                                return [
                                    4,
                                    _this._notifyAllSubscribers(event.data.event, event.data.session, false)
                                ];
                            case 1:
                                _state.sent(); // broadcast = false so we don't get an endless loop of messages
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(event) {
                    return _ref.apply(this, arguments);
                };
            }());
        }
        this.initialize();
    }
    (0, $fGdZr._)(GoTrueClient, [
        {
            key: "_debug",
            value: function _debug() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                if (this.logDebugMessages) this.logger.apply(this, [
                    "GoTrueClient@".concat(this.instanceID, " (").concat((0, $7e12a7bc19ec358b$export$83d89fbfd8236492), ") ").concat(new Date().toISOString())
                ].concat((0, $dHvbf._)(args)));
                return this;
            }
        },
        {
            key: "initialize",
            value: /**
     * Initializes the client session either from the url or from storage.
     * This method is automatically called when instantiating the client, but should also be called
     * manually when checking for an error from an auth redirect (oauth, magiclink, password recovery, etc).
     */ function initialize() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.initializePromise) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.initializePromise
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                _this.initializePromise = (0, $5Pgs2._)(function() {
                                    return (0, $1XfpH.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    _this._acquireLock(-1, /*#__PURE__*/ (0, $5Pgs2._)(function() {
                                                        return (0, $1XfpH.__generator)(this, function(_state) {
                                                            switch(_state.label){
                                                                case 0:
                                                                    return [
                                                                        4,
                                                                        _this._initialize()
                                                                    ];
                                                                case 1:
                                                                    return [
                                                                        2,
                                                                        _state.sent()
                                                                    ];
                                                            }
                                                        });
                                                    }))
                                                ];
                                            case 1:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                        }
                                    });
                                })();
                                return [
                                    4,
                                    _this.initializePromise
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_initialize",
            value: /**
     * IMPORTANT:
     * 1. Never throw in this method, as it is called from the constructor
     * 2. Never return a session from this method as it would be cached over
     *    the whole lifetime of the client
     */ function _initialize() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _a, params, callbackUrlType, _ref, data, _$error, errorCode, session, redirectType, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    10,
                                    11,
                                    13
                                ]);
                                params = (0, $e47a9df456bd0ac4$export$7a29392fb778224c)(window.location.href);
                                callbackUrlType = 'none';
                                if (!_this._isImplicitGrantCallback(params)) return [
                                    3,
                                    1
                                ];
                                callbackUrlType = 'implicit';
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                return [
                                    4,
                                    _this._isPKCECallback(params)
                                ];
                            case 2:
                                if (_state.sent()) callbackUrlType = 'pkce';
                                _state.label = 3;
                            case 3:
                                if (!((0, $e47a9df456bd0ac4$export$4e09c449d6c407f7)() && _this.detectSessionInUrl && callbackUrlType !== 'none')) return [
                                    3,
                                    8
                                ];
                                return [
                                    4,
                                    _this._getSessionFromURL(params, callbackUrlType)
                                ];
                            case 4:
                                _ref = _state.sent(), data = _ref.data, _$error = _ref.error;
                                if (!_$error) return [
                                    3,
                                    6
                                ];
                                _this._debug('#_initialize()', 'error detecting session from URL', _$error);
                                if ((0, $73f5e58330057bc1$export$45edea3999507afd)(_$error)) {
                                    errorCode = (_a = _$error.details) === null || _a === void 0 ? void 0 : _a.code;
                                    if (errorCode === 'identity_already_exists' || errorCode === 'identity_not_found' || errorCode === 'single_identity_not_deletable') return [
                                        2,
                                        {
                                            error: _$error
                                        }
                                    ];
                                }
                                // failed login attempt via url,
                                // remove old session as in verifyOtp, signUp and signInWith*
                                return [
                                    4,
                                    _this._removeSession()
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    2,
                                    {
                                        error: _$error
                                    }
                                ];
                            case 6:
                                session = data.session, redirectType = data.redirectType;
                                _this._debug('#_initialize()', 'detected session in URL', session, 'redirect type', redirectType);
                                return [
                                    4,
                                    _this._saveSession(session)
                                ];
                            case 7:
                                _state.sent();
                                setTimeout(/*#__PURE__*/ (0, $5Pgs2._)(function() {
                                    return (0, $1XfpH.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!(redirectType === 'recovery')) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    _this._notifyAllSubscribers('PASSWORD_RECOVERY', session)
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 2:
                                                return [
                                                    4,
                                                    _this._notifyAllSubscribers('SIGNED_IN', session)
                                                ];
                                            case 3:
                                                _state.sent();
                                                _state.label = 4;
                                            case 4:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }), 0);
                                return [
                                    2,
                                    {
                                        error: null
                                    }
                                ];
                            case 8:
                                // no login attempt via callback url try to recover session from storage
                                return [
                                    4,
                                    _this._recoverAndRefresh()
                                ];
                            case 9:
                                _state.sent();
                                return [
                                    2,
                                    {
                                        error: null
                                    }
                                ];
                            case 10:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        error: error
                                    }
                                ];
                                return [
                                    2,
                                    {
                                        error: new (0, $73f5e58330057bc1$export$f7559805d4a50078)('Unexpected error during initialization', error)
                                    }
                                ];
                            case 11:
                                return [
                                    4,
                                    _this._handleVisibilityChange()
                                ];
                            case 12:
                                _state.sent();
                                _this._debug('#_initialize()', 'end');
                                return [
                                    7
                                ];
                            case 13:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signInAnonymously",
            value: /**
     * Creates a new anonymous user.
     *
     * @returns A session where the is_anonymous claim in the access token JWT set to true
     */ function signInAnonymously(credentials) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _a, _b, _c, res, data, _$error, session, user, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'POST', "".concat(_this.url, "/signup"), {
                                        headers: _this.headers,
                                        body: {
                                            data: (_b = (_a = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : {},
                                            gotrue_meta_security: {
                                                captcha_token: (_c = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _c === void 0 ? void 0 : _c.captchaToken
                                            }
                                        },
                                        xform: (0, $cc4d33f36ba2dab3$export$273fe4673a018c2e)
                                    })
                                ];
                            case 1:
                                res = _state.sent();
                                data = res.data, _$error = res.error;
                                if (_$error || !data) return [
                                    2,
                                    {
                                        data: {
                                            user: null,
                                            session: null
                                        },
                                        error: _$error
                                    }
                                ];
                                session = data.session;
                                user = data.user;
                                if (!data.session) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this._saveSession(data.session)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    _this._notifyAllSubscribers('SIGNED_IN', session)
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    2,
                                    {
                                        data: {
                                            user: user,
                                            session: session
                                        },
                                        error: null
                                    }
                                ];
                            case 5:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: {
                                            user: null,
                                            session: null
                                        },
                                        error: error
                                    }
                                ];
                                throw error;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signUp",
            value: /**
     * Creates a new user.
     *
     * Be aware that if a user account exists in the system you may get back an
     * error message that attempts to hide this information from the user.
     * This method has support for PKCE via email signups. The PKCE flow cannot be used when autoconfirm is enabled.
     *
     * @returns A logged-in session if the server has "autoconfirm" ON
     * @returns A user if the server has "autoconfirm" OFF
     */ function signUp(credentials) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _a, _b, _c, res, email, password, options, codeChallenge, codeChallengeMethod, ref, phone, password1, options1, data, _$error, session, user, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    11,
                                    ,
                                    12
                                ]);
                                if (!('email' in credentials)) return [
                                    3,
                                    4
                                ];
                                email = credentials.email, password = credentials.password, options = credentials.options;
                                codeChallenge = null;
                                codeChallengeMethod = null;
                                if (!(_this.flowType === 'pkce')) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (0, $e47a9df456bd0ac4$export$81b177cadfcf873c)(_this.storage, _this.storageKey)
                                ];
                            case 1:
                                ref = (0, $aSMts._).apply(void 0, [
                                    _state.sent(),
                                    2
                                ]), codeChallenge = ref[0], codeChallengeMethod = ref[1], ref;
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'POST', "".concat(_this.url, "/signup"), {
                                        headers: _this.headers,
                                        redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                                        body: {
                                            email: email,
                                            password: password,
                                            data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                                            gotrue_meta_security: {
                                                captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                                            },
                                            code_challenge: codeChallenge,
                                            code_challenge_method: codeChallengeMethod
                                        },
                                        xform: (0, $cc4d33f36ba2dab3$export$273fe4673a018c2e)
                                    })
                                ];
                            case 3:
                                res = _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 4:
                                if (!('phone' in credentials)) return [
                                    3,
                                    6
                                ];
                                phone = credentials.phone, password1 = credentials.password, options1 = credentials.options;
                                return [
                                    4,
                                    (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'POST', "".concat(_this.url, "/signup"), {
                                        headers: _this.headers,
                                        body: {
                                            phone: phone,
                                            password: password1,
                                            data: (_b = options1 === null || options1 === void 0 ? void 0 : options1.data) !== null && _b !== void 0 ? _b : {},
                                            channel: (_c = options1 === null || options1 === void 0 ? void 0 : options1.channel) !== null && _c !== void 0 ? _c : 'sms',
                                            gotrue_meta_security: {
                                                captcha_token: options1 === null || options1 === void 0 ? void 0 : options1.captchaToken
                                            }
                                        },
                                        xform: (0, $cc4d33f36ba2dab3$export$273fe4673a018c2e)
                                    })
                                ];
                            case 5:
                                res = _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                throw new (0, $73f5e58330057bc1$export$9ef583f0381b4cc)('You must provide either an email or phone number and a password');
                            case 7:
                                data = res.data, _$error = res.error;
                                if (_$error || !data) return [
                                    2,
                                    {
                                        data: {
                                            user: null,
                                            session: null
                                        },
                                        error: _$error
                                    }
                                ];
                                session = data.session;
                                user = data.user;
                                if (!data.session) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _this._saveSession(data.session)
                                ];
                            case 8:
                                _state.sent();
                                return [
                                    4,
                                    _this._notifyAllSubscribers('SIGNED_IN', session)
                                ];
                            case 9:
                                _state.sent();
                                _state.label = 10;
                            case 10:
                                return [
                                    2,
                                    {
                                        data: {
                                            user: user,
                                            session: session
                                        },
                                        error: null
                                    }
                                ];
                            case 11:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: {
                                            user: null,
                                            session: null
                                        },
                                        error: error
                                    }
                                ];
                                throw error;
                            case 12:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signInWithPassword",
            value: /**
     * Log in an existing user with an email and password or phone and password.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or that the
     * email/phone and password combination is wrong or that the account can only
     * be accessed via social login.
     */ function signInWithPassword(credentials) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var res, email, password, options, phone, password1, options1, data, _$error, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    9,
                                    ,
                                    10
                                ]);
                                if (!('email' in credentials)) return [
                                    3,
                                    2
                                ];
                                email = credentials.email, password = credentials.password, options = credentials.options;
                                return [
                                    4,
                                    (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'POST', "".concat(_this.url, "/token?grant_type=password"), {
                                        headers: _this.headers,
                                        body: {
                                            email: email,
                                            password: password,
                                            gotrue_meta_security: {
                                                captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                                            }
                                        },
                                        xform: (0, $cc4d33f36ba2dab3$export$db83aade1c2922c7)
                                    })
                                ];
                            case 1:
                                res = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 2:
                                if (!('phone' in credentials)) return [
                                    3,
                                    4
                                ];
                                phone = credentials.phone, password1 = credentials.password, options1 = credentials.options;
                                return [
                                    4,
                                    (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'POST', "".concat(_this.url, "/token?grant_type=password"), {
                                        headers: _this.headers,
                                        body: {
                                            phone: phone,
                                            password: password1,
                                            gotrue_meta_security: {
                                                captcha_token: options1 === null || options1 === void 0 ? void 0 : options1.captchaToken
                                            }
                                        },
                                        xform: (0, $cc4d33f36ba2dab3$export$db83aade1c2922c7)
                                    })
                                ];
                            case 3:
                                res = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                throw new (0, $73f5e58330057bc1$export$9ef583f0381b4cc)('You must provide either an email or phone number and a password');
                            case 5:
                                data = res.data, _$error = res.error;
                                if (_$error) return [
                                    2,
                                    {
                                        data: {
                                            user: null,
                                            session: null
                                        },
                                        error: _$error
                                    }
                                ];
                                else if (!data || !data.session || !data.user) return [
                                    2,
                                    {
                                        data: {
                                            user: null,
                                            session: null
                                        },
                                        error: new (0, $73f5e58330057bc1$export$7e277b620449c1b4)()
                                    }
                                ];
                                if (!data.session) return [
                                    3,
                                    8
                                ];
                                return [
                                    4,
                                    _this._saveSession(data.session)
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    4,
                                    _this._notifyAllSubscribers('SIGNED_IN', data.session)
                                ];
                            case 7:
                                _state.sent();
                                _state.label = 8;
                            case 8:
                                return [
                                    2,
                                    {
                                        data: Object.assign({
                                            user: data.user,
                                            session: data.session
                                        }, data.weak_password ? {
                                            weakPassword: data.weak_password
                                        } : null),
                                        error: _$error
                                    }
                                ];
                            case 9:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: {
                                            user: null,
                                            session: null
                                        },
                                        error: error
                                    }
                                ];
                                throw error;
                            case 10:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signInWithOAuth",
            value: /**
     * Log in an existing user via a third-party provider.
     * This method supports the PKCE flow.
     */ function signInWithOAuth(credentials) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _a, _b, _c, _d;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._handleProviderSignIn(credentials.provider, {
                                        redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
                                        scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
                                        queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
                                        skipBrowserRedirect: (_d = credentials.options) === null || _d === void 0 ? void 0 : _d.skipBrowserRedirect
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "exchangeCodeForSession",
            value: /**
     * Log in an existing user by exchanging an Auth Code issued during the PKCE flow.
     */ function exchangeCodeForSession(authCode) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.initializePromise
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    _this._acquireLock(-1, /*#__PURE__*/ (0, $5Pgs2._)(function() {
                                        return (0, $1XfpH.__generator)(this, function(_state) {
                                            return [
                                                2,
                                                _this._exchangeCodeForSession(authCode)
                                            ];
                                        });
                                    }))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_exchangeCodeForSession",
            value: function _exchangeCodeForSession(authCode) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var storageItem, _split, codeVerifier, redirectType, _ref, data, _$error, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $e47a9df456bd0ac4$export$ba6fcb7c333d32c0)(_this.storage, "".concat(_this.storageKey, "-code-verifier"))
                                ];
                            case 1:
                                storageItem = _state.sent();
                                _split = (0, $aSMts._)((storageItem !== null && storageItem !== void 0 ? storageItem : '').split('/'), 2), codeVerifier = _split[0], redirectType = _split[1];
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    8,
                                    ,
                                    9
                                ]);
                                return [
                                    4,
                                    (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'POST', "".concat(_this.url, "/token?grant_type=pkce"), {
                                        headers: _this.headers,
                                        body: {
                                            auth_code: authCode,
                                            code_verifier: codeVerifier
                                        },
                                        xform: (0, $cc4d33f36ba2dab3$export$273fe4673a018c2e)
                                    })
                                ];
                            case 3:
                                _ref = _state.sent(), data = _ref.data, _$error = _ref.error;
                                return [
                                    4,
                                    (0, $e47a9df456bd0ac4$export$d35c645d585317ec)(_this.storage, "".concat(_this.storageKey, "-code-verifier"))
                                ];
                            case 4:
                                _state.sent();
                                if (_$error) throw _$error;
                                if (!data || !data.session || !data.user) return [
                                    2,
                                    {
                                        data: {
                                            user: null,
                                            session: null,
                                            redirectType: null
                                        },
                                        error: new (0, $73f5e58330057bc1$export$7e277b620449c1b4)()
                                    }
                                ];
                                if (!data.session) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    _this._saveSession(data.session)
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    4,
                                    _this._notifyAllSubscribers('SIGNED_IN', data.session)
                                ];
                            case 6:
                                _state.sent();
                                _state.label = 7;
                            case 7:
                                return [
                                    2,
                                    {
                                        data: Object.assign(Object.assign({}, data), {
                                            redirectType: redirectType !== null && redirectType !== void 0 ? redirectType : null
                                        }),
                                        error: _$error
                                    }
                                ];
                            case 8:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: {
                                            user: null,
                                            session: null,
                                            redirectType: null
                                        },
                                        error: error
                                    }
                                ];
                                throw error;
                            case 9:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signInWithIdToken",
            value: /**
     * Allows signing in with an OIDC ID token. The authentication provider used
     * should be enabled and configured.
     */ function signInWithIdToken(credentials) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var options, provider, token, access_token, nonce, res, data, _$error, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    5,
                                    ,
                                    6
                                ]);
                                options = credentials.options, provider = credentials.provider, token = credentials.token, access_token = credentials.access_token, nonce = credentials.nonce;
                                return [
                                    4,
                                    (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'POST', "".concat(_this.url, "/token?grant_type=id_token"), {
                                        headers: _this.headers,
                                        body: {
                                            provider: provider,
                                            id_token: token,
                                            access_token: access_token,
                                            nonce: nonce,
                                            gotrue_meta_security: {
                                                captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                                            }
                                        },
                                        xform: (0, $cc4d33f36ba2dab3$export$273fe4673a018c2e)
                                    })
                                ];
                            case 1:
                                res = _state.sent();
                                data = res.data, _$error = res.error;
                                if (_$error) return [
                                    2,
                                    {
                                        data: {
                                            user: null,
                                            session: null
                                        },
                                        error: _$error
                                    }
                                ];
                                else if (!data || !data.session || !data.user) return [
                                    2,
                                    {
                                        data: {
                                            user: null,
                                            session: null
                                        },
                                        error: new (0, $73f5e58330057bc1$export$7e277b620449c1b4)()
                                    }
                                ];
                                if (!data.session) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this._saveSession(data.session)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    _this._notifyAllSubscribers('SIGNED_IN', data.session)
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    2,
                                    {
                                        data: data,
                                        error: _$error
                                    }
                                ];
                            case 5:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: {
                                            user: null,
                                            session: null
                                        },
                                        error: error
                                    }
                                ];
                                throw error;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signInWithOtp",
            value: /**
     * Log in a user using magiclink or a one-time password (OTP).
     *
     * If the `{{ .ConfirmationURL }}` variable is specified in the email template, a magiclink will be sent.
     * If the `{{ .Token }}` variable is specified in the email template, an OTP will be sent.
     * If you're using phone sign-ins, only an OTP will be sent. You won't be able to send a magiclink for phone sign-ins.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or, that the account
     * can only be accessed via social login.
     *
     * Do note that you will need to configure a Whatsapp sender on Twilio
     * if you are using phone sign in with the 'whatsapp' channel. The whatsapp
     * channel is not supported on other providers
     * at this time.
     * This method supports PKCE when an email is passed.
     */ function signInWithOtp(credentials) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _a, _b, _c, _d, _e, email, options, codeChallenge, codeChallengeMethod, ref, _$error, phone, options1, _ref, data, _$error1, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    7,
                                    ,
                                    8
                                ]);
                                if (!('email' in credentials)) return [
                                    3,
                                    4
                                ];
                                email = credentials.email, options = credentials.options;
                                codeChallenge = null;
                                codeChallengeMethod = null;
                                if (!(_this.flowType === 'pkce')) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (0, $e47a9df456bd0ac4$export$81b177cadfcf873c)(_this.storage, _this.storageKey)
                                ];
                            case 1:
                                ref = (0, $aSMts._).apply(void 0, [
                                    _state.sent(),
                                    2
                                ]), codeChallenge = ref[0], codeChallengeMethod = ref[1], ref;
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'POST', "".concat(_this.url, "/otp"), {
                                        headers: _this.headers,
                                        body: {
                                            email: email,
                                            data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                                            create_user: (_b = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _b !== void 0 ? _b : true,
                                            gotrue_meta_security: {
                                                captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                                            },
                                            code_challenge: codeChallenge,
                                            code_challenge_method: codeChallengeMethod
                                        },
                                        redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                                    })
                                ];
                            case 3:
                                _$error = _state.sent().error;
                                return [
                                    2,
                                    {
                                        data: {
                                            user: null,
                                            session: null
                                        },
                                        error: _$error
                                    }
                                ];
                            case 4:
                                if (!('phone' in credentials)) return [
                                    3,
                                    6
                                ];
                                phone = credentials.phone, options1 = credentials.options;
                                return [
                                    4,
                                    (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'POST', "".concat(_this.url, "/otp"), {
                                        headers: _this.headers,
                                        body: {
                                            phone: phone,
                                            data: (_c = options1 === null || options1 === void 0 ? void 0 : options1.data) !== null && _c !== void 0 ? _c : {},
                                            create_user: (_d = options1 === null || options1 === void 0 ? void 0 : options1.shouldCreateUser) !== null && _d !== void 0 ? _d : true,
                                            gotrue_meta_security: {
                                                captcha_token: options1 === null || options1 === void 0 ? void 0 : options1.captchaToken
                                            },
                                            channel: (_e = options1 === null || options1 === void 0 ? void 0 : options1.channel) !== null && _e !== void 0 ? _e : 'sms'
                                        }
                                    })
                                ];
                            case 5:
                                _ref = _state.sent(), data = _ref.data, _$error1 = _ref.error;
                                return [
                                    2,
                                    {
                                        data: {
                                            user: null,
                                            session: null,
                                            messageId: data === null || data === void 0 ? void 0 : data.message_id
                                        },
                                        error: _$error1
                                    }
                                ];
                            case 6:
                                throw new (0, $73f5e58330057bc1$export$9ef583f0381b4cc)('You must provide either an email or phone number.');
                            case 7:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: {
                                            user: null,
                                            session: null
                                        },
                                        error: error
                                    }
                                ];
                                throw error;
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "verifyOtp",
            value: /**
     * Log in a user given a User supplied OTP or TokenHash received through mobile or email.
     */ function verifyOtp(params) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _a, _b, redirectTo, captchaToken, _ref, data, _$error, session, user, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    5,
                                    ,
                                    6
                                ]);
                                redirectTo = undefined;
                                captchaToken = undefined;
                                if ('options' in params) {
                                    redirectTo = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo;
                                    captchaToken = (_b = params.options) === null || _b === void 0 ? void 0 : _b.captchaToken;
                                }
                                return [
                                    4,
                                    (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'POST', "".concat(_this.url, "/verify"), {
                                        headers: _this.headers,
                                        body: Object.assign(Object.assign({}, params), {
                                            gotrue_meta_security: {
                                                captcha_token: captchaToken
                                            }
                                        }),
                                        redirectTo: redirectTo,
                                        xform: (0, $cc4d33f36ba2dab3$export$273fe4673a018c2e)
                                    })
                                ];
                            case 1:
                                _ref = _state.sent(), data = _ref.data, _$error = _ref.error;
                                if (_$error) throw _$error;
                                if (!data) throw new Error('An error occurred on token verification.');
                                session = data.session;
                                user = data.user;
                                if (!(session === null || session === void 0 ? void 0 : session.access_token)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this._saveSession(session)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    _this._notifyAllSubscribers(params.type == 'recovery' ? 'PASSWORD_RECOVERY' : 'SIGNED_IN', session)
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    2,
                                    {
                                        data: {
                                            user: user,
                                            session: session
                                        },
                                        error: null
                                    }
                                ];
                            case 5:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: {
                                            user: null,
                                            session: null
                                        },
                                        error: error
                                    }
                                ];
                                throw error;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signInWithSSO",
            value: /**
     * Attempts a single-sign on using an enterprise Identity Provider. A
     * successful SSO attempt will redirect the current page to the identity
     * provider authorization page. The redirect URL is implementation and SSO
     * protocol specific.
     *
     * You can use it by providing a SSO domain. Typically you can extract this
     * domain by asking users for their email address. If this domain is
     * registered on the Auth instance the redirect will use that organization's
     * currently active SSO Identity Provider for the login.
     *
     * If you have built an organization-specific login page, you can use the
     * organization's SSO Identity Provider UUID directly instead.
     */ function signInWithSSO(params) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _a, _b, _c, codeChallenge, codeChallengeMethod, ref, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    4,
                                    ,
                                    5
                                ]);
                                codeChallenge = null;
                                codeChallengeMethod = null;
                                if (!(_this.flowType === 'pkce')) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (0, $e47a9df456bd0ac4$export$81b177cadfcf873c)(_this.storage, _this.storageKey)
                                ];
                            case 1:
                                ref = (0, $aSMts._).apply(void 0, [
                                    _state.sent(),
                                    2
                                ]), codeChallenge = ref[0], codeChallengeMethod = ref[1], ref;
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'POST', "".concat(_this.url, "/sso"), {
                                        body: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, 'providerId' in params ? {
                                            provider_id: params.providerId
                                        } : null), 'domain' in params ? {
                                            domain: params.domain
                                        } : null), {
                                            redirect_to: (_b = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo) !== null && _b !== void 0 ? _b : undefined
                                        }), ((_c = params === null || params === void 0 ? void 0 : params.options) === null || _c === void 0 ? void 0 : _c.captchaToken) ? {
                                            gotrue_meta_security: {
                                                captcha_token: params.options.captchaToken
                                            }
                                        } : null), {
                                            skip_http_redirect: true,
                                            code_challenge: codeChallenge,
                                            code_challenge_method: codeChallengeMethod
                                        }),
                                        headers: _this.headers,
                                        xform: (0, $cc4d33f36ba2dab3$export$b04785c46dcd8f8b)
                                    })
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 4:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                                throw error;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "reauthenticate",
            value: /**
     * Sends a reauthentication OTP to the user's email or phone number.
     * Requires the user to be signed-in.
     */ function reauthenticate() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.initializePromise
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this._acquireLock(-1, /*#__PURE__*/ (0, $5Pgs2._)(function() {
                                        return (0, $1XfpH.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        _this._reauthenticate()
                                                    ];
                                                case 1:
                                                    return [
                                                        2,
                                                        _state.sent()
                                                    ];
                                            }
                                        });
                                    }))
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_reauthenticate",
            value: function _reauthenticate() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this._useSession(/*#__PURE__*/ function() {
                                        var _ref = (0, $5Pgs2._)(function(result) {
                                            var session, sessionError, _$error;
                                            return (0, $1XfpH.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        session = result.data.session, sessionError = result.error;
                                                        if (sessionError) throw sessionError;
                                                        if (!session) throw new (0, $73f5e58330057bc1$export$403b3fc0d3ad5f0c)();
                                                        return [
                                                            4,
                                                            (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'GET', "".concat(_this.url, "/reauthenticate"), {
                                                                headers: _this.headers,
                                                                jwt: session.access_token
                                                            })
                                                        ];
                                                    case 1:
                                                        _$error = _state.sent().error;
                                                        return [
                                                            2,
                                                            {
                                                                data: {
                                                                    user: null,
                                                                    session: null
                                                                },
                                                                error: _$error
                                                            }
                                                        ];
                                                }
                                            });
                                        });
                                        return function(result) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: {
                                            user: null,
                                            session: null
                                        },
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "resend",
            value: /**
     * Resends an existing signup confirmation email, email change email, SMS OTP or phone change OTP.
     */ function resend(credentials) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var endpoint, email, type, options, _$error, phone, type1, options1, _ref, data, _$error1, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    5,
                                    ,
                                    6
                                ]);
                                endpoint = "".concat(_this.url, "/resend");
                                if (!('email' in credentials)) return [
                                    3,
                                    2
                                ];
                                email = credentials.email, type = credentials.type, options = credentials.options;
                                return [
                                    4,
                                    (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'POST', endpoint, {
                                        headers: _this.headers,
                                        body: {
                                            email: email,
                                            type: type,
                                            gotrue_meta_security: {
                                                captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                                            }
                                        },
                                        redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                                    })
                                ];
                            case 1:
                                _$error = _state.sent().error;
                                return [
                                    2,
                                    {
                                        data: {
                                            user: null,
                                            session: null
                                        },
                                        error: _$error
                                    }
                                ];
                            case 2:
                                if (!('phone' in credentials)) return [
                                    3,
                                    4
                                ];
                                phone = credentials.phone, type1 = credentials.type, options1 = credentials.options;
                                return [
                                    4,
                                    (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'POST', endpoint, {
                                        headers: _this.headers,
                                        body: {
                                            phone: phone,
                                            type: type1,
                                            gotrue_meta_security: {
                                                captcha_token: options1 === null || options1 === void 0 ? void 0 : options1.captchaToken
                                            }
                                        }
                                    })
                                ];
                            case 3:
                                _ref = _state.sent(), data = _ref.data, _$error1 = _ref.error;
                                return [
                                    2,
                                    {
                                        data: {
                                            user: null,
                                            session: null,
                                            messageId: data === null || data === void 0 ? void 0 : data.message_id
                                        },
                                        error: _$error1
                                    }
                                ];
                            case 4:
                                throw new (0, $73f5e58330057bc1$export$9ef583f0381b4cc)('You must provide either an email or phone number and a type');
                            case 5:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: {
                                            user: null,
                                            session: null
                                        },
                                        error: error
                                    }
                                ];
                                throw error;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSession",
            value: /**
     * Returns the session, refreshing it if necessary.
     *
     * The session returned can be null if the session is not detected which can happen in the event a user is not signed-in or has logged out.
     *
     * **IMPORTANT:** This method loads values directly from the storage attached
     * to the client. If that storage is based on request cookies for example,
     * the values in it may not be authentic and therefore it's strongly advised
     * against using this method and its results in such circumstances. A warning
     * will be emitted if this is detected. Use {@link #getUser()} instead.
     */ function getSession() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var result;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.initializePromise
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this._acquireLock(-1, /*#__PURE__*/ (0, $5Pgs2._)(function() {
                                        return (0, $1XfpH.__generator)(this, function(_state) {
                                            return [
                                                2,
                                                _this._useSession(/*#__PURE__*/ function() {
                                                    var _ref = (0, $5Pgs2._)(function(result) {
                                                        return (0, $1XfpH.__generator)(this, function(_state) {
                                                            return [
                                                                2,
                                                                result
                                                            ];
                                                        });
                                                    });
                                                    return function(result) {
                                                        return _ref.apply(this, arguments);
                                                    };
                                                }())
                                            ];
                                        });
                                    }))
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_acquireLock",
            value: /**
     * Acquires a global lock based on the storage key.
     */ function _acquireLock(acquireTimeout, fn) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var last, result;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this._debug('#_acquireLock', 'begin', acquireTimeout);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    ,
                                    3,
                                    4
                                ]);
                                if (_this.lockAcquired) {
                                    last = _this.pendingInLock.length ? _this.pendingInLock[_this.pendingInLock.length - 1] : Promise.resolve();
                                    result = (0, $5Pgs2._)(function() {
                                        return (0, $1XfpH.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        last
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        4,
                                                        fn()
                                                    ];
                                                case 2:
                                                    return [
                                                        2,
                                                        _state.sent()
                                                    ];
                                            }
                                        });
                                    })();
                                    _this.pendingInLock.push((0, $5Pgs2._)(function() {
                                        var e;
                                        return (0, $1XfpH.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    _state.trys.push([
                                                        0,
                                                        2,
                                                        ,
                                                        3
                                                    ]);
                                                    return [
                                                        4,
                                                        result
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        3,
                                                        3
                                                    ];
                                                case 2:
                                                    e = _state.sent();
                                                    return [
                                                        3,
                                                        3
                                                    ];
                                                case 3:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    })());
                                    return [
                                        2,
                                        result
                                    ];
                                }
                                return [
                                    4,
                                    _this.lock("lock:".concat(_this.storageKey), acquireTimeout, /*#__PURE__*/ (0, $5Pgs2._)(function() {
                                        var result, waitOn;
                                        return (0, $1XfpH.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    _this._debug('#_acquireLock', 'lock acquired for storage key', _this.storageKey);
                                                    _state.label = 1;
                                                case 1:
                                                    _state.trys.push([
                                                        1,
                                                        ,
                                                        7,
                                                        8
                                                    ]);
                                                    _this.lockAcquired = true;
                                                    result = fn();
                                                    _this.pendingInLock.push((0, $5Pgs2._)(function() {
                                                        var e;
                                                        return (0, $1XfpH.__generator)(this, function(_state) {
                                                            switch(_state.label){
                                                                case 0:
                                                                    _state.trys.push([
                                                                        0,
                                                                        2,
                                                                        ,
                                                                        3
                                                                    ]);
                                                                    return [
                                                                        4,
                                                                        result
                                                                    ];
                                                                case 1:
                                                                    _state.sent();
                                                                    return [
                                                                        3,
                                                                        3
                                                                    ];
                                                                case 2:
                                                                    e = _state.sent();
                                                                    return [
                                                                        3,
                                                                        3
                                                                    ];
                                                                case 3:
                                                                    return [
                                                                        2
                                                                    ];
                                                            }
                                                        });
                                                    })());
                                                    return [
                                                        4,
                                                        result
                                                    ];
                                                case 2:
                                                    _state.sent();
                                                    _state.label = 3;
                                                case 3:
                                                    if (!_this.pendingInLock.length) return [
                                                        3,
                                                        5
                                                    ];
                                                    waitOn = (0, $dHvbf._)(_this.pendingInLock);
                                                    return [
                                                        4,
                                                        Promise.all(waitOn)
                                                    ];
                                                case 4:
                                                    _state.sent();
                                                    _this.pendingInLock.splice(0, waitOn.length);
                                                    return [
                                                        3,
                                                        3
                                                    ];
                                                case 5:
                                                    return [
                                                        4,
                                                        result
                                                    ];
                                                case 6:
                                                    return [
                                                        2,
                                                        _state.sent()
                                                    ];
                                                case 7:
                                                    _this._debug('#_acquireLock', 'lock released for storage key', _this.storageKey);
                                                    _this.lockAcquired = false;
                                                    return [
                                                        7
                                                    ];
                                                case 8:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }))
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                _this._debug('#_acquireLock', 'end');
                                return [
                                    7
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_useSession",
            value: /**
     * Use instead of {@link #getSession} inside the library. It is
     * semantically usually what you want, as getting a session involves some
     * processing afterwards that requires only one client operating on the
     * session at once across multiple tabs or processes.
     */ function _useSession(fn) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var result;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this._debug('#_useSession', 'begin');
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    ,
                                    4,
                                    5
                                ]);
                                return [
                                    4,
                                    _this.__loadSession()
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    4,
                                    fn(result)
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 4:
                                _this._debug('#_useSession', 'end');
                                return [
                                    7
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "__loadSession",
            value: /**
     * NEVER USE DIRECTLY!
     *
     * Always use {@link #_useSession}.
     */ function __loadSession() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var currentSession, maybeSession, hasExpired, suppressWarning, proxySession, _ref, session, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this._debug('#__loadSession()', 'begin');
                                if (!_this.lockAcquired) _this._debug('#__loadSession()', 'used outside of an acquired lock!', new Error().stack);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    ,
                                    7,
                                    8
                                ]);
                                currentSession = null;
                                return [
                                    4,
                                    (0, $e47a9df456bd0ac4$export$ba6fcb7c333d32c0)(_this.storage, _this.storageKey)
                                ];
                            case 2:
                                maybeSession = _state.sent();
                                _this._debug('#getSession()', 'session from storage', maybeSession);
                                if (!(maybeSession !== null)) return [
                                    3,
                                    5
                                ];
                                if (!_this._isValidSession(maybeSession)) return [
                                    3,
                                    3
                                ];
                                currentSession = maybeSession;
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                _this._debug('#getSession()', 'session from storage is not valid');
                                return [
                                    4,
                                    _this._removeSession()
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                if (!currentSession) return [
                                    2,
                                    {
                                        data: {
                                            session: null
                                        },
                                        error: null
                                    }
                                ];
                                hasExpired = currentSession.expires_at ? currentSession.expires_at <= Date.now() / 1000 : false;
                                _this._debug('#__loadSession()', "session has".concat(hasExpired ? '' : ' not', " expired"), 'expires_at', currentSession.expires_at);
                                if (!hasExpired) {
                                    if (_this.storage.isServer) {
                                        suppressWarning = _this.suppressGetSessionWarning;
                                        proxySession = new Proxy(currentSession, {
                                            get: function(target, prop, receiver) {
                                                if (!suppressWarning && prop === 'user') {
                                                    // only show warning when the user object is being accessed from the server
                                                    console.warn('Using the user object as returned from supabase.auth.getSession() or from some supabase.auth.onAuthStateChange() events could be insecure! This value comes directly from the storage medium (usually cookies on the server) and may not be authentic. Use supabase.auth.getUser() instead which authenticates the data by contacting the Supabase Auth server.');
                                                    suppressWarning = true; // keeps this proxy instance from logging additional warnings
                                                    _this.suppressGetSessionWarning = true; // keeps this client's future proxy instances from warning
                                                }
                                                return Reflect.get(target, prop, receiver);
                                            }
                                        });
                                        currentSession = proxySession;
                                    }
                                    return [
                                        2,
                                        {
                                            data: {
                                                session: currentSession
                                            },
                                            error: null
                                        }
                                    ];
                                }
                                return [
                                    4,
                                    _this._callRefreshToken(currentSession.refresh_token)
                                ];
                            case 6:
                                _ref = _state.sent(), session = _ref.session, error = _ref.error;
                                if (error) return [
                                    2,
                                    {
                                        data: {
                                            session: null
                                        },
                                        error: error
                                    }
                                ];
                                return [
                                    2,
                                    {
                                        data: {
                                            session: session
                                        },
                                        error: null
                                    }
                                ];
                            case 7:
                                _this._debug('#__loadSession()', 'end');
                                return [
                                    7
                                ];
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getUser",
            value: /**
     * Gets the current user details if there is an existing session. This method
     * performs a network request to the Supabase Auth server, so the returned
     * value is authentic and can be used to base authorization rules on.
     *
     * @param jwt Takes in an optional access token JWT. If no JWT is provided, the JWT from the current session is used.
     */ function getUser(jwt) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var result;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!jwt) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this._getUser(jwt)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.initializePromise
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    4,
                                    _this._acquireLock(-1, /*#__PURE__*/ (0, $5Pgs2._)(function() {
                                        return (0, $1XfpH.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        _this._getUser()
                                                    ];
                                                case 1:
                                                    return [
                                                        2,
                                                        _state.sent()
                                                    ];
                                            }
                                        });
                                    }))
                                ];
                            case 4:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_getUser",
            value: function _getUser(jwt) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    4,
                                    ,
                                    9
                                ]);
                                if (!jwt) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'GET', "".concat(_this.url, "/user"), {
                                        headers: _this.headers,
                                        jwt: jwt,
                                        xform: (0, $cc4d33f36ba2dab3$export$e20f488897843593)
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                return [
                                    4,
                                    _this._useSession(/*#__PURE__*/ function() {
                                        var _ref = (0, $5Pgs2._)(function(result) {
                                            var _a, _b, _c, data, _$error;
                                            return (0, $1XfpH.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        data = result.data, _$error = result.error;
                                                        if (_$error) throw _$error;
                                                        // returns an error if there is no access_token or custom authorization header
                                                        if (!((_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) && !_this.hasCustomAuthorizationHeader) return [
                                                            2,
                                                            {
                                                                data: {
                                                                    user: null
                                                                },
                                                                error: new (0, $73f5e58330057bc1$export$403b3fc0d3ad5f0c)()
                                                            }
                                                        ];
                                                        return [
                                                            4,
                                                            (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'GET', "".concat(_this.url, "/user"), {
                                                                headers: _this.headers,
                                                                jwt: (_c = (_b = data.session) === null || _b === void 0 ? void 0 : _b.access_token) !== null && _c !== void 0 ? _c : undefined,
                                                                xform: (0, $cc4d33f36ba2dab3$export$e20f488897843593)
                                                            })
                                                        ];
                                                    case 1:
                                                        return [
                                                            2,
                                                            _state.sent()
                                                        ];
                                                }
                                            });
                                        });
                                        return function(result) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 4:
                                error = _state.sent();
                                if (!(0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    3,
                                    8
                                ];
                                if (!(0, $73f5e58330057bc1$export$3e849aa4db565c1d)(error)) return [
                                    3,
                                    7
                                ];
                                // JWT contains a `session_id` which does not correspond to an active
                                // session in the database, indicating the user is signed out.
                                return [
                                    4,
                                    _this._removeSession()
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    4,
                                    (0, $e47a9df456bd0ac4$export$d35c645d585317ec)(_this.storage, "".concat(_this.storageKey, "-code-verifier"))
                                ];
                            case 6:
                                _state.sent();
                                _state.label = 7;
                            case 7:
                                return [
                                    2,
                                    {
                                        data: {
                                            user: null
                                        },
                                        error: error
                                    }
                                ];
                            case 8:
                                throw error;
                            case 9:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateUser",
            value: /**
     * Updates user data for a logged in user.
     */ function updateUser(attributes) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.initializePromise
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this._acquireLock(-1, /*#__PURE__*/ (0, $5Pgs2._)(function() {
                                        return (0, $1XfpH.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        _this._updateUser(attributes, options)
                                                    ];
                                                case 1:
                                                    return [
                                                        2,
                                                        _state.sent()
                                                    ];
                                            }
                                        });
                                    }))
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_updateUser",
            value: function _updateUser(attributes) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this._useSession(/*#__PURE__*/ function() {
                                        var _ref = (0, $5Pgs2._)(function(result) {
                                            var sessionData, sessionError, session, codeChallenge, codeChallengeMethod, ref, _ref, data, userError;
                                            return (0, $1XfpH.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        sessionData = result.data, sessionError = result.error;
                                                        if (sessionError) throw sessionError;
                                                        if (!sessionData.session) throw new (0, $73f5e58330057bc1$export$403b3fc0d3ad5f0c)();
                                                        session = sessionData.session;
                                                        codeChallenge = null;
                                                        codeChallengeMethod = null;
                                                        if (!(_this.flowType === 'pkce' && attributes.email != null)) return [
                                                            3,
                                                            2
                                                        ];
                                                        return [
                                                            4,
                                                            (0, $e47a9df456bd0ac4$export$81b177cadfcf873c)(_this.storage, _this.storageKey)
                                                        ];
                                                    case 1:
                                                        ref = (0, $aSMts._).apply(void 0, [
                                                            _state.sent(),
                                                            2
                                                        ]), codeChallenge = ref[0], codeChallengeMethod = ref[1], ref;
                                                        _state.label = 2;
                                                    case 2:
                                                        return [
                                                            4,
                                                            (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'PUT', "".concat(_this.url, "/user"), {
                                                                headers: _this.headers,
                                                                redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                                                                body: Object.assign(Object.assign({}, attributes), {
                                                                    code_challenge: codeChallenge,
                                                                    code_challenge_method: codeChallengeMethod
                                                                }),
                                                                jwt: session.access_token,
                                                                xform: (0, $cc4d33f36ba2dab3$export$e20f488897843593)
                                                            })
                                                        ];
                                                    case 3:
                                                        _ref = _state.sent(), data = _ref.data, userError = _ref.error;
                                                        if (userError) throw userError;
                                                        session.user = data.user;
                                                        return [
                                                            4,
                                                            _this._saveSession(session)
                                                        ];
                                                    case 4:
                                                        _state.sent();
                                                        return [
                                                            4,
                                                            _this._notifyAllSubscribers('USER_UPDATED', session)
                                                        ];
                                                    case 5:
                                                        _state.sent();
                                                        return [
                                                            2,
                                                            {
                                                                data: {
                                                                    user: session.user
                                                                },
                                                                error: null
                                                            }
                                                        ];
                                                }
                                            });
                                        });
                                        return function(result) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: {
                                            user: null
                                        },
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Decodes a JWT (without performing any validation).
     */ key: "_decodeJWT",
            value: function _decodeJWT(jwt) {
                return (0, $e47a9df456bd0ac4$export$cc1c0b988f7b5577)(jwt);
            }
        },
        {
            key: "setSession",
            value: /**
     * Sets the session data from the current session. If the current session is expired, setSession will take care of refreshing it to obtain a new session.
     * If the refresh token or access token in the current session is invalid, an error will be thrown.
     * @param currentSession The current session that minimally contains an access token and refresh token.
     */ function setSession(currentSession) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.initializePromise
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this._acquireLock(-1, /*#__PURE__*/ (0, $5Pgs2._)(function() {
                                        return (0, $1XfpH.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        _this._setSession(currentSession)
                                                    ];
                                                case 1:
                                                    return [
                                                        2,
                                                        _state.sent()
                                                    ];
                                            }
                                        });
                                    }))
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_setSession",
            value: function _setSession(currentSession) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var timeNow, expiresAt, hasExpired, session, payload, _ref, refreshedSession, _$error, _ref1, data, _$error1, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    7,
                                    ,
                                    8
                                ]);
                                if (!currentSession.access_token || !currentSession.refresh_token) throw new (0, $73f5e58330057bc1$export$403b3fc0d3ad5f0c)();
                                timeNow = Date.now() / 1000;
                                expiresAt = timeNow;
                                hasExpired = true;
                                session = null;
                                payload = (0, $e47a9df456bd0ac4$export$cc1c0b988f7b5577)(currentSession.access_token);
                                if (payload.exp) {
                                    expiresAt = payload.exp;
                                    hasExpired = expiresAt <= timeNow;
                                }
                                if (!hasExpired) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this._callRefreshToken(currentSession.refresh_token)
                                ];
                            case 1:
                                _ref = _state.sent(), refreshedSession = _ref.session, _$error = _ref.error;
                                if (_$error) return [
                                    2,
                                    {
                                        data: {
                                            user: null,
                                            session: null
                                        },
                                        error: _$error
                                    }
                                ];
                                if (!refreshedSession) return [
                                    2,
                                    {
                                        data: {
                                            user: null,
                                            session: null
                                        },
                                        error: null
                                    }
                                ];
                                session = refreshedSession;
                                return [
                                    3,
                                    6
                                ];
                            case 2:
                                return [
                                    4,
                                    _this._getUser(currentSession.access_token)
                                ];
                            case 3:
                                _ref1 = _state.sent(), data = _ref1.data, _$error1 = _ref1.error;
                                if (_$error1) throw _$error1;
                                session = {
                                    access_token: currentSession.access_token,
                                    refresh_token: currentSession.refresh_token,
                                    user: data.user,
                                    token_type: 'bearer',
                                    expires_in: expiresAt - timeNow,
                                    expires_at: expiresAt
                                };
                                return [
                                    4,
                                    _this._saveSession(session)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    4,
                                    _this._notifyAllSubscribers('SIGNED_IN', session)
                                ];
                            case 5:
                                _state.sent();
                                _state.label = 6;
                            case 6:
                                return [
                                    2,
                                    {
                                        data: {
                                            user: session.user,
                                            session: session
                                        },
                                        error: null
                                    }
                                ];
                            case 7:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: {
                                            session: null,
                                            user: null
                                        },
                                        error: error
                                    }
                                ];
                                throw error;
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "refreshSession",
            value: /**
     * Returns a new session, regardless of expiry status.
     * Takes in an optional current session. If not passed in, then refreshSession() will attempt to retrieve it from getSession().
     * If the current session's refresh token is invalid, an error will be thrown.
     * @param currentSession The current session. If passed in, it must contain a refresh token.
     */ function refreshSession(currentSession) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.initializePromise
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this._acquireLock(-1, /*#__PURE__*/ (0, $5Pgs2._)(function() {
                                        return (0, $1XfpH.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        _this._refreshSession(currentSession)
                                                    ];
                                                case 1:
                                                    return [
                                                        2,
                                                        _state.sent()
                                                    ];
                                            }
                                        });
                                    }))
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_refreshSession",
            value: function _refreshSession(currentSession) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this._useSession(/*#__PURE__*/ function() {
                                        var _ref = (0, $5Pgs2._)(function(result) {
                                            var _a, data, _$error, _ref, session, _$error1;
                                            return (0, $1XfpH.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        if (!currentSession) {
                                                            data = result.data, _$error = result.error;
                                                            if (_$error) throw _$error;
                                                            currentSession = (_a = data.session) !== null && _a !== void 0 ? _a : undefined;
                                                        }
                                                        if (!(currentSession === null || currentSession === void 0 ? void 0 : currentSession.refresh_token)) throw new (0, $73f5e58330057bc1$export$403b3fc0d3ad5f0c)();
                                                        return [
                                                            4,
                                                            _this._callRefreshToken(currentSession.refresh_token)
                                                        ];
                                                    case 1:
                                                        _ref = _state.sent(), session = _ref.session, _$error1 = _ref.error;
                                                        if (_$error1) return [
                                                            2,
                                                            {
                                                                data: {
                                                                    user: null,
                                                                    session: null
                                                                },
                                                                error: _$error1
                                                            }
                                                        ];
                                                        if (!session) return [
                                                            2,
                                                            {
                                                                data: {
                                                                    user: null,
                                                                    session: null
                                                                },
                                                                error: null
                                                            }
                                                        ];
                                                        return [
                                                            2,
                                                            {
                                                                data: {
                                                                    user: session.user,
                                                                    session: session
                                                                },
                                                                error: null
                                                            }
                                                        ];
                                                }
                                            });
                                        });
                                        return function(result) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: {
                                            user: null,
                                            session: null
                                        },
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_getSessionFromURL",
            value: /**
     * Gets the session data from a URL string
     */ function _getSessionFromURL(params, callbackUrlType) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _ref, data, _$error, url, provider_token, provider_refresh_token, access_token, refresh_token, expires_in, expires_at, token_type, timeNow, expiresIn, expiresAt, actuallyExpiresIn, issuedAt, _ref1, data1, _$error1, session, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    4,
                                    ,
                                    5
                                ]);
                                if (!(0, $e47a9df456bd0ac4$export$4e09c449d6c407f7)()) throw new (0, $73f5e58330057bc1$export$bf5df8e043856ef5)('No browser detected.');
                                // If there's an error in the URL, it doesn't matter what flow it is, we just return the error.
                                if (params.error || params.error_description || params.error_code) // The error class returned implies that the redirect is from an implicit grant flow
                                // but it could also be from a redirect error from a PKCE flow.
                                throw new (0, $73f5e58330057bc1$export$bf5df8e043856ef5)(params.error_description || 'Error in URL with unspecified error_description', {
                                    error: params.error || 'unspecified_error',
                                    code: params.error_code || 'unspecified_code'
                                });
                                // Checks for mismatches between the flowType initialised in the client and the URL parameters
                                switch(callbackUrlType){
                                    case 'implicit':
                                        if (_this.flowType === 'pkce') throw new (0, $73f5e58330057bc1$export$39583657eb2a7027)('Not a valid PKCE flow url.');
                                        break;
                                    case 'pkce':
                                        if (_this.flowType === 'implicit') throw new (0, $73f5e58330057bc1$export$bf5df8e043856ef5)('Not a valid implicit grant flow url.');
                                        break;
                                    default:
                                }
                                if (!(callbackUrlType === 'pkce')) return [
                                    3,
                                    2
                                ];
                                _this._debug('#_initialize()', 'begin', 'is PKCE flow', true);
                                if (!params.code) throw new (0, $73f5e58330057bc1$export$39583657eb2a7027)('No code detected.');
                                return [
                                    4,
                                    _this._exchangeCodeForSession(params.code)
                                ];
                            case 1:
                                _ref = _state.sent(), data = _ref.data, _$error = _ref.error;
                                if (_$error) throw _$error;
                                url = new URL(window.location.href);
                                url.searchParams["delete"]('code');
                                window.history.replaceState(window.history.state, '', url.toString());
                                return [
                                    2,
                                    {
                                        data: {
                                            session: data.session,
                                            redirectType: null
                                        },
                                        error: null
                                    }
                                ];
                            case 2:
                                provider_token = params.provider_token, provider_refresh_token = params.provider_refresh_token, access_token = params.access_token, refresh_token = params.refresh_token, expires_in = params.expires_in, expires_at = params.expires_at, token_type = params.token_type;
                                if (!access_token || !expires_in || !refresh_token || !token_type) throw new (0, $73f5e58330057bc1$export$bf5df8e043856ef5)('No session defined in URL');
                                timeNow = Math.round(Date.now() / 1000);
                                expiresIn = parseInt(expires_in);
                                expiresAt = timeNow + expiresIn;
                                if (expires_at) expiresAt = parseInt(expires_at);
                                actuallyExpiresIn = expiresAt - timeNow;
                                if (actuallyExpiresIn * 1000 <= $5134855c200492a8$var$AUTO_REFRESH_TICK_DURATION) console.warn("@supabase/gotrue-js: Session as retrieved from URL expires in ".concat(actuallyExpiresIn, "s, should have been closer to ").concat(expiresIn, "s"));
                                issuedAt = expiresAt - expiresIn;
                                if (timeNow - issuedAt >= 120) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued over 120s ago, URL could be stale', issuedAt, expiresAt, timeNow);
                                else if (timeNow - issuedAt < 0) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued in the future? Check the device clock for skew', issuedAt, expiresAt, timeNow);
                                return [
                                    4,
                                    _this._getUser(access_token)
                                ];
                            case 3:
                                _ref1 = _state.sent(), data1 = _ref1.data, _$error1 = _ref1.error;
                                if (_$error1) throw _$error1;
                                session = {
                                    provider_token: provider_token,
                                    provider_refresh_token: provider_refresh_token,
                                    access_token: access_token,
                                    expires_in: expiresIn,
                                    expires_at: expiresAt,
                                    refresh_token: refresh_token,
                                    token_type: token_type,
                                    user: data1.user
                                };
                                // Remove tokens from URL
                                window.location.hash = '';
                                _this._debug('#_getSessionFromURL()', 'clearing window.location.hash');
                                return [
                                    2,
                                    {
                                        data: {
                                            session: session,
                                            redirectType: params.type
                                        },
                                        error: null
                                    }
                                ];
                            case 4:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: {
                                            session: null,
                                            redirectType: null
                                        },
                                        error: error
                                    }
                                ];
                                throw error;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Checks if the current URL contains parameters given by an implicit oauth grant flow (https://www.rfc-editor.org/rfc/rfc6749.html#section-4.2)
     */ key: "_isImplicitGrantCallback",
            value: function _isImplicitGrantCallback(params) {
                return Boolean(params.access_token || params.error_description);
            }
        },
        {
            key: "_isPKCECallback",
            value: /**
     * Checks if the current URL and backing storage contain parameters given by a PKCE flow
     */ function _isPKCECallback(params) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var currentStorageContent;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $e47a9df456bd0ac4$export$ba6fcb7c333d32c0)(_this.storage, "".concat(_this.storageKey, "-code-verifier"))
                                ];
                            case 1:
                                currentStorageContent = _state.sent();
                                return [
                                    2,
                                    !!(params.code && currentStorageContent)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signOut",
            value: /**
     * Inside a browser context, `signOut()` will remove the logged in user from the browser session and log them out - removing all items from localstorage and then trigger a `"SIGNED_OUT"` event.
     *
     * For server-side management, you can revoke all refresh tokens for a user by passing a user's JWT through to `auth.api.signOut(JWT: string)`.
     * There is no way to revoke a user's access token jwt until it expires. It is recommended to set a shorter expiry on the jwt for this reason.
     *
     * If using `others` scope, no `SIGNED_OUT` event is fired!
     */ function signOut() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
                    scope: 'global'
                };
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.initializePromise
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this._acquireLock(-1, /*#__PURE__*/ (0, $5Pgs2._)(function() {
                                        return (0, $1XfpH.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        _this._signOut(options)
                                                    ];
                                                case 1:
                                                    return [
                                                        2,
                                                        _state.sent()
                                                    ];
                                            }
                                        });
                                    }))
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_signOut",
            value: function _signOut() {
                var scope = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
                    scope: 'global'
                }).scope;
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._useSession(/*#__PURE__*/ function() {
                                        var _ref = (0, $5Pgs2._)(function(result) {
                                            var _a, data, sessionError, accessToken, error;
                                            return (0, $1XfpH.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        data = result.data, sessionError = result.error;
                                                        if (sessionError) return [
                                                            2,
                                                            {
                                                                error: sessionError
                                                            }
                                                        ];
                                                        accessToken = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token;
                                                        if (!accessToken) return [
                                                            3,
                                                            2
                                                        ];
                                                        return [
                                                            4,
                                                            _this.admin.signOut(accessToken, scope)
                                                        ];
                                                    case 1:
                                                        error = _state.sent().error;
                                                        if (error) {
                                                            // ignore 404s since user might not exist anymore
                                                            // ignore 401s since an invalid or expired JWT should sign out the current session
                                                            if (!((0, $73f5e58330057bc1$export$4fe744aeb810d543)(error) && (error.status === 404 || error.status === 401 || error.status === 403))) return [
                                                                2,
                                                                {
                                                                    error: error
                                                                }
                                                            ];
                                                        }
                                                        _state.label = 2;
                                                    case 2:
                                                        if (!(scope !== 'others')) return [
                                                            3,
                                                            5
                                                        ];
                                                        return [
                                                            4,
                                                            _this._removeSession()
                                                        ];
                                                    case 3:
                                                        _state.sent();
                                                        return [
                                                            4,
                                                            (0, $e47a9df456bd0ac4$export$d35c645d585317ec)(_this.storage, "".concat(_this.storageKey, "-code-verifier"))
                                                        ];
                                                    case 4:
                                                        _state.sent();
                                                        _state.label = 5;
                                                    case 5:
                                                        return [
                                                            2,
                                                            {
                                                                error: null
                                                            }
                                                        ];
                                                }
                                            });
                                        });
                                        return function(result) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Receive a notification every time an auth event happens.
     * @param callback A callback function to be invoked when an auth event happens.
     */ key: "onAuthStateChange",
            value: function onAuthStateChange(callback) {
                var _this = this;
                var id = (0, $e47a9df456bd0ac4$export$31b40729666a4ae0)();
                var subscription = {
                    id: id,
                    callback: callback,
                    unsubscribe: function() {
                        _this._debug('#unsubscribe()', 'state change callback with id removed', id);
                        _this.stateChangeEmitters["delete"](id);
                    }
                };
                this._debug('#onAuthStateChange()', 'registered callback with id', id);
                this.stateChangeEmitters.set(id, subscription);
                var _this1 = this;
                (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this1.initializePromise
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this1._acquireLock(-1, /*#__PURE__*/ (0, $5Pgs2._)(function() {
                                        return (0, $1XfpH.__generator)(this, function(_state) {
                                            _this1._emitInitialSession(id);
                                            return [
                                                2
                                            ];
                                        });
                                    }))
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
                return {
                    data: {
                        subscription: subscription
                    }
                };
            }
        },
        {
            key: "_emitInitialSession",
            value: function _emitInitialSession(id) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._useSession(/*#__PURE__*/ function() {
                                        var _ref = (0, $5Pgs2._)(function(result) {
                                            var _a, _b, session, error, err;
                                            return (0, $1XfpH.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        _state.trys.push([
                                                            0,
                                                            2,
                                                            ,
                                                            4
                                                        ]);
                                                        session = result.data.session, error = result.error;
                                                        if (error) throw error;
                                                        return [
                                                            4,
                                                            (_a = _this.stateChangeEmitters.get(id)) === null || _a === void 0 ? void 0 : _a.callback('INITIAL_SESSION', session)
                                                        ];
                                                    case 1:
                                                        _state.sent();
                                                        _this._debug('INITIAL_SESSION', 'callback id', id, 'session', session);
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 2:
                                                        err = _state.sent();
                                                        return [
                                                            4,
                                                            (_b = _this.stateChangeEmitters.get(id)) === null || _b === void 0 ? void 0 : _b.callback('INITIAL_SESSION', null)
                                                        ];
                                                    case 3:
                                                        _state.sent();
                                                        _this._debug('INITIAL_SESSION', 'callback id', id, 'error', err);
                                                        console.error(err);
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 4:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(result) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "resetPasswordForEmail",
            value: /**
     * Sends a password reset request to an email address. This method supports the PKCE flow.
     *
     * @param email The email address of the user.
     * @param options.redirectTo The URL to send the user to after they click the password reset link.
     * @param options.captchaToken Verification token received when the user completes the captcha on the site.
     */ function resetPasswordForEmail(email) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var codeChallenge, codeChallengeMethod, ref, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                codeChallenge = null;
                                codeChallengeMethod = null;
                                if (!(_this.flowType === 'pkce')) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (0, $e47a9df456bd0ac4$export$81b177cadfcf873c)(_this.storage, _this.storageKey, true // isPasswordRecovery
                                    )
                                ];
                            case 1:
                                ref = (0, $aSMts._).apply(void 0, [
                                    _state.sent(),
                                    2
                                ]), codeChallenge = ref[0], codeChallengeMethod = ref[1], ref;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'POST', "".concat(_this.url, "/recover"), {
                                        body: {
                                            email: email,
                                            code_challenge: codeChallenge,
                                            code_challenge_method: codeChallengeMethod,
                                            gotrue_meta_security: {
                                                captcha_token: options.captchaToken
                                            }
                                        },
                                        headers: _this.headers,
                                        redirectTo: options.redirectTo
                                    })
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 4:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                                throw error;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getUserIdentities",
            value: /**
     * Gets all the identities linked to a user.
     */ function getUserIdentities() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _a, _ref, data, _$error, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.getUser()
                                ];
                            case 1:
                                _ref = _state.sent(), data = _ref.data, _$error = _ref.error;
                                if (_$error) throw _$error;
                                return [
                                    2,
                                    {
                                        data: {
                                            identities: (_a = data.user.identities) !== null && _a !== void 0 ? _a : []
                                        },
                                        error: null
                                    }
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "linkIdentity",
            value: /**
     * Links an oauth identity to an existing user.
     * This method supports the PKCE flow.
     */ function linkIdentity(credentials) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _a, _ref, data, _$error, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this._useSession(/*#__PURE__*/ function() {
                                        var _ref = (0, $5Pgs2._)(function(result) {
                                            var _a, _b, _c, _d, _e, data, _$error, url;
                                            return (0, $1XfpH.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        data = result.data, _$error = result.error;
                                                        if (_$error) throw _$error;
                                                        return [
                                                            4,
                                                            _this._getUrlForProvider("".concat(_this.url, "/user/identities/authorize"), credentials.provider, {
                                                                redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
                                                                scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
                                                                queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
                                                                skipBrowserRedirect: true
                                                            })
                                                        ];
                                                    case 1:
                                                        url = _state.sent();
                                                        return [
                                                            4,
                                                            (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'GET', url, {
                                                                headers: _this.headers,
                                                                jwt: (_e = (_d = data.session) === null || _d === void 0 ? void 0 : _d.access_token) !== null && _e !== void 0 ? _e : undefined
                                                            })
                                                        ];
                                                    case 2:
                                                        return [
                                                            2,
                                                            _state.sent()
                                                        ];
                                                }
                                            });
                                        });
                                        return function(result) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                            case 1:
                                _ref = _state.sent(), data = _ref.data, _$error = _ref.error;
                                if (_$error) throw _$error;
                                if ((0, $e47a9df456bd0ac4$export$4e09c449d6c407f7)() && !((_a = credentials.options) === null || _a === void 0 ? void 0 : _a.skipBrowserRedirect)) window.location.assign(data === null || data === void 0 ? void 0 : data.url);
                                return [
                                    2,
                                    {
                                        data: {
                                            provider: credentials.provider,
                                            url: data === null || data === void 0 ? void 0 : data.url
                                        },
                                        error: null
                                    }
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: {
                                            provider: credentials.provider,
                                            url: null
                                        },
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "unlinkIdentity",
            value: /**
     * Unlinks an identity from a user by deleting it. The user will no longer be able to sign in with that identity once it's unlinked.
     */ function unlinkIdentity(identity) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this._useSession(/*#__PURE__*/ function() {
                                        var _ref = (0, $5Pgs2._)(function(result) {
                                            var _a, _b, data, _$error;
                                            return (0, $1XfpH.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        data = result.data, _$error = result.error;
                                                        if (_$error) throw _$error;
                                                        return [
                                                            4,
                                                            (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'DELETE', "".concat(_this.url, "/user/identities/").concat(identity.identity_id), {
                                                                headers: _this.headers,
                                                                jwt: (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : undefined
                                                            })
                                                        ];
                                                    case 1:
                                                        return [
                                                            2,
                                                            _state.sent()
                                                        ];
                                                }
                                            });
                                        });
                                        return function(result) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_refreshAccessToken",
            value: /**
     * Generates a new JWT.
     * @param refreshToken A valid refresh token that was returned on login.
     */ function _refreshAccessToken(refreshToken) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var debugName, startedAt, error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                debugName = "#_refreshAccessToken(".concat(refreshToken.substring(0, 5), "...)");
                                _this._debug(debugName, 'begin');
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    4,
                                    5
                                ]);
                                startedAt = Date.now();
                                return [
                                    4,
                                    (0, $e47a9df456bd0ac4$export$9e1b8e833f44ff21)(/*#__PURE__*/ function() {
                                        var _ref = (0, $5Pgs2._)(function(attempt) {
                                            return (0, $1XfpH.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        if (!(attempt > 0)) return [
                                                            3,
                                                            2
                                                        ];
                                                        return [
                                                            4,
                                                            (0, $e47a9df456bd0ac4$export$e772c8ff12451969)(200 * Math.pow(2, attempt - 1))
                                                        ];
                                                    case 1:
                                                        _state.sent(); // 200, 400, 800, ...
                                                        _state.label = 2;
                                                    case 2:
                                                        _this._debug(debugName, 'refreshing attempt', attempt);
                                                        return [
                                                            4,
                                                            (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'POST', "".concat(_this.url, "/token?grant_type=refresh_token"), {
                                                                body: {
                                                                    refresh_token: refreshToken
                                                                },
                                                                headers: _this.headers,
                                                                xform: (0, $cc4d33f36ba2dab3$export$273fe4673a018c2e)
                                                            })
                                                        ];
                                                    case 3:
                                                        return [
                                                            2,
                                                            _state.sent()
                                                        ];
                                                }
                                            });
                                        });
                                        return function(attempt) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }(), function(attempt, error) {
                                        var nextBackOffInterval = 200 * Math.pow(2, attempt);
                                        return error && (0, $73f5e58330057bc1$export$a77af358da5fb874)(error) && // retryable only if the request can be sent before the backoff overflows the tick duration
                                        Date.now() + nextBackOffInterval - startedAt < $5134855c200492a8$var$AUTO_REFRESH_TICK_DURATION;
                                    })
                                ];
                            case 2:
                                // will attempt to refresh the token with exponential backoff
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                error = _state.sent();
                                _this._debug(debugName, 'error', error);
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: {
                                            session: null,
                                            user: null
                                        },
                                        error: error
                                    }
                                ];
                                throw error;
                            case 4:
                                _this._debug(debugName, 'end');
                                return [
                                    7
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_isValidSession",
            value: function _isValidSession(maybeSession) {
                var isValidSession = (typeof maybeSession === "undefined" ? "undefined" : (0, $qb7pP._)(maybeSession)) === 'object' && maybeSession !== null && 'access_token' in maybeSession && 'refresh_token' in maybeSession && 'expires_at' in maybeSession;
                return isValidSession;
            }
        },
        {
            key: "_handleProviderSignIn",
            value: function _handleProviderSignIn(provider, options) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var url;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._getUrlForProvider("".concat(_this.url, "/authorize"), provider, {
                                        redirectTo: options.redirectTo,
                                        scopes: options.scopes,
                                        queryParams: options.queryParams
                                    })
                                ];
                            case 1:
                                url = _state.sent();
                                _this._debug('#_handleProviderSignIn()', 'provider', provider, 'options', options, 'url', url);
                                // try to open on the browser
                                if ((0, $e47a9df456bd0ac4$export$4e09c449d6c407f7)() && !options.skipBrowserRedirect) window.location.assign(url);
                                return [
                                    2,
                                    {
                                        data: {
                                            provider: provider,
                                            url: url
                                        },
                                        error: null
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_recoverAndRefresh",
            value: /**
     * Recovers the session from LocalStorage and refreshes the token
     * Note: this method is async to accommodate for AsyncStorage e.g. in React native.
     */ function _recoverAndRefresh() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _a, debugName, currentSession, timeNow, expiresWithMargin, error, err;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                debugName = '#_recoverAndRefresh()';
                                _this._debug(debugName, 'begin');
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    12,
                                    13,
                                    14
                                ]);
                                return [
                                    4,
                                    (0, $e47a9df456bd0ac4$export$ba6fcb7c333d32c0)(_this.storage, _this.storageKey)
                                ];
                            case 2:
                                currentSession = _state.sent();
                                _this._debug(debugName, 'session from storage', currentSession);
                                if (!!_this._isValidSession(currentSession)) return [
                                    3,
                                    5
                                ];
                                _this._debug(debugName, 'session is not valid');
                                if (!(currentSession !== null)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this._removeSession()
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                            case 5:
                                timeNow = Math.round(Date.now() / 1000);
                                expiresWithMargin = ((_a = currentSession.expires_at) !== null && _a !== void 0 ? _a : Infinity) < timeNow + (0, $b2aad0884e88cf33$export$7d4b3a66850dd9bd);
                                _this._debug(debugName, "session has".concat(expiresWithMargin ? '' : ' not', " expired with margin of ").concat((0, $b2aad0884e88cf33$export$7d4b3a66850dd9bd), "s"));
                                if (!expiresWithMargin) return [
                                    3,
                                    9
                                ];
                                if (!(_this.autoRefreshToken && currentSession.refresh_token)) return [
                                    3,
                                    8
                                ];
                                return [
                                    4,
                                    _this._callRefreshToken(currentSession.refresh_token)
                                ];
                            case 6:
                                error = _state.sent().error;
                                if (!error) return [
                                    3,
                                    8
                                ];
                                console.error(error);
                                if (!!(0, $73f5e58330057bc1$export$a77af358da5fb874)(error)) return [
                                    3,
                                    8
                                ];
                                _this._debug(debugName, 'refresh failed with a non-retryable error, removing the session', error);
                                return [
                                    4,
                                    _this._removeSession()
                                ];
                            case 7:
                                _state.sent();
                                _state.label = 8;
                            case 8:
                                return [
                                    3,
                                    11
                                ];
                            case 9:
                                // no need to persist currentSession again, as we just loaded it from
                                // local storage; persisting it again may overwrite a value saved by
                                // another client with access to the same local storage
                                return [
                                    4,
                                    _this._notifyAllSubscribers('SIGNED_IN', currentSession)
                                ];
                            case 10:
                                _state.sent();
                                _state.label = 11;
                            case 11:
                                return [
                                    3,
                                    14
                                ];
                            case 12:
                                err = _state.sent();
                                _this._debug(debugName, 'error', err);
                                console.error(err);
                                return [
                                    2
                                ];
                            case 13:
                                _this._debug(debugName, 'end');
                                return [
                                    7
                                ];
                            case 14:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_callRefreshToken",
            value: function _callRefreshToken(refreshToken) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _a, _b, debugName, _ref, data, _$error, result, error, result1;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!refreshToken) throw new (0, $73f5e58330057bc1$export$403b3fc0d3ad5f0c)();
                                // refreshing is already in progress
                                if (_this.refreshingDeferred) return [
                                    2,
                                    _this.refreshingDeferred.promise
                                ];
                                debugName = "#_callRefreshToken(".concat(refreshToken.substring(0, 5), "...)");
                                _this._debug(debugName, 'begin');
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    5,
                                    9,
                                    10
                                ]);
                                _this.refreshingDeferred = new (0, $e47a9df456bd0ac4$export$85f6557964517f1a)();
                                return [
                                    4,
                                    _this._refreshAccessToken(refreshToken)
                                ];
                            case 2:
                                _ref = _state.sent(), data = _ref.data, _$error = _ref.error;
                                if (_$error) throw _$error;
                                if (!data.session) throw new (0, $73f5e58330057bc1$export$403b3fc0d3ad5f0c)();
                                return [
                                    4,
                                    _this._saveSession(data.session)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    4,
                                    _this._notifyAllSubscribers('TOKEN_REFRESHED', data.session)
                                ];
                            case 4:
                                _state.sent();
                                result = {
                                    session: data.session,
                                    error: null
                                };
                                _this.refreshingDeferred.resolve(result);
                                return [
                                    2,
                                    result
                                ];
                            case 5:
                                error = _state.sent();
                                _this._debug(debugName, 'error', error);
                                if (!(0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    3,
                                    8
                                ];
                                result1 = {
                                    session: null,
                                    error: error
                                };
                                if (!!(0, $73f5e58330057bc1$export$a77af358da5fb874)(error)) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    _this._removeSession()
                                ];
                            case 6:
                                _state.sent();
                                _state.label = 7;
                            case 7:
                                (_a = _this.refreshingDeferred) === null || _a === void 0 || _a.resolve(result1);
                                return [
                                    2,
                                    result1
                                ];
                            case 8:
                                (_b = _this.refreshingDeferred) === null || _b === void 0 || _b.reject(error);
                                throw error;
                            case 9:
                                _this.refreshingDeferred = null;
                                _this._debug(debugName, 'end');
                                return [
                                    7
                                ];
                            case 10:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_notifyAllSubscribers",
            value: function _notifyAllSubscribers(event, session) {
                var broadcast = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var debugName, errors, promises, i;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                debugName = "#_notifyAllSubscribers(".concat(event, ")");
                                _this._debug(debugName, 'begin', session, "broadcast = ".concat(broadcast));
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    ,
                                    3,
                                    4
                                ]);
                                if (_this.broadcastChannel && broadcast) _this.broadcastChannel.postMessage({
                                    event: event,
                                    session: session
                                });
                                errors = [];
                                promises = Array.from(_this.stateChangeEmitters.values()).map(/*#__PURE__*/ function() {
                                    var _ref = (0, $5Pgs2._)(function(x) {
                                        var e;
                                        return (0, $1XfpH.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    _state.trys.push([
                                                        0,
                                                        2,
                                                        ,
                                                        3
                                                    ]);
                                                    return [
                                                        4,
                                                        x.callback(event, session)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        3,
                                                        3
                                                    ];
                                                case 2:
                                                    e = _state.sent();
                                                    errors.push(e);
                                                    return [
                                                        3,
                                                        3
                                                    ];
                                                case 3:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(x) {
                                        return _ref.apply(this, arguments);
                                    };
                                }());
                                return [
                                    4,
                                    Promise.all(promises)
                                ];
                            case 2:
                                _state.sent();
                                if (errors.length > 0) {
                                    for(i = 0; i < errors.length; i += 1)console.error(errors[i]);
                                    throw errors[0];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _this._debug(debugName, 'end');
                                return [
                                    7
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_saveSession",
            value: /**
     * set currentSession and currentUser
     * process to _startAutoRefreshToken if possible
     */ function _saveSession(session) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this._debug('#_saveSession()', session);
                                // _saveSession is always called whenever a new session has been acquired
                                // so we can safely suppress the warning returned by future getSession calls
                                _this.suppressGetSessionWarning = true;
                                return [
                                    4,
                                    (0, $e47a9df456bd0ac4$export$e82c36d29078a87f)(_this.storage, _this.storageKey, session)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_removeSession",
            value: function _removeSession() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this._debug('#_removeSession()');
                                return [
                                    4,
                                    (0, $e47a9df456bd0ac4$export$d35c645d585317ec)(_this.storage, _this.storageKey)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this._notifyAllSubscribers('SIGNED_OUT', null)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Removes any registered visibilitychange callback.
     *
     * {@see #startAutoRefresh}
     * {@see #stopAutoRefresh}
     */ key: "_removeVisibilityChangedCallback",
            value: function _removeVisibilityChangedCallback() {
                this._debug('#_removeVisibilityChangedCallback()');
                var callback = this.visibilityChangedCallback;
                this.visibilityChangedCallback = null;
                try {
                    if (callback && (0, $e47a9df456bd0ac4$export$4e09c449d6c407f7)() && (window === null || window === void 0 ? void 0 : window.removeEventListener)) window.removeEventListener('visibilitychange', callback);
                } catch (e) {
                    console.error('removing visibilitychange callback failed', e);
                }
            }
        },
        {
            key: "_startAutoRefresh",
            value: /**
     * This is the private implementation of {@link #startAutoRefresh}. Use this
     * within the library.
     */ function _startAutoRefresh() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var ticker;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._stopAutoRefresh()
                                ];
                            case 1:
                                _state.sent();
                                _this._debug('#_startAutoRefresh()');
                                ticker = setInterval(function() {
                                    return _this._autoRefreshTokenTick();
                                }, $5134855c200492a8$var$AUTO_REFRESH_TICK_DURATION);
                                _this.autoRefreshTicker = ticker;
                                if (ticker && (typeof ticker === "undefined" ? "undefined" : (0, $qb7pP._)(ticker)) === 'object' && typeof ticker.unref === 'function') // ticker is a NodeJS Timeout object that has an `unref` method
                                // https://nodejs.org/api/timers.html#timeoutunref
                                // When auto refresh is used in NodeJS (like for testing) the
                                // `setInterval` is preventing the process from being marked as
                                // finished and tests run endlessly. This can be prevented by calling
                                // `unref()` on the returned object.
                                ticker.unref();
                                else if (typeof Deno !== 'undefined' && typeof Deno.unrefTimer === 'function') // similar like for NodeJS, but with the Deno API
                                // https://deno.land/api@latest?unstable&s=Deno.unrefTimer
                                // @ts-expect-error TS has no context of Deno
                                Deno.unrefTimer(ticker);
                                // run the tick immediately, but in the next pass of the event loop so that
                                // #_initialize can be allowed to complete without recursively waiting on
                                // itself
                                setTimeout(/*#__PURE__*/ (0, $5Pgs2._)(function() {
                                    return (0, $1XfpH.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    _this.initializePromise
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    4,
                                                    _this._autoRefreshTokenTick()
                                                ];
                                            case 2:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }), 0);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_stopAutoRefresh",
            value: /**
     * This is the private implementation of {@link #stopAutoRefresh}. Use this
     * within the library.
     */ function _stopAutoRefresh() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var ticker;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        _this._debug('#_stopAutoRefresh()');
                        ticker = _this.autoRefreshTicker;
                        _this.autoRefreshTicker = null;
                        if (ticker) clearInterval(ticker);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "startAutoRefresh",
            value: /**
     * Starts an auto-refresh process in the background. The session is checked
     * every few seconds. Close to the time of expiration a process is started to
     * refresh the session. If refreshing fails it will be retried for as long as
     * necessary.
     *
     * If you set the {@link GoTrueClientOptions#autoRefreshToken} you don't need
     * to call this function, it will be called for you.
     *
     * On browsers the refresh process works only when the tab/window is in the
     * foreground to conserve resources as well as prevent race conditions and
     * flooding auth with requests. If you call this method any managed
     * visibility change callback will be removed and you must manage visibility
     * changes on your own.
     *
     * On non-browser platforms the refresh process works *continuously* in the
     * background, which may not be desirable. You should hook into your
     * platform's foreground indication mechanism and call these methods
     * appropriately to conserve resources.
     *
     * {@see #stopAutoRefresh}
     */ function startAutoRefresh() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this._removeVisibilityChangedCallback();
                                return [
                                    4,
                                    _this._startAutoRefresh()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "stopAutoRefresh",
            value: /**
     * Stops an active auto refresh process running in the background (if any).
     *
     * If you call this method any managed visibility change callback will be
     * removed and you must manage visibility changes on your own.
     *
     * See {@link #startAutoRefresh} for more details.
     */ function stopAutoRefresh() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this._removeVisibilityChangedCallback();
                                return [
                                    4,
                                    _this._stopAutoRefresh()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_autoRefreshTokenTick",
            value: /**
     * Runs the auto refresh token tick.
     */ function _autoRefreshTokenTick() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var e;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this._debug('#_autoRefreshTokenTick()', 'begin');
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this._acquireLock(0, /*#__PURE__*/ (0, $5Pgs2._)(function() {
                                        var now, e;
                                        return (0, $1XfpH.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    _state.trys.push([
                                                        0,
                                                        ,
                                                        5,
                                                        6
                                                    ]);
                                                    now = Date.now();
                                                    _state.label = 1;
                                                case 1:
                                                    _state.trys.push([
                                                        1,
                                                        3,
                                                        ,
                                                        4
                                                    ]);
                                                    return [
                                                        4,
                                                        _this._useSession(/*#__PURE__*/ function() {
                                                            var _ref = (0, $5Pgs2._)(function(result) {
                                                                var session, expiresInTicks;
                                                                return (0, $1XfpH.__generator)(this, function(_state) {
                                                                    switch(_state.label){
                                                                        case 0:
                                                                            session = result.data.session;
                                                                            if (!session || !session.refresh_token || !session.expires_at) {
                                                                                _this._debug('#_autoRefreshTokenTick()', 'no session');
                                                                                return [
                                                                                    2
                                                                                ];
                                                                            }
                                                                            // session will expire in this many ticks (or has already expired if <= 0)
                                                                            expiresInTicks = Math.floor((session.expires_at * 1000 - now) / $5134855c200492a8$var$AUTO_REFRESH_TICK_DURATION);
                                                                            _this._debug('#_autoRefreshTokenTick()', "access token expires in ".concat(expiresInTicks, " ticks, a tick lasts ").concat($5134855c200492a8$var$AUTO_REFRESH_TICK_DURATION, "ms, refresh threshold is ").concat($5134855c200492a8$var$AUTO_REFRESH_TICK_THRESHOLD, " ticks"));
                                                                            if (!(expiresInTicks <= $5134855c200492a8$var$AUTO_REFRESH_TICK_THRESHOLD)) return [
                                                                                3,
                                                                                2
                                                                            ];
                                                                            return [
                                                                                4,
                                                                                _this._callRefreshToken(session.refresh_token)
                                                                            ];
                                                                        case 1:
                                                                            _state.sent();
                                                                            _state.label = 2;
                                                                        case 2:
                                                                            return [
                                                                                2
                                                                            ];
                                                                    }
                                                                });
                                                            });
                                                            return function(result) {
                                                                return _ref.apply(this, arguments);
                                                            };
                                                        }())
                                                    ];
                                                case 2:
                                                    return [
                                                        2,
                                                        _state.sent()
                                                    ];
                                                case 3:
                                                    e = _state.sent();
                                                    console.error('Auto refresh tick failed with error. This is likely a transient error.', e);
                                                    return [
                                                        3,
                                                        4
                                                    ];
                                                case 4:
                                                    return [
                                                        3,
                                                        6
                                                    ];
                                                case 5:
                                                    _this._debug('#_autoRefreshTokenTick()', 'end');
                                                    return [
                                                        7
                                                    ];
                                                case 6:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }))
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                if (e.isAcquireTimeout || e instanceof (0, $82be7713279e39ac$export$23e9464cc010dff9)) _this._debug('auto refresh token tick lock not available');
                                else throw e;
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_handleVisibilityChange",
            value: /**
     * Registers callbacks on the browser / platform, which in-turn run
     * algorithms when the browser window/tab are in foreground. On non-browser
     * platforms it assumes always foreground.
     */ function _handleVisibilityChange() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this._debug('#_handleVisibilityChange()');
                                if (!(0, $e47a9df456bd0ac4$export$4e09c449d6c407f7)() || !(window === null || window === void 0 ? void 0 : window.addEventListener)) {
                                    if (_this.autoRefreshToken) // in non-browser environments the refresh token ticker runs always
                                    _this.startAutoRefresh();
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _this.visibilityChangedCallback = /*#__PURE__*/ (0, $5Pgs2._)(function() {
                                    return (0, $1XfpH.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    _this._onVisibilityChanged(false)
                                                ];
                                            case 1:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                        }
                                    });
                                });
                                window === null || window === void 0 || window.addEventListener('visibilitychange', _this.visibilityChangedCallback);
                                // now immediately call the visbility changed callback to setup with the
                                // current visbility state
                                return [
                                    4,
                                    _this._onVisibilityChanged(true)
                                ];
                            case 2:
                                _state.sent(); // initial call
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                console.error('_handleVisibilityChange', error);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_onVisibilityChanged",
            value: /**
     * Callback registered with `window.addEventListener('visibilitychange')`.
     */ function _onVisibilityChanged(calledFromInitialize) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var methodName;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                methodName = "#_onVisibilityChanged(".concat(calledFromInitialize, ")");
                                _this._debug(methodName, 'visibilityState', document.visibilityState);
                                if (!(document.visibilityState === 'visible')) return [
                                    3,
                                    4
                                ];
                                if (_this.autoRefreshToken) // in browser environments the refresh token ticker runs only on focused tabs
                                // which prevents race conditions
                                _this._startAutoRefresh();
                                if (!!calledFromInitialize) return [
                                    3,
                                    3
                                ];
                                // called when the visibility has changed, i.e. the browser
                                // transitioned from hidden -> visible so we need to see if the session
                                // should be recovered immediately... but to do that we need to acquire
                                // the lock first asynchronously
                                return [
                                    4,
                                    _this.initializePromise
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this._acquireLock(-1, /*#__PURE__*/ (0, $5Pgs2._)(function() {
                                        return (0, $1XfpH.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (document.visibilityState !== 'visible') {
                                                        _this._debug(methodName, 'acquired the lock to recover the session, but the browser visibilityState is no longer visible, aborting');
                                                        // visibility has changed while waiting for the lock, abort
                                                        return [
                                                            2
                                                        ];
                                                    }
                                                    // recover the session
                                                    return [
                                                        4,
                                                        _this._recoverAndRefresh()
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }))
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                if (document.visibilityState === 'hidden') {
                                    if (_this.autoRefreshToken) _this._stopAutoRefresh();
                                }
                                _state.label = 5;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_getUrlForProvider",
            value: /**
     * Generates the relevant login URL for a third-party provider.
     * @param options.redirectTo A URL or mobile address to send the user to after they are confirmed.
     * @param options.scopes A space-separated list of scopes granted to the OAuth application.
     * @param options.queryParams An object of key-value pairs containing query parameters granted to the OAuth application.
     */ function _getUrlForProvider(url, provider, options) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var urlParams, _ref, codeChallenge, codeChallengeMethod, flowParams, query;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                urlParams = [
                                    "provider=".concat(encodeURIComponent(provider))
                                ];
                                if (options === null || options === void 0 ? void 0 : options.redirectTo) urlParams.push("redirect_to=".concat(encodeURIComponent(options.redirectTo)));
                                if (options === null || options === void 0 ? void 0 : options.scopes) urlParams.push("scopes=".concat(encodeURIComponent(options.scopes)));
                                if (!(_this.flowType === 'pkce')) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    (0, $e47a9df456bd0ac4$export$81b177cadfcf873c)(_this.storage, _this.storageKey)
                                ];
                            case 1:
                                _ref = (0, $aSMts._).apply(void 0, [
                                    _state.sent(),
                                    2
                                ]), codeChallenge = _ref[0], codeChallengeMethod = _ref[1];
                                flowParams = new URLSearchParams({
                                    code_challenge: "".concat(encodeURIComponent(codeChallenge)),
                                    code_challenge_method: "".concat(encodeURIComponent(codeChallengeMethod))
                                });
                                urlParams.push(flowParams.toString());
                                _state.label = 2;
                            case 2:
                                if (options === null || options === void 0 ? void 0 : options.queryParams) {
                                    query = new URLSearchParams(options.queryParams);
                                    urlParams.push(query.toString());
                                }
                                if (options === null || options === void 0 ? void 0 : options.skipBrowserRedirect) urlParams.push("skip_http_redirect=".concat(options.skipBrowserRedirect));
                                return [
                                    2,
                                    "".concat(url, "?").concat(urlParams.join('&'))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_unenroll",
            value: function _unenroll(params) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this._useSession(/*#__PURE__*/ function() {
                                        var _ref = (0, $5Pgs2._)(function(result) {
                                            var _a, sessionData, sessionError;
                                            return (0, $1XfpH.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        sessionData = result.data, sessionError = result.error;
                                                        if (sessionError) return [
                                                            2,
                                                            {
                                                                data: null,
                                                                error: sessionError
                                                            }
                                                        ];
                                                        return [
                                                            4,
                                                            (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'DELETE', "".concat(_this.url, "/factors/").concat(params.factorId), {
                                                                headers: _this.headers,
                                                                jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                                                            })
                                                        ];
                                                    case 1:
                                                        return [
                                                            2,
                                                            _state.sent()
                                                        ];
                                                }
                                            });
                                        });
                                        return function(result) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_enroll",
            value: function _enroll(params) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var error;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this._useSession(/*#__PURE__*/ function() {
                                        var _ref = (0, $5Pgs2._)(function(result) {
                                            var _a, _b, sessionData, sessionError, body, _ref, data, _$error;
                                            return (0, $1XfpH.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        sessionData = result.data, sessionError = result.error;
                                                        if (sessionError) return [
                                                            2,
                                                            {
                                                                data: null,
                                                                error: sessionError
                                                            }
                                                        ];
                                                        body = Object.assign({
                                                            friendly_name: params.friendlyName,
                                                            factor_type: params.factorType
                                                        }, params.factorType === 'phone' ? {
                                                            phone: params.phone
                                                        } : {
                                                            issuer: params.issuer
                                                        });
                                                        return [
                                                            4,
                                                            (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'POST', "".concat(_this.url, "/factors"), {
                                                                body: body,
                                                                headers: _this.headers,
                                                                jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                                                            })
                                                        ];
                                                    case 1:
                                                        _ref = _state.sent(), data = _ref.data, _$error = _ref.error;
                                                        if (_$error) return [
                                                            2,
                                                            {
                                                                data: null,
                                                                error: _$error
                                                            }
                                                        ];
                                                        if (params.factorType === 'totp' && ((_b = data === null || data === void 0 ? void 0 : data.totp) === null || _b === void 0 ? void 0 : _b.qr_code)) data.totp.qr_code = "data:image/svg+xml;utf-8,".concat(data.totp.qr_code);
                                                        return [
                                                            2,
                                                            {
                                                                data: data,
                                                                error: null
                                                            }
                                                        ];
                                                }
                                            });
                                        });
                                        return function(result) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                error = _state.sent();
                                if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                    2,
                                    {
                                        data: null,
                                        error: error
                                    }
                                ];
                                throw error;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_verify",
            value: /**
     * {@see GoTrueMFAApi#verify}
     */ function _verify(params) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        return [
                            2,
                            _this._acquireLock(-1, /*#__PURE__*/ (0, $5Pgs2._)(function() {
                                var error;
                                return (0, $1XfpH.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _state.trys.push([
                                                0,
                                                2,
                                                ,
                                                3
                                            ]);
                                            return [
                                                4,
                                                _this._useSession(/*#__PURE__*/ function() {
                                                    var _ref = (0, $5Pgs2._)(function(result) {
                                                        var _a, sessionData, sessionError, _ref, data, _$error;
                                                        return (0, $1XfpH.__generator)(this, function(_state) {
                                                            switch(_state.label){
                                                                case 0:
                                                                    sessionData = result.data, sessionError = result.error;
                                                                    if (sessionError) return [
                                                                        2,
                                                                        {
                                                                            data: null,
                                                                            error: sessionError
                                                                        }
                                                                    ];
                                                                    return [
                                                                        4,
                                                                        (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'POST', "".concat(_this.url, "/factors/").concat(params.factorId, "/verify"), {
                                                                            body: {
                                                                                code: params.code,
                                                                                challenge_id: params.challengeId
                                                                            },
                                                                            headers: _this.headers,
                                                                            jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                                                                        })
                                                                    ];
                                                                case 1:
                                                                    _ref = _state.sent(), data = _ref.data, _$error = _ref.error;
                                                                    if (_$error) return [
                                                                        2,
                                                                        {
                                                                            data: null,
                                                                            error: _$error
                                                                        }
                                                                    ];
                                                                    return [
                                                                        4,
                                                                        _this._saveSession(Object.assign({
                                                                            expires_at: Math.round(Date.now() / 1000) + data.expires_in
                                                                        }, data))
                                                                    ];
                                                                case 2:
                                                                    _state.sent();
                                                                    return [
                                                                        4,
                                                                        _this._notifyAllSubscribers('MFA_CHALLENGE_VERIFIED', data)
                                                                    ];
                                                                case 3:
                                                                    _state.sent();
                                                                    return [
                                                                        2,
                                                                        {
                                                                            data: data,
                                                                            error: _$error
                                                                        }
                                                                    ];
                                                            }
                                                        });
                                                    });
                                                    return function(result) {
                                                        return _ref.apply(this, arguments);
                                                    };
                                                }())
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                _state.sent()
                                            ];
                                        case 2:
                                            error = _state.sent();
                                            if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                                2,
                                                {
                                                    data: null,
                                                    error: error
                                                }
                                            ];
                                            throw error;
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }))
                        ];
                    });
                })();
            }
        },
        {
            key: "_challenge",
            value: /**
     * {@see GoTrueMFAApi#challenge}
     */ function _challenge(params) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        return [
                            2,
                            _this._acquireLock(-1, /*#__PURE__*/ (0, $5Pgs2._)(function() {
                                var error;
                                return (0, $1XfpH.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _state.trys.push([
                                                0,
                                                2,
                                                ,
                                                3
                                            ]);
                                            return [
                                                4,
                                                _this._useSession(/*#__PURE__*/ function() {
                                                    var _ref = (0, $5Pgs2._)(function(result) {
                                                        var _a, sessionData, sessionError;
                                                        return (0, $1XfpH.__generator)(this, function(_state) {
                                                            switch(_state.label){
                                                                case 0:
                                                                    sessionData = result.data, sessionError = result.error;
                                                                    if (sessionError) return [
                                                                        2,
                                                                        {
                                                                            data: null,
                                                                            error: sessionError
                                                                        }
                                                                    ];
                                                                    return [
                                                                        4,
                                                                        (0, $cc4d33f36ba2dab3$export$8969b3850ca2cdfd)(_this.fetch, 'POST', "".concat(_this.url, "/factors/").concat(params.factorId, "/challenge"), {
                                                                            body: {
                                                                                channel: params.channel
                                                                            },
                                                                            headers: _this.headers,
                                                                            jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                                                                        })
                                                                    ];
                                                                case 1:
                                                                    return [
                                                                        2,
                                                                        _state.sent()
                                                                    ];
                                                            }
                                                        });
                                                    });
                                                    return function(result) {
                                                        return _ref.apply(this, arguments);
                                                    };
                                                }())
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                _state.sent()
                                            ];
                                        case 2:
                                            error = _state.sent();
                                            if ((0, $73f5e58330057bc1$export$cde1786a482f9a1c)(error)) return [
                                                2,
                                                {
                                                    data: null,
                                                    error: error
                                                }
                                            ];
                                            throw error;
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }))
                        ];
                    });
                })();
            }
        },
        {
            key: "_challengeAndVerify",
            value: /**
     * {@see GoTrueMFAApi#challengeAndVerify}
     */ function _challengeAndVerify(params) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _ref, challengeData, challengeError;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._challenge({
                                        factorId: params.factorId
                                    })
                                ];
                            case 1:
                                _ref = _state.sent(), challengeData = _ref.data, challengeError = _ref.error;
                                if (challengeError) return [
                                    2,
                                    {
                                        data: null,
                                        error: challengeError
                                    }
                                ];
                                return [
                                    4,
                                    _this._verify({
                                        factorId: params.factorId,
                                        challengeId: challengeData.id,
                                        code: params.code
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_listFactors",
            value: /**
     * {@see GoTrueMFAApi#listFactors}
     */ function _listFactors() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var _ref, user, userError, factors, totp, phone;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getUser()
                                ];
                            case 1:
                                _ref = _state.sent(), user = _ref.data.user, userError = _ref.error;
                                if (userError) return [
                                    2,
                                    {
                                        data: null,
                                        error: userError
                                    }
                                ];
                                factors = (user === null || user === void 0 ? void 0 : user.factors) || [];
                                totp = factors.filter(function(factor) {
                                    return factor.factor_type === 'totp' && factor.status === 'verified';
                                });
                                phone = factors.filter(function(factor) {
                                    return factor.factor_type === 'phone' && factor.status === 'verified';
                                });
                                return [
                                    2,
                                    {
                                        data: {
                                            all: factors,
                                            totp: totp,
                                            phone: phone
                                        },
                                        error: null
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_getAuthenticatorAssuranceLevel",
            value: /**
     * {@see GoTrueMFAApi#getAuthenticatorAssuranceLevel}
     */ function _getAuthenticatorAssuranceLevel() {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        return [
                            2,
                            _this._acquireLock(-1, /*#__PURE__*/ (0, $5Pgs2._)(function() {
                                return (0, $1XfpH.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                _this._useSession(/*#__PURE__*/ function() {
                                                    var _ref = (0, $5Pgs2._)(function(result) {
                                                        var _a, _b, session, sessionError, payload, currentLevel, nextLevel, verifiedFactors, currentAuthenticationMethods;
                                                        return (0, $1XfpH.__generator)(this, function(_state) {
                                                            session = result.data.session, sessionError = result.error;
                                                            if (sessionError) return [
                                                                2,
                                                                {
                                                                    data: null,
                                                                    error: sessionError
                                                                }
                                                            ];
                                                            if (!session) return [
                                                                2,
                                                                {
                                                                    data: {
                                                                        currentLevel: null,
                                                                        nextLevel: null,
                                                                        currentAuthenticationMethods: []
                                                                    },
                                                                    error: null
                                                                }
                                                            ];
                                                            payload = _this._decodeJWT(session.access_token);
                                                            currentLevel = null;
                                                            if (payload.aal) currentLevel = payload.aal;
                                                            nextLevel = currentLevel;
                                                            verifiedFactors = (_b = (_a = session.user.factors) === null || _a === void 0 ? void 0 : _a.filter(function(factor) {
                                                                return factor.status === 'verified';
                                                            })) !== null && _b !== void 0 ? _b : [];
                                                            if (verifiedFactors.length > 0) nextLevel = 'aal2';
                                                            currentAuthenticationMethods = payload.amr || [];
                                                            return [
                                                                2,
                                                                {
                                                                    data: {
                                                                        currentLevel: currentLevel,
                                                                        nextLevel: nextLevel,
                                                                        currentAuthenticationMethods: currentAuthenticationMethods
                                                                    },
                                                                    error: null
                                                                }
                                                            ];
                                                        });
                                                    });
                                                    return function(result) {
                                                        return _ref.apply(this, arguments);
                                                    };
                                                }())
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                _state.sent()
                                            ];
                                    }
                                });
                            }))
                        ];
                    });
                })();
            }
        }
    ]);
    return GoTrueClient;
}();
$5134855c200492a8$export$2e2bcd8739ae039.nextInstanceID = 0;



var $c1c862a7333a63d7$var$AuthAdminApi = (0, $edafeda94c9906ac$export$2e2bcd8739ae039);
var $c1c862a7333a63d7$export$2e2bcd8739ae039 = $c1c862a7333a63d7$var$AuthAdminApi;



var $df0d9e6f1488becb$var$AuthClient = (0, $5134855c200492a8$export$2e2bcd8739ae039);
var $df0d9e6f1488becb$export$2e2bcd8739ae039 = $df0d9e6f1488becb$var$AuthClient;








var $5c045fb040098b6a$export$8199a418bb09bd56 = /*#__PURE__*/ function(AuthClient) {
    "use strict";
    (0, $1atwj._)(SupabaseAuthClient, AuthClient);
    function SupabaseAuthClient(options) {
        (0, $50OuQ._)(this, SupabaseAuthClient);
        return (0, $huFCX._)(this, SupabaseAuthClient, [
            options
        ]);
    }
    return SupabaseAuthClient;
}((0, $df0d9e6f1488becb$export$2e2bcd8739ae039));


var $8005220778fd53a2$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8005220778fd53a2$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function SupabaseClient(supabaseUrl, supabaseKey, options) {
        (0, $50OuQ._)(this, SupabaseClient);
        var _a, _b, _c;
        this.supabaseUrl = supabaseUrl;
        this.supabaseKey = supabaseKey;
        if (!supabaseUrl) throw new Error('supabaseUrl is required.');
        if (!supabaseKey) throw new Error('supabaseKey is required.');
        var _supabaseUrl = (0, $69cd3a7da24f8adb$export$d95b4586d238a081)(supabaseUrl);
        this.realtimeUrl = "".concat(_supabaseUrl, "/realtime/v1").replace(/^http/i, 'ws');
        this.authUrl = "".concat(_supabaseUrl, "/auth/v1");
        this.storageUrl = "".concat(_supabaseUrl, "/storage/v1");
        this.functionsUrl = "".concat(_supabaseUrl, "/functions/v1");
        // default storage key uses the supabase project ref as a namespace
        var defaultStorageKey = "sb-".concat(new URL(this.authUrl).hostname.split('.')[0], "-auth-token");
        var DEFAULTS = {
            db: (0, $3b56cbd3e30ce46e$export$b31378ae815bea6b),
            realtime: (0, $3b56cbd3e30ce46e$export$59685507ca0a3912),
            auth: Object.assign(Object.assign({}, (0, $3b56cbd3e30ce46e$export$af122550cc2345b3)), {
                storageKey: defaultStorageKey
            }),
            global: (0, $3b56cbd3e30ce46e$export$b63a5c3a2e5becd2)
        };
        var settings = (0, $69cd3a7da24f8adb$export$da186dc3f8eace71)(options !== null && options !== void 0 ? options : {}, DEFAULTS);
        this.storageKey = (_a = settings.auth.storageKey) !== null && _a !== void 0 ? _a : '';
        this.headers = (_b = settings.global.headers) !== null && _b !== void 0 ? _b : {};
        if (!settings.accessToken) this.auth = this._initSupabaseAuthClient((_c = settings.auth) !== null && _c !== void 0 ? _c : {}, this.headers, settings.global.fetch);
        else {
            this.accessToken = settings.accessToken;
            this.auth = new Proxy({}, {
                get: function(_, prop) {
                    throw new Error("@supabase/supabase-js: Supabase Client is configured with the accessToken option, accessing supabase.auth.".concat(String(prop), " is not possible"));
                }
            });
        }
        this.fetch = (0, $83d30eae6e87e98f$export$651dd5aef824521f)(supabaseKey, this._getAccessToken.bind(this), settings.global.fetch);
        this.realtime = this._initRealtimeClient(Object.assign({
            headers: this.headers,
            accessToken: this._getAccessToken.bind(this)
        }, settings.realtime));
        this.rest = new (0, $f22638f4b54b5a77$export$796f32e2ee984aaa)("".concat(_supabaseUrl, "/rest/v1"), {
            headers: this.headers,
            schema: settings.db.schema,
            fetch: this.fetch
        });
        if (!settings.accessToken) this._listenForAuthEvents();
    }
    (0, $fGdZr._)(SupabaseClient, [
        {
            key: "functions",
            get: /**
     * Supabase Functions allows you to deploy and invoke edge functions.
     */ function get() {
                return new (0, $3ea221538d6cfdc0$export$1d0b400bf8a0fa55)(this.functionsUrl, {
                    headers: this.headers,
                    customFetch: this.fetch
                });
            }
        },
        {
            key: "storage",
            get: /**
     * Supabase Storage allows you to manage user-generated content, such as photos or videos.
     */ function get() {
                return new (0, $4c574872bb39cb61$export$6c85f5032e75eff9)(this.storageUrl, this.headers, this.fetch);
            }
        },
        {
            /**
     * Perform a query on a table or a view.
     *
     * @param relation - The table or view name to query
     */ key: "from",
            value: function from(relation) {
                return this.rest.from(relation);
            }
        },
        {
            // NOTE: signatures must be kept in sync with PostgrestClient.schema
            /**
     * Select a schema to query or perform an function (rpc) call.
     *
     * The schema needs to be on the list of exposed schemas inside Supabase.
     *
     * @param schema - The schema to query
     */ key: "schema",
            value: function schema(_schema) {
                return this.rest.schema(_schema);
            }
        },
        {
            // NOTE: signatures must be kept in sync with PostgrestClient.rpc
            /**
     * Perform a function call.
     *
     * @param fn - The function name to call
     * @param args - The arguments to pass to the function call
     * @param options - Named parameters
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     * @param options.get - When set to `true`, the function will be called with
     * read-only access mode.
     * @param options.count - Count algorithm to use to count rows returned by the
     * function. Only applicable for [set-returning
     * functions](https://www.postgresql.org/docs/current/functions-srf.html).
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ key: "rpc",
            value: function rpc(fn) {
                var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                return this.rest.rpc(fn, args, options);
            }
        },
        {
            /**
     * Creates a Realtime channel with Broadcast, Presence, and Postgres Changes.
     *
     * @param {string} name - The name of the Realtime channel.
     * @param {Object} opts - The options to pass to the Realtime channel.
     *
     */ key: "channel",
            value: function channel(name) {
                var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                    config: {}
                };
                return this.realtime.channel(name, opts);
            }
        },
        {
            /**
     * Returns all Realtime channels.
     */ key: "getChannels",
            value: function getChannels() {
                return this.realtime.getChannels();
            }
        },
        {
            /**
     * Unsubscribes and removes Realtime channel from Realtime client.
     *
     * @param {RealtimeChannel} channel - The name of the Realtime channel.
     *
     */ key: "removeChannel",
            value: function removeChannel(channel) {
                return this.realtime.removeChannel(channel);
            }
        },
        {
            /**
     * Unsubscribes and removes all Realtime channels from Realtime client.
     */ key: "removeAllChannels",
            value: function removeAllChannels() {
                return this.realtime.removeAllChannels();
            }
        },
        {
            key: "_getAccessToken",
            value: function _getAccessToken() {
                var _a, _b;
                return $8005220778fd53a2$var$__awaiter(this, void 0, void 0, function() {
                    var data;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this.accessToken) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.accessToken()
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                return [
                                    4,
                                    this.auth.getSession()
                                ];
                            case 3:
                                data = _state.sent().data;
                                return [
                                    2,
                                    (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : null
                                ];
                        }
                    });
                });
            }
        },
        {
            key: "_initSupabaseAuthClient",
            value: function _initSupabaseAuthClient(param, headers, fetch) {
                var autoRefreshToken = param.autoRefreshToken, persistSession = param.persistSession, detectSessionInUrl = param.detectSessionInUrl, storage = param.storage, storageKey = param.storageKey, flowType = param.flowType, lock = param.lock, debug = param.debug;
                var _a;
                var authHeaders = {
                    Authorization: "Bearer ".concat(this.supabaseKey),
                    apikey: "".concat(this.supabaseKey)
                };
                return new (0, $5c045fb040098b6a$export$8199a418bb09bd56)({
                    url: this.authUrl,
                    headers: Object.assign(Object.assign({}, authHeaders), headers),
                    storageKey: storageKey,
                    autoRefreshToken: autoRefreshToken,
                    persistSession: persistSession,
                    detectSessionInUrl: detectSessionInUrl,
                    storage: storage,
                    flowType: flowType,
                    lock: lock,
                    debug: debug,
                    fetch: fetch,
                    // auth checks if there is a custom authorizaiton header using this flag
                    // so it knows whether to return an error when getUser is called with no session
                    hasCustomAuthorizationHeader: (_a = 'Authorization' in this.headers, _a !== void 0) ? _a : false
                });
            }
        },
        {
            key: "_initRealtimeClient",
            value: function _initRealtimeClient(options) {
                return new (0, $d3a19c16dd3933b4$export$2e2bcd8739ae039)(this.realtimeUrl, Object.assign(Object.assign({}, options), {
                    params: Object.assign({
                        apikey: this.supabaseKey
                    }, options === null || options === void 0 ? void 0 : options.params)
                }));
            }
        },
        {
            key: "_listenForAuthEvents",
            value: function _listenForAuthEvents() {
                var _this = this;
                var data = this.auth.onAuthStateChange(function(event, session) {
                    _this._handleTokenChanged(event, 'CLIENT', session === null || session === void 0 ? void 0 : session.access_token);
                });
                return data;
            }
        },
        {
            key: "_handleTokenChanged",
            value: function _handleTokenChanged(event, source, token) {
                if ((event === 'TOKEN_REFRESHED' || event === 'SIGNED_IN') && this.changedAccessToken !== token) this.changedAccessToken = token;
                else if (event === 'SIGNED_OUT') {
                    this.realtime.setAuth();
                    if (source == 'STORAGE') this.auth.signOut();
                    this.changedAccessToken = undefined;
                }
            }
        }
    ]);
    return SupabaseClient;
}();





var $3b3e42b07ef2b485$export$5d730b7aed1a3eb0 = function(supabaseUrl, supabaseKey, options) {
    return new (0, $8005220778fd53a2$export$2e2bcd8739ae039)(supabaseUrl, supabaseKey, options);
};



var $1e471b7ebb1a7ebe$var$supabaseUrl = (0, $0d51ec966e2c6e90$export$721045acb0bbe132);
var $1e471b7ebb1a7ebe$var$supabaseAnonKey = (0, $0d51ec966e2c6e90$export$c0b592c68ac1c625);
var $1e471b7ebb1a7ebe$export$a0b632a28672d3c0 = (0, $3b3e42b07ef2b485$export$5d730b7aed1a3eb0)($1e471b7ebb1a7ebe$var$supabaseUrl, $1e471b7ebb1a7ebe$var$supabaseAnonKey);
function $1e471b7ebb1a7ebe$var$generateShortId() {
    return crypto.randomUUID().replace(/-/g, '').slice(0, 7);
}
function $1e471b7ebb1a7ebe$export$463aee721735543a(_) {
    return $1e471b7ebb1a7ebe$var$_createShortUrlId.apply(this, arguments);
}
function $1e471b7ebb1a7ebe$var$_createShortUrlId() {
    $1e471b7ebb1a7ebe$var$_createShortUrlId = (0, $5Pgs2._)(function(param) {
        var collectionId, collectionName, books, _ref, existingUrl, queryError, shortId, _$error, error;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    collectionId = param.collectionId, collectionName = param.collectionName, books = param.books;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        $1e471b7ebb1a7ebe$export$a0b632a28672d3c0.from('url_mappings').select('*').eq('collection_id', collectionId).single()
                    ];
                case 2:
                    _ref = _state.sent(), existingUrl = _ref.data, queryError = _ref.error;
                    if (queryError && queryError.code !== 'PGRST116') throw queryError;
                    if (existingUrl) return [
                        2,
                        existingUrl.short_id
                    ];
                    shortId = $1e471b7ebb1a7ebe$var$generateShortId();
                    return [
                        4,
                        $1e471b7ebb1a7ebe$export$a0b632a28672d3c0.from('url_mappings').insert({
                            short_id: shortId,
                            collection_id: collectionId,
                            collection_name: collectionName,
                            books: books
                        }).select().single()
                    ];
                case 3:
                    _$error = _state.sent().error;
                    if (_$error) throw _$error;
                    return [
                        2,
                        shortId
                    ];
                case 4:
                    error = _state.sent();
                    console.error('Error creating short URL:', error);
                    throw error;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $1e471b7ebb1a7ebe$var$_createShortUrlId.apply(this, arguments);
}
function $1e471b7ebb1a7ebe$export$3abff15fec1791bc(shortId) {
    return $1e471b7ebb1a7ebe$var$_getOriginalUrlParams.apply(this, arguments);
}
function $1e471b7ebb1a7ebe$var$_getOriginalUrlParams() {
    $1e471b7ebb1a7ebe$var$_getOriginalUrlParams = (0, $5Pgs2._)(function(shortId) {
        var _ref, data, _$error, error;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        $1e471b7ebb1a7ebe$export$a0b632a28672d3c0.from('url_mappings').select('*').eq('short_id', shortId).single()
                    ];
                case 1:
                    _ref = _state.sent(), data = _ref.data, _$error = _ref.error;
                    if (_$error) throw _$error;
                    if (!data) throw new Error('Short URL not found');
                    return [
                        2,
                        {
                            collectionId: data.collection_id,
                            collectionName: data.collection_name,
                            books: data.books
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.error('Error retrieving URL data:', error);
                    throw error;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $1e471b7ebb1a7ebe$var$_getOriginalUrlParams.apply(this, arguments);
}
var $1e471b7ebb1a7ebe$export$1e4a33a4e0a6191c = /*#__PURE__*/ function() {
    var _ref = (0, $5Pgs2._)(function(id) {
        var error;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $1e471b7ebb1a7ebe$export$a0b632a28672d3c0.from('url_mappings')["delete"]().eq('collection_id', id)
                    ];
                case 1:
                    error = _state.sent().error;
                    if (error) {
                        console.error('Error deleting row:', error.message);
                        return [
                            2
                        ];
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function deleteSupabseRow(id) {
        return _ref.apply(this, arguments);
    };
}();





var $d88b71eee351db62$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $qb7pP = parcelRequire("qb7pP");
var $d88b71eee351db62$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && (typeof value === "undefined" ? "undefined" : (0, $qb7pP._)(value)) === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError((typeof iterable === "undefined" ? "undefined" : (0, $qb7pP._)(iterable)) + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function stop() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $d88b71eee351db62$exports));
try {
    regeneratorRuntime = $d88b71eee351db62$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if ((typeof globalThis === "undefined" ? "undefined" : (0, $qb7pP._)(globalThis)) === "object") globalThis.regeneratorRuntime = $d88b71eee351db62$var$runtime;
    else Function("r", "regeneratorRuntime = r")($d88b71eee351db62$var$runtime);
}


// eslint-disable-next-line no-undef
if (null) // eslint-disable-next-line no-undef
null.accept();
// Router
var $d9a41438d6034af2$var$controlRouter = function controlRouter() {
    var routes = [
        {
            path: '/',
            callback: function() {
                return $d9a41438d6034af2$var$setUpHomeView();
            }
        },
        {
            path: '/find-books',
            callback: function() {
                return $d9a41438d6034af2$var$setUpSearchView(window.location.pathname);
            }
        },
        {
            path: '/bookmarks',
            callback: function() {
                return $d9a41438d6034af2$var$setUpBookmarksView();
            }
        },
        {
            path: '/collections',
            callback: function() {
                return $d9a41438d6034af2$var$setUpCollectionsView();
            }
        },
        {
            path: '/create-collections',
            callback: function() {
                return $d9a41438d6034af2$var$setUpSearchView(window.location.pathname);
            }
        },
        {
            path: '/book',
            callback: function() {
                return $d9a41438d6034af2$var$controlBooks();
            }
        },
        {
            path: '/collection',
            callback: function() {
                return $d9a41438d6034af2$var$controlIndividualCollectionRoute();
            }
        },
        {
            path: '/error',
            callback: function() {
                return $d9a41438d6034af2$var$setUpErrorView();
            }
        },
        {
            path: '/page-not-found',
            callback: function() {
                return $d9a41438d6034af2$var$setUpPageNotFoundView();
            }
        }
    ];
    (0, $c4ab8714ef37556f$export$2e2bcd8739ae039).routes = routes;
    (0, $c4ab8714ef37556f$export$2e2bcd8739ae039).addHandlerRouter();
};
// Initial View
var $d9a41438d6034af2$var$setUpInitialView = function setUpInitialView() {
    (0, $aafb1cd6a41c7c1b$export$2e2bcd8739ae039).render();
    (0, $aafb1cd6a41c7c1b$export$2e2bcd8739ae039).addHandlerNavbarPosition();
    (0, $aafb1cd6a41c7c1b$export$2e2bcd8739ae039).addHandlerCloseMenu();
    (0, $12f8f514a54c20f4$export$2e2bcd8739ae039).render();
};
// Error View
var $d9a41438d6034af2$var$setUpErrorView = function setUpErrorView() {
    (0, $902aac28f1dedc9b$export$2e2bcd8739ae039).render();
};
// Page Not Found View
var $d9a41438d6034af2$var$setUpPageNotFoundView = function setUpPageNotFoundView() {
    (0, $902aac28f1dedc9b$export$2e2bcd8739ae039).render('pageNotFound');
};
// Home View
var $d9a41438d6034af2$var$setUpHomeView = function setUpHomeView() {
    (0, $8b4adf54cc3b8756$export$2e2bcd8739ae039).render();
    (0, $8b4adf54cc3b8756$export$2e2bcd8739ae039).addHandlerCarousel();
    (0, $8b4adf54cc3b8756$export$2e2bcd8739ae039).addHandlerSearch($d9a41438d6034af2$var$controlHomeSearch);
    (0, $8b4adf54cc3b8756$export$2e2bcd8739ae039).addHandlerDebounce(function(query) {
        return $d9a41438d6034af2$var$controlSearchDebounce(query, 'home');
    });
    var properties = (0, $fc18c856e77e0624$export$c338c72616630535)();
    (0, $fc18c856e77e0624$export$cfff717aa51d5799)((0, $0d51ec966e2c6e90$export$79f902c668fe8d1f).VIEWED_HOME_PAGE, properties);
};
var $d9a41438d6034af2$var$controlHomeSearch = function controlHomeSearch(query) {
    if (!query) return;
    (0, $c4ab8714ef37556f$export$2e2bcd8739ae039).navigateTo('/find-books');
    $d9a41438d6034af2$var$controlSearchResults('/find-books', query, '');
    (0, $fc18c856e77e0624$export$cfff717aa51d5799)((0, $0d51ec966e2c6e90$export$79f902c668fe8d1f).CLICKED_SEARCH, {
        from: 'Home Page',
        searchedValue: query
    });
};
// Individual Book View
var $d9a41438d6034af2$var$setUpBookViewHandlers = function setUpBookViewHandlers() {
    (0, $563536d85d91ca17$export$2e2bcd8739ae039).addHandlerTabHandler();
    (0, $563536d85d91ca17$export$2e2bcd8739ae039).addHandlerShare($d9a41438d6034af2$var$controlBookShare);
    (0, $563536d85d91ca17$export$2e2bcd8739ae039).addHandlerXShare(function(title, url) {
        return $d9a41438d6034af2$var$controlXShare(title, url);
    });
    (0, $563536d85d91ca17$export$2e2bcd8739ae039).addHandlerAddBookmark($d9a41438d6034af2$var$controlAddBookmark);
};
var $d9a41438d6034af2$var$controlBooks = /*#__PURE__*/ function() {
    var _ref = (0, $5Pgs2._)(function() {
        var id, utm, err;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    id = (0, $fc18c856e77e0624$export$57a5f2d0e67d7713)('book-id').id;
                    if (!id) return [
                        2
                    ];
                    (0, $563536d85d91ca17$export$2e2bcd8739ae039).renderLoader();
                    return [
                        4,
                        $9dcf34dc7ab40417$export$c394977f6d1b4b6c(id)
                    ];
                case 1:
                    _state.sent();
                    (0, $563536d85d91ca17$export$2e2bcd8739ae039).render($9dcf34dc7ab40417$export$ca000e230c0caa3e.book);
                    $d9a41438d6034af2$var$setUpBookViewHandlers();
                    utm = (0, $fc18c856e77e0624$export$c338c72616630535)();
                    (0, $fc18c856e77e0624$export$cfff717aa51d5799)((0, $0d51ec966e2c6e90$export$79f902c668fe8d1f).VIEWED_BOOK, (0, $50aa2eeb65885e7e$export$71511d61b312f219)({
                        title: $9dcf34dc7ab40417$export$ca000e230c0caa3e.book.title
                    }, utm));
                    window.scrollTo({
                        top: 0,
                        left: 0
                    });
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    console.log(err);
                    (0, $c4ab8714ef37556f$export$2e2bcd8739ae039).navigateTo('/error');
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function controlBooks() {
        return _ref.apply(this, arguments);
    };
}();
var $d9a41438d6034af2$var$controlBookShare = /*#__PURE__*/ function() {
    var _ref = (0, $5Pgs2._)(function(title) {
        var path, message, err;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    path = window.location.href;
                    return [
                        4,
                        (0, $fc18c856e77e0624$export$4a0bf7d3e8ab0007)(path, title)
                    ];
                case 1:
                    message = _state.sent();
                    if (!message) return [
                        2
                    ];
                    (0, $563536d85d91ca17$export$2e2bcd8739ae039).renderToast(message, false);
                    (0, $fc18c856e77e0624$export$cfff717aa51d5799)((0, $0d51ec966e2c6e90$export$79f902c668fe8d1f).CLICKED_SHARE, {
                        type: 'Default',
                        item: 'Book'
                    });
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    console.error(err);
                    (0, $563536d85d91ca17$export$2e2bcd8739ae039).renderToast("Couldn't copy the URL", true);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function controlBookShare(title) {
        return _ref.apply(this, arguments);
    };
}();
var $d9a41438d6034af2$var$controlXShare = function controlXShare(title, url) {
    var text = 'Check out the book "'.concat(title, '" on shelf share.');
    var xUrl = "https://twitter.com/intent/tweet?text=".concat(encodeURIComponent(text), "&url=").concat(encodeURIComponent(url));
    window.open(xUrl, '_blank');
    (0, $fc18c856e77e0624$export$cfff717aa51d5799)((0, $0d51ec966e2c6e90$export$79f902c668fe8d1f).CLICKED_SHARE, {
        type: 'X',
        item: 'Book'
    });
};
var $d9a41438d6034af2$var$controlBookUrlCreation = function controlBookUrlCreation(route, id) {
    (0, $c4ab8714ef37556f$export$2e2bcd8739ae039).navigateTo((0, $fc18c856e77e0624$export$a853aba3035a900d)(route, {
        id: id
    }, false));
};
// Search Results View
var $d9a41438d6034af2$var$controlSearchResults = /*#__PURE__*/ function() {
    var _ref = (0, $5Pgs2._)(function(path, query, category) {
        var err;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    if (!query && !category) return [
                        2
                    ];
                    $d9a41438d6034af2$var$controlSearchUrlCreation(query, category, path);
                    if (category) (0, $fc18c856e77e0624$export$cfff717aa51d5799)((0, $0d51ec966e2c6e90$export$79f902c668fe8d1f).CLICKED_SEARCH_FILTER, {
                        type: category
                    });
                    if (path === '/find-books') {
                        (0, $7d7339a8dc0dc616$export$2e2bcd8739ae039).renderLoader();
                        (0, $fc18c856e77e0624$export$cfff717aa51d5799)((0, $0d51ec966e2c6e90$export$79f902c668fe8d1f).CLICKED_SEARCH, {
                            from: 'Find Books Page',
                            searchedValue: query
                        });
                    }
                    if (path === '/create-collections') {
                        (0, $6316bd0acf1406ab$export$2e2bcd8739ae039).renderLoader();
                        (0, $fc18c856e77e0624$export$cfff717aa51d5799)((0, $0d51ec966e2c6e90$export$79f902c668fe8d1f).CLICKED_SEARCH, {
                            from: 'Create Collections Page',
                            searchedValue: query
                        });
                    }
                    return [
                        4,
                        $9dcf34dc7ab40417$export$202b8e5cb363a0c4(query, category)
                    ];
                case 1:
                    _state.sent();
                    if (path === '/find-books') (0, $7d7339a8dc0dc616$export$2e2bcd8739ae039).render($9dcf34dc7ab40417$export$ca000e230c0caa3e.search.results);
                    if (path === '/create-collections') (0, $6316bd0acf1406ab$export$2e2bcd8739ae039).render($9dcf34dc7ab40417$export$ca000e230c0caa3e.search.results);
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    console.error(err);
                    if (path === '/find-books') (0, $7d7339a8dc0dc616$export$2e2bcd8739ae039).renderAlert();
                    if (path === '/create-collections') (0, $6316bd0acf1406ab$export$2e2bcd8739ae039).renderAlert();
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function controlSearchResults(path, query, category) {
        return _ref.apply(this, arguments);
    };
}();
var $d9a41438d6034af2$var$controlSearchUrlCreation = function controlSearchUrlCreation(query, category, path) {
    var searchParameters = {
        query: query,
        category: category,
        path: path
    };
    (0, $fc18c856e77e0624$export$a853aba3035a900d)(window.location.pathname, searchParameters);
};
var $d9a41438d6034af2$var$controlUrlSearchResultsLoad = function controlUrlSearchResultsLoad() {
    var searchParams = (0, $fc18c856e77e0624$export$57a5f2d0e67d7713)();
    if (!searchParams) return;
    $d9a41438d6034af2$var$controlSearchResults(searchParams.path, searchParams.query, searchParams.category);
};
var $d9a41438d6034af2$var$controlSearchResultBookmark = /*#__PURE__*/ function() {
    var _ref = (0, $5Pgs2._)(function(bookId) {
        var book;
        return (0, $1XfpH.__generator)(this, function(_state) {
            try {
                if (!bookId) throw new Error('Book ID is missing');
                book = $9dcf34dc7ab40417$export$ca000e230c0caa3e.search.results.find(function(book) {
                    return book.id === bookId;
                });
                if (!book) throw new Error('Book not found in search results');
                if (!book.bookmarked) $9dcf34dc7ab40417$export$72009cc673d27d80(book);
                else $9dcf34dc7ab40417$export$136048bcb9946c75(book.id);
                book.bookmarked = !book.bookmarked;
                (0, $7d7339a8dc0dc616$export$2e2bcd8739ae039).update($9dcf34dc7ab40417$export$ca000e230c0caa3e.search.results);
            } catch (err) {
                console.error("Error in controlSearchResultBookmark: ".concat(err.message));
            }
            return [
                2
            ];
        });
    });
    return function controlSearchResultBookmark(bookId) {
        return _ref.apply(this, arguments);
    };
}();
var $d9a41438d6034af2$var$setUpSearchView = function setUpSearchView(path) {
    if (path === '/create-collections') {
        (0, $f1583b4246933fbc$export$2e2bcd8739ae039).render('', true, 'collection-btn');
        (0, $6316bd0acf1406ab$export$2e2bcd8739ae039).addHandlerAddBook($d9a41438d6034af2$var$controlAddToCollection);
        (0, $f1583b4246933fbc$export$2e2bcd8739ae039).addHandlerCreateCollection($d9a41438d6034af2$var$controlCreateCollection);
        (0, $f1583b4246933fbc$export$2e2bcd8739ae039).addHandlerResetSelections($d9a41438d6034af2$var$controlResetSelections);
        (0, $f1583b4246933fbc$export$2e2bcd8739ae039).updateSelectedBooks($9dcf34dc7ab40417$export$ca000e230c0caa3e.selectedBooks);
        (0, $fc18c856e77e0624$export$cfff717aa51d5799)((0, $0d51ec966e2c6e90$export$79f902c668fe8d1f).VIEWED_CREATE_COLLECTIONS_PAGE);
    } else if (path === '/find-books') {
        (0, $f1583b4246933fbc$export$2e2bcd8739ae039).render();
        (0, $7d7339a8dc0dc616$export$2e2bcd8739ae039).addHandlerBookmark($d9a41438d6034af2$var$controlSearchResultBookmark);
        (0, $fc18c856e77e0624$export$cfff717aa51d5799)((0, $0d51ec966e2c6e90$export$79f902c668fe8d1f).VIEWED_FIND_BOOKS_PAGE);
    }
    (0, $f1583b4246933fbc$export$2e2bcd8739ae039).addHandlerSearch(function(query, category) {
        return $d9a41438d6034af2$var$controlSearchResults(path, query, category);
    });
    (0, $f1583b4246933fbc$export$2e2bcd8739ae039).addHandlerDebounce(function(query) {
        return $d9a41438d6034af2$var$controlSearchDebounce(query, 'search');
    });
    (0, $f1583b4246933fbc$export$2e2bcd8739ae039).addHandlerBookRoutes(function(route, id) {
        return $d9a41438d6034af2$var$controlBookUrlCreation(route, id);
    });
    $d9a41438d6034af2$var$controlUrlSearchResultsLoad();
};
var $d9a41438d6034af2$var$searchDebounceCallback = /*#__PURE__*/ function() {
    var _ref = (0, $5Pgs2._)(function(query, path) {
        var err;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    if (!query) return [
                        2
                    ];
                    return [
                        4,
                        $9dcf34dc7ab40417$export$f4814d7adfd1c109(query)
                    ];
                case 1:
                    _state.sent();
                    if (path === 'home') (0, $8b4adf54cc3b8756$export$2e2bcd8739ae039).updateSuggestions($9dcf34dc7ab40417$export$ca000e230c0caa3e.search.titles);
                    if (path === 'search') (0, $f1583b4246933fbc$export$2e2bcd8739ae039).updateSuggestions($9dcf34dc7ab40417$export$ca000e230c0caa3e.search.titles);
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    console.warn('Suggestions unavailable:', err.message);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function searchDebounceCallback(query, path) {
        return _ref.apply(this, arguments);
    };
}();
var $d9a41438d6034af2$var$debouncedSearch = (0, $fc18c856e77e0624$export$61fc7d43ac8f84b0)($d9a41438d6034af2$var$searchDebounceCallback);
var $d9a41438d6034af2$var$controlSearchDebounce = function(query, path) {
    return $d9a41438d6034af2$var$debouncedSearch(query, path);
};
// Bookmarks
var $d9a41438d6034af2$var$controlAddBookmark = function controlAddBookmark() {
    if (!$9dcf34dc7ab40417$export$ca000e230c0caa3e.book.bookmarked) {
        $9dcf34dc7ab40417$export$72009cc673d27d80($9dcf34dc7ab40417$export$ca000e230c0caa3e.book);
        (0, $fc18c856e77e0624$export$cfff717aa51d5799)((0, $0d51ec966e2c6e90$export$79f902c668fe8d1f).CLICKED_BOOKMARK, {
            title: $9dcf34dc7ab40417$export$ca000e230c0caa3e.book.title,
            authors: $9dcf34dc7ab40417$export$ca000e230c0caa3e.book.authors.join(", ")
        });
    } else $9dcf34dc7ab40417$export$136048bcb9946c75($9dcf34dc7ab40417$export$ca000e230c0caa3e.book.id);
    (0, $563536d85d91ca17$export$2e2bcd8739ae039).update($9dcf34dc7ab40417$export$ca000e230c0caa3e.book);
};
var $d9a41438d6034af2$var$controlRemoveBookmark = function controlRemoveBookmark1(bookId) {
    $9dcf34dc7ab40417$export$136048bcb9946c75(bookId);
    // Find a more optimal way to render the below part
    (0, $a9853349f6311190$export$2e2bcd8739ae039).render($9dcf34dc7ab40417$export$ca000e230c0caa3e.bookmarks);
    (0, $a9853349f6311190$export$2e2bcd8739ae039).addHandlerRemoveBookmark($d9a41438d6034af2$var$controlRemoveBookmark);
    (0, $a9853349f6311190$export$2e2bcd8739ae039).addHandlerLinks();
};
var $d9a41438d6034af2$var$setUpBookmarksView = function setUpBookmarksView() {
    (0, $a9853349f6311190$export$2e2bcd8739ae039).renderLoader();
    (0, $a9853349f6311190$export$2e2bcd8739ae039).render($9dcf34dc7ab40417$export$ca000e230c0caa3e.bookmarks);
    (0, $a9853349f6311190$export$2e2bcd8739ae039).addHandlerRemoveBookmark($d9a41438d6034af2$var$controlRemoveBookmark);
    (0, $a9853349f6311190$export$2e2bcd8739ae039).addHandlerLinks();
    (0, $a9853349f6311190$export$2e2bcd8739ae039).addHandlerBookRoutes(function(route, id) {
        return $d9a41438d6034af2$var$controlBookUrlCreation(route, id);
    });
    (0, $fc18c856e77e0624$export$cfff717aa51d5799)((0, $0d51ec966e2c6e90$export$79f902c668fe8d1f).VIEWED_SHELF);
};
// Collections
var $d9a41438d6034af2$var$setUpCollectionsView = function setUpCollectionsView() {
    (0, $91000ab0687e1a6f$export$2e2bcd8739ae039).renderLoader();
    (0, $91000ab0687e1a6f$export$2e2bcd8739ae039).render($9dcf34dc7ab40417$export$ca000e230c0caa3e.collections);
    (0, $91000ab0687e1a6f$export$2e2bcd8739ae039).addHandlerViewCollection($d9a41438d6034af2$var$controlIndividualCollectionViewButton);
    (0, $91000ab0687e1a6f$export$2e2bcd8739ae039).addHandlerDeleteCollection($d9a41438d6034af2$var$controlDeleteCollection);
    (0, $91000ab0687e1a6f$export$2e2bcd8739ae039).addHandlerLinks();
};
var $d9a41438d6034af2$var$controlAddToCollection = function controlAddToCollection(bookId) {
    var book = $9dcf34dc7ab40417$export$ca000e230c0caa3e.search.results.find(function(book) {
        return book.id === bookId;
    });
    if (book) {
        if (book.selected) $9dcf34dc7ab40417$export$121c76e4246ff7ba(bookId);
        else $9dcf34dc7ab40417$export$b5bf271fe430fb9f(book);
        (0, $f1583b4246933fbc$export$2e2bcd8739ae039).updateSelectedBooks($9dcf34dc7ab40417$export$ca000e230c0caa3e.selectedBooks);
        (0, $6316bd0acf1406ab$export$2e2bcd8739ae039).update($9dcf34dc7ab40417$export$ca000e230c0caa3e.search.results);
    }
};
var $d9a41438d6034af2$var$controlResetSelections = function controlResetSelections() {
    $9dcf34dc7ab40417$export$2a0fdc24076a638a();
    (0, $f1583b4246933fbc$export$2e2bcd8739ae039).updateSelectedBooks($9dcf34dc7ab40417$export$ca000e230c0caa3e.selectedBooks);
    (0, $6316bd0acf1406ab$export$2e2bcd8739ae039).update($9dcf34dc7ab40417$export$ca000e230c0caa3e.search.results);
};
var $d9a41438d6034af2$var$controlCreateCollection = function controlCreateCollection(collectionName, totalBooks) {
    if (!collectionName) return;
    $9dcf34dc7ab40417$export$c74125a8e3af6bb2(collectionName);
    (0, $f1583b4246933fbc$export$2e2bcd8739ae039).updateSelectedBooks($9dcf34dc7ab40417$export$ca000e230c0caa3e.selectedBooks);
    (0, $6316bd0acf1406ab$export$2e2bcd8739ae039).update($9dcf34dc7ab40417$export$ca000e230c0caa3e.search.results);
    (0, $fc18c856e77e0624$export$cfff717aa51d5799)((0, $0d51ec966e2c6e90$export$79f902c668fe8d1f).CREATED_COLLECTION, {
        name: collectionName,
        totalBooks: totalBooks
    });
};
// Individual Collection
var $d9a41438d6034af2$var$controlRenderIndividualCollection = function controlRenderIndividualCollection(collection) {
    (0, $fc7bd4694965bc86$export$2e2bcd8739ae039).render(collection, true, 'no-button');
    (0, $fc7bd4694965bc86$export$2e2bcd8739ae039).addHandlerShare(function() {
        return $d9a41438d6034af2$var$controlIndividualCollectionShare(collection);
    });
    (0, $fc7bd4694965bc86$export$2e2bcd8739ae039).addHandlerBookRoutes(function(route, id) {
        return $d9a41438d6034af2$var$controlBookUrlCreation(route, id);
    });
    window.scrollTo({
        top: 0,
        left: 0
    });
    (0, $fc18c856e77e0624$export$cfff717aa51d5799)((0, $0d51ec966e2c6e90$export$79f902c668fe8d1f).VIEWED_COLLECTION);
};
var $d9a41438d6034af2$var$controlIndividualCollectionViewButton = /*#__PURE__*/ function() {
    var _ref = (0, $5Pgs2._)(function(collectionId) {
        var collection, shortId;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    (0, $fc7bd4694965bc86$export$2e2bcd8739ae039).renderLoader();
                    collection = $9dcf34dc7ab40417$export$ca000e230c0caa3e.collections.find(function(collection) {
                        return collection.collectionId === Number(collectionId) || collection.id === Number(collectionId);
                    });
                    if (!collection) (0, $fc7bd4694965bc86$export$2e2bcd8739ae039).renderAlert();
                    $d9a41438d6034af2$var$controlRenderIndividualCollection(collection);
                    return [
                        4,
                        (0, $1e471b7ebb1a7ebe$export$463aee721735543a)(collection)
                    ];
                case 1:
                    shortId = _state.sent();
                    window.history.pushState('', '', "/collection?sId=".concat(shortId));
                    return [
                        2
                    ];
            }
        });
    });
    return function controlIndividualCollectionViewButton(collectionId) {
        return _ref.apply(this, arguments);
    };
}();
var $d9a41438d6034af2$var$controlIndividualCollectionRoute = /*#__PURE__*/ function() {
    var _ref = (0, $5Pgs2._)(function() {
        var sId, collection, e;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    (0, $fc7bd4694965bc86$export$2e2bcd8739ae039).renderLoader();
                    sId = (0, $fc18c856e77e0624$export$57a5f2d0e67d7713)().sId;
                    return [
                        4,
                        (0, $1e471b7ebb1a7ebe$export$3abff15fec1791bc)(sId)
                    ];
                case 1:
                    collection = _state.sent();
                    $d9a41438d6034af2$var$controlRenderIndividualCollection(collection);
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    console.error(e);
                    (0, $c4ab8714ef37556f$export$2e2bcd8739ae039).navigateTo('/error');
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function controlIndividualCollectionRoute() {
        return _ref.apply(this, arguments);
    };
}();
var $d9a41438d6034af2$var$controlIndividualCollectionShare = /*#__PURE__*/ function() {
    var _ref = (0, $5Pgs2._)(function(collection) {
        var shortUrlId, message, err;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, $1e471b7ebb1a7ebe$export$463aee721735543a)(collection)
                    ];
                case 1:
                    shortUrlId = _state.sent();
                    return [
                        4,
                        (0, $fc18c856e77e0624$export$4a0bf7d3e8ab0007)("".concat(window.location.origin, "/collection?sId=").concat(shortUrlId), collection.collectionName, true)
                    ];
                case 2:
                    message = _state.sent();
                    if (!message) throw new Error("Error copying URL");
                    (0, $fc7bd4694965bc86$export$2e2bcd8739ae039).renderToast(message, false);
                    (0, $fc18c856e77e0624$export$cfff717aa51d5799)((0, $0d51ec966e2c6e90$export$79f902c668fe8d1f).CLICKED_SHARE, {
                        type: 'Default',
                        item: 'Collection'
                    });
                    return [
                        3,
                        4
                    ];
                case 3:
                    err = _state.sent();
                    console.error(err);
                    (0, $fc7bd4694965bc86$export$2e2bcd8739ae039).renderToast("Couldn't copy the URL", true);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function controlIndividualCollectionShare(collection) {
        return _ref.apply(this, arguments);
    };
}();
var $d9a41438d6034af2$var$deleteCollectionFromSupabase = function deleteCollectionFromSupabase(collectionId) {
    (0, $1e471b7ebb1a7ebe$export$1e4a33a4e0a6191c)(collectionId);
};
var $d9a41438d6034af2$var$controlDeleteCollection = function controlDeleteCollection1(collectionId) {
    $9dcf34dc7ab40417$export$3d16e031f6551662(collectionId);
    (0, $91000ab0687e1a6f$export$2e2bcd8739ae039).render($9dcf34dc7ab40417$export$ca000e230c0caa3e.collections);
    (0, $91000ab0687e1a6f$export$2e2bcd8739ae039).addHandlerViewCollection($d9a41438d6034af2$var$controlIndividualCollectionViewButton);
    (0, $91000ab0687e1a6f$export$2e2bcd8739ae039).addHandlerDeleteCollection($d9a41438d6034af2$var$controlDeleteCollection);
    (0, $91000ab0687e1a6f$export$2e2bcd8739ae039).addHandlerLinks();
    $d9a41438d6034af2$var$deleteCollectionFromSupabase(collectionId);
};
// Not in use currently
// const controlIndividualCollectionRemoveBook = function (bookId, collectionId) {
//   model.deleteIndividualCollectionBook(bookId, collectionId);
//   const collection = model.state.collections.find(
//     collection => collection.collectionId === Number(collectionId),
//   );
//   if (collection) {
//     controlRenderIndividualCollection(collection);
//   } else {
//     Router.navigateTo('/collections');
//   }
// };
var $d9a41438d6034af2$var$init = function init() {
    if (0, $0d51ec966e2c6e90$export$c016e91678be354b) {
        (0, $6c21bacc9274e141$export$2e2bcd8739ae039).init((0, $0d51ec966e2c6e90$export$c016e91678be354b), {
            debug: false,
            persistence: 'localStorage'
        });
        var uniqueId = (0, $6c21bacc9274e141$export$2e2bcd8739ae039).get_distinct_id();
        (0, $6c21bacc9274e141$export$2e2bcd8739ae039).identify(uniqueId);
    }
    $d9a41438d6034af2$var$setUpInitialView();
    $d9a41438d6034af2$var$controlRouter();
};
$d9a41438d6034af2$var$init();

})();
//# sourceMappingURL=index.06c2a6e5.js.map
